 (function(modules) { // webpackBootstrap
 	// The module cache
 	var installedModules = {};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}


 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 593);
 })

 ([

 (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(600);
} else {
  module.exports = require('./cjs/react.development.js');
}


 }),

 (function(module, exports, __webpack_require__) {



if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(606)();
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(604);
 var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(325);
 var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(613);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });


 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(722);

 var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(723);

 var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(370);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(724);

 var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(725);

 var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(726);

 var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(727);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(371);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(217);

 var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(728);

 var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(729);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(730);

 var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(731);

 var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(732);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
(function(process) {
 __webpack_require__.d(__webpack_exports__, "a", function() { return css; });

 __webpack_require__.d(__webpack_exports__, "c", function() { return keyframes; });









 var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__ = __webpack_require__(803);
 var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__);
 var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__ = __webpack_require__(804);
 var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__ = __webpack_require__(805);
 var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(806);
 var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
 var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(808);
 var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__ = __webpack_require__(809);
 var __WEBPACK_IMPORTED_MODULE_8_merge_anything__ = __webpack_require__(811);










// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
}

// 
function isStatelessFunction(test) {
  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && (Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://app.callforimpact.com/api/Rise","REACT_APP_NODE_URL":"https://node2.globalincubator.net"}).REACT_APP_SC_ATTR || Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://app.callforimpact.com/api/Rise","REACT_APP_NODE_URL":"https://node2.globalincubator.net"}).SC_ATTR) || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://app.callforimpact.com/api/Rise","REACT_APP_NODE_URL":"https://node2.globalincubator.net"}).REACT_APP_SC_DISABLE_SPEEDY || Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://app.callforimpact.com/api/Rise","REACT_APP_NODE_URL":"https://node2.globalincubator.net"}).SC_DISABLE_SPEEDY) || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 



var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
} : {};


function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}



var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};


var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 


var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 



var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};


var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};


var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};


var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};


var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 




var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  
  var size = tag.ownerDocument.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = tag.ownerDocument.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  
  throw new StyledComponentsError(10);
};


var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    
    return false;
  }

  return true;
};


var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 


var makeTextMarker = function makeTextMarker(id) {
  return '\n\n';
};


var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};


var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var targetDocument = document;
  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;

  var el = targetDocument.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.4.1");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  
  el.appendChild(targetDocument.createTextNode(''));

  if (target && !tagEl) {
    
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};


var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.1" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};


var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};


var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; 
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; 
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    // $FlowFixMe
    if (el.isConnected === false) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(targetDocument, id) {
  return targetDocument.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(el.ownerDocument, id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    
    var newMarker = makeTextNode(el.ownerDocument, id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;


var MAX_SIZE = void 0;
if (IS_BROWSER) {
  
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  

  

  

  

  

  

  

  

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');

    var nodesSize = nodes.length;

    
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        
        this.rehydratedNames[name] = true;
      }

      
      extracted.push.apply(extracted, extractComps(el.textContent));

      
      els.push(el);
    }

    
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  


  
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    
    this.clones.push(sheet);

    
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    
    tag.removeRules(id);

    
    this.ignoreRehydratedNames[id] = true;

    
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 



var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;


function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__["a" ])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 


var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCssArray = function objToCssArray(obj, prevKey) {
  var rules = [];
  var keys = Object.keys(obj);

  keys.forEach(function (key) {
    if (!isFalsish(obj[key])) {
      if (isPlainObject(obj[key])) {
        rules.push.apply(rules, objToCssArray(obj[key], key));

        return rules;
      } else if (isFunction(obj[key])) {
        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');

        return rules;
      }
      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
    }
    return rules;
  });

  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  
  if (isFunction(chunk)) {
    if (isStatelessFunction(chunk) && executionContext) {
      var _result = chunk(executionContext);

      if (false) {
        // eslint-disable-next-line no-console
        console.warn(getComponentName(chunk) + ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.');
      }

      return flatten(_result, executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  
  return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (isFunction(styles) || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isValidElementType"])(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 



var charsLength = 52;


var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};


function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 


var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};



var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic = "production" === 'production' && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  

  return theme;
});

// 
var escapeRegex = / = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var ThemeConsumer = ThemeContext.Consumer;



var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" ])(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Provider,
      { value: context },
      this.props.children
    );
  };

  


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

// 

var CLOSING_TAG_R = /^\s*<\/[a-z]/i;

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, _, callback) {
        var tags = instance.tags;

        var html = '';

        
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        
        instance.sealAllTags();

        var renderedHtml = chunk.toString();

        
        if (CLOSING_TAG_R.test(renderedHtml)) {
          var endOfClosingTag = renderedHtml.indexOf('>');

          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
        } else this.push(html + renderedHtml);

        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });

    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();
var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" ])(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? React.Children.only(children) : children
    );
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),

  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var identifiers = {};


function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {
      _this.warnInnerRef = once(function (displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
        );
      });

      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".', '\n ' + new Error().stack)
        );
      });

      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
        );
      });
    }
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.props, this.attrs);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {
        this.warnInnerRef(displayName);
      }

      if (key === 'forwardedComponent' || key === 'as') {
        continue;
      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || Object(__WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__["a" ])(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {
              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
            }

            attr = attr(context);

            if (false) {
              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
            }
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) warnTooManyClasses(className);

    return className;
  };

  return StyledComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  
  var WrappedStyledComponent = void 0;
  var forwardRef = function forwardRef(props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  };
  forwardRef.displayName = displayName;
  WrappedStyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(forwardRef);
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  // $FlowFixMe
  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
    get: function get$$1() {
      return this._foldedDefaultProps;
    },
    set: function set$$1(obj) {
      // $FlowFixMe
      this._foldedDefaultProps = isTargetStyledComp ? Object(__WEBPACK_IMPORTED_MODULE_8_merge_anything__["a" ])(target.defaultProps, obj) : obj;
    }
  });

  if (false) {
    // $FlowFixMe
    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
  }

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent(props) {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
  }

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {
          // eslint-disable-next-line no-console
          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component$$1) + '"');
        }

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 


var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 


if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}


if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

//

 __webpack_exports__["b"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

}.call(__webpack_exports__, __webpack_require__(124)))

 }),

 (function(module, exports, __webpack_require__) {

(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;
;(function() {

  
  var undefined;

  
  var VERSION = '4.17.20';

  
  var LARGE_ARRAY_SIZE = 200;

  
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  
  var MAX_MEMOIZE_SIZE = 500;

  
  var PLACEHOLDER = '__lodash_placeholder__';

  
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  
  var reEscapeChar = /\\(\\)?/g;

  
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  
  var reFlags = /\w*$/;

  
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  
  var reIsBinary = /^0b[01]+$/i;

  
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  
  var reIsOctal = /^0o[0-7]+$/i;

  
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  
  var reNoMatch = /($^)/;

  
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  
  var reApos = RegExp(rsApos, 'g');

  
  var reComboMark = RegExp(rsCombo, 'g');

  
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  
  var templateCounter = -1;

  
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  
  var root = freeGlobal || freeSelf || Function('return this')();

  
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  
  var moduleExports = freeModule && freeModule.exports === freeExports;

  
  var freeProcess = moduleExports && freeGlobal.process;

  
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  

  
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  
  var asciiSize = baseProperty('length');

  
  function asciiToArray(string) {
    return string.split('');
  }

  
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  
  function baseIsNaN(value) {
    return value !== value;
  }

  
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  
  var deburrLetter = basePropertyOf(deburredLetters);

  
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  

  
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    
    var coreJsData = context['__core-js_shared__'];

    
    var funcToString = funcProto.toString;

    
    var hasOwnProperty = objectProto.hasOwnProperty;

    
    var idCounter = 0;

    
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    
    var nativeObjectToString = objectProto.toString;

    
    var objectCtorString = funcToString.call(Object);

    
    var oldDash = root._;

    
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    
    var metaMap = WeakMap && new WeakMap;

    
    var realNames = {};

    
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    

    
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    
    function baseLodash() {
      // No operation performed.
    }

    
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    
    lodash.templateSettings = {

      
      'escape': reEscape,

      
      'evaluate': reEvaluate,

      
      'interpolate': reInterpolate,

      
      'variable': '',

      
      'imports': {

        
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    

    
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    

    
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    

    
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    

    
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    

    
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    

    
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    
    function stackGet(key) {
      return this.__data__.get(key);
    }

    
    function stackHas(key) {
      return this.__data__.has(key);
    }

    
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    

    
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    
    var baseEach = createBaseEach(baseForOwn);

    
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    
    var baseFor = createBaseFor();

    
    var baseForRight = createBaseFor(true);

    
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    
    function baseGt(value, other) {
      return value > other;
    }

    
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    
    function baseLt(value, other) {
      return value < other;
    }

    
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    
    var castRest = baseRest;

    
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n\n');
    }

    
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    
    var isMaskable = coreJsData ? isFunction : stubFalse;

    
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    
    var setData = shortOut(baseSetData);

    
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    
    var setToString = shortOut(baseSetToString);

    
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 ) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    

    
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    
    var pull = baseRest(pullAll);

    
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    
    var zip = baseRest(unzip);

    
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    

    
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    
    function thru(value, interceptor) {
      return interceptor(value);
    }

    
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    
    function wrapperChain() {
      return chain(this);
    }

    
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    
    function wrapperToIterator() {
      return this;
    }

    
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    

    
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    
    var find = createFind(findIndex);

    
    var findLast = createFind(findLastIndex);

    
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    

    
    var now = ctxNow || function() {
      return root.Date.now();
    };

    

    
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    
    function once(func) {
      return before(2, func);
    }

    
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    
    function unary(func) {
      return ary(func, 1);
    }

    
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    

    
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    
    var gt = createRelationalOperation(baseGt);

    
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    
    var isArray = Array.isArray;

    
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    
    var isBuffer = nativeIsBuffer || stubFalse;

    
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    
    function isNull(value) {
      return value === null;
    }

    
    function isNil(value) {
      return value == null;
    }

    
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    
    function isUndefined(value) {
      return value === undefined;
    }

    
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    
    var lt = createRelationalOperation(baseLt);

    
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    

    
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    
    var at = flatRest(baseAt);

    
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    
    var invoke = baseRest(baseInvoke);

    
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    
    var toPairs = createToPairs(keys);

    
    var toPairsIn = createToPairs(keysIn);

    
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    

    
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    

    
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    
    var lowerFirst = createCaseFirst('toLowerCase');

    
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    
    var upperFirst = createCaseFirst('toUpperCase');

    
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    

    
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    
    function constant(value) {
      return function() {
        return value;
      };
    }

    
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    
    var flow = createFlow();

    
    var flowRight = createFlow(true);

    
    function identity(value) {
      return value;
    }

    
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    
    function noop() {
      // No operation performed.
    }

    
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    
    var over = createOver(arrayMap);

    
    var overEvery = createOver(arrayEvery);

    
    var overSome = createOver(arraySome);

    
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    
    var range = createRange();

    
    var rangeRight = createRange(true);

    
    function stubArray() {
      return [];
    }

    
    function stubFalse() {
      return false;
    }

    
    function stubObject() {
      return {};
    }

    
    function stubString() {
      return '';
    }

    
    function stubTrue() {
      return true;
    }

    
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    

    
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    
    var ceil = createRound('ceil');

    
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    
    var floor = createRound('floor');

    
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    
    function mean(array) {
      return baseMean(array, identity);
    }

    
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    
    var round = createRound('round');

    
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    

    
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}.call(exports, __webpack_require__(51), __webpack_require__(123)(module)))

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
 var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(616);



var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};


function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}



function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" ]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" ]] = observable, _ref2;
}


function warning(message) {
  
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}



function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}



function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}



function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return callServer; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return uploadFile; });
 var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(344);
 var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
 var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(661);
 var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
 var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(679);
 var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
 var __WEBPACK_IMPORTED_MODULE_3_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_3_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_4__constants_apiConf__ = __webpack_require__(156);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var apiRequest=function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(method,url,params){var isFormData=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var headers,CONFIG,URL,formData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4__constants_apiConf__["c" ])();case 2:headers=_context.sent;CONFIG={method:method,headers:headers};URL=__WEBPACK_IMPORTED_MODULE_4__constants_apiConf__["a" ]+'/'+url.endPoint;if(!params){_context.next=14;break;}if(!((typeof params==='undefined'?'undefined':_typeof(params))==='object')){_context.next=14;break;}_context.t0=method;_context.next=_context.t0==='GET'?10:_context.t0==='DELETE'?10:_context.t0==='POST'?12:_context.t0==='PUT'?12:12;break;case 10:URL+=transformGetParams(params);return _context.abrupt('break',14);case 12:if(isFormData){if(isFormData===true){CONFIG.data=params;}else if(isFormData===1){formData=new FormData();Object.keys(params).forEach(function(key){formData.append(key,params[key]);});CONFIG.data=formData;}else if(isFormData===2){CONFIG.data=getFormDataParams(params);CONFIG.headers=new Headers(Object.assign({},headers,{'content-type':'multipart/form-data'}));}}else{CONFIG.headers['content-type']='application/x-www-form-urlencoded';CONFIG.data=__WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params);}return _context.abrupt('break',14);case 14:CONFIG.url=URL;return _context.abrupt('return',__WEBPACK_IMPORTED_MODULE_1_axios___default()(CONFIG).then(function(response){return response.data;}).catch(function(error){throw error;}));case 16:case'end':return _context.stop();}}},_callee,this);}));return function apiRequest(_x2,_x3,_x4){return _ref.apply(this,arguments);};}();var apiFetch=function(){var _ref2=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(method,url,parameters,isFormData){var params,makeCall;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:params=parameters||{};if(false){params.sb='develop_torres';}makeCall=false;return _context2.abrupt('return',__WEBPACK_IMPORTED_MODULE_3_redux_react_session__["sessionService"].loadUser().then(function(userData){params.session_user=userData.id;params.session_code=userData.user_code;params.instance=userData.instance;makeCall=true;return apiRequest(method,url,params,isFormData);}).catch(function(err){if(!makeCall){return apiRequest(method,url,params,isFormData);}throw err;}));case 4:case'end':return _context2.stop();}}},_callee2,this);}));return function apiFetch(_x5,_x6,_x7,_x8){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function transformGetParams(params){var paramsString='?';Object.keys(params).map(function(param,index){paramsString+=index>0?'&':'';paramsString+=param+'='+params[param];return param;});return paramsString;}function getFormDataParams(params){var formData=new FormData();Object.keys(params).map(function(paramKey){formData.append(paramKey,params[paramKey]);return paramKey;});return formData;}var callServer=function callServer(method,serverUrl,params){var url=serverUrl;var CONFIG={method:method,headers:{}};if(params){if((typeof params==='undefined'?'undefined':_typeof(params))==='object'){switch(method){case'GET':case'DELETE':url+=transformGetParams(params);break;case'POST':case'PUT':default:CONFIG.headers['content-type']='application/x-www-form-urlencoded';CONFIG.data=__WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params);break;}}}CONFIG.url=url;return __WEBPACK_IMPORTED_MODULE_1_axios___default()(CONFIG).then(function(response){return response.data;}).catch(function(error){throw error;});};var uploadFile=function uploadFile(file){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var params={document_file:file,type:type};return apiFetch('POST',{endPoint:'upload-resource'},params,1);}; __webpack_exports__["b"] = (apiFetch);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _objectWithoutProperties;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(62);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" ])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return TABLET_WIDTH; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return DESKTOP_WIDTH; });
var TABLET_WIDTH=768;var DESKTOP_WIDTH=1200;

 }),

 (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;


(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "b", function() { return getStepsWatchedAction; });

 __webpack_exports__["c"] = loadingAction;
 __webpack_exports__["f"] = resetLoadingAction;

 __webpack_require__.d(__webpack_exports__, "e", function() { return resetContext; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return logOut; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return setSectionSelected; });
 __webpack_exports__["a"] = globalReducer;
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_1__initialState__ = __webpack_require__(74);
 var __WEBPACK_IMPORTED_MODULE_2__action_types__ = __webpack_require__(215);
var LOADING='LOADING';var RESET_LOADING='RESET_LOADING';var RESET_STORE='RESET_STORE';var SET_STEPS_WATCHED='SET_STEPS_WATCHED';var SECTION_SELECTED='SECTION_SELECTED';// ACTIONS
function loading(payload){return{type:LOADING,payload:payload};}function resetLoading(){return{type:RESET_LOADING};}function resetStore(){return{type:RESET_STORE};}function setStepsWatched(list){return{type:SET_STEPS_WATCHED,list:list};}var getStepsWatchedAction=function getStepsWatchedAction(){return function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'getStepsWatched'}).then(function(_ref){var list=_ref.list;dispatch(setStepsWatched(list));});};};var setStepsWatchedAction=function setStepsWatchedAction(name){return function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'setStepWatched'},{name:name}).then(function(_ref2){var success=_ref2.success,info=_ref2.info;if(success)dispatch(setStepsWatched(info.list));});};};// ACTION CREATORS
function loadingAction(action){return function(dispatch){dispatch(loading(action));};}function resetLoadingAction(){return function(dispatch){dispatch(resetLoading());};}function resetStoreAction(){return function(dispatch){dispatch(resetStore());};}var resetContext=function resetContext(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__action_types__["e" ]});};};var logOut=function logOut(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'logout'});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__action_types__["b" ]});};};var setSectionSelected=function setSectionSelected(selected){return function(dispatch){dispatch({type:SECTION_SELECTED,payload:selected});};};// REDUCER
function globalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_1__initialState__["a" ].global;var action=arguments[1];switch(action.type){case LOADING:{var loadingProcesses=state.loading;if(action.payload){loadingProcesses+=1;}else{loadingProcesses-=1;}loadingProcesses=Math.max(0,loadingProcesses);return Object.assign({},state,{lastLoading:new Date().getTime(),loading:loadingProcesses});}case RESET_LOADING:return Object.assign({},state,{loading:0});case SET_STEPS_WATCHED:return Object.assign({},state,{stepsWatched:action.list});case RESET_STORE:return __WEBPACK_IMPORTED_MODULE_1__initialState__["a" ];case SECTION_SELECTED:return Object.assign({},state,{selected:action.payload});default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__chainPropTypes__ = __webpack_require__(218);

 var __WEBPACK_IMPORTED_MODULE_1__deepmerge__ = __webpack_require__(733);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__deepmerge__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__elementAcceptingRef__ = __webpack_require__(734);

 var __WEBPACK_IMPORTED_MODULE_3__elementTypeAcceptingRef__ = __webpack_require__(735);

 var __WEBPACK_IMPORTED_MODULE_4__exactProp__ = __webpack_require__(736);

 var __WEBPACK_IMPORTED_MODULE_5__formatMuiErrorMessage__ = __webpack_require__(737);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__formatMuiErrorMessage__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__getDisplayName__ = __webpack_require__(738);

 var __WEBPACK_IMPORTED_MODULE_7__HTMLElementType__ = __webpack_require__(740);

 var __WEBPACK_IMPORTED_MODULE_8__ponyfillGlobal__ = __webpack_require__(741);

 var __WEBPACK_IMPORTED_MODULE_9__refType__ = __webpack_require__(742);













 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

 __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(53);
 var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(128);




function withStyles(stylesOrCreator, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["l" ])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" ]
  }, options));
}

 __webpack_exports__["a"] = (withStyles);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "g", function() { return primary; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return secondary; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return white; });

 __webpack_require__.d(__webpack_exports__, "a", function() { return black; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return gray; });

 __webpack_require__.d(__webpack_exports__, "c", function() { return mediumGray; });



 __webpack_require__.d(__webpack_exports__, "f", function() { return orange; });


 __webpack_require__.d(__webpack_exports__, "h", function() { return red; });





 __webpack_require__.d(__webpack_exports__, "j", function() { return skyBlue; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return messageSend; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return messageReceived; });

var primary='#2196F3';var secondary='#F50057';var white='#FFFFFF';var whiteTransparent='rgba(255, 255, 255, 0.4);';var black='#000000DE';var gray='#E0E0E0';var darkGray='#646464';var mediumGray='#979797';var lightGray='#CACACA';var bgDarkGray='#F2F2F2';var bgLightGray='#F6F6F6';var orange='#FFA200';var darkOrange='#FE622D';var flatOrange='#FC4236';var red='#FF2400';var purple='#B71B46';var green='#2ECC71';var darkBlue='#28384A';var yellow='#ffff03';var yellowTransparent='rgba(255, 255, 3, 0.4)';var skyBlue='#2680EB';var messageSend='#E1FFC9';var messageReceived='#F0F0F0';var COLORS_UI=['#F44336','#9C27B0','#3F51B5','#03A9F4','#009688','#8BC34A','#E65100','#795548','#E91E63','#673AB7','#1E88E5','#006064','#43A047','#827717','#F4511E']; var _unused_webpack_default_export = ({skyBlue:skyBlue,primary:primary,secondary:secondary,white:white,whiteTransparent:whiteTransparent,black:black,gray:gray,darkGray:darkGray,mediumGray:mediumGray,lightGray:lightGray,bgDarkGray:bgDarkGray,bgLightGray:bgLightGray,orange:orange,darkOrange:darkOrange,flatOrange:flatOrange,red:red,purple:purple,green:green,darkBlue:darkBlue,yellow:yellow,yellowTransparent:yellowTransparent,messageSend:messageSend,messageReceived:messageReceived});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "a", function() { return RalewayFont; });
var RobotoFont={lightFamily:'Roboto Light',regularFamily:'Roboto',semiBoldFamily:'Roboto Medium',boldFamily:'Roboto Bold',lightWeight:300,regularWeight:500,boldWeight:600};var RalewayFont={lightFamily:'Raleway Light',regularFamily:'Raleway',semiBoldFamily:'Raleway Medium',boldFamily:'Raleway Bold',lightWeight:300,regularWeight:500,boldWeight:600}; __webpack_exports__["b"] = ({RobotoFont:RobotoFont,RalewayFont:RalewayFont});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "i", function() { return epsilon; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return epsilon2; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return pi; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return halfPi; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
 __webpack_require__.d(__webpack_exports__, "w", function() { return tau; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return radians; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return atan; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return cos; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return ceil; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return exp; });

 __webpack_require__.d(__webpack_exports__, "n", function() { return log; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return pow; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return sin; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
 __webpack_require__.d(__webpack_exports__, "u", function() { return sqrt; });
 __webpack_require__.d(__webpack_exports__, "v", function() { return tan; });
 __webpack_exports__["b"] = acos;
 __webpack_exports__["c"] = asin;
 __webpack_exports__["m"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return BASEROUTE; });
 __webpack_require__.d(__webpack_exports__, "y", function() { return ROUTE_MAIN_PAGE; });
 __webpack_require__.d(__webpack_exports__, "w", function() { return ROUTE_LOGIN; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return ROUTE_FORGET_PASSWORD; });
 __webpack_require__.d(__webpack_exports__, "x", function() { return ROUTE_LOGOUT; });
 __webpack_require__.d(__webpack_exports__, "G", function() { return ROUTE_SIGNUP; });
 __webpack_require__.d(__webpack_exports__, "H", function() { return ROUTE_SIGNUP_INVITATION; });
 __webpack_require__.d(__webpack_exports__, "I", function() { return ROUTE_SIGNUP_TEMP; });
 __webpack_require__.d(__webpack_exports__, "F", function() { return ROUTE_PROFILE; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return ROUTE_EDIT_PROFILE; });
 __webpack_require__.d(__webpack_exports__, "J", function() { return ROUTE_SOCIAL_OAUTH; });
 __webpack_require__.d(__webpack_exports__, "P", function() { return ROUTE_THINK; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return ROUTE_CHAT; });
 __webpack_require__.d(__webpack_exports__, "W", function() { return ROUTE_USERS_PROFILES; });
 __webpack_require__.d(__webpack_exports__, "X", function() { return ROUTE_USER_PROFILE; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return ROUTE_CANCEL_DELETION_ACCOUNT; });

 __webpack_require__.d(__webpack_exports__, "i", function() { return ROUTE_CONNECTIONS; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return ROUTE_CONNECTIONS_SECTION; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return ROUTE_GPDR; });
 __webpack_require__.d(__webpack_exports__, "u", function() { return ROUTE_INITIATIVES; });
 __webpack_require__.d(__webpack_exports__, "Q", function() { return ROUTE_THINK_SEED_CREATION; });
 __webpack_require__.d(__webpack_exports__, "R", function() { return ROUTE_THINK_SEED_CREATION_FROM_CALL; });
 __webpack_require__.d(__webpack_exports__, "v", function() { return ROUTE_INVITATIONS; });
 __webpack_require__.d(__webpack_exports__, "S", function() { return ROUTE_THINK_SEED_VIEW; });
 __webpack_require__.d(__webpack_exports__, "V", function() { return ROUTE_UPGRADE; });
 __webpack_require__.d(__webpack_exports__, "T", function() { return ROUTE_THINK_TANK; });
 __webpack_require__.d(__webpack_exports__, "U", function() { return ROUTE_THINK_TANKS; });
 __webpack_require__.d(__webpack_exports__, "z", function() { return ROUTE_MESSAGES; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return ROUTE_DELETE_ACCOUNT_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "D", function() { return ROUTE_NARRATIVE_THINK_CHAT; });
 __webpack_require__.d(__webpack_exports__, "B", function() { return ROUTE_NARRATIVE_SPEED_DATING; });
 __webpack_require__.d(__webpack_exports__, "Y", function() { return ROUTE_ZOOM_MEETING; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return ROUTE_CALL_FOR_IMPACT; });
 __webpack_require__.d(__webpack_exports__, "A", function() { return ROUTE_NARRATIVE; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return ROUTE_ELEMENT; });
 __webpack_require__.d(__webpack_exports__, "C", function() { return ROUTE_NARRATIVE_STEP; });
 __webpack_require__.d(__webpack_exports__, "M", function() { return ROUTE_THEME_TABLE; });
 __webpack_require__.d(__webpack_exports__, "O", function() { return ROUTE_THEME_TABLE_SECTION; });
 __webpack_require__.d(__webpack_exports__, "N", function() { return ROUTE_THEME_TABLE_EDIT; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ROUTE_CALL; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ROUTE_CALL_HALL; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return ROUTE_CALL_HALL_SECTION; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return ROUTE_CALL_THEME_TABLE; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return ROUTE_IMPERSONATE; });
 __webpack_require__.d(__webpack_exports__, "E", function() { return ROUTE_NO_RECOMMENDATIONS; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return ROUTE_FINE_SERENDIPITY; });
 __webpack_require__.d(__webpack_exports__, "K", function() { return ROUTE_SPEED_DATING; });
 __webpack_require__.d(__webpack_exports__, "L", function() { return ROUTE_SPEED_DATING_RANDOM; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return ROUTE_FEEDBACK_USERS; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return ROUTE_FEEDBACK_TABLES; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return ROUTE_EMBED_MAIN; });
var BASEROUTE='/';var ROUTE_MAIN_PAGE='/main';var ROUTE_LOGIN='/signin';var ROUTE_FORGET_PASSWORD='/forgetpassword';var ROUTE_LOGOUT='/logout';var ROUTE_SIGNUP='/signup';var ROUTE_SIGNUP_INVITATION='/signup/:hash';var ROUTE_SIGNUP_TEMP='/signup_temp';var ROUTE_PROFILE='/userprofile';var ROUTE_EDIT_PROFILE='/userprofile/edit';var ROUTE_SOCIAL_OAUTH='/social_oauth/:type?';var ROUTE_THINK='/think';var ROUTE_CHAT='/chat/:id';var ROUTE_USERS_PROFILES='/users_profiles/:id';var ROUTE_USER_PROFILE='/user/:id';var ROUTE_CANCEL_DELETION_ACCOUNT='/cancel-deletion';var ROUTE_DISCOVER='/discover';var ROUTE_CONNECTIONS='/connections';var ROUTE_CONNECTIONS_SECTION='/connections/:section';var ROUTE_GPDR='/gpdr';var ROUTE_INITIATIVES='/initiatives';var ROUTE_THINK_SEED_CREATION='/think-chat/creation';var ROUTE_THINK_SEED_CREATION_FROM_CALL='/think-chat/creation/call/:callId';var ROUTE_INVITATIONS='/invitations';var ROUTE_THINK_SEED_VIEW='/think-seed/view/:id';var ROUTE_UPGRADE='/upgrade/:id';var ROUTE_THINK_TANK='/think-tank/:id';var ROUTE_THINK_TANKS='/think-tanks';var ROUTE_MESSAGES='/messages';var ROUTE_DELETE_ACCOUNT_SUCCESS='/deleted-account';var ROUTE_NARRATIVE_THINK_CHAT='/narratives/:id/think-chats/';var ROUTE_NARRATIVE_SPEED_DATING='/narratives/:id/speed-dating/';var ROUTE_ZOOM_MEETING='/zoom-meeting/:id';var ROUTE_CALL_FOR_IMPACT='/call-for-impact/:id';var ROUTE_NARRATIVE='/narratives/:id';var ROUTE_ELEMENT='/elements/:id';var ROUTE_NARRATIVE_STEP='/narratives/:idn/step/:ids';var ROUTE_THEME_TABLE='/theme-table/:id';var ROUTE_THEME_TABLE_SECTION='/theme-table/:id/:section';var ROUTE_THEME_TABLE_EDIT='/think-seed/:id/edit';var ROUTE_CALL='/calls/:id';var ROUTE_CALL_HALL='/calls/:id/hall';var ROUTE_CALL_HALL_SECTION='/calls/:id/hall/:section';var ROUTE_CALL_THEME_TABLE='/calls/:callId/theme-table/:id';var ROUTE_IMPERSONATE='/impersonate/:hash';var ROUTE_NO_RECOMMENDATIONS='/no-recommendations';var ROUTE_FINE_SERENDIPITY='/fine-tune';var ROUTE_SPEED_DATING='/speed-dating/:id';var ROUTE_SPEED_DATING_RANDOM='/speed-dating/:id/random';var ROUTE_FEEDBACK_USERS='/recommendations/users';var ROUTE_FEEDBACK_TABLES='/recommendations/tables';var ROUTE_EMBED_MAIN='/embed/:id';

 }),

 (function(module, exports, __webpack_require__) {

(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid()';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

}.call(exports, __webpack_require__(123)(module)))

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return getNarrativeNextStep; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return resetAll; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return goHome; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return getSpecificStep; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return getNarrative; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return getObjective; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return setStepAsViewed; });
 var __WEBPACK_IMPORTED_MODULE_0_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_2_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_3_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_4_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
 var __WEBPACK_IMPORTED_MODULE_6_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(352);
var getNarrativeNextStep=function getNarrativeNextStep(narrativeId,actualStep){var params={current_step:actualStep};var endPoint='narrative/'+narrativeId+'/actual_step';return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:endPoint},params);};var resetAll=function resetAll(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_7__types__["a" ]});};};var goHome=function goHome(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_7__types__["a" ]});__WEBPACK_IMPORTED_MODULE_4_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_6_constants_urls__["u" ]);};};var getSpecificStep=function getSpecificStep(idn,ids){return function(dispatch,getState){var _getState=getState(),app=_getState.app;var url='narratives/'+idn+'/step/'+ids;dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:url}).then(function(step){dispatch({type:__WEBPACK_IMPORTED_MODULE_7__types__["c" ],payload:step});});Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'narratives/'+idn}).then(function(narrative){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));var id=narrative.id,name=narrative.name,specialType=narrative.specialType;var color=narrative.color;if(typeof app.advanced_configuration!=='undefined'&&typeof app.advanced_configuration.random_colors!=='undefined'&&app.advanced_configuration.random_colors){color=Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["i" ])();}else{var colorInfo=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["a" ],function(c){if(c.color.toLowerCase()===color.toLowerCase()){return true;}return false;});if(colorInfo){color=colorInfo;}}var context={id:id,elementType:'narrative',elementId:id,name:name,specialType:specialType,color:color};dispatch({type:__WEBPACK_IMPORTED_MODULE_7__types__["b" ],payload:context});var breadcrumb=[{color:'#ffffff',text:name}];dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_components_Navbar_modules__["b" ])(breadcrumb.slice()));});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));};};// Context functions
var getNarrative=function getNarrative(narrativeId,firstStep){return function(dispatch,getState){var _getState2=getState(),app=_getState2.app;if(firstStep){dispatch({type:__WEBPACK_IMPORTED_MODULE_7__types__["d" ],payload:firstStep});}dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'narratives/'+narrativeId}).then(function(narrative){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));var id=narrative.id,name=narrative.name,specialType=narrative.specialType;var color=narrative.color;if(typeof app.advanced_configuration!=='undefined'&&typeof app.advanced_configuration.random_colors!=='undefined'&&app.advanced_configuration.random_colors){color=Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["i" ])();}else{var colorInfo=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["a" ],function(c){if(c.color.toLowerCase()===color.toLowerCase()){return true;}return false;});if(colorInfo){color=colorInfo;}}var context={id:id,elementType:'narrative',elementId:id,name:name,specialType:specialType,color:color};dispatch({type:__WEBPACK_IMPORTED_MODULE_7__types__["b" ],payload:context});var breadcrumb=[{color:'#ffffff',text:name}];dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_components_Navbar_modules__["b" ])(breadcrumb.slice()));});};};var getObjective=function getObjective(objectiveId){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'objective/'+objectiveId}).then(function(response){var color=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["a" ],{color:response.color});if(!color){color={color:response.color,contrastColor:Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["h" ])(response.color)};}var context={id:response.id,elementType:'objective',elementId:response.id,name:response.name,color:color};dispatch({type:__WEBPACK_IMPORTED_MODULE_7__types__["b" ],payload:context});__WEBPACK_IMPORTED_MODULE_4_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_6_constants_urls__["y" ]);var breadcrumb=[{color:'#ffffff',text:response.name}];dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_components_Navbar_modules__["b" ])(breadcrumb.slice()));});};};var setStepAsViewed=function setStepAsViewed(id,narrativeId){var params={type:'narrative',id:narrativeId,is_visualizated:1};return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'question/'+id+'/viewed'},params);};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "b", function() { return setBreadcrumb; });



 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(682);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INITIAL_STATE={breadcrumb:[]};var resetBreadcrumb=function resetBreadcrumb(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["a" ],breadcrumb:[]});};};var setBreadcrumb=function setBreadcrumb(breadcrumb){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["a" ],breadcrumb:breadcrumb});};};var addBreadcrumb=function addBreadcrumb(element){return function(dispatch,getState){var breadcrumb=getState().navbar.breadcrumb;breadcrumb.push(element);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["a" ],breadcrumb:breadcrumb});};};var removeBreadcrumb=function removeBreadcrumb(){return function(dispatch,getState){var breadcrumb=getState().navbar.breadcrumb;breadcrumb.pop();dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["a" ],breadcrumb:breadcrumb});};};var setBreadcrumbPosition=function setBreadcrumbPosition(element,position){return function(dispatch,getState){var breadcrumb=getState().navbar.breadcrumb;breadcrumb[position]=element;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["a" ],breadcrumb:breadcrumb});};};var ACTION_HANDLERS=_defineProperty({},__WEBPACK_IMPORTED_MODULE_1__types__["a" ],function(state,_ref){var breadcrumb=_ref.breadcrumb;return Object.assign({},state,{breadcrumb:breadcrumb});}); __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(861);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = objectToGetParams;
function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return encodeURIComponent(key) + "=" + encodeURIComponent(String(value));
    });
    return params.length > 0 ? "?" + params.join('&') : '';
}


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(601);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_INIT; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return STATUS_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return STATUS_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return STATUS_SAVING; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return STATUS_SAVED; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return STATUS_INVITATIONS_SENT; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return STATUS_NO_INVITATIONS_SENT; });

var STATUS_INIT='init';var STATUS_SUCCESS='success';var STATUS_FAILURE='failure';var STATUS_SAVING='saving';var STATUS_SAVED='saved';var STATUS_INVITATIONS_SENT='invitations_sent';var STATUS_NO_INVITATIONS_SENT='no_invitations_sent';var STATUS_REDIRECT='redirect';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createIcon;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

function createIcon(iconConfig) {
    var Icon = function (_a) {
        var bgStyle = _a.bgStyle, borderRadius = _a.borderRadius, iconFillColor = _a.iconFillColor, round = _a.round, size = _a.size, rest = __rest(_a, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", __assign({ viewBox: "0 0 64 64", width: size, height: size }, rest),
            round ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "32", cy: "32", r: "31", fill: iconConfig.color, style: bgStyle })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { width: "64", height: "64", rx: borderRadius, ry: borderRadius, fill: iconConfig.color, style: bgStyle })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: iconConfig.path, fill: iconFillColor })));
    };
    Icon.defaultProps = {
        bgStyle: {},
        borderRadius: 0,
        iconFillColor: 'white',
        size: 64,
    };
    return Icon;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__ShareButton__ = __webpack_require__(1314);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = __assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function (key) {
            delete passedProps[key];
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ShareButton__["a" ], __assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-" + networkName;
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(CreatedButton);
}
 __webpack_exports__["a"] = (createShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(75);
var history=Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" ])({basename:'/'}); __webpack_exports__["a"] = (history);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = assert;
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssertionError =  (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(Error));
function assert(value, message) {
    if (!value) {
        throw new AssertionError(message);
    }
}


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionReducer = exports.sessionService = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(624);

var _jsCookie = __webpack_require__(625);

var Cookies = _interopRequireWildcard(_jsCookie);

var _isPromise = __webpack_require__(626);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _actions = __webpack_require__(627);

var _reducer = __webpack_require__(628);

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var instance = void 0;

var sessionService = exports.sessionService = function () {
  function sessionService(store, options) {
    _classCallCheck(this, sessionService);

    instance = this;
    sessionService.setOptions(store, options);
    return instance;
  }

  _createClass(sessionService, null, [{
    key: 'setOptions',
    value: function setOptions(store) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          driver = _ref.driver,
          validateSession = _ref.validateSession,
          _ref$refreshOnCheckAu = _ref.refreshOnCheckAuth,
          refreshOnCheckAuth = _ref$refreshOnCheckAu === undefined ? false : _ref$refreshOnCheckAu,
          _ref$expires = _ref.expires,
          expires = _ref$expires === undefined ? 360 : _ref$expires,
          _ref$redirectPath = _ref.redirectPath,
          redirectPath = _ref$redirectPath === undefined ? 'login' : _ref$redirectPath,
          _ref$server = _ref.server,
          server = _ref$server === undefined ? false : _ref$server;

      instance.store = store;
      instance.refreshOnCheckAuth = refreshOnCheckAuth;
      instance.redirectPath = redirectPath;
      instance.expires = expires;
      instance.driver = driver;
      instance.server = server;
      instance.validateSession = validateSession;

      // configure the storage
      var storageOptions = {
        name: 'redux-react-session'
      };
      var localforage = __webpack_require__(629);
      if (driver && driver !== 'COOKIES') {
        storageOptions.driver = localforage[driver];
      }
      instance.storage = localforage.createInstance(storageOptions);
    }
  }, {
    key: 'initSessionService',
    value: function initSessionService(store, options) {
      instance = new sessionService(store, options);
      return sessionService.refreshFromLocalStorage();
    }
  }, {
    key: 'initServerSession',
    value: function initServerSession(store, req, options) {
      instance = new sessionService(store, _extends({}, options, { server: true }));
      var parseCookies = function parseCookies(req) {
        var list = {};
        var rc = req.get('cookie');
        rc && rc.split(';').forEach(function (cookie) {
          var parts = cookie.split('=');
          if (parts[0].trim() === _constants.USER_SESSION || parts[0].trim() === _constants.USER_DATA) {
            list[parts[0].trim()] = JSON.parse(decodeURIComponent(parts[1]));
          }
        });

        return list;
      };
      return sessionService.saveFromClient(parseCookies(req));
    }
  }, {
    key: 'saveFromClient',
    value: function saveFromClient(cookies) {
      return new Promise(function (resolve, reject) {
        if (cookies[_constants.USER_SESSION]) {
          sessionService.saveSession(cookies[_constants.USER_SESSION]).then(function () {
            if (cookies[_constants.USER_DATA]) {
              sessionService.saveUser(cookies[_constants.USER_DATA]).then(function () {
                return resolve();
              });
            } else {
              return resolve();
            }
          });
        } else {
          instance.store.dispatch((0, _actions.getSessionError)());
          reject('Session not found');
        }
      });
    }
  }, {
    key: 'invalidateSession',
    value: function invalidateSession() {
      instance.store.dispatch((0, _actions.invalidSession)());
      sessionService.deleteSession();
      sessionService.deleteUser();
    }
  }, {
    key: 'attemptLoadUser',
    value: function attemptLoadUser() {
      instance.store.dispatch((0, _actions.getSessionSuccess)());
      return sessionService.loadUser().then(function (user) {
        instance.store.dispatch((0, _actions.getUserSessionSuccess)(user));
      }).catch(function () {
        instance.store.dispatch((0, _actions.getUserSessionError)());
      });
    }
  }, {
    key: 'refreshFromLocalStorage',
    value: function refreshFromLocalStorage() {
      var _this = this;

      return sessionService.loadSession().then(function (session) {
        if (instance.validateSession) {
          var value = instance.validateSession(session);

          if ((0, _isPromise2.default)(value)) {
            return value.then(function (valid) {
              if (!valid) {
                throw new Error("Session is invalid");
              }
              return _this.attemptLoadUser();
            }).catch(function () {
              _this.invalidateSession();
            });
          } else if (!value) {
            _this.invalidateSession();
            return;
          }
        }
        return _this.attemptLoadUser();
      }).catch(function () {
        instance.store.dispatch((0, _actions.getSessionError)());
      });
    }
  }, {
    key: 'checkAuth',
    value: function checkAuth(nextState, replace, next) {
      var _instance = instance,
          refreshOnCheckAuth = _instance.refreshOnCheckAuth,
          store = _instance.store;

      sessionService.loadSession().then(function () {
        refreshOnCheckAuth && store.dispatch((0, _actions.getSessionSuccess)());
        sessionService.loadUser().then(function (user) {
          refreshOnCheckAuth && store.dispatch((0, _actions.getUserSessionSuccess)(user));
          next();
        }).catch(function () {
          return next();
        });
      }).catch(function () {
        refreshOnCheckAuth && store.dispatch((0, _actions.getSessionError)());
        refreshOnCheckAuth && store.dispatch((0, _actions.getUserSessionError)());
        replace({
          pathname: instance.redirectPath,
          state: { nextPathname: nextState.location.pathname }
        });
        next();
      });
    }
  }, {
    key: 'saveSession',
    value: function saveSession(session) {
      return new Promise(function (resolve) {
        if (instance.server) {
          instance[_constants.USER_SESSION] = session;
          instance.store.dispatch((0, _actions.getSessionSuccess)());
          resolve();
        } else if (instance.driver === 'COOKIES') {
          Cookies.set(_constants.USER_SESSION, session, { expires: instance.expires });
          instance.store.dispatch((0, _actions.getSessionSuccess)());
          resolve();
        } else {
          instance.storage.setItem(_constants.USER_SESSION, session).then(function () {
            instance.store.dispatch((0, _actions.getSessionSuccess)());
            resolve();
          }).catch(function () {
            Cookies.set(_constants.USER_SESSION, session, { expires: instance.expires });
            instance.store.dispatch((0, _actions.getSessionSuccess)());
            resolve();
          });
        }
      });
    }
  }, {
    key: 'loadSession',
    value: function loadSession() {
      return new Promise(function (resolve, reject) {
        if (instance.server) {
          instance[_constants.USER_SESSION] ? resolve(instance[_constants.USER_SESSION]) : reject();
        } else if (instance.driver === 'COOKIES') {
          var cookies = Cookies.getJSON(_constants.USER_SESSION);
          cookies ? resolve(cookies) : reject('Session not found');
        } else {
          instance.storage.getItem(_constants.USER_SESSION).then(function (currentSession) {
            if (currentSession) {
              resolve(currentSession);
            } else {
              var _cookies = Cookies.getJSON(_constants.USER_SESSION);
              _cookies ? resolve(_cookies) : reject('Session not found');
            }
          }).catch(function (err) {
            return reject(err);
          });
        }
      });
    }
  }, {
    key: 'deleteSession',
    value: function deleteSession() {
      return instance.storage.removeItem(_constants.USER_SESSION).then(function () {
        instance.store.dispatch((0, _actions.getSessionError)());
        Cookies.remove(_constants.USER_SESSION);
        delete instance[_constants.USER_SESSION];
      });
    }
  }, {
    key: 'saveUser',
    value: function saveUser(user) {
      return new Promise(function (resolve) {
        if (instance.server) {
          instance[_constants.USER_DATA] = user;
          instance.store.dispatch((0, _actions.getUserSessionSuccess)(user));
          resolve();
        } else if (instance.driver === 'COOKIES') {
          Cookies.set(_constants.USER_DATA, user, { expires: instance.expires });
          instance.store.dispatch((0, _actions.getUserSessionSuccess)(user));
          resolve();
        } else {
          instance.storage.setItem(_constants.USER_DATA, user).then(function (user) {
            instance.store.dispatch((0, _actions.getUserSessionSuccess)(user));
            resolve();
          }).catch(function () {
            instance.store.dispatch((0, _actions.getUserSessionSuccess)(user));
            Cookies.set(_constants.USER_DATA, user, { expires: instance.expires });
            resolve();
          });
        }
      });
    }
  }, {
    key: 'loadUser',
    value: function loadUser() {
      return new Promise(function (resolve, reject) {
        if (instance.server) {
          instance[_constants.USER_DATA] ? resolve(instance[_constants.USER_DATA]) : reject();
        } else if (instance.driver === 'COOKIES') {
          var cookies = Cookies.getJSON(_constants.USER_DATA);
          cookies ? resolve(cookies) : reject('User not found');
        } else {
          instance.storage.getItem(_constants.USER_DATA).then(function (currentUser) {
            if (currentUser) {
              resolve(currentUser);
            } else {
              var _cookies2 = Cookies.getJSON(_constants.USER_DATA);
              _cookies2 ? resolve(_cookies2) : reject('User not found');
            }
          }).catch(function (err) {
            return reject(err);
          });
        }
      });
    }
  }, {
    key: 'deleteUser',
    value: function deleteUser() {
      return instance.storage.removeItem(_constants.USER_DATA).then(function () {
        instance.store.dispatch((0, _actions.getUserSessionError)());
        Cookies.remove(_constants.USER_DATA);
        delete instance[_constants.USER_DATA];
      });
    }
  }]);

  return sessionService;
}();

var sessionReducer = exports.sessionReducer = _reducer2.default;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "h", function() { return NARRATIVE; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_FOR_IMPACT; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return THINK_SEED; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return THINK_TANK; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ELEMENT; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return THEME_TABLE; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return USER; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return INITIAL_CARD; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return SPEED_DATING_RANDOM; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return SPEED_DATING_MEETING; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return SPEED_DATING; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return MEETING; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return FEEDBACK_USERS; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return FEEDBACK_TABLES; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return EMBED; });
var NARRATIVE='narrative';var CALL_FOR_IMPACT='call_for_impact';var THINK_SEED='think_seed';var THINK_TANK='think_tank';var ELEMENT='element';var THEME_TABLE='theme_table';var USER='user';var INITIAL_CARD='initial_card';var SPEED_DATING_RANDOM='speed_dating_random';var SPEED_DATING_MEETING='speed_dating_meeting';var SPEED_DATING='speed_dating';var MEETING='meeting';var FEEDBACK_USERS='feedback_users';var FEEDBACK_TABLES='feedback_tables';var EMBED='embed';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "e", function() { return getThinkSeed; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return joinThinkSeed; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return setContributionsInThinkSeed; });
 __webpack_exports__["b"] = getMyThinkChats;
 __webpack_require__.d(__webpack_exports__, "g", function() { return joinThemeTable; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return updateThemeTable; });
 __webpack_exports__["a"] = changeThinkSeedImage;
 __webpack_require__.d(__webpack_exports__, "i", function() { return leaveThinkChat; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return getNarrativeThinkChats; });

 __webpack_require__.d(__webpack_exports__, "f", function() { return getUserNarrativeThinkChats; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return getRecommendedTables; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return sendTableFeedback; });
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_1_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_2_modules_socket_actions__ = __webpack_require__(81);
 var __WEBPACK_IMPORTED_MODULE_3_constants_rooms__ = __webpack_require__(158);
 var __WEBPACK_IMPORTED_MODULE_4_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(365);
var getThinkSeed=function getThinkSeed(id){var endPoint='think-seed/'+id;return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:endPoint});};var joinThinkSeed=function joinThinkSeed(id){var endPoint='think-seed/'+id+'/join';Object(__WEBPACK_IMPORTED_MODULE_2_modules_socket_actions__["c" ])(__WEBPACK_IMPORTED_MODULE_3_constants_rooms__["b" ],id);return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:endPoint});};var setContributionsInThinkSeed=function setContributionsInThinkSeed(id,contributions,other){var endPoint='think-seed/'+id+'/contributions';var params={contributions:contributions.join(','),other:other};return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:endPoint},params);};function getMyThinkChats(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["e" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'think-seed/me'},{}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["f" ],payload:{data:data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));data.forEach(function(table){Object(__WEBPACK_IMPORTED_MODULE_2_modules_socket_actions__["c" ])(__WEBPACK_IMPORTED_MODULE_3_constants_rooms__["b" ],table.id);});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["d" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));});};}var joinThemeTable=function joinThemeTable(table){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["m" ],payload:table});Object(__WEBPACK_IMPORTED_MODULE_2_modules_socket_actions__["c" ])(__WEBPACK_IMPORTED_MODULE_3_constants_rooms__["b" ],table.id);};};var updateThemeTable=function updateThemeTable(table){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["q" ],payload:table});};};function changeThinkSeedImage(id,image){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["b" ],payload:{data:image}});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'think-seed/'+id+'/image'},{image:image}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["c" ],payload:{data:data}});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["a" ]});});};}var leaveThinkChat=function leaveThinkChat(user,chatId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));var params={userId:user.id,chatId:chatId};dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["n" ],payload:{params:params}});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'chat/'+chatId+'/leave'}).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));__WEBPACK_IMPORTED_MODULE_4_store_history__["a" ].push('/think');}).catch(function(error){console.error('couldn´t leave chat',error);dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));});};};var getNarrativeThinkChats=function getNarrativeThinkChats(narrativeId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["h" ],payload:{narrativeId:narrativeId}});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'narratives/'+narrativeId+'/think-chats'}).then(function(response){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["i" ],payload:{narrativeId:narrativeId,thinkChats:response.data}});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["g" ],payload:{narrativeId:narrativeId}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));});};};var getNarrativeTopics=function getNarrativeTopics(narrativeId){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'narratives/'+narrativeId+'/think-chats'});};var getUserNarrativeThinkChats=function getUserNarrativeThinkChats(narrativeId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["k" ],payload:{narrativeId:narrativeId}});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'narratives/'+narrativeId+'/think-chats'},{user_join:1}).then(function(response){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["l" ],payload:{narrativeId:narrativeId,thinkChats:response.data}});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["j" ],payload:{narrativeId:narrativeId}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));});};};var getRecommendedTables=function getRecommendedTables(){var includeInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var search=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'recommendations/tables'},{include_info:includeInfo,search:search});};var sendTableFeedback=function sendTableFeedback(tableId,feedback,fromType,fromId){var params={element_type:'theme_table',element_id:tableId,accept:feedback,from_type:fromType,from_id:fromId};return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'feedback'},params);};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(941);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(942);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Loading=function(_Component){_inherits(Loading,_Component);function Loading(){_classCallCheck(this,Loading);return _possibleConstructorReturn(this,(Loading.__proto__||Object.getPrototypeOf(Loading)).apply(this,arguments));}_createClass(Loading,[{key:'componentDidMount',value:function componentDidMount(){var colorAnimation=this.props.colorAnimation;Object(__WEBPACK_IMPORTED_MODULE_2__animation__["a" ])(colorAnimation);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{color:'transparent',className:'loading_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{className:'loading_component'}));}}]);return Loading;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Loading.propTypes={colorAnimation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Loading.defaultProps={colorAnimation:'#999999'}; __webpack_exports__["a"] = (Loading);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_create__ = __webpack_require__(1456);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_create__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_creator__ = __webpack_require__(185);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_creator__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_local__ = __webpack_require__(1485);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__src_local__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_matcher__ = __webpack_require__(506);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__src_matcher__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_mouse__ = __webpack_require__(1486);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__src_mouse__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_namespace__ = __webpack_require__(277);
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__src_namespace__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_namespaces__ = __webpack_require__(278);
 __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__src_namespaces__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__src_point__ = __webpack_require__(186);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__src_point__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_8__src_select__ = __webpack_require__(504);
 __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__src_select__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_9__src_selectAll__ = __webpack_require__(1487);
 __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_9__src_selectAll__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_10__src_selection_index__ = __webpack_require__(56);
 __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selection_index__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_11__src_selector__ = __webpack_require__(279);
 __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selector__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__ = __webpack_require__(505);
 __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_13__src_selection_style__ = __webpack_require__(509);
 __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_13__src_selection_style__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_14__src_touch__ = __webpack_require__(1488);
 __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_14__src_touch__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_15__src_touches__ = __webpack_require__(1489);
 __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__src_touches__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_16__src_window__ = __webpack_require__(280);
 __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_16__src_window__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_17__src_selection_on__ = __webpack_require__(281);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["c"]; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["a"]; });




















 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetID = resetID;
exports.default = idgen;
var id = 0;

function resetID() {
  id = 0;
}

function idgen() {
  var oldId = id;
  id += 1;
  return oldId;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(818);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__ModalManager__ = __webpack_require__(403);




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = capitalize;
 var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(13);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? "Material-UI: capitalize(string) expects a string argument." : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" ])(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(1150);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "m", function() { return sendFile; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return viewDocument; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return markChatAsRead; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return addNewChat; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return fetchUserChats; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return sendMessage; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return fetchChat; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return getOlderMessages; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return resetSelectedChat; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return leaveChat; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return killSeed; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return getInvitations; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return rejectInvitation; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return acceptInvitation; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return setAsLeader; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return setSelectChatImage; });

 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_modules_socket_actions__ = __webpack_require__(81);
 var __WEBPACK_IMPORTED_MODULE_5_modules_socket_constants__ = __webpack_require__(155);
 var __WEBPACK_IMPORTED_MODULE_6_constants_chat__ = __webpack_require__(216);
 var __WEBPACK_IMPORTED_MODULE_7_constants_rooms__ = __webpack_require__(158);
 var __WEBPACK_IMPORTED_MODULE_8_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_9_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_10_constants_notifications__ = __webpack_require__(108);
 var __WEBPACK_IMPORTED_MODULE_11_store_globalState_initialState__ = __webpack_require__(74);
 var __WEBPACK_IMPORTED_MODULE_12__types__ = __webpack_require__(694);
var _ACTION_HANDLERS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_11_store_globalState_initialState__["a" ].chats;var handleChats=function handleChats(chats){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["b" ],chats:chats});};};var sendFile=function sendFile(data,message,callback){return function(){var params={document_file:message.file};Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'upload-resource'},params,1).then(function(response){var params2=Object.assign({},message,{hash:response.info.hash,temp_id:message.temp_id});Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'chat/'+message.chat_id+'/attachment'},params2).then(function(){callback();});});};};var viewDocument=function viewDocument(hash,bp){var params={actual_bp:bp,h:hash};return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'documents/view'},params);};var markChatAsRead=function markChatAsRead(chatId){return function(dispatch,getState){var user=getState().session.user.id;var chats=getState().chats.chats;var chat=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chats,{id:chatId});if(chat&&chat.last_message&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(chat.last_message.users_read,function(u){return u===user;})===-1){Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'chat/read'},{chat_id:chatId});dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["i" ],chatId:chatId,user:user});}};};var addNewChat=function addNewChat(chat){return function(dispatch,getState){var chats=getState().chats.chats;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chats,{id:chat.id})){chats.push(chat);dispatch(handleChats(chats));}};};var fetchUserChats=function fetchUserChats(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'users/chats'}).then(function(chats){dispatch(handleChats(chats));});};};var sendMessage=function sendMessage(message){return function(dispatch,getState){Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'message'},message);var chat=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(getState().chats.chats,{id:message.chat_id});if(chat){// Send notification to room
var newMessage=Object.assign({},message);newMessage.read=0;newMessage.type='text';var room=false;switch(chat.element_related.type_id){case __WEBPACK_IMPORTED_MODULE_6_constants_chat__["b" ]:room=''+__WEBPACK_IMPORTED_MODULE_5_modules_socket_constants__["b" ]+__WEBPACK_IMPORTED_MODULE_5_modules_socket_constants__["e" ]+__WEBPACK_IMPORTED_MODULE_7_constants_rooms__["b" ]+__WEBPACK_IMPORTED_MODULE_5_modules_socket_constants__["e" ]+chat.element_related.id;break;case __WEBPACK_IMPORTED_MODULE_6_constants_chat__["a" ]:room=''+__WEBPACK_IMPORTED_MODULE_5_modules_socket_constants__["b" ]+__WEBPACK_IMPORTED_MODULE_5_modules_socket_constants__["e" ]+__WEBPACK_IMPORTED_MODULE_7_constants_rooms__["a" ]+__WEBPACK_IMPORTED_MODULE_5_modules_socket_constants__["e" ]+chat.element_related.id;break;default:break;}Object(__WEBPACK_IMPORTED_MODULE_4_modules_socket_actions__["e" ])(room,__WEBPACK_IMPORTED_MODULE_12__types__["e" ],{message:JSON.stringify(newMessage)});}};};var fetchChat=function fetchChat(chatId){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'chat/'+chatId});};var getOlderMessages=function getOlderMessages(){return function(dispatch,getState){var _getState=getState(),selectedChat=_getState.chats.selectedChat;if(selectedChat){var firstMessage=selectedChat.messages[0].id;var chatId=selectedChat.id;dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["j" ],isLoadingOlder:true});Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'chat/'+chatId+'/messages'},{before_than:firstMessage}).then(function(response){var newMessages=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(selectedChat.messages.concat(response),'id');var orderMessages=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(newMessages,['timestamp'],['asc']);selectedChat.messages=orderMessages;dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["k" ],selectedChat:selectedChat});dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["j" ],isLoadingOlder:false});});}};};var resetSelectedChat=function resetSelectedChat(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["k" ],selectedChat:null});};};var leaveChat=function leaveChat(chatId){return function(dispatch){var params={chatId:chatId};dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["d" ],params:params});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'chat/'+chatId+'/leave'}).then(function(){__WEBPACK_IMPORTED_MODULE_8_store_history__["a" ].push('/think');dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));}).catch(function(error){console.error('couldn´t leave chat',error);dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));});};};var killSeed=function killSeed(user,chatId){return function(dispatch){var params={userId:user.id,chatId:chatId};dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["d" ],params:params});return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'chat/'+chatId+'/leave'});};};var getInvitations=function getInvitations(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'think-seed/invitations'}).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["c" ],invitations:response});});};};var rejectInvitation=function rejectInvitation(id,callback){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'invitation/'+id+'/reject '}).then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["h" ],id:id});callback();});};};var acceptInvitation=function acceptInvitation(invitation,thinkSeedId,callback){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["a" ],invitation:invitation});callback();};};var setAsLeader=function setAsLeader(thinkSeedId,userId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["n" ]});Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'think-seed/'+thinkSeedId+'/leader/'+userId}).then(function(chat){dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["l" ],chat:chat});dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["k" ],selectedChat:chat});});};};var setSelectChatImage=function setSelectChatImage(urlImage){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_12__types__["m" ],image:urlImage});};};var fetchThinkTanks=function fetchThinkTanks(userId){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'users/'+userId+'/think-tanks'});};var handleNewNotification=function handleNewNotification(state,action){var payload=action.payload;var newState=Object.assign({},state);switch(payload.req_message){case __WEBPACK_IMPORTED_MODULE_10_constants_notifications__["d" ]:{var chat=JSON.parse(payload.chat);var chats=state.chats?[].concat(_toConsumableArray(state.chats)):null;if(chats&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chats,{id:chat.id})){chats.push(chat);}return Object.assign({},state,{chats:chats});}case __WEBPACK_IMPORTED_MODULE_10_constants_notifications__["b" ]:{var message=JSON.parse(payload.message);newState.newMessage=Object.assign({},message);var found=false;if(newState.chats){for(var i=0;i<newState.chats.length;i+=1){if(newState.chats[i].id===parseInt(message.chat_id,10)){newState.chats[i].last_message=message;found=true;}}}if(!found){newState.mustReloadChats=true;}}break;case __WEBPACK_IMPORTED_MODULE_10_constants_notifications__["e" ]:{var invitation=JSON.parse(payload.invitation);var invitations=state.invitations;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(invitations,{id:invitation.id})){invitations.push(invitation);}return Object.assign({},state,{invitations:invitations});}default:break;}return newState;};var ACTION_HANDLERS=(_ACTION_HANDLERS={},_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["c" ],function(state,_ref){var invitations=_ref.invitations;return Object.assign({},state,{invitations:invitations,mustReloadInvitations:false});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["b" ],function(state,_ref2){var chats=_ref2.chats;return Object.assign({},state,{chats:[].concat(_toConsumableArray(chats)),mustReloadChats:false});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["k" ],function(state,_ref3){var selectedChat=_ref3.selectedChat;return Object.assign({},state,{selectedChat:selectedChat});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["i" ],function(state,_ref4){var chatId=_ref4.chatId,user=_ref4.user;var newState=Object.assign({},state);if(newState.chats){for(var i=0;i<newState.chats.length;i+=1){if(newState.chats[i].id===chatId){if(!newState.chats[i].last_message){newState.chats[i].last_message={};}if(!newState.chats[i].last_message.users_read){newState.chats[i].last_message.users_read=[];}newState.chats[i].last_message.users_read.push(user);}}}return newState;}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["f" ],function(state,action){return handleNewNotification(state,action);}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["g" ],function(state,action){return handleNewNotification(state,action);}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["j" ],function(state,_ref5){var isLoadingOlder=_ref5.isLoadingOlder;return Object.assign({},state,{isLoadingOlder:isLoadingOlder});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["d" ],function(state,_ref6){var params=_ref6.params;var chats=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(state.chats,function(chat){return chat.id!==params.chatId;});return Object.assign({},state,{chats:chats});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["h" ],function(state,_ref7){var id=_ref7.id;var invitations=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(state.invitations,function(invitation){return invitation.id!==id;});return Object.assign({},state,{invitations:invitations});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["a" ],function(state,_ref8){var invitation=_ref8.invitation;var invitations=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(state.invitations,function(inv){return invitation.id!==inv.id;});return Object.assign({},state,{invitations:invitations});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["n" ],function(state){return Object.assign({},state,{selectLeaderStatus:__WEBPACK_IMPORTED_MODULE_9_constants_status__["f" ]});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["l" ],function(state,_ref9){var chat=_ref9.chat;var chats=state.chats;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(chats,{id:chat.id});chats.push(chat);var newState=Object.assign({},state);newState.chats=chats;newState.selectLeaderStatus=__WEBPACK_IMPORTED_MODULE_9_constants_status__["e" ];return newState;}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_12__types__["m" ],function(state,_ref10){var image=_ref10.image;var selectedChat=state.selectedChat;selectedChat.element_related.image=image;var newState=Object.assign({},state);newState.selectedChat=selectedChat;return newState;}),_ACTION_HANDLERS); __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Avatar__ = __webpack_require__(863);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Avatar__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(492);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["c"]; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["b"]; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(118);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(493);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(1432);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__src_cross__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(1433);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__src_descending__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(495);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__src_deviation__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(497);
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__src_extent__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(1434);
 __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__src_histogram__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(1437);
 __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(1438);
 __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(501);
 __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(1439);
 __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__src_max__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(1440);
 __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__src_mean__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(1441);
 __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_13__src_median__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(1442);
 __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(502);
 __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_15__src_min__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(494);
 __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_16__src_pairs__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(1443);
 __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_17__src_permute__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(275);
 __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(499);
 __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(1444);
 __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_20__src_scan__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(1445);
 __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_21__src_shuffle__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(1446);
 __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_22__src_sum__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(500);
 __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
 __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
 __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
 var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(503);
 __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_24__src_transpose__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(496);
 __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_25__src_variance__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(1447);
 __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_26__src_zip__["a"]; });





























 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return colors; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return random; });

 __webpack_require__.d(__webpack_exports__, "e", function() { return hexToRgb; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return hexToRgbString; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return getDarkerColor; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return getLighterColor; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return rgbToHex; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return invertColor; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return hsl; });

 __webpack_require__.d(__webpack_exports__, "b", function() { return getContrastColor; });
 var __WEBPACK_IMPORTED_MODULE_0_chroma_js__ = __webpack_require__(683);
 var __WEBPACK_IMPORTED_MODULE_0_chroma_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chroma_js__);
 var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var colors=[{color:'#f44336',name:'red',contrastColor:'#0d083c'},{color:'#E91E63',name:'pink',contrastColor:'#010434'},{color:'#9C27B0',name:'purple',contrastColor:'#dafa69'},{color:'#673AB7',name:'deep purple',contrastColor:'#8ff66d'},{color:'#3F51B5',name:'indigo',contrastColor:'#9eee3f'},{color:'#2196F3',name:'blue',contrastColor:'#041547'},{color:'#03A9F4',name:'light blue',contrastColor:'#2e3824'},{color:'#00BCD4',name:'cyan',contrastColor:'#541b87'},{color:'#009688',name:'teal',contrastColor:'#210547'},{color:'#4CAF50',name:'green',contrastColor:'#270d0b'},{color:'#8BC34A',name:'light green',contrastColor:'#4a19ba'},// { color: '#CDDC39', name: 'lime', contrastColor: '#48266e' },
// { color: '#FBC02D', name: 'yellow', contrastColor: '#382ecc' },
// { color: '#FFC107', name: 'amber', contrastColor: '#5c3771' },
{color:'#FF9800',name:'orange',contrastColor:'#36220c'},{color:'#FF5722',name:'deep orange',contrastColor:'#0c1e40'},{color:'#795548',name:'brown',contrastColor:'#e7f77f'},{color:'#607D8B',name:'blue grey',contrastColor:'#040129'}];var random=function random(){return colors[Math.floor(Math.random()*colors.length)];};var getColorByString=function getColorByString(myString){var numericValues=Array.prototype.map.call(myString,function(e){return e.charCodeAt(0);});var totalValue=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sum(numericValues);return colors[totalValue%colors.length].color;};var hexToRgb=function hexToRgb(hexadecimal){// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
var shorthandRegex=/^#?([a-f\d])([a-f\d])([a-f\d])$/i;var hex=hexadecimal.replace(shorthandRegex,function(m,r,g,b){return r+r+g+g+b+b;});var result=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);return result?{r:parseInt(result[1],16),g:parseInt(result[2],16),b:parseInt(result[3],16)}:null;};var hexToRgbString=function hexToRgbString(hexadecimal){// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
var shorthandRegex=/^#?([a-f\d])([a-f\d])([a-f\d])$/i;var hex=hexadecimal.replace(shorthandRegex,function(m,r,g,b){return r+r+g+g+b+b;});var result=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);return result?parseInt(result[1],16)+', '+parseInt(result[2],16)+', '+parseInt(result[3],16):null;};var getDarkerColor=function getDarkerColor(hexadecimal){var darker=arguments.length>1&&arguments[1]!==undefined?arguments[1]:50;var rgb=hexToRgb(hexadecimal);var r=rgb.r,g=rgb.g,b=rgb.b;r=Math.max(0,r-darker);g=Math.max(0,g-darker);b=Math.max(0,b-darker);return{r:r,g:g,b:b};};var getLighterColor=function getLighterColor(hexadecimal){var lighter=arguments.length>1&&arguments[1]!==undefined?arguments[1]:25;var rgb=hexToRgb(hexadecimal);var r=rgb.r,g=rgb.g,b=rgb.b;r=Math.min(255,r+lighter);g=Math.min(255,g+lighter);b=Math.min(255,b+lighter);return{r:r,g:g,b:b};};var componentToHex=function componentToHex(c){var hex=c.toString(16);return hex.length===1?'0'+hex:hex;};var rgbToHex=function rgbToHex(_ref){var r=_ref.r,g=_ref.g,b=_ref.b;return'#'+componentToHex(r)+componentToHex(g)+componentToHex(b);};var invertColor=function invertColor(color){var maxLoops=5000;var randomColor=__WEBPACK_IMPORTED_MODULE_0_chroma_js___default.a.random();var contrast=__WEBPACK_IMPORTED_MODULE_0_chroma_js___default.a.contrast(randomColor,color);while(maxLoops>0&&contrast<=7){maxLoops-=1;var aux=__WEBPACK_IMPORTED_MODULE_0_chroma_js___default.a.random();var auxContrast=__WEBPACK_IMPORTED_MODULE_0_chroma_js___default.a.contrast(aux,color);if(auxContrast>contrast){contrast=auxContrast;randomColor=aux;}}return randomColor;};var hsl=function hsl(color){return __WEBPACK_IMPORTED_MODULE_0_chroma_js___default()(color).hsl();};var getBrightness=function getBrightness(r,g,b){return(r*299+g*587+b*114)/1000;};var getContrastColor=function getContrastColor(color){var hex=hexToRgb(color);var textColor='rgba(0, 0, 0, 0.54)';var brightness=getBrightness(hex.r,hex.b,hex.g);if(brightness<180){textColor='rgb(255, 255, 255)';}return textColor;};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return fetchInstance; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return setSplashScreen; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return viewUserProfile; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return setIsAuthenticated; });

 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_3_components_LanguageSelector_modules_actions__ = __webpack_require__(687);
 var __WEBPACK_IMPORTED_MODULE_4_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_5_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(688);
var _ACTION_HANDLERS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INITIAL_STATE={actual_date:0,date_diff:0,code:false,color1:'',color2:'',color3:'',color4:'',color5:'',color6:'',color7:'',colors:__WEBPACK_IMPORTED_MODULE_2_utils_colors__["a" ],lang:'',logo:'',name:'',elements_showing:'',main_element:'',phantom_user:'',state:'',use_policy:'',isAuthenticated:false,id:0,poweredBy:'',selectedUser:0,splashScreen:true,zoomMeeting:null,openChat:null};var fetchInstance=function fetchInstance(domain){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_store_globalState_global__["c" ])(true));var params={domain:domain};Object(__WEBPACK_IMPORTED_MODULE_5_utils_apiFetch__["b" ])('GET',{endPoint:'instance'},params).then(function(response){var instance=Object.assign({},response);var actualTime=__WEBPACK_IMPORTED_MODULE_1_moment___default()().unix();instance.date_diff=actualTime-instance.actual_date;dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["b" ],instance:instance});if(typeof instance.advanced_configuration!=='undefined'&&typeof instance.advanced_configuration.additional_language_files!=='undefined'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_components_LanguageSelector_modules_actions__["a" ])(instance.advanced_configuration.additional_language_files));}dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_store_globalState_global__["c" ])(false));});};};var setSplashScreen=function setSplashScreen(show){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["g" ],splashScreen:show});};};var viewUserProfile=function viewUserProfile(selectedUser){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["e" ],selectedUser:selectedUser});};};var setIsAuthenticated=function setIsAuthenticated(isAuthenticated){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["f" ],isAuthenticated:isAuthenticated});};};var openChatModal=function openChatModal(chatId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["a" ],openChat:chatId});};};var handleAppNodeNotifications=function handleAppNodeNotifications(state,notification){switch(notification.req_message){case'join_zoom_meeting':return Object.assign({},state,{zoomMeeting:notification});default:break;}return state;};var ACTION_HANDLERS=(_ACTION_HANDLERS={},_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["a" ],function(state,_ref){var openChat=_ref.openChat;return Object.assign({},state,{openChat:openChat});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["e" ],function(state,_ref2){var selectedUser=_ref2.selectedUser;return Object.assign({},state,{selectedUser:selectedUser});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["b" ],function(state,_ref3){var instance=_ref3.instance;return Object.assign({},state,instance);}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["f" ],function(state,_ref4){var isAuthenticated=_ref4.isAuthenticated;return Object.assign({},state,{isAuthenticated:isAuthenticated});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["g" ],function(state,_ref5){var splashScreen=_ref5.splashScreen;return Object.assign({},state,{splashScreen:splashScreen});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["c" ],function(state,action){return handleAppNodeNotifications(state,action.payload);}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["d" ],function(state,action){return handleAppNodeNotifications(state,action.payload);}),_ACTION_HANDLERS); __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = useForkRef;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__setRef__ = __webpack_require__(165);


function useForkRef(refA, refB) {
  
  return __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" ])(refA, refValue);
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" ])(refB, refValue);
    };
  }, [refA, refB]);
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";






var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(345);
var isBuffer = __webpack_require__(663);



// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;


function isArray(val) {
  return toString.call(val) === '[object Array]';
}


function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}


function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}


function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}


function isString(val) {
  return typeof val === 'string';
}


function isNumber(val) {
  return typeof val === 'number';
}


function isUndefined(val) {
  return typeof val === 'undefined';
}


function isObject(val) {
  return val !== null && typeof val === 'object';
}


function isDate(val) {
  return toString.call(val) === '[object Date]';
}


function isFile(val) {
  return toString.call(val) === '[object File]';
}


function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}


function isFunction(val) {
  return toString.call(val) === '[object Function]';
}


function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}


function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}


function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}


function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}


function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}


function merge() {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}


function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return setCanDrag; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return setGoDown; });

 __webpack_require__.d(__webpack_exports__, "b", function() { return setAutoNavigation; });
 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(684);
var _ACTION_HANDLERS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INITIAL_STATE={canDrag:true,goDown:false,canNavigate:true,autoNavigation:true// Indicates if server choose the next step
};var setCanDrag=function setCanDrag(canDrag){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["b" ],canDrag:canDrag});};};var setGoDown=function setGoDown(goDown){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["d" ],goDown:goDown});};};var setCanNavigate=function setCanNavigate(canNavigate){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["c" ],canNavigate:canNavigate});};};var setAutoNavigation=function setAutoNavigation(autoNavigation){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["a" ],autoNavigation:autoNavigation});};};var ACTION_HANDLERS=(_ACTION_HANDLERS={},_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1__types__["b" ],function(state,_ref){var canDrag=_ref.canDrag;return Object.assign({},state,{canDrag:canDrag});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1__types__["d" ],function(state,_ref2){var goDown=_ref2.goDown;return Object.assign({},state,{goDown:goDown});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1__types__["c" ],function(state,_ref3){var canNavigate=_ref3.canNavigate;return Object.assign({},state,{canNavigate:canNavigate});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1__types__["a" ],function(state,_ref4){var autoNavigation=_ref4.autoNavigation;return Object.assign({},state,{autoNavigation:autoNavigation});}),_ACTION_HANDLERS); __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(886);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components__["a" ]);

 }),

 (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createReducer;
function createReducer(INITIAL_STATE,ACTION_HANDLERS){return function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];if(ACTION_HANDLERS[action.type]){return ACTION_HANDLERS[action.type](state,action);}return state;};}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_1__createGenerateClassName__ = __webpack_require__(160);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__createGenerateClassName__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_2__createStyles__ = __webpack_require__(375);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__createStyles__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_3__getThemeProps__ = __webpack_require__(219);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__getThemeProps__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_4__jssPreset__ = __webpack_require__(220);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__jssPreset__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_5__makeStyles__ = __webpack_require__(161);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__makeStyles__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_6__mergeClasses__ = __webpack_require__(222);
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__mergeClasses__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_7__ServerStyleSheets__ = __webpack_require__(382);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__ServerStyleSheets__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_8__styled__ = __webpack_require__(384);
 __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__styled__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_9__StylesProvider__ = __webpack_require__(162);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__StylesProvider__["b"]; });

 var __WEBPACK_IMPORTED_MODULE_10__ThemeProvider__ = __webpack_require__(385);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__ThemeProvider__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_11__useTheme__ = __webpack_require__(109);
 __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__useTheme__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_12__withStyles__ = __webpack_require__(386);
 __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__withStyles__["a"]; });

 var __WEBPACK_IMPORTED_MODULE_13__withTheme__ = __webpack_require__(387);

 __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_13__withTheme__["a"]; });





if (false) {
  ponyfillGlobal['__@material-ui/styles-init__'] = ponyfillGlobal['__@material-ui/styles-init__'] || 0;

  if (ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
  }

  ponyfillGlobal['__@material-ui/styles-init__'] += 1;
}




























 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return getOnGoingActivity; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return enableItemFromSerendipity; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return disableItemFromSerendipity; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return getSerendipityPreferences; });

 __webpack_require__.d(__webpack_exports__, "d", function() { return getSerendipityAction; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return setSerendipityActionInContext; });
 var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
 var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_3_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_4_constants_serendipity__ = __webpack_require__(362);
 var __WEBPACK_IMPORTED_MODULE_5_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(363);
var getOnGoingActivity=function getOnGoingActivity(){return function(dispatch,getState){var _getState=getState(),_getState$serendipity=_getState.serendipity,serendipityPreferences=_getState$serendipity.preferences,serendipityHistory=_getState$serendipity.history,narratives=_getState.narratives.list,speedDatingMeetings=_getState.speedDating.meetings;// Los puntos cuantos menos tenga mas preferencia tiene
var serendipityItems=[];// Narratives
var hasSomeNarrativeCompleted=false;__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(narratives,function(narrative){if(narrative.type.id===21227761){var points=0;var isDisabled=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(serendipityPreferences,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["h" ]&&item.element_id===narrative.id&&!item.enabled;});var enabled=narrative.progress<100&&!isDisabled;points+=narrative.section.section_position*100;points+=narrative.position;if(narrative.progress>0){points-=5000;}if(narrative.progress>=100){points+=10000;hasSomeNarrativeCompleted=true;}if(isDisabled){points+=50000;}var serendipityInfo={type:__WEBPACK_IMPORTED_MODULE_5_constants_types__["h" ],order:points,enabled:enabled};var serendipityItem=Object.assign({},narrative,{serendipityInfo:serendipityInfo});serendipityItems.push(serendipityItem);}});// Si tiene ya alguna narrativa completada
// O tiene ya algo en el histórico que no sea el feedback users
// Y las dos últimas cosas que le ha recomendado no es el feedback users
var historyLength=serendipityHistory.length;var noRecentFeedbackHistory=true;if(historyLength>0&&serendipityHistory[historyLength-1].serendipityInfo.type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["e" ]){noRecentFeedbackHistory=false;}if(historyLength>1&&serendipityHistory[historyLength-2].serendipityInfo.type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["e" ]){noRecentFeedbackHistory=false;}if((hasSomeNarrativeCompleted||historyLength)&&noRecentFeedbackHistory){var serendipityItemFeedbackUsers={serendipityInfo:{type:__WEBPACK_IMPORTED_MODULE_5_constants_types__["e" ],order:-50000,enabled:true}};serendipityItems.push(serendipityItemFeedbackUsers);}// Si las dos últimas cosas que le ha recomendado no es el feedback tables
var noRecentFeedbackHistoryTables=true;if(historyLength>0&&serendipityHistory[historyLength-1].serendipityInfo.type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["d" ]){noRecentFeedbackHistoryTables=false;}if(historyLength>1&&serendipityHistory[historyLength-2].serendipityInfo.type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["d" ]){noRecentFeedbackHistoryTables=false;}if(noRecentFeedbackHistoryTables){var _serendipityItemFeedbackUsers={serendipityInfo:{type:__WEBPACK_IMPORTED_MODULE_5_constants_types__["d" ],order:-60000,enabled:true}};serendipityItems.push(_serendipityItemFeedbackUsers);}// Speed dating calls
__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(speedDatingMeetings,function(element){var enabled=!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(serendipityPreferences,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["j" ]&&item.element_id===element.id&&!item.enabled;});var order=-70000;if(__WEBPACK_IMPORTED_MODULE_1_moment___default()().unix()<=element.start_date+60||__WEBPACK_IMPORTED_MODULE_1_moment___default()().unix()>element.end_date){enabled=false;}if(enabled){var serendipityInfo={type:__WEBPACK_IMPORTED_MODULE_5_constants_types__["j" ],order:order,enabled:enabled};var serendipityItem=Object.assign({},element,{serendipityInfo:serendipityInfo});serendipityItems.push(serendipityItem);}});return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(serendipityItems,['serendipityInfo.order']);};};var enableItemFromSerendipity=function enableItemFromSerendipity(elementType,elementId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["e" ],payload:{elementType:elementType,elementId:elementId}});var params={element_type:elementType,element_id:elementId};return Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'serendipity/items/enable'},params).then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["f" ]});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["d" ],payload:{elementType:elementType,elementId:elementId}});});};};var disableItemFromSerendipity=function disableItemFromSerendipity(elementType,elementId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["b" ],payload:{elementType:elementType,elementId:elementId}});var params={element_type:elementType,element_id:elementId};return Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'serendipity/items/disable'},params).then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["c" ]});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["a" ],payload:{elementType:elementType,elementId:elementId}});});};};var getSerendipityPreferences=function getSerendipityPreferences(){return function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('GET',{endPoint:'serendipity/items'}).then(function(payload){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["g" ],payload:payload});});};};var pushElementInHistory=function pushElementInHistory(element){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["h" ],payload:element});};};var getSerendipityAction=function getSerendipityAction(){return function(dispatch,getState){var _getState2=getState(),_getState2$serendipit=_getState2.serendipity,actionInContext=_getState2$serendipit.actionInContext,serendipityHistory=_getState2$serendipit.history;if(actionInContext){return actionInContext;}var items=dispatch(getOnGoingActivity());var item=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(items,function(element){if(!element.serendipityInfo.enabled){return false;}return!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(serendipityHistory,{type:element.serendipityInfo.type,id:element.id});});if(item){dispatch(pushElementInHistory(item));switch(item.serendipityInfo.type){case __WEBPACK_IMPORTED_MODULE_5_constants_types__["h" ]:return function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push('/narratives/'+item.id);};case __WEBPACK_IMPORTED_MODULE_5_constants_types__["e" ]:return function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push('/recommendations/users');};case __WEBPACK_IMPORTED_MODULE_5_constants_types__["d" ]:return function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push('/recommendations/tables');};case __WEBPACK_IMPORTED_MODULE_5_constants_types__["b" ]:return function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push('/elements/'+item.id);};case __WEBPACK_IMPORTED_MODULE_5_constants_types__["l" ]:return function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push('/theme-table/'+item.id);};case __WEBPACK_IMPORTED_MODULE_5_constants_types__["m" ]:return function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push('/theme-table/'+item.id);};case __WEBPACK_IMPORTED_MODULE_5_constants_types__["n" ]:return function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push('/theme-table/'+item.id);};case __WEBPACK_IMPORTED_MODULE_5_constants_types__["j" ]:return function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push('/zoom-meeting/'+item.zoom_data.id);};default:return null;}}return null;};};var setSerendipityActionInContext=function setSerendipityActionInContext(action){var priority=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_4_constants_serendipity__["a" ].MEDIUM;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["i" ],payload:{action:action,priority:priority}});};};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = __extends;
 __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
























var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
 __webpack_exports__["a"] = Selection;
 var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(1457);
 var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(1458);
 var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(1459);
 var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(1460);
 var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(507);
 var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(1462);
 var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(1463);
 var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(1464);
 var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(1465);
 var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(1466);
 var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(1467);
 var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(1468);
 var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(1469);
 var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(1470);
 var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(1471);
 var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(1472);
 var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(509);
 var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(1473);
 var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(1474);
 var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(1475);
 var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(1476);
 var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(1477);
 var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(1478);
 var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(1479);
 var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(1480);
 var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(1481);
 var __WEBPACK_IMPORTED_MODULE_26__clone__ = __webpack_require__(1482);
 var __WEBPACK_IMPORTED_MODULE_27__datum__ = __webpack_require__(1483);
 var __WEBPACK_IMPORTED_MODULE_28__on__ = __webpack_require__(281);
 var __WEBPACK_IMPORTED_MODULE_29__dispatch__ = __webpack_require__(1484);































var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection(, root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" ],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" ],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" ],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" ],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["b" ],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" ],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" ],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" ],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" ],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" ],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" ],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" ],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" ],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" ],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" ],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" ],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" ],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" ],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" ],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" ],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" ],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" ],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" ],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" ],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" ],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" ],
  clone: __WEBPACK_IMPORTED_MODULE_26__clone__["a" ],
  datum: __WEBPACK_IMPORTED_MODULE_27__datum__["a" ],
  on: __WEBPACK_IMPORTED_MODULE_28__on__["b" ],
  dispatch: __WEBPACK_IMPORTED_MODULE_29__dispatch__["a" ]
};

 __webpack_exports__["b"] = (selection);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(283);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(516);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_array__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(286);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_basis__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(514);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(517);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__src_date__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(187);
 __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(518);
 __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__src_object__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(1494);
 __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(519);
 __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(1495);
 __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
 __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(1498);
 __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(513);
 __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["b"]; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["c"]; });
 var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(1499);
 __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["a"]; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(1500);
 __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_13__src_lab__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(1501);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["a"]; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(1502);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["b"]; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(1503);
 __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_16__src_quantize__["a"]; });



















 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "c", function() { return SCHEDULED; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return STARTING; });


 __webpack_require__.d(__webpack_exports__, "b", function() { return ENDING; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ENDED; });
 __webpack_exports__["g"] = init;
 __webpack_exports__["h"] = set;
 __webpack_exports__["f"] = get;
 var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(100);
 var __WEBPACK_IMPORTED_MODULE_1_d3_timer__ = __webpack_require__(188);



var emptyOn = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" ])("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

 __webpack_exports__["e"] = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTING) throw new Error("too late; already started");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["d" ])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" ])(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" ])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(63);
 var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(391);
 var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(224);




function getPath(obj, path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  return path.split('.').reduce(function (acc, item) {
    return acc && acc[item] ? acc[item] : null;
  }, obj);
}

function style(options) {
  var prop = options.prop,
      _options$cssProperty = options.cssProperty,
      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
      themeKey = options.themeKey,
      transform = options.transform;

  var fn = function fn(props) {
    if (props[prop] == null) {
      return null;
    }

    var propValue = props[prop];
    var theme = props.theme;
    var themeMapping = getPath(theme, themeKey) || {};

    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
      var value;

      if (typeof themeMapping === 'function') {
        value = themeMapping(propValueFinal);
      } else if (Array.isArray(themeMapping)) {
        value = themeMapping[propValueFinal] || propValueFinal;
      } else {
        value = getPath(themeMapping, propValueFinal) || propValueFinal;

        if (transform) {
          value = transform(value);
        }
      }

      if (cssProperty === false) {
        return value;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" ])({}, cssProperty, value);
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" ])(props, propValue, styleFromPropValue);
  };

  fn.propTypes =  false ? _defineProperty({}, prop, responsivePropType) : {};
  fn.filterProps = [prop];
  return fn;
}

 __webpack_exports__["a"] = (style);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(284);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["e"]; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(1492);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(1493);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = projection;
 __webpack_exports__["b"] = projectionMutator;
 var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__ = __webpack_require__(532);
 var __WEBPACK_IMPORTED_MODULE_1__clip_circle__ = __webpack_require__(538);
 var __WEBPACK_IMPORTED_MODULE_2__clip_rectangle__ = __webpack_require__(192);
 var __WEBPACK_IMPORTED_MODULE_3__compose__ = __webpack_require__(531);
 var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(297);
 var __WEBPACK_IMPORTED_MODULE_5__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_6__rotation__ = __webpack_require__(191);
 var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(193);
 var __WEBPACK_IMPORTED_MODULE_8__fit__ = __webpack_require__(300);
 var __WEBPACK_IMPORTED_MODULE_9__resample__ = __webpack_require__(1597);











var transformRadians = Object(__WEBPACK_IMPORTED_MODULE_7__transform__["b" ])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math__["r" ], y * __WEBPACK_IMPORTED_MODULE_5__math__["r" ]);
  }
});

function transformRotate(rotate) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__transform__["b" ])({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" ], // clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity__["a" ], // clip extent
      delta2 = 0.5, projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" ])(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["r" ], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["r" ]);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["h" ], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["h" ]];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? Object(__WEBPACK_IMPORTED_MODULE_1__clip_circle__["a" ])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math__["r" ]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" ]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math__["h" ];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity__["a" ]) : Object(__WEBPACK_IMPORTED_MODULE_2__clip_rectangle__["a" ])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : ;
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" ], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" ], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" ], phi * __WEBPACK_IMPORTED_MODULE_5__math__["h" ]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" ], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" ], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" ] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" ], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math__["h" ], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math__["h" ]];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" ])(projectTransform, delta2 = _ * _), reset()) : Object(__WEBPACK_IMPORTED_MODULE_5__math__["u" ])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["a" ])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["c" ])(projection, size, object);
  };

  projection.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["d" ])(projection, width, object);
  };

  projection.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["b" ])(projection, height, object);
  };

  function recenter() {
    projectRotate = Object(__WEBPACK_IMPORTED_MODULE_3__compose__["a" ])(rotate = Object(__WEBPACK_IMPORTED_MODULE_6__rotation__["b" ])(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__merge__ = __webpack_require__(163);



function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var fn = function fn(props) {
    return styles.reduce(function (acc, style) {
      var output = style(props);

      if (output) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__merge__["a" ])(acc, output);
      }

      return acc;
    }, {});
  }; // Alternative approach that doesn't yield any performance gain.
  // const handlers = styles.reduce((acc, style) => {
  //   style.filterProps.forEach(prop => {
  //     acc[prop] = style;
  //   });
  //   return acc;
  // }, {});
  // const fn = props => {
  //   return Object.keys(props).reduce((acc, prop) => {
  //     if (handlers[prop]) {
  //       return merge(acc, handlers[prop](props));
  //     }
  //     return acc;
  //   }, {});
  // };


  fn.propTypes =  false ? styles.reduce(function (acc, style) {
    return _extends(acc, style.propTypes);
  }, {}) : {};
  fn.filterProps = styles.reduce(function (acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  return fn;
}

 __webpack_exports__["a"] = (compose);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(887);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  STYLES: ['large', 'small', 'floating', 'flat'],
  WAVES: ['light', 'red', 'yellow', 'orange', 'purple', 'green', 'teal'],
  SIZES: ['s', 'm', 'l', 'xl'],
  PLACEMENTS: ['left', 'center', 'right'],
  SCALES: ['big', 'small'],
  ICON_SIZES: ['tiny', 'small', 'medium', 'large']
};
exports.default = _default;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return removeAccents; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return getTitleSize; });


 __webpack_require__.d(__webpack_exports__, "a", function() { return capitalize; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return parseTags; });
 var __WEBPACK_IMPORTED_MODULE_0_autolinker__ = __webpack_require__(955);
var removeAccents=function removeAccents(s){var r={À:'A',Á:'A',Â:'A',Ã:'A',Ä:'A',Å:'A',Æ:'E',È:'E',É:'E',Ê:'E',Ë:'E',Ì:'I',Í:'I',Î:'I',Ò:'O',Ó:'O',Ô:'O',Ö:'O',Ù:'U',Ú:'U',Û:'U',Ü:'U',Ñ:'N'};return s.replace(/[ÀÁÂÃÄÅÆÈÉÊËÌÍÎÒÓÔÖÙÚÛÜÑ]/gi,function(m){var ret=r[m.toUpperCase()];if(m===m.toLowerCase()){ret=ret.toLowerCase();}return ret;});};var getTitleSize=function getTitleSize(text){var fontSize=32;var lenStr=text.length;if(lenStr>80){fontSize=22;}else if(lenStr>40){fontSize=28;}return fontSize;};var fromHtmlEntities=function fromHtmlEntities(string){return string.replace(/&#\d+;/gm,function(s){return String.fromCharCode(s.match(/\d+/gm)[0]);});};var toHtmlEntities=function toHtmlEntities(string){return string.replace(/./gm,function(s){return s.match(/[a-z0-9\s]+/i)?s:'&#'+s.charCodeAt(0)+';';});};var capitalize=function capitalize(string){return string.charAt(0).toUpperCase()+string.slice(1);};var parseTags=function parseTags(msg){var message=__WEBPACK_IMPORTED_MODULE_0_autolinker__["a" ].link(msg,{stripPrefix:false,className:'link',sanitizeHtml:true});var arrayMessage=message.split('');var count=arrayMessage.filter(function(c){return c==='*';}).length;if(count<2){return message;}if(count%2===1){count-=1;}while(count>0){var index=arrayMessage.indexOf('*');if(count%2===0){arrayMessage.splice(index,1,'<strong>');}else{arrayMessage.splice(index,1,'</strong>');}count-=1;}var newMessage=arrayMessage.join('');return newMessage;};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
 var __WEBPACK_IMPORTED_MODULE_0__TextField__ = __webpack_require__(963);
 __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TextField__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(1189);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


 }),

 (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(578);


var freeSelf = typeof self == 'object' && self && self.Object === Object && self;


var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


 }),

 (function(module, exports) {


var isArray = Array.isArray;

module.exports = isArray;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _inheritsLoose;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_setPrototypeOf__ = __webpack_require__(605);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_setPrototypeOf__["a" ])(subClass, superClass);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ({session:{user:{},authenticated:false,checked:true},global:{loading:0,lastLoading:null,stepsWatched:[],selected:null},login:{error:''},signup:{error:'',success:''},modalInformation:{open:false,text:'',singlePressPosition:false,longPressPosition:false,pressAndDragPosition:false,swipeUp:false,swipeDown:false,swipeLeft:false,swipeRight:false,singlePress:false,longPress:false,pressAndDrag:false,onOpen:false,onClose:false},socket:{rooms:{},rooms_back:{},rooms_request:{},is_connected_to_node:false,interval_reconnect_node:null},chats:{chats:null,newMessage:null,isLoadingOlder:false,mustReloadChats:true,mustReloadInvitations:true,selectLeaderStatus:null}});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });

 __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(643);
 var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(644);
 var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(152);
 var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(645);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" ])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" ])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}


function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}


function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}


function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}


function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}



function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" ])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" ])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}



function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["g"] = getMyThinkTanks;
 __webpack_exports__["i"] = getThinkTank;
 __webpack_exports__["b"] = changeThinkTankImage;
 __webpack_exports__["j"] = getThinkTankTools;
 __webpack_exports__["p"] = requestJoin;
 __webpack_exports__["a"] = acceptJoin;
 __webpack_exports__["o"] = rejectJoin;

 __webpack_exports__["f"] = getAllRequestsJoin;
 __webpack_exports__["m"] = leaveThinkTank;
 __webpack_require__.d(__webpack_exports__, "d", function() { return getAdditionalThinks; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return launchThinkTank; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return proposeContent; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return getProposedContent; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return getAllProposedContent; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return deleteProposedContent; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return launchTable; });
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_1_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_2_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(355);
function getMyThinkTanks(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["k" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'think-tanks/me'},{}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["l" ],payload:{data:data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["j" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));});};}function getThinkTank(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["s" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'think-tanks/'+id},{}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["t" ],payload:{data:data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["r" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));});};}function changeThinkTankImage(id,image){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["c" ],payload:{data:image}});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'think-tanks/'+id+'/image'},{image:image}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["d" ],payload:{data:data}});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["b" ]});});};}function getThinkTankTools(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["v" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'think-tanks/'+id+'/tools'},{}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["w" ],payload:{data:data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["u" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));});};}function requestJoin(id){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["J" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'think-tanks/'+id+'/request_join'}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["K" ],payload:{data:data}});}).catch(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["I" ],payload:{data:data.response.data}});});};}function acceptJoin(id,requestId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["D" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'think-tanks/'+id+'/requests_join/'+requestId+'/accept'}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["E" ],payload:{response:data,id:requestId}});}).catch(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["C" ],payload:{data:data.response.data}});});};}function rejectJoin(id,requestId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["G" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'think-tanks/'+id+'/requests_join/'+requestId+'/reject'}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["H" ],payload:{response:data,id:requestId}});}).catch(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["F" ],payload:{data:data.response.data}});});};}function getRequestsJoin(id){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["p" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'think-tanks/'+id+'/requests_join'}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["q" ],payload:{data:data.data}});}).catch(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["o" ],payload:{data:data.response.data}});});};}function getAllRequestsJoin(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["p" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'think-tanks/requests_join'}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["q" ],payload:{data:data.data}});}).catch(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["o" ],payload:{data:data.response.data}});});};}function leaveThinkTank(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["y" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'think-tanks/'+id+'/leave'}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["z" ],payload:{response:data,id:id}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));__WEBPACK_IMPORTED_MODULE_2_store_history__["a" ].push('/think');}).catch(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["x" ],payload:{data:data.response.data}});});};}var getAdditionalThinks=function getAdditionalThinks(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["f" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'theme-table/thinks'}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["g" ],payload:{data:data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["e" ]});});};};var launchThinkTank=function launchThinkTank(_ref){var id=_ref.id,name=_ref.name,description=_ref.description,members=_ref.members,socialNetworkMovement=_ref.socialNetworkMovement,blog=_ref.blog,project=_ref.project,openInnovation=_ref.openInnovation;return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'think-seed/'+id+'/launch'},{name:name,description:description,members:members,social_network_movement:socialNetworkMovement,blog:blog,project:project,open_innovation:openInnovation}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["a" ],payload:{data:data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));});};};var proposeContent=function proposeContent(params){return function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'theme-table/'+params.related_id+'/content'},params);};};var getProposedContent=function getProposedContent(id){var params={id:id};return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'theme-table/'+id+'/content'},params).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["n" ],payload:{data:data}});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["m" ]});});};};var getAllProposedContent=function getAllProposedContent(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'content'}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["i" ],payload:{data:data}});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["h" ]});});};};var deleteProposedContent=function deleteProposedContent(id,userId){var params={id:id,user_id:userId};return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('delete',{endPoint:'theme-table/content/'+id},params);};var launchTable=function launchTable(id,userId){var params={id:id,user_id:userId};return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'theme-table/'+id+'/launch'},params);};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(858);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = Transition;
 __webpack_exports__["b"] = transition;
 __webpack_exports__["c"] = newId;
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_1__attr__ = __webpack_require__(1509);
 var __WEBPACK_IMPORTED_MODULE_2__attrTween__ = __webpack_require__(1510);
 var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__(1511);
 var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__(1512);
 var __WEBPACK_IMPORTED_MODULE_5__ease__ = __webpack_require__(1513);
 var __WEBPACK_IMPORTED_MODULE_6__filter__ = __webpack_require__(1514);
 var __WEBPACK_IMPORTED_MODULE_7__merge__ = __webpack_require__(1515);
 var __WEBPACK_IMPORTED_MODULE_8__on__ = __webpack_require__(1516);
 var __WEBPACK_IMPORTED_MODULE_9__remove__ = __webpack_require__(1517);
 var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__(1518);
 var __WEBPACK_IMPORTED_MODULE_11__selectAll__ = __webpack_require__(1519);
 var __WEBPACK_IMPORTED_MODULE_12__selection__ = __webpack_require__(1520);
 var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__(1521);
 var __WEBPACK_IMPORTED_MODULE_14__styleTween__ = __webpack_require__(1522);
 var __WEBPACK_IMPORTED_MODULE_15__text__ = __webpack_require__(1523);
 var __WEBPACK_IMPORTED_MODULE_16__transition__ = __webpack_require__(1524);
 var __WEBPACK_IMPORTED_MODULE_17__tween__ = __webpack_require__(189);



















var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" ])().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" ].prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: __WEBPACK_IMPORTED_MODULE_10__select__["a" ],
  selectAll: __WEBPACK_IMPORTED_MODULE_11__selectAll__["a" ],
  filter: __WEBPACK_IMPORTED_MODULE_6__filter__["a" ],
  merge: __WEBPACK_IMPORTED_MODULE_7__merge__["a" ],
  selection: __WEBPACK_IMPORTED_MODULE_12__selection__["a" ],
  transition: __WEBPACK_IMPORTED_MODULE_16__transition__["a" ],
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: __WEBPACK_IMPORTED_MODULE_8__on__["a" ],
  attr: __WEBPACK_IMPORTED_MODULE_1__attr__["a" ],
  attrTween: __WEBPACK_IMPORTED_MODULE_2__attrTween__["a" ],
  style: __WEBPACK_IMPORTED_MODULE_13__style__["a" ],
  styleTween: __WEBPACK_IMPORTED_MODULE_14__styleTween__["a" ],
  text: __WEBPACK_IMPORTED_MODULE_15__text__["a" ],
  remove: __WEBPACK_IMPORTED_MODULE_9__remove__["a" ],
  tween: __WEBPACK_IMPORTED_MODULE_17__tween__["a" ],
  delay: __WEBPACK_IMPORTED_MODULE_3__delay__["a" ],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" ],
  ease: __WEBPACK_IMPORTED_MODULE_5__ease__["a" ]
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = noop;
function noop() {}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return init; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return emit; });
 __webpack_exports__["d"] = reconnect_node;

 __webpack_exports__["c"] = joinInNodeRoom;

 __webpack_exports__["e"] = sendNotificationToRoom;
 var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(340);
 var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(155);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var __socket=null;var __node_code=null;var init=function init(store,forceReconnect){if(__socket&&!forceReconnect){__socket.socket.connect({autoconnect:true});return;}if(__socket&&forceReconnect){__socket.emit(__WEBPACK_IMPORTED_MODULE_0__types__["d" ].FORCEDISCONNECT,{});return;}var state=store.getState();var _state$session$user=state.session.user,actual_user_id=_state$session$user.id,node_code=_state$session$user.node_code;var instanceId=state.app.id;var user_code=node_code+node_code;if(!actual_user_id||!user_code){return;}__socket=window.io(__WEBPACK_IMPORTED_MODULE_1__constants__["d" ],{transports:['websocket'],upgrade:false});__node_code=node_code;Object.keys(__WEBPACK_IMPORTED_MODULE_0__types__["d" ]).forEach(function(type){__socket.off(__WEBPACK_IMPORTED_MODULE_0__types__["d" ][type]);__socket.on(__WEBPACK_IMPORTED_MODULE_0__types__["d" ][type],function(){var payload=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var newPayLoad=(typeof payload==='undefined'?'undefined':_typeof(payload))==='object'?payload:{};newPayLoad.user_id=actual_user_id;newPayLoad.user_code=user_code;newPayLoad.instanceId=instanceId;store.dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["d" ][type],payload:newPayLoad});switch(__WEBPACK_IMPORTED_MODULE_0__types__["d" ][type]){case __WEBPACK_IMPORTED_MODULE_0__types__["d" ].WHATS_YOUR_CODE:{var user_code_small=user_code.substr(0,Math.round(user_code.length/4));if(__socket){__socket.emit(__WEBPACK_IMPORTED_MODULE_0__types__["c" ],{code:user_code_small,installation:__WEBPACK_IMPORTED_MODULE_1__constants__["b" ],id:actual_user_id,hidden_user:0,version:3,encripted:true});}break;}case __WEBPACK_IMPORTED_MODULE_0__types__["d" ].DISCONNECT:__socket.removeAllListeners();__socket=null;init(store);break;default:break;}});});};var emit=function emit(type,payload){return __socket.emit(type,payload);};function reconnect_node(count){if(count>=__WEBPACK_IMPORTED_MODULE_1__constants__["c" ])return;if(__socket&&__socket.socket){var newCount=count+1;__socket.socket.connect(newCount);}}function emitNotificationToNode(type,data){if(!__node_code)return;var data_json=JSON.stringify(data);if(__socket){__socket.emit(type,data_json);}}function joinInNodeRoom(type,id){try{if(typeof __socket!=='undefined'){emitNotificationToNode(__WEBPACK_IMPORTED_MODULE_0__types__["a" ],{type:type,id:id});}}catch(ex){console.error(ex);}}function leaveFromNodeRoom(type,id){try{if(typeof __socket!=='undefined'){emitNotificationToNode(__WEBPACK_IMPORTED_MODULE_0__types__["b" ],{type:type,id:id});}}catch(ex){console.error(ex);}}function sendNotificationToRoom(room,message,data){emitNotificationToNode(__WEBPACK_IMPORTED_MODULE_0__types__["d" ].NOTIFICATION_TO_ROOM,Object.assign({room:room,req_message:message},data));}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "e", function() { return fetchMainNarratives; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return fetchObjectives; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return fetchTools; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return fetchElements; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return getNarrativeSpeedDating; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return getNarrativeSpeedDatingMatches; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return connectInNarrativeSpeedDating; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return getUserNarrativeSpeedDatingActualCalls; });

 __webpack_require__.d(__webpack_exports__, "h", function() { return getMyCallsForImpact; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return setNarrativeAsCompleted; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return cleanUsersFromNarrative; });
 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_modules_socket_actions__ = __webpack_require__(81);
 var __WEBPACK_IMPORTED_MODULE_5_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_6_constants_narratives__ = __webpack_require__(690);
 var __WEBPACK_IMPORTED_MODULE_7_constants_rooms__ = __webpack_require__(158);
 var __WEBPACK_IMPORTED_MODULE_8_constants_notifications__ = __webpack_require__(108);
 var __WEBPACK_IMPORTED_MODULE_9__types__ = __webpack_require__(691);
var _ACTION_HANDLERS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INITIAL_STATE={list:null,objectives:null,tools:null,elements:{},speedDating:null,speedDatingStatus:null,speedDatingError:null,speedDatingMatches:null,speedDatingMatchesStatus:null,speedDatingMatchesError:null,speedDatingCalls:null,speedDatingCallsStatus:null,speedDatingCallsError:null,resetComplete:null,myCallsForImpact:[],myCallsForImpactStatus:null,newUsersInNarratives:{}};var fetchMainNarratives=function fetchMainNarratives(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('GET',{endPoint:'narratives'}).then(function(narratives){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["f" ],narratives:narratives});narratives.forEach(function(narrative){if(narrative.type.id===__WEBPACK_IMPORTED_MODULE_6_constants_narratives__["a" ]){Object(__WEBPACK_IMPORTED_MODULE_4_modules_socket_actions__["c" ])(__WEBPACK_IMPORTED_MODULE_7_constants_rooms__["a" ],narrative.id);}});}).catch(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));});};};var fetchObjectives=function fetchObjectives(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('GET',{endPoint:'objectives'}).then(function(objectives){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["g" ],objectives:objectives});}).catch(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));});};};var fetchTools=function fetchTools(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('GET',{endPoint:'main_tools'}).then(function(tools){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["n" ],tools:tools});}).catch(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));});};};var fetchElements=function fetchElements(elementType){var size=arguments.length>1&&arguments[1]!==undefined?arguments[1]:20;return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('GET',{endPoint:'elements'},{type:elementType,size:size}).then(function(elements){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["e" ],elements:elements,elementType:elementType});}).catch(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));});};};var getNarrativeSpeedDating=function getNarrativeSpeedDating(narrativeId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["i" ]});Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('GET',{endPoint:'narratives/'+narrativeId+'/speed-dating'}).then(function(speedDating){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["m" ],speedDating:speedDating});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["h" ],error:error});});};};var getNarrativeSpeedDatingMatches=function getNarrativeSpeedDatingMatches(narrativeId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["k" ]});Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('GET',{endPoint:'narratives/'+narrativeId+'/speed-dating/matches'}).then(function(speedDatingMatches){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["l" ],speedDatingMatches:speedDatingMatches});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["j" ],error:error});});};};var connectInNarrativeSpeedDating=function connectInNarrativeSpeedDating(narrativeId,userId){return Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'narratives/'+narrativeId+'/speed-dating/connect'},{user_id:userId});};var getUserNarrativeSpeedDatingActualCalls=function getUserNarrativeSpeedDatingActualCalls(narrativeId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["c" ]});Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('GET',{endPoint:'narratives/'+narrativeId+'/speed-dating/calls'}).then(function(speedDatingCalls){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["d" ],speedDatingCalls:speedDatingCalls});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["b" ],error:error});});};};var resetNarrative=function resetNarrative(narrativeId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["u" ]});Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'narrative/'+narrativeId+'/reset'},{}).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["v" ],payload:{response:response}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["t" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));});};};var getMyCallsForImpact=function getMyCallsForImpact(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["p" ]});Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('GET',{endPoint:'callsforimpact/mine'}).then(function(myCallsForImpact){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["q" ],myCallsForImpact:myCallsForImpact});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["o" ],error:error});});};};var setNarrativeAsCompleted=function setNarrativeAsCompleted(narrativeId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["w" ],narrativeId:narrativeId});};};var cleanUsersFromNarrative=function cleanUsersFromNarrative(narrativeId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_9__types__["a" ],narrativeId:narrativeId});};};var handleNodeNotifications=function handleNodeNotifications(state,notification){switch(notification.req_message){case __WEBPACK_IMPORTED_MODULE_8_constants_notifications__["i" ]:{var user=JSON.parse(notification.user);var narrativeId=parseInt(notification.narrative_id,10);var newUsersInNarratives=Object.assign({},state.newUsersInNarratives);if(typeof newUsersInNarratives[narrativeId]==='undefined'){newUsersInNarratives[narrativeId]=[];}if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(newUsersInNarratives[narrativeId],{id:user.id})){newUsersInNarratives[narrativeId].push(user);}return Object.assign({},state,{newUsersInNarratives:newUsersInNarratives});}default:return state;}};var ACTION_HANDLERS=(_ACTION_HANDLERS={},_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["r" ],function(state,_ref){var payload=_ref.payload;return handleNodeNotifications(state,payload);}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["s" ],function(state,_ref2){var payload=_ref2.payload;return handleNodeNotifications(state,payload);}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["p" ],function(state){return Object.assign({},state,{myCallsForImpactStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["b" ]});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["q" ],function(state,_ref3){var myCallsForImpact=_ref3.myCallsForImpact;return Object.assign({},state,{myCallsForImpact:myCallsForImpact,myCallsForImpactStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["g" ]});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["o" ],function(state){return Object.assign({},state,{myCallsForImpactStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["a" ]});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["f" ],function(state,_ref4){var narratives=_ref4.narratives;return Object.assign({},state,{list:narratives});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["g" ],function(state,_ref5){var objectives=_ref5.objectives;return Object.assign({},state,{objectives:objectives});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["n" ],function(state,_ref6){var tools=_ref6.tools;return Object.assign({},state,{tools:tools});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["e" ],function(state,_ref7){var elements=_ref7.elements,elementType=_ref7.elementType;var stateElements=Object.assign({},state.elements);stateElements[elementType]=elements;return Object.assign({},state,{elements:stateElements});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["i" ],function(state){return Object.assign({},state,{speedDating:null,speedDatingStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["b" ],speedDatingError:null});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["m" ],function(state,_ref8){var speedDating=_ref8.speedDating;return Object.assign({},state,{speedDating:speedDating,speedDatingStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["g" ],speedDatingError:null});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["h" ],function(state,_ref9){var error=_ref9.error;return Object.assign({},state,{speedDating:null,speedDatingStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["a" ],speedDatingError:error});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["k" ],function(state){return Object.assign({},state,{speedDatingMatches:null,speedDatingMatchesStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["b" ],speedDatingMatchesError:null});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["l" ],function(state,_ref10){var speedDatingMatches=_ref10.speedDatingMatches;return Object.assign({},state,{speedDatingMatches:speedDatingMatches,speedDatingMatchesStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["g" ],speedDatingMatchesError:null});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["j" ],function(state,_ref11){var error=_ref11.error;return Object.assign({},state,{speedDatingMatches:null,speedDatingMatchesStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["a" ],speedDatingMatchesError:error});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["c" ],function(state){return Object.assign({},state,{speedDatingCalls:null,speedDatingCallsStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["b" ],speedDatingCallsError:null});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["d" ],function(state,_ref12){var speedDatingCalls=_ref12.speedDatingCalls;return Object.assign({},state,{speedDatingCalls:speedDatingCalls,speedDatingCallsStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["g" ]});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["b" ],function(state,_ref13){var error=_ref13.error;return Object.assign({},state,{speedDatingCallsStatus:__WEBPACK_IMPORTED_MODULE_5_constants_status__["a" ],speedDatingCallsError:error});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["u" ],function(state){return Object.assign({},state,{resetComplete:null});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["v" ],function(state){return Object.assign({},state,{resetComplete:true});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["t" ],function(state){return Object.assign({},state,{resetComplete:false});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["w" ],function(state,_ref14){var narrativeId=_ref14.narrativeId;var newList=[].concat(_toConsumableArray(state.list));var index=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(newList,{id:narrativeId});if(index>=0){newList[index].progress=100;}return Object.assign({},state,{list:newList});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_9__types__["a" ],function(state,_ref15){var narrativeId=_ref15.narrativeId;var newUsersInNarratives=Object.assign({},state.newUsersInNarratives);if(typeof newUsersInNarratives[narrativeId]!=='undefined'){delete newUsersInNarratives[narrativeId];}return Object.assign({},state,{newUsersInNarratives:Object.assign({},newUsersInNarratives)});}),_ACTION_HANDLERS); __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return RuleList; });

 __webpack_require__.d(__webpack_exports__, "b", function() { return SheetsRegistry; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return create; });

 __webpack_require__.d(__webpack_exports__, "d", function() { return createRule; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return getDynamicStyles; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return hasCSSTOMSupport; });

 __webpack_require__.d(__webpack_exports__, "g", function() { return toCssValue; });
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1_is_in_browser__ = __webpack_require__(376);
 var __WEBPACK_IMPORTED_MODULE_2_tiny_warning__ = __webpack_require__(152);
 var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(221);
 var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(73);
 var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(210);
 var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(62);








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}



function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};


var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via ``.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};


function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}



function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += '\n';
            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += '\n';
          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += '\n';
      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "\n" + result + "\n";
  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =

function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.key = void 0;
    this.isProcessed = false;
    this.style = void 0;
    this.renderer = void 0;
    this.renderable = void 0;
    this.options = void 0;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =

function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" ])(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    _this.selectorText = void 0;
    _this.id = void 0;
    _this.renderable = void 0;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" ])(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  


  var _proto2 = StyleRule.prototype;

  
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" ])(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(name, style, options) {
    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(name, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;


var ConditionalRule =

function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.at = void 0;
    this.key = void 0;
    this.query = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {\n" + children + "\n}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;


var KeyframesRule =

function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.key = void 0;
    this.name = void 0;
    this.id = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "\n" + children + "\n";
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};



var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var plugin = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =

function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" ])(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
    _this.renderable = void 0;
    return _this;
  }

  var _proto = KeyframeRule.prototype;

  
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =

function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += '\n';
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =

function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =

function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.key = void 0;
    this.value = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  

};

var RuleList =

function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  
  ;

  _proto.get = function get(name) {
    return this.map[name];
  }
  
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.map[name], data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var styleRule = rule;
    var style = styleRule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== styleRule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.

      for (var prop in styleRule.style) {
        var nextValue = styleRule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          styleRule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = styleRule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          styleRule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += '\n';
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =

function () {
  function StyleSheet(styles, options) {
    this.options = void 0;
    this.deployed = void 0;
    this.attached = void 0;
    this.rules = void 0;
    this.renderer = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.queue = void 0;
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  
  ;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =

function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = void 0;
  }

  var _proto = PluginsRegistry.prototype;

  
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      // $FlowFixMe[prop-missing]
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();


var SheetsRegistry =

function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" ])(_ref, ["attached"]);

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += '\n';
      css += sheet.toString(options);
    }

    return css;
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" ])(SheetsRegistry, [{
    key: "index",

    
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();



var registry = new SheetsRegistry();


// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis[ns] == null) globalThis[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis[ns]++;

var maxRules = 1e10;


var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;
  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
};


var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};



var getHead = memoize(function () {
  return document.querySelector('head');
});


function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}



function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}



function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}


function findPrevNode(options) {
  var registry$1 = registry.registry;

  if (registry$1.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}



function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}



var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      var c = container;
      c.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        var _c = container;

        _c.appendRule(rule);
      }
  } catch (err) {
     false ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =

function () {
  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.element = void 0;
    this.sheet = void 0;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) registry.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules[index] = cssRule;
    }
  }
  
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =

function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.5.1";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: __WEBPACK_IMPORTED_MODULE_1_is_in_browser__["a" ] ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = registry.index === 0 ? 0 : registry.index + 1;
    }

    var sheet = new StyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    registry.remove(sheet);
    return this;
  }
  
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      // $FlowFixMe[incompatible-call]
      return this.createRule(undefined, name, style);
    } // $FlowFixMe[incompatible-type]


    var ruleOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();


function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}


var SheetsManager =

function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" ])(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" ])(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" ])(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}();




var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;


var create = function create(options) {
  return new Jss(options);
};


var jss = create();

 var _unused_webpack_default_export = (jss);



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = useTheme;
 var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(53);
 var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
 var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(128);



function useTheme() {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["k" ])() || __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" ];

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return getUserData; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return getUserInvitationData; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return connectToUser; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return sendFeedbackSuggestionConnect; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return getRecommendedUsers; });
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
var getUserData=function getUserData(userId){var endPoint='users/'+userId;return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:endPoint});};var getUserInvitationData=function getUserInvitationData(hash){var endPoint='users/invitations/'+hash;return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:endPoint});};var connectToUser=function connectToUser(userId){var params={action:'connect',userId:userId};var endPoint='users/connection';return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:endPoint},params);};var sendFeedbackSuggestionConnect=function sendFeedbackSuggestionConnect(userId,accept,fromType,fromId){var params={element_type:'user',element_id:userId,from_type:fromType,fromId:fromId,accept:accept};var endPoint='feedback';return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:endPoint},params);};var getRecommendedUsers=function getRecommendedUsers(){var includeInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var search=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'recommendations/users'},{include_info:includeInfo,search:search});};

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _constants = _interopRequireDefault(__webpack_require__(66));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Icon = function Icon(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = {
    'material-icons': true
  };
  var rest = Object.assign(props, {});

  _constants.default.PLACEMENTS.forEach(function (p) {
    classes[p] = props[p];
    delete rest[p];
  });

  _constants.default.ICON_SIZES.forEach(function (s) {
    classes[s] = props[s];
    delete rest[s];
  });

  return _react.default.createElement("i", _extends({
    className: (0, _classnames.default)(classes, className)
  }, rest), children);
};

Icon.propTypes = {
  
  className: _propTypes.default.string,

  
  children: _propTypes.default.string.isRequired,

  
  left: _propTypes.default.bool,
  center: _propTypes.default.bool,
  right: _propTypes.default.bool,

  
  tiny: _propTypes.default.bool,
  small: _propTypes.default.bool,
  medium: _propTypes.default.bool,
  large: _propTypes.default.bool
};
var _default = Icon;
exports.default = _default;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return Match; });

var Match =  (function () {
    
    function Match(cfg) {
        
        this.__jsduckDummyDocProp = null; // property used just to get the above doc comment into the ES5 output and documentation generator
        
        this.matchedText = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.offset = 0; // default value just to get the above doc comment in the ES5 output and documentation generator
        this.tagBuilder = cfg.tagBuilder;
        this.matchedText = cfg.matchedText;
        this.offset = cfg.offset;
    }
    
    Match.prototype.getMatchedText = function () {
        return this.matchedText;
    };
    
    Match.prototype.setOffset = function (offset) {
        this.offset = offset;
    };
    
    Match.prototype.getOffset = function () {
        return this.offset;
    };
    
    Match.prototype.getCssClassSuffixes = function () {
        return [this.getType()];
    };
    
    Match.prototype.buildTag = function () {
        return this.tagBuilder.build(this);
    };
    return Match;
}());


//# sourceMappingURL=match.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return Matcher; });

var Matcher =  (function () {
    
    function Matcher(cfg) {
        
        this.__jsduckDummyDocProp = null; // property used just to get the above doc comment into the ES5 output and documentation generator
        this.tagBuilder = cfg.tagBuilder;
    }
    return Matcher;
}());


//# sourceMappingURL=matcher.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "h", function() { return letterRe; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return digitRe; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return nonDigitRe; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return whitespaceRe; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return quoteRe; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return controlCharsRe; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return alphaCharsStr; });




 __webpack_require__.d(__webpack_exports__, "c", function() { return alphaNumericCharsStr; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return alphaNumericAndMarksCharsStr; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return getDomainNameStr; });

 __webpack_require__.d(__webpack_exports__, "f", function() { return domainNameCharRegex; });


var letterRe = /[A-Za-z]/;

var digitRe = /[\d]/;

var nonDigitRe = /[\D]/;

var whitespaceRe = /\s/;

var quoteRe = /['"]/;

var controlCharsRe = /[\x00-\x1F\x7F]/;

var alphaCharsStr = /A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC/
    .source; // see note in above variable description

var emojiStr = /\u2700-\u27bf\udde6-\uddff\ud800-\udbff\udc00-\udfff\ufe0e\ufe0f\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0\ud83c\udffb-\udfff\u200d\u3299\u3297\u303d\u3030\u24c2\ud83c\udd70-\udd71\udd7e-\udd7f\udd8e\udd91-\udd9a\udde6-\uddff\ude01-\ude02\ude1a\ude2f\ude32-\ude3a\ude50-\ude51\u203c\u2049\u25aa-\u25ab\u25b6\u25c0\u25fb-\u25fe\u00a9\u00ae\u2122\u2139\udc04\u2600-\u26FF\u2b05\u2b06\u2b07\u2b1b\u2b1c\u2b50\u2b55\u231a\u231b\u2328\u23cf\u23e9-\u23f3\u23f8-\u23fa\udccf\u2935\u2934\u2190-\u21ff/
    .source;

var marksStr = /\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F/
    .source; // see note in above variable description

var alphaCharsAndMarksStr = alphaCharsStr + emojiStr + marksStr;

var decimalNumbersStr = /0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19/
    .source; // see note in above variable description

var alphaNumericCharsStr = alphaCharsAndMarksStr + decimalNumbersStr;

var alphaNumericAndMarksCharsStr = alphaCharsAndMarksStr + decimalNumbersStr;
// Simplified IP regular expression
var ipStr = '(?:[' + decimalNumbersStr + ']{1,3}\\.){3}[' + decimalNumbersStr + ']{1,3}';
// Protected domain label which do not allow "-" character on the beginning and the end of a single label
var domainLabelStr = '[' + alphaNumericAndMarksCharsStr + '](?:[' + alphaNumericAndMarksCharsStr + '\\-]{0,61}[' + alphaNumericAndMarksCharsStr + '])?';
var getDomainLabelStr = function (group) {
    return '(?=(' + domainLabelStr + '))\\' + group;
};

var getDomainNameStr = function (group) {
    return '(?:' + getDomainLabelStr(group) + '(?:\\.' + getDomainLabelStr(group + 1) + '){0,126}|' + ipStr + ')';
};

var domainNameRegex = new RegExp('[' + alphaNumericAndMarksCharsStr + '.\\-]*[' + alphaNumericAndMarksCharsStr + '\\-]');

var domainNameCharRegex = new RegExp("[" + alphaNumericAndMarksCharsStr + "]");

//# sourceMappingURL=regex-lib.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = useFormControl;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__FormControlContext__ = __webpack_require__(248);


function useFormControl() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__FormControlContext__["a" ]);
}

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no_think_chats.35af5f5d.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return deleteAccount; });
 __webpack_exports__["b"] = fetchProfileInit;
 __webpack_exports__["c"] = fetchProfileSuccess;



 __webpack_require__.d(__webpack_exports__, "f", function() { return updateProfile; });
 __webpack_exports__["e"] = getUserData;



 __webpack_exports__["d"] = getUserAnswers;



 var __WEBPACK_IMPORTED_MODULE_0_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_0_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_2__store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(366);
// import apiFetch from 'utils/apiFetch';
var deleteAccount=function deleteAccount(password){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["b" ]});var params={password:password};Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('delete',{endPoint:'users'},params).then(function(response){if(response.success){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["c" ]});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["a" ],payload:response.info});}dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["a" ],payload:'Error connecting server'});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_globalState_global__["c" ])(false));});};};function fetchProfileInit(){return{type:__WEBPACK_IMPORTED_MODULE_3__types__["e" ]};}function fetchProfileSuccess(success){return{type:__WEBPACK_IMPORTED_MODULE_3__types__["f" ],payload:success};}function fetchProfileFailure(error){return{type:__WEBPACK_IMPORTED_MODULE_3__types__["d" ],payload:error};}function getDataAction(callback){return function(){__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].loadUser().then(function(data){callback(data);});};}function fetchProfileAction(event,_ref,callback){var firstName=_ref.firstName,lastName=_ref.lastName,email=_ref.email,lang=_ref.lang,image=_ref.image;event.preventDefault();// const ProfileForm = {
//   code: '',
//   name: firstName,
//   lastName,
//   lang,
//   status: 'active',
//   emailList: [email],
// };
return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_globalState_global__["c" ])(true));dispatch(fetchProfileInit());return new Promise(function(resolve){__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveSession({token:'123456789'}).then(function(){__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveUser({email:email,firstName:firstName,lastName:lastName,lang:lang,image:image}).then(function(){dispatch(fetchProfileSuccess('Success'));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_globalState_global__["c" ])(false));callback();resolve(true);});});});};}var updateProfile=function updateProfile(params,hideLoading){return function(dispatch,getState){if(!hideLoading){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_globalState_global__["c" ])(true));}return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('PUT',{endPoint:'users'},params).then(function(response){__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveSession({token:response.user_code}).then(function(){var user=Object.assign({},response);user.instance=getState().app.id;__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveUser(user).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_globalState_global__["c" ])(false));});});}).catch(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_globalState_global__["c" ])(false));});};};function getUserData(user){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'user'},{user:user});}function getConnections(user){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'users/connection'},{user:user});}function getUserActions(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var user=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'users/actions'},{type:type,user:user});}function getPrivacyElements(user){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'users/privacy/elements'},{user:user});}function getUserAnswers(userId){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'users/'+userId+'/answers'});}function getProfileFields(){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'instances/profile-fields'});}function getUserSettings(){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'users/settings'});}function saveUserSettings(params){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'users/settings'},params);}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(1036);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });


 }),

 (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1179);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1201);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Switch__ = __webpack_require__(1233);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Switch__["a"]; });


 }),

 (function(module, exports, __webpack_require__) {



var debug = __webpack_require__(1320)('jsonp');



module.exports = jsonp;



var count = 0;



function noop(){}



function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createShareCount;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
 var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var defaultChildren = function (shareCount) { return shareCount; };
var SocialMediaShareCount =  (function (_super) {
    __extends(SocialMediaShareCount, _super);
    function SocialMediaShareCount(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.state = { count: 0, isLoading: false };
        return _this;
    }
    SocialMediaShareCount.prototype.componentDidMount = function () {
        this._isMounted = true;
        this.updateCount(this.props.url);
    };
    SocialMediaShareCount.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.url !== prevProps.url) {
            this.updateCount(this.props.url);
        }
    };
    SocialMediaShareCount.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    SocialMediaShareCount.prototype.updateCount = function (url) {
        var _this = this;
        this.setState({
            isLoading: true,
        });
        this.props.getCount(url, function (count) {
            if (_this._isMounted) {
                _this.setState({
                    count: count,
                    isLoading: false,
                });
            }
        });
    };
    SocialMediaShareCount.prototype.render = function () {
        var _a = this.state, count = _a.count, isLoading = _a.isLoading;
        var _b = this.props, _c = _b.children, children = _c === void 0 ? defaultChildren : _c, className = _b.className, _ = _b.getCount, rest = __rest(_b, ["children", "className", "getCount"]);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", __assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('react-share__ShareCount', className) }, rest), !isLoading && count !== undefined && children(count)));
    };
    return SocialMediaShareCount;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function createShareCount(getCount) {
    var ShareCount = function (props) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialMediaShareCount, __assign({ getCount: getCount }, props))); };
    ShareCount.displayName = "ShareCount(" + getCount.name + ")";
    return ShareCount;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_dispatch__ = __webpack_require__(1454);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dispatch__["a"]; });



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(1544);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

 __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


 }),

 (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1742),
    getValue = __webpack_require__(1747);


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";













 var __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__ = __webpack_require__(630);
 var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(631);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialize = __WEBPACK_IMPORTED_MODULE_1__core__["initialize"];
var ga = __WEBPACK_IMPORTED_MODULE_1__core__["ga"];
var set = __WEBPACK_IMPORTED_MODULE_1__core__["set"];
var send = __WEBPACK_IMPORTED_MODULE_1__core__["send"];
var pageview = __WEBPACK_IMPORTED_MODULE_1__core__["pageview"];
var modalview = __WEBPACK_IMPORTED_MODULE_1__core__["modalview"];
var timing = __WEBPACK_IMPORTED_MODULE_1__core__["timing"];
var event = __WEBPACK_IMPORTED_MODULE_1__core__["event"];
var exception = __WEBPACK_IMPORTED_MODULE_1__core__["exception"];
var plugin = __WEBPACK_IMPORTED_MODULE_1__core__["plugin"];
var outboundLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var testModeAPI = __WEBPACK_IMPORTED_MODULE_1__core__["testModeAPI"];
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" ].origTrackLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" ].trackLink;
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" ].trackLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var OutboundLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" ];
 __webpack_exports__["a"] = (_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__core__, {
  OutboundLink: OutboundLink
}));

 }),

 (function(module, exports, __webpack_require__) {

"use strict";






var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return NEW_MESSAGE; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return THINK_CHAT_UPDATED; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return NEW_THINK_CHAT_INVITATION; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return NEW_THINK_TANK_REQUEST; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return NEW_THINK_TANK; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return NEW_SPEED_DATING_MEETING; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return NEW_USER_CONNECTION; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return HAS_PENDING_REQUESTS; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return NEW_USER_IN_IMPACT_EVENT; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return NEW_TABLE_JOINED; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return NOTIFICATION_MODAL; });
var NEW_MESSAGE='new_message';var THINK_CHAT_UPDATED='think_chat_updated';var NEW_THINK_CHAT_INVITATION='new_invitation_think_chat';var NEW_THINK_TANK_REQUEST='new_think_tank_request';var NEW_THINK_TANK='new_think_tank';var NEW_SPEED_DATING_MEETING='new_speed_dating_meeting';var NEW_USER_CONNECTION='new_user_connection';var HAS_PENDING_REQUESTS='has_pending_requests';var NEW_USER_IN_IMPACT_EVENT='new_user_in_impact_event';var NEW_TABLE_JOINED='new_table_joined';var NOTIFICATION_MODAL='notification_modal';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__useTheme__ = __webpack_require__(762);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useTheme__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return PHASE_THINK_CHAT; });

 __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_DEAD; });

 __webpack_require__.d(__webpack_exports__, "c", function() { return TYPE_INDIVIDUAL; });
var PHASE_THINK_CHAT=21283154;var PHASE_THINK_TANK=21283155;var STATUS_DEAD=21227337;var TYPE_NORMAL=21283817;var TYPE_INDIVIDUAL=21283818;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(952);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(964);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__InputBase__ = __webpack_require__(965);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputBase__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = formControlState;
function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(1014);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1082);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1187);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

 __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  return Math.random();
});


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(608);


var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


 }),

 (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


 }),

 (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "e", function() { return getUserConnect; });

 __webpack_require__.d(__webpack_exports__, "f", function() { return getUserRequestedConnections; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return addRequestedConnection; });

 __webpack_require__.d(__webpack_exports__, "c", function() { return getHasPendingRequests; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return getHasPendingRequestsWithTimer; });
 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__ = __webpack_require__(215);
 var __WEBPACK_IMPORTED_MODULE_2_constants_notifications__ = __webpack_require__(108);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var _ACTION_HANDLERS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var filterConnections=function filterConnections(array,userChats,allConnections){var newArray=[];array.map(function(connection){if(typeof newArray.find(function(c){return c.id===connection.id;})==='undefined'){newArray.push(connection);}return connection;});if(allConnections){return newArray;}var newArray2=[];newArray.forEach(function(connection){var found=false;var i=0;while(!found&&i<userChats.length){if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(userChats[i].element_related)){if(userChats[i].users.some(function(elem){return elem.id===connection.id;})||newArray2.some(function(elem2){return elem2.id===connection.id;})){found=true;}}i+=1;}if(!found){newArray2.push(connection);}});return newArray2;};var getUserConnect=function getUserConnect(allConnections){return function(dispatch,getState){var _getState=getState(),id=_getState.session.user.id,userChats=_getState.chats.chats;Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('GET',{endPoint:'users/connection'},{user:id}).then(function(res){var connections=filterConnections(res,userChats,allConnections);dispatch({type:__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["f" ],connections:connections});});};};var getUserRecommendations=function getUserRecommendations(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('GET',{endPoint:'users/recommendations'}).then(function(recommendations){dispatch({type:__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["i" ],recommendations:recommendations});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));}).catch(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));});};};var getUserRequestedConnections=function getUserRequestedConnections(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('GET',{endPoint:'users/connection/requested'}).then(function(requested){dispatch({type:__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["g" ],requested:requested});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));}).catch(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));});};};var addRequestedConnection=function addRequestedConnection(user){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["a" ],user:user});};};var removeConnection=function removeConnection(id){return function(dispatch,getState){var _getState2=getState(),connections=_getState2.userConnections.connections;var filteredConnections=connections.filter(function(elem){return elem.id!==id;});dispatch({type:__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["f" ],connections:filteredConnections});};};var getHasPendingRequests=function getHasPendingRequests(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('GET',{endPoint:'users/has_pending_requests'}).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["h" ],hasPendingRequests:response.has_pending_requests});});};};var timerPendingRequests=null;var getHasPendingRequestsWithTimer=function getHasPendingRequestsWithTimer(){return function(dispatch){if(timerPendingRequests!==null){clearTimeout(timerPendingRequests);}timerPendingRequests=setTimeout(function(){timerPendingRequests=null;dispatch(getHasPendingRequests());},10000);};};var INITIAL_STATE={connections:[],requested:[],recommendations:[],hasPendingRequests:false};var handleModalNotifications=function handleModalNotifications(state,notification){switch(notification.req_message){case __WEBPACK_IMPORTED_MODULE_2_constants_notifications__["h" ]:{var user=JSON.parse(notification.user);user.match_actions='connect';user.match_actual_user_actions='connect';var newConnections=[].concat(_toConsumableArray(state.connections));newConnections.push(user);return Object.assign({},state,{connections:newConnections});}case __WEBPACK_IMPORTED_MODULE_2_constants_notifications__["a" ]:{var hasPendingRequests=parseInt(notification.has_pending_requests,10)>0;return Object.assign({},state,{hasPendingRequests:hasPendingRequests});}default:return state;}};var ACTION_HANDLERS=(_ACTION_HANDLERS={},_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["c" ],function(state,action){return handleModalNotifications(state,action.payload);}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["d" ],function(state,action){return handleModalNotifications(state,action.payload);}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["f" ],function(state,action){return Object.assign({},state,{connections:action.connections});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["h" ],function(state,action){return Object.assign({},state,{hasPendingRequests:action.hasPendingRequests});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["i" ],function(state,action){return Object.assign({},state,{recommendations:action.recommendations});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["g" ],function(state,action){return Object.assign({},state,{requested:action.requested});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_1_store_globalState_action_types__["a" ],function(state,action){return Object.assign({},state,{requested:[].concat(_toConsumableArray(state.requested),[action.user])});}),_ACTION_HANDLERS); __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _toConsumableArray;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayWithoutHoles__ = __webpack_require__(755);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_iterableToArray__ = __webpack_require__(756);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_unsupportedIterableToArray__ = __webpack_require__(378);
 var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_nonIterableSpread__ = __webpack_require__(757);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayWithoutHoles__["a" ])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_iterableToArray__["a" ])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_unsupportedIterableToArray__["a" ])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_nonIterableSpread__["a" ])();
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__createMuiTheme__ = __webpack_require__(223);

var defaultTheme = Object(__WEBPACK_IMPORTED_MODULE_0__createMuiTheme__["a" ])();
 __webpack_exports__["a"] = (defaultTheme);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["g"] = hexToRgb;
 __webpack_exports__["k"] = rgbToHex;
 __webpack_exports__["h"] = hslToRgb;
 __webpack_exports__["b"] = decomposeColor;
 __webpack_exports__["j"] = recomposeColor;
 __webpack_exports__["e"] = getContrastRatio;
 __webpack_exports__["f"] = getLuminance;
 __webpack_exports__["c"] = emphasize;
 __webpack_exports__["d"] = fade;
 __webpack_exports__["a"] = darken;
 __webpack_exports__["i"] = lighten;
 var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(13);





function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}



function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}



function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}


function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}


function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" ])(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}


function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}


function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}


function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}


function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}


function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}


function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}


function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _slicedToArray;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayWithHoles__ = __webpack_require__(788);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_iterableToArrayLimit__ = __webpack_require__(789);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_unsupportedIterableToArray__ = __webpack_require__(378);
 var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_nonIterableRest__ = __webpack_require__(790);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayWithHoles__["a" ])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_iterableToArrayLimit__["a" ])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_unsupportedIterableToArray__["a" ])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_nonIterableRest__["a" ])();
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return easing; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return duration; });
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}



 __webpack_exports__["a"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(options, ["duration", "easing", "delay"]);

    if (false) {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return getElementsCreatedByUser; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return postElementByUser; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return getElementById; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return getElementsSelected; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return getUserInterests; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return connectWithElement; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return removeConnectionWithElement; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return getElementTypesShownInUserCard; });
 var __WEBPACK_IMPORTED_MODULE_0_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(360);
var getElementsCreatedByUser=function getElementsCreatedByUser(elementTypes){return function(dispatch){var params={element_types:elementTypes};dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["c" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'users/elements_created'},params).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["d" ],payload:{elements:response.data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["b" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));});};};var postElementByUser=function postElementByUser(params){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["n" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'users/elements_created'},params).then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["o" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["b" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));});};};var getElementById=function getElementById(elementId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["i" ]});var params={id:elementId};dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'users/element_created'},params).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["j" ],payload:{element:response.data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["h" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));});};};var getElementsSelected=function getElementsSelected(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["f" ]});var params={};dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'elements/selected'},params).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["g" ],payload:{element:response.data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["e" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));});};};var getUserInterests=function getUserInterests(id){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["l" ]});var params={id:id};dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'user/'+id+'/interest'},params).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["m" ],payload:response});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["k" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));});};};var connectWithElement=function connectWithElement(narrativeType,element){return function(dispatch){var params={narrativeType:narrativeType,type:element.type,name:element.name};dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["a" ],payload:element});return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'elements/connection'},params);};};var removeConnectionWithElement=function removeConnectionWithElement(narrativeType,element){return function(dispatch){var params={narrativeType:narrativeType,type:element.type,name:element.name};dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["p" ],payload:element});return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('DELETE',{endPoint:'elements/connection'},params);};};var getElementTypesShownInUserCard=function getElementTypesShownInUserCard(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'element_types'},{show_in_user_card:1}).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["q" ],payload:response.data});});};};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = defaults;
 __webpack_exports__["b"] = ellipsis;
 __webpack_exports__["c"] = indexOf;
 __webpack_exports__["d"] = remove;
 __webpack_exports__["e"] = splitAndCapture;
 __webpack_exports__["f"] = throwUnhandledCaseError;

function defaults(dest, src) {
    for (var prop in src) {
        if (src.hasOwnProperty(prop) && dest[prop] === undefined) {
            dest[prop] = src[prop];
        }
    }
    return dest;
}

function ellipsis(str, truncateLen, ellipsisChars) {
    var ellipsisLength;
    if (str.length > truncateLen) {
        if (ellipsisChars == null) {
            ellipsisChars = '&hellip;';
            ellipsisLength = 3;
        }
        else {
            ellipsisLength = ellipsisChars.length;
        }
        str = str.substring(0, truncateLen - ellipsisLength) + ellipsisChars;
    }
    return str;
}

function indexOf(arr, element) {
    // @ts-ignore - As far as TypeScript is concerned, this method will always
    // exist (lowest "lib" in TS is "ES5"). Hence we need to ignore this error
    // to support IE8 which only implements ES3 and doesn't have this method
    if (Array.prototype.indexOf) {
        return arr.indexOf(element);
    }
    else {
        for (var i = 0, len = arr.length; i < len; i++) {
            if (arr[i] === element)
                return i;
        }
        return -1;
    }
}

function remove(arr, fn) {
    for (var i = arr.length - 1; i >= 0; i--) {
        if (fn(arr[i]) === true) {
            arr.splice(i, 1);
        }
    }
}

function splitAndCapture(str, splitRegex) {
    if (!splitRegex.global)
        throw new Error("`splitRegex` must have the 'g' flag set");
    var result = [], lastIdx = 0, match;
    while (match = splitRegex.exec(str)) {
        result.push(str.substring(lastIdx, match.index));
        result.push(match[0]); // push the splitting char(s)
        lastIdx = match.index + match[0].length;
    }
    result.push(str.substring(lastIdx));
    return result;
}

function throwUnhandledCaseError(theValue) {
    throw new Error("Unhandled case for value: '" + theValue + "'");
}

//# sourceMappingURL=utils.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_think_paperbin_svg__ = __webpack_require__(261);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_think_paperbin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_think_paperbin_svg__);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1145);
function UserSmallCard(props){var user=props.user,literals=props.literals,recognized=props.recognized,actualUser=props.actualUser,onDelete=props.onDelete,buttonVoteUp=props.buttonVoteUp,tags=props.tags,onClick=props.onClick,showDeleteButton=props.showDeleteButton,isDragging=props.isDragging;var click=function click(){if(onClick&&!isDragging){onClick(user.id);}};var handleDelete=function handleDelete(event){if(onDelete){onDelete(user.id);}event.stopPropagation();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],{key:user.id,className:'user_wrapper',onClick:click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Avatar__["a" ],{key:user.id,id:user.id,avatar:user.avatar,firstname:user.firstname,size:52,isChampion:!!user.is_recognized}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},user.firstname+' '+user.lastname),user.contributions?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contributions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.contributions),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tags,function(cont){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:cont,className:'contribution tag gray'},cont);})):null,buttonVoteUp)),(recognized||showDeleteButton)&&user.id!==actualUser.id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_assets_images_think_paperbin_svg___default.a,alt:'',className:'paperbin','data-user':user.id,onClick:handleDelete})));} __webpack_exports__["a"] = (UserSmallCard);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ArrowBack.2c20c7a9.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1249);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["c"] = hue;
 __webpack_exports__["b"] = gamma;
 __webpack_exports__["a"] = nogamma;
 var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(515);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(isNaN(a) ? b : a);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(1545);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_nest__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(1546);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_set__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(289);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(1547);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__src_keys__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(1548);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__src_values__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(1549);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_entries__["a"]; });








 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["g"] = spherical;
 __webpack_exports__["a"] = cartesian;
 __webpack_exports__["d"] = cartesianDot;
 __webpack_exports__["c"] = cartesianCross;
 __webpack_exports__["b"] = cartesianAddInPlace;
 __webpack_exports__["f"] = cartesianScale;
 __webpack_exports__["e"] = cartesianNormalizeInPlace;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);


function spherical(cartesian) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" ])(cartesian[1], cartesian[0]), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" ])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(phi);
  return [cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = azimuthalRaw;
 __webpack_exports__["a"] = azimuthalInvert;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(x),
        cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(y),
        k = scale(cx * cy);
    return [
      k * cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(x),
      k * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(x * x + y * y),
        c = angle(z),
        sc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(c),
        cc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(c);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" ])(x * sc, z * cc),
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" ])(z && y * sc / z)
    ];
  }
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = linearish;
 __webpack_exports__["a"] = linear;
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);
 var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(196);
 var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(1657);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["B" ])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" ])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["z" ])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["z" ])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["z" ])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" ])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" ], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["m" ]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" ])(scale, linear());
  };

  return linearish(scale);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
 __webpack_exports__["b"] = acos;
 __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return epsilon2; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return beaches; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return cells; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return circles; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return edges; });
 __webpack_exports__["d"] = Diagram;
 var __WEBPACK_IMPORTED_MODULE_0__Beach__ = __webpack_require__(1716);
 var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(571);
 var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(572);
 var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(314);
 var __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__ = __webpack_require__(313);






var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" ];
  circles = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" ];

  while (true) {
    circle = __WEBPACK_IMPORTED_MODULE_2__Circle__["c" ];
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["a" ])(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["b" ])(circle.arc);
    } else {
      break;
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["d" ])();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["a" ])(x0, y0, x1, y1);
    Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["b" ])(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["a" ])(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}


 }),

 (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(204),
    getRawTag = __webpack_require__(1743),
    objectToString = __webpack_require__(1744);


var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';


var symToStringTag = Symbol ? Symbol.toStringTag : undefined;


function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


 }),

 (function(module, exports) {


function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(642);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(648);


 var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(338);

 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(339);







 var __WEBPACK_IMPORTED_MODULE_4__middleware__ = __webpack_require__(649);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__middleware__["a"]; });









 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

 __webpack_exports__["a"] = (warning);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(107);
 var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
 var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(47);
 var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


 __webpack_exports__["a"] = (Router);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(334);
 var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};


var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

 __webpack_exports__["a"] = (matchPath);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return NODE_URL; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return INSTALLATION_CODE; });

 __webpack_require__.d(__webpack_exports__, "f", function() { return USER_BASE_ROOM; });



 __webpack_require__.d(__webpack_exports__, "a", function() { return GLOBAL_ROOM; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_ATTEMPTS_TO_RECONNECT; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return SEPARATOR_NAME_ROOM; });
var NODE_URL="https://node2.globalincubator.net";var INSTALLATION_CODE='calltoinnovation';var MESSAGE_USER_CODE='___user___';var USER_BASE_ROOM=''+INSTALLATION_CODE+MESSAGE_USER_CODE;var NEW_CHAT_MESSAGE='new_chat_message';var TEST_STATUS_MESSAGE='test_status';var NEW_ROOM_MESSAGE='new_room';var GLOBAL_ROOM='rise';var MAX_ATTEMPTS_TO_RECONNECT=20;var SEPARATOR_NAME_ROOM='___';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return API_BASE_URL; });

 __webpack_require__.d(__webpack_exports__, "b", function() { return VALUES_SEPARATOR; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return getHeaders; });
 var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(344);
 var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
 var __WEBPACK_IMPORTED_MODULE_1_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_1_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var API_BASE_URL="https://app.callforimpact.com/api/Rise";var HEADERS={Accept:'application/json','Content-Type':'application/json',Token:'0d74b9f24c5a1cddfc1a7f1542796565',Secret:'1da5f16fd946d8eb86b0471542796565','session-gi-active':'1','API-apptype':'web',crossDomain:true};var VALUES_SEPARATOR='%-_-%';var getHeaders=function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var headers,user;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:headers={Accept:'application/json','Content-Type':'application/json',Token:'0d74b9f24c5a1cddfc1a7f1542796565',Secret:'1da5f16fd946d8eb86b0471542796565','session-gi-active':'1',crossDomain:true,'API-apptype':'web'};_context.prev=1;_context.next=4;return __WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].loadUser();case 4:user=_context.sent;if(user&&user.id){headers['SESSION-GI']=user.id+'.'+user.user_code;}_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);console.error(_context.t0);case 11:return _context.abrupt('return',headers);case 12:case'end':return _context.stop();}}},_callee,this,[[1,8]]);}));return function getHeaders(){return _ref.apply(this,arguments);};}();

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return doSignup; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return doSignupSocial; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return uploadImage; });
 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_1_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(689);
var _ACTION_HANDLERS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INITIAL_STATE={avatar:'',error:false,success:false};var doSignup=function doSignup(_ref){var name=_ref.name,surname=_ref.surname,email=_ref.email,password=_ref.password,lang=_ref.lang,avatar=_ref.avatar,linkedin=_ref.linkedin,invitation=_ref.invitation;return function(dispatch,getState){var data={name:name,surname:surname,email:email,password:password,instanceCode:getState().app.code,avatar:avatar,lang:lang,linkedin:linkedin,invitation:invitation};return Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'users'},data).then(function(response){__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].saveSession({token:response.user_code}).then(function(){var user=Object.assign({},response);user.instance=getState().app.id;__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].saveUser(user).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_modules_app__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["c" ],success:true});window.sendUserIdentifier(user.id);});});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["b" ],error:error.response.data});throw error;});};};var doSignupSocial=function doSignupSocial(){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));var data={instanceCode:getState().app.code};return Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'users/signup/social'},data).then(function(response){__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].saveSession({token:response.user_code}).then(function(){var user=Object.assign({},response);user.instance=getState().app.id;__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].saveUser(user).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_modules_app__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["c" ],success:true});});});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["b" ],error:error.response.data});});};};var uploadImage=function uploadImage(data,name){return function(dispatch){var params={data:data,name:name};dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'upload-file'},params).then(function(response){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["a" ],avatar:response.url});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["b" ],error:error.response.data});});};};var ACTION_HANDLERS=(_ACTION_HANDLERS={},_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_5__types__["a" ],function(state,_ref2){var avatar=_ref2.avatar;return Object.assign({},state,{avatar:avatar});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_5__types__["b" ],function(state,_ref3){var error=_ref3.error;return Object.assign({},state,{error:error});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_5__types__["c" ],function(state,_ref4){var success=_ref4.success;return Object.assign({},state,{success:success});}),_ACTION_HANDLERS); __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ROOM_CALL_FOR_IMPACT; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ROOM_THEME_TABLE; });
var ROOM_CALL_FOR_IMPACT='call_for_impact';var ROOM_THEME_TABLE='theme_table';

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(739);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__ = __webpack_require__(743);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__makeStyles__ = __webpack_require__(759);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__makeStyles__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__StylesProvider__ = __webpack_require__(380);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["b"]; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["a"]; });



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(13);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["a" ])(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

 __webpack_exports__["a"] = (merge);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = setRef;
// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = useEventCallback;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];


function useEventCallback(fn) {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function () {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__CSSTransition__ = __webpack_require__(826);

 var __WEBPACK_IMPORTED_MODULE_1__ReplaceTransition__ = __webpack_require__(830);

 var __WEBPACK_IMPORTED_MODULE_2__SwitchTransition__ = __webpack_require__(832);

 var __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__ = __webpack_require__(407);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__Transition__ = __webpack_require__(228);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Transition__["d"]; });
 var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(405);








 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);



var ListContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});

if (false) {
  ListContext.displayName = 'ListContext';
}

 __webpack_exports__["a"] = (ListContext);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(843),
    Draggable = _require.default,
    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266


module.exports = Draggable;
module.exports.default = Draggable;
module.exports.DraggableCore = DraggableCore;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findInArray = findInArray;
exports.isFunction = isFunction;
exports.isNum = isNum;
exports.int = int;
exports.dontSetMe = dontSetMe;

// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array

, callback

)

{
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func

)

{
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num

)

{
  return typeof num === 'number' && !isNaN(num);
}

function int(a

)

{
  return parseInt(a, 10);
}

function dontSetMe(props

, propName

, componentName

) {
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/table.0c37f441.jpg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__DialogContent__ = __webpack_require__(889);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogContent__["a"]; });


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Autocomplete", {
  enumerable: true,
  get: function get() {
    return _Autocomplete.default;
  }
});
Object.defineProperty(exports, "Badge", {
  enumerable: true,
  get: function get() {
    return _Badge.default;
  }
});
Object.defineProperty(exports, "Breadcrumb", {
  enumerable: true,
  get: function get() {
    return _Breadcrumb.default;
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});
Object.defineProperty(exports, "Caption", {
  enumerable: true,
  get: function get() {
    return _Caption.default;
  }
});
Object.defineProperty(exports, "Card", {
  enumerable: true,
  get: function get() {
    return _Card.default;
  }
});
Object.defineProperty(exports, "CardPanel", {
  enumerable: true,
  get: function get() {
    return _CardPanel.default;
  }
});
Object.defineProperty(exports, "CardTitle", {
  enumerable: true,
  get: function get() {
    return _CardTitle.default;
  }
});
Object.defineProperty(exports, "Carousel", {
  enumerable: true,
  get: function get() {
    return _Carousel.default;
  }
});
Object.defineProperty(exports, "Checkbox", {
  enumerable: true,
  get: function get() {
    return _Checkbox.default;
  }
});
Object.defineProperty(exports, "Chip", {
  enumerable: true,
  get: function get() {
    return _Chip.default;
  }
});
Object.defineProperty(exports, "Col", {
  enumerable: true,
  get: function get() {
    return _Col.default;
  }
});
Object.defineProperty(exports, "Collapsible", {
  enumerable: true,
  get: function get() {
    return _Collapsible.default;
  }
});
Object.defineProperty(exports, "CollapsibleItem", {
  enumerable: true,
  get: function get() {
    return _CollapsibleItem.default;
  }
});
Object.defineProperty(exports, "Collection", {
  enumerable: true,
  get: function get() {
    return _Collection.default;
  }
});
Object.defineProperty(exports, "CollectionItem", {
  enumerable: true,
  get: function get() {
    return _CollectionItem.default;
  }
});
Object.defineProperty(exports, "Container", {
  enumerable: true,
  get: function get() {
    return _Container.default;
  }
});
Object.defineProperty(exports, "DatePicker", {
  enumerable: true,
  get: function get() {
    return _DatePicker.default;
  }
});
Object.defineProperty(exports, "Divider", {
  enumerable: true,
  get: function get() {
    return _Divider.default;
  }
});
Object.defineProperty(exports, "Dropdown", {
  enumerable: true,
  get: function get() {
    return _Dropdown.default;
  }
});
Object.defineProperty(exports, "Footer", {
  enumerable: true,
  get: function get() {
    return _Footer.default;
  }
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function get() {
    return _Icon.default;
  }
});
Object.defineProperty(exports, "MediaBox", {
  enumerable: true,
  get: function get() {
    return _MediaBox.default;
  }
});
Object.defineProperty(exports, "Modal", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "NavItem", {
  enumerable: true,
  get: function get() {
    return _NavItem.default;
  }
});
Object.defineProperty(exports, "Navbar", {
  enumerable: true,
  get: function get() {
    return _Navbar.default;
  }
});
Object.defineProperty(exports, "Pagination", {
  enumerable: true,
  get: function get() {
    return _Pagination.default;
  }
});
Object.defineProperty(exports, "PaginationButton", {
  enumerable: true,
  get: function get() {
    return _PaginationButton.default;
  }
});
Object.defineProperty(exports, "Parallax", {
  enumerable: true,
  get: function get() {
    return _Parallax.default;
  }
});
Object.defineProperty(exports, "Preloader", {
  enumerable: true,
  get: function get() {
    return _Preloader.default;
  }
});
Object.defineProperty(exports, "ProgressBar", {
  enumerable: true,
  get: function get() {
    return _ProgressBar.default;
  }
});
Object.defineProperty(exports, "RadioGroup", {
  enumerable: true,
  get: function get() {
    return _RadioGroup.default;
  }
});
Object.defineProperty(exports, "Range", {
  enumerable: true,
  get: function get() {
    return _Range.default;
  }
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _Row.default;
  }
});
Object.defineProperty(exports, "SearchForm", {
  enumerable: true,
  get: function get() {
    return _SearchForm.default;
  }
});
Object.defineProperty(exports, "Section", {
  enumerable: true,
  get: function get() {
    return _Section.default;
  }
});
Object.defineProperty(exports, "Select", {
  enumerable: true,
  get: function get() {
    return _Select.default;
  }
});
Object.defineProperty(exports, "SideNav", {
  enumerable: true,
  get: function get() {
    return _SideNav.default;
  }
});
Object.defineProperty(exports, "SideNavItem", {
  enumerable: true,
  get: function get() {
    return _SideNavItem.default;
  }
});
Object.defineProperty(exports, "Slide", {
  enumerable: true,
  get: function get() {
    return _Slide.default;
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _Slider.default;
  }
});
Object.defineProperty(exports, "Spinner", {
  enumerable: true,
  get: function get() {
    return _Spinner.default;
  }
});
Object.defineProperty(exports, "Switch", {
  enumerable: true,
  get: function get() {
    return _Switch.default;
  }
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _Tab.default;
  }
});
Object.defineProperty(exports, "Table", {
  enumerable: true,
  get: function get() {
    return _Table.default;
  }
});
Object.defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function get() {
    return _Tabs.default;
  }
});
Object.defineProperty(exports, "TextInput", {
  enumerable: true,
  get: function get() {
    return _TextInput.default;
  }
});
Object.defineProperty(exports, "Textarea", {
  enumerable: true,
  get: function get() {
    return _Textarea.default;
  }
});
Object.defineProperty(exports, "TimePicker", {
  enumerable: true,
  get: function get() {
    return _TimePicker.default;
  }
});
Object.defineProperty(exports, "Toast", {
  enumerable: true,
  get: function get() {
    return _Toast.default;
  }
});
Object.defineProperty(exports, "resetID", {
  enumerable: true,
  get: function get() {
    return _idgen.resetID;
  }
});

var _Autocomplete = _interopRequireDefault(__webpack_require__(414));

var _Badge = _interopRequireDefault(__webpack_require__(890));

var _Breadcrumb = _interopRequireDefault(__webpack_require__(891));

var _Button = _interopRequireDefault(__webpack_require__(238));

var _Caption = _interopRequireDefault(__webpack_require__(892));

var _Card = _interopRequireDefault(__webpack_require__(893));

var _CardPanel = _interopRequireDefault(__webpack_require__(894));

var _CardTitle = _interopRequireDefault(__webpack_require__(895));

var _Carousel = _interopRequireDefault(__webpack_require__(896));

var _Checkbox = _interopRequireDefault(__webpack_require__(897));

var _Chip = _interopRequireDefault(__webpack_require__(898));

var _Col = _interopRequireDefault(__webpack_require__(174));

var _Collapsible = _interopRequireDefault(__webpack_require__(899));

var _CollapsibleItem = _interopRequireDefault(__webpack_require__(900));

var _Collection = _interopRequireDefault(__webpack_require__(901));

var _CollectionItem = _interopRequireDefault(__webpack_require__(902));

var _Container = _interopRequireDefault(__webpack_require__(903));

var _DatePicker = _interopRequireDefault(__webpack_require__(904));

var _Divider = _interopRequireDefault(__webpack_require__(905));

var _Dropdown = _interopRequireDefault(__webpack_require__(415));

var _Footer = _interopRequireDefault(__webpack_require__(906));

var _Icon = _interopRequireDefault(__webpack_require__(86));

var _MediaBox = _interopRequireDefault(__webpack_require__(907));

var _Modal = _interopRequireDefault(__webpack_require__(908));

var _NavItem = _interopRequireDefault(__webpack_require__(910));

var _Navbar = _interopRequireDefault(__webpack_require__(911));

var _Pagination = _interopRequireDefault(__webpack_require__(912));

var _PaginationButton = _interopRequireDefault(__webpack_require__(417));

var _Parallax = _interopRequireDefault(__webpack_require__(913));

var _Preloader = _interopRequireDefault(__webpack_require__(914));

var _ProgressBar = _interopRequireDefault(__webpack_require__(915));

var _RadioGroup = _interopRequireDefault(__webpack_require__(916));

var _Range = _interopRequireDefault(__webpack_require__(917));

var _Row = _interopRequireDefault(__webpack_require__(239));

var _SearchForm = _interopRequireDefault(__webpack_require__(416));

var _Section = _interopRequireDefault(__webpack_require__(918));

var _Select = _interopRequireDefault(__webpack_require__(919));

var _SideNav = _interopRequireDefault(__webpack_require__(920));

var _SideNavItem = _interopRequireDefault(__webpack_require__(921));

var _Slide = _interopRequireDefault(__webpack_require__(923));

var _Slider = _interopRequireDefault(__webpack_require__(924));

var _Spinner = _interopRequireDefault(__webpack_require__(418));

var _Switch = _interopRequireDefault(__webpack_require__(925));

var _Tab = _interopRequireDefault(__webpack_require__(419));

var _Table = _interopRequireDefault(__webpack_require__(926));

var _Tabs = _interopRequireDefault(__webpack_require__(927));

var _TextInput = _interopRequireDefault(__webpack_require__(175));

var _Textarea = _interopRequireDefault(__webpack_require__(928));

var _TimePicker = _interopRequireDefault(__webpack_require__(929));

var _Toast = _interopRequireDefault(__webpack_require__(930));

var _idgen = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _constants = _interopRequireDefault(__webpack_require__(66));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Col = function Col(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$node = _ref.node,
      C = _ref$node === void 0 ? 'div' : _ref$node,
      s = _ref.s,
      m = _ref.m,
      l = _ref.l,
      xl = _ref.xl,
      offset = _ref.offset,
      push = _ref.push,
      pull = _ref.pull,
      other = _objectWithoutProperties(_ref, ["children", "className", "node", "s", "m", "l", "xl", "offset", "push", "pull"]);

  var sizes = {
    s: s,
    m: m,
    l: l,
    xl: xl
  };
  var classes = {
    col: true
  };

  _constants.default.SIZES.forEach(function (size) {
    return classes[size + sizes[size]] = sizes[size];
  });

  if (offset) {
    offset.split(' ').forEach(function (offset) {
      return classes['offset-' + offset] = true;
    });
  }

  if (push) {
    push.split(' ').forEach(function (push) {
      return classes['push-' + push] = true;
    });
  }

  if (pull) {
    pull.split(' ').forEach(function (pull) {
      return classes['pull-' + pull] = true;
    });
  }

  return _react.default.createElement(C, _extends({}, other, {
    className: (0, _classnames.default)(classes, className)
  }), children);
};

Col.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,

  
  xl: _propTypes.default.number,

  
  l: _propTypes.default.number,

  
  m: _propTypes.default.number,

  
  s: _propTypes.default.number,

  
  node: _propTypes.default.node,

  
  offset: _propTypes.default.string,
  push: _propTypes.default.string,
  pull: _propTypes.default.string
};
var _default = Col;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _idgen = _interopRequireDefault(__webpack_require__(36));

var _constants = _interopRequireDefault(__webpack_require__(66));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TextInput = _react.default.forwardRef(function (props, ref) {
  // eslint-disable-next-line react/prop-types
  var dataLength = props['data-length'];
  var inputRef = ref || (0, _react.createRef)(null);
  (0, _react.useEffect)(function () {
    if (inputRef && dataLength) {
      M.CharacterCounter.init(inputRef.current);
    }
  }, [dataLength, inputRef]);
  (0, _react.useEffect)(function () {
    M.updateTextFields();
  }, [props.children]);

  var children = props.children,
      s = props.s,
      m = props.m,
      l = props.l,
      xl = props.xl,
      disabled = props.disabled,
      noLayout = props.noLayout,
      placeholder = props.placeholder,
      icon = props.icon,
      label = props.label,
      inputClassName = props.inputClassName,
      success = props.success,
      error = props.error,
      password = props.password,
      email = props.email,
      validate = props.validate,
      defaultValue = props.defaultValue,
      value = props.value,
      type = props.type,
      other = _objectWithoutProperties(props, ["children", "s", "m", "l", "xl", "disabled", "noLayout", "placeholder", "icon", "label", "inputClassName", "success", "error", "password", "email", "validate", "defaultValue", "value", "type"]);

  var sizes = {
    s: s,
    m: m,
    l: l,
    xl: xl
  };
  var responsiveClasses;

  if (!noLayout) {
    responsiveClasses = {
      col: true
    };

    _constants.default.SIZES.forEach(function (size) {
      responsiveClasses[size + sizes[size]] = sizes[size];
    });
  }

  var wrapperClasses = (0, _classnames.default)('input-field', responsiveClasses);
  var computedType;

  if (type) {
    computedType = type;
  } else if (password) {
    computedType = 'password';
  } else if (email) {
    computedType = 'email';
  } else {
    computedType = 'text';
  }

  var inputProps = _objectSpread({
    placeholder: placeholder,
    type: computedType,
    value: value,
    defaultValue: defaultValue,
    disabled: disabled
  }, other);

  var renderLabel = function renderLabel() {
    return label && _react.default.createElement("label", {
      className: (0, _classnames.default)({
        active: value || placeholder,
        'label-icon': typeof label !== 'string'
      }),
      "data-success": success,
      "data-error": error,
      htmlFor: inputProps.id
    }, label);
  };

  var renderHelper = function renderHelper() {
    return (error || success) && _react.default.createElement("span", {
      className: "helper-text",
      "data-error": error,
      "data-success": success
    });
  };

  var renderIcon = function renderIcon() {
    if (!icon) return;

    if (typeof icon === 'string') {
      return _react.default.createElement("i", {
        className: "material-icons prefix"
      }, icon);
    }

    return _react.default.cloneElement(icon, {
      className: 'prefix'
    });
  };

  if (type === 'file') {
    return _react.default.createElement("div", {
      className: "".concat(wrapperClasses, " file-field")
    }, _react.default.createElement("div", {
      className: "btn"
    }, _react.default.createElement("span", null, label), _react.default.createElement("input", _extends({
      type: "file",
      className: (0, _classnames.default)({
        validate: validate
      }, inputClassName)
    }, inputProps))), _react.default.createElement("div", {
      className: "file-path-wrapper"
    }, _react.default.createElement("input", {
      className: "file-path validate",
      type: "text"
    })), renderHelper(), children);
  }

  return _react.default.createElement("div", {
    className: wrapperClasses
  }, renderIcon(), _react.default.createElement("input", _extends({
    ref: inputRef,
    className: (0, _classnames.default)({
      validate: validate
    }, inputClassName)
  }, inputProps)), renderLabel(), renderHelper(), children);
});

TextInput.displayName = 'TextInput';
TextInput.propTypes = {
  
  noLayout: _propTypes.default.bool,

  
  s: _propTypes.default.number,

  
  m: _propTypes.default.number,

  
  l: _propTypes.default.number,

  
  xl: _propTypes.default.number,

  
  disabled: _propTypes.default.bool,

  
  placeholder: _propTypes.default.string,

  
  id: _propTypes.default.string,

  
  icon: _propTypes.default.node,

  
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),

  
  defaultValue: _propTypes.default.string,

  
  value: _propTypes.default.string,

  
  validate: _propTypes.default.bool,

  
  success: _propTypes.default.string,

  
  error: _propTypes.default.string,

  
  inputClassName: _propTypes.default.string,

  
  type: _propTypes.default.string,

  
  onChange: _propTypes.default.func,

  
  password: _propTypes.default.bool,

  
  email: _propTypes.default.bool,

  
  children: _propTypes.default.node
};
TextInput.defaultProps = {
  id: "TextInput-".concat((0, _idgen.default)())
};
var _default = TextInput;
exports.default = _default;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "c", function() { return ChatListWrapper; });



 __webpack_require__.d(__webpack_exports__, "d", function() { return ChatsList; });


 __webpack_require__.d(__webpack_exports__, "b", function() { return Chat; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return UpperInfo; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return LowerInfo; });
 __webpack_require__.d(__webpack_exports__, "w", function() { return UsersInside; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return TimeLeft; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarWrapper; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return CreateChatDesktop; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return CreateChat; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return FilterContainer; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return SearchBar; });

 __webpack_require__.d(__webpack_exports__, "t", function() { return UserAvatar; });
 __webpack_require__.d(__webpack_exports__, "u", function() { return UserContent; });
 __webpack_require__.d(__webpack_exports__, "v", function() { return UserName; });


 __webpack_require__.d(__webpack_exports__, "l", function() { return MiniAvatar; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return MiniNumber; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return MessageDate; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return LastMessageText; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return IndicatorNews; });




 __webpack_require__.d(__webpack_exports__, "n", function() { return NewChatContainer; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return NewChatHeader; });

 __webpack_require__.d(__webpack_exports__, "o", function() { return NewChatGrid; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
 var __WEBPACK_IMPORTED_MODULE_2_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_3_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_icons_search_svg__ = __webpack_require__(422);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_icons_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_icons_search_svg__);
var _templateObject=_taggedTemplateLiteral(['\n  display: block !important;\n  flex-direction: unset !important;\n  height: 100%;\n  width: 100%;\n  background-color: ',';\n'],['\n  display: block !important;\n  flex-direction: unset !important;\n  height: 100%;\n  width: 100%;\n  background-color: ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: block !important;\n  flex-direction: unset !important;\n  height: calc(100vh - 107px);\n  position: relative;\n  width: 100%;\n  overflow: auto;\n\n  @media (max-width: ','px) {\n    height: calc(100vh - 170px);\n  }\n\n  .chat_grid {\n    white-space: nowrap;\n    height: calc(100% - 7.4rem);\n    .chats_list {\n      white-space: initial;\n      display: ',';\n      vertical-align: top;\n      width: ',';\n      height: 100%;\n      overflow: auto;\n      padding-bottom: 3rem;\n\n      @media (max-width: ','px) {\n        width: 100%;\n        padding-right: 0;\n      }\n    }\n\n    .selected_chat {\n      white-space: initial;\n      display: inline-block;\n      vertical-align: top;\n      background-color: #fff;\n      height: 100%;\n      width: calc(100% - 50rem);\n      box-shadow: 0px -2px 6px 1px rgb(0 0 0 / 20%);\n\n      .chat_wrapper {\n        height: 100%;\n\n        .chat_header {\n          box-shadow: 2px 0px 6px 1px rgb(0 0 0 / 20%);\n          position: relative;\n          z-index: 8;\n\n          .back_arrow {\n            display: none;\n          }\n        }\n\n        .chat_container {\n          height: calc(100% - 6rem);\n\n          .chat_messages {\n            height: calc(100% - 6rem);\n          }\n        }\n      }\n    }\n  }\n\n  .no_elements {\n    div {\n      color: ',';\n    }\n  }\n'],['\n  display: block !important;\n  flex-direction: unset !important;\n  height: calc(100vh - 107px);\n  position: relative;\n  width: 100%;\n  overflow: auto;\n\n  @media (max-width: ','px) {\n    height: calc(100vh - 170px);\n  }\n\n  .chat_grid {\n    white-space: nowrap;\n    height: calc(100% - 7.4rem);\n    .chats_list {\n      white-space: initial;\n      display: ',';\n      vertical-align: top;\n      width: ',';\n      height: 100%;\n      overflow: auto;\n      padding-bottom: 3rem;\n\n      @media (max-width: ','px) {\n        width: 100%;\n        padding-right: 0;\n      }\n    }\n\n    .selected_chat {\n      white-space: initial;\n      display: inline-block;\n      vertical-align: top;\n      background-color: #fff;\n      height: 100%;\n      width: calc(100% - 50rem);\n      box-shadow: 0px -2px 6px 1px rgb(0 0 0 / 20%);\n\n      .chat_wrapper {\n        height: 100%;\n\n        .chat_header {\n          box-shadow: 2px 0px 6px 1px rgb(0 0 0 / 20%);\n          position: relative;\n          z-index: 8;\n\n          .back_arrow {\n            display: none;\n          }\n        }\n\n        .chat_container {\n          height: calc(100% - 6rem);\n\n          .chat_messages {\n            height: calc(100% - 6rem);\n          }\n        }\n      }\n    }\n  }\n\n  .no_elements {\n    div {\n      color: ',';\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  margin-top: 1rem;\n  background-color: #f5f5f5;\n  height: calc(100vh - 90px);\n  padding-bottom: 50px;\n'],['\n  margin-top: 1rem;\n  background-color: #f5f5f5;\n  height: calc(100vh - 90px);\n  padding-bottom: 50px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: relative;\n  margin-top: 30px;\n\n  .image_chat_icon {\n    text-align: center;\n    img {\n      width: 80%;\n      max-width: 250px;\n    }\n  }\n\n  .no_chats_message {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 600;\n  }\n'],['\n  position: relative;\n  margin-top: 30px;\n\n  .image_chat_icon {\n    text-align: center;\n    img {\n      width: 80%;\n      max-width: 250px;\n    }\n  }\n\n  .no_chats_message {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 600;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  padding-bottom: 5px;\n  margin-bottom: 5px;\n  border-bottom: 1px solid #fff;\n'],['\n  padding-bottom: 5px;\n  margin-bottom: 5px;\n  border-bottom: 1px solid #fff;\n']),_templateObject6=_taggedTemplateLiteral(['\n  margin: 2rem;\n  .title_chats {\n    font-family: ',';\n    color: ',';\n    font-size: 2.2rem;\n    margin: 1rem 0 2rem;\n  }\n'],['\n  margin: 2rem;\n  .title_chats {\n    font-family: ',';\n    color: ',';\n    font-size: 2.2rem;\n    margin: 1rem 0 2rem;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px;\n  margin: 10px 0;\n  background-color: ',';\n'],['\n  color: ',';\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px;\n  margin: 10px 0;\n  background-color: ',';\n']),_templateObject8=_taggedTemplateLiteral(['\n  overflow-x: auto;\n  white-space: nowrap;\n  padding: 10px 0;\n'],['\n  overflow-x: auto;\n  white-space: nowrap;\n  padding: 10px 0;\n']),_templateObject9=_taggedTemplateLiteral(['\n  font-family: ',';\n  width: 90%;\n  padding: 10px;\n  background-color: #fafafa;\n  position: relative;\n  margin-top: 1rem;\n  border-radius: 1.5rem;\n  box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.20);\n  cursor: pointer;\n'],['\n  font-family: ',';\n  width: 90%;\n  padding: 10px;\n  background-color: #fafafa;\n  position: relative;\n  margin-top: 1rem;\n  border-radius: 1.5rem;\n  box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.20);\n  cursor: pointer;\n']),_templateObject10=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n'],['\n  display: flex;\n  align-items: center;\n']),_templateObject11=_taggedTemplateLiteral(['\n  margin-top: 2rem;\n  height: 3rem;\n  display: flex;\n  align-items: center;\n'],['\n  margin-top: 2rem;\n  height: 3rem;\n  display: flex;\n  align-items: center;\n']),_templateObject12=_taggedTemplateLiteral(['\n  position: relative;\n  width: 50%;\n  margin-left: 0.5rem;\n'],['\n  position: relative;\n  width: 50%;\n  margin-left: 0.5rem;\n']),_templateObject13=_taggedTemplateLiteral(['\n  width: 50%;\n  display: flex;\n  justify-content: flex-end;\n  color: #FFA200;\n  font-size: 1.1rem;\n'],['\n  width: 50%;\n  display: flex;\n  justify-content: flex-end;\n  color: #FFA200;\n  font-size: 1.1rem;\n']),_templateObject14=_taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  border-radius: 2rem;\n  margin-right: 1rem;\n'],['\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  border-radius: 2rem;\n  margin-right: 1rem;\n']),_templateObject15=_taggedTemplateLiteral(['\n  color: ',';\n  box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.20);\n  border-radius: 2rem;\n  padding: 1rem 3rem;\n  font-size: 2.4rem;\n  width: 90%;\n  font-family: ',';\n  cursor: pointer;\n\n  span {\n    font-family: ',';\n    font-size: 1.4rem;\n    color: ',';\n    display: inline-block;\n    margin-left: 2rem;\n    margin-top: -0.3rem;\n    vertical-align: middle;\n  }\n\n  @media (max-width: ','px) {\n    display: none;\n  }\n'],['\n  color: ',';\n  box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.20);\n  border-radius: 2rem;\n  padding: 1rem 3rem;\n  font-size: 2.4rem;\n  width: 90%;\n  font-family: ',';\n  cursor: pointer;\n\n  span {\n    font-family: ',';\n    font-size: 1.4rem;\n    color: ',';\n    display: inline-block;\n    margin-left: 2rem;\n    margin-top: -0.3rem;\n    vertical-align: middle;\n  }\n\n  @media (max-width: ','px) {\n    display: none;\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  position: absolute;\n  right: 2%;\n  bottom: 10%;\n  width: 63px;\n  height: 63px;\n  margin: 2%;\n  align-items: center;\n  z-index: 10000;\n\n  @media (min-width: ','px) {\n    display: none;\n  }\n\n  button {\n    border-style: none;\n    background-color: ',';\n    width: 58px;\n    height: 58px;\n    padding: 5px;\n    border-radius: 50px;\n\n  }\n'],['\n  position: absolute;\n  right: 2%;\n  bottom: 10%;\n  width: 63px;\n  height: 63px;\n  margin: 2%;\n  align-items: center;\n  z-index: 10000;\n\n  @media (min-width: ','px) {\n    display: none;\n  }\n\n  button {\n    border-style: none;\n    background-color: ',';\n    width: 58px;\n    height: 58px;\n    padding: 5px;\n    border-radius: 50px;\n\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  white-space: nowrap;\n  overflow-x: auto;\n  padding: 0.5rem 1rem 0;\n  box-shadow: inset 0px 3px 6px -2px rgb(0 0 0 / 16%), 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  z-index: 9;\n  background-color: #fff;\n  z-index: 9;\n  position: relative;\n  padding: 1.2rem 1.5rem;\n'],['\n  white-space: nowrap;\n  overflow-x: auto;\n  padding: 0.5rem 1rem 0;\n  box-shadow: inset 0px 3px 6px -2px rgb(0 0 0 / 16%), 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  z-index: 9;\n  background-color: #fff;\n  z-index: 9;\n  position: relative;\n  padding: 1.2rem 1.5rem;\n']),_templateObject18=_taggedTemplateLiteral(['\n  background-color: ',';\n  border-radius: 50px;\n  display: flex;\n  float: left;\n  align-items: center;\n  border: 2px grey;\n\n  @media (max-width: ','px) {\n    display: block;\n    float: none;\n  }\n\n  .lensIcon {\n    float: left;\n    vertical-align: middle;\n    margin: 5px;\n    width: 15px;\n  }\n\n  input {\n    background-image: url(',');\n    background-repeat: no-repeat;\n    background-position: 1rem center;\n    width: 30rem;\n    padding-left: 4rem;\n    margin-right: 1rem;\n\n    @media (max-width: ','px) {\n      width: 100%;\n    }\n  }\n'],['\n  background-color: ',';\n  border-radius: 50px;\n  display: flex;\n  float: left;\n  align-items: center;\n  border: 2px grey;\n\n  @media (max-width: ','px) {\n    display: block;\n    float: none;\n  }\n\n  .lensIcon {\n    float: left;\n    vertical-align: middle;\n    margin: 5px;\n    width: 15px;\n  }\n\n  input {\n    background-image: url(',');\n    background-repeat: no-repeat;\n    background-position: 1rem center;\n    width: 30rem;\n    padding-left: 4rem;\n    margin-right: 1rem;\n\n    @media (max-width: ','px) {\n      width: 100%;\n    }\n  }\n']),_templateObject19=_taggedTemplateLiteral(['\n  background-color: transparent;\n  margin: 15px;\n  height: 28px;\n  border-radius: 50px;\n  border: 2px solid ',';\n  font-family: ',';\n  color: ',';\n  align-items: center;\n  padding: 5px;\n  display: inline-block;\n  font-weight: 200;\n  font-size: 14px;\n'],['\n  background-color: transparent;\n  margin: 15px;\n  height: 28px;\n  border-radius: 50px;\n  border: 2px solid ',';\n  font-family: ',';\n  color: ',';\n  align-items: center;\n  padding: 5px;\n  display: inline-block;\n  font-weight: 200;\n  font-size: 14px;\n']),_templateObject20=_taggedTemplateLiteral(['\n   && {\n    width: ',';\n    height: ',';\n    display: inline-block;\n    border-radius: ',';\n    border: ',';\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      object-fit: cover;\n      background-color: #fafafa;\n    }\n\n    &.text-avatar {\n      font-size: 2rem;\n    }\n   }\n'],['\n   && {\n    width: ',';\n    height: ',';\n    display: inline-block;\n    border-radius: ',';\n    border: ',';\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      object-fit: cover;\n      background-color: #fafafa;\n    }\n\n    &.text-avatar {\n      font-size: 2rem;\n    }\n   }\n']),_templateObject21=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: top;\n  width: 78%;\n  .name_indicator{\n    position: relative;\n    display: flex;\n    font-family: ',';\n    font-size: 1.4rem;\n  }\n'],['\n  display: inline-block;\n  vertical-align: top;\n  width: 78%;\n  .name_indicator{\n    position: relative;\n    display: flex;\n    font-family: ',';\n    font-size: 1.4rem;\n  }\n']),_templateObject22=_taggedTemplateLiteral(['\n  font-size: 1.2rem;\n  font-family: ',';\n  color: #444;\n  height: 20px;\n  text-overflow: ellipsis;\n  display: inline-block;\n  width: calc(100% - 60px);\n  overflow: hidden;\n  white-space: nowrap;\n'],['\n  font-size: 1.2rem;\n  font-family: ',';\n  color: #444;\n  height: 20px;\n  text-overflow: ellipsis;\n  display: inline-block;\n  width: calc(100% - 60px);\n  overflow: hidden;\n  white-space: nowrap;\n']),_templateObject23=_taggedTemplateLiteral(['\n  font-weight: 600;\n  font-size: 1rem;\n  color: #444;\n  height: 20px;\n  text-overflow: ellipsis;\n  display: inline-block;\n  width: calc(100% - 75px);\n'],['\n  font-weight: 600;\n  font-size: 1rem;\n  color: #444;\n  height: 20px;\n  text-overflow: ellipsis;\n  display: inline-block;\n  width: calc(100% - 75px);\n']),_templateObject24=_taggedTemplateLiteral(['\n  font-size: 14px;\n  color: #444;\n  height: 20px;\n  text-overflow: ellipsis;\n  display: inline-block;\n  width: calc(100% - 60px);\n  overflow: hidden;\n  white-space: nowrap;\n'],['\n  font-size: 14px;\n  color: #444;\n  height: 20px;\n  text-overflow: ellipsis;\n  display: inline-block;\n  width: calc(100% - 60px);\n  overflow: hidden;\n  white-space: nowrap;\n']),_templateObject25=_taggedTemplateLiteral(['\n   && {\n    position: absolute;\n    top: -15px;\n    left: ',';\n    width: 2.5rem;\n    height: 2.5rem;\n    display: inline-block;\n    border-radius: 50%;\n    box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.41);\n    border: none;\n    img {\n      object-fit: cover;\n      background-color: #fafafa;\n    }\n\n    &.text-avatar {\n      font-size: 28px;\n      padding-top: 13px;\n      text-align: center;\n    }\n   }\n'],['\n   && {\n    position: absolute;\n    top: -15px;\n    left: ',';\n    width: 2.5rem;\n    height: 2.5rem;\n    display: inline-block;\n    border-radius: 50%;\n    box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.41);\n    border: none;\n    img {\n      object-fit: cover;\n      background-color: #fafafa;\n    }\n\n    &.text-avatar {\n      font-size: 28px;\n      padding-top: 13px;\n      text-align: center;\n    }\n   }\n']),_templateObject26=_taggedTemplateLiteral(['\n   && {\n    position: absolute;\n    background: white;\n    top: -15px;\n    left: ',';\n    width: 2.5rem;\n    height: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    border: none;\n    color: black;\n    font-size: 1.1rem;\n   }\n'],['\n   && {\n    position: absolute;\n    background: white;\n    top: -15px;\n    left: ',';\n    width: 2.5rem;\n    height: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    border: none;\n    color: black;\n    font-size: 1.1rem;\n   }\n']),_templateObject27=_taggedTemplateLiteral(['\n  width: 60px;\n  display: inline-block;\n  text-align: right;\n  color: #888;\n  font-size: 1rem;\n'],['\n  width: 60px;\n  display: inline-block;\n  text-align: right;\n  color: #888;\n  font-size: 1rem;\n']),_templateObject28=_taggedTemplateLiteral(['\n  color: #444;\n  font-size: 1rem;\n  height: 1.1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: calc(100% - 35px);\n  position: relative;\n'],['\n  color: #444;\n  font-size: 1rem;\n  height: 1.1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: calc(100% - 35px);\n  position: relative;\n']),_templateObject29=_taggedTemplateLiteral(['\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  margin-right: 0.5rem;\n  background-color: ',';\n'],['\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  margin-right: 0.5rem;\n  background-color: ',';\n']),_templateObject30=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: top;\n  text-align: center;\n  width: 10rem;\n  cursor: pointer;\n  margin-right: 10px;\n\n  .avatar_bubble {\n    margin: 0 auto;\n  }\n\n  .username {\n    font-size: 12px;\n    font-weight: 600;\n    width: 80%;\n    white-space: initial;\n    margin: 0 auto;\n    color: ',';\n    height: 32px;\n    margin-top: 0.5rem;\n  }\n'],['\n  display: inline-block;\n  vertical-align: top;\n  text-align: center;\n  width: 10rem;\n  cursor: pointer;\n  margin-right: 10px;\n\n  .avatar_bubble {\n    margin: 0 auto;\n  }\n\n  .username {\n    font-size: 12px;\n    font-weight: 600;\n    width: 80%;\n    white-space: initial;\n    margin: 0 auto;\n    color: ',';\n    height: 32px;\n    margin-top: 0.5rem;\n  }\n']),_templateObject31=_taggedTemplateLiteral(['\n  width: 42px;\n  margin: 5px auto;\n\n'],['\n  width: 42px;\n  margin: 5px auto;\n\n']),_templateObject32=_taggedTemplateLiteral(['\n  && {\n    width: 42px;\n    height: 42px;\n    display: inline-block;\n\n    img {\n      object-fit: contain;\n      background-color: #eee;\n    }\n\n    &.text-avatar {\n      font-size: 24px;\n      padding-top: 9px;\n      text-align: center;\n    }\n   }\n'],['\n  && {\n    width: 42px;\n    height: 42px;\n    display: inline-block;\n\n    img {\n      object-fit: contain;\n      background-color: #eee;\n    }\n\n    &.text-avatar {\n      font-size: 24px;\n      padding-top: 9px;\n      text-align: center;\n    }\n   }\n']),_templateObject33=_taggedTemplateLiteral(['\n  font-size: 13px;\n  color: #fff;\n  margin-right: 22px;\n  margin-left: 22px;\n  text-align: left;\n'],['\n  font-size: 13px;\n  color: #fff;\n  margin-right: 22px;\n  margin-left: 22px;\n  text-align: left;\n']),_templateObject34=_taggedTemplateLiteral(['\n   font-family: ',';\n\n   .new_chat_title {\n    font-family: ',';\n    font-size: 16px;\n    text-align: center;\n    color: ',';\n    margin: 2rem;\n  }\n'],['\n   font-family: ',';\n\n   .new_chat_title {\n    font-family: ',';\n    font-size: 16px;\n    text-align: center;\n    color: ',';\n    margin: 2rem;\n  }\n']),_templateObject35=_taggedTemplateLiteral(['\n   height: 45px;\n   color: black;\n   font-size: 16px;\n   font-weight: bold;\n   display: flex;\n   margin-top: env(safe-area-inset-top);\n   align-items: center;\n\n   .arrowback {\n     float: left;\n     height: 45px;\n     margin-left: 2rem;\n   }\n\n  div {\n    float: left;\n    width: 85%;\n    height: 45px;\n    padding: 15px 0px;\n\n    @media (max-width: ','px){\n      width: 47vw;\n    }\n  }\n\n  .search_lens {\n    height: 45px;\n    padding: 10px;\n    @media (max-width: ','px){\n      margin-left: 11%;\n    }\n   }\n\n   .infocircle {\n     float: right;\n     height: 45px;\n     padding: 10px;\n   }\n'],['\n   height: 45px;\n   color: black;\n   font-size: 16px;\n   font-weight: bold;\n   display: flex;\n   margin-top: env(safe-area-inset-top);\n   align-items: center;\n\n   .arrowback {\n     float: left;\n     height: 45px;\n     margin-left: 2rem;\n   }\n\n  div {\n    float: left;\n    width: 85%;\n    height: 45px;\n    padding: 15px 0px;\n\n    @media (max-width: ','px){\n      width: 47vw;\n    }\n  }\n\n  .search_lens {\n    height: 45px;\n    padding: 10px;\n    @media (max-width: ','px){\n      margin-left: 11%;\n    }\n   }\n\n   .infocircle {\n     float: right;\n     height: 45px;\n     padding: 10px;\n   }\n']),_templateObject36=_taggedTemplateLiteral(['\n   background-color: ',';\n   width: 334px;\n   height: 28px;\n   border-radius: 50px;\n   margin: 9px;\n\n   @media (max-width: ','px){\n    width: 334px;\n   }\n\n   img {\n      float: left;\n      width: 18px;\n      height: 18px;\n      margin: 6px;\n   }\n\n   input {\n    font-family: ',';\n    color: #30423E;\n    font-size: 16px;\n    border: none;\n    width: 70%;\n    height: 28px;\n\n    @media (max-width: ','px){\n      width: 280px;\n    }\n\n  }\n\n'],['\n   background-color: ',';\n   width: 334px;\n   height: 28px;\n   border-radius: 50px;\n   margin: 9px;\n\n   @media (max-width: ','px){\n    width: 334px;\n   }\n\n   img {\n      float: left;\n      width: 18px;\n      height: 18px;\n      margin: 6px;\n   }\n\n   input {\n    font-family: ',';\n    color: #30423E;\n    font-size: 16px;\n    border: none;\n    width: 70%;\n    height: 28px;\n\n    @media (max-width: ','px){\n      width: 280px;\n    }\n\n  }\n\n']),_templateObject37=_taggedTemplateLiteral(['\n  width: 90%;\n  display: grid;\n  grid-template-columns: auto auto auto auto auto;\n  grid-template-rows: 150px;\n  margin: 2rem 5%;\n\n  @media (max-width: ','px) {\n    grid-template-columns: 30% 30% 30%;\n    grid-template-rows: 150px 150px 150px;\n  }\n\n'],['\n  width: 90%;\n  display: grid;\n  grid-template-columns: auto auto auto auto auto;\n  grid-template-rows: 150px;\n  margin: 2rem 5%;\n\n  @media (max-width: ','px) {\n    grid-template-columns: 30% 30% 30%;\n    grid-template-rows: 150px 150px 150px;\n  }\n\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var NoMessagesLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;});var ChatListWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],function(props){return props.selectedChat?'inline-block':'block';},function(props){return props.selectedChat?'50rem':'100%';},__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ]);var ChatsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var ImageChatsLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var MatchesChats=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var ChatsList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ]);var Minititle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7,function(props){return props.text;},function(props){return props.color;});var MatchesSlider=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);var Chat=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily);var UpperInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10);var LowerInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11);var UsersInside=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12);var TimeLeft=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13);var AvatarWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject14);var CreateChatDesktop=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject15,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var CreateChat=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_3_constants_colors__["j" ]);var FilterContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17);var SearchBar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["k" ],__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_5_assets_images_icons_search_svg___default.a,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var EachFilter=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject19,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["k" ],__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["k" ]);var UserAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject20,function(props){return!props.dead?'40px':'40px';},function(props){return!props.dead?'40px':'40px';},function(props){return!props.dead?'50%':'0%';},function(props){return!props.dead?'1px solid #ddd':'none';});var UserContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject21,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily);var UserName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject22,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily);var ThinkChatTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject23);var ChatName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject24);var MiniAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject25,function(props){return props.left;});var MiniNumber=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject26,function(props){return props.left;});var MessageDate=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject27);var LastMessageText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject28);var IndicatorNews=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject29,function(props){return props.color;});var BubbleMatchElement=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject30,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ]);var AvatarBubbleWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject31);var UserBubbleAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject32);var Subtitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject33);var NewChatContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject34,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ]);var NewChatHeader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject35,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var NewChatFilter=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject36,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["k" ],__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var NewChatGrid=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject37,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__InputLabel__ = __webpack_require__(971);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputLabel__["a"]; });


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no_results.83c2394d.svg";

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendorPrefix = exports.events = undefined;
exports.arrayMove = arrayMove;
exports.omit = omit;
exports.closest = closest;
exports.limit = limit;
exports.getElementMargin = getElementMargin;
exports.provideDisplayName = provideDisplayName;
exports.getPosition = getPosition;
exports.isTouchEvent = isTouchEvent;
exports.getEdgeOffset = getEdgeOffset;
exports.getLockPixelOffset = getLockPixelOffset;

var _invariant = __webpack_require__(47);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
    return acc;
  }, {});
}

var events = exports.events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = exports.vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

function provideDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

function getPosition(event) {
  if (event.touches && event.touches.length) {
    return {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  } else if (event.changedTouches && event.changedTouches.length) {
    return {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
  } else {
    return {
      x: event.pageX,
      y: event.pageY
    };
  }
}

function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}

function getEdgeOffset(node, parent) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { top: 0, left: 0 };

  // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
  if (node) {
    var nodeOffset = {
      top: offset.top + node.offsetTop,
      left: offset.left + node.offsetLeft
    };

    if (node.parentNode !== parent) {
      return getEdgeOffset(node.parentNode, parent, nodeOffset);
    } else {
      return nodeOffset;
    }
  }
}

function getLockPixelOffset(_ref) {
  var lockOffset = _ref.lockOffset,
      width = _ref.width,
      height = _ref.height;

  var offsetX = lockOffset;
  var offsetY = lockOffset;
  var unit = 'px';

  if (typeof lockOffset === 'string') {
    var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

    (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);

    offsetX = offsetY = parseFloat(lockOffset);
    unit = match[1];
  }

  (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

  if (unit === '%') {
    offsetX = offsetX * width / 100;
    offsetY = offsetY * height / 100;
  }

  return {
    x: offsetX,
    y: offsetY
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1227);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1231);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return getURLByPhase; });
var getURLByPhase=function getURLByPhase(call){var id=call.id;return"/narratives/"+id;};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1414);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(277);
 var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(278);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" ] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" ]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

 __webpack_exports__["a"] = (function(name) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" ])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_timer__ = __webpack_require__(288);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["b"]; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["c"]; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["d"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_timeout__ = __webpack_require__(1506);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_timeout__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_interval__ = __webpack_require__(1507);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_interval__["a"]; });







 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = tweenValue;
 var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(58);


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" ])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" ])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

 __webpack_exports__["a"] = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" ])(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" ])(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" ])(node, id).value[name];
  };
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(296);


 __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" ])(Math.abs(x)), x ? x[1] : NaN;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = rotateRadians;
 var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(531);
 var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(18);



function rotationIdentity(lambda, phi) {
  return [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" ] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" ] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" ] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" ] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math__["w" ]) ? (deltaPhi || deltaGamma ? Object(__WEBPACK_IMPORTED_MODULE_0__compose__["a" ])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" ] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" ] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" ] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" ] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(deltaPhi),
      sinDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(deltaPhi),
      cosDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(deltaGamma),
      sinDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" ])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" ])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" ])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" ])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

 __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" ], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" ], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math__["r" ] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" ], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" ]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" ], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" ], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" ], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" ]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" ], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" ], coordinates;
  };

  return forward;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = clipRectangle;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__(534);
 var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(1587);
 var __WEBPACK_IMPORTED_MODULE_3__rejoin__ = __webpack_require__(535);
 var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(43);






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" ])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" ] ? direction > 0 ? 0 : 3
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" ])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math__["i" ] ? direction > 0 ? 2 : 1
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" ])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" ] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = Object(__WEBPACK_IMPORTED_MODULE_1__buffer__["a" ])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["n" ])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          Object(__WEBPACK_IMPORTED_MODULE_3__rejoin__["a" ])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (Object(__WEBPACK_IMPORTED_MODULE_2__line__["a" ])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = transformer;
 __webpack_exports__["a"] = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(305);


 __webpack_exports__["a"] = (function(defaultMimeType, response) {
  return function(url, callback) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" ])(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r.get(callback);
    }
    return r;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["c"] = deinterpolateLinear;
 __webpack_exports__["a"] = copy;
 __webpack_exports__["b"] = continuous;
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);
 var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(103);
 var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(306);
 var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(552);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" ])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" ])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" ],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" ].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" ]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" ].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" ].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["r" ], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(40);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__src_interval__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(1663);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["b"]; });
 __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
 __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(1664);
 __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["b"]; });
 __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
 __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(1665);
 __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(1666);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(1667);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["b"]; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(1668);
 __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["g"]; });
 __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["h"]; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["g"]; });
 __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["h"]; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["d"]; });
 __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["k"]; });
 __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["l"]; });
 __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["m"]; });
 __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["n"]; });
 __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["i"]; });
 __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["j"]; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["e"]; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["f"]; });
 var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(1669);
 __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(1670);
 __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
 __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(1671);
 __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
 __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(1672);
 __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
 __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(1673);
 __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
 __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(1674);
 __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["g"]; });
 __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["h"]; });
 __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["g"]; });
 __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["h"]; });
 __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
 __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["d"]; });
 __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["k"]; });
 __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["l"]; });
 __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["m"]; });
 __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["n"]; });
 __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["i"]; });
 __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["j"]; });
 __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
 __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
 __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["e"]; });
 __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["f"]; });
 var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(1675);
 __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
 __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(1676);
 __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
 __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["b"]; });































 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

 __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["c"] = point;
 __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

 __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["c"] = point;
 __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

 __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


 }),

 (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1732),
    listCacheDelete = __webpack_require__(1733),
    listCacheGet = __webpack_require__(1734),
    listCacheHas = __webpack_require__(1735),
    listCacheSet = __webpack_require__(1736);


function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


 }),

 (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(576);


function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


 }),

 (function(module, exports, __webpack_require__) {

var root = __webpack_require__(71);


var Symbol = root.Symbol;

module.exports = Symbol;


 }),

 (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105);


var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


 }),

 (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1756);


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


 }),

 (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(322);


var INFINITY = 1 / 0;


function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


 }),

 (function(module, exports, __webpack_require__) {

"use strict";




var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = warning;

function warning(message) {
  
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    
  } catch (e) {}
  

}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(334);
 var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};


var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

 __webpack_exports__["a"] = (generatePath);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(107);
 var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
 var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(47);
 var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(154);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};



var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" ])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


 __webpack_exports__["a"] = (Route);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";
(function(process) {

var utils = __webpack_require__(48);
var normalizeHeaderName = __webpack_require__(665);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(346);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(346);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {  }
    }
    return data;
  }],

  
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, *}.call(exports, __webpack_require__(124)))

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";







 __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_CONTEXT; });



 __webpack_require__.d(__webpack_exports__, "f", function() { return SET_CONNECTION; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return SET_RECOMMENDATIONS; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CONNECTIONS_REQUESTED; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_REQUESTED_CONNECTION; });

 __webpack_require__.d(__webpack_exports__, "b", function() { return LOG_OUT; });

 __webpack_require__.d(__webpack_exports__, "d", function() { return NOTIFICATION_TO_ROOM; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATION; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return SET_HAS_PENDING_REQUESTS; });
var SET_USER_DATA='user/set-data';var SET_ACTUAL_STEP='actual-step/set-data';var SET_SUB_STEP='actual-step/set-sub-step';var SET_LOAD_NEXT='actual-step/set-load-next';var GO_HOME='actual-step/go-home';var SET_ACTUAL_STEP_VALUES='actual-step/set-values';var SET_ACTUAL_CONTEXT='actual-context/set-context';var RESET_CONTEXT='actual-context/reset-context';var RESET_ALL='actual-step/reset-all';var SET_STEPS_HISTORY='actual-step/set-steps-history';var SET_ACTUAL_STEP_HISTORY='actual-step/set-actual-step-history';var SET_CONNECTION='user-connection';var SET_RECOMMENDATIONS='set/user_recommendations';var SET_CONNECTIONS_REQUESTED='set/user_connections_requested';var ADD_REQUESTED_CONNECTION='add/user_requested_connection';var SET_NEXT_STEP='actual-step/set-next-step';var LOG_OUT='LOG_OUT';var SET_NEXT_CONTEXT='actual-context/set-next-context';var NOTIFICATION_TO_ROOM='notification to room';var NOTIFICATION='notification';var SET_HAS_PENDING_REQUESTS='set_has_pending_requests';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return CHAT_TYPE_THEME_TABLE; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return CHAT_TYPE_CALL_FOR_IMPACT; });
var CHAT_TYPE_THEME_TABLE=21224196;var CHAT_TYPE_CALL_FOR_IMPACT=21283824;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(153);
// Written in this round about way for babel-transform-imports


 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = chainPropTypes;
function chainPropTypes(propType1, propType2) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__getThemeProps__ = __webpack_require__(745);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getThemeProps__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__jssPreset__ = __webpack_require__(746);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__jssPreset__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__mergeClasses__ = __webpack_require__(760);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mergeClasses__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(63);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_3__createBreakpoints__ = __webpack_require__(389);
 var __WEBPACK_IMPORTED_MODULE_4__createMixins__ = __webpack_require__(770);
 var __WEBPACK_IMPORTED_MODULE_5__createPalette__ = __webpack_require__(771);
 var __WEBPACK_IMPORTED_MODULE_6__createTypography__ = __webpack_require__(780);
 var __WEBPACK_IMPORTED_MODULE_7__shadows__ = __webpack_require__(781);
 var __WEBPACK_IMPORTED_MODULE_8__shape__ = __webpack_require__(782);
 var __WEBPACK_IMPORTED_MODULE_9__createSpacing__ = __webpack_require__(783);
 var __WEBPACK_IMPORTED_MODULE_10__transitions__ = __webpack_require__(131);
 var __WEBPACK_IMPORTED_MODULE_11__zIndex__ = __webpack_require__(399);













function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = Object(__WEBPACK_IMPORTED_MODULE_5__createPalette__["a" ])(paletteInput);
  var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_3__createBreakpoints__["a" ])(breakpointsInput);
  var spacing = Object(__WEBPACK_IMPORTED_MODULE_9__createSpacing__["a" ])(spacingInput);
  var muiTheme = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" ])({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: Object(__WEBPACK_IMPORTED_MODULE_4__createMixins__["a" ])(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: __WEBPACK_IMPORTED_MODULE_7__shadows__["a" ],
    typography: Object(__WEBPACK_IMPORTED_MODULE_6__createTypography__["a" ])(palette, typographyInput),
    spacing: spacing,
    shape: __WEBPACK_IMPORTED_MODULE_8__shape__["a" ],
    transitions: __WEBPACK_IMPORTED_MODULE_10__transitions__["a" ],
    zIndex: __WEBPACK_IMPORTED_MODULE_11__zIndex__["a" ]
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" ])(acc, argument);
  }, muiTheme);

  if (false) {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

 __webpack_exports__["a"] = (createMuiTheme);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = handleBreakpoints;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(127);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__ = __webpack_require__(126);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4__merge__ = __webpack_require__(163);




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {
    if (!props.theme) {
      console.error('Material-UI: You are calling a style function without a theme value.');
    }
  }

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" ])(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return Object(__WEBPACK_IMPORTED_MODULE_4__merge__["a" ])(base, extended);
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    xs: PropTypes.object,
    sm: PropTypes.object,
    md: PropTypes.object,
    lg: PropTypes.object,
    xl: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" ])(styleFunction.filterProps));
  return newStyleFunction;
}

 var _unused_webpack_default_export = (breakpoints);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return getSpeedDatingMeetings; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return getSpeedDatingRecommendations; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return getSpeedDatingSelectedUsers; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return getSpeedDatingData; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return sendSpeedDatingUserFeedback; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return joinSpeedDatingRandom; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return deleteSpeedDatingRandom; });
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(364);
var getSpeedDatingMeetings=function getSpeedDatingMeetings(){return function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'speed-dating/pending'}).then(function(payload){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["c" ],payload:payload});});};};var getSpeedDatingRecommendations=function getSpeedDatingRecommendations(id){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'speed-dating/'+id+'/recommendations'});};var getSpeedDatingSelectedUsers=function getSpeedDatingSelectedUsers(id){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'speed-dating/'+id+'/selected'});};var getSpeedDatingData=function getSpeedDatingData(id){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'speed-dating/'+id});};var sendSpeedDatingUserFeedback=function sendSpeedDatingUserFeedback(id,userId,feedback){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'speed-dating/'+id+'/user/'+userId+'/feedback/'+feedback});};var joinSpeedDatingRandom=function joinSpeedDatingRandom(id){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'speed-dating/'+id+'/random'});};var deleteSpeedDatingRandom=function deleteSpeedDatingRandom(id){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('DELETE',{endPoint:'speed-dating/'+id+'/random'});};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ownerWindow;
 var __WEBPACK_IMPORTED_MODULE_0__ownerDocument__ = __webpack_require__(77);

function ownerWindow(node) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_0__ownerDocument__["a" ])(node);
  return doc.defaultView || window;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createChainedFunction;

function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (false) {
      if (typeof func !== 'function') {
        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 __webpack_require__.d(__webpack_exports__, "b", function() { return ENTERING; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ENTERED; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return EXITING; });
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(62);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(73);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(405);
 var __WEBPACK_IMPORTED_MODULE_6__utils_PropTypes__ = __webpack_require__(406);
 var __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__ = __webpack_require__(229);








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';


var Transition = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" ])(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || __WEBPACK_IMPORTED_MODULE_5__config__["a" ].disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || __WEBPACK_IMPORTED_MODULE_5__config__["a" ].disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" ])(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      
      // allows for nested Transitions
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" ].Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children), childProps))
    );
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Transition.contextType = __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" ];
Transition.propTypes =  false ? {
  
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : PropTypes.instanceOf(Element)
  }),

  
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  
  in: PropTypes.bool,

  
  mountOnEnter: PropTypes.bool,

  
  unmountOnExit: PropTypes.bool,

  
  appear: PropTypes.bool,

  
  enter: PropTypes.bool,

  
  exit: PropTypes.bool,

  
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  
  addEndListener: PropTypes.func,

  
  onEnter: PropTypes.func,

  
  onEntering: PropTypes.func,

  
  onEntered: PropTypes.func,

  
  onExit: PropTypes.func,

  
  onExiting: PropTypes.func,

  
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
 __webpack_exports__["d"] = (Transition);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return reflow; });
 __webpack_exports__["a"] = getTransitionProps;
var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Paper__ = __webpack_require__(833);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Paper__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ButtonBase__ = __webpack_require__(840);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ButtonBase__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = isMuiElement;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function isMuiElement(element, muiNames) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](element) && muiNames.indexOf(element.type.muiName) !== -1;
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.addEvent = addEvent;
exports.removeEvent = removeEvent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.offsetXYFromParent = offsetXYFromParent;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTranslation = getTranslation;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.addUserSelectStyles = addUserSelectStyles;
exports.removeUserSelectStyles = removeUserSelectStyles;
exports.addClassName = addClassName;
exports.removeClassName = removeClassName;

var _shims = __webpack_require__(170);

var _getPrefix = _interopRequireWildcard(__webpack_require__(844));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var matchesSelectorFunc = '';

function matchesSelector(el

, selector

)

{
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims.isFunction)(el[method]);
    });
  } // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable


  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable

  return el[matchesSelectorFunc](selector);
} // Works up the tree to the draggable itself attempting to match selector.


function matchesSelectorAndParentsTo(el

, selector

, baseNode

)

{
  var node = el;

  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el

, event

, handler

, inputOptions

)

{
  if (!el) return;

  var options = _objectSpread({
    capture: true
  }, inputOptions);

  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el

, event

, handler

, inputOptions

)

{
  if (!el) return;

  var options = _objectSpread({
    capture: true
  }, inputOptions);

  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node

)

{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims.int)(computedStyle.borderTopWidth);
  height += (0, _shims.int)(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node

)

{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims.int)(computedStyle.borderLeftWidth);
  width += (0, _shims.int)(computedStyle.borderRightWidth);
  return width;
}

function innerHeight(node

)

{
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims.int)(computedStyle.paddingTop);
  height -= (0, _shims.int)(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node

)

{
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims.int)(computedStyle.paddingLeft);
  width -= (0, _shims.int)(computedStyle.paddingRight);
  return width;
} // Get from offsetParent


function offsetXYFromParent(evt

, offsetParent

, scale

)

{
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x: x,
    y: y
  };
}

function createCSSTransform(controlPos

, positionOffset

, scale

)

{
  var translation = getTranslation(controlPos, positionOffset, 'px');

  var cssTransform = _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);

  cssTransform.transform = "".concat(cssTransform.transform, " scale(").concat(scale, ")");
  return cssTransform;
}

function createSVGTransform(controlPos

, positionOffset

)

{
  var translation = getTranslation(controlPos, positionOffset, '');
  return translation;
}

function getTranslation(_ref, positionOffset

, unitSuffix

)

{
  var x = _ref.x,
      y = _ref.y;
  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");

  if (positionOffset) {
    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }

  return translation;
}

function getTouch(e

, identifier

)

{
  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e

)

{
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
} // User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed


function addUserSelectStyles(doc

) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');

  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }

  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc

) {
  if (!doc) return;

  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE

    if (doc.selection) {
      // $FlowIgnore: IE
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      var selection = (doc.defaultView || window).getSelection();

      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {// probably IE
  }
}

function addClassName(el

, className

) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}

function removeClassName(el

, className

) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
  }
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(856);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createSvgIcon;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
 var __WEBPACK_IMPORTED_MODULE_2__SvgIcon__ = __webpack_require__(865);





function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SvgIcon__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      ref: ref
    }, props), path);
  };

  if (false) {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = __WEBPACK_IMPORTED_MODULE_2__SvgIcon__["a" ].muiName;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.memo( __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(Component));
}

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/speedDatingLogoGreen.5653f41d.svg";

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(86));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _constants = _interopRequireDefault(__webpack_require__(66));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _idgen = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      node = _ref.node,
      fab = _ref.fab,
      modal = _ref.modal,
      flat = _ref.flat,
      floating = _ref.floating,
      large = _ref.large,
      small = _ref.small,
      disabled = _ref.disabled,
      waves = _ref.waves,
      tooltip = _ref.tooltip,
      _ref$tooltipOptions = _ref.tooltipOptions,
      tooltipOptions = _ref$tooltipOptions === void 0 ? {} : _ref$tooltipOptions,
      icon = _ref.icon,
      props = _objectWithoutProperties(_ref, ["children", "className", "node", "fab", "modal", "flat", "floating", "large", "small", "disabled", "waves", "tooltip", "tooltipOptions", "icon"]);

  var _btn = (0, _react.useRef)(null);

  var _fab = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    if (tooltip) {
      var instance = M.Tooltip.init(_btn.current, tooltipOptions);
      return function () {
        instance && instance.destroy();
      };
    }
  }, [tooltip, tooltipOptions, children]);
  (0, _react.useEffect)(function () {
    if (fab) {
      var instance = M.FloatingActionButton.init(_fab.current, fab);
      return function () {
        instance && instance.destroy();
      };
    }
  }, [fab]);

  var renderFab = function renderFab(classes) {
    return _react.default.createElement("div", _extends({}, props, {
      ref: _fab.current,
      className: (0, _classnames.default)('fixed-action-btn', {
        toolbar: fab.toolbarEnabled
      })
    }), _react.default.createElement("a", {
      className: classes
    }, icon || _react.default.createElement(_Icon.default, null, "edit")), _react.default.createElement("ul", null, _react.Children.map(children, function (child) {
      return _react.default.createElement("li", {
        key: (0, _idgen.default)()
      }, child);
    })));
  };

  var C = node;
  var classes = {
    btn: true,
    disabled: disabled,
    'waves-effect': waves
  };

  if (_constants.default.WAVES.indexOf(waves) > -1) {
    classes['waves-' + waves] = true;
  }

  var styles = {
    flat: flat,
    floating: floating,
    large: large,
    small: small
  };

  _constants.default.STYLES.forEach(function (style) {
    if (styles[style]) {
      classes.btn = false;
      classes['btn-' + style] = true;
    }
  });

  if (modal) {
    classes['modal-' + modal] = true;
  }

  if (fab) {
    return renderFab((0, _classnames.default)(classes, className));
  } else {
    return _react.default.createElement(C, _extends({}, props, {
      disabled: disabled,
      className: (0, _classnames.default)(classes, className),
      ref: _btn,
      "data-tooltip": tooltip
    }), icon, children);
  }
};

Button.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,

  
  flat: _propTypes.default.bool,
  large: _propTypes.default.bool,
  small: _propTypes.default.bool,
  floating: _propTypes.default.bool,

  
  fab: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
    direction: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
    hoverEnabled: _propTypes.default.bool,
    toolbarEnabled: _propTypes.default.bool
  })]),

  
  icon: _propTypes.default.node,
  modal: _propTypes.default.oneOf(['close', 'confirm']),
  node: _propTypes.default.node,

  
  onClick: _propTypes.default.func,

  
  tooltip: _propTypes.default.string,

  
  tooltipOptions: _propTypes.default.shape({
    exitDelay: _propTypes.default.number,
    enterDelay: _propTypes.default.number,
    html: _propTypes.default.string,
    margin: _propTypes.default.number,
    inDuration: _propTypes.default.number,
    outDuration: _propTypes.default.number,
    transitionMovement: _propTypes.default.number,
    delay: _propTypes.default.number,
    position: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left'])
  }),
  waves: _propTypes.default.oneOf(['light', 'red', 'yellow', 'orange', 'purple', 'green', 'teal'])
};
Button.defaultProps = {
  node: 'button'
};
var _default = Button;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Row = function Row(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$node = _ref.node,
      Node = _ref$node === void 0 ? 'div' : _ref$node,
      props = _objectWithoutProperties(_ref, ["children", "className", "node"]);

  return _react.default.createElement(Node, _extends({
    className: (0, _classnames.default)('row', className)
  }, props), children);
};

Row.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  node: _propTypes.default.node
};
var _default = Row;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/grey_arrow_right.ee61dff6.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return HtmlTag; });
 var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(133);


var HtmlTag =  (function () {
    
    function HtmlTag(cfg) {
        if (cfg === void 0) { cfg = {}; }
        
        this.tagName = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.attrs = {}; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.innerHTML = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.whitespaceRegex = /\s+/; // default value just to get the above doc comment in the ES5 output and documentation generator
        this.tagName = cfg.tagName || '';
        this.attrs = cfg.attrs || {};
        this.innerHTML = cfg.innerHtml || cfg.innerHTML || ''; // accept either the camelCased form or the fully capitalized acronym as in the DOM
    }
    
    HtmlTag.prototype.setTagName = function (tagName) {
        this.tagName = tagName;
        return this;
    };
    
    HtmlTag.prototype.getTagName = function () {
        return this.tagName || '';
    };
    
    HtmlTag.prototype.setAttr = function (attrName, attrValue) {
        var tagAttrs = this.getAttrs();
        tagAttrs[attrName] = attrValue;
        return this;
    };
    
    HtmlTag.prototype.getAttr = function (attrName) {
        return this.getAttrs()[attrName];
    };
    
    HtmlTag.prototype.setAttrs = function (attrs) {
        Object.assign(this.getAttrs(), attrs);
        return this;
    };
    
    HtmlTag.prototype.getAttrs = function () {
        return this.attrs || (this.attrs = {});
    };
    
    HtmlTag.prototype.setClass = function (cssClass) {
        return this.setAttr('class', cssClass);
    };
    
    HtmlTag.prototype.addClass = function (cssClass) {
        var classAttr = this.getClass(), whitespaceRegex = this.whitespaceRegex, classes = (!classAttr) ? [] : classAttr.split(whitespaceRegex), newClasses = cssClass.split(whitespaceRegex), newClass;
        while (newClass = newClasses.shift()) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" ])(classes, newClass) === -1) {
                classes.push(newClass);
            }
        }
        this.getAttrs()['class'] = classes.join(" ");
        return this;
    };
    
    HtmlTag.prototype.removeClass = function (cssClass) {
        var classAttr = this.getClass(), whitespaceRegex = this.whitespaceRegex, classes = (!classAttr) ? [] : classAttr.split(whitespaceRegex), removeClasses = cssClass.split(whitespaceRegex), removeClass;
        while (classes.length && (removeClass = removeClasses.shift())) {
            var idx = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" ])(classes, removeClass);
            if (idx !== -1) {
                classes.splice(idx, 1);
            }
        }
        this.getAttrs()['class'] = classes.join(" ");
        return this;
    };
    
    HtmlTag.prototype.getClass = function () {
        return this.getAttrs()['class'] || "";
    };
    
    HtmlTag.prototype.hasClass = function (cssClass) {
        return (' ' + this.getClass() + ' ').indexOf(' ' + cssClass + ' ') !== -1;
    };
    
    HtmlTag.prototype.setInnerHTML = function (html) {
        this.innerHTML = html;
        return this;
    };
    
    HtmlTag.prototype.setInnerHtml = function (html) {
        return this.setInnerHTML(html);
    };
    
    HtmlTag.prototype.getInnerHTML = function () {
        return this.innerHTML || "";
    };
    
    HtmlTag.prototype.getInnerHtml = function () {
        return this.getInnerHTML();
    };
    
    HtmlTag.prototype.toAnchorString = function () {
        var tagName = this.getTagName(), attrsStr = this.buildAttrsStr();
        attrsStr = (attrsStr) ? ' ' + attrsStr : ''; // prepend a space if there are actually attributes
        return ['<', tagName, attrsStr, '>', this.getInnerHtml(), '</', tagName, '>'].join("");
    };
    
    HtmlTag.prototype.buildAttrsStr = function () {
        if (!this.attrs)
            return ""; // no `attrs` Object (map) has been set, return empty string
        var attrs = this.getAttrs(), attrsArr = [];
        for (var prop in attrs) {
            if (attrs.hasOwnProperty(prop)) {
                attrsArr.push(prop + '="' + attrs[prop] + '"');
            }
        }
        return attrsArr.join(" ");
    };
    return HtmlTag;
}());


//# sourceMappingURL=html-tag.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return EmailMatch; });
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__match__ = __webpack_require__(87);



var EmailMatch =  (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" ])(EmailMatch, _super);
    
    function EmailMatch(cfg) {
        var _this = _super.call(this, cfg) || this;
        
        _this.email = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        _this.email = cfg.email;
        return _this;
    }
    
    EmailMatch.prototype.getType = function () {
        return 'email';
    };
    
    EmailMatch.prototype.getEmail = function () {
        return this.email;
    };
    
    EmailMatch.prototype.getAnchorHref = function () {
        return 'mailto:' + this.email;
    };
    
    EmailMatch.prototype.getAnchorText = function () {
        return this.email;
    };
    return EmailMatch;
}(__WEBPACK_IMPORTED_MODULE_1__match__["a" ]));


//# sourceMappingURL=email-match.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return HashtagMatch; });
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__match__ = __webpack_require__(87);



var HashtagMatch =  (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" ])(HashtagMatch, _super);
    
    function HashtagMatch(cfg) {
        var _this = _super.call(this, cfg) || this;
        
        _this.serviceName = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.hashtag = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        _this.serviceName = cfg.serviceName;
        _this.hashtag = cfg.hashtag;
        return _this;
    }
    
    HashtagMatch.prototype.getType = function () {
        return 'hashtag';
    };
    
    HashtagMatch.prototype.getServiceName = function () {
        return this.serviceName;
    };
    
    HashtagMatch.prototype.getHashtag = function () {
        return this.hashtag;
    };
    
    HashtagMatch.prototype.getAnchorHref = function () {
        var serviceName = this.serviceName, hashtag = this.hashtag;
        switch (serviceName) {
            case 'twitter':
                return 'https://twitter.com/hashtag/' + hashtag;
            case 'facebook':
                return 'https://www.facebook.com/hashtag/' + hashtag;
            case 'instagram':
                return 'https://instagram.com/explore/tags/' + hashtag;
            default: // Shouldn't happen because Autolinker's constructor should block any invalid values, but just in case.
                throw new Error('Unknown service name to point hashtag to: ' + serviceName);
        }
    };
    
    HashtagMatch.prototype.getAnchorText = function () {
        return '#' + this.hashtag;
    };
    return HashtagMatch;
}(__WEBPACK_IMPORTED_MODULE_1__match__["a" ]));


//# sourceMappingURL=hashtag-match.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return MentionMatch; });
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__match__ = __webpack_require__(87);



var MentionMatch =  (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" ])(MentionMatch, _super);
    
    function MentionMatch(cfg) {
        var _this = _super.call(this, cfg) || this;
        
        _this.serviceName = 'twitter'; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.mention = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        _this.mention = cfg.mention;
        _this.serviceName = cfg.serviceName;
        return _this;
    }
    
    MentionMatch.prototype.getType = function () {
        return 'mention';
    };
    
    MentionMatch.prototype.getMention = function () {
        return this.mention;
    };
    
    MentionMatch.prototype.getServiceName = function () {
        return this.serviceName;
    };
    
    MentionMatch.prototype.getAnchorHref = function () {
        switch (this.serviceName) {
            case 'twitter':
                return 'https://twitter.com/' + this.mention;
            case 'instagram':
                return 'https://instagram.com/' + this.mention;
            case 'soundcloud':
                return 'https://soundcloud.com/' + this.mention;
            default: // Shouldn't happen because Autolinker's constructor should block any invalid values, but just in case.
                throw new Error('Unknown service name to point mention to: ' + this.serviceName);
        }
    };
    
    MentionMatch.prototype.getAnchorText = function () {
        return '@' + this.mention;
    };
    
    MentionMatch.prototype.getCssClassSuffixes = function () {
        var cssClassSuffixes = _super.prototype.getCssClassSuffixes.call(this), serviceName = this.getServiceName();
        if (serviceName) {
            cssClassSuffixes.push(serviceName);
        }
        return cssClassSuffixes;
    };
    return MentionMatch;
}(__WEBPACK_IMPORTED_MODULE_1__match__["a" ]));


//# sourceMappingURL=mention-match.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneMatch; });
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__match__ = __webpack_require__(87);



var PhoneMatch =  (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" ])(PhoneMatch, _super);
    
    function PhoneMatch(cfg) {
        var _this = _super.call(this, cfg) || this;
        
        _this.number = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.plusSign = false; // default value just to get the above doc comment in the ES5 output and documentation generator
        _this.number = cfg.number;
        _this.plusSign = cfg.plusSign;
        return _this;
    }
    
    PhoneMatch.prototype.getType = function () {
        return 'phone';
    };
    
    PhoneMatch.prototype.getPhoneNumber = function () {
        return this.number;
    };
    
    PhoneMatch.prototype.getNumber = function () {
        return this.getPhoneNumber();
    };
    
    PhoneMatch.prototype.getAnchorHref = function () {
        return 'tel:' + (this.plusSign ? '+' : '') + this.number;
    };
    
    PhoneMatch.prototype.getAnchorText = function () {
        return this.matchedText;
    };
    return PhoneMatch;
}(__WEBPACK_IMPORTED_MODULE_1__match__["a" ]));


//# sourceMappingURL=phone-match.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return UrlMatch; });
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__match__ = __webpack_require__(87);



var UrlMatch =  (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" ])(UrlMatch, _super);
    
    function UrlMatch(cfg) {
        var _this = _super.call(this, cfg) || this;
        
        _this.url = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.urlMatchType = 'scheme'; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.protocolUrlMatch = false; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.protocolRelativeMatch = false; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.stripPrefix = { scheme: true, www: true }; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.stripTrailingSlash = true; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.decodePercentEncoding = true; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.schemePrefixRegex = /^(https?:\/\/)?/i;
        
        _this.wwwPrefixRegex = /^(https?:\/\/)?(www\.)?/i;
        
        _this.protocolRelativeRegex = /^\/\//;
        
        _this.protocolPrepended = false;
        _this.urlMatchType = cfg.urlMatchType;
        _this.url = cfg.url;
        _this.protocolUrlMatch = cfg.protocolUrlMatch;
        _this.protocolRelativeMatch = cfg.protocolRelativeMatch;
        _this.stripPrefix = cfg.stripPrefix;
        _this.stripTrailingSlash = cfg.stripTrailingSlash;
        _this.decodePercentEncoding = cfg.decodePercentEncoding;
        return _this;
    }
    
    UrlMatch.prototype.getType = function () {
        return 'url';
    };
    
    UrlMatch.prototype.getUrlMatchType = function () {
        return this.urlMatchType;
    };
    
    UrlMatch.prototype.getUrl = function () {
        var url = this.url;
        // if the url string doesn't begin with a protocol, assume 'http://'
        if (!this.protocolRelativeMatch && !this.protocolUrlMatch && !this.protocolPrepended) {
            url = this.url = 'http://' + url;
            this.protocolPrepended = true;
        }
        return url;
    };
    
    UrlMatch.prototype.getAnchorHref = function () {
        var url = this.getUrl();
        return url.replace(/&amp;/g, '&'); // any &amp;'s in the URL should be converted back to '&' if they were displayed as &amp; in the source html
    };
    
    UrlMatch.prototype.getAnchorText = function () {
        var anchorText = this.getMatchedText();
        if (this.protocolRelativeMatch) {
            // Strip off any protocol-relative '//' from the anchor text
            anchorText = this.stripProtocolRelativePrefix(anchorText);
        }
        if (this.stripPrefix.scheme) {
            anchorText = this.stripSchemePrefix(anchorText);
        }
        if (this.stripPrefix.www) {
            anchorText = this.stripWwwPrefix(anchorText);
        }
        if (this.stripTrailingSlash) {
            anchorText = this.removeTrailingSlash(anchorText); // remove trailing slash, if there is one
        }
        if (this.decodePercentEncoding) {
            anchorText = this.removePercentEncoding(anchorText);
        }
        return anchorText;
    };
    // ---------------------------------------
    // Utility Functionality
    
    UrlMatch.prototype.stripSchemePrefix = function (url) {
        return url.replace(this.schemePrefixRegex, '');
    };
    
    UrlMatch.prototype.stripWwwPrefix = function (url) {
        return url.replace(this.wwwPrefixRegex, '$1'); // leave any scheme ($1), it one exists
    };
    
    UrlMatch.prototype.stripProtocolRelativePrefix = function (text) {
        return text.replace(this.protocolRelativeRegex, '');
    };
    
    UrlMatch.prototype.removeTrailingSlash = function (anchorText) {
        if (anchorText.charAt(anchorText.length - 1) === '/') {
            anchorText = anchorText.slice(0, -1);
        }
        return anchorText;
    };
    
    UrlMatch.prototype.removePercentEncoding = function (anchorText) {
        // First, convert a few of the known % encodings to the corresponding
        // HTML entities that could accidentally be interpretted as special
        // HTML characters
        var preProcessedEntityAnchorText = anchorText
            .replace(/%22/gi, '&quot;') // " char
            .replace(/%26/gi, '&amp;') // & char
            .replace(/%27/gi, '&#39;') // ' char
            .replace(/%3C/gi, '&lt;') // < char
            .replace(/%3E/gi, '&gt;'); // > char
        try {
            // Now attempt to decode the rest of the anchor text
            return decodeURIComponent(preProcessedEntityAnchorText);
        }
        catch (e) { // Invalid % escape sequence in the anchor text
            return preProcessedEntityAnchorText;
        }
    };
    return UrlMatch;
}(__WEBPACK_IMPORTED_MODULE_1__match__["a" ]));


//# sourceMappingURL=url-match.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 __webpack_require__.d(__webpack_exports__, "h", function() { return ChatWrapper; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return ChatHeader; });

 __webpack_require__.d(__webpack_exports__, "t", function() { return UserName; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return ChatMessages; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return ChatFormWrapper; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ChatForm; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return MessageInput; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return BtnSend; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return FileUpld; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return ChatContainer; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return Message; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return Leave; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return Join; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return DayTitleContainer; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return DayTitle; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AlertNewMessages; });


 __webpack_require__.d(__webpack_exports__, "k", function() { return FileInfo; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return ModalWrapper; });








 __webpack_require__.d(__webpack_exports__, "s", function() { return SenderName; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return ImagePreview; });




 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__ = __webpack_require__(68);
 var __WEBPACK_IMPORTED_MODULE_3_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_4_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: 30px;\n  vertical-align: middle;\n  align-items: center;\n  position: relative;\n  top: 5px;\n\n  i {\n    color: #666;\n    cursor: pointer;\n    font-size: 16px;\n    margin: 5px 5px 0px 0px;\n  }\n'],['\n  display: inline-block;\n  width: 30px;\n  vertical-align: middle;\n  align-items: center;\n  position: relative;\n  top: 5px;\n\n  i {\n    color: #666;\n    cursor: pointer;\n    font-size: 16px;\n    margin: 5px 5px 0px 0px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n\n  .info_icon {\n    float: right;\n    margin-top: 15px;\n    width: 25px;\n    height: 25px;\n    top: 10px;\n  }\n\n  i {\n    color: white;\n    font-size: 1.5rem;\n    position: absolute;\n    cursor: pointer;\n    right: 1rem;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n\n  .info_icon {\n    float: right;\n    margin-top: 15px;\n    width: 25px;\n    height: 25px;\n    top: 10px;\n  }\n\n  i {\n    color: white;\n    font-size: 1.5rem;\n    position: absolute;\n    cursor: pointer;\n    right: 1rem;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  height: 80%;\n  position: relative;\n  width: 100%;\n  display: inline-block;\n  float: right;\n\n  .chat_title {\n    background-color: ',';\n    color: #fff;\n    height: 6.4rem;\n    font-size: 1.6rem;\n    padding: 2.5rem 1rem 0;\n  }\n\n  @media (max-width: ','px) {\n    background: white;\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    z-index: 300;\n    height: 100%;\n  }\n'],['\n  height: 80%;\n  position: relative;\n  width: 100%;\n  display: inline-block;\n  float: right;\n\n  .chat_title {\n    background-color: ',';\n    color: #fff;\n    height: 6.4rem;\n    font-size: 1.6rem;\n    padding: 2.5rem 1rem 0;\n  }\n\n  @media (max-width: ','px) {\n    background: white;\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    z-index: 300;\n    height: 100%;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  padding: 5px 10px;\n  background-color: #2680EB;\n  width: 100%;\n  margin: 0 auto;\n  height: 6.4rem;\n  line-height: 50px;\n  display: flex;\n  align-items: center;\n\n  .hide {\n    width: 5rem;\n    text-align: center;\n    font-size: 1.5rem;\n\n    p {\n      color: white;\n      font-weight: 600;\n    }\n\n  }\n'],['\n  padding: 5px 10px;\n  background-color: #2680EB;\n  width: 100%;\n  margin: 0 auto;\n  height: 6.4rem;\n  line-height: 50px;\n  display: flex;\n  align-items: center;\n\n  .hide {\n    width: 5rem;\n    text-align: center;\n    font-size: 1.5rem;\n\n    p {\n      color: white;\n      font-weight: 600;\n    }\n\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n   && {\n    width: 32px;\n    height: 32px;\n    margin-right: 1.5rem;\n\n    &.text-avatar {\n      font-size: 21px;\n      padding-top: 0px;\n      line-height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n   }\n'],['\n   && {\n    width: 32px;\n    height: 32px;\n    margin-right: 1.5rem;\n\n    &.text-avatar {\n      font-size: 21px;\n      padding-top: 0px;\n      line-height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n   }\n']),_templateObject6=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 17px;\n  text-align: left;\n  width: calc(100% - 80px);\n  margin-left: 5px;\n\n  .chat_name {\n    color: white;\n    margin-left: 0.5rem;\n    font-size: 1.5rem;\n    font-weight: 600;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    width: 100%;\n    overflow: hidden;\n  }\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 17px;\n  text-align: left;\n  width: calc(100% - 80px);\n  margin-left: 5px;\n\n  .chat_name {\n    color: white;\n    margin-left: 0.5rem;\n    font-size: 1.5rem;\n    font-weight: 600;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    width: 100%;\n    overflow: hidden;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  .list_messages {\n    padding-top: 1rem;\n    height: 47.7vh;\n    overflow: auto;\n\n    .first_message {\n      margin: 1rem auto;\n      background-color: #FFF176;\n      border: 1px solid #FFEB3B;\n      color: ',';\n      width: 30rem;\n      padding: 1rem;\n      font-size: 1.3rem;\n      text-align: center;\n      border-radius: 3rem;\n      line-height: 1.6rem;\n    }\n  }\n'],['\n  .list_messages {\n    padding-top: 1rem;\n    height: 47.7vh;\n    overflow: auto;\n\n    .first_message {\n      margin: 1rem auto;\n      background-color: #FFF176;\n      border: 1px solid #FFEB3B;\n      color: ',';\n      width: 30rem;\n      padding: 1rem;\n      font-size: 1.3rem;\n      text-align: center;\n      border-radius: 3rem;\n      line-height: 1.6rem;\n    }\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  background-color: #fff;\n  box-shadow: 0px -2px 6px 1px rgb(0 0 0 / 20%);\n  height: calc(4rem + env(safe-area-inset-bottom));\n  padding-bottom: env(safe-area-inset-bottom);\n  width: 100%;\n  display: flex;\n  align-items: center;\n'],['\n  background-color: #fff;\n  box-shadow: 0px -2px 6px 1px rgb(0 0 0 / 20%);\n  height: calc(4rem + env(safe-area-inset-bottom));\n  padding-bottom: env(safe-area-inset-bottom);\n  width: 100%;\n  display: flex;\n  align-items: center;\n']),_templateObject9=_taggedTemplateLiteral(['\n  background-color: #fff;\n  padding: 5px;\n  margin: 0 auto;\n  height: 75%;\n  //box-shadow: 0px 2px 6px 3px #eee;\n  box-shadow: 2px 2px 5px #999;\n  border-radius: 10px;\n  width: 85%;\n  display: flex;\n  align-items: center;\n  margin-left: 1rem;\n'],['\n  background-color: #fff;\n  padding: 5px;\n  margin: 0 auto;\n  height: 75%;\n  //box-shadow: 0px 2px 6px 3px #eee;\n  box-shadow: 2px 2px 5px #999;\n  border-radius: 10px;\n  width: 85%;\n  display: flex;\n  align-items: center;\n  margin-left: 1rem;\n']),_templateObject10=_taggedTemplateLiteral(['\n  width: 100%;\n  outline: none;\n  font-size: 1.1rem;\n  padding: 0.5rem;\n\n  &:focus {\n    outline: none !important;\n  }\n  > div {\n    width: 100%;\n  }\n  > div::before {\n    border-bottom: 0px !important;\n  }\n  > div::after {\n    border-bottom: 0px !important;\n  }\n'],['\n  width: 100%;\n  outline: none;\n  font-size: 1.1rem;\n  padding: 0.5rem;\n\n  &:focus {\n    outline: none !important;\n  }\n  > div {\n    width: 100%;\n  }\n  > div::before {\n    border-bottom: 0px !important;\n  }\n  > div::after {\n    border-bottom: 0px !important;\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  width: 15%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  width: 15%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),_templateObject12=_taggedTemplateLiteral(['\n  width: 15%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  input {\n    display: none;\n  }\n\n  img {\n    font-size: 1.2rem;\n  }\n'],['\n  width: 15%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  input {\n    display: none;\n  }\n\n  img {\n    font-size: 1.2rem;\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  margin: 0 auto;\n  height: calc(70vh - ',' - env(safe-area-inset-top));\n'],['\n  margin: 0 auto;\n  height: calc(70vh - ',' - env(safe-area-inset-top));\n']),_templateObject14=_taggedTemplateLiteral(['\n  min-height: 4rem;\n  width: ',';\n  margin-left: ',';\n  margin-right: ',';\n  margin-top: 10px;\n  margin-bottom: 20px;\n  border-radius: 10px;\n  background-color: ',';\n\n  padding: 10px;\n  box-shadow: 0px 2px 6px 3px #ccc;\n  z-index: 100000;\n\n  .text {\n    color: #575757;\n    font-size: 1.5rem;\n    display: inline-block;\n    vertical-align: bottom;\n    width: calc(100% - 40px);\n    word-break: break-word;\n    line-height: 1.8rem;\n    min-height: 3.5rem;\n  }\n\n  .link {\n    color: ',';\n    font-size: 14px;\n    display: inline-block;\n    vertical-align: bottom;\n    word-break: break-word;\n    text-decoration: underline;\n    cursor: pointer;\n    line-height: 1.8rem;\n  }\n  .hour {\n    color: #666;\n    font-size: 9px;\n    display: inline-block;\n    vertical-align: bottom;\n    width: 40px;\n    text-align: right;\n  }\n'],['\n  min-height: 4rem;\n  width: ',';\n  margin-left: ',';\n  margin-right: ',';\n  margin-top: 10px;\n  margin-bottom: 20px;\n  border-radius: 10px;\n  background-color: ',';\n\n  padding: 10px;\n  box-shadow: 0px 2px 6px 3px #ccc;\n  z-index: 100000;\n\n  .text {\n    color: #575757;\n    font-size: 1.5rem;\n    display: inline-block;\n    vertical-align: bottom;\n    width: calc(100% - 40px);\n    word-break: break-word;\n    line-height: 1.8rem;\n    min-height: 3.5rem;\n  }\n\n  .link {\n    color: ',';\n    font-size: 14px;\n    display: inline-block;\n    vertical-align: bottom;\n    word-break: break-word;\n    text-decoration: underline;\n    cursor: pointer;\n    line-height: 1.8rem;\n  }\n  .hour {\n    color: #666;\n    font-size: 9px;\n    display: inline-block;\n    vertical-align: bottom;\n    width: 40px;\n    text-align: right;\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  background-color: #FFAB91;\n  border-radius: 1rem;\n  display: block;\n  padding: 0.5rem;\n  font-size: 1.3rem;\n  width: 30rem;\n  text-align: center;\n  margin: 0 auto;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  margin-bottom: 2rem;\n'],['\n  background-color: #FFAB91;\n  border-radius: 1rem;\n  display: block;\n  padding: 0.5rem;\n  font-size: 1.3rem;\n  width: 30rem;\n  text-align: center;\n  margin: 0 auto;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  margin-bottom: 2rem;\n']),_templateObject16=_taggedTemplateLiteral(['\n  background-color: #CCFF90;\n  border-radius: 1rem;\n  display: block;\n  padding: 0.5rem;\n  font-size: 1.3rem;\n  width: 30rem;\n  text-align: center;\n  margin: 0 auto;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  margin-bottom: 2rem;\n'],['\n  background-color: #CCFF90;\n  border-radius: 1rem;\n  display: block;\n  padding: 0.5rem;\n  font-size: 1.3rem;\n  width: 30rem;\n  text-align: center;\n  margin: 0 auto;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  margin-bottom: 2rem;\n']),_templateObject17=_taggedTemplateLiteral(['\n'],['\n']),_templateObject18=_taggedTemplateLiteral(['\n  text-align: center;\n  font-family: ',';\n  justify-content: center;\n  color: #fff;\n  background-color: ',';\n  opacity: 1;\n  width: 215px;\n  height: 24px;\n  font-size: 1.1rem;\n  border-radius: 16px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 5px;\n'],['\n  text-align: center;\n  font-family: ',';\n  justify-content: center;\n  color: #fff;\n  background-color: ',';\n  opacity: 1;\n  width: 215px;\n  height: 24px;\n  font-size: 1.1rem;\n  border-radius: 16px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 5px;\n']),_templateObject19=_taggedTemplateLiteral(['\n  position: absolute;\n  cursor: pointer;\n  color: ',';\n  background-color: #fff;\n  padding: 5px 10px;\n  width: auto;\n  bottom: 80px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  font-size: 16px;\n  border-radius: 3px;\n  font-weight: 600;\n  box-shadow: 0px 2px 3px 1px ',';\n  border: 1px solid ',';\n'],['\n  position: absolute;\n  cursor: pointer;\n  color: ',';\n  background-color: #fff;\n  padding: 5px 10px;\n  width: auto;\n  bottom: 80px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  font-size: 16px;\n  border-radius: 3px;\n  font-weight: 600;\n  box-shadow: 0px 2px 3px 1px ',';\n  border: 1px solid ',';\n']),_templateObject20=_taggedTemplateLiteral(['\n  position: absolute;\n  background-color: #FF5722;\n  border-radius: 30px;\n  bottom: 20px;\n  width: 70%;\n  z-index: 10;\n  max-width: 1200px;\n  height: 50px;\n  padding: 5px;\n  box-shadow: 0px 2px 6px 3px #FF6E40;\n  color: #fff;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n'],['\n  position: absolute;\n  background-color: #FF5722;\n  border-radius: 30px;\n  bottom: 20px;\n  width: 70%;\n  z-index: 10;\n  max-width: 1200px;\n  height: 50px;\n  padding: 5px;\n  box-shadow: 0px 2px 6px 3px #FF6E40;\n  color: #fff;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n']),_templateObject21=_taggedTemplateLiteral(['\n  position: fixed;\n  background-color: #ff0000;\n  color: #fff;\n  font-size: 13px;\n  top: 110px;\n  width: 80vw;\n  left: 10vw;\n  height: 27px;\n  padding: 5px;\n  border-radius: 20px;\n  text-align: center;\n  font-weight: 600;\n  @media (min-width: ','px) {\n    top: 24vh;\n    width: 70vw;\n    left: 26vw;\n  }\n'],['\n  position: fixed;\n  background-color: #ff0000;\n  color: #fff;\n  font-size: 13px;\n  top: 110px;\n  width: 80vw;\n  left: 10vw;\n  height: 27px;\n  padding: 5px;\n  border-radius: 20px;\n  text-align: center;\n  font-weight: 600;\n  @media (min-width: ','px) {\n    top: 24vh;\n    width: 70vw;\n    left: 26vw;\n  }\n']),_templateObject22=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: baseline;\n  position: relative;\n  .link {\n    color: ',';\n    font-size: 14px;\n    display: inline-block;\n    vertical-align: bottom;\n    width: calc(100% - 40px);\n    word-break: break-word;\n    text-decoration: underline;\n  }\n  .hour {\n    color: #666;\n    font-size: 9px;\n    display: inline-block;\n    vertical-align: bottom;\n    width: 40px;\n    text-align: right;\n    position: absolute;\n    bottom: 0px;\n    right: 0px;\n  }\n  i {\n    color: ',';\n    font-size: 14px;\n    display: inline-block;\n    vertical-align: left;\n  }\n\n'],['\n  display: flex;\n  align-items: baseline;\n  position: relative;\n  .link {\n    color: ',';\n    font-size: 14px;\n    display: inline-block;\n    vertical-align: bottom;\n    width: calc(100% - 40px);\n    word-break: break-word;\n    text-decoration: underline;\n  }\n  .hour {\n    color: #666;\n    font-size: 9px;\n    display: inline-block;\n    vertical-align: bottom;\n    width: 40px;\n    text-align: right;\n    position: absolute;\n    bottom: 0px;\n    right: 0px;\n  }\n  i {\n    color: ',';\n    font-size: 14px;\n    display: inline-block;\n    vertical-align: left;\n  }\n\n']),_templateObject23=_taggedTemplateLiteral(['\n  top: 30%;\n  left: 50%;\n  width: 90%;\n  max-height: 90%;\n  bottom: auto;\n  position: absolute;\n  text-align: center;\n  margin: 0 auto;\n  transform: translateX(-50%);\n\n  &.file {\n    top: 15%;\n  }\n\n  iframe {\n    height: 60vh;\n    background-color: #fff;\n  }\n'],['\n  top: 30%;\n  left: 50%;\n  width: 90%;\n  max-height: 90%;\n  bottom: auto;\n  position: absolute;\n  text-align: center;\n  margin: 0 auto;\n  transform: translateX(-50%);\n\n  &.file {\n    top: 15%;\n  }\n\n  iframe {\n    height: 60vh;\n    background-color: #fff;\n  }\n']),_templateObject24=_taggedTemplateLiteral(['\n  width: 40px;\n  height: 40px;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  line-height: 46px;\n  cursor: pointer;\n\n  i {\n    font-size: 14px;\n    color: #888;\n  }\n'],['\n  width: 40px;\n  height: 40px;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  line-height: 46px;\n  cursor: pointer;\n\n  i {\n    font-size: 14px;\n    color: #888;\n  }\n']),_templateObject25=_taggedTemplateLiteral(['\n  width: 40px;\n  height: 40px;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  line-height: 46px;\n\n  i {\n    font-size: 14px;\n    color: #888;\n  }\n'],['\n  width: 40px;\n  height: 40px;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  line-height: 46px;\n\n  i {\n    font-size: 14px;\n    color: #888;\n  }\n']),_templateObject26=_taggedTemplateLiteral(['\n  display: block !important;\n  flex-direction: unset !important;\n  min-height: 100%;\n  position: absolute;\n  width: 100%;\n  background-color: #f5f5f5;\n  padding-bottom: 20px;\n\n  .users-list {\n    margin-bottom: 30px;\n  }\n\n\n  .contribution {\n    font-size: 12px;\n    color: #444;\n    display: inline-block;\n    background-color: #eee;\n    color: #666;\n    border: 1px solid #ccc;\n    margin-left: 5px;\n    margin-bottom: 5px;\n    padding: 2px 5px;\n    border-radius: 5px;\n  }\n\n  .your_leader {\n    font-weight: 600;\n    font-size: 12px;\n    color: #43A047;\n  }\n\n  .deleteButton {\n    position: absolute;\n    width: 50%;\n    text-align: center;\n    left: 25%;\n    bottom: 2%;\n  }\n'],['\n  display: block !important;\n  flex-direction: unset !important;\n  min-height: 100%;\n  position: absolute;\n  width: 100%;\n  background-color: #f5f5f5;\n  padding-bottom: 20px;\n\n  .users-list {\n    margin-bottom: 30px;\n  }\n\n\n  .contribution {\n    font-size: 12px;\n    color: #444;\n    display: inline-block;\n    background-color: #eee;\n    color: #666;\n    border: 1px solid #ccc;\n    margin-left: 5px;\n    margin-bottom: 5px;\n    padding: 2px 5px;\n    border-radius: 5px;\n  }\n\n  .your_leader {\n    font-weight: 600;\n    font-size: 12px;\n    color: #43A047;\n  }\n\n  .deleteButton {\n    position: absolute;\n    width: 50%;\n    text-align: center;\n    left: 25%;\n    bottom: 2%;\n  }\n']),_templateObject27=_taggedTemplateLiteral(['\n    display: block;\n    position: relative;\n    background-color: ',';\n    width: 100%;\n    margin: 0 auto;\n    height: 100px;\n    line-height: 50px;\n    border-bottom: 1px solid #eee;\n    background-image: url(',');\n    background-repeat: no-repeat, repeat;\n    background-position: center;\n    background-size: cover;\n\n    .edit_image_layer {\n      position: absolute;\n      right: 10px;\n      top: 0px;\n      z-index: 2;\n\n      i {\n        color: #fff;\n        cursor: pointer;\n        font-size: 16px;\n        margin-left: 10px;\n      }\n    }\n'],['\n    display: block;\n    position: relative;\n    background-color: ',';\n    width: 100%;\n    margin: 0 auto;\n    height: 100px;\n    line-height: 50px;\n    border-bottom: 1px solid #eee;\n    background-image: url(',');\n    background-repeat: no-repeat, repeat;\n    background-position: center;\n    background-size: cover;\n\n    .edit_image_layer {\n      position: absolute;\n      right: 10px;\n      top: 0px;\n      z-index: 2;\n\n      i {\n        color: #fff;\n        cursor: pointer;\n        font-size: 16px;\n        margin-left: 10px;\n      }\n    }\n']),_templateObject28=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  vertical-align: bottom;\n  margin-left: 5%;\n  margin-right: 25%;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  position: relative;\n  z-index: 2;\n  height: 50%;\n  overflow: hidden;\n'],['\n  display: flex;\n  flex-direction: column;\n  vertical-align: bottom;\n  margin-left: 5%;\n  margin-right: 25%;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  position: relative;\n  z-index: 2;\n  height: 50%;\n  overflow: hidden;\n']),_templateObject29=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: 50px;\n  vertical-align: middle;\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  i {\n    color: #fff;\n    cursor: pointer;\n    font-size: 16px;\n    margin-left: 10px;\n  }\n'],['\n  display: inline-block;\n  width: 50px;\n  vertical-align: middle;\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  i {\n    color: #fff;\n    cursor: pointer;\n    font-size: 16px;\n    margin-left: 10px;\n  }\n']),_templateObject30=_taggedTemplateLiteral(['\n  display: inline-block;\n  margin-left: 5%;\n  margin-right: 25%;\n  color: #444;\n  font-size: 14px;\n  font-weight: 600;\n'],['\n  display: inline-block;\n  margin-left: 5%;\n  margin-right: 25%;\n  color: #444;\n  font-size: 14px;\n  font-weight: 600;\n']),_templateObject31=_taggedTemplateLiteral(['\n  height: 100%;\n  display: inline-block;\n  vertical-align: middle;\n  color: #fff;\n  font-size: 25px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n'],['\n  height: 100%;\n  display: inline-block;\n  vertical-align: middle;\n  color: #fff;\n  font-size: 25px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n']),_templateObject32=_taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  color: #000;\n  font-size: 15px;\n  ',';\n  text-align: ',';\n  width: calc(100% - 2rem);\n'],['\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  color: #000;\n  font-size: 15px;\n  ',';\n  text-align: ',';\n  width: calc(100% - 2rem);\n']),_templateObject33=_taggedTemplateLiteral(['\n  max-width: 150px;\n  max-height: 150px;\n'],['\n  max-width: 150px;\n  max-height: 150px;\n']),_templateObject34=_taggedTemplateLiteral(['\n  display: flex;\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n  height: 40px;\n  background-color: #fff;\n  padding-left: 10px;\n  padding-right: 10px;\n'],['\n  display: flex;\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n  height: 40px;\n  background-color: #fff;\n  padding-left: 10px;\n  padding-right: 10px;\n']),_templateObject35=_taggedTemplateLiteral(['\n  font-weight: 1000;\n  font-size: 21px;\n  margin-top: 5px;\n  display: flex;\n  background-color: #fff;\n  color: #000;\n  width: 50%;\n'],['\n  font-weight: 1000;\n  font-size: 21px;\n  margin-top: 5px;\n  display: flex;\n  background-color: #fff;\n  color: #000;\n  width: 50%;\n']),_templateObject36=_taggedTemplateLiteral(['\n  line-height: 26px;\n  color: red;\n  font-size: 13px;\n  font-weight: 600;\n'],['\n  line-height: 26px;\n  color: red;\n  font-size: 13px;\n  font-weight: 600;\n']),_templateObject37=_taggedTemplateLiteral(['\n  float: right;\n  width: 21px;\n  height: 21px;\n  margin: 4px;\n\n  img {\n    padding-top: 15px;\n  }\n'],['\n  float: right;\n  width: 21px;\n  height: 21px;\n  margin: 4px;\n\n  img {\n    padding-top: 15px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BackArrow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var UserTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var ChatWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__["b" ]);var ChatHeader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var UserAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject5);var UserName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var ChatMessages=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ]);var ChatFormWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);var ChatForm=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);var MessageInput=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__["default"])(_templateObject10);var BtnSend=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11);var FileUpld=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12);var ChatContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13,function(props){return props.showLaunchBar?'0px':'5px';});var Message=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject14,function(props){return props.isActualUser?'min(90%, calc(100% - 3rem))':'min(83%, calc(100% - 5rem))';},function(props){return props.isActualUser?'auto':'4.5rem';},function(props){return props.isActualUser?'2rem':'auto';},function(props){return props.messageColor;},function(props){return props.color;});var Leave=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject15);var Join=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16);var DayTitleContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17);var DayTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18,__WEBPACK_IMPORTED_MODULE_4_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["g" ]);var AlertNewMessages=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject19,function(props){return props.color;},function(props){return props.color;},function(props){return props.color;});var ChatClosed=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject20);var TimeLeft=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject21,__WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__["b" ]);var FileInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject22,function(props){return props.color;},function(props){return props.color;});var ModalWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject23);var BtnAddUsers=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject24);var BtnUpgrade=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject25);var UsersWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject26);var UsersHeader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject27,function(props){return props.color;},function(props){return props.img;});var UsersInChatTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject28);var BackArrowUsers=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject29);var ChatDescription=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject30);var ChatName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject31);var SenderName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject32,function(props){return props.isActualUser?'right: 0rem':'left: 2rem';},function(props){return props.isActualUser?'right':'left';});var ImagePreview=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].img(_templateObject33);var LaunchThinkTank=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject34);var TimeLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject35);var Closed=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject36);var SearchIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject37);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = useFormControl;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);



var FormControlContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  FormControlContext.displayName = 'FormControlContext';
}

function useFormControl() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](FormControlContext);
}
 __webpack_exports__["a"] = (FormControlContext);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_exports__["b"] = isFilled;
 __webpack_exports__["a"] = isAdornedStart;
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(977);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = useControlled;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (false) {
    React.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);

    var _React$useRef2 = React.useRef(defaultProp),
        defaultValue = _React$useRef2.current;

    React.useEffect(function () {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  var setValueIfUncontrolled = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__CircularProgress__ = __webpack_require__(981);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CircularProgress__["a"]; });


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var _reactFormValidatorCore = __webpack_require__(254);

var _SelectValidator = __webpack_require__(1025);

var _SelectValidator2 = _interopRequireDefault(_SelectValidator);

var _TextValidator = __webpack_require__(1026);

var _TextValidator2 = _interopRequireDefault(_TextValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SelectValidator = _SelectValidator2.default;
exports.TextValidator = _TextValidator2.default;
exports.ValidatorComponent = _reactFormValidatorCore.ValidatorComponent;
exports.ValidatorForm = _reactFormValidatorCore.ValidatorForm;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var _ValidatorComponent = __webpack_require__(1015);

var _ValidatorComponent2 = _interopRequireDefault(_ValidatorComponent);

var _ValidatorForm = __webpack_require__(441);

var _ValidatorForm2 = _interopRequireDefault(_ValidatorForm);

var _ValidationRules = __webpack_require__(442);

var _ValidationRules2 = _interopRequireDefault(_ValidationRules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ValidatorComponent = _ValidatorComponent2.default;
exports.ValidatorForm = _ValidatorForm2.default;
exports.ValidationRules = _ValidationRules2.default;

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/linkedin.9ac83877.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Dialog__ = __webpack_require__(1043);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dialog__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__DialogContentText__ = __webpack_require__(1047);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogContentText__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Typography__ = __webpack_require__(1048);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Typography__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__DialogTitle__ = __webpack_require__(1049);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogTitle__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return acceptCodeOfHonor; });
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
var acceptCodeOfHonor=function acceptCodeOfHonor(params){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'elements/connection'},params);};

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paperbin.d6df09c6.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1146);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return NetworkingHallSection; });


 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_3_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_icons_search_svg__ = __webpack_require__(422);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_icons_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_icons_search_svg__);
var _templateObject=_taggedTemplateLiteral(['\n  width: clamp(20vw, 40rem, 100vw);\n  height: clamp(20vw, 40rem, 100vw);\n  margin: 0 auto;\n  border-radius: 50%;\n  overflow: hidden;\n'],['\n  width: clamp(20vw, 40rem, 100vw);\n  height: clamp(20vw, 40rem, 100vw);\n  margin: 0 auto;\n  border-radius: 50%;\n  overflow: hidden;\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin-bottom: 2rem;\n\n  @media (max-width: ','px) {\n    margin-bottom: 10rem;\n  }\n\n  .no_elements {\n    > div {\n      color: #777;\n    }\n  }\n\n  .search_bar {\n    white-space: nowrap;\n    overflow-x: auto;\n    padding: 0.5rem 1rem 0;\n    box-shadow: inset 0px 3px 6px -2px rgb(0 0 0 / 16%), 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    z-index: 9;\n    background-color: #fff;\n    z-index: 9;\n    position: relative;\n\n    >.form_question_input {\n      width: auto;\n\n      input {\n        background-image: url(',');\n        background-repeat: no-repeat;\n        background-position: 1rem center;\n        width: 15rem;\n        padding-left: 4rem;\n        margin-right: 1rem;\n\n        @media (max-width: ','px) {\n          width: 4rem;\n        }\n\n        &:focus,\n        &:active {\n          width: 15rem;\n        }\n      }\n    }\n\n    > div {\n      margin-top: 0.5rem;\n    }\n\n    input {\n      max-width: 90%;\n      font-size: 1.3rem;\n    }\n\n    button {\n      font-size: 1.3rem;\n      height: 3.4rem;\n    }\n\n    .btn_filters {\n      &.selected {\n        background-color: #fff;\n        color: ',';\n\n        i {\n          color: ',';\n        }\n      }\n    }\n\n    .AutocompleteInput_wrapper {\n      display: inline-block;\n    }\n    .AutocompleteInput_select > div:first-child {\n      background-image: url(',');\n      background-repeat: no-repeat;\n      background-position: 1rem center;\n      width: 15rem;\n      padding-left: 4rem;\n      margin-right: 1rem;\n      border-radius: 2rem !important;\n    }\n\n    @media (max-width: ','px) {\n      .AutocompleteInput_select > div:first-child {\n        height: 3rem;\n        min-height: 3rem;\n\n        * {\n          font-size: 1.1rem;\n        }\n      }\n      button {\n        font-size: 1.1rem;\n        height: 2.8rem;\n        padding: 0 1rem;\n        vertical-align: middle;\n\n        i {\n          vertical-align: middle;\n          font-size: 1.5rem;\n        }\n      }\n    }\n  }\n\n  .filters_tags {\n    padding: 1rem 0;\n    display: inline-block;\n    vertical-align: middle;\n\n    .tag_filter {\n      display: inline-block;\n      color: #767676;\n      font-size: 1.2rem;\n      border: 0.1rem solid #bfbfbf;\n      border-radius: 2rem;\n      padding: 1rem;\n      margin-right: 1rem;\n      cursor: pointer;\n\n      &.selected {\n        color: #fff;\n        background-color: ',';\n        border-color: ',';\n      }\n    }\n  }\n\n  .content {\n    display: grid;\n    grid-template-columns: 43% calc(57% - 4rem);\n    grid-gap: 2rem;\n    position: relative;\n\n    .gravity_bubbles_wrapper {\n      .gravity_bubbles {\n        width: 100%;\n        height: 100%;\n\n        @media (min-width: ','px) {\n          min-height: 60rem;\n        }\n      }\n    }\n\n    .lists {\n      @media (min-width: ','px) {\n        box-shadow: 0px 3px 0px 6px #f9f9f9,-3px 3px 6px 1px rgb(0 0 0 / 16%);\n        padding-top: 3rem !important;\n      }\n      .list {\n        clear: both;\n        margin-bottom: 2rem;\n        .header {\n          display: grid;\n          grid-template-columns: auto 50px;\n          grid-gap: 2rem;\n\n          .title {\n            color: ',';\n            font-size: 1.5rem;\n            font-family: ',';\n            margin-bottom: 1rem;\n          }\n\n          .icon_expand {\n            justify-self: end;\n            img {\n              cursor: pointer;\n              height: 20px;\n            }\n          }\n        }\n\n        .faces_wrapper {\n          white-space: nowrap;\n          overflow: auto;\n          text-align: left;\n\n          .face_bubble {\n            width: calc(100% / 6) !important;\n            margin: 0;\n            min-width: 10rem;\n          }\n\n          .face_bubble_text {\n            color: rgba(0, 0, 0, 0.54);\n            font-size: 1rem;\n            white-space: normal;\n          }\n        }\n\n        .in_table {\n          .faces_wrapper {\n            white-space: normal;\n          }\n        }\n      }\n    }\n\n    &.fullscreen {\n      display: block;\n\n      .lists {\n        position: absolute;\n        top: 0rem;\n        right: 0;\n        width: 50%;\n        z-index: 8;\n        background-color: #f9f9f9;\n        padding: 1rem 1rem 0;\n        height: calc(100% - 6rem);\n        overflow: auto;\n      }\n    }\n  }\n\n  .theme_tables_wrapper {\n    overflow: hidden;\n    height: calc(100vh - 19rem);\n\n    &.with_header {\n      height: calc(100vh - 39rem);\n    }\n\n    @media (max-width: ','px) {\n      height: calc(100vw - 2rem);\n    }\n  }\n\n  @media (max-width: ','px) {\n    .filters_tags {\n      padding: 0 1rem;\n    }\n\n    .content {\n      grid-template-columns: 1fr;\n      display: block;\n\n      .gravity_bubbles_wrapper {\n        width: calc(100% - 2rem);\n        height: calc(100vw + 2rem);\n        margin: 1rem auto;\n        background-color: rgba(255, 255, 255, 0.1);\n      }\n      .lists {\n        .list {\n          margin-left: 1rem;\n          margin-right: 1rem;\n          .faces_wrapper {\n            grid-template-columns: repeat(3, 1fr) !important;\n\n            .face_bubble {\n              width: calc(100% / 3) !important;\n            }\n          }\n        }\n      }\n\n      &.fullscreen {\n        display: block;\n\n        .lists {\n          position: relative;\n          width: 100%;\n          z-index: 10;\n          background-color: transparent;\n          padding: 1rem 1rem 0;\n          height: auto;\n          overflow: auto;\n        }\n      }\n    }\n  }\n\n  &.elements_hall {\n    @media (max-width: ','px) {\n      .content {\n        .gravity_bubbles_wrapper {\n          width: calc(100% - 2rem);\n          height: calc(100vh - 27rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n          margin: 1rem auto;\n          background-color: rgba(255, 255, 255, 0.1);\n\n          .theme_tables_wrapper {\n            height: calc(100vh - 27rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n          }\n        }\n    }\n  }\n\n  .user_card {\n    display: flex;\n    align-items: center;\n    overflow: auto;\n  }\n'],['\n  margin-bottom: 2rem;\n\n  @media (max-width: ','px) {\n    margin-bottom: 10rem;\n  }\n\n  .no_elements {\n    > div {\n      color: #777;\n    }\n  }\n\n  .search_bar {\n    white-space: nowrap;\n    overflow-x: auto;\n    padding: 0.5rem 1rem 0;\n    box-shadow: inset 0px 3px 6px -2px rgb(0 0 0 / 16%), 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    z-index: 9;\n    background-color: #fff;\n    z-index: 9;\n    position: relative;\n\n    >.form_question_input {\n      width: auto;\n\n      input {\n        background-image: url(',');\n        background-repeat: no-repeat;\n        background-position: 1rem center;\n        width: 15rem;\n        padding-left: 4rem;\n        margin-right: 1rem;\n\n        @media (max-width: ','px) {\n          width: 4rem;\n        }\n\n        &:focus,\n        &:active {\n          width: 15rem;\n        }\n      }\n    }\n\n    > div {\n      margin-top: 0.5rem;\n    }\n\n    input {\n      max-width: 90%;\n      font-size: 1.3rem;\n    }\n\n    button {\n      font-size: 1.3rem;\n      height: 3.4rem;\n    }\n\n    .btn_filters {\n      &.selected {\n        background-color: #fff;\n        color: ',';\n\n        i {\n          color: ',';\n        }\n      }\n    }\n\n    .AutocompleteInput_wrapper {\n      display: inline-block;\n    }\n    .AutocompleteInput_select > div:first-child {\n      background-image: url(',');\n      background-repeat: no-repeat;\n      background-position: 1rem center;\n      width: 15rem;\n      padding-left: 4rem;\n      margin-right: 1rem;\n      border-radius: 2rem !important;\n    }\n\n    @media (max-width: ','px) {\n      .AutocompleteInput_select > div:first-child {\n        height: 3rem;\n        min-height: 3rem;\n\n        * {\n          font-size: 1.1rem;\n        }\n      }\n      button {\n        font-size: 1.1rem;\n        height: 2.8rem;\n        padding: 0 1rem;\n        vertical-align: middle;\n\n        i {\n          vertical-align: middle;\n          font-size: 1.5rem;\n        }\n      }\n    }\n  }\n\n  .filters_tags {\n    padding: 1rem 0;\n    display: inline-block;\n    vertical-align: middle;\n\n    .tag_filter {\n      display: inline-block;\n      color: #767676;\n      font-size: 1.2rem;\n      border: 0.1rem solid #bfbfbf;\n      border-radius: 2rem;\n      padding: 1rem;\n      margin-right: 1rem;\n      cursor: pointer;\n\n      &.selected {\n        color: #fff;\n        background-color: ',';\n        border-color: ',';\n      }\n    }\n  }\n\n  .content {\n    display: grid;\n    grid-template-columns: 43% calc(57% - 4rem);\n    grid-gap: 2rem;\n    position: relative;\n\n    .gravity_bubbles_wrapper {\n      .gravity_bubbles {\n        width: 100%;\n        height: 100%;\n\n        @media (min-width: ','px) {\n          min-height: 60rem;\n        }\n      }\n    }\n\n    .lists {\n      @media (min-width: ','px) {\n        box-shadow: 0px 3px 0px 6px #f9f9f9,-3px 3px 6px 1px rgb(0 0 0 / 16%);\n        padding-top: 3rem !important;\n      }\n      .list {\n        clear: both;\n        margin-bottom: 2rem;\n        .header {\n          display: grid;\n          grid-template-columns: auto 50px;\n          grid-gap: 2rem;\n\n          .title {\n            color: ',';\n            font-size: 1.5rem;\n            font-family: ',';\n            margin-bottom: 1rem;\n          }\n\n          .icon_expand {\n            justify-self: end;\n            img {\n              cursor: pointer;\n              height: 20px;\n            }\n          }\n        }\n\n        .faces_wrapper {\n          white-space: nowrap;\n          overflow: auto;\n          text-align: left;\n\n          .face_bubble {\n            width: calc(100% / 6) !important;\n            margin: 0;\n            min-width: 10rem;\n          }\n\n          .face_bubble_text {\n            color: rgba(0, 0, 0, 0.54);\n            font-size: 1rem;\n            white-space: normal;\n          }\n        }\n\n        .in_table {\n          .faces_wrapper {\n            white-space: normal;\n          }\n        }\n      }\n    }\n\n    &.fullscreen {\n      display: block;\n\n      .lists {\n        position: absolute;\n        top: 0rem;\n        right: 0;\n        width: 50%;\n        z-index: 8;\n        background-color: #f9f9f9;\n        padding: 1rem 1rem 0;\n        height: calc(100% - 6rem);\n        overflow: auto;\n      }\n    }\n  }\n\n  .theme_tables_wrapper {\n    overflow: hidden;\n    height: calc(100vh - 19rem);\n\n    &.with_header {\n      height: calc(100vh - 39rem);\n    }\n\n    @media (max-width: ','px) {\n      height: calc(100vw - 2rem);\n    }\n  }\n\n  @media (max-width: ','px) {\n    .filters_tags {\n      padding: 0 1rem;\n    }\n\n    .content {\n      grid-template-columns: 1fr;\n      display: block;\n\n      .gravity_bubbles_wrapper {\n        width: calc(100% - 2rem);\n        height: calc(100vw + 2rem);\n        margin: 1rem auto;\n        background-color: rgba(255, 255, 255, 0.1);\n      }\n      .lists {\n        .list {\n          margin-left: 1rem;\n          margin-right: 1rem;\n          .faces_wrapper {\n            grid-template-columns: repeat(3, 1fr) !important;\n\n            .face_bubble {\n              width: calc(100% / 3) !important;\n            }\n          }\n        }\n      }\n\n      &.fullscreen {\n        display: block;\n\n        .lists {\n          position: relative;\n          width: 100%;\n          z-index: 10;\n          background-color: transparent;\n          padding: 1rem 1rem 0;\n          height: auto;\n          overflow: auto;\n        }\n      }\n    }\n  }\n\n  &.elements_hall {\n    @media (max-width: ','px) {\n      .content {\n        .gravity_bubbles_wrapper {\n          width: calc(100% - 2rem);\n          height: calc(100vh - 27rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n          margin: 1rem auto;\n          background-color: rgba(255, 255, 255, 0.1);\n\n          .theme_tables_wrapper {\n            height: calc(100vh - 27rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n          }\n        }\n    }\n  }\n\n  .user_card {\n    display: flex;\n    align-items: center;\n    overflow: auto;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  height: 90%;\n  width: 100vw;\n  max-width: 100%;\n  outline: none;\n  position: absolute;\n  left: 48%;\n  top: 46%;\n  transform: translate(-50%, -50%);\n'],['\n  height: 90%;\n  width: 100vw;\n  max-width: 100%;\n  outline: none;\n  position: absolute;\n  left: 48%;\n  top: 46%;\n  transform: translate(-50%, -50%);\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: relative;\n  float: right;\n  font-size: 2rem;\n  color: #fff;\n  margin: 1rem 1rem 1.5rem;\n  cursor: pointer;\n\n  @media (max-width: ','px) {\n    display: none;\n  }\n'],['\n  position: relative;\n  float: right;\n  font-size: 2rem;\n  color: #fff;\n  margin: 1rem 1rem 1.5rem;\n  cursor: pointer;\n\n  @media (max-width: ','px) {\n    display: none;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var NetworkingHallSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_4_assets_images_icons_search_svg___default.a,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.color;},function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_4_assets_images_icons_search_svg___default.a,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.color;},function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var FeedbackModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var CloseIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject4,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return CustomCardWrapper; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return CardBody; });



 __webpack_require__.d(__webpack_exports__, "q", function() { return Title; });

 __webpack_require__.d(__webpack_exports__, "p", function() { return Text; });

 __webpack_require__.d(__webpack_exports__, "n", function() { return Subtitle; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return Quote; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return Youtube; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return Image; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return ImageRounded; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return Overlay; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return Tags; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return UserLayer; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return Avatar; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return AvatarInitial; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return Username; });









 __webpack_require__.d(__webpack_exports__, "g", function() { return ElementButtons; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return ElementButton; });

 __webpack_require__.d(__webpack_exports__, "e", function() { return CustomList; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return QuoteAuthor; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return Link; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
 var __WEBPACK_IMPORTED_MODULE_2_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_3_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  margin: 0 auto;\n'],['\n  margin: 0 auto;\n']),_templateObject2=_taggedTemplateLiteral(['\n  order: 1;\n  flex-grow: 2;\n'],['\n  order: 1;\n  flex-grow: 2;\n']),_templateObject3=_taggedTemplateLiteral(['\n  font-size: 0;\n  border-top: 1px solid #fff;\n  padding: 10px 5px;\n  order: 2;\n\n  div {\n    display: inline-block;\n    vertical-align: middle;\n    text-align: center;\n    width: 25%;\n  }\n'],['\n  font-size: 0;\n  border-top: 1px solid #fff;\n  padding: 10px 5px;\n  order: 2;\n\n  div {\n    display: inline-block;\n    vertical-align: middle;\n    text-align: center;\n    width: 25%;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 14px;\n'],['\n  color: #fff;\n  font-size: 14px;\n']),_templateObject5=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 18px;\n  width: 24px;\n  height: 18px;\n\n  &.active {\n    text-shadow: 0 0 15px #ffffff;\n  }\n\n  &.small-icon {\n    font-size: 10px;\n    position: absolute;\n    top: 6px;\n    right: 32%;\n    color: red;\n    background-color: rgba(255, 255, 255, 0.7);\n    width: 16px;\n    height: 16px;\n    padding: 3px;\n    border-radius: 50%;\n  }\n'],['\n  color: #fff;\n  font-size: 18px;\n  width: 24px;\n  height: 18px;\n\n  &.active {\n    text-shadow: 0 0 15px #ffffff;\n  }\n\n  &.small-icon {\n    font-size: 10px;\n    position: absolute;\n    top: 6px;\n    right: 32%;\n    color: red;\n    background-color: rgba(255, 255, 255, 0.7);\n    width: 16px;\n    height: 16px;\n    padding: 3px;\n    border-radius: 50%;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n  }\n'],['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: #fff;\n    background-image: linear-gradient(',', ',');\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n  }\n'],['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: #fff;\n    background-image: linear-gradient(',', ',');\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  color: ',';\n  line-height: ',';\n  font-size: ',';\n  font-family: \'helvetica neue light\';\n  padding-bottom: 5px;\n  text-align: center;\n  max-width: ',';\n  display: inline-block;\n  vertical-align: middle;\n\n  left: 0px;\n  right: 10px;\n  position: relative;\n  font-family: ',';\n\n  strong {\n    font-family: ',';\n    color: #fff;\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n'],['\n  color: ',';\n  line-height: ',';\n  font-size: ',';\n  font-family: \'helvetica neue light\';\n  padding-bottom: 5px;\n  text-align: center;\n  max-width: ',';\n  display: inline-block;\n  vertical-align: middle;\n\n  left: 0px;\n  right: 10px;\n  position: relative;\n  font-family: ',';\n\n  strong {\n    font-family: ',';\n    color: #fff;\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  background-image: url(\'','\');\n  width: 90px;\n  height: 90px;\n  margin: 10px 10px 10px 0;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  background-position: 50%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n\n  @media (max-width: ','px) {\n    font-size: 24px;\n    line-height: 28px;\n    width: 70px;\n    height: 70px;\n    margin: 0px 5px 10px 0;\n  }\n'],['\n  background-image: url(\'','\');\n  width: 90px;\n  height: 90px;\n  margin: 10px 10px 10px 0;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  background-position: 50%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n\n  @media (max-width: ','px) {\n    font-size: 24px;\n    line-height: 28px;\n    width: 70px;\n    height: 70px;\n    margin: 0px 5px 10px 0;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  color: ',';\n  line-height: 16px;\n  text-align: justify;\n  width: 80%;\n  left: 10%;\n  right: 10%;\n  position: relative;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  font-size: 16px;\n\n  @media (min-width: ','px) {\n    font-size: 20px;\n    line-height: 26px;\n    text-align: center;\n  }\n  strong {\n    font-family: ',';\n    color: #fff;\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n'],['\n  color: ',';\n  line-height: 16px;\n  text-align: justify;\n  width: 80%;\n  left: 10%;\n  right: 10%;\n  position: relative;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  font-size: 16px;\n\n  @media (min-width: ','px) {\n    font-size: 20px;\n    line-height: 26px;\n    text-align: center;\n  }\n  strong {\n    font-family: ',';\n    color: #fff;\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  color: ',';\n  line-height: 22px;\n  font-size: 18px;\n  text-align: justify;\n  width: 80%;\n  left: 10%;\n  right: 10%;\n  position: relative;\n  margin-top: 15px;\n  margin-bottom: 20px;\n  @media (min-width: 800px) {\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  strong {\n    font-family: ',';\n    color: #fff;\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n'],['\n  color: ',';\n  line-height: 22px;\n  font-size: 18px;\n  text-align: justify;\n  width: 80%;\n  left: 10%;\n  right: 10%;\n  position: relative;\n  margin-top: 15px;\n  margin-bottom: 20px;\n  @media (min-width: 800px) {\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  strong {\n    font-family: ',';\n    color: #fff;\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n']),_templateObject12=_taggedTemplateLiteral(['\n  color: #fff;\n  line-height: calc(15px + (22 - 15) * ((100vw - 320px) / (412 - 320)));\n  font-size: calc(16px + (22 - 16) * ((100vw - 320px) / (412 - 320)));\n  font-family: \'helvetica neue strong\';\n  text-align: center;\n  width: 90%;\n  left: 5%;\n  right: 5%;\n  position: relative;\n  @media (min-width: 800px) {\n    font-size: 24px;\n    line-height: 28px;\n  }\n  strong {\n    font-family: ',';\n    color: #fff;\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n'],['\n  color: #fff;\n  line-height: calc(15px + (22 - 15) * ((100vw - 320px) / (412 - 320)));\n  font-size: calc(16px + (22 - 16) * ((100vw - 320px) / (412 - 320)));\n  font-family: \'helvetica neue strong\';\n  text-align: center;\n  width: 90%;\n  left: 5%;\n  right: 5%;\n  position: relative;\n  @media (min-width: 800px) {\n    font-size: 24px;\n    line-height: 28px;\n  }\n  strong {\n    font-family: ',';\n    color: #fff;\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  text-align: center;\n  color: #fff;\n  line-height: 21px;\n  font-size: 16px;\n  width: 70%;\n  margin: 0 auto 20px;\n  font-style: italic;\n  position: relative;\n  quotes: "\u201C" "\u201D" "\u2018" "\u2019";\n  display: block;\n\n  &:before {\n    content: open-quote;\n    font-size: 24px;\n    font-weight: 600;\n  }\n\n  &:after {\n    content: close-quote;\n    font-size: 24px;\n    font-weight: 600;\n  }\n'],['\n  text-align: center;\n  color: #fff;\n  line-height: 21px;\n  font-size: 16px;\n  width: 70%;\n  margin: 0 auto 20px;\n  font-style: italic;\n  position: relative;\n  quotes: "\u201C" "\u201D" "\u2018" "\u2019";\n  display: block;\n\n  &:before {\n    content: open-quote;\n    font-size: 24px;\n    font-weight: 600;\n  }\n\n  &:after {\n    content: close-quote;\n    font-size: 24px;\n    font-weight: 600;\n  }\n']),_templateObject14=_taggedTemplateLiteral(['\n  width: 560px;\n  height: 315px;\n\n  @media (max-width: ','px) {\n    width: 100vw;\n    height: 56vw;\n    margin-top: 20px;\n  }\n'],['\n  width: 560px;\n  height: 315px;\n\n  @media (max-width: ','px) {\n    width: 100vw;\n    height: 56vw;\n    margin-top: 20px;\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 560px;\n  pointer-events: none;\n  margin-bottom: ','px;\n  margin-top: ','px;\n'],['\n  width: 100%;\n  max-width: 560px;\n  pointer-events: none;\n  margin-bottom: ','px;\n  margin-top: ','px;\n']),_templateObject16=_taggedTemplateLiteral(['\n  width: ',';\n  height:  ',';\n  margin: ','px auto ','px;\n  border-radius: ',';\n  background-size: cover;\n  background-position: 50%;\n  background-image: url(',');\n  max-width: 200px;\n  max-height: 200px;\n'],['\n  width: ',';\n  height:  ',';\n  margin: ','px auto ','px;\n  border-radius: ',';\n  background-size: cover;\n  background-position: 50%;\n  background-image: url(',');\n  max-width: 200px;\n  max-height: 200px;\n']),_templateObject17=_taggedTemplateLiteral(['\n  background-size: cover;\n  background-position: 50%;\n  background-image: url(',');\n  height: ','px;\n  margin-bottom: -','px;\n  z-index: 10;\n  position: relative;\n'],['\n  background-size: cover;\n  background-position: 50%;\n  background-image: url(',');\n  height: ','px;\n  margin-bottom: -','px;\n  z-index: 10;\n  position: relative;\n']),_templateObject18=_taggedTemplateLiteral(['\n  width: 100%;\n\n  div {\n    border-radius: 50px;\n    background-color: #fff;\n    color: #000000b8;\n    font-size: 12px;\n    padding: 4px 10px;\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0px 5px 5px;\n  }\n'],['\n  width: 100%;\n\n  div {\n    border-radius: 50px;\n    background-color: #fff;\n    color: #000000b8;\n    font-size: 12px;\n    padding: 4px 10px;\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0px 5px 5px;\n  }\n']),_templateObject19=_taggedTemplateLiteral(['\n  display: block;\n  margin: 10px;\n'],['\n  display: block;\n  margin: 10px;\n']),_templateObject20=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-image: url(',');\n  background-position: 50%;\n  background-size: cover;\n  margin-right : 10px;\n  vertical-align: middle;\n  background-color: #fff;\n'],['\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-image: url(',');\n  background-position: 50%;\n  background-size: cover;\n  margin-right : 10px;\n  vertical-align: middle;\n  background-color: #fff;\n']),_templateObject21=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-right : 10px;\n  vertical-align: middle;\n  line-height: 40px;\n  text-align: center;\n  font-size: 18px;\n  text-transform: uppercase;\n  color: #4d4d4d;\n  background-color: #fff;\n'],['\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-right : 10px;\n  vertical-align: middle;\n  line-height: 40px;\n  text-align: center;\n  font-size: 18px;\n  text-transform: uppercase;\n  color: #4d4d4d;\n  background-color: #fff;\n']),_templateObject22=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  width: calc(100% - 50px);\n  font-size: 14px;\n  color: #fff;\n  text-align: left;\n  font-family: \'helvetica neue\';\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  width: calc(100% - 50px);\n  font-size: 14px;\n  color: #fff;\n  text-align: left;\n  font-family: \'helvetica neue\';\n']),_templateObject23=_taggedTemplateLiteral(['\n  order: 3;\n  padding-bottom: 5px;\n'],['\n  order: 3;\n  padding-bottom: 5px;\n']),_templateObject24=_taggedTemplateLiteral(['\n padding-bottom: 5px;\n'],['\n padding-bottom: 5px;\n']),_templateObject25=_taggedTemplateLiteral(['\n  width: 90%;\n  padding: 5px 8px;\n  font-size: 12px;\n  line-height: 16px;\n  height: 60px;\n  resize: vertical;\n  border: 0px;\n'],['\n  width: 90%;\n  padding: 5px 8px;\n  font-size: 12px;\n  line-height: 16px;\n  height: 60px;\n  resize: vertical;\n  border: 0px;\n']),_templateObject26=_taggedTemplateLiteral(['\n  color: #fff;\n  background-color: #00000073;\n  margin: 5px 0 0 auto;\n  font-size: 12px;\n  padding: 6px 15px;\n  border-radius: 20px;\n  font-family: ',';\n  cursor: pointer;\n  border: 0px;\n'],['\n  color: #fff;\n  background-color: #00000073;\n  margin: 5px 0 0 auto;\n  font-size: 12px;\n  padding: 6px 15px;\n  border-radius: 20px;\n  font-family: ',';\n  cursor: pointer;\n  border: 0px;\n']),_templateObject27=_taggedTemplateLiteral(['\n  list-style: none;\n  padding-left: 0;\n'],['\n  list-style: none;\n  padding-left: 0;\n']),_templateObject28=_taggedTemplateLiteral(['\n  background-color: #F1F1F1;\n  border: 0px;\n  position: relative;\n  padding-left: 28px;\n  line-height: 18px;\n  font-size: 9px;\n  border-radius: 0 3px 0 0;\n'],['\n  background-color: #F1F1F1;\n  border: 0px;\n  position: relative;\n  padding-left: 28px;\n  line-height: 18px;\n  font-size: 9px;\n  border-radius: 0 3px 0 0;\n']),_templateObject29=_taggedTemplateLiteral(['\n   && {\n    width: 30px;\n    height: 30px;\n    display: inline-block;\n    font-size: 15px;\n    text-align: center;\n    padding-top: 6px;\n    position: absolute;\n    top: -6px;\n    left: -15px;\n   }\n'],['\n   && {\n    width: 30px;\n    height: 30px;\n    display: inline-block;\n    font-size: 15px;\n    text-align: center;\n    padding-top: 6px;\n    position: absolute;\n    top: -6px;\n    left: -15px;\n   }\n']),_templateObject30=_taggedTemplateLiteral(['\n  background-color: #fff;\n  padding: 10px;\n  border-radius: 0 0 3px 3px;\n  color: #666;\n'],['\n  background-color: #fff;\n  padding: 10px;\n  border-radius: 0 0 3px 3px;\n  color: #666;\n']),_templateObject31=_taggedTemplateLiteral(['\n  width: 90%;\n  margin: 5px auto 5px;\n  border-radius: 3px;\n  padding: 5px;\n  text-align: left;\n'],['\n  width: 90%;\n  margin: 5px auto 5px;\n  border-radius: 3px;\n  padding: 5px;\n  text-align: left;\n']),_templateObject32=_taggedTemplateLiteral(['\n  padding: 0px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n'],['\n  padding: 0px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n']),_templateObject33=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ','\n  height: ','\n  border-radius: 50%;\n  font-weight: 600;\n  border: 5px solid #fff;\n  color: ',';\n  background-color: ',';\n  text-align: center;\n  cursor: pointer;\n  font-size:  ','\n  margin-top: 15px;\n  @media (min-width: 800px) {\n    width: ','\n    height: ','\n    padding: ',';\n    font-size:  ','\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ','\n  height: ','\n  border-radius: 50%;\n  font-weight: 600;\n  border: 5px solid #fff;\n  color: ',';\n  background-color: ',';\n  text-align: center;\n  cursor: pointer;\n  font-size:  ','\n  margin-top: 15px;\n  @media (min-width: 800px) {\n    width: ','\n    height: ','\n    padding: ',';\n    font-size:  ','\n  }\n']),_templateObject34=_taggedTemplateLiteral(['\n    position: absolute;\n    bottom: -10px;\n    width: 100%;\n    height: 20vh;\n    background: ',';\n'],['\n    position: absolute;\n    bottom: -10px;\n    width: 100%;\n    height: 20vh;\n    background: ',';\n']),_templateObject35=_taggedTemplateLiteral(['\n  width: 80%;\n  left: 10%;\n  right: 10%;\n  position: relative;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  text-align: left;\n\n  .list_title {\n    font-weight: 600;\n    color: #fff;\n    line-height: calc(20px + (30 - 18) * ((100vw - 320px) / (412 - 320)));\n    font-size: calc(16px + (18 - 14) * ((100vw - 320px) / (412 - 320)));\n  }\n\n  ul {\n    list-style: inside;\n    li {\n      color: #fff;\n      line-height: calc(16px + (30 - 18) * ((100vw - 320px) / (412 - 320)));\n      font-size: calc(14px + (16 - 14) * ((100vw - 320px) / (412 - 320)));\n    }\n  }\n'],['\n  width: 80%;\n  left: 10%;\n  right: 10%;\n  position: relative;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  text-align: left;\n\n  .list_title {\n    font-weight: 600;\n    color: #fff;\n    line-height: calc(20px + (30 - 18) * ((100vw - 320px) / (412 - 320)));\n    font-size: calc(16px + (18 - 14) * ((100vw - 320px) / (412 - 320)));\n  }\n\n  ul {\n    list-style: inside;\n    li {\n      color: #fff;\n      line-height: calc(16px + (30 - 18) * ((100vw - 320px) / (412 - 320)));\n      font-size: calc(14px + (16 - 14) * ((100vw - 320px) / (412 - 320)));\n    }\n  }\n']),_templateObject36=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 12px;\n  text-align: right;\n  width: 70%;\n  margin: 0 auto 20px;\n  display: block;\n'],['\n  color: #fff;\n  font-size: 12px;\n  text-align: right;\n  width: 70%;\n  margin: 0 auto 20px;\n  display: block;\n']),_templateObject37=_taggedTemplateLiteral(['\n  background-color: #fff;\n  color: ',';\n  padding: 10px 20px;\n  display: inline-block;\n  margin: 10px 0 10px auto;\n  font-size: 14px;\n  border-radius: 20px;\n  float: right;\n  margin-right: 20px;\n'],['\n  background-color: #fff;\n  color: ',';\n  padding: 10px 20px;\n  display: inline-block;\n  margin: 10px 0 10px auto;\n  font-size: 14px;\n  border-radius: 20px;\n  float: right;\n  margin-right: 20px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CustomCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var CardBody=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var CardOptions=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var OptionCounter=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].span(_templateObject4);var OptionIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject5);var highlight=function highlight(backgroundColorText){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject6,backgroundColorText);};var highlightWhite=function highlightWhite(backgroundColorText){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject7,backgroundColorText,backgroundColorText);};var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,function(props){return props.color||'#fff';},function(props){return'min('+(props.maxFontSize+6)+'px, 22px + (24 - 22) * ((100vw - 320px) / (412 - 320)))';},function(props){return'min('+props.maxFontSize+'px, 16px + (18 - 16) * ((100vw - 320px) / (412 - 320)))';},function(props){return props.maxWidth;},__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,function(props){return highlight(props.backgroundColorText);});var IconTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9,function(props){return props.icon;},__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var Text=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,function(props){return props.noBackgroundColor?highlightWhite(props.backgroundColorText):highlight(props.backgroundColorText);});var TextGoals=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,function(props){return highlight(props.backgroundColorText);});var Subtitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,function(props){return highlight(props.backgroundColorText);});var Quote=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].q(_templateObject13);var Youtube=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].iframe(_templateObject14,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].img(_templateObject15,function(props){return props.marginBottom;},function(props){return props.marginTop;});var ImageRounded=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16,function(props){return props.width?props.width+'px':'40vw';},function(props){return props.width?props.width+'px':'40vw';},function(props){return props.marginTop;},function(props){return props.marginBottom;},function(props){return parseInt(props.rounded,10)===1?'50%':'0%';},function(props){return props.src;});var Overlay=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17,function(props){return props.src;},function(props){return props.height;},function(props){return props.height-props.paddingTop;});var Tags=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18);var UserLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject19);var Avatar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject20,function(props){return props.img;});var AvatarInitial=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject21);var Username=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject22);var CardCommentsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject23);var NewCommentsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject24);var NewCommentBox=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].textarea(_templateObject25);var SendCommentButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject26,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily);var ListCommentsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].ul(_templateObject27);var CommentHeader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject28);var CommentAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject29);var CommentText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject30);var CommentWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].li(_templateObject31);var ElementButtons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject32);var ElementButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject33,function(props){return props.type==='yes'?'85px':'67px';},function(props){return props.type==='yes'?'85px':'67px';},function(props){return props.selected?props.color:'#fff';},function(props){return props.selected?'#fff':'transparent';},function(props){return props.type==='yes'?'16px':'14px';},function(props){return props.type==='yes'?'150px':'100px';},function(props){return props.type==='yes'?'150px':'100px';},function(props){return props.type==='yes'?'60px 15px':'35px 15px';},function(props){return props.type==='yes'?'20px':'18px';});var FadeFrame=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject34,function(props){return'linear-gradient(to bottom, rgba('+Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["f" ])(props.color)+',0) 0%, rgba('+Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["f" ])(props.color)+', 1) 100%)';});var CustomList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject35);var QuoteAuthor=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject36);var Link=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].a(_templateObject37,function(props){return props.color;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1205);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(176);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FilterChat=function(_Component){_inherits(FilterChat,_Component);function FilterChat(props){_classCallCheck(this,FilterChat);var _this=_possibleConstructorReturn(this,(FilterChat.__proto__||Object.getPrototypeOf(FilterChat)).call(this,props));_this.handleChangeInput=function(event){var doFilter=_this.props.doFilter;doFilter(event.target.value);_this.setState({inputValue:event.target.value});};_this.tableInputKeyPress=function(event){if(event.which===13){event.preventDefault();}};_this.state={inputValue:''};_this.handleChangeInput=_this.handleChangeInput.bind(_this);return _this;}_createClass(FilterChat,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["g" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["q" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form_input_stl',placeholder:'Search People',value:this.state.inputValue,onChange:this.handleChangeInput,onKeyDown:this.tableInputKeyPress})));}}]);return FilterChat;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FilterChat.propTypes={doFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (FilterChat);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1220);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1244);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return TABLE; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return SPEED_DATING_DURATION; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return SPEED_DATING_REST; });
var EVENT=21283706;var TABLE=21283707;var SPEED_DATING_DURATION=300;var SPEED_DATING_REST=120;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "C", function() { return Wrapper; });
 __webpack_require__.d(__webpack_exports__, "z", function() { return TitleBack; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return FormWrapper; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return InputName; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return Image; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return InputDescription; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return BtnSubmit; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return ErrorLayer; });

 __webpack_require__.d(__webpack_exports__, "j", function() { return IconTitle; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return MsgSuccess; });

 __webpack_require__.d(__webpack_exports__, "x", function() { return TagsWrapper; });
 __webpack_require__.d(__webpack_exports__, "v", function() { return TagContainer; });
 __webpack_require__.d(__webpack_exports__, "w", function() { return TagLabel; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return CongratulationsWrapper; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return CongratulationsTitle; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return CongratulationsSubtitle; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return InvitePeopleView; });
 __webpack_require__.d(__webpack_exports__, "y", function() { return TimeLife; });

 __webpack_require__.d(__webpack_exports__, "u", function() { return PrivateTable; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return CreatedIn; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return InvitePeople; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return CircleImage; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return MyNetworkGrid; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return MyNetworkWrapper; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return PeopleSelected; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return InviteButton; });
 __webpack_require__.d(__webpack_exports__, "A", function() { return UserAround; });
 __webpack_require__.d(__webpack_exports__, "B", function() { return UserWrapper; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return CongratulationsModal; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__ = __webpack_require__(68);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_3_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  > .header {\n    padding: 2rem 2rem;\n    box-shadow: inset 0px -2px 4px -2px rgba(0, 0, 0, 0.16);\n    display: flex;\n    .back_button {\n      cursor: pointer;\n      margin-right: 1.5rem;\n      flex: 1;\n      i {\n        color: ',';\n        font-size: 1.8rem;\n      }\n    }\n\n    > div {\n      display: inline-block;\n      vertical-align: middle;\n    }\n\n    > .title {\n      color: ',';\n      font-size: 1.8rem;\n      margin-right: 2rem;\n      flex: 100;\n      font-family: ',';\n      img {\n        margin-right: 0.5rem;\n      }\n    }\n\n\n    @media (max-width: ','px) {\n      .btn_join_lg {\n        display: none;\n      }\n\n      .title {\n        width: calc(100% - 5rem);\n      }\n    }\n'],['\n  > .header {\n    padding: 2rem 2rem;\n    box-shadow: inset 0px -2px 4px -2px rgba(0, 0, 0, 0.16);\n    display: flex;\n    .back_button {\n      cursor: pointer;\n      margin-right: 1.5rem;\n      flex: 1;\n      i {\n        color: ',';\n        font-size: 1.8rem;\n      }\n    }\n\n    > div {\n      display: inline-block;\n      vertical-align: middle;\n    }\n\n    > .title {\n      color: ',';\n      font-size: 1.8rem;\n      margin-right: 2rem;\n      flex: 100;\n      font-family: ',';\n      img {\n        margin-right: 0.5rem;\n      }\n    }\n\n\n    @media (max-width: ','px) {\n      .btn_join_lg {\n        display: none;\n      }\n\n      .title {\n        width: calc(100% - 5rem);\n      }\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n  .title_create {\n    margin: 1% 0;\n    text-align: left;\n\n    div {\n      display: inline-block;\n      font-family: ',';\n      font-size: 22px;\n      margin: 1%;\n    }\n\n    img {\n      display: inline-block;\n      margin-left: 1%;\n      cursor: pointer;\n    }\n'],['\n  .title_create {\n    margin: 1% 0;\n    text-align: left;\n\n    div {\n      display: inline-block;\n      font-family: ',';\n      font-size: 22px;\n      margin: 1%;\n    }\n\n    img {\n      display: inline-block;\n      margin-left: 1%;\n      cursor: pointer;\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n  padding: 0px 20px 30px;\n  width: 100%;\n  max-width: 60rem;\n  margin: 0 auto;\n\n  \n  }\n\n  \n\n\n\n  .imageClickable {\n    border: 0px;\n    background-color: transparent;\n    width: 550px;\n  }\n\n  &.full_width {\n    max-width: 90%;\n  }\n'],['\n  padding: 0px 20px 30px;\n  width: 100%;\n  max-width: 60rem;\n  margin: 0 auto;\n\n  \n  }\n\n  \n\n\n\n  .imageClickable {\n    border: 0px;\n    background-color: transparent;\n    width: 550px;\n  }\n\n  &.full_width {\n    max-width: 90%;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  && {\n    width: 100%;\n    margin: 0px 0 1rem;\n    border: 0px;\n    box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n    border-radius: 1rem;\n    overflow: hidden;\n    input {\n      background-color: #fff;\n      height: 6vh;\n      color: #575757;\n      padding: 10px;\n      font-family: ','\n      font-size: 14px;\n    }\n\n    > div::before {\n      border-bottom: 0px !important;\n    }\n  }\n'],['\n  && {\n    width: 100%;\n    margin: 0px 0 1rem;\n    border: 0px;\n    box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n    border-radius: 1rem;\n    overflow: hidden;\n    input {\n      background-color: #fff;\n      height: 6vh;\n      color: #575757;\n      padding: 10px;\n      font-family: ','\n      font-size: 14px;\n    }\n\n    > div::before {\n      border-bottom: 0px !important;\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  width: 100%;\n  margin: 10px 0px;\n  border-radius: 10px;\n  padding: ',';\n  background-color: transparent;\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  color: black;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  justify-content: center;\n  img {\n    min-height: 25vh;\n    background-size: cover;\n    width: auto;\n  }\n  .upload {\n    img {\n      height: 3rem;\n      margin-bottom: 1rem;\n    }\n    display:flex;\n    flex-direction: column;\n    justify-content: space-around;\n  }\n\n  .uploaded {\n    width: 100%;\n    border-radius: 1rem;\n    display:flex;\n    flex-direction: column;\n    justify-content: space-around;\n  }\n'],['\n  width: 100%;\n  margin: 10px 0px;\n  border-radius: 10px;\n  padding: ',';\n  background-color: transparent;\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  color: black;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  justify-content: center;\n  img {\n    min-height: 25vh;\n    background-size: cover;\n    width: auto;\n  }\n  .upload {\n    img {\n      height: 3rem;\n      margin-bottom: 1rem;\n    }\n    display:flex;\n    flex-direction: column;\n    justify-content: space-around;\n  }\n\n  .uploaded {\n    width: 100%;\n    border-radius: 1rem;\n    display:flex;\n    flex-direction: column;\n    justify-content: space-around;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  && {\n    width: 100%;\n    margin: 0 0 1rem;\n    border: 0px;\n    border-radius: 10px;\n    box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n    overflow: hidden;\n\n    > div::before {\n      border-bottom: 0px !important;\n    }\n\n    > div {\n      padding: 0;\n    }\n\n    textarea {\n      background-color: #fff;\n      color: #000;\n      padding: 10px;\n      font-family: ',';\n      font-size: 14px;\n      box-sizing: border-box;\n\n    }\n\n\n  }\n'],['\n  && {\n    width: 100%;\n    margin: 0 0 1rem;\n    border: 0px;\n    border-radius: 10px;\n    box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n    overflow: hidden;\n\n    > div::before {\n      border-bottom: 0px !important;\n    }\n\n    > div {\n      padding: 0;\n    }\n\n    textarea {\n      background-color: #fff;\n      color: #000;\n      padding: 10px;\n      font-family: ',';\n      font-size: 14px;\n      box-sizing: border-box;\n\n    }\n\n\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  color: ',';\n  background-color: ',';\n  margin: 20px auto 40px;\n  font-size: 14px;\n  padding: 10px 60px;\n  border-radius: 20px;\n  font-family: ',';\n  display: block;\n\n  @media (max-width: ','px) {\n    margin-bottom: 10rem;\n  }\n'],['\n  color: ',';\n  background-color: ',';\n  margin: 20px auto 40px;\n  font-size: 14px;\n  padding: 10px 60px;\n  border-radius: 20px;\n  font-family: ',';\n  display: block;\n\n  @media (max-width: ','px) {\n    margin-bottom: 10rem;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  background-color: #F44336;\n  margin-top: 20px;\n  font-size: 16px;\n  text-align: center;\n  font-family: ',';\n  color: #fff;\n  padding: 10px;\n'],['\n  background-color: #F44336;\n  margin-top: 20px;\n  font-size: 16px;\n  text-align: center;\n  font-family: ',';\n  color: #fff;\n  padding: 10px;\n']),_templateObject9=_taggedTemplateLiteral(['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n\n  }\n\n'],['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n\n  }\n\n']),_templateObject10=_taggedTemplateLiteral(['\n  color: black;\n  line-height: 22px;\n  font-size: 16px;\n  margin: 0px auto;\n  font-family: \'helvetica neue light\';\n  max-width: 100%;\n  margin-bottom: 3rem;\n  text-align: left;\n\n  strong {\n    font-family: ',';\n    color: black;\n    font-weight: 100;\n    border-radius: 7px;\n    white-space: nowrap;\n  }\n'],['\n  color: black;\n  line-height: 22px;\n  font-size: 16px;\n  margin: 0px auto;\n  font-family: \'helvetica neue light\';\n  max-width: 100%;\n  margin-bottom: 3rem;\n  text-align: left;\n\n  strong {\n    font-family: ',';\n    color: black;\n    font-weight: 100;\n    border-radius: 7px;\n    white-space: nowrap;\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  background-image: url(',');\n'],['\n  background-image: url(',');\n']),_templateObject12=_taggedTemplateLiteral(['\n  font-size: 16px;\n  color: #fff;\n  font-weight: 600;\n  padding: 10px;\n  line-height: 24px;\n'],['\n  font-size: 16px;\n  color: #fff;\n  font-weight: 600;\n  padding: 10px;\n  line-height: 24px;\n']),_templateObject13=_taggedTemplateLiteral(['\n  text-align: center;\n  cursor: pointer;\n  font-size: 13px;\n  padding: 10px;\n  color: #fff;\n'],['\n  text-align: center;\n  cursor: pointer;\n  font-size: 13px;\n  padding: 10px;\n  color: #fff;\n']),_templateObject14=_taggedTemplateLiteral(['\n  text-align: left;\n  border-radius: 1rem;\n  margin-bottom: 1rem;\n  border-radius: 10px;\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  overflow: hidden;\n\n  input {\n    margin: 0 !important;\n    padding: 1rem;\n    font-family: ',';\n    font-size: 1.4rem;\n    box-shadow: none;\n  }\n'],['\n  text-align: left;\n  border-radius: 1rem;\n  margin-bottom: 1rem;\n  border-radius: 10px;\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  overflow: hidden;\n\n  input {\n    margin: 0 !important;\n    padding: 1rem;\n    font-family: ',';\n    font-size: 1.4rem;\n    box-shadow: none;\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 4rem;\n  border-radius: 1rem;\n  background-color: white;\n  box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.41);\n  margin: 0rem 0 1rem;\n  padding: 1rem;\n  white-space: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n'],['\n  width: 100%;\n  height: 4rem;\n  border-radius: 1rem;\n  background-color: white;\n  box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.41);\n  margin: 0rem 0 1rem;\n  padding: 1rem;\n  white-space: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n']),_templateObject16=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  background-color: ',';\n  font-size: 12px;\n  padding: 5px;\n  color: white;\n  border-radius: 50px;\n  font-family: ','\n  cursor: pointer;\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  background-color: ',';\n  font-size: 12px;\n  padding: 5px;\n  color: white;\n  border-radius: 50px;\n  font-family: ','\n  cursor: pointer;\n']),_templateObject17=_taggedTemplateLiteral(['\n  width: 100%;\n  background-image: url(',');\n  background-size: cover;\n  background-repeat: no-repeat;\n  img {\n    height: 100%;\n    width: 100%;\n  }\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .confetti {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n'],['\n  width: 100%;\n  background-image: url(',');\n  background-size: cover;\n  background-repeat: no-repeat;\n  img {\n    height: 100%;\n    width: 100%;\n  }\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .confetti {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  font-family: ',';\n  font-size: 35px;\n  font-weight: bolder;\n  color: black;\n  text-align: center;\n  margin-left: 10px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n'],['\n  font-family: ',';\n  font-size: 35px;\n  font-weight: bolder;\n  color: black;\n  text-align: center;\n  margin-left: 10px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n']),_templateObject19=_taggedTemplateLiteral(['\n  font-family: ',';\n  font-size: 20px;\n  color: black;\n  text-align: center;\n  font-weight: 100;\n  margin-left: 10px;\n  margin-right: 10px;\n'],['\n  font-family: ',';\n  font-size: 20px;\n  color: black;\n  text-align: center;\n  font-weight: 100;\n  margin-left: 10px;\n  margin-right: 10px;\n']),_templateObject20=_taggedTemplateLiteral(['\n  padding: 0px 20px 30px;\n  width: 100%;\n  margin: 0 auto;\n\n  .table_view {\n\n  }\n'],['\n  padding: 0px 20px 30px;\n  width: 100%;\n  margin: 0 auto;\n\n  .table_view {\n\n  }\n']),_templateObject21=_taggedTemplateLiteral(['\n  background-color: #fff;\n  min-height: 8vh;\n  padding: 1rem;\n  border-radius: 1rem;\n  font-family: ',';\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  font-size: 1.2rem;\n  margin: 0px 0 1rem;\n\n  .time_life {\n    color: #FFA200;\n    font-weight: bold;\n    font-size: 1.4rem;\n    margin-top: 1rem;\n    display: flex;\n    align-items: center;\n  }\n\n  input {\n    border: none;\n    display: inline-block;\n    color: #FFA200;\n    font-weight: bold;\n    font-size: 1.4rem;\n    width: 3rem;\n    text-align: center;\n  }\n\n  input: focus {\n    outline: none;\n  }\n'],['\n  background-color: #fff;\n  min-height: 8vh;\n  padding: 1rem;\n  border-radius: 1rem;\n  font-family: ',';\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  font-size: 1.2rem;\n  margin: 0px 0 1rem;\n\n  .time_life {\n    color: #FFA200;\n    font-weight: bold;\n    font-size: 1.4rem;\n    margin-top: 1rem;\n    display: flex;\n    align-items: center;\n  }\n\n  input {\n    border: none;\n    display: inline-block;\n    color: #FFA200;\n    font-weight: bold;\n    font-size: 1.4rem;\n    width: 3rem;\n    text-align: center;\n  }\n\n  input: focus {\n    outline: none;\n  }\n']),_templateObject22=_taggedTemplateLiteral(['\n  div {\n    width: 20vw;\n    background-color: #fff;\n    height: 8vh;\n    color: #212121;\n    padding: 10px;\n    border-radius: 10px;\n    font-family: ',';\n    font-weight: ',';\n    box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n    margin: 5px 0 5px;\n    display: inline-block;\n\n    @media (max-width: ','px) {\n      width: 42vw;\n    }\n\n    .title {\n      font-size: 12px;\n    }\n\n    .content {\n      font-size: 14px;\n    }\n  }\n\n  .left {\n    margin-right: 4px;\n\n    @media (max-width: ','px) {\n      margin-right: 10px;\n    }\n  }\n\n  .right {\n    margin-left: 4px;\n\n    @media (max-width: ','px) {\n      margin-left: 10px;\n    }\n  }\n\n'],['\n  div {\n    width: 20vw;\n    background-color: #fff;\n    height: 8vh;\n    color: #212121;\n    padding: 10px;\n    border-radius: 10px;\n    font-family: ',';\n    font-weight: ',';\n    box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n    margin: 5px 0 5px;\n    display: inline-block;\n\n    @media (max-width: ','px) {\n      width: 42vw;\n    }\n\n    .title {\n      font-size: 12px;\n    }\n\n    .content {\n      font-size: 14px;\n    }\n  }\n\n  .left {\n    margin-right: 4px;\n\n    @media (max-width: ','px) {\n      margin-right: 10px;\n    }\n  }\n\n  .right {\n    margin-left: 4px;\n\n    @media (max-width: ','px) {\n      margin-left: 10px;\n    }\n  }\n\n']),_templateObject23=_taggedTemplateLiteral(['\n  background-color: #fff;\n  color: #212121;\n  padding: 1rem;\n  border-radius: 10px;\n  font-family: ',';\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  font-size: 14px;\n  margin: 5px 0 5px;\n\n  img {\n    vertical-align: middle;\n    margin-right: 1rem;\n  }\n\n  > div:first-child {\n    font-size: 1.2rem;\n    margin-bottom: 1rem;\n  }\n'],['\n  background-color: #fff;\n  color: #212121;\n  padding: 1rem;\n  border-radius: 10px;\n  font-family: ',';\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  font-size: 14px;\n  margin: 5px 0 5px;\n\n  img {\n    vertical-align: middle;\n    margin-right: 1rem;\n  }\n\n  > div:first-child {\n    font-size: 1.2rem;\n    margin-bottom: 1rem;\n  }\n']),_templateObject24=_taggedTemplateLiteral(['\n  margin-bottom: 1rem;\n  white-space: nowrap;\n  background-color: #fff;\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  border-radius: 1rem;\n  padding: 1rem;\n\n  img {\n    width: 2rem;\n    margin-right: 1rem;\n  }\n\n  select {\n    color: #212121;\n    font-family: ',';\n    font-size: 1.4rem;\n    margin: 0;\n    border: none;\n    background-color: transparent;\n    border: 0;\n    width: calc(100% - 4rem);\n  }\n\n  select:focus {\n    outline: none;\n  }\n'],['\n  margin-bottom: 1rem;\n  white-space: nowrap;\n  background-color: #fff;\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  border-radius: 1rem;\n  padding: 1rem;\n\n  img {\n    width: 2rem;\n    margin-right: 1rem;\n  }\n\n  select {\n    color: #212121;\n    font-family: ',';\n    font-size: 1.4rem;\n    margin: 0;\n    border: none;\n    background-color: transparent;\n    border: 0;\n    width: calc(100% - 4rem);\n  }\n\n  select:focus {\n    outline: none;\n  }\n']),_templateObject25=_taggedTemplateLiteral(['\n  height: 100%;\n\n  .title_invite {\n    height: 50%;\n    font-family: ',';\n    font-size: 1.8rem;\n    text-align: left;\n    margin-bottom: 2rem;\n    margin-top: 2rem;\n  }\n\n  .title_name {\n    width: 15rem;\n    height: 4rem;\n    background-color: white;\n    border: 2px solid black;\n    border-radius: 2.5rem;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    flex-direction: column;\n\n\n    div {\n      font-family: ',';\n      font-size: 1.6rem;\n    }\n  }\n\n  .circle_view {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  img {\n    border: 5px solid white;\n    border-radius: 50%;\n    height: 20rem;\n    width: 20rem;\n    box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n    background: ',';\n  }\n'],['\n  height: 100%;\n\n  .title_invite {\n    height: 50%;\n    font-family: ',';\n    font-size: 1.8rem;\n    text-align: left;\n    margin-bottom: 2rem;\n    margin-top: 2rem;\n  }\n\n  .title_name {\n    width: 15rem;\n    height: 4rem;\n    background-color: white;\n    border: 2px solid black;\n    border-radius: 2.5rem;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    flex-direction: column;\n\n\n    div {\n      font-family: ',';\n      font-size: 1.6rem;\n    }\n  }\n\n  .circle_view {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  img {\n    border: 5px solid white;\n    border-radius: 50%;\n    height: 20rem;\n    width: 20rem;\n    box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n    background: ',';\n  }\n']),_templateObject26=_taggedTemplateLiteral(['\n  background-image: url(',');\n  background-size: cover;\n  border: 5px solid white;\n  border-radius: 50%;\n  height: 20rem;\n  width: 20rem;\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  position: relative;\n  .title_name {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n'],['\n  background-image: url(',');\n  background-size: cover;\n  border: 5px solid white;\n  border-radius: 50%;\n  height: 20rem;\n  width: 20rem;\n  box-shadow:  0px 3px 3px 2px rgb(0 0 0 / 0.15);\n  position: relative;\n  .title_name {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n']),_templateObject27=_taggedTemplateLiteral(['\n  max-height: 100vh;\n  display: grid;\n  grid-template-columns: auto auto auto auto auto;\n  grid-template-rows: 150px;\n  margin: 0% auto;\n\n  @media (max-width: ','px) {\n    width: 90%;\n    display: grid;\n    grid-template-columns: 30% 30% 30%;\n    grid-template-rows: 150px 150px 150px;\n  }\n\n  .avatar_name {\n    font-size: 1.2rem;\n  }\n'],['\n  max-height: 100vh;\n  display: grid;\n  grid-template-columns: auto auto auto auto auto;\n  grid-template-rows: 150px;\n  margin: 0% auto;\n\n  @media (max-width: ','px) {\n    width: 90%;\n    display: grid;\n    grid-template-columns: 30% 30% 30%;\n    grid-template-rows: 150px 150px 150px;\n  }\n\n  .avatar_name {\n    font-size: 1.2rem;\n  }\n']),_templateObject28=_taggedTemplateLiteral(['\n  padding: 0 2rem;\n  .title_network {\n    font-family: ',';\n    font-size: 1.8rem;\n    height: 2.5rem;\n    padding: 0 1rem;\n  }\n'],['\n  padding: 0 2rem;\n  .title_network {\n    font-family: ',';\n    font-size: 1.8rem;\n    height: 2.5rem;\n    padding: 0 1rem;\n  }\n']),_templateObject29=_taggedTemplateLiteral(['\n  height: 15rem;\n  padding: 1rem;\n  margin-top: 3rem;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap;\n\n\n  .title {\n    font-family: ',';\n    font-size: 1.8rem;\n  }\n\n  .container {\n    margin-top: 1rem;\n    display: inline-block;\n    padding: 1rem;\n    width: 30vw;\n    height: 15vh;\n\n  }\n\n  .text_name {\n    font-family: ',';\n    font-size: 1.2rem;\n    padding: 0.6rem;\n  }\n'],['\n  height: 15rem;\n  padding: 1rem;\n  margin-top: 3rem;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap;\n\n\n  .title {\n    font-family: ',';\n    font-size: 1.8rem;\n  }\n\n  .container {\n    margin-top: 1rem;\n    display: inline-block;\n    padding: 1rem;\n    width: 30vw;\n    height: 15vh;\n\n  }\n\n  .text_name {\n    font-family: ',';\n    font-size: 1.2rem;\n    padding: 0.6rem;\n  }\n']),_templateObject30=_taggedTemplateLiteral(['\n  width: 100%;\n  text-align: center;\n  margin-top: 2rem;\n  z-index: 100;\n\n  @media (max-width: ','px) {\n    margin-bottom: 10rem;\n  }\n'],['\n  width: 100%;\n  text-align: center;\n  margin-top: 2rem;\n  z-index: 100;\n\n  @media (max-width: ','px) {\n    margin-bottom: 10rem;\n  }\n']),_templateObject31=_taggedTemplateLiteral(['\n  width: 4rem;\n  height: 4rem;\n  z-index: 10;\n  position: absolute;\n  top: ',';\n  left: ',';\n'],['\n  width: 4rem;\n  height: 4rem;\n  z-index: 10;\n  position: absolute;\n  top: ',';\n  left: ',';\n']),_templateObject32=_taggedTemplateLiteral(['\n  margin-right: 1rem;\n  max-width: 45rem;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n  display: inline-block;\n  vertical-align: top;\n  border-radius: 1.5rem;\n  padding: 1rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border: 0.1rem solid #e9e9e9;\n  width: 30rem;\n  white-space: normal;\n  min-height: 10rem;\n  margin-top: 1rem;\n  position: relative;\n\n  > div {\n    display: grid;\n    grid-template-columns: 7rem auto;\n  }\n\n  .userContent {\n    margin-left: 1rem;\n  }\n\n  .name{\n    font-size: 1.4rem;\n    font-family: ',';\n    line-height: 1.8rem;\n    width: calc(100% - 3rem);\n  }\n  .contributions{\n    > div:first-child {\n      font-size: 1.2rem;\n      margin-top: 1rem;\n      font-family: ',';\n      white-space: normal;\n      margin-bottom: 0.5rem;\n    }\n\n    .contribution {\n      display: inline-block;\n      margin: 0.5rem 0.5rem 0 0;\n    }\n  }\n  button {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin: 0;\n  }\n'],['\n  margin-right: 1rem;\n  max-width: 45rem;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n  display: inline-block;\n  vertical-align: top;\n  border-radius: 1.5rem;\n  padding: 1rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border: 0.1rem solid #e9e9e9;\n  width: 30rem;\n  white-space: normal;\n  min-height: 10rem;\n  margin-top: 1rem;\n  position: relative;\n\n  > div {\n    display: grid;\n    grid-template-columns: 7rem auto;\n  }\n\n  .userContent {\n    margin-left: 1rem;\n  }\n\n  .name{\n    font-size: 1.4rem;\n    font-family: ',';\n    line-height: 1.8rem;\n    width: calc(100% - 3rem);\n  }\n  .contributions{\n    > div:first-child {\n      font-size: 1.2rem;\n      margin-top: 1rem;\n      font-family: ',';\n      white-space: normal;\n      margin-bottom: 0.5rem;\n    }\n\n    .contribution {\n      display: inline-block;\n      margin: 0.5rem 0.5rem 0 0;\n    }\n  }\n  button {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin: 0;\n  }\n']),_templateObject33=_taggedTemplateLiteral(['\n  background-color: #f9f9f9;\n  border-radius: 4rem;\n  max-width: 90%;\n  width: 60rem;\n  margin: 2rem auto;\n  text-align: center;\n  padding: 2rem;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  .message_success {\n    font-size: 1.4rem;\n    font-family: ',';\n    margin: 2rem;\n    color: #707070;\n  }\n\n  .buttons {\n    width: 50%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  .welcome {\n    margin-top: 2rem;\n    border-radius: 20px;\n    border: 0px;\n    color: #1976d2;\n    background-color: #fff;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n    padding: 10px 20px;\n    letter-spacing: 1px;\n    font-size: 1.2rem;\n  }\n'],['\n  background-color: #f9f9f9;\n  border-radius: 4rem;\n  max-width: 90%;\n  width: 60rem;\n  margin: 2rem auto;\n  text-align: center;\n  padding: 2rem;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  .message_success {\n    font-size: 1.4rem;\n    font-family: ',';\n    margin: 2rem;\n    color: #707070;\n  }\n\n  .buttons {\n    width: 50%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  .welcome {\n    margin-top: 2rem;\n    border-radius: 20px;\n    border: 0px;\n    color: #1976d2;\n    background-color: #fff;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n    padding: 10px 20px;\n    letter-spacing: 1px;\n    font-size: 1.2rem;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var TitleBack=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var FormWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var InputName=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__["default"])(_templateObject4,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].label(_templateObject5,function(props){return props.image?'0px':'30px 20px';});var InputDescription=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__["default"]).attrs({multiline:true,rows:4})(_templateObject6,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var BtnSubmit=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject7,function(props){return props.status?'#fff':'#000';},function(props){return props.status?'#196CBF':'#CACACA';},__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var ErrorLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var highlight=function highlight(backgroundColorText){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject9,backgroundColorText);};var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var IconTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11,function(props){return props.icon;});var MsgSuccess=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12);var NoThanksMsg=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13);var TagsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject14,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var TagContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject15);var TagLabel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["c" ],__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var CongratulationsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17,function(props){return props.img;});var CongratulationsTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var CongratulationsSubtitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject19,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var InvitePeopleView=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject20);var TimeLife=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject21,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var SpeedDating=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject22,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].lightWeight,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var PrivateTable=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject23,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var CreatedIn=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject24,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var InvitePeople=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject25,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,function(props){return props.img;});var CircleImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject26,function(props){return props.img;});var MyNetworkGrid=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject27,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var MyNetworkWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject28,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var PeopleSelected=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject29,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var InviteButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject30,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var UserAround=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject31,function(props){return props.top;},function(props){return props.left;});var UserWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject32,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var CongratulationsModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject33,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1281);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return getCallForImpact; });

 __webpack_require__.d(__webpack_exports__, "b", function() { return getPublicCallsForImpact; });
 var __WEBPACK_IMPORTED_MODULE_0_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(359);
var getCallForImpact=function getCallForImpact(id){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["b" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'callforimpact/'+id}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["c" ],payload:{data:data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));}).catch(function(error){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["a" ],payload:{error:error}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));});};};var getCallForImpactContent=function getCallForImpactContent(id){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'callforimpact/'+id+'/content'});};var getPublicCallsForImpact=function getPublicCallsForImpact(params){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'public/callsforimpact'},params);};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "e", function() { return ListStyled; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return PrintUsers; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return BubbleWrapper; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return Searcher; });

 __webpack_require__.d(__webpack_exports__, "d", function() { return ListItem; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return ListWrapper; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return TagsWrapper; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return TagLabel; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return Icon; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return CreatorMargin; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n'],['\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 10px auto 50px;\n'],['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 10px auto 50px;\n']),_templateObject3=_taggedTemplateLiteral(['\n  margin: 10px auto 50px;\n  text-align: center;\n'],['\n  margin: 10px auto 50px;\n  text-align: center;\n']),_templateObject4=_taggedTemplateLiteral(['\n  background-color: ',';\n  border-radius: 50%;\n  width: calc((((90vw - 2em) / 3)) - 25px);\n  height: calc((((90vw - 2em) / 3)) - 25px);\n  line-height: 18px;;\n  color: #fff;\n  text-align: center;\n  vertical-align: middle;\n  overflow: hidden;\n  margin: 0px 0px 13px 13px;\n  font-size: min(16px, 10px + (12 - 10) * ((100vw - 320px) / (412 - 320)));\n  font-weight: 600;\n  transition: all 0.3s ease;\n  box-shadow: ',';\n  max-width: 15rem;\n  max-height: 15rem;\n  cursor: pointer;\n  line-height: 15rem;\n  display: inline-block;\n  div {\n    margin: auto;\n    width: 100%;\n    word-break: break-word;\n    color: ',';\n  }\n'],['\n  background-color: ',';\n  border-radius: 50%;\n  width: calc((((90vw - 2em) / 3)) - 25px);\n  height: calc((((90vw - 2em) / 3)) - 25px);\n  line-height: 18px;;\n  color: #fff;\n  text-align: center;\n  vertical-align: middle;\n  overflow: hidden;\n  margin: 0px 0px 13px 13px;\n  font-size: min(16px, 10px + (12 - 10) * ((100vw - 320px) / (412 - 320)));\n  font-weight: 600;\n  transition: all 0.3s ease;\n  box-shadow: ',';\n  max-width: 15rem;\n  max-height: 15rem;\n  cursor: pointer;\n  line-height: 15rem;\n  display: inline-block;\n  div {\n    margin: auto;\n    width: 100%;\n    word-break: break-word;\n    color: ',';\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  background-color: transparent;\n  width: 52.8rem;\n  height: 5vh;\n  margin-bottom: 2%;\n  margin-left: 12.8rem;\n\n  input {\n    width: 52.8rem;\n    height: 5vh;\n    border-radius: 5px !important;\n    border: 2px solid white;\n    color: #000000;\n    font-family: \'helvetica neue light\';\n    font-size: 18px;\n    outline: none;\n  }\n\n  @media (max-width: ','px){\n    width: 30rem;\n    height: 5vh;\n    margin-bottom: 2%;\n    margin-left: 25px;\n\n    input {\n      width: 30rem;\n      height: 5vh;\n      border-radius: 5px !important;\n      border: 2px solid white;\n      color: #000000;\n      font-family: \'helvetica neue light\';\n      font-size: 18px;\n      outline: none;\n    }\n  }\n'],['\n  background-color: transparent;\n  width: 52.8rem;\n  height: 5vh;\n  margin-bottom: 2%;\n  margin-left: 12.8rem;\n\n  input {\n    width: 52.8rem;\n    height: 5vh;\n    border-radius: 5px !important;\n    border: 2px solid white;\n    color: #000000;\n    font-family: \'helvetica neue light\';\n    font-size: 18px;\n    outline: none;\n  }\n\n  @media (max-width: ','px){\n    width: 30rem;\n    height: 5vh;\n    margin-bottom: 2%;\n    margin-left: 25px;\n\n    input {\n      width: 30rem;\n      height: 5vh;\n      border-radius: 5px !important;\n      border: 2px solid white;\n      color: #000000;\n      font-family: \'helvetica neue light\';\n      font-size: 18px;\n      outline: none;\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  text-align: left;\n'],['\n  text-align: left;\n']),_templateObject7=_taggedTemplateLiteral(['\n  background-color: ',';\n  color: ',';\n  font-family: \'helvetica neue light\';\n  font-size: 18px;\n  text-align: left;\n  width: ',';\n  ','\n  margin-left: 5px;\n  margin-bottom: 5px;\n  padding: ',';\n  border: 1px solid #fff;\n  border-radius: 5px;\n  display: inline-block;\n  text-align: left;\n  transition: all 0.2s ease;\n  cursor: pointer;\n'],['\n  background-color: ',';\n  color: ',';\n  font-family: \'helvetica neue light\';\n  font-size: 18px;\n  text-align: left;\n  width: ',';\n  ','\n  margin-left: 5px;\n  margin-bottom: 5px;\n  padding: ',';\n  border: 1px solid #fff;\n  border-radius: 5px;\n  display: inline-block;\n  text-align: left;\n  transition: all 0.2s ease;\n  cursor: pointer;\n']),_templateObject8=_taggedTemplateLiteral(['\n  width: 90%;\n  ','\n'],['\n  width: 90%;\n  ','\n']),_templateObject9=_taggedTemplateLiteral(['\n  text-align: left;\n  padding: 0px 20px;\n'],['\n  text-align: left;\n  padding: 0px 20px;\n']),_templateObject10=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  background-color: #fff;\n  font-size: 12px;\n  padding: 5px;\n  color: #4d4d4d;\n  border-radius: 5px;\n  margin-top: 1rem;\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  background-color: #fff;\n  font-size: 12px;\n  padding: 5px;\n  color: #4d4d4d;\n  border-radius: 5px;\n  margin-top: 1rem;\n']),_templateObject11=_taggedTemplateLiteral(['\n  height: 100%;\n  width: 100%;\n  border: ',';\n  max-width: 129px;\n  img {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n  }\n  opacity: ',';\n'],['\n  height: 100%;\n  width: 100%;\n  border: ',';\n  max-width: 129px;\n  img {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n  }\n  opacity: ',';\n']),_templateObject12=_taggedTemplateLiteral(['\n  height: 150px;\n'],['\n  height: 150px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// shake
var ListStyled=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var BubblesWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject2);var ListProperties=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject3);var PrintUsers=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var BubbleWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return props.selected?'rgba(51, 51, 51, 0.51)':'rgba(255, 255, 255, 0.6)';},function(props){return props.selected?'0px 0px 0px 6px rgba(255,255,255,0.6)':'none';},function(props){return props.selected?'#fff':props.color;});var Searcher=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var ListItemWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var ListItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7,function(props){return props.selected?'#ffffff':'transparent';},function(props){return props.selected?props.color:'#ffffff';},function(props){return props.isSdg?'30%':'';},function(props){return props.isSdg?'max-width: 129px;':'';},function(props){return props.isSdg?'0px':'8px';});var ListWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,function(props){return props.view==='bubbles'?BubblesWrapper:ListProperties;});var TagsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);var TagLabel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10);var Icon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11,function(props){return props.selected?'2px solid #fff':'none';},function(props){return props.selected?'1':'0.3';});var CreatorMargin=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1421);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(137);


 __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" ];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_drag__ = __webpack_require__(1455);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_drag__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_nodrag__ = __webpack_require__(510);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["a"]; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["b"]; });




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(278);


 __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" ].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" ][prefix], local: name} : name;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

 __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

 __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
 __webpack_exports__["a"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

 __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(281);


 __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["c" ], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(60);
 var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(513);
 var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(516);
 var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(517);
 var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(187);
 var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(518);
 var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(519);
 var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(515);









 __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" ])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" ]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" ])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" ]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" ])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" ] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" ]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" ]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" ]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" ]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" ])(a, b);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = Color;
 __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
 __webpack_exports__["e"] = color;
 __webpack_exports__["h"] = rgbConvert;
 __webpack_exports__["g"] = rgb;
 __webpack_exports__["b"] = Rgb;

 __webpack_exports__["f"] = hsl;
 var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(285);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" ])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" ])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" ])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" ])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" ])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));


function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = extend;
 __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

 __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_selection_index__ = __webpack_require__(1504);
 var __WEBPACK_IMPORTED_MODULE_1__src_transition_index__ = __webpack_require__(79);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_transition_index__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_active__ = __webpack_require__(1535);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_active__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_interrupt__ = __webpack_require__(520);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__src_interrupt__["a"]; });






 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = now;
 __webpack_exports__["a"] = Timer;
 __webpack_exports__["c"] = timer;
 __webpack_exports__["d"] = timerFlush;
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

 __webpack_exports__["a"] = (map);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_dsv__ = __webpack_require__(291);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dsv__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_csv__ = __webpack_require__(1550);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["c"]; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["d"]; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["a"]; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_tsv__ = __webpack_require__(1551);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["c"]; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["d"]; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["a"]; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["b"]; });





 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EOL = {},
    EOF = {},
    QUOTE = 34,
    NEWLINE = 10,
    RETURN = 13;

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "]";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

 __webpack_exports__["a"] = (function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      DELIMITER = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }

  function parseRows(text, f) {
    var rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // current line number
        t, // current token
        eof = N <= 0, // current token followed by EOF?
        eol = false; // current token followed by EOL?

    // Strip the trailing newline.
    if (text.charCodeAt(N - 1) === NEWLINE) --N;
    if (text.charCodeAt(N - 1) === RETURN) --N;

    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;

      // Unescape quotes.
      var i, j = I, c;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
        if ((i = I) >= N) eof = true;
        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
      }

      // Find next delimiter or newline.
      while (I < N) {
        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        else if (c !== DELIMITER) continue;
        return text.slice(j, i);
      }

      // Return last token before EOF.
      return eof = true, text.slice(j, N);
    }

    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f && (row = f(row, n++)) == null) continue;
      rows.push(row);
    }

    return rows;
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    })).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(text) {
    return text == null ? ""
        : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\""
        : text;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatRows: formatRows
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  return (Math.random() - 0.5) * 1e-6;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_quadtree__ = __webpack_require__(1555);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_quadtree__["a"]; });



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(1573);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(525);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_locale__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(526);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(1579);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(1580);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(1581);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
 __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return x;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = conicEqualAreaRaw;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(299);
 var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__ = __webpack_require__(1598);




function conicEqualAreaRaw(y0, y1) {
  var sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y0), n = (sy0 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" ])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" ]) return Object(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__["a" ])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(c) / n;

  function project(x, y) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(c - 2 * n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y)) / n;
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(x *= n), r0 - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" ])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" ])(r0y)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" ])(r0y), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" ])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

 __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" ])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = conicProjection;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(61);



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math__["o" ] / 3,
      m = Object(__WEBPACK_IMPORTED_MODULE_1__index__["b" ])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" ], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" ]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" ], phi1 * __WEBPACK_IMPORTED_MODULE_0__math__["h" ]];
  };

  return p;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = fitExtent;
 __webpack_exports__["c"] = fitSize;
 __webpack_exports__["d"] = fitWidth;
 __webpack_exports__["b"] = fitHeight;
 var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(102);
 var __WEBPACK_IMPORTED_MODULE_1__path_bounds__ = __webpack_require__(541);



function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  Object(__WEBPACK_IMPORTED_MODULE_0__stream__["a" ])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" ]));
  fitBounds(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" ].result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}

function fitExtent(projection, extent, object) {
  return fit(projection, function(b) {
    var w = extent[1][0] - extent[0][0],
        h = extent[1][1] - extent[0][1],
        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

function fitWidth(projection, width, object) {
  return fit(projection, function(b) {
    var w = +width,
        k = w / (b[1][0] - b[0][0]),
        x = (w - k * (b[1][0] + b[0][0])) / 2,
        y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitHeight(projection, height, object) {
  return fit(projection, function(b) {
    var h = +height,
        k = h / (b[1][1] - b[0][1]),
        x = -k * b[0][0],
        y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["c"] = mercatorRaw;
 __webpack_exports__["b"] = mercatorProjection;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__rotation__ = __webpack_require__(191);
 var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(61);




function mercatorRaw(lambda, phi) {
  return [lambda, Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" ])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" ])((__WEBPACK_IMPORTED_MODULE_0__math__["l" ] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" ])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" ])(y)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" ]];
};

 __webpack_exports__["a"] = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math__["w" ]);
});

function mercatorProjection(project) {
  var m = Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" ])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math__["o" ] * scale(),
        t = m(Object(__WEBPACK_IMPORTED_MODULE_1__rotation__["a" ])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["c"] = hierarchy;
 __webpack_exports__["b"] = computeHeight;
 __webpack_exports__["a"] = Node;
 var __WEBPACK_IMPORTED_MODULE_0__count__ = __webpack_require__(1612);
 var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__(1613);
 var __WEBPACK_IMPORTED_MODULE_2__eachBefore__ = __webpack_require__(1614);
 var __WEBPACK_IMPORTED_MODULE_3__eachAfter__ = __webpack_require__(1615);
 var __WEBPACK_IMPORTED_MODULE_4__sum__ = __webpack_require__(1616);
 var __WEBPACK_IMPORTED_MODULE_5__sort__ = __webpack_require__(1617);
 var __WEBPACK_IMPORTED_MODULE_6__path__ = __webpack_require__(1618);
 var __WEBPACK_IMPORTED_MODULE_7__ancestors__ = __webpack_require__(1619);
 var __WEBPACK_IMPORTED_MODULE_8__descendants__ = __webpack_require__(1620);
 var __WEBPACK_IMPORTED_MODULE_9__leaves__ = __webpack_require__(1621);
 var __WEBPACK_IMPORTED_MODULE_10__links__ = __webpack_require__(1622);












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count__["a" ],
  each: __WEBPACK_IMPORTED_MODULE_1__each__["a" ],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter__["a" ],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore__["a" ],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum__["a" ],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort__["a" ],
  path: __WEBPACK_IMPORTED_MODULE_6__path__["a" ],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors__["a" ],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants__["a" ],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves__["a" ],
  links: __WEBPACK_IMPORTED_MODULE_10__links__["a" ],
  copy: node_copy
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = optional;
 __webpack_exports__["b"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
 __webpack_exports__["c"] = squarifyRatio;
 var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(142);
 var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(194);



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" ])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" ])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

 __webpack_exports__["a"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(139);
 var __WEBPACK_IMPORTED_MODULE_1_d3_dispatch__ = __webpack_require__(100);



 __webpack_exports__["a"] = (function(url, callback) {
  var request,
      event = Object(__WEBPACK_IMPORTED_MODULE_1_d3_dispatch__["a" ])("beforesend", "progress", "load", "error"),
      mimeType,
      headers = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["c" ])(),
      xhr = new XMLHttpRequest,
      user = null,
      password = null,
      response,
      responseType,
      timeout = 0;

  // If IE does not support CORS, use XDomainRequest.
  if (typeof XDomainRequest !== "undefined"
      && !("withCredentials" in xhr)
      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;

  "onload" in xhr
      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };

  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr)
        || status >= 200 && status < 300
        || status === 304) {
      if (response) {
        try {
          result = response.call(request, xhr);
        } catch (e) {
          event.call("error", request, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request, result);
    } else {
      event.call("error", request, o);
    }
  }

  xhr.onprogress = function(e) {
    event.call("progress", request, e);
  };

  request = {
    header: function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers.get(name);
      if (value == null) headers.remove(name);
      else headers.set(name, value + "");
      return request;
    },

    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return request;
    },

    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return request;
    },

    timeout: function(value) {
      if (!arguments.length) return timeout;
      timeout = +value;
      return request;
    },

    user: function(value) {
      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
    },

    password: function(value) {
      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
    },

    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value) {
      response = value;
      return request;
    },

    // Alias for send("GET", …).
    get: function(data, callback) {
      return request.send("GET", data, callback);
    },

    // Alias for send("POST", …).
    post: function(data, callback) {
      return request.send("POST", data, callback);
    },

    // If callback is non-null, it will be used for error and load events.
    send: function(method, data, callback) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",* }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(308);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["d"]; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["e"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(555);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_locale__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(556);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(1677);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__src_isoParse__["a"]; });






 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return timeFormat; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return timeParse; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return utcFormat; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return utcParse; });
 __webpack_exports__["a"] = defaultLocale;
 var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(555);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" ])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(101);
 var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(104);
 var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(198);
 var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(310);





 __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" ],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" ],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" ],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" ])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = x;
 __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = point;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(145);
 var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(201);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" ]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" ]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

 __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" ](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = sum;
 var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(147);


 __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" ])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = RedBlackNode;
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

 __webpack_exports__["b"] = (RedBlackTree);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["c"] = createEdge;
 __webpack_exports__["b"] = createBorderEdge;
 __webpack_exports__["d"] = setEdgeEnd;
 __webpack_exports__["a"] = clipEdges;
 var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__(148);


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" ].push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" ][left.index].halfedges.push(index);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" ][right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" ].length,
      edge;

  while (i--) {
    if (!connectEdge(edge = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" ][i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" ]
            || Math.abs(edge[0][1] - edge[1][1]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" ])) {
      delete __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" ][i];
    }
  }
}


 }),

 (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1731),
    isObjectLike = __webpack_require__(150);


function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


 }),

 (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105),
    root = __webpack_require__(71);


var Map = getNative(root, 'Map');

module.exports = Map;


 }),

 (function(module, exports) {


function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


 }),

 (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1748),
    mapCacheDelete = __webpack_require__(1755),
    mapCacheGet = __webpack_require__(1757),
    mapCacheHas = __webpack_require__(1758),
    mapCacheSet = __webpack_require__(1759);


function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


 }),

 (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1776),
    baseKeys = __webpack_require__(1783),
    isArrayLike = __webpack_require__(585);


function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


 }),

 (function(module, exports) {


var MAX_SAFE_INTEGER = 9007199254740991;


function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


 }),

 (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(72),
    isSymbol = __webpack_require__(322);


var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;


function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


 }),

 (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(149),
    isObjectLike = __webpack_require__(150);


var symbolTag = '[object Symbol]';


function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(596);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}


function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
 var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = connectAdvanced;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(73);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(210);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(62);
 var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(122);
 var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
 var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(47);
 var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
 var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
 var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(610);
 var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
 var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(612);
 var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(324);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(

selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" ])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" ], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" ], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" ], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" ])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      

    });

    var Connect =
    
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" ])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" ])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" ](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" ])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = wrapMapToPropsConstant;

 __webpack_exports__["b"] = wrapMapToPropsFunc;
 var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(327);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(619);
 var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(209);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" ])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" ])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_SESSION_SUCCESS = exports.GET_SESSION_SUCCESS = '@@redux-react-session/GET_SESSION_SUCCESS';
var GET_SESSION_ERROR = exports.GET_SESSION_ERROR = '@@redux-react-session/GET_SESSION_ERROR';
var GET_USER_SESSION_SUCCESS = exports.GET_USER_SESSION_SUCCESS = '@@redux-react-session/GET_USER_SESSION_SUCCESS';
var GET_USER_SESSION_ERROR = exports.GET_USER_SESSION_ERROR = '@@redux-react-session/GET_USER_SESSION_ERROR';
var INVALID_SESSION = exports.INVALID_SESSION = '@@redux-react-session/INVALID_SESSION';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(331);

 var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(332);

 var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(333);

 var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(213);

 var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(153);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(335);

 var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(336);

 var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(212);

 var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(154);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__matchPath__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(337);






















 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(107);
 var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
 var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(75);
 var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(153);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" ])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" ], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


 __webpack_exports__["a"] = (MemoryRouter);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(47);
 var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


 __webpack_exports__["a"] = (Prompt);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(107);
 var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
 var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(47);
 var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
 var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(75);
 var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(212);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" ])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" ])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" ])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" ])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" ])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


 __webpack_exports__["a"] = (Redirect);

 }),

 (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(646)


module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp


var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}


function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}


function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}


function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}


function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}


function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}


function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}


function attachKeys (re, keys) {
  re.keys = keys
  return re
}


function flags (options) {
  return options && options.sensitive ? '' : 'i'
}


function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}


function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}


function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}


function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options =  (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}


function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options =  (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path,  (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp( (path),  (keys), options)
  }

  return stringToRegexp( (path),  (keys), options)
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(107);
 var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
 var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(47);
 var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(75);
 var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(153);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" ])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};



var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" ])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" ])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" ])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" ], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


 __webpack_exports__["a"] = (StaticRouter);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(107);
 var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
 var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(47);
 var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
 var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(154);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" ])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


 __webpack_exports__["a"] = (Switch);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(647);
 var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
 var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(213);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" ], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

 __webpack_exports__["a"] = (withRouter);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_CHANGE; });
 __webpack_exports__["b"] = routerReducer;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  location: null

  
};function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { location: payload });
  }

  return state;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });








var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}


var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

var routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "c", function() { return MY_CODE_IS; });



 __webpack_require__.d(__webpack_exports__, "a", function() { return JOIN_IN_ROOM; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return LEAVE_FROM_ROOM; });




















 __webpack_require__.d(__webpack_exports__, "d", function() { return messageTypes; });
var WHATS_YOUR_CODE='whats your code';var MY_CODE_IS='my code is';var CODE_ACCEPTED='code accepted';var CODE_DENIED='code denied';var DISCONNECT='disconnect';var JOIN_IN_ROOM='join in room';var LEAVE_FROM_ROOM='leave from room';var JOINED_IN_ROOM='joined in room';var NOTIFICATION='notification';var NOTIFICATION_TO_ROOM='notification to room';var UPDATE_USERS_ROOM='update users room';var CONNECT_USER_TO_ROOM='connect user to room';var DISCONNECT_USER='disconnect user';var USER_FOCUS='user focus';var USER_BLUR='user blur';var INPUT_KEYPRESS='input keypress';var INPUT_CHANGE='input change';var CHAT_OLD_MESSAGES='chat old messages';var MESSAGE_TO_CHAT='message to chat';var USER_HAS_LEFT_THE_CHAT='user has left the chat';var USER_HAS_ENTER_THE_CHAT='user has enter the chat';var USER_IS_WRITING_IN_CHAT='user is writing in chat';var USER_IS_WATCHING_THE_CHAT='user is watching the chat';var USER_IS_NOT_WATCHING_THE_CHAT='user is not watching the chat';var DELETE_CHAT='delete chat';var NOTIFICATION_TO_USER='notification to user';var FORCEDISCONNECT='forceDisconnect';var messageTypes={WHATS_YOUR_CODE:WHATS_YOUR_CODE,CODE_ACCEPTED:CODE_ACCEPTED,DISCONNECT:DISCONNECT,JOINED_IN_ROOM:JOINED_IN_ROOM,NOTIFICATION:NOTIFICATION,NOTIFICATION_TO_ROOM:NOTIFICATION_TO_ROOM,UPDATE_USERS_ROOM:UPDATE_USERS_ROOM,CONNECT_USER_TO_ROOM:CONNECT_USER_TO_ROOM,DISCONNECT_USER:DISCONNECT_USER,USER_FOCUS:USER_FOCUS,USER_BLUR:USER_BLUR,INPUT_KEYPRESS:INPUT_KEYPRESS,INPUT_CHANGE:INPUT_CHANGE,CHAT_OLD_MESSAGES:CHAT_OLD_MESSAGES,MESSAGE_TO_CHAT:MESSAGE_TO_CHAT,USER_HAS_LEFT_THE_CHAT:USER_HAS_LEFT_THE_CHAT,USER_HAS_ENTER_THE_CHAT:USER_HAS_ENTER_THE_CHAT,USER_IS_WRITING_IN_CHAT:USER_IS_WRITING_IN_CHAT,USER_IS_WATCHING_THE_CHAT:USER_IS_WATCHING_THE_CHAT,USER_IS_NOT_WATCHING_THE_CHAT:USER_IS_NOT_WATCHING_THE_CHAT,DELETE_CHAT:DELETE_CHAT,NOTIFICATION_TO_USER:NOTIFICATION_TO_USER,FORCEDISCONNECT:FORCEDISCONNECT,CODE_DENIED:CODE_DENIED};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = cloneObject;

 __webpack_exports__["b"] = mergeDeep;
 var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function cloneObject(o){return JSON.parse(JSON.stringify(o));}function isObject(item){return item&&(typeof item==='undefined'?'undefined':_typeof(item))==='object'&&!Array.isArray(item);}function mergeDeep(target){for(var _len=arguments.length,sources=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){sources[_key-1]=arguments[_key];}if(!sources.length)return target;var source=sources.shift();if(isObject(target)&&isObject(source)){__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(Object.keys(source),function(key){if(isObject(source[key])){if(!target[key])Object.assign(target,_defineProperty({},key,{}));mergeDeep(target[key],source[key]);}else{Object.assign(target,_defineProperty({},key,source[key]));}});}return mergeDeep.apply(undefined,[target].concat(sources));}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PLATFORM_LANGUAGE; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ADDITIONAL_LANGUAGE; });
var SET_PLATFORM_LANGUAGE='SET_PLATFORM_LANGUAGE';var SET_ADDITIONAL_LANGUAGE='SET_ADDITIONAL_LANGUAGE';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return selectDashboardElement; });



 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5_routes_MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(685);
var _ACTION_HANDLERS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INITIAL_STATE={elements:null,selectedElements:[],visitedElements:[]};var selectDashboardElement=function selectDashboardElement(type,id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ])());dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["b" ],element:{type:type,id:id}});};};var unselectDashboardElement=function unselectDashboardElement(type,id){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["e" ],element:{type:type,id:id}});};};var goToNextElement=function goToNextElement(){return function(dispatch,getState){var _getState$dashboard=getState().dashboard,elements=_getState$dashboard.elements,visitedElements=_getState$dashboard.visitedElements;var orderElements=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(elements,function(element){return!element.disabled;}),['position']);var selectedElement=false;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(orderElements,function(element){if(!selectedElement&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(visitedElements,function(visited){return visited===element.element_id;})){selectedElement=element;visitedElements.push(selectedElement.element_id);}});if(!selectedElement){visitedElements.length=0;selectedElement=orderElements[0];visitedElements.push(selectedElement.element_id);}dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["a" ]});dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["d" ],visitedElements:visitedElements});dispatch(selectDashboardElement(selectedElement.element_type,selectedElement.element_id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_routes_MainPage_modules_mainPage__["d" ])(true));};};var fetchDashboard=function fetchDashboard(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["a" ]});Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'dashboard'}).then(function(elements){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["c" ],elements:elements});});};};var ACTION_HANDLERS=(_ACTION_HANDLERS={},_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["c" ],function(state,_ref){var elements=_ref.elements;return Object.assign({},state,{elements:elements});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["a" ],function(state){return Object.assign({},state,{selectedElements:[]});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["b" ],function(state,_ref2){var element=_ref2.element;var visitedElements=state.visitedElements;visitedElements.push(element.id);return Object.assign({},state,{selectedElements:[element],visitedElements:visitedElements});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["d" ],function(state,_ref3){var visitedElements=_ref3.visitedElements;return Object.assign({},state,{visitedElements:visitedElements});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_6__types__["e" ],function(state,_ref4){var element=_ref4.element;var newElements=state.selectedElements;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(newElements,{type:element.type,id:element.id});return Object.assign({},state,{selectedElements:newElements});}),_ACTION_HANDLERS); __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(659);


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);
var settle = __webpack_require__(666);
var buildURL = __webpack_require__(668);
var parseHeaders = __webpack_require__(669);
var isURLSameOrigin = __webpack_require__(670);
var createError = __webpack_require__(347);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(671);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(667);


module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";



function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

var encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ACTUAL_CONTEXT; });

 __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_ALL; });







 __webpack_require__.d(__webpack_exports__, "d", function() { return SET_START_STEP_ID; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SPECIFIC_STEP; });
var SET_ACTUAL_CONTEXT='SET_ACTUAL_CONTEXT';var SET_NEXT_CONTEXT='SET_NEXT_CONTEXT';var RESET_ALL='RESET_ALL';var SET_ACTUAL_STEP='SET_ACTUAL_STEP';var SET_NEXT_STEP='SET_NEXT_STEP';var SET_ACTUAL_POSITION_HISTORY='SET_ACTUAL_POSITION_HISTORY';var SET_STEPS_HISTORY='SET_STEPS_HISTORY';var SET_ACTUAL_STEP_ANSWERS='SET_ACTUAL_STEP_ANSWERS';var SET_HAS_CHANGE_STEP='SET_HAS_CHANGE_STEP';var SET_SUB_STEP='SET_SUB_STEP';var SET_START_STEP_ID='SET_START_STEP_ID';var SET_SPECIFIC_STEP='SET_SPECIFIC_STEP';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_LOGIN_INIT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_LOGIN_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_LOGIN_FAILURE; });
var FETCH_LOGIN_INIT='FETCH_LOGIN_INIT';var FETCH_LOGIN_SUCCESS='FETCH_LOGIN_SUCCESS';var FETCH_LOGIN_FAILURE='FETCH_LOGIN_FAILURE';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return setQueryString; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return search; });
 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(696);
var _ACTION_HANDLERS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INITIAL_STATE={results:[],q:'',size:9,canLoadMore:false,isLoading:false};var setQueryString=function setQueryString(q){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["c" ],q:q});};};var search=function search(){return function(dispatch,getState){var _getState$searcher=getState().searcher,q=_getState$searcher.q,size=_getState$searcher.size,prevResults=_getState$searcher.results,isLoading=_getState$searcher.isLoading;if(!isLoading){var params={q:q,size:size,offset:prevResults.length};dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["b" ],isLoading:true});Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'search'},params).then(function(results){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["d" ],results:prevResults.concat(results)});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["a" ],canLoadMore:results.length>=size});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["b" ],isLoading:false});});}};};var ACTION_HANDLERS=(_ACTION_HANDLERS={},_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_2__types__["c" ],function(state,_ref){var q=_ref.q;return Object.assign({},state,{q:q,results:[],canLoadMore:false});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_2__types__["d" ],function(state,_ref2){var results=_ref2.results;return Object.assign({},state,{results:results});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_2__types__["a" ],function(state,_ref3){var canLoadMore=_ref3.canLoadMore;return Object.assign({},state,{canLoadMore:canLoadMore});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_2__types__["b" ],function(state,_ref4){var isLoading=_ref4.isLoading;return Object.assign({},state,{isLoading:isLoading});}),_ACTION_HANDLERS); __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "k", function() { return GET_MY_THINK_TANKS_DATA_INIT; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return GET_MY_THINK_TANKS_DATA_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return GET_MY_THINK_TANKS_DATA_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return GET_THINK_TANK_DATA_INIT; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return GET_THINK_TANK_DATA_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return GET_THINK_TANK_DATA_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "v", function() { return GET_THINK_TANK_TOOLS_INIT; });
 __webpack_require__.d(__webpack_exports__, "w", function() { return GET_THINK_TANK_TOOLS_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "u", function() { return GET_THINK_TANK_TOOLS_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_THINK_TANK_IMAGE_INIT; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_THINK_TANK_IMAGE_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_THINK_TANK_IMAGE_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "J", function() { return REQUEST_THINK_TANK_INIT; });
 __webpack_require__.d(__webpack_exports__, "K", function() { return REQUEST_THINK_TANK_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "I", function() { return REQUEST_THINK_TANK_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "D", function() { return REQUEST_ACCEPT_THINK_TANK_INIT; });
 __webpack_require__.d(__webpack_exports__, "C", function() { return REQUEST_ACCEPT_THINK_TANK_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "E", function() { return REQUEST_ACCEPT_THINK_TANK_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "G", function() { return REQUEST_REJECT_THINK_TANK_INIT; });
 __webpack_require__.d(__webpack_exports__, "H", function() { return REQUEST_REJECT_THINK_TANK_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "F", function() { return REQUEST_REJECT_THINK_TANK_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return GET_REQUESTS_THINK_TANK_INIT; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return GET_REQUESTS_THINK_TANK_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return GET_REQUESTS_THINK_TANK_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "y", function() { return LEAVE_THINK_TANK_INIT; });
 __webpack_require__.d(__webpack_exports__, "z", function() { return LEAVE_THINK_TANK_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "x", function() { return LEAVE_THINK_TANK_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return GET_ADDITIONAL_THINKS_INIT; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return GET_ADDITIONAL_THINKS_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return GET_ADDITIONAL_THINKS_FAILURE; });

 __webpack_require__.d(__webpack_exports__, "n", function() { return GET_PROPOSED_CONTENT_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return GET_PROPOSED_CONTENT_FAILURE; });

 __webpack_require__.d(__webpack_exports__, "i", function() { return GET_ALL_PROPOSED_CONTENT_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return GET_ALL_PROPOSED_CONTENT_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "B", function() { return NOTIFICATION_TO_ROOM; });
 __webpack_require__.d(__webpack_exports__, "A", function() { return NOTIFICATION; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ADDITIONAL_THINK_TANK; });
var GET_MY_THINK_TANKS_DATA_INIT='GET_MY_THINK_TANKS_DATA_INIT';var GET_MY_THINK_TANKS_DATA_SUCCESS='GET_MY_THINK_TANKS_DATA_SUCCESS';var GET_MY_THINK_TANKS_DATA_FAILURE='GET_MY_THINK_TANKS_DATA_FAILURE';var GET_THINK_TANK_DATA_INIT='GET_THINK_TANK_DATA_INIT';var GET_THINK_TANK_DATA_SUCCESS='GET_THINK_TANK_DATA_SUCCESS';var GET_THINK_TANK_DATA_FAILURE='GET_THINK_TANK_DATA_FAILURE';var GET_THINK_TANK_TOOLS_INIT='GET_THINK_TANK_TOOLS_INIT';var GET_THINK_TANK_TOOLS_SUCCESS='GET_THINK_TANK_TOOLS_SUCCESS';var GET_THINK_TANK_TOOLS_FAILURE='GET_THINK_TANK_TOOLS_FAILURE';var CHANGE_THINK_TANK_IMAGE_INIT='CHANGE_THINK_TANK_IMAGE_INIT';var CHANGE_THINK_TANK_IMAGE_SUCCESS='CHANGE_THINK_TANK_IMAGE_SUCCESS';var CHANGE_THINK_TANK_IMAGE_FAILURE='CHANGE_THINK_TANK_IMAGE_FAILURE';var REQUEST_THINK_TANK_INIT='REQUEST_THINK_TANK_INIT';var REQUEST_THINK_TANK_SUCCESS='REQUEST_THINK_TANK_SUCCESS';var REQUEST_THINK_TANK_FAILURE='REQUEST_THINK_TANK_FAILURE';var REQUEST_ACCEPT_THINK_TANK_INIT='REQUEST_ACCEPT_THINK_TANK_INIT';var REQUEST_ACCEPT_THINK_TANK_FAILURE='REQUEST_ACCEPT_THINK_TANK_FAILURE';var REQUEST_ACCEPT_THINK_TANK_SUCCESS='REQUEST_ACCEPT_THINK_TANK_SUCCESS';var REQUEST_REJECT_THINK_TANK_INIT='REQUEST_REJECT_THINK_TANK_INIT';var REQUEST_REJECT_THINK_TANK_SUCCESS='REQUEST_REJECT_THINK_TANK_SUCCESS';var REQUEST_REJECT_THINK_TANK_FAILURE='REQUEST_REJECT_THINK_TANK_FAILURE';var GET_REQUESTS_THINK_TANK_INIT='GET_REQUESTS_THINK_TANK_INIT';var GET_REQUESTS_THINK_TANK_SUCCESS='GET_REQUESTS_THINK_TANK_SUCCESS';var GET_REQUESTS_THINK_TANK_FAILURE='GET_REQUESTS_THINK_TANK_FAILURE';var LEAVE_THINK_TANK_INIT='LEAVE_THINK_TANK_INIT';var LEAVE_THINK_TANK_SUCCESS='LEAVE_THINK_TANK_SUCCESS';var LEAVE_THINK_TANK_FAILURE='LEAVE_THINK_TANK_FAILURE';var GET_ADDITIONAL_THINKS_INIT='GET_ADDITIONAL_THINKS_INIT';var GET_ADDITIONAL_THINKS_SUCCESS='GET_ADDITIONAL_THINKS_SUCCESS';var GET_ADDITIONAL_THINKS_FAILURE='GET_ADDITIONAL_THINKS_FAILURE';var GET_PROPOSED_CONTENT_INIT='GET_PROPOSED_CONTENT_INIT';var GET_PROPOSED_CONTENT_SUCCESS='GET_PROPOSED_CONTENT_SUCCESS';var GET_PROPOSED_CONTENT_FAILURE='GET_PROPOSED_CONTENT_FAILURE';var GET_ALL_PROPOSED_CONTENT_INIT='GET_ALL_PROPOSED_CONTENT_INIT';var GET_ALL_PROPOSED_CONTENT_SUCCESS='GET_ALL_PROPOSED_CONTENT_SUCCESS';var GET_ALL_PROPOSED_CONTENT_FAILURE='GET_ALL_PROPOSED_CONTENT_FAILURE';var NOTIFICATION_TO_ROOM='notification to room';var NOTIFICATION='notification';var ADD_ADDITIONAL_THINK_TANK='ADD_ADDITIONAL_THINK_TANK';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATION_TO_ROOM; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFICATION; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_NOTIFICATION; });
var NOTIFICATION_TO_ROOM='notification to room';var NOTIFICATION='notification';var HIDE_NOTIFICATION='hide_notification';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_BOOST_INIT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_BOOST_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return SAVE_BOOST_FAILURE; });
var SAVE_BOOST_INIT='SAVE_BOOST_INIT';var SAVE_BOOST_SUCCESS='SAVE_BOOST_SUCCESS';var SAVE_BOOST_FAILURE='SAVE_BOOST_FAILURE';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_TOOL_INIT; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_TOOL_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_TOOL_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_TOOL_INIT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_TOOL_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_TOOL_FAILURE; });
var SAVE_TOOL_INIT='SAVE_TOOL_INIT';var SAVE_TOOL_SUCCESS='SAVE_TOOL_SUCCESS';var SAVE_TOOL_FAILURE='SAVE_TOOL_FAILURE';var DELETE_TOOL_INIT='DELETE_TOOL_INIT';var DELETE_TOOL_SUCCESS='DELETE_TOOL_SUCCESS';var DELETE_TOOL_FAILURE='DELETE_TOOL_FAILURE';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return GET_CALL_FOR_IMPACT_INIT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return GET_CALL_FOR_IMPACT_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return GET_CALL_FOR_IMPACT_FAILURE; });
var GET_CALL_FOR_IMPACT_INIT='GET_CALL_FOR_IMPACT_INIT';var GET_CALL_FOR_IMPACT_SUCCESS='GET_CALL_FOR_IMPACT_SUCCESS';var GET_CALL_FOR_IMPACT_FAILURE='GET_CALL_FOR_IMPACT_FAILURE';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return GET_ELEMENTS_CREATED_BY_USER_INIT; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return GET_ELEMENTS_CREATED_BY_USER_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return GET_ELEMENTS_CREATED_BY_USER_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return POST_ELEMENTS_CREATED_BY_USER_INIT; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return POST_ELEMENTS_CREATED_BY_USER_SUCCESS; });

 __webpack_require__.d(__webpack_exports__, "i", function() { return GET_ELEMENT_BY_ID_INIT; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return GET_ELEMENT_BY_ID_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return GET_ELEMENT_BY_ID_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return GET_ELEMENTS_SELECTED_INIT; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return GET_ELEMENTS_SELECTED_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return GET_ELEMENTS_SELECTED_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return GET_USER_INTERESTS_INIT; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return GET_USER_INTERESTS_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return GET_USER_INTERESTS_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_SELECTED_ELEMENT; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return REMOVE_SELECTED_ELEMENT; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return SET_ELEMENT_TYPES_SHOWN_IN_USER_CARD; });
var GET_ELEMENTS_CREATED_BY_USER_INIT='GET_ELEMENTS_CREATED_BY_USER_INIT';var GET_ELEMENTS_CREATED_BY_USER_SUCCESS='GET_ELEMENTS_CREATED_BY_USER_SUCCESS';var GET_ELEMENTS_CREATED_BY_USER_FAILURE='GET_ELEMENTS_CREATED_BY_USER_FAILURE';var POST_ELEMENTS_CREATED_BY_USER_INIT='POST_ELEMENTS_CREATED_BY_USER_INIT';var POST_ELEMENTS_CREATED_BY_USER_SUCCESS='POST_ELEMENTS_CREATED_BY_USER_SUCCESS';var POST_ELEMENTS_CREATED_BY_USER_FAILURE='POST_ELEMENTS_CREATED_BY_USER_FAILURE';var GET_ELEMENT_BY_ID_INIT='GET_ELEMENT_BY_ID_INIT';var GET_ELEMENT_BY_ID_SUCCESS='GET_ELEMENT_BY_ID_SUCCESS';var GET_ELEMENT_BY_ID_FAILURE='GET_ELEMENT_BY_ID_FAILURE';var GET_ELEMENTS_SELECTED_INIT='GET_ELEMENTS_SELECTED_INIT';var GET_ELEMENTS_SELECTED_SUCCESS='GET_ELEMENTS_SELECTED_SUCCESS';var GET_ELEMENTS_SELECTED_FAILURE='GET_ELEMENTS_SELECTED_FAILURE';var GET_USER_INTERESTS_INIT='GET_USER_INTERESTS_INIT';var GET_USER_INTERESTS_SUCCESS='GET_USER_INTERESTS_SUCCESS';var GET_USER_INTERESTS_FAILURE='GET_USER_INTERESTS_FAILURE';var ADD_SELECTED_ELEMENT='ADD_SELECTED_ELEMENT';var REMOVE_SELECTED_ELEMENT='REMOVE_SELECTED_ELEMENT';var SET_ELEMENT_TYPES_SHOWN_IN_USER_CARD='SET_ELEMENT_TYPES_SHOWN_IN_USER_CARD';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "e", function() { return GET_ZOOM_SIGNATURE_INIT; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return GET_ZOOM_SIGNATURE_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return GET_ZOOM_SIGNATURE_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return GET_ZOOM_MEETING_INIT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return GET_ZOOM_MEETING_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return GET_ZOOM_MEETING_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return NOTIFICATION_TO_ROOM; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return NOTIFICATION; });
var GET_ZOOM_SIGNATURE_INIT='GET_ZOOM_SIGNATURE_INIT';var GET_ZOOM_SIGNATURE_SUCCESS='GET_ZOOM_SIGNATURE_SUCCESS';var GET_ZOOM_SIGNATURE_FAILURE='GET_ZOOM_SIGNATURE_FAILURE';var GET_ZOOM_MEETING_INIT='GET_ZOOM_MEETING_INIT';var GET_ZOOM_MEETING_SUCCESS='GET_ZOOM_MEETING_SUCCESS';var GET_ZOOM_MEETING_FAILURE='GET_ZOOM_MEETING_FAILURE';var NOTIFICATION_TO_ROOM='notification to room';var NOTIFICATION='notification';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return PRIORITIES; });
var PRIORITIES={MEDIUM:'medium',HIGH:'high',LOW:'low'};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "e", function() { return ENABLE_ITEM_INIT; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return ENABLE_ITEM_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ENABLE_ITEM_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return DISABLE_ITEM_INIT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return DISABLE_ITEM_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return DISABLE_ITEM_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return GET_PREFERENCES_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return SET_ACTION_IN_CONTEXT; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return PUSH_ELEMENT_IN_HISTORY; });
var ENABLE_ITEM_INIT='ENABLE_ITEM_INIT';var ENABLE_ITEM_SUCCESS='ENABLE_ITEM_SUCCESS';var ENABLE_ITEM_FAILURE='ENABLE_ITEM_FAILURE';var DISABLE_ITEM_INIT='DISABLE_ITEM_INIT';var DISABLE_ITEM_SUCCESS='DISABLE_ITEM_SUCCESS';var DISABLE_ITEM_FAILURE='DISABLE_ITEM_FAILURE';var GET_PREFERENCES_SUCCESS='GET_PREFERENCES_SUCCESS';var SET_ACTION_IN_CONTEXT='SET_ACTION_IN_CONTEXT';var PUSH_ELEMENT_IN_HISTORY='PUSH_ELEMENT_IN_HISTORY';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SPEED_DATING_MEETINGS; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFICATION_TO_ROOM; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return NOTIFICATION; });
var SET_SPEED_DATING_MEETINGS='SET_SPEED_DATING_MEETINGS';var NOTIFICATION_TO_ROOM='notification to room';var NOTIFICATION='notification';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "e", function() { return GET_MY_THINK_CHATS_DATA_INIT; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return GET_MY_THINK_CHATS_DATA_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return GET_MY_THINK_CHATS_DATA_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_THINK_SEED_IMAGE_INIT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_THINK_SEED_IMAGE_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_THINK_SEED_IMAGE_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return LEAVE_THINK_CHAT; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return JOIN_THINK_CHAT; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_THINK_CHAT; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return GET_NARRATIVES_THINK_CHATS_INIT; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return GET_NARRATIVES_THINK_CHATS_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return GET_NARRATIVES_THINK_CHATS_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return GET_USER_NARRATIVES_THINK_CHATS_INIT; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return GET_USER_NARRATIVES_THINK_CHATS_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return GET_USER_NARRATIVES_THINK_CHATS_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return NOTIFICATION_TO_ROOM; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return NOTIFICATION; });
var GET_MY_THINK_CHATS_DATA_INIT='GET_MY_THINK_CHATS_DATA_INIT';var GET_MY_THINK_CHATS_DATA_SUCCESS='GET_MY_THINK_CHATS_DATA_SUCCESS';var GET_MY_THINK_CHATS_DATA_FAILURE='GET_MY_THINK_CHATS_DATA_FAILURE';var CHANGE_THINK_SEED_IMAGE_INIT='CHANGE_THINK_SEED_IMAGE_INIT';var CHANGE_THINK_SEED_IMAGE_SUCCESS='CHANGE_THINK_SEED_IMAGE_SUCCESS';var CHANGE_THINK_SEED_IMAGE_FAILURE='CHANGE_THINK_SEED_IMAGE_FAILURE';var LEAVE_THINK_CHAT='LEAVE_THINK_CHAT';var JOIN_THINK_CHAT='JOIN_THINK_CHAT';var UPDATE_THINK_CHAT='UPDATE_THINK_CHAT';var GET_NARRATIVES_THINK_CHATS_INIT='GET_NARRATIVES_THINK_CHATS_INIT';var GET_NARRATIVES_THINK_CHATS_SUCCESS='GET_NARRATIVES_THINK_CHATS_SUCCESS';var GET_NARRATIVES_THINK_CHATS_FAILURE='GET_NARRATIVES_THINK_CHATS_FAILURE';var GET_USER_NARRATIVES_THINK_CHATS_INIT='GET_USER_NARRATIVES_THINK_CHATS_INIT';var GET_USER_NARRATIVES_THINK_CHATS_SUCCESS='GET_USER_NARRATIVES_THINK_CHATS_SUCCESS';var GET_USER_NARRATIVES_THINK_CHATS_FAILURE='GET_USER_NARRATIVES_THINK_CHATS_FAILURE';var NOTIFICATION_TO_ROOM='notification to room';var NOTIFICATION='notification';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_PROFILE_INIT; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_PROFILE_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_PROFILE_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_ACCOUNT_INIT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_ACCOUNT_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_ACCOUNT_FAILURE; });
var FETCH_PROFILE_INIT='FETCH_PROFILE_INIT';var FETCH_PROFILE_SUCCESS='FETCH_PROFILE_SUCCESS';var FETCH_PROFILE_FAILURE='FETCH_PROFILE_FAILURE';var DELETE_ACCOUNT_INIT='DELETE_ACCOUNT_INIT';var DELETE_ACCOUNT_SUCCESS='DELETE_ACCOUNT_SUCCESS';var DELETE_ACCOUNT_FAILURE='DELETE_ACCOUNT_FAILURE';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_MODAL_INFORMATION; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_MODAL_INFORMATION; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_MODAL_INFORMATION_TEXT; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return SHOW_MODAL_TEXT; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return SHOW_MODAL_SWIPE_UP; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return SHOW_MODAL_SWIPE_DOWN; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return SHOW_MODAL_SWIPE_LEFT; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return SHOW_MODAL_SWIPE_RIGHT; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return SHOW_MODAL_SINGLE_PRESS; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return SHOW_MODAL_LONG_PRESS; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_MODAL_PRESS_AND_DRAG; });
var SHOW_MODAL_INFORMATION='SHOW_MODAL_INFORMATION';var HIDE_MODAL_INFORMATION='HIDE_MODAL_INFORMATION';var UPDATE_MODAL_INFORMATION_TEXT='UPDATE_MODAL_INFORMATION_TEXT';var SHOW_MODAL_TEXT='SHOW_MODAL_TEXT';var SHOW_MODAL_SWIPE_UP='SHOW_MODAL_SWIPE_UP';var SHOW_MODAL_SWIPE_DOWN='SHOW_MODAL_SWIPE_DOWN';var SHOW_MODAL_SWIPE_LEFT='SHOW_MODAL_SWIPE_LEFT';var SHOW_MODAL_SWIPE_RIGHT='SHOW_MODAL_SWIPE_RIGHT';var SHOW_MODAL_SINGLE_PRESS='SHOW_MODAL_SINGLE_PRESS';var SHOW_MODAL_LONG_PRESS='SHOW_MODAL_LONG_PRESS';var SHOW_MODAL_PRESS_AND_DRAG='SHOW_MODAL_PRESS_AND_DRAG';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_exports__["a"] = hideModalInformation;









 var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(367);
function showModalInformation(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{type:__WEBPACK_IMPORTED_MODULE_0__types__["b" ],payload:Object.assign({open:true},params)};}function hideModalInformation(){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["a" ]};}function updateModalInformationText(text){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["k" ],payload:{text:text}};}function showModalText(text){var onOpen=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var onClose=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["j" ],payload:{open:true,text:text,onOpen:onOpen,onClose:onClose}};}function showSwipeUp(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var onOpen=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var onClose=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["i" ],payload:{open:true,swipeUp:true,text:text,onOpen:onOpen,onClose:onClose}};}function showSwipeDown(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var onOpen=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var onClose=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["f" ],payload:{open:true,swipeDown:true,text:text,onOpen:onOpen,onClose:onClose}};}function showSwipeLeft(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var onOpen=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var onClose=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["g" ],payload:{open:true,swipeLeft:true,text:text,onOpen:onOpen,onClose:onClose}};}function showSwipeRight(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var onOpen=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var onClose=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["h" ],payload:{open:true,swipeRight:true,text:text,onOpen:onOpen,onClose:onClose}};}function showSinglePress(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var position=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var onOpen=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var onClose=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["e" ],payload:{open:true,singlePress:true,singlePressPosition:position,text:text,onOpen:onOpen,onClose:onClose}};}function showLongPress(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var position=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var onOpen=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var onClose=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["c" ],payload:{open:true,longPress:true,longPressPosition:position,text:text,onOpen:onOpen,onClose:onClose}};}function showPressAndDrag(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var position=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var onOpen=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var onClose=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["d" ],payload:{open:true,pressAndDrag:true,pressAndDragPosition:position,text:text,onOpen:onOpen,onClose:onClose}};}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";






var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(47);
 var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
 var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(75);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};



var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" ])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


 __webpack_exports__["a"] = (Link);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(213);
// Written in this round about way for babel-transform-imports


 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__withWidth__ = __webpack_require__(373);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withWidth__["a"]; });




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_styles__ = __webpack_require__(53);
 var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(122);
 var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
 var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(84);
 var __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__ = __webpack_require__(389);
 var __WEBPACK_IMPORTED_MODULE_9__useMediaQuery__ = __webpack_require__(792);









 // By default, returns true if screen width is the same or greater than the given breakpoint.

var isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" ].indexOf(breakpoint) <= __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" ].indexOf(width);
  }

  return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" ].indexOf(breakpoint) < __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" ].indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.

var isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" ].indexOf(width) <= __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" ].indexOf(breakpoint);
  }

  return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" ].indexOf(width) < __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" ].indexOf(breakpoint);
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$noSSR = options.noSSR,
        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
        initialWidthOption = options.initialWidth;

    function WithWidth(props) {
      var contextTheme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" ])();
      var theme = props.theme || contextTheme;

      var _getThemeProps = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["f" ])({
        theme: theme,
        name: 'MuiWithWidth',
        props: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, props)
      }),
          initialWidth = _getThemeProps.initialWidth,
          width = _getThemeProps.width,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(_getThemeProps, ["initialWidth", "width"]);

      var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
          mountedState = _React$useState[0],
          setMountedState = _React$useState[1];

      useEnhancedEffect(function () {
        setMountedState(true);
      }, []);
      

      var keys = theme.breakpoints.keys.slice().reverse();
      var widthComputed = keys.reduce(function (output, key) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var matches = Object(__WEBPACK_IMPORTED_MODULE_9__useMediaQuery__["a" ])(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null);

      var more = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
      }, withThemeOption ? {
        theme: theme
      } : {}, other); // When rendering the component on the server,
      // we have no idea about the client browser screen width.
      // In order to prevent blinks and help the reconciliation of the React tree
      // we are not rendering the child component.
      //
      // An alternative is to use the `initialWidth` property.


      if (more.width === undefined) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, more);
    }

     false ? WithWidth.propTypes = {
      
      initialWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

      
      theme: PropTypes.object,

      
      width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : void 0;

    if (false) {
      WithWidth.displayName = "WithWidth(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(WithWidth, Component);
    return WithWidth;
  };
};

 __webpack_exports__["a"] = (withWidth);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
 __webpack_exports__["a"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__createStyles__ = __webpack_require__(744);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createStyles__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

 __webpack_exports__["a"] = (isBrowser);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _unsupportedIterableToArray;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__ = __webpack_require__(377);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__["a" ])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__["a" ])(o, minLen);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ThemeContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ThemeContext.displayName = 'ThemeContext';
}

 __webpack_exports__["a"] = (ThemeContext);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "a", function() { return StylesContext; });
 __webpack_exports__["b"] = StylesProvider;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__ = __webpack_require__(160);
 var __WEBPACK_IMPORTED_MODULE_6_jss__ = __webpack_require__(83);
 var __WEBPACK_IMPORTED_MODULE_7__jssPreset__ = __webpack_require__(220);







 // Default JSS instance.

var jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["c" ])(Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" ])()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__["a" ])(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext(defaultOptions);

if (false) {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(StylesContext);

  var context = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (false) {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (false) {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["c" ])({
      plugins: Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" ])().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? StylesProvider.propTypes = {
  
  children: PropTypes.node.isRequired,

  
  disableGeneration: PropTypes.bool,

  
  generateClassName: PropTypes.func,

  
  injectFirst: PropTypes.bool,

  
  jss: PropTypes.object,

  
  serverGenerateClassName: PropTypes.func,

  
  sheetsCache: PropTypes.object,

  
  sheetsManager: PropTypes.object,

  
  sheetsRegistry: PropTypes.object
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
 __webpack_exports__["a"] = (noopTheme);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ServerStyleSheets__ = __webpack_require__(766);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ServerStyleSheets__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__styled__ = __webpack_require__(767);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__styled__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider__ = __webpack_require__(768);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ThemeProvider__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__withStyles__ = __webpack_require__(769);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withStyles__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__withTheme__ = __webpack_require__(388);

 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withTheme__["a"]; });



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = withThemeCreator;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(122);
 var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(109);







function withThemeCreator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultTheme = options.defaultTheme;

  var withTheme = function withTheme(Component) {
    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithTheme(props, ref) {
      var innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["innerRef"]);

      var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" ])() || defaultTheme;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        theme: theme,
        ref: innerRef || ref
      }, other));
    });
     false ? WithTheme.propTypes = {
      
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return new Error('Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
      })
    } : void 0;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };

  return withTheme;
} // Provide the theme object as a prop to the input component.
// It's an alternative API to useTheme().
// We encourage the usage of useTheme() where possible.

var withTheme = withThemeCreator();
 var _unused_webpack_default_export = (withTheme);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return keys; });
 __webpack_exports__["a"] = createBreakpoints;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";







 var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(59);
 var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(64);



function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return "".concat(value, "px solid");
}

var border = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
var borderTop = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
var borderRight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
var borderBottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
var borderLeft = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
var borderColor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'borderColor',
  themeKey: 'palette'
});
var borderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'borderRadius',
  themeKey: 'shape'
});
var borders = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" ])(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
 var _unused_webpack_default_export = (borders);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var responsivePropType =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
 var _unused_webpack_default_export = (responsivePropType);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";













 var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(59);
 var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(64);


var flexBasis = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'flexBasis'
});
var flexDirection = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'flexDirection'
});
var flexWrap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'flexWrap'
});
var justifyContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'justifyContent'
});
var alignItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'alignItems'
});
var alignContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'alignContent'
});
var order = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'order'
});
var flex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'flex'
});
var flexGrow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'flexGrow'
});
var flexShrink = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'flexShrink'
});
var alignSelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'alignSelf'
});
var justifyItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'justifyItems'
});
var justifySelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'justifySelf'
});
var flexbox = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" ])(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
 var _unused_webpack_default_export = (flexbox);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";












 var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(59);
 var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(64);


var gridGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridGap'
});
var gridColumnGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridColumnGap'
});
var gridRowGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridRowGap'
});
var gridColumn = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridColumn'
});
var gridRow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridRow'
});
var gridAutoFlow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridAutoColumns'
});
var gridAutoRows = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridTemplateAreas'
});
var gridArea = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'gridArea'
});
var grid = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" ])(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
 var _unused_webpack_default_export = (grid);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(59);
 var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(64);


var color = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'color',
  themeKey: 'palette'
});
var bgcolor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
var palette = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" ])(color, bgcolor);
 var _unused_webpack_default_export = (palette);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";






 var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(59);
 var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(64);


var position = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'position'
});
var zIndex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
var top = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'top'
});
var right = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'right'
});
var bottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'bottom'
});
var left = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'left'
});
 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" ])(position, zIndex, top, right, bottom, left));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";









 var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(59);
 var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(64);



function transform(value) {
  return value <= 1 ? "".concat(value * 100, "%") : value;
}

var width = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'width',
  transform: transform
});
var maxWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'maxWidth',
  transform: transform
});
var minWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'minWidth',
  transform: transform
});
var height = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'height',
  transform: transform
});
var maxHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'maxHeight',
  transform: transform
});
var minHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'minHeight',
  transform: transform
});
var sizeWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'size',
  cssProperty: 'width',
  transform: transform
});
var sizeHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'size',
  cssProperty: 'height',
  transform: transform
});
var boxSizing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'boxSizing'
});
var sizing = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" ])(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
 var _unused_webpack_default_export = (sizing);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createUnarySpacing;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(130);
 var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(391);
 var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(224);
 var __WEBPACK_IMPORTED_MODULE_3__merge__ = __webpack_require__(163);
 var __WEBPACK_IMPORTED_MODULE_4__memoize__ = __webpack_require__(791);





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = Object(__WEBPACK_IMPORTED_MODULE_4__memoize__["a" ])(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" ])(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (false) {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" ])(props, propValue, styleFromPropValue);
  }).reduce(__WEBPACK_IMPORTED_MODULE_3__merge__["a" ], {});
}

spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;
 var _unused_webpack_default_export = (spacing);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";







 var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(59);
 var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(64);


var fontFamily = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'fontFamily',
  themeKey: 'typography'
});
var fontSize = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'fontSize',
  themeKey: 'typography'
});
var fontStyle = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'fontStyle',
  themeKey: 'typography'
});
var fontWeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'fontWeight',
  themeKey: 'typography'
});
var letterSpacing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'letterSpacing'
});
var lineHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'lineHeight'
});
var textAlign = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'textAlign'
});
var typography = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" ])(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
 var _unused_webpack_default_export = (typography);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
 __webpack_exports__["a"] = (zIndex);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(794);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(159);
 var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_8__Popover__ = __webpack_require__(402);
 var __WEBPACK_IMPORTED_MODULE_9__MenuList__ = __webpack_require__(834);
 var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_11__utils_setRef__ = __webpack_require__(165);
 var __WEBPACK_IMPORTED_MODULE_12__styles_useTheme__ = __webpack_require__(84);













var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  },

  
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Menu = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Menu(props, ref) {
  var _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      _props$disableAutoFoc = props.disableAutoFocusItem,
      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$MenuListProps = props.MenuListProps,
      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
      onClose = props.onClose,
      onEntering = props.onEntering,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      PopoverClasses = props.PopoverClasses,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_12__styles_useTheme__["a" ])();
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var contentAnchorRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var getContentAnchorEl = function getContentAnchorEl() {
    return contentAnchorRef.current;
  };

  var handleEntering = function handleEntering(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  


  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (! __WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant !== "menu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (index === activeItemIndex) {
      return __WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
        ref: function ref(instance) {
          // #StrictMode ready
          contentAnchorRef.current = __WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"](instance);
          Object(__WEBPACK_IMPORTED_MODULE_11__utils_setRef__["a" ])(child.ref, instance);
        }
      });
    }

    return child;
  });
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Popover__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    getContentAnchorEl: getContentAnchorEl,
    classes: PopoverClasses,
    onClose: onClose,
    onEntering: handleEntering,
    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, PaperProps, {
      classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    open: open,
    ref: ref,
    transitionDuration: transitionDuration
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__MenuList__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    onKeyDown: handleListKeyDown,
    actions: menuListActionsRef,
    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
    autoFocusItem: autoFocusItem,
    variant: variant
  }, MenuListProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.list, MenuListProps.className)
  }), items));
});
 false ? Menu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  anchorEl: PropTypes
  
  .oneOfType([HTMLElementType, PropTypes.func]),

  
  autoFocus: PropTypes.bool,

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  disableAutoFocusItem: PropTypes.bool,

  
  MenuListProps: PropTypes.object,

  
  onClose: PropTypes.func,

  
  onEnter: PropTypes.func,

  
  onEntered: PropTypes.func,

  
  onEntering: PropTypes.func,

  
  onExit: PropTypes.func,

  
  onExited: PropTypes.func,

  
  onExiting: PropTypes.func,

  
  open: PropTypes.bool.isRequired,

  
  PaperProps: PropTypes.object,

  
  PopoverClasses: PropTypes.object,

  
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" ])(styles, {
  name: 'MuiMenu'
})(Menu));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Popover__ = __webpack_require__(817);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popover__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ariaHidden;
 __webpack_require__.d(__webpack_exports__, "b", function() { return ModalManager; });
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(383);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(221);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(127);
 var __WEBPACK_IMPORTED_MODULE_3__utils_getScrollbarSize__ = __webpack_require__(404);
 var __WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__ = __webpack_require__(77);
 var __WEBPACK_IMPORTED_MODULE_5__utils_ownerWindow__ = __webpack_require__(226);





 // Is a vertical scrollbar displayed?

function isOverflowing(container) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__["a" ])(container);

  if (doc.body === container) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__utils_ownerWindow__["a" ])(doc).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" ])(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}

function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      var scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_3__utils_getScrollbarSize__["a" ])();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

      fixedNodes = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__["a" ])(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedNodes, function (node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: 'overflow',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  var restore = function restore() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function (node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty('padding-right');
        }
      });
    }

    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
          el = _ref.el,
          key = _ref.key;

      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}



var ModalManager = function () {
  function ModalManager() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" ])(this, ModalManager);

    // this.modals[modalIndex] = modal
    this.modals = []; // this.containers[containerIndex] = {
    //   modals: [],
    //   container,
    //   restore: null,
    // }

    this.containers = [];
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" ])(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex !== -1) {
        return modalIndex;
      }

      modalIndex = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }

      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });

      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }

      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];

      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex === -1) {
        return modalIndex;
      }

      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }

        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, true);
        }

        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }

      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = getScrollbarSize;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ({
  disabled: false
});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var timeoutsShape =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape =  false ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(62);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(210);
 var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(73);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
 var __WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__ = __webpack_require__(229);
 var __WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__ = __webpack_require__(831);









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};


var TransitionGroup = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" ])(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" ])(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["b" ])(nextProps, handleExited) : Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["c" ])(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["a" ])(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" ])(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" ].Provider, {
        value: contextValue
      }, children);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" ].Provider, {
      value: contextValue
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, props, children));
  };

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TransitionGroup.propTypes =  false ? {
  
  component: PropTypes.any,

  
  children: PropTypes.node,

  
  appear: PropTypes.bool,

  
  enter: PropTypes.bool,

  
  exit: PropTypes.bool,

  
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
 __webpack_exports__["a"] = (TransitionGroup);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__MenuItem__ = __webpack_require__(838);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuItem__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ListItem__ = __webpack_require__(839);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItem__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_exports__["a"] = useIsFocusVisible;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};


function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}



function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}



function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}



function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    var node = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(isFocusVisible);
  }

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundPosition = getBoundPosition;
exports.snapToGrid = snapToGrid;
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.getControlPosition = getControlPosition;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;

var _shims = __webpack_require__(170);

var _domFns = __webpack_require__(234);

function getBoundPosition(draggable

, x

, y

)

{
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y]; // Clone new bounds

  var bounds = draggable.props.bounds;
  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;
    var ownerWindow = ownerDocument.defaultView;
    var boundNode;

    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }

    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }

    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.

    bounds = {
      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
    };
  } // Keep x and y below right and bottom limits...


  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.

  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
  return [x, y];
}

function snapToGrid(grid

, pendingX

, pendingY

)

{
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable

)

{
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable

)

{
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
} // Get {x, y} positions from event.


function getControlPosition(e

, touchIdentifier

, draggableCore

)

{
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch

  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.

  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
} // Create an data object exposed by <DraggableCore>'s events


function createCoreData(draggable

, x

, y

)

{
  var state = draggable.state;
  var isStart = !(0, _shims.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x: x,
      y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX,
      deltaY: y - state.lastY,
      lastX: state.lastX,
      lastY: state.lastY,
      x: x,
      y: y
    };
  }
} // Create an data exposed by <Draggable>'s events


function createDraggableData(draggable

, coreData

)

{
  var scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
} // A lot faster than stringify/parse


function cloneBounds(bounds

)

{
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable

)

{
  var node = draggable.findDOMNode();

  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME


  return node;
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;


function log() {
  var _console;

  if (undefined) (_console = console).log.apply(_console, arguments);
}

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ChampionUser.c94d9a58.svg";

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.autocompleteOptions = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _constants = _interopRequireDefault(__webpack_require__(66));

var _idgen = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Autocomplete = function Autocomplete(_ref) {
  var className = _ref.className,
      title = _ref.title,
      icon = _ref.icon,
      s = _ref.s,
      m = _ref.m,
      l = _ref.l,
      xl = _ref.xl,
      id = _ref.id,
      options = _ref.options,
      rest = _objectWithoutProperties(_ref, ["className", "title", "icon", "s", "m", "l", "xl", "id", "options"]);

  var autocompleteRef = (0, _react.useRef)(null);
  var sizes = {
    s: s,
    m: m,
    l: l,
    xl: xl
  };
  var classes = {
    col: true
  };

  _constants.default.SIZES.forEach(function (size) {
    classes[size + sizes[size]] = sizes[size];
  });

  (0, _react.useEffect)(function () {
    M.updateTextFields();
    var instance = M.Autocomplete.init(autocompleteRef.current, options);
    return function () {
      instance && instance.destroy();
    };
  }, [options]);
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('input-field', className, classes)
  }, icon && (0, _react.cloneElement)(icon, {
    className: 'prefix'
  }), _react.default.createElement("input", _extends({
    className: "autocomplete",
    type: "text",
    ref: autocompleteRef,
    id: id
  }, rest)), _react.default.createElement("label", {
    htmlFor: id
  }, title));
};

var autocompleteOptions = _propTypes.default.shape({
  
  data: _propTypes.default.objectOf(_propTypes.default.string),

  
  limit: _propTypes.default.number,

  
  onAutocomplete: _propTypes.default.func,

  
  minLength: _propTypes.default.number,

  
  sortFunction: _propTypes.default.func
});

exports.autocompleteOptions = autocompleteOptions;
Autocomplete.propTypes = {
  
  id: _propTypes.default.string,
  className: _propTypes.default.string,

  
  title: _propTypes.default.string,

  
  icon: _propTypes.default.node,
  s: _propTypes.default.number,
  m: _propTypes.default.number,
  l: _propTypes.default.number,
  xl: _propTypes.default.number,

  
  placeholder: _propTypes.default.string,

  
  onChange: _propTypes.default.func,

  
  value: _propTypes.default.string,

  
  options: autocompleteOptions
};
Autocomplete.defaultProps = {
  id: "Autocomplete-".concat((0, _idgen.default)()),
  options: {
    data: {},
    limit: Infinity,
    onAutocomplete: null,
    minLength: 1,
    sortFunction: null
  }
};
var _default = Autocomplete;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.dropdownOptions = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _idgen = _interopRequireDefault(__webpack_require__(36));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      className = _ref.className,
      trigger = _ref.trigger,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, ["children", "className", "trigger", "options"]);

  var _dropdownContent = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    var instance = M.Dropdown.init(document.querySelector("[data-target=\"".concat(props.id, "\"]")), options);
    return function () {
      instance && instance.destroy();
    };
  }, [options, props.id, children]);

  var renderTrigger = function renderTrigger() {
    return (0, _react.cloneElement)(trigger, {
      'data-target': props.id,
      className: (0, _classnames.default)(trigger.props.className, 'dropdown-trigger')
    });
  };

  var renderItems = function renderItems(c) {
    return _react.Children.map(c, function (element) {
      if (!element || element.type === 'li') {
        // Skip null, undefined, or li children
        return element;
      } else if (element.type === _react.Fragment) {
        // Recurse here for Fragments
        return renderItems(element.props.children);
      } else if (element.type.name === 'Divider' || element.type.displayName === 'Divider') {
        // Replace <Divider/> component with proper semantics
        return _react.default.createElement("li", {
          key: (0, _idgen.default)(),
          className: "divider",
          tabIndex: "-1"
        });
      } else {
        // Wrap child element in <li/>
        return _react.default.createElement("li", {
          key: (0, _idgen.default)()
        }, element);
      }
    });
  };

  return _react.default.createElement(_react.Fragment, null, renderTrigger(), _react.default.createElement("ul", _extends({}, props, {
    className: (0, _classnames.default)('dropdown-content', className),
    ref: _dropdownContent
  }), renderItems(children)));
};

var dropdownOptions = _propTypes.default.shape({
  alignment: _propTypes.default.oneOf(['left', 'right']),
  autoTrigger: _propTypes.default.bool,
  constrainWidth: _propTypes.default.bool,
  container: _propTypes.default.node,
  coverTrigger: _propTypes.default.bool,
  closeOnClick: _propTypes.default.bool,
  hover: _propTypes.default.bool,
  inDuration: _propTypes.default.number,
  outDuration: _propTypes.default.number,
  onOpenStart: _propTypes.default.func,
  onOpenEnd: _propTypes.default.func,
  onCloseStart: _propTypes.default.func,
  onCloseEnd: _propTypes.default.func
});

exports.dropdownOptions = dropdownOptions;
Dropdown.propTypes = {
  id: _propTypes.default.string,

  
  trigger: _propTypes.default.node.isRequired,
  children: _propTypes.default.node,
  className: _propTypes.default.string,

  
  options: dropdownOptions
};
Dropdown.defaultProps = {
  id: "Dropdown_".concat((0, _idgen.default)()),
  options: {
    alignment: 'left',
    autoTrigger: true,
    constrainWidth: true,
    container: null,
    coverTrigger: true,
    closeOnClick: true,
    hover: false,
    inDuration: 150,
    outDuration: 250,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null
  }
};
var _default = Dropdown;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Icon = _interopRequireDefault(__webpack_require__(86));

var _TextInput = _interopRequireDefault(__webpack_require__(175));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchForm = function SearchForm(_ref) {
  var searchIcon = _ref.searchIcon,
      closeIcon = _ref.closeIcon;
  return _react.default.createElement("form", null, _react.default.createElement(_TextInput.default, {
    label: searchIcon,
    type: "search"
  }, closeIcon));
};

SearchForm.propTypes = {
  searchIcon: _propTypes.default.node.isRequired,
  closeIcon: _propTypes.default.node.isRequired
};
SearchForm.defaultProps = {
  searchIcon: _react.default.createElement(_Icon.default, null, "search"),
  closeIcon: _react.default.createElement(_Icon.default, null, "close")
};
var _default = SearchForm;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationButton = function PaginationButton(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      children = _ref.children,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      href = _ref.href,
      onSelect = _ref.onSelect;
  var classes = {
    'waves-effect': !disabled,
    disabled: disabled,
    active: active
  };
  var linkProps = href ? {
    href: href
  } : null;
  return _react.default.createElement("li", {
    className: (0, _classnames.default)(classes, className),
    onClick: onSelect
  }, _react.default.createElement("a", linkProps, children));
};

PaginationButton.propTypes = {
  active: _propTypes.default.bool,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  href: _propTypes.default.string,
  onSelect: _propTypes.default.func
};
var _default = PaginationButton;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Spinner = function Spinner(_ref) {
  var _cx;

  var color = _ref.color,
      only = _ref.only,
      className = _ref.className;
  var spinnerClasses = (0, _classnames.default)('spinner-layer', (_cx = {}, _defineProperty(_cx, "spinner-".concat(color, "-only"), only), _defineProperty(_cx, "spinner-".concat(color), !only), _cx));
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(spinnerClasses, className)
  }, _react.default.createElement("div", {
    className: "circle-clipper left"
  }, _react.default.createElement("div", {
    className: "circle"
  })), _react.default.createElement("div", {
    className: "gap-patch"
  }, _react.default.createElement("div", {
    className: "circle"
  })), _react.default.createElement("div", {
    className: "circle-clipper right"
  }, _react.default.createElement("div", {
    className: "circle"
  })));
};

Spinner.defaultProps = {
  only: true
};
Spinner.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string,
  only: _propTypes.default.bool
};
var _default = Spinner;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Col = _interopRequireDefault(__webpack_require__(174));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is just a holder for the props and children for tab, thus
// there is no logic here.
var Tab = function Tab(_ref) {
  var children = _ref.children,
      idx = _ref.idx,
      className = _ref.className;
  return _react.default.createElement(_Col.default, {
    id: "tab_".concat(idx),
    s: 12,
    className: className
  }, children);
};

Tab.propTypes = {
  title: _propTypes.default.string.isRequired,
  idx: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  active: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  tabWidth: _propTypes.default.number
};
var _default = Tab;
exports.default = _default;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(944);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_table_jpg__ = __webpack_require__(171);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_table_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_think_table_jpg__);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_icons_tree_png__ = __webpack_require__(951);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_icons_tree_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_images_icons_tree_png__);
 var __WEBPACK_IMPORTED_MODULE_7_constants_tables__ = __webpack_require__(110);
 var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(176);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChatElement=function(_Component){_inherits(ChatElement,_Component);function ChatElement(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChatElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChatElement.__proto__||Object.getPrototypeOf(ChatElement)).call.apply(_ref,[this].concat(args))),_this),_this.state={hasNews:false,chat:undefined},_this.handleClick=function(){var _this$props=_this.props,onClick=_this$props.onClick,chat=_this$props.chat;onClick(chat.element_related.id,false);},_this.showLastMessage=function(message){if(message.user&&message.type){var messageType=typeof message.type.value!=='undefined'?message.type.value.toLowerCase():message.type.toLowerCase();if(messageType==='leave'){return message.user.firstname+' has left the Table';}if(messageType==='join'){return message.user.firstname+' has joined the Table';}if(messageType==='attachment'){return message.user.firstname+' attached a file';}return message.user.firstname+': '+message.text;}return'';},_this.printLower=function(users,limit){var usersImg=users.map(function(user,i){if(i<3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["l" ],{src:user.avatar,alt:user.firstname,left:i*13+'px'});}if(i===3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["m" ],{left:i*13+'px'},'+',users.length-3);}return null;});var limitDate=__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(limit);var today=__WEBPACK_IMPORTED_MODULE_3_moment___default()();var difference=__WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(limitDate.diff(today));var time=' ';var days=difference.get('days')>9?difference.get('days'):'0'+difference.get('days');var hours=difference.get('hours')>9?difference.get('hours'):'0'+difference.get('hours');var minutes=difference.get('minutes')>9?difference.get('minutes'):'0'+difference.get('minutes');var seconds=difference.get('seconds')>9?difference.get('seconds'):'0'+difference.get('seconds');if(difference.get('milliseconds')>0){time=days+':'+hours+':'+minutes+':'+seconds;}else{time='00:00:00:00';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["j" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["w" ],null,usersImg),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["r" ],null,time));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChatElement,[{key:'componentDidMount',value:function componentDidMount(){var chat=this.props.chat;this.setState({chat:chat});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props=this.props,chat=_props.chat,user=_props.user;var hasNews=this.state.hasNews;var news=chat.last_message&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.indexOf(chat.last_message.users_read,user.id)===-1&&chat.last_message.user_id!==user.id;if(news!==hasNews){this.setState({hasNews:news});}}},{key:'render',value:function render(){var _props2=this.props,user=_props2.user,width=_props2.width,table=_props2.table;var _state=this.state,hasNews=_state.hasNews,chat=_state.chat;var chatName=table.name;var chatImage=table.image;if(chat){var dead=table.type!==__WEBPACK_IMPORTED_MODULE_7_constants_tables__["c" ]&&table.status.id===__WEBPACK_IMPORTED_MODULE_7_constants_tables__["b" ];var timeStr='';if(chat.last_message){var time=__WEBPACK_IMPORTED_MODULE_3_moment___default()(chat.last_message.timestamp,'X');var timeDay=time.format('YYYY-MM-DD');timeStr=__WEBPACK_IMPORTED_MODULE_3_moment___default()(chat.last_message.timestamp,'X').format('HH:mm');if(!__WEBPACK_IMPORTED_MODULE_3_moment___default()().isSame(timeDay,'day')){if(__WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(time,'day')<7){timeStr=time.format('dddd');}else{timeStr=time.format('DD/MM/YYYY');}}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["b" ],{'data-chat':chat.id,onClick:this.handleClick,width:width,className:'chat_element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["s" ],null,dead&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity-frame'}),dead&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["t" ],{dead:true,src:__WEBPACK_IMPORTED_MODULE_6_assets_images_icons_tree_png___default.a})),!dead&&chatImage&&chatImage!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Avatar__["a" ],{size:40,avatar:chatImage})),!dead&&(!chatImage||chatImage==='')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Avatar__["a" ],{size:40,avatar:__WEBPACK_IMPORTED_MODULE_5_assets_images_think_table_jpg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["u" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name_indicator'},hasNews&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["h" ],{color:'#FFA200'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["v" ],null,''+chatName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["k" ],null,timeStr)),chat.last_message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["i" ],null,this.showLastMessage(chat.last_message))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);}}]);return ChatElement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChatElement.propTypes={chat:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,table:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (ChatElement);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/search.66dfb1e0.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(133);
 var __WEBPACK_IMPORTED_MODULE_1__anchor_tag_builder__ = __webpack_require__(424);
 var __WEBPACK_IMPORTED_MODULE_2__match_match__ = __webpack_require__(87);
 var __WEBPACK_IMPORTED_MODULE_3__match_email_match__ = __webpack_require__(242);
 var __WEBPACK_IMPORTED_MODULE_4__match_hashtag_match__ = __webpack_require__(243);
 var __WEBPACK_IMPORTED_MODULE_5__match_mention_match__ = __webpack_require__(244);
 var __WEBPACK_IMPORTED_MODULE_6__match_phone_match__ = __webpack_require__(245);
 var __WEBPACK_IMPORTED_MODULE_7__match_url_match__ = __webpack_require__(246);
 var __WEBPACK_IMPORTED_MODULE_8__matcher_matcher__ = __webpack_require__(88);
 var __WEBPACK_IMPORTED_MODULE_9__html_tag__ = __webpack_require__(241);
 var __WEBPACK_IMPORTED_MODULE_10__matcher_email_matcher__ = __webpack_require__(425);
 var __WEBPACK_IMPORTED_MODULE_11__matcher_url_matcher__ = __webpack_require__(427);
 var __WEBPACK_IMPORTED_MODULE_12__matcher_hashtag_matcher__ = __webpack_require__(428);
 var __WEBPACK_IMPORTED_MODULE_13__matcher_phone_matcher__ = __webpack_require__(429);
 var __WEBPACK_IMPORTED_MODULE_14__matcher_mention_matcher__ = __webpack_require__(430);
 var __WEBPACK_IMPORTED_MODULE_15__htmlParser_parse_html__ = __webpack_require__(960);

















var Autolinker =  (function () {
    
    function Autolinker(cfg) {
        if (cfg === void 0) { cfg = {}; }
        
        this.version = Autolinker.version;
        
        this.urls = {}; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.email = true; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.phone = true; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.hashtag = false; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.mention = false; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.newWindow = true; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.stripPrefix = { scheme: true, www: true }; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.stripTrailingSlash = true; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.decodePercentEncoding = true; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.truncate = { length: 0, location: 'end' }; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.className = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.replaceFn = null; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.context = undefined; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.sanitizeHtml = false; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.matchers = null;
        
        this.tagBuilder = null;
        // Note: when `this.something` is used in the rhs of these assignments,
        //       it refers to the default values set above the constructor
        this.urls = this.normalizeUrlsCfg(cfg.urls);
        this.email = typeof cfg.email === 'boolean' ? cfg.email : this.email;
        this.phone = typeof cfg.phone === 'boolean' ? cfg.phone : this.phone;
        this.hashtag = cfg.hashtag || this.hashtag;
        this.mention = cfg.mention || this.mention;
        this.newWindow = typeof cfg.newWindow === 'boolean' ? cfg.newWindow : this.newWindow;
        this.stripPrefix = this.normalizeStripPrefixCfg(cfg.stripPrefix);
        this.stripTrailingSlash = typeof cfg.stripTrailingSlash === 'boolean' ? cfg.stripTrailingSlash : this.stripTrailingSlash;
        this.decodePercentEncoding = typeof cfg.decodePercentEncoding === 'boolean' ? cfg.decodePercentEncoding : this.decodePercentEncoding;
        this.sanitizeHtml = cfg.sanitizeHtml || false;
        // Validate the value of the `mention` cfg
        var mention = this.mention;
        if (mention !== false && mention !== 'twitter' && mention !== 'instagram' && mention !== 'soundcloud') {
            throw new Error("invalid `mention` cfg - see docs");
        }
        // Validate the value of the `hashtag` cfg
        var hashtag = this.hashtag;
        if (hashtag !== false && hashtag !== 'twitter' && hashtag !== 'facebook' && hashtag !== 'instagram') {
            throw new Error("invalid `hashtag` cfg - see docs");
        }
        this.truncate = this.normalizeTruncateCfg(cfg.truncate);
        this.className = cfg.className || this.className;
        this.replaceFn = cfg.replaceFn || this.replaceFn;
        this.context = cfg.context || this;
    }
    
    Autolinker.link = function (textOrHtml, options) {
        var autolinker = new Autolinker(options);
        return autolinker.link(textOrHtml);
    };
    
    Autolinker.parse = function (textOrHtml, options) {
        var autolinker = new Autolinker(options);
        return autolinker.parse(textOrHtml);
    };
    
    Autolinker.prototype.normalizeUrlsCfg = function (urls) {
        if (urls == null)
            urls = true; // default to `true`
        if (typeof urls === 'boolean') {
            return { schemeMatches: urls, wwwMatches: urls, tldMatches: urls };
        }
        else { // object form
            return {
                schemeMatches: typeof urls.schemeMatches === 'boolean' ? urls.schemeMatches : true,
                wwwMatches: typeof urls.wwwMatches === 'boolean' ? urls.wwwMatches : true,
                tldMatches: typeof urls.tldMatches === 'boolean' ? urls.tldMatches : true
            };
        }
    };
    
    Autolinker.prototype.normalizeStripPrefixCfg = function (stripPrefix) {
        if (stripPrefix == null)
            stripPrefix = true; // default to `true`
        if (typeof stripPrefix === 'boolean') {
            return { scheme: stripPrefix, www: stripPrefix };
        }
        else { // object form
            return {
                scheme: typeof stripPrefix.scheme === 'boolean' ? stripPrefix.scheme : true,
                www: typeof stripPrefix.www === 'boolean' ? stripPrefix.www : true
            };
        }
    };
    
    Autolinker.prototype.normalizeTruncateCfg = function (truncate) {
        if (typeof truncate === 'number') {
            return { length: truncate, location: 'end' };
        }
        else { // object, or undefined/null
            return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" ])(truncate || {}, {
                length: Number.POSITIVE_INFINITY,
                location: 'end'
            });
        }
    };
    
    Autolinker.prototype.parse = function (textOrHtml) {
        var _this = this;
        var skipTagNames = ['a', 'style', 'script'], skipTagsStackCount = 0, // used to only Autolink text outside of anchor/script/style tags. We don't want to autolink something that is already linked inside of an <a> tag, for instance
        matches = [];
        // Find all matches within the `textOrHtml` (but not matches that are
        // already nested within <a>, <style> and <script> tags)
        Object(__WEBPACK_IMPORTED_MODULE_15__htmlParser_parse_html__["a" ])(textOrHtml, {
            onOpenTag: function (tagName) {
                if (skipTagNames.indexOf(tagName) >= 0) {
                    skipTagsStackCount++;
                }
            },
            onText: function (text, offset) {
                // Only process text nodes that are not within an <a>, <style> or <script> tag
                if (skipTagsStackCount === 0) {
                    // "Walk around" common HTML entities. An '&nbsp;' (for example)
                    // could be at the end of a URL, but we don't want to 
                    // include the trailing '&' in the URL. See issue #76
                    // TODO: Handle HTML entities separately in parseHtml() and
                    // don't emit them as "text" except for &amp; entities
                    var htmlCharacterEntitiesRegex = /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi;
                    var textSplit = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" ])(text, htmlCharacterEntitiesRegex);
                    var currentOffset_1 = offset;
                    textSplit.forEach(function (splitText, i) {
                        // even number matches are text, odd numbers are html entities
                        if (i % 2 === 0) {
                            var textNodeMatches = _this.parseText(splitText, currentOffset_1);
                            matches.push.apply(matches, textNodeMatches);
                        }
                        currentOffset_1 += splitText.length;
                    });
                }
            },
            onCloseTag: function (tagName) {
                if (skipTagNames.indexOf(tagName) >= 0) {
                    skipTagsStackCount = Math.max(skipTagsStackCount - 1, 0); // attempt to handle extraneous </a> tags by making sure the stack count never goes below 0
                }
            },
            onComment: function (offset) { },
            onDoctype: function (offset) { }, // no need to process doctype nodes
        });
        // After we have found all matches, remove subsequent matches that
        // overlap with a previous match. This can happen for instance with URLs,
        // where the url 'google.com/#link' would match '#link' as a hashtag.
        matches = this.compactMatches(matches);
        // And finally, remove matches for match types that have been turned
        // off. We needed to have all match types turned on initially so that
        // things like hashtags could be filtered out if they were really just
        // part of a URL match (for instance, as a named anchor).
        matches = this.removeUnwantedMatches(matches);
        return matches;
    };
    
    Autolinker.prototype.compactMatches = function (matches) {
        // First, the matches need to be sorted in order of offset
        matches.sort(function (a, b) { return a.getOffset() - b.getOffset(); });
        for (var i = 0; i < matches.length - 1; i++) {
            var match = matches[i], offset = match.getOffset(), matchedTextLength = match.getMatchedText().length, endIdx = offset + matchedTextLength;
            if (i + 1 < matches.length) {
                // Remove subsequent matches that equal offset with current match
                if (matches[i + 1].getOffset() === offset) {
                    var removeIdx = matches[i + 1].getMatchedText().length > matchedTextLength ? i : i + 1;
                    matches.splice(removeIdx, 1);
                    continue;
                }
                // Remove subsequent matches that overlap with the current match
                if (matches[i + 1].getOffset() < endIdx) {
                    matches.splice(i + 1, 1);
                }
            }
        }
        return matches;
    };
    
    Autolinker.prototype.removeUnwantedMatches = function (matches) {
        if (!this.hashtag)
            Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" ])(matches, function (match) { return match.getType() === 'hashtag'; });
        if (!this.email)
            Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" ])(matches, function (match) { return match.getType() === 'email'; });
        if (!this.phone)
            Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" ])(matches, function (match) { return match.getType() === 'phone'; });
        if (!this.mention)
            Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" ])(matches, function (match) { return match.getType() === 'mention'; });
        if (!this.urls.schemeMatches) {
            Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" ])(matches, function (m) { return m.getType() === 'url' && m.getUrlMatchType() === 'scheme'; });
        }
        if (!this.urls.wwwMatches) {
            Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" ])(matches, function (m) { return m.getType() === 'url' && m.getUrlMatchType() === 'www'; });
        }
        if (!this.urls.tldMatches) {
            Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" ])(matches, function (m) { return m.getType() === 'url' && m.getUrlMatchType() === 'tld'; });
        }
        return matches;
    };
    
    Autolinker.prototype.parseText = function (text, offset) {
        if (offset === void 0) { offset = 0; }
        offset = offset || 0;
        var matchers = this.getMatchers(), matches = [];
        for (var i = 0, numMatchers = matchers.length; i < numMatchers; i++) {
            var textMatches = matchers[i].parseMatches(text);
            // Correct the offset of each of the matches. They are originally
            // the offset of the match within the provided text node, but we
            // need to correct them to be relative to the original HTML input
            // string (i.e. the one provided to #parse).
            for (var j = 0, numTextMatches = textMatches.length; j < numTextMatches; j++) {
                textMatches[j].setOffset(offset + textMatches[j].getOffset());
            }
            matches.push.apply(matches, textMatches);
        }
        return matches;
    };
    
    Autolinker.prototype.link = function (textOrHtml) {
        if (!textOrHtml) {
            return "";
        } // handle `null` and `undefined` (for JavaScript users that don't have TypeScript support)
        
        if (this.sanitizeHtml) {
            textOrHtml = textOrHtml
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        }
        var matches = this.parse(textOrHtml), newHtml = [], lastIndex = 0;
        for (var i = 0, len = matches.length; i < len; i++) {
            var match = matches[i];
            newHtml.push(textOrHtml.substring(lastIndex, match.getOffset()));
            newHtml.push(this.createMatchReturnVal(match));
            lastIndex = match.getOffset() + match.getMatchedText().length;
        }
        newHtml.push(textOrHtml.substring(lastIndex)); // handle the text after the last match
        return newHtml.join('');
    };
    
    Autolinker.prototype.createMatchReturnVal = function (match) {
        // Handle a custom `replaceFn` being provided
        var replaceFnResult;
        if (this.replaceFn) {
            replaceFnResult = this.replaceFn.call(this.context, match); // Autolinker instance is the context
        }
        if (typeof replaceFnResult === 'string') {
            return replaceFnResult; // `replaceFn` returned a string, use that
        }
        else if (replaceFnResult === false) {
            return match.getMatchedText(); // no replacement for the match
        }
        else if (replaceFnResult instanceof __WEBPACK_IMPORTED_MODULE_9__html_tag__["a" ]) {
            return replaceFnResult.toAnchorString();
        }
        else { // replaceFnResult === true, or no/unknown return value from function
            // Perform Autolinker's default anchor tag generation
            var anchorTag = match.buildTag(); // returns an Autolinker.HtmlTag instance
            return anchorTag.toAnchorString();
        }
    };
    
    Autolinker.prototype.getMatchers = function () {
        if (!this.matchers) {
            var tagBuilder = this.getTagBuilder();
            var matchers = [
                new __WEBPACK_IMPORTED_MODULE_12__matcher_hashtag_matcher__["a" ]({ tagBuilder: tagBuilder, serviceName: this.hashtag }),
                new __WEBPACK_IMPORTED_MODULE_10__matcher_email_matcher__["a" ]({ tagBuilder: tagBuilder }),
                new __WEBPACK_IMPORTED_MODULE_13__matcher_phone_matcher__["a" ]({ tagBuilder: tagBuilder }),
                new __WEBPACK_IMPORTED_MODULE_14__matcher_mention_matcher__["a" ]({ tagBuilder: tagBuilder, serviceName: this.mention }),
                new __WEBPACK_IMPORTED_MODULE_11__matcher_url_matcher__["a" ]({ tagBuilder: tagBuilder, stripPrefix: this.stripPrefix, stripTrailingSlash: this.stripTrailingSlash, decodePercentEncoding: this.decodePercentEncoding })
            ];
            return (this.matchers = matchers);
        }
        else {
            return this.matchers;
        }
    };
    
    Autolinker.prototype.getTagBuilder = function () {
        var tagBuilder = this.tagBuilder;
        if (!tagBuilder) {
            tagBuilder = this.tagBuilder = new __WEBPACK_IMPORTED_MODULE_1__anchor_tag_builder__["a" ]({
                newWindow: this.newWindow,
                truncate: this.truncate,
                className: this.className
            });
        }
        return tagBuilder;
    };
    
    Autolinker.version = '3.14.3';
    
    Autolinker.AnchorTagBuilder = __WEBPACK_IMPORTED_MODULE_1__anchor_tag_builder__["a" ];
    
    Autolinker.HtmlTag = __WEBPACK_IMPORTED_MODULE_9__html_tag__["a" ];
    
    Autolinker.matcher = {
        Email: __WEBPACK_IMPORTED_MODULE_10__matcher_email_matcher__["a" ],
        Hashtag: __WEBPACK_IMPORTED_MODULE_12__matcher_hashtag_matcher__["a" ],
        Matcher: __WEBPACK_IMPORTED_MODULE_8__matcher_matcher__["a" ],
        Mention: __WEBPACK_IMPORTED_MODULE_14__matcher_mention_matcher__["a" ],
        Phone: __WEBPACK_IMPORTED_MODULE_13__matcher_phone_matcher__["a" ],
        Url: __WEBPACK_IMPORTED_MODULE_11__matcher_url_matcher__["a" ]
    };
    
    Autolinker.match = {
        Email: __WEBPACK_IMPORTED_MODULE_3__match_email_match__["a" ],
        Hashtag: __WEBPACK_IMPORTED_MODULE_4__match_hashtag_match__["a" ],
        Match: __WEBPACK_IMPORTED_MODULE_2__match_match__["a" ],
        Mention: __WEBPACK_IMPORTED_MODULE_5__match_mention_match__["a" ],
        Phone: __WEBPACK_IMPORTED_MODULE_6__match_phone_match__["a" ],
        Url: __WEBPACK_IMPORTED_MODULE_7__match_url_match__["a" ]
    };
    return Autolinker;
}());
 __webpack_exports__["a"] = (Autolinker);

//# sourceMappingURL=autolinker.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return AnchorTagBuilder; });
 var __WEBPACK_IMPORTED_MODULE_0__html_tag__ = __webpack_require__(241);
 var __WEBPACK_IMPORTED_MODULE_1__truncate_truncate_smart__ = __webpack_require__(956);
 var __WEBPACK_IMPORTED_MODULE_2__truncate_truncate_middle__ = __webpack_require__(957);
 var __WEBPACK_IMPORTED_MODULE_3__truncate_truncate_end__ = __webpack_require__(958);





var AnchorTagBuilder =  (function () {
    
    function AnchorTagBuilder(cfg) {
        if (cfg === void 0) { cfg = {}; }
        
        this.newWindow = false; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.truncate = {}; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        this.className = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
        this.newWindow = cfg.newWindow || false;
        this.truncate = cfg.truncate || {};
        this.className = cfg.className || '';
    }
    
    AnchorTagBuilder.prototype.build = function (match) {
        return new __WEBPACK_IMPORTED_MODULE_0__html_tag__["a" ]({
            tagName: 'a',
            attrs: this.createAttrs(match),
            innerHtml: this.processAnchorText(match.getAnchorText())
        });
    };
    
    AnchorTagBuilder.prototype.createAttrs = function (match) {
        var attrs = {
            'href': match.getAnchorHref() // we'll always have the `href` attribute
        };
        var cssClass = this.createCssClass(match);
        if (cssClass) {
            attrs['class'] = cssClass;
        }
        if (this.newWindow) {
            attrs['target'] = "_blank";
            attrs['rel'] = "noopener noreferrer"; // Issue #149. See https://mathiasbynens.github.io/rel-noopener/
        }
        if (this.truncate) {
            if (this.truncate.length && this.truncate.length < match.getAnchorText().length) {
                attrs['title'] = match.getAnchorHref();
            }
        }
        return attrs;
    };
    
    AnchorTagBuilder.prototype.createCssClass = function (match) {
        var className = this.className;
        if (!className) {
            return "";
        }
        else {
            var returnClasses = [className], cssClassSuffixes = match.getCssClassSuffixes();
            for (var i = 0, len = cssClassSuffixes.length; i < len; i++) {
                returnClasses.push(className + '-' + cssClassSuffixes[i]);
            }
            return returnClasses.join(' ');
        }
    };
    
    AnchorTagBuilder.prototype.processAnchorText = function (anchorText) {
        anchorText = this.doTruncate(anchorText);
        return anchorText;
    };
    
    AnchorTagBuilder.prototype.doTruncate = function (anchorText) {
        var truncate = this.truncate;
        if (!truncate || !truncate.length)
            return anchorText;
        var truncateLength = truncate.length, truncateLocation = truncate.location;
        if (truncateLocation === 'smart') {
            return Object(__WEBPACK_IMPORTED_MODULE_1__truncate_truncate_smart__["a" ])(anchorText, truncateLength);
        }
        else if (truncateLocation === 'middle') {
            return Object(__WEBPACK_IMPORTED_MODULE_2__truncate_truncate_middle__["a" ])(anchorText, truncateLength);
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_3__truncate_truncate_end__["a" ])(anchorText, truncateLength);
        }
    };
    return AnchorTagBuilder;
}());


//# sourceMappingURL=anchor-tag-builder.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return EmailMatcher; });
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(88);
 var __WEBPACK_IMPORTED_MODULE_2__regex_lib__ = __webpack_require__(89);
 var __WEBPACK_IMPORTED_MODULE_3__match_email_match__ = __webpack_require__(242);
 var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(133);
 var __WEBPACK_IMPORTED_MODULE_5__tld_regex__ = __webpack_require__(426);






// For debugging: search for other "For debugging" lines
// import CliTable from 'cli-table';
// RegExp objects which are shared by all instances of EmailMatcher. These are
// here to avoid re-instantiating the RegExp objects if `Autolinker.link()` is
// called multiple times, thus instantiating EmailMatcher and its RegExp 
// objects each time (which is very expensive - see https://github.com/gregjacobs/Autolinker.js/issues/314). 
// See descriptions of the properties where they are used for details about them
var localPartCharRegex = new RegExp("[" + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "!#$%&'*+/=?^_`{|}~-]");
var strictTldRegex = new RegExp("^" + __WEBPACK_IMPORTED_MODULE_5__tld_regex__["a" ].source + "$");

var EmailMatcher =  (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" ])(EmailMatcher, _super);
    function EmailMatcher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        
        _this.localPartCharRegex = localPartCharRegex;
        
        _this.strictTldRegex = strictTldRegex;
        return _this;
    }
    
    EmailMatcher.prototype.parseMatches = function (text) {
        var tagBuilder = this.tagBuilder, localPartCharRegex = this.localPartCharRegex, strictTldRegex = this.strictTldRegex, matches = [], len = text.length, noCurrentEmailMatch = new CurrentEmailMatch();
        // for matching a 'mailto:' prefix
        var mailtoTransitions = {
            'm': 'a',
            'a': 'i',
            'i': 'l',
            'l': 't',
            't': 'o',
            'o': ':',
        };
        var charIdx = 0, state = 0 , currentEmailMatch = noCurrentEmailMatch;
        // For debugging: search for other "For debugging" lines
        // const table = new CliTable( {
        // 	head: [ 'charIdx', 'char', 'state', 'charIdx', 'currentEmailAddress.idx', 'hasDomainDot' ]
        // } );
        while (charIdx < len) {
            var char = text.charAt(charIdx);
            // For debugging: search for other "For debugging" lines
            // table.push( 
            // 	[ charIdx, char, State[ state ], charIdx, currentEmailAddress.idx, currentEmailAddress.hasDomainDot ] 
            // );
            switch (state) {
                case 0 :
                    stateNonEmailAddress(char);
                    break;
                case 1 :
                    stateMailTo(text.charAt(charIdx - 1), char);
                    break;
                case 2 :
                    stateLocalPart(char);
                    break;
                case 3 :
                    stateLocalPartDot(char);
                    break;
                case 4 :
                    stateAtSign(char);
                    break;
                case 5 :
                    stateDomainChar(char);
                    break;
                case 6 :
                    stateDomainHyphen(char);
                    break;
                case 7 :
                    stateDomainDot(char);
                    break;
                default:
                    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" ])(state);
            }
            // For debugging: search for other "For debugging" lines
            // table.push( 
            // 	[ charIdx, char, State[ state ], charIdx, currentEmailAddress.idx, currentEmailAddress.hasDomainDot ] 
            // );
            charIdx++;
        }
        // Capture any valid match at the end of the string
        captureMatchIfValidAndReset();
        // For debugging: search for other "For debugging" lines
        //console.log( '\n' + table.toString() );
        return matches;
        // Handles the state when we're not in an email address
        function stateNonEmailAddress(char) {
            if (char === 'm') {
                beginEmailMatch(1 );
            }
            else if (localPartCharRegex.test(char)) {
                beginEmailMatch();
            }
            else {
                // not an email address character, continue
            }
        }
        // Handles if we're reading a 'mailto:' prefix on the string
        function stateMailTo(prevChar, char) {
            if (prevChar === ':') {
                // We've reached the end of the 'mailto:' prefix
                if (localPartCharRegex.test(char)) {
                    state = 2 ;
                    currentEmailMatch = new CurrentEmailMatch(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])({}, currentEmailMatch), { hasMailtoPrefix: true }));
                }
                else {
                    // we've matched 'mailto:' but didn't get anything meaningful
                    // immediately afterwards (for example, we encountered a 
                    // space character, or an '@' character which formed 'mailto:@'
                    resetToNonEmailMatchState();
                }
            }
            else if (mailtoTransitions[prevChar] === char) {
                // We're currently reading the 'mailto:' prefix, stay in
                // Mailto state
            }
            else if (localPartCharRegex.test(char)) {
                // We we're reading a prefix of 'mailto:', but encountered a
                // different character that didn't continue the prefix
                state = 2 ;
            }
            else if (char === '.') {
                // We we're reading a prefix of 'mailto:', but encountered a
                // dot character
                state = 3 ;
            }
            else if (char === '@') {
                // We we're reading a prefix of 'mailto:', but encountered a
                // an @ character
                state = 4 ;
            }
            else {
                // not an email address character, return to "NonEmailAddress" state
                resetToNonEmailMatchState();
            }
        }
        // Handles the state when we're currently in the "local part" of an 
        // email address (as opposed to the "domain part")
        function stateLocalPart(char) {
            if (char === '.') {
                state = 3 ;
            }
            else if (char === '@') {
                state = 4 ;
            }
            else if (localPartCharRegex.test(char)) {
                // stay in the "local part" of the email address
            }
            else {
                // not an email address character, return to "NonEmailAddress" state
                resetToNonEmailMatchState();
            }
        }
        // Handles the state where we've read 
        function stateLocalPartDot(char) {
            if (char === '.') {
                // We read a second '.' in a row, not a valid email address 
                // local part
                resetToNonEmailMatchState();
            }
            else if (char === '@') {
                // We read the '@' character immediately after a dot ('.'), not 
                // an email address
                resetToNonEmailMatchState();
            }
            else if (localPartCharRegex.test(char)) {
                state = 2 ;
            }
            else {
                // Anything else, not an email address
                resetToNonEmailMatchState();
            }
        }
        function stateAtSign(char) {
            if (__WEBPACK_IMPORTED_MODULE_2__regex_lib__["f" ].test(char)) {
                state = 5 ;
            }
            else {
                // Anything else, not an email address
                resetToNonEmailMatchState();
            }
        }
        function stateDomainChar(char) {
            if (char === '.') {
                state = 7 ;
            }
            else if (char === '-') {
                state = 6 ;
            }
            else if (__WEBPACK_IMPORTED_MODULE_2__regex_lib__["f" ].test(char)) {
                // Stay in the DomainChar state
            }
            else {
                // Anything else, we potentially matched if the criteria has
                // been met
                captureMatchIfValidAndReset();
            }
        }
        function stateDomainHyphen(char) {
            if (char === '-' || char === '.') {
                // Not valid to have two hyphens ("--") or hypen+dot ("-.")
                captureMatchIfValidAndReset();
            }
            else if (__WEBPACK_IMPORTED_MODULE_2__regex_lib__["f" ].test(char)) {
                state = 5 ;
            }
            else {
                // Anything else
                captureMatchIfValidAndReset();
            }
        }
        function stateDomainDot(char) {
            if (char === '.' || char === '-') {
                // not valid to have two dots ("..") or dot+hypen (".-")
                captureMatchIfValidAndReset();
            }
            else if (__WEBPACK_IMPORTED_MODULE_2__regex_lib__["f" ].test(char)) {
                state = 5 ;
                // After having read a '.' and then a valid domain character,
                // we now know that the domain part of the email is valid, and
                // we have found at least a partial EmailMatch (however, the
                // email address may have additional characters from this point)
                currentEmailMatch = new CurrentEmailMatch(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])({}, currentEmailMatch), { hasDomainDot: true }));
            }
            else {
                // Anything else
                captureMatchIfValidAndReset();
            }
        }
        function beginEmailMatch(newState) {
            if (newState === void 0) { newState = 2 ; }
            state = newState;
            currentEmailMatch = new CurrentEmailMatch({ idx: charIdx });
        }
        function resetToNonEmailMatchState() {
            state = 0 ;
            currentEmailMatch = noCurrentEmailMatch;
        }
        
        function captureMatchIfValidAndReset() {
            if (currentEmailMatch.hasDomainDot) { // we need at least one dot in the domain to be considered a valid email address
                var matchedText = text.slice(currentEmailMatch.idx, charIdx);
                // If we read a '.' or '-' char that ended the email address
                // (valid domain name characters, but only valid email address
                // characters if they are followed by something else), strip 
                // it off now
                if (/[-.]$/.test(matchedText)) {
                    matchedText = matchedText.slice(0, -1);
                }
                var emailAddress = currentEmailMatch.hasMailtoPrefix
                    ? matchedText.slice('mailto:'.length)
                    : matchedText;
                // if the email address has a valid TLD, add it to the list of matches
                if (doesEmailHaveValidTld(emailAddress)) {
                    matches.push(new __WEBPACK_IMPORTED_MODULE_3__match_email_match__["a" ]({
                        tagBuilder: tagBuilder,
                        matchedText: matchedText,
                        offset: currentEmailMatch.idx,
                        email: emailAddress
                    }));
                }
            }
            resetToNonEmailMatchState();
            
            function doesEmailHaveValidTld(emailAddress) {
                var emailAddressTld = emailAddress.split('.').pop() || '';
                var emailAddressNormalized = emailAddressTld.toLowerCase();
                var isValidTld = strictTldRegex.test(emailAddressNormalized);
                return isValidTld;
            }
        }
    };
    return EmailMatcher;
}(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" ]));

var CurrentEmailMatch =  (function () {
    function CurrentEmailMatch(cfg) {
        if (cfg === void 0) { cfg = {}; }
        this.idx = cfg.idx !== undefined ? cfg.idx : -1;
        this.hasMailtoPrefix = !!cfg.hasMailtoPrefix;
        this.hasDomainDot = !!cfg.hasDomainDot;
    }
    return CurrentEmailMatch;
}());

//# sourceMappingURL=email-matcher.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return tldRegex; });
// NOTE: THIS IS A GENERATED FILE
// To update with the latest TLD list, run `npm run update-tld-regex` or `yarn update-tld-regex` (depending on which you have installed)
var tldRegex = /(?:xn--vermgensberatung-pwb|xn--vermgensberater-ctb|xn--clchc0ea0b2g2a9gcd|xn--w4r85el8fhu5dnra|northwesternmutual|travelersinsurance|vermögensberatung|xn--3oq18vl8pn36a|xn--5su34j936bgsg|xn--bck1b9a5dre4c|xn--mgbai9azgqp6j|xn--mgberp4a5d4ar|xn--xkc2dl3a5ee0h|vermögensberater|xn--fzys8d69uvgm|xn--mgba7c0bbn0a|xn--xkc2al3hye2a|americanexpress|kerryproperties|sandvikcoromant|xn--i1b6b1a6a2e|xn--kcrx77d1x4a|xn--lgbbat1ad8j|xn--mgba3a4f16a|xn--mgbaakc7dvf|xn--mgbc0a9azcg|xn--nqv7fs00ema|afamilycompany|americanfamily|bananarepublic|cancerresearch|cookingchannel|kerrylogistics|weatherchannel|xn--54b7fta0cc|xn--6qq986b3xl|xn--80aqecdr1a|xn--b4w605ferd|xn--fiq228c5hs|xn--h2breg3eve|xn--jlq61u9w7b|xn--mgba3a3ejt|xn--mgbaam7a8h|xn--mgbayh7gpa|xn--mgbb9fbpob|xn--mgbbh1a71e|xn--mgbca7dzdo|xn--mgbi4ecexp|xn--mgbx4cd0ab|xn--rvc1e0am3e|international|lifeinsurance|spreadbetting|travelchannel|wolterskluwer|xn--eckvdtc9d|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--h2brj9c8c|xn--tiq49xqyj|xn--yfro4i67o|xn--ygbi2ammx|construction|lplfinancial|scholarships|versicherung|xn--3e0b707e|xn--45br5cyl|xn--80adxhks|xn--80asehdb|xn--8y0a063a|xn--gckr3f0f|xn--mgb9awbf|xn--mgbab2bd|xn--mgbgu82a|xn--mgbpl2fh|xn--mgbt3dhd|xn--mk1bu44c|xn--ngbc5azd|xn--ngbe9e0a|xn--ogbpf8fl|xn--qcka1pmc|accountants|barclaycard|blackfriday|blockbuster|bridgestone|calvinklein|contractors|creditunion|engineering|enterprises|foodnetwork|investments|kerryhotels|lamborghini|motorcycles|olayangroup|photography|playstation|productions|progressive|redumbrella|rightathome|williamhill|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--2scrj9c|xn--3bst00m|xn--3ds443g|xn--3hcrj9c|xn--42c2d9a|xn--45brj9c|xn--55qw42g|xn--6frz82g|xn--80ao21a|xn--9krt00a|xn--cck2b3b|xn--czr694b|xn--d1acj3b|xn--efvy88h|xn--estv75g|xn--fct429k|xn--fjq720a|xn--flw351e|xn--g2xx48c|xn--gecrj9c|xn--gk3at1e|xn--h2brj9c|xn--hxt814e|xn--imr513n|xn--j6w193g|xn--jvr189m|xn--kprw13d|xn--kpry57d|xn--kpu716f|xn--mgbbh1a|xn--mgbtx2b|xn--mix891f|xn--nyqy26a|xn--otu796d|xn--pbt977c|xn--pgbs0dh|xn--q9jyb4c|xn--rhqv96g|xn--rovu88b|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--vuq861b|xn--w4rs40l|xn--xhq521b|xn--zfr164b|சிங்கப்பூர்|accountant|apartments|associates|basketball|bnpparibas|boehringer|capitalone|consulting|creditcard|cuisinella|eurovision|extraspace|foundation|healthcare|immobilien|industries|management|mitsubishi|nationwide|newholland|nextdirect|onyourside|properties|protection|prudential|realestate|republican|restaurant|schaeffler|swiftcover|tatamotors|technology|telefonica|university|vistaprint|vlaanderen|volkswagen|xn--30rr7y|xn--3pxu8k|xn--45q11c|xn--4gbrim|xn--55qx5d|xn--5tzm5g|xn--80aswg|xn--90a3ac|xn--9dbq2a|xn--9et52u|xn--c2br7g|xn--cg4bki|xn--czrs0t|xn--czru2d|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--io0a7i|xn--kput3i|xn--mxtq1m|xn--o3cw4h|xn--pssy2u|xn--unup4y|xn--wgbh1c|xn--wgbl6a|xn--y9a3aq|accenture|alfaromeo|allfinanz|amsterdam|analytics|aquarelle|barcelona|bloomberg|christmas|community|directory|education|equipment|fairwinds|financial|firestone|fresenius|frontdoor|fujixerox|furniture|goldpoint|hisamitsu|homedepot|homegoods|homesense|honeywell|institute|insurance|kuokgroup|ladbrokes|lancaster|landrover|lifestyle|marketing|marshalls|melbourne|microsoft|panasonic|passagens|pramerica|richardli|scjohnson|shangrila|solutions|statebank|statefarm|stockholm|travelers|vacations|xn--90ais|xn--c1avg|xn--d1alf|xn--e1a4c|xn--fhbei|xn--j1aef|xn--j1amh|xn--l1acc|xn--ngbrx|xn--nqv7f|xn--p1acf|xn--tckwe|xn--vhquv|yodobashi|abudhabi|airforce|allstate|attorney|barclays|barefoot|bargains|baseball|boutique|bradesco|broadway|brussels|budapest|builders|business|capetown|catering|catholic|chrysler|cipriani|cityeats|cleaning|clinique|clothing|commbank|computer|delivery|deloitte|democrat|diamonds|discount|discover|download|engineer|ericsson|esurance|etisalat|everbank|exchange|feedback|fidelity|firmdale|football|frontier|goodyear|grainger|graphics|guardian|hdfcbank|helsinki|holdings|hospital|infiniti|ipiranga|istanbul|jpmorgan|lighting|lundbeck|marriott|maserati|mckinsey|memorial|merckmsd|mortgage|movistar|observer|partners|pharmacy|pictures|plumbing|property|redstone|reliance|saarland|samsclub|security|services|shopping|showtime|softbank|software|stcgroup|supplies|symantec|training|uconnect|vanguard|ventures|verisign|woodside|xn--90ae|xn--node|xn--p1ai|xn--qxam|yokohama|السعودية|abogado|academy|agakhan|alibaba|android|athleta|auction|audible|auspost|avianca|banamex|bauhaus|bentley|bestbuy|booking|brother|bugatti|capital|caravan|careers|cartier|channel|charity|chintai|citadel|clubmed|college|cologne|comcast|company|compare|contact|cooking|corsica|country|coupons|courses|cricket|cruises|dentist|digital|domains|exposed|express|farmers|fashion|ferrari|ferrero|finance|fishing|fitness|flights|florist|flowers|forsale|frogans|fujitsu|gallery|genting|godaddy|grocery|guitars|hamburg|hangout|hitachi|holiday|hosting|hoteles|hotmail|hyundai|iselect|ismaili|jewelry|juniper|kitchen|komatsu|lacaixa|lancome|lanxess|lasalle|latrobe|leclerc|liaison|limited|lincoln|markets|metlife|monster|netbank|netflix|network|neustar|okinawa|oldnavy|organic|origins|philips|pioneer|politie|realtor|recipes|rentals|reviews|rexroth|samsung|sandvik|schmidt|schwarz|science|shiksha|shriram|singles|staples|starhub|storage|support|surgery|systems|temasek|theater|theatre|tickets|tiffany|toshiba|trading|walmart|wanggou|watches|weather|website|wedding|whoswho|windows|winners|xfinity|yamaxun|youtube|zuerich|католик|اتصالات|الجزائر|العليان|پاکستان|كاثوليك|موبايلي|இந்தியா|abarth|abbott|abbvie|active|africa|agency|airbus|airtel|alipay|alsace|alstom|anquan|aramco|author|bayern|beauty|berlin|bharti|blanco|bostik|boston|broker|camera|career|caseih|casino|center|chanel|chrome|church|circle|claims|clinic|coffee|comsec|condos|coupon|credit|cruise|dating|datsun|dealer|degree|dental|design|direct|doctor|dunlop|dupont|durban|emerck|energy|estate|events|expert|family|flickr|futbol|gallup|garden|george|giving|global|google|gratis|health|hermes|hiphop|hockey|hotels|hughes|imamat|insure|intuit|jaguar|joburg|juegos|kaufen|kinder|kindle|kosher|lancia|latino|lawyer|lefrak|living|locker|london|luxury|madrid|maison|makeup|market|mattel|mobile|mobily|monash|mormon|moscow|museum|mutual|nagoya|natura|nissan|nissay|norton|nowruz|office|olayan|online|oracle|orange|otsuka|pfizer|photos|physio|piaget|pictet|quebec|racing|realty|reisen|repair|report|review|rocher|rogers|ryukyu|safety|sakura|sanofi|school|schule|search|secure|select|shouji|soccer|social|stream|studio|supply|suzuki|swatch|sydney|taipei|taobao|target|tattoo|tennis|tienda|tjmaxx|tkmaxx|toyota|travel|unicom|viajes|viking|villas|virgin|vision|voting|voyage|vuelos|walter|warman|webcam|xihuan|yachts|yandex|zappos|москва|онлайн|ابوظبي|ارامكو|الاردن|المغرب|امارات|فلسطين|مليسيا|भारतम्|இலங்கை|ファッション|actor|adult|aetna|amfam|amica|apple|archi|audio|autos|azure|baidu|beats|bible|bingo|black|boats|bosch|build|canon|cards|chase|cheap|cisco|citic|click|cloud|coach|codes|crown|cymru|dabur|dance|deals|delta|dodge|drive|dubai|earth|edeka|email|epost|epson|faith|fedex|final|forex|forum|gallo|games|gifts|gives|glade|glass|globo|gmail|green|gripe|group|gucci|guide|homes|honda|horse|house|hyatt|ikano|intel|irish|iveco|jetzt|koeln|kyoto|lamer|lease|legal|lexus|lilly|linde|lipsy|lixil|loans|locus|lotte|lotto|lupin|macys|mango|media|miami|money|mopar|movie|nadex|nexus|nikon|ninja|nokia|nowtv|omega|osaka|paris|parts|party|phone|photo|pizza|place|poker|praxi|press|prime|promo|quest|radio|rehab|reise|ricoh|rocks|rodeo|rugby|salon|sener|seven|sharp|shell|shoes|skype|sling|smart|smile|solar|space|sport|stada|store|study|style|sucks|swiss|tatar|tires|tirol|tmall|today|tokyo|tools|toray|total|tours|trade|trust|tunes|tushu|ubank|vegas|video|vodka|volvo|wales|watch|weber|weibo|works|world|xerox|yahoo|zippo|ایران|بازار|بھارت|سودان|سورية|همراه|भारोत|संगठन|বাংলা|భారత్|ഭാരതം|嘉里大酒店|aarp|able|adac|aero|aigo|akdn|ally|amex|arab|army|arpa|arte|asda|asia|audi|auto|baby|band|bank|bbva|beer|best|bike|bing|blog|blue|bofa|bond|book|buzz|cafe|call|camp|care|cars|casa|case|cash|cbre|cern|chat|citi|city|club|cool|coop|cyou|data|date|dclk|deal|dell|desi|diet|dish|docs|doha|duck|duns|dvag|erni|fage|fail|fans|farm|fast|fiat|fido|film|fire|fish|flir|food|ford|free|fund|game|gbiz|gent|ggee|gift|gmbh|gold|golf|goog|guge|guru|hair|haus|hdfc|help|here|hgtv|host|hsbc|icbc|ieee|imdb|immo|info|itau|java|jeep|jobs|jprs|kddi|kiwi|kpmg|kred|land|lego|lgbt|lidl|life|like|limo|link|live|loan|loft|love|ltda|luxe|maif|meet|meme|menu|mini|mint|mobi|moda|moto|name|navy|news|next|nico|nike|ollo|open|page|pars|pccw|pics|ping|pink|play|plus|pohl|porn|post|prod|prof|qpon|raid|read|reit|rent|rest|rich|rmit|room|rsvp|ruhr|safe|sale|sarl|save|saxo|scor|scot|seat|seek|sexy|shaw|shia|shop|show|silk|sina|site|skin|sncf|sohu|song|sony|spot|star|surf|talk|taxi|team|tech|teva|tiaa|tips|town|toys|tube|vana|visa|viva|vivo|vote|voto|wang|weir|wien|wiki|wine|work|xbox|yoga|zara|zero|zone|дети|сайт|بارت|بيتك|ڀارت|تونس|شبكة|عراق|عمان|موقع|भारत|ভারত|ভাৰত|ਭਾਰਤ|ભારત|ଭାରତ|ಭಾರತ|ලංකා|グーグル|クラウド|ポイント|大众汽车|组织机构|電訊盈科|香格里拉|aaa|abb|abc|aco|ads|aeg|afl|aig|anz|aol|app|art|aws|axa|bar|bbc|bbt|bcg|bcn|bet|bid|bio|biz|bms|bmw|bnl|bom|boo|bot|box|buy|bzh|cab|cal|cam|car|cat|cba|cbn|cbs|ceb|ceo|cfa|cfd|com|crs|csc|dad|day|dds|dev|dhl|diy|dnp|dog|dot|dtv|dvr|eat|eco|edu|esq|eus|fan|fit|fly|foo|fox|frl|ftr|fun|fyi|gal|gap|gdn|gea|gle|gmo|gmx|goo|gop|got|gov|hbo|hiv|hkt|hot|how|ibm|ice|icu|ifm|inc|ing|ink|int|ist|itv|jcb|jcp|jio|jll|jmp|jnj|jot|joy|kfh|kia|kim|kpn|krd|lat|law|lds|llc|lol|lpl|ltd|man|map|mba|med|men|mil|mit|mlb|mls|mma|moe|moi|mom|mov|msd|mtn|mtr|nab|nba|nec|net|new|nfl|ngo|nhk|now|nra|nrw|ntt|nyc|obi|off|one|ong|onl|ooo|org|ott|ovh|pay|pet|phd|pid|pin|pnc|pro|pru|pub|pwc|qvc|red|ren|ril|rio|rip|run|rwe|sap|sas|sbi|sbs|sca|scb|ses|sew|sex|sfr|ski|sky|soy|srl|srt|stc|tab|tax|tci|tdk|tel|thd|tjx|top|trv|tui|tvs|ubs|uno|uol|ups|vet|vig|vin|vip|wed|win|wme|wow|wtc|wtf|xin|xxx|xyz|you|yun|zip|бел|ком|қаз|мкд|мон|орг|рус|срб|укр|հայ|קום|عرب|قطر|كوم|مصر|कॉम|नेट|คอม|ไทย|ストア|セール|みんな|中文网|天主教|我爱你|新加坡|淡马锡|诺基亚|飞利浦|ac|ad|ae|af|ag|ai|al|am|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw|ελ|бг|ею|рф|გე|닷넷|닷컴|삼성|한국|コム|世界|中信|中国|中國|企业|佛山|信息|健康|八卦|公司|公益|台湾|台灣|商城|商店|商标|嘉里|在线|大拿|娱乐|家電|工行|广东|微博|慈善|手机|手表|招聘|政务|政府|新闻|时尚|書籍|机构|游戏|澳門|点看|珠宝|移动|网址|网店|网站|网络|联通|谷歌|购物|通販|集团|食品|餐厅|香港)/;

//# sourceMappingURL=tld-regex.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return UrlMatcher; });
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(88);
 var __WEBPACK_IMPORTED_MODULE_2__regex_lib__ = __webpack_require__(89);
 var __WEBPACK_IMPORTED_MODULE_3__tld_regex__ = __webpack_require__(426);
 var __WEBPACK_IMPORTED_MODULE_4__match_url_match__ = __webpack_require__(246);
 var __WEBPACK_IMPORTED_MODULE_5__url_match_validator__ = __webpack_require__(959);






// RegExp objects which are shared by all instances of UrlMatcher. These are
// here to avoid re-instantiating the RegExp objects if `Autolinker.link()` is
// called multiple times, thus instantiating UrlMatcher and its RegExp 
// objects each time (which is very expensive - see https://github.com/gregjacobs/Autolinker.js/issues/314). 
// See descriptions of the properties where they are used for details about them
var matcherRegex = (function () {
    var schemeRegex = /(?:[A-Za-z][-.+A-Za-z0-9]{0,63}:(?![A-Za-z][-.+A-Za-z0-9]{0,63}:\/\/)(?!\d+\/?)(?:\/\/)?)/, // match protocol, allow in format "http://" or "mailto:". However, do not match the first part of something like 'link:http://www.google.com' (i.e. don't match "link:"). Also, make sure we don't interpret 'google.com:8000' as if 'google.com' was a protocol here (i.e. ignore a trailing port number in this regex)
    wwwRegex = /(?:www\.)/, // starting with 'www.'
    // Allow optional path, query string, and hash anchor, not ending in the following characters: "?!:,.;"
    // http://blog.codinghorror.com/the-problem-with-urls/
    urlSuffixRegex = new RegExp('[/?#](?:[' + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + '\\-+&@#/%=~_()|\'$*\\[\\]{}?!:,.;^\u2713]*[' + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + '\\-+&@#/%=~_()|\'$*\\[\\]{}\u2713])?');
    return new RegExp([
        '(?:',
        '(',
        schemeRegex.source,
        Object(__WEBPACK_IMPORTED_MODULE_2__regex_lib__["g" ])(2),
        ')',
        '|',
        '(',
        '(//)?',
        wwwRegex.source,
        Object(__WEBPACK_IMPORTED_MODULE_2__regex_lib__["g" ])(6),
        ')',
        '|',
        '(',
        '(//)?',
        Object(__WEBPACK_IMPORTED_MODULE_2__regex_lib__["g" ])(10) + '\\.',
        __WEBPACK_IMPORTED_MODULE_3__tld_regex__["a" ].source,
        '(?![-' + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["c" ] + '])',
        ')',
        ')',
        '(?::[0-9]+)?',
        '(?:' + urlSuffixRegex.source + ')?' // match for path, query string, and/or hash anchor - optional
    ].join(""), 'gi');
})();
var wordCharRegExp = new RegExp('[' + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + ']');

var UrlMatcher =  (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" ])(UrlMatcher, _super);
    
    function UrlMatcher(cfg) {
        var _this = _super.call(this, cfg) || this;
        
        _this.stripPrefix = { scheme: true, www: true }; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.stripTrailingSlash = true; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.decodePercentEncoding = true; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.matcherRegex = matcherRegex;
        
        _this.wordCharRegExp = wordCharRegExp;
        _this.stripPrefix = cfg.stripPrefix;
        _this.stripTrailingSlash = cfg.stripTrailingSlash;
        _this.decodePercentEncoding = cfg.decodePercentEncoding;
        return _this;
    }
    
    UrlMatcher.prototype.parseMatches = function (text) {
        var matcherRegex = this.matcherRegex, stripPrefix = this.stripPrefix, stripTrailingSlash = this.stripTrailingSlash, decodePercentEncoding = this.decodePercentEncoding, tagBuilder = this.tagBuilder, matches = [], match;
        var _loop_1 = function () {
            var matchStr = match[0], schemeUrlMatch = match[1], wwwUrlMatch = match[4], wwwProtocolRelativeMatch = match[5], 
            //tldUrlMatch = match[ 8 ],  -- not needed at the moment
            tldProtocolRelativeMatch = match[9], offset = match.index, protocolRelativeMatch = wwwProtocolRelativeMatch || tldProtocolRelativeMatch, prevChar = text.charAt(offset - 1);
            if (!__WEBPACK_IMPORTED_MODULE_5__url_match_validator__["a" ].isValid(matchStr, schemeUrlMatch)) {
                return "continue";
            }
            // If the match is preceded by an '@' character, then it is either
            // an email address or a username. Skip these types of matches.
            if (offset > 0 && prevChar === '@') {
                return "continue";
            }
            // If it's a protocol-relative '//' match, but the character before the '//'
            // was a word character (i.e. a letter/number), then we found the '//' in the
            // middle of another word (such as "asdf//asdf.com"). In this case, skip the
            // match.
            if (offset > 0 && protocolRelativeMatch && this_1.wordCharRegExp.test(prevChar)) {
                return "continue";
            }
            // If the URL ends with a question mark, don't include the question
            // mark as part of the URL. We'll assume the question mark was the
            // end of a sentence, such as: "Going to google.com?"
            if (/\?$/.test(matchStr)) {
                matchStr = matchStr.substr(0, matchStr.length - 1);
            }
            // Handle a closing parenthesis or square bracket at the end of the 
            // match, and exclude it if there is not a matching open parenthesis 
            // or square bracket in the match itself.
            if (this_1.matchHasUnbalancedClosingParen(matchStr)) {
                matchStr = matchStr.substr(0, matchStr.length - 1); // remove the trailing ")"
            }
            else {
                // Handle an invalid character after the TLD
                var pos = this_1.matchHasInvalidCharAfterTld(matchStr, schemeUrlMatch);
                if (pos > -1) {
                    matchStr = matchStr.substr(0, pos); // remove the trailing invalid chars
                }
            }
            // The autolinker accepts many characters in a url's scheme (like `fake://test.com`).
            // However, in cases where a URL is missing whitespace before an obvious link,
            // (for example: `nowhitespacehttp://www.test.com`), we only want the match to start
            // at the http:// part. We will check if the match contains a common scheme and then 
            // shift the match to start from there. 		
            var foundCommonScheme = ['http://', 'https://'].find(function (commonScheme) { return !!schemeUrlMatch && schemeUrlMatch.indexOf(commonScheme) !== -1; });
            if (foundCommonScheme) {
                // If we found an overmatched URL, we want to find the index
                // of where the match should start and shift the match to
                // start from the beginning of the common scheme
                var indexOfSchemeStart = matchStr.indexOf(foundCommonScheme);
                matchStr = matchStr.substr(indexOfSchemeStart);
                schemeUrlMatch = schemeUrlMatch.substr(indexOfSchemeStart);
                offset = offset + indexOfSchemeStart;
            }
            var urlMatchType = schemeUrlMatch ? 'scheme' : (wwwUrlMatch ? 'www' : 'tld'), protocolUrlMatch = !!schemeUrlMatch;
            matches.push(new __WEBPACK_IMPORTED_MODULE_4__match_url_match__["a" ]({
                tagBuilder: tagBuilder,
                matchedText: matchStr,
                offset: offset,
                urlMatchType: urlMatchType,
                url: matchStr,
                protocolUrlMatch: protocolUrlMatch,
                protocolRelativeMatch: !!protocolRelativeMatch,
                stripPrefix: stripPrefix,
                stripTrailingSlash: stripTrailingSlash,
                decodePercentEncoding: decodePercentEncoding,
            }));
        };
        var this_1 = this;
        while ((match = matcherRegex.exec(text)) !== null) {
            _loop_1();
        }
        return matches;
    };
    
    UrlMatcher.prototype.matchHasUnbalancedClosingParen = function (matchStr) {
        var endChar = matchStr.charAt(matchStr.length - 1);
        var startChar;
        if (endChar === ')') {
            startChar = '(';
        }
        else if (endChar === ']') {
            startChar = '[';
        }
        else if (endChar === '}') {
            startChar = '{';
        }
        else {
            return false; // not a close parenthesis or square bracket
        }
        // Find if there are the same number of open braces as close braces in
        // the URL string, minus the last character (which we have already 
        // determined to be either ')', ']' or '}'
        var numOpenBraces = 0;
        for (var i = 0, len = matchStr.length - 1; i < len; i++) {
            var char = matchStr.charAt(i);
            if (char === startChar) {
                numOpenBraces++;
            }
            else if (char === endChar) {
                numOpenBraces = Math.max(numOpenBraces - 1, 0);
            }
        }
        // If the number of open braces matches the number of close braces in
        // the URL minus the last character, then the match has *unbalanced*
        // braces because of the last character. Example of unbalanced braces
        // from the regex match:
        //     "http://example.com?a[]=1]"
        if (numOpenBraces === 0) {
            return true;
        }
        return false;
    };
    
    UrlMatcher.prototype.matchHasInvalidCharAfterTld = function (urlMatch, schemeUrlMatch) {
        if (!urlMatch) {
            return -1;
        }
        var offset = 0;
        if (schemeUrlMatch) {
            offset = urlMatch.indexOf(':');
            urlMatch = urlMatch.slice(offset);
        }
        var re = new RegExp("^((.?\/\/)?[-." + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "]*[-" + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "]\\.[-" + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "]+)");
        var res = re.exec(urlMatch);
        if (res === null) {
            return -1;
        }
        offset += res[1].length;
        urlMatch = urlMatch.slice(res[1].length);
        if (/^[^-.A-Za-z0-9:\/?#]/.test(urlMatch)) {
            return offset;
        }
        return -1;
    };
    return UrlMatcher;
}(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" ]));


//# sourceMappingURL=url-matcher.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return HashtagMatcher; });
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(88);
 var __WEBPACK_IMPORTED_MODULE_2__regex_lib__ = __webpack_require__(89);
 var __WEBPACK_IMPORTED_MODULE_3__match_hashtag_match__ = __webpack_require__(243);




// RegExp objects which are shared by all instances of HashtagMatcher. These are
// here to avoid re-instantiating the RegExp objects if `Autolinker.link()` is
// called multiple times, thus instantiating HashtagMatcher and its RegExp 
// objects each time (which is very expensive - see https://github.com/gregjacobs/Autolinker.js/issues/314). 
// See descriptions of the properties where they are used for details about them
var matcherRegex = new RegExp("#[_" + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "]{1,139}(?![_" + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "])", 'g'); // lookahead used to make sure we don't match something above 139 characters
var nonWordCharRegex = new RegExp('[^' + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + ']');

var HashtagMatcher =  (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" ])(HashtagMatcher, _super);
    
    function HashtagMatcher(cfg) {
        var _this = _super.call(this, cfg) || this;
        
        _this.serviceName = 'twitter'; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.matcherRegex = matcherRegex;
        
        _this.nonWordCharRegex = nonWordCharRegex;
        _this.serviceName = cfg.serviceName;
        return _this;
    }
    
    HashtagMatcher.prototype.parseMatches = function (text) {
        var matcherRegex = this.matcherRegex, nonWordCharRegex = this.nonWordCharRegex, serviceName = this.serviceName, tagBuilder = this.tagBuilder, matches = [], match;
        while ((match = matcherRegex.exec(text)) !== null) {
            var offset = match.index, prevChar = text.charAt(offset - 1);
            // If we found the match at the beginning of the string, or we found the match
            // and there is a whitespace char in front of it (meaning it is not a '#' char
            // in the middle of a word), then it is a hashtag match.
            if (offset === 0 || nonWordCharRegex.test(prevChar)) {
                var matchedText = match[0], hashtag = match[0].slice(1); // strip off the '#' character at the beginning
                matches.push(new __WEBPACK_IMPORTED_MODULE_3__match_hashtag_match__["a" ]({
                    tagBuilder: tagBuilder,
                    matchedText: matchedText,
                    offset: offset,
                    serviceName: serviceName,
                    hashtag: hashtag
                }));
            }
        }
        return matches;
    };
    return HashtagMatcher;
}(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" ]));


//# sourceMappingURL=hashtag-matcher.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneMatcher; });
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(88);
 var __WEBPACK_IMPORTED_MODULE_2__match_phone_match__ = __webpack_require__(245);
 var __WEBPACK_IMPORTED_MODULE_3__regex_lib__ = __webpack_require__(89);




// RegExp objects which are shared by all instances of PhoneMatcher. These are
// here to avoid re-instantiating the RegExp objects if `Autolinker.link()` is
// called multiple times, thus instantiating PhoneMatcher and its RegExp
// objects each time (which is very expensive - see https://github.com/gregjacobs/Autolinker.js/issues/314).
// See descriptions of the properties where they are used for details about them
// Over the years, many people have added to this regex, but it should have been
// split up by country. Maybe one day we can break this down.
var mostPhoneNumbers = /(?:(?:(?:(\+)?\d{1,3}[-\040.]?)?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]?\d{4})|(?:(\+)(?:9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)[-\040.]?(?:\d[-\040.]?){6,12}\d+))([,;]+[0-9]+#?)*/;
// Regex for Japanese phone numbers
var japanesePhoneRe = /(0([1-9]{1}-?[1-9]\d{3}|[1-9]{2}-?\d{3}|[1-9]{2}\d{1}-?\d{2}|[1-9]{2}\d{2}-?\d{1})-?\d{4}|0[789]0-?\d{4}-?\d{4}|050-?\d{4}-?\d{4})/;
// Combined regex
var phoneMatcherRegex = new RegExp(mostPhoneNumbers.source + "|" + japanesePhoneRe.source, 'g');

var PhoneMatcher =  (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" ])(PhoneMatcher, _super);
    function PhoneMatcher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        
        _this.matcherRegex = phoneMatcherRegex;
        return _this;
    }
    
    PhoneMatcher.prototype.parseMatches = function (text) {
        var matcherRegex = this.matcherRegex, tagBuilder = this.tagBuilder, matches = [], match;
        while ((match = matcherRegex.exec(text)) !== null) {
            // Remove non-numeric values from phone number string
            var matchedText = match[0], cleanNumber = matchedText.replace(/[^0-9,;#]/g, ''), // strip out non-digit characters exclude comma semicolon and #
            plusSign = !!(match[1] || match[2]), // match[ 1 ] or match[ 2 ] is the prefixed plus sign, if there is one
            before = match.index == 0 ? '' : text.substr(match.index - 1, 1), after = text.substr(match.index + matchedText.length, 1), contextClear = !before.match(/\d/) && !after.match(/\d/);
            if (this.testMatch(match[3]) && this.testMatch(matchedText) && contextClear) {
                matches.push(new __WEBPACK_IMPORTED_MODULE_2__match_phone_match__["a" ]({
                    tagBuilder: tagBuilder,
                    matchedText: matchedText,
                    offset: match.index,
                    number: cleanNumber,
                    plusSign: plusSign
                }));
            }
        }
        return matches;
    };
    PhoneMatcher.prototype.testMatch = function (text) {
        return __WEBPACK_IMPORTED_MODULE_3__regex_lib__["i" ].test(text);
    };
    return PhoneMatcher;
}(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" ]));


//# sourceMappingURL=phone-matcher.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return MentionMatcher; });
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(88);
 var __WEBPACK_IMPORTED_MODULE_2__regex_lib__ = __webpack_require__(89);
 var __WEBPACK_IMPORTED_MODULE_3__match_mention_match__ = __webpack_require__(244);




// RegExp objects which are shared by all instances of MentionMatcher. These are
// here to avoid re-instantiating the RegExp objects if `Autolinker.link()` is
// called multiple times, thus instantiating MentionMatcher and its RegExp 
// objects each time (which is very expensive - see https://github.com/gregjacobs/Autolinker.js/issues/314). 
// See descriptions of the properties where they are used for details about them
var twitterRegex = new RegExp("@[_" + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "]{1,50}(?![_" + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "])", 'g'); // lookahead used to make sure we don't match something above 50 characters
var instagramRegex = new RegExp("@[_." + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "]{1,30}(?![_" + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "])", 'g'); // lookahead used to make sure we don't match something above 30 characters
var soundcloudRegex = new RegExp("@[-_." + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "]{1,50}(?![-_" + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + "])", 'g'); // lookahead used to make sure we don't match something above 50 characters
var nonWordCharRegex = new RegExp('[^' + __WEBPACK_IMPORTED_MODULE_2__regex_lib__["b" ] + ']');

var MentionMatcher =  (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" ])(MentionMatcher, _super);
    
    function MentionMatcher(cfg) {
        var _this = _super.call(this, cfg) || this;
        
        _this.serviceName = 'twitter'; // default value just to get the above doc comment in the ES5 output and documentation generator
        
        _this.matcherRegexes = {
            'twitter': twitterRegex,
            'instagram': instagramRegex,
            'soundcloud': soundcloudRegex
        };
        
        _this.nonWordCharRegex = nonWordCharRegex;
        _this.serviceName = cfg.serviceName;
        return _this;
    }
    
    MentionMatcher.prototype.parseMatches = function (text) {
        var serviceName = this.serviceName, matcherRegex = this.matcherRegexes[this.serviceName], nonWordCharRegex = this.nonWordCharRegex, tagBuilder = this.tagBuilder, matches = [], match;
        if (!matcherRegex) {
            return matches;
        }
        while ((match = matcherRegex.exec(text)) !== null) {
            var offset = match.index, prevChar = text.charAt(offset - 1);
            // If we found the match at the beginning of the string, or we found the match
            // and there is a whitespace char in front of it (meaning it is not an email
            // address), then it is a username match.
            if (offset === 0 || nonWordCharRegex.test(prevChar)) {
                var matchedText = match[0].replace(/\.+$/g, ''), // strip off trailing .
                mention = matchedText.slice(1); // strip off the '@' character at the beginning
                matches.push(new __WEBPACK_IMPORTED_MODULE_3__match_mention_match__["a" ]({
                    tagBuilder: tagBuilder,
                    matchedText: matchedText,
                    offset: offset,
                    serviceName: serviceName,
                    mention: mention
                }));
            }
        }
        return matches;
    };
    return MentionMatcher;
}(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" ]));


//# sourceMappingURL=mention-matcher.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__FilledInput__ = __webpack_require__(968);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FilledInput__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__OutlinedInput__ = __webpack_require__(969);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OutlinedInput__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__FormControl__ = __webpack_require__(974);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormControl__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__useFormControl__ = __webpack_require__(90);




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(236);




 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" ])( __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown'));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(38);









var NativeSelectInput = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function NativeSelectInput(props, ref) {
  var classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("select", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, // TODO v5: merge root and select
    classes.select, classes[variant], className, disabled && classes.disabled),
    disabled: disabled,
    ref: inputRef || ref
  }, other)), props.multiple ? null : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.icon, classes["icon".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" ])(variant))], disabled && classes.disabled)
  }));
});
 false ? NativeSelectInput.propTypes = {
  
  children: PropTypes.node,

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string,

  
  disabled: PropTypes.bool,

  
  IconComponent: PropTypes.elementType.isRequired,

  
  inputRef: refType,

  
  multiple: PropTypes.bool,

  
  name: PropTypes.string,

  
  onChange: PropTypes.func,

  
  value: PropTypes.any,

  
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
 __webpack_exports__["a"] = (NativeSelectInput);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



 __webpack_exports__["a"] = isCommunities;

var ROLE_CHAMPION=21283819;var ROLE_COMMUNITIES_MANAGER=21280499;var ROLE_USER=21280500;function isCommunities(id){if(id===ROLE_COMMUNITIES_MANAGER){return true;}return false;}function isChampion(id){if(id===ROLE_CHAMPION){return true;}return false;}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return DISCOVER; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return INITIATIVES; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_FOR_IMPACT; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return NARRATIVE; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return CONNECTIONS; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return CHATS; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return THINK; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return THINK_CHAT; });

 __webpack_require__.d(__webpack_exports__, "h", function() { return PROFILE; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return FINETUNE; });
var DISCOVER='discover';var INITIATIVES='initiatives';var CALL_FOR_IMPACT='call_for_impact';var NARRATIVE='narrative';var CONNECTIONS='connections';var CHATS='chats';var THINK='think';var THINK_CHAT='think-chat';var THINK_TANK='think-tank';var PROFILE='profile';var FINETUNE='fine-tune';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
 var __WEBPACK_IMPORTED_MODULE_0__NotFound__ = __webpack_require__(1009);
 var __WEBPACK_IMPORTED_MODULE_1__Login__ = __webpack_require__(1011);
 var __WEBPACK_IMPORTED_MODULE_2__Logout__ = __webpack_require__(1030);
 var __WEBPACK_IMPORTED_MODULE_3__ForgetPassword__ = __webpack_require__(1033);
 var __WEBPACK_IMPORTED_MODULE_4__Signup__ = __webpack_require__(1040);
 var __WEBPACK_IMPORTED_MODULE_5__SignupTemp__ = __webpack_require__(1059);
 var __WEBPACK_IMPORTED_MODULE_6__Profile__ = __webpack_require__(1066);
 var __WEBPACK_IMPORTED_MODULE_7__SocialOauth__ = __webpack_require__(1072);
 var __WEBPACK_IMPORTED_MODULE_8__Chat__ = __webpack_require__(1075);
 var __WEBPACK_IMPORTED_MODULE_9__UsersProfiles__ = __webpack_require__(1079);
 var __WEBPACK_IMPORTED_MODULE_10__UserProfile__ = __webpack_require__(1102);
 var __WEBPACK_IMPORTED_MODULE_11__CancelDeletionAccount__ = __webpack_require__(1131);
 var __WEBPACK_IMPORTED_MODULE_12__Connections__ = __webpack_require__(1137);
 var __WEBPACK_IMPORTED_MODULE_13__Narratives__ = __webpack_require__(1239);
 var __WEBPACK_IMPORTED_MODULE_14__Gpdr__ = __webpack_require__(1259);
 var __WEBPACK_IMPORTED_MODULE_15__ThinkSeedCreation__ = __webpack_require__(1263);
 var __WEBPACK_IMPORTED_MODULE_16__Invitations__ = __webpack_require__(1272);
 var __WEBPACK_IMPORTED_MODULE_17__Upgrade__ = __webpack_require__(1277);
 var __WEBPACK_IMPORTED_MODULE_18__Think__ = __webpack_require__(1288);
 var __WEBPACK_IMPORTED_MODULE_19__ThinkTank__ = __webpack_require__(1297);
 var __WEBPACK_IMPORTED_MODULE_20__DeleteAccountSuccess__ = __webpack_require__(1375);
 var __WEBPACK_IMPORTED_MODULE_21__NarrativeThinkChats__ = __webpack_require__(1379);
 var __WEBPACK_IMPORTED_MODULE_22__NarrativeSpeedDating__ = __webpack_require__(1384);
 var __WEBPACK_IMPORTED_MODULE_23__ZoomMeeting__ = __webpack_require__(1388);
 var __WEBPACK_IMPORTED_MODULE_24__CallForImpact__ = __webpack_require__(1399);
 var __WEBPACK_IMPORTED_MODULE_25__Narrative__ = __webpack_require__(1402);
 var __WEBPACK_IMPORTED_MODULE_26__ElementForm__ = __webpack_require__(1868);
 var __WEBPACK_IMPORTED_MODULE_27__Step__ = __webpack_require__(1872);
 var __WEBPACK_IMPORTED_MODULE_28__ThemeTable__ = __webpack_require__(1875);
 var __WEBPACK_IMPORTED_MODULE_29__ThemeTableEdit__ = __webpack_require__(1899);
 var __WEBPACK_IMPORTED_MODULE_30__CallForImpactHall__ = __webpack_require__(1902);
 var __WEBPACK_IMPORTED_MODULE_31__NoRecommendations__ = __webpack_require__(1908);
 var __WEBPACK_IMPORTED_MODULE_32__Call__ = __webpack_require__(1914);
 var __WEBPACK_IMPORTED_MODULE_33__Impersonate__ = __webpack_require__(1919);
 var __WEBPACK_IMPORTED_MODULE_34__ProfileEdit__ = __webpack_require__(1923);
 var __WEBPACK_IMPORTED_MODULE_35__FineTune__ = __webpack_require__(1927);
 var __WEBPACK_IMPORTED_MODULE_36__SpeedDating__ = __webpack_require__(1932);
 var __WEBPACK_IMPORTED_MODULE_37__RecommendationsUsers__ = __webpack_require__(1937);
 var __WEBPACK_IMPORTED_MODULE_38__RecommendationsTables__ = __webpack_require__(1941);
 var __WEBPACK_IMPORTED_MODULE_39__SpeedDatingRandomMeeting__ = __webpack_require__(1945);
 var __WEBPACK_IMPORTED_MODULE_40__Embed_Main__ = __webpack_require__(1949);
 var __WEBPACK_IMPORTED_MODULE_41__constants_urls__ = __webpack_require__(19);
var routes=[{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["a" ],component:__WEBPACK_IMPORTED_MODULE_13__Narratives__["a" ],exact:true,header:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["u" ],component:__WEBPACK_IMPORTED_MODULE_13__Narratives__["a" ],exact:true,header:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["s" ],component:__WEBPACK_IMPORTED_MODULE_14__Gpdr__["a" ],exact:false,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["i" ],component:__WEBPACK_IMPORTED_MODULE_12__Connections__["a" ],exact:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["j" ],component:__WEBPACK_IMPORTED_MODULE_12__Connections__["a" ],exact:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["d" ],component:__WEBPACK_IMPORTED_MODULE_30__CallForImpactHall__["a" ],exact:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["e" ],component:__WEBPACK_IMPORTED_MODULE_30__CallForImpactHall__["a" ],exact:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["R" ],component:__WEBPACK_IMPORTED_MODULE_15__ThinkSeedCreation__["a" ],exact:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["Q" ],component:__WEBPACK_IMPORTED_MODULE_15__ThinkSeedCreation__["a" ],exact:false,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["J" ],component:__WEBPACK_IMPORTED_MODULE_7__SocialOauth__["a" ],exact:false,footer:false,layout:false,ignoreSession:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["y" ],component:__WEBPACK_IMPORTED_MODULE_13__Narratives__["a" ],exact:false,header:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["w" ],component:__WEBPACK_IMPORTED_MODULE_1__Login__["a" ],exact:false,header:false,footer:false,layout:false,ignoreSession:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["x" ],component:__WEBPACK_IMPORTED_MODULE_2__Logout__["a" ],exact:false,header:false,layout:false,ignoreSession:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["r" ],component:__WEBPACK_IMPORTED_MODULE_3__ForgetPassword__["a" ],exact:false,header:false,layout:false,ignoreSession:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["H" ],component:__WEBPACK_IMPORTED_MODULE_4__Signup__["a" ],exact:true,header:false,layout:false,ignoreSession:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["G" ],component:__WEBPACK_IMPORTED_MODULE_4__Signup__["a" ],exact:true,header:false,layout:false,ignoreSession:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["I" ],component:__WEBPACK_IMPORTED_MODULE_5__SignupTemp__["a" ],exact:true,header:false,layout:false,ignoreSession:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["F" ],component:__WEBPACK_IMPORTED_MODULE_6__Profile__["a" ],exact:true,header:false,ignoreSession:false,layout:true,footer:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["l" ],component:__WEBPACK_IMPORTED_MODULE_34__ProfileEdit__["a" ],exact:true,header:false,ignoreSession:false,layout:true,footer:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["W" ],component:__WEBPACK_IMPORTED_MODULE_9__UsersProfiles__["a" ],exact:false,header:false,ignoreSession:false,footer:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["X" ],component:__WEBPACK_IMPORTED_MODULE_10__UserProfile__["a" ],exact:false,header:false,ignoreSession:false,footer:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["P" ],component:__WEBPACK_IMPORTED_MODULE_18__Think__["a" ],exact:false,header:false,ignoreSession:false,footer:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["U" ],component:__WEBPACK_IMPORTED_MODULE_18__Think__["a" ],exact:false,header:false,ignoreSession:false,footer:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["h" ],component:__WEBPACK_IMPORTED_MODULE_8__Chat__["a" ],exact:false,footer:false,ignoreSession:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["g" ],component:__WEBPACK_IMPORTED_MODULE_11__CancelDeletionAccount__["a" ],exact:false,ignoreSession:true,footer:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["v" ],component:__WEBPACK_IMPORTED_MODULE_16__Invitations__["a" ],exact:true,footer:false,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["z" ],component:__WEBPACK_IMPORTED_MODULE_16__Invitations__["a" ],exact:true,footer:false,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["S" ],component:__WEBPACK_IMPORTED_MODULE_28__ThemeTable__["a" ],exact:false,footer:true,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["V" ],component:__WEBPACK_IMPORTED_MODULE_17__Upgrade__["a" ],exact:false,footer:false,ignoreSession:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["T" ],component:__WEBPACK_IMPORTED_MODULE_19__ThinkTank__["a" ],exact:true,footer:false,ignoreSession:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["M" ],component:__WEBPACK_IMPORTED_MODULE_28__ThemeTable__["a" ],exact:true,footer:false,ignoreSession:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["b" ],component:__WEBPACK_IMPORTED_MODULE_32__Call__["a" ],exact:true,footer:false,ignoreSession:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["f" ],component:__WEBPACK_IMPORTED_MODULE_28__ThemeTable__["a" ],exact:true,footer:false,ignoreSession:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["k" ],component:__WEBPACK_IMPORTED_MODULE_20__DeleteAccountSuccess__["a" ],exact:true,footer:false,ignoreSession:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["D" ],component:__WEBPACK_IMPORTED_MODULE_21__NarrativeThinkChats__["a" ],exact:true,footer:true,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["B" ],component:__WEBPACK_IMPORTED_MODULE_22__NarrativeSpeedDating__["a" ],exact:true,footer:true,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["Y" ],component:__WEBPACK_IMPORTED_MODULE_23__ZoomMeeting__["a" ],exact:true,footer:false,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["c" ],component:__WEBPACK_IMPORTED_MODULE_24__CallForImpact__["a" ],exact:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["A" ],component:__WEBPACK_IMPORTED_MODULE_25__Narrative__["a" ],exact:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["m" ],component:__WEBPACK_IMPORTED_MODULE_26__ElementForm__["a" ],exact:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["C" ],component:__WEBPACK_IMPORTED_MODULE_27__Step__["a" ],exact:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["E" ],component:__WEBPACK_IMPORTED_MODULE_31__NoRecommendations__["a" ],exact:true,footer:true,layout:true,ignoreSession:false},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["t" ],component:__WEBPACK_IMPORTED_MODULE_33__Impersonate__["a" ],exact:false,footer:false,layout:false,ignoreSession:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["O" ],component:__WEBPACK_IMPORTED_MODULE_28__ThemeTable__["a" ],exact:true,footer:false,ignoreSession:true,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["N" ],component:__WEBPACK_IMPORTED_MODULE_29__ThemeTableEdit__["a" ],exact:true,footer:false,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["q" ],component:__WEBPACK_IMPORTED_MODULE_35__FineTune__["a" ],exact:true,footer:false,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["K" ],component:__WEBPACK_IMPORTED_MODULE_36__SpeedDating__["a" ],exact:true,footer:false,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["L" ],component:__WEBPACK_IMPORTED_MODULE_39__SpeedDatingRandomMeeting__["a" ],exact:true,footer:false,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["p" ],component:__WEBPACK_IMPORTED_MODULE_37__RecommendationsUsers__["a" ],exact:true,footer:false,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["o" ],component:__WEBPACK_IMPORTED_MODULE_38__RecommendationsTables__["a" ],exact:true,footer:false,ignoreSession:false,layout:true},{path:__WEBPACK_IMPORTED_MODULE_41__constants_urls__["n" ],component:__WEBPACK_IMPORTED_MODULE_40__Embed_Main__["a" ],exact:true,footer:false,ignoreSession:true,layout:false},{component:__WEBPACK_IMPORTED_MODULE_0__NotFound__["a" ],layout:true,header:false}];

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = requirePropFactory;
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
(function(setImmediate) { var __WEBPACK_IMPORTED_MODULE_0__finally__ = __webpack_require__(1018);


// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}


function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  
  this._state = 0;
  
  this._handled = false;
  
  this._value = undefined;
  
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}


function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}


function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  // @ts-ignore
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = __WEBPACK_IMPORTED_MODULE_0__finally__["a" ];

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

 __webpack_exports__["default"] = (Promise);

}.call(__webpack_exports__, __webpack_require__(1016).setImmediate))

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormContext = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _promisePolyfill = __webpack_require__(440);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

var _createReactContext = __webpack_require__(1020);

var _createReactContext2 = _interopRequireDefault(_createReactContext);

var _ValidationRules = __webpack_require__(442);

var _ValidationRules2 = _interopRequireDefault(_ValidationRules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } 




var FormContext = (0, _createReactContext2.default)('form');

exports.FormContext = FormContext;

var ValidatorForm = function (_React$Component) {
    _inherits(ValidatorForm, _React$Component);

    function ValidatorForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ValidatorForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ValidatorForm.__proto__ || Object.getPrototypeOf(ValidatorForm)).call.apply(_ref, [this].concat(args))), _this), _this.getFormHelpers = function () {
            return {
                form: {
                    attachToForm: _this.attachToForm,
                    detachFromForm: _this.detachFromForm,
                    instantValidate: _this.instantValidate,
                    debounceTime: _this.debounceTime
                }
            };
        }, _this.instantValidate = _this.props.instantValidate !== undefined ? _this.props.instantValidate : true, _this.debounceTime = _this.props.debounceTime, _this.childs = [], _this.errors = [], _this.attachToForm = function (component) {
            if (_this.childs.indexOf(component) === -1) {
                _this.childs.push(component);
            }
        }, _this.detachFromForm = function (component) {
            var componentPos = _this.childs.indexOf(component);
            if (componentPos !== -1) {
                _this.childs = _this.childs.slice(0, componentPos).concat(_this.childs.slice(componentPos + 1));
            }
        }, _this.submit = function (event) {
            if (event) {
                event.preventDefault();
                event.persist();
            }
            _this.errors = [];
            _this.walk(_this.childs).then(function (result) {
                if (_this.errors.length) {
                    _this.props.onError(_this.errors);
                }
                if (result) {
                    _this.props.onSubmit(event);
                }
                return result;
            });
        }, _this.walk = function (children, dryRun) {
            var self = _this;
            return new _promisePolyfill2.default(function (resolve) {
                var result = true;
                if (Array.isArray(children)) {
                    _promisePolyfill2.default.all(children.map(function (input) {
                        return self.checkInput(input, dryRun);
                    })).then(function (data) {
                        data.forEach(function (item) {
                            if (!item) {
                                result = false;
                            }
                        });
                        resolve(result);
                    });
                } else {
                    self.walk([children], dryRun).then(function (result) {
                        return resolve(result);
                    });
                }
            });
        }, _this.checkInput = function (input, dryRun) {
            return new _promisePolyfill2.default(function (resolve) {
                var result = true;
                var validators = input.props.validators;
                if (validators) {
                    _this.validate(input, true, dryRun).then(function (data) {
                        if (!data) {
                            result = false;
                        }
                        resolve(result);
                    });
                } else {
                    resolve(result);
                }
            });
        }, _this.validate = function (input, includeRequired, dryRun) {
            return new _promisePolyfill2.default(function (resolve) {
                var value = input.props.value;

                input.validate(value, includeRequired, dryRun).then(function (valid) {
                    if (!valid) {
                        _this.errors.push(input);
                    }
                    resolve(valid);
                });
            });
        }, _this.find = function (collection, fn) {
            for (var i = 0, l = collection.length; i < l; i++) {
                var item = collection[i];
                if (fn(item)) {
                    return item;
                }
            }
            return null;
        }, _this.resetValidations = function () {
            _this.childs.forEach(function (child) {
                child.validateDebounced.cancel();
                child.setState({ isValid: true });
            });
        }, _this.isFormValid = function () {
            var dryRun = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return _this.walk(_this.childs, dryRun);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ValidatorForm, [{
        key: 'render',
        value: function render() {
            // eslint-disable-next-line
            var _props = this.props,
                onSubmit = _props.onSubmit,
                instantValidate = _props.instantValidate,
                onError = _props.onError,
                debounceTime = _props.debounceTime,
                children = _props.children,
                rest = _objectWithoutProperties(_props, ['onSubmit', 'instantValidate', 'onError', 'debounceTime', 'children']);

            return _react2.default.createElement(
                FormContext.Provider,
                { value: this.getFormHelpers() },
                _react2.default.createElement(
                    'form',
                    _extends({}, rest, { onSubmit: this.submit }),
                    children
                )
            );
        }
    }]);

    return ValidatorForm;
}(_react2.default.Component);

ValidatorForm.getValidator = function (validator, value, includeRequired) {
    var result = true;
    var name = validator;
    if (name !== 'required' || includeRequired) {
        var extra = void 0;
        var splitIdx = validator.indexOf(':');
        if (splitIdx !== -1) {
            name = validator.substring(0, splitIdx);
            extra = validator.substring(splitIdx + 1);
        }
        result = _ValidationRules2.default[name](value, extra);
    }
    return result;
};

ValidatorForm.addValidationRule = function (name, callback) {
    _ValidationRules2.default[name] = callback;
};

ValidatorForm.getValidationRule = function (name) {
    return _ValidationRules2.default[name];
};

ValidatorForm.hasValidationRule = function (name) {
    return _ValidationRules2.default[name] && typeof _ValidationRules2.default[name] === 'function';
};

ValidatorForm.removeValidationRule = function (name) {
    delete _ValidationRules2.default[name];
};

ValidatorForm.propTypes = {
    onSubmit: _propTypes2.default.func.isRequired,
    instantValidate: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    onError: _propTypes2.default.func,
    debounceTime: _propTypes2.default.number
};

ValidatorForm.defaultProps = {
    onError: function onError() {},
    debounceTime: 0
};

exports.default = ValidatorForm;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var isExisty = function isExisty(value) {
    return value !== null && value !== undefined;
};

var _isEmpty = function _isEmpty(value) {
    if (value instanceof Array) {
        return value.length === 0;
    }
    return value === '' || !isExisty(value);
};

var isEmptyTrimed = function isEmptyTrimed(value) {
    if (typeof value === 'string') {
        return value.trim() === '';
    }
    return true;
};

var validations = {
    matchRegexp: function matchRegexp(value, regexp) {
        var validationRegexp = regexp instanceof RegExp ? regexp : new RegExp(regexp);
        return _isEmpty(value) || validationRegexp.test(value);
    },

    // eslint-disable-next-line
    isEmail: function isEmail(value) {
        return validations.matchRegexp(value, /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i);
    },

    isEmpty: function isEmpty(value) {
        return _isEmpty(value);
    },

    required: function required(value) {
        return !_isEmpty(value);
    },

    trim: function trim(value) {
        return !isEmptyTrimed(value);
    },

    isNumber: function isNumber(value) {
        return validations.matchRegexp(value, /^-?[0-9]\d*(\d+)?$/i);
    },

    isFloat: function isFloat(value) {
        return validations.matchRegexp(value, /^(?:-?[1-9]\d*|-?0)?(?:\.\d+)?$/i);
    },

    isPositive: function isPositive(value) {
        if (isExisty(value)) {
            return (validations.isNumber(value) || validations.isFloat(value)) && value >= 0;
        }
        return true;
    },

    maxNumber: function maxNumber(value, max) {
        return _isEmpty(value) || parseInt(value, 10) <= parseInt(max, 10);
    },

    minNumber: function minNumber(value, min) {
        return _isEmpty(value) || parseInt(value, 10) >= parseInt(min, 10);
    },

    maxFloat: function maxFloat(value, max) {
        return _isEmpty(value) || parseFloat(value) <= parseFloat(max);
    },

    minFloat: function minFloat(value, min) {
        return _isEmpty(value) || parseFloat(value) >= parseFloat(min);
    },

    isString: function isString(value) {
        return _isEmpty(value) || typeof value === 'string' || value instanceof String;
    },
    minStringLength: function minStringLength(value, length) {
        return validations.isString(value) && value.length >= length;
    },
    maxStringLength: function maxStringLength(value, length) {
        return validations.isString(value) && value.length <= length;
    },

    // eslint-disable-next-line no-undef
    isFile: function isFile(value) {
        return _isEmpty(value) || value instanceof File;
    },
    maxFileSize: function maxFileSize(value, max) {
        return _isEmpty(value) || validations.isFile(value) && value.size <= parseInt(max, 10);
    },
    allowedExtensions: function allowedExtensions(value, fileTypes) {
        return _isEmpty(value) || validations.isFile(value) && fileTypes.split(',').indexOf(value.type) !== -1;
    }
};

module.exports = validations;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



 __webpack_require__.d(__webpack_exports__, "a", function() { return doLogin; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return doLoginSocial; });


 var __WEBPACK_IMPORTED_MODULE_0_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_0_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_1_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_2__utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_3__store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(353);
 var __WEBPACK_IMPORTED_MODULE_5__Profile_modules_actions__ = __webpack_require__(92);
function fetchLoginInit(){return{type:__WEBPACK_IMPORTED_MODULE_4__types__["b" ]};}function fetchLoginSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_4__types__["c" ]};}function fetchLoginFailure(error){return{type:__WEBPACK_IMPORTED_MODULE_4__types__["a" ],payload:error};}var doLogin=function doLogin(email,password){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_globalState_global__["c" ])(true));var data={email:email,password:password,instanceCode:getState().app.code};return Object(__WEBPACK_IMPORTED_MODULE_2__utils_apiFetch__["b" ])('POST',{endPoint:'users-login'},data).then(function(response){__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveSession({token:response.user_code}).then(function(){var user=Object.assign({},response);user.instance=getState().app.id;__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveUser(user).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_globalState_global__["c" ])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_modules_app__["c" ])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__Profile_modules_actions__["c" ])('Success'));window.sendUserIdentifier(user.id);});});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_globalState_global__["c" ])(false));var errorResponse=typeof error.response!=='undefined'?error.response.data:'';dispatch(fetchLoginFailure(errorResponse));});};};var doLoginSocial=function doLoginSocial(userId){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_globalState_global__["c" ])(true));var data={instanceCode:getState().app.code,userId:userId};return Object(__WEBPACK_IMPORTED_MODULE_2__utils_apiFetch__["b" ])('GET',{endPoint:'users/login/social'},data).then(function(response){__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveSession({token:response.user_code}).then(function(){var user=Object.assign({},response);user.instance=getState().app.id;__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveUser(user).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_globalState_global__["c" ])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_modules_app__["c" ])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__Profile_modules_actions__["c" ])('Success'));});});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_globalState_global__["c" ])(false));dispatch(fetchLoginFailure(error.response.data));});};};function fetchloginAction(event,data){event.preventDefault();return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_globalState_global__["c" ])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__Profile_modules_actions__["b" ])());return new Promise(function(resolve){__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveSession({token:'123456789'}).then(function(){__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveUser(data).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__Profile_modules_actions__["c" ])('Success'));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_globalState_global__["c" ])(false));resolve(true);});});});};}function recoverPassword(_ref){var email=_ref.email,lang=_ref.lang;var url='request_password';return Object(__WEBPACK_IMPORTED_MODULE_2__utils_apiFetch__["b" ])('GET',{endPoint:url},{email:email,lang:lang});}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



 __webpack_exports__["a"] = fetchloginAction;
 __webpack_exports__["b"] = recoverPassword;
 var __WEBPACK_IMPORTED_MODULE_0_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_0_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_1__utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_2__store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(1039);
function fetchLoginInit(){return{type:__WEBPACK_IMPORTED_MODULE_3__types__["b" ]};}function fetchLoginSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_3__types__["c" ]};}function fetchLoginFailure(error){return{type:__WEBPACK_IMPORTED_MODULE_3__types__["a" ],payload:error};}function fetchloginAction(event,_ref){var email=_ref.email;event.preventDefault();return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_globalState_global__["c" ])(true));dispatch(fetchLoginInit());return new Promise(function(resolve){__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveSession({token:'123456789'}).then(function(){__WEBPACK_IMPORTED_MODULE_0_redux_react_session__["sessionService"].saveUser({email:email}).then(function(){dispatch(fetchLoginSuccess());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_globalState_global__["c" ])(false));resolve(true);});});});};}function recoverPassword(_ref2){var email=_ref2.email,lang=_ref2.lang;var url='request_password';return Object(__WEBPACK_IMPORTED_MODULE_1__utils_apiFetch__["b" ])('GET',{endPoint:url},{email:email,lang:lang});}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Fade__ = __webpack_require__(1046);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Fade__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Slide__ = __webpack_require__(1050);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Slide__["a"]; });


 }),

 (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],e):"object"==typeof exports?exports.reactAvatar=e(require("react")):t.reactAvatar=e(t.react)}(window,function(t){return function(t){var e={};function i(n){if(e[n])return e[n].exports;var a=e[n]={i:n,l:!1,exports:{}};return t[n].call(a.exports,a,a.exports,i),a.l=!0,a.exports}return i.m=t,i.c=e,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},i.r=function(t){Object.defineProperty(t,"__esModule",{value:!0})},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=23)}([function(e,i){e.exports=t},function(t,e,i){t.exports=i(22),i(20),i(19),i(18),i(17),i(16),i(15),i(14),i(13),i(12),i(11),i(10),i(9)},function(t,e,i){!function(){"use strict";var i={};function n(t){return d(">"+f("B",t.length),t)}function a(t){return d(">"+f("H",t.length),t)}function r(t){return d(">"+f("L",t.length),t)}function o(t,e,i){var o,s,h,l,c="",u="";if("Byte"==e)(o=t.length)<=4?u=n(t)+f("\0",4-o):(u=d(">L",[i]),c=n(t));else if("Short"==e)(o=t.length)<=2?u=a(t)+f("\0\0",2-o):(u=d(">L",[i]),c=a(t));else if("Long"==e)(o=t.length)<=1?u=r(t):(u=d(">L",[i]),c=r(t));else if("Ascii"==e)(o=(s=t+"\0").length)>4?(u=d(">L",[i]),c=s):u=s+f("\0",4-o);else if("Rational"==e){if("number"==typeof t[0])o=1,h=t[0],l=t[1],s=d(">L",[h])+d(">L",[l]);else{o=t.length,s="";for(var g=0;g<o;g++)h=t[g][0],l=t[g][1],s+=d(">L",[h])+d(">L",[l])}u=d(">L",[i]),c=s}else if("SRational"==e){if("number"==typeof t[0])o=1,h=t[0],l=t[1],s=d(">l",[h])+d(">l",[l]);else for(o=t.length,s="",g=0;g<o;g++)h=t[g][0],l=t[g][1],s+=d(">l",[h])+d(">l",[l]);u=d(">L",[i]),c=s}else"Undefined"==e&&((o=t.length)>4?(u=d(">L",[i]),c=t):u=t+f("\0",4-o));return[d(">L",[o]),u,c]}function s(t,e,i){var n,a=Object.keys(t).length,r=d(">H",[a]);n=["0th","1st"].indexOf(e)>-1?2+12*a+4:2+12*a;var s="",h="";for(var l in t)if("string"==typeof l&&(l=parseInt(l)),!("0th"==e&&[34665,34853].indexOf(l)>-1||"Exif"==e&&40965==l||"1st"==e&&[513,514].indexOf(l)>-1)){var c=t[l],u=d(">H",[l]),f=v[e][l].type,g=d(">H",[p[f]]);"number"==typeof c&&(c=[c]);var m=o(c,f,8+n+i+h.length);s+=u+g+m[0]+m[1],h+=m[2]}return[r+s,h]}function h(t){var e;if("ÿØ"==t.slice(0,2))e=function(t){for(var e,i=0;i<t.length;i++)if("ÿá"==(e=t[i]).slice(0,2)&&"Exif\0\0"==e.slice(4,10))return e;return null}(g(t)),this.tiftag=e?e.slice(10):null;else if(["II","MM"].indexOf(t.slice(0,2))>-1)this.tiftag=t;else{if("Exif"!=t.slice(0,4))throw"Given file is neither JPEG nor TIFF.";this.tiftag=t.slice(6)}}if(i.version="1.0.4",i.remove=function(t){var e=!1;if("ÿØ"==t.slice(0,2));else{if("data:image/jpeg;base64,"!=t.slice(0,23)&&"data:image/jpg;base64,"!=t.slice(0,22))throw"Given data is not jpeg.";t=c(t.split(",")[1]),e=!0}var i=g(t).filter(function(t){return!("ÿá"==t.slice(0,2)&&"Exif\0\0"==t.slice(4,10))}).join("");return e&&(i="data:image/jpeg;base64,"+l(i)),i},i.insert=function(t,e){var i=!1;if("Exif\0\0"!=t.slice(0,6))throw"Given data is not exif.";if("ÿØ"==e.slice(0,2));else{if("data:image/jpeg;base64,"!=e.slice(0,23)&&"data:image/jpg;base64,"!=e.slice(0,22))throw"Given data is not jpeg.";e=c(e.split(",")[1]),i=!0}var n="ÿá"+d(">H",[t.length+2])+t,a=function(t,e){return"ÿà"==t[1].slice(0,2)&&"ÿá"==t[2].slice(0,2)&&"Exif\0\0"==t[2].slice(4,10)?e?(t[2]=e,t=["ÿØ"].concat(t.slice(2))):t=null==e?t.slice(0,2).concat(t.slice(3)):t.slice(0).concat(t.slice(2)):"ÿà"==t[1].slice(0,2)?e&&(t[1]=e):"ÿá"==t[1].slice(0,2)&&"Exif\0\0"==t[1].slice(4,10)?e?t[1]=e:null==e&&(t=t.slice(0).concat(t.slice(2))):e&&(t=[t[0],e].concat(t.slice(1))),t.join("")}(g(e),n);return i&&(a="data:image/jpeg;base64,"+l(a)),a},i.load=function(t){var e;if("string"!=typeof t)throw"'load' gots invalid type argument.";if("ÿØ"==t.slice(0,2))e=t;else if("data:image/jpeg;base64,"==t.slice(0,23)||"data:image/jpg;base64,"==t.slice(0,22))e=c(t.split(",")[1]);else{if("Exif"!=t.slice(0,4))throw"'load' gots invalid file data.";e=t.slice(6)}var i={"0th":{},Exif:{},GPS:{},Interop:{},"1st":{},thumbnail:null},n=new h(e);if(null===n.tiftag)return i;"II"==n.tiftag.slice(0,2)?n.endian_mark="<":n.endian_mark=">";var a=u(n.endian_mark+"L",n.tiftag.slice(4,8))[0];i["0th"]=n.get_ifd(a,"0th");var r=i["0th"].first_ifd_pointer;if(delete i["0th"].first_ifd_pointer,34665 in i["0th"]&&(a=i["0th"][34665],i.Exif=n.get_ifd(a,"Exif")),34853 in i["0th"]&&(a=i["0th"][34853],i.GPS=n.get_ifd(a,"GPS")),40965 in i.Exif&&(a=i.Exif[40965],i.Interop=n.get_ifd(a,"Interop")),"\0\0\0\0"!=r&&(a=u(n.endian_mark+"L",r)[0],i["1st"]=n.get_ifd(a,"1st"),513 in i["1st"]&&514 in i["1st"])){var o=i["1st"][513]+i["1st"][514],s=n.tiftag.slice(i["1st"][513],o);i.thumbnail=s}return i},i.dump=function(t){var e,n,a,r,o,h,l=(e=t,JSON.parse(JSON.stringify(e))),c=!1,u=!1,f=!1,v=!1;n="0th"in l?l["0th"]:{},"Exif"in l&&Object.keys(l.Exif).length||"Interop"in l&&Object.keys(l.Interop).length?(n[34665]=1,c=!0,a=l.Exif,"Interop"in l&&Object.keys(l.Interop).length?(a[40965]=1,f=!0,r=l.Interop):Object.keys(a).indexOf(i.ExifIFD.InteroperabilityTag.toString())>-1&&delete a[40965]):Object.keys(n).indexOf(i.ImageIFD.ExifTag.toString())>-1&&delete n[34665],"GPS"in l&&Object.keys(l.GPS).length?(n[i.ImageIFD.GPSTag]=1,u=!0,o=l.GPS):Object.keys(n).indexOf(i.ImageIFD.GPSTag.toString())>-1&&delete n[i.ImageIFD.GPSTag],"1st"in l&&"thumbnail"in l&&null!=l.thumbnail&&(v=!0,l["1st"][513]=1,l["1st"][514]=1,h=l["1st"]);var m,y,S,C=s(n,"0th",0),_=C[0].length+12*c+12*u+4+C[1].length,b="",w=0,x="",P=0,k="",L=0,A="";if(c&&(w=(m=s(a,"Exif",_))[0].length+12*f+m[1].length),u&&(P=(x=s(o,"GPS",_+w).join("")).length),f&&(L=(k=s(r,"Interop",_+w+P).join("")).length),v&&(y=s(h,"1st",_+w+P+L),(S=function(t){for(var e=g(l.thumbnail);"ÿà"<=e[1].slice(0,2)&&e[1].slice(0,2)<="ÿï";)e=[e[0]].concat(e.slice(2));return e.join("")}()).length>64e3))throw"Given thumbnail is too large. max 64kB";var K="",D="",R="",G="\0\0\0\0";if(c){var F=d(">L",[T=8+_]);K=d(">H",[34665])+d(">H",[p.Long])+d(">L",[1])+F}if(u&&(F=d(">L",[T=8+_+w]),D=d(">H",[34853])+d(">H",[p.Long])+d(">L",[1])+F),f&&(F=d(">L",[T=8+_+w+P]),R=d(">H",[40965])+d(">H",[p.Long])+d(">L",[1])+F),v){var T;G=d(">L",[T=8+_+w+P+L]);var I="\0\0\0\0"+d(">L",[T+y[0].length+24+4+y[1].length]),O="\0\0\0\0"+d(">L",[S.length]);A=y[0]+I+O+"\0\0\0\0"+y[1]+S}var M=C[0]+K+D+G+C[1];return c&&(b=m[0]+R+m[1]),"Exif\0\0MM\0*\0\0\0\b"+M+b+x+k+A},h.prototype={get_ifd:function(t,e){var i,n={},a=u(this.endian_mark+"H",this.tiftag.slice(t,t+2))[0],r=t+2;i=["0th","1st"].indexOf(e)>-1?"Image":e;for(var o=0;o<a;o++){t=r+12*o;var s=u(this.endian_mark+"H",this.tiftag.slice(t,t+2))[0],h=[u(this.endian_mark+"H",this.tiftag.slice(t+2,t+4))[0],u(this.endian_mark+"L",this.tiftag.slice(t+4,t+8))[0],this.tiftag.slice(t+8,t+12)];s in v[i]&&(n[s]=this.convert_value(h))}return"0th"==e&&(t=r+12*a,n.first_ifd_pointer=this.tiftag.slice(t,t+4)),n},convert_value:function(t){var e,i=null,n=t[0],a=t[1],r=t[2];if(1==n)a>4?(e=u(this.endian_mark+"L",r)[0],i=u(this.endian_mark+f("B",a),this.tiftag.slice(e,e+a))):i=u(this.endian_mark+f("B",a),r.slice(0,a));else if(2==n)a>4?(e=u(this.endian_mark+"L",r)[0],i=this.tiftag.slice(e,e+a-1)):i=r.slice(0,a-1);else if(3==n)a>2?(e=u(this.endian_mark+"L",r)[0],i=u(this.endian_mark+f("H",a),this.tiftag.slice(e,e+2*a))):i=u(this.endian_mark+f("H",a),r.slice(0,2*a));else if(4==n)a>1?(e=u(this.endian_mark+"L",r)[0],i=u(this.endian_mark+f("L",a),this.tiftag.slice(e,e+4*a))):i=u(this.endian_mark+f("L",a),r);else if(5==n)if(e=u(this.endian_mark+"L",r)[0],a>1){i=[];for(var o=0;o<a;o++)i.push([u(this.endian_mark+"L",this.tiftag.slice(e+8*o,e+4+8*o))[0],u(this.endian_mark+"L",this.tiftag.slice(e+4+8*o,e+8+8*o))[0]])}else i=[u(this.endian_mark+"L",this.tiftag.slice(e,e+4))[0],u(this.endian_mark+"L",this.tiftag.slice(e+4,e+8))[0]];else if(7==n)a>4?(e=u(this.endian_mark+"L",r)[0],i=this.tiftag.slice(e,e+a)):i=r.slice(0,a);else{if(10!=n)throw"Exif might be wrong. Got incorrect value type to decode. type:"+n;if(e=u(this.endian_mark+"L",r)[0],a>1)for(i=[],o=0;o<a;o++)i.push([u(this.endian_mark+"l",this.tiftag.slice(e+8*o,e+4+8*o))[0],u(this.endian_mark+"l",this.tiftag.slice(e+4+8*o,e+8+8*o))[0]]);else i=[u(this.endian_mark+"l",this.tiftag.slice(e,e+4))[0],u(this.endian_mark+"l",this.tiftag.slice(e+4,e+8))[0]]}return i instanceof Array&&1==i.length?i[0]:i}},"undefined"!=typeof window&&"function"==typeof window.btoa)var l=window.btoa;if(void 0===l&&(l=function(t){for(var e,i,n,a,r,o,s,h="",l=0,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";l<t.length;)a=(e=t.charCodeAt(l++))>>2,r=(3&e)<<4|(i=t.charCodeAt(l++))>>4,o=(15&i)<<2|(n=t.charCodeAt(l++))>>6,s=63&n,isNaN(i)?o=s=64:isNaN(n)&&(s=64),h=h+c.charAt(a)+c.charAt(r)+c.charAt(o)+c.charAt(s);return h}),"undefined"!=typeof window&&"function"==typeof window.atob)var c=window.atob;function d(t,e){if(!(e instanceof Array))throw"'pack' error. Got invalid type argument.";if(t.length-1!=e.length)throw"'pack' error. "+(t.length-1)+" marks, "+e.length+" elements.";var i;if("<"==t[0])i=!0;else{if(">"!=t[0])throw"";i=!1}for(var n="",a=1,r=null,o=null,s=null;o=t[a];){if("b"==o.toLowerCase()){if(r=e[a-1],"b"==o&&r<0&&(r+=256),r>255||r<0)throw"'pack' error.";s=String.fromCharCode(r)}else if("H"==o){if((r=e[a-1])>65535||r<0)throw"'pack' error.";s=String.fromCharCode(Math.floor(r%65536/256))+String.fromCharCode(r%256),i&&(s=s.split("").reverse().join(""))}else{if("l"!=o.toLowerCase())throw"'pack' error.";if(r=e[a-1],"l"==o&&r<0&&(r+=4294967296),r>4294967295||r<0)throw"'pack' error.";s=String.fromCharCode(Math.floor(r/16777216))+String.fromCharCode(Math.floor(r%16777216/65536))+String.fromCharCode(Math.floor(r%65536/256))+String.fromCharCode(r%256),i&&(s=s.split("").reverse().join(""))}n+=s,a+=1}return n}function u(t,e){if("string"!=typeof e)throw"'unpack' error. Got invalid type argument.";for(var i,n=0,a=1;a<t.length;a++)if("b"==t[a].toLowerCase())n+=1;else if("h"==t[a].toLowerCase())n+=2;else{if("l"!=t[a].toLowerCase())throw"'unpack' error. Got invalid mark.";n+=4}if(n!=e.length)throw"'unpack' error. Mismatch between symbol and string length. "+n+":"+e.length;if("<"==t[0])i=!0;else{if(">"!=t[0])throw"'unpack' error.";i=!1}for(var r=[],o=0,s=1,h=null,l=null,c=null,d="";l=t[s];){if("b"==l.toLowerCase())c=1,h=(d=e.slice(o,o+c)).charCodeAt(0),"b"==l&&h>=128&&(h-=256);else if("H"==l)c=2,d=e.slice(o,o+c),i&&(d=d.split("").reverse().join("")),h=256*d.charCodeAt(0)+d.charCodeAt(1);else{if("l"!=l.toLowerCase())throw"'unpack' error. "+l;c=4,d=e.slice(o,o+c),i&&(d=d.split("").reverse().join("")),h=16777216*d.charCodeAt(0)+65536*d.charCodeAt(1)+256*d.charCodeAt(2)+d.charCodeAt(3),"l"==l&&h>=2147483648&&(h-=4294967296)}r.push(h),o+=c,s+=1}return r}function f(t,e){for(var i="",n=0;n<e;n++)i+=t;return i}function g(t){if("ÿØ"!=t.slice(0,2))throw"Given data isn't JPEG.";for(var e=2,i=["ÿØ"];;){if("ÿÚ"==t.slice(e,e+2)){i.push(t.slice(e));break}var n=e+u(">H",t.slice(e+2,e+4))[0]+2;if(i.push(t.slice(e,n)),(e=n)>=t.length)throw"Wrong JPEG data."}return i}void 0===c&&(c=function(t){var e,i,n,a,r,o,s="",h=0,l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";for(t=t.replace(/[^A-Za-z0-9\+\/\=]/g,"");h<t.length;)e=l.indexOf(t.charAt(h++))<<2|(a=l.indexOf(t.charAt(h++)))>>4,i=(15&a)<<4|(r=l.indexOf(t.charAt(h++)))>>2,n=(3&r)<<6|(o=l.indexOf(t.charAt(h++))),s+=String.fromCharCode(e),64!=r&&(s+=String.fromCharCode(i)),64!=o&&(s+=String.fromCharCode(n));return s});var p={Byte:1,Ascii:2,Short:3,Long:4,Rational:5,Undefined:7,SLong:9,SRational:10},v={Image:{11:{name:"ProcessingSoftware",type:"Ascii"},254:{name:"NewSubfileType",type:"Long"},255:{name:"SubfileType",type:"Short"},256:{name:"ImageWidth",type:"Long"},257:{name:"ImageLength",type:"Long"},258:{name:"BitsPerSample",type:"Short"},259:{name:"Compression",type:"Short"},262:{name:"PhotometricInterpretation",type:"Short"},263:{name:"Threshholding",type:"Short"},264:{name:"CellWidth",type:"Short"},265:{name:"CellLength",type:"Short"},266:{name:"FillOrder",type:"Short"},269:{name:"DocumentName",type:"Ascii"},270:{name:"ImageDescription",type:"Ascii"},271:{name:"Make",type:"Ascii"},272:{name:"Model",type:"Ascii"},273:{name:"StripOffsets",type:"Long"},274:{name:"Orientation",type:"Short"},277:{name:"SamplesPerPixel",type:"Short"},278:{name:"RowsPerStrip",type:"Long"},279:{name:"StripByteCounts",type:"Long"},282:{name:"XResolution",type:"Rational"},283:{name:"YResolution",type:"Rational"},284:{name:"PlanarConfiguration",type:"Short"},290:{name:"GrayResponseUnit",type:"Short"},291:{name:"GrayResponseCurve",type:"Short"},292:{name:"T4Options",type:"Long"},293:{name:"T6Options",type:"Long"},296:{name:"ResolutionUnit",type:"Short"},301:{name:"TransferFunction",type:"Short"},305:{name:"Software",type:"Ascii"},306:{name:"DateTime",type:"Ascii"},315:{name:"Artist",type:"Ascii"},316:{name:"HostComputer",type:"Ascii"},317:{name:"Predictor",type:"Short"},318:{name:"WhitePoint",type:"Rational"},319:{name:"PrimaryChromaticities",type:"Rational"},320:{name:"ColorMap",type:"Short"},321:{name:"HalftoneHints",type:"Short"},322:{name:"TileWidth",type:"Short"},323:{name:"TileLength",type:"Short"},324:{name:"TileOffsets",type:"Short"},325:{name:"TileByteCounts",type:"Short"},330:{name:"SubIFDs",type:"Long"},332:{name:"InkSet",type:"Short"},333:{name:"InkNames",type:"Ascii"},334:{name:"NumberOfInks",type:"Short"},336:{name:"DotRange",type:"Byte"},337:{name:"TargetPrinter",type:"Ascii"},338:{name:"ExtraSamples",type:"Short"},339:{name:"SampleFormat",type:"Short"},340:{name:"SMinSampleValue",type:"Short"},341:{name:"SMaxSampleValue",type:"Short"},342:{name:"TransferRange",type:"Short"},343:{name:"ClipPath",type:"Byte"},344:{name:"XClipPathUnits",type:"Long"},345:{name:"YClipPathUnits",type:"Long"},346:{name:"Indexed",type:"Short"},347:{name:"JPEGTables",type:"Undefined"},351:{name:"OPIProxy",type:"Short"},512:{name:"JPEGProc",type:"Long"},513:{name:"JPEGInterchangeFormat",type:"Long"},514:{name:"JPEGInterchangeFormatLength",type:"Long"},515:{name:"JPEGRestartInterval",type:"Short"},517:{name:"JPEGLosslessPredictors",type:"Short"},518:{name:"JPEGPointTransforms",type:"Short"},519:{name:"JPEGQTables",type:"Long"},520:{name:"JPEGDCTables",type:"Long"},521:{name:"JPEGACTables",type:"Long"},529:{name:"YCbCrCoefficients",type:"Rational"},530:{name:"YCbCrSubSampling",type:"Short"},531:{name:"YCbCrPositioning",type:"Short"},532:{name:"ReferenceBlackWhite",type:"Rational"},700:{name:"XMLPacket",type:"Byte"},18246:{name:"Rating",type:"Short"},18249:{name:"RatingPercent",type:"Short"},32781:{name:"ImageID",type:"Ascii"},33421:{name:"CFARepeatPatternDim",type:"Short"},33422:{name:"CFAPattern",type:"Byte"},33423:{name:"BatteryLevel",type:"Rational"},33432:{name:"Copyright",type:"Ascii"},33434:{name:"ExposureTime",type:"Rational"},34377:{name:"ImageResources",type:"Byte"},34665:{name:"ExifTag",type:"Long"},34675:{name:"InterColorProfile",type:"Undefined"},34853:{name:"GPSTag",type:"Long"},34857:{name:"Interlace",type:"Short"},34858:{name:"TimeZoneOffset",type:"Long"},34859:{name:"SelfTimerMode",type:"Short"},37387:{name:"FlashEnergy",type:"Rational"},37388:{name:"SpatialFrequencyResponse",type:"Undefined"},37389:{name:"Noise",type:"Undefined"},37390:{name:"FocalPlaneXResolution",type:"Rational"},37391:{name:"FocalPlaneYResolution",type:"Rational"},37392:{name:"FocalPlaneResolutionUnit",type:"Short"},37393:{name:"ImageNumber",type:"Long"},37394:{name:"SecurityClassification",type:"Ascii"},37395:{name:"ImageHistory",type:"Ascii"},37397:{name:"ExposureIndex",type:"Rational"},37398:{name:"TIFFEPStandardID",type:"Byte"},37399:{name:"SensingMethod",type:"Short"},40091:{name:"XPTitle",type:"Byte"},40092:{name:"XPComment",type:"Byte"},40093:{name:"XPAuthor",type:"Byte"},40094:{name:"XPKeywords",type:"Byte"},40095:{name:"XPSubject",type:"Byte"},50341:{name:"PrintImageMatching",type:"Undefined"},50706:{name:"DNGVersion",type:"Byte"},50707:{name:"DNGBackwardVersion",type:"Byte"},50708:{name:"UniqueCameraModel",type:"Ascii"},50709:{name:"LocalizedCameraModel",type:"Byte"},50710:{name:"CFAPlaneColor",type:"Byte"},50711:{name:"CFALayout",type:"Short"},50712:{name:"LinearizationTable",type:"Short"},50713:{name:"BlackLevelRepeatDim",type:"Short"},50714:{name:"BlackLevel",type:"Rational"},50715:{name:"BlackLevelDeltaH",type:"SRational"},50716:{name:"BlackLevelDeltaV",type:"SRational"},50717:{name:"WhiteLevel",type:"Short"},50718:{name:"DefaultScale",type:"Rational"},50719:{name:"DefaultCropOrigin",type:"Short"},50720:{name:"DefaultCropSize",type:"Short"},50721:{name:"ColorMatrix1",type:"SRational"},50722:{name:"ColorMatrix2",type:"SRational"},50723:{name:"CameraCalibration1",type:"SRational"},50724:{name:"CameraCalibration2",type:"SRational"},50725:{name:"ReductionMatrix1",type:"SRational"},50726:{name:"ReductionMatrix2",type:"SRational"},50727:{name:"AnalogBalance",type:"Rational"},50728:{name:"AsShotNeutral",type:"Short"},50729:{name:"AsShotWhiteXY",type:"Rational"},50730:{name:"BaselineExposure",type:"SRational"},50731:{name:"BaselineNoise",type:"Rational"},50732:{name:"BaselineSharpness",type:"Rational"},50733:{name:"BayerGreenSplit",type:"Long"},50734:{name:"LinearResponseLimit",type:"Rational"},50735:{name:"CameraSerialNumber",type:"Ascii"},50736:{name:"LensInfo",type:"Rational"},50737:{name:"ChromaBlurRadius",type:"Rational"},50738:{name:"AntiAliasStrength",type:"Rational"},50739:{name:"ShadowScale",type:"SRational"},50740:{name:"DNGPrivateData",type:"Byte"},50741:{name:"MakerNoteSafety",type:"Short"},50778:{name:"CalibrationIlluminant1",type:"Short"},50779:{name:"CalibrationIlluminant2",type:"Short"},50780:{name:"BestQualityScale",type:"Rational"},50781:{name:"RawDataUniqueID",type:"Byte"},50827:{name:"OriginalRawFileName",type:"Byte"},50828:{name:"OriginalRawFileData",type:"Undefined"},50829:{name:"ActiveArea",type:"Short"},50830:{name:"MaskedAreas",type:"Short"},50831:{name:"AsShotICCProfile",type:"Undefined"},50832:{name:"AsShotPreProfileMatrix",type:"SRational"},50833:{name:"CurrentICCProfile",type:"Undefined"},50834:{name:"CurrentPreProfileMatrix",type:"SRational"},50879:{name:"ColorimetricReference",type:"Short"},50931:{name:"CameraCalibrationSignature",type:"Byte"},50932:{name:"ProfileCalibrationSignature",type:"Byte"},50934:{name:"AsShotProfileName",type:"Byte"},50935:{name:"NoiseReductionApplied",type:"Rational"},50936:{name:"ProfileName",type:"Byte"},50937:{name:"ProfileHueSatMapDims",type:"Long"},50938:{name:"ProfileHueSatMapData1",type:"Float"},50939:{name:"ProfileHueSatMapData2",type:"Float"},50940:{name:"ProfileToneCurve",type:"Float"},50941:{name:"ProfileEmbedPolicy",type:"Long"},50942:{name:"ProfileCopyright",type:"Byte"},50964:{name:"ForwardMatrix1",type:"SRational"},50965:{name:"ForwardMatrix2",type:"SRational"},50966:{name:"PreviewApplicationName",type:"Byte"},50967:{name:"PreviewApplicationVersion",type:"Byte"},50968:{name:"PreviewSettingsName",type:"Byte"},50969:{name:"PreviewSettingsDigest",type:"Byte"},50970:{name:"PreviewColorSpace",type:"Long"},50971:{name:"PreviewDateTime",type:"Ascii"},50972:{name:"RawImageDigest",type:"Undefined"},50973:{name:"OriginalRawFileDigest",type:"Undefined"},50974:{name:"SubTileBlockSize",type:"Long"},50975:{name:"RowInterleaveFactor",type:"Long"},50981:{name:"ProfileLookTableDims",type:"Long"},50982:{name:"ProfileLookTableData",type:"Float"},51008:{name:"OpcodeList1",type:"Undefined"},51009:{name:"OpcodeList2",type:"Undefined"},51022:{name:"OpcodeList3",type:"Undefined"}},Exif:{33434:{name:"ExposureTime",type:"Rational"},33437:{name:"FNumber",type:"Rational"},34850:{name:"ExposureProgram",type:"Short"},34852:{name:"SpectralSensitivity",type:"Ascii"},34855:{name:"ISOSpeedRatings",type:"Short"},34856:{name:"OECF",type:"Undefined"},34864:{name:"SensitivityType",type:"Short"},34865:{name:"StandardOutputSensitivity",type:"Long"},34866:{name:"RecommendedExposureIndex",type:"Long"},34867:{name:"ISOSpeed",type:"Long"},34868:{name:"ISOSpeedLatitudeyyy",type:"Long"},34869:{name:"ISOSpeedLatitudezzz",type:"Long"},36864:{name:"ExifVersion",type:"Undefined"},36867:{name:"DateTimeOriginal",type:"Ascii"},36868:{name:"DateTimeDigitized",type:"Ascii"},37121:{name:"ComponentsConfiguration",type:"Undefined"},37122:{name:"CompressedBitsPerPixel",type:"Rational"},37377:{name:"ShutterSpeedValue",type:"SRational"},37378:{name:"ApertureValue",type:"Rational"},37379:{name:"BrightnessValue",type:"SRational"},37380:{name:"ExposureBiasValue",type:"SRational"},37381:{name:"MaxApertureValue",type:"Rational"},37382:{name:"SubjectDistance",type:"Rational"},37383:{name:"MeteringMode",type:"Short"},37384:{name:"LightSource",type:"Short"},37385:{name:"Flash",type:"Short"},37386:{name:"FocalLength",type:"Rational"},37396:{name:"SubjectArea",type:"Short"},37500:{name:"MakerNote",type:"Undefined"},37510:{name:"UserComment",type:"Ascii"},37520:{name:"SubSecTime",type:"Ascii"},37521:{name:"SubSecTimeOriginal",type:"Ascii"},37522:{name:"SubSecTimeDigitized",type:"Ascii"},40960:{name:"FlashpixVersion",type:"Undefined"},40961:{name:"ColorSpace",type:"Short"},40962:{name:"PixelXDimension",type:"Long"},40963:{name:"PixelYDimension",type:"Long"},40964:{name:"RelatedSoundFile",type:"Ascii"},40965:{name:"InteroperabilityTag",type:"Long"},41483:{name:"FlashEnergy",type:"Rational"},41484:{name:"SpatialFrequencyResponse",type:"Undefined"},41486:{name:"FocalPlaneXResolution",type:"Rational"},41487:{name:"FocalPlaneYResolution",type:"Rational"},41488:{name:"FocalPlaneResolutionUnit",type:"Short"},41492:{name:"SubjectLocation",type:"Short"},41493:{name:"ExposureIndex",type:"Rational"},41495:{name:"SensingMethod",type:"Short"},41728:{name:"FileSource",type:"Undefined"},41729:{name:"SceneType",type:"Undefined"},41730:{name:"CFAPattern",type:"Undefined"},41985:{name:"CustomRendered",type:"Short"},41986:{name:"ExposureMode",type:"Short"},41987:{name:"WhiteBalance",type:"Short"},41988:{name:"DigitalZoomRatio",type:"Rational"},41989:{name:"FocalLengthIn35mmFilm",type:"Short"},41990:{name:"SceneCaptureType",type:"Short"},41991:{name:"GainControl",type:"Short"},41992:{name:"Contrast",type:"Short"},41993:{name:"Saturation",type:"Short"},41994:{name:"Sharpness",type:"Short"},41995:{name:"DeviceSettingDescription",type:"Undefined"},41996:{name:"SubjectDistanceRange",type:"Short"},42016:{name:"ImageUniqueID",type:"Ascii"},42032:{name:"CameraOwnerName",type:"Ascii"},42033:{name:"BodySerialNumber",type:"Ascii"},42034:{name:"LensSpecification",type:"Rational"},42035:{name:"LensMake",type:"Ascii"},42036:{name:"LensModel",type:"Ascii"},42037:{name:"LensSerialNumber",type:"Ascii"},42240:{name:"Gamma",type:"Rational"}},GPS:{0:{name:"GPSVersionID",type:"Byte"},1:{name:"GPSLatitudeRef",type:"Ascii"},2:{name:"GPSLatitude",type:"Rational"},3:{name:"GPSLongitudeRef",type:"Ascii"},4:{name:"GPSLongitude",type:"Rational"},5:{name:"GPSAltitudeRef",type:"Byte"},6:{name:"GPSAltitude",type:"Rational"},7:{name:"GPSTimeStamp",type:"Rational"},8:{name:"GPSSatellites",type:"Ascii"},9:{name:"GPSStatus",type:"Ascii"},10:{name:"GPSMeasureMode",type:"Ascii"},11:{name:"GPSDOP",type:"Rational"},12:{name:"GPSSpeedRef",type:"Ascii"},13:{name:"GPSSpeed",type:"Rational"},14:{name:"GPSTrackRef",type:"Ascii"},15:{name:"GPSTrack",type:"Rational"},16:{name:"GPSImgDirectionRef",type:"Ascii"},17:{name:"GPSImgDirection",type:"Rational"},18:{name:"GPSMapDatum",type:"Ascii"},19:{name:"GPSDestLatitudeRef",type:"Ascii"},20:{name:"GPSDestLatitude",type:"Rational"},21:{name:"GPSDestLongitudeRef",type:"Ascii"},22:{name:"GPSDestLongitude",type:"Rational"},23:{name:"GPSDestBearingRef",type:"Ascii"},24:{name:"GPSDestBearing",type:"Rational"},25:{name:"GPSDestDistanceRef",type:"Ascii"},26:{name:"GPSDestDistance",type:"Rational"},27:{name:"GPSProcessingMethod",type:"Undefined"},28:{name:"GPSAreaInformation",type:"Undefined"},29:{name:"GPSDateStamp",type:"Ascii"},30:{name:"GPSDifferential",type:"Short"},31:{name:"GPSHPositioningError",type:"Rational"}},Interop:{1:{name:"InteroperabilityIndex",type:"Ascii"}}};v["0th"]=v.Image,v["1st"]=v.Image,i.TAGS=v,i.ImageIFD={ProcessingSoftware:11,NewSubfileType:254,SubfileType:255,ImageWidth:256,ImageLength:257,BitsPerSample:258,Compression:259,PhotometricInterpretation:262,Threshholding:263,CellWidth:264,CellLength:265,FillOrder:266,DocumentName:269,ImageDescription:270,Make:271,Model:272,StripOffsets:273,Orientation:274,SamplesPerPixel:277,RowsPerStrip:278,StripByteCounts:279,XResolution:282,YResolution:283,PlanarConfiguration:284,GrayResponseUnit:290,GrayResponseCurve:291,T4Options:292,T6Options:293,ResolutionUnit:296,TransferFunction:301,Software:305,DateTime:306,Artist:315,HostComputer:316,Predictor:317,WhitePoint:318,PrimaryChromaticities:319,ColorMap:320,HalftoneHints:321,TileWidth:322,TileLength:323,TileOffsets:324,TileByteCounts:325,SubIFDs:330,InkSet:332,InkNames:333,NumberOfInks:334,DotRange:336,TargetPrinter:337,ExtraSamples:338,SampleFormat:339,SMinSampleValue:340,SMaxSampleValue:341,TransferRange:342,ClipPath:343,XClipPathUnits:344,YClipPathUnits:345,Indexed:346,JPEGTables:347,OPIProxy:351,JPEGProc:512,JPEGInterchangeFormat:513,JPEGInterchangeFormatLength:514,JPEGRestartInterval:515,JPEGLosslessPredictors:517,JPEGPointTransforms:518,JPEGQTables:519,JPEGDCTables:520,JPEGACTables:521,YCbCrCoefficients:529,YCbCrSubSampling:530,YCbCrPositioning:531,ReferenceBlackWhite:532,XMLPacket:700,Rating:18246,RatingPercent:18249,ImageID:32781,CFARepeatPatternDim:33421,CFAPattern:33422,BatteryLevel:33423,Copyright:33432,ExposureTime:33434,ImageResources:34377,ExifTag:34665,InterColorProfile:34675,GPSTag:34853,Interlace:34857,TimeZoneOffset:34858,SelfTimerMode:34859,FlashEnergy:37387,SpatialFrequencyResponse:37388,Noise:37389,FocalPlaneXResolution:37390,FocalPlaneYResolution:37391,FocalPlaneResolutionUnit:37392,ImageNumber:37393,SecurityClassification:37394,ImageHistory:37395,ExposureIndex:37397,TIFFEPStandardID:37398,SensingMethod:37399,XPTitle:40091,XPComment:40092,XPAuthor:40093,XPKeywords:40094,XPSubject:40095,PrintImageMatching:50341,DNGVersion:50706,DNGBackwardVersion:50707,UniqueCameraModel:50708,LocalizedCameraModel:50709,CFAPlaneColor:50710,CFALayout:50711,LinearizationTable:50712,BlackLevelRepeatDim:50713,BlackLevel:50714,BlackLevelDeltaH:50715,BlackLevelDeltaV:50716,WhiteLevel:50717,DefaultScale:50718,DefaultCropOrigin:50719,DefaultCropSize:50720,ColorMatrix1:50721,ColorMatrix2:50722,CameraCalibration1:50723,CameraCalibration2:50724,ReductionMatrix1:50725,ReductionMatrix2:50726,AnalogBalance:50727,AsShotNeutral:50728,AsShotWhiteXY:50729,BaselineExposure:50730,BaselineNoise:50731,BaselineSharpness:50732,BayerGreenSplit:50733,LinearResponseLimit:50734,CameraSerialNumber:50735,LensInfo:50736,ChromaBlurRadius:50737,AntiAliasStrength:50738,ShadowScale:50739,DNGPrivateData:50740,MakerNoteSafety:50741,CalibrationIlluminant1:50778,CalibrationIlluminant2:50779,BestQualityScale:50780,RawDataUniqueID:50781,OriginalRawFileName:50827,OriginalRawFileData:50828,ActiveArea:50829,MaskedAreas:50830,AsShotICCProfile:50831,AsShotPreProfileMatrix:50832,CurrentICCProfile:50833,CurrentPreProfileMatrix:50834,ColorimetricReference:50879,CameraCalibrationSignature:50931,ProfileCalibrationSignature:50932,AsShotProfileName:50934,NoiseReductionApplied:50935,ProfileName:50936,ProfileHueSatMapDims:50937,ProfileHueSatMapData1:50938,ProfileHueSatMapData2:50939,ProfileToneCurve:50940,ProfileEmbedPolicy:50941,ProfileCopyright:50942,ForwardMatrix1:50964,ForwardMatrix2:50965,PreviewApplicationName:50966,PreviewApplicationVersion:50967,PreviewSettingsName:50968,PreviewSettingsDigest:50969,PreviewColorSpace:50970,PreviewDateTime:50971,RawImageDigest:50972,OriginalRawFileDigest:50973,SubTileBlockSize:50974,RowInterleaveFactor:50975,ProfileLookTableDims:50981,ProfileLookTableData:50982,OpcodeList1:51008,OpcodeList2:51009,OpcodeList3:51022,NoiseProfile:51041},i.ExifIFD={ExposureTime:33434,FNumber:33437,ExposureProgram:34850,SpectralSensitivity:34852,ISOSpeedRatings:34855,OECF:34856,SensitivityType:34864,StandardOutputSensitivity:34865,RecommendedExposureIndex:34866,ISOSpeed:34867,ISOSpeedLatitudeyyy:34868,ISOSpeedLatitudezzz:34869,ExifVersion:36864,DateTimeOriginal:36867,DateTimeDigitized:36868,ComponentsConfiguration:37121,CompressedBitsPerPixel:37122,ShutterSpeedValue:37377,ApertureValue:37378,BrightnessValue:37379,ExposureBiasValue:37380,MaxApertureValue:37381,SubjectDistance:37382,MeteringMode:37383,LightSource:37384,Flash:37385,FocalLength:37386,SubjectArea:37396,MakerNote:37500,UserComment:37510,SubSecTime:37520,SubSecTimeOriginal:37521,SubSecTimeDigitized:37522,FlashpixVersion:40960,ColorSpace:40961,PixelXDimension:40962,PixelYDimension:40963,RelatedSoundFile:40964,InteroperabilityTag:40965,FlashEnergy:41483,SpatialFrequencyResponse:41484,FocalPlaneXResolution:41486,FocalPlaneYResolution:41487,FocalPlaneResolutionUnit:41488,SubjectLocation:41492,ExposureIndex:41493,SensingMethod:41495,FileSource:41728,SceneType:41729,CFAPattern:41730,CustomRendered:41985,ExposureMode:41986,WhiteBalance:41987,DigitalZoomRatio:41988,FocalLengthIn35mmFilm:41989,SceneCaptureType:41990,GainControl:41991,Contrast:41992,Saturation:41993,Sharpness:41994,DeviceSettingDescription:41995,SubjectDistanceRange:41996,ImageUniqueID:42016,CameraOwnerName:42032,BodySerialNumber:42033,LensSpecification:42034,LensMake:42035,LensModel:42036,LensSerialNumber:42037,Gamma:42240},i.GPSIFD={GPSVersionID:0,GPSLatitudeRef:1,GPSLatitude:2,GPSLongitudeRef:3,GPSLongitude:4,GPSAltitudeRef:5,GPSAltitude:6,GPSTimeStamp:7,GPSSatellites:8,GPSStatus:9,GPSMeasureMode:10,GPSDOP:11,GPSSpeedRef:12,GPSSpeed:13,GPSTrackRef:14,GPSTrack:15,GPSImgDirectionRef:16,GPSImgDirection:17,GPSMapDatum:18,GPSDestLatitudeRef:19,GPSDestLatitude:20,GPSDestLongitudeRef:21,GPSDestLongitude:22,GPSDestBearingRef:23,GPSDestBearing:24,GPSDestDistanceRef:25,GPSDestDistance:26,GPSProcessingMethod:27,GPSAreaInformation:28,GPSDateStamp:29,GPSDifferential:30,GPSHPositioningError:31},i.InteropIFD={InteroperabilityIndex:1},i.GPSHelper={degToDmsRational:function(t){var e=t%1*60,i=e%1*60;return[[Math.floor(t),1],[Math.floor(e),1],[Math.round(100*i),100]]},dmsRationalToDeg:function(t,e){return("S"===e||"W"===e?-1:1)*t[0][0]/t[0][1]+t[1][0]/t[1][1]/60+t[2][0]/t[2][1]/3600}},void 0!==t&&t.exports&&(e=t.exports=i),e.piexif=i}()},function(t,e){!function(){"use strict";Konva.DD={anim:new Konva.Animation(function(){var t=this.dirty;return this.dirty=!1,t}),isDragging:!1,justDragged:!1,offset:{x:0,y:0},node:null,_drag:function(t){var e=Konva.DD,i=e.node;if(i){if(!e.isDragging){var n=i.getStage().getPointerPosition();n||(i.getStage()._setPointerPosition(t),n=i.getStage().getPointerPosition());var a=i.dragDistance();if(Math.max(Math.abs(n.x-e.startPointerPos.x),Math.abs(n.y-e.startPointerPos.y))<a)return}if(i.getStage()._setPointerPosition(t),!e.isDragging&&(e.isDragging=!0,i.fire("dragstart",{type:"dragstart",target:i,evt:t},!0),!i.isDragging()))return;i._setDragPosition(t),i.fire("dragmove",{type:"dragmove",target:i,evt:t},!0)}},_endDragBefore:function(t){var e,i=Konva.DD,n=i.node;n&&(e=n.getLayer(),i.anim.stop(),i.isDragging&&(i.isDragging=!1,i.justDragged=!0,Konva.listenClickTap=!1,t&&(t.dragEndNode=n)),delete i.node,(n.getLayer()||e||n instanceof Konva.Stage)&&(e||n).draw())},_endDragAfter:function(t){var e=(t=t||{}).dragEndNode;t&&e&&e.fire("dragend",{type:"dragend",target:e,evt:t},!0)}},Konva.Node.prototype.startDrag=function(){var t=Konva.DD,e=this.getStage(),i=this.getLayer(),n=e.getPointerPosition(),a=this.getAbsolutePosition();n&&(t.node&&t.node.stopDrag(),t.node=this,t.startPointerPos=n,t.offset.x=n.x-a.x,t.offset.y=n.y-a.y,t.anim.setLayers(i||this.getLayers()),t.anim.start(),this._setDragPosition())},Konva.Node.prototype._setDragPosition=function(t){var e=Konva.DD,i=this.getStage().getPointerPosition(),n=this.getDragBoundFunc();if(i){var a={x:i.x-e.offset.x,y:i.y-e.offset.y};void 0!==n&&(a=n.call(this,a,t)),this.setAbsolutePosition(a),this._lastPos&&this._lastPos.x===a.x&&this._lastPos.y===a.y||(e.anim.dirty=!0),this._lastPos=a}},Konva.Node.prototype.stopDrag=function(){var t=Konva.DD,e={};t._endDragBefore(e),t._endDragAfter(e)},Konva.Node.prototype.setDraggable=function(t){this._setAttr("draggable",t),this._dragChange()};var t=Konva.Node.prototype.remove;Konva.Node.prototype.__originalRemove=t,Konva.Node.prototype.remove=function(){var e=Konva.DD;e.node&&e.node._id===this._id&&this.stopDrag(),t.call(this)},Konva.Node.prototype.isDragging=function(){var t=Konva.DD;return!(!t.node||t.node._id!==this._id||!t.isDragging)},Konva.Node.prototype._listenDrag=function(){var t=this;this._dragCleanup(),"Stage"===this.getClassName()?this.on("contentMousedown.konva contentTouchstart.konva",function(e){Konva.DD.node||t.startDrag(e)}):this.on("mousedown.konva touchstart.konva",function(e){1!==e.evt.button&&2!==e.evt.button&&(Konva.DD.node||t.startDrag(e))})},Konva.Node.prototype._dragChange=function(){if(this.attrs.draggable)this._listenDrag();else{this._dragCleanup();var t=this.getStage(),e=Konva.DD;t&&e.node&&e.node._id===this._id&&e.node.stopDrag()}},Konva.Node.prototype._dragCleanup=function(){"Stage"===this.getClassName()?(this.off("contentMousedown.konva"),this.off("contentTouchstart.konva")):(this.off("mousedown.konva"),this.off("touchstart.konva"))},Konva.Factory.addGetterSetter(Konva.Node,"dragBoundFunc"),Konva.Factory.addGetter(Konva.Node,"draggable",!1),Konva.Factory.addOverloadedGetterSetter(Konva.Node,"draggable"),Konva.isBrowser&&(window.addEventListener("mouseup",Konva.DD._endDragBefore,!0),window.addEventListener("touchend",Konva.DD._endDragBefore,!0),window.addEventListener("mousemove",Konva.DD._drag),window.addEventListener("touchmove",Konva.DD._drag),window.addEventListener("mouseup",Konva.DD._endDragAfter,!1),window.addEventListener("touchend",Konva.DD._endDragAfter,!1))}()},function(t,e){!function(t){"use strict";var e=t.global.performance&&t.global.performance.now?function(){return t.global.performance.now()}:function(){return(new Date).getTime()};var i=t.global.requestAnimationFrame||t.global.webkitRequestAnimationFrame||t.global.mozRequestAnimationFrame||t.global.oRequestAnimationFrame||t.global.msRequestAnimationFrame||function(t){setTimeout(t,1e3/60)};function n(){return i.apply(t.global,arguments)}t.Animation=function(i,n){var a=t.Animation;this.func=i,this.setLayers(n),this.id=a.animIdCounter++,this.frame={time:0,timeDiff:0,lastTime:e()}},t.Animation.prototype={setLayers:function(t){var e;return e=t?t.length>0?t:[t]:[],this.layers=e,this},getLayers:function(){return this.layers},addLayer:function(t){var e,i=this.layers,n=i.length;for(e=0;e<n;e++)if(i[e]._id===t._id)return!1;return this.layers.push(t),!0},isRunning:function(){var e,i=t.Animation.animations,n=i.length;for(e=0;e<n;e++)if(i[e].id===this.id)return!0;return!1},start:function(){var i=t.Animation;return this.stop(),this.frame.timeDiff=0,this.frame.lastTime=e(),i._addAnimation(this),this},stop:function(){return t.Animation._removeAnimation(this),this},_updateFrameObject:function(t){this.frame.timeDiff=t-this.frame.lastTime,this.frame.lastTime=t,this.frame.time+=this.frame.timeDiff,this.frame.frameRate=1e3/this.frame.timeDiff}},t.Animation.animations=[],t.Animation.animIdCounter=0,t.Animation.animRunning=!1,t.Animation._addAnimation=function(t){this.animations.push(t),this._handleAnimation()},t.Animation._removeAnimation=function(t){var e,i=t.id,n=this.animations,a=n.length;for(e=0;e<a;e++)if(n[e].id===i){this.animations.splice(e,1);break}},t.Animation._runFrames=function(){var t,i,n,a,r,o,s,h,l={},c=this.animations;for(a=0;a<c.length;a++)if(i=(t=c[a]).layers,n=t.func,t._updateFrameObject(e()),o=i.length,!n||!1!==n.call(t,t.frame))for(r=0;r<o;r++)void 0!==(s=i[r])._id&&(l[s._id]=s);for(h in l)l.hasOwnProperty(h)&&l[h].draw()},t.Animation._animationLoop=function(){var e=t.Animation;e.animations.length?(e._runFrames(),n(e._animationLoop)):e.animRunning=!1},t.Animation._handleAnimation=function(){this.animRunning||(this.animRunning=!0,n(this._animationLoop))},t.BaseLayer.prototype.batchDraw=function(){var e=this,i=t.Animation;return this.batchAnim||(this.batchAnim=new i(function(){e.batchAnim.stop()},this)),this.batchAnim.isRunning()||this.batchAnim.start(),this},t.Stage.prototype.batchDraw=function(){return this.getChildren().each(function(t){t.batchDraw()}),this}}(Konva)},function(t,e){!function(){"use strict";Konva.Path=function(t){this.___init(t)},Konva.Path.prototype={___init:function(t){this.dataArray=[];var e=this;Konva.Shape.call(this,t),this.className="Path",this.dataArray=Konva.Path.parsePathData(this.getData()),this.pathLength=0;for(var i=0;i<this.dataArray.length;++i)this.pathLength+=this.dataArray[i].pathLength;this.on("dataChange.konva",function(){e.dataArray=Konva.Path.parsePathData(this.getData()),this.pathLength=0;for(var t=0;t<this.dataArray.length;++t)this.pathLength+=this.dataArray[t].pathLength}),this.sceneFunc(this._sceneFunc)},_sceneFunc:function(t){var e=this.dataArray;t.beginPath();for(var i=0;i<e.length;i++){var n=e[i].command,a=e[i].points;switch(n){case"L":t.lineTo(a[0],a[1]);break;case"M":t.moveTo(a[0],a[1]);break;case"C":t.bezierCurveTo(a[0],a[1],a[2],a[3],a[4],a[5]);break;case"Q":t.quadraticCurveTo(a[0],a[1],a[2],a[3]);break;case"A":var r=a[0],o=a[1],s=a[2],h=a[3],l=a[4],c=a[5],d=a[6],u=a[7],f=s>h?s:h,g=s>h?1:s/h,p=s>h?h/s:1;t.translate(r,o),t.rotate(d),t.scale(g,p),t.arc(0,0,f,l,l+c,1-u),t.scale(1/g,1/p),t.rotate(-d),t.translate(-r,-o);break;case"z":t.closePath()}}t.fillStrokeShape(this)},getSelfRect:function(){var t=[];this.dataArray.forEach(function(e){t=t.concat(e.points)});for(var e,i,n=t[0],a=t[0],r=t[1],o=t[1],s=0;s<t.length/2;s++)e=t[2*s],i=t[2*s+1],isNaN(e)||(n=Math.min(n,e),a=Math.max(a,e)),isNaN(i)||(r=Math.min(r,i),o=Math.max(o,i));return{x:Math.round(n),y:Math.round(r),width:Math.round(a-n),height:Math.round(o-r)}},getLength:function(){return this.pathLength},getPointAtLength:function(t){var e,i=0,n=this.dataArray.length;if(!n)return null;for(;i<n&&t>this.dataArray[i].pathLength;)t-=this.dataArray[i].pathLength,++i;if(i===n)return{x:(e=this.dataArray[i-1].points.slice(-2))[0],y:e[1]};if(t<.01)return{x:(e=this.dataArray[i].points.slice(0,2))[0],y:e[1]};var a=this.dataArray[i],r=a.points;switch(a.command){case"L":return Konva.Path.getPointOnLine(t,a.start.x,a.start.y,r[0],r[1]);case"C":return Konva.Path.getPointOnCubicBezier(t/a.pathLength,a.start.x,a.start.y,r[0],r[1],r[2],r[3],r[4],r[5]);case"Q":return Konva.Path.getPointOnQuadraticBezier(t/a.pathLength,a.start.x,a.start.y,r[0],r[1],r[2],r[3]);case"A":var o=r[0],s=r[1],h=r[2],l=r[3],c=r[4],d=r[5],u=r[6];return c+=d*t/a.pathLength,Konva.Path.getPointOnEllipticalArc(o,s,h,l,c,u)}return null}},Konva.Util.extend(Konva.Path,Konva.Shape),Konva.Path.getLineLength=function(t,e,i,n){return Math.sqrt((i-t)*(i-t)+(n-e)*(n-e))},Konva.Path.getPointOnLine=function(t,e,i,n,a,r,o){void 0===r&&(r=e),void 0===o&&(o=i);var s=(a-i)/(n-e+1e-8),h=Math.sqrt(t*t/(1+s*s));n<e&&(h*=-1);var l,c=s*h;if(n===e)l={x:r,y:o+c};else if((o-i)/(r-e+1e-8)===s)l={x:r+h,y:o+c};else{var d,u,f=this.getLineLength(e,i,n,a);if(f<1e-8)return;var g=(r-e)*(n-e)+(o-i)*(a-i);d=e+(g/=f*f)*(n-e),u=i+g*(a-i);var p=this.getLineLength(r,o,d,u),v=Math.sqrt(t*t-p*p);h=Math.sqrt(v*v/(1+s*s)),n<e&&(h*=-1),l={x:d+h,y:u+(c=s*h)}}return l},Konva.Path.getPointOnCubicBezier=function(t,e,i,n,a,r,o,s,h){function l(t){return t*t*t}function c(t){return 3*t*t*(1-t)}function d(t){return 3*t*(1-t)*(1-t)}function u(t){return(1-t)*(1-t)*(1-t)}return{x:s*l(t)+r*c(t)+n*d(t)+e*u(t),y:h*l(t)+o*c(t)+a*d(t)+i*u(t)}},Konva.Path.getPointOnQuadraticBezier=function(t,e,i,n,a,r,o){function s(t){return t*t}function h(t){return 2*t*(1-t)}function l(t){return(1-t)*(1-t)}return{x:r*s(t)+n*h(t)+e*l(t),y:o*s(t)+a*h(t)+i*l(t)}},Konva.Path.getPointOnEllipticalArc=function(t,e,i,n,a,r){var o=Math.cos(r),s=Math.sin(r),h=i*Math.cos(a),l=n*Math.sin(a);return{x:t+(h*o-l*s),y:e+(h*s+l*o)}},Konva.Path.parsePathData=function(t){if(!t)return[];var e=t,i=["m","M","l","L","v","V","h","H","z","Z","c","C","q","Q","t","T","s","S","a","A"];e=e.replace(new RegExp(" ","g"),",");for(var n=0;n<i.length;n++)e=e.replace(new RegExp(i[n],"g"),"|"+i[n]);var a,r=e.split("|"),o=[],s=[],h=0,l=0,c=/([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;for(n=1;n<r.length;n++){var d=r[n],u=d.charAt(0);for(d=d.slice(1),s.length=0;a=c.exec(d);)s.push(a[0]);for(var f=[],g=0,p=s.length;g<p;g++){var v=parseFloat(s[g]);isNaN(v)?f.push(0):f.push(v)}for(;f.length>0&&!isNaN(f[0]);){var m,y,S,C,_,b,w,x,P,k,L=null,A=[],K=h,D=l;switch(u){case"l":h+=f.shift(),l+=f.shift(),L="L",A.push(h,l);break;case"L":h=f.shift(),l=f.shift(),A.push(h,l);break;case"m":var R=f.shift(),G=f.shift();if(h+=R,l+=G,L="M",o.length>2&&"z"===o[o.length-1].command)for(var F=o.length-2;F>=0;F--)if("M"===o[F].command){h=o[F].points[0]+R,l=o[F].points[1]+G;break}A.push(h,l),u="l";break;case"M":h=f.shift(),l=f.shift(),L="M",A.push(h,l),u="L";break;case"h":h+=f.shift(),L="L",A.push(h,l);break;case"H":h=f.shift(),L="L",A.push(h,l);break;case"v":l+=f.shift(),L="L",A.push(h,l);break;case"V":l=f.shift(),L="L",A.push(h,l);break;case"C":A.push(f.shift(),f.shift(),f.shift(),f.shift()),h=f.shift(),l=f.shift(),A.push(h,l);break;case"c":A.push(h+f.shift(),l+f.shift(),h+f.shift(),l+f.shift()),h+=f.shift(),l+=f.shift(),L="C",A.push(h,l);break;case"S":y=h,S=l,"C"===(m=o[o.length-1]).command&&(y=h+(h-m.points[2]),S=l+(l-m.points[3])),A.push(y,S,f.shift(),f.shift()),h=f.shift(),l=f.shift(),L="C",A.push(h,l);break;case"s":y=h,S=l,"C"===(m=o[o.length-1]).command&&(y=h+(h-m.points[2]),S=l+(l-m.points[3])),A.push(y,S,h+f.shift(),l+f.shift()),h+=f.shift(),l+=f.shift(),L="C",A.push(h,l);break;case"Q":A.push(f.shift(),f.shift()),h=f.shift(),l=f.shift(),A.push(h,l);break;case"q":A.push(h+f.shift(),l+f.shift()),h+=f.shift(),l+=f.shift(),L="Q",A.push(h,l);break;case"T":y=h,S=l,"Q"===(m=o[o.length-1]).command&&(y=h+(h-m.points[0]),S=l+(l-m.points[1])),h=f.shift(),l=f.shift(),L="Q",A.push(y,S,h,l);break;case"t":y=h,S=l,"Q"===(m=o[o.length-1]).command&&(y=h+(h-m.points[0]),S=l+(l-m.points[1])),h+=f.shift(),l+=f.shift(),L="Q",A.push(y,S,h,l);break;case"A":C=f.shift(),_=f.shift(),b=f.shift(),w=f.shift(),x=f.shift(),P=h,k=l,h=f.shift(),l=f.shift(),L="A",A=this.convertEndpointToCenterParameterization(P,k,h,l,w,x,C,_,b);break;case"a":C=f.shift(),_=f.shift(),b=f.shift(),w=f.shift(),x=f.shift(),P=h,k=l,h+=f.shift(),l+=f.shift(),L="A",A=this.convertEndpointToCenterParameterization(P,k,h,l,w,x,C,_,b)}o.push({command:L||u,points:A,start:{x:K,y:D},pathLength:this.calcLength(K,D,L||u,A)})}"z"!==u&&"Z"!==u||o.push({command:"z",points:[],start:void 0,pathLength:0})}return o},Konva.Path.calcLength=function(t,e,i,n){var a,r,o,s,h=Konva.Path;switch(i){case"L":return h.getLineLength(t,e,n[0],n[1]);case"C":for(a=0,r=h.getPointOnCubicBezier(0,t,e,n[0],n[1],n[2],n[3],n[4],n[5]),s=.01;s<=1;s+=.01)o=h.getPointOnCubicBezier(s,t,e,n[0],n[1],n[2],n[3],n[4],n[5]),a+=h.getLineLength(r.x,r.y,o.x,o.y),r=o;return a;case"Q":for(a=0,r=h.getPointOnQuadraticBezier(0,t,e,n[0],n[1],n[2],n[3]),s=.01;s<=1;s+=.01)o=h.getPointOnQuadraticBezier(s,t,e,n[0],n[1],n[2],n[3]),a+=h.getLineLength(r.x,r.y,o.x,o.y),r=o;return a;case"A":a=0;var l=n[4],c=n[5],d=n[4]+c,u=Math.PI/180;if(Math.abs(l-d)<u&&(u=Math.abs(l-d)),r=h.getPointOnEllipticalArc(n[0],n[1],n[2],n[3],l,0),c<0)for(s=l-u;s>d;s-=u)o=h.getPointOnEllipticalArc(n[0],n[1],n[2],n[3],s,0),a+=h.getLineLength(r.x,r.y,o.x,o.y),r=o;else for(s=l+u;s<d;s+=u)o=h.getPointOnEllipticalArc(n[0],n[1],n[2],n[3],s,0),a+=h.getLineLength(r.x,r.y,o.x,o.y),r=o;return o=h.getPointOnEllipticalArc(n[0],n[1],n[2],n[3],d,0),a+h.getLineLength(r.x,r.y,o.x,o.y)}return 0},Konva.Path.convertEndpointToCenterParameterization=function(t,e,i,n,a,r,o,s,h){var l=h*(Math.PI/180),c=Math.cos(l)*(t-i)/2+Math.sin(l)*(e-n)/2,d=-1*Math.sin(l)*(t-i)/2+Math.cos(l)*(e-n)/2,u=c*c/(o*o)+d*d/(s*s);u>1&&(o*=Math.sqrt(u),s*=Math.sqrt(u));var f=Math.sqrt((o*o*(s*s)-o*o*(d*d)-s*s*(c*c))/(o*o*(d*d)+s*s*(c*c)));a===r&&(f*=-1),isNaN(f)&&(f=0);var g=f*o*d/s,p=f*-s*c/o,v=(t+i)/2+Math.cos(l)*g-Math.sin(l)*p,m=(e+n)/2+Math.sin(l)*g+Math.cos(l)*p,y=function(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])},S=function(t,e){return(t[0]*e[0]+t[1]*e[1])/(y(t)*y(e))},C=function(t,e){return(t[0]*e[1]<t[1]*e[0]?-1:1)*Math.acos(S(t,e))},_=C([1,0],[(c-g)/o,(d-p)/s]),b=[(c-g)/o,(d-p)/s],w=[(-1*c-g)/o,(-1*d-p)/s],x=C(b,w);return S(b,w)<=-1&&(x=Math.PI),S(b,w)>=1&&(x=0),0===r&&x>0&&(x-=2*Math.PI),1===r&&x<0&&(x+=2*Math.PI),[v,m,o,s,_,x,l,r]},Konva.Factory.addGetterSetter(Konva.Path,"data"),Konva.Collection.mapMethods(Konva.Path)}()},function(t,e){!function(){"use strict";Konva.Rect=function(t){this.___init(t)},Konva.Rect.prototype={___init:function(t){Konva.Shape.call(this,t),this.className="Rect",this.sceneFunc(this._sceneFunc)},_sceneFunc:function(t){var e=this.getCornerRadius(),i=this.getWidth(),n=this.getHeight();t.beginPath(),e?(e=Math.min(e,i/2,n/2),t.moveTo(e,0),t.lineTo(i-e,0),t.arc(i-e,e,e,3*Math.PI/2,0,!1),t.lineTo(i,n-e),t.arc(i-e,n-e,e,0,Math.PI/2,!1),t.lineTo(e,n),t.arc(e,n-e,e,Math.PI/2,Math.PI,!1),t.lineTo(0,e),t.arc(e,e,e,Math.PI,3*Math.PI/2,!1)):t.rect(0,0,i,n),t.closePath(),t.fillStrokeShape(this)}},Konva.Util.extend(Konva.Rect,Konva.Shape),Konva.Factory.addGetterSetter(Konva.Rect,"cornerRadius",0,Konva.Validators.getNumberValidator()),Konva.Collection.mapMethods(Konva.Rect)}()},function(t,e){!function(t){"use strict";var e=2*Math.PI-1e-4;t.Circle=function(t){this.___init(t)},t.Circle.prototype={_centroid:!0,___init:function(e){t.Shape.call(this,e),this.className="Circle",this.sceneFunc(this._sceneFunc)},_sceneFunc:function(t){t.beginPath(),t.arc(0,0,this.getRadius(),0,e,!1),t.closePath(),t.fillStrokeShape(this)},getWidth:function(){return 2*this.getRadius()},getHeight:function(){return 2*this.getRadius()},setWidth:function(e){t.Node.prototype.setWidth.call(this,e),this.radius()!==e/2&&this.setRadius(e/2)},setHeight:function(e){t.Node.prototype.setHeight.call(this,e),this.radius()!==e/2&&this.setRadius(e/2)}},t.Util.extend(t.Circle,t.Shape),t.Factory.addGetterSetter(t.Circle,"radius",0,t.Validators.getNumberValidator()),t.Factory.addOverloadedGetterSetter(t.Circle,"radius"),t.Collection.mapMethods(t.Circle)}(Konva)},function(t,e){!function(){"use strict";Konva.Image=function(t){this.___init(t)},Konva.Image.prototype={___init:function(t){Konva.Shape.call(this,t),this.className="Image",this.sceneFunc(this._sceneFunc),this.hitFunc(this._hitFunc)},_useBufferCanvas:function(){return(this.hasShadow()||1!==this.getAbsoluteOpacity())&&this.hasStroke()&&this.getStage()},_sceneFunc:function(t){var e,i,n,a=this.getWidth(),r=this.getHeight(),o=this.getImage();o&&(e=this.getCropWidth(),i=this.getCropHeight(),n=e&&i?[o,this.getCropX(),this.getCropY(),e,i,0,0,a,r]:[o,0,0,a,r]),(this.hasFill()||this.hasStroke())&&(t.beginPath(),t.rect(0,0,a,r),t.closePath(),t.fillStrokeShape(this)),o&&t.drawImage.apply(t,n)},_hitFunc:function(t){var e=this.getWidth(),i=this.getHeight();t.beginPath(),t.rect(0,0,e,i),t.closePath(),t.fillStrokeShape(this)},getWidth:function(){var t=this.getImage();return this.attrs.width||(t?t.width:0)},getHeight:function(){var t=this.getImage();return this.attrs.height||(t?t.height:0)}},Konva.Util.extend(Konva.Image,Konva.Shape),Konva.Factory.addGetterSetter(Konva.Image,"image"),Konva.Factory.addComponentsGetterSetter(Konva.Image,"crop",["x","y","width","height"]),Konva.Factory.addGetterSetter(Konva.Image,"cropX",0,Konva.Validators.getNumberValidator()),Konva.Factory.addGetterSetter(Konva.Image,"cropY",0,Konva.Validators.getNumberValidator()),Konva.Factory.addGetterSetter(Konva.Image,"cropWidth",0,Konva.Validators.getNumberValidator()),Konva.Factory.addGetterSetter(Konva.Image,"cropHeight",0,Konva.Validators.getNumberValidator()),Konva.Collection.mapMethods(Konva.Image),Konva.Image.fromURL=function(t,e){var i=new Image;i.onload=function(){var t=new Konva.Image({image:i});e(t)},i.crossOrigin="Anonymous",i.src=t}}()},function(t,e){!function(){"use strict";Konva.Group=function(t){this.___init(t)},Konva.Util.addMethods(Konva.Group,{___init:function(t){this.nodeType="Group",Konva.Container.call(this,t)},_validateAdd:function(t){var e=t.getType();"Group"!==e&&"Shape"!==e&&Konva.Util.throw("You may only add groups and shapes to groups.")}}),Konva.Util.extend(Konva.Group,Konva.Container),Konva.Collection.mapMethods(Konva.Group)}()},function(t,e){!function(){"use strict";Konva.FastLayer=function(t){this.____init(t)},Konva.Util.addMethods(Konva.FastLayer,{____init:function(t){this.nodeType="Layer",this.canvas=new Konva.SceneCanvas,Konva.BaseLayer.call(this,t)},_validateAdd:function(t){"Shape"!==t.getType()&&Konva.Util.throw("You may only add shapes to a fast layer.")},_setCanvasSize:function(t,e){this.canvas.setSize(t,e)},hitGraphEnabled:function(){return!1},getIntersection:function(){return null},drawScene:function(t){var e=this.getLayer(),i=t||e&&e.getCanvas();return this.getClearBeforeDraw()&&i.getContext().clear(),Konva.Container.prototype.drawScene.call(this,i),this},draw:function(){return this.drawScene(),this},setVisible:function(t){return Konva.Node.prototype.setVisible.call(this,t),this.getCanvas()._canvas.style.display=t?"block":"none",this}}),Konva.Util.extend(Konva.FastLayer,Konva.BaseLayer),Konva.Collection.mapMethods(Konva.FastLayer)}()},function(t,e){!function(){"use strict";var t=[{x:0,y:0},{x:-1,y:-1},{x:1,y:-1},{x:1,y:1},{x:-1,y:1}],e=t.length;Konva.Layer=function(t){this.____init(t)},Konva.Util.addMethods(Konva.Layer,{____init:function(t){this.nodeType="Layer",this.canvas=new Konva.SceneCanvas,this.hitCanvas=new Konva.HitCanvas({pixelRatio:1}),Konva.BaseLayer.call(this,t)},_setCanvasSize:function(t,e){this.canvas.setSize(t,e),this.hitCanvas.setSize(t,e)},_validateAdd:function(t){var e=t.getType();"Group"!==e&&"Shape"!==e&&Konva.Util.throw("You may only add groups and shapes to a layer.")},getIntersection:function(i,n){var a,r,o,s;if(!this.hitGraphEnabled()||!this.isVisible())return null;for(var h=1,l=!1;;){for(r=0;r<e;r++){if(o=t[r],(s=(a=this._getIntersection({x:i.x+o.x*h,y:i.y+o.y*h})).shape)&&n)return s.findAncestor(n,!0);if(s)return s;if(l=!!a.antialiased,!a.antialiased)break}if(!l)return null;h+=1}},_getImageData:function(t,e){var i=this.hitCanvas.width||1,n=this.hitCanvas.height||1,a=Math.round(e)*i+Math.round(t);return this._hitImageData||(this._hitImageData=this.hitCanvas.context.getImageData(0,0,i,n)),[this._hitImageData.data[4*a+0],this._hitImageData.data[4*a+1],this._hitImageData.data[4*a+2],this._hitImageData.data[4*a+3]]},_getIntersection:function(t){var e,i,n=this.hitCanvas.pixelRatio,a=this.hitCanvas.context.getImageData(Math.round(t.x*n),Math.round(t.y*n),1,1).data,r=a[3];return 255===r?(e=Konva.Util._rgbToHex(a[0],a[1],a[2]),(i=Konva.shapes["#"+e])?{shape:i}:{antialiased:!0}):r>0?{antialiased:!0}:{}},drawScene:function(t,e){var i=this.getLayer(),n=t||i&&i.getCanvas();return this._fire("beforeDraw",{node:this}),this.getClearBeforeDraw()&&n.getContext().clear(),Konva.Container.prototype.drawScene.call(this,n,e),this._fire("draw",{node:this}),this},drawHit:function(t,e){var i=this.getLayer(),n=t||i&&i.hitCanvas;return i&&i.getClearBeforeDraw()&&i.getHitCanvas().getContext().clear(),Konva.Container.prototype.drawHit.call(this,n,e),this.imageData=null,this},clear:function(t){return Konva.BaseLayer.prototype.clear.call(this,t),this.getHitCanvas().getContext().clear(t),this.imageData=null,this},setVisible:function(t){return Konva.Node.prototype.setVisible.call(this,t),t?(this.getCanvas()._canvas.style.display="block",this.hitCanvas._canvas.style.display="block"):(this.getCanvas()._canvas.style.display="none",this.hitCanvas._canvas.style.display="none"),this},enableHitGraph:function(){return this.setHitGraphEnabled(!0),this},disableHitGraph:function(){return this.setHitGraphEnabled(!1),this},setSize:function(t,e){return Konva.BaseLayer.prototype.setSize.call(this,t,e),this.hitCanvas.setSize(t,e),this}}),Konva.Util.extend(Konva.Layer,Konva.BaseLayer),Konva.Factory.addGetterSetter(Konva.Layer,"hitGraphEnabled",!0),Konva.Collection.mapMethods(Konva.Layer)}()},function(t,e){!function(t){"use strict";t.BaseLayer=function(t){this.___init(t)},t.Util.addMethods(t.BaseLayer,{___init:function(e){this.nodeType="Layer",t.Container.call(this,e)},createPNGStream:function(){return this.canvas._canvas.createPNGStream()},getCanvas:function(){return this.canvas},getHitCanvas:function(){return this.hitCanvas},getContext:function(){return this.getCanvas().getContext()},clear:function(t){return this.getContext().clear(t),this},clearHitCache:function(){this._hitImageData=void 0},setZIndex:function(e){t.Node.prototype.setZIndex.call(this,e);var i=this.getStage();return i&&(i.content.removeChild(this.getCanvas()._canvas),e<i.getChildren().length-1?i.content.insertBefore(this.getCanvas()._canvas,i.getChildren()[e+1].getCanvas()._canvas):i.content.appendChild(this.getCanvas()._canvas)),this},moveToTop:function(){t.Node.prototype.moveToTop.call(this);var e=this.getStage();return e&&(e.content.removeChild(this.getCanvas()._canvas),e.content.appendChild(this.getCanvas()._canvas)),this},moveUp:function(){if(!t.Node.prototype.moveUp.call(this))return this;var e=this.getStage();return e?(e.content.removeChild(this.getCanvas()._canvas),this.index<e.getChildren().length-1?e.content.insertBefore(this.getCanvas()._canvas,e.getChildren()[this.index+1].getCanvas()._canvas):e.content.appendChild(this.getCanvas()._canvas),this):this},moveDown:function(){if(t.Node.prototype.moveDown.call(this)){var e=this.getStage();if(e){var i=e.getChildren();e.content.removeChild(this.getCanvas()._canvas),e.content.insertBefore(this.getCanvas()._canvas,i[this.index+1].getCanvas()._canvas)}}return this},moveToBottom:function(){if(t.Node.prototype.moveToBottom.call(this)){var e=this.getStage();if(e){var i=e.getChildren();e.content.removeChild(this.getCanvas()._canvas),e.content.insertBefore(this.getCanvas()._canvas,i[1].getCanvas()._canvas)}}return this},getLayer:function(){return this},remove:function(){var e=this.getCanvas()._canvas;return t.Node.prototype.remove.call(this),e&&e.parentNode&&t.Util._isInDocument(e)&&e.parentNode.removeChild(e),this},getStage:function(){return this.parent},setSize:function(t,e){return this.canvas.setSize(t,e),this},_toKonvaCanvas:function(e){return(e=e||{}).width=e.width||this.getWidth(),e.height=e.height||this.getHeight(),e.x=void 0!==e.x?e.x:this.getX(),e.y=void 0!==e.y?e.y:this.getY(),t.Node.prototype._toKonvaCanvas.call(this,e)},getWidth:function(){if(this.parent)return this.parent.getWidth()},setWidth:function(){t.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.')},getHeight:function(){if(this.parent)return this.parent.getHeight()},setHeight:function(){t.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.')},_applyTransform:function(t,e,i){var n=t.getAbsoluteTransform(i).getMatrix();e.transform(n[0],n[1],n[2],n[3],n[4],n[5])}}),t.Util.extend(t.BaseLayer,t.Container),t.Factory.addGetterSetter(t.BaseLayer,"clearBeforeDraw",!0),t.Collection.mapMethods(t.BaseLayer)}(Konva)},function(t,e){!function(){"use strict";var t="_",e=["mousedown","mousemove","mouseup","mouseout","touchstart","touchmove","touchend","mouseover","wheel","contextmenu"],i=e.length;function n(e,i){e.content.addEventListener(i,function(n){e[t+i](n)},!1)}Konva.Stage=function(t){this.___init(t)},Konva.Util.addMethods(Konva.Stage,{___init:function(t){this.nodeType="Stage",Konva.Container.call(this,t),this._id=Konva.idCounter++,this._buildDOM(),this._bindContentEvents(),this._enableNestedTransforms=!1,Konva.stages.push(this)},_validateAdd:function(t){"Layer"!==t.getType()&&Konva.Util.throw("You may only add layers to the stage.")},setContainer:function(t){if("string"==typeof t){if("."===t.charAt(0)){var e=t.slice(1);t=Konva.document.getElementsByClassName(e)[0]}else{var i;i="#"!==t.charAt(0)?t:t.slice(1),t=Konva.document.getElementById(i)}if(!t)throw"Can not find container in document with id "+i}return this._setAttr("container",t),this},shouldDrawHit:function(){return!0},draw:function(){return Konva.Node.prototype.draw.call(this),this},setHeight:function(t){return Konva.Node.prototype.setHeight.call(this,t),this._resizeDOM(),this},setWidth:function(t){return Konva.Node.prototype.setWidth.call(this,t),this._resizeDOM(),this},clear:function(){var t,e=this.children,i=e.length;for(t=0;t<i;t++)e[t].clear();return this},clone:function(t){return t||(t={}),t.container=Konva.document.createElement("div"),Konva.Container.prototype.clone.call(this,t)},destroy:function(){var t=this.content;Konva.Container.prototype.destroy.call(this),t&&Konva.Util._isInDocument(t)&&this.getContainer().removeChild(t);var e=Konva.stages.indexOf(this);return e>-1&&Konva.stages.splice(e,1),this},getPointerPosition:function(){return this.pointerPos},getStage:function(){return this},getContent:function(){return this.content},_toKonvaCanvas:function(t){var e=(t=t||{}).x||0,i=t.y||0,n=new Konva.SceneCanvas({width:t.width||this.getWidth(),height:t.height||this.getHeight(),pixelRatio:t.pixelRatio||1}),a=n.getContext()._context,r=this.children;return(e||i)&&a.translate(-1*e,-1*i),r.each(function(n){if(n.isVisible()){var r=n._toKonvaCanvas(t);a.drawImage(r._canvas,e,i,r.getWidth()/r.getPixelRatio(),r.getHeight()/r.getPixelRatio())}}),n},toImage:function(t){var e=t.callback;t.callback=function(t){Konva.Util._getImage(t,function(t){e(t)})},this.toDataURL(t)},getIntersection:function(t,e){var i,n,a=this.getChildren();for(i=a.length-1;i>=0;i--)if(n=a[i].getIntersection(t,e))return n;return null},_resizeDOM:function(){if(this.content){var t,e,i=this.getWidth(),n=this.getHeight(),a=this.getChildren(),r=a.length;for(this.content.style.width=i+"px",this.content.style.height=n+"px",this.bufferCanvas.setSize(i,n),this.bufferHitCanvas.setSize(i,n),t=0;t<r;t++)(e=a[t]).setSize(i,n),e.draw()}},add:function(t){if(arguments.length>1){for(var e=0;e<arguments.length;e++)this.add(arguments[e]);return this}return Konva.Container.prototype.add.call(this,t),t._setCanvasSize(this.width(),this.height()),t.draw(),Konva.isBrowser&&this.content.appendChild(t.canvas._canvas),this},getParent:function(){return null},getLayer:function(){return null},getLayers:function(){return this.getChildren()},_bindContentEvents:function(){if(Konva.isBrowser)for(var t=0;t<i;t++)n(this,e[t])},_mouseover:function(t){Konva.UA.mobile||(this._setPointerPosition(t),this._fire("contentMouseover",{evt:t}))},_mouseout:function(t){if(!Konva.UA.mobile){this._setPointerPosition(t);var e=this.targetShape;e&&!Konva.isDragging()&&(e._fireAndBubble("mouseout",{evt:t}),e._fireAndBubble("mouseleave",{evt:t}),this.targetShape=null),this.pointerPos=void 0,this._fire("contentMouseout",{evt:t})}},_mousemove:function(t){return Konva.UA.ieMobile?this._touchmove(t):void 0===t.movementX&&void 0===t.movementY||0!==t.movementY||0!==t.movementX?Konva.UA.mobile?null:(this._setPointerPosition(t),Konva.isDragging()||((e=this.getIntersection(this.getPointerPosition()))&&e.isListening()?Konva.isDragging()||this.targetShape&&this.targetShape._id===e._id?e._fireAndBubble("mousemove",{evt:t}):(this.targetShape&&(this.targetShape._fireAndBubble("mouseout",{evt:t},e),this.targetShape._fireAndBubble("mouseleave",{evt:t},e)),e._fireAndBubble("mouseover",{evt:t},this.targetShape),e._fireAndBubble("mouseenter",{evt:t},this.targetShape),this.targetShape=e):(this.targetShape&&!Konva.isDragging()&&(this.targetShape._fireAndBubble("mouseout",{evt:t}),this.targetShape._fireAndBubble("mouseleave",{evt:t}),this.targetShape=null),this._fire("mousemove",{evt:t,target:this,currentTarget:this})),this._fire("contentMousemove",{evt:t})),void(t.cancelable&&t.preventDefault())):null;var e},_mousedown:function(t){if(Konva.UA.ieMobile)return this._touchstart(t);if(!Konva.UA.mobile){this._setPointerPosition(t);var e=this.getIntersection(this.getPointerPosition());Konva.listenClickTap=!0,e&&e.isListening()?(this.clickStartShape=e,e._fireAndBubble("mousedown",{evt:t})):this._fire("mousedown",{evt:t,target:this,currentTarget:this}),this._fire("contentMousedown",{evt:t})}},_mouseup:function(t){if(Konva.UA.ieMobile)return this._touchend(t);if(!Konva.UA.mobile){this._setPointerPosition(t);var e=this.getIntersection(this.getPointerPosition()),i=this.clickStartShape,n=this.clickEndShape,a=!1,r=Konva.DD;Konva.inDblClickWindow?(a=!0,clearTimeout(this.dblTimeout)):r&&r.justDragged?r&&(r.justDragged=!1):(Konva.inDblClickWindow=!0,clearTimeout(this.dblTimeout)),this.dblTimeout=setTimeout(function(){Konva.inDblClickWindow=!1},Konva.dblClickWindow),e&&e.isListening()?(this.clickEndShape=e,e._fireAndBubble("mouseup",{evt:t}),Konva.listenClickTap&&i&&i._id===e._id&&(e._fireAndBubble("click",{evt:t}),a&&n&&n._id===e._id&&e._fireAndBubble("dblclick",{evt:t}))):(this._fire("mouseup",{evt:t,target:this,currentTarget:this}),Konva.listenClickTap&&this._fire("click",{evt:t,target:this,currentTarget:this}),a&&this._fire("dblclick",{evt:t,target:this,currentTarget:this})),this._fire("contentMouseup",{evt:t}),Konva.listenClickTap&&(this._fire("contentClick",{evt:t}),a&&this._fire("contentDblclick",{evt:t})),Konva.listenClickTap=!1}t.cancelable&&t.preventDefault()},_contextmenu:function(t){this._setPointerPosition(t);var e=this.getIntersection(this.getPointerPosition());e&&e.isListening()?e._fireAndBubble("contextmenu",{evt:t}):this._fire("contextmenu",{evt:t,target:this,currentTarget:this}),this._fire("contentContextmenu",{evt:t})},_touchstart:function(t){this._setPointerPosition(t);var e=this.getIntersection(this.getPointerPosition());Konva.listenClickTap=!0,e&&e.isListening()?(this.tapStartShape=e,e._fireAndBubble("touchstart",{evt:t}),e.isListening()&&e.preventDefault()&&t.cancelable&&t.preventDefault()):this._fire("touchstart",{evt:t,target:this,currentTarget:this}),this._fire("contentTouchstart",{evt:t})},_touchend:function(t){this._setPointerPosition(t);var e=this.getIntersection(this.getPointerPosition()),i=!1;Konva.inDblClickWindow?(i=!0,clearTimeout(this.dblTimeout)):(Konva.inDblClickWindow=!0,clearTimeout(this.dblTimeout)),this.dblTimeout=setTimeout(function(){Konva.inDblClickWindow=!1},Konva.dblClickWindow),e&&e.isListening()?(e._fireAndBubble("touchend",{evt:t}),Konva.listenClickTap&&this.tapStartShape&&e._id===this.tapStartShape._id&&(e._fireAndBubble("tap",{evt:t}),i&&e._fireAndBubble("dbltap",{evt:t})),e.isListening()&&e.preventDefault()&&t.cancelable&&t.preventDefault()):(this._fire("touchend",{evt:t,target:this,currentTarget:this}),Konva.listenClickTap&&this._fire("tap",{evt:t,target:this,currentTarget:this}),i&&this._fire("dbltap",{evt:t,target:this,currentTarget:this})),this._fire("contentTouchend",{evt:t}),Konva.listenClickTap&&(this._fire("contentTap",{evt:t}),i&&this._fire("contentDbltap",{evt:t})),Konva.listenClickTap=!1},_touchmove:function(t){this._setPointerPosition(t);var e,i=Konva.DD;Konva.isDragging()||((e=this.getIntersection(this.getPointerPosition()))&&e.isListening()?(e._fireAndBubble("touchmove",{evt:t}),e.isListening()&&e.preventDefault()&&t.cancelable&&t.preventDefault()):this._fire("touchmove",{evt:t,target:this,currentTarget:this}),this._fire("contentTouchmove",{evt:t})),i&&Konva.isDragging()&&Konva.DD.node.preventDefault()&&t.cancelable&&t.preventDefault()},_wheel:function(t){this._setPointerPosition(t);var e=this.getIntersection(this.getPointerPosition());e&&e.isListening()?e._fireAndBubble("wheel",{evt:t}):this._fire("wheel",{evt:t,target:this,currentTarget:this}),this._fire("contentWheel",{evt:t})},_setPointerPosition:function(t){var e=this._getContentPosition(),i=null,n=null;if(void 0!==(t=t||window.event).touches){if(t.touches.length>0){var a=t.touches[0];i=a.clientX-e.left,n=a.clientY-e.top}}else i=t.clientX-e.left,n=t.clientY-e.top;null!==i&&null!==n&&(this.pointerPos={x:i,y:n})},_getContentPosition:function(){var t=this.content.getBoundingClientRect?this.content.getBoundingClientRect():{top:0,left:0};return{top:t.top,left:t.left}},_buildDOM:function(){if(this.bufferCanvas=new Konva.SceneCanvas,this.bufferHitCanvas=new Konva.HitCanvas({pixelRatio:1}),Konva.isBrowser){var t=this.getContainer();if(!t)throw"Stage has no container. A container is required.";t.innerHTML="",this.content=Konva.document.createElement("div"),this.content.style.position="relative",this.content.style.userSelect="none",this.content.className="konvajs-content",this.content.setAttribute("role","presentation"),t.appendChild(this.content),this._resizeDOM()}},_onContent:function(t,e){var i,n,a=t.split(" "),r=a.length;for(i=0;i<r;i++)n=a[i],this.content.addEventListener(n,e,!1)},cache:function(){Konva.Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.")},clearCache:function(){}}),Konva.Util.extend(Konva.Stage,Konva.Container),Konva.Factory.addGetter(Konva.Stage,"container"),Konva.Factory.addOverloadedGetterSetter(Konva.Stage,"container")}()},function(t,e){!function(t){"use strict";var e="hasShadow",i="shadowRGBA";function n(t){t.fill()}function a(t){t.stroke()}function r(t){t.fill()}function o(t){t.stroke()}function s(){this._clearCache(e)}function h(){this._clearCache(i)}t.Shape=function(t){this.__init(t)},t.Util.addMethods(t.Shape,{__init:function(e){this.nodeType="Shape",this._fillFunc=n,this._strokeFunc=a,this._fillFuncHit=r,this._strokeFuncHit=o;for(var i,l=t.shapes;!(i=t.Util.getRandomColor())||i in l;);this.colorKey=i,l[i]=this,t.Node.call(this,e),this.on("shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva",s),this.on("shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva",h)},hasChildren:function(){return!1},getChildren:function(){return[]},getContext:function(){return this.getLayer().getContext()},getCanvas:function(){return this.getLayer().getCanvas()},hasShadow:function(){return this._getCache(e,this._hasShadow)},_hasShadow:function(){return this.getShadowEnabled()&&0!==this.getShadowOpacity()&&!!(this.getShadowColor()||this.getShadowBlur()||this.getShadowOffsetX()||this.getShadowOffsetY())},getShadowRGBA:function(){return this._getCache(i,this._getShadowRGBA)},_getShadowRGBA:function(){if(this.hasShadow()){var e=t.Util.colorToRGBA(this.shadowColor());return"rgba("+e.r+","+e.g+","+e.b+","+e.a*(this.getShadowOpacity()||1)+")"}},hasFill:function(){return!!(this.getFill()||this.getFillPatternImage()||this.getFillLinearGradientColorStops()||this.getFillRadialGradientColorStops())},hasStroke:function(){return this.strokeEnabled()&&!(!this.stroke()&&!this.getStrokeLinearGradientColorStops())},intersects:function(t){var e=this.getStage().bufferHitCanvas;return e.getContext().clear(),this.drawHit(e),e.context.getImageData(Math.round(t.x),Math.round(t.y),1,1).data[3]>0},destroy:function(){return t.Node.prototype.destroy.call(this),delete t.shapes[this.colorKey],this},_useBufferCanvas:function(t){return!t&&this.perfectDrawEnabled()&&1!==this.getAbsoluteOpacity()&&this.hasFill()&&this.hasStroke()&&this.getStage()||this.perfectDrawEnabled()&&this.hasShadow()&&1!==this.getAbsoluteOpacity()&&this.hasFill()&&this.hasStroke()&&this.getStage()},getSelfRect:function(){var t=this.getSize();return{x:this._centroid?Math.round(-t.width/2):0,y:this._centroid?Math.round(-t.height/2):0,width:t.width,height:t.height}},getClientRect:function(t){var e=(t=t||{}).skipTransform,i=t.relativeTo,n=this.getSelfRect(),a=this.hasStroke()&&this.strokeWidth()||0,r=n.width+a,o=n.height+a,s=!t.skipShadow&&this.hasShadow(),h=s?this.shadowOffsetX():0,l=s?this.shadowOffsetY():0,c=r+Math.abs(h),d=o+Math.abs(l),u=s&&this.shadowBlur()||0,f=c+2*u,g=d+2*u,p=0;Math.round(a/2)!==a/2&&(p=1);var v={width:f+p,height:g+p,x:-Math.round(a/2+u)+Math.min(h,0)+n.x,y:-Math.round(a/2+u)+Math.min(l,0)+n.y};return e?v:this._transformedRect(v,i)},drawScene:function(t,e,i,n){var a,r,o=this.getLayer(),s=t||o.getCanvas(),h=s.getContext(),l=this._cache.canvas,c=this.sceneFunc(),d=this.hasShadow(),u=this.hasStroke();if(!this.isVisible()&&!i)return this;if(l)return h.save(),o._applyTransform(this,h,e),this._drawCachedSceneCanvas(h),h.restore(),this;if(!c)return this;if(h.save(),this._useBufferCanvas(i)&&!n){if((r=(a=this.getStage().bufferCanvas).getContext()).clear(),r.save(),r._applyLineJoin(this),!i)if(o)o._applyTransform(this,r,e);else{var f=this.getAbsoluteTransform(e).getMatrix();h.transform(f[0],f[1],f[2],f[3],f[4],f[5])}c.call(this,r,this),r.restore();var g=a.pixelRatio;d&&!s.hitCanvas?(h.save(),h._applyShadow(this),h._applyOpacity(this),h._applyGlobalCompositeOperation(this),h.drawImage(a._canvas,0,0,a.width/g,a.height/g),h.restore()):(h._applyOpacity(this),h._applyGlobalCompositeOperation(this),h.drawImage(a._canvas,0,0,a.width/g,a.height/g))}else{if(h._applyLineJoin(this),!i)if(o)o._applyTransform(this,h,e);else{var p=this.getAbsoluteTransform(e).getMatrix();h.transform(p[0],p[1],p[2],p[3],p[4],p[5])}d&&u&&!s.hitCanvas?(h.save(),i||(h._applyOpacity(this),h._applyGlobalCompositeOperation(this)),h._applyShadow(this),c.call(this,h,this),h.restore(),this.hasFill()&&this.getShadowForStrokeEnabled()&&c.call(this,h,this)):d&&!s.hitCanvas?(h.save(),i||(h._applyOpacity(this),h._applyGlobalCompositeOperation(this)),h._applyShadow(this),c.call(this,h,this),h.restore()):(i||(h._applyOpacity(this),h._applyGlobalCompositeOperation(this)),c.call(this,h,this))}return h.restore(),this},drawHit:function(t,e,i){var n=this.getLayer(),a=t||n.hitCanvas,r=a.getContext(),o=this.hitFunc()||this.sceneFunc(),s=this._cache.canvas,h=s&&s.hit;if(!this.shouldDrawHit(a)&&!i)return this;if(n&&n.clearHitCache(),h)return r.save(),n._applyTransform(this,r,e),this._drawCachedHitCanvas(r),r.restore(),this;if(!o)return this;if(r.save(),r._applyLineJoin(this),!i)if(n)n._applyTransform(this,r,e);else{var l=this.getAbsoluteTransform(e).getMatrix();r.transform(l[0],l[1],l[2],l[3],l[4],l[5])}return o.call(this,r,this),r.restore(),this},drawHitFromCache:function(e){var i,n,a,r,o,s=e||0,h=this._cache.canvas,l=this._getCachedSceneCanvas(),c=h.hit,d=c.getContext(),u=c.getWidth(),f=c.getHeight();d.clear(),d.drawImage(l._canvas,0,0,u,f);try{for(a=(n=(i=d.getImageData(0,0,u,f)).data).length,r=t.Util._hexToRgb(this.colorKey),o=0;o<a;o+=4)n[o+3]>s?(n[o]=r.r,n[o+1]=r.g,n[o+2]=r.b,n[o+3]=255):n[o+3]=0;d.putImageData(i,0,0)}catch(e){t.Util.error("Unable to draw hit graph from cached scene canvas. "+e.message)}return this}}),t.Util.extend(t.Shape,t.Node),t.Factory.addGetterSetter(t.Shape,"stroke",void 0,t.Validators.getStringValidator()),t.Factory.addGetterSetter(t.Shape,"strokeWidth",2,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Shape,"strokeHitEnabled",!0,t.Validators.getBooleanValidator()),t.Factory.addGetterSetter(t.Shape,"perfectDrawEnabled",!0,t.Validators.getBooleanValidator()),t.Factory.addGetterSetter(t.Shape,"shadowForStrokeEnabled",!0,t.Validators.getBooleanValidator()),t.Factory.addGetterSetter(t.Shape,"lineJoin"),t.Factory.addGetterSetter(t.Shape,"lineCap"),t.Factory.addGetterSetter(t.Shape,"sceneFunc"),t.Factory.addGetterSetter(t.Shape,"hitFunc"),t.Factory.addGetterSetter(t.Shape,"dash"),t.Factory.addGetterSetter(t.Shape,"dashOffset",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Shape,"shadowColor",void 0,t.Validators.getStringValidator()),t.Factory.addGetterSetter(t.Shape,"shadowBlur",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Shape,"shadowOpacity",1,t.Validators.getNumberValidator()),t.Factory.addComponentsGetterSetter(t.Shape,"shadowOffset",["x","y"]),t.Factory.addGetterSetter(t.Shape,"shadowOffsetX",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Shape,"shadowOffsetY",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Shape,"fillPatternImage"),t.Factory.addGetterSetter(t.Shape,"fill",void 0,t.Validators.getStringValidator()),t.Factory.addGetterSetter(t.Shape,"fillPatternX",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Shape,"fillPatternY",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Shape,"fillLinearGradientColorStops"),t.Factory.addGetterSetter(t.Shape,"strokeLinearGradientColorStops"),t.Factory.addGetterSetter(t.Shape,"fillRadialGradientStartRadius",0),t.Factory.addGetterSetter(t.Shape,"fillRadialGradientEndRadius",0),t.Factory.addGetterSetter(t.Shape,"fillRadialGradientColorStops"),t.Factory.addGetterSetter(t.Shape,"fillPatternRepeat","repeat"),t.Factory.addGetterSetter(t.Shape,"fillEnabled",!0),t.Factory.addGetterSetter(t.Shape,"strokeEnabled",!0),t.Factory.addGetterSetter(t.Shape,"shadowEnabled",!0),t.Factory.addGetterSetter(t.Shape,"dashEnabled",!0),t.Factory.addGetterSetter(t.Shape,"strokeScaleEnabled",!0),t.Factory.addGetterSetter(t.Shape,"fillPriority","color"),t.Factory.addComponentsGetterSetter(t.Shape,"fillPatternOffset",["x","y"]),t.Factory.addGetterSetter(t.Shape,"fillPatternOffsetX",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Shape,"fillPatternOffsetY",0,t.Validators.getNumberValidator()),t.Factory.addComponentsGetterSetter(t.Shape,"fillPatternScale",["x","y"]),t.Factory.addGetterSetter(t.Shape,"fillPatternScaleX",1,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Shape,"fillPatternScaleY",1,t.Validators.getNumberValidator()),t.Factory.addComponentsGetterSetter(t.Shape,"fillLinearGradientStartPoint",["x","y"]),t.Factory.addComponentsGetterSetter(t.Shape,"strokeLinearGradientStartPoint",["x","y"]),t.Factory.addGetterSetter(t.Shape,"fillLinearGradientStartPointX",0),t.Factory.addGetterSetter(t.Shape,"strokeLinearGradientStartPointX",0),t.Factory.addGetterSetter(t.Shape,"fillLinearGradientStartPointY",0),t.Factory.addGetterSetter(t.Shape,"strokeLinearGradientStartPointY",0),t.Factory.addComponentsGetterSetter(t.Shape,"fillLinearGradientEndPoint",["x","y"]),t.Factory.addComponentsGetterSetter(t.Shape,"strokeLinearGradientEndPoint",["x","y"]),t.Factory.addGetterSetter(t.Shape,"fillLinearGradientEndPointX",0),t.Factory.addGetterSetter(t.Shape,"strokeLinearGradientEndPointX",0),t.Factory.addGetterSetter(t.Shape,"fillLinearGradientEndPointY",0),t.Factory.addGetterSetter(t.Shape,"strokeLinearGradientEndPointY",0),t.Factory.addComponentsGetterSetter(t.Shape,"fillRadialGradientStartPoint",["x","y"]),t.Factory.addGetterSetter(t.Shape,"fillRadialGradientStartPointX",0),t.Factory.addGetterSetter(t.Shape,"fillRadialGradientStartPointY",0),t.Factory.addComponentsGetterSetter(t.Shape,"fillRadialGradientEndPoint",["x","y"]),t.Factory.addGetterSetter(t.Shape,"fillRadialGradientEndPointX",0),t.Factory.addGetterSetter(t.Shape,"fillRadialGradientEndPointY",0),t.Factory.addGetterSetter(t.Shape,"fillPatternRotation",0),t.Factory.backCompat(t.Shape,{dashArray:"dash",getDashArray:"getDash",setDashArray:"getDash",drawFunc:"sceneFunc",getDrawFunc:"getSceneFunc",setDrawFunc:"setSceneFunc",drawHitFunc:"hitFunc",getDrawHitFunc:"getHitFunc",setDrawHitFunc:"setHitFunc"}),t.Collection.mapMethods(t.Shape)}(Konva)},function(t,e){!function(){"use strict";Konva.Container=function(t){this.__init(t)},Konva.Util.addMethods(Konva.Container,{__init:function(t){this.children=new Konva.Collection,Konva.Node.call(this,t)},getChildren:function(t){if(!t)return this.children;var e=new Konva.Collection;return this.children.each(function(i){t(i)&&e.push(i)}),e},hasChildren:function(){return this.getChildren().length>0},removeChildren:function(){for(var t,e=Konva.Collection.toCollection(this.children),i=0;i<e.length;i++)delete(t=e[i]).parent,t.index=0,t.remove();return e=null,this.children=new Konva.Collection,this},destroyChildren:function(){for(var t,e=Konva.Collection.toCollection(this.children),i=0;i<e.length;i++)delete(t=e[i]).parent,t.index=0,t.destroy();return e=null,this.children=new Konva.Collection,this},add:function(t){if(arguments.length>1){for(var e=0;e<arguments.length;e++)this.add(arguments[e]);return this}if(t.getParent())return t.moveTo(this),this;var i=this.children;return this._validateAdd(t),t.index=i.length,t.parent=this,i.push(t),this._fire("add",{child:t}),Konva.DD&&t.isDragging()&&Konva.DD.anim.setLayers(t.getLayer()),this},destroy:function(){return this.hasChildren()&&this.destroyChildren(),Konva.Node.prototype.destroy.call(this),this},find:function(t){return this._generalFind(t,!1)},findOne:function(t){var e=this._generalFind(t,!0);return e.length>0?e[0]:void 0},_generalFind:function(t,e){var i=[];return"string"==typeof t?i=this._findByString(t,e):"function"==typeof t&&(i=this._findByFunction(t,e)),Konva.Collection.toCollection(i)},_findByString:function(t){var e,i,n,a,r,o,s,h=[],l=t.replace(/ /g,"").split(","),c=l.length;for(e=0;e<c;e++){if(n=l[e],!Konva.Util.isValidSelector(n)){var d='Selector "'+n+'" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".\nIf you have a custom shape with such className, please change it to start with upper letter like "Triangle".\nKonva is awesome, right?';Konva.Util.warn(d)}if("#"===n.charAt(0))(r=this._getNodeById(n.slice(1)))&&h.push(r);else if("."===n.charAt(0))a=this._getNodesByName(n.slice(1)),h=h.concat(a);else for(s=(o=this.getChildren()).length,i=0;i<s;i++)h=h.concat(o[i]._get(n))}return h},_findByFunction:function(t,e){var i=[],n=function(a){if(!(e&&i.length>0)){var r=a.getChildren(),o=r.length;t(a)&&(i=i.concat(a));for(var s=0;s<o;s++)n(r[s])}};return n(this),i},_getNodeById:function(t){var e=Konva.ids[t];return void 0!==e&&this.isAncestorOf(e)?e:null},_getNodesByName:function(t){var e=Konva.names[t]||[];return this._getDescendants(e)},_get:function(t){for(var e=Konva.Node.prototype._get.call(this,t),i=this.getChildren(),n=i.length,a=0;a<n;a++)e=e.concat(i[a]._get(t));return e},toObject:function(){var t=Konva.Node.prototype.toObject.call(this);t.children=[];for(var e=this.getChildren(),i=e.length,n=0;n<i;n++){var a=e[n];t.children.push(a.toObject())}return t},_getDescendants:function(t){for(var e=[],i=t.length,n=0;n<i;n++){var a=t[n];this.isAncestorOf(a)&&e.push(a)}return e},isAncestorOf:function(t){for(var e=t.getParent();e;){if(e._id===this._id)return!0;e=e.getParent()}return!1},clone:function(t){var e=Konva.Node.prototype.clone.call(this,t);return this.getChildren().each(function(t){e.add(t.clone())}),e},getAllIntersections:function(t){var e=[];return this.find("Shape").each(function(i){i.isVisible()&&i.intersects(t)&&e.push(i)}),e},_setChildrenIndices:function(){this.children.each(function(t,e){t.index=e})},drawScene:function(t,e,i){var n=this.getLayer(),a=t||n&&n.getCanvas(),r=a&&a.getContext(),o=this._cache.canvas,s=o&&o.scene;return(this.isVisible()||i)&&(!i&&s?(r.save(),n._applyTransform(this,r,e),this._drawCachedSceneCanvas(r),r.restore()):this._drawChildren(a,"drawScene",e,!1,i)),this},drawHit:function(t,e,i){var n=this.getLayer(),a=t||n&&n.hitCanvas,r=a&&a.getContext(),o=this._cache.canvas,s=o&&o.hit;return(this.shouldDrawHit(a)||i)&&(n&&n.clearHitCache(),!i&&s?(r.save(),n._applyTransform(this,r,e),this._drawCachedHitCanvas(r),r.restore()):this._drawChildren(a,"drawHit",e)),this},_drawChildren:function(t,e,i,n,a){var r,o,s=this.getLayer(),h=t&&t.getContext(),l=this.getClipWidth(),c=this.getClipHeight(),d=this.getClipFunc(),u=l&&c||d;if(u&&s){h.save();var f=this.getAbsoluteTransform(i),g=f.getMatrix();h.transform(g[0],g[1],g[2],g[3],g[4],g[5]),h.beginPath(),d?d.call(this,h,this):(r=this.getClipX(),o=this.getClipY(),h.rect(r,o,l,c)),h.clip(),g=f.copy().invert().getMatrix(),h.transform(g[0],g[1],g[2],g[3],g[4],g[5])}this.children.each(function(r){r[e](t,i,n,a)}),u&&h.restore()},shouldDrawHit:function(t){var e=this.getLayer(),i=Konva.DD&&Konva.isDragging()&&-1!==Konva.DD.anim.getLayers().indexOf(e);return t&&t.isCache||e&&e.hitGraphEnabled()&&this.isVisible()&&!i},getClientRect:function(t){var e,i,n,a,r,o=(t=t||{}).skipTransform,s=t.relativeTo,h=this;this.children.each(function(r){if(r.getVisible()){var o=r.getClientRect({relativeTo:h,skipShadow:t.skipShadow});0===o.width&&0===o.height||(void 0===e?(e=o.x,i=o.y,n=o.x+o.width,a=o.y+o.height):(e=Math.min(e,o.x),i=Math.min(i,o.y),n=Math.max(n,o.x+o.width),a=Math.max(a,o.y+o.height)))}});for(var l=this.find("Shape"),c=!1,d=0;d<l.length;d++)if(l[d]._isVisible(this)){c=!0;break}return r=c?{x:e,y:i,width:n-e,height:a-i}:{x:0,y:0,width:0,height:0},o?r:this._transformedRect(r,s)}}),Konva.Util.extend(Konva.Container,Konva.Node),Konva.Container.prototype.get=Konva.Container.prototype.find,Konva.Factory.addComponentsGetterSetter(Konva.Container,"clip",["x","y","width","height"]),Konva.Factory.addGetterSetter(Konva.Container,"clipX",void 0,Konva.Validators.getNumberValidator()),Konva.Factory.addGetterSetter(Konva.Container,"clipY",void 0,Konva.Validators.getNumberValidator()),Konva.Factory.addGetterSetter(Konva.Container,"clipWidth",void 0,Konva.Validators.getNumberValidator()),Konva.Factory.addGetterSetter(Konva.Container,"clipHeight",void 0,Konva.Validators.getNumberValidator()),Konva.Factory.addGetterSetter(Konva.Container,"clipFunc"),Konva.Collection.mapMethods(Konva.Container)}()},function(t,e){!function(t){"use strict";var e="Shape",i=["id"],n=["xChange.konva","yChange.konva","scaleXChange.konva","scaleYChange.konva","skewXChange.konva","skewYChange.konva","rotationChange.konva","offsetXChange.konva","offsetYChange.konva","transformsEnabledChange.konva"].join(" "),a=["scaleXChange.konva","scaleYChange.konva"].join(" ");t.Node=function(t){this._init(t)},t.Util.addMethods(t.Node,{_init:function(e){this._id=t.idCounter++,this.eventListeners={},this.attrs={},this._cache={},this._filterUpToDate=!1,this._isUnderCache=!1,this.setAttrs(e),this.on(n,function(){this._clearCache("transform"),this._clearSelfAndDescendantCache("absoluteTransform")}),this.on(a,function(){this._clearSelfAndDescendantCache("absoluteScale")}),this.on("visibleChange.konva",function(){this._clearSelfAndDescendantCache("visible")}),this.on("listeningChange.konva",function(){this._clearSelfAndDescendantCache("listening")}),this.on("opacityChange.konva",function(){this._clearSelfAndDescendantCache("absoluteOpacity")})},_clearCache:function(t){t?delete this._cache[t]:this._cache={}},_getCache:function(t,e){return void 0===this._cache[t]&&(this._cache[t]=e.call(this)),this._cache[t]},_clearSelfAndDescendantCache:function(t){this._clearCache(t),this.children&&this.getChildren().each(function(e){e._clearSelfAndDescendantCache(t)})},clearCache:function(){return delete this._cache.canvas,this._filterUpToDate=!1,this},cache:function(e){var i=e||{},n={};void 0!==i.x&&void 0!==i.y&&void 0!==i.width&&void 0!==i.height||(n=this.getClientRect({skipTransform:!0,relativeTo:this.getParent()}));var a=i.width||n.width,r=i.height||n.height,o=i.pixelRatio,s=void 0===i.x?n.x:i.x,h=void 0===i.y?n.y:i.y,l=i.offset||0,c=i.drawBorder||!1;if(a&&r){a+=2*l,r+=2*l,s-=l,h-=l;var d=new t.SceneCanvas({pixelRatio:o,width:a,height:r}),u=new t.SceneCanvas({pixelRatio:o,width:a,height:r}),f=new t.HitCanvas({pixelRatio:1,width:a,height:r}),g=d.getContext(),p=f.getContext();return f.isCache=!0,this.clearCache(),g.save(),p.save(),g.translate(-s,-h),p.translate(-s,-h),this._isUnderCache=!0,this._clearSelfAndDescendantCache("absoluteOpacity"),this._clearSelfAndDescendantCache("absoluteScale"),this.drawScene(d,this,!0),this.drawHit(f,this,!0),this._isUnderCache=!1,g.restore(),p.restore(),c&&(g.save(),g.beginPath(),g.rect(0,0,a,r),g.closePath(),g.setAttr("strokeStyle","red"),g.setAttr("lineWidth",5),g.stroke(),g.restore()),this._cache.canvas={scene:d,filter:u,hit:f,x:s,y:h},this}t.Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.")},getClientRect:function(){throw new Error('abstract "getClientRect" method call')},_transformedRect:function(t,e){var i,n,a,r,o=[{x:t.x,y:t.y},{x:t.x+t.width,y:t.y},{x:t.x+t.width,y:t.y+t.height},{x:t.x,y:t.y+t.height}],s=this.getAbsoluteTransform(e);return o.forEach(function(t){var e=s.point(t);void 0===i&&(i=a=e.x,n=r=e.y),i=Math.min(i,e.x),n=Math.min(n,e.y),a=Math.max(a,e.x),r=Math.max(r,e.y)}),{x:i,y:n,width:a-i,height:r-n}},_drawCachedSceneCanvas:function(t){t.save(),t._applyOpacity(this),t._applyGlobalCompositeOperation(this),t.translate(this._cache.canvas.x,this._cache.canvas.y);var e=this._getCachedSceneCanvas(),i=e.pixelRatio;t.drawImage(e._canvas,0,0,e.width/i,e.height/i),t.restore()},_drawCachedHitCanvas:function(t){var e=this._cache.canvas.hit;t.save(),t.translate(this._cache.canvas.x,this._cache.canvas.y),t.drawImage(e._canvas,0,0),t.restore()},_getCachedSceneCanvas:function(){var e,i,n,a,r=this.filters(),o=this._cache.canvas,s=o.scene,h=o.filter,l=h.getContext();if(r){if(!this._filterUpToDate){var c=s.pixelRatio;try{for(e=r.length,l.clear(),l.drawImage(s._canvas,0,0,s.getWidth()/c,s.getHeight()/c),i=l.getImageData(0,0,h.getWidth(),h.getHeight()),n=0;n<e;n++)"function"==typeof(a=r[n])?(a.call(this,i),l.putImageData(i,0,0)):t.Util.error("Filter should be type of function, but got "+typeof a+" insted. Please check correct filters")}catch(e){t.Util.error("Unable to apply filter. "+e.message)}this._filterUpToDate=!0}return h}return s},on:function(t,e){if(3===arguments.length)return this._delegate.apply(this,arguments);var i,n,a,r,o=t.split(" "),s=o.length;for(i=0;i<s;i++)a=(n=o[i].split("."))[0],r=n[1]||"",this.eventListeners[a]||(this.eventListeners[a]=[]),this.eventListeners[a].push({name:r,handler:e});return this},off:function(t,e){var i,n,a,r,o,s=(t||"").split(" "),h=s.length;if(!t)for(n in this.eventListeners)this._off(n);for(i=0;i<h;i++)if(r=(a=s[i].split("."))[0],o=a[1],r)this.eventListeners[r]&&this._off(r,o,e);else for(n in this.eventListeners)this._off(n,o,e);return this},dispatchEvent:function(t){var e={target:this,type:t.type,evt:t};return this.fire(t.type,e),this},addEventListener:function(t,e){return this.on(t,function(t){e.call(this,t.evt)}),this},removeEventListener:function(t){return this.off(t),this},_delegate:function(e,i,n){var a=this;this.on(e,function(e){for(var r=e.target.findAncestors(i,!0,a),o=0;o<r.length;o++)(e=t.Util.cloneObject(e)).currentTarget=r[o],n.call(r[o],e)})},remove:function(){var t=this.getParent();return t&&t.children&&(t.children.splice(this.index,1),t._setChildrenIndices(),delete this.parent),this._clearSelfAndDescendantCache("stage"),this._clearSelfAndDescendantCache("absoluteTransform"),this._clearSelfAndDescendantCache("visible"),this._clearSelfAndDescendantCache("listening"),this._clearSelfAndDescendantCache("absoluteOpacity"),this},destroy:function(){t._removeId(this.getId());for(var e=(this.getName()||"").split(/\s/g),i=0;i<e.length;i++){var n=e[i];t._removeName(n,this._id)}return this.remove(),this},getAttr:function(e){var i="get"+t.Util._capitalize(e);return t.Util._isFunction(this[i])?this[i]():this.attrs[e]},getAncestors:function(){for(var e=this.getParent(),i=new t.Collection;e;)i.push(e),e=e.getParent();return i},getAttrs:function(){return this.attrs||{}},setAttrs:function(e){var i,n;if(!e)return this;for(i in e)"children"!==i&&(n="set"+t.Util._capitalize(i),t.Util._isFunction(this[n])?this[n](e[i]):this._setAttr(i,e[i]));return this},isListening:function(){return this._getCache("listening",this._isListening)},_isListening:function(){var t=this.getListening(),e=this.getParent();return"inherit"===t?!e||e.isListening():t},isVisible:function(){return this._getCache("visible",this._isVisible)},_isVisible:function(t){var e=this.getVisible(),i=this.getParent();return t===i&&"inherit"===e||(t===i?e:"inherit"===e?!i||i._isVisible(t):e)},shouldDrawHit:function(){var t=this.getLayer();return!t&&this.isListening()&&this.isVisible()||t&&t.hitGraphEnabled()&&this.isListening()&&this.isVisible()},show:function(){return this.setVisible(!0),this},hide:function(){return this.setVisible(!1),this},getZIndex:function(){return this.index||0},getAbsoluteZIndex:function(){var t,i,n,a,r=this.getDepth(),o=this,s=0;return"Stage"!==o.nodeType&&function h(l){for(t=[],i=l.length,n=0;n<i;n++)a=l[n],s++,a.nodeType!==e&&(t=t.concat(a.getChildren().toArray())),a._id===o._id&&(n=i);t.length>0&&t[0].getDepth()<=r&&h(t)}(o.getStage().getChildren()),s},getDepth:function(){for(var t=0,e=this.parent;e;)t++,e=e.parent;return t},setPosition:function(t){return this.setX(t.x),this.setY(t.y),this},getPosition:function(){return{x:this.getX(),y:this.getY()}},getAbsolutePosition:function(e){var i=this.getAbsoluteTransform(e).getMatrix(),n=new t.Transform,a=this.offset();return n.m=i.slice(),n.translate(a.x,a.y),n.getTranslation()},setAbsolutePosition:function(t){var e,i=this._clearTransform();return this.attrs.x=i.x,this.attrs.y=i.y,delete i.x,delete i.y,(e=this.getAbsoluteTransform()).invert(),e.translate(t.x,t.y),t={x:this.attrs.x+e.getTranslation().x,y:this.attrs.y+e.getTranslation().y},this.setPosition({x:t.x,y:t.y}),this._setTransform(i),this},_setTransform:function(t){var e;for(e in t)this.attrs[e]=t[e];this._clearCache("transform"),this._clearSelfAndDescendantCache("absoluteTransform")},_clearTransform:function(){var t={x:this.getX(),y:this.getY(),rotation:this.getRotation(),scaleX:this.getScaleX(),scaleY:this.getScaleY(),offsetX:this.getOffsetX(),offsetY:this.getOffsetY(),skewX:this.getSkewX(),skewY:this.getSkewY()};return this.attrs.x=0,this.attrs.y=0,this.attrs.rotation=0,this.attrs.scaleX=1,this.attrs.scaleY=1,this.attrs.offsetX=0,this.attrs.offsetY=0,this.attrs.skewX=0,this.attrs.skewY=0,this._clearCache("transform"),this._clearSelfAndDescendantCache("absoluteTransform"),t},move:function(t){var e=t.x,i=t.y,n=this.getX(),a=this.getY();return void 0!==e&&(n+=e),void 0!==i&&(a+=i),this.setPosition({x:n,y:a}),this},_eachAncestorReverse:function(t,e){var i,n,a=[],r=this.getParent();if(e&&e._id===this._id)t(this);else{for(a.unshift(this);r&&(!e||r._id!==e._id);)a.unshift(r),r=r.parent;for(i=a.length,n=0;n<i;n++)t(a[n])}},rotate:function(t){return this.setRotation(this.getRotation()+t),this},moveToTop:function(){if(!this.parent)return t.Util.warn("Node has no parent. moveToTop function is ignored."),!1;var e=this.index;return this.parent.children.splice(e,1),this.parent.children.push(this),this.parent._setChildrenIndices(),!0},moveUp:function(){if(!this.parent)return t.Util.warn("Node has no parent. moveUp function is ignored."),!1;var e=this.index;return e<this.parent.getChildren().length-1&&(this.parent.children.splice(e,1),this.parent.children.splice(e+1,0,this),this.parent._setChildrenIndices(),!0)},moveDown:function(){if(!this.parent)return t.Util.warn("Node has no parent. moveDown function is ignored."),!1;var e=this.index;return e>0&&(this.parent.children.splice(e,1),this.parent.children.splice(e-1,0,this),this.parent._setChildrenIndices(),!0)},moveToBottom:function(){if(!this.parent)return t.Util.warn("Node has no parent. moveToBottom function is ignored."),!1;var e=this.index;return e>0&&(this.parent.children.splice(e,1),this.parent.children.unshift(this),this.parent._setChildrenIndices(),!0)},setZIndex:function(e){if(!this.parent)return t.Util.warn("Node has no parent. zIndex parameter is ignored."),!1;var i=this.index;return this.parent.children.splice(i,1),this.parent.children.splice(e,0,this),this.parent._setChildrenIndices(),this},getAbsoluteOpacity:function(){return this._getCache("absoluteOpacity",this._getAbsoluteOpacity)},_getAbsoluteOpacity:function(){var t=this.getOpacity(),e=this.getParent();return e&&!e._isUnderCache&&(t*=this.getParent().getAbsoluteOpacity()),t},moveTo:function(t){return this.getParent()!==t&&((this.__originalRemove||this.remove).call(this),t.add(this)),this},toObject:function(){var e,i,n,a,r={},o=this.getAttrs();for(e in r.attrs={},o)i=o[e],n="function"==typeof this[e]&&this[e],delete o[e],a=n?n.call(this):null,o[e]=i,a!==i&&(r.attrs[e]=i);return r.className=this.getClassName(),t.Util._prepareToStringify(r)},toJSON:function(){return JSON.stringify(this.toObject())},getParent:function(){return this.parent},findAncestors:function(t,e,i){var n=[];e&&this._isMatch(t)&&n.push(this);for(var a=this.parent;a;){if(a===i)return n;a._isMatch(t)&&n.push(a),a=a.parent}return n},findAncestor:function(t,e,i){return this.findAncestors(t,e,i)[0]},_isMatch:function(e){if(!e)return!1;var i,n,a=e.replace(/ /g,"").split(","),r=a.length;for(i=0;i<r;i++)if(n=a[i],t.Util.isValidSelector(n)||(t.Util.warn('Selector "'+n+'" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'),t.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'),t.Util.warn("Konva is awesome, right?")),"#"===n.charAt(0)){if(this.id()===n.slice(1))return!0}else if("."===n.charAt(0)){if(this.hasName(n.slice(1)))return!0}else if(0!==this._get(n).length)return!0;return!1},getLayer:function(){var t=this.getParent();return t?t.getLayer():null},getStage:function(){return this._getCache("stage",this._getStage)},_getStage:function(){var t=this.getParent();return t?t.getStage():void 0},fire:function(t,e,i){return(e=e||{}).target=e.target||this,i?this._fireAndBubble(t,e):this._fire(t,e),this},getAbsoluteTransform:function(t){return t?this._getAbsoluteTransform(t):this._getCache("absoluteTransform",this._getAbsoluteTransform)},_getAbsoluteTransform:function(e){var i=new t.Transform;return this._eachAncestorReverse(function(t){var e=t.transformsEnabled();"all"===e?i.multiply(t.getTransform()):"position"===e&&i.translate(t.getX()-t.getOffsetX(),t.getY()-t.getOffsetY())},e),i},getAbsoluteScale:function(t){return t?this._getAbsoluteScale(t):this._getCache("absoluteScale",this._getAbsoluteScale)},_getAbsoluteScale:function(t){for(var e=this;e;)e._isUnderCache&&(t=e),e=e.getParent();var i=1,n=1;return this._eachAncestorReverse(function(t){i*=t.scaleX(),n*=t.scaleY()},t),{x:i,y:n}},getTransform:function(){return this._getCache("transform",this._getTransform)},_getTransform:function(){var e=new t.Transform,i=this.getX(),n=this.getY(),a=t.getAngle(this.getRotation()),r=this.getScaleX(),o=this.getScaleY(),s=this.getSkewX(),h=this.getSkewY(),l=this.getOffsetX(),c=this.getOffsetY();return 0===i&&0===n||e.translate(i,n),0!==a&&e.rotate(a),0===s&&0===h||e.skew(s,h),1===r&&1===o||e.scale(r,o),0===l&&0===c||e.translate(-1*l,-1*c),e},clone:function(e){var n,a,r,o,s,h=t.Util.cloneObject(this.attrs);for(var l in i)delete h[i[l]];for(n in e)h[n]=e[n];var c=new this.constructor(h);for(n in this.eventListeners)for(r=(a=this.eventListeners[n]).length,o=0;o<r;o++)(s=a[o]).name.indexOf("konva")<0&&(c.eventListeners[n]||(c.eventListeners[n]=[]),c.eventListeners[n].push(s));return c},_toKonvaCanvas:function(e){e=e||{};var i=this.getClientRect(),n=this.getStage(),a=void 0!==e.x?e.x:i.x,r=void 0!==e.y?e.y:i.y,o=e.pixelRatio||1,s=new t.SceneCanvas({width:e.width||i.width||(n?n.getWidth():0),height:e.height||i.height||(n?n.getHeight():0),pixelRatio:o}),h=s.getContext();return h.save(),(a||r)&&h.translate(-1*a,-1*r),this.drawScene(s),h.restore(),s},toCanvas:function(t){return this._toKonvaCanvas(t)._canvas},toDataURL:function(t){var e=(t=t||{}).mimeType||null,i=t.quality||null,n=this._toKonvaCanvas(t).toDataURL(e,i);return t.callback&&t.callback(n),n},toImage:function(e){if(!e||!e.callback)throw"callback required for toImage method config argument";var i=e.callback;delete e.callback,t.Util._getImage(this.toDataURL(e),function(t){i(t)})},setSize:function(t){return this.setWidth(t.width),this.setHeight(t.height),this},getSize:function(){return{width:this.getWidth(),height:this.getHeight()}},getWidth:function(){return this.attrs.width||0},getHeight:function(){return this.attrs.height||0},getClassName:function(){return this.className||this.nodeType},getType:function(){return this.nodeType},getDragDistance:function(){return void 0!==this.attrs.dragDistance?this.attrs.dragDistance:this.parent?this.parent.getDragDistance():t.dragDistance},_get:function(t){return this.className===t||this.nodeType===t?[this]:[]},_off:function(t,e,i){var n,a,r,o=this.eventListeners[t];for(n=0;n<o.length;n++)if(a=o[n].name,r=o[n].handler,!("konva"===a&&"konva"!==e||e&&a!==e||i&&i!==r)){if(o.splice(n,1),0===o.length){delete this.eventListeners[t];break}n--}},_fireChangeEvent:function(t,e,i){this._fire(t+"Change",{oldVal:e,newVal:i})},setId:function(e){var i=this.getId();return t._removeId(i),t._addId(this,e),this._setAttr("id",e),this},setName:function(e){var i,n,a=(this.getName()||"").split(/\s/g),r=(e||"").split(/\s/g);for(n=0;n<a.length;n++)i=a[n],-1===r.indexOf(i)&&i&&t._removeName(i,this._id);for(n=0;n<r.length;n++)i=r[n],-1===a.indexOf(i)&&i&&t._addName(this,i);return this._setAttr("name",e),this},addName:function(t){if(!this.hasName(t)){var e=this.name(),i=e?e+" "+t:t;this.setName(i)}return this},hasName:function(t){return-1!==(this.name()||"").split(/\s/g).indexOf(t)},removeName:function(t){var e=(this.name()||"").split(/\s/g),i=e.indexOf(t);return-1!==i&&(e.splice(i,1),this.setName(e.join(" "))),this},setAttr:function(e,i){var n=this["set"+t.Util._capitalize(e)];return t.Util._isFunction(n)?n.call(this,i):this._setAttr(e,i),this},_setAttr:function(e,i){var n;(n=this.attrs[e])===i&&!t.Util.isObject(i)||(void 0===i||null===i?delete this.attrs[e]:this.attrs[e]=i,this._fireChangeEvent(e,n,i))},_setComponentAttr:function(t,e,i){var n;void 0!==i&&((n=this.attrs[t])||(this.attrs[t]=this.getAttr(t)),this.attrs[t][e]=i,this._fireChangeEvent(t,n,i))},_fireAndBubble:function(t,i,n){var a=!0;if(i&&this.nodeType===e&&(i.target=this),"mouseenter"===t&&n&&(this._id===n._id||this.isAncestorOf&&this.isAncestorOf(n))?a=!1:"mouseleave"===t&&n&&(this._id===n._id||this.isAncestorOf&&this.isAncestorOf(n))&&(a=!1),a){this._fire(t,i);var r=("mouseenter"===t||"mouseleave"===t)&&n&&n.isAncestorOf&&n.isAncestorOf(this)&&!n.isAncestorOf(this.parent);(i&&!i.cancelBubble||!i)&&this.parent&&this.parent.isListening()&&!r&&(n&&n.parent?this._fireAndBubble.call(this.parent,t,i,n.parent):this._fireAndBubble.call(this.parent,t,i))}},_fire:function(t,e){var i,n=this.eventListeners[t];if((e=e||{}).currentTarget=this,e.type=t,n)for(i=0;i<n.length;i++)n[i].handler.call(this,e)},draw:function(){return this.drawScene(),this.drawHit(),this}}),t.Node.create=function(e,i){return t.Util._isString(e)&&(e=JSON.parse(e)),this._createNode(e,i)},t.Node._createNode=function(e,i){var n,a,r,o=t.Node.prototype.getClassName.call(e),s=e.children;if(i&&(e.attrs.container=i),n=new t[o](e.attrs),s)for(a=s.length,r=0;r<a;r++)n.add(this._createNode(s[r]));return n},t.Factory.addOverloadedGetterSetter(t.Node,"position"),t.Factory.addGetterSetter(t.Node,"x",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Node,"y",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Node,"globalCompositeOperation","source-over",t.Validators.getStringValidator()),t.Factory.addGetterSetter(t.Node,"opacity",1,t.Validators.getNumberValidator()),t.Factory.addGetter(t.Node,"name"),t.Factory.addOverloadedGetterSetter(t.Node,"name"),t.Factory.addGetter(t.Node,"id"),t.Factory.addOverloadedGetterSetter(t.Node,"id"),t.Factory.addGetterSetter(t.Node,"rotation",0,t.Validators.getNumberValidator()),t.Factory.addComponentsGetterSetter(t.Node,"scale",["x","y"]),t.Factory.addGetterSetter(t.Node,"scaleX",1,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Node,"scaleY",1,t.Validators.getNumberValidator()),t.Factory.addComponentsGetterSetter(t.Node,"skew",["x","y"]),t.Factory.addGetterSetter(t.Node,"skewX",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Node,"skewY",0,t.Validators.getNumberValidator()),t.Factory.addComponentsGetterSetter(t.Node,"offset",["x","y"]),t.Factory.addGetterSetter(t.Node,"offsetX",0,t.Validators.getNumberValidator()),t.Factory.addGetterSetter(t.Node,"offsetY",0,t.Validators.getNumberValidator()),t.Factory.addSetter(t.Node,"dragDistance",t.Validators.getNumberValidator()),t.Factory.addOverloadedGetterSetter(t.Node,"dragDistance"),t.Factory.addSetter(t.Node,"width",t.Validators.getNumberValidator()),t.Factory.addOverloadedGetterSetter(t.Node,"width"),t.Factory.addSetter(t.Node,"height",t.Validators.getNumberValidator()),t.Factory.addOverloadedGetterSetter(t.Node,"height"),t.Factory.addGetterSetter(t.Node,"listening","inherit",function(e){return!0===e||!1===e||"inherit"===e||t.Util.warn(e+' is a not valid value for "listening" attribute. The value may be true, false or "inherit".'),e}),t.Factory.addGetterSetter(t.Node,"preventDefault",!0,t.Validators.getBooleanValidator()),t.Factory.addGetterSetter(t.Node,"filters",null,function(t){return this._filterUpToDate=!1,t}),t.Factory.addGetterSetter(t.Node,"visible","inherit",function(e){return!0===e||!1===e||"inherit"===e||t.Util.warn(e+' is a not valid value for "visible" attribute. The value may be true, false or "inherit".'),e}),t.Factory.addGetterSetter(t.Node,"transformsEnabled","all",t.Validators.getStringValidator()),t.Factory.addOverloadedGetterSetter(t.Node,"size"),t.Factory.backCompat(t.Node,{rotateDeg:"rotate",setRotationDeg:"setRotation",getRotationDeg:"getRotation"}),t.Collection.mapMethods(t.Node)}(Konva)},function(t,e){!function(){"use strict";Konva.Factory={addGetterSetter:function(t,e,i,n,a){this.addGetter(t,e,i),this.addSetter(t,e,n,a),this.addOverloadedGetterSetter(t,e)},addGetter:function(t,e,i){var n="get"+Konva.Util._capitalize(e);t.prototype[n]=function(){var t=this.attrs[e];return void 0===t?i:t}},addSetter:function(t,e,i,n){var a="set"+Konva.Util._capitalize(e);t.prototype[a]=function(t){return i&&void 0!==t&&null!==t&&(t=i.call(this,t,e)),this._setAttr(e,t),n&&n.call(this),this}},addComponentsGetterSetter:function(t,e,i,n,a){var r,o,s=i.length,h=Konva.Util._capitalize,l="get"+h(e),c="set"+h(e);t.prototype[l]=function(){var t={};for(r=0;r<s;r++)t[o=i[r]]=this.getAttr(e+h(o));return t},t.prototype[c]=function(t){var i,r=this.attrs[e];for(i in n&&(t=n.call(this,t)),t)t.hasOwnProperty(i)&&this._setAttr(e+h(i),t[i]);return this._fireChangeEvent(e,r,t),a&&a.call(this),this},this.addOverloadedGetterSetter(t,e)},addOverloadedGetterSetter:function(t,e){var i=Konva.Util._capitalize(e),n="set"+i,a="get"+i;t.prototype[e]=function(){return arguments.length?(this[n](arguments[0]),this):this[a]()}},addDeprecatedGetterSetter:function(t,e,i,n){Konva.Util.error("Adding deprecated "+e);var a="get"+Konva.Util._capitalize(e),r=e+" property is deprecated and will be removed soon. Look at Konva change log for more information.";t.prototype[a]=function(){Konva.Util.error(r);var t=this.attrs[e];return void 0===t?i:t},this.addSetter(t,e,n,function(){Konva.Util.error(r)}),this.addOverloadedGetterSetter(t,e)},backCompat:function(t,e){Konva.Util.each(e,function(e,i){var n=t.prototype[i],a="get"+Konva.Util._capitalize(e),r="set"+Konva.Util._capitalize(e);function o(){n.apply(this,arguments),Konva.Util.error('"'+e+'" method is deprecated and will be removed soon. Use ""'+i+'" instead.')}t.prototype[e]=o,t.prototype[a]=o,t.prototype[r]=o})},afterSetFilter:function(){this._filterUpToDate=!1}},Konva.Validators={RGBComponent:function(t){return t>255?255:t<0?0:Math.round(t)},alphaComponent:function(t){return t>1?1:t<1e-4?1e-4:t},_formatValue:function(t){return Konva.Util._isString(t)?'"'+t+'"':"[object Number]"===Object.prototype.toString.call(t)?t:Konva.Util._isBoolean(t)?t:Object.prototype.toString.call(t)},getNumberValidator:function(){if(Konva.isUnminified)return function(t,e){return Konva.Util._isNumber(t)||Konva.Util.warn(Konva.Validators._formatValue(t)+' is a not valid value for "'+e+'" attribute. The value should be a number.'),t}},getNumberOrAutoValidator:function(){if(Konva.isUnminified)return function(t,e){return Konva.Util._isNumber(t)||"auto"===t||Konva.Util.warn(Konva.Validators._formatValue(t)+' is a not valid value for "'+e+'" attribute. The value should be a number or "auto".'),t}},getStringValidator:function(){if(Konva.isUnminified)return function(t,e){return Konva.Util._isString(t)||Konva.Util.warn(Konva.Validators._formatValue(t)+' is a not valid value for "'+e+'" attribute. The value should be a string.'),t}},getFunctionValidator:function(){if(Konva.isUnminified)return function(t,e){return Konva.Util._isFunction(t)||Konva.Util.warn(Konva.Validators._formatValue(t)+' is a not valid value for "'+e+'" attribute. The value should be a function.'),t}},getNumberArrayValidator:function(){if(Konva.isUnminified)return function(t,e){return Konva.Util._isArray(t)?t.forEach(function(t){Konva.Util._isNumber(t)||Konva.Util.warn('"'+e+'" attribute has non numeric element '+t+". Make sure that all elements are numbers.")}):Konva.Util.warn(Konva.Validators._formatValue(t)+' is a not valid value for "'+e+'" attribute. The value should be a array of numbers.'),t}},getBooleanValidator:function(){if(Konva.isUnminified)return function(t,e){return!0===t||!1===t||Konva.Util.warn(Konva.Validators._formatValue(t)+' is a not valid value for "'+e+'" attribute. The value should be a boolean.'),t}}}}()},function(t,e){!function(){"use strict";var t=["arc","arcTo","beginPath","bezierCurveTo","clearRect","clip","closePath","createLinearGradient","createPattern","createRadialGradient","drawImage","fill","fillText","getImageData","createImageData","lineTo","moveTo","putImageData","quadraticCurveTo","rect","restore","rotate","save","scale","setLineDash","setTransform","stroke","strokeText","transform","translate"];Konva.Context=function(t){this.init(t)},Konva.Context.prototype={init:function(t){this.canvas=t,this._context=t._canvas.getContext("2d"),Konva.enableTrace&&(this.traceArr=[],this._enableTrace())},fillShape:function(t){t.getFillEnabled()&&this._fill(t)},strokeShape:function(t){t.getStrokeEnabled()&&this._stroke(t)},fillStrokeShape:function(t){t.getFillEnabled()&&this._fill(t),t.getStrokeEnabled()&&this._stroke(t)},getTrace:function(t){var e,i,n,a,r=this.traceArr,o=r.length,s="";for(e=0;e<o;e++)(n=(i=r[e]).method)?(a=i.args,s+=n,t?s+="()":Konva.Util._isArray(a[0])?s+="(["+a.join(",")+"])":s+="("+a.join(",")+")"):(s+=i.property,t||(s+="="+i.val)),s+=";";return s},clearTrace:function(){this.traceArr=[]},_trace:function(t){var e=this.traceArr;e.push(t),e.length>=Konva.traceArrMax&&e.shift()},reset:function(){var t=this.getCanvas().getPixelRatio();this.setTransform(1*t,0,0,1*t,0,0)},getCanvas:function(){return this.canvas},clear:function(t){var e=this.getCanvas();t?this.clearRect(t.x||0,t.y||0,t.width||0,t.height||0):this.clearRect(0,0,e.getWidth()/e.pixelRatio,e.getHeight()/e.pixelRatio)},_applyLineCap:function(t){var e=t.getLineCap();e&&this.setAttr("lineCap",e)},_applyOpacity:function(t){var e=t.getAbsoluteOpacity();1!==e&&this.setAttr("globalAlpha",e)},_applyLineJoin:function(t){var e=t.getLineJoin();e&&this.setAttr("lineJoin",e)},setAttr:function(t,e){this._context[t]=e},arc:function(){var t=arguments;this._context.arc(t[0],t[1],t[2],t[3],t[4],t[5])},beginPath:function(){this._context.beginPath()},bezierCurveTo:function(){var t=arguments;this._context.bezierCurveTo(t[0],t[1],t[2],t[3],t[4],t[5])},clearRect:function(){var t=arguments;this._context.clearRect(t[0],t[1],t[2],t[3])},clip:function(){this._context.clip()},closePath:function(){this._context.closePath()},createImageData:function(){var t=arguments;return 2===t.length?this._context.createImageData(t[0],t[1]):1===t.length?this._context.createImageData(t[0]):void 0},createLinearGradient:function(){var t=arguments;return this._context.createLinearGradient(t[0],t[1],t[2],t[3])},createPattern:function(){var t=arguments;return this._context.createPattern(t[0],t[1])},createRadialGradient:function(){var t=arguments;return this._context.createRadialGradient(t[0],t[1],t[2],t[3],t[4],t[5])},drawImage:function(){var t=arguments,e=this._context;3===t.length?e.drawImage(t[0],t[1],t[2]):5===t.length?e.drawImage(t[0],t[1],t[2],t[3],t[4]):9===t.length&&e.drawImage(t[0],t[1],t[2],t[3],t[4],t[5],t[6],t[7],t[8])},isPointInPath:function(t,e){return this._context.isPointInPath(t,e)},fill:function(){this._context.fill()},fillRect:function(t,e,i,n){this._context.fillRect(t,e,i,n)},strokeRect:function(t,e,i,n){this._context.strokeRect(t,e,i,n)},fillText:function(){var t=arguments;this._context.fillText(t[0],t[1],t[2])},measureText:function(t){return this._context.measureText(t)},getImageData:function(){var t=arguments;return this._context.getImageData(t[0],t[1],t[2],t[3])},lineTo:function(){var t=arguments;this._context.lineTo(t[0],t[1])},moveTo:function(){var t=arguments;this._context.moveTo(t[0],t[1])},rect:function(){var t=arguments;this._context.rect(t[0],t[1],t[2],t[3])},putImageData:function(){var t=arguments;this._context.putImageData(t[0],t[1],t[2])},quadraticCurveTo:function(){var t=arguments;this._context.quadraticCurveTo(t[0],t[1],t[2],t[3])},restore:function(){this._context.restore()},rotate:function(){var t=arguments;this._context.rotate(t[0])},save:function(){this._context.save()},scale:function(){var t=arguments;this._context.scale(t[0],t[1])},setLineDash:function(){var t=arguments,e=this._context;this._context.setLineDash?e.setLineDash(t[0]):"mozDash"in e?e.mozDash=t[0]:"webkitLineDash"in e&&(e.webkitLineDash=t[0])},getLineDash:function(){return this._context.getLineDash()},setTransform:function(){var t=arguments;this._context.setTransform(t[0],t[1],t[2],t[3],t[4],t[5])},stroke:function(){this._context.stroke()},strokeText:function(){var t=arguments;this._context.strokeText(t[0],t[1],t[2])},transform:function(){var t=arguments;this._context.transform(t[0],t[1],t[2],t[3],t[4],t[5])},translate:function(){var t=arguments;this._context.translate(t[0],t[1])},_enableTrace:function(){var e,i,n=this,a=t.length,r=Konva.Util._simplifyArray,o=this.setAttr,s=function(t){var e,a=n[t];n[t]=function(){return i=r(Array.prototype.slice.call(arguments,0)),e=a.apply(n,arguments),n._trace({method:t,args:i}),e}};for(e=0;e<a;e++)s(t[e]);n.setAttr=function(){o.apply(n,arguments);var t=arguments[0],e=arguments[1];"shadowOffsetX"!==t&&"shadowOffsetY"!==t&&"shadowBlur"!==t||(e/=this.canvas.getPixelRatio()),n._trace({property:t,val:e})}}},["fillStyle","strokeStyle","shadowColor","shadowBlur","shadowOffsetX","shadowOffsetY","lineCap","lineDashOffset","lineJoin","lineWidth","miterLimit","font","textAlign","textBaseline","globalAlpha","globalCompositeOperation"].forEach(function(t){Object.defineProperty(Konva.Context.prototype,t,{get:function(){return this._context[t]},set:function(e){this._context[t]=e}})}),Konva.SceneContext=function(t){Konva.Context.call(this,t)},Konva.SceneContext.prototype={_fillColor:function(t){var e=t.fill();this.setAttr("fillStyle",e),t._fillFunc(this)},_fillPattern:function(t){var e=t.getFillPatternX(),i=t.getFillPatternY(),n=t.getFillPatternScale(),a=Konva.getAngle(t.getFillPatternRotation()),r=t.getFillPatternOffset();(e||i)&&this.translate(e||0,i||0),a&&this.rotate(a),n&&this.scale(n.x,n.y),r&&this.translate(-1*r.x,-1*r.y),this.setAttr("fillStyle",this.createPattern(t.getFillPatternImage(),t.getFillPatternRepeat()||"repeat")),this.fill()},_fillLinearGradient:function(t){var e=t.getFillLinearGradientStartPoint(),i=t.getFillLinearGradientEndPoint(),n=t.getFillLinearGradientColorStops(),a=this.createLinearGradient(e.x,e.y,i.x,i.y);if(n){for(var r=0;r<n.length;r+=2)a.addColorStop(n[r],n[r+1]);this.setAttr("fillStyle",a),t._fillFunc(this)}},_fillRadialGradient:function(t){for(var e=t.getFillRadialGradientStartPoint(),i=t.getFillRadialGradientEndPoint(),n=t.getFillRadialGradientStartRadius(),a=t.getFillRadialGradientEndRadius(),r=t.getFillRadialGradientColorStops(),o=this.createRadialGradient(e.x,e.y,n,i.x,i.y,a),s=0;s<r.length;s+=2)o.addColorStop(r[s],r[s+1]);this.setAttr("fillStyle",o),this.fill()},_fill:function(t){var e=t.fill(),i=t.getFillPriority();if(e&&"color"===i)this._fillColor(t);else{var n=t.getFillPatternImage();if(n&&"pattern"===i)this._fillPattern(t);else{var a=t.getFillLinearGradientColorStops();if(a&&"linear-gradient"===i)this._fillLinearGradient(t);else{var r=t.getFillRadialGradientColorStops();r&&"radial-gradient"===i?this._fillRadialGradient(t):e?this._fillColor(t):n?this._fillPattern(t):a?this._fillLinearGradient(t):r&&this._fillRadialGradient(t)}}}},_strokeLinearGradient:function(t){var e=t.getStrokeLinearGradientStartPoint(),i=t.getStrokeLinearGradientEndPoint(),n=t.getStrokeLinearGradientColorStops(),a=this.createLinearGradient(e.x,e.y,i.x,i.y);if(n){for(var r=0;r<n.length;r+=2)a.addColorStop(n[r],n[r+1]);this.setAttr("strokeStyle",a)}},_stroke:function(t){var e=t.dash(),i=t.getStrokeScaleEnabled()||t instanceof Konva.Text;t.hasStroke()&&(i||(this.save(),this.setTransform(1,0,0,1,0,0)),this._applyLineCap(t),e&&t.dashEnabled()&&(this.setLineDash(e),this.setAttr("lineDashOffset",t.dashOffset())),this.setAttr("lineWidth",t.strokeWidth()),t.getShadowForStrokeEnabled()||this.setAttr("shadowColor","rgba(0,0,0,0)"),t.getStrokeLinearGradientColorStops()?this._strokeLinearGradient(t):this.setAttr("strokeStyle",t.stroke()),t._strokeFunc(this),i||this.restore())},_applyShadow:function(t){var e=Konva.Util,i=e.get(t.getShadowRGBA(),"black"),n=e.get(t.getShadowBlur(),5),a=e.get(t.getShadowOffset(),{x:0,y:0}),r=t.getAbsoluteScale(),o=this.canvas.getPixelRatio(),s=r.x*o,h=r.y*o;this.setAttr("shadowColor",i),this.setAttr("shadowBlur",n*Math.min(Math.abs(s),Math.abs(h))),this.setAttr("shadowOffsetX",a.x*s),this.setAttr("shadowOffsetY",a.y*h)},_applyGlobalCompositeOperation:function(t){var e=t.getGlobalCompositeOperation();"source-over"!==e&&this.setAttr("globalCompositeOperation",e)}},Konva.Util.extend(Konva.SceneContext,Konva.Context),Konva.HitContext=function(t){Konva.Context.call(this,t)},Konva.HitContext.prototype={_fill:function(t){this.save(),this.setAttr("fillStyle",t.colorKey),t._fillFuncHit(this),this.restore()},_stroke:function(t){if(t.hasStroke()&&t.strokeHitEnabled()){var e=t.getStrokeScaleEnabled()||t instanceof Konva.Text;e||(this.save(),this.setTransform(1,0,0,1,0,0)),this._applyLineCap(t),this.setAttr("lineWidth",t.strokeWidth()),this.setAttr("strokeStyle",t.colorKey),t._strokeFuncHit(this),e||this.restore()}}},Konva.Util.extend(Konva.HitContext,Konva.Context)}()},function(t,e){!function(){"use strict";var t;Konva.Canvas=function(t){this.init(t)},Konva.Canvas.prototype={init:function(e){var i=(e||{}).pixelRatio||Konva.pixelRatio||function(){if(t)return t;var e=Konva.Util.createCanvasElement().getContext("2d");return t=(Konva.window.devicePixelRatio||1)/(e.webkitBackingStorePixelRatio||e.mozBackingStorePixelRatio||e.msBackingStorePixelRatio||e.oBackingStorePixelRatio||e.backingStorePixelRatio||1)}();this.pixelRatio=i,this._canvas=Konva.Util.createCanvasElement(),this._canvas.style.padding=0,this._canvas.style.margin=0,this._canvas.style.border=0,this._canvas.style.background="transparent",this._canvas.style.position="absolute",this._canvas.style.top=0,this._canvas.style.left=0},getContext:function(){return this.context},getPixelRatio:function(){return this.pixelRatio},setPixelRatio:function(t){var e=this.pixelRatio;this.pixelRatio=t,this.setSize(this.getWidth()/e,this.getHeight()/e)},setWidth:function(t){this.width=this._canvas.width=t*this.pixelRatio,this._canvas.style.width=t+"px";var e=this.pixelRatio;this.getContext()._context.scale(e,e)},setHeight:function(t){this.height=this._canvas.height=t*this.pixelRatio,this._canvas.style.height=t+"px";var e=this.pixelRatio;this.getContext()._context.scale(e,e)},getWidth:function(){return this.width},getHeight:function(){return this.height},setSize:function(t,e){this.setWidth(t),this.setHeight(e)},toDataURL:function(t,e){try{return this._canvas.toDataURL(t,e)}catch(t){try{return this._canvas.toDataURL()}catch(t){return Konva.Util.warn("Unable to get data URL. "+t.message),""}}}},Konva.SceneCanvas=function(t){var e=t||{},i=e.width||0,n=e.height||0;Konva.Canvas.call(this,e),this.context=new Konva.SceneContext(this),this.setSize(i,n)},Konva.Util.extend(Konva.SceneCanvas,Konva.Canvas),Konva.HitCanvas=function(t){var e=t||{},i=e.width||0,n=e.height||0;Konva.Canvas.call(this,e),this.context=new Konva.HitContext(this),this.setSize(i,n),this.hitCanvas=!0},Konva.Util.extend(Konva.HitCanvas,Konva.Canvas)}()},function(t,e){!function(){"use strict";Konva.Collection=function(){var t=[].slice.call(arguments),e=t.length,i=0;for(this.length=e;i<e;i++)this[i]=t[i];return this},Konva.Collection.prototype=[],Konva.Collection.prototype.each=function(t){for(var e=0;e<this.length;e++)t(this[e],e)},Konva.Collection.prototype.toArray=function(){var t,e=[],i=this.length;for(t=0;t<i;t++)e.push(this[t]);return e},Konva.Collection.toCollection=function(t){var e,i=new Konva.Collection,n=t.length;for(e=0;e<n;e++)i.push(t[e]);return i},Konva.Collection._mapMethod=function(t){Konva.Collection.prototype[t]=function(){var e,i=this.length,n=[].slice.call(arguments);for(e=0;e<i;e++)this[e][t].apply(this[e],n);return this}},Konva.Collection.mapMethods=function(t){var e=t.prototype;for(var i in e)Konva.Collection._mapMethod(i)},Konva.Transform=function(t){this.m=t&&t.slice()||[1,0,0,1,0,0]},Konva.Transform.prototype={copy:function(){return new Konva.Transform(this.m)},point:function(t){var e=this.m;return{x:e[0]*t.x+e[2]*t.y+e[4],y:e[1]*t.x+e[3]*t.y+e[5]}},translate:function(t,e){return this.m[4]+=this.m[0]*t+this.m[2]*e,this.m[5]+=this.m[1]*t+this.m[3]*e,this},scale:function(t,e){return this.m[0]*=t,this.m[1]*=t,this.m[2]*=e,this.m[3]*=e,this},rotate:function(t){var e=Math.cos(t),i=Math.sin(t),n=this.m[0]*e+this.m[2]*i,a=this.m[1]*e+this.m[3]*i,r=this.m[0]*-i+this.m[2]*e,o=this.m[1]*-i+this.m[3]*e;return this.m[0]=n,this.m[1]=a,this.m[2]=r,this.m[3]=o,this},getTranslation:function(){return{x:this.m[4],y:this.m[5]}},skew:function(t,e){var i=this.m[0]+this.m[2]*e,n=this.m[1]+this.m[3]*e,a=this.m[2]+this.m[0]*t,r=this.m[3]+this.m[1]*t;return this.m[0]=i,this.m[1]=n,this.m[2]=a,this.m[3]=r,this},multiply:function(t){var e=this.m[0]*t.m[0]+this.m[2]*t.m[1],i=this.m[1]*t.m[0]+this.m[3]*t.m[1],n=this.m[0]*t.m[2]+this.m[2]*t.m[3],a=this.m[1]*t.m[2]+this.m[3]*t.m[3],r=this.m[0]*t.m[4]+this.m[2]*t.m[5]+this.m[4],o=this.m[1]*t.m[4]+this.m[3]*t.m[5]+this.m[5];return this.m[0]=e,this.m[1]=i,this.m[2]=n,this.m[3]=a,this.m[4]=r,this.m[5]=o,this},invert:function(){var t=1/(this.m[0]*this.m[3]-this.m[1]*this.m[2]),e=this.m[3]*t,i=-this.m[1]*t,n=-this.m[2]*t,a=this.m[0]*t,r=t*(this.m[2]*this.m[5]-this.m[3]*this.m[4]),o=t*(this.m[1]*this.m[4]-this.m[0]*this.m[5]);return this.m[0]=e,this.m[1]=i,this.m[2]=n,this.m[3]=a,this.m[4]=r,this.m[5]=o,this},getMatrix:function(){return this.m},setAbsolutePosition:function(t,e){var i=this.m[0],n=this.m[1],a=this.m[2],r=this.m[3],o=this.m[4],s=(i*(e-this.m[5])-n*(t-o))/(i*r-n*a),h=(t-o-a*s)/i;return this.translate(h,s)}};var t=Math.PI/180,e=180/Math.PI,i={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,132,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,255,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,203],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[119,128,144],slategrey:[119,128,144],snow:[255,255,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],transparent:[255,255,255,0],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,5]},n=/rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;Konva.Util={_isElement:function(t){return!(!t||1!=t.nodeType)},_isFunction:function(t){return!!(t&&t.constructor&&t.call&&t.apply)},_isObject:function(t){return!!t&&t.constructor===Object},_isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)},_isNumber:function(t){return"[object Number]"===Object.prototype.toString.call(t)&&!isNaN(t)&&isFinite(t)},_isString:function(t){return"[object String]"===Object.prototype.toString.call(t)},_isBoolean:function(t){return"[object Boolean]"===Object.prototype.toString.call(t)},isObject:function(t){return t instanceof Object},isValidSelector:function(t){if("string"!=typeof t)return!1;var e=t[0];return"#"===e||"."===e||e===e.toUpperCase()},_sign:function(t){return 0===t?0:t>0?1:-1},createCanvasElement:function(){var t=Konva.isBrowser?Konva.document.createElement("canvas"):new Konva._nodeCanvas;try{t.style=t.style||{}}catch(t){}return t},_isInDocument:function(t){for(;t=t.parentNode;)if(t==Konva.document)return!0;return!1},_simplifyArray:function(t){var e,i,n=[],a=t.length,r=Konva.Util;for(e=0;e<a;e++)i=t[e],r._isNumber(i)?i=Math.round(1e3*i)/1e3:r._isString(i)||(i=i.toString()),n.push(i);return n},_getImage:function(t,e){var i,n;t?this._isElement(t)?e(t):this._isString(t)?((i=new Konva.window.Image).onload=function(){e(i)},i.src=t):t.data?((n=Konva.Util.createCanvasElement()).width=t.width,n.height=t.height,n.getContext("2d").putImageData(t,0,0),this._getImage(n.toDataURL(),e)):e(null):e(null)},_getRGBAString:function(t){return["rgba(",t.red||0,",",t.green||0,",",t.blue||0,",",t.alpha||1,")"].join("")},_rgbToHex:function(t,e,i){return((1<<24)+(t<<16)+(e<<8)+i).toString(16).slice(1)},_hexToRgb:function(t){t=t.replace("#","");var e=parseInt(t,16);return{r:e>>16&255,g:e>>8&255,b:255&e}},getRandomColor:function(){for(var t=(16777215*Math.random()<<0).toString(16);t.length<6;)t="0"+t;return"#"+t},get:function(t,e){return void 0===t?e:t},getRGB:function(t){var e;return t in i?{r:(e=i[t])[0],g:e[1],b:e[2]}:"#"===t[0]?this._hexToRgb(t.substring(1)):"rgb("===t.substr(0,4)?(e=n.exec(t.replace(/ /g,"")),{r:parseInt(e[1],10),g:parseInt(e[2],10),b:parseInt(e[3],10)}):{r:0,g:0,b:0}},colorToRGBA:function(t){return t=t||"black",Konva.Util._namedColorToRBA(t)||Konva.Util._hex3ColorToRGBA(t)||Konva.Util._hex6ColorToRGBA(t)||Konva.Util._rgbColorToRGBA(t)||Konva.Util._rgbaColorToRGBA(t)},_namedColorToRBA:function(t){var e=i[t.toLowerCase()];return e?{r:e[0],g:e[1],b:e[2],a:1}:null},_rgbColorToRGBA:function(t){if(0===t.indexOf("rgb(")){var e=(t=t.match(/rgb\(([^)]+)\)/)[1]).split(/ *, */).map(Number);return{r:e[0],g:e[1],b:e[2],a:1}}},_rgbaColorToRGBA:function(t){if(0===t.indexOf("rgba(")){var e=(t=t.match(/rgba\(([^)]+)\)/)[1]).split(/ *, */).map(Number);return{r:e[0],g:e[1],b:e[2],a:e[3]}}},_hex6ColorToRGBA:function(t){if("#"===t[0]&&7===t.length)return{r:parseInt(t.slice(1,3),16),g:parseInt(t.slice(3,5),16),b:parseInt(t.slice(5,7),16),a:1}},_hex3ColorToRGBA:function(t){if("#"===t[0]&&4===t.length)return{r:parseInt(t[1]+t[1],16),g:parseInt(t[2]+t[2],16),b:parseInt(t[3]+t[3],16),a:1}},_merge:function(t,e){var i=this._clone(e);for(var n in t)this._isObject(t[n])?i[n]=this._merge(t[n],i[n]):i[n]=t[n];return i},trimRight:function(t){return t.replace(/\s+$/,"")},trimLeft:function(t){return t.replace(/^\s+/,"")},haveIntersection:function(t,e){return!(e.x>t.x+t.width||e.x+e.width<t.x||e.y>t.y+t.height||e.y+e.height<t.y)},cloneObject:function(t){var e={};for(var i in t)this._isObject(t[i])?e[i]=this.cloneObject(t[i]):this._isArray(t[i])?e[i]=this.cloneArray(t[i]):e[i]=t[i];return e},cloneArray:function(t){return t.slice(0)},_degToRad:function(e){return e*t},_radToDeg:function(t){return t*e},_capitalize:function(t){return t.charAt(0).toUpperCase()+t.slice(1)},throw:function(t){throw new Error("Konva error: "+t)},error:function(t){console.error("Konva error: "+t)},warn:function(t){Konva.global.console&&console.warn&&Konva.showWarnings&&console.warn("Konva warning: "+t)},extend:function(t,e){function i(){this.constructor=t}i.prototype=e.prototype;var n=t.prototype;for(var a in t.prototype=new i,n)n.hasOwnProperty(a)&&(t.prototype[a]=n[a]);t.__super__=e.prototype,t.super=e},addMethods:function(t,e){var i;for(i in e)t.prototype[i]=e[i]},_getControlPoints:function(t,e,i,n,a,r,o){var s=Math.sqrt(Math.pow(i-t,2)+Math.pow(n-e,2)),h=Math.sqrt(Math.pow(a-i,2)+Math.pow(r-n,2)),l=o*s/(s+h),c=o*h/(s+h);return[i-l*(a-t),n-l*(r-e),i+c*(a-t),n+c*(r-e)]},_expandPoints:function(t,e){var i,n,a=t.length,r=[];for(i=2;i<a-2;i+=2)n=Konva.Util._getControlPoints(t[i-2],t[i-1],t[i],t[i+1],t[i+2],t[i+3],e),r.push(n[0]),r.push(n[1]),r.push(t[i]),r.push(t[i+1]),r.push(n[2]),r.push(n[3]);return r},_removeLastLetter:function(t){return t.substring(0,t.length-1)},each:function(t,e){for(var i in t)e(i,t[i])},_inRange:function(t,e,i){return e<=t&&t<i},_getProjectionToSegment:function(t,e,i,n,a,r){var o,s,h,l=(t-i)*(t-i)+(e-n)*(e-n);if(0==l)o=t,s=e,h=(a-i)*(a-i)+(r-n)*(r-n);else{var c=((a-t)*(i-t)+(r-e)*(n-e))/l;c<0?(o=t,s=e,h=(t-a)*(t-a)+(e-r)*(e-r)):c>1?(o=i,s=n,h=(i-a)*(i-a)+(n-r)*(n-r)):h=((o=t+c*(i-t))-a)*(o-a)+((s=e+c*(n-e))-r)*(s-r)}return[o,s,h]},_getProjectionToLine:function(t,e,i){var n=Konva.Util.cloneObject(t),a=Number.MAX_VALUE;return e.forEach(function(r,o){if(i||o!==e.length-1){var s=e[(o+1)%e.length],h=Konva.Util._getProjectionToSegment(r.x,r.y,s.x,s.y,t.x,t.y),l=h[0],c=h[1],d=h[2];d<a&&(n.x=l,n.y=c,a=d)}}),n},_prepareArrayForTween:function(t,e,i){var n,a=[],r=[];if(t.length>e.length){var o=e;e=t,t=o}for(n=0;n<t.length;n+=2)a.push({x:t[n],y:t[n+1]});for(n=0;n<e.length;n+=2)r.push({x:e[n],y:e[n+1]});var s=[];return r.forEach(function(t){var e=Konva.Util._getProjectionToLine(t,a,i);s.push(e.x),s.push(e.y)}),s},_prepareToStringify:function(t){var e;for(var i in t.visitedByCircularReferenceRemoval=!0,t)if(t.hasOwnProperty(i)&&t[i]&&"object"==typeof t[i])if(e=Object.getOwnPropertyDescriptor(t,i),t[i].visitedByCircularReferenceRemoval||Konva.Util._isElement(t[i])){if(!e.configurable)return null;delete t[i]}else if(null===Konva.Util._prepareToStringify(t[i])){if(!e.configurable)return null;delete t[i]}return delete t.visitedByCircularReferenceRemoval,t}}}()},function(t,e){var i;i=function(){return this}();try{i=i||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(i=window)}t.exports=i},function(t,e,i){(function(e){

!function(){"use strict";var i=Math.PI/180,n={version:"@@version",stages:[],idCounter:0,ids:{},names:{},shapes:{},listenClickTap:!1,inDblClickWindow:!1,isBrowser:"undefined"!=typeof window&&("[object Window]"==={}.toString.call(window)||"[object global]"==={}.toString.call(window)),isUnminified:/comment/.test(function(){}),enableTrace:!1,traceArrMax:100,dblClickWindow:400,pixelRatio:void 0,dragDistance:3,angleDeg:!0,showWarnings:!0,Filters:{},isDragging:function(){var t=n.DD;return!!t&&t.isDragging},isDragReady:function(){var t=n.DD;return!!t&&!!t.node},_addId:function(t,e){e&&(this.ids[e]=t)},_removeId:function(t){void 0!==t&&delete this.ids[t]},_addName:function(t,e){e&&(this.names[e]||(this.names[e]=[]),this.names[e].push(t))},_removeName:function(t,e){if(t){var i=this.names[t];if(i){for(var n=0;n<i.length;n++)i[n]._id===e&&i.splice(n,1);0===i.length&&delete this.names[t]}}},getAngle:function(t){return this.angleDeg?t*i:t},_detectIE:function(t){var e=t.indexOf("msie ");if(e>0)return parseInt(t.substring(e+5,t.indexOf(".",e)),10);if(t.indexOf("trident/")>0){var i=t.indexOf("rv:");return parseInt(t.substring(i+3,t.indexOf(".",i)),10)}var n=t.indexOf("edge/");return n>0&&parseInt(t.substring(n+5,t.indexOf(".",n)),10)},_parseUA:function(t){var e=t.toLowerCase(),i=/(chrome)[ /]([\w.]+)/.exec(e)||/(webkit)[ /]([\w.]+)/.exec(e)||/(opera)(?:.*version|)[ /]([\w.]+)/.exec(e)||/(msie) ([\w.]+)/.exec(e)||e.indexOf("compatible")<0&&/(mozilla)(?:.*? rv:([\w.]+)|)/.exec(e)||[],a=!!t.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i),r=!!t.match(/IEMobile/i);return{browser:i[1]||"",version:i[2]||"0",isIE:n._detectIE(e),mobile:a,ieMobile:r}},UA:void 0},a=void 0!==e?e:"undefined"!=typeof window?window:"undefined"!=typeof WorkerGlobalScope?self:{};n.UA=n._parseUA(a.navigator&&a.navigator.userAgent||""),a.Konva&&console.error("Konva instance is already exist in current eviroment. Please use only one instance."),a.Konva=n,n.global=a,n.window=a,n.document=a.document,t.exports=n}()}).call(this,i(21))},function(t,e,i){"use strict";i.r(e);var n=i(0),a=i.n(n),r=i(2),o=i.n(r),s=i(1),h=i.n(s);function l(t){return(l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function c(t){for(var e=1;e<arguments.length;e++){var i=null!=arguments[e]?arguments[e]:{},n=Object.keys(i);"function"==typeof Object.getOwnPropertySymbols&&(n=n.concat(Object.getOwnPropertySymbols(i).filter(function(t){return Object.getOwnPropertyDescriptor(i,t).enumerable}))),n.forEach(function(e){p(t,e,i[e])})}return t}function d(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function u(t){return(u=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function f(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function g(t,e){return(g=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function p(t,e,i){return e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}i(8),i(7),i(6),i(5),i(4),i(3);var v=function(t){function e(t){var i,n;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var a=(i=!(n=u(e).call(this,t))||"object"!==l(n)&&"function"!=typeof n?f(this):n).generateHash("avatar_container"),r=i.generateHash("avatar_loader");return i.onFileLoad=i.onFileLoad.bind(f(i)),i.onCloseClick=i.onCloseClick.bind(f(i)),i.state={imgWidth:0,imgHeight:0,scale:1,containerId:a,loaderId:r,lastMouseY:0,showLoader:!(i.props.src||i.props.img)},i}var i,n;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&g(t,e)}(e,a.a.Component),i=e,(n=[{key:"generateHash",value:function(t){var e=function(){return Math.floor(65536*(1+Math.random())).toString(16).substring(1)};return t+"-"+e()+"-"+e()+"-"+e()}},{key:"onCloseCallback",value:function(){this.props.onClose()}},{key:"onCropCallback",value:function(t){this.props.onCrop(t)}},{key:"onFileLoadCallback",value:function(t){this.props.onFileLoad(t)}},{key:"onBeforeFileLoadCallback",value:function(t){this.props.onBeforeFileLoad(t)}},{key:"onImageLoadCallback",value:function(t){this.props.onImageLoad(t)}},{key:"componentDidMount",value:function(){var t=this;if(!this.state.showLoader){var e=this.props.img||new Image;!this.props.img&&this.props.src&&(e.src=this.props.src),this.setState({image:e},function(){if(t.image.complete)return t.init();t.image.onload=function(){t.onImageLoadCallback(t.image),t.init()}})}}},{key:"onFileLoad",value:function(t){var e=this;if(t.preventDefault(),this.onBeforeFileLoadCallback(t),t.target.value){var i=new FileReader,n=t.target.files[0];this.onFileLoadCallback(n);var a=new Image,r=this;i.onloadend=function(){e.resetOrientation(i.result,function(t){a.src=t,r.setState({image:a,file:n,showLoader:!1},function(){if(r.image.complete)return r.init();r.image.onload=function(){return r.init()}})})},i.readAsDataURL(n)}}},{key:"resetOrientation",value:function(t,e){if(!t.startsWith("data:image/jpeg"))return e(t);var i=o.a.load(t)["0th"];if(!i||!i[o.a.ImageIFD.Orientation])return e(t);var n=i[o.a.ImageIFD.Orientation];if(n<2||n>8)return e(t);var a=new Image;a.onload=function(){var t=a.width,i=a.height,r=document.createElement("canvas"),o=r.getContext("2d");switch(4<n&&n<9?(r.width=i,r.height=t):(r.width=t,r.height=i),n){case 2:o.transform(-1,0,0,1,t,0);break;case 3:o.transform(-1,0,0,-1,t,i);break;case 4:o.transform(1,0,0,-1,0,i);break;case 5:o.transform(0,1,1,0,0,0);break;case 6:o.transform(0,1,-1,0,i,0);break;case 7:o.transform(0,-1,-1,0,i,t);break;case 8:o.transform(0,-1,1,0,0,t)}o.drawImage(a,0,0),e(r.toDataURL())},a.src=t}},{key:"onCloseClick",value:function(){var t=this;this.setState({showLoader:!0},function(){return t.onCloseCallback()})}},{key:"init",value:function(){var t,e,i=this.props,n=i.height,a=i.minCropRadius,r=i.cropRadius,o=this.image.width,s=this.image.height,h=s/o,l=this.props,c=l.imageWidth,d=l.imageHeight;d&&c&&console.warn("The imageWidth and imageHeight properties can not be set together, using only imageWidth."),d&&!c?e=(t=d||s)/h:c?t=(e=c)*h||s:e=(t=n||s)/h;var u=t/s,f=Math.max(a,r||Math.min(e,t)/3);this.setState({imgWidth:e,imgHeight:t,scale:u,cropRadius:f},this.initCanvas)}},{key:"initCanvas",value:function(){var t=this,e=this.initStage(),i=this.initBackground(),n=this.initShading(),a=this.initCrop(),r=this.initCropStroke(),o=this.initResize(),s=this.initResizeIcon(),l=new h.a.Layer;l.add(i),l.add(n),l.add(r),l.add(a),l.add(o),l.add(s),e.add(l);var c=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return a.radius()-t},d=function(t){return a.x()-c(t)<0},u=function(t){return a.y()-c(t)<0},f=function(t){return a.x()+c(t)>e.width()},g=function(t){return a.y()+c(t)>e.height()},p=function(e){return c(e)>=t.minCropRadius?e:a.radius()-t.minCropRadius},v=function(t){return t+.86*a.radius()},m=function(t){return t-.5*a.radius()},y=function(t,e){o.x(v(t)-8),o.y(m(e)-8),s.x(v(t)-8),s.y(m(e)-10)},S=function(){return a.toDataURL({x:a.x()-a.radius(),y:a.y()-a.radius(),width:2*a.radius(),height:2*a.radius()})},C=function(t){var e=t>0||function(t){return!(d(t)||f(t)||g(t)||u(t))}(t)?t:0;r.radius(r.radius()-p(e)),a.radius(a.radius()-p(e)),o.fire("resize")};this.onCropCallback(S()),a.on("dragmove",function(){return a.fire("resize")}),a.on("dragend",function(){return t.onCropCallback(S())}),a.on("resize",function(){var i=d()?a.radius()+1:f()?e.width()-a.radius()-1:a.x(),n=u()?a.radius()+1:g()?e.height()-a.radius()-1:a.y();y(i,n),a.setFillPatternOffset({x:i/t.scale,y:n/t.scale}),a.x(i),r.x(i),a.y(n),r.y(n)}),a.on("mouseenter",function(){return e.container().style.cursor="move"}),a.on("mouseleave",function(){return e.container().style.cursor="default"}),a.on("dragstart",function(){return e.container().style.cursor="move"}),a.on("dragend",function(){return e.container().style.cursor="default"}),o.on("touchstart",function(e){o.on("dragmove",function(i){if("touchmove"===i.evt.type){var n=i.evt.changedTouches[0].pageY-e.evt.changedTouches[0].pageY||0;C(n*t.mobileScaleSpeed)}})}),o.on("dragmove",function(e){if("touchmove"!==e.evt.type){var i=e.evt.y,n=i?i-t.state.lastMouseY:void 0,a=e.evt.movementY||n||0;t.setState({lastMouseY:i}),C(a)}}),o.on("dragend",function(){return t.onCropCallback(S())}),o.on("resize",function(){return y(a.x(),a.y())}),o.on("mouseenter",function(){return e.container().style.cursor="nesw-resize"}),o.on("mouseleave",function(){return e.container().style.cursor="default"}),o.on("dragstart",function(i){t.setState({lastMouseY:i.evt.y}),e.container().style.cursor="nesw-resize"}),o.on("dragend",function(){return e.container().style.cursor="default"})}},{key:"initStage",value:function(){return new h.a.Stage({container:this.containerId,width:this.width,height:this.height})}},{key:"initBackground",value:function(){return new h.a.Image({x:0,y:0,width:this.width,height:this.height,image:this.image})}},{key:"initShading",value:function(){return new h.a.Rect({x:0,y:0,width:this.width,height:this.height,fill:this.shadingColor,strokeWidth:4,opacity:this.shadingOpacity})}},{key:"initCrop",value:function(){return new h.a.Circle({x:this.halfWidth,y:this.halfHeight,radius:this.cropRadius,fillPatternImage:this.image,fillPatternOffset:{x:this.halfWidth/this.scale,y:this.halfHeight/this.scale},fillPatternScale:{x:this.scale,y:this.scale},opacity:1,draggable:!0,dashEnabled:!0,dash:[10,5]})}},{key:"initCropStroke",value:function(){return new h.a.Circle({x:this.halfWidth,y:this.halfHeight,radius:this.cropRadius,stroke:this.cropColor,strokeWidth:this.lineWidth,strokeScaleEnabled:!0,dashEnabled:!0,dash:[10,5]})}},{key:"initResize",value:function(){return new h.a.Rect({x:this.halfWidth+.86*this.cropRadius-8,y:this.halfHeight+-.5*this.cropRadius-8,width:16,height:16,draggable:!0,dragBoundFunc:function(t){return{x:this.getAbsolutePosition().x,y:t.y}}})}},{key:"initResizeIcon",value:function(){return new h.a.Path({x:this.halfWidth+.86*this.cropRadius-8,y:this.halfHeight+-.5*this.cropRadius-10,data:"M47.624,0.124l12.021,9.73L44.5,24.5l10,10l14.661-15.161l9.963,12.285v-31.5H47.624z M24.5,44.5   L9.847,59.653L0,47.5V79h31.5l-12.153-9.847L34.5,54.5L24.5,44.5z",fill:this.cropColor,scale:{x:.2,y:.2}})}},{key:"render",value:function(){var t=this,e=this.props,i=e.width,n=e.height,r={display:"flex",justifyContent:"center",backgroundColor:this.backgroundColor,width:i||this.width,position:"relative"},o=this.props.label,s=c({},this.props.labelStyle,{lineHeight:(n||200)+"px"}),h=c({},this.props.borderStyle,{width:i||200,height:n||200});return a.a.createElement("div",null,this.state.showLoader?a.a.createElement("div",{style:h},a.a.createElement("input",{onChange:function(e){return t.onFileLoad(e)},name:this.loaderId,type:"file",id:this.loaderId,style:{width:.1,height:.1,opacity:0,overflow:"hidden",position:"absolute",zIndex:-1},accept:this.mimeTypes}),a.a.createElement("label",{htmlFor:this.loaderId,style:s},o)):a.a.createElement("div",{style:r},a.a.createElement("svg",{onClick:this.onCloseClick,style:{position:"absolute",zIndex:999,cursor:"pointer",left:"10px",top:"10px"},viewBox:"0 0 475.2 475.2",width:"20px",height:"20px"},a.a.createElement("g",null,a.a.createElement("path",{d:"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6    s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7    s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7    C468.6,170.8,468.6,304.4,386.5,386.5z",fill:this.closeIconColor}),a.a.createElement("path",{d:"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1    l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4    c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z",fill:this.closeIconColor}))),a.a.createElement("div",{id:this.containerId})))}},{key:"lineWidth",get:function(){return this.props.lineWidth}},{key:"containerId",get:function(){return this.state.containerId}},{key:"closeIconColor",get:function(){return this.props.closeIconColor}},{key:"cropColor",get:function(){return this.props.cropColor}},{key:"loaderId",get:function(){return this.state.loaderId}},{key:"mimeTypes",get:function(){return this.props.mimeTypes}},{key:"backgroundColor",get:function(){return this.props.backgroundColor}},{key:"shadingColor",get:function(){return this.props.shadingColor}},{key:"shadingOpacity",get:function(){return this.props.shadingOpacity}},{key:"mobileScaleSpeed",get:function(){return this.props.mobileScaleSpeed}},{key:"cropRadius",get:function(){return this.state.cropRadius}},{key:"minCropRadius",get:function(){return this.props.minCropRadius}},{key:"scale",get:function(){return this.state.scale}},{key:"width",get:function(){return this.state.imgWidth}},{key:"halfWidth",get:function(){return this.state.imgWidth/2}},{key:"height",get:function(){return this.state.imgHeight}},{key:"halfHeight",get:function(){return this.state.imgHeight/2}},{key:"image",get:function(){return this.state.image}}])&&d(i.prototype,n),e}();p(v,"defaultProps",{shadingColor:"grey",shadingOpacity:.6,cropColor:"white",closeIconColor:"white",lineWidth:4,minCropRadius:30,backgroundColor:"grey",mimeTypes:"image/jpeg,image/png",mobileScaleSpeed:.5,onClose:function(){},onCrop:function(){},onFileLoad:function(){},onImageLoad:function(){},onBeforeFileLoad:function(){},label:"Choose a file",labelStyle:{fontSize:"1.25em",fontWeight:"700",color:"black",display:"inline-block",fontFamily:"sans-serif",cursor:"pointer"},borderStyle:{border:"2px solid #979797",borderStyle:"dashed",borderRadius:"8px",textAlign:"center"}}),e.default=v}])});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1051);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return EMAIL; });
var EMAIL=/^[a-zA-Z0-9.!#$%&â€™*+/=?^_`{|}~-]+@[a-zA-Z0-9.!#$%&â€™*+/=?^_`{|}~-]+\.[a-zA-Z.]{2,5}$/; var _unused_webpack_default_export = ({EMAIL:EMAIL});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return TAB_RESUME; });

 __webpack_require__.d(__webpack_exports__, "a", function() { return TAB_DATA; });


 __webpack_require__.d(__webpack_exports__, "b", function() { return TAB_ERASE; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return TAB_GPDR; });





var TAB_RESUME='resume';var TAB_CONNECTIONS='connections';var TAB_DATA='data';var TAB_PROFILE='profile';var TAB_SETTINGS='settings';var TAB_ERASE='erase_tab';var TAB_GPDR='gpdr_tab';// export const RESUME_FIELDS = ['overview', 'category', 'entity', 'foundationStudies', 'position', 'studies', 'universities', 'universityStudies', 'residence', 'gender'];
var RESUME_FIELDS=['overview','entity','position','residence','gender'];var SETTING_MAIN_VIEW='main_view';var SETTING_CHANGE_PASSWORD_VIEW='change_password_view';var SETTING_DELETE_ACCOUNT_VIEW='delete_account_view';var MAX_VISIBLE_TAGS=7;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "n", function() { return ProfileWrapper; });







 __webpack_require__.d(__webpack_exports__, "o", function() { return TabContent; });


 __webpack_require__.d(__webpack_exports__, "c", function() { return EraseForm; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return EraseButton; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return EraseText; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return EraseSubtext; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return Overlay; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ErasePop; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return EraseButtonPop; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return EraseSubtextPop; });

 __webpack_require__.d(__webpack_exports__, "j", function() { return LevelSelector; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return Level; });







 __webpack_require__.d(__webpack_exports__, "h", function() { return GPDRWrapper; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return LogoutButton; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return UserCardWrapper; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return NoElements; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
 var __WEBPACK_IMPORTED_MODULE_2_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_3_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  .titles_profile {\n    @media (max-width: ','px) {\n      padding: 0 20px 0px;\n    }\n  }\n  .loading {\n    height: 80vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .text {\n      font-size: 2rem;\n    }\n  }\n'],['\n  .titles_profile {\n    @media (max-width: ','px) {\n      padding: 0 20px 0px;\n    }\n  }\n  .loading {\n    height: 80vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .text {\n      font-size: 2rem;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  background: ',';\n  border-radius: 3px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  transition: box-shadow .3s;\n  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n  overflow: auto;\n  padding-bottom: 20px;\n  text-align: center;\n  margin-top: 20px;\n'],['\n  background: ',';\n  border-radius: 3px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  transition: box-shadow .3s;\n  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n  overflow: auto;\n  padding-bottom: 20px;\n  text-align: center;\n  margin-top: 20px;\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 70px;\n  height: 70px;\n  background-image: url(',');\n  background-size: contain;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  margin: 20px auto;\n  border-radius: 50%;\n'],['\n  width: 70px;\n  height: 70px;\n  background-image: url(',');\n  background-size: contain;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  margin: 20px auto;\n  border-radius: 50%;\n']),_templateObject4=_taggedTemplateLiteral(['\n  && {\n    width: 70px;\n    height: 70px;\n    background-color: #999;\n    font-size: 50px;\n    margin: 20px auto;\n    text-transform: uppercase;\n  }\n'],['\n  && {\n    width: 70px;\n    height: 70px;\n    background-color: #999;\n    font-size: 50px;\n    margin: 20px auto;\n    text-transform: uppercase;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  color: #fff;\n  text-align: left;\n  padding: 10px;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 35px auto 0;\n'],['\n  color: #fff;\n  text-align: left;\n  padding: 10px;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 35px auto 0;\n']),_templateObject6=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 14px;\n  padding: 10px;\n'],['\n  color: #fff;\n  font-size: 14px;\n  padding: 10px;\n']),_templateObject7=_taggedTemplateLiteral(['\n  background-color: rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n'],['\n  background-color: rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n']),_templateObject8=_taggedTemplateLiteral(['\n  width: 33%;\n  display: inline-block;\n  text-align: center;\n  padding: 10px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n\n  @media (max-width: ','px) {\n    font-size: 14px;\n  }\n\n  ',';\n\n'],['\n  width: 33%;\n  display: inline-block;\n  text-align: center;\n  padding: 10px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n\n  @media (max-width: ','px) {\n    font-size: 14px;\n  }\n\n  ',';\n\n']),_templateObject9=_taggedTemplateLiteral(['\n  @media (max-width: ','px) {\n    margin-bottom: 10rem;\n  }\n\n  .profile_tab {\n    width: 50rem;\n    max-width: 90vw;\n    margin: 0 auto;\n  }\n'],['\n  @media (max-width: ','px) {\n    margin-bottom: 10rem;\n  }\n\n  .profile_tab {\n    width: 50rem;\n    max-width: 90vw;\n    margin: 0 auto;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  > div {\n    color: #fff;\n  }\n'],['\n  > div {\n    color: #fff;\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 65vh;\n  margin-top: 10px;\n'],['\n  width: 100%;\n  height: 65vh;\n  margin-top: 10px;\n']),_templateObject12=_taggedTemplateLiteral(['\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  img {\n    margin-top: 4rem;\n  }\n'],['\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  img {\n    margin-top: 4rem;\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  background-color: #F44336;\n  text-transform: uppercase;\n  color: #fff;\n  width: 15rem;\n  padding: 1rem;\n  font-size: 1.4rem;\n  border-radius: 2rem;\n  margin-top: 4rem;\n'],['\n  background-color: #F44336;\n  text-transform: uppercase;\n  color: #fff;\n  width: 15rem;\n  padding: 1rem;\n  font-size: 1.4rem;\n  border-radius: 2rem;\n  margin-top: 4rem;\n']),_templateObject14=_taggedTemplateLiteral(['\n  color: black;\n  font-size: 16px;\n  text-transform: uppercase;\n  font-weight: 600;\n  margin-top: 8rem;\n'],['\n  color: black;\n  font-size: 16px;\n  text-transform: uppercase;\n  font-weight: 600;\n  margin-top: 8rem;\n']),_templateObject15=_taggedTemplateLiteral(['\n  color: black;\n  font-size: 1.3rem;\n  margin-top: 2rem;\n  font-style: italic;\n  width: 80%;\n  text-align: left;\n'],['\n  color: black;\n  font-size: 1.3rem;\n  margin-top: 2rem;\n  font-style: italic;\n  width: 80%;\n  text-align: left;\n']),_templateObject16=_taggedTemplateLiteral(['\n  height: 100vh;\n  width: 100vw;\n  position: absolute;\n  background: gray;\n  z-index: 10;\n  opacity: 70%;\n'],['\n  height: 100vh;\n  width: 100vw;\n  position: absolute;\n  background: gray;\n  z-index: 10;\n  opacity: 70%;\n']),_templateObject17=_taggedTemplateLiteral(['\n  width: 33rem;\n  min-height: 25rem;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  border-radius: 1.5rem;\n  z-index: 101;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  .close_button {\n    width: 90%;\n    height: 5%;\n    font-size: 2rem;\n    margin-top: 2rem;\n    i {\n      float: right;\n      cursor: pointer;\n    }\n  }\n  button {\n    margin: 1rem 0rem;\n  }\n'],['\n  width: 33rem;\n  min-height: 25rem;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  border-radius: 1.5rem;\n  z-index: 101;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  .close_button {\n    width: 90%;\n    height: 5%;\n    font-size: 2rem;\n    margin-top: 2rem;\n    i {\n      float: right;\n      cursor: pointer;\n    }\n  }\n  button {\n    margin: 1rem 0rem;\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  background-color: #F44336;\n  text-transform: uppercase;\n  color: #fff;\n  width: 15rem;\n  padding: 1rem;\n  font-size: 1.4rem;\n  border-radius: 2rem;\n'],['\n  background-color: #F44336;\n  text-transform: uppercase;\n  color: #fff;\n  width: 15rem;\n  padding: 1rem;\n  font-size: 1.4rem;\n  border-radius: 2rem;\n']),_templateObject19=_taggedTemplateLiteral(['\n  color: black;\n  font-size: 1.3rem;\n  margin-top: 2rem;\n  width: 80%;\n'],['\n  color: black;\n  font-size: 1.3rem;\n  margin-top: 2rem;\n  width: 80%;\n']),_templateObject20=_taggedTemplateLiteral(['\n  font-family: ',';\n  padding: 4px;\n  border-radius: 10px;\n  padding-left: 8px;\n  padding-right: 8px;\n  white-space: nowrap;\n  display: inline-block;\n  vertical-align: middle;\n  color: ',';\n  background-color: #fff;\n  font-size: 14px;\n  margin-right: 5px;\n  margin-bottom: 3px;\n\n  @media (max-width: ','px) {\n    font-size: 14px;\n  }\n'],['\n  font-family: ',';\n  padding: 4px;\n  border-radius: 10px;\n  padding-left: 8px;\n  padding-right: 8px;\n  white-space: nowrap;\n  display: inline-block;\n  vertical-align: middle;\n  color: ',';\n  background-color: #fff;\n  font-size: 14px;\n  margin-right: 5px;\n  margin-bottom: 3px;\n\n  @media (max-width: ','px) {\n    font-size: 14px;\n  }\n']),_templateObject21=_taggedTemplateLiteral(['\n  width: 20vh;\n  position: relative;\n  z-index: 10;\n  background-color: #fff;\n  border-radius: 20px;\n  // left: ','px;\n  top: 20px;\n  right: 5px;\n  float: right;\n'],['\n  width: 20vh;\n  position: relative;\n  z-index: 10;\n  background-color: #fff;\n  border-radius: 20px;\n  // left: ','px;\n  top: 20px;\n  right: 5px;\n  float: right;\n']),_templateObject22=_taggedTemplateLiteral(['\n  margin: 5px;\n  background-color: ',';\n  border-radius: 20px;\n  text-align: left;\n  font-size: 14px;\n  color: ',';\n\n  i {\n    color: #fff;\n    font-size: 16px;\n    color: ',';\n    margin: 5px;\n  }\n'],['\n  margin: 5px;\n  background-color: ',';\n  border-radius: 20px;\n  text-align: left;\n  font-size: 14px;\n  color: ',';\n\n  i {\n    color: #fff;\n    font-size: 16px;\n    color: ',';\n    margin: 5px;\n  }\n']),_templateObject23=_taggedTemplateLiteral(['\n  font-family: \'helvetica neue light\';\n  font-size: 13px;\n  color: #fff;\n  margin-right: 22px;\n  margin-left: 22px;\n  text-align: left;\n  margin-bottom: 2px;\n'],['\n  font-family: \'helvetica neue light\';\n  font-size: 13px;\n  color: #fff;\n  margin-right: 22px;\n  margin-left: 22px;\n  text-align: left;\n  margin-bottom: 2px;\n']),_templateObject24=_taggedTemplateLiteral(['\n  color: #fff;\n  font-family: ',';\n  margin-bottom: 20px;\n  text-align: left;\n  margin-top: 30px;\n  padding-bottom: 3px;\n\n'],['\n  color: #fff;\n  font-family: ',';\n  margin-bottom: 20px;\n  text-align: left;\n  margin-top: 30px;\n  padding-bottom: 3px;\n\n']),_templateObject25=_taggedTemplateLiteral(['\n  font-size: 18px;\n  text-align: left;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  color: rgba(0, 0, 0, 0.54);\n  font-family: ',';\n  display: inline-block;\n  max-width: 90%;\n  vertical-align: middle;\n\n  @media (max-width: ','px) {\n    font-size: 14px;\n  }\n'],['\n  font-size: 18px;\n  text-align: left;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  color: rgba(0, 0, 0, 0.54);\n  font-family: ',';\n  display: inline-block;\n  max-width: 90%;\n  vertical-align: middle;\n\n  @media (max-width: ','px) {\n    font-size: 14px;\n  }\n']),_templateObject26=_taggedTemplateLiteral(['\n  background-color: ',';\n  font-size: 14px;\n  color: #fff;\n  text-align: left;\n  padding: 1rem;\n  margin: 20px auto -15px 0;\n  display: block;\n  font-family: ',';\n'],['\n  background-color: ',';\n  font-size: 14px;\n  color: #fff;\n  text-align: left;\n  padding: 1rem;\n  margin: 20px auto -15px 0;\n  display: block;\n  font-family: ',';\n']),_templateObject27=_taggedTemplateLiteral(['\n  padding: 1rem;\n'],['\n  padding: 1rem;\n']),_templateObject28=_taggedTemplateLiteral(['\n  width: 20px;\n  height: 20px;\n  border-radius: 50px;\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer;\n  color: #fff;\n  margin-left: 5px;\n  text-align: center;\n  line-height: 20px;\n'],['\n  width: 20px;\n  height: 20px;\n  border-radius: 50px;\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer;\n  color: #fff;\n  margin-left: 5px;\n  text-align: center;\n  line-height: 20px;\n']),_templateObject29=_taggedTemplateLiteral(['\n\n'],['\n\n']),_templateObject30=_taggedTemplateLiteral(['\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .notice {\n    color: black;\n    font-size: 14px;\n    line-height: 16px;\n  width: 90%;\n  }\n\n  && {\n    .form_question_title {\n      color: black;\n      font-size: 14px;\n      width: 90%;\n    }\n  }\n'],['\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .notice {\n    color: black;\n    font-size: 14px;\n    line-height: 16px;\n  width: 90%;\n  }\n\n  && {\n    .form_question_title {\n      color: black;\n      font-size: 14px;\n      width: 90%;\n    }\n  }\n']),_templateObject31=_taggedTemplateLiteral(['\n  border: 1px solid #F44336;\n  color: #fff;\n  background-color: #F44336;\n  position: absolute;\n  right: 0px;\n  top: calc(10px + env(safe-area-inset-top));\n  font-size: 14px;\n  border-radius: 20px;\n  padding: 5px 20px;\n  display: none;\n\n  @media (max-width: ','px) {\n    display: block;\n  }\n'],['\n  border: 1px solid #F44336;\n  color: #fff;\n  background-color: #F44336;\n  position: absolute;\n  right: 0px;\n  top: calc(10px + env(safe-area-inset-top));\n  font-size: 14px;\n  border-radius: 20px;\n  padding: 5px 20px;\n  display: none;\n\n  @media (max-width: ','px) {\n    display: block;\n  }\n']),_templateObject32=_taggedTemplateLiteral(['\n  height: 100%;\n  overflow: scroll;\n  width: 100%;\n\n  .header {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    min-height: 15rem;\n\n    .username {\n      font-size: 1.6rem;\n      font-weight: bold;\n      font-family: ',';\n      color: #000;\n      margin-top: 1rem;\n      margin-left: 1rem;\n    }\n\n    .avatar {\n      position: relative;\n      margin: 1rem;\n    }\n\n    .overview {\n      font-size: 1.4rem;\n      line-height: 1.9rem;\n      width: 80%;\n      overflow: auto;\n      background: white;\n      padding: 1.5rem;\n      border-radius: 2rem;\n      display: flex;\n      flex-direction: column;\n      position: relative;\n      margin-left: 5rem;\n      margin-top: -4rem;\n      box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n      .close {\n        place-self: flex-end;\n        color: #2680EB;\n        cursor: pointer;\n      }\n      .input_text {\n        width: 100%;\n      }\n    }\n    .overview_empty {\n      font-size: 1.4rem;\n      line-height: 1.9rem;\n      overflow: auto;\n      background: white;\n      padding: 1.5rem;\n      border-radius: 2rem;\n      display: flex;\n      flex-direction: column;\n      position: absolute;\n      top: 4rem;\n      left: 6rem;\n      color: #2680EB;\n      box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n      cursor: pointer;\n    }\n    .overview-content {\n      display: flex;\n      justify-content: space-between;\n      margin-top: 0.5rem;\n      .text {\n        font-size: 1rem;\n        color: #2680EB;\n        cursor: pointer;\n      }\n    }\n  }\n\n  .tab_content {\n    padding: 0rem;\n    overflow: auto;\n\n    .separator {\n      display: flex;\n      align-items: center;\n      background-color: #f2f2f2;\n      color: #5E5E5E;\n      font-size: 1.6rem;\n      font-weight:  ',';\n      font-family: ',';\n      background: attr(data-color);\n      width: calc(100% - 4rem);\n      margin: 2rem auto 1rem;\n      padding: 1.5rem;\n      border-radius: 0.8rem;\n\n      img {\n        height: 2rem;\n        margin-right: 0.5rem;\n      }\n      &.answer{\n        color: white;\n      }\n    }\n\n    .title {\n      color: #5E5E5E;\n      font-size: 1.3rem;\n      margin-bottom: 1rem;\n      margin-top: 2rem;\n    }\n\n    .subsection {\n      margin: 2rem 3rem;\n    }\n\n    .step_name {\n      font-size: 1.6rem;\n      font-family: ',';\n      color: ',';\n      margin: 0rem auto;\n      width: calc(100% - 7rem);\n    }\n\n    .subsection_content{\n      display: flex;\n      overflow-x: scroll;\n      height: 6vh;\n      align-items: center;\n      -ms-overflow-style: none;\n      scrollbar-width: none;\n      margin: 1rem auto 0rem;\n      width: calc(100% - 7rem);\n    }\n\n    .subsection_content::-webkit-scrollbar{\n      display: none;\n    }\n\n    .container_tags {\n      background-color: #E8E8E8;\n      border-radius: 2rem;\n      padding: 1rem 1rem 0;\n      margin: 1rem;\n\n      .description_tag {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 1rem;\n        margin-bottom: 1rem;\n        font-size: 1.4rem;\n        color: #000;\n      }\n    }\n  }\n'],['\n  height: 100%;\n  overflow: scroll;\n  width: 100%;\n\n  .header {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    min-height: 15rem;\n\n    .username {\n      font-size: 1.6rem;\n      font-weight: bold;\n      font-family: ',';\n      color: #000;\n      margin-top: 1rem;\n      margin-left: 1rem;\n    }\n\n    .avatar {\n      position: relative;\n      margin: 1rem;\n    }\n\n    .overview {\n      font-size: 1.4rem;\n      line-height: 1.9rem;\n      width: 80%;\n      overflow: auto;\n      background: white;\n      padding: 1.5rem;\n      border-radius: 2rem;\n      display: flex;\n      flex-direction: column;\n      position: relative;\n      margin-left: 5rem;\n      margin-top: -4rem;\n      box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n      .close {\n        place-self: flex-end;\n        color: #2680EB;\n        cursor: pointer;\n      }\n      .input_text {\n        width: 100%;\n      }\n    }\n    .overview_empty {\n      font-size: 1.4rem;\n      line-height: 1.9rem;\n      overflow: auto;\n      background: white;\n      padding: 1.5rem;\n      border-radius: 2rem;\n      display: flex;\n      flex-direction: column;\n      position: absolute;\n      top: 4rem;\n      left: 6rem;\n      color: #2680EB;\n      box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n      cursor: pointer;\n    }\n    .overview-content {\n      display: flex;\n      justify-content: space-between;\n      margin-top: 0.5rem;\n      .text {\n        font-size: 1rem;\n        color: #2680EB;\n        cursor: pointer;\n      }\n    }\n  }\n\n  .tab_content {\n    padding: 0rem;\n    overflow: auto;\n\n    .separator {\n      display: flex;\n      align-items: center;\n      background-color: #f2f2f2;\n      color: #5E5E5E;\n      font-size: 1.6rem;\n      font-weight:  ',';\n      font-family: ',';\n      background: attr(data-color);\n      width: calc(100% - 4rem);\n      margin: 2rem auto 1rem;\n      padding: 1.5rem;\n      border-radius: 0.8rem;\n\n      img {\n        height: 2rem;\n        margin-right: 0.5rem;\n      }\n      &.answer{\n        color: white;\n      }\n    }\n\n    .title {\n      color: #5E5E5E;\n      font-size: 1.3rem;\n      margin-bottom: 1rem;\n      margin-top: 2rem;\n    }\n\n    .subsection {\n      margin: 2rem 3rem;\n    }\n\n    .step_name {\n      font-size: 1.6rem;\n      font-family: ',';\n      color: ',';\n      margin: 0rem auto;\n      width: calc(100% - 7rem);\n    }\n\n    .subsection_content{\n      display: flex;\n      overflow-x: scroll;\n      height: 6vh;\n      align-items: center;\n      -ms-overflow-style: none;\n      scrollbar-width: none;\n      margin: 1rem auto 0rem;\n      width: calc(100% - 7rem);\n    }\n\n    .subsection_content::-webkit-scrollbar{\n      display: none;\n    }\n\n    .container_tags {\n      background-color: #E8E8E8;\n      border-radius: 2rem;\n      padding: 1rem 1rem 0;\n      margin: 1rem;\n\n      .description_tag {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 1rem;\n        margin-bottom: 1rem;\n        font-size: 1.4rem;\n        color: #000;\n      }\n    }\n  }\n']),_templateObject33=_taggedTemplateLiteral(['\n  width: calc(100% - 4rem);\n  height: 30rem;\n  padding: 2rem;\n  margin: 2rem auto;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n\n  .nocontent {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    img {\n      width: 20rem;\n    }\n\n    .text {\n      margin-top: 1rem;\n      font-size: 1.6rem;\n      text-align: center;\n      color: black;\n    }\n  }\n'],['\n  width: calc(100% - 4rem);\n  height: 30rem;\n  padding: 2rem;\n  margin: 2rem auto;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n\n  .nocontent {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    img {\n      width: 20rem;\n    }\n\n    .text {\n      margin-top: 1rem;\n      font-size: 1.6rem;\n      text-align: center;\n      color: black;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProfileWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var Card=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.color;});var Avatar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,function(props){return props.src;});var AvatarText=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject4);var UserName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var Overview=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var ProfileTabs=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7);var ProfileTab=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],function(props){return props.active?'border-bottom: 2px solid #fff':'';});var TabContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var ProfileContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10);var DashboardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11);var EraseForm=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12);var EraseButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13);var EraseText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject14);var EraseSubtext=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject15);var Overlay=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16);var ErasePop=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17);var EraseButtonPop=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18);var EraseSubtextPop=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject19);// Privacy element
var PrivacyTag=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject20,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var LevelSelector=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject21,function(props){return props.left;});var Level=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject22,function(props){return props.selected?'#FFEB3B':'#ffffff';},function(props){return props.color;},function(props){return props.color;});var Subtitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject23);var ProfileSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject24,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily);var ProfileSectionTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject25,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var NarrativeTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject26,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily);var NarrativeQuestions=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject27);var ProfilePrivacyIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject28);var RelationsList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject29);var GPDRWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject30);var LogoutButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject31,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var UserCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject32,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["b" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["b" ].regularWeight,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["b" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].semiBoldFamily,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ]);var NoElements=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject33);

 }),

 (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(453);

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;

 }),

 (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
});

var _utils = __webpack_require__(1087);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "g", function() { return SearcherModal; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return CloseIcon; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return SearchInput; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return ResultsWrapper; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ResultWrapper; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return UserAvatar; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return UserName; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return Loading; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return LoadMoreBtn; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__ = __webpack_require__(68);
 var __WEBPACK_IMPORTED_MODULE_3_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_loader_svg__ = __webpack_require__(1095);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_loader_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_loader_svg__);
var _templateObject=_taggedTemplateLiteral(['\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n'],['\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  animation: ',' 0.2s linear 1;\n'],['\n  animation: ',' 0.2s linear 1;\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: fixed;\n  background-color: ',';\n  width: 100vw;\n  height: 100vh;\n  top: 0px;\n  left: 0px;\n  z-index: 1499;\n  padding: 10px;\n  ','\n'],['\n  position: fixed;\n  background-color: ',';\n  width: 100vw;\n  height: 100vh;\n  top: 0px;\n  left: 0px;\n  z-index: 1499;\n  padding: 10px;\n  ','\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  text-align: center;\n  line-height: 20px;\n  background-color: #fff;\n  border-radius: 50%;\n  padding-top: 1px;\n  \n  i {\n    font-size: 12px;\n    color: #4d4d4d;\n  }  \n'],['\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  text-align: center;\n  line-height: 20px;\n  background-color: #fff;\n  border-radius: 50%;\n  padding-top: 1px;\n  \n  i {\n    font-size: 12px;\n    color: #4d4d4d;\n  }  \n']),_templateObject5=_taggedTemplateLiteral(['\n  && {\n    width: calc(100% - 4em);\n    margin: 20px 2em 20px;\n    border: 0px;\n\n    > div::before {\n      border-bottom: 1px solid #fff !important;\n    }\n\n    > div::after {\n      border-bottom: 2px solid #fff !important;\n    }\n\n    input {\n      background-color: transparent;\n      font-family: \'helvetica neue light\';\n      color: ',';\n      font-size: 18px;\n      padding: 10px;\n      border-radius: 3px;\n    }    \n  }\n'],['\n  && {\n    width: calc(100% - 4em);\n    margin: 20px 2em 20px;\n    border: 0px;\n\n    > div::before {\n      border-bottom: 1px solid #fff !important;\n    }\n\n    > div::after {\n      border-bottom: 2px solid #fff !important;\n    }\n\n    input {\n      background-color: transparent;\n      font-family: \'helvetica neue light\';\n      color: ',';\n      font-size: 18px;\n      padding: 10px;\n      border-radius: 3px;\n    }    \n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  margin: 20px;\n  max-height: 70vh;\n  overflow: auto;\n'],['\n  margin: 20px;\n  max-height: 70vh;\n  overflow: auto;\n']),_templateObject7=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: 95px;\n  height: 110px;\n  vertical-align: top;\n  margin: 0 5px 5px 0;\n'],['\n  display: inline-block;\n  width: 95px;\n  height: 110px;\n  vertical-align: top;\n  margin: 0 5px 5px 0;\n']),_templateObject8=_taggedTemplateLiteral(['\n   && {\n    width: 60px;\n    height: 60px;\n    display: inline-block;\n\n    &.text-avatar {\n      font-size: 30px;\n      padding-top: 13px;\n    }\n   }\n'],['\n   && {\n    width: 60px;\n    height: 60px;\n    display: inline-block;\n\n    &.text-avatar {\n      font-size: 30px;\n      padding-top: 13px;\n    }\n   }\n']),_templateObject9=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 14px;\n  line-height: 14px;\n  margin-top: 5px;\n  height: 30px;\n  overflow: hidden;\n'],['\n  color: ',';\n  font-size: 14px;\n  line-height: 14px;\n  margin-top: 5px;\n  height: 30px;\n  overflow: hidden;\n']),_templateObject10=_taggedTemplateLiteral(['\n  width: 24rem;\n  height: 24rem;\n  background-size: cover;\n  background-image: url(',');\n  margin: 0 auto;\n'],['\n  width: 24rem;\n  height: 24rem;\n  background-size: cover;\n  background-image: url(',');\n  margin: 0 auto;\n']),_templateObject11=_taggedTemplateLiteral(['\n  width: 120px;\n  margin: 20px auto;\n  display: block;\n  color: ',';\n  border: 2px solid ',';\n  text-align: center;\n  padding: 10px;\n  font-size: 16px;\n  background: transparent;\n  font-weight: 600;\n'],['\n  width: 120px;\n  margin: 20px auto;\n  display: block;\n  color: ',';\n  border: 2px solid ',';\n  text-align: center;\n  padding: 10px;\n  font-size: 16px;\n  background: transparent;\n  font-weight: 600;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var fadeIn=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject);var fadeEffect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject2,fadeIn);var SearcherModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,function(props){return props.color;},fadeEffect);var CloseIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var SearchInput=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__["default"])(_templateObject5,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["k" ]);var ResultsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var ResultWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7);var UserAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject8);var UserName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["k" ]);var Loading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_4_assets_images_loader_svg___default.a);var LoadMoreBtn=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject11,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["k" ],__WEBPACK_IMPORTED_MODULE_3_constants_colors__["k" ]);

 }),

 (function(module, exports, __webpack_require__) {

(function(global) {


var FUNC_ERROR_TEXT = 'Expected a function';


var NAN = 0 / 0;


var symbolTag = '[object Symbol]';


var reTrim = /^\s+|\s+$/g;


var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;


var reIsBinary = /^0b[01]+$/i;


var reIsOctal = /^0o[0-7]+$/i;


var freeParseInt = parseInt;


var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;


var freeSelf = typeof self == 'object' && self && self.Object === Object && self;


var root = freeGlobal || freeSelf || Function('return this')();


var objectProto = Object.prototype;


var objectToString = objectProto.toString;


var nativeMax = Math.max,
    nativeMin = Math.min;


var now = function() {
  return root.Date.now();
};


function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}


function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}


function isObjectLike(value) {
  return !!value && typeof value == 'object';
}


function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}


function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

}.call(exports, __webpack_require__(51)))

 }),

 (function(module, exports) {


function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}


function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}


function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return ConnectionsSection; });

 __webpack_require__.d(__webpack_exports__, "a", function() { return Connection; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ConnectionAvatar; });

 __webpack_require__.d(__webpack_exports__, "c", function() { return ConnectionName; });















 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_InputBase__ = __webpack_require__(113);
 var __WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  .tabs {\n    padding-top: 1rem;\n    background-color: #fff;\n\n    @media (max-width: ','px) {\n      position: sticky;\n      top: 0;\n      border-bottom: 1px solid #eee;\n      z-index:10;\n    }\n  }\n\n  .tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .tabs {\n  white-space: nowrap;\n  display: grid;\n  border-bottom: 1px solid #e9e9e9;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  overflow: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &.flex {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n  }\n\n  .tab {\n    text-align: center;\n    cursor: pointer;\n  }\n\n  &.gray {\n    background-color: #D9D9D9;\n\n    .tab {\n      color: #000;\n      &.selected {\n        border-bottom: 2px solid #000;\n      }\n    }\n  }\n}\n'],['\n  .tabs {\n    padding-top: 1rem;\n    background-color: #fff;\n\n    @media (max-width: ','px) {\n      position: sticky;\n      top: 0;\n      border-bottom: 1px solid #eee;\n      z-index:10;\n    }\n  }\n\n  .tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .tabs {\n  white-space: nowrap;\n  display: grid;\n  border-bottom: 1px solid #e9e9e9;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  overflow: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &.flex {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n  }\n\n  .tab {\n    text-align: center;\n    cursor: pointer;\n  }\n\n  &.gray {\n    background-color: #D9D9D9;\n\n    .tab {\n      color: #000;\n      &.selected {\n        border-bottom: 2px solid #000;\n      }\n    }\n  }\n}\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  .slide {\n    background: none !important;\n  }\n'],['\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  .slide {\n    background: none !important;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: 30%;\n  height: 110px;\n  vertical-align: top;\n  margin: 0 5px 5px 0;\n  text-align: center;\n'],['\n  display: inline-block;\n  width: 30%;\n  height: 110px;\n  vertical-align: top;\n  margin: 0 5px 5px 0;\n  text-align: center;\n']),_templateObject4=_taggedTemplateLiteral(['\n   && {\n    width: 60px;\n    height: 60px;\n    display: inline-block;\n    margin: 0 auto;\n\n    &.text-avatar {\n      font-size: 30px;\n      padding-top: 13px;\n      text-align: center;\n      text-transform: uppercase;\n    }\n   }\n'],['\n   && {\n    width: 60px;\n    height: 60px;\n    display: inline-block;\n    margin: 0 auto;\n\n    &.text-avatar {\n      font-size: 30px;\n      padding-top: 13px;\n      text-align: center;\n      text-transform: uppercase;\n    }\n   }\n']),_templateObject5=_taggedTemplateLiteral(['\n  margin-left: -5vw;\n  padding-top: 10px;\n'],['\n  margin-left: -5vw;\n  padding-top: 10px;\n']),_templateObject6=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 14px;\n  line-height: 14px;\n  margin-top: 5px;\n  height: 30px;\n  overflow: hidden;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n'],['\n  color: ',';\n  font-size: 14px;\n  line-height: 14px;\n  margin-top: 5px;\n  height: 30px;\n  overflow: hidden;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n']),_templateObject7=_taggedTemplateLiteral(['\n  text-transform: uppercase;\n  color: #fff;\n  font-family: \'helvetica neue\';\n  font-size: 11px;\n  margin-bottom: 20px;\n  text-align: left;\n  margin-top: 30px;\n  border-bottom: 1px solid #fff;\n  padding-bottom: 3px;\n'],['\n  text-transform: uppercase;\n  color: #fff;\n  font-family: \'helvetica neue\';\n  font-size: 11px;\n  margin-bottom: 20px;\n  text-align: left;\n  margin-top: 30px;\n  border-bottom: 1px solid #fff;\n  padding-bottom: 3px;\n']),_templateObject8=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 16px;\n  margin-top: 25px;\n  text-align: center;\n'],['\n  color: ',';\n  font-size: 16px;\n  margin-top: 25px;\n  text-align: center;\n']),_templateObject9=_taggedTemplateLiteral(['\n  padding: 0px 20px;\n'],['\n  padding: 0px 20px;\n']),_templateObject10=_taggedTemplateLiteral(['\n  display: block;\n  margin: 10px auto;\n  border-radius: 20px;\n  text-align: center;\n  padding: 7px;\n  font-size: 14px;\n  width: 140px;\n  border: 1px solid #aaa;\n  color: #666;\n  background-color: #fff;\n'],['\n  display: block;\n  margin: 10px auto;\n  border-radius: 20px;\n  text-align: center;\n  padding: 7px;\n  font-size: 14px;\n  width: 140px;\n  border: 1px solid #aaa;\n  color: #666;\n  background-color: #fff;\n']),_templateObject11=_taggedTemplateLiteral(['\n  display: block;\n  margin: 10px auto;\n  border-radius: 20px;\n  text-align: center;\n  padding: 7px;\n  font-size: 14px;\n  width: 140px;\n  border: 1px solid #F44336;\n  color: #fff;\n  background-color: #F44336;\n'],['\n  display: block;\n  margin: 10px auto;\n  border-radius: 20px;\n  text-align: center;\n  padding: 7px;\n  font-size: 14px;\n  width: 140px;\n  border: 1px solid #F44336;\n  color: #fff;\n  background-color: #F44336;\n']),_templateObject12=_taggedTemplateLiteral(['\n  background-color: rgba(0, 0, 0, 0.05);\n  white-space: nowrap;\n'],['\n  background-color: rgba(0, 0, 0, 0.05);\n  white-space: nowrap;\n']),_templateObject13=_taggedTemplateLiteral(['\n  width: calc(100% / 4);\n  display: inline-block;\n  text-align: center;\n  padding: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n\n  ',';\n'],['\n  width: calc(100% / 4);\n  display: inline-block;\n  text-align: center;\n  padding: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n\n  ',';\n']),_templateObject14=_taggedTemplateLiteral(['\n  width: 90%;\n  margin: 0 auto;\n'],['\n  width: 90%;\n  margin: 0 auto;\n']),_templateObject15=_taggedTemplateLiteral(['\n  width: 89%;\n  margin: 0 auto;\n  display: flex;\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 0px 10px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  height: 30px;\n  img {\n    width: 16px;\n  }\n'],['\n  width: 89%;\n  margin: 0 auto;\n  display: flex;\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 0px 10px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  height: 30px;\n  img {\n    width: 16px;\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  && {\n    flex: 1;\n    height: 30px;\n    input {\n      color: #4d4d4d;\n      font-family: \'helvetica neue light\';\n      font-size: 14px;\n    }\n  }\n'],['\n  && {\n    flex: 1;\n    height: 30px;\n    input {\n      color: #4d4d4d;\n      font-family: \'helvetica neue light\';\n      font-size: 14px;\n    }\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  padding: 0px 20px 0px;\n  width: 100%;\n'],['\n  padding: 0px 20px 0px;\n  width: 100%;\n']),_templateObject18=_taggedTemplateLiteral(['\n  background-color: #F44336;\n  margin-top: 20px;\n  font-size: 16px;\n  text-align: center;\n  font-family: \'helvetica neue strong\';\n  color: #fff;\n  padding: 10px;\n'],['\n  background-color: #F44336;\n  margin-top: 20px;\n  font-size: 16px;\n  text-align: center;\n  font-family: \'helvetica neue strong\';\n  color: #fff;\n  padding: 10px;\n']),_templateObject19=_taggedTemplateLiteral(['\n  text-align: center;\n  color: #fff;\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 50px;\n'],['\n  text-align: center;\n  color: #fff;\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 50px;\n']),_templateObject20=_taggedTemplateLiteral(['\n  font-family: \'helvetica neue light\';\n  font-size: 13px;\n  color: #fff;\n  margin-right: 22px;\n  margin-left: 22px;\n  text-align: left;\n  margin-bottom: 2px;\n'],['\n  font-family: \'helvetica neue light\';\n  font-size: 13px;\n  color: #fff;\n  margin-right: 22px;\n  margin-left: 22px;\n  text-align: left;\n  margin-bottom: 2px;\n']),_templateObject21=_taggedTemplateLiteral(['\n  height: 70vh;\n  position: relative;\n'],['\n  height: 70vh;\n  position: relative;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ConnectionsSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var ConnectionsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var Connection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var ConnectionAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject4);var FeedbackLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var ConnectionName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["k" ]);var ProfileSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7);var NoRelations=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["k" ]);var ConnectionsPadding=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);var ButtonViewMore=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject10);var ButtonClose=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject11);var ConnectionsTabs=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12);var ConnectionsTab=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13,function(props){return props.active?'border-bottom: 2px solid #fff':'';});var TabContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject14);var Searcher=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject15);var SearcherInput=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_InputBase__["a" ])(_templateObject16);var FormWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17);var ErrorLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18);var NoUsersMsg=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject19);var Subtitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject20);var UsersCards=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject21);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1140);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return AvatarsCollisionWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarCollisionBubble; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['{\n  0% {\n    transform: translatey(0px) rotate(20deg);\n  }\n  50% {\n    transform: translatey(-10px) rotate(20deg);\n  }\n  100% {\n  transform: translatey(0px) rotate(20deg);\n  }\n}'],['{\n  0% {\n    transform: translatey(0px) rotate(20deg);\n  }\n  50% {\n    transform: translatey(-10px) rotate(20deg);\n  }\n  100% {\n  transform: translatey(0px) rotate(20deg);\n  }\n}']),_templateObject2=_taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  .avatar_bubble {\n    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.16);\n    transform: rotate(20deg);\n    animation: ',' 6s ease-in-out infinite;\n  }\n'],['\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  .avatar_bubble {\n    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.16);\n    transform: rotate(20deg);\n    animation: ',' 6s ease-in-out infinite;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: absolute;\n  top: ','px;\n  left: ','px;\n  z-index: ',';\n'],['\n  position: absolute;\n  top: ','px;\n  left: ','px;\n  z-index: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var float=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject);var AvatarsCollisionWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,float);var AvatarCollisionBubble=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,function(props){return props.top;},function(props){return props.left;},function(props){return props.zIndex;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1153);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1155);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

 }),

 (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

 }),

 (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(453);

var assertThisInitialized = __webpack_require__(466);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

 }),

 (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

 }),

 (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

 }),

 (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1161);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
 var __WEBPACK_IMPORTED_MODULE_0__colorManipulator__ = __webpack_require__(129);
 __webpack_require__.d(__webpack_exports__, "hexToRgb", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["g"]; });
 __webpack_require__.d(__webpack_exports__, "rgbToHex", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["k"]; });
 __webpack_require__.d(__webpack_exports__, "hslToRgb", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["h"]; });
 __webpack_require__.d(__webpack_exports__, "decomposeColor", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["b"]; });
 __webpack_require__.d(__webpack_exports__, "recomposeColor", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["j"]; });
 __webpack_require__.d(__webpack_exports__, "getContrastRatio", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["e"]; });
 __webpack_require__.d(__webpack_exports__, "getLuminance", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["f"]; });
 __webpack_require__.d(__webpack_exports__, "emphasize", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["c"]; });
 __webpack_require__.d(__webpack_exports__, "fade", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["d"]; });
 __webpack_require__.d(__webpack_exports__, "darken", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["a"]; });
 __webpack_require__.d(__webpack_exports__, "lighten", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["i"]; });
 var __WEBPACK_IMPORTED_MODULE_1__createMuiTheme__ = __webpack_require__(223);
 __webpack_require__.d(__webpack_exports__, "createMuiTheme", function() { return __WEBPACK_IMPORTED_MODULE_1__createMuiTheme__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__createMuiStrictModeTheme__ = __webpack_require__(1166);
 __webpack_require__.d(__webpack_exports__, "unstable_createMuiStrictModeTheme", function() { return __WEBPACK_IMPORTED_MODULE_2__createMuiStrictModeTheme__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__createStyles__ = __webpack_require__(1167);
 __webpack_require__.d(__webpack_exports__, "createStyles", function() { return __WEBPACK_IMPORTED_MODULE_3__createStyles__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__makeStyles__ = __webpack_require__(1168);
 __webpack_require__.d(__webpack_exports__, "makeStyles", function() { return __WEBPACK_IMPORTED_MODULE_4__makeStyles__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__responsiveFontSizes__ = __webpack_require__(1169);
 __webpack_require__.d(__webpack_exports__, "responsiveFontSizes", function() { return __WEBPACK_IMPORTED_MODULE_5__responsiveFontSizes__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__styled__ = __webpack_require__(1171);
 __webpack_require__.d(__webpack_exports__, "styled", function() { return __WEBPACK_IMPORTED_MODULE_6__styled__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__transitions__ = __webpack_require__(131);
 __webpack_require__.d(__webpack_exports__, "easing", function() { return __WEBPACK_IMPORTED_MODULE_7__transitions__["c"]; });
 __webpack_require__.d(__webpack_exports__, "duration", function() { return __WEBPACK_IMPORTED_MODULE_7__transitions__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_8__useTheme__ = __webpack_require__(84);
 __webpack_require__.d(__webpack_exports__, "useTheme", function() { return __WEBPACK_IMPORTED_MODULE_8__useTheme__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_9__withStyles__ = __webpack_require__(15);
 __webpack_require__.d(__webpack_exports__, "withStyles", function() { return __WEBPACK_IMPORTED_MODULE_9__withStyles__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_10__withTheme__ = __webpack_require__(1172);
 __webpack_require__.d(__webpack_exports__, "withTheme", function() { return __WEBPACK_IMPORTED_MODULE_10__withTheme__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_11__material_ui_styles__ = __webpack_require__(53);
 __webpack_require__.d(__webpack_exports__, "createGenerateClassName", function() { return __WEBPACK_IMPORTED_MODULE_11__material_ui_styles__["d"]; });
 __webpack_require__.d(__webpack_exports__, "jssPreset", function() { return __WEBPACK_IMPORTED_MODULE_11__material_ui_styles__["g"]; });
 __webpack_require__.d(__webpack_exports__, "ServerStyleSheets", function() { return __WEBPACK_IMPORTED_MODULE_11__material_ui_styles__["a"]; });
 __webpack_require__.d(__webpack_exports__, "StylesProvider", function() { return __WEBPACK_IMPORTED_MODULE_11__material_ui_styles__["b"]; });
 __webpack_require__.d(__webpack_exports__, "MuiThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_11__material_ui_styles__["c"]; });
 __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_11__material_ui_styles__["c"]; });

 // eslint-disable-next-line camelcase












 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1176);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return Bubble; });

 __webpack_require__.d(__webpack_exports__, "d", function() { return Text; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return FacesWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return BubblesWrapper; });




 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  width: calc(100% / 3 - 20px);\n  margin: 10px;\n  position: relative;\n  text-align: center;\n\n  .bubble_icon {\n    position: absolute;\n    left: calc(50% + 2rem);\n    top: 6.4rem;\n  }\n\n  @media (min-width: 800px) {\n    width: 100px;\n  }\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  width: calc(100% / 3 - 20px);\n  margin: 10px;\n  position: relative;\n  text-align: center;\n\n  .bubble_icon {\n    position: absolute;\n    left: calc(50% + 2rem);\n    top: 6.4rem;\n  }\n\n  @media (min-width: 800px) {\n    width: 100px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 90px;\n  height: 90px;\n  max-width: 90px;\n  max-height: 90px;\n  line-height: 70px;\n  border-radius: 50%;\n  background-color: #fff;\n  background-image: ',';\n  background-size: cover;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  margin: 0px auto 10px;\n  font-size: 32px;\n  text-align: center;\n  box-shadow: ',';\n  transform: scale(',');\n  opacity: ',';\n  transition: all 0.3s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'],['\n  width: 90px;\n  height: 90px;\n  max-width: 90px;\n  max-height: 90px;\n  line-height: 70px;\n  border-radius: 50%;\n  background-color: #fff;\n  background-image: ',';\n  background-size: cover;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  margin: 0px auto 10px;\n  font-size: 32px;\n  text-align: center;\n  box-shadow: ',';\n  transform: scale(',');\n  opacity: ',';\n  transition: all 0.3s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),_templateObject3=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 12px;\n  height: 26px;\n  overflow: hidden;\n  text-align: center;\n  margin-bottom: 2rem;\n  margin-top: 1rem;\n  line-height: 1.3rem;\n'],['\n  color: ',';\n  font-size: 12px;\n  height: 26px;\n  overflow: hidden;\n  text-align: center;\n  margin-bottom: 2rem;\n  margin-top: 1rem;\n  line-height: 1.3rem;\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 100%;\n  overflow-x: ',';\n  position: relative;\n  text-align: center;\n'],['\n  width: 100%;\n  max-width: 100%;\n  overflow-x: ',';\n  position: relative;\n  text-align: center;\n']),_templateObject5=_taggedTemplateLiteral(['\n  max-height: 100%;\n  width: 100%;\n  margin: 0 auto;\n  text-align: left;\n  position: relative;\n  display: flex;\n'],['\n  max-height: 100%;\n  width: 100%;\n  margin: 0 auto;\n  text-align: left;\n  position: relative;\n  display: flex;\n']),_templateObject6=_taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  border-radius: 4px;\n  background-color: ',';\n  z-index: 10;\n'],['\n  position: relative;\n  width: 100%;\n  border-radius: 4px;\n  background-color: ',';\n  z-index: 10;\n']),_templateObject7=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  color: #4d4d4d;\n  font-size: 14px;\n  cursor: pointer;\n'],['\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  color: #4d4d4d;\n  font-size: 14px;\n  cursor: pointer;\n']),_templateObject8=_taggedTemplateLiteral(['\n  position: relative;\n  margin: 0 auto 0px;\n  border-left: 0;\n  border-right: 0;\n\n  svg {\n    background-color: transparent !important;\n  }\n'],['\n  position: relative;\n  margin: 0 auto 0px;\n  border-left: 0;\n  border-right: 0;\n\n  svg {\n    background-color: transparent !important;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  height: 80vh;\n'],['\n  height: 80vh;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Bubble=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.background?'url('+props.background+')':'none';},function(props){return props.selected?'0px 0px 0px 6px rgba(255,255,255,0.6)':'none';},function(props){return props.selected?1:0.8;},function(props){return props.selected?1:0.75;});var Text=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,function(props){return props.colorText?props.colorText:'#fff';});var FacesWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return props.isDragging?'hidden':'auto';});var BubblesWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var DetailDeliverable=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,function(props){return props.color;});var CloseDetail=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject7);var Card=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);var FeedbackLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return BUBBLE_SIZE; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return DESVIATION; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return FIRST_LEVEL_INFO_ZOOM; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return SECOND_LEVEL_INFO_ZOOM; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return MARGIN_OFFSET; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return MARGIN_BUBBLE; });

 __webpack_require__.d(__webpack_exports__, "g", function() { return MAX_ORBIT_SATELLITES; });

 __webpack_require__.d(__webpack_exports__, "h", function() { return SATELLITES_SIZE; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return INLINE_ELEMENTS_SIZE; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return ZOOM_WHEEL; });
var BUBBLE_SIZE={lg:120,md:100,xs:60};var DESVIATION=30;var FIRST_LEVEL_INFO_ZOOM={lg:0.8,md:1.2,xs:1.6};var SECOND_LEVEL_INFO_ZOOM={lg:1.5,md:2.3,xs:2.8};var MARGIN_OFFSET=20;var MARGIN_BUBBLE=30;var MAX_TAGS=2;var MAX_ORBIT_SATELLITES=3;var MAX_INLINE_ELEMENTS=1;var SATELLITES_SIZE={lg:40,md:30,xs:24};var INLINE_ELEMENTS_SIZE={lg:20,md:14,xs:8};var ZOOM_WHEEL=5;

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/addLogo.d3021c55.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1209);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1222);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return TYPE_CALL_FOR_IMPACT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return TYPE_THEME_TABLE; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return TYPE_SPEED_DATING; });
var TYPE_CALL_FOR_IMPACT=21283708;var TYPE_THEME_TABLE=21283681;var TYPE_SPEED_DATING=21275704;

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/callIconBlack.0e63536f.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tableBlack.129c3c96.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clock.948ba6fe.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mistery.6430180c.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1266);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/unlock.f6ff9a72.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return BackArrow; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return InvitationsListWrapper; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return InvitationsListHeader; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return InvitationsList; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return Invitation; });




 __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonsWrapper; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return InvitationText; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonInvite; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
 var __WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: 50px;\n  vertical-align: middle;\n\n  i {\n    color: #666;\n    cursor: pointer;\n    font-size: 16px;\n  }\n'],['\n  display: inline-block;\n  width: 50px;\n  vertical-align: middle;\n\n  i {\n    color: #666;\n    cursor: pointer;\n    font-size: 16px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: block !important;\n  flex-direction: unset !important;\n  height: 100%;\n  width: 100%;\n  background-color: ',';\n  overflow: auto;\n\n  @media (max-width: ','px) {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    z-index: 300;\n    height: 100%;\n    width: 100%;\n  }\n\n  .no_elements {\n    margin: 0px;\n\n    div {\n      color: #666;\n      font-size: 18px;\n      margin-top: 20px;\n    }\n  }\n'],['\n  display: block !important;\n  flex-direction: unset !important;\n  height: 100%;\n  width: 100%;\n  background-color: ',';\n  overflow: auto;\n\n  @media (max-width: ','px) {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    z-index: 300;\n    height: 100%;\n    width: 100%;\n  }\n\n  .no_elements {\n    margin: 0px;\n\n    div {\n      color: #666;\n      font-size: 18px;\n      margin-top: 20px;\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  display:flex;\n  background-color: #fff;\n  padding: 0px 10px;\n  width: 100%;\n  margin: 0 auto;\n  height: calc(60px + env(safe-area-inset-top));\n  padding-top: env(safe-area-inset-top);\n  line-height: 50px;\n  border-bottom: 1px solid #eee;\n  font-size: 20px;\n  font-weight: 600;\n  align-items: center;\n'],['\n  display:flex;\n  background-color: #fff;\n  padding: 0px 10px;\n  width: 100%;\n  margin: 0 auto;\n  height: calc(60px + env(safe-area-inset-top));\n  padding-top: env(safe-area-inset-top);\n  line-height: 50px;\n  border-bottom: 1px solid #eee;\n  font-size: 20px;\n  font-weight: 600;\n  align-items: center;\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 100%;\n  z-index: 1;\n  height: calc(100vh - 110px);\n  background-color: #f5f5f5;\n\n  @media (max-width: ','px) {\n    height: calc(100vh - 60px - env(safe-area-inset-top));\n  }\n'],['\n  width: 100%;\n  z-index: 1;\n  height: calc(100vh - 110px);\n  background-color: #f5f5f5;\n\n  @media (max-width: ','px) {\n    height: calc(100vh - 60px - env(safe-area-inset-top));\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  padding: 15px;\n  background-color: #fafafa;\n  border-bottom: 1px solid #eee;\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n\n  .avatar_bubble {\n    margin-right: 10px;\n  }\n'],['\n  padding: 15px;\n  background-color: #fafafa;\n  border-bottom: 1px solid #eee;\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n\n  .avatar_bubble {\n    margin-right: 10px;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 80px;\n'],['\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 80px;\n']),_templateObject7=_taggedTemplateLiteral(['\n   && {\n    width: 60px;\n    height: 60px;\n    display: inline-block;\n\n    img {\n      object-fit: contain;\n      background-color: #eee;\n    }\n\n    &.text-avatar {\n      font-size: 28px;\n      padding-top: 13px;\n      text-align: center;\n    }\n   }\n'],['\n   && {\n    width: 60px;\n    height: 60px;\n    display: inline-block;\n\n    img {\n      object-fit: contain;\n      background-color: #eee;\n    }\n\n    &.text-avatar {\n      font-size: 28px;\n      padding-top: 13px;\n      text-align: center;\n    }\n   }\n']),_templateObject8=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: top;\n  width: calc(100% - 80px);\n'],['\n  display: inline-block;\n  vertical-align: top;\n  width: calc(100% - 80px);\n']),_templateObject9=_taggedTemplateLiteral(['\n  font-weight: 600;\n  font-size: 14px;\n  color: #444;\n  height: 20px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: \'helvetica neue\';\n  display: inline-block;\n  width: calc(100% - 60px);\n'],['\n  font-weight: 600;\n  font-size: 14px;\n  color: #444;\n  height: 20px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: \'helvetica neue\';\n  display: inline-block;\n  width: calc(100% - 60px);\n']),_templateObject10=_taggedTemplateLiteral(['\n   position: relative;\n   right: 0;\n   display:flex;\n   justify-content: space-evenly;\n   max-width: 50%;\n   padding-left: 2rem;\n'],['\n   position: relative;\n   right: 0;\n   display:flex;\n   justify-content: space-evenly;\n   max-width: 50%;\n   padding-left: 2rem;\n']),_templateObject11=_taggedTemplateLiteral(['\n   max-width: 25%;\n   overflow-wrap: break-word;\n'],['\n   max-width: 25%;\n   overflow-wrap: break-word;\n']),_templateObject12=_taggedTemplateLiteral(['\n  background: ',';\n  padding: 1.2rem 2rem;\n  border-radius: 2rem;\n  color: white;\n'],['\n  background: ',';\n  padding: 1.2rem 2rem;\n  border-radius: 2rem;\n  color: white;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BackArrow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var InvitationsListWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var InvitationsListHeader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var InvitationsList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var Invitation=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var AvatarWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var UserAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject7);var UserContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);var UserName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);var ButtonsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10);var InvitationText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11);var ButtonInvite=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject12,function(props){return props.color;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return killThinkSeed; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return launchThinkTank; });
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_1__store_globalState_global__ = __webpack_require__(12);
var killThinkSeed=function killThinkSeed(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__store_globalState_global__["c" ])(true));return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'think-seed/'+id+'/kill'}).then(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__store_globalState_global__["c" ])(false));});};};var launchThinkTank=function launchThinkTank(_ref){var id=_ref.id,name=_ref.name,description=_ref.description,members=_ref.members,socialNetworkMovement=_ref.socialNetworkMovement,blog=_ref.blog,project=_ref.project,openInnovation=_ref.openInnovation;return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__store_globalState_global__["c" ])(true));return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'think-seed/'+id+'/launch'},{name:name,description:description,members:members,social_network_movement:socialNetworkMovement,blog:blog,project:project,open_innovation:openInnovation}).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__store_globalState_global__["c" ])(false));});};};

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no_results.36010b00.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1309);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = saveTool;
 __webpack_exports__["a"] = deleteTool;
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_1_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(358);
function saveTool(tool){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["e" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'tool'},tool).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["f" ],payload:{data:data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["d" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));});};}function deleteTool(toolId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["b" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('DELETE',{endPoint:'tool/'+toolId},{}).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["c" ],payload:{data:data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["a" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_store_globalState_global__["c" ])(false));});};}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return getSignature; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return getMeeting; });
 var __WEBPACK_IMPORTED_MODULE_0_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(361);
var getSignature=function getSignature(meetingId){return function(dispatch){var params={meeting_id:meetingId};dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["e" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'zoom/signature'},params).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["f" ],payload:{signature:response.data}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["d" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));});};};var getMeeting=function getMeeting(meetingId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["b" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'zoom/meetings/'+meetingId}).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["c" ],payload:{data:response}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["a" ]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_store_globalState_global__["c" ])(false));});};};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return Header; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ZoomIframe; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return SpeedDatingBarLayer; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return CloseIcon; });

 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1000000;\n\n  .header_bar {\n    background-color: #eee;\n    padding: calc(env(safe-area-inset-top) + 20px) 40px 15px 20px;\n    color: #000;\n    font-size: 14px;\n    border-bottom: 1px solid #ddd;\n\n    a {\n      font-size: 12px;\n      font-weight: 600;\n      margin-left: 5px;\n      font-size: 14px;\n    }\n\n    button.close_button {\n      background-color: transparent;\n      position: absolute;\n      right: 10px;\n      top: 10px;\n      font-size: 24px;\n      color: #444;\n    }\n  }\n'],['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1000000;\n\n  .header_bar {\n    background-color: #eee;\n    padding: calc(env(safe-area-inset-top) + 20px) 40px 15px 20px;\n    color: #000;\n    font-size: 14px;\n    border-bottom: 1px solid #ddd;\n\n    a {\n      font-size: 12px;\n      font-weight: 600;\n      margin-left: 5px;\n      font-size: 14px;\n    }\n\n    button.close_button {\n      background-color: transparent;\n      position: absolute;\n      right: 10px;\n      top: 10px;\n      font-size: 24px;\n      color: #444;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  height: calc(100% - ','px);\n  position: fixed;\n  border: 0;\n  z-index: 500;\n  left: 0;\n  top: ','px;\n  background-color: #000;\n'],['\n  width: 100%;\n  height: calc(100% - ','px);\n  position: fixed;\n  border: 0;\n  z-index: 500;\n  left: 0;\n  top: ','px;\n  background-color: #000;\n']),_templateObject3=_taggedTemplateLiteral(['\n  .user_layer {\n    float: left;\n\n    .username {\n      margin: 0px 10px;\n      display: inline-block;\n      vertical-align: middle;\n      font-weight: 600;\n    }\n  }\n\n  .countdown {\n    float: right;\n    text-align: center;\n\n    b {\n      font-family: \'helvetica neue strong\';\n      font-size: 16px;\n      margin-left: 5px;\n    }\n  }\n'],['\n  .user_layer {\n    float: left;\n\n    .username {\n      margin: 0px 10px;\n      display: inline-block;\n      vertical-align: middle;\n      font-weight: 600;\n    }\n  }\n\n  .countdown {\n    float: right;\n    text-align: center;\n\n    b {\n      font-family: \'helvetica neue strong\';\n      font-size: 16px;\n      margin-left: 5px;\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  color: #444;\n  font-size: 28px;\n  position: absolute;\n  z-index: 100;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n  z-index: 100;\n  pointer-events: all !important;\n'],['\n  color: #444;\n  font-size: 28px;\n  position: absolute;\n  z-index: 100;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n  z-index: 100;\n  pointer-events: all !important;\n']),_templateObject5=_taggedTemplateLiteral(['\n  background-color: ',';\n  border-radius: 6px;\n  height: 80vh;\n  overflow: auto;\n  margin: 20px auto 20px;\n  padding: 20px;\n  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n'],['\n  background-color: ',';\n  border-radius: 6px;\n  height: 80vh;\n  overflow: auto;\n  margin: 20px auto 20px;\n  padding: 20px;\n  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var ZoomIframe=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].iframe(_templateObject2,function(props){return props.height;},function(props){return props.height;});var SpeedDatingBarLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var CloseIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject4);var ProfileModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,function(props){return props.color;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1409);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "k", function() { return Title; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return SliderWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return DeliverableCard; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return DeliverableTitle; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return DeliverableUser; });



 __webpack_require__.d(__webpack_exports__, "d", function() { return DeliverableImage; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return DeliverableDescription; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return LikeButton; });

 __webpack_require__.d(__webpack_exports__, "a", function() { return CloseIcon; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return ShowNumber; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return SafeZone; });

 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
var _templateObject=_taggedTemplateLiteral(['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n\n  }\n\n'],['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n\n  }\n\n']),_templateObject2=_taggedTemplateLiteral(['\n  max-width: 96vw;\n  text-align: center;\n  color: #fff;\n  line-height: 22px;\n  font-size: 18px;\n  margin: 0px auto;\n  font-family: \'helvetica neue light\';\n  max-width: 90%;\n  display: inline-block;\n  vertical-align: middle;\n  margin-bottom: 10px;\n  strong {\n    font-family: \'helvetica neue light\';\n    color: #fff;\n    font-weight: 100;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n'],['\n  max-width: 96vw;\n  text-align: center;\n  color: #fff;\n  line-height: 22px;\n  font-size: 18px;\n  margin: 0px auto;\n  font-family: \'helvetica neue light\';\n  max-width: 90%;\n  display: inline-block;\n  vertical-align: middle;\n  margin-bottom: 10px;\n  strong {\n    font-family: \'helvetica neue light\';\n    color: #fff;\n    font-weight: 100;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  && {\n    position: relative;\n    max-width: 100%;\n    width: 100%;\n\n    .carousel {\n      height: 43rem;\n      .carousel-item {\n        height: 43rem;\n        width: clamp(30rem, 70rem, 90vw);\n      }\n    }\n    .control-dots {\n        bottom: 18vh;\n        margin-bottom: -18vh;\n    }\n    .slider-wrapper {\n        height: 65vh;\n    }\n    .slide {\n      background: none !important;\n\n      iframe {\n        display: block;\n        width: 100%;\n        margin: 0 0px 20px;\n        border: 0;\n      }\n    }\n  }\n\n'],['\n  && {\n    position: relative;\n    max-width: 100%;\n    width: 100%;\n\n    .carousel {\n      height: 43rem;\n      .carousel-item {\n        height: 43rem;\n        width: clamp(30rem, 70rem, 90vw);\n      }\n    }\n    .control-dots {\n        bottom: 18vh;\n        margin-bottom: -18vh;\n    }\n    .slider-wrapper {\n        height: 65vh;\n    }\n    .slide {\n      background: none !important;\n\n      iframe {\n        display: block;\n        width: 100%;\n        margin: 0 0px 20px;\n        border: 0;\n      }\n    }\n  }\n\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n  height: 40rem;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  background-color: #fff;\n  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);\n  border-radius: 4px;\n  text-align: left;\n  z-index: 10;\n'],['\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n  height: 40rem;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  background-color: #fff;\n  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);\n  border-radius: 4px;\n  text-align: left;\n  z-index: 10;\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: inline-block;\n  padding: 8px;\n  position: absolute;\n  right: 5%;\n  float: right;\n  top: 5%;\n  color: #4d4d4d;\n  font-size: calc(14px + (14.1 - 14) * ((100vw - 320px) / (412 - 320)));\n  font-weight: bold;\n  border-bottom: 1px solid #eee;\n  background-color: #fafafa;\n  border-radius: 10px;\n'],['\n  display: inline-block;\n  padding: 8px;\n  position: absolute;\n  right: 5%;\n  float: right;\n  top: 5%;\n  color: #4d4d4d;\n  font-size: calc(14px + (14.1 - 14) * ((100vw - 320px) / (412 - 320)));\n  font-weight: bold;\n  border-bottom: 1px solid #eee;\n  background-color: #fafafa;\n  border-radius: 10px;\n']),_templateObject6=_taggedTemplateLiteral(['\n  padding: 10px;\n  text-align: left;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n'],['\n  padding: 10px;\n  text-align: left;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n']),_templateObject7=_taggedTemplateLiteral(['\n  && {\n    width: 28px;\n    height: 28px;\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 10px;\n\n    &.text-avatar {\n      font-size: 14px;\n      padding-top: 4px;\n    }\n   }\n\n'],['\n  && {\n    width: 28px;\n    height: 28px;\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 10px;\n\n    &.text-avatar {\n      font-size: 14px;\n      padding-top: 4px;\n    }\n   }\n\n']),_templateObject8=_taggedTemplateLiteral(['\n  && {\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 10px;\n    border: 1px solid white;\n\n    &.text-avatar {\n      font-size: 18px;\n    }\n   }\n\n'],['\n  && {\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 10px;\n    border: 1px solid white;\n\n    &.text-avatar {\n      font-size: 18px;\n    }\n   }\n\n']),_templateObject9=_taggedTemplateLiteral(['\n  color: #fff;\n  font-family: helvetica neue light;\n  font-size: 14px;\n  display: inline-block;\n  vertical-align: middle;\n'],['\n  color: #fff;\n  font-family: helvetica neue light;\n  font-size: 14px;\n  display: inline-block;\n  vertical-align: middle;\n']),_templateObject10=_taggedTemplateLiteral(['\n  width: 100%;\n  padding-bottom: 40rem;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background: url(',');\n'],['\n  width: 100%;\n  padding-bottom: 40rem;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background: url(',');\n']),_templateObject11=_taggedTemplateLiteral(['\n  font-size: 14px;\n  color: #fff;\n  text-align: justify;\n  line-height: 18px;\n  max-height: 80%;\n  overflow-y: hidden;\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n  width: 100%;\n  padding: 1rem 1rem 5rem;\n  background-color: rgba(0, 0, 0, 0.5);\n'],['\n  font-size: 14px;\n  color: #fff;\n  text-align: justify;\n  line-height: 18px;\n  max-height: 80%;\n  overflow-y: hidden;\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n  width: 100%;\n  padding: 1rem 1rem 5rem;\n  background-color: rgba(0, 0, 0, 0.5);\n']),_templateObject12=_taggedTemplateLiteral(['\n  background-color: #ccc;\n  width: 60px;\n  height: 60px;\n  margin: -30px auto 10px;\n  border-radius: 50%;\n  text-align: center;\n  border: 2px solid #ccc;\n  padding-top: 16px;\n  z-index: 100;\n  cursor: pointer;\n  position: relative;\n  i {\n    font-size: 30px;\n    color: #444;\n  }\n\n  &.like {\n    background-color: ',';\n    border: 2px solid \'#fff\';\n\n    i {\n      font-size: 30px;\n      color: #fff;\n      text-shadow: 0 0 1px #000;\n    }\n  }\n'],['\n  background-color: #ccc;\n  width: 60px;\n  height: 60px;\n  margin: -30px auto 10px;\n  border-radius: 50%;\n  text-align: center;\n  border: 2px solid #ccc;\n  padding-top: 16px;\n  z-index: 100;\n  cursor: pointer;\n  position: relative;\n  i {\n    font-size: 30px;\n    color: #444;\n  }\n\n  &.like {\n    background-color: ',';\n    border: 2px solid \'#fff\';\n\n    i {\n      font-size: 30px;\n      color: #fff;\n      text-shadow: 0 0 1px #000;\n    }\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n    position: sticky;\n    bottom: -25px;\n    width: 100%;\n    height: 8vh;\n    background-color: ',';\n    opacity: 0.85;\n'],['\n    position: sticky;\n    bottom: -25px;\n    width: 100%;\n    height: 8vh;\n    background-color: ',';\n    opacity: 0.85;\n']),_templateObject14=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 18px;\n  position: absolute;\n  z-index: 100;\n  top: 10px;\n  right: 5px;\n  cursor: pointer;\n'],['\n  color: #fff;\n  font-size: 18px;\n  position: absolute;\n  z-index: 100;\n  top: 10px;\n  right: 5px;\n  cursor: pointer;\n']),_templateObject15=_taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  color: #fff;\n  font-size: 18px;\n  font-family: helvetica neue light;\n  font-style: normal;\n  z-index: 100;\n  background-color: ',';\n  border-radius: 30px;\n  padding: 5px 10px 5px 10px;\n  margin-left: 5px;\n'],['\n  position: relative;\n  display: inline-block;\n  color: #fff;\n  font-size: 18px;\n  font-family: helvetica neue light;\n  font-style: normal;\n  z-index: 100;\n  background-color: ',';\n  border-radius: 30px;\n  padding: 5px 10px 5px 10px;\n  margin-left: 5px;\n']),_templateObject16=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: absolute;\n  bottom: 0px;\n  width: 100%;\n  background-color: transparent;\n  height: 40px;\n'],['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: absolute;\n  bottom: 0px;\n  width: 100%;\n  background-color: transparent;\n  height: 40px;\n']),_templateObject17=_taggedTemplateLiteral(['\n  height: 80vh;\n'],['\n  height: 80vh;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var highlight=function highlight(backgroundColorText){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject,backgroundColorText);};var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return highlight(props.backgroundColorText);});var SliderWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var DeliverableCard=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var DeliverableTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var DeliverableUser=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var UserAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject7);var UserAvatarLike=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject8);var UserName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);var DeliverableImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10,function(props){return props.image;});var DeliverableDescription=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11);var LikeButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12,function(props){return props.color;});var FadeFrame=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13,function(props){return props.color;});var CloseIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject14);var ShowNumber=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject15,function(props){return props.backgroundColor;});var SafeZone=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16);var FeedbackLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return bisectRight; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return bisectLeft; });
 var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(118);
 var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(493);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" ])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" ]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
 __webpack_exports__["c"] = (bisectRight);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(118);


 __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" ])(f(d), x);
  };
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = pair;
 __webpack_exports__["a"] = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(496);


 __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" ])(array, f);
  return v ? Math.sqrt(v) : v;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(137);


 __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = tickIncrement;
 __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

 __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(502);


 __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" ])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(56);


 __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" ]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" ]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" ]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

 __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

 __webpack_exports__["a"] = (matcher);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = EnterNode;
 var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(508);
 var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(56);



 __webpack_exports__["b"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" ](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" ]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = styleValue;
 var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(280);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

 __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" ])(node).getComputedStyle(node, null).getPropertyValue(name);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = yesdrag;
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_1__noevent__ = __webpack_require__(511);



 __webpack_exports__["a"] = (function(view) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["k" ])(view).on("dragstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" ], true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" ], true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
});

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["k" ])(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" ], true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = nopropagation;
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" ].stopImmediatePropagation();
}

 __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" ].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" ].stopImmediatePropagation();
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
 var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(60);
 var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(286);
 var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(514);
 var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(138);





 __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" ])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" ])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" ])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" ])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" ])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" ]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" ]);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(286);


 __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" ])((t - i / n) * n, v0, v1, v2, v3);
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(283);


 __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" ])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(283);


 __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" ])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(187);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

 __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__transition_schedule__ = __webpack_require__(58);


 __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["d" ] && schedule.state < __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["b" ];
    schedule.state = __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["a" ];
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(60);
 var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);



 __webpack_exports__["a"] = (function(a, b) {
  var c;
  return (typeof b === "number" ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["m" ]
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" ] ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["o" ]
      : (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" ])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["o" ])
      : __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["s" ])(a, b);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_linear__ = __webpack_require__(1525);
 __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__src_linear__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_quad__ = __webpack_require__(1526);
 __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__src_quad__["b"]; });
 __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__src_quad__["a"]; });
 __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__src_quad__["c"]; });
 __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_1__src_quad__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_cubic__ = __webpack_require__(1527);
 __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["b"]; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["a"]; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["c"]; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_poly__ = __webpack_require__(1528);
 __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_3__src_poly__["b"]; });
 __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_3__src_poly__["a"]; });
 __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_3__src_poly__["c"]; });
 __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_3__src_poly__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_sin__ = __webpack_require__(1529);
 __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_4__src_sin__["b"]; });
 __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_4__src_sin__["a"]; });
 __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_4__src_sin__["c"]; });
 __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_4__src_sin__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_exp__ = __webpack_require__(1530);
 __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_5__src_exp__["b"]; });
 __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_5__src_exp__["a"]; });
 __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_5__src_exp__["c"]; });
 __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__src_exp__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_circle__ = __webpack_require__(1531);
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__src_circle__["b"]; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__src_circle__["a"]; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__src_circle__["c"]; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__src_circle__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_7__src_bounce__ = __webpack_require__(1532);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__src_bounce__["c"]; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__src_bounce__["a"]; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__src_bounce__["c"]; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__src_bounce__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_8__src_back__ = __webpack_require__(1533);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__src_back__["b"]; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__src_back__["a"]; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__src_back__["c"]; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__src_back__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_9__src_elastic__ = __webpack_require__(1534);
 __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__src_elastic__["c"]; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_9__src_elastic__["a"]; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__src_elastic__["c"]; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__src_elastic__["b"]; });





















 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return cos; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return sin; });

 __webpack_require__.d(__webpack_exports__, "b", function() { return halfPi; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return tau; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return max; });
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = x;
 __webpack_exports__["c"] = y;
 var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(100);
 var __WEBPACK_IMPORTED_MODULE_1_d3_collection__ = __webpack_require__(139);
 var __WEBPACK_IMPORTED_MODULE_2_d3_timer__ = __webpack_require__(188);




function x(d) {
  return d.x;
}

function y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

 __webpack_exports__["a"] = (function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = Object(__WEBPACK_IMPORTED_MODULE_1_d3_collection__["c" ])(),
      stepper = Object(__WEBPACK_IMPORTED_MODULE_2_d3_timer__["d" ])(step),
      event = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" ])("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(190);
 var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(1574);
 var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(1575);
 var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(526);
 var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(527);
 var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(528);
 var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(1578);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

 __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" ])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" ],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" ])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" ],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" ])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" ][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" ] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" ])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" ])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = formatSpecifier;
 var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(527);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" ][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(1576);
 var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(528);
 var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(1577);




 __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" ],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" ])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" ],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" ],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
 var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(296);


var prefixExponent;

 __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" ])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" ])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return areaRingSum; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return areaStream; });
 var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(120);
 var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(80);
 var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(102);





var areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" ])();

var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" ])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["w" ] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" ];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math__["w" ]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" ], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" ];
  lambda0 = lambda, cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" ]), sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" ], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" ];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" ]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(phi),
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(adLambda),
      v = k * sdLambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(adLambda);
  areaRingSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" ])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

 __webpack_exports__["c"] = (function(object) {
  areaSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" ])(object, areaStream);
  return areaSum * 2;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = circleStream;
 var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(140);
 var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(1585);
 var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_3__rotation__ = __webpack_require__(191);





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" ])(radius),
      sinRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" ])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" ];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" ];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" ])([cosRadius, -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" ])(t), -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" ])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" ])(point), point[0] -= cosRadius;
  Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" ])(point);
  var radius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" ])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math__["w" ] - __WEBPACK_IMPORTED_MODULE_2__math__["i" ]) % __WEBPACK_IMPORTED_MODULE_2__math__["w" ];
}

 __webpack_exports__["b"] = (function() {
  var center = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])([0, 0]),
      radius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(90),
      precision = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" ], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" ];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" ],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" ];
    ring = [];
    rotate = Object(__WEBPACK_IMPORTED_MODULE_3__rotation__["b" ])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" ], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" ], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), circle) : precision;
  };

  return circle;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(533);
 var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(18);



 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" ])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math__["o" ], -__WEBPACK_IMPORTED_MODULE_1__math__["l" ]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["o" ] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" ],
          delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(lambda1 - lambda0);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(delta - __WEBPACK_IMPORTED_MODULE_1__math__["o" ]) < __WEBPACK_IMPORTED_MODULE_1__math__["i" ]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["l" ] : -__WEBPACK_IMPORTED_MODULE_1__math__["l" ]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math__["o" ]) { // line crosses antimeridian
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math__["i" ]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math__["i" ]; // handle degeneracies
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" ]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math__["i" ];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(lambda0 - lambda1);
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math__["i" ]
      ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["d" ])((Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(phi0) * (cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(phi1)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(lambda1)
          - Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(phi1) * (cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(phi0)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math__["l" ];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" ], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" ], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" ], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" ], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" ], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" ], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" ], phi);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math__["i" ]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math__["o" ] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" ];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(534);
 var __WEBPACK_IMPORTED_MODULE_1__rejoin__ = __webpack_require__(535);
 var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_3__polygonContains__ = __webpack_require__(537);
 var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(43);






 __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["a" ])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["n" ])(segments);
        var startInside = Object(__WEBPACK_IMPORTED_MODULE_3__polygonContains__["a" ])(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          Object(__WEBPACK_IMPORTED_MODULE_1__rejoin__["a" ])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" ] - __WEBPACK_IMPORTED_MODULE_2__math__["i" ] : __WEBPACK_IMPORTED_MODULE_2__math__["l" ] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" ] - __WEBPACK_IMPORTED_MODULE_2__math__["i" ] : __WEBPACK_IMPORTED_MODULE_2__math__["l" ] - b[1]);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(80);


 __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__pointEqual__ = __webpack_require__(536);


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
 __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (Object(__WEBPACK_IMPORTED_MODULE_0__pointEqual__["a" ])(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);


 __webpack_exports__["a"] = (function(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" ])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" ] && Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" ])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" ];
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(120);
 var __WEBPACK_IMPORTED_MODULE_1__cartesian__ = __webpack_require__(140);
 var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(18);




var sum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" ])();

 __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" ])(lambda), -Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" ])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" ],
        sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" ])(phi0),
        cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" ])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" ],
          sinPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" ])(phi1),
          cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" ])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math__["o" ],
          k = sinPhi0 * sinPhi1;

      sum.add(Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" ])(k * sign * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" ])(absDelta), cosPhi0 * cosPhi1 + k * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" ])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math__["w" ] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" ])(Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" ])(point0), Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" ])(point1));
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" ])(arc);
        var intersection = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" ])(normal, arc);
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" ])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" ])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math__["i" ] || angle < __WEBPACK_IMPORTED_MODULE_2__math__["i" ] && sum < -__WEBPACK_IMPORTED_MODULE_2__math__["i" ]) ^ (winding & 1);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(140);
 var __WEBPACK_IMPORTED_MODULE_1__circle__ = __webpack_require__(530);
 var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_3__pointEqual__ = __webpack_require__(536);
 var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(533);






 __webpack_exports__["a"] = (function(radius) {
  var cr = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" ])(radius),
      delta = 6 * __WEBPACK_IMPORTED_MODULE_2__math__["r" ],
      smallRadius = cr > 0,
      notHemisphere = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" ])(cr) > __WEBPACK_IMPORTED_MODULE_2__math__["i" ]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    Object(__WEBPACK_IMPORTED_MODULE_1__circle__["a" ])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" ])(lambda) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" ])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["o" ] : -__WEBPACK_IMPORTED_MODULE_2__math__["o" ]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" ])(point0, point2) || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" ])(point1, point2)) {
            point1[0] += __WEBPACK_IMPORTED_MODULE_2__math__["i" ];
            point1[1] += __WEBPACK_IMPORTED_MODULE_2__math__["i" ];
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" ])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" ])(a),
        pb = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" ])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" ])(pa, pb),
        n2n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" ])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" ])(n1, n2),
        A = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" ])(n1, c1),
        B = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" ])(n2, c2);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" ])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" ])(A, u),
        uu = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" ])(u, u),
        t2 = w * w - uu * (Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" ])(A, A) - 1);

    if (t2 < 0) return;

    var t = Object(__WEBPACK_IMPORTED_MODULE_2__math__["u" ])(t2),
        q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" ])(u, (-w - t) / uu);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" ])(q, A);
    q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" ])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" ])(delta - __WEBPACK_IMPORTED_MODULE_2__math__["o" ]) < __WEBPACK_IMPORTED_MODULE_2__math__["i" ],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math__["i" ];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" ])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math__["i" ] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math__["o" ] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" ])(u, (-w + t) / uu);
      Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" ])(q1, A);
      return [q, Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" ])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math__["o" ] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_4__index__["a" ])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math__["o" ], radius - __WEBPACK_IMPORTED_MODULE_2__math__["o" ]]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__length__ = __webpack_require__(540);


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

 __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return Object(__WEBPACK_IMPORTED_MODULE_0__length__["a" ])(object);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(120);
 var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(80);
 var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(102);





var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" ])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop__["a" ];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" ], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" ];
  lambda0 = lambda, sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(phi), cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" ], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" ];
  var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(phi),
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(phi),
      delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(lambda - lambda0),
      cosDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(delta),
      sinDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" ])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" ])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

 __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" ])(object, lengthStream);
  return +lengthSum;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(80);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

 __webpack_exports__["a"] = (boundsStream);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea__ = __webpack_require__(298);


 __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea__["b" ])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = equirectangularRaw;
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(61);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

 __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" ])(equirectangularRaw)
      .scale(152.63);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = packEnclose;
 var __WEBPACK_IMPORTED_MODULE_0__enclose__ = __webpack_require__(545);


function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = Object(__WEBPACK_IMPORTED_MODULE_0__enclose__["a" ])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

 __webpack_exports__["a"] = (function(circles) {
  packEnclose(circles);
  return circles;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(1624);


 __webpack_exports__["a"] = (function(circles) {
  var i = 0, n = (circles = Object(__WEBPACK_IMPORTED_MODULE_0__array__["a" ])(__WEBPACK_IMPORTED_MODULE_0__array__["b" ].call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

 __webpack_exports__["b"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(121);


 __webpack_exports__["a"] = ((function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" ]));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(121);


 __webpack_exports__["a"] = ((function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" ]));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(305);


 __webpack_exports__["a"] = (function(defaultMimeType, parse) {
  return function(url, row, callback) {
    if (arguments.length < 3) callback = row, row = null;
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" ])(url).mimeType(defaultMimeType);
    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
    r.row(row);
    return callback ? r.get(callback) : r;
  };
});

function responseOf(parse, row) {
  return function(request) {
    return parse(request.responseText, row);
  };
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
 __webpack_exports__["a"] = ordinal;
 var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(139);
 var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(103);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["c" ])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" ].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["c" ])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" ].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return +x;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = calendar;
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);
 var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(197);
 var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(307);
 var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(103);
 var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(196);
 var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(553);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" ])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" ], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["m" ]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" ])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" ])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" ])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" ].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" ])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" ])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

 __webpack_exports__["b"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["D" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["B" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["e" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["h" ], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["c" ]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = formatLocale;
 var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(197);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["P" ].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["P" ])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["F" ].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" ].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" ])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" ].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" ].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" ])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" ].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" ])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" ])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["v" ].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" ].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" ])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" ])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" ].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["D" ])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["F" ].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" ])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["X" ].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" ])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["Z" ])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["Z" ].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["Z" ].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" ])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" ])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["P" ].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["_7" ])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return isoSpecifier; });
 var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(308);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["d" ])(isoSpecifier);

 __webpack_exports__["a"] = (formatIso);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(101);
 var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(104);
 var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(198);
 var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(309);
 var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(310);






 __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" ],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" ],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" ],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" ])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" ])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
 __webpack_exports__["b"] = curveRadial;
 var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(198);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" ]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = lineRadial;
 var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(558);
 var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(309);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" ])(_)) : c()._curve;
  };

  return l;
}

 __webpack_exports__["a"] = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" ])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" ]));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(145);


 __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["j" ]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["m" ]);
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

 __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(145);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["j" ] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["j" ] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["m" ] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["m" ] / 10) * kr;

 __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["m" ] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

 __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

 __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = CardinalClosed;
 var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(199);
 var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(201);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["c" ])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

 __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = CardinalOpen;
 var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(201);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["c" ])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

 __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["c"] = createCell;
 __webpack_exports__["a"] = cellHalfedgeStart;

 __webpack_exports__["d"] = sortCellHalfedges;
 __webpack_exports__["b"] = clipCells;
 var __WEBPACK_IMPORTED_MODULE_0__Edge__ = __webpack_require__(314);
 var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(148);



function createCell(site) {
  return __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" ][site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" ].length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" ][i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" ][halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" ].length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" ][iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!__WEBPACK_IMPORTED_MODULE_1__Diagram__["e" ][halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" ][halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" ][halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] || Math.abs(endY - startY) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ]) {
          halfedges.splice(iHalfedge, 0, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" ].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" ])(site, end,
              Math.abs(endX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] && y1 - endY > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] ? [x0, Math.abs(startX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] ? startY : y1]
              : Math.abs(endY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] && x1 - endX > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] ? [Math.abs(startY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] ? startX : x1, y1]
              : Math.abs(endX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] && endY - y0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] ? [x1, Math.abs(startX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] ? startY : y0]
              : Math.abs(endY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] && endX - x0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] ? [Math.abs(startY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" ] ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" ][iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" ].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" ])(site = cover.site, v00, v01)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" ].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" ])(site, v01, v11)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" ].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" ])(site, v11, v10)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" ].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" ])(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" ][iCell]) {
      if (!cell.halfedges.length) {
        delete __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" ][iCell];
      }
    }
  }
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return firstCircle; });
 __webpack_exports__["a"] = attachCircle;
 __webpack_exports__["b"] = detachCircle;
 var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(313);
 var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(148);



var circlePool = [];

var firstCircle;

function Circle() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" ])(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -__WEBPACK_IMPORTED_MODULE_1__Diagram__["g" ]) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" ]._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" ].insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" ].remove(circle);
    circlePool.push(circle);
    Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" ])(circle);
    arc.circle = null;
  }
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = Transform;
 __webpack_require__.d(__webpack_exports__, "c", function() { return identity; });
 __webpack_exports__["b"] = transform;
function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity = new Transform(1, 0, 0);

transform.prototype = Transform.prototype;

function transform(node) {
  return node.__zoom || identity;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return TagCloudView; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return TagElement; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  0% {\n    text-shadow: 0 5px 6px rgba(0,0,0,0.3);\n    transform: translatey(0px);\n  }\n  50% {\n    text-shadow: 0 15px 6px rgba(0,0,0,0.2);\n    transform: translatey(-7px);\n  }\n  100% {\n    text-shadow: 0 5px 6px rgba(0,0,0,0.3);\n    transform: translatey(0px);\n  }\n'],['\n  0% {\n    text-shadow: 0 5px 6px rgba(0,0,0,0.3);\n    transform: translatey(0px);\n  }\n  50% {\n    text-shadow: 0 15px 6px rgba(0,0,0,0.2);\n    transform: translatey(-7px);\n  }\n  100% {\n    text-shadow: 0 5px 6px rgba(0,0,0,0.3);\n    transform: translatey(0px);\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  animation: ',' 3s ease-in-out infinite;\n'],['\n  animation: ',' 3s ease-in-out infinite;\n']),_templateObject3=_taggedTemplateLiteral(['\n'],['\n']),_templateObject4=_taggedTemplateLiteral(['\n  cursor: pointer;\n  font-size: ','px;\n  color: ',';\n  display: inline-block;\n  vertical-align: text-top;\n  margin-top: ','px;\n  margin-bottom: ','px;\n  margin-right: ','px;\n  margin-left: ','px;\n  ','\n  ','\n'],['\n  cursor: pointer;\n  font-size: ','px;\n  color: ',';\n  display: inline-block;\n  vertical-align: text-top;\n  margin-top: ','px;\n  margin-bottom: ','px;\n  margin-right: ','px;\n  margin-left: ','px;\n  ','\n  ','\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var float=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject);var floatEffect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject2,float);var TagCloudView=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var TagElement=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return props.fontSize;},function(props){return props.selected?props.colorSelected:'#fff';},function(props){return props.marginTop;},function(props){return props.marginBottom;},function(props){return props.marginRight;},function(props){return props.marginLeft;},function(props){return props.selected?'transform: rotate('+props.rotate+'deg);':floatEffect;},function(props){return props.selected?'text-shadow: 0px 2px 6px rgba(0,0,0,0.6);':'';});

 }),

 (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(202),
    stackClear = __webpack_require__(1737),
    stackDelete = __webpack_require__(1738),
    stackGet = __webpack_require__(1739),
    stackHas = __webpack_require__(1740),
    stackSet = __webpack_require__(1741);


function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


 }),

 (function(module, exports) {


function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


 }),

 (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(149),
    isObject = __webpack_require__(317);


var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';


function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


 }),

 (function(module, exports, __webpack_require__) {

(function(global) {
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}.call(exports, __webpack_require__(51)))

 }),

 (function(module, exports) {


var funcProto = Function.prototype;


var funcToString = funcProto.toString;


function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


 }),

 (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1760),
    arraySome = __webpack_require__(1763),
    cacheHas = __webpack_require__(1764);


var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;


function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


 }),

 (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1778),
    isObjectLike = __webpack_require__(150);


var objectProto = Object.prototype;


var hasOwnProperty = objectProto.hasOwnProperty;


var propertyIsEnumerable = objectProto.propertyIsEnumerable;


var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


 }),

 (function(module, exports, __webpack_require__) {

(function(module) {var root = __webpack_require__(71),
    stubFalse = __webpack_require__(1779);


var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;


var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;


var moduleExports = freeModule && freeModule.exports === freeExports;


var Buffer = moduleExports ? root.Buffer : undefined;


var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;


var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

}.call(exports, __webpack_require__(123)(module)))

 }),

 (function(module, exports) {


var MAX_SAFE_INTEGER = 9007199254740991;


var reIsUint = /^(?:0|[1-9]\d*)$/;


function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


 }),

 (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1780),
    baseUnary = __webpack_require__(1781),
    nodeUtil = __webpack_require__(1782);


var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;


var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


 }),

 (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(577),
    isLength = __webpack_require__(320);


function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


 }),

 (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(317);


function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


 }),

 (function(module, exports) {


function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


 }),

 (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(589),
    toKey = __webpack_require__(207);


function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


 }),

 (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(72),
    isKey = __webpack_require__(321),
    stringToPath = __webpack_require__(1809),
    toString = __webpack_require__(1812);


function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1833);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1852);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/callIcon.425c25b9.svg";

 }),

 (function(module, exports, __webpack_require__) {

__webpack_require__(594);
module.exports = __webpack_require__(599);


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(595).enable();
  window.Promise = __webpack_require__(597);
}

// fetch() polyfill for making API calls.
__webpack_require__(598);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(208);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(323);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";
(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.


var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}.call(exports, __webpack_require__(51)))

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(323);

module.exports = Promise;



var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};



Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


 }),

 (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_3_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_3_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_4_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_5_react_ga__ = __webpack_require__(106);
 var __WEBPACK_IMPORTED_MODULE_6_store_globalState_initialState__ = __webpack_require__(74);
 var __WEBPACK_IMPORTED_MODULE_7_store_configureStore__ = __webpack_require__(639);
 var __WEBPACK_IMPORTED_MODULE_7_store_configureStore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_store_configureStore__);
 var __WEBPACK_IMPORTED_MODULE_8_routes_App__ = __webpack_require__(719);
 var __WEBPACK_IMPORTED_MODULE_9_routes_Embed_App__ = __webpack_require__(1961);
 var __WEBPACK_IMPORTED_MODULE_10_components_OverrideTheme__ = __webpack_require__(1964);
 var __WEBPACK_IMPORTED_MODULE_11__registerServiceWorker__ = __webpack_require__(1973);
 var __WEBPACK_IMPORTED_MODULE_12_styles_index_css__ = __webpack_require__(1974);
 var __WEBPACK_IMPORTED_MODULE_12_styles_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styles_index_css__);
var sessionOptions={refreshOnCheckAuth:true,redirectPath:__WEBPACK_IMPORTED_MODULE_4_constants_urls__["w" ]};var store=__WEBPACK_IMPORTED_MODULE_7_store_configureStore___default()(__WEBPACK_IMPORTED_MODULE_6_store_globalState_initialState__["a" ]);__WEBPACK_IMPORTED_MODULE_3_redux_react_session__["sessionService"].initSessionService(store,sessionOptions);__WEBPACK_IMPORTED_MODULE_5_react_ga__["a" ].initialize('UA-138142799-1');__WEBPACK_IMPORTED_MODULE_5_react_ga__["a" ].pageview(window.location.pathname+window.location.search);if(window.location.pathname.indexOf('/embed/')>=0){Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" ],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_OverrideTheme__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_routes_Embed_App__["a" ],null))),document.getElementById('root'));}else{Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" ],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_OverrideTheme__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_routes_App__["a" ],null))),document.getElementById('root'));}Object(__WEBPACK_IMPORTED_MODULE_11__registerServiceWorker__["a" ])();

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var l=__webpack_require__(208),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


 }),

 (function(module, exports, __webpack_require__) {

"use strict";



var aa=__webpack_require__(0),n=__webpack_require__(208),r=__webpack_require__(602);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(603);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(73);
 var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(324);
 var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(209);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" ])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" ])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" ].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" ].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" ], _Provider$childContex);
  return Provider;
}
 __webpack_exports__["a"] = (createProvider());

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";




var ReactPropTypesSecret = __webpack_require__(607);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";




var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(609);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(611);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =

function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(62);
 var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(325);
 var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(614);
 var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(615);
 var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(620);
 var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(621);
 var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(622);










function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" ] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" ] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" ] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" ] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" ] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" ] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" ] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" ] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" ])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
 __webpack_exports__["a"] = (createConnect());

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(326);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" ])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" ])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" ])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(mapDispatchToProps, dispatch);
  }) : undefined;
}
 __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
(function(global, module) { var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(618);



var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" ])(root);
 __webpack_exports__["a"] = (result);

}.call(__webpack_exports__, __webpack_require__(51), __webpack_require__(617)(module)))

 }),

 (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = isPlainObject;

function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(326);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" ])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" ])(function () {
    return {};
  }) : undefined;
}
 __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";




 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(327);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
 __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 __webpack_exports__["a"] = finalPropsSelectorFactory;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(62);
 var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(623);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" ])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(209);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" ])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_SESSION = exports.USER_SESSION = 'USER-SESSION';
var USER_DATA = exports.USER_DATA = 'USER_DATA';

 }),

 (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


 }),

 (function(module, exports) {

module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invalidSession = exports.getUserSessionError = exports.getUserSessionSuccess = exports.getSessionError = exports.getSessionSuccess = undefined;

var _actionTypes = __webpack_require__(328);

var getSessionSuccess = exports.getSessionSuccess = function getSessionSuccess() {
  return { type: _actionTypes.GET_SESSION_SUCCESS };
};

var getSessionError = exports.getSessionError = function getSessionError() {
  return { type: _actionTypes.GET_SESSION_ERROR };
};

var getUserSessionSuccess = exports.getUserSessionSuccess = function getUserSessionSuccess(user) {
  return {
    user: user,
    type: _actionTypes.GET_USER_SESSION_SUCCESS
  };
};

var getUserSessionError = exports.getUserSessionError = function getUserSessionError() {
  return { type: _actionTypes.GET_USER_SESSION_ERROR };
};

var invalidSession = exports.invalidSession = function invalidSession() {
  return { type: _actionTypes.INVALID_SESSION };
};

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(328);

var initialState = exports.initialState = {
  authenticated: false,
  checked: false,
  invalid: false,
  user: {}
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.GET_SESSION_SUCCESS:
      {
        return {
          user: _extends({}, state.user),
          authenticated: true,
          checked: true,
          invalid: false
        };
      }
    case _actionTypes.GET_SESSION_ERROR:
      {
        return _extends({}, state, {
          user: _extends({}, state.user),
          authenticated: false,
          checked: true
        });
      }
    case _actionTypes.GET_USER_SESSION_SUCCESS:
      {
        return _extends({}, state, { user: action.user });
      }
    case _actionTypes.GET_USER_SESSION_ERROR:
      {
        return _extends({}, state, { user: {} });
      }
    case _actionTypes.INVALID_SESSION:
      {
        return {
          user: {},
          checked: true,
          authenticated: false,
          invalid: true
        };
      }
    default:
      {
        return state;
      }
  }
};

exports.default = reducer;

 }),

 (function(module, exports, __webpack_require__) {

(function(global) {var require;var require;
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);


function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support (#5572)
        // since Safari 10.1 shipped with fetch, we can use that to detect it
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            resolve(openreq.result);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback retuns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = req.onblocked = function (err) {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(err);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};



function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});

}.call(exports, __webpack_require__(51)))

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(211);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink =

function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" ])('ga tracking not enabled');
});

_defineProperty(OutboundLink, "propTypes", {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trackerNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
});

_defineProperty(OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
 __webpack_exports__["initialize"] = initialize;
 __webpack_exports__["ga"] = ga;
 __webpack_exports__["set"] = set;
 __webpack_exports__["send"] = send;
 __webpack_exports__["pageview"] = pageview;
 __webpack_exports__["modalview"] = modalview;
 __webpack_exports__["timing"] = timing;
 __webpack_exports__["event"] = event;
 __webpack_exports__["exception"] = exception;
 __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
 __webpack_exports__["outboundLink"] = outboundLink;
 __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
 var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(632);
 var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(635);
 var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(329);
 var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(636);
 var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(211);
 var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(637);
 var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(638);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }












var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" ].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" ], arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" ])(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) Object(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" ])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}


function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])('called ga(\'arguments\');');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}


function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])('called ga(\'set\', fieldsObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}


function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])('called ga(\'send\', fieldObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}


function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('path is required in .pageview()');
    return;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" ])(rawPath);

  if (path === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("with path: ".concat(path).concat(extraLog));
    }
  }
}


function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" ])(rawModalName));

  if (modalName === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])('called ga(\'send\', \'pageview\', path);');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("with path: ".concat(path));
    }
  }
}


function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}


function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}


function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('`name` is required in .require()');
        return;
      }

      var name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" ])(rawName);

      if (name === '') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof(options) !== 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" ])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};


function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" ])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" ];
 __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" ]
});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = format;
 var __WEBPACK_IMPORTED_MODULE_0__mightBeEmail__ = __webpack_require__(633);
 var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(634);
 var __WEBPACK_IMPORTED_MODULE_2__console_warn__ = __webpack_require__(211);



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__mightBeEmail__["a" ])(s)) {
    Object(__WEBPACK_IMPORTED_MODULE_2__console_warn__["a" ])('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" ])(s);
  }

  return s;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = toTitleCase;
 var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(329);


var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__trim__["a" ])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  

});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var gaCalls = [];
 __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

 }),

 (function(module, exports, __webpack_require__) {

if(true){module.exports=__webpack_require__(640);}else{module.exports=require('./configureStore.dev');}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
 __webpack_exports__["default"] = configureStore;
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(641);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(151);
 var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(75);
 var __WEBPACK_IMPORTED_MODULE_4_modules_socket_actions__ = __webpack_require__(81);
 var __WEBPACK_IMPORTED_MODULE_5__globalState__ = __webpack_require__(650);
// import {
//   middleware as idleMiddleware,
//   actions as idleActions,
// } from 'modules/idleMonitor';
var history=Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" ])();var routerReduxMiddleware=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["b" ])(history);var middlewares=[__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" ].withExtraArgument({emit:__WEBPACK_IMPORTED_MODULE_4_modules_socket_actions__["a" ]}),// idleMiddleware,
routerReduxMiddleware];var enhancer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" ])(__WEBPACK_IMPORTED_MODULE_0_redux__["a" ].apply(undefined,middlewares));function configureStore(initialState){var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" ])(__WEBPACK_IMPORTED_MODULE_5__globalState__["a" ],initialState,enhancer);var currentIsAuthenticated=false;var currentUser={};// Will start the idle monitoring when the user logs in, and stop it if the user is signed out.
store.subscribe(function(){var previousIsAuthenticated=currentIsAuthenticated;var previousUser=currentUser;var state=store.getState();currentIsAuthenticated=state.session.authenticated;currentUser=state.session.user;// if (currentIsAuthenticated !== previousIsAuthenticated) {
//   store.dispatch((currentIsAuthenticated ? idleActions.start : idleActions.stop)());
// }
if(JSON.stringify(currentUser)!==JSON.stringify(previousUser)){Object(__WEBPACK_IMPORTED_MODULE_4_modules_socket_actions__["b" ])(store,true);}});return store;}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

 __webpack_exports__["a"] = (thunk);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(330);
 var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(338);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ConnectedRouter = function (_Component) {
  _inherits(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectedRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
      _this.store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" ],
        payload: location
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        propsStore = _props.store,
        history = _props.history;

    this.store = propsStore || this.context.store;
    this.handleLocationChange(history.location);
  };

  ConnectedRouter.prototype.componentDidMount = function componentDidMount() {
    var history = this.props.history;

    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
  };

  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  ConnectedRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" ], this.props);
  };

  return ConnectedRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConnectedRouter.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
ConnectedRouter.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


 __webpack_exports__["a"] = (ConnectedRouter);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

 __webpack_exports__["a"] = (resolvePathname);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

 __webpack_exports__["a"] = (valueEqual);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

 __webpack_exports__["a"] = (invariant);


 }),

 (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";



var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(330);


var getLocation = function getLocation(state) {
  return state.router.location;
};

var createMatchSelector = function createMatchSelector(path) {
  var lastPathname = null;
  var lastMatch = null;
  return function (state) {
    var _getLocation = getLocation(state),
        pathname = _getLocation.pathname;

    if (pathname === lastPathname) {
      return lastMatch;
    }
    lastPathname = pathname;
    var match = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" ])(pathname, path);
    if (!match || !lastMatch || match.url !== lastMatch.url) {
      lastMatch = match;
    }
    return lastMatch;
  };
};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = routerMiddleware;
 var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(339);



function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" ]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, args);
      };
    };
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1__reducers__ = __webpack_require__(651);
 var __WEBPACK_IMPORTED_MODULE_2__action_types__ = __webpack_require__(215);
 var __WEBPACK_IMPORTED_MODULE_3__initialState__ = __webpack_require__(74);
var appReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" ])(Object.assign({},__WEBPACK_IMPORTED_MODULE_1__reducers__["a" ]));var rootReducer=function rootReducer(state,action){var newState=state;if(action.type===__WEBPACK_IMPORTED_MODULE_2__action_types__["b" ]){newState.chats=__WEBPACK_IMPORTED_MODULE_3__initialState__["a" ].chats;}return appReducer(newState,action);}; __webpack_exports__["a"] = (rootReducer);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__conf01__ = __webpack_require__(652);
 var __WEBPACK_IMPORTED_MODULE_1__conf02__ = __webpack_require__(708);
 var __WEBPACK_IMPORTED_MODULE_2__conf03__ = __webpack_require__(711);
 var __WEBPACK_IMPORTED_MODULE_2__conf03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__conf03__);
 var __WEBPACK_IMPORTED_MODULE_3__conf04__ = __webpack_require__(712);
 var __WEBPACK_IMPORTED_MODULE_3__conf04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__conf04__);
 var __WEBPACK_IMPORTED_MODULE_4__conf05__ = __webpack_require__(713);
 var __WEBPACK_IMPORTED_MODULE_4__conf05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__conf05__);
 var __WEBPACK_IMPORTED_MODULE_5__conf06__ = __webpack_require__(714);
 var __WEBPACK_IMPORTED_MODULE_5__conf06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__conf06__);
 var __WEBPACK_IMPORTED_MODULE_6__conf07__ = __webpack_require__(715);
 var __WEBPACK_IMPORTED_MODULE_6__conf07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__conf07__);
 var __WEBPACK_IMPORTED_MODULE_7__conf08__ = __webpack_require__(716);
 var __WEBPACK_IMPORTED_MODULE_7__conf08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__conf08__);
 var __WEBPACK_IMPORTED_MODULE_8__conf09__ = __webpack_require__(717);
 var __WEBPACK_IMPORTED_MODULE_8__conf09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__conf09__);
 var __WEBPACK_IMPORTED_MODULE_9__conf10__ = __webpack_require__(718);
 var __WEBPACK_IMPORTED_MODULE_9__conf10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__conf10__);
 __webpack_exports__["a"] = (Object.assign({},__WEBPACK_IMPORTED_MODULE_0__conf01__["a" ],__WEBPACK_IMPORTED_MODULE_1__conf02__["a" ],__WEBPACK_IMPORTED_MODULE_2__conf03___default.a,__WEBPACK_IMPORTED_MODULE_3__conf04___default.a,__WEBPACK_IMPORTED_MODULE_4__conf05___default.a,__WEBPACK_IMPORTED_MODULE_5__conf06___default.a,__WEBPACK_IMPORTED_MODULE_6__conf07___default.a,__WEBPACK_IMPORTED_MODULE_7__conf08___default.a,__WEBPACK_IMPORTED_MODULE_8__conf09___default.a,__WEBPACK_IMPORTED_MODULE_9__conf10___default.a));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(151);
 var __WEBPACK_IMPORTED_MODULE_1_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_1_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_2_components_LanguageSelector_modules__ = __webpack_require__(653);
 var __WEBPACK_IMPORTED_MODULE_3_components_Dashboard_modules_dashboard__ = __webpack_require__(343);
 var __WEBPACK_IMPORTED_MODULE_4_routes_Login_modules__ = __webpack_require__(686);
 var __WEBPACK_IMPORTED_MODULE_5_routes_Signup_modules_signup__ = __webpack_require__(157);
 var __WEBPACK_IMPORTED_MODULE_6_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_7_routes_MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_8_routes_Narratives_modules__ = __webpack_require__(82);
 var __WEBPACK_IMPORTED_MODULE_9_components_Narratives_MTP_modules__ = __webpack_require__(692);
 var __WEBPACK_IMPORTED_MODULE_10_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_11_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_12_modules_socket__ = __webpack_require__(695);
 var __WEBPACK_IMPORTED_MODULE_13_components_Searcher_modules_searcher__ = __webpack_require__(354);
 var __WEBPACK_IMPORTED_MODULE_14_components_ThinkTanks_modules__ = __webpack_require__(697);
 var __WEBPACK_IMPORTED_MODULE_15_components_NotificationsModal_modules__ = __webpack_require__(698);
 var __WEBPACK_IMPORTED_MODULE_16_components_Boost_modules__ = __webpack_require__(699);
 var __WEBPACK_IMPORTED_MODULE_17_components_Tools_modules__ = __webpack_require__(700);
 var __WEBPACK_IMPORTED_MODULE_18_modules_steps__ = __webpack_require__(701);
 var __WEBPACK_IMPORTED_MODULE_19_modules_callForImpact__ = __webpack_require__(702);
 var __WEBPACK_IMPORTED_MODULE_20_modules_elements__ = __webpack_require__(703);
 var __WEBPACK_IMPORTED_MODULE_21_modules_zoom__ = __webpack_require__(704);
 var __WEBPACK_IMPORTED_MODULE_22_modules_serendipity__ = __webpack_require__(705);
 var __WEBPACK_IMPORTED_MODULE_23_modules_speedDating__ = __webpack_require__(706);
 var __WEBPACK_IMPORTED_MODULE_24_modules_think_seeds__ = __webpack_require__(707);
 var __WEBPACK_IMPORTED_MODULE_25__global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_26__userConnections__ = __webpack_require__(125);
// import { reducer as idle } from 'modules/idleMonitor';
 __webpack_exports__["a"] = ({router:__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["c" ],session:__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionReducer"],i18n:__WEBPACK_IMPORTED_MODULE_2_components_LanguageSelector_modules__["a" ],// idle,
login:__WEBPACK_IMPORTED_MODULE_4_routes_Login_modules__["a" ],signup:__WEBPACK_IMPORTED_MODULE_5_routes_Signup_modules_signup__["a" ],global:__WEBPACK_IMPORTED_MODULE_25__global__["a" ],app:__WEBPACK_IMPORTED_MODULE_6_modules_app__["a" ],mainPageData:__WEBPACK_IMPORTED_MODULE_7_routes_MainPage_modules_mainPage__["a" ],dashboard:__WEBPACK_IMPORTED_MODULE_3_components_Dashboard_modules_dashboard__["a" ],MTPData:__WEBPACK_IMPORTED_MODULE_9_components_Narratives_MTP_modules__["a" ],navbar:__WEBPACK_IMPORTED_MODULE_10_components_Navbar_modules__["a" ],chats:__WEBPACK_IMPORTED_MODULE_11_modules_chats__["c" ],socket:__WEBPACK_IMPORTED_MODULE_12_modules_socket__["a" ],searcher:__WEBPACK_IMPORTED_MODULE_13_components_Searcher_modules_searcher__["a" ],userConnections:__WEBPACK_IMPORTED_MODULE_26__userConnections__["b" ],narratives:__WEBPACK_IMPORTED_MODULE_8_routes_Narratives_modules__["c" ],thinkChats:__WEBPACK_IMPORTED_MODULE_24_modules_think_seeds__["a" ],thinkTanks:__WEBPACK_IMPORTED_MODULE_14_components_ThinkTanks_modules__["a" ],tools:__WEBPACK_IMPORTED_MODULE_17_components_Tools_modules__["a" ],boost:__WEBPACK_IMPORTED_MODULE_16_components_Boost_modules__["a" ],steps:__WEBPACK_IMPORTED_MODULE_18_modules_steps__["a" ],zoom:__WEBPACK_IMPORTED_MODULE_21_modules_zoom__["a" ],notificationsModal:__WEBPACK_IMPORTED_MODULE_15_components_NotificationsModal_modules__["a" ],callForImpact:__WEBPACK_IMPORTED_MODULE_19_modules_callForImpact__["a" ],elements:__WEBPACK_IMPORTED_MODULE_20_modules_elements__["a" ],serendipity:__WEBPACK_IMPORTED_MODULE_22_modules_serendipity__["a" ],speedDating:__WEBPACK_IMPORTED_MODULE_23_modules_speedDating__["a" ]});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = i18nReducer;
 var __WEBPACK_IMPORTED_MODULE_0_i18n__ = __webpack_require__(654);
 var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_objects__ = __webpack_require__(341);
 var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(342);
// import { getBrowserLanguage } from 'utils/language';
// const USER_LANG = getBrowserLanguage();
var USER_LANG='en';var INITIAL_LANG_CONF={language:USER_LANG,additionalLanguages:[],literals:__WEBPACK_IMPORTED_MODULE_0_i18n__["a" ][USER_LANG]};function i18nReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_LANG_CONF;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_3__types__["b" ]:{var literalsObjects=[];if(typeof __WEBPACK_IMPORTED_MODULE_0_i18n__["a" ][payload]!=='undefined'){literalsObjects.push(__WEBPACK_IMPORTED_MODULE_0_i18n__["a" ][payload]);}__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(state.additionalLanguages,function(additionalLanguage){literalsObjects.push(__WEBPACK_IMPORTED_MODULE_0_i18n__["a" ][additionalLanguage]);});var literals={};__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(literalsObjects,function(literalObject){Object(__WEBPACK_IMPORTED_MODULE_2_utils_objects__["b" ])(literals,literalObject);});return{language:payload,literals:literals};}case __WEBPACK_IMPORTED_MODULE_3__types__["a" ]:{var _literalsObjects=[];if(typeof __WEBPACK_IMPORTED_MODULE_0_i18n__["a" ][state.language]!=='undefined'){_literalsObjects.push(__WEBPACK_IMPORTED_MODULE_0_i18n__["a" ][state.language]);}__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(payload,function(additionalLanguage){_literalsObjects.push(__WEBPACK_IMPORTED_MODULE_0_i18n__["a" ][additionalLanguage]);});var _literals={};__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(_literalsObjects,function(literalObject){Object(__WEBPACK_IMPORTED_MODULE_2_utils_objects__["b" ])(_literals,literalObject);});return Object.assign({},state,{additionalLanguages:payload,literals:_literals});}default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ES__ = __webpack_require__(655);
 var __WEBPACK_IMPORTED_MODULE_1__EN__ = __webpack_require__(656);
 var __WEBPACK_IMPORTED_MODULE_2__SPARKS__ = __webpack_require__(657);
 var __WEBPACK_IMPORTED_MODULE_3__ACCIO__ = __webpack_require__(658);
 __webpack_exports__["a"] = (Object.assign({},__WEBPACK_IMPORTED_MODULE_0__ES__["a" ],__WEBPACK_IMPORTED_MODULE_1__EN__["a" ],__WEBPACK_IMPORTED_MODULE_2__SPARKS__["a" ],__WEBPACK_IMPORTED_MODULE_3__ACCIO__["a" ]));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ({es:{login:{title:'Login',description:'Powered by RISE. WORKS @ 2019.',name:'Nombre',email:'Email',password:'Contraseña',separatorText:'ó',actionBtn:'Entrar',linkedInActionBtn:'Entrar con LinkedIn',rememberPassword:'¿Has olvidado tu contraseña?',register:'... o regístrate',signupTitle:'Sed pellentesque',signupDescription:'Praesent vulputate tempus libero, accumsan eleifend dui ornare viverra. Ut gravida lorem sit amet mi consequat mollis.',signupActionBtn:'Regístrate',error:{require:'Este campo es obligatorio.',email:'Introduce un email válido.'}},navbar:{logout:'Logout',profile:'Perfil',altPhoto:'Foto'},confirmModal:{accept:'Aceptar',cancel:'Cancelar'},shareModal:{title:'Share Think Tank URL'},forgetPassword:{title:'Restablecer contraseña',userEmail:'Email',userEmailPlaceholder:'Introduce tu email de usuario',enterYourEmailAddress:'Introduce tu dirección de correo.',emailWillBeSent:'Te enviaremos un email para restablecer tu contraseña.',emailSent:'Te hemos enviado un email para restablecer tu contraseña.',checkInbox:'Comprueba tu bandeja de entrada de ',resetPasswordAction:'Restablecer contraseña',acceptAction:'Aceptar'},narratives:{yes:'Yes',no:'No'},signup:{title:'Lorem ipsum',description:'Sponsored by Fundación Rafael del Pino.',firstName:'Nombre',lastName:'Apellido',email:'Email',password:'Contraseña',image:'Foto',separatorText:'ó',actionBtn:'Regístrate',linkedInActionBtn:'Registrate con LinkedIn',loginTitle:'Sed pellentesque',rule:'¿Aceptas nuestros términos y condiciones?',loginActionBtn:'Entrar',termTitle:'Acepta primero las condiciones de uso.',termDescription:'It\'s ok to send me (very occasional) email with news about the Wuzzin service.By proceeding to create your account and use Wuzzin, you are agreeing to our Terms of Service and Privacy Policy.If you do not agree, you cannot use Wuzzin.',avatar:{title:'Editar Imagen',zoom:'Zoom',rotate:'Rotar 90º',ok:'OK'},error:{require:'Este campo es obligatorio.',email:'Introduce un email válido.'}},profile:{title:'Perfil',description:'Sponsored by Fundación Rafael del Pino',firstName:'Nombre',lastName:'Apellido',email:'Email',password:'Contraseña',image:'Foto',separatorText:'o',actionBtn:'Actualizar',cancel:'Cancelar',error:{require:'Este campo es obligatorio.',email:'Introduce un email válido.',passwordDontMatch:'Las contraseñas no coinciden'},avatar:{title:'Editar Imagen',zoom:'Zoom',rotate:'Rotar 90º',ok:'OK'},editProfile:'Editar perfil',logout:'Cerrar sesión',resume:'Resumen',connections:'Conexiones',privacy:'Privacidad',users:'Usuarios',overview:'Presentación',category:'Categoría',entity:'Entidad',foundationStudies:'Estudios cursados en la fundación',gender:'Sexo',position:'Cargo',residence:'Residencia',studies:'Estudios',universities:'Universidades',universityStudies:'Estudios universitarios',male:'Hombre',female:'Mujer',visibleForAll:'Visible para todo el mundo',shareInC2i:'Compartido en /Ci',shareWithUsersConnected:'Compartido con usuarios con los que estoy conectado',private:'Privado',defaultOption:'Opción por defecto',data:'Información',usersWithHowYouAreConnected:'Usuarios con los que estás conectado',usersYouHaveRequestedToConnect:'Usuarios seleccionados por ti',usersWhoWantToConnectWithYou:'Usuarios que quieren conectar contigo',profile:'Perfil',settings:'Ajustes',notifications:'Notificaciones',sendMeUserSuggestions:'Enviarme recomendaciones de usuarios a mi email',notifyMeWhenAUserWantsToContactMe:'Avisarme cuando un usuario quiera contactar conmigo',notifyMeWhenAUserSendsMeAMessage:'Avisarme cuando un usuario me envie un mensaje',yourAccount:'Tu cuenta',changePassword:'Cambiar mi contraseña',change:'Cambiar',deleteAccount:'Eliminar mi cuenta',delete:'Eliminar',actualPassword:'Contraseña actual',newPassword:'Nueva contraseña',repeatNewPassword:'Repite contraseña',close:'Cerrar',errorTitle:'Error',changesSaved:'Cambios guardados',passwordChanged:'Se ha cambiado correctamente la contraseña',deleteExplanation:'Si continuas se programará la eliminación de tu cuenta para las próximas 24 horas. En este tiempo podrás cancelar el borrado de tu cuenta en cualquier momento accediendo desde el link que encontrarás en el email que se te enviará al continuar.',deleteAccountSuccess:'Se ha programado la eliminación de tu cuenta. En unos momentos recibirás un correo con un enlace para cancelar el borrado antes de que se produzca el borrado definitivo en 24 horas.'},zoomMeeting:{startingMeetingIn:'Iniciando reunion en',seconds:'segundos.',problemOpenNewWindow:'Si tienes algun problema con la reunion puedes intentar abrirla en la aplicacion de Zoom.',openANewWindow:'Abrir Zoom',timeLeft:'Tiempo restante',viewProfile:'Ver perfil',addOneMinute:'+1 minuto',finish:'Finalizar',confirmText:'¿Estas seguro de que quieres finalizar la reunion?'},mainpage:{welcome:'Bienvenido',title:'Ecosystem',description:'These are other people from Amigo, Singularity, Colaborador, Otras Becas, Investigacion. Please sort the ones you know more.',bubbleTitle:'This is the profile distribution in the audience so far.',pieTitle:'In Rise you will find several graphs to show you the information',barTitle:'These are technologies considered by the audience critical pursue in Spain.',freeResponseTitle:'<general>¿Conoces alguna otra empresa que trabaje en <insight>Swarm Robotics</insight>?</general>'},userCard:{sendMessage:'Enviar mensaje',connect:'Conectar',deleteConnection:'Eliminar conexión',resume:'Resumen',connections:'Conexiones',overview:'Presentación',category:'Categoría',entity:'Entidad',foundationStudies:'Estudios cursados en la fundación',gender:'Sexo',position:'Cargo',residence:'Residencia',studies:'Estudios',universities:'Universidades',universityStudies:'Estudios universitarios',male:'Hombre',female:'Mujer',data:'Información'},chat:{noChats:'Todavía no has iniciado ninguna conversación',title:'Messages',yourMessage:'Tu mensaje',today:'Hoy',newMessages:'Nuevos mensajes'},searcher:{search:'Busca por tus intereses',viewMore:'Cargar mas'},usersProfiles:{weFoundTheseUsers:'Hemos encontrado estos usuarios que pueden interesarte para tus objetivos',recommendations:'Recomendaciones'},userProfile:{userProfile:'Perfil de usuario'},cancelDeletionAccount:{text:'Haciendo click en el siguiente botón cancelarás el borrado de tu cuenta.',title:'Eliminar cuenta',cancel:'Cancelar',cancelled:'Borrado cancelado',deletionAccountHasBeenCancelled:'Se ha cancelado el borrado de tu cuenta',error:'Error',errorDeletion:'No se ha podido cancelar el borrado de la cuenta. Esto puede ser porque ya se haya producido o porque se hubiera cancelado anteriormente.',close:'Cerrar'}}});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ({en:{login:{title:'Login',description:'Powered by Fundación Rafael del Pino @ 2019',name:'Name',email:'Email',password:'Password',separatorText:'or',actionBtn:'Login',linkedInActionBtn:'Login with LinkedIn',rememberPassword:'Forgot your password?',register:'..or Register?',signupTitle:'Sed pellentesque',signupDescription:'Praesent vulputate tempus libero, accumsan eleifend dui ornare viverra. Ut gravida lorem sit amet mi consequat mollis.',signupActionBtn:'Sign up',error:{require:'This value is required.',email:'This value is not email.'},footerText:'/ rise',titleText:'Call for impact',loginAccount:'Login into your account',registry:'Registry'},navbar:{logout:'Logout',profile:'Profile',altPhoto:'Photo'},forgetPassword:{title:'Please insert a valid email address',userEmail:'Email',userEmailPlaceholder:'Enter your user email',enterYourEmailAddress:'Enter your email address.',emailWillBeSent:'We will send you an email to reset your password.',emailSent:'We have sent you an email to reset your password.',checkInbox:'Check your inbox  ',resetPasswordAction:'Send email',acceptAction:'Accept',goBack:'Go back to Login'},signup:{existUserInvitation:'The invitation email address already exists. Please access the login to enter with your credentials.',registry:'Registry',title:'Seize Serendipity',description:'Powered by Fundación Rafael del Pino @ 2019',firstName:'First name',lastName:'Last name',email:'Email',password:'Password',image:'Photo',separatorText:'or',actionBtn:'Sign up',linkedInActionBtn:'Sign up with LinkedIn',linkedInText:'Enter your LinkedIn Profile for more relevant recommendations.',linkedInUrl:'Enter link to your LinkedIn profile',photoText:'A profile with a photo is more likely to generate good connections.',photoPutFace:'Do you dare to put on a face?',photoAddProfile:'Add profile picture',photoSubtext:'You can change your profile picture from the Me menu of the app.',loginTitle:'Sed pellentesque',rule:'Do you agree and accept ',rule2:'our terms?',loginActionBtn:'..or Login',termTitle:'Conditions',next:'Next',termDescription:'You must accept the terms to signup',uploadingPhoto:'Uploading picture',avatar:{title:'Edit Picture',zoom:'Zoom',rotate:'Rotate 90º',ok:'OK'},error:{require:'This value is required.',email:'This value is not email.'},enterData:'Enter your data.',yourAffiliation:'If your affiliation has offered us your data, this process will be much shorter.',registryNotAvailable:'Registry is not available. We\'re still in internal ALPHA sandbox',backToLogin:'Back to login'},profile:{title:'My profile',clickToEdit:'click to edit',subtitle1:'Define how others see you.',subtitle2:'Manage your data, your hopes and your dreams.',description:'Sponsored by Fundación Rafael del Pino',firstName:'First name',lastName:'Last name',email:'Email',password:'Password',image:'Photo',separatorText:'or',actionBtn:'Update',accept:'Accept',cancel:'Cancel',goBack:'Go Back',yourDataYourChoice:'Your Data, Your Choice',defineYourMTP:'Define your Transformative Purpose',define:'Define',error:{require:'This value is required.',email:'This value is not email.',firstname:'Please insert your first name',lastname:'Please insert your last name',passwordDontMatch:'Password don\'t match'},viewPurpose:'View purpose',avatar:{title:'Edit Picture',zoom:'Zoom',rotate:'Rotate 90º',ok:'OK'},connections:'Connections',pins:'Pins',noConnections:'No Connections',noPins:'No Pins',editProfile:'Edit profile',logout:'Logout',resume:'BASIC PROFILE',privacy:'Privacy',users:'users',overview:'Overview',category:'Category',entity:'Entity',foundationStudies:'Studies taken at the foundation',gender:'Gender',position:'Position',residence:'Residence',studies:'Studies',universities:'Universities',universityStudies:'University studies',male:'Male',female:'Female',visibleForAll:'Visible for everybody',shareInC2i:'Shared within /Ci',shareWithUsersConnected:'Shared with users with whom I am connected',private:'Private',defaultOption:'Default option',data:'ANSWERS',usersWithHowYouAreConnected:'Users with whom your are connected',usersYouHaveRequestedToConnect:'Users you have requested to connect',usersWhoWantToConnectWithYou:'Users who want to connect with you',profile:'Profile',settings:'Settings',notifications:'Notifications',sendMeUserSuggestions:'Send me user recommendations to my email',notifyMeWhenAUserWantsToContactMe:'Notify me when a user wants to contact me',notifyMeWhenAUserSendsMeAMessage:'Notify me when a user sends me a message',yourAccount:'Your account',changePassword:'Change password',change:'Change',deleteAccount:'Delete account',delete:'Delete',actualPassword:'Actual password',newPassword:'New password',repeatNewPassword:'Repeat password',close:'Close',errorTitle:'Error',changesSaved:'Changes saved',passwordChanged:'The password has been successfully changed',deleteExplanation:'If you continue, the deletion of your account will be scheduled for the next 24 hours. In this time you can cancel the deletion of your account at any time by accessing the link you will find in the email that will be sent to you when you continue.',deleteAccountSuccess:'The deletion of your account has been scheduled. In a few moments you will receive an email with a link to cancel the deletion before the final erasure occurs in 24 hours.',erase:'ERASE',nuclearOption:'Nuclear Option',eraseAllData:'Erase all your data',easeAllDataSub:'You are about to delete your account and all your information.',wantDelete:'I want to delete',gpdr:'Personal data',gpdrNotice:'You are about to delete your account and all your information. We are sad that you want to leave, but remember that you can come back at any time. To continue with the deletion you must enter your password.',eraseSuccess:'Your account is scheduled to be deleted within 24 hours. You will receive an email with instructions in case you want to cancel this process.',personalInterest:'Personal Interests',otherPI:'Other Personal Interests',loading:'Loading...',callForImpact:'Impact Events',tables:'Tables',noContent:'No content here',noContentSub:'Complete your info in the "Fine Tune" section.'},mainpage:{welcome:'Welcome',title:'Ecosystem',description:'These are other people from Amigo, Singularity, Colaborador, Otaras Becas, Investigacion. Please sort the ones you know more.',bubbleTitle:'This is the profile distribution in the audience so far.',pieTitle:'In Rise you will find several graphs to show you the information',barTitle:'These are technologies considered by the audience critical pursue in Spain.',freeResponseTitle:'<general>Do you know of any other company working on <insight>Swarm Robotics</insight>?</general>',scatterTitle:'This is Scatter Title',viewMoreCards:'View more cards',previous:'Previous',next:'Next'},dashboard:{updates:'Updated',hiperlinkForImpact:'Hiperlinks for impact'},cards:{select:'Select',unselect:'Unselect'},generalModal:{yes:'Yes',no:'No'},narratives:{yes:'Yes',no:'No',theseArePeopleInterestedInThe:'These are people from the ecosystem interested in the',selectOneYouGladToWorkWith:'Select the ones you would be glad to work with.',theseAreTheMostFrequentlySelected:'These are the most frequently selected',mtp:{aboutMTP:'<strong>About</strong> massive transformative purposes',whatIsAnMTP:'What <strong>IS</strong> an MTP?',whatIsNotAnMTP:'What is <strong>NOT</strong> an MTP?',examplesOfMTPs:'<strong>Examples</strong> of MTP\'s',createMTP:'<strong>Create</strong> a massive transformative purpose',shareAndAlign:'<strong>Share & Align</strong>',send:'Send',addAnotherMTP:'Add another MTP',pressToUploadImage:'Press to Upload an image',uploading:'Uploading',inputARealMTP:'Input a real MTP',tag:'Tag',insertSomeText:'Enter some text',sent:'Sent',topicsAndKeywords:'Topics & Keywords',headlinesFromTheFuture:'Headlines from the future',entermyMTP:'Enter my MTP',whatChallengesAreYouMostInterested:'What <strong>CHALLENGES</strong> are you more interested in?',whatCollectiveWouldYouLikeToFocusOn:'What <strong>COLLECTIVES</strong> would you like to focus on?',actionsDescription:'These are the most frequently selected <strong>ACTIONS</strong>. Which one would you like to focus on?',otherActions:'Other actions...',child:'Child',women:'Women',elderly:'Elderly',society:'Society',humanity:'Humanity',other:'Other',insertYourCollective:'Insert your collective',selectedKeywords:'Selected keywords',mtpsPhrasesDescription:'Insert <strong>3 headlines</strong> for your MTPs',plaseShareOptimisticHeadline:'Please share <strong>1 optimistic headline</strong> you would like to read in the news during your lifetime.',headlinesProposedByPeers:'These are some of the headlines proposed by your peers. Swipe to view more.'}},modalInformation:{},formElement:{pressToUploadImage:'Press to upload image',uploading:'Uploading...',name:'Name',description:'Description',tags:'Tags',send:'Send',sent:'Sent',errorName:'Please insert a name',errorUploadingImage:'Please wait until the image is uploaded'},listComponent:{other:'other',searchOrCreate:'Search or create',usersIn:'Users in',searchElement:'Type to search element',searchElementOrCreate:'Type to search or create element'},userCard:{sendMessage:'Send message',connect:'Connect',deleteConnection:'Delete connection',resume:'RESUME',connections:'Connections',overview:'Overview',category:'Category',entity:'Entity',foundationStudies:'Studies taken at the foundation',gender:'Gender',position:'Position',residence:'Residence',studies:'Studies',universities:'Academic Background',universityStudies:'University studies',male:'Male',female:'Female',data:'ANSWERS',edit:'Edit',save:'Save',noInfo:'Oops!! This information is not available yet.',loadingUserInfo:'Loading user profile...',compare:'COMPARE',sharedElements:'Shared elements',tables:'Tables',call:'Call',callCompare:'You are already working together on',tablesCompare:'You are coinciding at',sharesInterestsCompare:'You have shared interests',youHaveNoCommonElemments:'You have no elements in common.',viewPurpose:'View purpose',noUserData:'Oops, there is no user information',noUserAnswers:'Oops, there is no user data',elements:{relation_co:'Affiliations'},elementsDescription:{relation_co:'You were colleagues at',default:'You are coinciding at'}},chat:{chat:'CHAT',hide:'Hide',noChats:'You have not started any conversations yet',title:' New Table',subtitle:'Tables are temporary. After 7 days participants can either let them die or launch Think Tanks to evolve the conversation.',yourMessage:'Your message',today:'Today',newMessages:'New messages',thinkSeedClosed:'This Table is closed',lessOneMinute:'Less than 1 minute left!',lessThan:'Less than',minutesLeft:'minutes left!',lessThanOneHourLeft:'Less than 1 hour left!',hoursLeft:'hours left!',usersInChat:'Users in this Table',description:'Description',delete:'Leave and delete',areYouSureToLeave:'Are you sure you want to leave?',joinedChat:'has joined the Table.',leftChat:'has left the Table',invitations1:'You have been sent ',invitations2:' invitations',noChatsAlt:'No Tables',startANewChat:'Start a new Table with...',newChat:'New Chat',newChatTitle:'Select a contact with whom start a new chat',existingChats:'Ongoing Tables',thinkSeeds:'Tables',launchKill:'Launch/Kill',launch:'Launch',expand:'Expand',boost:'Boost',canContribute:'Can contribute',investment:'Investment',experience:'Experience',contacts:'Contacts',clients:'Clients/Diffusion',ideas:'Ideas',timeWork:'Time/Work',assets:'Assets (Hardware/Software)',mustLeadTheProject:'Must lead the project',iMustLeadTheProject:'I must lead the project',oneVote:'1 vote',votes:'votes',yourSelectionAsLeader:'Your selection as leader - ',actualLeader:'Actual leader',and:'and',you:'you',getOut:'Are you sure to get out of this Table?',openChats:'Open Chats',firstMessage:'Welcome to the chat. Be the first to welcome other members of the community.'},invitations:{invitations:'Your invitations',accept:'Accept',reject:'Reject',areYouSureReject:'Are you sure you want to reject the invitation?',areYouSureAccept:'Are you sure you want to accept the invitation?',noInvitations:'There are no invitations'},confirmModal:{accept:'Accept',cancel:'Cancel'},shareModal:{title:'Share this Table'},searcher:{search:'Search',viewMore:'Load more'},usersProfiles:{weFoundTheseUsers:'We have found users who may interest you',recommendations:'Recommendations'},userProfile:{userProfile:'User profile'},cancelDeletionAccount:{text:'By clicking on the following button you will cancel the deletion of your account.',title:'Delete account',cancel:'Cancel',cancelled:'Delete canceled',deletionAccountHasBeenCancelled:'You have canceled the deletion of your account',error:'Error',errorDeletion:'The deletion of the account could not be canceled. This may be because it has already occurred or because it had been canceled previously.',close:'Close'},feedbackUser:{viewProfile:'View Profile',iAlreadyKnowHim:'We are Friends',modalThinkChatTitle:'You have joined the Think-Chat',modalThinkChatSubtitle:'Please indicate how you can contribute to this project',investment:'Investment',experience:'Experience',contacts:'Contacts',clients:'Clients/Diffusion',ideas:'Ideas',timeWork:'Time/Work',assets:'Assets (Hardware/Software)',others:'Others',save:'Save',skip:'Skip',otherContributionsPlaceholder:'What else can you contribute?',loadingUserInfo:'Loading user info...'},mainMenu:{goals:'Goals',connect:'Connect',discover:'Discover',messaging:'Think',me:'Me',continue:'Next',initiatives:'/Ci'},connections:{title:'Your Connections',description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque nisl eros, pulvinar facilisis justo mollis, auctor consequat urna. Morbi a bibendum metus. Donec scelerisque sollicitudin enim eu venenatis.',people:'PEOPLE',topics:'TABLES',contacts:'Contacts',content:'CONTENT',subtitle1:'Find, accept and manage connections.',subtitle2:'Only once both accept you can start interacting.',usersWithHowYouAreConnected:'Users with whom your are connected',usersYouHaveRequestedToConnect:'Users you have requested to connect',usersWhoWantToConnectWithYou:'Users who want to connect with you',noConnections:'No Connections',recommendedUsers:'Discover users',viewAll:'View all',close:'Close',yourNetwork:'Your network',searchConnections:'Search Connections',chats:'CHATS',noUsers:'There is are users',connections:'Connections',elements:{relation_co:'AFFILIATIONS',company:'COMPANIES'}},userCardResume:{noTagsMessage:'There are opportunities linked to data that have not been made public',firstname:'Name',lastname:'Surname',overview:'Overview',noOverview:'Short Bio + Current Position',noMTP:'Define your Transformative Purpose',mtp:'Massive Transformative Purpose',viewLess:'View less',privacity:'Privacidad',visibleForAll:'Visible for everybody',shareInC2i:'Shared within /Ci',shareWithUsersConnected:'Shared with users with whom I am connected',private:'Private',viewProfile:'View profile',avatar:{title:'Edit Picture',zoom:'Zoom',rotate:'Rotate 90º',ok:'OK'},colleagues:'You were colleagues at ',complementaryTags:'Complementary Tags',personalInterests:'Personal Interests',sharedInterests:'Shared Interests',otherInterests:'Other Personal Interests',workingTogether:'You are already working together on ',canYouHelp:'Personal Call for Impact',goToMtpNarrative:'Help me define my transformative purpose >>',ageRangeSentence:'is in the',ageRangeSentence2:'age range',and:'and',collectiveSentence:'belongs to the',collectiveSentence2Singular:'group',collectiveSentence2Plural:'groups',isSeekingFor:'is seeking for',hasAprojectCanHelpIn:'has a project that can help in',sentenceBusinessModel1:'is working in a',sentenceBusinessModel2:'business model',sentenceUserProjectStatus1:'has a project in',sentenceUserProjectStatus2:'status',sentenceUserFunding1:'is looking for',sentenceUserFunding2:'funding',sentenceInvestorProjectHelp1:'wants to help in the',sentenceInvestorProjectHelp2:'areas',sentenceInvestorODS1:'is looking for projects that can help in',sentenceInvestorODS2:'Sustainable Development Goals',sentenceInvestorBusinessModel1:'wants to invest in projects with',sentenceInvestorBusinessModel2:'business model',sentenceInvestorProjectStatus1:'is interested in projects in the following states:',sentenceInvestorFunding1:'is looking for',sentenceInvestorFunding2:'investment',sentenceProfileDomain1:'belongs to',sentenceProfileDomain2:'domains',sentenceProfileInto1:'belongs to',sentenceProfileInto2Singular:'area',sentenceProfileInto2Plural:'areas',sentenceProfileProgram1:'has been in',sentenceProfileProgram2Singular:'program',sentenceProfileProgram2Plural:'programs',sentenceProfileConnections1:'is interested in connect with',sentenceProfileFieldConnect1:'wants to connect on',sentenceProfileFieldConnect2Singular:'field',sentenceProfileFieldConnect2Plural:'fields',guideMe:'Guide Me - Improve my profile',clickToEdit:'- click a tag to edit :)'},splashScreen:{welcomeBack:'Welcome back ',letsContinue:', let\'s continue where we left off',redirectingToMeeting:'Redirecting to meeting'},gpdr:{title:'Personal data',profile:'Profile'},subOptions:{send:'Send'},creationThinkSeed:{newTable:'Create a table',pressToUploadImage:'Press to Upload an image',uploading:'Uploading',name:'Name',description:'Description',send:'Send',sent:'Sent',errorName:'Please insert a name',errorUploadingImage:'Please wait until the image is uploaded',create:'Create',errorSaving:'Error saving',saving:'Saving',invite:'Invite',success1:'A new Table called',noThanks:'No, thanks',success2:' has been created. You can find it in your Table section and it will be available for 7 days. From here we recommend some users that we believe can provide you with value when it comes to achieving your goal.',selectAtLeastOneUser:'Select at least one user',invitationsHasBeenSent:'The invitations have been sent. Slide down to go to the next step.',invitationsHasBeenSent2:'The invitations have been sent. You can find the think-seed in the Table section.',noInvitationsSent:'You can find the think-seed in the Table section',title:'Create Table',titleName:'Title',createdIn:'Table is being created in',timeLife:'Time of life',speedDating:'Speed dating',date:'Date',hour:'Hour',privateTable:'Private table',onlyInvited:'Only the users you invite will see the table',tags:'Tags',defaultTitleForm:'<strong>Launch your Table</strong>. You will have 7 days to decide if you want to launch a think tank with your colleagues.',congratulations:'Congratulations!',thinkChatCreated:'Your Table creation has been completed!',continue:'Continue',next:'Next',invitePeopleFromMyNetwork:'Invite people from your network',myNetwork:'My network',relatedTable:'Related Tables',peopleSelected:'People selected',loading:'Loading',youHaveCreateTheTable:'You have created the table succesfully.',addContent:'Add content',welcome:'Welcome to participants',editTable:'Edit table',accept:'Accept',createNewTable:'Create new table'},thinkSeedCard:{users:'Brains already inside:',whatAre:'How it works:',info:'Explore together. Either launch something or kill the Table fast!',expiration:'Table expires in:',seedName:'TABLE',openThinkSeeds:'Number of Tables:',loadingInfo:'Loading info...'},initiatives:{title:'Impact Events',viewProfile:'View Profile',progress:'Your progress',fineTune:'Fine-tune ',serendipity:'Serendipity',complete:'Complete the steps to make better recommendations',start:'Start Guided Steps',enjoy:'Enjoy the <strong>impact</strong> on your phone',subtitle:'Champions with high reputation inside the community have the opportunity to launch calls for impact. Discover trends and find new opportunities for impact. The perfect excuse to work together!',searchInitiatives:'Search initiatives',noNarratives:'No results',agenda:'Agenda',call4ImpactTitle:'Impact <strong>Events</strong>',timeline:'Timeline',call4ImpactDescription:'Select well-respected members of the community will be gradually identified and offered the opportunity of presenting a call for impact.',otherNarrativesTitle:'Narratives',otherNarrativesDescription:'Make the most out of /Ci by completing these items below',notStarted:'Not started',comingSoon:'Coming soon',completed:'Completed',createChat:'Create a Chat',createChatDesc:'Tables are first-level conversation between participants. ',createTable:'Create a Table',createTableDesc:'Tables are second-level conversation around specific topics. ',view:'View',edit:'Edit',objectivesTitle:'Set new objectives',objectivesSubtitle:'/Ci helps you realize your objectives by connecting with other members of the community',toolsTitle:'Available Tools',yourOngoingActivity:'Your <b>ongoing</b> activity',yourPastActivity:'Your <b>past</b> activity',nameTypes:{challenge:'Your challenges',tag:'Your tag'},descriptionTypes:{challenge:'Here you have the challenges you have created',tag:'Here you have the tags you have created'},modifyChallenge:'Lets <strong>modify</strong> your challenges',toolsDescription:'As you evolve on your call for Impact, to a Table and a Think Tank you will unlock several tools to leverage collective intelligence and scale your impact.',recommendedUsers:'Recommended <strong>users</strong>',recommendedTables:'Recommended <strong>tables</strong>',search:'Search',noUsers:'There are no results',noTables:'There are no results'},call4Impact:{timeUntilEvent:'Time until event',joinPreEvent:'Join PRE-Event',joinPostEvent:'Join POST-Event',joinTheEvent:'Event ongoing!',joinGroups:'Join groups',connectToMeeting:'Connect to meeting',joinSpeedDating:'Speed Dating',joinConclusionMeeting:'Join the conclusion meeting',speedDating:'Speed dating',viewTopics:'VIEW TOPICS',hideTopics:'HIDE TOPICS',liveEvent:'Live Event',limitDate:'Deadline',loadingDetails:'Loading info',thereIsNoTopics:'There are no tables',start:'Start',open:'Open',close:'Close',hall:'Hall',live:'Live',details:'VIEW MORE DETAILS',reStart:'Re-start',table:'Table',tables:'Tables',content:'Content',plan:'Plan Speed Dating',planSpeedDating:'Plan Speed Dating',planMeeting:'Meeting'},addUsersChat:{noThanks:'No, thanks',invite:'Invite',title:'Add Users to Table',invitationsSent:'The invitations have been sent.',searchUsers:'Search users',noUsers:'No users found on your network',cancel:'Cancel',sending:'Sending',selected:'selected'},finalStep:{sectionFinished:'It is great to have you here!',goBack:'Section finished',answer:'Press next to continue',sectionFinishedPreEvent:'You have just completed the pre-event. You can continue interacting with matched colleagues, think-chats and think-tanks whilst you wait for the event.',finishPreEvent:'Thank you for participating in the pre-event. You can continue interacting with other participants through think-chats and think-tanks whilst you wait for the event that will happen',finishNarrative:'You have finished the steps in this section. Let’s continue exploring new ways of achieving impact together.',reset:'Reset narrative',resetNarrative:'Are you sure to reset the steps of the narrative?',completedNarrative:'You have <b>completed</b> all current steps in this section',joinOtherImpactObjectives:'Complete sections to <b>fine-tune your recommendations</b>.',goToHall:'Go to Networking Hall'},upgrade:{think:'Think',launchThinkTank:'Launch as think-tank',titleThinkTank:'Now it´s time to decide to launch the think-seed into a think-tank.',descriptionThinkTank:'If you decide to move forward, you will receive support in order to make different types of think-tanks into succesful impact initatives.',killThinkSeed:'Kill this think-seed',titleForm1:'Think tanks are powerful tools',titleForm2:'Let´s start with the basics',name:'Name of Think Tank',description:'Description',members:'Unselect current or add new',next:'Next',calendlyTitle:'And finally, we have selected an expert that will help you set the think/tank up based on the information we have. Please schedule a 15-30 min session to get the ball rolling.',optionsTitle:'All think-tanks have a private area to collaborate and share files with other members. But we can enhance them to help you launch something spectacular:',socialNetworkMovement:'Do your insights need to be assimilated by the masses in order to have an impact? Then you should include Social Network Movement:',socialNetworkMovement2:'Our tools will help you reach hundreds of thousands of targeted citizens and measure assimilation, engagement and conversion.',socialNetworkMovement3:'Ex. Financial Literacy. We shared key insights with 2 million spaniards and converted 21,000 students.',blog:'Do you need to be seen as thought leaders in order to increase your impact? Then publish your insights as a reputable connected site/blog:',blog2:'We include a public area to share conclusions and start creating your niche of leadership.',blog3:'Ex. BioGuía or Capital Radio. Using this same professional CMS they distribute content easily and the site pays for itself.',project:'Do you intend to launch the think-tank as a formal structure with budgets, employees or accounting?  Then you should include this feature.',project2:'Ex. Think tank that expects to generate projects: Vision APP is pushing state of the art in eye-protection for the digital age and generates apps. One is ',project3:' that targets the myopia epidemic.',openInnovation:'Do your challenges require open innovation to increase chances of success? If you feel you will need the /Ci community and other entrepreneurial and scientific communities to play a role having the ability to launch challenges to co-create might be the way to go.',openInnovation2:'Ex. Activate the same tools behind socialab or Open Future.',seeMore:'See more',seeLess:'See less',errorFillAll:'Please fill in all the fields.',backToThink:'Back To Think',fillName:'Fill the name for the think tank',launch:'Launch',info:'Info',options:'Options'},codeofhonor:{title:'Code of honour',p1:'We have a joint mission of positively impact society. We will respect this objective',p2:'As we join, we become colleagues/fellows with other individuals who value Time Well Spent. Our interactions will be thoughtful and respectful concerning privacy and time.',actionBtn:'You have my commitment'},introductionCard:{swipeRight:'Click this button if you are interested.',swipeLeft:'Click this button if it is not your current focus.'},think:{title:'My Tables',thinkChats:'Think-Chats',thinkTanks:'Think-Tanks',thinkChatsDesc:'Tables are first-level conversations to gather around specific topics. Tables are temporary and can evolve into THINK TANKS.',thinkTanksDesc:'Think Tanks host evolved conversations with sophisticated tools that will help articulate a vision.',create:'Create',errorLoadingThinkChats:'Error loading Think-Chats',errorLoadingThinkTanks:'Error loading Think-Tanks',noThinkChatsMsg:'There are no Think-Chats',noMoreThink:'You have not joined any Chats yet',otherThink:'Other ongoing chats',ongoingChats:'Your ongoing <strong>tables</strong>',yourInvitations:'You are <strong>invited</strong>',ending:'Ending in: ',invitedYou:'Has invited you',ignore:'Ignore',join:'Join',noContent:'No content here',noContentSub:'The tables you create and join will appear here',createTable:'Create a table',recommended:'Recommended Tables',noThinkTanksMsg:'There are no Think-Tanks',viewMyInvitations:'View my invitations',thereArePendingRequests:'There are pending requests',moreThanTen:'You are not allowed to join more than 10 Tables.',moreThanThree:'You are currently in three or more Tables, are you sure you are going to be active in all of them?',viewTableDetail:'View table detail',boost:'BOOST',launch:'LAUNCH TABLE',guided:'GUIDED STEPS',kill:'KILL TABLE',endsIn:'Ends in',killed:'KILLED'},thinkTank:{info:'Think Tank Information',chat:'Chat',collaborate:'Collaborate',tools:'Tools',noToolsMsg:'There are no tools',createTool:'Create tool',invitationsSent:'The invitations have been sent.',description:'Description',members:'Members',reqMembers:'Member requests',you:'you',and:'and',noPermissions:'You are not allowed to access this Think Tank. You can request to join so that Think Tank members take you into account and can accept your entry.',sentRequest:'Sent',requestPermission:'Request permission',getOut:'Are you sure to get out of this Think Tank?',delete:'Leave and delete'},tools:{createNewTool:'Create new tool',name:'Name',description:'Description',url:'URL',save:'Save',errorRequiredFields:'Please fill all required fields',edit:'Edit',remove:'Remove',confirmRemoveToolTitle:'Do you want to delete this tool?',confirmRemoveToolSubtitle:'This action cannot be undone',cancel:'Cancel'},boost:{next:'Next',boostYourThinkChatTitle:'Boost your Think-Chat',boostYourThinkChatSubtitle:'Boost your Think-Chat and let the system search for the most suitable candidates to help you in this project.',continue:'Continue',minimumUsersTitle:'Minimum users',minimumUsersSubtitle:'Indicate how many people at least you want to join. Enter a number between 1 and 10.',needsTitle:'Needs',needsSubtitle:'Enter the needs that you need to cover with the new users that join this project.',errorMinimumUsers:'Enter a number between 1 and 10.',errorNeeds:'Enter the needs',urgencyTitle:'Urgency',urgencySubtitle:'Select how urgent the project is and the deadlines in which you want the Boost to run. The longer you leave the better results you can get.',urgencyLow:'No urgent (4 days)',urgencyMedium:'Urgent (3 days)',urgencyHigh:'Very high (24 hours)',errorUrgency:'Select the urgency',labelsTitle:'Labels',labelsSubtitle:'Enter the labels to define this Boost. These labels will serve to find better candidates for this project.',errorLabels:'Enter at least one label.',finish:'Finish',labels:'Labels',errorSaving:'Error saving. A Boost may have already been run on this Think-Chat.',back:'Back',successScreenTitle:'Prepare to have your Think-Chat boosted :)',successScreenSubtitle:'The system will start looking for candidates for your project and we will offer them to join.'},launch:{next:'Next',accept:'Accept',infoInput:'Think Tanks are powerful tools. Let´s start with the basics',infoTerms:'All think-tanks have a private area to collaborate and share files with other members. But we can enhance them to help you launch something spectacular:',insights:'Do your insights need to be assimilated by the masses in order to have an impact? Then you should include Social Network Movement:',need:'Do you need to be seen as thought leaders in order to increase your impact? Then publish your insights as a reputable connected site/blog:',intend:'Do you intend to launch the think-tank as a formal structure with budgets, employees or accounting? Then you should include this feature.',challenges:'Do your challenges require open innovation to increase chances of success? If you feel you will need the /Ci community and other entrepreneurial and scientific communities to play a role having the ability to launch challenges to co-create might be the way to go.',finish:'Finish',users:'Unselect current or add new',text:'Your table time will be unlimited. Do you want to expand?',yes:'Yes',congratsTitle:'Congratulations',congratsText:'Your table now has unlimited time!',no:'No'},deleteAccountSuccess:{title:'Delete account',text:'All your data is being deleted. You will no longer be able to access with your account, but if at any time you want to go back we will be happy to see you here again.',goToLogin:'Go to login'},narrativeThinkChats:{joinGroups:'Join groups',chooseGroups:'Choose the tables that may be of interest to you',noGroups:'There are no tables',backToMainPage:'Back to main page'},speedDating:{title:'Speed dating',noResults:'We have not found any user.',itWillBeTried:'At this time there are no more users to display, it will be tried again in ',noUsers:'At this time there are no more candidates to display.',seconds:'seconds.',backToMainPage:'Back to main page',chooseUsers:'Choose users',titleDesc:'Please select potential candidates for the speed dating',description:'Here the users who have signed up for speed-dating will be displayed so that you can select with whom you would like to have a brief conversation. If they also select you, a match will occur and you will be redirected to a Zoom meeting with them.',selectedUsers:'These are the users you have selected. The system is trying to organize 5 min sessions with them.',pleaseWaitUntilNextMeeting:'Plase wait here until your next meeting starts',matchesDesc1:'They might be in other meetings or they might not have selected not yet.',matchesDesc2:'Please wait a few seconds/minutes and we\'ll organize your next impact date :)',meetingsWillBeginAt:'Meetings will begin at',youHaveShownInterest:'You have shown <strong>interest</strong',scheduledSpeedDatings:'<strong>Scheduled</strong>&nbsp; Speed Datings',startingAt:'Starting at',event:'Event',table:'Table',randomMeetingInProcess:'Your next mystery meeting is being prepared, in a few moments you will be introduced to the user with whom you will share 5 minutes in which you will be able to introduce yourselves.',randomMeetingNotStarted:'The speed dating has not started yet, you can choose the users you would like to have a 5 minutes meeting with by clicking on the "Back to Speed Dating" button, or if you prefer, stay on this screen once it starts so that the system will choose the most interesting users for you based on your interests.',backToSpeedDating:'Back to Speed Dating'},zoomMeeting:{startingMeetingIn:'Starting meeting in',seconds:'seconds.',problemOpenNewWindow:'If you have a problem with the meeting you can try to open it on the Zoom App.',openANewWindow:'Open Zoom',timeLeft:'Time left',viewProfile:'View profile',addOneMinute:'+1 minute',finish:'Finish',confirmText:'Are you sure you want to finish the meeting?',or:' or ',backToHome:'Back to home'},notificationsModal:{go:'Go!',join:'Join',joinThePreEvent:'Join the PRE-Event',joinTheIntroMeeting:'Join the Intro meeting',chooseYourGroups:'Choose your groups to discuss',joinTheSpeedDating:'Join the speed dating',joinTheConclusionsMeeting:'Join the conclusions meeting',joinThePostEvent:'Go to post event',finishSDTitle:'The meeting has finished',finishSDPhrase:'The meeting time is up, you can wait on this screen for the next one to start or return to the home screen to continue browsing. If the meeting has been interesting and you want to have the opportunity to connect with this user once the event is over, click on the "I want to connect with this user" button, and if he also wants to connect with you, a match will take place and you can chat from the "Net Hall" section.',finishSDPhraseRequested:'The meeting time is up, you can wait on this screen for the next one to start or return to the home screen to continue browsing.',finishSDConnectButton:'I want to connect with this user',finishSDRequestSent:'The request has been sent.',goToHome:'Go to home',startSDTitle:'You are in a speed dating with...',startSDPhrase:'You will have up to 5 minutes to introduce yourselves, discuss your topic, and propose the next steps.',goToMeeting:'Go to meeting',wasAlsoLookingForwardsWithYou:'was also looking forward to connect with you!',youAreNowConnected:'You are now connected',close:'Close',speedDatingFeedbackTitle:'Speed dating Feedback',speedDatingFeedbackSubTitle1:'Would you like to add',speedDatingFeedbackSubTitle2:'to your network?',viewProfile:'View profile',notNow:'Not now',proposeToConnect:'Propose to connect',proposeConnectHasBeenSent:'The proposal to connect has been sent',isAlreadyInYourNetwork:'is already in your network.',hasNotYetAcceptedConnectionProposal:'has not yet accepted your connection proposal.'},layout:{myProfile:'My profile',logout:'Logout',search:'Search',serendipity:'Serendipity',closeMenu:'Close Menu',narratives:'Narratives',callForImpacts:'Call for impact',connections:'Net Hall',initiatives:'Impact',initiativesShort:'Impact',initiativesNav:'Impact',chats:'Chats',discover:'Discover',think:'My Tables',me:'Me',fineTune:'Fine Tune',connect:'Net Hall',thinkChats:'Tables',thinkTanks:'Think Tanks',impactTools:'Impact Tools',createTable:'Create a table',createCall:'Create Call for impact',speed:'Request Speed dating',ask:'Ask the ecosystem',noTablesFound:'No tables found',youAreNotInTables:'You are not in any table',impactEvents:'Impact Events'},affiliation:{belong:'I belong to the affiliation',sponsor:'Sponsor of this call for impact',people:'People',tables:'Tables',peopleAndTables:'People & Tables',alreadyBelong:'Remove connection with this affiliation'},people:{filters:'Filters',searchPeople:'Search people',recommended:'Recommended',champions:'Champion Users',online:'Online',cleanFilters:'Clear filters',noUsers:'There are no results',inMyNetwork:'In my network',everyoneInHalls:'Everyone in halls',noRecommendedUsers:'There are no recommended users'},feedbackModal:{close:'Close'},topics:{searchTopics:'Search tables',newTable:'Create a table',filters:'Filters',cleanFilters:'Clear filters',peopleInAllTables:'People in all tables',peopleIn:'People in',inAllTables:'in all tables',in:'in',noTopics:'There are no tables',viewDetails:'View details',elements:{relation_co:'Affiliations'},name:'*Name',description:'*Description',tags:'*Tags',next:'Next',uploadImage:'Press to upload an image'},elementsHall:{noElements:'There are no elements',peopleIn:'People in',allUsers:'All users',search:'Search',filters:'Filters',cleanFilters:'Clear filters',people:'People',tables:'Tables',affiliations:'Affiliations'},themeTablesBubbles:{fullscreen:'Fullscreen',isNew:'New'},themeTable:{themeTable:'Table'},themeTableDetail:{expand:'Expand',joinThisTable:'Join this table',description:'DESCRIPTION',content:'Content',insight:'INSIGHT',chat:'CHAT',topics:'Topics',people:'People',tables:'Tables',affiliations:'Affiliations',leaveTable:'Leave table',editCollab:'Edit Collaborative Conclusions',next:'Next',confirmJoinTable:'Do you want to join this table?',confirmLeaveTable:'Do you want to leave this table?',confirmKillTable:'Do you want to kill this table?',joinRequestSuccessfull:'Your request to join has been sent.',noContent:'Sorry, there is no content at this moment.',youAreAboutToJoinThinkSeed:'You are about to join this table',joinThinkSeedMore3:'You are currently in three or more tables, are you sure you are going to be active in all of them?',joinThinkSeedMore10:'You are not allowed to join more than 10 Tables.',elements:{relation_co:'Affiliations',company:'Companies'},proposedContent:'Content',contributions:'Can contribute',referral:'Referral link',propose:'Propose content to table',collab:'Collaborative doc',attach:'Attachment',prop:'Propose',whatType:'What type of content do you want to propose?',voteup:'Vote Up',voted:'Voted',confirmDelete:'Are you sure you want to delete it?',attachment:'Attachment',file:'File',link:'Link',image:'Image',pdf:'PDF',editTable:'Edit table',deleteUser:'Are you sure you want to delete this user?',deleteTable:'Are you sure you want to delete this table?',speedDating:'Speed Dating',liveEvent:'Live Event',conclusions:'Insights',speaker:'Speaker',addToCalendar:'Add to my calendar',deleteAndCancel:'Delete & Cancel',startingAt:'Starting at:',reView:'Re-View',eventHall:'Event Hall',scheduled:'scheduled',boost:'BOOST',launch:'LAUNCH TABLE',guided:'GUIDED STEPS',kill:'KILL TABLE',starting:'Starting in:',ending:'Ending in',conclusionsAndInsights:'Conclusions & Insights',attachContentToTable:'Attach Content to table',invite:'Invite',fullEdit:'Full edit',viewContent:'View content',invitationsHasBeenSent:'Invitations has been sent',event:'Event',table:'Table',addContent:'Add content',plan:'Plan Speed Dating',mysteryDate:'Mystery Date'},swipeableCards:{maybeLater:'Maybe Later',connected:'You have already shown interest in connecting with this person.',chat:'Chat',openTableToChat:'Open table to chat',goToTable:'Go to table',selectForSpeedDating:'Select for Speed Dating',requestConnection:'Request connection',join:'Join'},thinkSeedContributionForm:{youHaveJoinThinkSeed:'You have joined the Think-Chat',indicateYourContributions:'Please indicate how you can contribute to this project',investment:'Investment',experience:'Experience',contacts:'Contacts',clientsDiffusion:'Clients/Diffusion',ideas:'Ideas',timeWork:'Time/Work',assets:'Assets (Hardware/Software)',others:'Others',whatElse:'What else can you contribute',send:'Send',cancel:'Cancel'},thinkSeedSmallCard:{title:'Table'},thinkTankSmallCard:{title:'Think Tank'},elementSmallCard:{challenge:'Challenge',project:'Project',relation_co:'Community'},narrativeSeedSmallCard:{new:'New',completed:'Completed',updates:'Updated'},topicSmallCard:{thinkChat:'Table'},callforImpactHall:{people:'PEOPLE',chat:'CHAT',contentTag:'EVENTS & CONTENT',tables:'Tables',affiliations:'Affiliations',topics:'TABLES',networkingHall:'Networking Hall',liveEvent:'Live Event',start:'Start',eventHall:'EVENT HALL',reView:'RE-VIEW',joinEvent:'JOIN EVENT',hall:'Hall',addToCalendar:'ADD LIVE EVENT TO CALENDAR',content:'Content',elements:{relation_co:'AFFILIATIONS'},conclusionsAndInsights:'Conclusions & Insights',fullEdit:'Full edit'},narrative:{previous:'Previous',next:'Next'},noRecommendations:{title:'You\'re All Caught Up',description:'You\'ve seen all the relevant content. Take a break or jump into your recent activity.',jumpTo:'Jump to',yourOngoingActivity:'Your <b>ongoing</b> activity',comebackLater:'Comeback later...'},recommendations:{serendipity:'Serendipity',descriptionTables:'These are some of the <strong>tables we think you may be interested in</strong>. Choose the ones you want to participate in, indicate the points in which you think you can contribute the most and start working together with other users to <strong>achieve a real impact<strong>.',descriptionUsers:'These are some of the <strong>users we think you may be interested in</strong>. Check out their profiles and click on the <strong>"Request Connection"</strong> button if you would like a connection opportunity with them. If the other user also requests a connection with you, a match will be made and you can start collaborating together.',noUsers:'No further recommendations at this time',noTables:'No further recommendations at this time'},autocompleteInput:{noResults:'There are no results',create:'Create'},callPhaseCard:{narrative:'Narrative',preEvent:'Pre Event',preEventDesc:'Take a tour of the content of the call to prepare for the event.',meeting:'Meeting',introMeeting:'Intro meeting',tablesMeeting:'Tables meeting',conclusionsMeeting:'Conclusions meeting',speedDating:'Speed Dating',postEvent:'Post Event',introMeetingDesc:'Intro meeting',tablesMeetingDesc:'Tables meeting',conclusionsMeetingDesc:'Conclusions meeting',speedDatingDesc:'Speed Dating',postEventDesc:'Take a look at some of the conclusions of the event'},speedDatingCard:{speedDating:'Speed Dating',meeting:'Meeting'},profileEdit:{firstname:'Firstname',lastname:'Lastname',editProfile:'Edit profile',selectYourGender:'Select your gender',male:'Male',female:'Female',gender:'Gender',overview:'Overview',email:'Email',save:'Save',cancel:'Cancel',errorUploadingImage:'Error uploading image',profileTab:'Profile',passwordTab:'Password',oldPassword:'Insert your actual password',newPassword:'Insert your new password',repeatPassword:'Repeat your new password',passwordsDontMatch:'Passwords do not match',passwordLengthError:'Password must be at least 8 characters',passwordHasBeenChanged:'Your password has been changed'},agenda:{timeline:'Timeline',scheduled:'<strong>Next</strong>‎ Speed - Datings, Meetings, Conferences.'},embedCallForImpactCarousel:{}}});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ({sparks:{initiatives:{title:'Sparks',otherNarrativesTitle:'',otherNarrativesDescription:'SPARKS aims to develop an innovation culture across the company. This pilot aims to promote 5 key innovation habits, aligned with corporate behaviors.',objectivesSubtitle:'Sparks helps you realize your objectives by connecting with other members of the community'},mainMenu:{initiatives:'Sparks'}}});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ({accio:{layout:{discover:'Serendipity',think:'My Tables',thinkChats:'Tables',initiatives:'Impact Events',initiativesShort:'Home',connections:'People´s Hall',callForImpacts:'Flipped events',connect:'Networking',initiativesNav:'Home',narratives:'Fine-Tune Recommendations'},mainMenu:{goals:'Goals',connect:'Networking',discover:'Serendipity',messaging:'Conversations',me:'Me',continue:'Next',initiatives:'Flipped events'},initiatives:{title:'Flipped events',subtitle:'Champions with high reputation inside the community have the opportunity to launch flipped events. Discover trends and find new opportunities for impact. The perfect excuse to work together!',call4ImpactTitle:'Flipped events',call4ImpactDescription:'Select well-respected members of the community will be gradually identified and offered the opportunity of presenting a flipped event.',otherNarrativesTitle:'Fine-Tune Recommendations'},profile:{connections:'Networking',noConnections:'No Networking'},userCard:{sendMessage:'Send message',resume:'RESUME',call:'Call'},connections:{title:'Your Networking',subtitle1:'Find, accept and manage your networking.',noConnections:'No Networking',searchConnections:'Search Connections',connections:'Networking'},callPhaseCard:{narrative:'Fine-Tune Recommendations'}}});

 }),

 (function(module, exports, __webpack_require__) {



// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(660);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


 }),

 (function(module, exports) {



!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(662);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);
var bind = __webpack_require__(345);
var Axios = __webpack_require__(664);
var defaults = __webpack_require__(214);


function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(349);
axios.CancelToken = __webpack_require__(677);
axios.isCancel = __webpack_require__(348);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(678);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


 }),

 (function(module, exports) {



module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(214);
var utils = __webpack_require__(48);
var InterceptorManager = __webpack_require__(672);
var dispatchRequest = __webpack_require__(673);


function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}


Axios.prototype.request = function request(config) {
  
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(347);


module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}


module.exports = function buildURL(url, params, paramsSerializer) {
  
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];


module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

function InterceptorManager() {
  this.handlers = [];
}


InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};


InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};


InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);
var transformData = __webpack_require__(674);
var isCancel = __webpack_require__(348);
var defaults = __webpack_require__(214);
var isAbsoluteURL = __webpack_require__(675);
var combineURLs = __webpack_require__(676);


function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}


module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);


module.exports = function transformData(data, headers, fns) {
  
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(349);


function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}


CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};


CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


 }),

 (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(680);
var parse = __webpack_require__(681);
var formats = __webpack_require__(351);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(350);
var formats = __webpack_require__(351);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(350);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return SET_BREADCRUMB; });
var SET_BREADCRUMB='NAVBAR/SET_BREADCRUMB';

 }),

 (function(module, exports, __webpack_require__) {



(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.chroma = factory());
}(this, (function () { 'use strict';

    var limit = function (x, min, max) {
        if ( min === void 0 ) min=0;
        if ( max === void 0 ) max=1;

        return x < min ? min : x > max ? max : x;
    };

    var clip_rgb = function (rgb) {
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for (var i=0; i<=3; i++) {
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) { rgb._clipped = true; }
                rgb[i] = limit(rgb[i], 0, 255);
            } else if (i === 3) {
                rgb[i] = limit(rgb[i], 0, 1);
            }
        }
        return rgb;
    };

    // ported from jQuery's $.type
    var classToType = {};
    for (var i = 0, list = ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Undefined', 'Null']; i < list.length; i += 1) {
        var name = list[i];

        classToType[("[object " + name + "]")] = name.toLowerCase();
    }
    var type = function(obj) {
        return classToType[Object.prototype.toString.call(obj)] || "object";
    };

    var unpack = function (args, keyOrder) {
        if ( keyOrder === void 0 ) keyOrder=null;

    	// if called with more than 3 arguments, we return the arguments
        if (args.length >= 3) { return Array.prototype.slice.call(args); }
        // with less than 3 args we check if first arg is object
        // and use the keyOrder string to extract and sort properties
    	if (type(args[0]) == 'object' && keyOrder) {
    		return keyOrder.split('')
    			.filter(function (k) { return args[0][k] !== undefined; })
    			.map(function (k) { return args[0][k]; });
    	}
    	// otherwise we just return the first argument
    	// (which we suppose is an array of args)
        return args[0];
    };

    var last = function (args) {
        if (args.length < 2) { return null; }
        var l = args.length-1;
        if (type(args[l]) == 'string') { return args[l].toLowerCase(); }
        return null;
    };

    var PI = Math.PI;

    var utils = {
    	clip_rgb: clip_rgb,
    	limit: limit,
    	type: type,
    	unpack: unpack,
    	last: last,
    	PI: PI,
    	TWOPI: PI*2,
    	PITHIRD: PI/3,
    	DEG2RAD: PI / 180,
    	RAD2DEG: 180 / PI
    };

    var input = {
    	format: {},
    	autodetect: []
    };

    var last$1 = utils.last;
    var clip_rgb$1 = utils.clip_rgb;
    var type$1 = utils.type;


    var Color = function Color() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var me = this;
        if (type$1(args[0]) === 'object' &&
            args[0].constructor &&
            args[0].constructor === this.constructor) {
            // the argument is already a Color instance
            return args[0];
        }

        // last argument could be the mode
        var mode = last$1(args);
        var autodetect = false;

        if (!mode) {
            autodetect = true;
            if (!input.sorted) {
                input.autodetect = input.autodetect.sort(function (a,b) { return b.p - a.p; });
                input.sorted = true;
            }
            // auto-detect format
            for (var i = 0, list = input.autodetect; i < list.length; i += 1) {
                var chk = list[i];

                mode = chk.test.apply(chk, args);
                if (mode) { break; }
            }
        }

        if (input.format[mode]) {
            var rgb = input.format[mode].apply(null, autodetect ? args : args.slice(0,-1));
            me._rgb = clip_rgb$1(rgb);
        } else {
            throw new Error('unknown format: '+args);
        }

        // add alpha channel
        if (me._rgb.length === 3) { me._rgb.push(1); }
    };

    Color.prototype.toString = function toString () {
        if (type$1(this.hex) == 'function') { return this.hex(); }
        return ("[" + (this._rgb.join(',')) + "]");
    };

    var Color_1 = Color;

    var chroma = function () {
    	var args = [], len = arguments.length;
    	while ( len-- ) args[ len ] = arguments[ len ];

    	return new (Function.prototype.bind.apply( chroma.Color, [ null ].concat( args) ));
    };

    chroma.Color = Color_1;
    chroma.version = '2.1.0';

    var chroma_1 = chroma;

    var unpack$1 = utils.unpack;
    var max = Math.max;

    var rgb2cmyk = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$1(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        var k = 1 - max(r,max(g,b));
        var f = k < 1 ? 1 / (1-k) : 0;
        var c = (1-r-k) * f;
        var m = (1-g-k) * f;
        var y = (1-b-k) * f;
        return [c,m,y,k];
    };

    var rgb2cmyk_1 = rgb2cmyk;

    var unpack$2 = utils.unpack;

    var cmyk2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$2(args, 'cmyk');
        var c = args[0];
        var m = args[1];
        var y = args[2];
        var k = args[3];
        var alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) { return [0,0,0,alpha]; }
        return [
            c >= 1 ? 0 : 255 * (1-c) * (1-k), // r
            m >= 1 ? 0 : 255 * (1-m) * (1-k), // g
            y >= 1 ? 0 : 255 * (1-y) * (1-k), // b
            alpha
        ];
    };

    var cmyk2rgb_1 = cmyk2rgb;

    var unpack$3 = utils.unpack;
    var type$2 = utils.type;



    Color_1.prototype.cmyk = function() {
        return rgb2cmyk_1(this._rgb);
    };

    chroma_1.cmyk = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['cmyk']) ));
    };

    input.format.cmyk = cmyk2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$3(args, 'cmyk');
            if (type$2(args) === 'array' && args.length === 4) {
                return 'cmyk';
            }
        }
    });

    var unpack$4 = utils.unpack;
    var last$2 = utils.last;
    var rnd = function (a) { return Math.round(a*100)/100; };

    
    var hsl2css = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var hsla = unpack$4(args, 'hsla');
        var mode = last$2(args) || 'lsa';
        hsla[0] = rnd(hsla[0] || 0);
        hsla[1] = rnd(hsla[1]*100) + '%';
        hsla[2] = rnd(hsla[2]*100) + '%';
        if (mode === 'hsla' || (hsla.length > 3 && hsla[3]<1)) {
            hsla[3] = hsla.length > 3 ? hsla[3] : 1;
            mode = 'hsla';
        } else {
            hsla.length = 3;
        }
        return (mode + "(" + (hsla.join(',')) + ")");
    };

    var hsl2css_1 = hsl2css;

    var unpack$5 = utils.unpack;

    
    var rgb2hsl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$5(args, 'rgba');
        var r = args[0];
        var g = args[1];
        var b = args[2];

        r /= 255;
        g /= 255;
        b /= 255;

        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);

        var l = (max + min) / 2;
        var s, h;

        if (max === min){
            s = 0;
            h = Number.NaN;
        } else {
            s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        }

        if (r == max) { h = (g - b) / (max - min); }
        else if (g == max) { h = 2 + (b - r) / (max - min); }
        else if (b == max) { h = 4 + (r - g) / (max - min); }

        h *= 60;
        if (h < 0) { h += 360; }
        if (args.length>3 && args[3]!==undefined) { return [h,s,l,args[3]]; }
        return [h,s,l];
    };

    var rgb2hsl_1 = rgb2hsl;

    var unpack$6 = utils.unpack;
    var last$3 = utils.last;


    var round = Math.round;

    
    var rgb2css = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgba = unpack$6(args, 'rgba');
        var mode = last$3(args) || 'rgb';
        if (mode.substr(0,3) == 'hsl') {
            return hsl2css_1(rgb2hsl_1(rgba), mode);
        }
        rgba[0] = round(rgba[0]);
        rgba[1] = round(rgba[1]);
        rgba[2] = round(rgba[2]);
        if (mode === 'rgba' || (rgba.length > 3 && rgba[3]<1)) {
            rgba[3] = rgba.length > 3 ? rgba[3] : 1;
            mode = 'rgba';
        }
        return (mode + "(" + (rgba.slice(0,mode==='rgb'?3:4).join(',')) + ")");
    };

    var rgb2css_1 = rgb2css;

    var unpack$7 = utils.unpack;
    var round$1 = Math.round;

    var hsl2rgb = function () {
        var assign;

        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        args = unpack$7(args, 'hsl');
        var h = args[0];
        var s = args[1];
        var l = args[2];
        var r,g,b;
        if (s === 0) {
            r = g = b = l*255;
        } else {
            var t3 = [0,0,0];
            var c = [0,0,0];
            var t2 = l < 0.5 ? l * (1+s) : l+s-l*s;
            var t1 = 2 * l - t2;
            var h_ = h / 360;
            t3[0] = h_ + 1/3;
            t3[1] = h_;
            t3[2] = h_ - 1/3;
            for (var i=0; i<3; i++) {
                if (t3[i] < 0) { t3[i] += 1; }
                if (t3[i] > 1) { t3[i] -= 1; }
                if (6 * t3[i] < 1)
                    { c[i] = t1 + (t2 - t1) * 6 * t3[i]; }
                else if (2 * t3[i] < 1)
                    { c[i] = t2; }
                else if (3 * t3[i] < 2)
                    { c[i] = t1 + (t2 - t1) * ((2 / 3) - t3[i]) * 6; }
                else
                    { c[i] = t1; }
            }
            (assign = [round$1(c[0]*255),round$1(c[1]*255),round$1(c[2]*255)], r = assign[0], g = assign[1], b = assign[2]);
        }
        if (args.length > 3) {
            // keep alpha channel
            return [r,g,b,args[3]];
        }
        return [r,g,b,1];
    };

    var hsl2rgb_1 = hsl2rgb;

    var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
    var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;

    var round$2 = Math.round;

    var css2rgb = function (css) {
        css = css.toLowerCase().trim();
        var m;

        if (input.format.named) {
            try {
                return input.format.named(css);
            } catch (e) {
                // eslint-disable-next-line
            }
        }

        // rgb(250,20,0)
        if ((m = css.match(RE_RGB))) {
            var rgb = m.slice(1,4);
            for (var i=0; i<3; i++) {
                rgb[i] = +rgb[i];
            }
            rgb[3] = 1;  // default alpha
            return rgb;
        }

        // rgba(250,20,0,0.4)
        if ((m = css.match(RE_RGBA))) {
            var rgb$1 = m.slice(1,5);
            for (var i$1=0; i$1<4; i$1++) {
                rgb$1[i$1] = +rgb$1[i$1];
            }
            return rgb$1;
        }

        // rgb(100%,0%,0%)
        if ((m = css.match(RE_RGB_PCT))) {
            var rgb$2 = m.slice(1,4);
            for (var i$2=0; i$2<3; i$2++) {
                rgb$2[i$2] = round$2(rgb$2[i$2] * 2.55);
            }
            rgb$2[3] = 1;  // default alpha
            return rgb$2;
        }

        // rgba(100%,0%,0%,0.4)
        if ((m = css.match(RE_RGBA_PCT))) {
            var rgb$3 = m.slice(1,5);
            for (var i$3=0; i$3<3; i$3++) {
                rgb$3[i$3] = round$2(rgb$3[i$3] * 2.55);
            }
            rgb$3[3] = +rgb$3[3];
            return rgb$3;
        }

        // hsl(0,100%,50%)
        if ((m = css.match(RE_HSL))) {
            var hsl = m.slice(1,4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            var rgb$4 = hsl2rgb_1(hsl);
            rgb$4[3] = 1;
            return rgb$4;
        }

        // hsla(0,100%,50%,0.5)
        if ((m = css.match(RE_HSLA))) {
            var hsl$1 = m.slice(1,4);
            hsl$1[1] *= 0.01;
            hsl$1[2] *= 0.01;
            var rgb$5 = hsl2rgb_1(hsl$1);
            rgb$5[3] = +m[4];  // default alpha = 1
            return rgb$5;
        }
    };

    css2rgb.test = function (s) {
        return RE_RGB.test(s) ||
            RE_RGBA.test(s) ||
            RE_RGB_PCT.test(s) ||
            RE_RGBA_PCT.test(s) ||
            RE_HSL.test(s) ||
            RE_HSLA.test(s);
    };

    var css2rgb_1 = css2rgb;

    var type$3 = utils.type;




    Color_1.prototype.css = function(mode) {
        return rgb2css_1(this._rgb, mode);
    };

    chroma_1.css = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['css']) ));
    };

    input.format.css = css2rgb_1;

    input.autodetect.push({
        p: 5,
        test: function (h) {
            var rest = [], len = arguments.length - 1;
            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

            if (!rest.length && type$3(h) === 'string' && css2rgb_1.test(h)) {
                return 'css';
            }
        }
    });

    var unpack$8 = utils.unpack;

    input.format.gl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgb = unpack$8(args, 'rgba');
        rgb[0] *= 255;
        rgb[1] *= 255;
        rgb[2] *= 255;
        return rgb;
    };

    chroma_1.gl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['gl']) ));
    };

    Color_1.prototype.gl = function() {
        var rgb = this._rgb;
        return [rgb[0]/255, rgb[1]/255, rgb[2]/255, rgb[3]];
    };

    var unpack$9 = utils.unpack;

    var rgb2hcg = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$9(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var c = delta * 100 / 255;
        var _g = min / (255 - delta) * 100;
        var h;
        if (delta === 0) {
            h = Number.NaN;
        } else {
            if (r === max) { h = (g - b) / delta; }
            if (g === max) { h = 2+(b - r) / delta; }
            if (b === max) { h = 4+(r - g) / delta; }
            h *= 60;
            if (h < 0) { h += 360; }
        }
        return [h, c, _g];
    };

    var rgb2hcg_1 = rgb2hcg;

    var unpack$a = utils.unpack;
    var floor = Math.floor;

    

    var hcg2rgb = function () {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;

        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        args = unpack$a(args, 'hcg');
        var h = args[0];
        var c = args[1];
        var _g = args[2];
        var r,g,b;
        _g = _g * 255;
        var _c = c * 255;
        if (c === 0) {
            r = g = b = _g;
        } else {
            if (h === 360) { h = 0; }
            if (h > 360) { h -= 360; }
            if (h < 0) { h += 360; }
            h /= 60;
            var i = floor(h);
            var f = h - i;
            var p = _g * (1 - c);
            var q = p + _c * (1 - f);
            var t = p + _c * f;
            var v = p + _c;
            switch (i) {
                case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
                case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
                case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
                case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
                case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
                case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
            }
        }
        return [r, g, b, args.length > 3 ? args[3] : 1];
    };

    var hcg2rgb_1 = hcg2rgb;

    var unpack$b = utils.unpack;
    var type$4 = utils.type;






    Color_1.prototype.hcg = function() {
        return rgb2hcg_1(this._rgb);
    };

    chroma_1.hcg = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hcg']) ));
    };

    input.format.hcg = hcg2rgb_1;

    input.autodetect.push({
        p: 1,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$b(args, 'hcg');
            if (type$4(args) === 'array' && args.length === 3) {
                return 'hcg';
            }
        }
    });

    var unpack$c = utils.unpack;
    var last$4 = utils.last;
    var round$3 = Math.round;

    var rgb2hex = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$c(args, 'rgba');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var a = ref[3];
        var mode = last$4(args) || 'auto';
        if (a === undefined) { a = 1; }
        if (mode === 'auto') {
            mode = a < 1 ? 'rgba' : 'rgb';
        }
        r = round$3(r);
        g = round$3(g);
        b = round$3(b);
        var u = r << 16 | g << 8 | b;
        var str = "000000" + u.toString(16); //#.toUpperCase();
        str = str.substr(str.length - 6);
        var hxa = '0' + round$3(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        switch (mode.toLowerCase()) {
            case 'rgba': return ("#" + str + hxa);
            case 'argb': return ("#" + hxa + str);
            default: return ("#" + str);
        }
    };

    var rgb2hex_1 = rgb2hex;

    var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    var RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;

    var hex2rgb = function (hex) {
        if (hex.match(RE_HEX)) {
            // remove optional leading #
            if (hex.length === 4 || hex.length === 7) {
                hex = hex.substr(1);
            }
            // expand short-notation to full six-digit
            if (hex.length === 3) {
                hex = hex.split('');
                hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
            }
            var u = parseInt(hex, 16);
            var r = u >> 16;
            var g = u >> 8 & 0xFF;
            var b = u & 0xFF;
            return [r,g,b,1];
        }

        // match rgba hex format, eg #FF000077
        if (hex.match(RE_HEXA)) {
            if (hex.length === 5 || hex.length === 9) {
                // remove optional leading #
                hex = hex.substr(1);
            }
            // expand short-notation to full eight-digit
            if (hex.length === 4) {
                hex = hex.split('');
                hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2]+hex[3]+hex[3];
            }
            var u$1 = parseInt(hex, 16);
            var r$1 = u$1 >> 24 & 0xFF;
            var g$1 = u$1 >> 16 & 0xFF;
            var b$1 = u$1 >> 8 & 0xFF;
            var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
            return [r$1,g$1,b$1,a];
        }

        // we used to check for css colors here
        // if _input.css? and rgb = _input.css hex
        //     return rgb

        throw new Error(("unknown hex color: " + hex));
    };

    var hex2rgb_1 = hex2rgb;

    var type$5 = utils.type;




    Color_1.prototype.hex = function(mode) {
        return rgb2hex_1(this._rgb, mode);
    };

    chroma_1.hex = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hex']) ));
    };

    input.format.hex = hex2rgb_1;
    input.autodetect.push({
        p: 4,
        test: function (h) {
            var rest = [], len = arguments.length - 1;
            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

            if (!rest.length && type$5(h) === 'string' && [3,4,5,6,7,8,9].indexOf(h.length) >= 0) {
                return 'hex';
            }
        }
    });

    var unpack$d = utils.unpack;
    var TWOPI = utils.TWOPI;
    var min = Math.min;
    var sqrt = Math.sqrt;
    var acos = Math.acos;

    var rgb2hsi = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        
        var ref = unpack$d(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var h;
        var min_ = min(r,g,b);
        var i = (r+g+b) / 3;
        var s = i > 0 ? 1 - min_/i : 0;
        if (s === 0) {
            h = NaN;
        } else {
            h = ((r-g)+(r-b)) / 2;
            h /= sqrt((r-g)*(r-g) + (r-b)*(g-b));
            h = acos(h);
            if (b > g) {
                h = TWOPI - h;
            }
            h /= TWOPI;
        }
        return [h*360,s,i];
    };

    var rgb2hsi_1 = rgb2hsi;

    var unpack$e = utils.unpack;
    var limit$1 = utils.limit;
    var TWOPI$1 = utils.TWOPI;
    var PITHIRD = utils.PITHIRD;
    var cos = Math.cos;

    
    var hsi2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        
        args = unpack$e(args, 'hsi');
        var h = args[0];
        var s = args[1];
        var i = args[2];
        var r,g,b;

        if (isNaN(h)) { h = 0; }
        if (isNaN(s)) { s = 0; }
        // normalize hue
        if (h > 360) { h -= 360; }
        if (h < 0) { h += 360; }
        h /= 360;
        if (h < 1/3) {
            b = (1-s)/3;
            r = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
            g = 1 - (b+r);
        } else if (h < 2/3) {
            h -= 1/3;
            r = (1-s)/3;
            g = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
            b = 1 - (r+g);
        } else {
            h -= 2/3;
            g = (1-s)/3;
            b = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
            r = 1 - (g+b);
        }
        r = limit$1(i*r*3);
        g = limit$1(i*g*3);
        b = limit$1(i*b*3);
        return [r*255, g*255, b*255, args.length > 3 ? args[3] : 1];
    };

    var hsi2rgb_1 = hsi2rgb;

    var unpack$f = utils.unpack;
    var type$6 = utils.type;






    Color_1.prototype.hsi = function() {
        return rgb2hsi_1(this._rgb);
    };

    chroma_1.hsi = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsi']) ));
    };

    input.format.hsi = hsi2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$f(args, 'hsi');
            if (type$6(args) === 'array' && args.length === 3) {
                return 'hsi';
            }
        }
    });

    var unpack$g = utils.unpack;
    var type$7 = utils.type;






    Color_1.prototype.hsl = function() {
        return rgb2hsl_1(this._rgb);
    };

    chroma_1.hsl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsl']) ));
    };

    input.format.hsl = hsl2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$g(args, 'hsl');
            if (type$7(args) === 'array' && args.length === 3) {
                return 'hsl';
            }
        }
    });

    var unpack$h = utils.unpack;
    var min$1 = Math.min;
    var max$1 = Math.max;

    
    var rgb2hsl$1 = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$h(args, 'rgb');
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var min_ = min$1(r, g, b);
        var max_ = max$1(r, g, b);
        var delta = max_ - min_;
        var h,s,v;
        v = max_ / 255.0;
        if (max_ === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max_;
            if (r === max_) { h = (g - b) / delta; }
            if (g === max_) { h = 2+(b - r) / delta; }
            if (b === max_) { h = 4+(r - g) / delta; }
            h *= 60;
            if (h < 0) { h += 360; }
        }
        return [h, s, v]
    };

    var rgb2hsv = rgb2hsl$1;

    var unpack$i = utils.unpack;
    var floor$1 = Math.floor;

    var hsv2rgb = function () {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;

        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        args = unpack$i(args, 'hsv');
        var h = args[0];
        var s = args[1];
        var v = args[2];
        var r,g,b;
        v *= 255;
        if (s === 0) {
            r = g = b = v;
        } else {
            if (h === 360) { h = 0; }
            if (h > 360) { h -= 360; }
            if (h < 0) { h += 360; }
            h /= 60;

            var i = floor$1(h);
            var f = h - i;
            var p = v * (1 - s);
            var q = v * (1 - s * f);
            var t = v * (1 - s * (1 - f));

            switch (i) {
                case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
                case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
                case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
                case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
                case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
                case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
            }
        }
        return [r,g,b,args.length > 3?args[3]:1];
    };

    var hsv2rgb_1 = hsv2rgb;

    var unpack$j = utils.unpack;
    var type$8 = utils.type;






    Color_1.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };

    chroma_1.hsv = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsv']) ));
    };

    input.format.hsv = hsv2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$j(args, 'hsv');
            if (type$8(args) === 'array' && args.length === 3) {
                return 'hsv';
            }
        }
    });

    var labConstants = {
        // Corresponds roughly to RGB brighter/darker
        Kn: 18,

        // D65 standard referent
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,

        t0: 0.137931034,  // 4 / 29
        t1: 0.206896552,  // 6 / 29
        t2: 0.12841855,   // 3 * t1 * t1
        t3: 0.008856452,  // t1 * t1 * t1
    };

    var unpack$k = utils.unpack;
    var pow = Math.pow;

    var rgb2lab = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$k(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2xyz(r,g,b);
        var x = ref$1[0];
        var y = ref$1[1];
        var z = ref$1[2];
        var l = 116 * y - 16;
        return [l < 0 ? 0 : l, 500 * (x - y), 200 * (y - z)];
    };

    var rgb_xyz = function (r) {
        if ((r /= 255) <= 0.04045) { return r / 12.92; }
        return pow((r + 0.055) / 1.055, 2.4);
    };

    var xyz_lab = function (t) {
        if (t > labConstants.t3) { return pow(t, 1 / 3); }
        return t / labConstants.t2 + labConstants.t0;
    };

    var rgb2xyz = function (r,g,b) {
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / labConstants.Xn);
        var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / labConstants.Yn);
        var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / labConstants.Zn);
        return [x,y,z];
    };

    var rgb2lab_1 = rgb2lab;

    var unpack$l = utils.unpack;
    var pow$1 = Math.pow;

    
    var lab2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$l(args, 'lab');
        var l = args[0];
        var a = args[1];
        var b = args[2];
        var x,y,z, r,g,b_;

        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;

        y = labConstants.Yn * lab_xyz(y);
        x = labConstants.Xn * lab_xyz(x);
        z = labConstants.Zn * lab_xyz(z);

        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);  // D65 -> sRGB
        g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
        b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);

        return [r,g,b_,args.length > 3 ? args[3] : 1];
    };

    var xyz_rgb = function (r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$1(r, 1 / 2.4) - 0.055)
    };

    var lab_xyz = function (t) {
        return t > labConstants.t1 ? t * t * t : labConstants.t2 * (t - labConstants.t0)
    };

    var lab2rgb_1 = lab2rgb;

    var unpack$m = utils.unpack;
    var type$9 = utils.type;






    Color_1.prototype.lab = function() {
        return rgb2lab_1(this._rgb);
    };

    chroma_1.lab = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['lab']) ));
    };

    input.format.lab = lab2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$m(args, 'lab');
            if (type$9(args) === 'array' && args.length === 3) {
                return 'lab';
            }
        }
    });

    var unpack$n = utils.unpack;
    var RAD2DEG = utils.RAD2DEG;
    var sqrt$1 = Math.sqrt;
    var atan2 = Math.atan2;
    var round$4 = Math.round;

    var lab2lch = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$n(args, 'lab');
        var l = ref[0];
        var a = ref[1];
        var b = ref[2];
        var c = sqrt$1(a * a + b * b);
        var h = (atan2(b, a) * RAD2DEG + 360) % 360;
        if (round$4(c*10000) === 0) { h = Number.NaN; }
        return [l, c, h];
    };

    var lab2lch_1 = lab2lch;

    var unpack$o = utils.unpack;



    var rgb2lch = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$o(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2lab_1(r,g,b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch_1(l,a,b_);
    };

    var rgb2lch_1 = rgb2lch;

    var unpack$p = utils.unpack;
    var DEG2RAD = utils.DEG2RAD;
    var sin = Math.sin;
    var cos$1 = Math.cos;

    var lch2lab = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        
        var ref = unpack$p(args, 'lch');
        var l = ref[0];
        var c = ref[1];
        var h = ref[2];
        if (isNaN(h)) { h = 0; }
        h = h * DEG2RAD;
        return [l, cos$1(h) * c, sin(h) * c]
    };

    var lch2lab_1 = lch2lab;

    var unpack$q = utils.unpack;



    var lch2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$q(args, 'lch');
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab_1 (l,c,h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = lab2rgb_1 (L,a,b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [r, g, b, args.length > 3 ? args[3] : 1];
    };

    var lch2rgb_1 = lch2rgb;

    var unpack$r = utils.unpack;


    var hcl2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var hcl = unpack$r(args, 'hcl').reverse();
        return lch2rgb_1.apply(void 0, hcl);
    };

    var hcl2rgb_1 = hcl2rgb;

    var unpack$s = utils.unpack;
    var type$a = utils.type;






    Color_1.prototype.lch = function() { return rgb2lch_1(this._rgb); };
    Color_1.prototype.hcl = function() { return rgb2lch_1(this._rgb).reverse(); };

    chroma_1.lch = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['lch']) ));
    };
    chroma_1.hcl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hcl']) ));
    };

    input.format.lch = lch2rgb_1;
    input.format.hcl = hcl2rgb_1;

    ['lch','hcl'].forEach(function (m) { return input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$s(args, m);
            if (type$a(args) === 'array' && args.length === 3) {
                return m;
            }
        }
    }); });

    

    var w3cx11 = {
        aliceblue: '#f0f8ff',
        antiquewhite: '#faebd7',
        aqua: '#00ffff',
        aquamarine: '#7fffd4',
        azure: '#f0ffff',
        beige: '#f5f5dc',
        bisque: '#ffe4c4',
        black: '#000000',
        blanchedalmond: '#ffebcd',
        blue: '#0000ff',
        blueviolet: '#8a2be2',
        brown: '#a52a2a',
        burlywood: '#deb887',
        cadetblue: '#5f9ea0',
        chartreuse: '#7fff00',
        chocolate: '#d2691e',
        coral: '#ff7f50',
        cornflower: '#6495ed',
        cornflowerblue: '#6495ed',
        cornsilk: '#fff8dc',
        crimson: '#dc143c',
        cyan: '#00ffff',
        darkblue: '#00008b',
        darkcyan: '#008b8b',
        darkgoldenrod: '#b8860b',
        darkgray: '#a9a9a9',
        darkgreen: '#006400',
        darkgrey: '#a9a9a9',
        darkkhaki: '#bdb76b',
        darkmagenta: '#8b008b',
        darkolivegreen: '#556b2f',
        darkorange: '#ff8c00',
        darkorchid: '#9932cc',
        darkred: '#8b0000',
        darksalmon: '#e9967a',
        darkseagreen: '#8fbc8f',
        darkslateblue: '#483d8b',
        darkslategray: '#2f4f4f',
        darkslategrey: '#2f4f4f',
        darkturquoise: '#00ced1',
        darkviolet: '#9400d3',
        deeppink: '#ff1493',
        deepskyblue: '#00bfff',
        dimgray: '#696969',
        dimgrey: '#696969',
        dodgerblue: '#1e90ff',
        firebrick: '#b22222',
        floralwhite: '#fffaf0',
        forestgreen: '#228b22',
        fuchsia: '#ff00ff',
        gainsboro: '#dcdcdc',
        ghostwhite: '#f8f8ff',
        gold: '#ffd700',
        goldenrod: '#daa520',
        gray: '#808080',
        green: '#008000',
        greenyellow: '#adff2f',
        grey: '#808080',
        honeydew: '#f0fff0',
        hotpink: '#ff69b4',
        indianred: '#cd5c5c',
        indigo: '#4b0082',
        ivory: '#fffff0',
        khaki: '#f0e68c',
        laserlemon: '#ffff54',
        lavender: '#e6e6fa',
        lavenderblush: '#fff0f5',
        lawngreen: '#7cfc00',
        lemonchiffon: '#fffacd',
        lightblue: '#add8e6',
        lightcoral: '#f08080',
        lightcyan: '#e0ffff',
        lightgoldenrod: '#fafad2',
        lightgoldenrodyellow: '#fafad2',
        lightgray: '#d3d3d3',
        lightgreen: '#90ee90',
        lightgrey: '#d3d3d3',
        lightpink: '#ffb6c1',
        lightsalmon: '#ffa07a',
        lightseagreen: '#20b2aa',
        lightskyblue: '#87cefa',
        lightslategray: '#778899',
        lightslategrey: '#778899',
        lightsteelblue: '#b0c4de',
        lightyellow: '#ffffe0',
        lime: '#00ff00',
        limegreen: '#32cd32',
        linen: '#faf0e6',
        magenta: '#ff00ff',
        maroon: '#800000',
        maroon2: '#7f0000',
        maroon3: '#b03060',
        mediumaquamarine: '#66cdaa',
        mediumblue: '#0000cd',
        mediumorchid: '#ba55d3',
        mediumpurple: '#9370db',
        mediumseagreen: '#3cb371',
        mediumslateblue: '#7b68ee',
        mediumspringgreen: '#00fa9a',
        mediumturquoise: '#48d1cc',
        mediumvioletred: '#c71585',
        midnightblue: '#191970',
        mintcream: '#f5fffa',
        mistyrose: '#ffe4e1',
        moccasin: '#ffe4b5',
        navajowhite: '#ffdead',
        navy: '#000080',
        oldlace: '#fdf5e6',
        olive: '#808000',
        olivedrab: '#6b8e23',
        orange: '#ffa500',
        orangered: '#ff4500',
        orchid: '#da70d6',
        palegoldenrod: '#eee8aa',
        palegreen: '#98fb98',
        paleturquoise: '#afeeee',
        palevioletred: '#db7093',
        papayawhip: '#ffefd5',
        peachpuff: '#ffdab9',
        peru: '#cd853f',
        pink: '#ffc0cb',
        plum: '#dda0dd',
        powderblue: '#b0e0e6',
        purple: '#800080',
        purple2: '#7f007f',
        purple3: '#a020f0',
        rebeccapurple: '#663399',
        red: '#ff0000',
        rosybrown: '#bc8f8f',
        royalblue: '#4169e1',
        saddlebrown: '#8b4513',
        salmon: '#fa8072',
        sandybrown: '#f4a460',
        seagreen: '#2e8b57',
        seashell: '#fff5ee',
        sienna: '#a0522d',
        silver: '#c0c0c0',
        skyblue: '#87ceeb',
        slateblue: '#6a5acd',
        slategray: '#708090',
        slategrey: '#708090',
        snow: '#fffafa',
        springgreen: '#00ff7f',
        steelblue: '#4682b4',
        tan: '#d2b48c',
        teal: '#008080',
        thistle: '#d8bfd8',
        tomato: '#ff6347',
        turquoise: '#40e0d0',
        violet: '#ee82ee',
        wheat: '#f5deb3',
        white: '#ffffff',
        whitesmoke: '#f5f5f5',
        yellow: '#ffff00',
        yellowgreen: '#9acd32'
    };

    var w3cx11_1 = w3cx11;

    var type$b = utils.type;





    Color_1.prototype.name = function() {
        var hex = rgb2hex_1(this._rgb, 'rgb');
        for (var i = 0, list = Object.keys(w3cx11_1); i < list.length; i += 1) {
            var n = list[i];

            if (w3cx11_1[n] === hex) { return n.toLowerCase(); }
        }
        return hex;
    };

    input.format.named = function (name) {
        name = name.toLowerCase();
        if (w3cx11_1[name]) { return hex2rgb_1(w3cx11_1[name]); }
        throw new Error('unknown color name: '+name);
    };

    input.autodetect.push({
        p: 5,
        test: function (h) {
            var rest = [], len = arguments.length - 1;
            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

            if (!rest.length && type$b(h) === 'string' && w3cx11_1[h.toLowerCase()]) {
                return 'named';
            }
        }
    });

    var unpack$t = utils.unpack;

    var rgb2num = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$t(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        return (r << 16) + (g << 8) + b;
    };

    var rgb2num_1 = rgb2num;

    var type$c = utils.type;

    var num2rgb = function (num) {
        if (type$c(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
            var r = num >> 16;
            var g = (num >> 8) & 0xFF;
            var b = num & 0xFF;
            return [r,g,b,1];
        }
        throw new Error("unknown num color: "+num);
    };

    var num2rgb_1 = num2rgb;

    var type$d = utils.type;



    Color_1.prototype.num = function() {
        return rgb2num_1(this._rgb);
    };

    chroma_1.num = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['num']) ));
    };

    input.format.num = num2rgb_1;

    input.autodetect.push({
        p: 5,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            if (args.length === 1 && type$d(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xFFFFFF) {
                return 'num';
            }
        }
    });

    var unpack$u = utils.unpack;
    var type$e = utils.type;
    var round$5 = Math.round;

    Color_1.prototype.rgb = function(rnd) {
        if ( rnd === void 0 ) rnd=true;

        if (rnd === false) { return this._rgb.slice(0,3); }
        return this._rgb.slice(0,3).map(round$5);
    };

    Color_1.prototype.rgba = function(rnd) {
        if ( rnd === void 0 ) rnd=true;

        return this._rgb.slice(0,4).map(function (v,i) {
            return i<3 ? (rnd === false ? v : round$5(v)) : v;
        });
    };

    chroma_1.rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['rgb']) ));
    };

    input.format.rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgba = unpack$u(args, 'rgba');
        if (rgba[3] === undefined) { rgba[3] = 1; }
        return rgba;
    };

    input.autodetect.push({
        p: 3,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$u(args, 'rgba');
            if (type$e(args) === 'array' && (args.length === 3 ||
                args.length === 4 && type$e(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) {
                return 'rgb';
            }
        }
    });

    

    var log = Math.log;

    var temperature2rgb = function (kelvin) {
        var temp = kelvin / 100;
        var r,g,b;
        if (temp < 66) {
            r = 255;
            g = -155.25485562709179 - 0.44596950469579133 * (g = temp-2) + 104.49216199393888 * log(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp-10) + 115.67994401066147 * log(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp-55) - 40.25366309332127 * log(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp-50) - 28.0852963507957 * log(g);
            b = 255;
        }
        return [r,g,b,1];
    };

    var temperature2rgb_1 = temperature2rgb;

    


    var unpack$v = utils.unpack;
    var round$6 = Math.round;

    var rgb2temperature = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgb = unpack$v(args, 'rgb');
        var r = rgb[0], b = rgb[2];
        var minTemp = 1000;
        var maxTemp = 40000;
        var eps = 0.4;
        var temp;
        while (maxTemp - minTemp > eps) {
            temp = (maxTemp + minTemp) * 0.5;
            var rgb$1 = temperature2rgb_1(temp);
            if ((rgb$1[2] / rgb$1[0]) >= (b / r)) {
                maxTemp = temp;
            } else {
                minTemp = temp;
            }
        }
        return round$6(temp);
    };

    var rgb2temperature_1 = rgb2temperature;

    Color_1.prototype.temp =
    Color_1.prototype.kelvin =
    Color_1.prototype.temperature = function() {
        return rgb2temperature_1(this._rgb);
    };

    chroma_1.temp =
    chroma_1.kelvin =
    chroma_1.temperature = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['temp']) ));
    };

    input.format.temp =
    input.format.kelvin =
    input.format.temperature = temperature2rgb_1;

    var type$f = utils.type;

    Color_1.prototype.alpha = function(a, mutate) {
        if ( mutate === void 0 ) mutate=false;

        if (a !== undefined && type$f(a) === 'number') {
            if (mutate) {
                this._rgb[3] = a;
                return this;
            }
            return new Color_1([this._rgb[0], this._rgb[1], this._rgb[2], a], 'rgb');
        }
        return this._rgb[3];
    };

    Color_1.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };

    Color_1.prototype.darken = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	var me = this;
    	var lab = me.lab();
    	lab[0] -= labConstants.Kn * amount;
    	return new Color_1(lab, 'lab').alpha(me.alpha(), true);
    };

    Color_1.prototype.brighten = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	return this.darken(-amount);
    };

    Color_1.prototype.darker = Color_1.prototype.darken;
    Color_1.prototype.brighter = Color_1.prototype.brighten;

    Color_1.prototype.get = function(mc) {
        var ref = mc.split('.');
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel);
            if (i > -1) { return src[i]; }
            throw new Error(("unknown channel " + channel + " in mode " + mode));
        } else {
            return src;
        }
    };

    var type$g = utils.type;
    var pow$2 = Math.pow;

    var EPS = 1e-7;
    var MAX_ITER = 20;

    Color_1.prototype.luminance = function(lum) {
        if (lum !== undefined && type$g(lum) === 'number') {
            if (lum === 0) {
                // return pure black
                return new Color_1([0,0,0,this._rgb[3]], 'rgb');
            }
            if (lum === 1) {
                // return pure white
                return new Color_1([255,255,255,this._rgb[3]], 'rgb');
            }
            // compute new color using...
            var cur_lum = this.luminance();
            var mode = 'rgb';
            var max_iter = MAX_ITER;

            var test = function (low, high) {
                var mid = low.interpolate(high, 0.5, mode);
                var lm = mid.luminance();
                if (Math.abs(lum - lm) < EPS || !max_iter--) {
                    // close enough
                    return mid;
                }
                return lm > lum ? test(low, mid) : test(mid, high);
            };

            var rgb = (cur_lum > lum ? test(new Color_1([0,0,0]), this) : test(this, new Color_1([255,255,255]))).rgb();
            return new Color_1(rgb.concat( [this._rgb[3]]));
        }
        return rgb2luminance.apply(void 0, (this._rgb).slice(0,3));
    };


    var rgb2luminance = function (r,g,b) {
        // relative luminance
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };

    var luminance_x = function (x) {
        x /= 255;
        return x <= 0.03928 ? x/12.92 : pow$2((x+0.055)/1.055, 2.4);
    };

    var interpolator = {};

    var type$h = utils.type;


    var mix = function (col1, col2, f) {
        if ( f === void 0 ) f=0.5;
        var rest = [], len = arguments.length - 3;
        while ( len-- > 0 ) rest[ len ] = arguments[ len + 3 ];

        var mode = rest[0] || 'lrgb';
        if (!interpolator[mode] && !rest.length) {
            // fall back to the first supported mode
            mode = Object.keys(interpolator)[0];
        }
        if (!interpolator[mode]) {
            throw new Error(("interpolation mode " + mode + " is not defined"));
        }
        if (type$h(col1) !== 'object') { col1 = new Color_1(col1); }
        if (type$h(col2) !== 'object') { col2 = new Color_1(col2); }
        return interpolator[mode](col1, col2, f)
            .alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };

    Color_1.prototype.mix =
    Color_1.prototype.interpolate = function(col2, f) {
    	if ( f === void 0 ) f=0.5;
    	var rest = [], len = arguments.length - 2;
    	while ( len-- > 0 ) rest[ len ] = arguments[ len + 2 ];

    	return mix.apply(void 0, [ this, col2, f ].concat( rest ));
    };

    Color_1.prototype.premultiply = function(mutate) {
    	if ( mutate === void 0 ) mutate=false;

    	var rgb = this._rgb;
    	var a = rgb[3];
    	if (mutate) {
    		this._rgb = [rgb[0]*a, rgb[1]*a, rgb[2]*a, a];
    		return this;
    	} else {
    		return new Color_1([rgb[0]*a, rgb[1]*a, rgb[2]*a, a], 'rgb');
    	}
    };

    Color_1.prototype.saturate = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	var me = this;
    	var lch = me.lch();
    	lch[1] += labConstants.Kn * amount;
    	if (lch[1] < 0) { lch[1] = 0; }
    	return new Color_1(lch, 'lch').alpha(me.alpha(), true);
    };

    Color_1.prototype.desaturate = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	return this.saturate(-amount);
    };

    var type$i = utils.type;

    Color_1.prototype.set = function(mc, value, mutate) {
        if ( mutate === void 0 ) mutate=false;

        var ref = mc.split('.');
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel);
            if (i > -1) {
                if (type$i(value) == 'string') {
                    switch(value.charAt(0)) {
                        case '+': src[i] += +value; break;
                        case '-': src[i] += +value; break;
                        case '*': src[i] *= +(value.substr(1)); break;
                        case '/': src[i] /= +(value.substr(1)); break;
                        default: src[i] = +value;
                    }
                } else if (type$i(value) === 'number') {
                    src[i] = value;
                } else {
                    throw new Error("unsupported value for Color.set");
                }
                var out = new Color_1(src, mode);
                if (mutate) {
                    this._rgb = out._rgb;
                    return this;
                }
                return out;
            }
            throw new Error(("unknown channel " + channel + " in mode " + mode));
        } else {
            return src;
        }
    };

    var rgb$1 = function (col1, col2, f) {
        var xyz0 = col1._rgb;
        var xyz1 = col2._rgb;
        return new Color_1(
            xyz0[0] + f * (xyz1[0]-xyz0[0]),
            xyz0[1] + f * (xyz1[1]-xyz0[1]),
            xyz0[2] + f * (xyz1[2]-xyz0[2]),
            'rgb'
        )
    };

    // register interpolator
    interpolator.rgb = rgb$1;

    var sqrt$2 = Math.sqrt;
    var pow$3 = Math.pow;

    var lrgb = function (col1, col2, f) {
        var ref = col1._rgb;
        var x1 = ref[0];
        var y1 = ref[1];
        var z1 = ref[2];
        var ref$1 = col2._rgb;
        var x2 = ref$1[0];
        var y2 = ref$1[1];
        var z2 = ref$1[2];
        return new Color_1(
            sqrt$2(pow$3(x1,2) * (1-f) + pow$3(x2,2) * f),
            sqrt$2(pow$3(y1,2) * (1-f) + pow$3(y2,2) * f),
            sqrt$2(pow$3(z1,2) * (1-f) + pow$3(z2,2) * f),
            'rgb'
        )
    };

    // register interpolator
    interpolator.lrgb = lrgb;

    var lab$1 = function (col1, col2, f) {
        var xyz0 = col1.lab();
        var xyz1 = col2.lab();
        return new Color_1(
            xyz0[0] + f * (xyz1[0]-xyz0[0]),
            xyz0[1] + f * (xyz1[1]-xyz0[1]),
            xyz0[2] + f * (xyz1[2]-xyz0[2]),
            'lab'
        )
    };

    // register interpolator
    interpolator.lab = lab$1;

    var _hsx = function (col1, col2, f, m) {
        var assign, assign$1;

        var xyz0, xyz1;
        if (m === 'hsl') {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === 'hsv') {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === 'hcg') {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === 'hsi') {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === 'lch' || m === 'hcl') {
            m = 'hcl';
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        }

        var hue0, hue1, sat0, sat1, lbv0, lbv1;
        if (m.substr(0, 1) === 'h') {
            (assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2]);
            (assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2]);
        }

        var sat, hue, lbv, dh;

        if (!isNaN(hue0) && !isNaN(hue1)) {
            // both colors have hue
            if (hue1 > hue0 && hue1 - hue0 > 180) {
                dh = hue1-(hue0+360);
            } else if (hue1 < hue0 && hue0 - hue1 > 180) {
                dh = hue1+360-hue0;
            } else{
                dh = hue1 - hue0;
            }
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') { sat = sat0; }
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') { sat = sat1; }
        } else {
            hue = Number.NaN;
        }

        if (sat === undefined) { sat = sat0 + f * (sat1 - sat0); }
        lbv = lbv0 + f * (lbv1-lbv0);
        return new Color_1([hue, sat, lbv], m);
    };

    var lch$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'lch');
    };

    // register interpolator
    interpolator.lch = lch$1;
    interpolator.hcl = lch$1;

    var num$1 = function (col1, col2, f) {
        var c1 = col1.num();
        var c2 = col2.num();
        return new Color_1(c1 + f * (c2-c1), 'num')
    };

    // register interpolator
    interpolator.num = num$1;

    var hcg$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hcg');
    };

    // register interpolator
    interpolator.hcg = hcg$1;

    var hsi$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hsi');
    };

    // register interpolator
    interpolator.hsi = hsi$1;

    var hsl$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hsl');
    };

    // register interpolator
    interpolator.hsl = hsl$1;

    var hsv$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hsv');
    };

    // register interpolator
    interpolator.hsv = hsv$1;

    var clip_rgb$2 = utils.clip_rgb;
    var pow$4 = Math.pow;
    var sqrt$3 = Math.sqrt;
    var PI$1 = Math.PI;
    var cos$2 = Math.cos;
    var sin$1 = Math.sin;
    var atan2$1 = Math.atan2;

    var average = function (colors, mode, weights) {
        if ( mode === void 0 ) mode='lrgb';
        if ( weights === void 0 ) weights=null;

        var l = colors.length;
        if (!weights) { weights = Array.from(new Array(l)).map(function () { return 1; }); }
        // normalize weights
        var k = l / weights.reduce(function(a, b) { return a + b; });
        weights.forEach(function (w,i) { weights[i] *= k; });
        // convert colors to Color objects
        colors = colors.map(function (c) { return new Color_1(c); });
        if (mode === 'lrgb') {
            return _average_lrgb(colors, weights)
        }
        var first = colors.shift();
        var xyz = first.get(mode);
        var cnt = [];
        var dx = 0;
        var dy = 0;
        // initial color
        for (var i=0; i<xyz.length; i++) {
            xyz[i] = (xyz[i] || 0) * weights[0];
            cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
            if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
                var A = xyz[i] / 180 * PI$1;
                dx += cos$2(A) * weights[0];
                dy += sin$1(A) * weights[0];
            }
        }

        var alpha = first.alpha() * weights[0];
        colors.forEach(function (c,ci) {
            var xyz2 = c.get(mode);
            alpha += c.alpha() * weights[ci+1];
            for (var i=0; i<xyz.length; i++) {
                if (!isNaN(xyz2[i])) {
                    cnt[i] += weights[ci+1];
                    if (mode.charAt(i) === 'h') {
                        var A = xyz2[i] / 180 * PI$1;
                        dx += cos$2(A) * weights[ci+1];
                        dy += sin$1(A) * weights[ci+1];
                    } else {
                        xyz[i] += xyz2[i] * weights[ci+1];
                    }
                }
            }
        });

        for (var i$1=0; i$1<xyz.length; i$1++) {
            if (mode.charAt(i$1) === 'h') {
                var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
                while (A$1 < 0) { A$1 += 360; }
                while (A$1 >= 360) { A$1 -= 360; }
                xyz[i$1] = A$1;
            } else {
                xyz[i$1] = xyz[i$1]/cnt[i$1];
            }
        }
        alpha /= l;
        return (new Color_1(xyz, mode)).alpha(alpha > 0.99999 ? 1 : alpha, true);
    };


    var _average_lrgb = function (colors, weights) {
        var l = colors.length;
        var xyz = [0,0,0,0];
        for (var i=0; i < colors.length; i++) {
            var col = colors[i];
            var f = weights[i] / l;
            var rgb = col._rgb;
            xyz[0] += pow$4(rgb[0],2) * f;
            xyz[1] += pow$4(rgb[1],2) * f;
            xyz[2] += pow$4(rgb[2],2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt$3(xyz[0]);
        xyz[1] = sqrt$3(xyz[1]);
        xyz[2] = sqrt$3(xyz[2]);
        if (xyz[3] > 0.9999999) { xyz[3] = 1; }
        return new Color_1(clip_rgb$2(xyz));
    };

    // minimal multi-purpose interface

    // @requires utils color analyze


    var type$j = utils.type;

    var pow$5 = Math.pow;

    var scale = function(colors) {

        // constructor
        var _mode = 'rgb';
        var _nacol = chroma_1('#ccc');
        var _spread = 0;
        // const _fixed = false;
        var _domain = [0, 1];
        var _pos = [];
        var _padding = [0,0];
        var _classes = false;
        var _colors = [];
        var _out = false;
        var _min = 0;
        var _max = 1;
        var _correctLightness = false;
        var _colorCache = {};
        var _useCache = true;
        var _gamma = 1;

        // private methods

        var setColors = function(colors) {
            colors = colors || ['#fff', '#000'];
            if (colors && type$j(colors) === 'string' && chroma_1.brewer &&
                chroma_1.brewer[colors.toLowerCase()]) {
                colors = chroma_1.brewer[colors.toLowerCase()];
            }
            if (type$j(colors) === 'array') {
                // handle single color
                if (colors.length === 1) {
                    colors = [colors[0], colors[0]];
                }
                // make a copy of the colors
                colors = colors.slice(0);
                // convert to chroma classes
                for (var c=0; c<colors.length; c++) {
                    colors[c] = chroma_1(colors[c]);
                }
                // auto-fill color position
                _pos.length = 0;
                for (var c$1=0; c$1<colors.length; c$1++) {
                    _pos.push(c$1/(colors.length-1));
                }
            }
            resetCache();
            return _colors = colors;
        };

        var getClass = function(value) {
            if (_classes != null) {
                var n = _classes.length-1;
                var i = 0;
                while (i < n && value >= _classes[i]) {
                    i++;
                }
                return i-1;
            }
            return 0;
        };

        var tMapLightness = function (t) { return t; };
        var tMapDomain = function (t) { return t; };

        // const classifyValue = function(value) {
        //     let val = value;
        //     if (_classes.length > 2) {
        //         const n = _classes.length-1;
        //         const i = getClass(value);
        //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
        //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
        //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
        //     }
        //     return val;
        // };

        var getColor = function(val, bypassMap) {
            var col, t;
            if (bypassMap == null) { bypassMap = false; }
            if (isNaN(val) || (val === null)) { return _nacol; }
            if (!bypassMap) {
                if (_classes && (_classes.length > 2)) {
                    // find the class
                    var c = getClass(val);
                    t = c / (_classes.length-2);
                } else if (_max !== _min) {
                    // just interpolate between min/max
                    t = (val - _min) / (_max - _min);
                } else {
                    t = 1;
                }
            } else {
                t = val;
            }

            // domain map
            t = tMapDomain(t);

            if (!bypassMap) {
                t = tMapLightness(t);  // lightness correction
            }

            if (_gamma !== 1) { t = pow$5(t, _gamma); }

            t = _padding[0] + (t * (1 - _padding[0] - _padding[1]));

            t = Math.min(1, Math.max(0, t));

            var k = Math.floor(t * 10000);

            if (_useCache && _colorCache[k]) {
                col = _colorCache[k];
            } else {
                if (type$j(_colors) === 'array') {
                    //for i in [0.._pos.length-1]
                    for (var i=0; i<_pos.length; i++) {
                        var p = _pos[i];
                        if (t <= p) {
                            col = _colors[i];
                            break;
                        }
                        if ((t >= p) && (i === (_pos.length-1))) {
                            col = _colors[i];
                            break;
                        }
                        if (t > p && t < _pos[i+1]) {
                            t = (t-p)/(_pos[i+1]-p);
                            col = chroma_1.interpolate(_colors[i], _colors[i+1], t, _mode);
                            break;
                        }
                    }
                } else if (type$j(_colors) === 'function') {
                    col = _colors(t);
                }
                if (_useCache) { _colorCache[k] = col; }
            }
            return col;
        };

        var resetCache = function () { return _colorCache = {}; };

        setColors(colors);

        // public interface

        var f = function(v) {
            var c = chroma_1(getColor(v));
            if (_out && c[_out]) { return c[_out](); } else { return c; }
        };

        f.classes = function(classes) {
            if (classes != null) {
                if (type$j(classes) === 'array') {
                    _classes = classes;
                    _domain = [classes[0], classes[classes.length-1]];
                } else {
                    var d = chroma_1.analyze(_domain);
                    if (classes === 0) {
                        _classes = [d.min, d.max];
                    } else {
                        _classes = chroma_1.limits(d, 'e', classes);
                    }
                }
                return f;
            }
            return _classes;
        };


        f.domain = function(domain) {
            if (!arguments.length) {
                return _domain;
            }
            _min = domain[0];
            _max = domain[domain.length-1];
            _pos = [];
            var k = _colors.length;
            if ((domain.length === k) && (_min !== _max)) {
                // update positions
                for (var i = 0, list = Array.from(domain); i < list.length; i += 1) {
                    var d = list[i];

                  _pos.push((d-_min) / (_max-_min));
                }
            } else {
                for (var c=0; c<k; c++) {
                    _pos.push(c/(k-1));
                }
                if (domain.length > 2) {
                    // set domain map
                    var tOut = domain.map(function (d,i) { return i/(domain.length-1); });
                    var tBreaks = domain.map(function (d) { return (d - _min) / (_max - _min); });
                    if (!tBreaks.every(function (val, i) { return tOut[i] === val; })) {
                        tMapDomain = function (t) {
                            if (t <= 0 || t >= 1) { return t; }
                            var i = 0;
                            while (t >= tBreaks[i+1]) { i++; }
                            var f = (t - tBreaks[i]) / (tBreaks[i+1] - tBreaks[i]);
                            var out = tOut[i] + f * (tOut[i+1] - tOut[i]);
                            return out;
                        };
                    }

                }
            }
            _domain = [_min, _max];
            return f;
        };

        f.mode = function(_m) {
            if (!arguments.length) {
                return _mode;
            }
            _mode = _m;
            resetCache();
            return f;
        };

        f.range = function(colors, _pos) {
            setColors(colors, _pos);
            return f;
        };

        f.out = function(_o) {
            _out = _o;
            return f;
        };

        f.spread = function(val) {
            if (!arguments.length) {
                return _spread;
            }
            _spread = val;
            return f;
        };

        f.correctLightness = function(v) {
            if (v == null) { v = true; }
            _correctLightness = v;
            resetCache();
            if (_correctLightness) {
                tMapLightness = function(t) {
                    var L0 = getColor(0, true).lab()[0];
                    var L1 = getColor(1, true).lab()[0];
                    var pol = L0 > L1;
                    var L_actual = getColor(t, true).lab()[0];
                    var L_ideal = L0 + ((L1 - L0) * t);
                    var L_diff = L_actual - L_ideal;
                    var t0 = 0;
                    var t1 = 1;
                    var max_iter = 20;
                    while ((Math.abs(L_diff) > 1e-2) && (max_iter-- > 0)) {
                        (function() {
                            if (pol) { L_diff *= -1; }
                            if (L_diff < 0) {
                                t0 = t;
                                t += (t1 - t) * 0.5;
                            } else {
                                t1 = t;
                                t += (t0 - t) * 0.5;
                            }
                            L_actual = getColor(t, true).lab()[0];
                            return L_diff = L_actual - L_ideal;
                        })();
                    }
                    return t;
                };
            } else {
                tMapLightness = function (t) { return t; };
            }
            return f;
        };

        f.padding = function(p) {
            if (p != null) {
                if (type$j(p) === 'number') {
                    p = [p,p];
                }
                _padding = p;
                return f;
            } else {
                return _padding;
            }
        };

        f.colors = function(numColors, out) {
            // If no arguments are given, return the original colors that were provided
            if (arguments.length < 2) { out = 'hex'; }
            var result = [];

            if (arguments.length === 0) {
                result = _colors.slice(0);

            } else if (numColors === 1) {
                result = [f(0.5)];

            } else if (numColors > 1) {
                var dm = _domain[0];
                var dd = _domain[1] - dm;
                result = __range__(0, numColors, false).map(function (i) { return f( dm + ((i/(numColors-1)) * dd) ); });

            } else { // returns all colors based on the defined classes
                colors = [];
                var samples = [];
                if (_classes && (_classes.length > 2)) {
                    for (var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
                        samples.push((_classes[i-1]+_classes[i])*0.5);
                    }
                } else {
                    samples = _domain;
                }
                result = samples.map(function (v) { return f(v); });
            }

            if (chroma_1[out]) {
                result = result.map(function (c) { return c[out](); });
            }
            return result;
        };

        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else {
                return _useCache;
            }
        };

        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else {
                return _gamma;
            }
        };

        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma_1(d);
                return f;
            } else {
                return _nacol;
            }
        };

        return f;
    };

    function __range__(left, right, inclusive) {
      var range = [];
      var ascending = left < right;
      var end = !inclusive ? right : ascending ? right + 1 : right - 1;
      for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
        range.push(i);
      }
      return range;
    }

    //
    // interpolates between a set of colors uzing a bezier spline
    //

    // @requires utils lab




    var bezier = function(colors) {
        var assign, assign$1, assign$2;

        var I, lab0, lab1, lab2;
        colors = colors.map(function (c) { return new Color_1(c); });
        if (colors.length === 2) {
            // linear interpolation
            (assign = colors.map(function (c) { return c.lab(); }), lab0 = assign[0], lab1 = assign[1]);
            I = function(t) {
                var lab = ([0, 1, 2].map(function (i) { return lab0[i] + (t * (lab1[i] - lab0[i])); }));
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 3) {
            // quadratic bezier interpolation
            (assign$1 = colors.map(function (c) { return c.lab(); }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2]);
            I = function(t) {
                var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t) * lab0[i]) + (2 * (1-t) * t * lab1[i]) + (t * t * lab2[i]); }));
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 4) {
            // cubic bezier interpolation
            var lab3;
            (assign$2 = colors.map(function (c) { return c.lab(); }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3]);
            I = function(t) {
                var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t)*(1-t) * lab0[i]) + (3 * (1-t) * (1-t) * t * lab1[i]) + (3 * (1-t) * t * t * lab2[i]) + (t*t*t * lab3[i]); }));
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 5) {
            var I0 = bezier(colors.slice(0, 3));
            var I1 = bezier(colors.slice(2, 5));
            I = function(t) {
                if (t < 0.5) {
                    return I0(t*2);
                } else {
                    return I1((t-0.5)*2);
                }
            };
        }
        return I;
    };

    var bezier_1 = function (colors) {
        var f = bezier(colors);
        f.scale = function () { return scale(f); };
        return f;
    };

    




    var blend = function (bottom, top, mode) {
        if (!blend[mode]) {
            throw new Error('unknown blend mode ' + mode);
        }
        return blend[mode](bottom, top);
    };

    var blend_f = function (f) { return function (bottom,top) {
            var c0 = chroma_1(top).rgb();
            var c1 = chroma_1(bottom).rgb();
            return chroma_1.rgb(f(c0, c1));
        }; };

    var each = function (f) { return function (c0, c1) {
            var out = [];
            out[0] = f(c0[0], c1[0]);
            out[1] = f(c0[1], c1[1]);
            out[2] = f(c0[2], c1[2]);
            return out;
        }; };

    var normal = function (a) { return a; };
    var multiply = function (a,b) { return a * b / 255; };
    var darken$1 = function (a,b) { return a > b ? b : a; };
    var lighten = function (a,b) { return a > b ? a : b; };
    var screen = function (a,b) { return 255 * (1 - (1-a/255) * (1-b/255)); };
    var overlay = function (a,b) { return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255 ) * ( 1 - b / 255 )); };
    var burn = function (a,b) { return 255 * (1 - (1 - b / 255) / (a/255)); };
    var dodge = function (a,b) {
        if (a === 255) { return 255; }
        a = 255 * (b / 255) / (1 - a / 255);
        return a > 255 ? 255 : a
    };

    // # add = (a,b) ->
    // #     if (a + b > 255) then 255 else a + b

    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken$1));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    // blend.add = blend_f(each(add));

    var blend_1 = blend;

    // cubehelix interpolation
    // based on D.A. Green "A colour scheme for the display of astronomical intensity images"
    // http://astron-soc.in/bulletin/11June/289392011.pdf

    var type$k = utils.type;
    var clip_rgb$3 = utils.clip_rgb;
    var TWOPI$2 = utils.TWOPI;
    var pow$6 = Math.pow;
    var sin$2 = Math.sin;
    var cos$3 = Math.cos;


    var cubehelix = function(start, rotations, hue, gamma, lightness) {
        if ( start === void 0 ) start=300;
        if ( rotations === void 0 ) rotations=-1.5;
        if ( hue === void 0 ) hue=1;
        if ( gamma === void 0 ) gamma=1;
        if ( lightness === void 0 ) lightness=[0,1];

        var dh = 0, dl;
        if (type$k(lightness) === 'array') {
            dl = lightness[1] - lightness[0];
        } else {
            dl = 0;
            lightness = [lightness, lightness];
        }

        var f = function(fract) {
            var a = TWOPI$2 * (((start+120)/360) + (rotations * fract));
            var l = pow$6(lightness[0] + (dl * fract), gamma);
            var h = dh !== 0 ? hue[0] + (fract * dh) : hue;
            var amp = (h * l * (1-l)) / 2;
            var cos_a = cos$3(a);
            var sin_a = sin$2(a);
            var r = l + (amp * ((-0.14861 * cos_a) + (1.78277* sin_a)));
            var g = l + (amp * ((-0.29227 * cos_a) - (0.90649* sin_a)));
            var b = l + (amp * (+1.97294 * cos_a));
            return chroma_1(clip_rgb$3([r*255,g*255,b*255,1]));
        };

        f.start = function(s) {
            if ((s == null)) { return start; }
            start = s;
            return f;
        };

        f.rotations = function(r) {
            if ((r == null)) { return rotations; }
            rotations = r;
            return f;
        };

        f.gamma = function(g) {
            if ((g == null)) { return gamma; }
            gamma = g;
            return f;
        };

        f.hue = function(h) {
            if ((h == null)) { return hue; }
            hue = h;
            if (type$k(hue) === 'array') {
                dh = hue[1] - hue[0];
                if (dh === 0) { hue = hue[1]; }
            } else {
                dh = 0;
            }
            return f;
        };

        f.lightness = function(h) {
            if ((h == null)) { return lightness; }
            if (type$k(h) === 'array') {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [h,h];
                dl = 0;
            }
            return f;
        };

        f.scale = function () { return chroma_1.scale(f); };

        f.hue(hue);

        return f;
    };

    var digits = '0123456789abcdef';

    var floor$2 = Math.floor;
    var random = Math.random;

    var random_1 = function () {
        var code = '#';
        for (var i=0; i<6; i++) {
            code += digits.charAt(floor$2(random() * 16));
        }
        return new Color_1(code, 'hex');
    };

    var log$1 = Math.log;
    var pow$7 = Math.pow;
    var floor$3 = Math.floor;
    var abs = Math.abs;


    var analyze = function (data, key) {
        if ( key === void 0 ) key=null;

        var r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE*-1,
            sum: 0,
            values: [],
            count: 0
        };
        if (type(data) === 'object') {
            data = Object.values(data);
        }
        data.forEach(function (val) {
            if (key && type(val) === 'object') { val = val[key]; }
            if (val !== undefined && val !== null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) { r.min = val; }
                if (val > r.max) { r.max = val; }
                r.count += 1;
            }
        });

        r.domain = [r.min, r.max];

        r.limits = function (mode, num) { return limits(r, mode, num); };

        return r;
    };


    var limits = function (data, mode, num) {
        if ( mode === void 0 ) mode='equal';
        if ( num === void 0 ) num=7;

        if (type(data) == 'array') {
            data = analyze(data);
        }
        var min = data.min;
        var max = data.max;
        var values = data.values.sort(function (a,b) { return a-b; });

        if (num === 1) { return [min,max]; }

        var limits = [];

        if (mode.substr(0,1) === 'c') { // continuous
            limits.push(min);
            limits.push(max);
        }

        if (mode.substr(0,1) === 'e') { // equal interval
            limits.push(min);
            for (var i=1; i<num; i++) {
                limits.push(min+((i/num)*(max-min)));
            }
            limits.push(max);
        }

        else if (mode.substr(0,1) === 'l') { // log scale
            if (min <= 0) {
                throw new Error('Logarithmic scales are only possible for values > 0');
            }
            var min_log = Math.LOG10E * log$1(min);
            var max_log = Math.LOG10E * log$1(max);
            limits.push(min);
            for (var i$1=1; i$1<num; i$1++) {
                limits.push(pow$7(10, min_log + ((i$1/num) * (max_log - min_log))));
            }
            limits.push(max);
        }

        else if (mode.substr(0,1) === 'q') { // quantile scale
            limits.push(min);
            for (var i$2=1; i$2<num; i$2++) {
                var p = ((values.length-1) * i$2)/num;
                var pb = floor$3(p);
                if (pb === p) {
                    limits.push(values[pb]);
                } else { // p > pb
                    var pr = p - pb;
                    limits.push((values[pb]*(1-pr)) + (values[pb+1]*pr));
                }
            }
            limits.push(max);

        }

        else if (mode.substr(0,1) === 'k') { // k-means clustering
            
            var cluster;
            var n = values.length;
            var assignments = new Array(n);
            var clusterSizes = new Array(num);
            var repeat = true;
            var nb_iters = 0;
            var centroids = null;

            // get seed values
            centroids = [];
            centroids.push(min);
            for (var i$3=1; i$3<num; i$3++) {
                centroids.push(min + ((i$3/num) * (max-min)));
            }
            centroids.push(max);

            while (repeat) {
                // assignment step
                for (var j=0; j<num; j++) {
                    clusterSizes[j] = 0;
                }
                for (var i$4=0; i$4<n; i$4++) {
                    var value = values[i$4];
                    var mindist = Number.MAX_VALUE;
                    var best = (void 0);
                    for (var j$1=0; j$1<num; j$1++) {
                        var dist = abs(centroids[j$1]-value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j$1;
                        }
                        clusterSizes[best]++;
                        assignments[i$4] = best;
                    }
                }

                // update centroids step
                var newCentroids = new Array(num);
                for (var j$2=0; j$2<num; j$2++) {
                    newCentroids[j$2] = null;
                }
                for (var i$5=0; i$5<n; i$5++) {
                    cluster = assignments[i$5];
                    if (newCentroids[cluster] === null) {
                        newCentroids[cluster] = values[i$5];
                    } else {
                        newCentroids[cluster] += values[i$5];
                    }
                }
                for (var j$3=0; j$3<num; j$3++) {
                    newCentroids[j$3] *= 1/clusterSizes[j$3];
                }

                // check convergence
                repeat = false;
                for (var j$4=0; j$4<num; j$4++) {
                    if (newCentroids[j$4] !== centroids[j$4]) {
                        repeat = true;
                        break;
                    }
                }

                centroids = newCentroids;
                nb_iters++;

                if (nb_iters > 200) {
                    repeat = false;
                }
            }

            // finished k-means clustering
            // the next part is borrowed from gabrielflor.it
            var kClusters = {};
            for (var j$5=0; j$5<num; j$5++) {
                kClusters[j$5] = [];
            }
            for (var i$6=0; i$6<n; i$6++) {
                cluster = assignments[i$6];
                kClusters[cluster].push(values[i$6]);
            }
            var tmpKMeansBreaks = [];
            for (var j$6=0; j$6<num; j$6++) {
                tmpKMeansBreaks.push(kClusters[j$6][0]);
                tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length-1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function (a,b){ return a-b; });
            limits.push(tmpKMeansBreaks[0]);
            for (var i$7=1; i$7 < tmpKMeansBreaks.length; i$7+= 2) {
                var v = tmpKMeansBreaks[i$7];
                if (!isNaN(v) && (limits.indexOf(v) === -1)) {
                    limits.push(v);
                }
            }
        }
        return limits;
    };

    var analyze_1 = {analyze: analyze, limits: limits};

    var contrast = function (a, b) {
        // WCAG contrast ratio
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
        a = new Color_1(a);
        b = new Color_1(b);
        var l1 = a.luminance();
        var l2 = b.luminance();
        return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
    };

    var sqrt$4 = Math.sqrt;
    var atan2$2 = Math.atan2;
    var abs$1 = Math.abs;
    var cos$4 = Math.cos;
    var PI$2 = Math.PI;

    var deltaE = function(a, b, L, C) {
        if ( L === void 0 ) L=1;
        if ( C === void 0 ) C=1;

        // Delta E (CMC)
        // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CMC.html
        a = new Color_1(a);
        b = new Color_1(b);
        var ref = Array.from(a.lab());
        var L1 = ref[0];
        var a1 = ref[1];
        var b1 = ref[2];
        var ref$1 = Array.from(b.lab());
        var L2 = ref$1[0];
        var a2 = ref$1[1];
        var b2 = ref$1[2];
        var c1 = sqrt$4((a1 * a1) + (b1 * b1));
        var c2 = sqrt$4((a2 * a2) + (b2 * b2));
        var sl = L1 < 16.0 ? 0.511 : (0.040975 * L1) / (1.0 + (0.01765 * L1));
        var sc = ((0.0638 * c1) / (1.0 + (0.0131 * c1))) + 0.638;
        var h1 = c1 < 0.000001 ? 0.0 : (atan2$2(b1, a1) * 180.0) / PI$2;
        while (h1 < 0) { h1 += 360; }
        while (h1 >= 360) { h1 -= 360; }
        var t = (h1 >= 164.0) && (h1 <= 345.0) ? (0.56 + abs$1(0.2 * cos$4((PI$2 * (h1 + 168.0)) / 180.0))) : (0.36 + abs$1(0.4 * cos$4((PI$2 * (h1 + 35.0)) / 180.0)));
        var c4 = c1 * c1 * c1 * c1;
        var f = sqrt$4(c4 / (c4 + 1900.0));
        var sh = sc * (((f * t) + 1.0) - f);
        var delL = L1 - L2;
        var delC = c1 - c2;
        var delA = a1 - a2;
        var delB = b1 - b2;
        var dH2 = ((delA * delA) + (delB * delB)) - (delC * delC);
        var v1 = delL / (L * sl);
        var v2 = delC / (C * sc);
        var v3 = sh;
        return sqrt$4((v1 * v1) + (v2 * v2) + (dH2 / (v3 * v3)));
    };

    // simple Euclidean distance
    var distance = function(a, b, mode) {
        if ( mode === void 0 ) mode='lab';

        // Delta E (CIE 1976)
        // see http://www.brucelindbloom.com/index.html?Equations.html
        a = new Color_1(a);
        b = new Color_1(b);
        var l1 = a.get(mode);
        var l2 = b.get(mode);
        var sum_sq = 0;
        for (var i in l1) {
            var d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d*d;
        }
        return Math.sqrt(sum_sq);
    };

    var valid = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        try {
            new (Function.prototype.bind.apply( Color_1, [ null ].concat( args) ));
            return true;
        } catch (e) {
            return false;
        }
    };

    // some pre-defined color scales:




    var scales = {
    	cool: function cool() { return scale([chroma_1.hsl(180,1,.9), chroma_1.hsl(250,.7,.4)]) },
    	hot: function hot() { return scale(['#000','#f00','#ff0','#fff'], [0,.25,.75,1]).mode('rgb') }
    };

    

    var colorbrewer = {
        // sequential
        OrRd: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000'],
        PuBu: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858'],
        BuPu: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'],
        Oranges: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704'],
        BuGn: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
        YlOrBr: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'],
        YlGn: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529'],
        Reds: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
        RdPu: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a'],
        Greens: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
        YlGnBu: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58'],
        Purples: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'],
        GnBu: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081'],
        Greys: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000'],
        YlOrRd: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026'],
        PuRd: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f'],
        Blues: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
        PuBuGn: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
        Viridis: ['#440154', '#482777', '#3f4a8a', '#31678e', '#26838f', '#1f9d8a', '#6cce5a', '#b6de2b', '#fee825'],

        // diverging

        Spectral: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
        RdYlGn: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
        RdBu: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
        PiYG: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
        PRGn: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
        RdYlBu: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
        BrBG: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
        RdGy: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
        PuOr: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],

        // qualitative

        Set2: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
        Accent: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666'],
        Set1: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
        Set3: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
        Dark2: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'],
        Paired: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'],
        Pastel2: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc'],
        Pastel1: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2'],
    };

    // add lowercase aliases for case-insensitive matches
    for (var i$1 = 0, list$1 = Object.keys(colorbrewer); i$1 < list$1.length; i$1 += 1) {
        var key = list$1[i$1];

        colorbrewer[key.toLowerCase()] = colorbrewer[key];
    }

    var colorbrewer_1 = colorbrewer;

    // feel free to comment out anything to rollup
    // a smaller chroma.js built

    // io --> convert colors















    // operators --> modify existing Colors










    // interpolators










    // generators -- > create new colors
    chroma_1.average = average;
    chroma_1.bezier = bezier_1;
    chroma_1.blend = blend_1;
    chroma_1.cubehelix = cubehelix;
    chroma_1.mix = chroma_1.interpolate = mix;
    chroma_1.random = random_1;
    chroma_1.scale = scale;

    // other utility methods
    chroma_1.analyze = analyze_1.analyze;
    chroma_1.contrast = contrast;
    chroma_1.deltaE = deltaE;
    chroma_1.distance = distance;
    chroma_1.limits = analyze_1.limits;
    chroma_1.valid = valid;

    // scale
    chroma_1.scales = scales;

    // colors
    chroma_1.colors = w3cx11_1;
    chroma_1.brewer = colorbrewer_1;

    var chroma_js = chroma_1;

    return chroma_js;

})));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CAN_DRAG; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return SET_GO_DOWN; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return SET_CAN_NAVIGATE; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return SET_AUTONAVIGATION; });
var SET_CAN_DRAG='SET_CAN_DRAG';var SET_GO_DOWN='SET_GO_DOWN';var SET_CAN_NAVIGATE='SET_CAN_NAVIGATE';var SET_AUTONAVIGATION='SET_AUTONAVIGATION';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DASHBOARD; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_ELEMENT; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return UNSELECT_ELEMENT; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_SELECTED_ELEMENTS; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return SET_VISITED_ELEMENTS; });
var SET_DASHBOARD='SET_DASHBOARD';var SELECT_ELEMENT='SELECT_ELEMENT';var UNSELECT_ELEMENT='UNSELECT_ELEMENT';var RESET_SELECTED_ELEMENTS='RESET_SELECTED_ELEMENTS';var SET_VISITED_ELEMENTS='SET_VISITED_ELEMENTS';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = loginReducer;
 var __WEBPACK_IMPORTED_MODULE_0_store_globalState_initialState__ = __webpack_require__(74);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(353);
function loginReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0_store_globalState_initialState__["a" ].login;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__types__["b" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["c" ]:return{error:''};case __WEBPACK_IMPORTED_MODULE_1__types__["a" ]:return{error:action.payload};default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 __webpack_exports__["a"] = setAdditionalLanguages;
 var __WEBPACK_IMPORTED_MODULE_0__store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(342);
function setPlatformLanguage(lang){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["b" ],payload:lang};}function setPlatformLanguageAction(lang){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__store_globalState_global__["c" ])(true));dispatch(setPlatformLanguage(lang));setTimeout(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__store_globalState_global__["c" ])(false));},1000);};}function setAdditionalLanguages(languages){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["a" ],payload:languages});};}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_INSTANCE; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return SET_AUTHENTICATED; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return SELECT_USER; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return SET_SPLASH_SCREEN; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return NOTIFICATION_TO_ROOM; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATION; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_OPEN_CHAT; });
var FETCH_INSTANCE='FETCH_INSTANCE';var SET_AUTHENTICATED='SET_AUTHENTICATED';var SELECT_USER='SELECT_USER';var SET_SPLASH_SCREEN='SET_SPLASH_SCREEN';var NOTIFICATION_TO_ROOM='notification to room';var NOTIFICATION='notification';var CHANGE_OPEN_CHAT='change_open_chat';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return SET_AVATAR; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ERROR; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SUCCESS; });

var SET_AVATAR='SET_AVATAR';var SET_ERROR='SET_ERROR';var SET_SUCCESS='SET_SUCCESS';var FETCH_SIGNUP='FETCH_SIGNUP';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "a", function() { return TYPE_CALL_FOR_IMPACT; });
var TYPE_NARRATIVE=21227761;var TYPE_CALL_FOR_IMPACT=21227760;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_NARRATIVES; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_OBJECTIVES; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_TOOLS; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_ELEMENTS; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_SPEED_DATING_INIT; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_SPEED_DATING_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_SPEED_DATING_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_SPEED_DATING_MATCHES_INIT; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_SPEED_DATING_MATCHES_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_SPEED_DATING_MATCHES_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ACTUAL_SPEED_DATING_CALLS_INIT; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ACTUAL_SPEED_DATING_CALLS_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ACTUAL_SPEED_DATING_CALLS_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return NOTIFICATION_TO_ROOM; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return NOTIFICATION; });
 __webpack_require__.d(__webpack_exports__, "u", function() { return RESET_NARRATIVE_INIT; });
 __webpack_require__.d(__webpack_exports__, "v", function() { return RESET_NARRATIVE_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return RESET_NARRATIVE_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return GET_MY_CALLS_FOR_IMPACT_INIT; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return GET_MY_CALLS_FOR_IMPACT_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return GET_MY_CALLS_FOR_IMPACT_FAILURE; });
 __webpack_require__.d(__webpack_exports__, "w", function() { return SET_NARRATIVE_AS_COMPLETED; });

 __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAN_USERS_FROM_NARRATIVE; });
var FETCH_NARRATIVES='FETCH_NARRATIVES';var FETCH_OBJECTIVES='FETCH_OBJECTIVES';var FETCH_TOOLS='FETCH_TOOLS';var FETCH_ELEMENTS='FETCH_ELEMENTS';var FETCH_SPEED_DATING_INIT='FETCH_SPEED_DATING_INIT';var FETCH_SPEED_DATING_SUCCESS='FETCH_SPEED_DATING_SUCCESS';var FETCH_SPEED_DATING_FAILURE='FETCH_SPEED_DATING_FAILURE';var FETCH_SPEED_DATING_MATCHES_INIT='FETCH_SPEED_DATING_MATCHES_INIT';var FETCH_SPEED_DATING_MATCHES_SUCCESS='FETCH_SPEED_DATING_MATCHES_SUCCESS';var FETCH_SPEED_DATING_MATCHES_FAILURE='FETCH_SPEED_DATING_MATCHES_FAILURE';var FETCH_ACTUAL_SPEED_DATING_CALLS_INIT='FETCH_ACTUAL_SPEED_DATING_CALLS_INIT';var FETCH_ACTUAL_SPEED_DATING_CALLS_SUCCESS='FETCH_ACTUAL_SPEED_DATING_CALLS_SUCCESS';var FETCH_ACTUAL_SPEED_DATING_CALLS_FAILURE='FETCH_ACTUAL_SPEED_DATING_CALLS_FAILURE';var NOTIFICATION_TO_ROOM='notification to room';var NOTIFICATION='notification';var RESET_NARRATIVE_INIT='RESET_NARRATIVE_INIT';var RESET_NARRATIVE_SUCCESS='RESET_NARRATIVE_SUCCESS';var RESET_NARRATIVE_FAILURE='RESET_NARRATIVE_FAILURE';var GET_MY_CALLS_FOR_IMPACT_INIT='GET_MY_CALLS_FOR_IMPACT_INIT';var GET_MY_CALLS_FOR_IMPACT_SUCCESS='GET_MY_CALLS_FOR_IMPACT_SUCCESS';var GET_MY_CALLS_FOR_IMPACT_FAILURE='GET_MY_CALLS_FOR_IMPACT_FAILURE';var SET_NARRATIVE_AS_COMPLETED='SET_NARRATIVE_AS_COMPLETED';var ADD_NEW_USER_TO_NARRATIVE='ADD_NEW_USER_TO_NARRATIVE';var CLEAN_USERS_FROM_NARRATIVE='CLEAN_USERS_FROM_NARRATIVE';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";











 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_2_constants_apiConf__ = __webpack_require__(156);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(693);
var _ACTION_HANDLERS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INITIAL_STATE={mtps:[],challenges:[],collectives:[],actions:[],actionsList:[],image:'',tags:[],uploadingImage:false,mtpsOtherUsers:[]};var setPersonalMTP=function setPersonalMTP(mtp){return function(){var params={name:mtp,type:'personal_mtp',narrative_type:'mtp',acceptDuplicate:1};Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'element'},params);};};var fetchActionList=function fetchActionList(){return function(dispatch){var params={narrativeType:'mtp',type:'action',size:10};Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'elements/most_used'},params).then(function(actionsList){var actions=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(actionsList,function(element){return{id:element.name,label:element.name,value:element.amount};});dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["d" ],actionsList:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.shuffle(actions)});});};};var fetchMTPs=function fetchMTPs(){return function(dispatch){var params={type:'mtp',size:10};Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('GET',{endPoint:'elements'},params).then(function(mtpsOtherUsers){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["h" ],mtpsOtherUsers:mtpsOtherUsers});});};};var setMTPs=function setMTPs(mtps){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["g" ],mtps:mtps});};};var setChallenges=function setChallenges(challenges){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["e" ],challenges:challenges});};};var setCollectives=function setCollectives(collectives){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["f" ],collectives:collectives});};};var setActions=function setActions(actions){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["c" ],actions:actions});};};var resetMtps=function resetMtps(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["b" ]});};};var addTag=function addTag(tag){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["a" ],tag:tag});};};var uploadMTPImage=function uploadMTPImage(data,name){return function(dispatch){var params={data:data,name:name};dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["i" ],uploadingImage:true});Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'upload-file'},params).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["j" ],image:response.url});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["j" ],image:false});});};};var sendMTPs=function sendMTPs(){return function(dispatch,getState){var _getState$MTPData=getState().MTPData,mtps=_getState$MTPData.mtps,challenges=_getState$MTPData.challenges,collectives=_getState$MTPData.collectives,actions=_getState$MTPData.actions,image=_getState$MTPData.image,tags=_getState$MTPData.tags;__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(mtps,function(mtp){if(mtp){var elements=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(challenges,function(challenge){return'challenge-'+challenge;});elements=elements.concat(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(collectives,function(collective){return'collective-'+collective;}));elements=elements.concat(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(actions,function(action){return'action-'+action;}));elements=elements.concat(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(tags,function(tag){return'tag-'+tag;}));var params={type:'mtp',name:mtp,image:image,elements:elements.join(__WEBPACK_IMPORTED_MODULE_2_constants_apiConf__["b" ])};Object(__WEBPACK_IMPORTED_MODULE_1_utils_apiFetch__["b" ])('POST',{endPoint:'element'},params);}});};};var ACTION_HANDLERS=(_ACTION_HANDLERS={},_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_4__types__["d" ],function(state,_ref){var actionsList=_ref.actionsList;return Object.assign({},state,{actionsList:actionsList});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_4__types__["b" ],function(state){return Object.assign({},state,{mtps:[],challenges:[],collections:[],actions:[]});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_4__types__["g" ],function(state,_ref2){var mtps=_ref2.mtps;return Object.assign({},state,{mtps:mtps});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_4__types__["e" ],function(state,_ref3){var challenges=_ref3.challenges;return Object.assign({},state,{challenges:challenges});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_4__types__["f" ],function(state,_ref4){var collectives=_ref4.collectives;return Object.assign({},state,{collectives:collectives});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_4__types__["c" ],function(state,_ref5){var actions=_ref5.actions;return Object.assign({},state,{actions:actions});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_4__types__["a" ],function(state,_ref6){var tag=_ref6.tag;return Object.assign({},state,{tags:state.tags.concat(tag)});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_4__types__["j" ],function(state,_ref7){var image=_ref7.image;return Object.assign({},state,{image:image,uploadingImage:false});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_4__types__["i" ],function(state,_ref8){var uploadingImage=_ref8.uploadingImage;return Object.assign({},state,{uploadingImage:uploadingImage});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_4__types__["h" ],function(state,_ref9){var mtpsOtherUsers=_ref9.mtpsOtherUsers;return Object.assign({},state,{mtpsOtherUsers:mtpsOtherUsers});}),_ACTION_HANDLERS); __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ACTIONS_LIST; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_MTPS_DATA; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return SET_MTPS; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CHALLENGES; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return SET_COLLECTIVES; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ACTIONS; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return UPLOAD_IMAGE; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return SET_UPLOADING_IMAGE; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TAG; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return SET_MTPS_OTHER_USERS; });
var SET_ACTIONS_LIST='MTP/SET_ACTIONS_LIST';var RESET_MTPS_DATA='MTP/RESET_MTPS_DATA';var SET_MTPS='MTP/SET_MTPS';var SET_CHALLENGES='MTP/SET_CHALLENGES';var SET_COLLECTIVES='MTP/SET_COLLECTIVES';var SET_ACTIONS='MTP/SET_ACTIONS';var UPLOAD_IMAGE='MTP/UPLOAD_IMAGE';var SET_UPLOADING_IMAGE='MTP/SET_UPLOADING_IMAGE';var ADD_TAG='MTP/ADD_TAG';var SET_MTPS_OTHER_USERS='MTP/SET_MTPS_OTHER_USERS';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_USER_CHATS; });

 __webpack_require__.d(__webpack_exports__, "g", function() { return NOTIFICATION_TO_ROOM; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return NOTIFICATION; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return NEW_MESSAGE; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return SET_SELECTED_CHAT; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return SET_CHAT_AS_READ; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return SET_IS_LOADING_OLDER; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return LEAVE_CHAT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return GET_INVITATIONS; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return REJECT_INVITATION; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPT_INVITATION; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_CHAT; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_CHAT_INIT; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_CHAT_IMAGE; });
var FETCH_USER_CHATS='FETCH_USER_CHATS';var SET_NEW_MESSAGE='SET_NEW_MESSAGE';var NOTIFICATION_TO_ROOM='notification to room';var NOTIFICATION='notification';var NEW_MESSAGE='new_message';var SET_SELECTED_CHAT='set_selected_chat';var SET_CHAT_AS_READ='set_chat_as_read';var SET_IS_LOADING_OLDER='set_is_loading_older';var LEAVE_CHAT='leave_chat';var GET_INVITATIONS='get_invitations';var REJECT_INVITATION='reject_invitation';var ACCEPT_INVITATION='accept_invitation';var UPDATE_CHAT='update_chat';var UPDATE_CHAT_INIT='update_chat_init';var UPDATE_CHAT_IMAGE='update_chat_image';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = socketReducer;
 var __WEBPACK_IMPORTED_MODULE_0_store_globalState_initialState__ = __webpack_require__(74);
 var __WEBPACK_IMPORTED_MODULE_1_utils_objects__ = __webpack_require__(341);
 var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(340);
 var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(155);
 var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(81);
function socketReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0_store_globalState_initialState__["a" ].socket;var action=arguments[1];var payload=action.payload;if(!payload){return state;}var user_id=payload.user_id,user_code=payload.user_code,instanceId=payload.instanceId;switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].WHATS_YOUR_CODE:{var rooms=Object(__WEBPACK_IMPORTED_MODULE_1_utils_objects__["a" ])(state.rooms);rooms[__WEBPACK_IMPORTED_MODULE_3__constants__["f" ]+user_id]={};rooms[__WEBPACK_IMPORTED_MODULE_3__constants__["f" ]+user_id].code=user_code;rooms[__WEBPACK_IMPORTED_MODULE_3__constants__["f" ]+user_id].users=[];return Object.assign({},state,{rooms:rooms});}case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].CODE_DENIED:{return Object.assign({},state,{is_connected_to_node:false});}case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].CODE_ACCEPTED:{var rooms_back=Object(__WEBPACK_IMPORTED_MODULE_1_utils_objects__["a" ])(state.rooms_back);var rooms_request=Object(__WEBPACK_IMPORTED_MODULE_1_utils_objects__["a" ])(state.rooms_request);var interval_reconnect_node=state.interval_reconnect_node;Object.keys(rooms_back).forEach(function(name){if(name===__WEBPACK_IMPORTED_MODULE_3__constants__["f" ]+user_id)return true;var pieces=name.split('___');Object(__WEBPACK_IMPORTED_MODULE_4__actions__["c" ])(pieces[1],pieces[2]);return true;});rooms_back={};Object.keys(rooms_request).forEach(function(name){if(name===__WEBPACK_IMPORTED_MODULE_3__constants__["f" ]+user_id)return true;var pieces=name.split('___');Object(__WEBPACK_IMPORTED_MODULE_4__actions__["c" ])(pieces[1],pieces[2]);return true;});rooms_request={};Object(__WEBPACK_IMPORTED_MODULE_4__actions__["c" ])(__WEBPACK_IMPORTED_MODULE_3__constants__["a" ],1);Object(__WEBPACK_IMPORTED_MODULE_4__actions__["c" ])(__WEBPACK_IMPORTED_MODULE_3__constants__["a" ],instanceId);if(interval_reconnect_node)clearInterval(interval_reconnect_node);return Object.assign({},state,{is_connected_to_node:true,rooms_back:rooms_back,rooms_request:rooms_request,interval_reconnect_node:interval_reconnect_node});}case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].DISCONNECT:{var _rooms_back=Object(__WEBPACK_IMPORTED_MODULE_1_utils_objects__["a" ])(state.rooms);var _rooms={};var _interval_reconnect_node=setInterval(function(){Object(__WEBPACK_IMPORTED_MODULE_4__actions__["d" ])(0);},5000);return Object.assign({},state,{is_connected_to_node:false,rooms_back:_rooms_back,rooms:_rooms,interval_reconnect_node:_interval_reconnect_node});}case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].JOINED_IN_ROOM:{var data=typeof action.payload==='string'?JSON.parse(action.payload):action.payload;var _rooms2=Object(__WEBPACK_IMPORTED_MODULE_1_utils_objects__["a" ])(state.rooms);var _rooms_request=Object(__WEBPACK_IMPORTED_MODULE_1_utils_objects__["a" ])(state.rooms_request);delete _rooms_request[data.room];_rooms2[data.room]={};_rooms2[data.room].code=data.code;_rooms2[data.room].users=data.users;return Object.assign({},state,{rooms:_rooms2,rooms_request:_rooms_request});}case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].NOTIFICATION:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].NOTIFICATION_TO_ROOM:{return state;}case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].UPDATE_USERS_ROOM:{return Object.assign({},state);}case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].CONNECT_USER_TO_ROOM:{var _rooms3=Object(__WEBPACK_IMPORTED_MODULE_1_utils_objects__["a" ])(state.rooms);if(typeof _rooms3[action.payload.room]==='undefined')return state;var _data=typeof action.payload==='string'?JSON.parse(action.payload):action.payload;var room_name=__WEBPACK_IMPORTED_MODULE_3__constants__["b" ]+'___'+_data.type+'___'+_data.id;if(typeof _rooms3[room_name]==='undefined')return state;var new_user_id=parseInt(_data.user.id,10);var found=false;_rooms3[room_name].users.forEach(function(user){if(parseInt(user.id,10)===new_user_id){found=true;return false;}return true;});if(!found){_rooms3[room_name].users.push(_data.user);}return Object.assign({},state,{rooms:_rooms3});}case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].DISCONNECT_USER:{var _rooms4=Object(__WEBPACK_IMPORTED_MODULE_1_utils_objects__["a" ])(state.rooms);if(typeof _rooms4[action.payload.room]==='undefined')return state;var _data2=typeof action.payload==='string'?JSON.parse(action.payload):action.payload;var disconnect_user_id=parseInt(_data2.user,10);Object.keys(_rooms4).map(function(room_id){var room=_rooms4[room_id];var new_users=[];var modified=false;if(room.users){room.users.forEach(function(user){if(parseInt(user.id,10)!==disconnect_user_id){new_users.push(user);}else{modified=true;}});}if(modified){_rooms4[room_id].users=new_users;}return true;});return Object.assign({},state,{rooms:_rooms4});}case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].USER_FOCUS:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].USER_BLUR:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].INPUT_KEYPRESS:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].INPUT_CHANGE:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].CHAT_OLD_MESSAGES:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].MESSAGE_TO_CHAT:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].USER_HAS_LEFT_THE_CHAT:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].USER_HAS_ENTER_THE_CHAT:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].USER_IS_WRITING_IN_CHAT:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].USER_IS_WATCHING_THE_CHAT:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].USER_IS_NOT_WATCHING_THE_CHAT:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].DELETE_CHAT:case __WEBPACK_IMPORTED_MODULE_2__types__["d" ].NOTIFICATION_TO_USER:return state;default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return SET_QUERY_STRING; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return SET_RESULTS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CAN_LOAD_MORE; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return SET_IS_LOADING; });
var SET_QUERY_STRING='set_query_string';var SET_RESULTS='set_results';var SET_CAN_LOAD_MORE='set_can_load_more';var SET_IS_LOADING='set_is_loading';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = thinkTanksReducer;
 var __WEBPACK_IMPORTED_MODULE_0_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
 var __WEBPACK_IMPORTED_MODULE_2_constants_notifications__ = __webpack_require__(108);
 var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(355);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INITIAL_STATE={myThinkTanksList:null,myThinkTanksStatus:null,actualThinkTank:null,actualThinkTankStatus:null,actualThinkTankTools:null,actualThinkTankToolsStatus:null,requestThinkTankStatus:null,requestThinkTankError:null,requestAcceptThinkTankStatus:null,requestAcceptThinkTankError:null,requestRejectThinkTankStatus:null,requestRejectThinkTankError:null,requestsJoinThinkTank:null,requestsThinkTankStatus:null,requestsThinkTankError:null,requestsLeaveThinkTankStatus:null,requestsLeaveThinkTankError:null,proposedContent:null,proposedContentStatus:null,allProposedContent:null,allProposedContentStatus:null};var handleNewNotification=function handleNewNotification(state,action){var payload=action.payload;switch(payload.req_message){case __WEBPACK_IMPORTED_MODULE_2_constants_notifications__["f" ]:{var thinkTank=JSON.parse(payload.think_tank);var myThinkTanksList=state.myThinkTanksList;var newThinkTanks=myThinkTanksList?myThinkTanksList.slice():[];if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(newThinkTanks,{id:thinkTank.id})){newThinkTanks.push(thinkTank);}return Object.assign({},state,{myThinkTanksList:newThinkTanks});}case __WEBPACK_IMPORTED_MODULE_2_constants_notifications__["g" ]:{var request=JSON.parse(payload.request);var requestsJoinThinkTank=state.requestsJoinThinkTank;var newRequests=requestsJoinThinkTank?requestsJoinThinkTank.slice():[];newRequests.push(request);return Object.assign({},state,{requestsJoinThinkTank:newRequests});}default:return Object.assign({},state);}};function thinkTanksReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_3__types__["A" ]:return handleNewNotification(state,action);case __WEBPACK_IMPORTED_MODULE_3__types__["B" ]:return handleNewNotification(state,action);case __WEBPACK_IMPORTED_MODULE_3__types__["k" ]:return Object.assign({},state,{myThinkTanksList:null,myThinkTanksStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["l" ]:return Object.assign({},state,{myThinkTanksList:payload.data,myThinkTanksStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["j" ]:return Object.assign({},state,{myThinkTanksList:null,myThinkTanksStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["s" ]:return Object.assign({},state,{actualThinkTank:null,actualThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ],requestThinkTankStatus:null,requestThinkTankError:null});case __WEBPACK_IMPORTED_MODULE_3__types__["t" ]:return Object.assign({},state,{actualThinkTank:payload.data,actualThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["a" ]:return Object.assign({},state,{myThinkTanksList:[].concat(_toConsumableArray(state.myThinkTanksList),[payload.data]),myThinkTanksListStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["r" ]:return Object.assign({},state,{actualThinkTank:null,actualThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["v" ]:return Object.assign({},state,{actualThinkTankTools:null,actualThinkTankToolsStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["w" ]:return Object.assign({},state,{actualThinkTankTools:payload.data,actualThinkTankToolsStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["u" ]:return Object.assign({},state,{actualThinkTankTools:null,actualThinkTankToolsStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["c" ]:{var actualThinkTank=state.actualThinkTank;return Object.assign({},state,{actualThinkTank:Object.assign({},actualThinkTank,{image:payload.data})});}case __WEBPACK_IMPORTED_MODULE_3__types__["J" ]:return Object.assign({},state,{requestThinkTankError:null,requestThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["K" ]:return Object.assign({},state,{requestThinkTankError:null,requestThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["I" ]:return Object.assign({},state,{requestThinkTankError:payload.data,requestThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["D" ]:return Object.assign({},state,{requestAcceptThinkTankError:null,requestAcceptThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["E" ]:{var requestsJoinThinkTank=state.requestsJoinThinkTank;__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(requestsJoinThinkTank,{id:payload.id});return Object.assign({},state,{requestsJoinThinkTank:requestsJoinThinkTank.slice(),// To do a copy instead copy the reference, so the components will realize the redux has changed
requestAcceptThinkTankError:null,requestAcceptThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});}case __WEBPACK_IMPORTED_MODULE_3__types__["C" ]:return Object.assign({},state,{requestAcceptThinkTankError:payload.data,requestAcceptThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["G" ]:return Object.assign({},state,{requestRejectThinkTankError:null,requestRejectThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["H" ]:{var _requestsJoinThinkTank=state.requestsJoinThinkTank;__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_requestsJoinThinkTank,{id:payload.id});return Object.assign({},state,{requestsJoinThinkTank:_requestsJoinThinkTank.slice(),// To do a copy instead copy the reference, so the components will realize the redux has changed
requestRejectThinkTankError:null,requestRejectThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});}case __WEBPACK_IMPORTED_MODULE_3__types__["F" ]:return Object.assign({},state,{requestRejectThinkTankError:payload.data,requestRejectThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["p" ]:return Object.assign({},state,{requestsJoinThinkTank:null,requestsThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["q" ]:return Object.assign({},state,{requestsJoinThinkTank:payload.data,requestsThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["o" ]:return Object.assign({},state,{requestsJoinThinkTank:payload.data,requestsThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["y" ]:return Object.assign({},state,{requestsLeaveThinkTankError:null,requestsLeaveThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["z" ]:{var myThinkTanksList=state.myThinkTanksList;__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(myThinkTanksList,{id:payload.id});var copyArray=[].concat(_toConsumableArray(myThinkTanksList));// Copy array to force refresh components
return Object.assign({},state,{myThinkTanksList:copyArray,requestsLeaveThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});}case __WEBPACK_IMPORTED_MODULE_3__types__["x" ]:return Object.assign({},state,{requestsLeaveThinkTankError:payload.data,requestsLeaveThinkTankStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["g" ]:return Object.assign({},state,{myAdditionalThinks:payload.data,myAdditionalThinksStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["e" ]:return Object.assign({},state,{myAdditionalThinks:null,myAdditionalThinksStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["n" ]:return Object.assign({},state,{proposedContent:payload.data,proposedContentStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["m" ]:return Object.assign({},state,{proposedContent:null,proposedContentStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["i" ]:return Object.assign({},state,{allProposedContent:payload.data,allProposedContentStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_3__types__["h" ]:return Object.assign({},state,{allProposedContent:payload.data,allProposedContentStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = notificationsModalReducer;
 var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(356);
var INITIAL_STATE={data:null,visible:false};var handleModalNotifications=function handleModalNotifications(state,notification){switch(notification.req_message){case'notification_modal':return Object.assign({},state,{data:notification,visible:true});default:break;}return state;};function notificationsModalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_0__types__["b" ]:case __WEBPACK_IMPORTED_MODULE_0__types__["c" ]:return handleModalNotifications(state,payload);case __WEBPACK_IMPORTED_MODULE_0__types__["a" ]:return Object.assign({},state,{data:null,visible:false});default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = boostReducer;
 var __WEBPACK_IMPORTED_MODULE_0_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(357);
var INITIAL_STATE={saveBoostStatus:null,savedBoost:null};function boostReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_1__types__["b" ]:return Object.assign({},state,{saveBoostStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ],savedBoost:null});case __WEBPACK_IMPORTED_MODULE_1__types__["c" ]:return Object.assign({},state,{saveBoostStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ],savedBoost:payload.data});case __WEBPACK_IMPORTED_MODULE_1__types__["a" ]:return Object.assign({},state,{saveBoostStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ],savedBoost:null});default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = toolsReducer;
 var __WEBPACK_IMPORTED_MODULE_0_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(358);
var INITIAL_STATE={saveToolStatus:null,savedTool:null,deleteToolStatus:null};function toolsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_1__types__["e" ]:return Object.assign({},state,{saveToolStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ],savedTool:null});case __WEBPACK_IMPORTED_MODULE_1__types__["f" ]:return Object.assign({},state,{saveToolStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ],savedTool:payload.data});case __WEBPACK_IMPORTED_MODULE_1__types__["d" ]:return Object.assign({},state,{saveToolStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ],savedTool:null});case __WEBPACK_IMPORTED_MODULE_1__types__["b" ]:return Object.assign({},state,{deleteToolStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_1__types__["c" ]:return Object.assign({},state,{deleteToolStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_1__types__["a" ]:return Object.assign({},state,{deleteToolStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = stepsReducer;
 var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(352);
var INITIAL_STATE={context:null,specificStep:null,hasChangeStep:false};function stepsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_0__types__["b" ]:return Object.assign({},state,{context:payload?Object.assign({},payload):null});case __WEBPACK_IMPORTED_MODULE_0__types__["a" ]:return Object.assign({},INITIAL_STATE);case __WEBPACK_IMPORTED_MODULE_0__types__["c" ]:return Object.assign({},state,{specificStep:payload});default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = stepsReducer;
 var __WEBPACK_IMPORTED_MODULE_0_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(359);
var INITIAL_STATE={callForImpact:null,callForImpactStatus:null,callForImpactError:null};function stepsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_1__types__["b" ]:return Object.assign({},state,{callForImpact:null,callForImpactStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ],callForImpactError:null});case __WEBPACK_IMPORTED_MODULE_1__types__["c" ]:return Object.assign({},state,{callForImpact:payload.data,callForImpactStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_1__types__["a" ]:return Object.assign({},state,{callForImpactStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ],callForImpactError:payload.error});default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = elementsReducer;
 var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
 var __WEBPACK_IMPORTED_MODULE_1_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(360);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INITIAL_STATE={element:null,elements:null,elementsStatus:null,selectedElements:null,selectedElementsStatus:null,connections:null,connectionsStatus:null,elementTypesShownInUserCard:[]};function elementsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_2__types__["c" ]:return Object.assign({},state,{elementsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_2__types__["d" ]:return Object.assign({},state,{elementsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["g" ],elements:payload.elements});case __WEBPACK_IMPORTED_MODULE_2__types__["b" ]:return Object.assign({},state,{elementsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["a" ],elements:null});case __WEBPACK_IMPORTED_MODULE_2__types__["i" ]:return Object.assign({},state,{elementsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["b" ],element:null});case __WEBPACK_IMPORTED_MODULE_2__types__["j" ]:return Object.assign({},state,{elementsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["g" ],element:payload.element});case __WEBPACK_IMPORTED_MODULE_2__types__["h" ]:return Object.assign({},state,{elementsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["a" ],element:null});case __WEBPACK_IMPORTED_MODULE_2__types__["f" ]:return Object.assign({},state,{selectedElementsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["b" ],selectedElements:null});case __WEBPACK_IMPORTED_MODULE_2__types__["g" ]:return Object.assign({},state,{selectedElementsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["g" ],selectedElements:payload.element});case __WEBPACK_IMPORTED_MODULE_2__types__["e" ]:return Object.assign({},state,{selectedElementsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["a" ],selectedElements:null});case __WEBPACK_IMPORTED_MODULE_2__types__["a" ]:{var selectedElements=state.selectedElements?[].concat(_toConsumableArray(state.selectedElements)):[];if(!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(selectedElements,{id:payload.id})){selectedElements.push(payload);}return Object.assign({},state,{selectedElements:selectedElements});}case __WEBPACK_IMPORTED_MODULE_2__types__["p" ]:{var _selectedElements=state.selectedElements?[].concat(_toConsumableArray(state.selectedElements)):[];__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_selectedElements,{id:payload.id});return Object.assign({},state,{selectedElements:_selectedElements});}case __WEBPACK_IMPORTED_MODULE_2__types__["l" ]:return Object.assign({},state,{connections:null,connectionsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_2__types__["m" ]:return Object.assign({},state,{connections:payload,connectionsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_2__types__["k" ]:return Object.assign({},state,{connections:null,connectionsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_2__types__["q" ]:return Object.assign({},state,{elementTypesShownInUserCard:payload});default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = stepsReducer;
 var __WEBPACK_IMPORTED_MODULE_0_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(361);
var INITIAL_STATE={signature:null,signatureStatus:null,meeting:null,meetingStatus:null};var handleModalNotifications=function handleModalNotifications(state,notification){switch(notification.req_message){case'meeting_increase_time':{var meeting=state.meeting;if(meeting&&parseInt(meeting.meeting_id,10)===parseInt(notification.meeting_id,10)){meeting.date_end=parseInt(notification.date_end,10);}return Object.assign({},state,{meeting:meeting});}default:break;}return state;};function stepsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_1__types__["g" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["h" ]:return handleModalNotifications(state,payload);case __WEBPACK_IMPORTED_MODULE_1__types__["e" ]:return Object.assign({},state,{signature:null,signatureStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_1__types__["f" ]:return Object.assign({},state,{signature:payload.signature,signatureStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_1__types__["d" ]:return Object.assign({},state,{signature:null,signatureStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_1__types__["b" ]:return Object.assign({},state,{meeting:null,meetingStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_1__types__["c" ]:return Object.assign({},state,{meeting:payload.data,meetingStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_1__types__["a" ]:return Object.assign({},state,{meeting:null,meetingStatus:__WEBPACK_IMPORTED_MODULE_0_constants_status__["a" ]});default:return Object.assign({},state);}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = elementsReducer;
 var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
 var __WEBPACK_IMPORTED_MODULE_1_constants_serendipity__ = __webpack_require__(362);
 var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(363);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INITIAL_STATE={preferences:[],actionInContext:null,actionInContextPriority:__WEBPACK_IMPORTED_MODULE_1_constants_serendipity__["a" ].LOW,history:[]};var changeItemStatus=function changeItemStatus(elementType,elementId,status,prevState){var state=Object.assign({},prevState);var preferences=state.preferences;var index=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(preferences,{element_type:elementType,element_id:elementId});if(index>=0){preferences[index].enabled=status;}else{var item={element_type:elementType,element_id:elementId,enabled:status};preferences.push(item);}state.preferences=[].concat(_toConsumableArray(preferences));return state;};function elementsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_2__types__["e" ]:{var elementType=payload.elementType,elementId=payload.elementId;return changeItemStatus(elementType,elementId,1,state);}case __WEBPACK_IMPORTED_MODULE_2__types__["d" ]:{var _elementType=payload.elementType,_elementId=payload.elementId;return changeItemStatus(_elementType,_elementId,0,state);}case __WEBPACK_IMPORTED_MODULE_2__types__["b" ]:{var _elementType2=payload.elementType,_elementId2=payload.elementId;return changeItemStatus(_elementType2,_elementId2,0,state);}case __WEBPACK_IMPORTED_MODULE_2__types__["a" ]:{var _elementType3=payload.elementType,_elementId3=payload.elementId;return changeItemStatus(_elementType3,_elementId3,1,state);}case __WEBPACK_IMPORTED_MODULE_2__types__["g" ]:{return Object.assign({},state,{preferences:[].concat(_toConsumableArray(payload))});}case __WEBPACK_IMPORTED_MODULE_2__types__["i" ]:return Object.assign({},state,{actionInContext:payload.action,actionInContextPriority:payload.priority});case __WEBPACK_IMPORTED_MODULE_2__types__["h" ]:{var history=[].concat(_toConsumableArray(state.history));history.push(payload);return Object.assign({},state,{history:history});}default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = speedDatingReducer;
 var __WEBPACK_IMPORTED_MODULE_0_constants_notifications__ = __webpack_require__(108);
 var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
 var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(364);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INITIAL_STATE={meetings:[]};var handleNodeNotifications=function handleNodeNotifications(state,notification){switch(notification.req_message){case __WEBPACK_IMPORTED_MODULE_0_constants_notifications__["c" ]:{var data=JSON.parse(notification.data);var meetings=state.meetings;var newMeetings=[].concat(_toConsumableArray(meetings));newMeetings.push(data);return Object.assign({},state,{meetings:newMeetings});}case __WEBPACK_IMPORTED_MODULE_0_constants_notifications__["j" ]:if(notification.type==='finish_speed_dating'){var _meetings=[].concat(_toConsumableArray(state.meetings));var removedMeeting=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_meetings,{zoom_data:{id:parseInt(notification.zoom_id,10)}});if(removedMeeting.length){var meeting=removedMeeting[0];meeting.status=21275693;_meetings.push(meeting);}return Object.assign({},state,{meetings:_meetings});}break;default:break;}return state;};function speedDatingReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_2__types__["a" ]:case __WEBPACK_IMPORTED_MODULE_2__types__["b" ]:return handleNodeNotifications(state,payload);case __WEBPACK_IMPORTED_MODULE_2__types__["c" ]:return Object.assign({},state,{meetings:payload});default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = thinkChatsReducer;
 var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
 var __WEBPACK_IMPORTED_MODULE_1_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_2_constants_notifications__ = __webpack_require__(108);
 var __WEBPACK_IMPORTED_MODULE_3_modules_socket_actions__ = __webpack_require__(81);
 var __WEBPACK_IMPORTED_MODULE_4_constants_rooms__ = __webpack_require__(158);
 var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(365);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INITIAL_STATE={myThinkChatsList:null,myThinkChatsStatus:null,narrativesThinkChats:{},narrativesThinkChatsStatus:{},userNarrativesThinkChats:{},userNarrativesThinkChatsStatus:{}};var handleModalNotifications=function handleModalNotifications(state,notification){switch(notification.req_message){case __WEBPACK_IMPORTED_MODULE_2_constants_notifications__["d" ]:{var table=JSON.parse(notification.table);var myThinkChatsList=state.myThinkChatsList?[].concat(_toConsumableArray(state.myThinkChatsList)):null;if(myThinkChatsList&&!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(myThinkChatsList,{id:table.id})){myThinkChatsList.push(table);Object(__WEBPACK_IMPORTED_MODULE_3_modules_socket_actions__["c" ])(__WEBPACK_IMPORTED_MODULE_4_constants_rooms__["b" ],table.id);}return Object.assign({},state,{myThinkChatsList:myThinkChatsList});}case __WEBPACK_IMPORTED_MODULE_2_constants_notifications__["k" ]:{var data=JSON.parse(notification.data);var userId=notification.user_id;var isMember=!!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(data.users,{id:userId});var _myThinkChatsList=state.myThinkChatsList;if(_myThinkChatsList){var index=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(_myThinkChatsList,{id:data.id});if(isMember){if(index>=0){_myThinkChatsList[index]=data;}else{_myThinkChatsList.push(data);}}else{__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_myThinkChatsList,{id:data.id});}}return Object.assign({},state,{myThinkChatsList:_myThinkChatsList});}default:break;}return state;};function thinkChatsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_5__types__["o" ]:case __WEBPACK_IMPORTED_MODULE_5__types__["p" ]:return handleModalNotifications(state,payload);case __WEBPACK_IMPORTED_MODULE_5__types__["e" ]:return Object.assign({},state,{myThinkChatsList:[],myThinkChatsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["b" ]});case __WEBPACK_IMPORTED_MODULE_5__types__["f" ]:return Object.assign({},state,{myThinkChatsList:[].concat(_toConsumableArray(payload.data)),myThinkChatsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_5__types__["d" ]:return Object.assign({},state,{myThinkChatsList:[],myThinkChatsStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["a" ]});case __WEBPACK_IMPORTED_MODULE_5__types__["n" ]:{var myThinkChatsList=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(state.myThinkChatsList,function(chat){return chat.chat_id!==payload.params.chatId;});return Object.assign({},state,{myThinkChatsList:myThinkChatsList});}case __WEBPACK_IMPORTED_MODULE_5__types__["m" ]:{var _myThinkChatsList2=[].concat(_toConsumableArray(state.myThinkChatsList));if(!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(_myThinkChatsList2,{id:payload.id})){_myThinkChatsList2.push(payload);}return Object.assign({},state,{myThinkChatsList:[].concat(_toConsumableArray(_myThinkChatsList2))});}case __WEBPACK_IMPORTED_MODULE_5__types__["q" ]:{var _myThinkChatsList3=[].concat(_toConsumableArray(state.myThinkChatsList));var index=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(_myThinkChatsList3,{id:payload.id});if(index){_myThinkChatsList3[index]=payload;}return Object.assign({},state,{myThinkChatsList:_myThinkChatsList3});}case __WEBPACK_IMPORTED_MODULE_5__types__["h" ]:{var narrativesThinkChats=state.narrativesThinkChats,narrativesThinkChatsStatus=state.narrativesThinkChatsStatus;var narrativeId=payload.narrativeId;narrativesThinkChats[narrativeId]=null;narrativesThinkChatsStatus[narrativeId]=__WEBPACK_IMPORTED_MODULE_1_constants_status__["b" ];return Object.assign({},state,{narrativesThinkChats:narrativesThinkChats,narrativesThinkChatsStatus:narrativesThinkChatsStatus});}case __WEBPACK_IMPORTED_MODULE_5__types__["i" ]:{var _narrativesThinkChats=state.narrativesThinkChats,_narrativesThinkChatsStatus=state.narrativesThinkChatsStatus;var _narrativeId=payload.narrativeId,thinkChats=payload.thinkChats;_narrativesThinkChats[_narrativeId]=thinkChats;_narrativesThinkChatsStatus[_narrativeId]=__WEBPACK_IMPORTED_MODULE_1_constants_status__["g" ];return Object.assign({},state,{narrativesThinkChats:_narrativesThinkChats,narrativesThinkChatsStatus:_narrativesThinkChatsStatus});}case __WEBPACK_IMPORTED_MODULE_5__types__["g" ]:{var _narrativesThinkChats2=state.narrativesThinkChats,_narrativesThinkChatsStatus2=state.narrativesThinkChatsStatus;var _narrativeId2=payload.narrativeId;_narrativesThinkChats2[_narrativeId2]=null;_narrativesThinkChatsStatus2[_narrativeId2]=__WEBPACK_IMPORTED_MODULE_1_constants_status__["a" ];return Object.assign({},state,{narrativesThinkChats:_narrativesThinkChats2,narrativesThinkChatsStatus:_narrativesThinkChatsStatus2});}case __WEBPACK_IMPORTED_MODULE_5__types__["k" ]:{var userNarrativesThinkChats=state.userNarrativesThinkChats,userNarrativesThinkChatsStatus=state.userNarrativesThinkChatsStatus;var _narrativeId3=payload.narrativeId;userNarrativesThinkChats[_narrativeId3]=null;userNarrativesThinkChatsStatus[_narrativeId3]=__WEBPACK_IMPORTED_MODULE_1_constants_status__["b" ];return Object.assign({},state,{userNarrativesThinkChats:userNarrativesThinkChats,userNarrativesThinkChatsStatus:userNarrativesThinkChatsStatus});}case __WEBPACK_IMPORTED_MODULE_5__types__["l" ]:{var _userNarrativesThinkChats=state.userNarrativesThinkChats,_userNarrativesThinkChatsStatus=state.userNarrativesThinkChatsStatus;var _narrativeId4=payload.narrativeId,_thinkChats=payload.thinkChats;_userNarrativesThinkChats[_narrativeId4]=_thinkChats;_userNarrativesThinkChatsStatus[_narrativeId4]=__WEBPACK_IMPORTED_MODULE_1_constants_status__["g" ];return Object.assign({},state,{userNarrativesThinkChats:_userNarrativesThinkChats,userNarrativesThinkChatsStatus:_userNarrativesThinkChatsStatus});}case __WEBPACK_IMPORTED_MODULE_5__types__["j" ]:{var _userNarrativesThinkChats2=state.userNarrativesThinkChats,_userNarrativesThinkChatsStatus2=state.userNarrativesThinkChatsStatus;var _narrativeId5=payload.narrativeId;_userNarrativesThinkChats2[_narrativeId5]=null;_userNarrativesThinkChatsStatus2[_narrativeId5]=__WEBPACK_IMPORTED_MODULE_1_constants_status__["a" ];return Object.assign({},state,{userNarrativesThinkChats:_userNarrativesThinkChats2,userNarrativesThinkChatsStatus:_userNarrativesThinkChatsStatus2});}default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_routes_Profile_modules__ = __webpack_require__(709);
 var __WEBPACK_IMPORTED_MODULE_1_components_ModalInformation_modules__ = __webpack_require__(710);
 __webpack_exports__["a"] = ({profile:__WEBPACK_IMPORTED_MODULE_0_routes_Profile_modules__["a" ],modalInformation:__WEBPACK_IMPORTED_MODULE_1_components_ModalInformation_modules__["a" ]});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = profileReducer;
 var __WEBPACK_IMPORTED_MODULE_0_store_globalState_initialState__ = __webpack_require__(74);
 var __WEBPACK_IMPORTED_MODULE_1_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(366);
var INITIAL_STATE={error:'',success:'',eraseAccountStatus:null,eraseAccountError:null};function profileReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__types__["e" ]:return{error:'',success:''};case __WEBPACK_IMPORTED_MODULE_2__types__["f" ]:return{error:'',success:'Success'};case __WEBPACK_IMPORTED_MODULE_2__types__["d" ]:return{error:action.payload,success:''};case __WEBPACK_IMPORTED_MODULE_2__types__["b" ]:return Object.assign({},state,{eraseAccountStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["b" ],eraseAccountError:null});case __WEBPACK_IMPORTED_MODULE_2__types__["c" ]:return Object.assign({},state,{eraseAccountStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["g" ]});case __WEBPACK_IMPORTED_MODULE_2__types__["a" ]:return Object.assign({},state,{eraseAccountStatus:__WEBPACK_IMPORTED_MODULE_1_constants_status__["a" ],eraseAccountError:action.payload});default:return state;}}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0_store_globalState_initialState__ = __webpack_require__(74);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(367);
function modalInformationReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0_store_globalState_initialState__["a" ].modalInformation;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__types__["a" ]:return __WEBPACK_IMPORTED_MODULE_0_store_globalState_initialState__["a" ].modalInformation;case __WEBPACK_IMPORTED_MODULE_1__types__["b" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["k" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["j" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["i" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["f" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["g" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["h" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["e" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["c" ]:case __WEBPACK_IMPORTED_MODULE_1__types__["d" ]:return Object.assign({},state,action.payload);default:return state;}} __webpack_exports__["a"] = (modalInformationReducer);

 }),

 (function(module, exports) {



 }),

 (function(module, exports) {



 }),

 (function(module, exports) {



 }),

 (function(module, exports) {



 }),

 (function(module, exports) {



 }),

 (function(module, exports) {



 }),

 (function(module, exports) {



 }),

 (function(module, exports) {



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(720);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_2_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_components_ModalInformation_modules_actions__ = __webpack_require__(368);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(721);
var mapStateToProps=function mapStateToProps(state){return{literals:state.i18n.literals,sessionChecked:state.session.checked,loading:state.global.loading,router:state.router,app:state.app,actualContext:state.steps.context,isAuthenticated:state.app.isAuthenticated,user:state.session,chats:state.chats,lastLoading:state.global.lastLoading};};function mapDispatchToProps(dispatch){return{fetchInstance:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_app__["b" ],dispatch),setIsAuthenticated:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_app__["c" ],dispatch),getStepsWatched:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["b" ],dispatch),hideModal:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ModalInformation_modules_actions__["a" ],dispatch),resetLoading:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ]));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_ga__ = __webpack_require__(106);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(151);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_withWidth__ = __webpack_require__(372);
 var __WEBPACK_IMPORTED_MODULE_7_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_7_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_8_components_ErrorBoundary__ = __webpack_require__(400);
 var __WEBPACK_IMPORTED_MODULE_9_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_10_components_SplashScreen__ = __webpack_require__(798);
 var __WEBPACK_IMPORTED_MODULE_11_modules_socket_constants__ = __webpack_require__(155);
 var __WEBPACK_IMPORTED_MODULE_12_modules_socket_actions__ = __webpack_require__(81);
 var __WEBPACK_IMPORTED_MODULE_13_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_14_components_Layout__ = __webpack_require__(813);
 var __WEBPACK_IMPORTED_MODULE_15__store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_16__components_Loading__ = __webpack_require__(1005);
 var __WEBPACK_IMPORTED_MODULE_17__index__ = __webpack_require__(438);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var URLS_NO_REDIRECT=[__WEBPACK_IMPORTED_MODULE_13_constants_urls__["a" ],__WEBPACK_IMPORTED_MODULE_13_constants_urls__["x" ],__WEBPACK_IMPORTED_MODULE_13_constants_urls__["G" ],__WEBPACK_IMPORTED_MODULE_13_constants_urls__["w" ],__WEBPACK_IMPORTED_MODULE_13_constants_urls__["r" ]];var App=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.loadPhysicsLibraries=function(){var libraries=['/js/createjs_1.1_min.js','/js/zim10.js','/js/Box2dWeb-2.1.a.3.min.js','/js/physics.js'];__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(libraries,function(library){var src=''+window.location.origin+library;var scriptPhysic=document.createElement('script');scriptPhysic.src=src;document.head.appendChild(scriptPhysic);});},_this.handleCheckLoading=function(){var _this$props=_this.props,lastLoading=_this$props.lastLoading,resetLoading=_this$props.resetLoading;if(new Date().getTime()-lastLoading>=10000){resetLoading();}},_this.getUserSession=function(){var _this$props2=_this.props,setIsAuthenticated=_this$props2.setIsAuthenticated,app=_this$props2.app;Object(__WEBPACK_IMPORTED_MODULE_9_utils_apiFetch__["b" ])('GET',{endPoint:'users/session'}).then(function(response){var user=Object.assign({},response);user.instance=app.id;__WEBPACK_IMPORTED_MODULE_7_redux_react_session__["sessionService"].saveSession({token:user.user_code}).then(function(){__WEBPACK_IMPORTED_MODULE_7_redux_react_session__["sessionService"].saveUser(user).then(function(){setIsAuthenticated(true);__WEBPACK_IMPORTED_MODULE_2_react_ga__["a" ].set({userId:user.id});});});}).catch(function(){if(!app.isAuthenticated&&!URLS_NO_REDIRECT.includes(window.location.pathname)){window.urlToRedirect=window.location.href;}var path=window.location.pathname;if(path.indexOf('signup')>=0){path='/signup';}var route=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_17__index__["a" ],{path:path});if(!route||!route.ignoreSession){__WEBPACK_IMPORTED_MODULE_15__store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_13_constants_urls__["x" ]);}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){var fetchInstance=this.props.fetchInstance;var domain= false?'rise-develop.webintra.net':window.location.host;// const domain = (process.env.NODE_ENV === 'development') ? 'app.callforimpact.com' : window.location.host;
// const domain = (process.env.NODE_ENV === 'development') ? 'collaborative-intelligence.webintra.net' : window.location.host;
// const domain = 'app.callforimpact.com';
fetchInstance(domain);var eventMethod=window.addEventListener?'addEventListener':'attachEvent';var eventer=window[eventMethod];var messageEvent=eventMethod==='attachEvent'?'onmessage':'message';// Listen to message from child window
eventer(messageEvent,function(e){switch(e.data){case'leave_meeting':__WEBPACK_IMPORTED_MODULE_15__store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_13_constants_urls__["u" ]);break;default:break;}},false);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;var _props=this.props,isAuthenticated=_props.isAuthenticated,app=_props.app,loading=_props.loading;if(prevProps.loading<loading){setTimeout(function(){_this2.handleCheckLoading();},10000);}if(prevProps.app.id!==app.id){this.getUserSession();}if(!prevProps.isAuthenticated&&isAuthenticated){Object(__WEBPACK_IMPORTED_MODULE_12_modules_socket_actions__["c" ])(__WEBPACK_IMPORTED_MODULE_11_modules_socket_constants__["a" ],app.id);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.checkLoading);}},{key:'render',value:function render(){var _props2=this.props,sessionChecked=_props2.sessionChecked,loading=_props2.loading,app=_props2.app,actualContext=_props2.actualContext,isAuthenticated=_props2.isAuthenticated;if(!app.code){return false;}var splashScreenType='';if(window.location.pathname.indexOf('zoom-meeting')>=0){splashScreenType='zoom-meeting';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_ErrorBoundary__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Loading__["a" ],{hide:!loading,actualContext:actualContext,app:app}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["a" ],{history:__WEBPACK_IMPORTED_MODULE_15__store_history__["a" ]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Layout__["a" ],{show:isAuthenticated},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" ],null,sessionChecked&&__WEBPACK_IMPORTED_MODULE_17__index__["a" ].map(function(route,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" ],{key:index,path:route.path,exact:route.exact,render:function render(){return route.ignoreSession||app.isAuthenticated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(route.component,{route:__WEBPACK_IMPORTED_MODULE_15__store_history__["a" ]})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" ],{to:{pathname:__WEBPACK_IMPORTED_MODULE_13_constants_urls__["w" ],state:{from:window.location.pathname}}});}});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_SplashScreen__["a" ],{type:splashScreenType}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);App.propTypes={sessionChecked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,fetchInstance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setIsAuthenticated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,actualContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isAuthenticated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,lastLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,resetLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};App.defaultProps={actualContext:null,lastLoading:0}; __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_withWidth__["a" ])()(App));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(369);
 var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
 var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(75);
 var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(217);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" ])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" ], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


 var _unused_webpack_default_export = (BrowserRouter);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(369);
 var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
 var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(75);
 var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(217);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" ])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" ], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


 var _unused_webpack_default_export = (HashRouter);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(331);
// Written in this round about way for babel-transform-imports


 var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(371);
 var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(370);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" ], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" ], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" ].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

 var _unused_webpack_default_export = (NavLink);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(332);
// Written in this round about way for babel-transform-imports


 var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(333);
// Written in this round about way for babel-transform-imports


 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(335);
// Written in this round about way for babel-transform-imports


 var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(336);
// Written in this round about way for babel-transform-imports


 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(212);
// Written in this round about way for babel-transform-imports


 var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(154);
// Written in this round about way for babel-transform-imports


 var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(337);
// Written in this round about way for babel-transform-imports


 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_exports__["a"] = deepmerge;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(126);


function isPlainObject(item) {
  return item && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" ])(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(218);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  

  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" ])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, acceptingRef);
elementAcceptingRef.isRequired = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" ])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element.isRequired, acceptingRef);
 var _unused_webpack_default_export = (elementAcceptingRef);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(218);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" ])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"], elementTypeAcceptingRef));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(63);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);


// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (true) {
    return propTypes;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, propTypes, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" ])({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = formatMuiErrorMessage;

function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(126);
 var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(159);
 var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);

 // Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}


function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}



function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" ])(Component) === 'object') {
    switch (Component.$$typeof) {
      case __WEBPACK_IMPORTED_MODULE_1_react_is__["ForwardRef"]:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case __WEBPACK_IMPORTED_MODULE_1_react_is__["Memo"]:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";

var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }

  return null;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 var _unused_webpack_default_export = (typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')());

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var refType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object]);
 var _unused_webpack_default_export = (refType);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createGenerateClassName;
 var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__ = __webpack_require__(374);



var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (false) {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[__WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__["a" ]] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createStyles;
function createStyles(styles) {
  return styles;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = getThemeProps;

function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = jssPreset;
 var __WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__ = __webpack_require__(747);
 var __WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__ = __webpack_require__(748);
 var __WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__ = __webpack_require__(749);
 var __WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__ = __webpack_require__(750);
 var __WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__ = __webpack_require__(752);
 var __WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__ = __webpack_require__(753);
 var __WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__ = __webpack_require__(758);






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset() {
  return {
    plugins: [Object(__WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__["a" ])(), Object(__WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__["a" ])(), Object(__WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__["a" ])(), Object(__WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__["a" ])(), Object(__WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__["a" ])(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : Object(__WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__["a" ])(), Object(__WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__["a" ])()]
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_tiny_warning__ = __webpack_require__(152);
 var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(83);



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = Object(__WEBPACK_IMPORTED_MODULE_1_jss__["d" ])(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      } // $FlowFixMe[prop-missing]


      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule; // $FlowFixMe[prop-missing]

      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      } // $FlowFixMe[prop-missing]


      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

 __webpack_exports__["a"] = (functionPlugin);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(83);



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =

function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.rules = void 0;
    this.options = void 0;
    this.key = void 0;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new __WEBPACK_IMPORTED_MODULE_1_jss__["a" ](Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  
  ;

  _proto.toString = function toString() {
    return this.rules.toString();
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =

function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.options = void 0;
    this.rule = void 0;
    this.isProcessed = false;
    this.key = void 0;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}



function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

 __webpack_exports__["a"] = (jssGlobal);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1_tiny_warning__ = __webpack_require__(152);



var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;


function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        rule = rule;
        return rule.selector;
      }

       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, prevOptions, {
      index: prevOptions.index + 1 // $FlowFixMe[prop-missing]

    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        container.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, options, {
          selector: selector
        }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
        // And flow doesn't know this will always be a StyleRule which has the addRule method
        // $FlowFixMe[incompatible-use]
        // $FlowFixMe[prop-missing]
        .addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

 __webpack_exports__["a"] = (jssNested);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(751);




function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" ])(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}



function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" ])(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

 __webpack_exports__["a"] = (camelCase);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

 __webpack_exports__["a"] = (hyphenateStyleName);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_jss__ = __webpack_require__(83);


var px = __WEBPACK_IMPORTED_MODULE_0_jss__["f" ] && CSS ? CSS.px : 'px';
var ms = __WEBPACK_IMPORTED_MODULE_0_jss__["f" ] && CSS ? CSS.ms : 'ms';
var percent = __WEBPACK_IMPORTED_MODULE_0_jss__["f" ] && CSS ? CSS.percent : '%';


var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};


function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var _key in obj) {
    newObj[_key] = obj[_key];
    newObj[_key.replace(regExp, replace)] = obj[_key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);


function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    }
  } else if (typeof value === 'number' && !Number.isNaN(value)) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}



function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

 __webpack_exports__["a"] = (defaultUnit);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_css_vendor__ = __webpack_require__(754);
 var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(83);





function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["a" ])(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["b" ])(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" ])(supportedProp, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["g" ])(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" ])(prop, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["g" ])(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

 __webpack_exports__["a"] = (jssVendorPrefixer);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "a", function() { return supportedKeyframes; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return supportedProperty; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return supportedValue; });
 var __WEBPACK_IMPORTED_MODULE_0_is_in_browser__ = __webpack_require__(376);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(127);



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = __WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" ] && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" ]) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}



var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};



function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;


function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}



function camelize(str) {
  return str.replace(regExp, toUpper);
}



function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" ])(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" ]) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}



function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ("production" !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;


function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" ]) el$1 = document.createElement('p');


function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ("production" !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _arrayWithoutHoles;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__ = __webpack_require__(377);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__["a" ])(arr);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

 __webpack_exports__["a"] = (jssPropsSort);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = makeStyles;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_jss__ = __webpack_require__(83);
 var __WEBPACK_IMPORTED_MODULE_4__mergeClasses__ = __webpack_require__(222);
 var __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__ = __webpack_require__(761);
 var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(109);
 var __WEBPACK_IMPORTED_MODULE_7__StylesProvider__ = __webpack_require__(162);
 var __WEBPACK_IMPORTED_MODULE_8__indexCounter__ = __webpack_require__(763);
 var __WEBPACK_IMPORTED_MODULE_9__getStylesCreator__ = __webpack_require__(764);
 var __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__ = __webpack_require__(381);












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" ])({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" ].get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" ].set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" ].get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" ].set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = Object(__WEBPACK_IMPORTED_MODULE_3_jss__["e" ])(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" ])({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" ].get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" ].delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__["a" ] : _options$defaultTheme,
      stylesOptions2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = Object(__WEBPACK_IMPORTED_MODULE_9__getStylesCreator__["a" ])(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: Object(__WEBPACK_IMPORTED_MODULE_8__indexCounter__["a" ])(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" ])() || defaultTheme;

    var stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_7__StylesProvider__["a" ]), stylesOptions2);

    var instance = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    var shouldUpdate = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (false) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = mergeClasses;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(13);


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, baseClasses);

  if (false) {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (false) {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
 __webpack_exports__["a"] = (multiKeyStore);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = useTheme;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__ThemeContext__ = __webpack_require__(379);


function useTheme() {
  var theme = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_1__ThemeContext__["a" ]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = increment;

// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__ = __webpack_require__(765);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = getStylesCreator;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(126);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_3__noopTheme__ = __webpack_require__(381);




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {
    if (_typeof(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" ])(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ServerStyleSheets; });
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(383);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(221);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_jss__ = __webpack_require__(83);
 var __WEBPACK_IMPORTED_MODULE_5__StylesProvider__ = __webpack_require__(162);
 var __WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__ = __webpack_require__(160);








var ServerStyleSheets = function () {
  function ServerStyleSheets() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" ])(this, ServerStyleSheets);

    this.options = options;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" ])(ServerStyleSheets, [{
    key: "collect",
    value: function collect(children) {
      // This is needed in order to deduplicate the injection of CSS in the page.
      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.

      this.sheetsRegistry = new __WEBPACK_IMPORTED_MODULE_4_jss__["b" ](); // A new class name generator

      var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__["a" ])();
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StylesProvider__["b" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        sheetsManager: sheetsManager,
        serverGenerateClassName: generateClassName,
        sheetsRegistry: this.sheetsRegistry
      }, this.options), children);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
    }
  }, {
    key: "getStyleElement",
    value: function getStyleElement(props) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        id: 'jss-server-side',
        key: 'jss-server-side',
        dangerouslySetInnerHTML: {
          __html: this.toString()
        }
      }, props));
    }
  }]);

  return ServerStyleSheets;
}();



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = styled;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(122);
 var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
 var __WEBPACK_IMPORTED_MODULE_7__makeStyles__ = __webpack_require__(161);









function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
} // styled-components's API removes the mapping between components and styles.
// Using components as a low-level styling construct can be simpler.


function styled(Component) {
  var componentCreator = function componentCreator(style) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(options, ["name"]);

    if (false) {
      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var stylesOrCreator = typeof style === 'function' ? function (theme) {
      return {
        root: function root(props) {
          return style(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
            theme: theme
          }, props));
        }
      };
    } : {
      root: style
    };
    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_7__makeStyles__["a" ])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var filterProps;
    var propTypes = {};

    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }
    


    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    


    var StyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function StyledComponent(props, ref) {
      var children = props.children,
          classNameProp = props.className,
          clone = props.clone,
          ComponentProp = props.component,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "className", "clone", "component"]);

      var classes = useStyles(props);
      var className = Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" ])(classes.root, classNameProp);
      var spread = other;

      if (filterProps) {
        spread = omit(spread, filterProps);
      }

      if (clone) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
          className: Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" ])(children.props.className, className)
        }, spread));
      }

      if (typeof children === 'function') {
        return children(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
          className: className
        }, spread));
      }

      var FinalComponent = ComponentProp || Component;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FinalComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        ref: ref,
        className: className
      }, spread), children);
    });
     false ? StyledComponent.propTypes = _extends({
      
      children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

      
      className: PropTypes.string,

      
      clone: chainPropTypes(PropTypes.bool, function (props) {
        if (props.clone && props.component) {
          return new Error('You can not use the clone and component prop at the same time.');
        }

        return null;
      }),

      
      component: PropTypes
      
      .elementType
    }, propTypes) : void 0;

    if (false) {
      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
    }

    __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(StyledComponent, Component);
    return StyledComponent;
  };

  return componentCreator;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__ = __webpack_require__(379);
 var __WEBPACK_IMPORTED_MODULE_5__useTheme__ = __webpack_require__(109);
 var __WEBPACK_IMPORTED_MODULE_6__nested__ = __webpack_require__(374);






 // To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (false) {
      if (!mergedTheme) {
        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, outerTheme, localTheme);
}



function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = Object(__WEBPACK_IMPORTED_MODULE_5__useTheme__["a" ])();

  if (false) {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[__WEBPACK_IMPORTED_MODULE_6__nested__["a" ]] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__["a" ].Provider, {
    value: theme
  }, children);
}

 false ? ThemeProvider.propTypes = {
  
  children: PropTypes.node.isRequired,

  
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
}

 __webpack_exports__["a"] = (ThemeProvider);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(122);
 var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__makeStyles__ = __webpack_require__(161);
 var __WEBPACK_IMPORTED_MODULE_7__getThemeProps__ = __webpack_require__(219);
 var __WEBPACK_IMPORTED_MODULE_8__useTheme__ = __webpack_require__(109);








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_6__makeStyles__["a" ])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = Object(__WEBPACK_IMPORTED_MODULE_8__useTheme__["a" ])() || defaultTheme;

        if (name) {
          more = Object(__WEBPACK_IMPORTED_MODULE_7__getThemeProps__["a" ])({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? WithStyles.propTypes = {
      
      classes: PropTypes.object,

      
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (false) {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

 __webpack_exports__["a"] = (withStyles);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createMixins;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(63);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" ])({}, breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" ])(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" ])(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 __webpack_exports__["a"] = createPalette;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_3__colors_common__ = __webpack_require__(772);
 var __WEBPACK_IMPORTED_MODULE_4__colors_grey__ = __webpack_require__(773);
 var __WEBPACK_IMPORTED_MODULE_5__colors_indigo__ = __webpack_require__(774);
 var __WEBPACK_IMPORTED_MODULE_6__colors_pink__ = __webpack_require__(775);
 var __WEBPACK_IMPORTED_MODULE_7__colors_red__ = __webpack_require__(776);
 var __WEBPACK_IMPORTED_MODULE_8__colors_orange__ = __webpack_require__(777);
 var __WEBPACK_IMPORTED_MODULE_9__colors_blue__ = __webpack_require__(778);
 var __WEBPACK_IMPORTED_MODULE_10__colors_green__ = __webpack_require__(779);
 var __WEBPACK_IMPORTED_MODULE_11__colorManipulator__ = __webpack_require__(129);













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" ].white,
    default: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" ][50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" ].white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" ][800],
    default: '#303030'
  },
  action: {
    active: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" ].white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["i" ])(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["a" ])(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" ][300],
    main: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" ][500],
    dark: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" ][700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" ].A200,
    main: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" ].A400,
    dark: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" ].A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" ][300],
    main: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" ][500],
    dark: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" ][700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" ][300],
    main: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" ][500],
    dark: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" ][700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" ][300],
    main: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" ][500],
    dark: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" ][700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" ][300],
    main: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" ][500],
    dark: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" ][700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["e" ])(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" ])(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });") : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" ])(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (false) {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    // A collection of common colors.
    common: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" ],
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" ],
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var common = {
  black: '#000',
  white: '#fff'
};
 __webpack_exports__["a"] = (common);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
 __webpack_exports__["a"] = (grey);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
 __webpack_exports__["a"] = (indigo);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
 __webpack_exports__["a"] = (pink);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
 __webpack_exports__["a"] = (red);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
 __webpack_exports__["a"] = (orange);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
 __webpack_exports__["a"] = (blue);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
 __webpack_exports__["a"] = (green);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createTypography;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(13);




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';


function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
 __webpack_exports__["a"] = (shadows);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shape = {
  borderRadius: 4
};
 __webpack_exports__["a"] = (shape);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createSpacing;
 var __WEBPACK_IMPORTED_MODULE_0__material_ui_system__ = __webpack_require__(784);

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["a" ])({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__borders__ = __webpack_require__(390);


 var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__(224);

 var __WEBPACK_IMPORTED_MODULE_2__compose__ = __webpack_require__(64);

 var __WEBPACK_IMPORTED_MODULE_3__css__ = __webpack_require__(785);

 var __WEBPACK_IMPORTED_MODULE_4__display__ = __webpack_require__(786);

 var __WEBPACK_IMPORTED_MODULE_5__flexbox__ = __webpack_require__(392);


 var __WEBPACK_IMPORTED_MODULE_6__grid__ = __webpack_require__(393);


 var __WEBPACK_IMPORTED_MODULE_7__palette__ = __webpack_require__(394);


 var __WEBPACK_IMPORTED_MODULE_8__positions__ = __webpack_require__(395);


 var __WEBPACK_IMPORTED_MODULE_9__shadows__ = __webpack_require__(787);

 var __WEBPACK_IMPORTED_MODULE_10__sizing__ = __webpack_require__(396);


 var __WEBPACK_IMPORTED_MODULE_11__spacing__ = __webpack_require__(397);

 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__spacing__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_12__style__ = __webpack_require__(59);

 var __WEBPACK_IMPORTED_MODULE_13__typography__ = __webpack_require__(398);


























 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(127);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3__merge__ = __webpack_require__(163);





function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

function css(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var output = styleFunction(props);

    if (props.css) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, Object(__WEBPACK_IMPORTED_MODULE_3__merge__["a" ])(output, styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
        theme: props.theme
      }, props.css))), omit(props.css, [styleFunction.filterProps]));
    }

    return output;
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    css: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['css'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" ])(styleFunction.filterProps));
  return newStyleFunction;
}

 var _unused_webpack_default_export = (css);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";






 var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(59);
 var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(64);


var displayPrint = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'displayPrint',
  cssProperty: false,
  transform: function transform(value) {
    return {
      '@media print': {
        display: value
      }
    };
  }
});
var displayRaw = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'display'
});
var overflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'overflow'
});
var textOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'textOverflow'
});
var visibility = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'visibility'
});
var whiteSpace = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'whiteSpace'
});
 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" ])(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(59);

var boxShadow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" ])({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
 var _unused_webpack_default_export = (boxShadow);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = memoize;
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__ = __webpack_require__(793);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = useMediaQuery;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_styles__ = __webpack_require__(53);



function useMediaQuery(queryInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_styles__["k" ])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_styles__["f" ])({
    theme: theme,
    name: 'MuiUseMediaQuery',
    props: {}
  });

  if (false) {
    if (typeof queryInput === 'function' && theme === null) {
      console.error(['Material-UI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
    }
  }

  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
  // All the browsers Material-UI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

  var _props$options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, props, options),
      _props$options$defaul = _props$options.defaultMatches,
      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
      _props$options$matchM = _props$options.matchMedia,
      matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM,
      _props$options$noSsr = _props$options.noSsr,
      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
      _props$options$ssrMat = _props$options.ssrMatchMedia,
      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](function () {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  }),
      match = _React$useState[0],
      setMatch = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    var active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    var queryList = matchMedia(query);

    var updateMatch = function updateMatch() {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch();
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue({
      query: query,
      match: match
    });
  }

  return match;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(795);
 var __WEBPACK_IMPORTED_MODULE_3__modules_actions__ = __webpack_require__(797);
function mapDispatchToProps(dispatch){return{createLog:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3__modules_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" ])(null,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ]));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(796);
 var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorBoundary=function(_Component){_inherits(ErrorBoundary,_Component);function ErrorBoundary(props){_classCallCheck(this,ErrorBoundary);var _this=_possibleConstructorReturn(this,(ErrorBoundary.__proto__||Object.getPrototypeOf(ErrorBoundary)).call(this,props));_this.state={hasError:false,loading:false};return _this;}_createClass(ErrorBoundary,[{key:'componentDidCatch',value:function componentDidCatch(error,errorInfo){var _this2=this;var createLog=this.props.createLog;this.setState({hasError:true,loading:true},function(){setTimeout(function(){_this2.setState({loading:false});},1000);if(window.location.hostname==='localhost'){console.error('<----- ERROR ---->');console.error(error?error.toString():'');console.error(errorInfo.componentStack);}else{createLog({sysURL:window.location.origin,currentPath:window.location.href,navigator:window.navigator.userAgent,error:error?error.toString():'',errorInfo:errorInfo.componentStack});}});}},{key:'render',value:function render(){var children=this.props.children;var _state=this.state,hasError=_state.hasError,loading=_state.loading;if(hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ErrorBoundary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(loading?'loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'500'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Unexpected Error',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,':(')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/',className:'go-back-link'},'Go back home')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gears'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gear one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gear two'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gear three'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'})))));}return children;}}]);return ErrorBoundary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ErrorBoundary.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,createLog:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (ErrorBoundary);

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return createLog; });
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
var createLog=function createLog(log){return function(dispatch,getState){var _getState=getState(),session=_getState.session,router=_getState.router,app=_getState.app,mainPageData=_getState.mainPageData,dashboard=_getState.dashboard,MTPData=_getState.MTPData,navbar=_getState.navbar,chats=_getState.chats,userConnections=_getState.userConnections,narratives=_getState.narratives,thinkChats=_getState.thinkChats,thinkTanks=_getState.thinkTanks,steps=_getState.steps,zoom=_getState.zoom,notificationsModal=_getState.notificationsModal,profile=_getState.profile,modalInformation=_getState.modalInformation;var state={session:session,router:router,app:app,mainPageData:mainPageData,dashboard:dashboard,MTPData:MTPData,navbar:navbar,chats:chats,userConnections:userConnections,narratives:narratives,thinkChats:thinkChats,thinkTanks:thinkTanks,steps:steps,zoom:zoom,notificationsModal:notificationsModal,profile:profile,modalInformation:modalInformation};var data=Object.assign({},log,{state:state});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'errors/log'},{log:JSON.stringify(data)});};};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(799);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_2_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_3__components_SplashScreen__ = __webpack_require__(800);
function mapStateToProps(state){return{literals:state.i18n.literals.splashScreen||{},app:state.app,user:state.session.user};}function mapDispatchToProps(dispatch){return{setSplashScreen:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_app__["d" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_SplashScreen__["a" ]));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_assets_images_logo_png__ = __webpack_require__(801);
 var __WEBPACK_IMPORTED_MODULE_2_assets_images_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_images_logo_png__);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(802);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var timeFadeOut=2500;var SplashScreen=function(_Component){_inherits(SplashScreen,_Component);function SplashScreen(props){_classCallCheck(this,SplashScreen);var _this=_possibleConstructorReturn(this,(SplashScreen.__proto__||Object.getPrototypeOf(SplashScreen)).call(this,props));_this.enableFadeOut=function(){var setSplashScreen=_this.props.setSplashScreen;if(_this.to){clearTimeout(_this.to);}_this.setState({fadeOut:true},function(){setTimeout(function(){setSplashScreen(false);},950);});};_this.printContent=function(){var _this$props=_this.props,literals=_this$props.literals,user=_this$props.user;var type=_this.state.type;switch(type){case'zoom-meeting':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,literals.redirectingToMeeting);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,literals.welcomeBack,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,user.name),literals.letsContinue);}};_this.state={fadeOut:false,type:props.type};return _this;}_createClass(SplashScreen,[{key:'componentDidMount',value:function componentDidMount(){this.to=setTimeout(this.enableFadeOut,timeFadeOut);}},{key:'componentDidUpdate',value:function componentDidUpdate(_ref){var prevSplashScreen=_ref.app.splashScreen;var splashScreen=this.props.app.splashScreen;var fadeOut=this.state.fadeOut;if(!prevSplashScreen&&splashScreen){if(this.to){clearTimeout(this.to);}if(fadeOut){this.setState({fadeOut:false});}this.to=setTimeout(this.enableFadeOut,timeFadeOut);}}},{key:'render',value:function render(){var _props=this.props,_props$app=_props.app,color1=_props$app.color1,splashScreen=_props$app.splashScreen,user=_props.user;var fadeOut=this.state.fadeOut;if(!user.id||!splashScreen){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["c" ],{className:'splash_screen',color:color1,fadeOut:fadeOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{className:'fa fa-times',onClick:this.enableFadeOut}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2_assets_images_logo_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["d" ],{backgroundColorText:color1},this.printContent()));}}]);return SplashScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SplashScreen.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setSplashScreen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};SplashScreen.defaultProps={type:''}; __webpack_exports__["a"] = (SplashScreen);

 }),

 (function(module, exports) {

module.exports = "data:image/png;base64,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"

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return SplashScreenWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return Logo; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return Text; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return CloseIcon; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n'],['\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  animation: ',' 2s;\n'],['\n  animation: ',' 2s;\n']),_templateObject3=_taggedTemplateLiteral(['\n  from {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n'],['\n  from {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  animation: ',' 1s;\n'],['\n  animation: ',' 1s;\n']),_templateObject5=_taggedTemplateLiteral(['\n  padding: 20px;\n  text-align: center;\n  position: fixed;\n  z-index: 100001;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ',';\n  justify-content: center;\n  transform: translate3d(0, 0, 0);\n  visibility: visible;\n  ','\n'],['\n  padding: 20px;\n  text-align: center;\n  position: fixed;\n  z-index: 100001;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ',';\n  justify-content: center;\n  transform: translate3d(0, 0, 0);\n  visibility: visible;\n  ','\n']),_templateObject6=_taggedTemplateLiteral(['\n  text-align: center;\n  margin: 0px auto 20px;\n  ','\n'],['\n  text-align: center;\n  margin: 0px auto 20px;\n  ','\n']),_templateObject7=_taggedTemplateLiteral(['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n\n  }\n  \n'],['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n\n  }\n  \n']),_templateObject8=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 20px;\n  margin: 0 auto;\n  line-height: 24px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  padding: 0px 3px;\n  ','\n  font-family: \'helvetica neue light\';\n  strong {\n    font-family: \'helvetica neue strong\';\n    color: #fff;\n    font-weight: 100;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n  \n'],['\n  color: #fff;\n  font-size: 20px;\n  margin: 0 auto;\n  line-height: 24px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  padding: 0px 3px;\n  ','\n  font-family: \'helvetica neue light\';\n  strong {\n    font-family: \'helvetica neue strong\';\n    color: #fff;\n    font-weight: 100;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n  \n']),_templateObject9=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 24px;\n  cursor: pointer;\n  position: absolute;\n  right: 20px;\n  top: calc(20px + env(safe-area-inset-top));\n'],['\n  color: #fff;\n  font-size: 24px;\n  cursor: pointer;\n  position: absolute;\n  right: 20px;\n  top: calc(20px + env(safe-area-inset-top));\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var fadeIn=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject);var fadeInEffect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject2,fadeIn);var fadeOut=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject3);var fadeOutEffect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject4,fadeOut);var SplashScreenWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,function(props){return props.color;},function(props){return props.fadeOut?fadeOutEffect:'';});var Logo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,fadeInEffect);var highlight=function highlight(backgroundColorText){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject7,backgroundColorText);};var Text=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,fadeInEffect,function(props){return highlight(props.backgroundColorText);});var CloseIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject9);

 }),

 (function(module, exports, __webpack_require__) {

!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
//# sourceMappingURL=stylis.min.js.map

 }),

 (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = ''
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

 __webpack_exports__["a"] = (unitlessKeys);


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(807);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

 __webpack_exports__["a"] = (memoizeOne);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(810);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" ])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  
  && prop.charCodeAt(1) === 110
  
  && prop.charCodeAt(2) < 91;
}

);

 __webpack_exports__["a"] = (index);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

 __webpack_exports__["a"] = (memoize);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 var __WEBPACK_IMPORTED_MODULE_0_is_what__ = __webpack_require__(812);




function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key)
        ? 'enumerable'
        : 'nonenumerable';
    if (propType === 'enumerable')
        carry[key] = newVal;
    if (propType === 'nonenumerable') {
        Object.defineProperty(carry, key, {
            value: newVal,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
}
function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" ])(newComer)) {
        // extend merge rules
        if (extensions && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" ])(extensions)) {
            extensions.forEach(function (extend) {
                newComer = extend(origin, newComer);
            });
        }
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" ])(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = __spreadArrays(props_1, symbols_1).reduce(function (carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if ((!Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["c" ])(key) && !Object.getOwnPropertyNames(newComer).includes(key)) ||
                (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["c" ])(key) && !Object.getOwnPropertySymbols(newComer).includes(key))) {
                assignProp(carry, key, targetVal, origin);
            }
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = __spreadArrays(props, symbols).reduce(function (carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" ])(origin))
            // @ts-ignore
            ? origin[key]
            : undefined;
        // extend merge rules
        if (extensions && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" ])(extensions)) {
            extensions.forEach(function (extend) {
                newVal = extend(targetVal, newVal);
            });
        }
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" ])(newVal)) {
            newVal = mergeRecursively(targetVal, newVal, extensions);
        }
        assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}

function merge(origin) {
    var newComers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        newComers[_i - 1] = arguments[_i];
    }
    var extensions = null;
    var base = origin;
    if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" ])(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function (result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}

function concatArrays(originVal, newVal) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" ])(originVal) && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" ])(newVal)) {
        // concat logic
        return originVal.concat(newVal);
    }
    return newVal; // always return newVal as fallback!!
}

 __webpack_exports__["a"] = (merge);



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 __webpack_require__.d(__webpack_exports__, "a", function() { return isArray; });


















 __webpack_require__.d(__webpack_exports__, "b", function() { return isPlainObject; });





 __webpack_require__.d(__webpack_exports__, "c", function() { return isSymbol; });





function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}

function isUndefined(payload) {
    return getType(payload) === 'Undefined';
}

function isNull(payload) {
    return getType(payload) === 'Null';
}

function isPlainObject(payload) {
    if (getType(payload) !== 'Object')
        return false;
    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
}

function isObject(payload) {
    return isPlainObject(payload);
}

function isEmptyObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length === 0;
}

function isAnyObject(payload) {
    return getType(payload) === 'Object';
}

function isObjectLike(payload) {
    return isAnyObject(payload);
}

function isFunction(payload) {
    return typeof payload === "function";
}

function isArray(payload) {
    return getType(payload) === 'Array';
}

function isFullArray(payload) {
    return isArray(payload) && payload.length > 0;
}

function isEmptyArray(payload) {
    return isArray(payload) && payload.length === 0;
}

function isString(payload) {
    return getType(payload) === 'String';
}

function isFullString(payload) {
    return isString(payload) && payload !== '';
}

function isEmptyString(payload) {
    return payload === '';
}

function isNumber(payload) {
    return getType(payload) === 'Number' && !isNaN(payload);
}

function isBoolean(payload) {
    return getType(payload) === 'Boolean';
}

function isRegExp(payload) {
    return getType(payload) === 'RegExp';
}

function isMap(payload) {
    return getType(payload) === 'Map';
}

function isWeakMap(payload) {
    return getType(payload) === 'WeakMap';
}

function isSet(payload) {
    return getType(payload) === 'Set';
}

function isWeakSet(payload) {
    return getType(payload) === 'WeakSet';
}

function isSymbol(payload) {
    return getType(payload) === 'Symbol';
}

function isDate(payload) {
    return getType(payload) === 'Date' && !isNaN(payload);
}

function isBlob(payload) {
    return getType(payload) === 'Blob';
}

function isFile(payload) {
    return getType(payload) === 'File';
}

function isPromise(payload) {
    return getType(payload) === 'Promise';
}

function isError(payload) {
    return getType(payload) === 'Error';
}

function isNaNValue(payload) {
    return getType(payload) === 'Number' && isNaN(payload);
}

function isPrimitive(payload) {
    return (isBoolean(payload) ||
        isNull(payload) ||
        isUndefined(payload) ||
        isNumber(payload) ||
        isString(payload) ||
        isSymbol(payload));
}

function isNullOrUndefined(payload) {
    return isNull(payload) || isUndefined(payload);
}

function isType(payload, type) {
    if (!(type instanceof Function)) {
        throw new TypeError('Type must be a function');
    }
    if (!Object.prototype.hasOwnProperty.call(type, 'prototype')) {
        throw new TypeError('Type is not a class');
    }
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return getType(payload) === name || Boolean(payload && payload.constructor === type);
}




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(814);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_4_routes_MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_5_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_6_components_ThinkTanks_modules_actions__ = __webpack_require__(76);
 var __WEBPACK_IMPORTED_MODULE_7_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_8_store_globalState_reducers_userConnections__ = __webpack_require__(125);
 var __WEBPACK_IMPORTED_MODULE_9_modules_elements_actions__ = __webpack_require__(132);
 var __WEBPACK_IMPORTED_MODULE_10_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_11_modules_speedDating_actions__ = __webpack_require__(225);
 var __WEBPACK_IMPORTED_MODULE_12_routes_Narratives_modules__ = __webpack_require__(82);
 var __WEBPACK_IMPORTED_MODULE_13__components__ = __webpack_require__(815);
function mapStateToProps(state){return{literals:state.i18n.literals.layout,chats:state.chats,user:state.session.user,app:state.app,narratives:state.narratives.list,thinkChats:state.thinkChats.myThinkChatsList,thinkTanks:state.thinkTanks.myThinkTanksList,requestsJoinThinkTank:state.thinkTanks.requestsJoinThinkTank,actualContext:state.steps.context,breadcrumb:state.navbar.breadcrumb,selectedSection:state.global.selected,autoNavigation:state.mainPageData.autoNavigation,hasPendingRequests:state.userConnections.hasPendingRequests};}function mapDispatchToProps(dispatch){return{goHome:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__["e" ],dispatch),fetchMainNarratives:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_12_routes_Narratives_modules__["e" ],dispatch),fetchObjectives:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_12_routes_Narratives_modules__["f" ],dispatch),fetchTools:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_12_routes_Narratives_modules__["g" ],dispatch),fetchElements:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_12_routes_Narratives_modules__["d" ],dispatch),getMyThinkChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_think_seeds_actions__["b" ],dispatch),getMyThinkTanks:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_components_ThinkTanks_modules_actions__["g" ],dispatch),getChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7_modules_chats__["e" ],dispatch),getInvitations:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7_modules_chats__["f" ],dispatch),setAutoNavigation:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_routes_MainPage_modules_mainPage__["b" ],dispatch),setGoDown:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_routes_MainPage_modules_mainPage__["d" ],dispatch),getAllRequestsJoin:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_components_ThinkTanks_modules_actions__["f" ],dispatch),getElementsSelected:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_9_modules_elements_actions__["e" ],dispatch),getMyCallsForImpact:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_12_routes_Narratives_modules__["h" ],dispatch),getElementsCreatedByUser:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_9_modules_elements_actions__["d" ],dispatch),getSerendipityPreferences:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_10_modules_serendipity_actions__["e" ],dispatch),getSerendipityAction:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_10_modules_serendipity_actions__["d" ],dispatch),fetchUserConnections:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_8_store_globalState_reducers_userConnections__["e" ],dispatch),getSpeedDatingMeetings:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_11_modules_speedDating_actions__["c" ],dispatch),getUserInterests:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_9_modules_elements_actions__["f" ],dispatch),getUserRequestedConnections:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_8_store_globalState_reducers_userConnections__["f" ],dispatch),getElementTypesShownInUserCard:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_9_modules_elements_actions__["c" ],dispatch),getHasPendingRequests:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_8_store_globalState_reducers_userConnections__["c" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_13__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_react_ga__ = __webpack_require__(106);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Menu__ = __webpack_require__(816);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(408);
 var __WEBPACK_IMPORTED_MODULE_7_react_draggable__ = __webpack_require__(169);
 var __WEBPACK_IMPORTED_MODULE_7_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_draggable__);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_think_table_jpg__ = __webpack_require__(171);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_think_table_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_images_think_table_jpg__);
 var __WEBPACK_IMPORTED_MODULE_9_constants_chat__ = __webpack_require__(216);
 var __WEBPACK_IMPORTED_MODULE_10_components_NotificationsModal__ = __webpack_require__(846);
 var __WEBPACK_IMPORTED_MODULE_11_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_12_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_13_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_14_components_Chats_components_ChatElement__ = __webpack_require__(421);
 var __WEBPACK_IMPORTED_MODULE_15_components_ChatRoom__ = __webpack_require__(111);
 var __WEBPACK_IMPORTED_MODULE_16_utils_string__ = __webpack_require__(67);
 var __WEBPACK_IMPORTED_MODULE_17_assets_images_menu_thinkNew_svg__ = __webpack_require__(985);
 var __WEBPACK_IMPORTED_MODULE_17_assets_images_menu_thinkNew_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_assets_images_menu_thinkNew_svg__);
 var __WEBPACK_IMPORTED_MODULE_18_assets_images_think_no_think_chats_svg__ = __webpack_require__(91);
 var __WEBPACK_IMPORTED_MODULE_18_assets_images_think_no_think_chats_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_assets_images_think_no_think_chats_svg__);
 var __WEBPACK_IMPORTED_MODULE_19_assets_images_menu_connect_icon_white_svg__ = __webpack_require__(986);
 var __WEBPACK_IMPORTED_MODULE_19_assets_images_menu_connect_icon_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_assets_images_menu_connect_icon_white_svg__);
 var __WEBPACK_IMPORTED_MODULE_20_assets_images_menu_initiativeNew_svg__ = __webpack_require__(987);
 var __WEBPACK_IMPORTED_MODULE_20_assets_images_menu_initiativeNew_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_assets_images_menu_initiativeNew_svg__);
 var __WEBPACK_IMPORTED_MODULE_21_assets_images_menu_discover_button_svg__ = __webpack_require__(988);
 var __WEBPACK_IMPORTED_MODULE_21_assets_images_menu_discover_button_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_assets_images_menu_discover_button_svg__);
 var __WEBPACK_IMPORTED_MODULE_22_assets_images_menu_tools_svg__ = __webpack_require__(989);
 var __WEBPACK_IMPORTED_MODULE_22_assets_images_menu_tools_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_assets_images_menu_tools_svg__);
 var __WEBPACK_IMPORTED_MODULE_23_assets_images_logos_logo_selected_svg__ = __webpack_require__(990);
 var __WEBPACK_IMPORTED_MODULE_23_assets_images_logos_logo_selected_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_assets_images_logos_logo_selected_svg__);
 var __WEBPACK_IMPORTED_MODULE_24_assets_images_logos_logo_selected_orange_svg__ = __webpack_require__(991);
 var __WEBPACK_IMPORTED_MODULE_24_assets_images_logos_logo_selected_orange_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_assets_images_logos_logo_selected_orange_svg__);
 var __WEBPACK_IMPORTED_MODULE_25_assets_images_logos_logo_unselected_svg__ = __webpack_require__(992);
 var __WEBPACK_IMPORTED_MODULE_25_assets_images_logos_logo_unselected_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_assets_images_logos_logo_unselected_svg__);
 var __WEBPACK_IMPORTED_MODULE_26_assets_images_logos_logo_orange_svg__ = __webpack_require__(993);
 var __WEBPACK_IMPORTED_MODULE_26_assets_images_logos_logo_orange_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_assets_images_logos_logo_orange_svg__);
 var __WEBPACK_IMPORTED_MODULE_27_assets_images_menu_finetune_svg__ = __webpack_require__(994);
 var __WEBPACK_IMPORTED_MODULE_27_assets_images_menu_finetune_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_assets_images_menu_finetune_svg__);
 var __WEBPACK_IMPORTED_MODULE_28_assets_images_fine_tune_svg__ = __webpack_require__(995);
 var __WEBPACK_IMPORTED_MODULE_28_assets_images_fine_tune_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_assets_images_fine_tune_svg__);
 var __WEBPACK_IMPORTED_MODULE_29_assets_images_menu_createTable_svg__ = __webpack_require__(996);
 var __WEBPACK_IMPORTED_MODULE_29_assets_images_menu_createTable_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_assets_images_menu_createTable_svg__);
 var __WEBPACK_IMPORTED_MODULE_30_assets_images_menu_createCall_svg__ = __webpack_require__(997);
 var __WEBPACK_IMPORTED_MODULE_30_assets_images_menu_createCall_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_assets_images_menu_createCall_svg__);
 var __WEBPACK_IMPORTED_MODULE_31_assets_images_menu_askEco_svg__ = __webpack_require__(998);
 var __WEBPACK_IMPORTED_MODULE_31_assets_images_menu_askEco_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_assets_images_menu_askEco_svg__);
 var __WEBPACK_IMPORTED_MODULE_32_assets_images_menu_requestSpeed_svg__ = __webpack_require__(999);
 var __WEBPACK_IMPORTED_MODULE_32_assets_images_menu_requestSpeed_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_assets_images_menu_requestSpeed_svg__);
 var __WEBPACK_IMPORTED_MODULE_33_components_LayoutContent__ = __webpack_require__(1000);
 var __WEBPACK_IMPORTED_MODULE_34_constants_roles__ = __webpack_require__(436);
 var __WEBPACK_IMPORTED_MODULE_35_constants_tables__ = __webpack_require__(110);
 var __WEBPACK_IMPORTED_MODULE_36_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_37_constants_layout__ = __webpack_require__(437);
 var __WEBPACK_IMPORTED_MODULE_38__BreadcrumbElement__ = __webpack_require__(1003);
 var __WEBPACK_IMPORTED_MODULE_39__styles__ = __webpack_require__(1004);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Layout=function(_Component){_inherits(Layout,_Component);function Layout(props){_classCallCheck(this,Layout);var _this=_possibleConstructorReturn(this,(Layout.__proto__||Object.getPrototypeOf(Layout)).call(this,props));_this.loadInfo=function(){var _this$props=_this.props,fetchMainNarratives=_this$props.fetchMainNarratives,fetchObjectives=_this$props.fetchObjectives,fetchTools=_this$props.fetchTools,getMyThinkChats=_this$props.getMyThinkChats,getInvitations=_this$props.getInvitations,getChats=_this$props.getChats,getElementsSelected=_this$props.getElementsSelected,getMyCallsForImpact=_this$props.getMyCallsForImpact,getElementsCreatedByUser=_this$props.getElementsCreatedByUser,app=_this$props.app,fetchUserConnections=_this$props.fetchUserConnections,getHasPendingRequests=_this$props.getHasPendingRequests,getSerendipityPreferences=_this$props.getSerendipityPreferences,getSpeedDatingMeetings=_this$props.getSpeedDatingMeetings,user=_this$props.user,getUserInterests=_this$props.getUserInterests,getUserRequestedConnections=_this$props.getUserRequestedConnections,getElementTypesShownInUserCard=_this$props.getElementTypesShownInUserCard;fetchMainNarratives();fetchObjectives();fetchTools();getMyThinkChats();getChats();getInvitations();getElementsSelected();getMyCallsForImpact();getSerendipityPreferences();fetchUserConnections(true);getUserRequestedConnections();getSpeedDatingMeetings();getUserInterests(user.id);getElementTypesShownInUserCard();getHasPendingRequests();if(app.elements_showing){getElementsCreatedByUser(app.elements_showing);}};_this.isInNarrative=function(){var actualContext=_this.props.actualContext;return actualContext&&typeof actualContext.color!=='undefined';};_this.getBackgroundColor=function(){var actualContext=_this.props.actualContext;if(actualContext&&typeof actualContext.color!=='undefined'){return typeof actualContext.color==='string'?actualContext.color:actualContext.color.color;}return'#fff';};_this.getSecondaryColor=function(){var _this$props2=_this.props,app=_this$props2.app,actualContext=_this$props2.actualContext;if(actualContext&&typeof actualContext.color!=='undefined'){var color=typeof actualContext.color==='string'?Object(__WEBPACK_IMPORTED_MODULE_12_utils_colors__["d" ])(actualContext.color):Object(__WEBPACK_IMPORTED_MODULE_12_utils_colors__["d" ])(actualContext.color.color);return Object(__WEBPACK_IMPORTED_MODULE_12_utils_colors__["j" ])(color);}return app.color1;};_this.getActualSection=function(){var _this$props3=_this.props,thinkChats=_this$props3.thinkChats,narratives=_this$props3.narratives;var _this$state=_this.state,prevPathName=_this$state.prevPathName,expandedOptions=_this$state.expandedOptions;if(prevPathName!==window.location.pathname){_this.setState({prevPathName:window.location.pathname});}var pieces=window.location.pathname.split('/');switch('/'+pieces[1]){case __WEBPACK_IMPORTED_MODULE_36_constants_urls__["y" ]:_this.setState({selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ]});break;case __WEBPACK_IMPORTED_MODULE_36_constants_urls__["u" ]:_this.setState({selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ]});break;case __WEBPACK_IMPORTED_MODULE_36_constants_urls__["i" ]:_this.setState({selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["c" ]});break;case __WEBPACK_IMPORTED_MODULE_36_constants_urls__["P" ]:_this.setState({selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["i" ]});break;case __WEBPACK_IMPORTED_MODULE_36_constants_urls__["F" ]:_this.setState({selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["h" ]});break;case'/narratives':{var selectedMainOption=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ];var id=parseInt(pieces[2],10);var narrative=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(narratives,{id:id});var selectedOption=null;var newExpandedOptions=[].concat(_toConsumableArray(expandedOptions));if(narrative){selectedOption=narrative.type.id===21227761?__WEBPACK_IMPORTED_MODULE_37_constants_layout__["g" ]:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["a" ];newExpandedOptions.push(selectedOption);}_this.setState({selectedMainOption:selectedMainOption,selectedOption:selectedOption,selectedSuboption:id,expandedOptions:newExpandedOptions});}break;case'/chat':{var _id=parseInt(pieces[2],10);_this.setState({selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["c" ],selectedOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["b" ],selectedSuboption:_id,expandedOptions:[].concat(_toConsumableArray(expandedOptions),[__WEBPACK_IMPORTED_MODULE_37_constants_layout__["b" ]])});}break;case'/theme-table':if(pieces.length>=3){var _id2=parseInt(pieces[2],10);var found=false;var _selectedOption=null;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(thinkChats,{element_related:{id:_id2}})){found=true;_selectedOption=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["j" ];}if(found){_this.setState({selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["i" ],selectedOption:_selectedOption,selectedSuboption:_id2,expandedOptions:[].concat(_toConsumableArray(expandedOptions),[_selectedOption])});}}break;default:break;}};_this.updateWindowDimensions=function(){_this.setState({windowWidth:window.innerWidth});};_this.handleUserMenuClick=function(event){_this.setState({userMenuAnchorEl:event.currentTarget});};_this.handleUserMenuClose=function(){_this.setState({userMenuAnchorEl:null});};_this.handleHideMenu=function(){var hideMenu=_this.state.hideMenu;_this.setState({hideMenu:!hideMenu});};_this.handleClickLogo=function(){var _this$props4=_this.props,history=_this$props4.history,setAutoNavigation=_this$props4.setAutoNavigation;var selectedMainOption=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ];_this.setState({selectedMainOption:selectedMainOption});setAutoNavigation(true);history.push(__WEBPACK_IMPORTED_MODULE_36_constants_urls__["u" ]);__WEBPACK_IMPORTED_MODULE_4_react_ga__["a" ].event({category:'Change Section',action:selectedMainOption,label:'Layout'});};_this.handleSelectMainOption=function(event){var _this$props5=_this.props,history=_this$props5.history,setAutoNavigation=_this$props5.setAutoNavigation,setGoDown=_this$props5.setGoDown,getSerendipityAction=_this$props5.getSerendipityAction;var selectedMainOption=event.currentTarget.getAttribute('data-section');_this.setState({selectedMainOption:selectedMainOption});var newPath=null;switch(selectedMainOption){case __WEBPACK_IMPORTED_MODULE_37_constants_layout__["d" ]:{var action=getSerendipityAction();if(action){action();}else{history.push('/no-recommendations');}}break;case __WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ]:newPath=__WEBPACK_IMPORTED_MODULE_36_constants_urls__["u" ];break;case __WEBPACK_IMPORTED_MODULE_37_constants_layout__["c" ]:newPath=__WEBPACK_IMPORTED_MODULE_36_constants_urls__["i" ];break;case __WEBPACK_IMPORTED_MODULE_37_constants_layout__["i" ]:newPath=__WEBPACK_IMPORTED_MODULE_36_constants_urls__["P" ];break;case __WEBPACK_IMPORTED_MODULE_37_constants_layout__["h" ]:newPath=__WEBPACK_IMPORTED_MODULE_36_constants_urls__["F" ];break;case __WEBPACK_IMPORTED_MODULE_37_constants_layout__["e" ]:newPath=__WEBPACK_IMPORTED_MODULE_36_constants_urls__["q" ];break;default:break;}__WEBPACK_IMPORTED_MODULE_4_react_ga__["a" ].event({category:'Change Section',action:selectedMainOption,label:'Layout'});if(newPath&&newPath!==window.location.pathname){setAutoNavigation(true);history.push(newPath);}else if(selectedMainOption===__WEBPACK_IMPORTED_MODULE_37_constants_layout__["d" ]){setGoDown(true);}};_this.handleOptionClick=function(event){var expandedOptions=_this.state.expandedOptions;var option=event.currentTarget.getAttribute('data-option');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expandedOptions,function(expandedOption){return expandedOption===option;})){expandedOptions.push(option);}else{__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(expandedOptions,function(expandedOption){return expandedOption===option;});}_this.setState({expandedOptions:expandedOptions});event.stopPropagation();};_this.handleClickCallForImpact=function(event){var id=parseInt(event.currentTarget.getAttribute('data-id'),10);var history=_this.props.history;_this.setState({selectedOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["a" ],selectedSuboption:id,selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ]});history.push('/calls/'+id);};_this.handleClickNarrative=function(event){var id=parseInt(event.currentTarget.getAttribute('data-id'),10);var history=_this.props.history;_this.setState({selectedOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["g" ],selectedSuboption:id,selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ]});history.push('/narratives/'+id);};_this.handleClickChat=function(event){var id=parseInt(event.currentTarget.getAttribute('data-id'),10);var history=_this.props.history;_this.setState({selectedOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["b" ],selectedSuboption:id,selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["c" ]});history.push('/chat/'+id);};_this.handleClickThinkChat=function(event){var id=parseInt(event.currentTarget.getAttribute('data-id'),10);var history=_this.props.history;_this.setState({selectedOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["j" ],selectedSuboption:id,selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["i" ]});history.push('/theme-table/'+id);};_this.goToThemeTable=function(tableId){var history=_this.props.history;_this.setState({selectedOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["j" ],selectedSuboption:tableId,selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["i" ]});history.push('/theme-table/'+tableId);};_this.handleSearcherInput=function(event){var value=event.target.value;_this.setState({search:value});};_this.handleGoToProfile=function(){var history=_this.props.history;_this.handleUserMenuClose();_this.setState({selectedOption:null,selectedSuboption:null,selectedMainOption:__WEBPACK_IMPORTED_MODULE_37_constants_layout__["h" ]});history.push(__WEBPACK_IMPORTED_MODULE_36_constants_urls__["F" ]);};_this.logout=function(){var history=_this.props.history;_this.handleUserMenuClose();history.push(__WEBPACK_IMPORTED_MODULE_36_constants_urls__["x" ]);};_this.handleGoBack=function(){var _this$props6=_this.props,history=_this$props6.history,breadcrumb=_this$props6.breadcrumb;var backBreadcrumb=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(breadcrumb,function(element){return typeof element.type!=='undefined'&&element.type==='back';});if(!backBreadcrumb||typeof backBreadcrumb.onClick==='undefined'){history.push(__WEBPACK_IMPORTED_MODULE_36_constants_urls__["u" ]);}else{backBreadcrumb.onClick();}};_this.printBreadcrumb=function(){var breadcrumb=_this.props.breadcrumb;var elementsBreadcrumbs=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(breadcrumb,function(element){return typeof element.type==='undefined'||element.type!=='back';});return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(elementsBreadcrumbs,function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__BreadcrumbElement__["a" ],{data:data,isFirst:index===0,key:index});});};_this.selectTool=function(event){var history=_this.props.history;var option=event.currentTarget.getAttribute('data-tool');switch(option){case'table':history.push('think-chat/creation');break;default:break;}};_this.goToFineTune=function(){var history=_this.props.history;history.push('/fine-tune');};_this.printDiscover=function(){var _this$props7=_this.props,literals=_this$props7.literals,user=_this$props7.user;var progress=_this.state.progress;var section=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["d" ];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_draggable___default.a,{defaultPosition:{x:0,y:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'drag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["c" ],{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text','data-section':section,onClick:_this.handleSelectMainOption},literals.serendipity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'},'|'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_27_assets_images_menu_finetune_svg___default.a,alt:'',onClick:_this.goToFineTune})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["f" ],{pro:13*(progress/100)}))),Object(__WEBPACK_IMPORTED_MODULE_34_constants_roles__["a" ])(user.role)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onMouseOver:function onMouseOver(){return _this.setState({tools:true});},onMouseOut:function onMouseOut(){return _this.setState({tools:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["g" ],{open:_this.state.tools},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_22_assets_images_menu_tools_svg___default.a,alt:'',id:'tools'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.impactTools)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["h" ],{open:_this.state.tools},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_30_assets_images_menu_createCall_svg___default.a,alt:''}),literals.createCall),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',onClick:_this.selectTool,'data-tool':'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_29_assets_images_menu_createTable_svg___default.a,alt:''}),literals.createTable),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_32_assets_images_menu_requestSpeed_svg___default.a,alt:''}),literals.speed),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_31_assets_images_menu_askEco_svg___default.a,alt:''}),literals.ask))));};_this.printC2I=function(){// const { literals } = this.props;
var hideMenu=_this.state.hideMenu;// const section = INITIATIVES;
// const selectedClass = selectedMainOption === section ? 'selected' : '';
if(hideMenu){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.printCallsForImpact(),_this.printNarratives());}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.printCallsForImpact(),_this.printNarratives());};_this.printCallsForImpact=function(){var _this$props8=_this.props,literals=_this$props8.literals,narratives=_this$props8.narratives;var _this$state2=_this.state,expandedOptions=_this$state2.expandedOptions,search=_this$state2.search,selectedOption=_this$state2.selectedOption,selectedSuboption=_this$state2.selectedSuboption,hideMenu=_this$state2.hideMenu,selectedMainOption=_this$state2.selectedMainOption;var option=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["a" ];var expandedClass=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expandedOptions,function(expandedOption){return expandedOption===option;})?'expanded':'';var selectedClass=selectedOption===option?'selected':'';// booleano de prueba para simular si hay notificaciones nuevas hasta que implemente esa funcionalidad
var hasNoti=false;var section=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ];var actualSection=selectedMainOption;var searchValue=Object(__WEBPACK_IMPORTED_MODULE_16_utils_string__["d" ])(search.toLowerCase());var finalNarratives=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(narratives,function(narrative){var name=narrative.name,typeId=narrative.type.id;var narrativeName=Object(__WEBPACK_IMPORTED_MODULE_16_utils_string__["d" ])(name.toLowerCase());if(typeId!==21227760){return false;}return narrativeName.indexOf(searchValue)!==-1;});if(!finalNarratives.length){return null;}var logo=__WEBPACK_IMPORTED_MODULE_25_assets_images_logos_logo_unselected_svg___default.a;var mainColor='';var colorText='grey';if(hasNoti){logo=__WEBPACK_IMPORTED_MODULE_26_assets_images_logos_logo_orange_svg___default.a;}if(actualSection===__WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ]){mainColor=_this.getSecondaryColor();colorText='#fff';logo=__WEBPACK_IMPORTED_MODULE_23_assets_images_logos_logo_selected_svg___default.a;if(hasNoti){logo=__WEBPACK_IMPORTED_MODULE_24_assets_images_logos_logo_selected_orange_svg___default.a;}}if(hideMenu){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'inline-block',backgroundColor:mainColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logo,alt:'','data-section':section,onClick:_this.handleSelectMainOption,style:{margin:'15px',display:'inline-block',cursor:'pointer'}}));}var narrativesOptions=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(finalNarratives,function(_ref){var id=_ref.id,name=_ref.name;var subselectedClass=selectedSuboption===id?'selected':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'option_submenu '+subselectedClass,key:id,'data-id':id,onClick:_this.handleClickCallForImpact},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert_in_menu'}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'option_menu '+expandedClass+' '+selectedClass,style:{backgroundColor:mainColor,marginBottom:'10px',height:'65px'},'data-section':section,onClick:_this.handleSelectMainOption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logo,alt:'',style:{display:'inline-block',cursor:'pointer',margin:'5px 5px 0 5px',width:'35px',verticalAlign:'sub'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text',style:{color:colorText}},literals.impactEvents),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_expand',onClick:_this.handleOptionClick,'data-option':option},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-right icon_open impact',style:{color:colorText}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_minimize',onClick:_this.handleOptionClick,'data-option':option},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-down icon_close impact',style:{color:colorText}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu_options '+expandedClass},narrativesOptions));};_this.printNarratives=function(){var _this$props9=_this.props,literals=_this$props9.literals,narratives=_this$props9.narratives;var _this$state3=_this.state,expandedOptions=_this$state3.expandedOptions,search=_this$state3.search,selectedOption=_this$state3.selectedOption,selectedSuboption=_this$state3.selectedSuboption,hideMenu=_this$state3.hideMenu;var option=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["g" ];var expandedClass=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expandedOptions,function(expandedOption){return expandedOption===option;})?'expanded':'';var selectedClass=selectedOption===option?'selected':'';var searchValue=Object(__WEBPACK_IMPORTED_MODULE_16_utils_string__["d" ])(search.toLowerCase());var finalNarratives=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(narratives,function(narrative){var name=narrative.name,typeId=narrative.type.id;var narrativeName=Object(__WEBPACK_IMPORTED_MODULE_16_utils_string__["d" ])(name.toLowerCase());if(typeId!==21227761){return false;}return narrativeName.indexOf(searchValue)!==-1;});if(!finalNarratives.length){return null;}if(hideMenu){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_28_assets_images_fine_tune_svg___default.a,alt:'',style:{display:'inline-block',margin:'15px'}});}var narrativesOptions=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(finalNarratives,function(_ref2){var id=_ref2.id,name=_ref2.name;var subselectedClass=selectedSuboption===id?'selected':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'option_submenu '+subselectedClass,key:id,'data-id':id,onClick:_this.handleClickNarrative},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert_in_menu'}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'option_menu '+expandedClass+' '+selectedClass,onClick:_this.handleOptionClick,'data-option':option},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_28_assets_images_fine_tune_svg___default.a,alt:'',style:{display:'inline-block',margin:'9px',verticalAlign:'middle'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.fineTune),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_expand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-right icon_open'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_minimize'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-down icon_close'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu_options '+expandedClass},narrativesOptions));};_this.printConnections=function(){var _this$props10=_this.props,literals=_this$props10.literals,hasPendingRequests=_this$props10.hasPendingRequests;var _this$state4=_this.state,selectedMainOption=_this$state4.selectedMainOption,hideMenu=_this$state4.hideMenu;var section=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["c" ];var selectedClass=selectedMainOption===section?'selected':'';if(hasPendingRequests&&selectedMainOption===section){selectedClass='selected orange';}if(hideMenu){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main_option '+selectedClass,'data-section':section,onClick:_this.handleSelectMainOption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{className:'icon',image:__WEBPACK_IMPORTED_MODULE_19_assets_images_menu_connect_icon_white_svg___default.a}),hasPendingRequests?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert_in_menu'}):null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main_option '+selectedClass,'data-section':section,onClick:_this.handleSelectMainOption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{className:'icon',image:__WEBPACK_IMPORTED_MODULE_19_assets_images_menu_connect_icon_white_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.connections),hasPendingRequests?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert_in_menu'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert_in_menu_text'},'The Network appreciates you')):null));};_this.printChats=function(){var _this$props11=_this.props,chats=_this$props11.chats.chats,literals=_this$props11.literals,user=_this$props11.user;var _this$state5=_this.state,expandedOptions=_this$state5.expandedOptions,search=_this$state5.search,selectedOption=_this$state5.selectedOption,selectedSuboption=_this$state5.selectedSuboption;var option=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["b" ];var selectedClass=selectedOption===option?'selected':'';if(!chats){return null;}var expandedClass=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expandedOptions,function(expandedOption){return expandedOption===option;})?'expanded':'';var searchValue=Object(__WEBPACK_IMPORTED_MODULE_16_utils_string__["d" ])(search.toLowerCase());var filteredChats=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(chats,function(_ref3){var users=_ref3.users,elementRelated=_ref3.element_related;var otherUser=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,function(chatUser){return chatUser.id!==user.id;});if(!otherUser){return null;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(elementRelated)){return false;}var nameChat=otherUser.firstname+' '+otherUser.lastname;var nameChatSearch=Object(__WEBPACK_IMPORTED_MODULE_16_utils_string__["d" ])(nameChat.toLowerCase());if(nameChatSearch.indexOf(searchValue)===-1){return false;}return true;});if(!filteredChats.length){return null;}var optionsChats=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(filteredChats,function(_ref4){var id=_ref4.id,users=_ref4.users;var otherUser=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,function(chatUser){return chatUser.id!==user.id;});if(!otherUser){return null;}var nameChat=otherUser.firstname+' '+otherUser.lastname;var subselectedClass=selectedSuboption===id?'selected':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'option_submenu '+subselectedClass,'data-id':id,key:otherUser.id,onClick:_this.handleClickChat},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},nameChat),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert_in_menu'}));});if(!optionsChats.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'option_menu '+expandedClass+' '+selectedClass,onClick:_this.handleOptionClick,'data-option':option},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.chats),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_expand arrow_expand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-right icon_open'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_minimize arrow_expand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-down icon_close'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu_options '+expandedClass},optionsChats));};_this.printThink=function(){var _this$props12=_this.props,literals=_this$props12.literals,chats=_this$props12.chats;var _this$state6=_this.state,selectedMainOption=_this$state6.selectedMainOption,hideMenu=_this$state6.hideMenu;var section=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["i" ];var selectedClass=selectedMainOption===section?'selected':'';var showAlertThink=chats&&chats.invitations&&chats.invitations.length;if(hideMenu){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main_option '+selectedClass,'data-section':section,onClick:_this.handleSelectMainOption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{className:'icon',image:__WEBPACK_IMPORTED_MODULE_17_assets_images_menu_thinkNew_svg___default.a}),showAlertThink?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert_in_menu'}):null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main_option '+selectedClass,'data-section':section,onClick:_this.handleSelectMainOption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{className:'icon',image:__WEBPACK_IMPORTED_MODULE_17_assets_images_menu_thinkNew_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.think),showAlertThink?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert_in_menu'}):null));};_this.printThinkChats=function(){var _this$props13=_this.props,thinkChats=_this$props13.thinkChats,literals=_this$props13.literals;var _this$state7=_this.state,expandedOptions=_this$state7.expandedOptions,search=_this$state7.search,selectedOption=_this$state7.selectedOption,selectedSuboption=_this$state7.selectedSuboption;var option=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["j" ];var selectedClass=selectedOption===option?'selected':'';var expandedClass=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expandedOptions,function(expandedOption){return expandedOption===option;})?'expanded':'';var searchValue=Object(__WEBPACK_IMPORTED_MODULE_16_utils_string__["d" ])(search.toLowerCase());var finalThinkChats=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(thinkChats,function(thinkChat){var name=thinkChat.name;var thinkChatName=Object(__WEBPACK_IMPORTED_MODULE_16_utils_string__["d" ])(name.toLowerCase());return thinkChatName.indexOf(searchValue)!==-1;});if(!finalThinkChats.length){return null;}var thinkChatsOptions=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(finalThinkChats,function(_ref5){var id=_ref5.id,name=_ref5.name;var subselectedClass=selectedSuboption===id?'selected':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'option_submenu '+subselectedClass,key:id,'data-id':id,onClick:_this.handleClickThinkChat},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert_in_menu'}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'option_menu '+expandedClass+' '+selectedClass,onClick:_this.handleOptionClick,'data-option':option},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.thinkChats),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_expand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-right icon_open'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_minimize'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-down icon_close'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu_options '+expandedClass},thinkChatsOptions));};_this.toggleCollapse=function(){var _this$state8=_this.state,hideMenu=_this$state8.hideMenu,expandedOptions=_this$state8.expandedOptions;var option1=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["a" ];var option2=__WEBPACK_IMPORTED_MODULE_37_constants_layout__["g" ];_this.setState({hideMenu:!hideMenu});if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expandedOptions,function(expandedOption){return expandedOption===option1;})){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(expandedOptions,function(expandedOption){return expandedOption===option1;});}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expandedOptions,function(expandedOption){return expandedOption===option2;})){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(expandedOptions,function(expandedOption){return expandedOption===option2;});}_this.setState({expandedOptions:expandedOptions});};_this.printChat=function(){var _this$state9=_this.state,chat=_this$state9.chat,chatId=_this$state9.chatId;if(chat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_ChatRoom__["a" ],{chatId:chatId,onClose:_this.closeChat});}return null;};_this.openChat=function(id){_this.setState({chat:true});_this.setState({chatId:id});};_this.closeChat=function(){var chat=_this.state.chat;_this.setState({chat:!chat});_this.setState({chatId:null});};_this.chatList=function(){var _this$props14=_this.props,chats=_this$props14.chats,app=_this$props14.app,user=_this$props14.user,literals=_this$props14.literals,thinkChats=_this$props14.thinkChats;var _this$state10=_this.state,hideMenu=_this$state10.hideMenu,search=_this$state10.search;var directChats=null;if(chats.chats){var searchValue=search?Object(__WEBPACK_IMPORTED_MODULE_16_utils_string__["d" ])(search.toLowerCase()):false;var filteredChats=chats.chats.filter(function(chat){if(searchValue){var name=Object(__WEBPACK_IMPORTED_MODULE_16_utils_string__["d" ])(chat.element_related.name.toLowerCase());if(name.indexOf(searchValue)===-1){return false;}}if(chat.element_related.type_id!==__WEBPACK_IMPORTED_MODULE_9_constants_chat__["b" ]){return false;}var table=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(thinkChats,{id:chat.element_related.id});if(!table){return false;}if(table.status.id===__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]){return false;}return true;});var today=__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix();filteredChats.sort(function(chat1,chat2){var a=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(thinkChats,{id:chat1.element_related.id});var b=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(thinkChats,{id:chat2.element_related.id});if(!a){return 1;}if(!b){return-1;}if(a.status.id===__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]&&b.status.id!==__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]){return 1;}if(a.status.id!==__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]&&b.status.id===__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]){return-1;}if(a.last_message&&!b.last_message){return-1;}if(!a.last_message&&b.last_message){return 1;}if(a.last_message&&b.last_message){return a.last_message.timestamp>b.last_message.timestamp?-1:1;}if(a.limit_date&&b.limit_date){if(a.limit_date>today&&b.limit_date>today){return a.limit_date<b.limit_date?-1:1;}if(a.limit_date<=today){return 1;}if(b.limit_date<=today){return-1;}}return a.timestamp>b.timestamp?-1:1;});if(hideMenu){directChats=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(filteredChats,function(chat){var table=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(thinkChats,{id:chat.element_related.id});if(!table){return null;}var image=table.image||__WEBPACK_IMPORTED_MODULE_8_assets_images_think_table_jpg___default.a;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'1rem'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Avatar__["a" ],{key:chat.id,size:40,avatar:image,firstname:chat.element_related.name,onClick:_this.goToThemeTable,id:chat.element_related.id}));});}else{directChats=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(filteredChats,function(chat){var table=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(thinkChats,{id:chat.element_related.id});if(!table){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Chats_components_ChatElement__["a" ],{chat:chat,key:chat.id,onClick:_this.goToThemeTable,app:app,user:user,table:table});});}}var numChats=chats.chats&&chats.chats.length?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(chats.chats,function(chat){return chat.element_related.type_id!==__WEBPACK_IMPORTED_MODULE_9_constants_chat__["a" ];}).length:0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat_content'},!hideMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'searcher',placeholder:literals.search,value:search,onChange:_this.handleSearcherInput}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat_list'},directChats&&directChats.length?directChats:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_tables'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_18_assets_images_think_no_think_chats_svg___default.a,alt:''}),hideMenu?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,numChats?literals.noTablesFound:literals.youAreNotInTables))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5vh'}}));};_this.printDesktopLayout=function(){var _this$state11=_this.state,userMenuAnchorEl=_this$state11.userMenuAnchorEl,hideMenu=_this$state11.hideMenu,collapsed=_this$state11.collapsed;var _this$props15=_this.props,app=_this$props15.app,_this$props15$user=_this$props15.user,avatar=_this$props15$user.avatar,firstname=_this$props15$user.name,literals=_this$props15.literals,history=_this$props15.history;var logo=app.logo,name=app.name;var mainColor=_this.getBackgroundColor();var secondaryColor=_this.getSecondaryColor();if(collapsed){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["a" ],{mainColor:mainColor,secondaryColor:secondaryColor,isInNarrative:_this.isInNarrative()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo',onClick:_this.handleClickLogo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logo,alt:name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'c2i_breadcrumb'},_this.printBreadcrumb()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user_layer',onClick:_this.handleUserMenuClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Avatar__["a" ],{avatar:avatar,firstname:firstname,size:38})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'username'},firstname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-chevron-down'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Menu__["a" ],{id:'simple-menu',anchorEl:userMenuAnchorEl,keepMounted:true,open:Boolean(userMenuAnchorEl),onClose:_this.handleUserMenuClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__["a" ],{onClick:_this.handleGoToProfile},literals.myProfile),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__["a" ],{onClick:_this.logout},literals.logout)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',null,!hideMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main_menu'},_this.printDiscover(),_this.printC2I(),_this.printConnections(),_this.printThink(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this.toggleCollapse,className:'collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-arrow-circle-left'}),literals.closeMenu),_this.chatList()),hideMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main_menu mini'},_this.printDiscover(),_this.printC2I(),_this.printConnections(),_this.printThink(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this.toggleCollapse,className:'collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-arrow-circle-left',style:{transform:'rotate(180deg)'}})),_this.chatList()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:!hideMenu?'main_wrapper':'main_wrapper all'},hideMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hide_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:_this.handleHideMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-caret-right'}))),!hideMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hide_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:_this.handleHideMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-caret-left'}))),_this.printContent())),!hideMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat big'},_this.printChat()),hideMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat'},_this.printChat()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_NotificationsModal__["a" ],null));};_this.printMobileLayout=function(){var _this$props16=_this.props,literals=_this$props16.literals,chats=_this$props16.chats,actualContext=_this$props16.actualContext,breadcrumb=_this$props16.breadcrumb,user=_this$props16.user,hasPendingRequests=_this$props16.hasPendingRequests,history=_this$props16.history;var actualUserId=user.id,avatar=user.avatar,firstname=user.name;var _this$state12=_this.state,selectedMainOption=_this$state12.selectedMainOption,progress=_this$state12.progress;var color=_this.getBackgroundColor();var screenHeight=window.innerHeight;var chatsWithNews=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chats.chats,function(chat){if(!chat.last_message){return false;}return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chat.users_read,function(u){return u===actualUserId;});});var showAlertThink=chats&&chats.invitations&&chats.invitations.length||chatsWithNews;var headerBorderWith=actualContext&&typeof actualContext.color!=='undefined'?0:'1px';var secondaryColor=actualContext&&typeof actualContext.color!=='undefined'?color:_this.getSecondaryColor();var backBreadcrumb=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(breadcrumb,function(element){return typeof element.type!=='undefined'&&element.type==='back';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["d" ],{mainColor:color,secondaryColor:secondaryColor,innerHeight:screenHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{style:{borderWidth:headerBorderWith}},backBreadcrumb?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back_arrow',onClick:_this.handleGoBack},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-arrow-left'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Avatar__["a" ],{avatar:avatar,firstname:firstname,size:32,onClick:_this.handleGoToProfile})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'c2i_breadcrumb'},_this.printBreadcrumb())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'main_wrapper'},_this.printContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shadow_left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shadow_right'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom_effect'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'main_menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-section':__WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ],className:'main_option '+(selectedMainOption===__WEBPACK_IMPORTED_MODULE_37_constants_layout__["f" ]?'selected':''),onClick:_this.handleSelectMainOption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{className:'icon',image:__WEBPACK_IMPORTED_MODULE_20_assets_images_menu_initiativeNew_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.initiativesNav)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-section':__WEBPACK_IMPORTED_MODULE_37_constants_layout__["c" ],className:'left main_option '+(selectedMainOption===__WEBPACK_IMPORTED_MODULE_37_constants_layout__["c" ]?'selected':''),onClick:_this.handleSelectMainOption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{className:'icon',image:__WEBPACK_IMPORTED_MODULE_19_assets_images_menu_connect_icon_white_svg___default.a}),hasPendingRequests?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert-mobile'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.connect)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-section':__WEBPACK_IMPORTED_MODULE_37_constants_layout__["d" ],className:'central main_option '+(selectedMainOption===__WEBPACK_IMPORTED_MODULE_37_constants_layout__["d" ]?'selected':''),onClick:_this.handleSelectMainOption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shadow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["e" ],{pro:80*progress/100}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pie_size'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shadow_circle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{className:'iconDiscover',image:__WEBPACK_IMPORTED_MODULE_21_assets_images_menu_discover_button_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-section':__WEBPACK_IMPORTED_MODULE_37_constants_layout__["e" ],className:'right main_option '+(selectedMainOption===__WEBPACK_IMPORTED_MODULE_37_constants_layout__["e" ]?'selected':''),onClick:_this.handleSelectMainOption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{className:'icon',image:__WEBPACK_IMPORTED_MODULE_27_assets_images_menu_finetune_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.fineTune)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-section':__WEBPACK_IMPORTED_MODULE_37_constants_layout__["i" ],className:'main_option '+(selectedMainOption===__WEBPACK_IMPORTED_MODULE_37_constants_layout__["i" ]?'selected':''),onClick:_this.handleSelectMainOption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{className:'icon',image:__WEBPACK_IMPORTED_MODULE_17_assets_images_menu_thinkNew_svg___default.a}),showAlertThink?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert-mobile'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.think)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_NotificationsModal__["a" ],null));};_this.printContent=function(){var _this$props17=_this.props,children=_this$props17.children,narratives=_this$props17.narratives,thinkChats=_this$props17.thinkChats;if(narratives===null||thinkChats===null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_components_LayoutContent__["a" ],null,children);};_this.state={windowWidth:0,userMenuAnchorEl:null,search:'',expandedOptions:[],selectedMainOption:null,selectedOption:null,selectedSuboption:null,hideMenu:false,prevPathName:'',chat:false,chatId:null,// tools: false,
progress:0};return _this;}_createClass(Layout,[{key:'componentDidMount',value:function componentDidMount(){// Load elements
var show=this.props.show;if(show){this.loadInfo();}// Handle resize events
window.addEventListener('resize',this.updateWindowDimensions);this.updateWindowDimensions();this.getActualSection();}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var windowWidth=this.state.windowWidth;var prevWindowWidth=nextState.windowWidth;if(windowWidth!==prevWindowWidth){var isActualDesktop=windowWidth>__WEBPACK_IMPORTED_MODULE_11_constants_breakPoints__["b" ];var isPreviousDesktop=prevWindowWidth>__WEBPACK_IMPORTED_MODULE_11_constants_breakPoints__["b" ];if(isActualDesktop===isPreviousDesktop){// Dont refresh in zoom apps
return false;}}return true;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var prevShow=prevProps.show,prevNarratives=prevProps.narratives,prevThinkChats=prevProps.thinkChats,prevApp=prevProps.app;var _props=this.props,show=_props.show,narratives=_props.narratives,thinkChats=_props.thinkChats,app=_props.app;var prevPathName=this.state.prevPathName;if(thinkChats){if(window.location.pathname!==prevPathName||!prevThinkChats&&thinkChats||prevThinkChats&&prevThinkChats.length!==thinkChats.length){this.getActualSection();}}if(show&&!prevShow){this.loadInfo();}if(app.openChat&&app.openChat!==prevApp.openChat){this.openChat(app.openChat);}var total=0;if(narratives&&prevNarratives!==narratives){narratives.forEach(function(na){total+=na.progress;});total/=narratives.length;this.setState({progress:total});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.updateWindowDimensions);}},{key:'render',value:function render(){var windowWidth=this.state.windowWidth;var _props2=this.props,show=_props2.show,children=_props2.children;if(!show){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,children);}if(windowWidth>__WEBPACK_IMPORTED_MODULE_11_constants_breakPoints__["b" ]){return this.printDesktopLayout();}return this.printMobileLayout();}}]);return Layout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Layout.propTypes={app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,chats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,fetchMainNarratives:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,fetchObjectives:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,fetchTools:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getMyThinkChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getInvitations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,narratives:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,thinkChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,breadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,actualContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,setAutoNavigation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setGoDown:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getElementsSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getMyCallsForImpact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getElementsCreatedByUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getSerendipityPreferences:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,fetchUserConnections:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getSpeedDatingMeetings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getUserRequestedConnections:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getElementTypesShownInUserCard:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getHasPendingRequests:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,hasPendingRequests:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};Layout.defaultProps={narratives:[],thinkChats:[],show:false,breadcrumb:[],actualContext:{}}; __webpack_exports__["a"] = (Layout);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(401);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__utils_debounce__ = __webpack_require__(164);
 var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__ = __webpack_require__(77);
 var __WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__ = __webpack_require__(226);
 var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(227);
 var __WEBPACK_IMPORTED_MODULE_11__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_12__Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_13__Grow__ = __webpack_require__(824);
 var __WEBPACK_IMPORTED_MODULE_14__Paper__ = __webpack_require__(231);















function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  
  root: {},

  
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Popover = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Popover(props, ref) {
  var action = props.action,
      anchorEl = props.anchorEl,
      _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$anchorOrigin,
      anchorPosition = props.anchorPosition,
      _props$anchorReferenc = props.anchorReference,
      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
      children = props.children,
      classes = props.classes,
      className = props.className,
      containerProp = props.container,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
      getContentAnchorEl = props.getContentAnchorEl,
      _props$marginThreshol = props.marginThreshold,
      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$transformOrigi = props.transformOrigin,
      transformOrigin = _props$transformOrigi === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$transformOrigi,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_13__Grow__["a" ] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps,
      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var paperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  var getAnchorOffset = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (contentAnchorOffset) {
    if (anchorReference === 'anchorPosition') {
      if (false) {
        if (!anchorPosition) {
          console.error('Material-UI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }

      return anchorPosition;
    }

    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" ])(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();

    if (false) {
      var box = anchorElement.getBoundingClientRect();

      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }

    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided

  var getContentAnchorOffset = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (element) {
    var contentAnchorOffset = 0;

    if (getContentAnchorEl && anchorReference === 'anchorEl') {
      var contentAnchorEl = getContentAnchorEl(element);

      if (contentAnchorEl && element.contains(contentAnchorEl)) {
        var scrollTop = getScrollParent(element, contentAnchorEl);
        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
      } // != the default value


      if (false) {
        if (anchorOrigin.vertical !== 'top') {
          console.error(['Material-UI: You can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
        }
      }
    }

    return contentAnchorOffset;
  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
  // and taking the content anchor offset into account if in use

  var getTransformOrigin = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (elemRect) {
    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (element) {
    // Check if the parent has requested anchoring on an inner content node
    var contentAnchorOffset = getContentAnchorOffset(element);
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of of the anchoring element


    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning

    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    var containerWindow = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__["a" ])(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;

      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }

    if (false) {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['Material-UI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    } // Check if the horizontal axis needs shifting


    if (left < marginThreshold) {
      var _diff2 = left - marginThreshold;

      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;

      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }

    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
  var setPositioningStyles = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    var element = paperRef.current;

    if (!element) {
      return;
    }

    var positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  var handleEntering = function handleEntering(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  var handlePaperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    paperRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](instance);
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (open) {
      setPositioningStyles();
    }
  });
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](action, function () {
    return open ? {
      updatePosition: function updatePosition() {
        setPositioningStyles();
      }
    } : null;
  }, [open, setPositioningStyles]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!open) {
      return undefined;
    }

    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_6__utils_debounce__["a" ])(function () {
      setPositioningStyles();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [open, setPositioningStyles]);
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  var container = containerProp || (anchorEl ? Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" ])(getAnchorEl(anchorEl)).body : undefined);
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Modal__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    container: container,
    open: open,
    ref: ref,
    BackdropProps: {
      invisible: true
    },
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" ])(classes.root, className)
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    appear: true,
    in: open,
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited,
    onExiting: onExiting,
    timeout: transitionDuration
  }, TransitionProps, {
    onEntering: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" ])(handleEntering, TransitionProps.onEntering)
  }), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Paper__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    elevation: elevation,
    ref: handlePaperRef
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" ])(classes.paper, PaperProps.className)
  }), children)));
});
 false ? Popover.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  action: refType,

  
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), function (props) {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
      }
    }

    return null;
  }),

  
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),

  
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  container: PropTypes
  
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  
  elevation: PropTypes.number,

  
  getContentAnchorEl: PropTypes.func,

  
  marginThreshold: PropTypes.number,

  
  onClose: PropTypes.func,

  
  onEnter: PropTypes.func,

  
  onEntered: PropTypes.func,

  
  onEntering: PropTypes.func,

  
  onExit: PropTypes.func,

  
  onExited: PropTypes.func,

  
  onExiting: PropTypes.func,

  
  open: PropTypes.bool.isRequired,

  
  PaperProps: PropTypes
  
  .shape({
    component: elementTypeAcceptingRef
  }),

  
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  
  TransitionComponent: PropTypes.elementType,

  
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  
  TransitionProps: PropTypes.object
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__styles_withStyles__["a" ])(styles, {
  name: 'MuiPopover'
})(Popover));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_styles__ = __webpack_require__(53);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_7__utils_ownerDocument__ = __webpack_require__(77);
 var __WEBPACK_IMPORTED_MODULE_8__Portal__ = __webpack_require__(819);
 var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(227);
 var __WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__ = __webpack_require__(46);
 var __WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__ = __webpack_require__(166);
 var __WEBPACK_IMPORTED_MODULE_12__styles_zIndex__ = __webpack_require__(399);
 var __WEBPACK_IMPORTED_MODULE_13__ModalManager__ = __webpack_require__(403);
 var __WEBPACK_IMPORTED_MODULE_14__Unstable_TrapFocus__ = __webpack_require__(821);
 var __WEBPACK_IMPORTED_MODULE_15__SimpleBackdrop__ = __webpack_require__(823);

















function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  return __WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"](container);
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


var defaultManager = new __WEBPACK_IMPORTED_MODULE_13__ModalManager__["b" ]();
var styles = function styles(theme) {
  return {
    
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    
    hidden: {
      visibility: 'hidden'
    }
  };
};


var Modal = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Modal(inProps, ref) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["k" ])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["f" ])({
    name: 'MuiModal',
    props: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, inProps),
    theme: theme
  });

  var _props$BackdropCompon = props.BackdropComponent,
      BackdropComponent = _props$BackdropCompon === void 0 ? __WEBPACK_IMPORTED_MODULE_15__SimpleBackdrop__["a" ] : _props$BackdropCompon,
      BackdropProps = props.BackdropProps,
      children = props.children,
      _props$closeAfterTran = props.closeAfterTransition,
      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
      container = props.container,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      _props$disableScrollL = props.disableScrollLock,
      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
      _props$hideBackdrop = props.hideBackdrop,
      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$manager = props.manager,
      manager = _props$manager === void 0 ? defaultManager : _props$manager,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onRendered = props.onRendered,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var modal = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({});
  var mountNodeRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var modalRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" ])(modalRef, ref);
  var hasTransition = getHasTransition(props);

  var getDoc = function getDoc() {
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils_ownerDocument__["a" ])(mountNodeRef.current);
  };

  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  var handleOpen = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" ])(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" ])(function (node) {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (onRendered) {
      onRendered();
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_13__ModalManager__["a" ])(modalRef.current, true);
    }
  });
  var handleClose = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    manager.remove(getModal());
  }, [manager]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleExited = function handleExited() {
    setExited(true);

    if (closeAfterTransition) {
      handleClose();
    }
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  var inlineStyle = styles(theme || {
    zIndex: __WEBPACK_IMPORTED_MODULE_12__styles_zIndex__["a" ]
  });
  var childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = children.props.tabIndex || '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" ])(handleEnter, children.props.onEnter);
    childProps.onExited = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" ])(handleExited, children.props.onExited);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Portal__["a" ], {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal
  }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
  }), hideBackdrop ? null : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](BackdropComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    open: open,
    onClick: handleBackdropClick
  }, BackdropProps)), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Unstable_TrapFocus__["a" ], {
    disableEnforceFocus: disableEnforceFocus,
    disableAutoFocus: disableAutoFocus,
    disableRestoreFocus: disableRestoreFocus,
    getDoc: getDoc,
    isEnabled: isTopModal,
    open: open
  }, __WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](children, childProps))));
});
 false ? Modal.propTypes = {
  
  BackdropComponent: PropTypes.elementType,

  
  BackdropProps: PropTypes.object,

  
  children: elementAcceptingRef.isRequired,

  
  closeAfterTransition: PropTypes.bool,

  
  container: PropTypes
  
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  
  disableAutoFocus: PropTypes.bool,

  
  disableBackdropClick: PropTypes.bool,

  
  disableEnforceFocus: PropTypes.bool,

  
  disableEscapeKeyDown: PropTypes.bool,

  
  disablePortal: PropTypes.bool,

  
  disableRestoreFocus: PropTypes.bool,

  
  disableScrollLock: PropTypes.bool,

  
  hideBackdrop: PropTypes.bool,

  
  keepMounted: PropTypes.bool,

  
  manager: PropTypes.object,

  
  onBackdropClick: PropTypes.func,

  
  onClose: PropTypes.func,

  
  onEscapeKeyDown: PropTypes.func,

  
  onRendered: PropTypes.func,

  
  open: PropTypes.bool.isRequired
} : void 0;
 __webpack_exports__["a"] = (Modal);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Portal__ = __webpack_require__(820);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Portal__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_4__utils_setRef__ = __webpack_require__(165);
 var __WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__ = __webpack_require__(46);







function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](container);
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];


var Portal = __WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__["a" ])( __WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](children) ? children.ref : null, ref);
  useEnhancedEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function () {
    if (mountNode && !disablePortal) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_setRef__["a" ])(ref, mountNode);
      return function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_setRef__["a" ])(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( __WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](children)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? __WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"](children, mountNode) : mountNode;
});
 false ? Portal.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  container: PropTypes
  
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  
  disablePortal: PropTypes.bool,

  
  onRendered: PropTypes.func
} : void 0;

if (false) {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = exactProp(Portal.propTypes);
}

 __webpack_exports__["a"] = (Portal);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Unstable_TrapFocus__ = __webpack_require__(822);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Unstable_TrapFocus__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__ = __webpack_require__(77);
 var __WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__ = __webpack_require__(46);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);









function Unstable_TrapFocus(props) {
  var children = props.children,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      getDoc = props.getDoc,
      isEnabled = props.isEnabled,
      open = props.open;
  var ignoreNextEnforceFocus = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  var sentinelStart = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var sentinelEnd = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var nodeToRestore = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  var rootRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    // #StrictMode ready
    rootRef.current = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__["a" ])(children.ref, handleOwnRef);
  var prevOpenRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    prevOpenRef.current = open;
  }, [open]);

  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
    // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (!open) {
      return;
    }

    var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" ])(rootRef.current); // We might render an empty child.

    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {
          console.error(['Material-UI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }

        rootRef.current.setAttribute('tabIndex', -1);
      }

      rootRef.current.focus();
    }

    var contain = function contain() {
      var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };

    var loopFocus = function loopFocus(event) {
      // 9 = Tab
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      } // Make sure the next tab starts from the right place.


      if (doc.activeElement === rootRef.current) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;

        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };

    doc.addEventListener('focus', contain, true);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    var interval = setInterval(function () {
      contain();
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focus', contain, true);
      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()

      if (!disableRestoreFocus) {
        // In IE 11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE 11 have a focus method.
        // Once IE 11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, {
    ref: handleRef
  }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}

 false ? Unstable_TrapFocus.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  disableAutoFocus: PropTypes.bool,

  
  disableEnforceFocus: PropTypes.bool,

  
  disableRestoreFocus: PropTypes.bool,

  
  getDoc: PropTypes.func.isRequired,

  
  isEnabled: PropTypes.func.isRequired,

  
  open: PropTypes.bool.isRequired
} : void 0;

if (false) {
  // eslint-disable-next-line
  Unstable_TrapFocus['propTypes' + ''] = exactProp(Unstable_TrapFocus.propTypes);
}

 __webpack_exports__["a"] = (Unstable_TrapFocus);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




var styles = {
  
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  
  invisible: {
    backgroundColor: 'transparent'
  }
};


var SimpleBackdrop = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function SimpleBackdrop(props, ref) {
  var _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["invisible", "open"]);

  return open ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    "aria-hidden": true,
    ref: ref
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, styles.root, invisible ? styles.invisible : {}, other.style)
  })) : null;
});
 false ? SimpleBackdrop.propTypes = {
  
  invisible: PropTypes.bool,

  
  open: PropTypes.bool.isRequired
} : void 0;
 __webpack_exports__["a"] = (SimpleBackdrop);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Grow__ = __webpack_require__(825);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grow__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(130);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(167);
 var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(84);
 var __WEBPACK_IMPORTED_MODULE_7__transitions_utils__ = __webpack_require__(230);
 var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(46);










function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};


var Grow = __WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Grow(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5_react_transition_group__["a" ] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var timer = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var autoTimeout = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" ])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var foreignRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" ])(children.ref, ref);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" ])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" ])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["b" ])(node); // So the animation always start from the start.

    var _getTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" ])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" ])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return __WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Grow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.element,

  
  disableStrictModeCompat: PropTypes.bool,

  
  in: PropTypes.bool,

  
  onEnter: PropTypes.func,

  
  onEntered: PropTypes.func,

  
  onEntering: PropTypes.func,

  
  onExit: PropTypes.func,

  
  onExited: PropTypes.func,

  
  onExiting: PropTypes.func,

  
  style: PropTypes.object,

  
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Grow.muiSupportAuto = true;
 __webpack_exports__["a"] = (Grow);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(62);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(73);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__ = __webpack_require__(827);
 var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__ = __webpack_require__(829);
 var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
 var __WEBPACK_IMPORTED_MODULE_7__Transition__ = __webpack_require__(228);
 var __WEBPACK_IMPORTED_MODULE_8__utils_PropTypes__ = __webpack_require__(406);










var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__["a" ])(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__["a" ])(node, c);
  });
};



var CSSTransition = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" ])(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" ])(_this$props, ["classNames"]);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Transition__["d" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, Transition.propTypes, {
  
  classNames: classNamesShape,

  
  onEnter: PropTypes.func,

  
  onEntering: PropTypes.func,

  
  onEntered: PropTypes.func,

  
  onExit: PropTypes.func,

  
  onExiting: PropTypes.func,

  
  onExited: PropTypes.func
}) : {};
 var _unused_webpack_default_export = (CSSTransition);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = addClass;
 var __WEBPACK_IMPORTED_MODULE_0__hasClass__ = __webpack_require__(828);

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!Object(__WEBPACK_IMPORTED_MODULE_0__hasClass__["a" ])(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = removeClass;
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    ;
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(62);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(73);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_5__TransitionGroup__ = __webpack_require__(407);








var ReplaceTransition = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" ])(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" ])(_this$props, ["children", "in"]);

    var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TransitionGroup__["a" ], props, inProp ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ReplaceTransition.propTypes =  false ? {
  in: PropTypes.bool.isRequired,
  children: function children(props, propName) {
    if (React.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
 var _unused_webpack_default_export = (ReplaceTransition);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = getChildMapping;

 __webpack_exports__["b"] = getInitialChildMapping;
 __webpack_exports__["c"] = getNextChildMapping;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);



function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        in: false
      });
    } else if (hasNext && hasPrev && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(73);
 var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3__Transition__ = __webpack_require__(228);
 var __WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__ = __webpack_require__(229);


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(oldChildren) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}



var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" ], null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" ]);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" ], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" ], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true
  })];
}, _enterRenders);


var SwitchTransition = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" ])(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: __WEBPACK_IMPORTED_MODULE_3__Transition__["a" ],
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === __WEBPACK_IMPORTED_MODULE_3__Transition__["b" ] && props.mode === modes.in) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["b" ]
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["c" ]
      };
    }

    return {
      current: __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case __WEBPACK_IMPORTED_MODULE_3__Transition__["b" ]:
        component = enterRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["c" ]:
        component = leaveRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["a" ]:
        component = current;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__["a" ].Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SwitchTransition.propTypes =  false ? {
  
  mode: PropTypes.oneOf([modes.in, modes.out]),

  
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
 var _unused_webpack_default_export = (SwitchTransition);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);







var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
 false ? Paper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  component: PropTypes
  
  .elementType,

  
  elevation: chainPropTypes(PropTypes.number, function (props) {
    var classes = props.classes,
        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning

    if (classes === undefined) {
      return null;
    }

    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
    }

    return null;
  }),

  
  square: PropTypes.bool,

  
  variant: PropTypes.oneOf(['elevation', 'outlined'])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'MuiPaper'
})(Paper));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__MenuList__ = __webpack_require__(835);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuList__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(159);
 var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_6__utils_ownerDocument__ = __webpack_require__(77);
 var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(836);
 var __WEBPACK_IMPORTED_MODULE_8__utils_getScrollbarSize__ = __webpack_require__(404);
 var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(46);











function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  var text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return;
    }
  }
}

var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];


var MenuList = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function MenuList(props, ref) {
  var actions = props.actions,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$autoFocusItem = props.autoFocusItem,
      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
      children = props.children,
      className = props.className,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      onKeyDown = props.onKeyDown,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);

  var listRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var textCriteriaRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect(function () {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](actions, function () {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
        // Let's ignore that piece of logic if users are already overriding the width
        // of the menu.
        var noExplicitWidth = !listRef.current.style.width;

        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_getScrollbarSize__["a" ])(true), "px");
          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }

        return listRef.current;
      }
    };
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    var list = listRef.current;
    var key = event.key;
    

    var currentFocus = Object(__WEBPACK_IMPORTED_MODULE_6__utils_ownerDocument__["a" ])(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    listRef.current = __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" ])(handleOwnRef, ref);
  

  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react__["Children"].forEach(children, function (child, index) {
    if (! __WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, newChildProps);
    }

    return child;
  });
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__List__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other), items);
});
 false ? MenuList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  autoFocus: PropTypes.bool,

  
  autoFocusItem: PropTypes.bool,

  
  children: PropTypes.node,

  
  className: PropTypes.string,

  
  disabledItemsFocusable: PropTypes.bool,

  
  disableListWrap: PropTypes.bool,

  
  onKeyDown: PropTypes.func,

  
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
 __webpack_exports__["a"] = (MenuList);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(837);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__ListContext__ = __webpack_require__(168);







var styles = {
  
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  
  dense: {},

  
  subheader: {
    paddingTop: 0
  }
};
var List = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    return {
      dense: dense
    };
  }, [dense]);
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ListContext__["a" ].Provider, {
    value: context
  }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
 false ? List.propTypes = {
  
  children: PropTypes.node,

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string,

  
  component: PropTypes
  
  .elementType,

  
  dense: PropTypes.bool,

  
  disablePadding: PropTypes.bool,

  
  subheader: PropTypes.node
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiList'
})(List));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(63);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_7__ListItem__ = __webpack_require__(409);








var styles = function styles(theme) {
  return {
    
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" ])({}, theme.typography.body1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" ])({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    
    gutters: {},

    
    selected: {},

    
    dense: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" ])({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = __WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ListItem__["a" ], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" ])({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" ])({
      dense: classes.dense
    }, ListItemClasses),
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? MenuItem.propTypes = {
  
  children: PropTypes.node,

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string,

  
  component: PropTypes
  
  .elementType,

  
  dense: PropTypes.bool,

  
  disabled: PropTypes.bool,

  
  disableGutters: PropTypes.bool,

  
  ListItemClasses: PropTypes.object,

  
  role: PropTypes.string,

  
  selected: PropTypes.bool,

  
  tabIndex: PropTypes.number
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'MuiMenuItem'
})(MenuItem));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(232);
 var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(233);
 var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(46);
 var __WEBPACK_IMPORTED_MODULE_10__List_ListContext__ = __webpack_require__(168);
 var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);












var styles = function styles(theme) {
  return {
    
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    
    container: {
      position: 'relative'
    },

    
    focusVisible: {},

    
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    
    disabled: {},

    
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];


var ListItem = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" ]);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {
        console.error('Material-UI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var children = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(childrenProp);
  var hasSecondaryAction = children.length && Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" ])(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    listItemRef.current = __WEBPACK_IMPORTED_MODULE_11_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" ])(handleOwnRef, ref);

  var componentProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.focusVisible, focusVisibleClassName);
    Component = __WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" ];
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" ].Provider, {
      value: childContext
    }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ContainerComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, componentProps, children), children.pop()));
  }

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" ].Provider, {
    value: childContext
  }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    ref: handleRef
  }, componentProps), children));
});
 false ? ListItem.propTypes = {
  
  alignItems: PropTypes.oneOf(['flex-start', 'center']),

  
  autoFocus: PropTypes.bool,

  
  button: PropTypes.bool,

  
  children: chainPropTypes(PropTypes.node, function (props) {
    var children = React.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)

    var secondaryActionIndex = -1;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];

      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('Material-UI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }

    return null;
  }),

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string,

  
  component: PropTypes
  
  .elementType,

  
  ContainerComponent: PropTypes.elementType,

  
  ContainerProps: PropTypes.object,

  
  dense: PropTypes.bool,

  
  disabled: PropTypes.bool,

  
  disableGutters: PropTypes.bool,

  
  divider: PropTypes.bool,

  
  focusVisibleClassName: PropTypes.string,

  
  selected: PropTypes.bool
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'MuiListItem'
})(ListItem));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__ = __webpack_require__(46);
 var __WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__ = __webpack_require__(166);
 var __WEBPACK_IMPORTED_MODULE_9__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_10__utils_useIsFocusVisible__ = __webpack_require__(410);
 var __WEBPACK_IMPORTED_MODULE_11__TouchRipple__ = __webpack_require__(841);












var styles = {
  
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  
  disabled: {},

  
  focusVisible: {}
};


var ButtonBase = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  function getButtonNode() {
    // #StrictMode ready
    return __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](buttonRef.current);
  }

  var rippleRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useIsFocusVisible__["a" ])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" ])(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" ])(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  


  var keydownRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](false);
  var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" ])(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" ])(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" ])(buttonRefProp, ref);
  var handleOwnRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" ])(focusVisibleRef, buttonRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" ])(handleUserRef, handleOwnRef);

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ComponentProp, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  

  
  __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__TouchRipple__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
 false ? ButtonBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  action: refType,

  
  buttonRef: refType,

  
  centerRipple: PropTypes.bool,

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  component: elementTypeAcceptingRef,

  
  disabled: PropTypes.bool,

  
  disableRipple: PropTypes.bool,

  
  disableTouchRipple: PropTypes.bool,

  
  focusRipple: PropTypes.bool,

  
  focusVisibleClassName: PropTypes.string,

  
  href: PropTypes.string,

  
  onBlur: PropTypes.func,

  
  onClick: PropTypes.func,

  
  onDragLeave: PropTypes.func,

  
  onFocus: PropTypes.func,

  
  onFocusVisible: PropTypes.func,

  
  onKeyDown: PropTypes.func,

  
  onKeyUp: PropTypes.func,

  
  onMouseDown: PropTypes.func,

  
  onMouseLeave: PropTypes.func,

  
  onMouseUp: PropTypes.func,

  
  onTouchEnd: PropTypes.func,

  
  onTouchMove: PropTypes.func,

  
  onTouchStart: PropTypes.func,

  
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  TouchRippleProps: PropTypes.object,

  
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__styles_withStyles__["a" ])(styles, {
  name: 'MuiButtonBase'
})(ButtonBase));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(127);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(167);
 var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_8__Ripple__ = __webpack_require__(842);









var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles = function styles(theme) {
  return {
    
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};


var TouchRipple = __WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["center", "classes", "className"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](0);
  var rippleCallback = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var container = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" ])(oldRipples), [__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Ripple__["a" ], {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" ])(classes.root, className),
    ref: container
  }, other), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_transition_group__["b" ], {
    component: null,
    exit: true
  }, ripples));
});
 false ? TouchRipple.propTypes = {
  
  center: PropTypes.bool,

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" ])(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})( __WEBPACK_IMPORTED_MODULE_3_react__["memo"](TouchRipple)));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_3__utils_useEventCallback__ = __webpack_require__(166);




var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"];


function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" ])(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" ])(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = Object(__WEBPACK_IMPORTED_MODULE_3__utils_useEventCallback__["a" ])(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: rippleClassName,
    style: rippleStyles
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: childClassName
  }));
}

 false ? Ripple.propTypes = {
  
  classes: PropTypes.object.isRequired,

  
  in: PropTypes.bool,

  
  onExited: PropTypes.func,

  
  pulsate: PropTypes.bool,

  
  rippleSize: PropTypes.number,

  
  rippleX: PropTypes.number,

  
  rippleY: PropTypes.number,

  
  timeout: PropTypes.number.isRequired
} : void 0;
 __webpack_exports__["a"] = (Ripple);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DraggableCore", {
  enumerable: true,
  get: function get() {
    return _DraggableCore.default;
  }
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(25));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _domFns = __webpack_require__(234);

var _positionFns = __webpack_require__(411);

var _shims = __webpack_require__(170);

var _DraggableCore = _interopRequireDefault(__webpack_require__(845));

var _log = _interopRequireDefault(__webpack_require__(412));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
// Define <Draggable>
//
var Draggable = function (_React$Component) {
  _inherits(Draggable, _React$Component);

  var _super = _createSuper(Draggable);

  function Draggable(props
  
  ) {
    var _this;

    _classCallCheck(this, Draggable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
      (0, _log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.

      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.


      if (shouldStart === false) return false;

      _this.setState({
        dragging: true,
        dragged: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log.default)('Draggable: onDrag: %j', coreData);
      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
      var newState
      
      = {
        x: uiData.x,
        y: uiData.y
      }; // Keep within bounds.

      if (_this.props.bounds) {
        // Save original x and y.
        var x = newState.x,
            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.

        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
            newStateX = _getBoundPosition2[0],
            newStateY = _getBoundPosition2[1];

        newState.x = newStateX;
        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.

        newState.slackX = _this.state.slackX + (x - newState.x);
        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.

        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      } // Short-circuit if user's callback killed it.


      var shouldUpdate = _this.props.onDrag(e, uiData);

      if (shouldUpdate === false) return false;

      _this.setState(newState);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.

      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));

      if (shouldContinue === false) return false;
      (0, _log.default)('Draggable: onDragStop: %j', coreData);
      var newState
      
      = {
        dragging: false,
        slackX: 0,
        slackY: 0
      }; // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.

      var controlled = Boolean(_this.props.position);

      if (controlled) {
        var _this$props$position = _this.props.position,
            x = _this$props$position.x,
            y = _this$props$position.y;
        newState.x = x;
        newState.y = y;
      }

      _this.setState(newState);
    });

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,
      // Whether or not we have been dragged before.
      dragged: false,
      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,
      prevPropsPosition: _objectSpread({}, props.position),
      // Used for compensating for out-of-bounds drags
      slackX: 0,
      slackY: 0,
      // Can only determine if SVG after mounting
      isElementSVG: false
    };

    if (props.position && !(props.onDrag || props.onStop)) {
      // eslint-disable-next-line no-console
      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
    }

    return _this;
  }

  _createClass(Draggable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
        this.setState({
          isElementSVG: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        dragging: false
      }); // prevents invariant if unmounted while dragging
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    
    {
      return this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    
    {
      var _classNames;

      var _this$props = this.props,
          axis = _this$props.axis,
          bounds = _this$props.bounds,
          children = _this$props.children,
          defaultPosition = _this$props.defaultPosition,
          defaultClassName = _this$props.defaultClassName,
          defaultClassNameDragging = _this$props.defaultClassNameDragging,
          defaultClassNameDragged = _this$props.defaultClassNameDragged,
          position = _this$props.position,
          positionOffset = _this$props.positionOffset,
          scale = _this$props.scale,
          draggableCoreProps = _objectWithoutProperties(_this$props, ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"]);

      var style = {};
      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.

      var controlled = Boolean(position);
      var draggable = !controlled || this.state.dragging;
      var validPosition = position || defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
      }; // If this element was SVG, we use the `transform` attribute.

      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset, scale);
      } // Mark with class while dragging


      var className = (0, _classnames.default)(children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames)); // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)

      return React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), React.cloneElement(React.Children.only(children), {
        className: className,
        style: _objectSpread(_objectSpread({}, children.props.style), style),
        transform: svgTransform
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: // React 16.3+
    // Arity (props, state)
    function getDerivedStateFromProps(_ref, _ref2) {
      var position = _ref.position;
      var prevPropsPosition = _ref2.prevPropsPosition;

      // Set x/y if a new position is provided in props that is different than the previous.
      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
        (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
          position: position,
          prevPropsPosition: prevPropsPosition
        });
        return {
          x: position.x,
          y: position.y,
          prevPropsPosition: _objectSpread({}, position)
        };
      }

      return null;
    }
  }]);

  return Draggable;
}(React.Component);

exports.default = Draggable;

_defineProperty(Draggable, "displayName", 'Draggable');

_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore.default.propTypes), {}, {
  
  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),

  
  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
    left: _propTypes.default.number,
    right: _propTypes.default.number,
    top: _propTypes.default.number,
    bottom: _propTypes.default.number
  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
  defaultClassName: _propTypes.default.string,
  defaultClassNameDragging: _propTypes.default.string,
  defaultClassNameDragged: _propTypes.default.string,

  
  defaultPosition: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),
  positionOffset: _propTypes.default.shape({
    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  }),

  
  position: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),

  
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
}));

_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore.default.defaultProps), {}, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: {
    x: 0,
    y: 0
  },
  position: null,
  scale: 1
}));

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrefix = getPrefix;
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
exports.default = void 0;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];

function getPrefix()

{
  var prop
  
  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
  // Checking specifically for 'window.document' is for pseudo-browser server-side
  // environments that define 'window' as the global context.
  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';
  var style = window.document.documentElement.style;
  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop

, prefix

)

{
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}

function browserPrefixToStyle(prop

, prefix

)

{
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}

function kebabToTitleCase(str

)

{
  var out = '';
  var shouldCapitalize = true;

  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }

  return out;
} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`


var _default = getPrefix();

exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(25));

var _domFns = __webpack_require__(234);

var _positionFns = __webpack_require__(411);

var _shims = __webpack_require__(170);

var _log = _interopRequireDefault(__webpack_require__(412));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Simple abstraction for dragging events names.
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
}; // Default to mouse events.

var dragEventFor = eventsFor.mouse;












//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
var DraggableCore = function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  var _super = _createSuper(DraggableCore);

  function DraggableCore() {
    var _this;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    });

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e); // Only accept left-clicks.


      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)

      var thisNode = _this.findDOMNode();

      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }

      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      } // Prevent scrolling on mobile devices, like ipad/iphone.
      // Important that this is after handle/cancel.


      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.

      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);

      _this.setState({
        touchIdentifier: touchIdentifier
      }); // Get the current drag point from the event. This is used as the offset.


      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return; // not possible but satisfies flow

      var x = position.x,
          y = position.y; // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.

      (0, _log.default)('calling', _this.props.onStart);

      var shouldUpdate = _this.props.onStart(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.

      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.

      _this.setState({
        dragging: true,
        lastX: x,
        lastY: y
      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.


      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y; // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX,
            deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        deltaX = _snapToGrid2[0];
        deltaY = _snapToGrid2[1];
        if (!deltaX && !deltaY) return; // skip useless drag

        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.

      var shouldUpdate = _this.props.onDrag(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = ((document.createEvent('MouseEvents')
          
          )
          
          ); // I see why this insanity was deprecated
          // $FlowIgnore

          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

          _this.handleDragStop(event);
        }

        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
      if (!_this.state.dragging) return;
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y;
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler

      var shouldContinue = _this.props.onStop(e, coreEvent);

      if (shouldContinue === false || _this.mounted === false) return false;

      var thisNode = _this.findDOMNode();

      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.

      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      if (thisNode) {
        // Remove event handlers
        (0, _log.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStop(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStop(e);
    });

    return _this;
  }

  _createClass(DraggableCore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention

      var thisNode = this.findDOMNode();

      if (thisNode) {
        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.

      var thisNode = this.findDOMNode();

      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    
    {
      return this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render() {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return React.cloneElement(React.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See 
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(React.Component);

exports.default = DraggableCore;

_defineProperty(DraggableCore, "displayName", 'DraggableCore');

_defineProperty(DraggableCore, "propTypes", {
  
  allowAnyClick: _propTypes.default.bool,

  
  disabled: _propTypes.default.bool,

  
  enableUserSelectHack: _propTypes.default.bool,

  
  offsetParent: function offsetParent(props
  
  , propName
  
  ) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  
  grid: _propTypes.default.arrayOf(_propTypes.default.number),

  
  handle: _propTypes.default.string,

  
  cancel: _propTypes.default.string,

  
  nodeRef: _propTypes.default.object,

  
  onStart: _propTypes.default.func,

  
  onDrag: _propTypes.default.func,

  
  onStop: _propTypes.default.func,

  
  onMouseDown: _propTypes.default.func,

  
  scale: _propTypes.default.number,

  
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});

_defineProperty(DraggableCore, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  cancel: null,
  disabled: false,
  enableUserSelectHack: true,
  offsetParent: null,
  handle: null,
  grid: null,
  transform: null,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {},
  scale: 1
});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(847);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_4_routes_MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_5_components_ModalInformation_modules_actions__ = __webpack_require__(368);
 var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(848);
 var __WEBPACK_IMPORTED_MODULE_7__modules_actions__ = __webpack_require__(950);
var mapStateToProps=function mapStateToProps(state){return{literals:state.i18n.literals.notificationsModal,data:state.notificationsModal.data,visible:state.notificationsModal.visible};};function mapDispatchToProps(dispatch){return{hideNotificationModal:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7__modules_actions__["a" ],dispatch),getNarrative:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__["a" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__["f" ],dispatch),setAutoNavigation:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_routes_MainPage_modules_mainPage__["b" ],dispatch),hideModal:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_components_ModalInformation_modules_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_3_components_NotificationsTypes_CallForImpact__ = __webpack_require__(849);
 var __WEBPACK_IMPORTED_MODULE_4_components_NotificationsTypes_StartSpeedDating__ = __webpack_require__(853);
 var __WEBPACK_IMPORTED_MODULE_5_components_NotificationsTypes_FinishSpeedDating__ = __webpack_require__(875);
 var __WEBPACK_IMPORTED_MODULE_6_components_NotificationsTypes_NewUserConnection__ = __webpack_require__(880);
 var __WEBPACK_IMPORTED_MODULE_7_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(949);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationsModal=function(_Component){_inherits(NotificationsModal,_Component);function NotificationsModal(props){_classCallCheck(this,NotificationsModal);var _this=_possibleConstructorReturn(this,(NotificationsModal.__proto__||Object.getPrototypeOf(NotificationsModal)).call(this,props));_this.handleClose=function(){var _this$props=_this.props,hideNotificationModal=_this$props.hideNotificationModal,hideModal=_this$props.hideModal;hideNotificationModal();hideModal();};_this.handleShowProfile=function(id){_this.setState({showProfile:id});};_this.handleCloseProfile=function(){_this.setState({showProfile:null});};_this.printStartSpeedDating=function(){var _this$props$data=_this.props.data,userId=_this$props$data.user,meetingId=_this$props$data.meeting_id;// If we are already in that meeting screen we don't should to show the modal
var actualPath=window.location.pathname;if(actualPath==='/zoom-meeting/'+meetingId){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_NotificationsTypes_StartSpeedDating__["a" ],{userId:parseInt(userId,10),meetingId:meetingId,onClose:_this.handleClose});};_this.printFinishSpeedDating=function(){var _this$props$data2=_this.props.data,users=_this$props$data2.users,startDate=_this$props$data2.start_date;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_NotificationsTypes_FinishSpeedDating__["a" ],{users:users,startDate:startDate,onClose:_this.handleClose,onShowProfile:_this.handleShowProfile});};_this.printCallForImpactNotification=function(){var data=_this.props.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_NotificationsTypes_CallForImpact__["a" ],{data:JSON.parse(data.narrative),onClose:_this.handleClose});};_this.printNewUserConnection=function(){var data=_this.props.data;var user=JSON.parse(data.user);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_NotificationsTypes_NewUserConnection__["a" ],{user:user,onClose:_this.handleClose});};_this.printContent=function(){var type=_this.props.data.type;var content=null;switch(type){case'call4impact':content=_this.printCallForImpactNotification();break;case'start_speed_dating':content=_this.printStartSpeedDating();break;case'finish_speed_dating':content=_this.printFinishSpeedDating();break;case'new_user_connection':content=_this.printNewUserConnection();break;default:break;}if(!content){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Modal__["a" ],{open:true,onClose:_this.handleClose,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',style:{zIndex:1110000},className:type+'_modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close_icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],{className:'fa fa-times',onClick:_this.handleClose})),content));};_this.state={showProfile:null};return _this;}_createClass(NotificationsModal,[{key:'render',value:function render(){var visible=this.props.visible;var showProfile=this.state.showProfile;if(!visible){return null;}if(showProfile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_UsersModal__["a" ],{usersIds:[showProfile],userSelected:showProfile,onEnd:this.handleCloseProfile,zIndex:1110000});}return this.printContent();}}]);return NotificationsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NotificationsModal.propTypes={hideNotificationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,visible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};NotificationsModal.defaultProps={data:null}; __webpack_exports__["a"] = (NotificationsModal);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(850);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(851);
var mapStateToProps=function mapStateToProps(state){return{literals:state.i18n.literals.notificationsModal};};function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components__["a" ]));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(852);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CallFromImpactNotification=function(_Component){_inherits(CallFromImpactNotification,_Component);function CallFromImpactNotification(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CallFromImpactNotification);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CallFromImpactNotification.__proto__||Object.getPrototypeOf(CallFromImpactNotification)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose){onClose();}},_this.handleClickCall4Impact=function(){var data=_this.props.data;_this.handleClose();var id=data.id;__WEBPACK_IMPORTED_MODULE_2_store_history__["a" ].push('/call-for-impact/'+id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CallFromImpactNotification,[{key:'render',value:function render(){var _props=this.props,data=_props.data,literals=_props.literals;var phase=data.phase,name=data.name,image=data.image;var phrase='';var callForAction='';switch(phase){case 21275547:// Pre event
phrase=literals.joinThePreEvent;callForAction=literals.go;break;case 21275548:// Intro meeting
phrase=literals.joinTheIntroMeeting;callForAction=literals.join;break;case 21275549:// Think chat meeting
phrase=literals.chooseYourGroups;callForAction=literals.go;break;case 21275550:// Conclusions meeting
phrase=literals.joinTheConclusionsMeeting;callForAction=literals.join;break;case 21275551:// Speed dating
phrase=literals.joinTheSpeedDating;callForAction=literals.join;break;case 21275552:// POST event
phrase=literals.joinThePostEvent;callForAction=literals.go;break;default:return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{image:image},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_call'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phrase'},phrase),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:this.handleClickCall4Impact},callForAction));}}]);return CallFromImpactNotification;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CallFromImpactNotification.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (CallFromImpactNotification);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return Call4ImpactModal; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  text-align: center;\n\n  .title_call {\n    font-size: 18px;\n    color: #444;\n    font-weight: 600;\n  }\n\n  .image {\n    width: 100px;\n    height: 100px;\n    background-image: url(',');\n    background-size: cover;\n    border-radius: 50%;\n    margin: 10px auto;\n  }\n\n  .phrase {\n    font-size: 14px;\n    color: #666;\n    font-weight: 600;\n    margin-bottom: 10px;\n  }\n\n  button {\n    min-width: 100px;\n  }\n'],['\n  text-align: center;\n\n  .title_call {\n    font-size: 18px;\n    color: #444;\n    font-weight: 600;\n  }\n\n  .image {\n    width: 100px;\n    height: 100px;\n    background-image: url(',');\n    background-size: cover;\n    border-radius: 50%;\n    margin: 10px auto;\n  }\n\n  .phrase {\n    font-size: 14px;\n    color: #666;\n    font-weight: 600;\n    margin-bottom: 10px;\n  }\n\n  button {\n    min-width: 100px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Call4ImpactModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.image;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(854);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(855);
var mapStateToProps=function mapStateToProps(state){return{literals:state.i18n.literals.notificationsModal,actualUser:state.session.user,app:state.app};};function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_UserCard__ = __webpack_require__(235);
 var __WEBPACK_IMPORTED_MODULE_3_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_4_react_ga__ = __webpack_require__(106);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(874);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StartSpeedDating=function(_Component){_inherits(StartSpeedDating,_Component);function StartSpeedDating(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StartSpeedDating);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StartSpeedDating.__proto__||Object.getPrototypeOf(StartSpeedDating)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(){var _this$props=_this.props,userId=_this$props.userId,meetingId=_this$props.meetingId,onClose=_this$props.onClose;__WEBPACK_IMPORTED_MODULE_4_react_ga__["a" ].event({category:'Go speed dating',action:'user_'+userId,label:'Feedback Step'});__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push('/zoom-meeting/'+meetingId);if(onClose){onClose();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StartSpeedDating,[{key:'render',value:function render(){var _props=this.props,literals=_props.literals,app=_props.app,userId=_props.userId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" ],{color:app.color1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_start'},literals.startSDTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_UserCard__["a" ],{userId:userId})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phrase'},literals.startSDPhrase),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:this.handleClick},literals.goToMeeting)));}}]);return StartSpeedDating;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StartSpeedDating.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,meetingId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,userId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};StartSpeedDating.defaultProps={onClose:null}; __webpack_exports__["a"] = (StartSpeedDating);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(857);
function mapStateToProps(state){return{literals:state.i18n.literals.userCard,userElements:state.elements.selectedElements,userThemeTables:state.thinkChats.myThinkChatsList.concat(state.thinkTanks.myThinkTanksList),userCallsForImpact:state.narratives.myCallsForImpact,elementTypesShownInUserCard:state.elements.elementTypesShownInUserCard,app:state.app,actualUser:state.session.user};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_components_FeedbackModal__ = __webpack_require__(78);
 var __WEBPACK_IMPORTED_MODULE_4_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_5_modules_users_actions__ = __webpack_require__(85);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_user_compare_no_results_svg__ = __webpack_require__(867);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_user_compare_no_results_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_images_user_compare_no_results_svg__);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_user_no_user_info_svg__ = __webpack_require__(868);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_user_no_user_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_images_user_no_user_info_svg__);
 var __WEBPACK_IMPORTED_MODULE_8_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_user_calls_svg__ = __webpack_require__(869);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_user_calls_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_images_user_calls_svg__);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_user_tables_svg__ = __webpack_require__(870);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_user_tables_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_assets_images_user_tables_svg__);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_user_onboarding_svg__ = __webpack_require__(871);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_user_onboarding_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_images_user_onboarding_svg__);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_user_profile_svg__ = __webpack_require__(872);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_user_profile_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_images_user_profile_svg__);
 var __WEBPACK_IMPORTED_MODULE_13__styles__ = __webpack_require__(873);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var TAB_RESUME='resume';var TAB_DATA='resdataume';var TAB_COMPARE='compare';function UserCard(props){var userId=props.userId,literals=props.literals,userElements=props.userElements,userThemeTables=props.userThemeTables,userCallsForImpact=props.userCallsForImpact,actualUser=props.actualUser,elementTypesShownInUserCard=props.elementTypesShownInUserCard;// Errors
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),errors=_useState2[0],setErrors=_useState2[1];var removeErrors=function removeErrors(){setErrors([]);};var printErrors=function printErrors(){if(!errors.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_FeedbackModal__["a" ],{onClose:removeErrors,open:true,success:false,text:errors.join('<br />')});};// User info
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),data=_useState4[0],setData=_useState4[1];var loadUserInfo=function loadUserInfo(){Object(__WEBPACK_IMPORTED_MODULE_5_modules_users_actions__["c" ])(userId).then(function(response){setData(response);}).catch(function(error){errors.push(error.response.data.error);setErrors([].concat(_toConsumableArray(errors)));});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(loadUserInfo,[userId]);// Handle Tabs
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(TAB_RESUME),_useState6=_slicedToArray(_useState5,2),selectedTab=_useState6[0],setSelectedTab=_useState6[1];var selectTab=function selectTab(event){var section=event.currentTarget.getAttribute('data-section');setSelectedTab(section);};// Handle Info
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(window.outerWidth<__WEBPACK_IMPORTED_MODULE_8_constants_breakPoints__["b" ]),_useState8=_slicedToArray(_useState7,2),collapsed=_useState8[0],setCollapsed=_useState8[1];var collapseInfo=function collapseInfo(){setCollapsed(!collapsed);};var whichHeader=function whichHeader(){var overview=data.overview;if(collapsed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overview_empty',onClick:collapseInfo},literals.viewPurpose);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overview'},overview,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-minus-circle close',onClick:collapseInfo}));};// Render content functions
var printHeader=function printHeader(){var id=data.id,firstname=data.firstname,lastname=data.lastname,avatar=data.avatar,overview=data.overview;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Avatar__["a" ],{id:id,firstname:firstname,avatar:avatar,size:84})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'username'},firstname+' '+lastname),overview?whichHeader():null));};// Resume Tab
var printResumeTab=function printResumeTab(){var isActualUser=userId===actualUser.id;var sharedElements=[];var rows=[];elementTypesShownInUserCard.forEach(function(elementType){var elementsByType=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(data.elements,{type:elementType.tag});if(elementsByType.length){if(!isActualUser){var sharedByType=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.intersectionBy(elementsByType,userElements,'id');if(sharedByType.length){sharedElements=sharedElements.concat(sharedByType);}}rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:elementType.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},elementType.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection_content'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(elementsByType,function(_ref){var id=_ref.id,name=_ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(userElements,{id:id})?'selected':'')},name);}))));}});if(!rows.length&&!sharedElements.length&&!data.calls_for_impact.length&&!data.theme_tables.length.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements gray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_7_assets_images_user_no_user_info_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noUserData));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,rows,data.calls_for_impact.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_assets_images_user_calls_svg___default.a,alt:'call'}),literals.call),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection_content'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.calls_for_impact,function(_ref2){var id=_ref2.id,name=_ref2.name,image=_ref2.image;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(userCallsForImpact,{id:id})?'selected':'')},image?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image',style:{backgroundImage:'url('+image+')'}}):null,name);}))):null,data.theme_tables.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10_assets_images_user_tables_svg___default.a,alt:'call'}),literals.tables),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection_content'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.theme_tables,function(_ref3){var id=_ref3.id,name=_ref3.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(userThemeTables,{id:id})?'selected':'')},name);}))):null,sharedElements.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},literals.sharedElements),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection_content'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(sharedElements,function(_ref4){var id=_ref4.id,name=_ref4.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray selected'},name);}))):null);};// Data Tab
var printDataTab=function printDataTab(){var narrativesFiltered=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(data.answers,function(_ref5){var id=_ref5.id,name=_ref5.name,color=_ref5.color,questions=_ref5.questions;var narrativeQuestions=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(questions,function(question){return question.title&&question.answers.length;});if(narrativeQuestions.length){var narrative={id:id,name:name,color:color,questions:narrativeQuestions};narrativesFiltered.push(narrative);}});if(!narrativesFiltered.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements gray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_7_assets_images_user_no_user_info_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noUserAnswers));}function imgSwitch(name){switch(name){case'Onboarding':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_assets_images_user_onboarding_svg___default.a,alt:''});case'Basic Profile':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12_assets_images_user_profile_svg___default.a,alt:''});default:return null;}}var narrativesLayers=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(narrativesFiltered,function(_ref6){var id=_ref6.id,name=_ref6.name,color=_ref6.color,questions=_ref6.questions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator answer',style:{background:color}},imgSwitch(name),name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(questions,function(_ref7){var questionId=_ref7.id,title=_ref7.title,answers=_ref7.answers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:questionId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title',dangerouslySetInnerHTML:{__html:title}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection_content'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(answers,function(answer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag gray selected',key:answer.id},answer.name);})));}))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,narrativesLayers);};// Compare Tab
var printCompareTab=function printCompareTab(){var sharedElements=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(data.elements,function(_ref8){var id=_ref8.id,type=_ref8.type;return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(elementTypesShownInUserCard,{tag:type})&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(userElements,{id:id});});var callsForImpact=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(data.calls_for_impact,function(_ref9){var id=_ref9.id;return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(userCallsForImpact,{id:id});});var themeTables=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(data.theme_tables,function(_ref10){var id=_ref10.id;return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(userThemeTables,{id:id});});if(!sharedElements.length&&!callsForImpact.length&&!themeTables.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements gray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_6_assets_images_user_compare_no_results_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.youHaveNoCommonElemments));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resume_tab'},callsForImpact.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_assets_images_user_calls_svg___default.a,alt:'call'}),literals.call),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container_tags'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description_tag'},literals.callCompare),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(callsForImpact,function(_ref11){var id=_ref11.id,name=_ref11.name,image=_ref11.image;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray selected'},image?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image',style:{backgroundImage:'url('+image+')'}}):null,name);}))):null,themeTables.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},literals.tables),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container_tags'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description_tag'},literals.tablesCompare),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(themeTables,function(_ref12){var id=_ref12.id,name=_ref12.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray selected'},name);}))):null,sharedElements.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},literals.sharedElements),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container_tags'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description_tag'},literals.sharesInterestsCompare),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(sharedElements,function(_ref13){var id=_ref13.id,name=_ref13.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray selected'},name);}))):null);};var printSelectedTab=function printSelectedTab(){if(!data){return null;}switch(selectedTab){case TAB_DATA:return printDataTab();case TAB_COMPARE:return printCompareTab();default:return printResumeTab();}};var printTabs=function printTabs(){var isActualUser=userId===actualUser.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs gray flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab===TAB_RESUME?'selected':''),'data-section':TAB_RESUME,onClick:selectTab},literals.resume),!isActualUser?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab===TAB_COMPARE?'selected':''),'data-section':TAB_COMPARE,onClick:selectTab},literals.compare):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab_content'},printSelectedTab()));};var printContent=function printContent(){if(!data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading'},literals.loadingUserInfo);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,printHeader(),printTabs());};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles__["a" ],{className:'user_card'},printErrors(),printContent());}UserCard.propTypes={userId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,userCallsForImpact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,userElements:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,userThemeTables:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,actualUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,elementTypesShownInUserCard:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired}; __webpack_exports__["a"] = (UserCard);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(859);
function mapStateToProps(state){return{literals:state.i18n.literals.feedbackModal};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(860);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeedbackModal=function(_Component){_inherits(FeedbackModal,_Component);function FeedbackModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FeedbackModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FeedbackModal.__proto__||Object.getPrototypeOf(FeedbackModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){var onClose=_this.props.onClose;onClose();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FeedbackModal,[{key:'render',value:function render(){var _props=this.props,open=_props.open,success=_props.success,text=_props.text,literals=_props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" ],{open:open,onClose:this.handleClose,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal feedback_modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback_icon '+(success?'success':'error')},success?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-check-circle'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback_message',dangerouslySetInnerHTML:{__html:text}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:this.handleClose},literals.close)))));}}]);return FeedbackModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FeedbackModal.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (FeedbackModal);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackModalWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Modal__ = __webpack_require__(37);
var _templateObject=_taggedTemplateLiteral(['\n  .feedback_modal {\n    text-align: center;\n    padding: 20px;\n    overflow: hidden;\n    \n    .feedback_icon {\n      &.success {\n        color: #8BC34A;\n      }\n\n      &.error {\n        color: #F44336;\n      }\n\n       i {\n        font-size: 60px;\n        margin-bottom: 20px;\n      }\n    }\n\n    .feedback_message {\n      color: #666;\n      font-size: 18px;\n      line-height: 30px;\n      font-weight: 600;\n    }\n  }\n'],['\n  .feedback_modal {\n    text-align: center;\n    padding: 20px;\n    overflow: hidden;\n    \n    .feedback_icon {\n      &.success {\n        color: #8BC34A;\n      }\n\n      &.error {\n        color: #F44336;\n      }\n\n       i {\n        font-size: 60px;\n        margin-bottom: 20px;\n      }\n    }\n\n    .feedback_message {\n      color: #666;\n      font-size: 18px;\n      line-height: 30px;\n      font-weight: 600;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FeedbackModalWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Modal__["a" ])(_templateObject);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_assets_images_ChampionUser_svg__ = __webpack_require__(413);
 var __WEBPACK_IMPORTED_MODULE_2_assets_images_ChampionUser_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_images_ChampionUser_svg__);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(862);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AvatarUser=function(_Component){_inherits(AvatarUser,_Component);function AvatarUser(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AvatarUser);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AvatarUser.__proto__||Object.getPrototypeOf(AvatarUser)).call.apply(_ref,[this].concat(args))),_this),_this.handleAvatarClick=function(){var _this$props=_this.props,id=_this$props.id,onClick=_this$props.onClick;if(onClick){onClick(id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AvatarUser,[{key:'render',value:function render(){var _props=this.props,firstname=_props.firstname,avatar=_props.avatar,size=_props.size,selected=_props.selected,onClick=_props.onClick,style=_props.style,bottom=_props.bottom,position=_props.position,isChampion=_props.isChampion,isSelected=_props.isSelected;var name=firstname||'';var styles=style?Object.assign({},style):{};if(isSelected){styles.border='3px solid #2680EB';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["c" ],{className:'avatar_wrapper'},isChampion?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["d" ],{size:size,className:'champion',src:__WEBPACK_IMPORTED_MODULE_2_assets_images_ChampionUser_svg___default.a,alt:''}):null,avatar&&avatar!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{style:styles,className:(selected?'selected':'')+' '+(onClick?'clickable':'')+' avatar_bubble',alt:name,src:avatar,size:size,onClick:this.handleAvatarClick,bottom:bottom,position:position}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" ],{style:styles,className:(selected?'selected':'')+' '+(onClick?'clickable':'')+' text-avatar avatar_bubble',size:size,onClick:this.handleAvatarClick,bottom:bottom,position:position},name.slice(0,1)));}}]);return AvatarUser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AvatarUser.propTypes={avatar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,firstname:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,bottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,position:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isChampion:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};AvatarUser.defaultProps={avatar:'',firstname:'',id:0,onClick:null,size:80,selected:false,style:{},bottom:0,position:'',isChampion:false,isSelected:false}; __webpack_exports__["a"] = (AvatarUser);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return Avatar; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return AvatarWrapper; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return Champion; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return AvatarText; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
var _templateObject=_taggedTemplateLiteral(['\n  width: ','px;\n  height: ','px;\n  background-image: url(',');\n  background-position: 50%;\n  background-size: cover;\n  border-radius: 43%;\n  transition: all 0.3s ease;\n  background-color: #ccc;\n  display: inline-block;\n  vertical-align: middle;\n  bottom: ','px;\n  position: ','\n\n\n  &.selected {\n    box-shadow: 0px 0px 0px 6px rgba(255,255,255,0.6);\n  }\n'],['\n  width: ','px;\n  height: ','px;\n  background-image: url(',');\n  background-position: 50%;\n  background-size: cover;\n  border-radius: 43%;\n  transition: all 0.3s ease;\n  background-color: #ccc;\n  display: inline-block;\n  vertical-align: middle;\n  bottom: ','px;\n  position: ','\n\n\n  &.selected {\n    box-shadow: 0px 0px 0px 6px rgba(255,255,255,0.6);\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n'],['\n  position: relative;\n  display: inline-block;\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: ','px;\n  height: ','px;\n  margin-left: -9px;\n  margin-top: -9px;\n  position: absolute;\n'],['\n  width: ','px;\n  height: ','px;\n  margin-left: -9px;\n  margin-top: -9px;\n  position: absolute;\n']),_templateObject4=_taggedTemplateLiteral(['\n  && {\n    width: ','px;\n    height: ','px;\n    background-color: ',';\n    font-size: ','px;\n    padding-top: 0px;\n    line-height: ','px;\n    text-transform: uppercase;\n    transition: all 0.3s ease;\n    text-align: center;\n    display: inline-block;\n    border-radius: 43%;\n    vertical-align: middle;\n    border: 1px solid #b1b1b1;\n    position: relative;\n    &.selected {\n      box-shadow: 0px 0px 0px 6px rgba(255,255,255,0.6);\n    }\n  }\n'],['\n  && {\n    width: ','px;\n    height: ','px;\n    background-color: ',';\n    font-size: ','px;\n    padding-top: 0px;\n    line-height: ','px;\n    text-transform: uppercase;\n    transition: all 0.3s ease;\n    text-align: center;\n    display: inline-block;\n    border-radius: 43%;\n    vertical-align: middle;\n    border: 1px solid #b1b1b1;\n    position: relative;\n    &.selected {\n      box-shadow: 0px 0px 0px 6px rgba(255,255,255,0.6);\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Avatar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.size;},function(props){return props.size;},function(props){return props.src;},function(props){return props.bottom;},function(props){return props.position||'relative';});var AvatarWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var Champion=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].img(_templateObject3,function(props){return props.size+18;},function(props){return props.size+18;});var AvatarText=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject4,function(props){return props.size;},function(props){return props.size;},function(props){return props.color;},function(props){return Math.ceil(props.size/2);},function(props){return Math.ceil(props.size);});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_7__internal_svg_icons_Person__ = __webpack_require__(864);








var styles = function styles(theme) {
  return {
    
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: 40,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      lineHeight: 1,
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },

    
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    
    circle: {},

    
    circular: {},

    
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    
    square: {
      borderRadius: 0
    },

    
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE 11.
      objectFit: 'cover',
      // Hide alt text.
      color: 'transparent',
      // Hide the image broken icon, only works on Chrome.
      textIndent: 10000
    },

    
    fallback: {
      width: '75%',
      height: '75%'
    }
  };
};

function useLoaded(_ref) {
  var src = _ref.src,
      srcSet = _ref.srcSet;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      loaded = _React$useState[0],
      setLoaded = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!src && !srcSet) {
      return undefined;
    }

    setLoaded(false);
    var active = true;
    var image = new Image();
    image.src = src;
    image.srcSet = srcSet;

    image.onload = function () {
      if (!active) {
        return;
      }

      setLoaded('loaded');
    };

    image.onerror = function () {
      if (!active) {
        return;
      }

      setLoaded('error');
    };

    return function () {
      active = false;
    };
  }, [src, srcSet]);
  return loaded;
}

var Avatar = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Avatar(props, ref) {
  var alt = props.alt,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'circle' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);

  var children = null; // Use a hook instead of onError on the img element to support server-side rendering.

  var loaded = useLoaded({
    src: src,
    srcSet: srcSet
  });
  var hasImg = src || srcSet;
  var hasImgNotFailing = hasImg && loaded !== 'error';

  if (hasImgNotFailing) {
    children = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("img", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  } else if (childrenProp != null) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__internal_svg_icons_Person__["a" ], {
      className: classes.fallback
    });
  }

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
    ref: ref
  }, other), children);
});
 false ? Avatar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  alt: PropTypes.string,

  
  children: PropTypes.node,

  
  classes: chainPropTypes(PropTypes.object, function (props) {
    var classes = props.classes;

    if (classes == null) {
      return null;
    }

    if (classes.circle != null && // 2 classnames? one from withStyles the other must be custom
    classes.circle.split(' ').length > 1) {
      throw new Error("Material-UI: The `circle` class was deprecated. Use `circular` instead.");
    }

    return null;
  }),

  
  className: PropTypes.string,

  
  component: PropTypes
  
  .elementType,

  
  imgProps: PropTypes.object,

  
  sizes: PropTypes.string,

  
  src: PropTypes.string,

  
  srcSet: PropTypes.string,

  
  variant: chainPropTypes(PropTypes.oneOf(['circle', 'circular', 'rounded', 'square']), function (props) {
    var variant = props.variant;

    if (variant === 'circle') {
      throw new Error('Material-UI: `variant="circle"` was deprecated. Use `variant="circular"` instead.');
    }

    return null;
  })
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'MuiAvatar'
})(Avatar));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(236);




 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" ])( __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person'));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__SvgIcon__ = __webpack_require__(866);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SvgIcon__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(38);







var styles = function styles(theme) {
  return {
    
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    
    colorPrimary: {
      color: theme.palette.primary.main
    },

    
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    
    colorAction: {
      color: theme.palette.action.active
    },

    
    colorError: {
      color: theme.palette.error.main
    },

    
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" ])(color))], fontSize !== 'default' && classes["fontSize".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" ])(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("title", null, titleAccess) : null);
});
 false ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  
  component: PropTypes
  
  .elementType,

  
  fontSize: PropTypes.oneOf(['default', 'inherit', 'large', 'small']),

  
  htmlColor: PropTypes.string,

  
  shapeRendering: PropTypes.string,

  
  titleAccess: PropTypes.string,

  
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon));

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/compare_no_results.9e3122e5.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no_user_info.5c112d51.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/calls.f2eb27f2.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tables.e57e8584.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/onboarding.fef62335.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/profile.096412b7.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return UserCardWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: #F1F1F1;\n  height: 90vh;\n  overflow: scroll;\n  width: 100%;\n  .loading {\n    font-size: 1.6rem;\n    text-align: center;\n    padding: 2rem;\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    padding: 1rem;\n    min-height: 15rem;\n\n    .username {\n      font-size: 1.6rem;\n      font-weight: ',';\n      font-family: ',';\n      color: #000;\n      margin-top: 1rem;\n      margin-left: 1rem;\n    }\n\n    .overview {\n      font-size: 1.4rem;\n      margin-top: 1rem;\n      margin-bottom: 1rem;\n      line-height: 1.9rem;\n      overflow: auto;\n      margin-left: 1rem;\n      background: white;\n      padding: 1.5rem;\n      border-radius: 2rem;\n      display: flex;\n      flex-direction: column;\n      .close {\n        place-self: flex-end;\n        color: #2680EB;\n        cursor: pointer;\n      }\n    }\n    .overview_empty {\n      font-size: 1.4rem;\n      margin-top: 1rem;\n      margin-bottom: 1rem;\n      line-height: 1.9rem;\n      margin-left: 1rem;\n      background: white;\n      padding: 1.5rem;\n      border-radius: 2rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 80%;\n      color: #2680EB;\n      cursor: pointer;\n    }\n  }\n\n  .tab_content {\n    padding: 0rem;\n    overflow: auto;\n\n    .separator {\n      display: flex;\n      align-items: center;\n      background-color: #D9D9D9;\n      color: #5E5E5E;\n      font-size: 1.6rem;\n      font-weight:  ',';\n      font-family: ',';\n      background: attr(data-color);\n      padding: 1rem 1rem 1rem 3rem;\n      margin-top: 2rem;\n      img {\n        height: 2rem;\n        margin-right: 0.5rem;\n        color: \n      }\n      &.answer{\n        color: white;\n      }\n    }\n\n    .title {\n      color: #5E5E5E;\n      font-size: 1.3rem;\n      margin-bottom: 1rem;\n      margin-top: 2rem;\n    }\n    \n    .subsection {\n      margin: 2rem 3rem;\n    }\n\n    .subsection_content{\n      margin: 2rem 2rem;\n    }\n  \n    .subsection_content::-webkit-scrollbar{\n      display: none;\n    }\n\n    .container_tags {\n      background-color: #E8E8E8;\n      border-radius: 2rem;\n      padding: 1rem 1rem 0;\n      margin: 1rem;\n\n      .description_tag {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 1rem;\n        margin-bottom: 1rem;\n        font-size: 1.4rem;\n        color: #000;\n      }\n    }\n  }\n'],['\n  background-color: #F1F1F1;\n  height: 90vh;\n  overflow: scroll;\n  width: 100%;\n  .loading {\n    font-size: 1.6rem;\n    text-align: center;\n    padding: 2rem;\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    padding: 1rem;\n    min-height: 15rem;\n\n    .username {\n      font-size: 1.6rem;\n      font-weight: ',';\n      font-family: ',';\n      color: #000;\n      margin-top: 1rem;\n      margin-left: 1rem;\n    }\n\n    .overview {\n      font-size: 1.4rem;\n      margin-top: 1rem;\n      margin-bottom: 1rem;\n      line-height: 1.9rem;\n      overflow: auto;\n      margin-left: 1rem;\n      background: white;\n      padding: 1.5rem;\n      border-radius: 2rem;\n      display: flex;\n      flex-direction: column;\n      .close {\n        place-self: flex-end;\n        color: #2680EB;\n        cursor: pointer;\n      }\n    }\n    .overview_empty {\n      font-size: 1.4rem;\n      margin-top: 1rem;\n      margin-bottom: 1rem;\n      line-height: 1.9rem;\n      margin-left: 1rem;\n      background: white;\n      padding: 1.5rem;\n      border-radius: 2rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 80%;\n      color: #2680EB;\n      cursor: pointer;\n    }\n  }\n\n  .tab_content {\n    padding: 0rem;\n    overflow: auto;\n\n    .separator {\n      display: flex;\n      align-items: center;\n      background-color: #D9D9D9;\n      color: #5E5E5E;\n      font-size: 1.6rem;\n      font-weight:  ',';\n      font-family: ',';\n      background: attr(data-color);\n      padding: 1rem 1rem 1rem 3rem;\n      margin-top: 2rem;\n      img {\n        height: 2rem;\n        margin-right: 0.5rem;\n        color: \n      }\n      &.answer{\n        color: white;\n      }\n    }\n\n    .title {\n      color: #5E5E5E;\n      font-size: 1.3rem;\n      margin-bottom: 1rem;\n      margin-top: 2rem;\n    }\n    \n    .subsection {\n      margin: 2rem 3rem;\n    }\n\n    .subsection_content{\n      margin: 2rem 2rem;\n    }\n  \n    .subsection_content::-webkit-scrollbar{\n      display: none;\n    }\n\n    .container_tags {\n      background-color: #E8E8E8;\n      border-radius: 2rem;\n      padding: 1rem 1rem 0;\n      margin: 1rem;\n\n      .description_tag {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 1rem;\n        margin-bottom: 1rem;\n        font-size: 1.4rem;\n        color: #000;\n      }\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UserCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["b" ].boldWeight,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["b" ].boldFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["b" ].regularWeight,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["b" ].regularFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return StartSpeedDatingWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  .content_user {\n    height: 65vh;\n    overflow: auto;\n    margin: 0 auto 20px;\n\n    .user_card {\n      height: auto;\n      overflow-x: hidden;\n    }\n\n    svg {\n      height: 200px !important;\n    }\n\n    @media (max-width: ','px) {\n      padding: 0px;\n      height: calc(55vh - env(safe-area-inset-top));\n      svg {\n        height: 120px !important;\n      }\n    }\n  }\n\n  .footer {\n    text-align: center;\n  }\n\n  .title_start {\n    font-size: 24px;\n    color: #444;\n    font-weight: 600;\n    margin-bottom: 20px;\n\n    @media (max-width: ','px) {\n      font-size: 18px;\n      line-height: 18px;\n      margin-bottom: 10px;\n    }\n  }\n\n  button {\n    min-width: 100px;\n  }\n\n  .phrase {\n    font-size: 16px;\n    color: #666;\n    font-weight: 600;\n    margin: 20px 0;\n\n    @media (max-width: ','px) {\n      font-size: 14px;\n      margin: 10px 0;\n    }\n  }\n'],['\n  .content_user {\n    height: 65vh;\n    overflow: auto;\n    margin: 0 auto 20px;\n\n    .user_card {\n      height: auto;\n      overflow-x: hidden;\n    }\n\n    svg {\n      height: 200px !important;\n    }\n\n    @media (max-width: ','px) {\n      padding: 0px;\n      height: calc(55vh - env(safe-area-inset-top));\n      svg {\n        height: 120px !important;\n      }\n    }\n  }\n\n  .footer {\n    text-align: center;\n  }\n\n  .title_start {\n    font-size: 24px;\n    color: #444;\n    font-weight: 600;\n    margin-bottom: 20px;\n\n    @media (max-width: ','px) {\n      font-size: 18px;\n      line-height: 18px;\n      margin-bottom: 10px;\n    }\n  }\n\n  button {\n    min-width: 100px;\n  }\n\n  .phrase {\n    font-size: 16px;\n    color: #666;\n    font-weight: 600;\n    margin: 20px 0;\n\n    @media (max-width: ','px) {\n      font-size: 14px;\n      margin: 10px 0;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StartSpeedDatingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(876);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_2_store_globalState_reducers_userConnections__ = __webpack_require__(125);
 var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(877);
var mapStateToProps=function mapStateToProps(state){return{literals:state.i18n.literals.notificationsModal,actualUser:state.session.user,myNetwork:state.userConnections.connections,requestConnections:state.userConnections.requested};};function mapDispatchToProps(dispatch){return{addRequestedConnection:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_store_globalState_reducers_userConnections__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components__["a" ]));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_4_react_ga__ = __webpack_require__(106);
 var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
 var __WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_7_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_8_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_icons_speed_dating_icon_svg__ = __webpack_require__(878);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_icons_speed_dating_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_images_icons_speed_dating_icon_svg__);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_hall_speedDatingLogoGreen_svg__ = __webpack_require__(237);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_hall_speedDatingLogoGreen_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_assets_images_hall_speedDatingLogoGreen_svg__);
 var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(879);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FinishSpeedDating=function(_Component){_inherits(FinishSpeedDating,_Component);function FinishSpeedDating(props){_classCallCheck(this,FinishSpeedDating);var _this=_possibleConstructorReturn(this,(FinishSpeedDating.__proto__||Object.getPrototypeOf(FinishSpeedDating)).call(this,props));_this.goHome=function(){var onClose=_this.props.onClose;__WEBPACK_IMPORTED_MODULE_7_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_8_constants_urls__["u" ]);if(onClose){onClose();}};_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose){onClose();}};_this.handleShowProfile=function(){var onShowProfile=_this.props.onShowProfile;if(onShowProfile){onShowProfile(_this.getOtherUserId());}};_this.getOtherUserId=function(){var _this$props=_this.props,usersStr=_this$props.users,actualUser=_this$props.actualUser;var users=typeof usersStr==='string'?JSON.parse(usersStr):usersStr;var user1=parseInt(users[0].id,10);var user2=parseInt(users[1].id,10);var otherUser=actualUser.id===user1?user2:user1;return otherUser;};_this.getOtherUser=function(){var _this$props2=_this.props,usersStr=_this$props2.users,actualUser=_this$props2.actualUser;var users=typeof usersStr==='string'?JSON.parse(usersStr):usersStr;var user1=parseInt(users[0].id,10);var otherUser=actualUser.id===user1?users[1]:users[0];return otherUser;};_this.connect=function(){var addRequestedConnection=_this.props.addRequestedConnection;var otherUser=_this.getOtherUserId();var params={userId:otherUser,action:'connect'};Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["b" ])('POST',{endPoint:'users/connection'},params);addRequestedConnection({id:otherUser});__WEBPACK_IMPORTED_MODULE_4_react_ga__["a" ].event({category:'Add Connection User',action:'user_'+otherUser,label:'Feedback Step'});_this.setState({hasConnect:true});};_this.state={hasConnect:false};return _this;}_createClass(FinishSpeedDating,[{key:'render',value:function render(){var _props=this.props,literals=_props.literals,myNetwork=_props.myNetwork,requestConnections=_props.requestConnections,actualUser=_props.actualUser,startDate=_props.startDate;var hasConnect=this.state.hasConnect;var otherUser=this.getOtherUser();var subtitle=literals.speedDatingFeedbackSubTitle1+' '+otherUser.firstname+' '+otherUser.lastname+' '+literals.speedDatingFeedbackSubTitle2;var footer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom_grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary black',onClick:this.handleClose},literals.notNow)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:this.connect},literals.proposeToConnect)));if(hasConnect){footer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'success_msg'},literals.proposeConnectHasBeenSent);}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(myNetwork,{id:otherUser.id})){footer=null;subtitle=otherUser.firstname+' '+otherUser.lastname+' '+literals.isAlreadyInYourNetwork;}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(requestConnections,{id:otherUser.id})){footer=null;subtitle=otherUser.firstname+' '+otherUser.lastname+' '+literals.hasNotYetAcceptedConnectionProposal;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Avatar__["a" ],{id:otherUser.id,avatar:otherUser.avatar,firstname:otherUser.firstname,size:80})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_assets_images_icons_speed_dating_icon_svg___default.a,alt:'',className:'speed_dating_icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Avatar__["a" ],{id:actualUser.id,avatar:actualUser.avatar,firstname:actualUser.firstname,size:80}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.speedDatingFeedbackTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle'},subtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'central_grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'speed_card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10_assets_images_hall_speedDatingLogoGreen_svg___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(startDate,'X').format('MMMM Do'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Avatar__["a" ],{id:otherUser.id,avatar:otherUser.avatar,firstname:otherUser.firstname,size:32}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user_name'},otherUser.firstname+' '+otherUser.lastname)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary white',onClick:this.handleShowProfile},literals.viewProfile))),footer);}}]);return FinishSpeedDating;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FinishSpeedDating.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,users:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,startDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,addRequestedConnection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,myNetwork:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,requestConnections:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,actualUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onShowProfile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};FinishSpeedDating.defaultProps={actualUser:{id:0},onClose:null,onShowProfile:null,myNetwork:[],requestConnections:[]}; __webpack_exports__["a"] = (FinishSpeedDating);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/speed_dating_icon.e9694750.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return FinishSpeedDatingWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_2_constants_fonts__ = __webpack_require__(17);
var _templateObject=_taggedTemplateLiteral(['\n  text-align: center;\n\n  .users {\n    white-space: nowrap;\n    max-width: 23rem;\n    margin: 0 auto 2rem;\n    white-space: nowrap;\n\n    > div {\n      width: 50%;\n      display: inline-block;\n\n      &:first-child {\n        text-align: left;\n\n        .avatar_bubble {\n          border: 0.3rem solid ',';\n        }\n      }\n      &:last-child {\n        text-align: right;\n        .avatar_bubble {\n          border: 0.1rem solid #000;\n        }\n      }\n    }\n\n    .speed_dating_icon {\n      margin: -2rem -4.5rem 0;\n      position: relative;\n      z-index: 10;\n    }\n  }\n\n  .central_grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 2rem;\n    width: 35rem;\n    margin: 2rem auto;\n    max-width: 100%;\n    align-items: center;\n\n    .speed_card {\n      border-radius: 1.5rem;\n      box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n      max-width: 100%;\n      width: 17rem;\n      .header {\n        background-color: #2680EB;\n        color: #fff;\n        border-radius: 1.5rem 1.5rem 0 0;\n        padding: 1rem;\n\n\n        .icon {\n          background: white;\n          border-radius: 100%;\n          border-radius: 100%;\n          width: 3rem;\n          height: 3rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          margin-left: 1rem;\n          display: inline-block;\n          vertical-align: top;\n          img {\n              height: 3rem;\n              width: 3rem;\n          }\n        }\n        .data {\n            width: calc(100% - 5rem);\n            font-family: ',';\n            color: white;\n            font-size: 1.8rem;\n            display: inline-block;\n            vertical-align: top;\n            margin-left: 1rem;\n            text-align: left;\n        }\n      }\n\n      .body {\n        padding: 1rem;\n        text-align: left;\n        .user_name {\n          display: inline-block;\n          vertical-align: middle;\n          font-size: 1.2rem;\n          margin-left: 1rem;\n          width: calc(100% - 4.5rem);\n          line-height: 1.4rem;\n        }\n      }\n    }\n  }\n\n  .bottom_grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 2rem;\n    width: 45rem;\n    margin: 2rem auto;\n    max-width: 100%;\n    align-items: center;\n\n    button {\n      width: 100%;\n    }\n  }\n'],['\n  text-align: center;\n\n  .users {\n    white-space: nowrap;\n    max-width: 23rem;\n    margin: 0 auto 2rem;\n    white-space: nowrap;\n\n    > div {\n      width: 50%;\n      display: inline-block;\n\n      &:first-child {\n        text-align: left;\n\n        .avatar_bubble {\n          border: 0.3rem solid ',';\n        }\n      }\n      &:last-child {\n        text-align: right;\n        .avatar_bubble {\n          border: 0.1rem solid #000;\n        }\n      }\n    }\n\n    .speed_dating_icon {\n      margin: -2rem -4.5rem 0;\n      position: relative;\n      z-index: 10;\n    }\n  }\n\n  .central_grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 2rem;\n    width: 35rem;\n    margin: 2rem auto;\n    max-width: 100%;\n    align-items: center;\n\n    .speed_card {\n      border-radius: 1.5rem;\n      box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n      max-width: 100%;\n      width: 17rem;\n      .header {\n        background-color: #2680EB;\n        color: #fff;\n        border-radius: 1.5rem 1.5rem 0 0;\n        padding: 1rem;\n\n\n        .icon {\n          background: white;\n          border-radius: 100%;\n          border-radius: 100%;\n          width: 3rem;\n          height: 3rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          margin-left: 1rem;\n          display: inline-block;\n          vertical-align: top;\n          img {\n              height: 3rem;\n              width: 3rem;\n          }\n        }\n        .data {\n            width: calc(100% - 5rem);\n            font-family: ',';\n            color: white;\n            font-size: 1.8rem;\n            display: inline-block;\n            vertical-align: top;\n            margin-left: 1rem;\n            text-align: left;\n        }\n      }\n\n      .body {\n        padding: 1rem;\n        text-align: left;\n        .user_name {\n          display: inline-block;\n          vertical-align: middle;\n          font-size: 1.2rem;\n          margin-left: 1rem;\n          width: calc(100% - 4.5rem);\n          line-height: 1.4rem;\n        }\n      }\n    }\n  }\n\n  .bottom_grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 2rem;\n    width: 45rem;\n    margin: 2rem auto;\n    max-width: 100%;\n    align-items: center;\n\n    button {\n      width: 100%;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FinishSpeedDatingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_colors__["f" ],__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].semiBoldFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(881);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(882);
var mapStateToProps=function mapStateToProps(state){return{literals:state.i18n.literals.notificationsModal,actualUser:state.session.user};};function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_connections_match_success_svg__ = __webpack_require__(883);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_connections_match_success_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_connections_match_success_svg__);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_gifs_confetti_gif__ = __webpack_require__(884);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_gifs_confetti_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_gifs_confetti_gif__);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(885);
function NewUserConnection(props){var user=props.user,actualUser=props.actualUser,literals=props.literals,onClose=props.onClose;var handleClose=function handleClose(){onClose();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_assets_images_gifs_confetti_gif___default.a,alt:'',className:'confetti'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Avatar__["a" ],{id:user.id,avatar:user.avatar,firstname:user.firstname,size:80})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Avatar__["a" ],{id:actualUser.id,avatar:actualUser.avatar,firstname:actualUser.firstname,size:80}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_assets_images_connections_match_success_svg___default.a,alt:'',className:'match_icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,user.firstname+' '+literals.wasAlsoLookingForwardsWithYou),literals.youAreNowConnected),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:handleClose},literals.close)));}NewUserConnection.propTypes={user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,actualUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (NewUserConnection);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/match_success.c48f426f.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/confetti.8db5efdb.gif";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return GreetingsModal; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  width: 27rem;\n  text-align: center;\n  margin: 0 auto;\n  position: relative;\n\n  .confetti {\n    position: absolute;\n    pointer-events: none;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 1;\n  }\n\n  .users {\n    white-space: nowrap;\n    margin-bottom: 1rem;\n\n    > div {\n      width: 50%;\n      display: inline-block;\n\n      &:first-child {\n        text-align: left;\n\n        .avatar_bubble {\n          border: 0.3rem solid ',';\n        }\n      }\n      &:last-child {\n        text-align: right;\n        .avatar_bubble {\n          border: 0.1rem solid #000;\n        }\n      }\n    }\n  }\n\n  .match_icon {\n    margin: 1rem;\n  }\n\n  .info {\n    color: ',';\n    font-size: 1.6rem;\n    line-height: 2.2rem;\n    strong {\n      display: block;\n      font-family: ',';\n      margin-bottom: 1rem;\n    }\n  }\n\n  .buttons {\n    margin-top: 2rem;\n    button.primary {\n      background-color: ',';\n      color: #fff;\n    }\n  }\n'],['\n  width: 27rem;\n  text-align: center;\n  margin: 0 auto;\n  position: relative;\n\n  .confetti {\n    position: absolute;\n    pointer-events: none;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 1;\n  }\n\n  .users {\n    white-space: nowrap;\n    margin-bottom: 1rem;\n\n    > div {\n      width: 50%;\n      display: inline-block;\n\n      &:first-child {\n        text-align: left;\n\n        .avatar_bubble {\n          border: 0.3rem solid ',';\n        }\n      }\n      &:last-child {\n        text-align: right;\n        .avatar_bubble {\n          border: 0.1rem solid #000;\n        }\n      }\n    }\n  }\n\n  .match_icon {\n    margin: 1rem;\n  }\n\n  .info {\n    color: ',';\n    font-size: 1.6rem;\n    line-height: 2.2rem;\n    strong {\n      display: block;\n      font-family: ',';\n      margin-bottom: 1rem;\n    }\n  }\n\n  .buttons {\n    margin-top: 2rem;\n    button.primary {\n      background-color: ',';\n      color: #fff;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GreetingsModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["f" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].semiBoldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["f" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_4_components_Steps_SwipeableCards__ = __webpack_require__(65);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(948);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var MAX_USERS=30;function UsersModal(props){var usersIds=props.usersIds,userSelected=props.userSelected,onEnd=props.onEnd,zIndex=props.zIndex;var users=[].concat(_toConsumableArray(usersIds));if(userSelected){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(users,function(userId){return userId===userSelected;});users.unshift(userSelected);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal__["a" ],{open:true,onClose:onEnd,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',style:{zIndex:zIndex}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" ],{className:'feedback_modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Steps_SwipeableCards__["a" ],{profile:'90vh',users:users.slice(0,MAX_USERS),hideFirst:true,onClose:onEnd,onEnd:onEnd})));}UsersModal.propTypes={usersIds:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,userSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,onEnd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,zIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};UsersModal.defaultProps={userSelected:null,onEnd:null,zIndex:20}; __webpack_exports__["a"] = (UsersModal);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_elements_actions__ = __webpack_require__(132);
 var __WEBPACK_IMPORTED_MODULE_4_store_globalState_reducers_userConnections__ = __webpack_require__(125);
 var __WEBPACK_IMPORTED_MODULE_5_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(888);
function mapStateToProps(state){return{literals:state.i18n.literals.swipeableCards,context:state.steps.context,connections:state.userConnections.connections,responses:state.userConnections.requested,actualUser:state.session.user,userTables:state.thinkChats.myThinkChatsList};}function mapDispatchToProps(dispatch){return{getUserInterests:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_elements_actions__["f" ],dispatch),addRequestedConnection:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_store_globalState_reducers_userConnections__["a" ],dispatch),getChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_chats__["e" ],dispatch),getHasPendingRequestsWithTimer:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_store_globalState_reducers_userConnections__["d" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__ = __webpack_require__(172);
 var __WEBPACK_IMPORTED_MODULE_5_react_materialize__ = __webpack_require__(173);
 var __WEBPACK_IMPORTED_MODULE_5_react_materialize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_materialize__);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_icons_requestConnectionIcon_svg__ = __webpack_require__(931);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_icons_requestConnectionIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_images_icons_requestConnectionIcon_svg__);
 var __WEBPACK_IMPORTED_MODULE_7_components_Steps_IntroductionCard__ = __webpack_require__(932);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_user_connectedWithUser_svg__ = __webpack_require__(937);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_user_connectedWithUser_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_images_user_connectedWithUser_svg__);
 var __WEBPACK_IMPORTED_MODULE_9_components_UserCard__ = __webpack_require__(235);
 var __WEBPACK_IMPORTED_MODULE_10_components_ThinkSeedCard__ = __webpack_require__(938);
 var __WEBPACK_IMPORTED_MODULE_11_components_ThinkSeedContributionForm__ = __webpack_require__(420);
 var __WEBPACK_IMPORTED_MODULE_12_modules_users_actions__ = __webpack_require__(85);
 var __WEBPACK_IMPORTED_MODULE_13_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_14_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_15_constants_tables__ = __webpack_require__(110);
 var __WEBPACK_IMPORTED_MODULE_16__styles__ = __webpack_require__(947);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DURATION_CAROUSEL=200;var OPTIONS_CAROUSEL={dist:-50,duration:DURATION_CAROUSEL,fullWidth:false,indicators:false,noWrap:false,numVisible:4,padding:-100,shift:50};function printSlider(props){var children=props.children,onChange=props.onChange;var handleClick=function handleClick(event){event.stopPropagation();};var handleChange=function handleChange(element){if(onChange){onChange(element);}};if(!children.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["b" ],{onMouseDown:handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_materialize__["Carousel"],{carouselId:'Carousel-2',options:Object.assign({},OPTIONS_CAROUSEL,{onCycleTo:handleChange})},children));}var MySlider=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(printSlider);function SwipeableCards(props){var users=props.users,thinkSeeds=props.thinkSeeds,title=props.title,hideFirst=props.hideFirst,context=props.context,onEnd=props.onEnd,onClose=props.onClose,onYup=props.onYup,onNope=props.onNope,history=props.history,alwaysShowOptions=props.alwaysShowOptions,addRequestedConnection=props.addRequestedConnection,getChats=props.getChats,userTables=props.userTables,getHasPendingRequestsWithTimer=props.getHasPendingRequestsWithTimer;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),cards=_useState2[0],setCards=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),actualThinkSeed=_useState4[0],setActualThinkSeed=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),isTheEnd=_useState6[0],setIsTheEnd=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(Math.round(Math.random()*9999999)),_useState8=_slicedToArray(_useState7,1),randomId=_useState8[0];// Navigate functions
var removeActualCard=function removeActualCard(){var swipableElement=document.getElementById('swipeable_'+randomId);var activeElement=swipableElement.getElementsByClassName('carousel-item active')[0];var parentNode=activeElement.parentNode;var index=Array.from(parentNode.children).indexOf(activeElement);if(index>=parentNode.children.length-1){index=0;}activeElement.classList.add('animate__backOutUp');setTimeout(function(){parentNode.removeChild(activeElement);var instance=window.M.Carousel.getInstance(parentNode);if(!parentNode.children.length){instance.destroy();setIsTheEnd(true);var contributionForms=document.getElementsByClassName('think_seed_contribution_form');if(onEnd&&!contributionForms.length){onEnd();}}else{instance.next();setTimeout(function(){instance=window.M.Carousel.init(parentNode,Object.assign({},OPTIONS_CAROUSEL,{duration:0}));instance.set(index);setTimeout(function(){instance._scroll();instance.options.duration=DURATION_CAROUSEL;},1500);},DURATION_CAROUSEL);}},600);};var printIntroductionCard=function printIntroductionCard(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Steps_IntroductionCard__["a" ],{title:title,onClick:removeActualCard});};var printUserCard=function printUserCard(userId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_UserCard__["a" ],{userId:userId});};var printThinkSeedCard=function printThinkSeedCard(thinkSeedId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_ThinkSeedCard__["a" ],{id:thinkSeedId});};var printCard=function printCard(card){switch(card.type){case __WEBPACK_IMPORTED_MODULE_14_constants_types__["f" ]:return printIntroductionCard();case __WEBPACK_IMPORTED_MODULE_14_constants_types__["o" ]:return printUserCard(card.id);case __WEBPACK_IMPORTED_MODULE_14_constants_types__["m" ]:return printThinkSeedCard(card.id);default:return null;}};// Initiatialize cards
var createCards=function createCards(){var initialCards=[];var card=null;if(!hideFirst&&false){card={type:__WEBPACK_IMPORTED_MODULE_14_constants_types__["f" ],id:0};initialCards.push(Object.assign({},card));}__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(users,function(id){card={type:__WEBPACK_IMPORTED_MODULE_14_constants_types__["o" ],id:id};initialCards.push(Object.assign({},card));});__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(thinkSeeds,function(id){card={type:__WEBPACK_IMPORTED_MODULE_14_constants_types__["m" ],id:id};initialCards.push(Object.assign({},card));});setCards(initialCards);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(createCards,[users,thinkSeeds]);// Handle options
var sendUserFeedback=function sendUserFeedback(userId,accept){var fromType=context?context.elementType:'generic';var fromId=context?context.elementId:0;Object(__WEBPACK_IMPORTED_MODULE_12_modules_users_actions__["e" ])(userId,accept,fromType,fromId);getHasPendingRequestsWithTimer();};var handleAcceptUser=function handleAcceptUser(userId){if(onYup){onYup(userId);}else{Object(__WEBPACK_IMPORTED_MODULE_12_modules_users_actions__["a" ])(userId);sendUserFeedback(userId,1);addRequestedConnection({id:userId});}};var handleRejectUser=function handleRejectUser(userId){if(onNope){onNope(userId);}else{sendUserFeedback(userId,0);}};var sendFeedbackForTable=function sendFeedbackForTable(thinkSeedId,accept){var fromType=context?context.elementType:'generic';var fromId=context?context.elementId:0;Object(__WEBPACK_IMPORTED_MODULE_13_modules_think_seeds_actions__["j" ])(thinkSeedId,accept,fromType,fromId);};var handleRejectThinkSeed=function handleRejectThinkSeed(thinkSeedId){sendFeedbackForTable(thinkSeedId,0);};var handleJoinThinkSeed=function handleJoinThinkSeed(thinkSeedId){setActualThinkSeed(thinkSeedId);Object(__WEBPACK_IMPORTED_MODULE_13_modules_think_seeds_actions__["h" ])(thinkSeedId).then(function(){getChats();});sendFeedbackForTable(thinkSeedId,1);};var sendContributionsInThinkSeed=function sendContributionsInThinkSeed(params){Object(__WEBPACK_IMPORTED_MODULE_13_modules_think_seeds_actions__["k" ])(actualThinkSeed,params.contributions,params.others);setActualThinkSeed(null);if(onEnd&&isTheEnd){onEnd();}};var handleNope=function handleNope(){var swipableElement=document.getElementById('swipeable_'+randomId);var activeElement=swipableElement.getElementsByClassName('carousel-item active')[0];var type=activeElement.getAttribute('data-type');var id=parseInt(activeElement.getAttribute('data-id'),10);switch(type){case __WEBPACK_IMPORTED_MODULE_14_constants_types__["o" ]:handleRejectUser(id);break;case __WEBPACK_IMPORTED_MODULE_14_constants_types__["m" ]:handleRejectThinkSeed(id);break;default:break;}removeActualCard();};var handleYes=function handleYes(){var swipableElement=document.getElementById('swipeable_'+randomId);var activeElement=swipableElement.getElementsByClassName('carousel-item active')[0];var type=activeElement.getAttribute('data-type');var id=parseInt(activeElement.getAttribute('data-id'),10);switch(type){case __WEBPACK_IMPORTED_MODULE_14_constants_types__["m" ]:handleJoinThinkSeed(id);break;case __WEBPACK_IMPORTED_MODULE_14_constants_types__["o" ]:handleAcceptUser(id);break;default:break;}removeActualCard();};var handleChat=function handleChat(event){var userId=parseInt(event.target.getAttribute('data-id'),10);var tableSelected=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(userTables,function(table){return table.type===__WEBPACK_IMPORTED_MODULE_15_constants_tables__["c" ]&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(table.users,{id:userId});});if(!tableSelected){history.push('/think-chat/creation');}else{history.push('/theme-table/'+tableSelected.id);}};var goToTable=function goToTable(event){var tableId=parseInt(event.currentTarget.getAttribute('data-id'),10);history.push('/theme-table/'+tableId);};// Render functions
var printFooter=function printFooter(card){var connections=props.connections,responses=props.responses,literals=props.literals,type=props.type;if(card.type===__WEBPACK_IMPORTED_MODULE_14_constants_types__["f" ]){return null;}if(card.type===__WEBPACK_IMPORTED_MODULE_14_constants_types__["m" ]){var isInTable=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(userTables,function(table){return table.id===card.id;});if(isInTable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'centered_button','data-type':card.type,'data-id':card.id,onClick:goToTable},literals.goToTable));}}if(card.type===__WEBPACK_IMPORTED_MODULE_14_constants_types__["o" ]){var connected=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(connections,function(user){return user.id===card.id;});var responsed=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(responses,function(res){return res.id===parseInt(card.id,10);});if(connected&&!alwaysShowOptions){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'chat','data-type':card.type,'data-id':card.id,onClick:handleChat},literals.openTableToChat));}if(responsed&&!alwaysShowOptions){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8_assets_images_user_connectedWithUser_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text_connected'},literals.connected));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'nope','data-type':card.type,'data-id':card.id,onClick:handleNope},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,card.type!==__WEBPACK_IMPORTED_MODULE_14_constants_types__["m" ]&&type===__WEBPACK_IMPORTED_MODULE_14_constants_types__["i" ]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'speed_dating','data-type':card.type,'data-id':card.id,onClick:handleYes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.selectForSpeedDating),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'})),card.type!==__WEBPACK_IMPORTED_MODULE_14_constants_types__["m" ]&&type!==__WEBPACK_IMPORTED_MODULE_14_constants_types__["i" ]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'yes','data-type':card.type,'data-id':card.id,onClick:handleYes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_assets_images_icons_requestConnectionIcon_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.requestConnection)),card.type===__WEBPACK_IMPORTED_MODULE_14_constants_types__["m" ]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'yes','data-type':card.type,'data-id':card.id,onClick:handleYes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.join))));};var printCloseIcon=function printCloseIcon(){if(!onClose){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle close_icon',onClick:onClose});};var printCards=function printCards(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(cards,function(card,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["a" ],{className:'swipeable_card index_'+index+' '+(card.type!==__WEBPACK_IMPORTED_MODULE_14_constants_types__["f" ]?'with_footer':''),key:index,'data-index':index,'data-type':card.type,'data-id':card.id},printCloseIcon(),printCard(card),printFooter(card));});};var checkIfIsTheEnd=function checkIfIsTheEnd(){if(isTheEnd&&onEnd){onEnd();}};var printThinkSeedContributionCard=function printThinkSeedContributionCard(){if(!actualThinkSeed){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal__["a" ],{open:true,onClose:checkIfIsTheEnd,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',style:{zIndex:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_ThinkSeedContributionForm__["a" ],{onClick:sendContributionsInThinkSeed})));};var SliderCards=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'swipeable_'+randomId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MySlider,null,printCards()));},[cards]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,printThinkSeedContributionCard(),isTheEnd?null:SliderCards);}SwipeableCards.propTypes={users:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,thinkSeeds:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,hideFirst:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onEnd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onYup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onNope:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,alwaysShowOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,addRequestedConnection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getHasPendingRequestsWithTimer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,userTables:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};SwipeableCards.defaultProps={users:[],thinkSeeds:[],title:'',hideFirst:false,context:null,onEnd:null,onClose:null,onYup:null,onNope:null,alwaysShowOptions:false,userTables:[],type:''}; __webpack_exports__["a"] = (SwipeableCards);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);






var styles = function styles(theme) {
  return {
    
    root: {
      flex: '1 1 auto',
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      overflowY: 'auto',
      padding: '8px 24px',
      '&:first-child': {
        // dialog without title
        paddingTop: 20
      }
    },

    
    dividers: {
      padding: '16px 24px',
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }
  };
};
var DialogContent = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function DialogContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$dividers = props.dividers,
      dividers = _props$dividers === void 0 ? false : _props$dividers,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "className", "dividers"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, dividers && classes.dividers),
    ref: ref
  }, other));
});
 false ? DialogContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  dividers: PropTypes.bool
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiDialogContent'
})(DialogContent));

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Badge = function Badge(_ref) {
  var className = _ref.className,
      newIcon = _ref.newIcon,
      caption = _ref.caption,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "newIcon", "caption", "children"]);

  var classes = {
    badge: true,
    new: newIcon
  };
  return _react.default.createElement("span", _extends({}, props, {
    "data-badge-caption": caption,
    className: (0, _classnames.default)(classes, className)
  }), children);
};

Badge.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,

  
  newIcon: _propTypes.default.bool,

  
  caption: _propTypes.default.string
};
var _default = Badge;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _Col = _interopRequireDefault(__webpack_require__(174));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Breadcrumb = function Breadcrumb(_ref) {
  var cols = _ref.cols,
      children = _ref.children,
      className = _ref.className;
  return _react.default.createElement("nav", {
    className: (0, _classnames.default)('row', className)
  }, _react.default.createElement("div", {
    className: "nav-wrapper"
  }, _react.default.createElement(_Col.default, {
    s: cols
  }, _react.default.Children.map(children, function (item) {
    return _react.default.cloneElement(item, {
      className: 'breadcrumb'
    });
  }))));
};

Breadcrumb.propTypes = {
  children: _propTypes.default.node,

  
  cols: _propTypes.default.number,
  className: _propTypes.default.string
};
Breadcrumb.defaultProps = {
  cols: 12
};
var _default = Breadcrumb;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _constants = _interopRequireDefault(__webpack_require__(66));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Caption = function Caption(_ref) {
  var className = _ref.className,
      placement = _ref.placement,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "placement", "children"]);

  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)('caption', "".concat(placement, "-align"), className)
  }, props), children);
};

Caption.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,

  
  placement: _propTypes.default.oneOf(_constants.default.PLACEMENTS)
};
Caption.defaultProps = {
  placement: 'center'
};
var _default = Caption;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _Icon = _interopRequireDefault(__webpack_require__(86));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-next-line react/prop-types
var Wrapper = function Wrapper(_ref) {
  var condition = _ref.condition,
      children = _ref.children;
  return condition ? _react.default.createElement("div", {
    className: "card-stacked"
  }, children) : _react.default.createElement(_react.Fragment, null, children);
};

var Card = function Card(_ref2) {
  var title = _ref2.title,
      header = _ref2.header,
      className = _ref2.className,
      textClassName = _ref2.textClassName,
      actions = _ref2.actions,
      reveal = _ref2.reveal,
      children = _ref2.children,
      horizontal = _ref2.horizontal,
      closeIcon = _ref2.closeIcon,
      revealIcon = _ref2.revealIcon,
      other = _objectWithoutProperties(_ref2, ["title", "header", "className", "textClassName", "actions", "reveal", "children", "horizontal", "closeIcon", "revealIcon"]);

  var classes = {
    card: true,
    horizontal: horizontal
  };
  return _react.default.createElement("div", _extends({}, other, {
    className: (0, _classnames.default)(className, classes)
  }), header, _react.default.createElement(Wrapper, {
    condition: horizontal
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)('card-content', textClassName)
  }, title && _react.default.createElement("span", {
    className: (0, _classnames.default)('card-title', {
      activator: reveal
    })
  }, title, reveal && (0, _react.cloneElement)(revealIcon, {
    right: true
  })), _react.default.createElement("div", null, children)), _react.default.createElement("div", {
    className: "card-reveal"
  }, _react.default.createElement("span", {
    className: "card-title"
  }, title, (0, _react.cloneElement)(closeIcon, {
    right: true
  })), reveal), actions && _react.default.createElement("div", {
    className: "card-action"
  }, actions)));
};

Card.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  title: _propTypes.default.string,
  textClassName: _propTypes.default.string,
  reveal: _propTypes.default.element,
  header: _propTypes.default.element,
  // The buttons to be displayed at the action area
  actions: _propTypes.default.arrayOf(_propTypes.default.element),
  horizontal: _propTypes.default.bool,

  
  closeIcon: _propTypes.default.node,

  
  revealIcon: _propTypes.default.node
};
Card.defaultProps = {
  closeIcon: _react.default.createElement(_Icon.default, null, "close"),
  revealIcon: _react.default.createElement(_Icon.default, null, "more_vert")
};
var _default = Card;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CardPanel = function CardPanel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = {
    'card-panel': true
  };
  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)(classes, className)
  }, props), children);
};

CardPanel.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
var _default = CardPanel;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _constants = _interopRequireDefault(__webpack_require__(66));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CardTitle = function CardTitle(_ref) {
  var image = _ref.image,
      reveal = _ref.reveal,
      waves = _ref.waves,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["image", "reveal", "waves", "children"]);

  var classes = (0, _classnames.default)(_defineProperty({
    'card-image': true,
    'waves-effect': waves,
    'waves-block': waves
  }, "waves-".concat(waves), waves));
  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)(classes)
  }, props), _react.default.createElement("img", {
    className: (0, _classnames.default)({
      activator: reveal
    }),
    src: image
  }), _react.default.createElement("span", {
    className: (0, _classnames.default)('card-title')
  }, children));
};

CardTitle.propTypes = {
  children: _propTypes.default.node,
  // Whether the image serves as activator for the reveal
  reveal: _propTypes.default.bool,
  // the waves effect
  waves: _propTypes.default.oneOf(_constants.default.WAVES),
  // The path to the image
  image: _propTypes.default.string.isRequired
};
var _default = CardTitle;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _idgen = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      carouselId = _ref.carouselId,
      fixedItem = _ref.fixedItem,
      images = _ref.images,
      centerImages = _ref.centerImages,
      options = _ref.options;
  var carouselRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var instance = M.Carousel.init(carouselRef.current, options);
    return function () {
      return instance.destroy();
    };
  }, [options, children, images]);
  var elemsToRender = children || images || [];
  var classes = (0, _classnames.default)('carousel', {
    'carousel-slider': options.fullWidth
  }, className);
  return _react.default.createElement("div", {
    id: carouselId,
    ref: carouselRef,
    className: classes
  }, Boolean(fixedItem) && _react.default.createElement("div", {
    className: "carousel-fixed-item center"
  }, fixedItem), _react.default.Children.map(elemsToRender, function (child) {
    var classes = (0, _classnames.default)('carousel-item', {
      'valign-wrapper': centerImages
    });

    if (typeof child === 'string') {
      return _react.default.createElement("a", {
        className: classes
      }, _react.default.createElement("img", {
        src: child,
        alt: child
      }));
    }

    return _react.default.cloneElement(child, {
      className: (0, _classnames.default)(classes, child.props.className)
    });
  }));
};

Carousel.propTypes = {
  
  children: _propTypes.default.any,

  
  images: _propTypes.default.arrayOf(_propTypes.default.string),

  
  centerImages: _propTypes.default.bool,

  
  fixedItem: _propTypes.default.node,

  
  className: _propTypes.default.string,

  
  carouselId: _propTypes.default.string,

  
  options: _propTypes.default.shape({
    
    duration: _propTypes.default.number,

    
    dist: _propTypes.default.number,

    
    shift: _propTypes.default.number,

    
    padding: _propTypes.default.number,

    
    numVisible: _propTypes.default.number,

    
    fullWidth: _propTypes.default.bool,

    
    indicators: _propTypes.default.bool,

    
    noWrap: _propTypes.default.bool,

    
    onCycleTo: _propTypes.default.func
  })
};
Carousel.defaultProps = {
  carouselId: "Carousel-".concat((0, _idgen.default)()),
  options: {
    duration: 200,
    dist: -100,
    shift: 0,
    padding: 0,
    numVisible: 5,
    fullWidth: false,
    indicators: false,
    noWrap: false,
    onCycleTo: null
  }
};
var _default = Carousel;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _idgen = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Checkbox = function Checkbox(_ref) {
  var id = _ref.id,
      className = _ref.className,
      indeterminate = _ref.indeterminate,
      filledIn = _ref.filledIn,
      label = _ref.label,
      _onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["id", "className", "indeterminate", "filledIn", "label", "onChange"]);

  var _useState = (0, _react.useState)(props.checked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var _input = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    if (_input.current) {
      _input.current.indeterminate = indeterminate;
      _input.current.checked = false;
      setChecked(false);
    }
  }, [indeterminate]);
  (0, _react.useEffect)(function () {
    setChecked(props.checked);
    _input.current.checked = props.checked;
  }, [props.checked]);
  return _react.default.createElement("label", {
    htmlFor: id
  }, _react.default.createElement("input", _extends({}, props, {
    id: id,
    className: (0, _classnames.default)({
      'filled-in': filledIn
    }, className),
    type: "checkbox",
    ref: _input,
    checked: checked,
    onChange: function onChange(e) {
      setChecked(function (prevChecked) {
        return !prevChecked;
      });
      _onChange && _onChange(e);
    }
  })), _react.default.createElement("span", null, label));
};

Checkbox.propTypes = {
  className: _propTypes.default.string,

  
  value: _propTypes.default.string.isRequired,

  
  filledIn: _propTypes.default.bool,

  
  label: _propTypes.default.string.isRequired,

  
  indeterminate: _propTypes.default.bool,

  
  onChange: _propTypes.default.func,

  
  id: _propTypes.default.string,

  
  disabled: _propTypes.default.bool,

  
  checked: _propTypes.default.bool
};
Checkbox.defaultProps = {
  id: "Checkbox_".concat((0, _idgen.default)())
};
var _default = Checkbox;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _Icon = _interopRequireDefault(__webpack_require__(86));

var _Autocomplete = __webpack_require__(414);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Chip = function Chip(_ref) {
  var children = _ref.children,
      close = _ref.close,
      closeIcon = _ref.closeIcon,
      className = _ref.className,
      options = _ref.options,
      other = _objectWithoutProperties(_ref, ["children", "close", "closeIcon", "className", "options"]);

  var instance = (0, _react.useRef)(null);
  var chipRef = (0, _react.useRef)(null);
  var classes = (0, _classnames.default)(className, {
    chip: !options,
    chips: options
  });
  var chipContent = options ? null : _react.default.createElement(_react.Fragment, null, children, Boolean(close) && closeIcon);
  (0, _react.useEffect)(function () {
    if (options) {
      instance.current = M.Chips.init(chipRef.current, options);
    }

    return function () {
      if (instance.current) {
        instance.current.destroy();
      }
    };
  }, [options, children]);
  return _react.default.createElement("div", _extends({
    className: classes
  }, other, {
    ref: chipRef
  }), chipContent);
};

Chip.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,

  
  close: _propTypes.default.bool,
  closeIcon: _propTypes.default.node,

  
  options: _propTypes.default.shape({
    
    data: _propTypes.default.arrayOf(_propTypes.default.objectOf(_propTypes.default.string)),

    
    placeholder: _propTypes.default.string,

    
    secondaryPlaceholder: _propTypes.default.string,

    
    limit: _propTypes.default.number,

    
    onChipAdd: _propTypes.default.func,

    
    onChipSelect: _propTypes.default.func,

    
    onChipDelete: _propTypes.default.func,

    
    autocompleteOptions: _Autocomplete.autocompleteOptions
  })
};
Chip.defaultProps = {
  close: false,
  closeIcon: _react.default.createElement(_Icon.default, {
    className: "close"
  }, "close"),
  options: null
};
var _default = Chip;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Collapsible = function Collapsible(_ref) {
  var children = _ref.children,
      className = _ref.className,
      accordion = _ref.accordion,
      options = _ref.options,
      defaultActiveKey = _ref.defaultActiveKey,
      popout = _ref.popout,
      onSelect = _ref.onSelect,
      props = _objectWithoutProperties(_ref, ["children", "className", "accordion", "options", "defaultActiveKey", "popout", "onSelect"]);

  var _collapsible = (0, _react.useRef)(null);

  var collapsible = accordion ? 'accordion' : 'expandable';

  var _useState = (0, _react.useState)(defaultActiveKey),
      _useState2 = _slicedToArray(_useState, 2),
      activeKey = _useState2[0],
      setActiveKey = _useState2[1];

  var renderItem = function renderItem(child, key) {
    if (!child) return null; // Extend with props if child is a react component

    if (typeof child.type === 'function') {
      Object.assign(props, {
        expanded: activeKey === key || child.props.expanded,
        eventKey: key
      });
    }

    return _react.default.cloneElement(child, {
      onSelect: function onSelect() {
        return handleSelect(key);
      }
    });
  };

  var handleSelect = function handleSelect(key) {
    if (onSelect) {
      onSelect(key);
    }

    if (activeKey === key) {
      setActiveKey(null);
    }

    if (accordion) {
      setActiveKey(key);
    }
  };

  (0, _react.useEffect)(function () {
    if (typeof M !== 'undefined') {
      var instance = M.Collapsible.init(_collapsible.current, _objectSpread({
        accordion: accordion
      }, options));
      return function () {
        instance && instance.destroy();
      };
    }
  }, [_collapsible, accordion, options, children]);
  return _react.default.createElement("ul", _extends({
    ref: _collapsible,
    className: (0, _classnames.default)(className, {
      collapsible: collapsible,
      expandable: accordion !== true,
      popout: popout
    }),
    "data-collapsible": collapsible
  }, props), _react.Children.map(children, renderItem));
};

Collapsible.propTypes = {
  
  accordion: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.node,

  
  popout: _propTypes.default.bool,

  
  defaultActiveKey: _propTypes.default.any,
  onSelect: _propTypes.default.func,

  
  options: _propTypes.default.any
};
Collapsible.defaultProps = {
  accordion: true
};
var _default = Collapsible;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CollapsibleItem = function CollapsibleItem(_ref) {
  var className = _ref.className,
      eventKey = _ref.eventKey,
      expanded = _ref.expanded,
      header = _ref.header,
      children = _ref.children,
      icon = _ref.icon,
      iconClassName = _ref.iconClassName,
      Node = _ref.node,
      onSelect = _ref.onSelect,
      props = _objectWithoutProperties(_ref, ["className", "eventKey", "expanded", "header", "children", "icon", "iconClassName", "node", "onSelect"]);

  return _react.default.createElement("li", _extends({
    className: (0, _classnames.default)(className, {
      active: expanded
    })
  }, props), _react.default.createElement(Node, {
    className: (0, _classnames.default)('collapsible-header', {
      active: expanded
    }),
    onClick: function onClick() {
      return onSelect(eventKey);
    }
  }, icon, header), _react.default.createElement("div", {
    className: "collapsible-body"
  }, children));
};

CollapsibleItem.propTypes = {
  header: _propTypes.default.any.isRequired,
  icon: _propTypes.default.node,
  iconClassName: _propTypes.default.string,
  children: _propTypes.default.node,
  onSelect: _propTypes.default.func,

  
  expanded: _propTypes.default.bool,

  
  eventKey: _propTypes.default.any,
  className: _propTypes.default.string,

  
  node: _propTypes.default.node
};
CollapsibleItem.defaultProps = {
  expanded: false,
  node: 'div'
};
var _default = CollapsibleItem;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Collection = function Collection(_ref) {
  var children = _ref.children,
      header = _ref.header,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, ["children", "header", "className"]);

  var getNodeType = (0, _react.useMemo)(function () {
    return _react.default.Children.toArray(children).some(function (child) {
      return child.props.href;
    }) ? 'div' : 'ul';
  }, [children]);
  var renderHeader = (0, _react.useMemo)(function () {
    var _header;

    if (_react.default.isValidElement(header)) {
      _header = header;
    } else {
      _header = _react.default.createElement("h4", null, header);
    }

    return _react.default.createElement("li", {
      className: "collection-header"
    }, _header);
  }, [header]);
  var C = getNodeType;
  return _react.default.createElement(C, _extends({}, other, {
    className: (0, _classnames.default)('collection', {
      'with-header': !!header
    }, className)
  }), header ? renderHeader : null, children);
};

Collection.propTypes = {
  children: _propTypes.default.node,
  header: _propTypes.default.node,
  className: _propTypes.default.string
};
var _default = Collection;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CollectionItem = function CollectionItem(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      other = _objectWithoutProperties(_ref, ["active", "children", "className", "href"]);

  var item = _react.default.createElement("li", _extends({}, other, {
    className: (0, _classnames.default)('collection-item', className)
  }), children);

  if (href) {
    item = _react.default.createElement("a", _extends({}, other, {
      href: href,
      className: (0, _classnames.default)('collection-item', {
        active: active
      }, className)
    }), children);
  }

  return item;
};

CollectionItem.propTypes = {
  active: _propTypes.default.bool,
  children: _propTypes.default.node,
  className: _propTypes.default.string,

  
  href: _propTypes.default.string
};
var _default = CollectionItem;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = function Container(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)('container', className)
  }, props));
};

Container.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string
};
var _default = Container;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _TextInput = _interopRequireDefault(__webpack_require__(175));

var _idgen = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DatePicker = function DatePicker(_ref) {
  var options = _ref.options,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["options", "onChange"]);

  var dateEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _options = onChange ? _objectSpread({}, options, {
      onSelect: onChange
    }) : options;

    var instance = M.Datepicker.init(dateEl.current, _options);
    return function () {
      instance && instance.destroy();
    };
  }, [options, onChange]);
  return _react.default.createElement(_TextInput.default, _extends({
    ref: dateEl,
    inputClassName: "datepicker"
  }, rest));
};

DatePicker.propTypes = {
  
  onChange: _propTypes.default.func,

  
  id: _propTypes.default.string,

  
  options: _propTypes.default.shape({
    
    autoClose: _propTypes.default.bool,

    
    format: _propTypes.default.string,

    
    parse: _propTypes.default.func,

    
    defaultDate: _propTypes.default.any,

    
    setDefaultDate: _propTypes.default.bool,

    
    disableWeekends: _propTypes.default.bool,

    
    disableDayFn: _propTypes.default.func,

    
    firstDay: _propTypes.default.number,

    
    minDate: _propTypes.default.any,

    
    maxDate: _propTypes.default.any,

    
    yearRange: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),

    
    isRTL: _propTypes.default.bool,

    
    showMonthAfterYear: _propTypes.default.bool,

    
    showDaysInNextAndPreviousMonths: _propTypes.default.bool,

    
    container: _propTypes.default.any,

    
    showClearBtn: _propTypes.default.bool,

    
    i18n: _propTypes.default.shape({
      cancel: _propTypes.default.string,
      clear: _propTypes.default.string,
      done: _propTypes.default.string,
      previousMonth: _propTypes.default.string,
      nextMonth: _propTypes.default.string,
      months: _propTypes.default.arrayOf(_propTypes.default.string),
      monthsShort: _propTypes.default.arrayOf(_propTypes.default.string),
      weekdays: _propTypes.default.arrayOf(_propTypes.default.string),
      weekdaysShort: _propTypes.default.arrayOf(_propTypes.default.string),
      weekdaysAbbrev: _propTypes.default.arrayOf(_propTypes.default.string)
    }),

    
    events: _propTypes.default.arrayOf(_propTypes.default.string),

    
    onSelect: _propTypes.default.func,

    
    onOpen: _propTypes.default.func,

    
    onClose: _propTypes.default.func,

    
    onDraw: _propTypes.default.func
  })
};
DatePicker.defaultProps = {
  id: "DatePicker-".concat((0, _idgen.default)()),
  options: {
    autoClose: false,
    format: 'mmm dd, yyyy',
    parse: null,
    defaultDate: null,
    setDefaultDate: false,
    disableWeekends: false,
    disableDayFn: null,
    firstDay: 0,
    minDate: null,
    maxDate: null,
    yearRange: 10,
    isRTL: false,
    showMonthAfterYear: false,
    showDaysInNextAndPreviousMonths: false,
    container: null,
    showClearBtn: false,
    i18n: {
      cancel: 'Cancel',
      clear: 'Clear',
      done: 'Ok',
      previousMonth: '‹',
      nextMonth: '›',
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdaysAbbrev: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    },
    events: [],
    onSelect: null,
    onOpen: null,
    onClose: null,
    onDraw: null
  }
};
var _default = DatePicker;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Divider = function Divider() {
  return _react.default.createElement("div", {
    className: "divider"
  });
};

var _default = Divider;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _Row = _interopRequireDefault(__webpack_require__(239));

var _Col = _interopRequireDefault(__webpack_require__(174));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Footer = function Footer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      copyrights = _ref.copyrights,
      links = _ref.links,
      moreLinks = _ref.moreLinks,
      props = _objectWithoutProperties(_ref, ["children", "className", "copyrights", "links", "moreLinks"]);

  var classes = {
    'page-footer': true
  };
  return _react.default.createElement("footer", _extends({
    className: (0, _classnames.default)(classes, className)
  }, props), _react.default.createElement("div", {
    className: "container"
  }, _react.default.createElement(_Row.default, null, _react.default.createElement(_Col.default, {
    l: 6,
    s: 12
  }, children), _react.default.createElement(_Col.default, {
    l: 4,
    s: 12,
    offset: "l2"
  }, links))), _react.default.createElement("div", {
    className: "footer-copyright"
  }, _react.default.createElement("div", {
    className: "container"
  }, copyrights, moreLinks)));
};

Footer.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  copyrights: _propTypes.default.string,
  links: _propTypes.default.node,
  moreLinks: _propTypes.default.node
};
var _default = Footer;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _idgen = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MediaBox = function MediaBox(_ref) {
  var id = _ref.id,
      options = _ref.options,
      children = _ref.children,
      className = _ref.className,
      caption = _ref.caption,
      props = _objectWithoutProperties(_ref, ["id", "options", "children", "className", "caption"]);

  var mediaBoxRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var instance = M.Materialbox.init(mediaBoxRef.current, options);
    return function () {
      if (instance) {
        instance.destroy();
      }
    };
  }, [id, options, children]);
  return _react.default.cloneElement(children, _objectSpread({
    id: id,
    ref: mediaBoxRef,
    className: (0, _classnames.default)('materialboxed', className),
    'data-caption': caption
  }, props));
};

MediaBox.propTypes = {
  children: _propTypes.default.node.isRequired,

  
  id: _propTypes.default.string,
  className: _propTypes.default.string,

  
  caption: _propTypes.default.string,
  options: _propTypes.default.shape({
    
    inDuration: _propTypes.default.number,

    
    outDuration: _propTypes.default.number,

    
    onOpenStart: _propTypes.default.func,

    
    onOpenEnd: _propTypes.default.func,

    
    onCloseStart: _propTypes.default.func,

    
    onCloseEnd: _propTypes.default.func
  })
};
MediaBox.defaultProps = {
  id: "MediaBox_".concat((0, _idgen.default)()),
  options: {
    inDuration: 275,
    outDuration: 200,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null
  }
};
var _default = MediaBox;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = __webpack_require__(25);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _idgen = _interopRequireDefault(__webpack_require__(36));

var _Button = _interopRequireDefault(__webpack_require__(238));

var _utils = __webpack_require__(909);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Modal = function Modal(_ref) {
  var actions = _ref.actions,
      bottomSheet = _ref.bottomSheet,
      children = _ref.children,
      fixedFooter = _ref.fixedFooter,
      header = _ref.header,
      className = _ref.className,
      trigger = _ref.trigger,
      options = _ref.options,
      open = _ref.open,
      root = _ref.root,
      props = _objectWithoutProperties(_ref, ["actions", "bottomSheet", "children", "fixedFooter", "header", "className", "trigger", "options", "open", "root"]);

  var _modalRoot = (0, _react.useRef)(null);

  var _modalInstance = (0, _react.useRef)(null);

  var _modalRef = (0, _react.useRef)(null);

  if (root === null) {
    console.warn('React Materialize: root should be a valid node element to render a Modal');
  }

  (0, _react.useEffect)(function () {
    var modalRoot = _modalRoot.current;

    if (!_modalInstance.current) {
      _modalInstance.current = M.Modal.init(_modalRef.current, options);
    }

    return function () {
      if (root.contains(modalRoot)) {
        root.removeChild(modalRoot);
      }

      _modalInstance.current.destroy();
    }; // deep comparing options object
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(0, _utils.safeJSONStringify)(options), root]);
  (0, _react.useEffect)(function () {
    if (open) {
      showModal();
    } else {
      hideModal();
    }
  }, [open]);

  var showModal = function showModal(e) {
    e && e.preventDefault();
    _modalInstance.current && _modalInstance.current.open();
  };

  var hideModal = function hideModal(e) {
    e && e.preventDefault();
    _modalInstance.current && _modalInstance.current.close();
  };

  var classes = (0, _classnames.default)('modal', {
    'modal-fixed-footer': fixedFooter,
    'bottom-sheet': bottomSheet
  }, className);

  var renderModalPortal = function renderModalPortal() {
    if (!_modalRoot.current) {
      _modalRoot.current = document.createElement('div');
      root.appendChild(_modalRoot.current);
    }

    return (0, _reactDom.createPortal)( _react.default.createElement("div", _extends({
      className: classes,
      ref: _modalRef
    }, props), _react.default.createElement("div", {
      className: "modal-content"
    }, _react.default.createElement("h4", null, header), children), _react.default.createElement("div", {
      className: "modal-footer"
    }, _react.Children.toArray(actions))), _modalRoot.current);
  };

  return _react.default.createElement(_react.Fragment, null, trigger && (0, _react.cloneElement)(trigger, {
    onClick: showModal
  }), renderModalPortal());
};

Modal.propTypes = {
  
  options: _propTypes.default.shape({
    
    opacity: _propTypes.default.number,

    
    inDuration: _propTypes.default.number,

    
    outDuration: _propTypes.default.number,

    
    onOpenStart: _propTypes.default.func,

    
    onOpenEnd: _propTypes.default.func,

    
    onCloseStart: _propTypes.default.func,

    
    onCloseEnd: _propTypes.default.func,

    
    preventScrolling: _propTypes.default.bool,

    
    dismissible: _propTypes.default.bool,

    
    startingTop: _propTypes.default.string,

    
    endingTop: _propTypes.default.string
  }),

  
  className: _propTypes.default.string,

  
  open: _propTypes.default.bool,

  
  bottomSheet: _propTypes.default.bool,

  
  children: _propTypes.default.node,

  
  fixedFooter: _propTypes.default.bool,

  
  header: _propTypes.default.string,

  
  trigger: _propTypes.default.node,

  
  actions: _propTypes.default.node,

  
  id: _propTypes.default.string,

  
  root: _propTypes.default.any
};
Modal.defaultProps = {
  id: "Modal-".concat((0, _idgen.default)()),
  root: typeof window !== 'undefined' ? document.body : null,
  open: false,
  options: {
    opacity: 0.5,
    inDuration: 250,
    outDuration: 250,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    preventScrolling: true,
    dismissible: true,
    startingTop: '4%',
    endingTop: '10%'
  },
  fixedFooter: false,
  bottomSheet: false,
  actions: [_react.default.createElement(_Button.default, {
    waves: "green",
    modal: "close",
    flat: true
  }, "Close")]
};
var _default = Modal;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeJSONStringify = void 0;

var safeJSONStringify = function safeJSONStringify(s) {
  try {
    return JSON.stringify(s);
  } catch (err) {
    console.error(err);
    return NaN;
  }
};

exports.safeJSONStringify = safeJSONStringify;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var NavItem = function NavItem(_ref) {
  var divider = _ref.divider,
      props = _objectWithoutProperties(_ref, ["divider"]);

  if (divider) return _react.default.createElement("li", {
    className: "divider"
  });
  return _react.default.createElement("a", props);
};

NavItem.propTypes = {
  
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  divider: _propTypes.default.bool,
  href: _propTypes.default.string,

  
  onClick: _propTypes.default.func
};
var _default = NavItem;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _Icon = _interopRequireDefault(__webpack_require__(86));

var _SearchForm = _interopRequireDefault(__webpack_require__(416));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Navbar = function Navbar(_ref) {
  var id = _ref.id,
      children = _ref.children,
      brand = _ref.brand,
      className = _ref.className,
      extendWith = _ref.extendWith,
      fixed = _ref.fixed,
      alignLinks = _ref.alignLinks,
      centerLogo = _ref.centerLogo,
      search = _ref.search,
      menuIcon = _ref.menuIcon,
      sidenav = _ref.sidenav,
      options = _ref.options,
      centerChildren = _ref.centerChildren,
      props = _objectWithoutProperties(_ref, ["id", "children", "brand", "className", "extendWith", "fixed", "alignLinks", "centerLogo", "search", "menuIcon", "sidenav", "options", "centerChildren"]);

  var _sidenav = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    var instance = M.Sidenav.init(_sidenav.current, options);
    return function () {
      instance && instance.destroy();
    };
  }, [options, children]);
  var brandClasses = (0, _classnames.default)({
    'brand-logo': true,
    right: alignLinks === 'left',
    center: centerLogo
  });
  var navCSS = (0, _classnames.default)({
    'nav-extended': extendWith
  }, className);
  var navMobileCSS = (0, _classnames.default)('hide-on-med-and-down', [alignLinks]);

  var links = _react.Children.map(children, function (link, index) {
    return _react.default.createElement("li", {
      key: index
    }, link);
  });

  var sidenavLinks = sidenav ? sidenav : _react.Children.map(children, function (link, index) {
    var clonedLink = link && link.props && link.props.id ? (0, _react.cloneElement)(link, _objectSpread({}, link.props, {
      id: "sidenav-".concat(link.props.id)
    })) : link;
    return _react.default.createElement("li", {
      key: index
    }, clonedLink);
  });

  var navbar = _react.default.createElement("nav", _extends({
    className: navCSS
  }, props), _react.default.createElement("div", {
    className: (0, _classnames.default)({
      container: centerChildren
    }, 'nav-wrapper')
  }, search ? _react.default.createElement(_SearchForm.default, null) : _react.default.createElement(_react.Fragment, null, brand && (0, _react.cloneElement)(brand, {
    className: (0, _classnames.default)(brand.props.className, brandClasses)
  }), _react.default.createElement("a", {
    href: "#!",
    "data-target": id,
    className: "sidenav-trigger"
  }, menuIcon), _react.default.createElement("ul", {
    className: navMobileCSS
  }, links))), extendWith && _react.default.createElement("div", {
    className: "nav-content"
  }, extendWith));

  if (fixed) {
    navbar = _react.default.createElement("div", {
      className: "navbar-fixed"
    }, navbar);
  }

  return _react.default.createElement(_react.Fragment, null, navbar, _react.default.createElement("ul", {
    id: id,
    className: (0, _classnames.default)('sidenav', [alignLinks]),
    ref: _sidenav
  }, sidenavLinks));
};

Navbar.propTypes = {
  
  id: _propTypes.default.string,
  brand: _propTypes.default.node,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  extendWith: _propTypes.default.node,
  search: _propTypes.default.bool,

  
  sidenav: _propTypes.default.node,

  
  alignLinks: _propTypes.default.oneOf(['left', 'right']),

  
  centerLogo: _propTypes.default.bool,

  
  centerChildren: _propTypes.default.bool,

  
  fixed: _propTypes.default.bool,

  
  options: _propTypes.default.shape({
    // Side of screen on which Sidenav appears.
    edge: _propTypes.default.oneOf(['left', 'right']),
    // Allow swipe gestures to open / close Sidenav.
    draggable: _propTypes.default.bool,
    // Length in ms of enter transition.
    inDuration: _propTypes.default.number,
    // Length in ms of exit transition.
    outDuration: _propTypes.default.number,
    // Function called when sidenav starts entering.
    onOpenStart: _propTypes.default.func,
    // Function called when sidenav finishes entering.
    onOpenEnd: _propTypes.default.func,
    // Function called when sidenav starts exiting.
    onCloseStart: _propTypes.default.func,
    // Function called when sidenav finishes exiting.
    onCloseEnd: _propTypes.default.func,
    // Prevent page from scrolling while sidenav is open.
    preventScrolling: _propTypes.default.bool
  }),
  menuIcon: _propTypes.default.node.isRequired
};
Navbar.defaultProps = {
  id: 'mobile-nav',
  options: {
    edge: 'left',
    draggable: true,
    inDuration: 250,
    outDuration: 200,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    preventScrolling: true
  },
  menuIcon: _react.default.createElement(_Icon.default, null, "menu")
};
var _default = Navbar;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _Icon = _interopRequireDefault(__webpack_require__(86));

var _PaginationButton = _interopRequireDefault(__webpack_require__(417));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Pagination = function Pagination(_ref) {
  var items = _ref.items,
      className = _ref.className,
      children = _ref.children,
      _ref$maxButtons = _ref.maxButtons,
      maxButtons = _ref$maxButtons === void 0 ? items : _ref$maxButtons,
      leftBtn = _ref.leftBtn,
      rightBtn = _ref.rightBtn,
      onSelect = _ref.onSelect,
      activePageProp = _ref.activePage;

  var _useState = (0, _react.useState)(activePageProp > 0 && activePageProp <= items ? activePageProp : 1),
      _useState2 = _slicedToArray(_useState, 2),
      activePage = _useState2[0],
      setActivePage = _useState2[1];

  (0, _react.useEffect)(function () {
    setActivePage(activePageProp);
  }, [activePageProp]);
  var onClick = (0, _react.useCallback)(function (pageIdx) {
    if (pageIdx > 0 && pageIdx <= items) {
      if (onSelect) onSelect(pageIdx);
      setActivePage(pageIdx);
    }
  }, [onSelect, items]);
  var renderButtons = (0, _react.useMemo)(function () {
    if (children) return children;
    var buttonsCount = Math.min(maxButtons, items);
    var maxPos = items - buttonsCount;
    var halfButtons = parseInt(buttonsCount / 2, 10);
    var hiddenPagesBefore = activePage - halfButtons;

    if (hiddenPagesBefore > maxPos) {
      hiddenPagesBefore = maxPos + 1;
    }

    var from = Math.max(hiddenPagesBefore, 1);
    var to = Math.min(items, from + maxButtons - 1);
    var buttons = [_react.default.createElement(_PaginationButton.default, {
      disabled: activePage === 1,
      key: 'pagination-0',
      onSelect: function onSelect() {
        return onClick(activePage - 1);
      }
    }, leftBtn)];

    var _loop = function _loop(i) {
      buttons.push( _react.default.createElement(_PaginationButton.default, {
        active: i === activePage,
        key: "pagination-".concat(i),
        onSelect: function onSelect() {
          return onClick(i);
        }
      }, i));
    };

    for (var i = from; i <= to; i++) {
      _loop(i);
    }

    buttons.push( _react.default.createElement(_PaginationButton.default, {
      key: "pagination-".concat(items + 1),
      disabled: activePage === items,
      onSelect: function onSelect() {
        return onClick(activePage + 1);
      }
    }, rightBtn));
    return buttons;
  }, [children, maxButtons, items, activePage, onClick, leftBtn, rightBtn]);
  return _react.default.createElement("ul", {
    className: (0, _classnames.default)('pagination', className)
  }, renderButtons);
};

Pagination.propTypes = {
  
  items: _propTypes.default.number.isRequired,

  
  activePage: _propTypes.default.number,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  maxButtons: _propTypes.default.number,
  onSelect: _propTypes.default.func,
  leftBtn: _propTypes.default.node,
  rightBtn: _propTypes.default.node
};
Pagination.defaultProps = {
  activePage: 1,
  items: 10,
  leftBtn: _react.default.createElement(_Icon.default, null, "chevron_left"),
  rightBtn: _react.default.createElement(_Icon.default, null, "chevron_right")
};
var _default = Pagination;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Parallax = function Parallax(_ref) {
  var children = _ref.children,
      className = _ref.className,
      image = _ref.image,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, ["children", "className", "image", "options"]);

  var _parallax = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    var instance = M.Parallax.init(_parallax.current, options);
    return function () {
      instance && instance.destroy();
    };
  }, [_parallax, options, children, image]);
  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)('parallax-container', className)
  }, props), children, _react.default.createElement("div", {
    className: "parallax",
    ref: _parallax
  }, image));
};

Parallax.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,

  
  image: _propTypes.default.node.isRequired,
  options: _propTypes.default.shape({
    
    responsiveThreshold: _propTypes.default.number
  })
};
Parallax.defaultProps = {
  options: {
    responsiveThreshold: 0
  }
};
var _default = Parallax;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _Spinner = _interopRequireDefault(__webpack_require__(418));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colors = ['blue', 'red', 'yellow', 'green'];

var Preloader = function Preloader(_ref) {
  var active = _ref.active,
      size = _ref.size,
      color = _ref.color,
      flashing = _ref.flashing,
      className = _ref.className;
  var classes = (0, _classnames.default)('preloader-wrapper', {
    active: active
  }, size);
  var spinners;

  if (flashing) {
    spinners = colors.map(function (color) {
      return _react.default.createElement(_Spinner.default, {
        color: color,
        only: false,
        key: color
      });
    });
  } else {
    spinners = _react.default.createElement(_Spinner.default, {
      color: color
    });
  }

  return _react.default.createElement("div", {
    className: (0, _classnames.default)(className, classes)
  }, spinners);
};

Preloader.propTypes = {
  className: _propTypes.default.string,

  
  size: _propTypes.default.oneOf(['big', 'small', 'medium']),

  
  active: _propTypes.default.bool,

  
  color: _propTypes.default.oneOf(['blue', 'red', 'yellow', 'green']),

  
  flashing: _propTypes.default.bool
};
Preloader.defaultProps = {
  active: true,
  flashing: false,
  color: 'blue'
};
var _default = Preloader;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress,
      className = _ref.className;
  var style;
  var classes = {
    indeterminate: progress === undefined,
    determinate: !!progress
  };

  if (progress) {
    style = {
      width: progress + '%'
    };
  }

  return _react.default.createElement("div", {
    className: (0, _classnames.default)('progress lighten-5', className)
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)(classes, className),
    style: style
  }));
};

ProgressBar.propTypes = {
  className: _propTypes.default.string,

  
  progress: _propTypes.default.number
};
var _default = ProgressBar;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RadioGroup = function RadioGroup(_ref) {
  var onChange = _ref.onChange,
      withGap = _ref.withGap,
      disabled = _ref.disabled,
      name = _ref.name,
      radioClassNames = _ref.radioClassNames,
      value = _ref.value,
      options = _ref.options;
  return _react.default.createElement(_react.default.Fragment, null, options.map(function (radioItem, idx) {
    return _react.default.createElement("label", {
      className: radioClassNames,
      htmlFor: "radio".concat(idx),
      key: "radio".concat(idx)
    }, _react.default.createElement("input", {
      id: "radio".concat(idx),
      value: radioItem.value,
      type: "radio",
      checked: radioItem.value === value,
      name: name,
      onChange: onChange,
      disabled: disabled,
      className: (0, _classnames.default)({
        'with-gap': withGap
      })
    }), _react.default.createElement("span", null, radioItem.label));
  }));
};

RadioGroup.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired
  })).isRequired,

  
  value: _propTypes.default.string,

  
  name: _propTypes.default.string,

  
  withGap: _propTypes.default.bool,

  
  onChange: _propTypes.default.func,

  
  disabled: _propTypes.default.bool,

  
  radioClassNames: _propTypes.default.string
};
var _default = RadioGroup;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Range = function Range(_ref) {
  var min = _ref.min,
      max = _ref.max,
      step = _ref.step;
  var rangeRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var instance = M.Range.init(rangeRef.current);
    return function () {
      instance && instance.destroy();
    };
  }, [min, max]);
  return _react.default.createElement("p", {
    className: "range-field"
  }, _react.default.createElement("input", {
    type: "range",
    ref: rangeRef,
    min: min,
    max: max,
    step: step
  }));
};

Range.propTypes = {
  min: _propTypes.default.string.isRequired,
  max: _propTypes.default.string.isRequired,
  step: _propTypes.default.string
};
var _default = Range;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Section = function Section(_ref) {
  var _ref$node = _ref.node,
      node = _ref$node === void 0 ? 'div' : _ref$node,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["node", "className"]);

  var Component = node;
  return _react.default.createElement(Component, _extends({
    className: (0, _classnames.default)('section', className)
  }, rest));
};

Section.propTypes = {
  children: _propTypes.default.node,
  node: _propTypes.default.node,
  id: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = Section;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _idgen = _interopRequireDefault(__webpack_require__(36));

var _constants = _interopRequireDefault(__webpack_require__(66));

var _Dropdown = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Select = function Select(_ref) {
  var id = _ref.id,
      s = _ref.s,
      m = _ref.m,
      l = _ref.l,
      xl = _ref.xl,
      noLayout = _ref.noLayout,
      browserDefault = _ref.browserDefault,
      icon = _ref.icon,
      label = _ref.label,
      className = _ref.className,
      success = _ref.success,
      error = _ref.error,
      validate = _ref.validate,
      children = _ref.children,
      multiple = _ref.multiple,
      options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["id", "s", "m", "l", "xl", "noLayout", "browserDefault", "icon", "label", "className", "success", "error", "validate", "children", "multiple", "options", "value", "onChange"]);

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      selectedValue = _useState2[0],
      setSelectedValue = _useState2[1];

  var _selectRef = (0, _react.useRef)(null);

  var _formSelectInstance = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    _formSelectInstance.current = M.FormSelect.init(_selectRef.current, options);
    return function () {
      _formSelectInstance.current && _formSelectInstance.current.destroy();
    };
  }, [options, children]);
  (0, _react.useEffect)(function () {
    setSelectedValue(value);
  }, [value]);
  var sizes = {
    s: s,
    m: m,
    l: l,
    xl: xl
  };
  var responsiveClasses = {};

  if (!noLayout) {
    responsiveClasses = {
      col: true
    };

    _constants.default.SIZES.forEach(function (size) {
      responsiveClasses[size + sizes[size]] = sizes[size];
    });
  }

  var renderOption = function renderOption(child) {
    return (0, _react.cloneElement)(child, {
      key: child.props.value
    });
  };

  var handleChange = function handleChange(e) {
    var value = e.target.value;

    if (multiple) {
      value = _formSelectInstance.current.getSelectedValues();
    }

    onChange && onChange(e);
    setSelectedValue(value);
  };

  return _react.default.createElement("div", {
    className: (0, _classnames.default)('input-field', responsiveClasses)
  }, Boolean(icon) && (0, _react.cloneElement)(icon, {
    className: 'prefix'
  }), _react.default.createElement("select", _extends({}, props, {
    type: "select",
    id: id,
    value: selectedValue,
    ref: _selectRef,
    onChange: handleChange,
    className: (0, _classnames.default)(className, _defineProperty({
      validate: validate,
      multiple: multiple
    }, 'browser-default', browserDefault)),
    multiple: multiple
  }), _react.Children.map(children, renderOption)), Boolean(label) && _react.default.createElement("label", {
    "data-success": success,
    "data-error": error,
    htmlFor: id
  }, label));
};

Select.propTypes = {
  
  browserDefault: _propTypes.default.bool,

  
  noLayout: _propTypes.default.bool,

  
  s: _propTypes.default.number,

  
  m: _propTypes.default.number,

  
  l: _propTypes.default.number,

  
  xl: _propTypes.default.number,

  
  disabled: _propTypes.default.bool,

  
  id: _propTypes.default.string,

  
  icon: _propTypes.default.node,

  
  label: _propTypes.default.string,

  
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),

  
  validate: _propTypes.default.bool,

  
  success: _propTypes.default.string,

  
  error: _propTypes.default.string,

  
  className: _propTypes.default.string,

  
  type: _propTypes.default.string,

  
  onChange: _propTypes.default.func,

  
  multiple: _propTypes.default.bool,
  children: _propTypes.default.any,

  
  options: _propTypes.default.shape({
    classes: _propTypes.default.string,

    
    dropdownOptions: _Dropdown.dropdownOptions
  })
};
Select.defaultProps = {
  id: "Select-".concat((0, _idgen.default)()),
  multiple: false,
  options: {
    classes: '',
    dropdownOptions: {
      alignment: 'left',
      autoTrigger: true,
      constrainWidth: true,
      coverTrigger: true,
      closeOnClick: true,
      hover: false,
      inDuration: 150,
      outDuration: 250,
      onOpenStart: null,
      onOpenEnd: null,
      onCloseStart: null,
      onCloseEnd: null
    }
  }
};
var _default = Select;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _idgen = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SideNav = function SideNav(_ref) {
  var options = _ref.options,
      id = _ref.id,
      className = _ref.className,
      children = _ref.children,
      trigger = _ref.trigger,
      fixed = _ref.fixed,
      props = _objectWithoutProperties(_ref, ["options", "id", "className", "children", "trigger", "fixed"]);

  var sidenavRef = (0, _react.useRef)(null);
  var triggerRef = (0, _react.useRef)(null);
  var classNames = (0, _classnames.default)('sidenav', {
    'sidenav-fixed': fixed || !trigger
  }, className);
  (0, _react.useEffect)(function () {
    var instance = M.Sidenav.init(sidenavRef.current, options);
    return function () {
      return instance.destroy();
    };
  }, [options, children]);
  var renderTrigger = (0, _react.useMemo)(function () {
    if (!trigger) return;
    var triggerView = fixed ? 'hide-on-large-only' : 'show-on-large';
    var classNames = (0, _classnames.default)(trigger.props.className, triggerView, 'sidenav-trigger');
    return _react.default.cloneElement(trigger, {
      ref: triggerRef,
      'data-target': id,
      className: classNames
    });
  }, [id, fixed, trigger]);
  return _react.default.createElement(_react.Fragment, null, renderTrigger, _react.default.createElement("ul", _extends({
    ref: function ref(el) {
      return sidenavRef.current = el;
    },
    id: id,
    className: classNames
  }, props), children));
};

SideNav.propTypes = {
  
  fixed: _propTypes.default.bool,

  
  id: _propTypes.default.string,

  
  trigger: _propTypes.default.node,

  
  options: _propTypes.default.shape({
    edge: _propTypes.default.oneOf(['left', 'right']),
    draggable: _propTypes.default.bool,
    inDuration: _propTypes.default.number,
    outDuration: _propTypes.default.number,
    onOpenStart: _propTypes.default.func,
    onOpenEnd: _propTypes.default.func,
    onCloseStart: _propTypes.default.func,
    onCloseEnd: _propTypes.default.func,
    preventScrolling: _propTypes.default.bool
  }),

  
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
SideNav.defaultProps = {
  id: "SideNav-".concat((0, _idgen.default)())
};
var _default = SideNav;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _UserView = _interopRequireWildcard(__webpack_require__(922));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SideNavItem = function SideNavItem(_ref) {
  var divider = _ref.divider,
      subheader = _ref.subheader,
      userView = _ref.userView,
      icon = _ref.icon,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '#!' : _ref$href,
      waves = _ref.waves,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["divider", "subheader", "userView", "icon", "href", "waves", "user", "children"]);

  var itemClasses = {
    divider: divider
  };
  var linkClasses = {
    subheader: subheader,
    'waves-effect': waves
  };
  return _react.default.createElement("li", _extends({
    className: (0, _classnames.default)(itemClasses)
  }, props), userView && user && _react.default.createElement(_UserView.default, user), !userView && _react.default.createElement("a", {
    className: (0, _classnames.default)(linkClasses),
    href: href
  }, icon && _react.default.cloneElement(icon, {
    className: 'prefix'
  }), children));
};

SideNavItem.propTypes = {
  children: _propTypes.default.node,
  divider: _propTypes.default.bool,
  subheader: _propTypes.default.bool,
  userView: _propTypes.default.bool,
  waves: _propTypes.default.bool,
  href: _propTypes.default.string,
  icon: _propTypes.default.node,
  user: _propTypes.default.shape(_UserView.UserShape)
};
var _default = SideNavItem;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UserShape = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserShape = {
  background: _propTypes.default.string,
  image: _propTypes.default.string,
  name: _propTypes.default.string,
  email: _propTypes.default.string
};
exports.UserShape = UserShape;

var UserView = function UserView(_ref) {
  var background = _ref.background,
      image = _ref.image,
      name = _ref.name,
      email = _ref.email;
  return _react.default.createElement("div", {
    className: "user-view"
  }, background && _react.default.createElement("div", {
    className: "background"
  }, _react.default.createElement("img", {
    src: background
  })), image && _react.default.createElement("a", {
    href: "#!user"
  }, _react.default.createElement("img", {
    className: "circle",
    src: image
  })), name && _react.default.createElement("a", {
    href: "#!name"
  }, _react.default.createElement("span", {
    className: "white-text name"
  }, name)), email && _react.default.createElement("a", {
    href: "#!email"
  }, _react.default.createElement("span", {
    className: "white-text email"
  }, email)));
};

UserView.propTypes = UserShape;
var _default = UserView;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slide = function Slide(_ref) {
  var image = _ref.image,
      children = _ref.children;
  return _react.default.createElement("li", null, image, children);
};

Slide.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,

  
  image: _propTypes.default.node.isRequired
};
var _default = Slide;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Slider = function Slider(_ref) {
  var children = _ref.children,
      className = _ref.className,
      options = _ref.options,
      fullscreen = _ref.fullscreen,
      props = _objectWithoutProperties(_ref, ["children", "className", "options", "fullscreen"]);

  var sliderInstance = (0, _react.useRef)(null);

  var _slider = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  (0, _react.useEffect)(function () {
    sliderInstance.current = M.Slider.init(_slider.current, options);
    return function () {
      if (sliderInstance.current) {
        setActiveIndex(sliderInstance.current.activeIndex);
        sliderInstance.current.destroy();
      }
    };
  }, [_slider, options, fullscreen, children]);
  (0, _react.useEffect)(function () {
    if (activeIndex) {
      if (typeof indicators === 'undefined' || options.indicators) {
        sliderInstance.current['$indicators'][activeIndex].className = 'indicator-item active';
      }
    }
  }, [activeIndex, options.indicators, fullscreen]);
  

  (0, _react.useEffect)(function () {
    if (fullscreen) {
      _slider.current.removeAttribute('style');

      _slider.current.childNodes[0].removeAttribute('style');
    }
  }, [fullscreen]);
  return _react.default.createElement("div", _extends({
    ref: _slider,
    className: (0, _classnames.default)('slider', className, {
      fullscreen: fullscreen
    })
  }, props), _react.default.createElement("ul", {
    className: "slides"
  }, children));
};

Slider.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,

  
  fullscreen: _propTypes.default.bool,
  options: _propTypes.default.shape({
    
    indicators: _propTypes.default.bool,

    
    interval: _propTypes.default.number,

    
    duration: _propTypes.default.number,

    
    height: _propTypes.default.number
  })
};
Slider.defaultProps = {
  fullscreen: false,
  options: {
    indicators: true,
    interval: 6000,
    duration: 500,
    height: 400
  }
};
var _default = Slider;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _idgen = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Switch = function Switch(_ref) {
  var id = _ref.id,
      offLabel = _ref.offLabel,
      onLabel = _ref.onLabel,
      props = _objectWithoutProperties(_ref, ["id", "offLabel", "onLabel"]);

  return _react.default.createElement("div", {
    className: "switch"
  }, _react.default.createElement("label", {
    htmlFor: id
  }, offLabel, _react.default.createElement("input", _extends({
    id: id,
    type: "checkbox"
  }, props)), _react.default.createElement("span", {
    className: "lever"
  }), onLabel));
};

Switch.propTypes = {
  
  id: _propTypes.default.string,
  className: _propTypes.default.string,

  
  offLabel: _propTypes.default.string.isRequired,

  
  onLabel: _propTypes.default.string.isRequired,

  
  onChange: _propTypes.default.func,

  
  disabled: _propTypes.default.bool,

  
  checked: _propTypes.default.bool
};
Switch.defaultProps = {
  id: "Switch-".concat((0, _idgen.default)()),
  onChange: function onChange() {}
};
var _default = Switch;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Table = function Table(_ref) {
  var centered = _ref.centered,
      children = _ref.children,
      className = _ref.className,
      hoverable = _ref.hoverable,
      responsive = _ref.responsive,
      striped = _ref.striped,
      props = _objectWithoutProperties(_ref, ["centered", "children", "className", "hoverable", "responsive", "striped"]);

  var classes = {
    centered: centered,
    highlight: hoverable,
    'responsive-table': responsive,
    striped: striped
  };
  return _react.default.createElement("table", _extends({
    className: (0, _classnames.default)(classes, className)
  }, props), children);
};

Table.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,

  
  centered: _propTypes.default.bool,

  
  hoverable: _propTypes.default.bool,

  
  responsive: _propTypes.default.bool,

  
  striped: _propTypes.default.bool
};
var _default = Table;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _idgen = _interopRequireDefault(__webpack_require__(36));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _Row = _interopRequireDefault(__webpack_require__(239));

var _Tab = _interopRequireDefault(__webpack_require__(419));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var scope = "tabs-".concat((0, _idgen.default)());

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      className = _ref.className,
      defaultValue = _ref.defaultValue,
      options = _ref.options,
      onChange = _ref.onChange;

  var _tabsRef = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    var instance = M.Tabs.init(_tabsRef.current, options);
    return function () {
      return instance.destroy();
    };
  }, [options, children]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("ul", {
    className: (0, _classnames.default)('tabs', className),
    ref: _tabsRef
  }, _react.default.Children.map(children, function (child, id) {
    var _classes;

    var idx = "".concat(scope).concat(id);
    var _child$props = child.props,
        active = _child$props.active,
        disabled = _child$props.disabled,
        tabWidth = _child$props.tabWidth,
        title = _child$props.title;
    var classes = (_classes = {}, _defineProperty(_classes, "s".concat(tabWidth), tabWidth), _defineProperty(_classes, "tab", true), _defineProperty(_classes, "disabled", disabled), _defineProperty(_classes, "col", true), _classes);
    return _react.default.createElement("li", {
      className: (0, _classnames.default)(classes),
      key: idx
    }, _react.default.createElement("a", _extends({
      href: "#tab_".concat(idx),
      className: active || defaultValue === idx ? 'active' : ''
    }, disabled ? {} : {
      onClick: onChange
    }), title));
  })), _react.default.createElement(_Row.default, null, _react.default.Children.map(children, function (child, id) {
    var idx = "".concat(scope).concat(id);
    return (0, _react.cloneElement)(child, {
      idx: idx
    });
  })));
};

Tabs.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  onChange: _propTypes.default.func,

  
  options: _propTypes.default.shape({
    
    duration: _propTypes.default.number,

    
    onShow: _propTypes.default.func,

    
    swipeable: _propTypes.default.bool,

    
    responsiveThreshold: _propTypes.default.number
  })
};
_Tab.default.defaultProps = {
  options: {
    duration: 300,
    onShow: null,
    swipeable: false,
    responsiveThreshold: Infinity
  }
};
var _default = Tabs;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _idgen = _interopRequireDefault(__webpack_require__(36));

var _constants = _interopRequireDefault(__webpack_require__(66));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Textarea = function Textarea(_ref) {
  var children = _ref.children,
      className = _ref.className,
      s = _ref.s,
      m = _ref.m,
      l = _ref.l,
      xl = _ref.xl,
      noLayout = _ref.noLayout,
      placeholder = _ref.placeholder,
      icon = _ref.icon,
      label = _ref.label,
      success = _ref.success,
      error = _ref.error,
      iconClassName = _ref.iconClassName,
      onChange = _ref.onChange,
      validate = _ref.validate,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, ["children", "className", "s", "m", "l", "xl", "noLayout", "placeholder", "icon", "label", "success", "error", "iconClassName", "onChange", "validate", "defaultValue", "value", "id"]);

  var textareaRef = (0, _react.useRef)(null);
  var dataLength = rest['data-length'];
  (0, _react.useEffect)(function () {
    if (dataLength) {
      M.CharacterCounter.init(textareaRef.current);
    }
  }, [dataLength, children]);
  (0, _react.useEffect)(function () {
    M.textareaAutoResize(textareaRef.current);
  }, [children]);
  var sizes = {
    s: s,
    m: m,
    l: l,
    xl: xl
  };
  var responsiveClasses;

  if (!noLayout) {
    responsiveClasses = {
      col: true
    };

    _constants.default.SIZES.forEach(function (size) {
      responsiveClasses[size + sizes[size]] = sizes[size];
    });
  }

  return _react.default.createElement("div", {
    className: (0, _classnames.default)('input-field', responsiveClasses)
  }, Boolean(icon) && _react.default.cloneElement(icon, {
    className: 'prefix'
  }), _react.default.createElement("textarea", _extends({
    placeholder: placeholder,
    id: id,
    value: value,
    defaultValue: defaultValue,
    ref: textareaRef,
    onChange: onChange
  }, rest, {
    className: (0, _classnames.default)('materialize-textarea', {
      validate: validate
    }, className)
  })), Boolean(label) && _react.default.createElement("label", {
    className: (0, _classnames.default)({
      active: value || placeholder,
      'label-icon': typeof label !== 'string'
    }),
    "data-success": success,
    "data-error": error,
    htmlFor: id
  }, label), [error || success] && _react.default.createElement("span", {
    className: "helper-text",
    "data-error": error,
    "data-success": success
  }), children);
};

Textarea.propTypes = {
  children: _propTypes.default.node,

  
  noLayout: _propTypes.default.bool,

  
  s: _propTypes.default.number,

  
  m: _propTypes.default.number,

  
  l: _propTypes.default.number,

  
  xl: _propTypes.default.number,

  
  disabled: _propTypes.default.bool,

  
  placeholder: _propTypes.default.string,

  
  id: _propTypes.default.string,

  
  icon: _propTypes.default.node,

  
  iconClassName: _propTypes.default.string,

  
  label: _propTypes.default.string,

  
  defaultValue: _propTypes.default.string,

  
  value: _propTypes.default.string,

  
  validate: _propTypes.default.bool,

  
  success: _propTypes.default.string,

  
  error: _propTypes.default.string,

  
  className: _propTypes.default.string,

  
  onChange: _propTypes.default.func
};
Textarea.defaultProps = {
  id: "Textarea-".concat((0, _idgen.default)())
};
var _default = Textarea;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _TextInput = _interopRequireDefault(__webpack_require__(175));

var _idgen = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TimePicker = function TimePicker(_ref) {
  var onChange = _ref.onChange,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, ["onChange", "options"]);

  var timeEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _options = onChange ? _objectSpread({}, options, {
      onSelect: onChange
    }) : options;

    var instance = M.Timepicker.init(timeEl.current, _options);
    return function () {
      instance && instance.destroy();
    };
  }, [options, onChange]);
  return _react.default.createElement(_TextInput.default, _extends({
    ref: timeEl,
    inputClassName: "timepicker"
  }, props));
};

TimePicker.propTypes = {
  
  onChange: _propTypes.default.func,

  
  id: _propTypes.default.string,

  
  options: _propTypes.default.shape({
    
    duration: _propTypes.default.number,

    
    container: _propTypes.default.string,

    
    showClearBtn: _propTypes.default.bool,

    
    defaultTime: _propTypes.default.string,

    
    fromNow: _propTypes.default.number,

    
    i18n: _propTypes.default.shape({
      cancel: _propTypes.default.string,
      clear: _propTypes.default.string,
      done: _propTypes.default.string
    }),

    
    autoClose: _propTypes.default.bool,

    
    twelveHour: _propTypes.default.bool,

    
    vibrate: _propTypes.default.bool,

    
    onOpenStart: _propTypes.default.func,

    
    onOpenEnd: _propTypes.default.func,

    
    onCloseStart: _propTypes.default.func,

    
    onCloseEnd: _propTypes.default.func,

    
    onSelect: _propTypes.default.func
  })
};
TimePicker.defaultProps = {
  id: "TimePicker-".concat((0, _idgen.default)()),
  options: {
    duration: 350,
    container: null,
    showClearBtn: false,
    defaultTime: 'now',
    fromNow: 0,
    i18n: {
      cancel: 'Cancel',
      clear: 'Clear',
      done: 'Ok'
    },
    autoClose: false,
    twelveHour: true,
    vibrate: true,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    onSelect: null
  }
};
var _default = TimePicker;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _Button = _interopRequireDefault(__webpack_require__(238));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toast = function Toast(props) {
  var children = props.children,
      className = props.className,
      _props$options = props.options,
      options = _props$options === void 0 ? {} : _props$options;

  var showToast = function showToast() {
    return typeof M !== 'undefined' ? M.toast(options) : null;
  };

  return _react.default.createElement(_Button.default, {
    onClick: showToast,
    className: (0, _classnames.default)('toast', className)
  }, children);
};

Toast.propTypes = {
  className: _propTypes.default.string,

  
  children: _propTypes.default.node,

  
  options: _propTypes.default.shape({
    
    html: _propTypes.default.string,

    
    displayLength: _propTypes.default.number,

    
    inDuration: _propTypes.default.number,

    
    outDuration: _propTypes.default.number,

    
    classes: _propTypes.default.string,

    
    completeCallback: _propTypes.default.func,

    
    activationPercent: _propTypes.default.number
  })
};
var _default = Toast;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/requestConnectionIcon.bf09b3f0.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(933);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components_IntroductionCard__ = __webpack_require__(934);
function mapStateToProps(state){return{literals:state.i18n.literals.introductionCard||{},app:state.app};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_IntroductionCard__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(935);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IntroductionCard=function(_Component){_inherits(IntroductionCard,_Component);function IntroductionCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IntroductionCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IntroductionCard.__proto__||Object.getPrototypeOf(IntroductionCard)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(){var onClick=_this.props.onClick;if(onClick){onClick();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IntroductionCard,[{key:'render',value:function render(){var _props=this.props,title=_props.title,literals=_props.literals;var sizeTitle=18;if(title.length<=20){sizeTitle=18;}else if(title.length<=70){sizeTitle=16;}else{sizeTitle=14;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["d" ],{dangerouslySetInnerHTML:{__html:title},size:sizeTitle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-animation-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-smile-beam'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-animation-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-frown-open'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-animation-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-smile-beam'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" ],{type:'nope'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" ],{type:'yup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["c" ],{type:'nope'},literals.swipeLeft),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["c" ],{type:'yup'},literals.swipeRight));}}]);return IntroductionCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);IntroductionCard.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};IntroductionCard.defaultProps={onClick:null}; __webpack_exports__["a"] = (IntroductionCard);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return Title; });

 __webpack_require__.d(__webpack_exports__, "c", function() { return Description; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return Button; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationSwipe; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_speed_dating_user_card_placeholder_png__ = __webpack_require__(936);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_speed_dating_user_card_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_speed_dating_user_card_placeholder_png__);
var _templateObject=_taggedTemplateLiteral(['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n\n  }\n\n'],['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n\n  }\n\n']),_templateObject2=_taggedTemplateLiteral(['\n  color: #444;\n  font-size: ','px;\n  font-family: \'helvetica neue\';\n  font-weight: 600;\n  position: relative;\n  width: 90%;\n  padding-top: 5rem;\n  left: 5%;\n  right: 5%;\n  text-align: center;\n  strong {\n    font-family: ',';\n    color: #444;\n    font-weight: 100;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n'],['\n  color: #444;\n  font-size: ','px;\n  font-family: \'helvetica neue\';\n  font-weight: 600;\n  position: relative;\n  width: 90%;\n  padding-top: 5rem;\n  left: 5%;\n  right: 5%;\n  text-align: center;\n  strong {\n    font-family: ',';\n    color: #444;\n    font-weight: 100;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: relative;\n  width: 90%;\n  margin-top: 5%;\n  left: 5%;\n  right: 5%;\n  height: 30vh;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n'],['\n  position: relative;\n  width: 90%;\n  margin-top: 5%;\n  left: 5%;\n  right: 5%;\n  height: 30vh;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  right: ',';\n  left: ',';\n  text-align: ',';\n  width: 40%;\n  top: 47rem;\n  color: #444;\n  font-size: 18px;\n  font-family: \'helvetica neue light\';\n'],['\n  position: absolute;\n  right: ',';\n  left: ',';\n  text-align: ',';\n  width: 40%;\n  top: 47rem;\n  color: #444;\n  font-size: 18px;\n  font-family: \'helvetica neue light\';\n']),_templateObject5=_taggedTemplateLiteral(['\n  background-color: ',';\n  width: 10rem;\n  height: 4.5rem;\n  border-radius: 4rem;\n  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);\n  text-align: center;\n  padding-top: 0.8rem;\n  cursor: pointer;\n  display: inline-block;\n  position: absolute;\n  top: 41rem;\n  right: ',';\n  left: ',';\n  margin-right: 1rem;\n  margin-left: 1rem;\n  i {\n    font-size: 3rem;\n    color: #fff;\n    text-shadow: 0 0 0.1rem #000;\n    margin: 0 1rem;\n  }\n'],['\n  background-color: ',';\n  width: 10rem;\n  height: 4.5rem;\n  border-radius: 4rem;\n  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);\n  text-align: center;\n  padding-top: 0.8rem;\n  cursor: pointer;\n  display: inline-block;\n  position: absolute;\n  top: 41rem;\n  right: ',';\n  left: ',';\n  margin-right: 1rem;\n  margin-left: 1rem;\n  i {\n    font-size: 3rem;\n    color: #fff;\n    text-shadow: 0 0 0.1rem #000;\n    margin: 0 1rem;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  0% {\n    ','\n  }\n\n  7% {\n    ','\n  }\n\n  8% {\n    ','\n  }\n\n  20% {\n    ','\n  }\n\n  30% {\n    ','\n  }\n\n  32% {\n    ','\n  }\n\n  33% {\n    ','\n  }\n\n  63% {\n    ','\n  }\n\n  66% {\n    ','\n  }\n\n  97% {\n    ','\n  }\n\n  100% {\n    ','\n  }\n'],['\n  0% {\n    ','\n  }\n\n  7% {\n    ','\n  }\n\n  8% {\n    ','\n  }\n\n  20% {\n    ','\n  }\n\n  30% {\n    ','\n  }\n\n  32% {\n    ','\n  }\n\n  33% {\n    ','\n  }\n\n  63% {\n    ','\n  }\n\n  66% {\n    ','\n  }\n\n  97% {\n    ','\n  }\n\n  100% {\n    ','\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  animation: ',' ',' linear infinite;\n'],['\n  animation: ',' ',' linear infinite;\n']),_templateObject8=_taggedTemplateLiteral(['\n  0% {\n    ','\n  }\n\n  30% {\n    ','\n  }\n\n  33% {\n    ','\n  }\n\n  40% {\n    ','\n  }\n\n  41% {\n    ','\n  }\n\n  53% {\n    ','\n  }\n\n  63% {\n    ','\n  }\n\n  65% {\n    ','\n  }\n\n  66% {\n    ','\n  }\n\n  97% {\n    ','\n  }\n\n  100% {\n    ','\n  }\n'],['\n  0% {\n    ','\n  }\n\n  30% {\n    ','\n  }\n\n  33% {\n    ','\n  }\n\n  40% {\n    ','\n  }\n\n  41% {\n    ','\n  }\n\n  53% {\n    ','\n  }\n\n  63% {\n    ','\n  }\n\n  65% {\n    ','\n  }\n\n  66% {\n    ','\n  }\n\n  97% {\n    ','\n  }\n\n  100% {\n    ','\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  0% {\n    ','\n  }\n\n  30% {\n    ','\n  }\n\n  33% {\n    ','\n  }\n\n  63% {\n    ','\n  }\n\n  66% {\n    ','\n  }\n\n  73% {\n    ','\n  }\n\n  74% {\n    ','\n  }\n\n  86% {\n    ','\n  }\n\n  96% {\n    ','\n  }\n\n  99% {\n    ','\n  }\n\n  100% {\n    ','\n  }\n'],['\n  0% {\n    ','\n  }\n\n  30% {\n    ','\n  }\n\n  33% {\n    ','\n  }\n\n  63% {\n    ','\n  }\n\n  66% {\n    ','\n  }\n\n  73% {\n    ','\n  }\n\n  74% {\n    ','\n  }\n\n  86% {\n    ','\n  }\n\n  96% {\n    ','\n  }\n\n  99% {\n    ','\n  }\n\n  100% {\n    ','\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  0% {\n    ','\n  }\n\n  7% {\n    ','\n  }\n\n  8% {\n    ','\n  }\n\n  97% {\n    ','\n  }\n\n  100% {\n    ','\n  }\n'],['\n  0% {\n    ','\n  }\n\n  7% {\n    ','\n  }\n\n  8% {\n    ','\n  }\n\n  97% {\n    ','\n  }\n\n  100% {\n    ','\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  0% {\n    ','\n  }\n\n  30% {\n    ','\n  }\n\n  33% {\n    ','\n  }\n\n  40% {\n    ','\n  }\n\n  41% {\n    ','\n  }\n'],['\n  0% {\n    ','\n  }\n\n  30% {\n    ','\n  }\n\n  33% {\n    ','\n  }\n\n  40% {\n    ','\n  }\n\n  41% {\n    ','\n  }\n']),_templateObject12=_taggedTemplateLiteral(['\n  0% {\n    ','\n  }\n\n  63% {\n    ','\n  }\n\n  66% {\n    ','\n  }\n\n  73% {\n    ','\n  }\n\n  74% {\n    ','\n  }\n\n  100% {\n    ','\n  }\n'],['\n  0% {\n    ','\n  }\n\n  63% {\n    ','\n  }\n\n  66% {\n    ','\n  }\n\n  73% {\n    ','\n  }\n\n  74% {\n    ','\n  }\n\n  100% {\n    ','\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n    position: relative;\n    width: 400px;\n    max-width: 90%;\n    margin: 20px auto;\n    height: 150px;\n\n  > div {\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 30px;\n    height: 250px;\n    border-radius: 6px;\n    font-size: 80px;\n    text-align: center;\n    padding-top: 60px;\n    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n    @media (max-width: ','px) {\n      height: 160px;\n      font-size: 60px;\n      padding-top: 25px;\n    }\n\n    &:after {\n      content: "";\n      background-image: url(',');\n      background-repeat: no-repeat;\n      background-size: contain;\n      background-position: center 10px;\n      opacity: 0.5;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      position: absolute;\n      z-index: -1;\n    }\n\n    i {\n      color: #fafafa;\n    }\n  }\n\n  .card-animation-1 {\n    ','\n    ','\n\n    &:after {\n      ','\n    }\n  }\n\n  .card-animation-2 {\n    ','\n    ','\n\n     &:after {\n      ','\n    }\n  }\n\n  .card-animation-3 {\n    ','\n    ','\n\n    &:after {\n      ','\n    }\n  }\n'],['\n    position: relative;\n    width: 400px;\n    max-width: 90%;\n    margin: 20px auto;\n    height: 150px;\n\n  > div {\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 30px;\n    height: 250px;\n    border-radius: 6px;\n    font-size: 80px;\n    text-align: center;\n    padding-top: 60px;\n    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n    @media (max-width: ','px) {\n      height: 160px;\n      font-size: 60px;\n      padding-top: 25px;\n    }\n\n    &:after {\n      content: "";\n      background-image: url(',');\n      background-repeat: no-repeat;\n      background-size: contain;\n      background-position: center 10px;\n      opacity: 0.5;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      position: absolute;\n      z-index: -1;\n    }\n\n    i {\n      color: #fafafa;\n    }\n  }\n\n  .card-animation-1 {\n    ','\n    ','\n\n    &:after {\n      ','\n    }\n  }\n\n  .card-animation-2 {\n    ','\n    ','\n\n     &:after {\n      ','\n    }\n  }\n\n  .card-animation-3 {\n    ','\n    ','\n\n    &:after {\n      ','\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var highlight=function highlight(backgroundColorText){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject,backgroundColorText);};var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.size;},__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,highlight('#444'));var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var Description=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return props.type==='yup'?'5%':'';},function(props){return props.type==='nope'?'5%':'';},function(props){return props.type==='nope'?'left':'right';});var Button=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,function(props){return props.type==='nope'?'#000':'#3A89D9';},function(props){return props.type==='yup'?'5%':'';},function(props){return props.type==='nope'?'5%':'';});var animationDuration='7s';var state1card='\n  z-index: 30;\n  background-color: #eee;\n  transform: scale(1) rotateZ(0deg);\n  top: 30px;\n  left: 25%;\n  opacity: 1;\n  color: #fafafa;\n  font-size: 0px;\n';var state1cardPrevTurned='\n  z-index: 30;\n  background-color: #eee;\n  transform: scale(1) rotateZ(0deg);\n  top: 30px;\n  left: 25%;\n  opacity: 1;\n  color: #fafafa;\n  font-size: 80px;\n';var state1cardTurned='\n  z-index: 30;\n  background-color: #64DD17;\n  transform: scale(1) rotateZ(10deg);\n  top: 30px;\n  left: 40%;\n  opacity: 1;\n  font-size: 80px;\n\n  &:after {\n    opacity: 0;\n  }\n';var state1cardTurnedReverse='\n  z-index: 30;\n  background-color: #DD2C00;\n  transform: scale(1) rotateZ(-10deg);\n  top: 30px;\n  left: 10%;\n  opacity: 1;\n  font-size: 80px;\n';var state1cardOpacity='\n  z-index: 30;\n  background-color: #64DD17;\n  transform: scale(1) rotateZ(10deg);\n  top: 30px;\n  left: 40%;\n  opacity: 0;\n  font-size: 80px;\n';var state1cardOpacityReverse='\n  z-index: 30;\n  background-color: #DD2C00;\n  transform: scale(1) rotateZ(-10deg);\n  top: 30px;\n  left: 10%;\n  opacity: 0;\n  font-size: 80px;\n';var state2card='\n  z-index: 20;\n  background-color: #eee;\n  transform: scale(0.9) rotateZ(0deg);\n  top: 5px;\n  left: 25%;\n  opacity: 1;\n  font-size: 0px;\n';var state3cardPrev='\n  z-index: 10;\n  background-color: #ddd;\n  transform: scale(0.8) rotateZ(0deg);\n  top: -20px;\n  left: 25%;\n  opacity: 0;\n  font-size: 0px;\n';var state3card='\n  z-index: 10;\n  background-color: #ddd;\n  transform: scale(0.8) rotateZ(0deg);\n  top: -20px;\n  left: 25%;\n  opacity: 1;\n  font-size: 0px;\n';var card1Effect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject6,state1card,state1card,state1cardPrevTurned,state1cardTurned,state1cardOpacity,state3cardPrev,state3card,state3card,state2card,state2card,state1card);var card1Animation=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject7,card1Effect,animationDuration);var card2Effect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject8,state2card,state2card,state1card,state1card,state1cardPrevTurned,state1cardTurnedReverse,state1cardOpacityReverse,state3cardPrev,state3card,state3card,state2card);var card2Animation=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject7,card2Effect,animationDuration);var card3Effect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject9,state3card,state3card,state2card,state2card,state1card,state1card,state1cardPrevTurned,state1cardTurned,state1cardOpacity,state3cardPrev,state3card);var card3Animation=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject7,card3Effect,animationDuration);var pseudoElementVisible='\n  opacity: 0.5;\n';var pseudoElementHidden='\n  opacity: 0;\n';var pseudo1Effect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject10,pseudoElementVisible,pseudoElementVisible,pseudoElementHidden,pseudoElementHidden,pseudoElementVisible);var pseudo1Animation=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject7,pseudo1Effect,animationDuration);var pseudo2Effect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject11,pseudoElementHidden,pseudoElementHidden,pseudoElementVisible,pseudoElementVisible,pseudoElementHidden);var pseudo2Animation=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject7,pseudo2Effect,animationDuration);var pseudo3Effect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject12,pseudoElementHidden,pseudoElementHidden,pseudoElementVisible,pseudoElementVisible,pseudoElementHidden,pseudoElementHidden);var pseudo3Animation=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject7,pseudo3Effect,animationDuration);var AnimationSwipe=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_3_assets_images_speed_dating_user_card_placeholder_png___default.a,state1card,card1Animation,pseudo1Animation,state2card,card2Animation,pseudo2Animation,state3card,card3Animation,pseudo3Animation);

 }),

 (function(module, exports) {

module.exports = "data:image/png;base64,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"

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/connectedWithUser.bd7bb340.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(939);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(940);
function mapStateToProps(state){return{literals:state.i18n.literals.thinkSeedCard};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
 var __WEBPACK_IMPORTED_MODULE_6_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(943);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function ThinkSeedCard(props){var id=props.id,literals=props.literals;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),data=_useState2[0],setData=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),error=_useState4[0],setError=_useState4[1];var loadInfo=function loadInfo(){Object(__WEBPACK_IMPORTED_MODULE_6_modules_think_seeds_actions__["e" ])(id).then(function(response){setData(response);}).catch(function(_ref){var response=_ref.response;setError(response.data.error);});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(loadInfo,[id]);// Count down
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),remainingTime=_useState6[0],setRemainingTime=_useState6[1];var toCountDown=null;var calculateCountdown=function calculateCountdown(){if(data){var thinkSeed=data;if(thinkSeed&&typeof thinkSeed.limit_date!=='undefined'&&__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix()<=thinkSeed.limit_date){var limitDate=__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(thinkSeed.limit_date);var difference=__WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(limitDate.diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()()));setRemainingTime({days:difference.get('days'),hours:difference.get('hours'),minutes:difference.get('minutes'),seconds:difference.get('seconds')});toCountDown=setTimeout(calculateCountdown,1000);}else{setRemainingTime(null);}}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){calculateCountdown();return function(){if(toCountDown){clearTimeout(toCountDown);}};},[data]);var printCountdown=function printCountdown(){if(!remainingTime){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'countdown'},remainingTime.days>0?remainingTime.days+'d ':'',remainingTime.days>0||remainingTime.hours>0?remainingTime.hours+'h ':'',remainingTime.days>0||remainingTime.hours>0||remainingTime.minutes>0?remainingTime.minutes+'m ':'',remainingTime.seconds+'s');};if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},error);}if(!data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_LoadingComponent__["a" ],{colorAnimation:'#cccccc'});}// Render functions
var printHeader=function printHeader(){var thinkSeed=data;var tags=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(thinkSeed.related_elements,{type:'tag'}),function(item){return item.name;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header',style:{backgroundImage:'url('+thinkSeed.image+')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'type'},literals.seedName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},thinkSeed.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags'},tags.join(', ')));};var printBody=function printBody(){var users=data.users;var thinkSeed=data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},thinkSeed.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.whatAre),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'how_it_works'},literals.info)),remainingTime?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.expiration),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'how_it_works'},printCountdown())):null,users.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.users),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(users,function(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["b" ],{key:user.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Avatar__["a" ],{key:user.id,id:user.id,avatar:user.avatar,firstname:user.firstname,size:70}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},user.firstname+' '+user.lastname),(user.contributions.length||user.contributions.others)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contributions'},literals.contributions,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(user.contributions,function(cont,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'contribution tag gray'},cont);}))));}))):null);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" ],null,printHeader(),printBody());}ThinkSeedCard.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}; __webpack_exports__["a"] = (ThinkSeedCard);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var PI=Math.PI;var TAU=PI*2;var HALF_PI=PI*0.5;var RAND=Math.random;var ROUND=Math.round;var SIN=Math.sin;var COS=Math.cos;var ABS=Math.abs;var POW=Math.pow;var lib={v2:Vector2,noise:noise,stats:Stats};var Config=function(){function Config(opts){_classCallCheck(this,Config);this.merge(opts);}_createClass(Config,[{key:'merge',value:function merge(opts){for(var opt in opts){this.set(opt,opts[opt]);}}},{key:'set',value:function set(key,value){if(!key||!value)return;this[key]=value;}}]);return Config;}();var Canvas=function(){function Canvas(selector,context,dimensions,center){_classCallCheck(this,Canvas);var self=this;if(selector){this.el=document.querySelector(selector);}else{this.el=document.createElement('canvas');document.body.appendChild(this.el);}this.ctx=this.el.getContext(context)||this.el.getContext('2d');this.dimensions=dimensions||{x:0,y:0};this.center=new lib.v2();window.addEventListener('resize',self.resize.bind(self));}_createClass(Canvas,[{key:'rgba',value:function rgba(r,g,b,a){return'rgba('+r+','+g+','+b+','+a+')';}},{key:'hsla',value:function hsla(h,s,l,a){return'hsla('+h+', '+s+', '+l+', '+a+')';}},{key:'fill',value:function fill(x,y,width,height,_fill){this.ctx.fillStyle=_fill||'rgba(255,255,255,1)';this.ctx.fillRect(x,y,width,height);}},{key:'clear',value:function clear(){this.ctx.clearRect(0,0,this.dimensions.x,this.dimensions.y);}},{key:'drawLine',value:function drawLine(x1,y1,x2,y2,stroke,strokeWidth){this.ctx.beginPath();this.ctx.moveTo(x1,y1);this.ctx.lineTo(x2,y2);this.ctx.strokeStyle=stroke||'rgba(255,255,255,1)';this.ctx.lineWidth=strokeWidth||2;this.ctx.stroke();this.ctx.closePath();}},{key:'resize',value:function resize(){this.el.width=this.dimensions.x=window.innerWidth;this.el.height=this.dimensions.y=window.innerHeight;this.center.x=this.dimensions.x*0.5;this.center.y=this.dimensions.y*0.5;this.ctx.globalCompositeOperation='lighter';}}]);return Canvas;}();var Particle=function(){function Particle(x,y,bounds,center){_classCallCheck(this,Particle);this.lastPosition=new lib.v2();this.position=new lib.v2(x,y);this.velocity=new lib.v2();this.life=0;this.ttl=1000;this.bounds=bounds;this.center=center;this.reset=false;}_createClass(Particle,[{key:'update',value:function update(){if(this.life>this.ttl||this.checkBounds()){this.reset=true;}else{this.position.add(this.velocity);this.life++;}}},{key:'checkBounds',value:function checkBounds(){return this.lastPosition.x-this.size*3>this.bounds.x||this.lastPosition.x<-this.size||this.lastPosition.y-this.size*3>this.bounds.y||this.lastPosition.y<-this.size||this.position.distanceTo(this.center)<3;}}]);return Particle;}();var ParticleSystem=function(){function ParticleSystem(particlesColor){_classCallCheck(this,ParticleSystem);lib.noise.seed(RAND*2000);var defaults={max:400,size:5};this.particlesColor=particlesColor;this.canvas=new Canvas('.loading_component','2d');this.canvas.resize();this.bounds=this.canvas.dimensions;this.config=new Config(defaults);this.tick=0;this.points=[];this.render();}_createClass(ParticleSystem,[{key:'update',value:function update(){var pRef=void 0;var p=void 0;var noiseVal=void 0;var noiseNorm=void 0;var theta=void 0;var theta2=void 0;var dTheta=void 0;var vel=void 0;var vel2=void 0;var size=void 0;var hue=void 0;var colorString=void 0;this.canvas.clear();this.canvas.ctx.lineCap='round';if(this.points.length<this.config.max&&this.tick%2===0){var rand=ROUND(RAND());var x=rand?ROUND(RAND())*this.canvas.dimensions.x:RAND()*this.canvas.dimensions.x;var y=rand?RAND()*this.canvas.dimensions.y:ROUND(RAND())*this.canvas.dimensions.y;p=new Particle(x,y,this.canvas.dimensions,this.canvas.center);this.points.push(p);}for(var i=this.points.length-1;i>=0;i--){p=this.points[i];if(p.reset){this.points.splice(i,1);continue;}else{p.lastPosition.x=p.position.x;p.lastPosition.y=p.position.y;noiseVal=lib.noise.simplex3(p.position.x*0.0015,p.position.y*0.0015,this.tick*0.005);noiseNorm=ABS(noiseVal);theta=noiseVal*TAU*(1000/(p.position.distanceTo(this.canvas.center)+1000));theta2=p.position.angleTo(this.canvas.center)+HALF_PI*0.25;dTheta=(theta+theta2)/2;hue=theta*10-30;colorString=this.canvas.hsla(0,'0%','100%',noiseNorm+0.2);vel=new lib.v2((COS(theta)*0.5+COS(theta2))*6,(SIN(theta)*0.5+SIN(theta2))*3).multiplyScalar(POW(2*(p.position.y/this.canvas.dimensions.y)+1,2));size=POW(p.position.y/this.canvas.dimensions.y*this.config.size,2)+2;p.velocity.lerp(vel,0.035);p.update();this.canvas.drawLine(p.lastPosition.x,p.lastPosition.y,p.position.x,p.position.y,this.particlesColor,size);}}this.tick++;}},{key:'render',value:function render(){var self=this;self.update();window.requestAnimationFrame(self.render.bind(self));}}]);return ParticleSystem;}();window.requestAnimationFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(callback){window.setTimeout(callback,1000/60);};}();var initialize=function initialize(color){var p=new ParticleSystem(color);}; __webpack_exports__["a"] = (initialize);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  height: 100%;\n  transition: background-color 0.4s linear;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n\n  .loading_component {\n    background-color: ',';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n'],['\n  background-color: ',';\n  height: 100%;\n  transition: background-color 0.4s linear;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n\n  .loading_component {\n    background-color: ',';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;},function(props){return props.color;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ThinkSeedCardWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return UserWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
var _templateObject=_taggedTemplateLiteral(['\n  height: 90%;\n  text-align: left;\n  overflow: auto;\n  .header {\n    background-color: #ccc;\n    background-size: cover;\n    background-position: 50%;\n    background-repeat: no-repeat;\n    min-height: 8rem;\n    padding: 1rem 2rem;\n    position: relative;\n\n    .opacity {\n      background-color: rgba(0, 0, 0, 0.3);\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n\n    .type {\n      color: #fff;\n      text-transform: uppercase;\n      font-size: 1.1rem;\n      position: relative;\n      z-index: 10;\n    }\n\n    .name {\n      color: #fff;\n      font-weight: ',';\n      font-family: ',';\n      font-size: 1.4rem;\n      margin-top: 2rem;\n      position: relative;\n      z-index: 12;\n    }\n\n    .tags {\n      color: #fff;\n      font-size: 1.3rem;\n      margin-top: 0.5rem;\n      position: relative;\n      z-index: 11;\n    }\n  }\n\n  .users {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .body {\n    padding: 2rem;\n    .description {\n      font-size: 1.4rem;\n      margin-top: 1rem;\n      margin-bottom: 1rem;\n      line-height: 1.9rem;\n    }\n\n    .subsection {\n      margin: 2rem 0;\n      .title {\n        color: #5E5E5E;\n        font-size: 1.3rem;\n        margin-bottom: 1rem;\n        text-transform: uppercase;\n        margin-top: 2rem;\n      }\n\n      .avatar_bubble {\n        margin-right: 1rem;\n      }\n\n      .how_it_works {\n        font-weight: ',';\n        font-family: ',';\n        font-size: 1.6rem;\n        color: #444;\n      }\n\n      .countdown {\n        color: #5E5E5E;\n        font-size: 1.6rem;\n      }\n    }\n  }\n'],['\n  height: 90%;\n  text-align: left;\n  overflow: auto;\n  .header {\n    background-color: #ccc;\n    background-size: cover;\n    background-position: 50%;\n    background-repeat: no-repeat;\n    min-height: 8rem;\n    padding: 1rem 2rem;\n    position: relative;\n\n    .opacity {\n      background-color: rgba(0, 0, 0, 0.3);\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n\n    .type {\n      color: #fff;\n      text-transform: uppercase;\n      font-size: 1.1rem;\n      position: relative;\n      z-index: 10;\n    }\n\n    .name {\n      color: #fff;\n      font-weight: ',';\n      font-family: ',';\n      font-size: 1.4rem;\n      margin-top: 2rem;\n      position: relative;\n      z-index: 12;\n    }\n\n    .tags {\n      color: #fff;\n      font-size: 1.3rem;\n      margin-top: 0.5rem;\n      position: relative;\n      z-index: 11;\n    }\n  }\n\n  .users {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .body {\n    padding: 2rem;\n    .description {\n      font-size: 1.4rem;\n      margin-top: 1rem;\n      margin-bottom: 1rem;\n      line-height: 1.9rem;\n    }\n\n    .subsection {\n      margin: 2rem 0;\n      .title {\n        color: #5E5E5E;\n        font-size: 1.3rem;\n        margin-bottom: 1rem;\n        text-transform: uppercase;\n        margin-top: 2rem;\n      }\n\n      .avatar_bubble {\n        margin-right: 1rem;\n      }\n\n      .how_it_works {\n        font-weight: ',';\n        font-family: ',';\n        font-size: 1.6rem;\n        color: #444;\n      }\n\n      .countdown {\n        color: #5E5E5E;\n        font-size: 1.6rem;\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin-right: 1rem;\n  max-width: 45rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  border-radius: 1.5rem;\n  padding: 1rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border: 0.1rem solid #e9e9e9;\n\n  .userContent {\n    margin-left: 1rem;\n    width: calc(100% - 8.5rem);\n  }\n\n  .name{\n    font-size: 1.4rem;\n    font-weight: bold;\n  }\n  .contributions{\n    font-size: 1.2rem;\n    margin-top: 0.5rem;\n\n    .contribution {\n      display: inline-block;\n      margin: 0.5rem 0.5rem 0 0;\n      max-width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n  }\n'],['\n  margin-right: 1rem;\n  max-width: 45rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  border-radius: 1.5rem;\n  padding: 1rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border: 0.1rem solid #e9e9e9;\n\n  .userContent {\n    margin-left: 1rem;\n    width: calc(100% - 8.5rem);\n  }\n\n  .name{\n    font-size: 1.4rem;\n    font-weight: bold;\n  }\n  .contributions{\n    font-size: 1.2rem;\n    margin-top: 0.5rem;\n\n    .contribution {\n      display: inline-block;\n      margin: 0.5rem 0.5rem 0 0;\n      max-width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ThinkSeedCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldWeight,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldWeight,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily);var UserWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(945);
function mapStateToProps(state){return{literals:state.i18n.literals.thinkSeedContributionForm};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components__["a" ]));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(946);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var listTags=[{id:21235752,name:'investment'},{id:21235753,name:'experience'},{id:21235754,name:'contacts'},{id:21235755,name:'clientsDiffusion'},{id:21235756,name:'ideas'},{id:21235757,name:'timeWork'},{id:21235758,name:'assets'}];function ThinkSeedContributionForm(props){var literals=props.literals,onClick=props.onClick,title=props.title,onCancel=props.onCancel;// Contributions tags
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),selectedTags=_useState2[0],setSelectedTags=_useState2[1];var selectTag=function selectTag(event){var id=parseInt(event.currentTarget.getAttribute('data-id'),10);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(selectedTags,function(tagId){return tagId===id;})){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(selectedTags,function(tagId){return tagId===id;});}else{selectedTags.push(id);}setSelectedTags([].concat(_toConsumableArray(selectedTags)));};// Other contributions
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState4=_slicedToArray(_useState3,2),others=_useState4[0],setOthers=_useState4[1];var handleChangeOthers=function handleChangeOthers(event){var value=event.currentTarget.value;setOthers(value);};// Events
var handleSubmit=function handleSubmit(){var params={contributions:selectedTags,others:others};onClick(params);};var titleToShow=title||literals.youHaveJoinThinkSeed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{className:'think_seed_contribution_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},titleToShow),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle'},literals.indicateYourContributions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(listTags,function(_ref){var id=_ref.id,name=_ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-id':id,key:id,onClick:selectTag,className:'tag gray clickable '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(selectedTags,function(tag){return tag===id;})?'selected':'')},literals[name]);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle'},literals.others),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form_input_stl',placeholder:literals.whatElse,value:others,onChange:handleChangeOthers})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:handleSubmit},literals.send),onCancel?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'cancel',onClick:onCancel},literals.cancel):null))));}ThinkSeedContributionForm.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};ThinkSeedContributionForm.defaultProps={title:null,onCancel:null}; __webpack_exports__["a"] = (ThinkSeedContributionForm);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ThinkSeedContributionFormStyled; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
var _templateObject=_taggedTemplateLiteral(['\n  text-align: center;\n  padding: 2rem;\n  background-color: #f1f1f1;\n  max-width: 80rem;\n  margin: 2rem auto;\n\n  .title {\n    font-size: 1.6rem;\n    line-height: 2rem;\n    margin-bottom: 2rem;\n    color: #444;\n    font-family: ',';\n    font-weight: ',';\n  }\n\n  .subtitle {\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n    color: #444;\n    margin-bottom: 1rem;\n  }\n\n  .tags {\n\n  }\n'],['\n  text-align: center;\n  padding: 2rem;\n  background-color: #f1f1f1;\n  max-width: 80rem;\n  margin: 2rem auto;\n\n  .title {\n    font-size: 1.6rem;\n    line-height: 2rem;\n    margin-bottom: 2rem;\n    color: #444;\n    font-family: ',';\n    font-weight: ',';\n  }\n\n  .subtitle {\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n    color: #444;\n    margin-bottom: 1rem;\n  }\n\n  .tags {\n\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ThinkSeedContributionFormStyled=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldWeight);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return SwipeableCardsWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return Card; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  20% {\n    transform: translateY(0px) scale(0.7);\n    opacity: 0.7;\n  }\n\n  100% {\n    transform: translateY(-700px) scale(0.7);\n    opacity: 0.7;\n  }\n'],['\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  20% {\n    transform: translateY(0px) scale(0.7);\n    opacity: 0.7;\n  }\n\n  100% {\n    transform: translateY(-700px) scale(0.7);\n    opacity: 0.7;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  height: 100%;\n  width: 90%;\n  position: relative;\n  min-height: clamp(40rem,86rem,68vh);\n  padding-bottom: 2rem;\n  @media (max-width: ','px) {\n    height: ',';\n    width: calc(100%);\n    ',';\n    max-height: calc(100vh - 16rem);\n  }\n\n  .carousel {\n    height: calc(100vh - 17rem) !important;\n    .carousel-item {\n      height: calc(100vh - 36vh) !important;\n      width: 80% !important;\n\n      &.animate__backOutUp {\n        animation: ',' 0.6s linear 1;\n        transform: translateY(-700px) scale(0.7) !important;\n        opacity: 0.7;\n      }\n    }\n  }\n\n  @media (max-width: ','px) {\n    .carousel {\n      height: calc(100vh - 30vh) !important;\n      .carousel-item {\n        height: calc(100vh - 47vh) !important;\n        width: 90% !important;\n      }\n    }\n  }\n'],['\n  height: 100%;\n  width: 90%;\n  position: relative;\n  min-height: clamp(40rem,86rem,68vh);\n  padding-bottom: 2rem;\n  @media (max-width: ','px) {\n    height: ',';\n    width: calc(100%);\n    ',';\n    max-height: calc(100vh - 16rem);\n  }\n\n  .carousel {\n    height: calc(100vh - 17rem) !important;\n    .carousel-item {\n      height: calc(100vh - 36vh) !important;\n      width: 80% !important;\n\n      &.animate__backOutUp {\n        animation: ',' 0.6s linear 1;\n        transform: translateY(-700px) scale(0.7) !important;\n        opacity: 0.7;\n      }\n    }\n  }\n\n  @media (max-width: ','px) {\n    .carousel {\n      height: calc(100vh - 30vh) !important;\n      .carousel-item {\n        height: calc(100vh - 47vh) !important;\n        width: 90% !important;\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  from {\n    z-index: 99;\n    width: 89%;\n    left: 5.5%;\n    top: 0.5rem;\n  }\n'],['\n  from {\n    z-index: 99;\n    width: 89%;\n    left: 5.5%;\n    top: 0.5rem;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  animation: ',' 0.2s linear 1;\n'],['\n  animation: ',' 0.2s linear 1;\n']),_templateObject5=_taggedTemplateLiteral(['\n    user-select: none;\n    height: 100%;\n    text-align: left;\n    max-width: 80rem;\n    margin: 0 auto;\n    box-shadow: 0 10px 20px rgba(0,0,0,0.09), 0 6px 6px rgba(0,0,0,0.13);\n\n    > div:first-child {\n      overflow: auto;\n      height: 100%;\n      background-color: #F1F1F1;\n    }\n\n    .close_icon {\n      position: absolute;\n      right: 1rem;\n      top: 1rem;\n      color: #444;\n      cursor: pointer;\n      font-size: 2rem;\n    }\n\n    ','\n\n    &.with_footer {\n      > div:first-child {\n        height: 90%;\n        grid-template-rows: calc(100% - 9rem) 9rem;\n      }\n    }\n\n    .footer {\n      background-color: #f5f5f5;\n      border-top: 0.1rem solid #ddd;\n      padding: 2rem;\n      display: flex;\n      height: 10%;\n      align-items: center;\n      justify-content: space-between;\n      position: relative;\n\n      @media (max-width: ','px) {\n        padding: 0;\n      }\n\n\n\n      .text_connected{\n        font-size: 1.7rem;\n      }\n\n      .chat {\n        padding: 1rem 6rem;\n        color: white;\n        height: 2rem;\n        white-space: nowrap;\n        background: #3A89D9;\n        font-size: 1.1rem;\n        font-weight: 600;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n      }\n\n      .centered_button {\n        margin: 0 auto;\n        background: #3A89D9;\n        color: #fff;\n        font-size: 1.3rem;\n        width: 20rem;\n      }\n\n      button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 4rem;\n        border-radius: 4rem;\n        box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);\n        padding: 0 3rem;\n\n        @media (max-width: ','px) {\n          padding: 0 1rem;\n\n        }\n\n        i {\n          color: #fff;\n          text-shadow: 0 0 0.1rem #000;\n          margin: 0 1rem;\n          font-size: 2rem;\n        }\n\n        img {\n          margin: 0 0.5rem 0 0;\n        }\n\n        p {\n          font-size: 1.5rem;\n          font-weight: 600;\n          color: white;\n        }\n\n        &.maybe {\n          background-color: #D9D9D9;\n          color: #000;\n          font-size: 1.5rem;\n        }\n\n        &.nope {\n          background-color: #000;\n        }\n\n        &.yes {\n          background-color: #3A89D9;\n        }\n\n        &.speed_dating {\n          background-color: #8AD923;\n\n        }\n      }\n    }\n'],['\n    user-select: none;\n    height: 100%;\n    text-align: left;\n    max-width: 80rem;\n    margin: 0 auto;\n    box-shadow: 0 10px 20px rgba(0,0,0,0.09), 0 6px 6px rgba(0,0,0,0.13);\n\n    > div:first-child {\n      overflow: auto;\n      height: 100%;\n      background-color: #F1F1F1;\n    }\n\n    .close_icon {\n      position: absolute;\n      right: 1rem;\n      top: 1rem;\n      color: #444;\n      cursor: pointer;\n      font-size: 2rem;\n    }\n\n    ','\n\n    &.with_footer {\n      > div:first-child {\n        height: 90%;\n        grid-template-rows: calc(100% - 9rem) 9rem;\n      }\n    }\n\n    .footer {\n      background-color: #f5f5f5;\n      border-top: 0.1rem solid #ddd;\n      padding: 2rem;\n      display: flex;\n      height: 10%;\n      align-items: center;\n      justify-content: space-between;\n      position: relative;\n\n      @media (max-width: ','px) {\n        padding: 0;\n      }\n\n\n\n      .text_connected{\n        font-size: 1.7rem;\n      }\n\n      .chat {\n        padding: 1rem 6rem;\n        color: white;\n        height: 2rem;\n        white-space: nowrap;\n        background: #3A89D9;\n        font-size: 1.1rem;\n        font-weight: 600;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n      }\n\n      .centered_button {\n        margin: 0 auto;\n        background: #3A89D9;\n        color: #fff;\n        font-size: 1.3rem;\n        width: 20rem;\n      }\n\n      button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 4rem;\n        border-radius: 4rem;\n        box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);\n        padding: 0 3rem;\n\n        @media (max-width: ','px) {\n          padding: 0 1rem;\n\n        }\n\n        i {\n          color: #fff;\n          text-shadow: 0 0 0.1rem #000;\n          margin: 0 1rem;\n          font-size: 2rem;\n        }\n\n        img {\n          margin: 0 0.5rem 0 0;\n        }\n\n        p {\n          font-size: 1.5rem;\n          font-weight: 600;\n          color: white;\n        }\n\n        &.maybe {\n          background-color: #D9D9D9;\n          color: #000;\n          font-size: 1.5rem;\n        }\n\n        &.nope {\n          background-color: #000;\n        }\n\n        &.yes {\n          background-color: #3A89D9;\n        }\n\n        &.speed_dating {\n          background-color: #8AD923;\n\n        }\n      }\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var backOutUp=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject);var SwipeableCardsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.profile;},function(props){return props.profile?'env(safe-area-inset-top)':'';},backOutUp,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var zoomIn=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject3);var zoomInEffect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" ])(_templateObject4,zoomIn);var Card=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,zoomInEffect,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackModal; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  height: 100%;\n  width: 80rem;\n  max-width: 100%;\n  outline: none;\n  position: absolute;\n  left: 55%;\n  top: 52%;\n  transform: translate(-50%, -50%);\n  margin-top: env(safe-area-inset-top);\n\n  .user_card {\n    height: 90%;\n  }\n\n  .carousel {\n    height: calc(100vh - 10rem) !important;\n    .carousel-item {\n      height: calc(100vh - 10rem) !important;\n      width: 80% !important;\n      opacity: 1 !important;\n    }\n  }\n\n  @media (max-width: ','px) {\n    max-height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n    top: calc(1rem +  env(safe-area-inset-top));\n    margin-top: 0;\n    transform: translate(-50%, 0);\n\n    .carousel {\n      height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;\n      .carousel-item {\n        height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;\n        width: 90% !important;\n      }\n    }\n  }\n'],['\n  height: 100%;\n  width: 80rem;\n  max-width: 100%;\n  outline: none;\n  position: absolute;\n  left: 55%;\n  top: 52%;\n  transform: translate(-50%, -50%);\n  margin-top: env(safe-area-inset-top);\n\n  .user_card {\n    height: 90%;\n  }\n\n  .carousel {\n    height: calc(100vh - 10rem) !important;\n    .carousel-item {\n      height: calc(100vh - 10rem) !important;\n      width: 80% !important;\n      opacity: 1 !important;\n    }\n  }\n\n  @media (max-width: ','px) {\n    max-height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n    top: calc(1rem +  env(safe-area-inset-top));\n    margin-top: 0;\n    transform: translate(-50%, 0);\n\n    .carousel {\n      height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;\n      .carousel-item {\n        height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;\n        width: 90% !important;\n      }\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FeedbackModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return CloseIcon; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  color: #444;\n  font-size: 18px;\n  position: absolute;\n  z-index: 100;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n  z-index: 100;\n  pointer-events: all !important;\n'],['\n  color: #444;\n  font-size: 18px;\n  position: absolute;\n  z-index: 100;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n  z-index: 100;\n  pointer-events: all !important;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CloseIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return hideNotificationModal; });
 var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(356);
var hideNotificationModal=function hideNotificationModal(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["a" ]});};};

 }),

 (function(module, exports) {

module.exports = "data:image/png;base64,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"

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_6_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_7_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_8__components_ChatRoom__ = __webpack_require__(953);
function mapStateToProps(state){return{literals:state.i18n.literals.chat||{},app:state.app,user:state.session.user,newMessage:state.chats.newMessage,chats:state.chats.chats,tables:state.thinkChats.myThinkChatsList};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_components_Navbar_modules__["b" ],dispatch),resetContext:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["e" ],dispatch),goHome:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["e" ],dispatch),sendMessage:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_modules_chats__["n" ],dispatch),markChatAsRead:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_modules_chats__["j" ],dispatch),resetSelectedChat:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_modules_chats__["l" ],dispatch),getOlderMessages:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_modules_chats__["g" ],dispatch),sendFile:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_modules_chats__["m" ],dispatch),leaveChat:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_modules_chats__["i" ],dispatch),setAsLeader:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_modules_chats__["o" ],dispatch),changeThinkSeedImage:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7_modules_think_seeds_actions__["a" ],dispatch),setSelectChatImage:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_modules_chats__["p" ],dispatch),leaveThinkChat:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7_modules_think_seeds_actions__["i" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_8__components_ChatRoom__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_5_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_iconSend_svg__ = __webpack_require__(954);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_iconSend_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_images_iconSend_svg__);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_grey_arrow_right_svg__ = __webpack_require__(240);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_grey_arrow_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_images_grey_arrow_right_svg__);
 var __WEBPACK_IMPORTED_MODULE_8_utils_string__ = __webpack_require__(67);
 var __WEBPACK_IMPORTED_MODULE_9_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(247);
 var __WEBPACK_IMPORTED_MODULE_11__FileUpload__ = __webpack_require__(980);
 var __WEBPACK_IMPORTED_MODULE_12__FileLink__ = __webpack_require__(983);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChatRoom=function(_Component){_inherits(ChatRoom,_Component);function ChatRoom(props){_classCallCheck(this,ChatRoom);var _this=_possibleConstructorReturn(this,(ChatRoom.__proto__||Object.getPrototypeOf(ChatRoom)).call(this,props));_this.handleNewMessage=function(newMessage){var _this$state=_this.state,messages=_this$state.messages,offset=_this$state.offset;if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(messages,{id:newMessage.id})){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(messages,{temp_id:newMessage.temp_id})){var index=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(messages,{temp_id:newMessage.temp_id});messages[index]=newMessage;}else{messages.push(newMessage);}_this.setState({messages:messages},function(){if(offset>95){_this.scrollToBottom();}});}};_this.fetchChat=function(){var _this$props=_this.props,chatId=_this$props.chatId,markChatAsRead=_this$props.markChatAsRead;_this.resetState();Object(__WEBPACK_IMPORTED_MODULE_4_modules_chats__["d" ])(chatId).then(function(response){var messages=response.messages;var orderMessages=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(messages,['timestamp'],['asc']);_this.setState({messages:orderMessages},_this.scrollToBottom);markChatAsRead(chatId);});};_this.resetState=function(){_this.setState({showAlertNewMessages:false,firstMessageId:0,hasStarted:false,offset:0});};_this.toggleCollapse=function(){var onCollapse=_this.props.onCollapse;if(onCollapse){onCollapse();}};_this.printMessages=function(){var messages=_this.state.messages;var _this$props2=_this.props,actualUser=_this$props2.user,literals=_this$props2.literals,theme=_this$props2.theme,color=_this$props2.app.color1;var actualDay=false;if(!messages.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'first_message'},literals.firstMessage);}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(messages,function(message,index){var isActualUser=message.user.id===actualUser.id;var time=__WEBPACK_IMPORTED_MODULE_2_moment___default()(message.timestamp,'X');var hour=time.format('HH:mm');var messageDay=time.format('YYYY-MM-DD');var showDay=messageDay!==actualDay;var dayString='';if(showDay){actualDay=messageDay;if(__WEBPACK_IMPORTED_MODULE_2_moment___default()().isSame(messageDay,'day')){dayString=literals.today;}else if(__WEBPACK_IMPORTED_MODULE_2_moment___default()().diff(time,'day')<7){dayString=time.format('dddd');}else{dayString=time.format('DD/MM/YYYY');}}var userSender=message.user;if(message.type==='leave'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["o" ],null,_this.renderMessage(message,hour,isActualUser));}if(message.type==='join'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["n" ],null,_this.renderMessage(message,hour,isActualUser));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:message.id},showDay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["j" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["i" ],null,dayString)),theme&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["s" ],{isActualUser:isActualUser},userSender.firstname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["p" ],{color:color,isActualUser:isActualUser,messageColor:isActualUser?__WEBPACK_IMPORTED_MODULE_9_constants_colors__["e" ]:__WEBPACK_IMPORTED_MODULE_9_constants_colors__["d" ],ref:index?null:_this.assignRefFirstMessage},_this.renderMessage(message,hour,isActualUser)),!isActualUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'absolute',bottom:'0.3rem',left:'1rem'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Avatar__["a" ],{size:40,avatar:userSender.avatar,position:'relative',firstname:userSender.firstname}))));});};_this.sendMessage=function(){var _this$state2=_this.state,textInput=_this$state2.textInput,messages=_this$state2.messages;var _this$props3=_this.props,actualUser=_this$props3.user,sendMessage=_this$props3.sendMessage,chatId=_this$props3.chatId,tableId=_this$props3.tableId;if(textInput){var tempId=Math.round(Math.random()*99999);var message={id:tempId*-1,temp_id:tempId,text:textInput,user:{id:actualUser.id,firstname:actualUser.name,lastname:actualUser.surname,avatar:actualUser.avatar},read:1,timestamp:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('X'),chat_id:parseInt(chatId,10),users_read:[actualUser.id],table_id:tableId};messages.push(message);sendMessage(message);_this.setState({textInput:'',enableSendMessage:false,messages:messages},_this.scrollToBottom);}};_this.handleChangeInput=function(event){var value=event.target.value;_this.setState({textInput:value});if(value!==''){_this.setState({enableSendMessage:true});}else{_this.setState({enableSendMessage:false});}};_this.handleChangeFileUpload=function(file,callback){var value=file;var textInput=_this.state.textInput;var _this$props4=_this.props,actualUser=_this$props4.user,sendFile=_this$props4.sendFile,chatId=_this$props4.chatId;var tempId=Math.round(Math.random()*99999);var message={id:tempId*-1,temp_id:tempId,text:textInput,user_id:actualUser.id,read:1,timestamp:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('X'),chat_id:parseInt(chatId,10),file:value};var reader=new FileReader();reader.onloadend=function(){sendFile(reader.result,message,callback);message.user=Object.assign({},actualUser);_this.setState({textInput:''});};reader.readAsDataURL(value);_this.setState({textInput:value.name});};_this.handleScrollMessages=function(event){var getOlderMessages=_this.props.getOlderMessages;var _this$state3=_this.state,firstMessageId=_this$state3.firstMessageId,hasStarted=_this$state3.hasStarted,offset=_this$state3.offset,messages=_this$state3.messages;var layerHeight=_this.messagesLayer.clientHeight;var contentHeight=_this.messagesLayer.scrollHeight;var scroll=_this.messagesLayer.scrollTop;var currentOffset=event.currentTarget.scrollTop;var direction=currentOffset>offset?'down':'up';var perc=100;if(contentHeight>layerHeight){var diff=contentHeight-layerHeight;perc=Math.round(scroll*100/diff);}_this.setState({offset:perc});if(perc===100){_this.setState({showAlertNewMessages:false});}else if(perc===0&&firstMessageId!==0&&messages.length>=0&&hasStarted&&direction==='up'){getOlderMessages();}};_this.slideToBottom=function(){var hasStarted=_this.state.hasStarted;if(_this.messagesEnd){_this.messagesEnd.scrollIntoView({behavior:'smooth'});}if(!hasStarted){setTimeout(function(){_this.setState({hasStarted:true});},1000);}};_this.assignRefMessagesEnd=function(ref){_this.messagesEnd=ref;};_this.assignRefMessagesLayer=function(ref){_this.messagesLayer=ref;};_this.assignRefFirstMessage=function(ref){if(_this.firstMessage&&_this.firstMessage!==ref){_this.firstMessage.scrollIntoView({behavior:'instant',block:'start'});}_this.firstMessage=ref;};_this.renderMessage=function(message,hour,isActualUser){var _this$props5=_this.props,literals=_this$props5.literals,color=_this$props5.app.color1;if(message.type==='attachment'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["k" ],{isActualUser:isActualUser,color:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__FileLink__["a" ],{mimeType:message.text.mimetype,hour:hour,viewDocument:__WEBPACK_IMPORTED_MODULE_4_modules_chats__["q" ],hash:message.text.hash,bp:message.text.bp,name:message.text.name,url:message.text.url,color:color}));}if(message.type==='join'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,message.text.user.firstname+' '+literals.joinedChat));}if(message.type==='leave'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,message.text.user.firstname+' '+literals.leftChat));}var newText=Object(__WEBPACK_IMPORTED_MODULE_8_utils_string__["c" ])(message.text);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text',dangerouslySetInnerHTML:{__html:newText}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hour'},hour));};_this.handleKeyDownMessageInput=function(event){if(event.key==='Enter'){_this.sendMessage();}};_this.scrollToBottom=function(){if(_this.messagesLayer){if(_this.messagesLayer.scrollHeight){_this.messagesLayer.scrollTop=_this.messagesLayer.scrollHeight;_this.setState({offset:100});}}};_this.closeChat=function(){var onClose=_this.props.onClose;onClose();};_this.printHeader=function(){var _this$props6=_this.props,chatId=_this$props6.chatId,chats=_this$props6.chats,actualUser=_this$props6.user,onClose=_this$props6.onClose,literals=_this$props6.literals,isTab=_this$props6.isTab,tables=_this$props6.tables;var chat=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(chats,{id:chatId});if(!chat){return null;}var name='';var table=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(tables,{id:chat.element_related.id});if(table){name=table.name;}else if(typeof chat.element_related.name!=='undefined'){name=chat.element_related.name;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["f" ],{className:'chat_header'},!isTab&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hide',onClick:_this.toggleCollapse},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7_assets_images_grey_arrow_right_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.hide))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["t" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat_name'},name)));};_this.state={textInput:'',showAlertNewMessages:false,firstMessageId:0,hasStarted:false,offset:0,enableSendMessage:false,messages:[]};return _this;}_createClass(ChatRoom,[{key:'componentDidMount',value:function componentDidMount(){var resetAll=this.props.resetAll;this.fetchChat();resetAll();}},{key:'componentDidUpdate',value:function componentDidUpdate(_ref){var prevChatId=_ref.chatId,prevNewMessage=_ref.newMessage;var _props=this.props,chatId=_props.chatId,newMessage=_props.newMessage,markChatAsRead=_props.markChatAsRead;if(prevChatId!==chatId){this.fetchChat();}if(newMessage&&(!prevNewMessage||newMessage.id!==prevNewMessage.id)&&newMessage.chat_id===chatId){this.handleNewMessage(newMessage);markChatAsRead(chatId);}}},{key:'render',value:function render(){var _state=this.state,textInput=_state.textInput,showAlertNewMessages=_state.showAlertNewMessages,enableSendMessage=_state.enableSendMessage;var _props2=this.props,literals=_props2.literals,actualUser=_props2.user,color=_props2.app.color1,theme=_props2.theme,isTab=_props2.isTab;if(!actualUser){return null;}var height='calc(100vh - 20.5rem)';if(isTab){height='calc(100vh - 14.3rem)';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["h" ],{className:'chat_wrapper',color:color},this.printHeader(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["c" ],{className:'chat_container',height:height},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["g" ],{className:'chat_messages',onScroll:this.handleScrollMessages,theme:theme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list_messages',ref:this.assignRefMessagesLayer},this.printMessages()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:this.assignRefMessagesEnd}))),showAlertNewMessages&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["a" ],{onClick:this.slideToBottom,color:color},literals.newMessages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["e" ],{className:'chat_form_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["d" ],{className:'chat_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["q" ],{value:textInput,onChange:this.handleChangeInput,onKeyDown:this.handleKeyDownMessageInput})),!enableSendMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__FileUpload__["a" ],{onChange:this.handleChangeFileUpload}),enableSendMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" ],{onClick:this.sendMessage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_assets_images_iconSend_svg___default.a,alt:''})))));}}]);return ChatRoom;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChatRoom.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,sendMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getOlderMessages:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,sendFile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,markChatAsRead:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tables:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,newMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,chatId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,chats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,tableId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,onCollapse:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isTab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ChatRoom.defaultProps={chatId:null,newMessage:null,chats:[],tables:[],tableId:0,onCollapse:null,isTab:false}; __webpack_exports__["a"] = (ChatRoom);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iconSend.ff514170.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__autolinker__ = __webpack_require__(423);


 var __WEBPACK_IMPORTED_MODULE_1__anchor_tag_builder__ = __webpack_require__(424);

 var __WEBPACK_IMPORTED_MODULE_2__html_tag__ = __webpack_require__(241);

 var __WEBPACK_IMPORTED_MODULE_3__match_index__ = __webpack_require__(961);

 var __WEBPACK_IMPORTED_MODULE_4__matcher_index__ = __webpack_require__(962);

// WARNING: This file is modified a bit when it is compiled into index.js in 
// order to support nodejs interoperability with require('autolinker') directly. 
// This is done by the buildSrcFixCommonJsIndexTask() function in the gulpfile. 
// See that function for more details.

 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__autolinker__["a" ]);







//# sourceMappingURL=index.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = truncateSmart;

function truncateSmart(url, truncateLen, ellipsisChars) {
    var ellipsisLengthBeforeParsing;
    var ellipsisLength;
    if (ellipsisChars == null) {
        ellipsisChars = '&hellip;';
        ellipsisLength = 3;
        ellipsisLengthBeforeParsing = 8;
    }
    else {
        ellipsisLength = ellipsisChars.length;
        ellipsisLengthBeforeParsing = ellipsisChars.length;
    }
    var parse_url = function (url) {
        var urlObj = {};
        var urlSub = url;
        var match = urlSub.match(/^([a-z]+):\/\//i);
        if (match) {
            urlObj.scheme = match[1];
            urlSub = urlSub.substr(match[0].length);
        }
        match = urlSub.match(/^(.*?)(?=(\?|#|\/|$))/i);
        if (match) {
            urlObj.host = match[1];
            urlSub = urlSub.substr(match[0].length);
        }
        match = urlSub.match(/^\/(.*?)(?=(\?|#|$))/i);
        if (match) {
            urlObj.path = match[1];
            urlSub = urlSub.substr(match[0].length);
        }
        match = urlSub.match(/^\?(.*?)(?=(#|$))/i);
        if (match) {
            urlObj.query = match[1];
            urlSub = urlSub.substr(match[0].length);
        }
        match = urlSub.match(/^#(.*?)$/i);
        if (match) {
            urlObj.fragment = match[1];
            //urlSub = urlSub.substr(match[0].length);  -- not used. Uncomment if adding another block.
        }
        return urlObj;
    };
    var buildUrl = function (urlObj) {
        var url = "";
        if (urlObj.scheme && urlObj.host) {
            url += urlObj.scheme + "://";
        }
        if (urlObj.host) {
            url += urlObj.host;
        }
        if (urlObj.path) {
            url += "/" + urlObj.path;
        }
        if (urlObj.query) {
            url += "?" + urlObj.query;
        }
        if (urlObj.fragment) {
            url += "#" + urlObj.fragment;
        }
        return url;
    };
    var buildSegment = function (segment, remainingAvailableLength) {
        var remainingAvailableLengthHalf = remainingAvailableLength / 2, startOffset = Math.ceil(remainingAvailableLengthHalf), endOffset = (-1) * Math.floor(remainingAvailableLengthHalf), end = "";
        if (endOffset < 0) {
            end = segment.substr(endOffset);
        }
        return segment.substr(0, startOffset) + ellipsisChars + end;
    };
    if (url.length <= truncateLen) {
        return url;
    }
    var availableLength = truncateLen - ellipsisLength;
    var urlObj = parse_url(url);
    // Clean up the URL
    if (urlObj.query) {
        var matchQuery = urlObj.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);
        if (matchQuery) {
            // Malformed URL; two or more "?". Removed any content behind the 2nd.
            urlObj.query = urlObj.query.substr(0, matchQuery[1].length);
            url = buildUrl(urlObj);
        }
    }
    if (url.length <= truncateLen) {
        return url;
    }
    if (urlObj.host) {
        urlObj.host = urlObj.host.replace(/^www\./, "");
        url = buildUrl(urlObj);
    }
    if (url.length <= truncateLen) {
        return url;
    }
    // Process and build the URL
    var str = "";
    if (urlObj.host) {
        str += urlObj.host;
    }
    if (str.length >= availableLength) {
        if (urlObj.host.length == truncateLen) {
            return (urlObj.host.substr(0, (truncateLen - ellipsisLength)) + ellipsisChars).substr(0, availableLength + ellipsisLengthBeforeParsing);
        }
        return buildSegment(str, availableLength).substr(0, availableLength + ellipsisLengthBeforeParsing);
    }
    var pathAndQuery = "";
    if (urlObj.path) {
        pathAndQuery += "/" + urlObj.path;
    }
    if (urlObj.query) {
        pathAndQuery += "?" + urlObj.query;
    }
    if (pathAndQuery) {
        if ((str + pathAndQuery).length >= availableLength) {
            if ((str + pathAndQuery).length == truncateLen) {
                return (str + pathAndQuery).substr(0, truncateLen);
            }
            var remainingAvailableLength = availableLength - str.length;
            return (str + buildSegment(pathAndQuery, remainingAvailableLength)).substr(0, availableLength + ellipsisLengthBeforeParsing);
        }
        else {
            str += pathAndQuery;
        }
    }
    if (urlObj.fragment) {
        var fragment = "#" + urlObj.fragment;
        if ((str + fragment).length >= availableLength) {
            if ((str + fragment).length == truncateLen) {
                return (str + fragment).substr(0, truncateLen);
            }
            var remainingAvailableLength2 = availableLength - str.length;
            return (str + buildSegment(fragment, remainingAvailableLength2)).substr(0, availableLength + ellipsisLengthBeforeParsing);
        }
        else {
            str += fragment;
        }
    }
    if (urlObj.scheme && urlObj.host) {
        var scheme = urlObj.scheme + "://";
        if ((str + scheme).length < availableLength) {
            return (scheme + str).substr(0, truncateLen);
        }
    }
    if (str.length <= truncateLen) {
        return str;
    }
    var end = "";
    if (availableLength > 0) {
        end = str.substr((-1) * Math.floor(availableLength / 2));
    }
    return (str.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, availableLength + ellipsisLengthBeforeParsing);
}

//# sourceMappingURL=truncate-smart.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = truncateMiddle;

function truncateMiddle(url, truncateLen, ellipsisChars) {
    if (url.length <= truncateLen) {
        return url;
    }
    var ellipsisLengthBeforeParsing;
    var ellipsisLength;
    if (ellipsisChars == null) {
        ellipsisChars = '&hellip;';
        ellipsisLengthBeforeParsing = 8;
        ellipsisLength = 3;
    }
    else {
        ellipsisLengthBeforeParsing = ellipsisChars.length;
        ellipsisLength = ellipsisChars.length;
    }
    var availableLength = truncateLen - ellipsisLength;
    var end = "";
    if (availableLength > 0) {
        end = url.substr((-1) * Math.floor(availableLength / 2));
    }
    return (url.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, availableLength + ellipsisLengthBeforeParsing);
}

//# sourceMappingURL=truncate-middle.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = truncateEnd;
 var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(133);


function truncateEnd(anchorText, truncateLen, ellipsisChars) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" ])(anchorText, truncateLen, ellipsisChars);
}

//# sourceMappingURL=truncate-end.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return UrlMatchValidator; });
 var __WEBPACK_IMPORTED_MODULE_0__regex_lib__ = __webpack_require__(89);


var UrlMatchValidator =  (function () {
    function UrlMatchValidator() {
    }
    
    UrlMatchValidator.isValid = function (urlMatch, protocolUrlMatch) {
        if ((protocolUrlMatch && !this.isValidUriScheme(protocolUrlMatch)) ||
            this.urlMatchDoesNotHaveProtocolOrDot(urlMatch, protocolUrlMatch) || // At least one period ('.') must exist in the URL match for us to consider it an actual URL, *unless* it was a full protocol match (like 'http://localhost')
            (this.urlMatchDoesNotHaveAtLeastOneWordChar(urlMatch, protocolUrlMatch) && // At least one letter character must exist in the domain name after a protocol match. Ex: skip over something like "git:1.0"
                !this.isValidIpAddress(urlMatch)) || // Except if it's an IP address
            this.containsMultipleDots(urlMatch)) {
            return false;
        }
        return true;
    };
    UrlMatchValidator.isValidIpAddress = function (uriSchemeMatch) {
        var newRegex = new RegExp(this.hasFullProtocolRegex.source + this.ipRegex.source);
        var uriScheme = uriSchemeMatch.match(newRegex);
        return uriScheme !== null;
    };
    UrlMatchValidator.containsMultipleDots = function (urlMatch) {
        var stringBeforeSlash = urlMatch;
        if (this.hasFullProtocolRegex.test(urlMatch)) {
            stringBeforeSlash = urlMatch.split('://')[1];
        }
        return stringBeforeSlash.split('/')[0].indexOf("..") > -1;
    };
    
    UrlMatchValidator.isValidUriScheme = function (uriSchemeMatch) {
        var uriSchemeMatchArr = uriSchemeMatch.match(this.uriSchemeRegex), uriScheme = uriSchemeMatchArr && uriSchemeMatchArr[0].toLowerCase();
        return (uriScheme !== 'javascript:' && uriScheme !== 'vbscript:');
    };
    
    UrlMatchValidator.urlMatchDoesNotHaveProtocolOrDot = function (urlMatch, protocolUrlMatch) {
        return (!!urlMatch && (!protocolUrlMatch || !this.hasFullProtocolRegex.test(protocolUrlMatch)) && urlMatch.indexOf('.') === -1);
    };
    
    UrlMatchValidator.urlMatchDoesNotHaveAtLeastOneWordChar = function (urlMatch, protocolUrlMatch) {
        if (urlMatch && protocolUrlMatch) {
            return !this.hasFullProtocolRegex.test(protocolUrlMatch) && !this.hasWordCharAfterProtocolRegex.test(urlMatch);
        }
        else {
            return false;
        }
    };
    
    UrlMatchValidator.hasFullProtocolRegex = /^[A-Za-z][-.+A-Za-z0-9]*:\/\//;
    
    UrlMatchValidator.uriSchemeRegex = /^[A-Za-z][-.+A-Za-z0-9]*:/;
    
    UrlMatchValidator.hasWordCharAfterProtocolRegex = new RegExp(":[^\\s]*?[" + __WEBPACK_IMPORTED_MODULE_0__regex_lib__["a" ] + "]");
    
    UrlMatchValidator.ipRegex = /[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?(:[0-9]*)?\/?$/;
    return UrlMatchValidator;
}());


//# sourceMappingURL=url-match-validator.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = parseHtml;
 var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(55);
 var __WEBPACK_IMPORTED_MODULE_1__regex_lib__ = __webpack_require__(89);
 var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(133);



// For debugging: search for other "For debugging" lines
// import CliTable from 'cli-table';

function parseHtml(html, _a) {
    var onOpenTag = _a.onOpenTag, onCloseTag = _a.onCloseTag, onText = _a.onText, onComment = _a.onComment, onDoctype = _a.onDoctype;
    var noCurrentTag = new CurrentTag();
    var charIdx = 0, len = html.length, state = 0 , currentDataIdx = 0, // where the current data start index is
    currentTag = noCurrentTag; // describes the current tag that is being read
    // For debugging: search for other "For debugging" lines
    // const table = new CliTable( {
    // 	head: [ 'charIdx', 'char', 'state', 'currentDataIdx', 'currentOpenTagIdx', 'tag.type' ]
    // } );
    while (charIdx < len) {
        var char = html.charAt(charIdx);
        // For debugging: search for other "For debugging" lines
        // ALSO: Temporarily remove the 'const' keyword on the State enum
        // table.push( 
        // 	[ charIdx, char, State[ state ], currentDataIdx, currentTag.idx, currentTag.idx === -1 ? '' : currentTag.type ] 
        // );
        switch (state) {
            case 0 :
                stateData(char);
                break;
            case 1 :
                stateTagOpen(char);
                break;
            case 2 :
                stateEndTagOpen(char);
                break;
            case 3 :
                stateTagName(char);
                break;
            case 4 :
                stateBeforeAttributeName(char);
                break;
            case 5 :
                stateAttributeName(char);
                break;
            case 6 :
                stateAfterAttributeName(char);
                break;
            case 7 :
                stateBeforeAttributeValue(char);
                break;
            case 8 :
                stateAttributeValueDoubleQuoted(char);
                break;
            case 9 :
                stateAttributeValueSingleQuoted(char);
                break;
            case 10 :
                stateAttributeValueUnquoted(char);
                break;
            case 11 :
                stateAfterAttributeValueQuoted(char);
                break;
            case 12 :
                stateSelfClosingStartTag(char);
                break;
            case 13 :
                stateMarkupDeclarationOpen(char);
                break;
            case 14 :
                stateCommentStart(char);
                break;
            case 15 :
                stateCommentStartDash(char);
                break;
            case 16 :
                stateComment(char);
                break;
            case 17 :
                stateCommentEndDash(char);
                break;
            case 18 :
                stateCommentEnd(char);
                break;
            case 19 :
                stateCommentEndBang(char);
                break;
            case 20 :
                stateDoctype(char);
                break;
            default:
                Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" ])(state);
        }
        // For debugging: search for other "For debugging" lines
        // ALSO: Temporarily remove the 'const' keyword on the State enum
        // table.push( 
        // 	[ charIdx, char, State[ state ], currentDataIdx, currentTag.idx, currentTag.idx === -1 ? '' : currentTag.type ] 
        // );
        charIdx++;
    }
    if (currentDataIdx < charIdx) {
        emitText();
    }
    // For debugging: search for other "For debugging" lines
    // console.log( '\n' + table.toString() );
    // Called when non-tags are being read (i.e. the text around HTML †ags)
    // https://www.w3.org/TR/html51/syntax.html#data-state
    function stateData(char) {
        if (char === '<') {
            startNewTag();
        }
    }
    // Called after a '<' is read from the Data state
    // https://www.w3.org/TR/html51/syntax.html#tag-open-state
    function stateTagOpen(char) {
        if (char === '!') {
            state = 13 ;
        }
        else if (char === '/') {
            state = 2 ;
            currentTag = new CurrentTag(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])({}, currentTag), { isClosing: true }));
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag();
        }
        else if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["h" ].test(char)) {
            // tag name start (and no '/' read)
            state = 3 ;
            currentTag = new CurrentTag(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])({}, currentTag), { isOpening: true }));
        }
        else {
            // Any other 
            state = 0 ;
            currentTag = noCurrentTag;
        }
    }
    // After a '<x', '</x' sequence is read (where 'x' is a letter character), 
    // this is to continue reading the tag name
    // https://www.w3.org/TR/html51/syntax.html#tag-name-state
    function stateTagName(char) {
        if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["k" ].test(char)) {
            currentTag = new CurrentTag(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])({}, currentTag), { name: captureTagName() }));
            state = 4 ;
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag();
        }
        else if (char === '/') {
            currentTag = new CurrentTag(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])({}, currentTag), { name: captureTagName() }));
            state = 12 ;
        }
        else if (char === '>') {
            currentTag = new CurrentTag(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])({}, currentTag), { name: captureTagName() }));
            emitTagAndPreviousTextNode(); // resets to Data state as well
        }
        else if (!__WEBPACK_IMPORTED_MODULE_1__regex_lib__["h" ].test(char) && !__WEBPACK_IMPORTED_MODULE_1__regex_lib__["e" ].test(char) && char !== ':') {
            // Anything else that does not form an html tag. Note: the colon 
            // character is accepted for XML namespaced tags
            resetToDataState();
        }
        else {
            // continue reading tag name
        }
    }
    // Called after the '/' is read from a '</' sequence
    // https://www.w3.org/TR/html51/syntax.html#end-tag-open-state
    function stateEndTagOpen(char) {
        if (char === '>') { // parse error. Encountered "</>". Skip it without treating as a tag
            resetToDataState();
        }
        else if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["h" ].test(char)) {
            state = 3 ;
        }
        else {
            // some other non-tag-like character, don't treat this as a tag
            resetToDataState();
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#before-attribute-name-state
    function stateBeforeAttributeName(char) {
        if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["k" ].test(char)) {
            // stay in BeforeAttributeName state - continue reading chars
        }
        else if (char === '/') {
            state = 12 ;
        }
        else if (char === '>') {
            emitTagAndPreviousTextNode(); // resets to Data state as well
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag();
        }
        else if (char === "=" || __WEBPACK_IMPORTED_MODULE_1__regex_lib__["j" ].test(char) || __WEBPACK_IMPORTED_MODULE_1__regex_lib__["d" ].test(char)) {
            // "Parse error" characters that, according to the spec, should be
            // appended to the attribute name, but we'll treat these characters
            // as not forming a real HTML tag
            resetToDataState();
        }
        else {
            // Any other char, start of a new attribute name
            state = 5 ;
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#attribute-name-state
    function stateAttributeName(char) {
        if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["k" ].test(char)) {
            state = 6 ;
        }
        else if (char === '/') {
            state = 12 ;
        }
        else if (char === '=') {
            state = 7 ;
        }
        else if (char === '>') {
            emitTagAndPreviousTextNode(); // resets to Data state as well
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag();
        }
        else if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["j" ].test(char)) {
            // "Parse error" characters that, according to the spec, should be
            // appended to the attribute name, but we'll treat these characters
            // as not forming a real HTML tag
            resetToDataState();
        }
        else {
            // anything else: continue reading attribute name
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#after-attribute-name-state
    function stateAfterAttributeName(char) {
        if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["k" ].test(char)) {
            // ignore the character - continue reading
        }
        else if (char === '/') {
            state = 12 ;
        }
        else if (char === '=') {
            state = 7 ;
        }
        else if (char === '>') {
            emitTagAndPreviousTextNode();
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag();
        }
        else if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["j" ].test(char)) {
            // "Parse error" characters that, according to the spec, should be
            // appended to the attribute name, but we'll treat these characters
            // as not forming a real HTML tag
            resetToDataState();
        }
        else {
            // Any other character, start a new attribute in the current tag
            state = 5 ;
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#before-attribute-value-state
    function stateBeforeAttributeValue(char) {
        if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["k" ].test(char)) {
            // ignore the character - continue reading
        }
        else if (char === "\"") {
            state = 8 ;
        }
        else if (char === "'") {
            state = 9 ;
        }
        else if (/[>=`]/.test(char)) {
            // Invalid chars after an '=' for an attribute value, don't count 
            // the current tag as an HTML tag
            resetToDataState();
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag();
        }
        else {
            // Any other character, consider it an unquoted attribute value
            state = 10 ;
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#attribute-value-double-quoted-state
    function stateAttributeValueDoubleQuoted(char) {
        if (char === "\"") { // end the current double-quoted attribute
            state = 11 ;
        }
        else {
            // consume the character as part of the double-quoted attribute value
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#attribute-value-single-quoted-state
    function stateAttributeValueSingleQuoted(char) {
        if (char === "'") { // end the current single-quoted attribute
            state = 11 ;
        }
        else {
            // consume the character as part of the double-quoted attribute value
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#attribute-value-unquoted-state
    function stateAttributeValueUnquoted(char) {
        if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["k" ].test(char)) {
            state = 4 ;
        }
        else if (char === '>') {
            emitTagAndPreviousTextNode();
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag();
        }
        else {
            // Any other character, treat it as part of the attribute value
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#after-attribute-value-quoted-state
    function stateAfterAttributeValueQuoted(char) {
        if (__WEBPACK_IMPORTED_MODULE_1__regex_lib__["k" ].test(char)) {
            state = 4 ;
        }
        else if (char === '/') {
            state = 12 ;
        }
        else if (char === '>') {
            emitTagAndPreviousTextNode();
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag();
        }
        else {
            // Any other character, "parse error". Spec says to switch to the
            // BeforeAttributeState and re-consume the character, as it may be
            // the start of a new attribute name
            state = 4 ;
            reconsumeCurrentCharacter();
        }
    }
    // A '/' has just been read in the current tag (presumably for '/>'), and 
    // this handles the next character
    // https://www.w3.org/TR/html51/syntax.html#self-closing-start-tag-state
    function stateSelfClosingStartTag(char) {
        if (char === '>') {
            currentTag = new CurrentTag(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])({}, currentTag), { isClosing: true }));
            emitTagAndPreviousTextNode(); // resets to Data state as well
        }
        else {
            state = 4 ;
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#markup-declaration-open-state
    // (HTML Comments or !DOCTYPE)
    function stateMarkupDeclarationOpen(char) {
        if (html.substr(charIdx, 2) === '--') { // html comment
            charIdx += 2; // "consume" characters
            currentTag = new CurrentTag(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])({}, currentTag), { type: 'comment' }));
            state = 14 ;
        }
        else if (html.substr(charIdx, 7).toUpperCase() === 'DOCTYPE') {
            charIdx += 7; // "consume" characters
            currentTag = new CurrentTag(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" ])({}, currentTag), { type: 'doctype' }));
            state = 20 ;
        }
        else {
            // At this point, the spec specifies that the state machine should
            // enter the "bogus comment" state, in which case any character(s) 
            // after the '<!' that were read should become an HTML comment up
            // until the first '>' that is read (or EOF). Instead, we'll assume
            // that a user just typed '<!' as part of text data
            resetToDataState();
        }
    }
    // Handles after the sequence '<!--' has been read
    // https://www.w3.org/TR/html51/syntax.html#comment-start-state
    function stateCommentStart(char) {
        if (char === '-') {
            // We've read the sequence '<!---' at this point (3 dashes)
            state = 15 ;
        }
        else if (char === '>') {
            // At this point, we'll assume the comment wasn't a real comment
            // so we'll just emit it as data. We basically read the sequence 
            // '<!-->'
            resetToDataState();
        }
        else {
            // Any other char, take it as part of the comment
            state = 16 ;
        }
    }
    // We've read the sequence '<!---' at this point (3 dashes)
    // https://www.w3.org/TR/html51/syntax.html#comment-start-dash-state
    function stateCommentStartDash(char) {
        if (char === '-') {
            // We've read '<!----' (4 dashes) at this point
            state = 18 ;
        }
        else if (char === '>') {
            // At this point, we'll assume the comment wasn't a real comment
            // so we'll just emit it as data. We basically read the sequence 
            // '<!--->'
            resetToDataState();
        }
        else {
            // Anything else, take it as a valid comment
            state = 16 ;
        }
    }
    // Currently reading the comment's text (data)
    // https://www.w3.org/TR/html51/syntax.html#comment-state
    function stateComment(char) {
        if (char === '-') {
            state = 17 ;
        }
        else {
            // Any other character, stay in the Comment state
        }
    }
    // When we we've read the first dash inside a comment, it may signal the
    // end of the comment if we read another dash
    // https://www.w3.org/TR/html51/syntax.html#comment-end-dash-state
    function stateCommentEndDash(char) {
        if (char === '-') {
            state = 18 ;
        }
        else {
            // Wasn't a dash, must still be part of the comment
            state = 16 ;
        }
    }
    // After we've read two dashes inside a comment, it may signal the end of 
    // the comment if we then read a '>' char
    // https://www.w3.org/TR/html51/syntax.html#comment-end-state
    function stateCommentEnd(char) {
        if (char === '>') {
            emitTagAndPreviousTextNode();
        }
        else if (char === '!') {
            state = 19 ;
        }
        else if (char === '-') {
            // A 3rd '-' has been read: stay in the CommentEnd state
        }
        else {
            // Anything else, switch back to the comment state since we didn't
            // read the full "end comment" sequence (i.e. '-->')
            state = 16 ;
        }
    }
    // We've read the sequence '--!' inside of a comment
    // https://www.w3.org/TR/html51/syntax.html#comment-end-bang-state
    function stateCommentEndBang(char) {
        if (char === '-') {
            // We read the sequence '--!-' inside of a comment. The last dash
            // could signify that the comment is going to close
            state = 17 ;
        }
        else if (char === '>') {
            // End of comment with the sequence '--!>'
            emitTagAndPreviousTextNode();
        }
        else {
            // The '--!' was not followed by a '>', continue reading the 
            // comment's text
            state = 16 ;
        }
    }
    
    function stateDoctype(char) {
        if (char === '>') {
            emitTagAndPreviousTextNode();
        }
        else if (char === '<') {
            startNewTag();
        }
        else {
            // stay in the Doctype state
        }
    }
    
    function resetToDataState() {
        state = 0 ;
        currentTag = noCurrentTag;
    }
    
    function startNewTag() {
        state = 1 ;
        currentTag = new CurrentTag({ idx: charIdx });
    }
    
    function emitTagAndPreviousTextNode() {
        var textBeforeTag = html.slice(currentDataIdx, currentTag.idx);
        if (textBeforeTag) {
            // the html tag was the first element in the html string, or two 
            // tags next to each other, in which case we should not emit a text 
            // node
            onText(textBeforeTag, currentDataIdx);
        }
        if (currentTag.type === 'comment') {
            onComment(currentTag.idx);
        }
        else if (currentTag.type === 'doctype') {
            onDoctype(currentTag.idx);
        }
        else {
            if (currentTag.isOpening) {
                onOpenTag(currentTag.name, currentTag.idx);
            }
            if (currentTag.isClosing) { // note: self-closing tags will emit both opening and closing
                onCloseTag(currentTag.name, currentTag.idx);
            }
        }
        // Since we just emitted a tag, reset to the data state for the next char
        resetToDataState();
        currentDataIdx = charIdx + 1;
    }
    function emitText() {
        var text = html.slice(currentDataIdx, charIdx);
        onText(text, currentDataIdx);
        currentDataIdx = charIdx + 1;
    }
    
    function captureTagName() {
        var startIdx = currentTag.idx + (currentTag.isClosing ? 2 : 1);
        return html.slice(startIdx, charIdx).toLowerCase();
    }
    
    function reconsumeCurrentCharacter() {
        charIdx--;
    }
}
var CurrentTag =  (function () {
    function CurrentTag(cfg) {
        if (cfg === void 0) { cfg = {}; }
        this.idx = cfg.idx !== undefined ? cfg.idx : -1;
        this.type = cfg.type || 'tag';
        this.name = cfg.name || '';
        this.isOpening = !!cfg.isOpening;
        this.isClosing = !!cfg.isClosing;
    }
    return CurrentTag;
}());

//# sourceMappingURL=parse-html.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__email_match__ = __webpack_require__(242);

 var __WEBPACK_IMPORTED_MODULE_1__hashtag_match__ = __webpack_require__(243);

 var __WEBPACK_IMPORTED_MODULE_2__match__ = __webpack_require__(87);

 var __WEBPACK_IMPORTED_MODULE_3__mention_match__ = __webpack_require__(244);

 var __WEBPACK_IMPORTED_MODULE_4__phone_match__ = __webpack_require__(245);

 var __WEBPACK_IMPORTED_MODULE_5__url_match__ = __webpack_require__(246);








//# sourceMappingURL=index.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__email_matcher__ = __webpack_require__(425);

 var __WEBPACK_IMPORTED_MODULE_1__hashtag_matcher__ = __webpack_require__(428);

 var __WEBPACK_IMPORTED_MODULE_2__matcher__ = __webpack_require__(88);

 var __WEBPACK_IMPORTED_MODULE_3__mention_matcher__ = __webpack_require__(430);

 var __WEBPACK_IMPORTED_MODULE_4__phone_matcher__ = __webpack_require__(429);

 var __WEBPACK_IMPORTED_MODULE_5__url_matcher__ = __webpack_require__(427);








//# sourceMappingURL=index.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__Input__ = __webpack_require__(112);
 var __WEBPACK_IMPORTED_MODULE_7__FilledInput__ = __webpack_require__(431);
 var __WEBPACK_IMPORTED_MODULE_8__OutlinedInput__ = __webpack_require__(432);
 var __WEBPACK_IMPORTED_MODULE_9__InputLabel__ = __webpack_require__(177);
 var __WEBPACK_IMPORTED_MODULE_10__FormControl__ = __webpack_require__(433);
 var __WEBPACK_IMPORTED_MODULE_11__FormHelperText__ = __webpack_require__(975);
 var __WEBPACK_IMPORTED_MODULE_12__Select__ = __webpack_require__(250);
 var __WEBPACK_IMPORTED_MODULE_13__styles_withStyles__ = __webpack_require__(15);














var variantComponent = {
  standard: __WEBPACK_IMPORTED_MODULE_6__Input__["a" ],
  filled: __WEBPACK_IMPORTED_MODULE_7__FilledInput__["a" ],
  outlined: __WEBPACK_IMPORTED_MODULE_8__OutlinedInput__["a" ]
};
var styles = {
  
  root: {}
};


var TextField = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TextField(props, ref) {
  var autoComplete = props.autoComplete,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      FormHelperTextProps = props.FormHelperTextProps,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      helperText = props.helperText,
      hiddenLabel = props.hiddenLabel,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      _props$select = props.select,
      select = _props$select === void 0 ? false : _props$select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);

  if (false) {
    if (select && !children) {
      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }

  var InputMore = {};

  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }

    if (label) {
      var _InputLabelProps$requ;

      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
      InputMore.label = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, label, displayRequired && "\xA0*");
    }
  }

  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }

    InputMore['aria-describedby'] = undefined;
  }

  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var InputComponent = variantComponent[variant];
  var InputElement = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__FormControl__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    ref: ref,
    required: required,
    color: color,
    variant: variant
  }, other), label && __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__InputLabel__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    htmlFor: id,
    id: inputLabelId
  }, InputLabelProps), label), select ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Select__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    "aria-describedby": helperTextId,
    id: id,
    labelId: inputLabelId,
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__FormHelperText__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    id: helperTextId
  }, FormHelperTextProps), helperText));
});
 false ? TextField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  autoComplete: PropTypes.string,

  
  autoFocus: PropTypes.bool,

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['primary', 'secondary']),

  
  defaultValue: PropTypes.any,

  
  disabled: PropTypes.bool,

  
  error: PropTypes.bool,

  
  FormHelperTextProps: PropTypes.object,

  
  fullWidth: PropTypes.bool,

  
  helperText: PropTypes.node,

  
  hiddenLabel: PropTypes.bool,

  
  id: PropTypes.string,

  
  InputLabelProps: PropTypes.object,

  
  inputProps: PropTypes.object,

  
  InputProps: PropTypes.object,

  
  inputRef: refType,

  
  label: PropTypes.node,

  
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),

  
  multiline: PropTypes.bool,

  
  name: PropTypes.string,

  
  onBlur: PropTypes.func,

  
  onChange: PropTypes.func,

  
  onFocus: PropTypes.func,

  
  placeholder: PropTypes.string,

  
  required: PropTypes.bool,

  
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  select: PropTypes.bool,

  
  SelectProps: PropTypes.object,

  
  size: PropTypes.oneOf(['medium', 'small']),

  
  type: PropTypes.string,

  
  value: PropTypes.any,

  
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13__styles_withStyles__["a" ])(styles, {
  name: 'MuiTextField'
})(TextField));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(113);
 var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(15);








var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    
    root: {
      position: 'relative'
    },

    
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    
    focused: {},

    
    disabled: {},

    
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    
    error: {},

    
    marginDense: {},

    
    multiline: {},

    
    fullWidth: {},

    
    input: {},

    
    inputMarginDense: {},

    
    inputMultiline: {},

    
    inputTypeSearch: {}
  };
};
var Input = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Input(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? Input.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  autoComplete: PropTypes.string,

  
  autoFocus: PropTypes.bool,

  
  classes: PropTypes.object,

  
  color: PropTypes.oneOf(['primary', 'secondary']),

  
  defaultValue: PropTypes.any,

  
  disabled: PropTypes.bool,

  
  disableUnderline: PropTypes.bool,

  
  endAdornment: PropTypes.node,

  
  error: PropTypes.bool,

  
  fullWidth: PropTypes.bool,

  
  id: PropTypes.string,

  
  inputComponent: PropTypes.elementType,

  
  inputProps: PropTypes.object,

  
  inputRef: refType,

  
  margin: PropTypes.oneOf(['dense', 'none']),

  
  multiline: PropTypes.bool,

  
  name: PropTypes.string,

  
  onChange: PropTypes.func,

  
  placeholder: PropTypes.string,

  
  readOnly: PropTypes.bool,

  
  required: PropTypes.bool,

  
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  startAdornment: PropTypes.node,

  
  type: PropTypes.string,

  
  value: PropTypes.any
} : void 0;
Input.muiName = 'Input';
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" ])(styles, {
  name: 'MuiInput'
})(Input));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(114);
 var __WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__ = __webpack_require__(248);
 var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(38);
 var __WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__ = __webpack_require__(46);
 var __WEBPACK_IMPORTED_MODULE_11__TextareaAutosize__ = __webpack_require__(966);
 var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(249);
















var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: '0 !important'
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    '@global': {
      '@keyframes mui-auto-fill': {},
      '@keyframes mui-auto-fill-cancel': {}
    },

    
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, theme.typography.body1, {
      color: theme.palette.text.primary,
      lineHeight: '1.1876em',
      // Reset (19px), match the native input line-height
      boxSizing: 'border-box',
      // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    }),

    
    formControl: {},

    
    focused: {},

    
    disabled: {},

    
    adornedStart: {},

    
    adornedEnd: {},

    
    error: {},

    
    marginDense: {},

    
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      '&$marginDense': {
        paddingTop: 4 - 1
      }
    },

    
    colorSecondary: {},

    
    fullWidth: {
      width: '100%'
    },

    
    input: {
      font: 'inherit',
      letterSpacing: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      height: '1.1876em',
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      animationName: 'mui-auto-fill-cancel',
      animationDuration: '10ms',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      },
      '&:-webkit-autofill': {
        animationDuration: '5000s',
        animationName: 'mui-auto-fill'
      }
    },

    
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    
    inputMultiline: {
      height: 'auto',
      resize: 'none',
      padding: 0
    },

    
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    
    inputAdornedStart: {},

    
    inputAdornedEnd: {},

    
    inputHiddenLabel: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_3_react__["useLayoutEffect"];


var InputBase = __WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function InputBase(props, ref) {
  var ariaDescribedby = props['aria-describedby'],
      autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      classes = props.classes,
      className = props.className,
      color = props.color,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      endAdornment = props.endAdornment,
      error = props.error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      id = props.id,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$inputProps = props.inputProps,
      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
      inputRefProp = props.inputRef,
      margin = props.margin,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      renderSuffix = props.renderSuffix,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMin = props.rowsMin,
      startAdornment = props.startAdornment,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      valueProp = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "startAdornment", "type", "value"]);

  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](value != null),
      isControlled = _React$useRef.current;

  var inputRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var handleInputRefWarning = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (instance) {
    if (false) {
      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
        console.error(['Material-UI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  var handleInputPropsRefProp = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" ])(inputPropsProp.ref, handleInputRefWarning);
  var handleInputRefProp = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" ])(inputRefProp, handleInputPropsRefProp);
  var handleInputRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" ])(inputRef, handleInputRefProp);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["b" ])();

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }

      return undefined;
    }, [muiFormControl]);
  }

  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" ])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  var onFilled = muiFormControl && muiFormControl.onFilled;
  var onEmpty = muiFormControl && muiFormControl.onEmpty;
  var checkDirty = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" ])(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect(function () {
    if (isControlled) {
      checkDirty({
        value: value
      });
    }
  }, [value, checkDirty, isControlled]);

  var handleFocus = function handleFocus(event) {
    // Fix a bug with IE 11 where the focus/blur events are triggered
    // while the input is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      var element = event.target || inputRef.current;

      if (element == null) {
        throw new Error( false ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info." : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" ])(1));
      }

      checkDirty({
        value: element.value
      });
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
    } // Perform in the willUpdate


    if (onChange) {
      onChange.apply(void 0, [event].concat(args));
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    checkDirty(inputRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(event) {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  var InputComponent = inputComponent;

  var inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, inputPropsProp, {
    ref: handleInputRef
  });

  if (typeof InputComponent !== 'string') {
    inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type: type
    }, inputProps, {
      ref: null
    });
  } else if (multiline) {
    if (rows && !rowsMax && !rowsMin) {
      InputComponent = 'textarea';
    } else {
      inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
        rows: rows,
        rowsMax: rowsMax
      }, inputProps);
      InputComponent = __WEBPACK_IMPORTED_MODULE_11__TextareaAutosize__["a" ];
    }
  } else {
    inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
      type: type
    }, inputProps);
  }

  var handleAutoFill = function handleAutoFill(event) {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" ])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
    onClick: handleClick,
    ref: ref
  }, other), startAdornment, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["a" ].Provider, {
    value: null
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: fcs.disabled,
    id: id,
    onAnimationStart: handleAutoFill,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    required: fcs.required,
    rows: rows,
    value: value,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }, inputProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }))), endAdornment, renderSuffix ? renderSuffix(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, fcs, {
    startAdornment: startAdornment
  })) : null);
});
 false ? InputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  'aria-describedby': PropTypes.string,

  
  autoComplete: PropTypes.string,

  
  autoFocus: PropTypes.bool,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['primary', 'secondary']),

  
  defaultValue: PropTypes.any,

  
  disabled: PropTypes.bool,

  
  endAdornment: PropTypes.node,

  
  error: PropTypes.bool,

  
  fullWidth: PropTypes.bool,

  
  id: PropTypes.string,

  
  inputComponent: PropTypes.elementType,

  
  inputProps: PropTypes.object,

  
  inputRef: refType,

  
  margin: PropTypes.oneOf(['dense', 'none']),

  
  multiline: PropTypes.bool,

  
  name: PropTypes.string,

  
  onBlur: PropTypes.func,

  
  onChange: PropTypes.func,

  
  onClick: PropTypes.func,

  
  onFocus: PropTypes.func,

  
  onKeyDown: PropTypes.func,

  
  onKeyUp: PropTypes.func,

  
  placeholder: PropTypes.string,

  
  readOnly: PropTypes.bool,

  
  renderSuffix: PropTypes.func,

  
  required: PropTypes.bool,

  
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  rowsMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  startAdornment: PropTypes.node,

  
  type: PropTypes.string,

  
  value: PropTypes.any
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" ])(styles, {
  name: 'MuiInputBase'
})(InputBase));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__TextareaAutosize__ = __webpack_require__(967);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextareaAutosize__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4__utils_debounce__ = __webpack_require__(164);
 var __WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__ = __webpack_require__(46);







function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"];
var styles = {
  
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
var TextareaAutosize = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TextareaAutosize(props, ref) {
  var onChange = props.onChange,
      rows = props.rows,
      rowsMax = props.rowsMax,
      _props$rowsMin = props.rowsMin,
      rowsMinProp = _props$rowsMin === void 0 ? 1 : _props$rowsMin,
      style = props.style,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]);

  var rowsMin = rows || rowsMinProp;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](value != null),
      isControlled = _React$useRef.current;

  var inputRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__["a" ])(ref, inputRef);
  var shadowRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var renders = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](0);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"]({}),
      state = _React$useState[0],
      setState = _React$useState[1];

  var syncHeight = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    var boxSizing = computedStyle['box-sizing'];
    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (rowsMin) {
      outerHeight = Math.max(Number(rowsMin) * singleRowHeight, outerHeight);
    }

    if (rowsMax) {
      outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function (prevState) {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      if (false) {
        if (renders.current === 20) {
          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
        }
      }

      return prevState;
    });
  }, [rowsMax, rowsMin, props.placeholder]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_4__utils_debounce__["a" ])(function () {
      renders.current = 0;
      syncHeight();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect(function () {
    syncHeight();
  });
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    renders.current = 0;
  }, [value]);

  var handleChange = function handleChange(event) {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("textarea", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    value: value,
    onChange: handleChange,
    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
    ,
    rows: rowsMin,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      height: state.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? 'hidden' : null
    }, style)
  }, other)), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, styles.shadow, style)
  }));
});
 false ? TextareaAutosize.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  className: PropTypes.string,

  
  onChange: PropTypes.func,

  
  placeholder: PropTypes.string,

  
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  rowsMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  style: PropTypes.object,

  
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
} : void 0;
 __webpack_exports__["a"] = (TextareaAutosize);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(113);
 var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(15);








var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    
    focused: {},

    
    disabled: {},

    
    adornedStart: {
      paddingLeft: 12
    },

    
    adornedEnd: {
      paddingRight: 12
    },

    
    error: {},

    
    marginDense: {},

    
    multiline: {
      padding: '27px 12px 10px',
      '&$marginDense': {
        paddingTop: 23,
        paddingBottom: 6
      }
    },

    
    input: {
      padding: '27px 12px 10px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      }
    },

    
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },

    
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      '&$inputMarginDense': {
        paddingTop: 10,
        paddingBottom: 11
      }
    },

    
    inputMultiline: {
      padding: 0
    },

    
    inputAdornedStart: {
      paddingLeft: 0
    },

    
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var FilledInput = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FilledInput(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? FilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  autoComplete: PropTypes.string,

  
  autoFocus: PropTypes.bool,

  
  classes: PropTypes.object,

  
  color: PropTypes.oneOf(['primary', 'secondary']),

  
  defaultValue: PropTypes.any,

  
  disabled: PropTypes.bool,

  
  disableUnderline: PropTypes.bool,

  
  endAdornment: PropTypes.node,

  
  error: PropTypes.bool,

  
  fullWidth: PropTypes.bool,

  
  id: PropTypes.string,

  
  inputComponent: PropTypes.elementType,

  
  inputProps: PropTypes.object,

  
  inputRef: refType,

  
  margin: PropTypes.oneOf(['dense', 'none']),

  
  multiline: PropTypes.bool,

  
  name: PropTypes.string,

  
  onChange: PropTypes.func,

  
  placeholder: PropTypes.string,

  
  readOnly: PropTypes.bool,

  
  required: PropTypes.bool,

  
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  startAdornment: PropTypes.node,

  
  type: PropTypes.string,

  
  value: PropTypes.any
} : void 0;
FilledInput.muiName = 'Input';
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" ])(styles, {
  name: 'MuiFilledInput'
})(FilledInput));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(113);
 var __WEBPACK_IMPORTED_MODULE_7__NotchedOutline__ = __webpack_require__(970);
 var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(15);









var styles = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    
    root: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        '&:hover $notchedOutline': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    
    focused: {},

    
    disabled: {},

    
    adornedStart: {
      paddingLeft: 14
    },

    
    adornedEnd: {
      paddingRight: 14
    },

    
    error: {},

    
    marginDense: {},

    
    multiline: {
      padding: '18.5px 14px',
      '&$marginDense': {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },

    
    notchedOutline: {
      borderColor: borderColor
    },

    
    input: {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderRadius: 'inherit'
      }
    },

    
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },

    
    inputMultiline: {
      padding: 0
    },

    
    inputAdornedStart: {
      paddingLeft: 0
    },

    
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function OutlinedInput(props, ref) {
  var classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      label = props.label,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      notched = props.notched,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    renderSuffix: function renderSuffix(state) {
      return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__NotchedOutline__["a" ], {
        className: classes.notchedOutline,
        label: label,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? OutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  autoComplete: PropTypes.string,

  
  autoFocus: PropTypes.bool,

  
  classes: PropTypes.object,

  
  color: PropTypes.oneOf(['primary', 'secondary']),

  
  defaultValue: PropTypes.any,

  
  disabled: PropTypes.bool,

  
  endAdornment: PropTypes.node,

  
  error: PropTypes.bool,

  
  fullWidth: PropTypes.bool,

  
  id: PropTypes.string,

  
  inputComponent: PropTypes.elementType,

  
  inputProps: PropTypes.object,

  
  inputRef: refType,

  
  label: PropTypes.node,

  
  labelWidth: PropTypes.number,

  
  margin: PropTypes.oneOf(['dense', 'none']),

  
  multiline: PropTypes.bool,

  
  name: PropTypes.string,

  
  notched: PropTypes.bool,

  
  onChange: PropTypes.func,

  
  placeholder: PropTypes.string,

  
  readOnly: PropTypes.bool,

  
  required: PropTypes.bool,

  
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  startAdornment: PropTypes.node,

  
  type: PropTypes.string,

  
  value: PropTypes.any
} : void 0;
OutlinedInput.muiName = 'Input';
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" ])(styles, {
  name: 'MuiOutlinedInput'
})(OutlinedInput));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(63);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(84);
 var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(38);









var styles = function styles(theme) {
  return {
    
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: '0 8px',
      pointerEvents: 'none',
      borderRadius: 'inherit',
      borderStyle: 'solid',
      borderWidth: 1,
      overflow: 'hidden'
    },

    
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '11px',
      // sync with `height` in `legend` styles
      transition: theme.transitions.create('width', {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    },

    
    legendLabelled: {
      display: 'block',
      width: 'auto',
      textAlign: 'left',
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: '0.75em',
      visibility: 'hidden',
      maxWidth: 0.01,
      transition: theme.transitions.create('max-width', {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      '& > span': {
        paddingLeft: 5,
        paddingRight: 5,
        display: 'inline-block'
      }
    },

    
    legendNotched: {
      maxWidth: 1000,
      transition: theme.transitions.create('max-width', {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
};


var NotchedOutline = __WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function NotchedOutline(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      label = props.label,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" ])();
  var align = theme.direction === 'rtl' ? 'right' : 'left';

  if (label !== undefined) {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("fieldset", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
      "aria-hidden": true,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.root, className),
      ref: ref,
      style: style
    }, other), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("legend", {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", null, label) : __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
      dangerouslySetInnerHTML: {
        __html: '&#8203;'
      }
    })));
  }

  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("fieldset", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    "aria-hidden": true,
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" ])({}, "padding".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" ])(align)), 8), style),
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.root, className),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
});
 false ? NotchedOutline.propTypes = {
  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  label: PropTypes.node,

  
  labelWidth: PropTypes.number.isRequired,

  
  notched: PropTypes.bool.isRequired,

  
  style: PropTypes.object
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'PrivateNotchedOutline'
})(NotchedOutline));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(114);
 var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(90);
 var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_8__FormLabel__ = __webpack_require__(972);









var styles = function styles(theme) {
  return {
    
    root: {
      display: 'block',
      transformOrigin: 'top left'
    },

    
    focused: {},

    
    disabled: {},

    
    error: {},

    
    required: {},

    
    asterisk: {},

    
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 17px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 12px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};
var InputLabel = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function InputLabel(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableAnimati = props.disableAnimation,
      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
      margin = props.margin,
      shrinkProp = props.shrink,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" ])();
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" ])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['margin', 'variant']
  });
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__FormLabel__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    "data-shrink": shrink,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
      'filled': classes.filled,
      'outlined': classes.outlined
    }[fcs.variant]),
    classes: {
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required,
      asterisk: classes.asterisk
    },
    ref: ref
  }, other));
});
 false ? InputLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['primary', 'secondary']),

  
  disableAnimation: PropTypes.bool,

  
  disabled: PropTypes.bool,

  
  error: PropTypes.bool,

  
  focused: PropTypes.bool,

  
  margin: PropTypes.oneOf(['dense']),

  
  required: PropTypes.bool,

  
  shrink: PropTypes.bool,

  
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" ])(styles, {
  name: 'MuiInputLabel'
})(InputLabel));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__FormLabel__ = __webpack_require__(973);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormLabel__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(114);
 var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(90);
 var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(38);
 var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(15);









var styles = function styles(theme) {
  return {
    
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
      color: theme.palette.text.secondary
    }, theme.typography.body1, {
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    
    colorSecondary: {
      '&$focused': {
        color: theme.palette.secondary.main
      }
    },

    
    focused: {},

    
    disabled: {},

    
    error: {},

    
    filled: {},

    
    required: {},

    
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};
var FormLabel = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormLabel(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'label' : _props$component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      required = props.required,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" ])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" ])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" ])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
    ref: ref
  }, other), children, fcs.required && __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    "aria-hidden": true,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.asterisk, fcs.error && classes.error)
  }, "\u2009", '*'));
});
 false ? FormLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['primary', 'secondary']),

  
  component: PropTypes
  
  .elementType,

  
  disabled: PropTypes.bool,

  
  error: PropTypes.bool,

  
  filled: PropTypes.bool,

  
  focused: PropTypes.bool,

  
  required: PropTypes.bool
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" ])(styles, {
  name: 'MuiFormLabel'
})(FormLabel));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__InputBase_utils__ = __webpack_require__(249);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(38);
 var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(233);
 var __WEBPACK_IMPORTED_MODULE_9__FormControlContext__ = __webpack_require__(248);










var styles = {
  
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  
  fullWidth: {
    width: '100%'
  }
};


var FormControl = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormControl(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      visuallyFocused = props.focused,
      _props$hiddenLabel = props.hiddenLabel,
      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? 'none' : _props$margin,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      size = props.size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialAdornedStart = false;

    if (children) {
      __WEBPACK_IMPORTED_MODULE_2_react__["Children"].forEach(children, function (child) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" ])(child, ['Input', 'Select'])) {
          return;
        }

        var input = Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" ])(child, ['Select']) ? child.props.input : child;

        if (input && Object(__WEBPACK_IMPORTED_MODULE_5__InputBase_utils__["a" ])(input.props)) {
          initialAdornedStart = true;
        }
      });
    }

    return initialAdornedStart;
  }),
      adornedStart = _React$useState[0],
      setAdornedStart = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialFilled = false;

    if (children) {
      __WEBPACK_IMPORTED_MODULE_2_react__["Children"].forEach(children, function (child) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" ])(child, ['Input', 'Select'])) {
          return;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_5__InputBase_utils__["b" ])(child.props, true)) {
          initialFilled = true;
        }
      });
    }

    return initialFilled;
  }),
      filled = _React$useState2[0],
      setFilled = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      _focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;

  if (disabled && focused) {
    setFocused(false);
  }

  var registerEffect;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var registeredInput = React.useRef(false);

    registerEffect = function registerEffect() {
      if (registeredInput.current) {
        console.error(['Material-UI: There are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
      }

      registeredInput.current = true;
      return function () {
        registeredInput.current = false;
      };
    };
  }

  var onFilled = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    setFilled(true);
  }, []);
  var onEmpty = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    setFilled(false);
  }, []);
  var childContext = {
    adornedStart: adornedStart,
    setAdornedStart: setAdornedStart,
    color: color,
    disabled: disabled,
    error: error,
    filled: filled,
    focused: focused,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    margin: (size === 'small' ? 'dense' : undefined) || margin,
    onBlur: function onBlur() {
      setFocused(false);
    },
    onEmpty: onEmpty,
    onFilled: onFilled,
    onFocus: function onFocus() {
      setFocused(true);
    },
    registerEffect: registerEffect,
    required: required,
    variant: variant
  };
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__FormControlContext__["a" ].Provider, {
    value: childContext
  }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, margin !== 'none' && classes["margin".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" ])(margin))], fullWidth && classes.fullWidth),
    ref: ref
  }, other), children));
});
 false ? FormControl.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['primary', 'secondary']),

  
  component: PropTypes
  
  .elementType,

  
  disabled: PropTypes.bool,

  
  error: PropTypes.bool,

  
  focused: PropTypes.bool,

  
  fullWidth: PropTypes.bool,

  
  hiddenLabel: PropTypes.bool,

  
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),

  
  required: PropTypes.bool,

  
  size: PropTypes.oneOf(['medium', 'small']),

  
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'MuiFormControl'
})(FormControl));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__FormHelperText__ = __webpack_require__(976);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormHelperText__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(114);
 var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(90);
 var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(15);








var styles = function styles(theme) {
  return {
    
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
      color: theme.palette.text.secondary
    }, theme.typography.caption, {
      textAlign: 'left',
      marginTop: 3,
      margin: 0,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    
    error: {},

    
    disabled: {},

    
    marginDense: {
      marginTop: 4
    },

    
    contained: {
      marginLeft: 14,
      marginRight: 14
    },

    
    focused: {},

    
    filled: {},

    
    required: {}
  };
};
var FormHelperText = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormHelperText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'p' : _props$component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      margin = props.margin,
      required = props.required,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" ])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" ])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), children === ' ' ?
  
  // eslint-disable-next-line react/no-danger
  __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : children);
});
 false ? FormHelperText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  component: PropTypes
  
  .elementType,

  
  disabled: PropTypes.bool,

  
  error: PropTypes.bool,

  
  filled: PropTypes.bool,

  
  focused: PropTypes.bool,

  
  margin: PropTypes.oneOf(['dense']),

  
  required: PropTypes.bool,

  
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" ])(styles, {
  name: 'MuiFormHelperText'
})(FormHelperText));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_styles__ = __webpack_require__(53);
 var __WEBPACK_IMPORTED_MODULE_5__SelectInput__ = __webpack_require__(978);
 var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(114);
 var __WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__ = __webpack_require__(90);
 var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_9__internal_svg_icons_ArrowDropDown__ = __webpack_require__(434);
 var __WEBPACK_IMPORTED_MODULE_10__Input__ = __webpack_require__(112);
 var __WEBPACK_IMPORTED_MODULE_11__NativeSelect_NativeSelect__ = __webpack_require__(979);
 var __WEBPACK_IMPORTED_MODULE_12__NativeSelect_NativeSelectInput__ = __webpack_require__(435);
 var __WEBPACK_IMPORTED_MODULE_13__FilledInput__ = __webpack_require__(431);
 var __WEBPACK_IMPORTED_MODULE_14__OutlinedInput__ = __webpack_require__(432);















var styles = __WEBPACK_IMPORTED_MODULE_11__NativeSelect_NativeSelect__["a" ];

var _ref = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Input__["a" ], null);

var _ref2 = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__FilledInput__["a" ], null);

var Select = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Select(props, ref) {
  var _props$autoWidth = props.autoWidth,
      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
      children = props.children,
      classes = props.classes,
      _props$displayEmpty = props.displayEmpty,
      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_9__internal_svg_icons_ArrowDropDown__["a" ] : _props$IconComponent,
      id = props.id,
      input = props.input,
      inputProps = props.inputProps,
      label = props.label,
      labelId = props.labelId,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      MenuProps = props.MenuProps,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$native = props.native,
      native = _props$native === void 0 ? false : _props$native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      _props$variant = props.variant,
      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);

  var inputComponent = native ? __WEBPACK_IMPORTED_MODULE_12__NativeSelect_NativeSelectInput__["a" ] : __WEBPACK_IMPORTED_MODULE_5__SelectInput__["a" ];
  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__["a" ])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" ])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  var variant = fcs.variant || variantProps;
  var InputComponent = input || {
    standard: _ref,
    outlined: __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__OutlinedInput__["a" ], {
      label: label,
      labelWidth: labelWidth
    }),
    filled: _ref2
  }[variant];
  return __WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      children: children,
      IconComponent: IconComponent,
      variant: variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: multiple
    }, native ? {
      id: id
    } : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      labelId: labelId,
      MenuProps: MenuProps,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        id: id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_styles__["i" ])({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? Select.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  autoWidth: PropTypes.bool,

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  defaultValue: PropTypes.any,

  
  displayEmpty: PropTypes.bool,

  
  IconComponent: PropTypes.elementType,

  
  id: PropTypes.string,

  
  input: PropTypes.element,

  
  inputProps: PropTypes.object,

  
  label: PropTypes.node,

  
  labelId: PropTypes.string,

  
  labelWidth: PropTypes.number,

  
  MenuProps: PropTypes.object,

  
  multiple: PropTypes.bool,

  
  native: PropTypes.bool,

  
  onChange: PropTypes.func,

  
  onClose: PropTypes.func,

  
  onOpen: PropTypes.func,

  
  open: PropTypes.bool,

  
  renderValue: PropTypes.func,

  
  SelectDisplayProps: PropTypes.object,

  
  value: PropTypes.any,

  
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
Select.muiName = 'Select';
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" ])(styles, {
  name: 'MuiSelect'
})(Select));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(130);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(126);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
 var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(159);
 var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);
 var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_8_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_9__utils_ownerDocument__ = __webpack_require__(77);
 var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(38);
 var __WEBPACK_IMPORTED_MODULE_11__Menu_Menu__ = __webpack_require__(401);
 var __WEBPACK_IMPORTED_MODULE_12__InputBase_utils__ = __webpack_require__(249);
 var __WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__ = __webpack_require__(46);
 var __WEBPACK_IMPORTED_MODULE_14__utils_useControlled__ = __webpack_require__(251);

















function areEqualValues(a, b) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" ])(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}

function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}



var SelectInput = __WEBPACK_IMPORTED_MODULE_5_react__["forwardRef"](function SelectInput(props, ref) {
  var ariaLabel = props['aria-label'],
      autoFocus = props.autoFocus,
      autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      inputRefProp = props.inputRef,
      labelId = props.labelId,
      _props$MenuProps = props.MenuProps,
      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
      multiple = props.multiple,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onOpen = props.onOpen,
      openProp = props.open,
      readOnly = props.readOnly,
      renderValue = props.renderValue,
      _props$SelectDisplayP = props.SelectDisplayProps,
      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
      tabIndexProp = props.tabIndex,
      type = props.type,
      valueProp = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useControlled__["a" ])({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" ])(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var inputRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"](null);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](null),
      displayNode = _React$useState[0],
      setDisplayNode = _React$useState[1];

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"](openProp != null),
      isOpenControlled = _React$useRef.current;

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](),
      menuMinWidthState = _React$useState2[0],
      setMenuMinWidthState = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](false),
      openState = _React$useState3[0],
      setOpenState = _React$useState3[1];

  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__["a" ])(ref, inputRefProp);
  __WEBPACK_IMPORTED_MODULE_5_react__["useImperativeHandle"](handleRef, function () {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value: value
    };
  }, [displayNode, value]);
  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    if (displayNode) {
      var label = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerDocument__["a" ])(displayNode).getElementById(labelId);

      if (label) {
        var handler = function handler() {
          if (getSelection().isCollapsed) {
            displayNode.focus();
          }
        };

        label.addEventListener('click', handler);
        return function () {
          label.removeEventListener('click', handler);
        };
      }
    }

    return undefined;
  }, [labelId, displayNode]);

  var update = function update(open, event) {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    } // Hijack the default focus behavior.


    event.preventDefault();
    displayNode.focus();
    update(true, event);
  };

  var handleClose = function handleClose(event) {
    update(false, event);
  };

  var childrenArray = __WEBPACK_IMPORTED_MODULE_5_react__["Children"].toArray(children); // Support autofill.

  var handleChange = function handleChange(event) {
    var index = childrenArray.map(function (child) {
      return child.props.value;
    }).indexOf(event.target.value);

    if (index === -1) {
      return;
    }

    var child = childrenArray[index];
    setValue(child.props.value);

    if (onChange) {
      onChange(event, child);
    }
  };

  var handleItemClick = function handleItemClick(child) {
    return function (event) {
      if (!multiple) {
        update(false, event);
      }

      var newValue;

      if (multiple) {
        newValue = Array.isArray(value) ? value.slice() : [];
        var itemIndex = value.indexOf(child.props.value);

        if (itemIndex === -1) {
          newValue.push(child.props.value);
        } else {
          newValue.splice(itemIndex, 1);
        }
      } else {
        newValue = child.props.value;
      }

      if (child.props.onClick) {
        child.props.onClick(event);
      }

      if (value === newValue) {
        return;
      }

      setValue(newValue);

      if (onChange) {
        event.persist(); // Preact support, target is read only property on a native event.

        Object.defineProperty(event, 'target', {
          writable: true,
          value: {
            value: newValue,
            name: name
          }
        });
        onChange(event, child);
      }
    };
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!readOnly) {
      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  var open = displayNode !== null && (isOpenControlled ? openProp : openState);

  var handleBlur = function handleBlur(event) {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      event.persist(); // Preact support, target is read only property on a native event.

      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value: value,
          name: name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  var display;
  var displaySingle;
  var displayMultiple = [];
  var computeDisplay = false;
  var foundMatch = false; // No need to display any value if the field is empty.

  if (Object(__WEBPACK_IMPORTED_MODULE_12__InputBase_utils__["b" ])({
    value: value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  var items = childrenArray.map(function (child) {
    if (! __WEBPACK_IMPORTED_MODULE_5_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error( false ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_utils__["b" ])(2));
      }

      selected = value.some(function (v) {
        return areEqualValues(v, child.props.value);
      });

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    if (selected) {
      foundMatch = true;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"](child, {
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      onKeyUp: function onKeyUp(event) {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }

        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected: selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (!foundMatch && !multiple && value !== '') {
        var values = childrenArray.map(function (child) {
          return child.props.value;
        });
        console.warn(["Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
          return x != null;
        }).map(function (x) {
          return "`".concat(x, "`");
        }).join(', ') || '""', ".")].join('\n'));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }

  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  } // Avoid performing a layout computation in the render method.


  var menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  var tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
  return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" ])(classes.root, // TODO v5: merge root and select
    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
    ref: setDisplayNode,
    tabIndex: tabIndex,
    role: "button",
    "aria-disabled": disabled ? 'true' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
    onKeyDown: handleKeyDown,
    onMouseDown: disabled || readOnly ? null : handleMouseDown,
    onBlur: handleBlur,
    onFocus: onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty(display) ?
  
  // eslint-disable-next-line react/no-danger
  __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : display), __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    value: Array.isArray(value) ? value.join(',') : value,
    name: name,
    ref: inputRef,
    "aria-hidden": true,
    onChange: handleChange,
    tabIndex: -1,
    className: classes.nativeInput,
    autoFocus: autoFocus
  }, other)), __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" ])(classes.icon, classes["icon".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" ])(variant))], open && classes.iconOpen, disabled && classes.disabled)
  }), __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Menu_Menu__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    id: "menu-".concat(name || ''),
    anchorEl: displayNode,
    open: open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      'aria-labelledby': labelId,
      role: 'listbox',
      disableListWrap: true
    }, MenuProps.MenuListProps),
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, MenuProps.PaperProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        minWidth: menuMinWidth
      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
    })
  }), items));
});
 false ? SelectInput.propTypes = {
  
  'aria-label': PropTypes.string,

  
  autoFocus: PropTypes.bool,

  
  autoWidth: PropTypes.bool,

  
  children: PropTypes.node,

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string,

  
  defaultValue: PropTypes.any,

  
  disabled: PropTypes.bool,

  
  displayEmpty: PropTypes.bool,

  
  IconComponent: PropTypes.elementType.isRequired,

  
  inputRef: refType,

  
  labelId: PropTypes.string,

  
  MenuProps: PropTypes.object,

  
  multiple: PropTypes.bool,

  
  name: PropTypes.string,

  
  onBlur: PropTypes.func,

  
  onChange: PropTypes.func,

  
  onClose: PropTypes.func,

  
  onFocus: PropTypes.func,

  
  onOpen: PropTypes.func,

  
  open: PropTypes.bool,

  
  readOnly: PropTypes.bool,

  
  renderValue: PropTypes.func,

  
  SelectDisplayProps: PropTypes.object,

  
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  type: PropTypes.any,

  
  value: PropTypes.any,

  
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
 __webpack_exports__["a"] = (SelectInput);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4__NativeSelectInput__ = __webpack_require__(435);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(114);
 var __WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__ = __webpack_require__(90);
 var __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_ArrowDropDown__ = __webpack_require__(434);
 var __WEBPACK_IMPORTED_MODULE_9__Input__ = __webpack_require__(112);










var styles = function styles(theme) {
  return {
    
    root: {},

    
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      },
      '&[multiple]': {
        height: 'auto'
      },
      '&:not([multiple]) option, &:not([multiple]) optgroup': {
        backgroundColor: theme.palette.background.paper
      },
      '&&': {
        paddingRight: 24
      }
    },

    
    filled: {
      '&&': {
        paddingRight: 32
      }
    },

    
    outlined: {
      borderRadius: theme.shape.borderRadius,
      '&&': {
        paddingRight: 32
      }
    },

    
    selectMenu: {
      height: 'auto',
      // Resets for multpile select with chips
      minHeight: '1.1876em',
      // Required for select\text-field height consistency
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },

    
    disabled: {},

    
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      pointerEvents: 'none',
      // Don't block pointer events on the select under the icon.
      color: theme.palette.action.active,
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    
    iconOpen: {
      transform: 'rotate(180deg)'
    },

    
    iconFilled: {
      right: 7
    },

    
    iconOutlined: {
      right: 7
    },

    
    nativeInput: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      opacity: 0,
      pointerEvents: 'none',
      width: '100%'
    }
  };
};
var defaultInput = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Input__["a" ], null);


var NativeSelect = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function NativeSelect(props, ref) {
  var children = props.children,
      classes = props.classes,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_ArrowDropDown__["a" ] : _props$IconComponent,
      _props$input = props.input,
      input = _props$input === void 0 ? defaultInput : _props$input,
      inputProps = props.inputProps,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__["a" ])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" ])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return __WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](input, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: __WEBPACK_IMPORTED_MODULE_4__NativeSelectInput__["a" ],
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? NativeSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  IconComponent: PropTypes.elementType,

  
  input: PropTypes.element,

  
  inputProps: PropTypes.object,

  
  onChange: PropTypes.func,

  
  value: PropTypes.any,

  
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
NativeSelect.muiName = 'Select';
 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiNativeSelect'
})(NativeSelect));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CircularProgress__ = __webpack_require__(252);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_addFile_svg__ = __webpack_require__(982);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_addFile_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_addFile_svg__);
 var __WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(247);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileUpload=function(_React$Component){_inherits(FileUpload,_React$Component);function FileUpload(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FileUpload);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FileUpload.__proto__||Object.getPrototypeOf(FileUpload)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:false,loading:false},_this.onChange=function(event){var onChange=_this.props.onChange;var selected=_this.state.selected;var file=event.target.files[0];_this.setState({selected:!selected,loading:true},function(){return onChange(file,function(){return _this.setState({loading:false});});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FileUpload,[{key:'render',value:function render(){var loading=this.state.loading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["l" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'file-input'},!loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_assets_images_addFile_svg___default.a,alt:''}),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CircularProgress__["a" ],{size:40,style:{color:'black'},className:'buttonProgress'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'file-input',type:'file',onChange:this.onChange}));}}]);return FileUpload;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FileUpload.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (FileUpload);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(38);








var SIZE = 44;
var styles = function styles(theme) {
  return {
    
    root: {
      display: 'inline-block'
    },

    
    static: {
      transition: theme.transitions.create('transform')
    },

    
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    
    determinate: {
      transition: theme.transitions.create('transform')
    },

    
    colorPrimary: {
      color: theme.palette.primary.main
    },

    
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    
    svg: {
      display: 'block' // Keeps the progress centered

    },

    
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },

    
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    
    circleDisableShrink: {
      animation: 'none'
    }
  };
};


var CircularProgress = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" ])(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("circle", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
 false ? CircularProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary']),

  
  disableShrink: chainPropTypes(PropTypes.bool, function (props) {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  style: PropTypes.object,

  
  thickness: PropTypes.number,

  
  value: PropTypes.number,

  
  variant: chainPropTypes(PropTypes.oneOf(['determinate', 'indeterminate', 'static']), function (props) {
    var variant = props.variant;

    if (variant === 'static') {
      throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
    }

    return null;
  })
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress));

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/addFile.1ec0d9f2.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_3__FileFrame__ = __webpack_require__(984);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(247);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileLink=function(_React$Component){_inherits(FileLink,_React$Component);function FileLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FileLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FileLink.__proto__||Object.getPrototypeOf(FileLink)).call.apply(_ref,[this].concat(args))),_this),_this.state={modalIsOpen:false,src:''},_this.handleClose=function(){_this.setState({modalIsOpen:false});},_this.linkClicked=function(){var _this$props=_this.props,viewDocument=_this$props.viewDocument,hash=_this$props.hash,bp=_this$props.bp;viewDocument(hash,bp).then(function(response){_this.setState({src:response.info,modalIsOpen:true});});},_this.printContent=function(){var _this$props2=_this.props,name=_this$props2.name,mimeType=_this$props2.mimeType,url=_this$props2.url;if(mimeType.indexOf('image')!==-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["m" ],{src:url,onClick:_this.linkClicked});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link',onClick:_this.linkClicked},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-file'}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FileLink,[{key:'render',value:function render(){var _props=this.props,hour=_props.hour,mimeType=_props.mimeType;var _state=this.state,modalIsOpen=_state.modalIsOpen,src=_state.src;var type='';if(mimeType){type=mimeType.split('/')[0];}var content=this.printContent();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,content,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hour'},hour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Modal__["a" ],{'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',open:modalIsOpen,onClose:this.handleClose,onBackdropClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["r" ],{className:type==='image'?'image':'file'},type==='image'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:src,style:{maxWidth:'100%'},alt:''}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileFrame__["a" ],{src:src}))));}}]);return FileLink;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FileLink.propTypes={hour:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,viewDocument:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,hash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,bp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,mimeType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}; __webpack_exports__["a"] = (FileLink);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileFrame=function(_React$Component){_inherits(FileFrame,_React$Component);function FileFrame(){_classCallCheck(this,FileFrame);return _possibleConstructorReturn(this,(FileFrame.__proto__||Object.getPrototypeOf(FileFrame)).apply(this,arguments));}_createClass(FileFrame,[{key:'render',value:function render(){var src=this.props.src;if(src){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'file',src:src});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null);}}]);return FileFrame;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FileFrame.propTypes={src:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}; __webpack_exports__["a"] = (FileFrame);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/thinkNew.5ac98d07.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/connect_icon_white.8813269e.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/initiativeNew.864b2e24.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/discover_button.7f4d386b.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tools.69144004.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_selected.5ef6ab46.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_selected_orange.bc403362.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_unselected.f2f34684.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_orange.40b75c85.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/finetune.a225ffaa.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fine_tune.a4c9f53a.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/createTable.8337c099.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/createCall.e1937c5f.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/askEco.f2f37ec5.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/requestSpeed.568ea26b.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1001);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1002);
function mapStateToProps(state){return{chats:state.chats};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LayoutContent=function(_Component){_inherits(LayoutContent,_Component);function LayoutContent(){_classCallCheck(this,LayoutContent);return _possibleConstructorReturn(this,(LayoutContent.__proto__||Object.getPrototypeOf(LayoutContent)).apply(this,arguments));}_createClass(LayoutContent,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(prevProps){if(JSON.stringify(prevProps.chats)!==JSON.stringify(this.props.chats)){return false;}return true;}},{key:'render',value:function render(){var children=this.props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,children);}}]);return LayoutContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); __webpack_exports__["a"] = (LayoutContent);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BreadcrumbElement=function(_Component){_inherits(BreadcrumbElement,_Component);function BreadcrumbElement(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BreadcrumbElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BreadcrumbElement.__proto__||Object.getPrototypeOf(BreadcrumbElement)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnClick=function(){var onClick=_this.props.data.onClick;if(onClick){onClick();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BreadcrumbElement,[{key:'render',value:function render(){var _props=this.props,_props$data=_props.data,text=_props$data.text,onClick=_props$data.onClick,isFirst=_props.isFirst;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!isFirst?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-chevron-right'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.handleOnClick,className:onClick?'clickable':''},text));}}]);return BreadcrumbElement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BreadcrumbElement.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isFirst:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};BreadcrumbElement.defaultProps={isFirst:false}; __webpack_exports__["a"] = (BreadcrumbElement);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return DesktopLayout; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return IconMainOption; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return IconSerendipity; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return ProgressSerendipity; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return MobileLayout; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return ToolsButton; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return ToolsWrapper; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return PieSize; });

 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_3_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_4_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  min-height: 100%;\n  background-color: ',';\n  transition: background-color 0.4s linear;\n  overflow: hidden;\n\n  .chat_content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .drag {\n    position: fixed;\n    bottom: 0;\n    left: 23.5rem;\n    z-index: 9999999;\n    display: flex;\n    align-item: center;\n    justify-content: center;\n  }\n\n  .chat {\n    z-index: 9;\n    width: 30rem;\n    max-height: 60vh;\n    position: fixed;\n    left: 6rem;\n    bottom: 0;\n    background: white;\n    box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px;\n    &.big {\n      left: clamp(23rem,20vw,28rem);\n    }\n  }\n\n  .collapse {\n    width: 100%;\n    color: #2680EB;\n    font-size: 1.6rem;\n    padding: 1.5rem 1.8rem;\n    cursor: pointer;\n\n    i {\n      margin-right: 1.6rem;\n    }\n  }\n\n  .chat_list {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .no_tables {\n      img {\n        width: 100%;\n      }\n      > div {\n        text-align: center;\n        font-size: 1.3rem;\n        margin-top: 1rem;\n      }\n    }\n  }\n\n  header {\n    position: fixed;\n    width: 100%;\n    height: 50px;\n    top: 0;\n    left: 0;\n    box-shadow: 0rem 0.3rem 0.6rem 0.1rem rgb(0 0 0 / 16%);\n    z-index: 20;\n\n\n    .logo {\n      height: 100%;\n      padding: 10px;\n      cursor: pointer;\n      display: inline-block;\n      vertical-align: middle;\n\n      img {\n        height: 30px;\n      }\n    }\n\n    .c2i_breadcrumb {\n      display: inline-block;\n      color: ',';\n      font-size: 16px;\n      letter-spacing: 1px;\n\n      i {\n        color: ',';\n        vertical-align: middle;\n        margin: 5px 10px;\n      }\n\n      div {\n        color: ',';\n        vertical-align: middle;\n        display: inline-block;\n        font-family: ',';\n\n        &.clickable {\n          cursor: pointer;\n        }\n      }\n    }\n\n    .right {\n      position: absolute;\n      right: 0px;\n      top: 0px;\n\n      .user_layer {\n        font-size: 0px;\n        cursor: pointer;\n        margin: 0px;\n        padding-left: 20px;\n        display: inline-block;\n        vertical-align: middle;\n        height: 50px;\n        padding: 5px 20px;\n\n        .avatar {\n          display: inline-block;\n          vertical-align: middle;\n          margin-right: 10px;\n        }\n      }\n\n      .username {\n        font-size: 13px;\n        color: ',';\n        display: inline-block;\n        vertical-align: middle;\n        font-family: ',';\n      }\n\n      .arrow {\n        display: inline-block;\n        vertical-align: middle;\n\n        i {\n          color: ',';\n          font-size: 16px;\n          margin-left: 10px;\n        }\n      }\n    }\n  }\n\n  main {\n    position: relative;\n    height: calc(100vh - 50px);\n    top: 5rem;\n    overflow: auto;\n\n    .main_menu {\n      position: fixed;\n      top: 5rem;\n      left: 0;\n      width: clamp(23rem,20vw,28rem);\n      height: calc(100vh - 5rem);\n      overflow: auto;\n      transition: width 1s;\n      z-index: 10;\n      background-color: rgba(255, 255, 255, 0.8);\n      box-shadow: 5px 3px 6px 1px rgb(0 0 0 / 16%);\n\n      &.mini {\n        width: 6rem;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        .alert_in_menu {\n          right: 0.5rem !important;\n          top: 2rem !important;\n        }\n      }\n\n      .create_table {\n        position: fixed;\n        right: 2rem;\n        bottom: 2rem;\n      }\n\n      .fine_tune_menu {\n        margin: 15px;\n      }\n\n      ::-webkit-scrollbar {\n        width: 0px;\n        background: transparent; \n      }\n\n      .searcher {\n        display: block;\n        width: 90%;\n        margin: 10px auto;\n        border-radius: 20px;\n        color: #666;\n        background-color: #fff;\n        padding: 10px 10px;\n        font-size: 14px;\n        border: 1px solid #ddd;\n      }\n\n      .main_option {\n        padding: 15px 10px;\n        cursor: pointer;\n        white-space: nowrap;\n        position: relative;\n\n        i {\n          color: ',';\n          font-size: 22px;\n          margin-left: 10px;\n          vertical-align: middle;\n          width: 30px;\n        }\n\n        .icon {\n          width: 4rem;\n          height: 4rem;\n          display: inline-block;\n          background-color: ',';\n          vertical-align: middle;\n          margin-right: 5px;\n          mask-size: 90%;\n        }\n\n        .text {\n          color: ',';\n          margin-left: 5px;\n          display: inline-block;\n          vertical-align: middle;\n          white-space: nowrap;\n          font-size: 15px;\n          width: calc(100% - 70px);\n        }\n\n        .alert_in_menu {\n          position: absolute;\n          width: 10px;\n          height: 10px;\n          border-radius: 50%;\n          right: 25px;\n          top: calc(50% - 5px);\n          background-color: ',';\n        }\n\n        .alert_in_menu_text {\n          position: absolute;\n          left: 6rem;\n          top: 5rem;\n        }\n\n        &.selected {\n          background-color: ',';\n\n          i {\n            color: #fff;\n          }\n\n          .text {\n            color: #fff;\n          }\n\n          .icon {\n            background-color: #fff;\n          }\n\n          .alert_in_menu {\n            background-color: #fff;\n          }\n\n          .alert_in_menu_text {\n            color: #fff;\n          }\n\n          &.orange {\n            background-color: ',';\n\n            .alert_in_menu {\n              display: none;\n            }\n          }\n        }\n      }\n\n      .option_menu {\n        padding: 5px 10px;\n        cursor: pointer;\n        white-space: nowrap;\n\n        .fine_tune {\n          display: inline-block;\n          margin: 9px;\n        }\n\n\n\n\n        .text {\n          color: ',';\n          margin-left: 5px;\n          display: inline-block;\n          vertical-align: middle;\n          white-space: nowrap;\n          font-size: 14px;\n          width: calc(100% - 90px);\n\n          &.impact {\n            color: white;\n          }\n        }\n\n        .icon_expand {\n          display: inline-block;\n          vertical-align: middle;\n          padding: 5px 10px;\n\n          i {\n            font-size: 18px;\n            color: ',';\n\n            &.impact {\n              color: white;\n            }\n          }\n        }\n\n        .icon_minimize {\n          display: none;\n          vertical-align: middle;\n          padding: 5px 10px;\n\n          i {\n            font-size: 18px;\n            color: ',';\n\n            &.impact {\n              color: white;\n            }\n          }\n        }\n\n        &.selected {\n          i {\n            color: ',';\n          }\n\n          .text {\n            color: ',';\n            font-family: ',';\n          }\n        }\n\n        &.expanded {\n          .icon_expand {\n            display: none;\n          }\n\n          .icon_minimize {\n            display: inline-block;\n          }\n        }\n      }\n\n      .submenu_options {\n        .option_submenu {\n          padding: 10px 5px 10px 25px;\n          position: relative;\n          display: none;\n          cursor: pointer;\n\n          .text {\n            white-space: normal;\n            font-size: 13px;\n            color: ',';\n            width: calc(100% - 35px);\n          }\n\n          .alert_in_menu {\n            position: absolute;\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            right: 10px;\n            top: 14px;\n            background-color: #fff;;\n            opacity: 0;\n          }\n\n          &.with_alert {\n            display: block;\n\n            .alert_in_menu {\n              opacity: 1;\n            }\n          }\n\n          &.selected {\n            .text {\n              color: ',';\n            }\n          }\n        }\n\n        &.expanded {\n          .option_submenu {\n            display: block;\n          }\n        }\n      }\n    }\n\n    .main_wrapper {\n      width: calc(100% - clamp(23rem,20vw,28rem));\n      margin-left: clamp(23rem,20vw,28rem);\n      background-color: ',';\n      min-height: calc(100vh - 50px);\n\n      &.all {\n        width: calc(100% - 6rem);\n        margin-left: 6rem;\n      }\n\n      section {\n        min-height: calc(100vh - 50px);\n      }\n    }\n\n    .hide_button {\n      min-height: calc(100vh - 50px);\n      float: left;\n      position: absolute;\n      display: none;\n\n      button {\n        border: 0px;\n        background-color: transparent;\n        width: 30px;\n        height: 30px;\n        font-size: 20px;\n        color: white;\n        margin: 0px;\n        position: absolute;\n        top: 50vh;\n        margin-left: 5px;\n\n      }\n    }\n\n  }\n'],['\n  min-height: 100%;\n  background-color: ',';\n  transition: background-color 0.4s linear;\n  overflow: hidden;\n\n  .chat_content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .drag {\n    position: fixed;\n    bottom: 0;\n    left: 23.5rem;\n    z-index: 9999999;\n    display: flex;\n    align-item: center;\n    justify-content: center;\n  }\n\n  .chat {\n    z-index: 9;\n    width: 30rem;\n    max-height: 60vh;\n    position: fixed;\n    left: 6rem;\n    bottom: 0;\n    background: white;\n    box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px;\n    &.big {\n      left: clamp(23rem,20vw,28rem);\n    }\n  }\n\n  .collapse {\n    width: 100%;\n    color: #2680EB;\n    font-size: 1.6rem;\n    padding: 1.5rem 1.8rem;\n    cursor: pointer;\n\n    i {\n      margin-right: 1.6rem;\n    }\n  }\n\n  .chat_list {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .no_tables {\n      img {\n        width: 100%;\n      }\n      > div {\n        text-align: center;\n        font-size: 1.3rem;\n        margin-top: 1rem;\n      }\n    }\n  }\n\n  header {\n    position: fixed;\n    width: 100%;\n    height: 50px;\n    top: 0;\n    left: 0;\n    box-shadow: 0rem 0.3rem 0.6rem 0.1rem rgb(0 0 0 / 16%);\n    z-index: 20;\n\n\n    .logo {\n      height: 100%;\n      padding: 10px;\n      cursor: pointer;\n      display: inline-block;\n      vertical-align: middle;\n\n      img {\n        height: 30px;\n      }\n    }\n\n    .c2i_breadcrumb {\n      display: inline-block;\n      color: ',';\n      font-size: 16px;\n      letter-spacing: 1px;\n\n      i {\n        color: ',';\n        vertical-align: middle;\n        margin: 5px 10px;\n      }\n\n      div {\n        color: ',';\n        vertical-align: middle;\n        display: inline-block;\n        font-family: ',';\n\n        &.clickable {\n          cursor: pointer;\n        }\n      }\n    }\n\n    .right {\n      position: absolute;\n      right: 0px;\n      top: 0px;\n\n      .user_layer {\n        font-size: 0px;\n        cursor: pointer;\n        margin: 0px;\n        padding-left: 20px;\n        display: inline-block;\n        vertical-align: middle;\n        height: 50px;\n        padding: 5px 20px;\n\n        .avatar {\n          display: inline-block;\n          vertical-align: middle;\n          margin-right: 10px;\n        }\n      }\n\n      .username {\n        font-size: 13px;\n        color: ',';\n        display: inline-block;\n        vertical-align: middle;\n        font-family: ',';\n      }\n\n      .arrow {\n        display: inline-block;\n        vertical-align: middle;\n\n        i {\n          color: ',';\n          font-size: 16px;\n          margin-left: 10px;\n        }\n      }\n    }\n  }\n\n  main {\n    position: relative;\n    height: calc(100vh - 50px);\n    top: 5rem;\n    overflow: auto;\n\n    .main_menu {\n      position: fixed;\n      top: 5rem;\n      left: 0;\n      width: clamp(23rem,20vw,28rem);\n      height: calc(100vh - 5rem);\n      overflow: auto;\n      transition: width 1s;\n      z-index: 10;\n      background-color: rgba(255, 255, 255, 0.8);\n      box-shadow: 5px 3px 6px 1px rgb(0 0 0 / 16%);\n\n      &.mini {\n        width: 6rem;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        .alert_in_menu {\n          right: 0.5rem !important;\n          top: 2rem !important;\n        }\n      }\n\n      .create_table {\n        position: fixed;\n        right: 2rem;\n        bottom: 2rem;\n      }\n\n      .fine_tune_menu {\n        margin: 15px;\n      }\n\n      ::-webkit-scrollbar {\n        width: 0px;\n        background: transparent; \n      }\n\n      .searcher {\n        display: block;\n        width: 90%;\n        margin: 10px auto;\n        border-radius: 20px;\n        color: #666;\n        background-color: #fff;\n        padding: 10px 10px;\n        font-size: 14px;\n        border: 1px solid #ddd;\n      }\n\n      .main_option {\n        padding: 15px 10px;\n        cursor: pointer;\n        white-space: nowrap;\n        position: relative;\n\n        i {\n          color: ',';\n          font-size: 22px;\n          margin-left: 10px;\n          vertical-align: middle;\n          width: 30px;\n        }\n\n        .icon {\n          width: 4rem;\n          height: 4rem;\n          display: inline-block;\n          background-color: ',';\n          vertical-align: middle;\n          margin-right: 5px;\n          mask-size: 90%;\n        }\n\n        .text {\n          color: ',';\n          margin-left: 5px;\n          display: inline-block;\n          vertical-align: middle;\n          white-space: nowrap;\n          font-size: 15px;\n          width: calc(100% - 70px);\n        }\n\n        .alert_in_menu {\n          position: absolute;\n          width: 10px;\n          height: 10px;\n          border-radius: 50%;\n          right: 25px;\n          top: calc(50% - 5px);\n          background-color: ',';\n        }\n\n        .alert_in_menu_text {\n          position: absolute;\n          left: 6rem;\n          top: 5rem;\n        }\n\n        &.selected {\n          background-color: ',';\n\n          i {\n            color: #fff;\n          }\n\n          .text {\n            color: #fff;\n          }\n\n          .icon {\n            background-color: #fff;\n          }\n\n          .alert_in_menu {\n            background-color: #fff;\n          }\n\n          .alert_in_menu_text {\n            color: #fff;\n          }\n\n          &.orange {\n            background-color: ',';\n\n            .alert_in_menu {\n              display: none;\n            }\n          }\n        }\n      }\n\n      .option_menu {\n        padding: 5px 10px;\n        cursor: pointer;\n        white-space: nowrap;\n\n        .fine_tune {\n          display: inline-block;\n          margin: 9px;\n        }\n\n\n\n\n        .text {\n          color: ',';\n          margin-left: 5px;\n          display: inline-block;\n          vertical-align: middle;\n          white-space: nowrap;\n          font-size: 14px;\n          width: calc(100% - 90px);\n\n          &.impact {\n            color: white;\n          }\n        }\n\n        .icon_expand {\n          display: inline-block;\n          vertical-align: middle;\n          padding: 5px 10px;\n\n          i {\n            font-size: 18px;\n            color: ',';\n\n            &.impact {\n              color: white;\n            }\n          }\n        }\n\n        .icon_minimize {\n          display: none;\n          vertical-align: middle;\n          padding: 5px 10px;\n\n          i {\n            font-size: 18px;\n            color: ',';\n\n            &.impact {\n              color: white;\n            }\n          }\n        }\n\n        &.selected {\n          i {\n            color: ',';\n          }\n\n          .text {\n            color: ',';\n            font-family: ',';\n          }\n        }\n\n        &.expanded {\n          .icon_expand {\n            display: none;\n          }\n\n          .icon_minimize {\n            display: inline-block;\n          }\n        }\n      }\n\n      .submenu_options {\n        .option_submenu {\n          padding: 10px 5px 10px 25px;\n          position: relative;\n          display: none;\n          cursor: pointer;\n\n          .text {\n            white-space: normal;\n            font-size: 13px;\n            color: ',';\n            width: calc(100% - 35px);\n          }\n\n          .alert_in_menu {\n            position: absolute;\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            right: 10px;\n            top: 14px;\n            background-color: #fff;;\n            opacity: 0;\n          }\n\n          &.with_alert {\n            display: block;\n\n            .alert_in_menu {\n              opacity: 1;\n            }\n          }\n\n          &.selected {\n            .text {\n              color: ',';\n            }\n          }\n        }\n\n        &.expanded {\n          .option_submenu {\n            display: block;\n          }\n        }\n      }\n    }\n\n    .main_wrapper {\n      width: calc(100% - clamp(23rem,20vw,28rem));\n      margin-left: clamp(23rem,20vw,28rem);\n      background-color: ',';\n      min-height: calc(100vh - 50px);\n\n      &.all {\n        width: calc(100% - 6rem);\n        margin-left: 6rem;\n      }\n\n      section {\n        min-height: calc(100vh - 50px);\n      }\n    }\n\n    .hide_button {\n      min-height: calc(100vh - 50px);\n      float: left;\n      position: absolute;\n      display: none;\n\n      button {\n        border: 0px;\n        background-color: transparent;\n        width: 30px;\n        height: 30px;\n        font-size: 20px;\n        color: white;\n        margin: 0px;\n        position: absolute;\n        top: 50vh;\n        margin-left: 5px;\n\n      }\n    }\n\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mask: url(',') no-repeat center;\n'],['\n  mask: url(',') no-repeat center;\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: absolute;\n  bottom: 1rem;\n  right: 0;\n  background: #2680EB;\n  color: white;\n  font-size: 1.5rem;\n  padding: 2rem;\n  border-radius: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0rem 0.3rem 0.6rem 0.1rem rgb(0 0 0 / 16%);\n\n  .bar {\n    margin-left: 2rem;\n  }\n\n  i {\n    margin-left: 2rem;\n    font-size: 2rem;\n  }\n  img {\n    width: 2rem;\n    margin-left: 2rem;\n  }\n'],['\n  position: absolute;\n  bottom: 1rem;\n  right: 0;\n  background: #2680EB;\n  color: white;\n  font-size: 1.5rem;\n  padding: 2rem;\n  border-radius: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0rem 0.3rem 0.6rem 0.1rem rgb(0 0 0 / 16%);\n\n  .bar {\n    margin-left: 2rem;\n  }\n\n  i {\n    margin-left: 2rem;\n    font-size: 2rem;\n  }\n  img {\n    width: 2rem;\n    margin-left: 2rem;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  bottom: 8rem;\n  right: 3rem;\n  width: 13rem;\n  height: 0.7rem;\n  z-index: 4;\n  border-radius: 2rem;\n  background: #DBDBDB;\n  box-shadow: 0rem 0.3rem 0.6rem 0.1rem rgb(0 0 0 / 16%);\n\n  &:before {\n    content: \'\';\n    position: fixed;\n    bottom: 8rem;\n    width: ',';\n    height: 0.7rem;\n    border-radius: 2rem;\n    background: #2680EB;\n    z-index: 4;\n  }\n'],['\n  position: absolute;\n  bottom: 8rem;\n  right: 3rem;\n  width: 13rem;\n  height: 0.7rem;\n  z-index: 4;\n  border-radius: 2rem;\n  background: #DBDBDB;\n  box-shadow: 0rem 0.3rem 0.6rem 0.1rem rgb(0 0 0 / 16%);\n\n  &:before {\n    content: \'\';\n    position: fixed;\n    bottom: 8rem;\n    width: ',';\n    height: 0.7rem;\n    border-radius: 2rem;\n    background: #2680EB;\n    z-index: 4;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  background-color: ',';\n  transition: background-color 0.4s linear;\n  height: calc(98vh - env(safe-area-inset-bottom));\n\n  .enddiv{\n    height: 13vh;\n    width: 100%;\n    position: relative;\n    bottom: 0;\n  }\n\n  header {\n    height: calc(50px + env(safe-area-inset-top));\n    order: 1;\n    padding-top: env(safe-area-inset-top);\n    border-bottom: 1px solid #e9e9e9;\n\n    .avatar {\n      height: 100%;\n      padding: 10px;\n      cursor: pointer;\n      display: inline-block;\n      vertical-align: middle;\n\n      img {\n        height: 30px;\n      }\n    }\n\n    .back_arrow {\n      cursor: pointer;\n      display: inline-block;\n      vertical-align: middle;\n\n      i {\n        font-size: 2.3rem;\n        padding: 1rem;\n        color: rgba(0,0,0,0.54);\n      }\n    }\n\n    .c2i_breadcrumb {\n      font-size: 14px;\n      margin: 0 1rem;\n      display: inline-block;\n      vertical-align: middle\n\n      i {\n        color: ',';\n        vertical-align: middle;\n        margin: 5px 10px;\n\n        &:first-child {\n          display: none;\n        }\n      }\n\n      div {\n        vertical-align: middle;\n        display: inline-block;\n        font-family: ',';\n        color: ',';\n        max-width: calc(100vw - 10rem);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  main {\n    order: 2;\n    overflow: auto;\n    height: calc(100vh - env(safe-area-inset-top));\n\n    .all_screen_mobile {\n      background-color: #fff;;\n    }\n  }\n\n  footer {\n    z-index: 250;\n    position: absolute !important;\n    bottom:  env(safe-area-inset-bottom) !important;\n    max-height: 9vh;\n    width: 100%;\n\n    .bottom_effect {\n      position: fixed;\n      z-index: 5;\n      background-color: #fff;\n      left: 0;\n      bottom: 0;\n      height: env(safe-area-inset-bottom);\n      width: 100%;\n    }\n\n    .shadow_left {\n      position: absolute;\n      z-index: 5;\n      left: 0;\n      top: 0;\n      height: 100%;\n      width: 38vw;\n      box-shadow: 0px -3px 6px 1px rgba(0, 0, 0, 0.16);\n    }\n\n    .shadow_right {\n      position: absolute;\n      z-index: 5;\n      right: 0;\n      top: 0;\n      height: 100%;\n      width: 38vw;\n      box-shadow: 0px -3px 6px 1px rgba(0, 0, 0, 0.16);\n    }\n    #main_menu {\n      white-space: nowrap;\n      font-size: 0;\n      position: relative;\n      z-index: 10;\n      background: radial-gradient(circle 38vw at 50% -10%,transparent 29%,#fff 30%);\n      height: 100%;\n\n      .main_option {\n        display: inline-block;\n        width: 20vw;\n        vertical-align: top;\n        text-align: center;\n\n        .icon {\n          width: 30px;\n          height: 30px;\n          background-color:gray;\n          margin: 5px auto;\n          mask-size: 100%;\n        }\n\n        .iconDiscover{\n          width: 70%;\n          height: 70%;\n          align-items: center;\n          background-color:gray;\n          mask-size: 80%;\n          position: absolute;\n          bottom: 2.5vw;\n          left: 2.8vw;\n        }\n\n        .text {\n          color: #B9B9B9;\n          font-size: 12px;\n        }\n\n        .alert-mobile {\n          display: inline-block;\n          width: 8px;\n          height: 8px;\n          border-radius: 50%;\n          background-color: #FF5722;\n          margin-left: 1rem;\n          position: absolute;\n          bottom: 4.5rem;\n        }\n\n        &.central {\n          width: 18vw;\n          height: 18vw;\n          border-radius: 100%;\n          margin: -10px -2.1vw 0;\n          position: relative;\n          bottom: 8vw;\n          z-index: 10;\n          background: #fff;\n          box-shadow: none;\n          .shadow {\n            width: 22vw;\n            height: 22vw;\n            box-shadow: inset 0px -8px 5px -3px rgb(0 0 0 / 16%);\n            position: absolute;\n            border-radius: 100%;\n            left: -10%;\n            top: -10%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n\n          .shadow_circle {\n            box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            border-radius: 50%;\n          }\n        }\n\n        &.left {\n          width: 23vw;\n          padding-right: 5vw;\n        }\n\n        &.right {\n          width: 23vw;\n          padding-left: 5vw;\n        }\n\n        &.selected {\n\n          .icon {\n            background-color: ',';\n          }\n\n          .text {\n            color: ',';\n          }\n        }\n      }\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  background-color: ',';\n  transition: background-color 0.4s linear;\n  height: calc(98vh - env(safe-area-inset-bottom));\n\n  .enddiv{\n    height: 13vh;\n    width: 100%;\n    position: relative;\n    bottom: 0;\n  }\n\n  header {\n    height: calc(50px + env(safe-area-inset-top));\n    order: 1;\n    padding-top: env(safe-area-inset-top);\n    border-bottom: 1px solid #e9e9e9;\n\n    .avatar {\n      height: 100%;\n      padding: 10px;\n      cursor: pointer;\n      display: inline-block;\n      vertical-align: middle;\n\n      img {\n        height: 30px;\n      }\n    }\n\n    .back_arrow {\n      cursor: pointer;\n      display: inline-block;\n      vertical-align: middle;\n\n      i {\n        font-size: 2.3rem;\n        padding: 1rem;\n        color: rgba(0,0,0,0.54);\n      }\n    }\n\n    .c2i_breadcrumb {\n      font-size: 14px;\n      margin: 0 1rem;\n      display: inline-block;\n      vertical-align: middle\n\n      i {\n        color: ',';\n        vertical-align: middle;\n        margin: 5px 10px;\n\n        &:first-child {\n          display: none;\n        }\n      }\n\n      div {\n        vertical-align: middle;\n        display: inline-block;\n        font-family: ',';\n        color: ',';\n        max-width: calc(100vw - 10rem);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  main {\n    order: 2;\n    overflow: auto;\n    height: calc(100vh - env(safe-area-inset-top));\n\n    .all_screen_mobile {\n      background-color: #fff;;\n    }\n  }\n\n  footer {\n    z-index: 250;\n    position: absolute !important;\n    bottom:  env(safe-area-inset-bottom) !important;\n    max-height: 9vh;\n    width: 100%;\n\n    .bottom_effect {\n      position: fixed;\n      z-index: 5;\n      background-color: #fff;\n      left: 0;\n      bottom: 0;\n      height: env(safe-area-inset-bottom);\n      width: 100%;\n    }\n\n    .shadow_left {\n      position: absolute;\n      z-index: 5;\n      left: 0;\n      top: 0;\n      height: 100%;\n      width: 38vw;\n      box-shadow: 0px -3px 6px 1px rgba(0, 0, 0, 0.16);\n    }\n\n    .shadow_right {\n      position: absolute;\n      z-index: 5;\n      right: 0;\n      top: 0;\n      height: 100%;\n      width: 38vw;\n      box-shadow: 0px -3px 6px 1px rgba(0, 0, 0, 0.16);\n    }\n    #main_menu {\n      white-space: nowrap;\n      font-size: 0;\n      position: relative;\n      z-index: 10;\n      background: radial-gradient(circle 38vw at 50% -10%,transparent 29%,#fff 30%);\n      height: 100%;\n\n      .main_option {\n        display: inline-block;\n        width: 20vw;\n        vertical-align: top;\n        text-align: center;\n\n        .icon {\n          width: 30px;\n          height: 30px;\n          background-color:gray;\n          margin: 5px auto;\n          mask-size: 100%;\n        }\n\n        .iconDiscover{\n          width: 70%;\n          height: 70%;\n          align-items: center;\n          background-color:gray;\n          mask-size: 80%;\n          position: absolute;\n          bottom: 2.5vw;\n          left: 2.8vw;\n        }\n\n        .text {\n          color: #B9B9B9;\n          font-size: 12px;\n        }\n\n        .alert-mobile {\n          display: inline-block;\n          width: 8px;\n          height: 8px;\n          border-radius: 50%;\n          background-color: #FF5722;\n          margin-left: 1rem;\n          position: absolute;\n          bottom: 4.5rem;\n        }\n\n        &.central {\n          width: 18vw;\n          height: 18vw;\n          border-radius: 100%;\n          margin: -10px -2.1vw 0;\n          position: relative;\n          bottom: 8vw;\n          z-index: 10;\n          background: #fff;\n          box-shadow: none;\n          .shadow {\n            width: 22vw;\n            height: 22vw;\n            box-shadow: inset 0px -8px 5px -3px rgb(0 0 0 / 16%);\n            position: absolute;\n            border-radius: 100%;\n            left: -10%;\n            top: -10%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n\n          .shadow_circle {\n            box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            border-radius: 50%;\n          }\n        }\n\n        &.left {\n          width: 23vw;\n          padding-right: 5vw;\n        }\n\n        &.right {\n          width: 23vw;\n          padding-left: 5vw;\n        }\n\n        &.selected {\n\n          .icon {\n            background-color: ',';\n          }\n\n          .text {\n            color: ',';\n          }\n        }\n      }\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  background: white;\n  width: 35rem;\n  height: 7rem;\n  border-radius: 2rem 0 0 2rem;\n  position: fixed;\n  right: ',';\n  top: 10rem;\n  box-shadow: 0rem 0.3rem 0.6rem 0.1rem rgb(0 0 0 / 16%);\n  display: flex;\n  align-items: center;\n  padding-left: 2rem;\n  transition: right 1s;\n  cursor: pointer;\n  .text {\n    padding-left: 2rem;\n    font-size: 1.8rem;\n    color: #2680EB;\n  }\n'],['\n  background: white;\n  width: 35rem;\n  height: 7rem;\n  border-radius: 2rem 0 0 2rem;\n  position: fixed;\n  right: ',';\n  top: 10rem;\n  box-shadow: 0rem 0.3rem 0.6rem 0.1rem rgb(0 0 0 / 16%);\n  display: flex;\n  align-items: center;\n  padding-left: 2rem;\n  transition: right 1s;\n  cursor: pointer;\n  .text {\n    padding-left: 2rem;\n    font-size: 1.8rem;\n    color: #2680EB;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  background: white;\n  width: 27rem;\n  height: 30rem;\n  position: fixed;\n  transition: right 1s;\n  right: ',';\n  top: 17rem;\n  box-shadow: 0rem 0.3rem 0.6rem 0.1rem rgb(0 0 0 / 16%);\n  cursor: pointer;\n  .row {\n    width: 100%;\n    height: 25%;\n    display: flex;\n    align-items: center;\n    padding: 2rem;\n    font-size: 1.6rem;\n    &:hover {\n      color: #2680EB;\n    }\n    img {\n      padding-right: 1.5rem;\n    }\n  }\n'],['\n  background: white;\n  width: 27rem;\n  height: 30rem;\n  position: fixed;\n  transition: right 1s;\n  right: ',';\n  top: 17rem;\n  box-shadow: 0rem 0.3rem 0.6rem 0.1rem rgb(0 0 0 / 16%);\n  cursor: pointer;\n  .row {\n    width: 100%;\n    height: 25%;\n    display: flex;\n    align-items: center;\n    padding: 2rem;\n    font-size: 1.6rem;\n    &:hover {\n      color: #2680EB;\n    }\n    img {\n      padding-right: 1.5rem;\n    }\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: ',';\n  height: ',';\n  border-radius: 100%;\n  background: #6489B5;\n  opacity: 0.4;\n'],['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: ',';\n  height: ',';\n  border-radius: 100%;\n  background: #6489B5;\n  opacity: 0.4;\n']),_templateObject9=_taggedTemplateLiteral(['\n  background: #2680EB;\n  border-radius: 100%;\n  font-size: 4rem;\n  color: white;\n  cursor: pointer;\n  width: 2rem;\n  height: 2rem;\n  padding: 3.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  background: #2680EB;\n  border-radius: 100%;\n  font-size: 4rem;\n  color: white;\n  cursor: pointer;\n  width: 2rem;\n  height: 2rem;\n  padding: 3.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DesktopLayout=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.mainColor;},function(props){return props.mainColor;},function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["b" ])(props.mainColor);},function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["b" ])(props.mainColor);},__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["b" ])(props.mainColor);},__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["b" ])(props.mainColor);},function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["c" ])(props.mainColor,150));},function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["c" ])(props.mainColor,150));},function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["c" ])(props.mainColor,150));},__WEBPACK_IMPORTED_MODULE_4_constants_colors__["f" ],function(props){return props.secondaryColor;},__WEBPACK_IMPORTED_MODULE_4_constants_colors__["f" ],function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["c" ])(props.mainColor,120));},function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["c" ])(props.mainColor,90));},function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["c" ])(props.mainColor,120));},function(props){return props.secondaryColor;},function(props){return props.secondaryColor;},__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].boldFamily,function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["c" ])(props.mainColor,100));},function(props){return props.secondaryColor;},function(props){return props.isInNarrative?'rgba(255, 255, 255, 0.2)':'#f9f9f9';});var IconMainOption=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].img(_templateObject2,function(props){return props.image;});var IconSerendipity=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject3);var ProgressSerendipity=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return props.pro+'rem';});var MobileLayout=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,function(props){return props.mainColor;},function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["b" ])(props.mainColor);},__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].boldFamily,function(props){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_colors__["b" ])(props.mainColor);},function(props){return props.secondaryColor;},function(props){return props.secondaryColor;});var ToolsButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,function(props){return props.open?'0':'-28rem';});var ToolsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7,function(props){return props.open?'0':'-27rem';});var PieSize=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,function(props){return props.pro+'%';},function(props){return props.pro+'%';});var AddButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(1006);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1007);
 var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(1008);
 var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// const LoadingImageStyle = {
//   backgroundImage: `url(${LoadingImageUrl})`,
// };
var Loading=function(_Component){_inherits(Loading,_Component);function Loading(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Loading);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Loading.__proto__||Object.getPrototypeOf(Loading)).call.apply(_ref,[this].concat(args))),_this),_this.getBackgroundColor=function(){var _this$props=_this.props,app=_this$props.app,actualContext=_this$props.actualContext,color=_this$props.color;if(color){return color;}if(!actualContext){return app.color1;}if(actualContext.color){return actualContext.color;}switch(actualContext.elementType){case'narrative':case'objective':return actualContext.color;default:return app.color1;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Loading,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_2__animation__["a" ])();}},{key:'render',value:function render(){var _props=this.props,hide=_props.hide,actualContext=_props.actualContext;var color=this.getBackgroundColor();var elementType=actualContext?actualContext.elementType:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{contextType:elementType,color:color||color.color,className:hide?'container--loading hidden':'container--loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{className:'canvas'}));}}]);return Loading;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Loading.propTypes={hide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,actualContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Loading.defaultProps={hide:true,actualContext:null,color:null,app:null}; __webpack_exports__["a"] = (Loading);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var PI=Math.PI;var TAU=PI*2;var HALF_PI=PI*0.5;var RAND=Math.random;var ROUND=Math.round;var SIN=Math.sin;var COS=Math.cos;var ABS=Math.abs;var POW=Math.pow;var lib={v2:Vector2,noise:noise,stats:Stats};var Config=function(){function Config(opts){_classCallCheck(this,Config);this.merge(opts);}_createClass(Config,[{key:'merge',value:function merge(opts){for(var opt in opts){this.set(opt,opts[opt]);}}},{key:'set',value:function set(key,value){if(!key||!value)return;this[key]=value;}}]);return Config;}();var Canvas=function(){function Canvas(selector,context,dimensions,center){_classCallCheck(this,Canvas);var self=this;if(selector){this.el=document.querySelector(selector);}else{this.el=document.createElement('canvas');document.body.appendChild(this.el);}this.ctx=this.el.getContext(context)||this.el.getContext('2d');this.dimensions=dimensions||{x:0,y:0};this.center=new lib.v2();window.addEventListener('resize',self.resize.bind(self));}_createClass(Canvas,[{key:'rgba',value:function rgba(r,g,b,a){return'rgba('+r+','+g+','+b+','+a+')';}},{key:'hsla',value:function hsla(h,s,l,a){return'hsla('+h+', '+s+', '+l+', '+a+')';}},{key:'fill',value:function fill(x,y,width,height,_fill){this.ctx.fillStyle=_fill||'rgba(255,255,255,1)';this.ctx.fillRect(x,y,width,height);}},{key:'clear',value:function clear(){this.ctx.clearRect(0,0,this.dimensions.x,this.dimensions.y);}},{key:'drawLine',value:function drawLine(x1,y1,x2,y2,stroke,strokeWidth){this.ctx.beginPath();this.ctx.moveTo(x1,y1);this.ctx.lineTo(x2,y2);this.ctx.strokeStyle=stroke||'rgba(255,255,255,1)';this.ctx.lineWidth=strokeWidth||2;this.ctx.stroke();this.ctx.closePath();}},{key:'resize',value:function resize(){this.el.width=this.dimensions.x=window.innerWidth;this.el.height=this.dimensions.y=window.innerHeight;this.center.x=this.dimensions.x*0.5;this.center.y=this.dimensions.y*0.5;this.ctx.globalCompositeOperation='lighter';}}]);return Canvas;}();var Particle=function(){function Particle(x,y,bounds,center){_classCallCheck(this,Particle);this.lastPosition=new lib.v2();this.position=new lib.v2(x,y);this.velocity=new lib.v2();this.life=0;this.ttl=1000;this.bounds=bounds;this.center=center;this.reset=false;}_createClass(Particle,[{key:'update',value:function update(){if(this.life>this.ttl||this.checkBounds()){this.reset=true;}else{this.position.add(this.velocity);this.life++;}}},{key:'checkBounds',value:function checkBounds(){return this.lastPosition.x-this.size*3>this.bounds.x||this.lastPosition.x<-this.size||this.lastPosition.y-this.size*3>this.bounds.y||this.lastPosition.y<-this.size||this.position.distanceTo(this.center)<3;}}]);return Particle;}();var ParticleSystem=function(){function ParticleSystem(){_classCallCheck(this,ParticleSystem);lib.noise.seed(RAND*2000);var defaults={max:400,size:5};this.canvas=new Canvas('.canvas','2d');this.canvas.resize();this.bounds=this.canvas.dimensions;this.config=new Config(defaults);this.tick=0;this.points=[];this.render();}_createClass(ParticleSystem,[{key:'update',value:function update(){var pRef=void 0;var p=void 0;var noiseVal=void 0;var noiseNorm=void 0;var theta=void 0;var theta2=void 0;var dTheta=void 0;var vel=void 0;var vel2=void 0;var size=void 0;var hue=void 0;var colorString=void 0;this.canvas.clear();this.canvas.ctx.lineCap='round';if(this.points.length<this.config.max&&this.tick%2===0){var rand=ROUND(RAND());var x=rand?ROUND(RAND())*this.canvas.dimensions.x:RAND()*this.canvas.dimensions.x;var y=rand?RAND()*this.canvas.dimensions.y:ROUND(RAND())*this.canvas.dimensions.y;p=new Particle(x,y,this.canvas.dimensions,this.canvas.center);this.points.push(p);}for(var i=this.points.length-1;i>=0;i--){p=this.points[i];if(p.reset){this.points.splice(i,1);continue;}else{p.lastPosition.x=p.position.x;p.lastPosition.y=p.position.y;noiseVal=lib.noise.simplex3(p.position.x*0.0015,p.position.y*0.0015,this.tick*0.005);noiseNorm=ABS(noiseVal);theta=noiseVal*TAU*(1000/(p.position.distanceTo(this.canvas.center)+1000));theta2=p.position.angleTo(this.canvas.center)+HALF_PI*0.25;dTheta=(theta+theta2)/2;hue=theta*10-30;colorString=this.canvas.hsla(0,'0%','100%',noiseNorm+0.2);vel=new lib.v2((COS(theta)*0.5+COS(theta2))*6,(SIN(theta)*0.5+SIN(theta2))*3).multiplyScalar(POW(2*(p.position.y/this.canvas.dimensions.y)+1,2));size=POW(p.position.y/this.canvas.dimensions.y*this.config.size,2)+2;p.velocity.lerp(vel,0.035);p.update();this.canvas.drawLine(p.lastPosition.x,p.lastPosition.y,p.position.x,p.position.y,colorString,size);}}this.tick++;}},{key:'render',value:function render(){var self=this;self.update();window.requestAnimationFrame(self.render.bind(self));}}]);return ParticleSystem;}();window.requestAnimationFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(callback){window.setTimeout(callback,1000/60);};}();var initialize=function initialize(){var p=new ParticleSystem();}; __webpack_exports__["a"] = (initialize);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  height: 100%;\n  transition: background-color 0.4s linear;\n  .canvas {\n    background-color: ',';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n  }\n  \n'],['\n  background-color: ',';\n  height: 100%;\n  transition: background-color 0.4s linear;\n  .canvas {\n    background-color: ',';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n  }\n  \n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;},function(props){return props.color;});

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(1010);
 var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
 __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NotFound'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'404'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'This page could not be found.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__constants_urls__["y" ]},'Go home'))));});

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1012);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1013);
 var __WEBPACK_IMPORTED_MODULE_5__MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_6__modules_actions__ = __webpack_require__(443);
function mapStateToProps(state){return{literals:state.i18n.literals.login,loginError:state.login.error,userLang:state.i18n.language,app:state.app};}function mapDispatchToProps(dispatch){return{doLogin:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6__modules_actions__["a" ],dispatch),showLoading:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ],dispatch),doLoginSocial:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6__modules_actions__["b" ],dispatch),setAutoNavigation:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5__MainPage_modules_mainPage__["b" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(115);
 var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_5_react_material_ui_form_validator__ = __webpack_require__(253);
 var __WEBPACK_IMPORTED_MODULE_5_react_material_ui_form_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_material_ui_form_validator__);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_icons_riseLogo_svg__ = __webpack_require__(1027);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_icons_riseLogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_images_icons_riseLogo_svg__);
 var __WEBPACK_IMPORTED_MODULE_7__constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_8__assets_images_linkedin_svg__ = __webpack_require__(255);
 var __WEBPACK_IMPORTED_MODULE_8__assets_images_linkedin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_linkedin_svg__);
 var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(1028);
 var __WEBPACK_IMPORTED_MODULE_10__styles_css__ = __webpack_require__(1029);
 var __WEBPACK_IMPORTED_MODULE_10__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Login=function(_Component){_inherits(Login,_Component);function Login(props){_classCallCheck(this,Login);var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this,props));_this.handleChange=function(name){return function(event){_this.setState(_defineProperty({},name,event.target.value),_this.validateForm);};};_this.validateForm=function(){var _this$state=_this.state,email=_this$state.email,password=_this$state.password;return _this.setState({formValid:email!==''&&password!==''});};_this.handleClickShowPassword=function(){_this.setState(function(state){return{showPassword:!state.showPassword};});};_this.handleMouseDownPassword=function(event){event.preventDefault();};_this.login=function(){var _this$state2=_this.state,formValid=_this$state2.formValid,email=_this$state2.email,password=_this$state2.password;var doLogin=_this.props.doLogin;if(formValid){doLogin(email,password);}};_this.handleGoLogin=function(){_this.setState({initial:false});};_this.handleRegister=function(){_this.setState({initial:false});};_this.openLinkedin=function(){var origin=window.location.origin;var redirectURL=origin+'/social_oauth/linkedin';var url=origin+'/system/security/external/oauth.php?oa_ref=3c90c80eb1c2b395af81dd463425731545396064&oa_redirect='+encodeURIComponent(redirectURL)+'&oa_domain='+origin;window.location.href=url;};_this.redirectAfterLogin=function(){var location=_this.props.location;if(window.urlToRedirect){var _window=window,urlToRedirect=_window.urlToRedirect;delete window.urlToRedirect;window.location.href=urlToRedirect;return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" ],{to:{pathname:__WEBPACK_IMPORTED_MODULE_7__constants_urls__["u" ],state:location.state}});};_this.state={email:'',password:'',showPassword:false,formValid:false,initial:true};return _this;}_createClass(Login,[{key:'componentDidMount',value:function componentDidMount(){var setAutoNavigation=this.props.setAutoNavigation;setAutoNavigation(true);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,literals=_props.literals,location=_props.location,loginError=_props.loginError,app=_props.app;var _state=this.state,email=_state.email,showPassword=_state.showPassword,password=_state.password,initial=_state.initial;if(app.isAuthenticated){var flagRedirect=location.state&&location.state.from!==__WEBPACK_IMPORTED_MODULE_7__constants_urls__["a" ]&&location.state.from!==__WEBPACK_IMPORTED_MODULE_7__constants_urls__["x" ];var redirectTo=flagRedirect?location.state.from:__WEBPACK_IMPORTED_MODULE_7__constants_urls__["u" ];__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser().then(function(){return _this2.redirectAfterLogin();}).catch(function(){});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" ],{to:{pathname:redirectTo,state:location.state}});}if(initial){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["b" ],{app:app},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_assets_images_icons_riseLogo_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.titleText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.footerText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handleGoLogin},literals.loginAccount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" ],{to:__WEBPACK_IMPORTED_MODULE_7__constants_urls__["G" ],onClick:this.handleRegister},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',null,literals.registry)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["c" ],{className:'Login',app:app},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__["a" ],{container:true,spacing:0,className:'Login__panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__["a" ],{item:true,xs:12,sm:12,md:12,className:'Login__panel--left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Login__panel--left__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Login__panel--left__content__header text-align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},app.login_text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Login__panel--left__content__form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_material_ui_form_validator__["ValidatorForm"],{onSubmit:this.login,autoComplete:'off'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_material_ui_form_validator__["TextValidator"],{id:'adornment-email',type:'text',autoComplete:'email',autoFocus:true,name:'email',placeholder:literals.email,value:email,className:'form__field',onChange:this.handleChange('email'),validators:['required','isEmail'],errorMessages:[literals.error.require,literals.error.email],inputProps:{className:'form__field__input'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_material_ui_form_validator__["TextValidator"],{id:'adornment-password',placeholder:literals.password,type:showPassword?'text':'password',autoComplete:'current-password',value:password,className:'form__field',name:'password',onChange:this.handleChange('password'),inputProps:{className:'form__field__input'},validators:['required'],errorMessages:[literals.error.require]}),loginError!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'error'},loginError),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Login__panel--left__content__form__description text-align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title'},app.poweredBy)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["a" ],{type:'submit'},literals.actionBtn),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" ],{to:__WEBPACK_IMPORTED_MODULE_7__constants_urls__["G" ],className:'btn-register'},literals.register),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" ],{to:__WEBPACK_IMPORTED_MODULE_7__constants_urls__["r" ],className:'btn-remember-password'},literals.rememberPassword)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Login__panel--left__content__form__social hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_linkedin_svg___default.a,alt:'LinkedIn',onClick:this.openLinkedin})))))));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Login.propTypes={location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,loginError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,doLogin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setAutoNavigation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (Login);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__utils_requirePropFactory__ = __webpack_require__(439);


// A grid component using the following libs as inspiration.
//
// For the implementation:
// - https://getbootstrap.com/docs/4.3/layout/grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/





var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function getOffset(val) {
  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var parse = parseFloat(val);
  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  SPACINGS.forEach(function (spacing) {
    var themeSpacing = theme.spacing(spacing);

    if (themeSpacing === 0) {
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "-".concat(getOffset(themeSpacing, 2)),
      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
      '& > $item': {
        padding: getOffset(themeSpacing, 2)
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    
    root: {},

    
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    
    zeroMinWidth: {
      minWidth: 0
    },

    
    'direction-xs-column': {
      flexDirection: 'column'
    },

    
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    
    'align-items-xs-center': {
      alignItems: 'center'
    },

    
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    
    'align-content-xs-center': {
      alignContent: 'center'
    },

    
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    
    'justify-xs-center': {
      justifyContent: 'center'
    },

    
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },

    
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    },

    
    'justify-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};
var Grid = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Grid(props, ref) {
  var _props$alignContent = props.alignContent,
      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
      classes = props.classes,
      classNameProp = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$container = props.container,
      container = _props$container === void 0 ? false : _props$container,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'row' : _props$direction,
      _props$item = props.item,
      item = _props$item === void 0 ? false : _props$item,
      _props$justify = props.justify,
      justify = _props$justify === void 0 ? 'flex-start' : _props$justify,
      _props$lg = props.lg,
      lg = _props$lg === void 0 ? false : _props$lg,
      _props$md = props.md,
      md = _props$md === void 0 ? false : _props$md,
      _props$sm = props.sm,
      sm = _props$sm === void 0 ? false : _props$sm,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
      _props$wrap = props.wrap,
      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
      _props$xl = props.xl,
      xl = _props$xl === void 0 ? false : _props$xl,
      _props$xs = props.xs,
      xs = _props$xs === void 0 ? false : _props$xs,
      _props$zeroMinWidth = props.zeroMinWidth,
      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);

  var className = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], justify !== 'flex-start' && classes["justify-xs-".concat(String(justify))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    className: className,
    ref: ref
  }, other));
});
 false ? Grid.propTypes = {
  
  alignContent: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  
  children: PropTypes.node,

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string,

  
  component: PropTypes
  
  .elementType,

  
  container: PropTypes.bool,

  
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  
  item: PropTypes.bool,

  
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  
  lg: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  
  md: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  
  sm: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  
  spacing: PropTypes.oneOf(SPACINGS),

  
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  
  xl: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  
  xs: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  
  zeroMinWidth: PropTypes.bool
} : void 0;
var StyledGrid = Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiGrid'
})(Grid);

if (false) {
  var requireProp = requirePropFactory('Grid');
  StyledGrid.propTypes = _extends({}, StyledGrid.propTypes, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('item')
  });
}

 __webpack_exports__["a"] = (StyledGrid);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _promisePolyfill = __webpack_require__(440);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

var _reactLifecyclesCompat = __webpack_require__(1019);

var _ValidatorForm = __webpack_require__(441);

var _ValidatorForm2 = _interopRequireDefault(_ValidatorForm);

var _utils = __webpack_require__(1024);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } 




var ValidatorComponent = function (_React$Component) {
    _inherits(ValidatorComponent, _React$Component);

    function ValidatorComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ValidatorComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ValidatorComponent.__proto__ || Object.getPrototypeOf(ValidatorComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isValid: true,
            value: _this.props.value,
            errorMessages: _this.props.errorMessages,
            validators: _this.props.validators
        }, _this.getErrorMessage = function () {
            var errorMessages = _this.state.errorMessages;

            var type = typeof errorMessages === 'undefined' ? 'undefined' : _typeof(errorMessages);

            if (type === 'string') {
                return errorMessages;
            } else if (type === 'object') {
                if (_this.invalid.length > 0) {
                    return errorMessages[_this.invalid[0]];
                }
            }
            // eslint-disable-next-line
            console.log('unknown errorMessages type', errorMessages);
            return true;
        }, _this.instantValidate = true, _this.invalid = [], _this.configure = function () {
            _this.form.attachToForm(_this);
            _this.instantValidate = _this.form.instantValidate;
            _this.debounceTime = _this.form.debounceTime;
            _this.validateDebounced = (0, _utils.debounce)(_this.validate, _this.debounceTime);
        }, _this.validate = function (value) {
            var includeRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var dryRun = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var validations = _promisePolyfill2.default.all(_this.state.validators.map(function (validator) {
                return _ValidatorForm2.default.getValidator(validator, value, includeRequired);
            }));

            return validations.then(function (results) {
                _this.invalid = [];
                var valid = true;
                results.forEach(function (result, key) {
                    if (!result) {
                        valid = false;
                        _this.invalid.push(key);
                    }
                });
                if (!dryRun) {
                    _this.setState({ isValid: valid }, function () {
                        _this.props.validatorListener(_this.state.isValid);
                    });
                }
                return valid;
            });
        }, _this.isValid = function () {
            return _this.state.isValid;
        }, _this.makeInvalid = function () {
            _this.setState({ isValid: false });
        }, _this.makeValid = function () {
            _this.setState({ isValid: true });
        }, _this.renderComponent = function (form) {
            if (!_this.form) {
                _this.form = form;
            }
            return _this.renderValidatorComponent();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ValidatorComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.configure();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return this.state !== nextState || this.props !== nextProps;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.instantValidate && this.props.value !== prevState.value) {
                this.validateDebounced(this.props.value, this.props.withRequiredValidator);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.form.detachFromForm(this);
            this.validateDebounced.cancel();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _ValidatorForm.FormContext.Consumer,
                null,
                function (_ref2) {
                    var form = _ref2.form;
                    return _react2.default.createElement(
                        'div',
                        _this2.props.containerProps,
                        _this2.renderComponent(form)
                    );
                }
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.validators && nextProps.errorMessages && (prevState.validators !== nextProps.validators || prevState.errorMessages !== nextProps.errorMessages)) {
                return {
                    value: nextProps.value,
                    validators: nextProps.validators,
                    errorMessages: nextProps.errorMessages
                };
            }

            return {
                value: nextProps.value
            };
        }
    }]);

    return ValidatorComponent;
}(_react2.default.Component);

ValidatorComponent.propTypes = {
    errorMessages: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    validators: _propTypes2.default.array,
    value: _propTypes2.default.any,
    validatorListener: _propTypes2.default.func,
    withRequiredValidator: _propTypes2.default.bool,
    containerProps: _propTypes2.default.object
};

ValidatorComponent.defaultProps = {
    errorMessages: 'error',
    validators: [],
    validatorListener: function validatorListener() {}
};

(0, _reactLifecyclesCompat.polyfill)(ValidatorComponent);

exports.default = ValidatorComponent;

 }),

 (function(module, exports, __webpack_require__) {

(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1017);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

}.call(exports, __webpack_require__(51)))

 }),

 (function(module, exports, __webpack_require__) {

(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

}.call(exports, __webpack_require__(51), __webpack_require__(124)))

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

function finallyConstructor(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
}

 __webpack_exports__["a"] = (finallyConstructor);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
 __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });


function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1021);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(1022);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(1023);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

 }),

 (function(module, exports, __webpack_require__) {

"use strict";
(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

}.call(exports, __webpack_require__(51)))

 }),

 (function(module, exports, __webpack_require__) {

"use strict";






var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var debounce = function debounce(func, wait, immediate) {
    var timeout = void 0;
    function cancel() {
        if (timeout !== undefined) {
            clearTimeout(timeout);
        }
    }
    var debounced = function debounced() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var context = this;
        var later = function delayed() {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
    debounced.cancel = cancel;
    return debounced;
};

exports.debounce = debounce;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TextField = __webpack_require__(68);

var _TextField2 = _interopRequireDefault(_TextField);

var _reactFormValidatorCore = __webpack_require__(254);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } 




var SelectValidator = function (_ValidatorComponent) {
    _inherits(SelectValidator, _ValidatorComponent);

    function SelectValidator() {
        _classCallCheck(this, SelectValidator);

        return _possibleConstructorReturn(this, (SelectValidator.__proto__ || Object.getPrototypeOf(SelectValidator)).apply(this, arguments));
    }

    _createClass(SelectValidator, [{
        key: 'renderValidatorComponent',
        value: function renderValidatorComponent() {
            
            var _props = this.props,
                error = _props.error,
                errorMessages = _props.errorMessages,
                validators = _props.validators,
                requiredError = _props.requiredError,
                helperText = _props.helperText,
                validatorListener = _props.validatorListener,
                withRequiredValidator = _props.withRequiredValidator,
                containerProps = _props.containerProps,
                rest = _objectWithoutProperties(_props, ['error', 'errorMessages', 'validators', 'requiredError', 'helperText', 'validatorListener', 'withRequiredValidator', 'containerProps']);

            var isValid = this.state.isValid;

            return _react2.default.createElement(_TextField2.default, _extends({}, rest, {
                select: true,
                error: !isValid || error,
                helperText: !isValid && this.getErrorMessage() || helperText
            }));
        }
    }]);

    return SelectValidator;
}(_reactFormValidatorCore.ValidatorComponent);

exports.default = SelectValidator;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TextField = __webpack_require__(68);

var _TextField2 = _interopRequireDefault(_TextField);

var _reactFormValidatorCore = __webpack_require__(254);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } 




var TextValidator = function (_ValidatorComponent) {
    _inherits(TextValidator, _ValidatorComponent);

    function TextValidator() {
        _classCallCheck(this, TextValidator);

        return _possibleConstructorReturn(this, (TextValidator.__proto__ || Object.getPrototypeOf(TextValidator)).apply(this, arguments));
    }

    _createClass(TextValidator, [{
        key: 'renderValidatorComponent',
        value: function renderValidatorComponent() {
            
            var _props = this.props,
                error = _props.error,
                errorMessages = _props.errorMessages,
                validators = _props.validators,
                requiredError = _props.requiredError,
                helperText = _props.helperText,
                validatorListener = _props.validatorListener,
                withRequiredValidator = _props.withRequiredValidator,
                containerProps = _props.containerProps,
                rest = _objectWithoutProperties(_props, ['error', 'errorMessages', 'validators', 'requiredError', 'helperText', 'validatorListener', 'withRequiredValidator', 'containerProps']);

            var isValid = this.state.isValid;

            return _react2.default.createElement(_TextField2.default, _extends({}, rest, {
                error: !isValid || error,
                helperText: !isValid && this.getErrorMessage() || helperText
            }));
        }
    }]);

    return TextValidator;
}(_reactFormValidatorCore.ValidatorComponent);

exports.default = TextValidator;

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/riseLogo.dd457c5a.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return LoginWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return InitialWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonLogin; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: white;\n  @media(min-width: ','px) {\n    background-color: #2680EB;\n  }\n\n  input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px ',' inset;\n    -webkit-text-fill-color: white;\n  }\n'],['\n  background-color: white;\n  @media(min-width: ','px) {\n    background-color: #2680EB;\n  }\n\n  input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px ',' inset;\n    -webkit-text-fill-color: white;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  background-color: #2680EB;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  button {\n    width: 30rem;\n    height: 5rem;\n    border-radius: 3rem;\n    font-size: 1.4rem;\n    background: white;\n    color: #2680EB;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    margin: 1rem;\n  }\n\n  p {\n    font-size: 3rem;\n    color: white;\n    margin-bottom: 4rem;\n    width: 25rem;\n    font-weight: bold;\n  }\n\n  img {\n    margin-bottom: 3rem;\n  }\n'],['\n  background-color: #2680EB;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  button {\n    width: 30rem;\n    height: 5rem;\n    border-radius: 3rem;\n    font-size: 1.4rem;\n    background: white;\n    color: #2680EB;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    margin: 1rem;\n  }\n\n  p {\n    font-size: 3rem;\n    color: white;\n    margin-bottom: 4rem;\n    width: 25rem;\n    font-weight: bold;\n  }\n\n  img {\n    margin-bottom: 3rem;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.3rem;\n  width: 15rem;\n  padding: 1.2rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: #2680EB;\n  margin-bottom: 2rem;\n'],['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.3rem;\n  width: 15rem;\n  padding: 1.2rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: #2680EB;\n  margin-bottom: 2rem;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LoginWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.app.color1;});var InitialWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var ButtonLogin=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject3);

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1031);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_4_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_5__components_Logout__ = __webpack_require__(1032);
var mapStateToProps=function mapStateToProps(){return{};};function mapDispatchToProps(dispatch){return{setIsAuthenticated:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_1_modules_app__["c" ],dispatch),resetContext:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_store_globalState_global__["e" ],dispatch),goHome:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__["e" ],dispatch),setSplashScreen:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_1_modules_app__["d" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__["f" ],dispatch),logOut:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_store_globalState_global__["d" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components_Logout__["a" ]));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_3_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_4_constants_urls__ = __webpack_require__(19);
var Logout=function Logout(_ref){var setIsAuthenticated=_ref.setIsAuthenticated,resetContext=_ref.resetContext,goHome=_ref.goHome,setSplashScreen=_ref.setSplashScreen,resetAll=_ref.resetAll,logOut=_ref.logOut;__WEBPACK_IMPORTED_MODULE_3_redux_react_session__["sessionService"].deleteSession();__WEBPACK_IMPORTED_MODULE_3_redux_react_session__["sessionService"].deleteUser();setIsAuthenticated(false);resetContext();goHome();setSplashScreen(true);resetAll();logOut();window.logout();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" ],{to:{pathname:__WEBPACK_IMPORTED_MODULE_4_constants_urls__["w" ]}});};Logout.propTypes={setIsAuthenticated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,goHome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setSplashScreen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,logOut:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (Logout);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1034);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3__store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1035);
 var __WEBPACK_IMPORTED_MODULE_5__modules_actions__ = __webpack_require__(444);
function mapStateToProps(state){return{isAuthenticated:state.session.authenticated,literals:state.i18n.literals.forgetPassword,loginError:state.login.error,userLang:state.i18n.language,app:state.app};}function mapDispatchToProps(dispatch){return{onLogin:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5__modules_actions__["a" ],dispatch),showLoading:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3__store_globalState_global__["c" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(115);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(93);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(433);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Input__ = __webpack_require__(112);
 var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputLabel__ = __webpack_require__(177);
 var __WEBPACK_IMPORTED_MODULE_8__constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(1037);
 var __WEBPACK_IMPORTED_MODULE_10__styles_css__ = __webpack_require__(1038);
 var __WEBPACK_IMPORTED_MODULE_10__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_css__);
 var __WEBPACK_IMPORTED_MODULE_11__modules_actions__ = __webpack_require__(444);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ForgetPassword=function(_Component){_inherits(ForgetPassword,_Component);function ForgetPassword(props){_classCallCheck(this,ForgetPassword);var _this=_possibleConstructorReturn(this,(ForgetPassword.__proto__||Object.getPrototypeOf(ForgetPassword)).call(this,props));_this.handleEmailChange=function(){return function(event){_this.setState({email:event.target.value});_this.setState({formValid:event.target.value!==''});};};_this.handleResetPassword=function(){var email=_this.state.email;_this.sendRecoverEmail(function(error,data){if(!error){_this.setState({message:data.info,email:data.success?'':email});}});};_this.sendRecoverEmail=function(callback){var _this$props=_this.props,showLoading=_this$props.showLoading,lang=_this$props.userLang;var email=_this.state.email;showLoading(true);Object(__WEBPACK_IMPORTED_MODULE_11__modules_actions__["b" ])({email:email,lang:lang}).then(function(data){if(callback&&typeof callback==='function'){callback(false,data);}showLoading(false);}).catch(function(error){if(callback&&typeof callback==='function'){callback(true,error);}showLoading(false);});};_this.state={email:'',formValid:false,message:''};return _this;}// handleNoEmailReceived = () => {
//   this.setState({
//     flagSent: false,
//   });
// };
_createClass(ForgetPassword,[{key:'render',value:function render(){var _props=this.props,literals=_props.literals,isAuthenticated=_props.isAuthenticated,location=_props.location,app=_props.app;var _state=this.state,email=_state.email,formValid=_state.formValid,message=_state.message;if(isAuthenticated){var flagRedirect=location.state&&location.state.from!==__WEBPACK_IMPORTED_MODULE_8__constants_urls__["a" ]&&location.state.from!==__WEBPACK_IMPORTED_MODULE_8__constants_urls__["x" ];var redirectTo=flagRedirect?location.state.from:__WEBPACK_IMPORTED_MODULE_8__constants_urls__["y" ];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" ],{to:{pathname:redirectTo,state:location.state}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["a" ],{className:'ForgetPassword',app:app},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__["a" ],{container:true,spacing:0,className:'ForgetPassword__panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__["a" ],{item:true,xs:12,sm:12,md:12,className:'ForgetPassword__panel--left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ForgetPassword__panel--left__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ForgetPassword__panel--left__content__header text-align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo',src:app.logo,alt:'logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},literals.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ForgetPassword__panel--left__content__form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__["a" ],{fullWidth:true,className:'form__field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputLabel__["a" ],{htmlFor:'adornment-email',classes:{root:'form__field__label'}},literals.userEmail),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Input__["a" ],{id:'adornment-email',type:'text',autoComplete:'email',autoFocus:true,value:email,onChange:this.handleEmailChange(),variant:'outlined',inputProps:{className:'form__field__input'}})),message!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'error'},message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__["a" ],{fullWidth:true,variant:'contained',color:'primary',className:'btn-send',disabled:!formValid,onClick:this.handleResetPassword},literals.resetPasswordAction),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" ],{to:__WEBPACK_IMPORTED_MODULE_8__constants_urls__["w" ],className:'btn-go-back'},literals.goBack)))))));}}]);return ForgetPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ForgetPassword.propTypes={location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isAuthenticated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,userLang:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,showLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (ForgetPassword);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__ = __webpack_require__(129);
 var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(232);
 var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(38);









var styles = function styles(theme) {
  return {
    
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["d" ])(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    
    text: {
      padding: '6px 8px'
    },

    
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["d" ])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["d" ])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },

    
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["d" ])(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["d" ])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["d" ])(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["d" ])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    
    disableElevation: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&$focusVisible': {
        boxShadow: 'none'
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&$disabled': {
        boxShadow: 'none'
      }
    },

    
    focusVisible: {},

    
    disabled: {},

    
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    
    sizeSmall: {},

    
    sizeLarge: {},

    
    fullWidth: {
      width: '100%'
    },

    
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.startIcon, classes["iconSize".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" ])(size))])
  }, startIconProp);
  var endIcon = endIconProp && __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.endIcon, classes["iconSize".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" ])(size))])
  }, endIconProp);
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" ], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" ])(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" ])(size))], classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" ])(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
 false ? Button.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  
  component: PropTypes
  
  .elementType,

  
  disabled: PropTypes.bool,

  
  disableElevation: PropTypes.bool,

  
  disableFocusRipple: PropTypes.bool,

  
  disableRipple: PropTypes.bool,

  
  endIcon: PropTypes.node,

  
  focusVisibleClassName: PropTypes.string,

  
  fullWidth: PropTypes.bool,

  
  href: PropTypes.string,

  
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  
  startIcon: PropTypes.node,

  
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string]),

  
  variant: PropTypes.oneOf(['contained', 'outlined', 'text'])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiButton'
})(Button));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "a", function() { return ForgetPasswordWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n'],['\n  background-color: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var recoverPasswordStyles=function recoverPasswordStyles(){return{dialogActions:{display:'block',justifyContent:'center',padding:'0 2.4rem 3.0rem',margin:'1.0rem 0 0'},dialogContent:{padding:'0',width:'100%',maxWidth:'45.0rem'},dialogTitle:{fontWeight:100,fontSize:'1.5rem',color:__WEBPACK_IMPORTED_MODULE_1_constants_colors__["a" ]},dialogMainTitle:{fontSize:'2.4rem',padding:'0 2.4rem'},textField:{width:'100%'}};};var ForgetPasswordWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.app.color1;});

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_LOGIN_INIT; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_LOGIN_SUCCESS; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_LOGIN_FAILURE; });
var FETCH_LOGIN_INIT='FETCH_LOGIN_INIT';var FETCH_LOGIN_SUCCESS='FETCH_LOGIN_SUCCESS';var FETCH_LOGIN_FAILURE='FETCH_LOGIN_FAILURE';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1041);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1042);
 var __WEBPACK_IMPORTED_MODULE_6__MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_7__modules_signup__ = __webpack_require__(157);
function mapStateToProps(state){return{literals:state.i18n.literals.signup,signupData:state.signup,userLang:state.i18n.language,app:state.app};}function mapDispatchToProps(dispatch){return{showLoading:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ],dispatch),doSignup:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7__modules_signup__["b" ],dispatch),uploadImage:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7__modules_signup__["d" ],dispatch),doSignupSocial:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7__modules_signup__["c" ],dispatch),setAutoNavigation:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6__MainPage_modules_mainPage__["b" ],dispatch),setSplashScreen:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_app__["d" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Dialog__ = __webpack_require__(256);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_DialogContent__ = __webpack_require__(172);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogContentText__ = __webpack_require__(257);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle__ = __webpack_require__(259);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Slide__ = __webpack_require__(446);
 var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__ = __webpack_require__(115);
 var __WEBPACK_IMPORTED_MODULE_9_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__ = __webpack_require__(93);
 var __WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__ = __webpack_require__(253);
 var __WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__);
 var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Input__ = __webpack_require__(112);
 var __WEBPACK_IMPORTED_MODULE_13_exif_react_avatar_edit__ = __webpack_require__(447);
 var __WEBPACK_IMPORTED_MODULE_13_exif_react_avatar_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_exif_react_avatar_edit__);
 var __WEBPACK_IMPORTED_MODULE_14_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_15_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_15_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_16_components_CodeOfHonor__ = __webpack_require__(448);
 var __WEBPACK_IMPORTED_MODULE_17_components_CodeOfHonor_modules_actions__ = __webpack_require__(260);
 var __WEBPACK_IMPORTED_MODULE_18_modules_users_actions__ = __webpack_require__(85);
 var __WEBPACK_IMPORTED_MODULE_19_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_20__assets_images_linkedin_svg__ = __webpack_require__(255);
 var __WEBPACK_IMPORTED_MODULE_20__assets_images_linkedin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_linkedin_svg__);
 var __WEBPACK_IMPORTED_MODULE_21__constants_patterns__ = __webpack_require__(449);
 var __WEBPACK_IMPORTED_MODULE_22__constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_23__styles__ = __webpack_require__(1057);
 var __WEBPACK_IMPORTED_MODULE_24__styles_css__ = __webpack_require__(1058);
 var __WEBPACK_IMPORTED_MODULE_24__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import history from 'store/history';
function Transition(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Slide__["a" ],Object.assign({direction:'down'},props));}var Signup=function(_Component){_inherits(Signup,_Component);function Signup(props){_classCallCheck(this,Signup);var _this=_possibleConstructorReturn(this,(Signup.__proto__||Object.getPrototypeOf(Signup)).call(this,props));_this.showCodeOfHonor=function(){var flag=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;_this.setState({flagCodeOfHonor:flag});};_this.onCloseAvatar=function(){_this.setState({previewAvatar:null});};_this.onCropAvatar=function(previewAvatar){_this.setState({previewAvatar:previewAvatar});};_this.showAvatarEditor=function(){_this.setState({openEditor:true});};_this.assignHiddenFileInput=function(ref){_this.hiddenFileInput=ref;};_this.handleChange=function(name){return function(event){var value=event.target.value;if(name==='term'){value=event.target.checked;}_this.setState(_defineProperty({},name,value),function(){_this.validateField(name,value);});};};_this.validateField=function(fieldName,value){var emailValid=_this.state.emailValid;switch(fieldName){case'email':emailValid=value.match(__WEBPACK_IMPORTED_MODULE_21__constants_patterns__["a" ]);break;default:break;}_this.setState({emailValid:emailValid},_this.validateForm);};_this.validateForm=function(){var _this$state=_this.state,firstName=_this$state.firstName,lastName=_this$state.lastName,emailValid=_this$state.emailValid;return _this.setState({formValid:firstName!==''&&lastName!==''&&emailValid});};_this.clearForm=function(){_this.setState({firstName:'',lastName:'',email:'',linkedInUrl:'',emailValid:false,formValid:false,scale:1});};_this.removeImage=function(){_this.setState({image:null});};_this.onChange=function(e){var files=Array.from(e.target.files);var formData=new FormData();files.forEach(function(file,i){formData.append(i,file);});var reader=new FileReader();var file=e.target.files[0];reader.onloadend=function(){_this.setState({image:reader.result,openEditor:true});};reader.readAsDataURL(file);};_this.handleClose=function(){_this.setState({open:false});};_this.handleEditorClose=function(){_this.setState({openEditor:false});};_this.handleOpenTerms=function(){_this.setState({open:true});};_this.handleAvatarClick=function(){_this.hiddenFileInput.click();};_this.handleCloseProfile=function(){_this.setState({profilePhoto:false,linkedIn:true});};_this.handleAvatarUpload=function(event){_this.setState({isUploadingImage:true});Object(__WEBPACK_IMPORTED_MODULE_14_utils_apiFetch__["c" ])(event.target.files[0],'avatar').then(function(response){_this.setState({isUploadingImage:false});if(response.success){_this.setState({image:response.info.url});}}).catch(function(error){console.error(error);_this.setState({isUploadingImage:false});});};_this.onSubmit=function(event){var setSplashScreen=_this.props.setSplashScreen;var _this$state2=_this.state,term=_this$state2.term,formValid=_this$state2.formValid;if(!term){_this.setState({open:true});}else if(formValid){setSplashScreen(false);_this.showCodeOfHonor();}event.preventDefault();return false;};_this.handleSubmit=function(){var doSignup=_this.props.doSignup;var _this$state3=_this.state,firstName=_this$state3.firstName,lastName=_this$state3.lastName,email=_this$state3.email,password=_this$state3.password,lang=_this$state3.lang,image=_this$state3.image,linkedInUrl=_this$state3.linkedInUrl,invitationCode=_this$state3.invitationCode;_this.setState({isLoadingData:true});doSignup({name:firstName,surname:lastName,email:email,password:password,lang:lang,avatar:image,linkedin:linkedInUrl,invitation:invitationCode}).then(function(){var params={narrativeType:'basic_profile',type:'code_of_honor',name:'accept'};Object(__WEBPACK_IMPORTED_MODULE_17_components_CodeOfHonor_modules_actions__["a" ])(params);__WEBPACK_IMPORTED_MODULE_9_store_history__["a" ].push('/initiatives');}).catch(function(error){_this.setState({isLoadingData:false,errorResponse:error.response.data});});};_this.zoomIn=function(){var scale=_this.state.scale;if(scale===1){scale=-2;}else{scale-=1;}_this.setState({scale:scale});};_this.zoomOut=function(){var scale=_this.state.scale;if(scale===-1){scale=2;}else{scale+=1;}_this.setState({scale:scale});};_this.rotateLeft=function(e){e.preventDefault();var rotate=_this.state.rotate;_this.setState({rotate:rotate+90});};_this.handleSave=function(){var uploadImage=_this.props.uploadImage;var previewAvatar=_this.state.previewAvatar;var img=previewAvatar;_this.setState({image:img,openEditor:false});uploadImage(img,'avatar');};_this.setEditorRef=function(editor){if(editor)_this.editor=editor;};_this.responseSocial=function(){var doSignupSocial=_this.props.doSignupSocial;doSignupSocial();};_this.openLinkedin=function(){var origin=window.location.origin;var tabLogin=window.open(origin+'/system/security/external/oauth.php?oa_ref=3c90c80eb1c2b395af81dd463425731545396064','_blank','width=600,height=480');var watchClose=setInterval(function(){if(tabLogin.closed){clearTimeout(watchClose);var params={t:'oauth_3c90c80eb1c2b395af81dd463425731545396064'};Object(__WEBPACK_IMPORTED_MODULE_14_utils_apiFetch__["a" ])('GET',origin+'/system/security/external/get_login_response.php',params).then(function(response){if(response.success){__WEBPACK_IMPORTED_MODULE_15_redux_react_session__["sessionService"].saveSession({token:response.data.user_code}).then(function(){var _response$data=response.data,id=_response$data.user_id,userCode=_response$data.user_code;__WEBPACK_IMPORTED_MODULE_15_redux_react_session__["sessionService"].saveUser({id:id,user_code:userCode}).then(function(){_this.responseSocial();});});}});}},200);};_this.showProfilePhoto=function(){_this.setState({profilePhoto:true});};_this.handleAcceptCodeOfHonor=function(){_this.showCodeOfHonor(false);_this.showProfilePhoto();};_this.handleChangeUrl=function(event){var value=event.target.value;_this.setState({linkedInUrl:value});};_this.goToLogin=function(){__WEBPACK_IMPORTED_MODULE_9_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_22__constants_urls__["w" ]);};var app=_this.props.app;_this.state={firstName:'',lastName:'',email:'',password:'',linkedInUrl:'',lang:app.lang,term:false,open:false,openEditor:false,previewAvatar:'',emailValid:false,formValid:false,flagCodeOfHonor:false,profilePhoto:false,linkedIn:false,isUploadingImage:false,isLoadingData:false,invitationCode:'',existsUser:false,errorResponse:false};return _this;}_createClass(Signup,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var hash=this.props.match.params.hash;if(hash){this.setState({isLoadingData:true,invitationCode:hash});Object(__WEBPACK_IMPORTED_MODULE_18_modules_users_actions__["d" ])(hash).then(function(response){_this2.setState({isLoadingData:false,firstName:response.firstname,lastName:response.lastname,email:response.email,image:response.avatar,linkedInUrl:response.linkedin,existsUser:response.exists},function(){_this2.validateField('email',response.email);});}).catch(function(error){console.error('error',error);_this2.setState({isLoadingData:false});});}}},{key:'render',value:function render(){var _this3=this;var _props=this.props,literals=_props.literals,location=_props.location,_props$signupData=_props.signupData,success=_props$signupData.success,error=_props$signupData.error,app=_props.app;var _state=this.state,firstName=_state.firstName,lastName=_state.lastName,email=_state.email,password=_state.password,term=_state.term,image=_state.image,open=_state.open,openEditor=_state.openEditor,flagCodeOfHonor=_state.flagCodeOfHonor,profilePhoto=_state.profilePhoto,linkedIn=_state.linkedIn,linkedInUrl=_state.linkedInUrl,isUploadingImage=_state.isUploadingImage,isLoadingData=_state.isLoadingData,existsUser=_state.existsUser,errorResponse=_state.errorResponse;if(isLoadingData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["g" ],{app:app},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_LoadingComponent__["a" ],{colorAnimation:'#ffffff'}));}if(app.id===31368040&&!email){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["g" ],{app:app},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__["a" ],{container:true,spacing:0,className:'Signup__panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__["a" ],{item:true,xs:12,sm:12,md:12,className:'Signup__panel--right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Signup__panel--right__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["e" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.registry),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.registryNotAvailable)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn primary',onClick:this.goToLogin},literals.backToLogin))))));}var content=function content(){if(image&&image!==''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fadein'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this3.removeImage,className:'delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["c" ],{className:'fa fa-times'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'avatar_preview',style:{backgroundImage:'url('+image+')'}}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',ref:_this3.assignHiddenFileInput,onChange:_this3.handleAvatarUpload,style:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this3.handleAvatarClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-user',id:'user'}))));};if(flagCodeOfHonor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'codeOfHonor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CodeOfHonor__["a" ],{onAccept:this.handleAcceptCodeOfHonor}));}if(profilePhoto){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.photoText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),literals.photoPutFace),content(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["b" ],{disabled:isUploadingImage,onClick:this.handleAvatarClick},isUploadingImage?literals.uploadingPhoto:literals.photoAddProfile),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.photoSubtext),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["b" ],{disabled:isUploadingImage,onClick:this.handleCloseProfile},literals.next)));}if(linkedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.handleAvatarClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-linkedin-in',id:'user'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.linkedInText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:literals.linkedInUrl,value:linkedInUrl,onChange:this.handleChangeUrl}),errorResponse?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error_msg'},errorResponse),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["b" ],{onClick:this.goToLogin},literals.backToLogin)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["b" ],{onClick:this.handleSubmit},literals.next)));}if(app.isAuthenticated){if(window.urlToRedirect){var _window=window,urlToRedirect=_window.urlToRedirect;delete window.urlToRedirect;window.location.href=urlToRedirect;return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" ],{to:{pathname:__WEBPACK_IMPORTED_MODULE_22__constants_urls__["u" ],state:location.state}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["g" ],{app:app},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__["a" ],{container:true,spacing:0,className:'Signup__panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__["a" ],{item:true,xs:12,sm:12,md:12,className:'Signup__panel--right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Signup__panel--right__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["e" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.registry),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.enterData),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.yourAffiliation)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Signup__panel--right__content__form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__["ValidatorForm"],{onSubmit:this.onSubmit,autoComplete:'off'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__["TextValidator"],{id:'adornment-email',placeholder:literals.email,type:'text',autoComplete:'email',value:email,name:'email',onChange:this.handleChange('email'),inputProps:{className:'form__field__input'},validators:['required','isEmail'],errorMessages:[literals.error.require,literals.error.email],className:'form__field'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__["TextValidator"],{id:'adornment-password',type:'password',placeholder:literals.password,name:'password',autoComplete:'password',value:password,onChange:this.handleChange('password'),className:'form__field',validators:['required'],errorMessages:[literals.error.require],inputProps:{className:'form__field__input'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__["TextValidator"],{id:'adornment-firstName',type:'text',placeholder:literals.firstName,autoComplete:'given-name',value:firstName,className:'form__field',name:'firstName',onChange:this.handleChange('firstName'),inputProps:{className:'form__field__input'},validators:['required'],errorMessages:[literals.error.require]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__["TextValidator"],{id:'adornment-lastName',placeholder:literals.lastName,type:'text',name:'lastName',className:'form__field',autoComplete:'family-name',value:lastName,onChange:this.handleChange('lastName'),inputProps:{className:'form__field__input'},validators:['required'],errorMessages:[literals.error.require]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Input__["a" ],{id:'adornment-term',type:'checkbox',value:term,onChange:this.handleChange('term'),inputProps:{className:'form__field__checkbox'}}),literals.rule,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link_conditions',onClick:this.handleOpenTerms},literals.rule2)),success!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'state-message state-message--success'}),error!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'state-message state-message--error'},error),existsUser?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error_msg'},''+literals.existUserInvitation):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["b" ],{type:'submit'},literals.next),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["a" ],{to:__WEBPACK_IMPORTED_MODULE_22__constants_urls__["w" ],className:'btn-login'},literals.loginActionBtn)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Signup__panel--right__content__form__social hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_linkedin_svg___default.a,alt:'LinkedIn',onClick:this.openLinkedin})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Dialog__["a" ],{open:open,TransitionComponent:Transition,keepMounted:true,className:'termDialog',onClose:this.handleClose,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle__["a" ],{id:'alert-dialog-slide-title'},literals.termTitle,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.handleClose,className:'delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_DialogContent__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogContentText__["a" ],{id:'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'terms_use',className:'terms_use',src:app.url_policy})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Dialog__["a" ],{open:openEditor,TransitionComponent:Transition,keepMounted:true,className:'avatarEditor',onClose:this.handleClose,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle__["a" ],{id:'alert-dialog-slide-title'},literals.avatar.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.handleEditorClose,className:'delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_DialogContent__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_exif_react_avatar_edit___default.a,{image:image,ref:this.setEditorRef,width:160,height:200,border:0,onCrop:this.onCropAvatar,onClose:this.onCloseAvatar})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editor-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__["a" ],{onClick:this.handleSave},literals.avatar.ok))))));}}]);return Signup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Signup.propTypes={literals:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,signupData:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,location:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,doSignup:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,uploadImage:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,doSignupSocial:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,// setAutoNavigation: PropTypes.func.isRequired,
setSplashScreen:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (Signup);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(63);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(38);
 var __WEBPACK_IMPORTED_MODULE_8__Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_9__Backdrop__ = __webpack_require__(1044);
 var __WEBPACK_IMPORTED_MODULE_10__Fade__ = __webpack_require__(445);
 var __WEBPACK_IMPORTED_MODULE_11__styles_transitions__ = __webpack_require__(131);
 var __WEBPACK_IMPORTED_MODULE_12__Paper__ = __webpack_require__(231);













var styles = function styles(theme) {
  return {
    
    root: {
      '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
      }
    },

    
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden',
      textAlign: 'center',
      '&:after': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0'
      }
    },

    
    container: {
      height: '100%',
      '@media print': {
        height: 'auto'
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },

    
    paper: {
      margin: 32,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE 11 issue, to remove at some point.
      '@media print': {
        overflowY: 'visible',
        boxShadow: 'none'
      }
    },

    
    paperScrollPaper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 64px)'
    },

    
    paperScrollBody: {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left' // 'initial' doesn't work on IE 11

    },

    
    paperWidthFalse: {
      maxWidth: 'calc(100% - 64px)'
    },

    
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" ])({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" ])({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" ])({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" ])({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" ])({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    
    paperFullWidth: {
      width: 'calc(100% - 64px)'
    },

    
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0,
        maxWidth: '100%'
      }
    }
  };
};
var defaultTransitionDuration = {
  enter: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" ].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" ].leavingScreen
};


var Dialog = __WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Dialog(props, ref) {
  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_12__Paper__["a" ] : _props$PaperComponent,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$scroll = props.scroll,
      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_10__Fade__["a" ] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      ariaDescribedby = props['aria-describedby'],
      ariaLabelledby = props['aria-labelledby'],
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);

  var mouseDownTarget = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();

  var handleMouseDown = function handleMouseDown(event) {
    mouseDownTarget.current = event.target;
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    // Ignore the events not coming from the "backdrop"
    // We don't want to close the dialog when clicking the dialog content.
    if (event.target !== event.currentTarget) {
      return;
    } // Make sure the event starts and ends on the same DOM element.


    if (event.target !== mouseDownTarget.current) {
      return;
    }

    mouseDownTarget.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Modal__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.root, className),
    BackdropComponent: __WEBPACK_IMPORTED_MODULE_9__Backdrop__["a" ],
    BackdropProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      transitionDuration: transitionDuration
    }, BackdropProps),
    closeAfterTransition: true,
    disableBackdropClick: disableBackdropClick,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    role: "none presentation"
  }, TransitionProps), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.container, classes["scroll".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" ])(scroll))]),
    onMouseUp: handleBackdropClick,
    onMouseDown: handleMouseDown
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](PaperComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    elevation: 24,
    role: "dialog",
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.paper, classes["paperScroll".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" ])(scroll))], classes["paperWidth".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" ])(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
  }), children))));
});
 false ? Dialog.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  'aria-describedby': PropTypes.string,

  
  'aria-labelledby': PropTypes.string,

  
  BackdropProps: PropTypes.object,

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  disableBackdropClick: PropTypes.bool,

  
  disableEscapeKeyDown: PropTypes.bool,

  
  fullScreen: PropTypes.bool,

  
  fullWidth: PropTypes.bool,

  
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),

  
  onBackdropClick: PropTypes.func,

  
  onClose: PropTypes.func,

  
  onEnter: PropTypes.func,

  
  onEntered: PropTypes.func,

  
  onEntering: PropTypes.func,

  
  onEscapeKeyDown: PropTypes.func,

  
  onExit: PropTypes.func,

  
  onExited: PropTypes.func,

  
  onExiting: PropTypes.func,

  
  open: PropTypes.bool.isRequired,

  
  PaperComponent: PropTypes.elementType,

  
  PaperProps: PropTypes.object,

  
  scroll: PropTypes.oneOf(['body', 'paper']),

  
  TransitionComponent: PropTypes.elementType,

  
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  
  TransitionProps: PropTypes.object
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'MuiDialog'
})(Dialog));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Backdrop__ = __webpack_require__(1045);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Backdrop__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__Fade__ = __webpack_require__(445);







var styles = {
  
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_6__Fade__["a" ] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    in: open,
    timeout: transitionDuration
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
 false ? Backdrop.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  invisible: PropTypes.bool,

  
  open: PropTypes.bool.isRequired,

  
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiBackdrop'
})(Backdrop));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(130);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(167);
 var __WEBPACK_IMPORTED_MODULE_6__styles_transitions__ = __webpack_require__(131);
 var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(84);
 var __WEBPACK_IMPORTED_MODULE_8__transitions_utils__ = __webpack_require__(230);
 var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(46);










var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_6__styles_transitions__["b" ].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_6__styles_transitions__["b" ].leavingScreen
};


var Fade = __WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Fade(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5_react_transition_group__["a" ] : _props$TransitionComp,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" ])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var foreignRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" ])(children.ref, ref);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" ])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" ])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["b" ])(node); // So the animation always start from the start.

    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" ])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" ])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return __WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Fade.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.element,

  
  disableStrictModeCompat: PropTypes.bool,

  
  in: PropTypes.bool,

  
  onEnter: PropTypes.func,

  
  onEntered: PropTypes.func,

  
  onEntering: PropTypes.func,

  
  onExit: PropTypes.func,

  
  onExited: PropTypes.func,

  
  onExiting: PropTypes.func,

  
  style: PropTypes.object,

  
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
 __webpack_exports__["a"] = (Fade);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_4__Typography__ = __webpack_require__(258);





var styles = {
  
  root: {
    marginBottom: 12
  }
};
var DialogContentText = __WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](function DialogContentText(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Typography__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    component: "p",
    variant: "body1",
    color: "textSecondary",
    ref: ref
  }, props));
});
 false ? DialogContentText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__styles_withStyles__["a" ])(styles, {
  name: 'MuiDialogContentText'
})(DialogContentText));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(38);







var styles = function styles(theme) {
  return {
    
    root: {
      margin: 0
    },

    
    body2: theme.typography.body2,

    
    body1: theme.typography.body1,

    
    caption: theme.typography.caption,

    
    button: theme.typography.button,

    
    h1: theme.typography.h1,

    
    h2: theme.typography.h2,

    
    h3: theme.typography.h3,

    
    h4: theme.typography.h4,

    
    h5: theme.typography.h5,

    
    h6: theme.typography.h6,

    
    subtitle1: theme.typography.subtitle1,

    
    subtitle2: theme.typography.subtitle2,

    
    overline: theme.typography.overline,

    
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    
    alignLeft: {
      textAlign: 'left'
    },

    
    alignCenter: {
      textAlign: 'center'
    },

    
    alignRight: {
      textAlign: 'right'
    },

    
    alignJustify: {
      textAlign: 'justify'
    },

    
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    
    gutterBottom: {
      marginBottom: '0.35em'
    },

    
    paragraph: {
      marginBottom: 16
    },

    
    colorInherit: {
      color: 'inherit'
    },

    
    colorPrimary: {
      color: theme.palette.primary.main
    },

    
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    
    colorError: {
      color: theme.palette.error.main
    },

    
    displayInline: {
      display: 'inline'
    },

    
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" ])(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" ])(align))], display !== 'initial' && classes["display".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" ])(display))]),
    ref: ref
  }, other));
});
 false ? Typography.propTypes = {
  
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  
  children: PropTypes.node,

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  
  component: PropTypes
  
  .elementType,

  
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  
  gutterBottom: PropTypes.bool,

  
  noWrap: PropTypes.bool,

  
  paragraph: PropTypes.bool,

  
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),

  
  variantMapping: PropTypes.object
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiTypography'
})(Typography));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(258);







var styles = {
  
  root: {
    margin: 0,
    padding: '16px 24px',
    flex: '0 0 auto'
  }
};
var DialogTitle = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function DialogTitle(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "className", "disableTypography"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className),
    ref: ref
  }, other), disableTypography ? children : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" ], {
    component: "h2",
    variant: "h6"
  }, children));
});
 false ? DialogTitle.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  disableTypography: PropTypes.bool
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiDialogTitle'
})(DialogTitle));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_5__utils_debounce__ = __webpack_require__(164);
 var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(167);
 var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(46);
 var __WEBPACK_IMPORTED_MODULE_9__styles_useTheme__ = __webpack_require__(84);
 var __WEBPACK_IMPORTED_MODULE_10__styles_transitions__ = __webpack_require__(131);
 var __WEBPACK_IMPORTED_MODULE_11__transitions_utils__ = __webpack_require__(230);











 // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `none`.`

function getTranslateValue(direction, node) {
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = window.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}

function setTranslateValue(direction, node) {
  var transform = getTranslateValue(direction, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" ].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" ].leavingScreen
};


var Slide = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Slide(props, ref) {
  var children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'down' : _props$direction,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["a" ] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "direction", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_9__styles_useTheme__["a" ])();
  var childrenRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    childrenRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRefIntermediary = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" ])(children.ref, handleOwnRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" ])(handleRefIntermediary, ref);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (isAppearing) {
      if (callback) {
        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
        if (isAppearing === undefined) {
          callback(childrenRef.current);
        } else {
          callback(childrenRef.current, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    setTranslateValue(direction, node);
    Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["b" ])(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["a" ])({
      timeout: timeout,
      style: style
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.transition = theme.transitions.create('transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["a" ])({
      timeout: timeout,
      style: style
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    node.style.transition = theme.transitions.create('transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    setTranslateValue(direction, node);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(function (node) {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  });
  var updatePosition = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current);
    }
  }, [direction]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_5__utils_debounce__["a" ])(function () {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    appear: true,
    in: inProp,
    timeout: timeout
  }, other), function (state, childProps) {
    return __WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      ref: handleRef,
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, style, children.props.style)
    }, childProps));
  });
});
 false ? Slide.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: elementAcceptingRef,

  
  direction: PropTypes.oneOf(['down', 'left', 'right', 'up']),

  
  in: PropTypes.bool,

  
  onEnter: PropTypes.func,

  
  onEntered: PropTypes.func,

  
  onEntering: PropTypes.func,

  
  onExit: PropTypes.func,

  
  onExited: PropTypes.func,

  
  onExiting: PropTypes.func,

  
  style: PropTypes.object,

  
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
 __webpack_exports__["a"] = (Slide);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1052);
function mapStateToProps(state){return{literals:state.i18n.literals.codeofhonor||{}};}function mapDispatchToProps(dispatch){return{showLoading:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(115);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__ = __webpack_require__(93);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_fingerprint_svg__ = __webpack_require__(1053);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_fingerprint_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_fingerprint_svg__);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_fdrpLogo_png__ = __webpack_require__(1054);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_fdrpLogo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_fdrpLogo_png__);
 var __WEBPACK_IMPORTED_MODULE_6__modules_actions__ = __webpack_require__(260);
 var __WEBPACK_IMPORTED_MODULE_7__styles_css__ = __webpack_require__(1055);
 var __WEBPACK_IMPORTED_MODULE_7__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_css__);
 var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1056);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CodeOfHonor=function(_Component){_inherits(CodeOfHonor,_Component);function CodeOfHonor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CodeOfHonor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CodeOfHonor.__proto__||Object.getPrototypeOf(CodeOfHonor)).call.apply(_ref,[this].concat(args))),_this),_this.handleCodeOfHonor=function(){var onAccept=_this.props.onAccept;onAccept();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CodeOfHonor,[{key:'render',value:function render(){var literals=this.props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__["a" ],{container:true,spacing:0,className:'CodeOfHonor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__["a" ],{item:true,xs:12,className:'CodeOfHonorContent',style:{justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'CodeOfHonor__title'},literals.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CodeOfHonor__description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.p1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.p2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CodeOfHonor__action'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_assets_images_fingerprint_svg___default.a,alt:'fingerprint',className:'CodeOfHonor__action__img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],{onClick:this.handleCodeOfHonor},literals.actionBtn)))));}}]);return CodeOfHonor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CodeOfHonor.displayName='CodeOfHonor';CodeOfHonor.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAccept:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,showLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (CodeOfHonor);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fingerprint.dd6bb962.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fdrpLogo.0a9076ba.png";

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonCommit; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.3rem;\n  width: 20rem;\n  padding: 1.2rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: #2680EB;\n  margin-bottom: 2rem;\n'],['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.3rem;\n  width: 20rem;\n  padding: 1.2rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: #2680EB;\n  margin-bottom: 2rem;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ButtonCommit=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "g", function() { return SignupWrapper; });

 __webpack_require__.d(__webpack_exports__, "c", function() { return Delete; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarOverflow; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonLogin; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return PrevInfo; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return ProfilePhotoWrapper; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return LinkedInWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 20px 0px;\n    background-color: white;\n  @media(min-width: ','px) {\n    background-color: #2680EB;\n  }\n  input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px ',' inset !important;\n    -webkit-text-fill-color: white;\n  }\n\n  .link_conditions {\n    text-decoration: underline;\n  }\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  padding: 20px 0px;\n    background-color: white;\n  @media(min-width: ','px) {\n    background-color: #2680EB;\n  }\n  input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px ',' inset !important;\n    -webkit-text-fill-color: white;\n  }\n\n  .link_conditions {\n    text-decoration: underline;\n  }\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n  font-size: 24px;\n'],['\n  font-size: 24px;\n']),_templateObject3=_taggedTemplateLiteral(['\n  font-size: 14px;\n  padding: 3px 5px;\n'],['\n  font-size: 14px;\n  padding: 3px 5px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  overflow: hidden;\n'],['\n  overflow: hidden;\n']),_templateObject5=_taggedTemplateLiteral(['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.3rem;\n  width: 15rem;\n  padding: 1.2rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: #2680EB;\n  margin-bottom: 2rem;\n'],['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.3rem;\n  width: 15rem;\n  padding: 1.2rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: #2680EB;\n  margin-bottom: 2rem;\n']),_templateObject6=_taggedTemplateLiteral(['\n  font-size: 1.4rem;\n  margin-bottom: 3rem;\n  .text {\n    margin: 1rem;\n  }\n  .title {\n    font-size: 1.8rem;\n    font-weight: bold;\n    margin: 1rem;\n    margin-bottom: 3rem;\n  }\n'],['\n  font-size: 1.4rem;\n  margin-bottom: 3rem;\n  .text {\n    margin: 1rem;\n  }\n  .title {\n    font-size: 1.8rem;\n    font-weight: bold;\n    margin: 1rem;\n    margin-bottom: 3rem;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  height: 100%;\n  background: white;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .content {\n    width: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    @media(min-width: ','px) {\n      max-width: 50%;\n      min-height: 50%;\n      margin: 0 auto;\n      background: white;\n      padding: 3rem;\n      border-radius: 2rem;\n      box-shadow: 0px 3px 6px 1px lightgray;\n    }\n  }\n\n  .button {\n    height: 15rem;\n    width: 15rem;\n    color: white;\n    background: #2680EB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 7rem;\n  }\n  #user {\n    font-size: 9rem;\n  }\n  p {\n    font-size: 1.3rem;\n    margin: 3rem 0rem;\n  }\n  .fadein .avatar_preview {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 15rem;\n    width: 15rem;\n    border-radius: 7rem;\n    background-size: cover;\n    background-position: 50%;\n    background-repeat: no-repeat;\n  }\n'],['\n  height: 100%;\n  background: white;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .content {\n    width: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    @media(min-width: ','px) {\n      max-width: 50%;\n      min-height: 50%;\n      margin: 0 auto;\n      background: white;\n      padding: 3rem;\n      border-radius: 2rem;\n      box-shadow: 0px 3px 6px 1px lightgray;\n    }\n  }\n\n  .button {\n    height: 15rem;\n    width: 15rem;\n    color: white;\n    background: #2680EB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 7rem;\n  }\n  #user {\n    font-size: 9rem;\n  }\n  p {\n    font-size: 1.3rem;\n    margin: 3rem 0rem;\n  }\n  .fadein .avatar_preview {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 15rem;\n    width: 15rem;\n    border-radius: 7rem;\n    background-size: cover;\n    background-position: 50%;\n    background-repeat: no-repeat;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  height: 100%;\n  background: white;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .content {\n    @media(min-width: ','px) {\n      max-width: 50%;\n      min-height: 50%;\n      margin: 0 auto;\n      background: white;\n      padding: 3rem;\n      border-radius: 2rem;\n      box-shadow: 0px 3px 6px 1px lightgray;\n    }\n    width: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n\n  .button {\n    height: 15rem;\n    width: 15rem;\n    color: white;\n    background: #2680EB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 7rem;\n  }\n  #user {\n    font-size: 9rem;\n  }\n  p {\n    font-size: 1.3rem;\n    margin: 3rem 0rem;\n  }\n  input {\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    width: 30rem;\n    height: 5rem;\n    border-radius: 1rem;\n    border: none;\n    font-size: 1.1rem;\n    padding: 2rem;\n    outline: none;\n  }\n'],['\n  height: 100%;\n  background: white;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .content {\n    @media(min-width: ','px) {\n      max-width: 50%;\n      min-height: 50%;\n      margin: 0 auto;\n      background: white;\n      padding: 3rem;\n      border-radius: 2rem;\n      box-shadow: 0px 3px 6px 1px lightgray;\n    }\n    width: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n\n  .button {\n    height: 15rem;\n    width: 15rem;\n    color: white;\n    background: #2680EB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 7rem;\n  }\n  #user {\n    font-size: 9rem;\n  }\n  p {\n    font-size: 1.3rem;\n    margin: 3rem 0rem;\n  }\n  input {\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    width: 30rem;\n    height: 5rem;\n    border-radius: 1rem;\n    border: none;\n    font-size: 1.1rem;\n    padding: 2rem;\n    outline: none;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SignupWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.app.color1;});var Camera=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject2);var Delete=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject3);var AvatarOverflow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var ButtonLogin=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject5);var PrevInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var ProfilePhotoWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var LinkedInWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1060);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1061);
 var __WEBPACK_IMPORTED_MODULE_6__MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_7__modules_signup__ = __webpack_require__(1064);
function mapStateToProps(state){return{literals:state.i18n.literals.signup,signupData:state.signup,userLang:state.i18n.language,app:state.app};}function mapDispatchToProps(dispatch){return{showLoading:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ],dispatch),doSignup:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7__modules_signup__["a" ],dispatch),uploadImage:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7__modules_signup__["c" ],dispatch),doSignupSocial:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7__modules_signup__["b" ],dispatch),setAutoNavigation:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6__MainPage_modules_mainPage__["b" ],dispatch),setSplashScreen:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_app__["d" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Dialog__ = __webpack_require__(256);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_DialogContent__ = __webpack_require__(172);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogContentText__ = __webpack_require__(257);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle__ = __webpack_require__(259);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Slide__ = __webpack_require__(446);
 var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__ = __webpack_require__(115);
 var __WEBPACK_IMPORTED_MODULE_9_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__ = __webpack_require__(93);
 var __WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__ = __webpack_require__(253);
 var __WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__);
 var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Input__ = __webpack_require__(112);
 var __WEBPACK_IMPORTED_MODULE_13_exif_react_avatar_edit__ = __webpack_require__(447);
 var __WEBPACK_IMPORTED_MODULE_13_exif_react_avatar_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_exif_react_avatar_edit__);
 var __WEBPACK_IMPORTED_MODULE_14_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_15_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_15_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_16_components_CodeOfHonor__ = __webpack_require__(448);
 var __WEBPACK_IMPORTED_MODULE_17_components_CodeOfHonor_modules_actions__ = __webpack_require__(260);
 var __WEBPACK_IMPORTED_MODULE_18__assets_images_linkedin_svg__ = __webpack_require__(255);
 var __WEBPACK_IMPORTED_MODULE_18__assets_images_linkedin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_linkedin_svg__);
 var __WEBPACK_IMPORTED_MODULE_19__constants_patterns__ = __webpack_require__(449);
 var __WEBPACK_IMPORTED_MODULE_20__constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_21__styles__ = __webpack_require__(1062);
 var __WEBPACK_IMPORTED_MODULE_22__styles_css__ = __webpack_require__(1063);
 var __WEBPACK_IMPORTED_MODULE_22__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import history from 'store/history';
function Transition(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Slide__["a" ],Object.assign({direction:'down'},props));}var Signup=function(_Component){_inherits(Signup,_Component);function Signup(props){_classCallCheck(this,Signup);var _this=_possibleConstructorReturn(this,(Signup.__proto__||Object.getPrototypeOf(Signup)).call(this,props));_this.showCodeOfHonor=function(){var flag=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;_this.setState({flagCodeOfHonor:flag});};_this.onCloseAvatar=function(){_this.setState({previewAvatar:null});};_this.onCropAvatar=function(previewAvatar){_this.setState({previewAvatar:previewAvatar});};_this.showAvatarEditor=function(){_this.setState({openEditor:true});};_this.assignHiddenFileInput=function(ref){_this.hiddenFileInput=ref;};_this.handleChange=function(name){return function(event){var value=event.target.value;if(name==='term'){value=event.target.checked;}_this.setState(_defineProperty({},name,value),function(){_this.validateField(name,value);});};};_this.validateField=function(fieldName,value){var emailValid=_this.state.emailValid;switch(fieldName){case'email':emailValid=value.match(__WEBPACK_IMPORTED_MODULE_19__constants_patterns__["a" ]);break;default:break;}_this.setState({emailValid:emailValid},_this.validateForm);};_this.validateForm=function(){var _this$state=_this.state,firstName=_this$state.firstName,lastName=_this$state.lastName,emailValid=_this$state.emailValid;return _this.setState({formValid:firstName!==''&&lastName!==''&&emailValid});};_this.clearForm=function(){_this.setState({firstName:'',lastName:'',email:'',linkedInUrl:'',emailValid:false,formValid:false,scale:1});};_this.removeImage=function(){_this.setState({image:null});};_this.onChange=function(e){var files=Array.from(e.target.files);var formData=new FormData();files.forEach(function(file,i){formData.append(i,file);});var reader=new FileReader();var file=e.target.files[0];reader.onloadend=function(){_this.setState({image:reader.result,openEditor:true});};reader.readAsDataURL(file);};_this.handleClose=function(){_this.setState({open:false});};_this.handleEditorClose=function(){_this.setState({openEditor:false});};_this.handleOpenTerms=function(){_this.setState({open:true});};_this.handleAvatarClick=function(){_this.hiddenFileInput.click();};_this.handleCloseProfile=function(){_this.setState({profilePhoto:false,linkedIn:true});};_this.handleAvatarUpload=function(event){Object(__WEBPACK_IMPORTED_MODULE_14_utils_apiFetch__["c" ])(event.target.files[0],'avatar').then(function(response){if(response.success){_this.setState({image:response.info.url});}});};_this.onSubmit=function(event){var setSplashScreen=_this.props.setSplashScreen;var _this$state2=_this.state,term=_this$state2.term,formValid=_this$state2.formValid;if(!term){_this.setState({open:true});}else if(formValid){setSplashScreen(false);_this.showCodeOfHonor();}event.preventDefault();return false;};_this.handleSubmit=function(){var _this$props=_this.props,doSignup=_this$props.doSignup,showLoading=_this$props.showLoading;var _this$state3=_this.state,firstName=_this$state3.firstName,lastName=_this$state3.lastName,email=_this$state3.email,password=_this$state3.password,lang=_this$state3.lang,image=_this$state3.image,linkedInUrl=_this$state3.linkedInUrl;doSignup({name:firstName,surname:lastName,email:email,password:password,lang:lang,image:image,linkedInUrl:linkedInUrl}).then(function(){var params={narrativeType:'basic_profile',type:'code_of_honor',name:'accept'};Object(__WEBPACK_IMPORTED_MODULE_17_components_CodeOfHonor_modules_actions__["a" ])(params);__WEBPACK_IMPORTED_MODULE_9_store_history__["a" ].push('/initiatives');});};_this.zoomIn=function(){var scale=_this.state.scale;if(scale===1){scale=-2;}else{scale-=1;}_this.setState({scale:scale});};_this.zoomOut=function(){var scale=_this.state.scale;if(scale===-1){scale=2;}else{scale+=1;}_this.setState({scale:scale});};_this.rotateLeft=function(e){e.preventDefault();var rotate=_this.state.rotate;_this.setState({rotate:rotate+90});};_this.handleSave=function(){var uploadImage=_this.props.uploadImage;var previewAvatar=_this.state.previewAvatar;var img=previewAvatar;_this.setState({image:img,openEditor:false});uploadImage(img,'avatar');};_this.setEditorRef=function(editor){if(editor)_this.editor=editor;};_this.responseSocial=function(){var doSignupSocial=_this.props.doSignupSocial;doSignupSocial();};_this.openLinkedin=function(){var origin=window.location.origin;var tabLogin=window.open(origin+'/system/security/external/oauth.php?oa_ref=3c90c80eb1c2b395af81dd463425731545396064','_blank','width=600,height=480');var watchClose=setInterval(function(){if(tabLogin.closed){clearTimeout(watchClose);var params={t:'oauth_3c90c80eb1c2b395af81dd463425731545396064'};Object(__WEBPACK_IMPORTED_MODULE_14_utils_apiFetch__["a" ])('GET',origin+'/system/security/external/get_login_response.php',params).then(function(response){if(response.success){__WEBPACK_IMPORTED_MODULE_15_redux_react_session__["sessionService"].saveSession({token:response.data.user_code}).then(function(){var _response$data=response.data,id=_response$data.user_id,userCode=_response$data.user_code;__WEBPACK_IMPORTED_MODULE_15_redux_react_session__["sessionService"].saveUser({id:id,user_code:userCode}).then(function(){_this.responseSocial();});});}});}},200);};_this.showProfilePhoto=function(){_this.setState({profilePhoto:true});};_this.handleAcceptCodeOfHonor=function(){_this.showCodeOfHonor(false);_this.showProfilePhoto();};_this.handleChangeUrl=function(event){var value=event.target.value;_this.setState({linkedInUrl:value});};var app=_this.props.app;_this.state={firstName:'',lastName:'',email:'',password:'',linkedInUrl:'',lang:app.lang,term:false,open:false,openEditor:false,previewAvatar:'',emailValid:false,formValid:false,flagCodeOfHonor:false,profilePhoto:false,linkedIn:false};return _this;}_createClass(Signup,[{key:'render',value:function render(){var _this2=this;var _props=this.props,literals=_props.literals,location=_props.location,_props$signupData=_props.signupData,success=_props$signupData.success,error=_props$signupData.error,app=_props.app;var _state=this.state,firstName=_state.firstName,lastName=_state.lastName,email=_state.email,password=_state.password,term=_state.term,image=_state.image,open=_state.open,openEditor=_state.openEditor,flagCodeOfHonor=_state.flagCodeOfHonor,profilePhoto=_state.profilePhoto,linkedIn=_state.linkedIn,linkedInUrl=_state.linkedInUrl;var content=function content(){if(image&&image!==''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fadein'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(){return _this2.removeImage();},className:'delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styles__["c" ],{className:'fa fa-times'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image,alt:literals.image}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',ref:_this2.assignHiddenFileInput,onChange:_this2.handleAvatarUpload,style:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this2.handleAvatarClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-user',id:'user'}))));};if(flagCodeOfHonor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'codeOfHonor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CodeOfHonor__["a" ],{onAccept:this.handleAcceptCodeOfHonor}));}if(profilePhoto){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.photoText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),literals.photoPutFace),content(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styles__["b" ],{onClick:this.handleAvatarClick},literals.photoAddProfile),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.photoSubtext),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styles__["b" ],{onClick:this.handleCloseProfile},literals.next)));}if(linkedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.handleAvatarClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-linkedin-in',id:'user'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.linkedInText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:literals.linkedInUrl,value:linkedInUrl,onChange:this.handleChangeUrl}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styles__["b" ],{onClick:this.handleSubmit},literals.next)));}if(app.isAuthenticated){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" ],{to:{pathname:__WEBPACK_IMPORTED_MODULE_20__constants_urls__["u" ],state:location.state}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styles__["g" ],{app:app},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__["a" ],{container:true,spacing:0,className:'Signup__panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__["a" ],{item:true,xs:12,sm:12,md:12,className:'Signup__panel--right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Signup__panel--right__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styles__["e" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.registry),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.enterData),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.yourAffiliation)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Signup__panel--right__content__form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__["ValidatorForm"],{onSubmit:this.onSubmit,autoComplete:'off'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__["TextValidator"],{id:'adornment-email',placeholder:literals.email,type:'text',autoComplete:'email',value:email,name:'email',onChange:this.handleChange('email'),inputProps:{className:'form__field__input'},validators:['required','isEmail'],errorMessages:[literals.error.require,literals.error.email],className:'form__field'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__["TextValidator"],{id:'adornment-password',type:'password',placeholder:literals.password,name:'password',autoComplete:'password',value:password,onChange:this.handleChange('password'),className:'form__field',validators:['required'],errorMessages:[literals.error.require],inputProps:{className:'form__field__input'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__["TextValidator"],{id:'adornment-firstName',type:'text',placeholder:literals.firstName,autoComplete:'given-name',value:firstName,className:'form__field',name:'firstName',onChange:this.handleChange('firstName'),inputProps:{className:'form__field__input'},validators:['required'],errorMessages:[literals.error.require]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_material_ui_form_validator__["TextValidator"],{id:'adornment-lastName',placeholder:literals.lastName,type:'text',name:'lastName',className:'form__field',autoComplete:'family-name',value:lastName,onChange:this.handleChange('lastName'),inputProps:{className:'form__field__input'},validators:['required'],errorMessages:[literals.error.require]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Input__["a" ],{id:'adornment-term',type:'checkbox',value:term,onChange:this.handleChange('term'),inputProps:{className:'form__field__checkbox'}}),literals.rule,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link_conditions',onClick:this.handleOpenTerms},literals.rule2)),success!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'state-message state-message--success'}),error!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'state-message state-message--error'},error),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styles__["b" ],{type:'submit'},literals.next),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["a" ],{to:__WEBPACK_IMPORTED_MODULE_20__constants_urls__["w" ],className:'btn-login'},literals.loginActionBtn)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Signup__panel--right__content__form__social hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_18__assets_images_linkedin_svg___default.a,alt:'LinkedIn',onClick:this.openLinkedin})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Dialog__["a" ],{open:open,TransitionComponent:Transition,keepMounted:true,className:'termDialog',onClose:this.handleClose,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle__["a" ],{id:'alert-dialog-slide-title'},literals.termTitle,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.handleClose,className:'delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_DialogContent__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogContentText__["a" ],{id:'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'terms_use',className:'terms_use',src:app.url_policy})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Dialog__["a" ],{open:openEditor,TransitionComponent:Transition,keepMounted:true,className:'avatarEditor',onClose:this.handleClose,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle__["a" ],{id:'alert-dialog-slide-title'},literals.avatar.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.handleEditorClose,className:'delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_DialogContent__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_exif_react_avatar_edit___default.a,{image:image,ref:this.setEditorRef,width:160,height:200,border:0,onCrop:this.onCropAvatar,onClose:this.onCloseAvatar})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editor-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__["a" ],{onClick:this.handleSave},literals.avatar.ok))))));}}]);return Signup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Signup.propTypes={literals:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,signupData:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,location:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,doSignup:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,uploadImage:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,doSignupSocial:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,// setAutoNavigation: PropTypes.func.isRequired,
setSplashScreen:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (Signup);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "g", function() { return SignupWrapper; });

 __webpack_require__.d(__webpack_exports__, "c", function() { return Delete; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarOverflow; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonLogin; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return PrevInfo; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return ProfilePhotoWrapper; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return LinkedInWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 20px 0px;\n    background-color: white;\n  @media(min-width: ','px) {\n    background-color: #2680EB;\n  }\n  input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px ',' inset !important;\n    -webkit-text-fill-color: white;    \n  }\n\n  .link_conditions {\n    text-decoration: underline;\n  }\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  padding: 20px 0px;\n    background-color: white;\n  @media(min-width: ','px) {\n    background-color: #2680EB;\n  }\n  input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px ',' inset !important;\n    -webkit-text-fill-color: white;    \n  }\n\n  .link_conditions {\n    text-decoration: underline;\n  }\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n  font-size: 24px;\n'],['\n  font-size: 24px;\n']),_templateObject3=_taggedTemplateLiteral(['\n  font-size: 14px;\n  padding: 3px 5px;\n'],['\n  font-size: 14px;\n  padding: 3px 5px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  overflow: hidden;\n'],['\n  overflow: hidden;\n']),_templateObject5=_taggedTemplateLiteral(['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.3rem;\n  width: 15rem;\n  padding: 1.2rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: #2680EB;\n  margin-bottom: 2rem;\n'],['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.3rem;\n  width: 15rem;\n  padding: 1.2rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: #2680EB;\n  margin-bottom: 2rem;\n']),_templateObject6=_taggedTemplateLiteral(['\n  font-size: 1.4rem;\n  margin-bottom: 3rem;\n  .text {\n    margin: 1rem;\n  }\n  .title {\n    font-size: 1.8rem;\n    font-weight: bold;\n    margin: 1rem;\n    margin-bottom: 3rem;\n  }\n'],['\n  font-size: 1.4rem;\n  margin-bottom: 3rem;\n  .text {\n    margin: 1rem;\n  }\n  .title {\n    font-size: 1.8rem;\n    font-weight: bold;\n    margin: 1rem;\n    margin-bottom: 3rem;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  height: 100%;\n  background: white;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .content {\n    width: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    @media(min-width: ','px) {\n      max-width: 50%;\n      height: 50%;\n      margin: 0 auto;\n      background: white;\n      padding: 3rem;\n      border-radius: 2rem;\n      box-shadow: 0px 3px 6px 1px lightgray;\n    }\n  }\n\n  .button {\n    height: 15rem;\n    width: 15rem; \n    color: white;\n    background: #2680EB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 7rem;\n  }\n  #user {\n    font-size: 9rem;\n  }\n  p {\n    font-size: 1.3rem;\n    margin: 3rem 0rem;\n  }\n  .fadein img {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 15rem;\n    width: 15rem;\n    border-radius: 7rem; \n  }\n'],['\n  height: 100%;\n  background: white;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .content {\n    width: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    @media(min-width: ','px) {\n      max-width: 50%;\n      height: 50%;\n      margin: 0 auto;\n      background: white;\n      padding: 3rem;\n      border-radius: 2rem;\n      box-shadow: 0px 3px 6px 1px lightgray;\n    }\n  }\n\n  .button {\n    height: 15rem;\n    width: 15rem; \n    color: white;\n    background: #2680EB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 7rem;\n  }\n  #user {\n    font-size: 9rem;\n  }\n  p {\n    font-size: 1.3rem;\n    margin: 3rem 0rem;\n  }\n  .fadein img {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 15rem;\n    width: 15rem;\n    border-radius: 7rem; \n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  height: 100%;\n  background: white;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .content {\n    @media(min-width: ','px) {\n      max-width: 50%;\n      height: 50%;\n      margin: 0 auto;\n      background: white;\n      padding: 3rem;\n      border-radius: 2rem;\n      box-shadow: 0px 3px 6px 1px lightgray;\n    }\n    width: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n\n  .button {\n    height: 15rem;\n    width: 15rem; \n    color: white;\n    background: #2680EB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 7rem;\n  }\n  #user {\n    font-size: 9rem;\n  }\n  p {\n    font-size: 1.3rem;\n    margin: 3rem 0rem;\n  }\n  input {\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    width: 30rem;\n    height: 5rem;\n    border-radius: 1rem;\n    border: none;\n    font-size: 1.1rem;\n    padding: 2rem;\n    outline: none;\n  }\n'],['\n  height: 100%;\n  background: white;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .content {\n    @media(min-width: ','px) {\n      max-width: 50%;\n      height: 50%;\n      margin: 0 auto;\n      background: white;\n      padding: 3rem;\n      border-radius: 2rem;\n      box-shadow: 0px 3px 6px 1px lightgray;\n    }\n    width: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n\n  .button {\n    height: 15rem;\n    width: 15rem; \n    color: white;\n    background: #2680EB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 7rem;\n  }\n  #user {\n    font-size: 9rem;\n  }\n  p {\n    font-size: 1.3rem;\n    margin: 3rem 0rem;\n  }\n  input {\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    width: 30rem;\n    height: 5rem;\n    border-radius: 1rem;\n    border: none;\n    font-size: 1.1rem;\n    padding: 2rem;\n    outline: none;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SignupWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.app.color1;});var Camera=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject2);var Delete=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject3);var AvatarOverflow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var ButtonLogin=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject5);var PrevInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var ProfilePhotoWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var LinkedInWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return doSignup; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return doSignupSocial; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return uploadImage; });
 var __WEBPACK_IMPORTED_MODULE_0_store_create_reducer__ = __webpack_require__(52);
 var __WEBPACK_IMPORTED_MODULE_1_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_1_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(1065);
var _ACTION_HANDLERS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INITIAL_STATE={avatar:'',error:false,success:false};var doSignup=function doSignup(_ref){var name=_ref.name,surname=_ref.surname,email=_ref.email,password=_ref.password,lang=_ref.lang;return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));var data={name:name,surname:surname,email:email,password:password,instanceCode:getState().app.code,avatar:getState().signup.avatar,lang:lang};return Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'users'},data).then(function(response){__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].saveSession({token:response.user_code}).then(function(){var user=Object.assign({},response);user.instance=getState().app.id;__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].saveUser(user).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_modules_app__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["c" ],success:true});window.sendUserIdentifier(user.id);});});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["b" ],error:error.response.data});});};};var doSignupSocial=function doSignupSocial(){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));var data={instanceCode:getState().app.code};return Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'users/signup/social'},data).then(function(response){__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].saveSession({token:response.user_code}).then(function(){var user=Object.assign({},response);user.instance=getState().app.id;__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].saveUser(user).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_modules_app__["c" ])(true));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["c" ],success:true});});});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["b" ],error:error.response.data});});};};var uploadImage=function uploadImage(data,name){return function(dispatch){var params={data:data,name:name};dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true));Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'upload-file'},params).then(function(response){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["a" ],avatar:response.url});}).catch(function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false));dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["b" ],error:error.response.data});});};};var ACTION_HANDLERS=(_ACTION_HANDLERS={},_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_5__types__["a" ],function(state,_ref2){var avatar=_ref2.avatar;return Object.assign({},state,{avatar:avatar});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_5__types__["b" ],function(state,_ref3){var error=_ref3.error;return Object.assign({},state,{error:error});}),_defineProperty(_ACTION_HANDLERS,__WEBPACK_IMPORTED_MODULE_5__types__["c" ],function(state,_ref4){var success=_ref4.success;return Object.assign({},state,{success:success});}),_ACTION_HANDLERS); var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0_store_create_reducer__["a" ])(INITIAL_STATE,ACTION_HANDLERS));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return SET_AVATAR; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ERROR; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SUCCESS; });

var SET_AVATAR='SET_AVATAR';var SET_ERROR='SET_ERROR';var SET_SUCCESS='SET_SUCCESS';var FETCH_SIGNUP='FETCH_SIGNUP';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1067);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_6_routes_MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(1068);
 var __WEBPACK_IMPORTED_MODULE_8__Signup_modules_signup__ = __webpack_require__(157);
 var __WEBPACK_IMPORTED_MODULE_9__modules_actions__ = __webpack_require__(92);
function mapStateToProps(state){return{literals:state.i18n.literals.profile,newAvatar:state.signup.avatar||'',userLang:state.i18n.language,app:state.app,eraseAccountStatus:state.profile.eraseAccountStatus,eraseAccountError:state.profile.eraseAccountError,userElements:state.elements.selectedElements,userThemeTables:state.thinkChats.myThinkChatsList.concat(state.thinkTanks.myThinkTanksList),userCallsForImpact:state.narratives.myCallsForImpact};}function mapDispatchToProps(dispatch){return{showLoading:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ],dispatch),uploadImage:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_8__Signup_modules_signup__["d" ],dispatch),updateProfile:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_9__modules_actions__["f" ],dispatch),setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_components_Navbar_modules__["b" ],dispatch),resetContext:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["e" ],dispatch),goHome:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["e" ],dispatch),getNarrative:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["a" ],dispatch),setAutoNavigation:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_routes_MainPage_modules_mainPage__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch),deleteAccount:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_9__modules_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_7__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_3_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_3_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_4_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_5_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_7_constants_profile__ = __webpack_require__(450);
 var __WEBPACK_IMPORTED_MODULE_8_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
 var __WEBPACK_IMPORTED_MODULE_10_modules_users_actions__ = __webpack_require__(85);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_think_no_think_chats_svg__ = __webpack_require__(91);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_think_no_think_chats_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_images_think_no_think_chats_svg__);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_icons_impact_event_svg__ = __webpack_require__(1069);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_icons_impact_event_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_images_icons_impact_event_svg__);
 var __WEBPACK_IMPORTED_MODULE_13_assets_images_icons_table_gray_svg__ = __webpack_require__(1070);
 var __WEBPACK_IMPORTED_MODULE_13_assets_images_icons_table_gray_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_assets_images_icons_table_gray_svg__);
 var __WEBPACK_IMPORTED_MODULE_14_assets_images_user_erase_svg__ = __webpack_require__(1071);
 var __WEBPACK_IMPORTED_MODULE_14_assets_images_user_erase_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_assets_images_user_erase_svg__);
 var __WEBPACK_IMPORTED_MODULE_15__modules_actions__ = __webpack_require__(92);
 var __WEBPACK_IMPORTED_MODULE_16__styles__ = __webpack_require__(451);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Profile=function(_Component){_inherits(Profile,_Component);function Profile(props){_classCallCheck(this,Profile);var _this=_possibleConstructorReturn(this,(Profile.__proto__||Object.getPrototypeOf(Profile)).call(this,props));_this.setBreadcrumbProfile=function(){var _this$props=_this.props,literals=_this$props.literals,setBreadcrumb=_this$props.setBreadcrumb,resetContext=_this$props.resetContext;var breadcrumb=[{color:'#ffffff',text:literals.subtitle1}];setBreadcrumb(breadcrumb.slice());resetContext();};_this.goToGpdr=function(){_this.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_7_constants_profile__["c" ],erasePop:false});};_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_5_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_8_constants_urls__["x" ]);};_this.collapseInfo=function(){var collapsed=_this.state.collapsed;if(collapsed){_this.setState({collapsed:false});}else{_this.setState({collapsed:true});}};_this.whichHeader=function(){var literals=_this.props.literals;var _this$state=_this.state,data=_this$state.data,collapsed=_this$state.collapsed;if(collapsed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overview_empty',onClick:_this.collapseInfo},literals.viewPurpose);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overview'},data.overview,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overview-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-minus-circle close',onClick:_this.collapseInfo})));};_this.goToEditProfile=function(){__WEBPACK_IMPORTED_MODULE_5_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_8_constants_urls__["l" ]);};_this.printHeader=function(){var _this$state2=_this.state,data=_this$state2.data,tabSelected=_this$state2.tabSelected;var id=data.id,firstname=data.firstname,lastname=data.lastname,avatar=data.avatar,overview=data.overview;var literals=_this.props.literals;if(tabSelected!==__WEBPACK_IMPORTED_MODULE_7_constants_profile__["b" ]&&tabSelected!==__WEBPACK_IMPORTED_MODULE_7_constants_profile__["c" ]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'username'},firstname+' '+lastname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Avatar__["a" ],{id:id,firstname:firstname,avatar:avatar,size:84}),overview?_this.whichHeader():null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:_this.goToEditProfile},literals.editProfile))));}return null;};_this.printResumeTab=function(){var _this$props2=_this.props,literals=_this$props2.literals,userElements=_this$props2.userElements,userThemeTables=_this$props2.userThemeTables;var data=_this.state.data;var elementsRows=[];var elementTypesData={};var elementTypes=[];__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.forEach(userElements,function(element){if(typeof elementTypesData[element.type]==='undefined'){elementTypesData[element.type]={name:element.type_name,elements:[]};elementTypesData[element.type].elements.push(element);}});__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.forEach(elementTypesData,function(elementType){elementTypes.push(elementType);});elementTypes.sort(function(a,b){return a.name<b.name?-1:1;});__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.forEach(elementTypes,function(elementType){elementsRows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},elementType.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection_content'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(elementType.elements,function(_ref){var id=_ref.id,name=_ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray selected'},name);}))));});if(!data.calls_for_impact.length&&!data.theme_tables.length&&!elementsRows.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["l" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nocontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_assets_images_think_no_think_chats_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noContentSub)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,data.calls_for_impact.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12_assets_images_icons_impact_event_svg___default.a,alt:''}),literals.callForImpact),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection_content'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(data.calls_for_impact,function(_ref2){var id=_ref2.id,name=_ref2.name,image=_ref2.image;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray selected'},image?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image',style:{backgroundImage:'url('+image+')'}}):null,name);}))):null,data.theme_tables.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13_assets_images_icons_table_gray_svg___default.a,alt:''}),literals.otherPI),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection_content'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(data.theme_tables,function(_ref3){var id=_ref3.id,name=_ref3.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray '+(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(userThemeTables,{id:id})?'selected':'')},name);}))):null,elementsRows);};_this.printUserCard=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["p" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab_content'},_this.printResumeTab()));};_this.printTabContent=function(){var tabSelected=_this.state.tabSelected;switch(tabSelected){case __WEBPACK_IMPORTED_MODULE_7_constants_profile__["c" ]:return _this.printGpdrTab();case __WEBPACK_IMPORTED_MODULE_7_constants_profile__["b" ]:return _this.printEraseTab();case __WEBPACK_IMPORTED_MODULE_7_constants_profile__["a" ]:return _this.printRelations();default:return _this.printUserCard();}};_this.selectProfilePrivacyLevel=function(event){var level=parseInt(event.target.getAttribute('data-level'),10);var _this$state3=_this.state,profilePrivacyField=_this$state3.profilePrivacyField,profilePrivacy=_this$state3.profilePrivacy,answers=_this$state3.answers;var pieces=profilePrivacyField.split('-');if(pieces[0]==='question'){var narrativeType=pieces[1];var stepId=parseInt(pieces[2],10);__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.forEach(answers,function(narrative){var question=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(narrative.questions,{id:stepId});if(question){var newAnswers=[];__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.forEach(question.answers,function(answer){var newAnswer=Object.assign({},answer);if(newAnswers.privacity!==level){newAnswer.privacity=level;}newAnswers.push(newAnswer);});question.answers=newAnswers;}});var params={level:level,narrative_type:narrativeType,step_id:stepId};Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["b" ])('POST',{endPoint:'elements/privacy'},params);}else{profilePrivacy[profilePrivacyField]=level;var _params={level:level,field:profilePrivacyField};Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["b" ])('POST',{endPoint:'users/profile-field/privacy'},_params);}_this.setState({answers:answers,profilePrivacy:profilePrivacy,profilePrivacyElement:null});};_this.printProfileLevelSelector=function(){var _this$state4=_this.state,level=_this$state4.profilePrivacyLevel,profilePrivacyElement=_this$state4.profilePrivacyElement;var _this$props3=_this.props,color=_this$props3.app.color1,literals=_this$props3.literals;var clientRect=profilePrivacyElement.getBoundingClientRect();var top=clientRect.top-50+window.scrollY;var left=20;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["j" ],{top:top,left:left},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["i" ],{color:color,selected:level===0,'data-level':'0',onClick:_this.selectProfilePrivacyLevel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-wifi'}),literals.visibleForAll),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["i" ],{color:color,selected:level===1,'data-level':'1',onClick:_this.selectProfilePrivacyLevel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-user-shield'}),literals.shareInC2i),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["i" ],{color:color,selected:level===2,'data-level':'2',onClick:_this.selectProfilePrivacyLevel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-comments'}),literals.shareWithUsersConnected),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["i" ],{color:color,selected:level===3,'data-level':'3',onClick:_this.selectProfilePrivacyLevel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lock'}),literals.private));};_this.printErasePop=function(){var literals=_this.props.literals;if(!_this.state.erasePop){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["m" ],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle close_icon',onClick:_this.showErasePop})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["b" ],{onClick:_this.showErasePop},literals.nuclearOption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],null,literals.easeAllDataSub),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn-sm claim',onClick:_this.goToGpdr},literals.wantDelete),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn-sm claim white'},literals.cancel)));};_this.showErasePop=function(){if(_this.state.erasePop){_this.setState({erasePop:false});}else{_this.setState({erasePop:true});}};_this.printEraseTab=function(){var literals=_this.props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["g" ],null,literals.eraseAllData),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14_assets_images_user_erase_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["a" ],{onClick:_this.showErasePop},literals.nuclearOption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["e" ],null,literals.easeAllDataSub),_this.printErasePop());};_this.printGpdrTab=function(){var _this$props4=_this.props,literals=_this$props4.literals,eraseAccountError=_this$props4.eraseAccountError;var _this$state$eraseForm=_this.state.eraseForm,errors=_this$state$eraseForm.errors,password=_this$state$eraseForm.password,isSubmit=_this$state$eraseForm.isSubmit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["h" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notice'},literals.gpdrNotice),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_title'},literals.password,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form_icon_required'},' *')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',className:'form_input_stl '+(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(errors,function(error){return error==='password';})?'error':''),value:password,onChange:_this.handleChangeErasePassword})),isSubmit&&eraseAccountError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error_msg'},eraseAccountError):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:_this.handleSubmitErase},literals.accept),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'cancel',onClick:_this.handleViewErase},literals.cancel))));};_this.handleClickProfilePrivacy=function(event){_this.setState({profilePrivacyField:event.target.getAttribute('data-field'),profilePrivacyLevel:parseInt(event.target.getAttribute('data-level'),10),profilePrivacyElement:event.target});event.stopPropagation();};_this.handleSubmitErase=function(){var deleteAccount=_this.props.deleteAccount;var eraseForm=_this.state.eraseForm;var errors=eraseForm.errors,password=eraseForm.password;// Clear array
errors.splice(0,errors.length);var error=false;if(!password){error=true;errors.push('password');}_this.setState({eraseForm:eraseForm});if(!error){eraseForm.isSubmit=true;_this.setState({eraseForm:eraseForm});deleteAccount(password);}};_this.handleChangeErasePassword=function(event){var value=event.target.value;var eraseForm=_this.state.eraseForm;eraseForm.password=value;_this.setState({eraseForm:eraseForm});};_this.printRelations=function(){var literals=_this.props.literals;var _this$state5=_this.state,answers=_this$state5.answers,profilePrivacyElement=_this$state5.profilePrivacyElement;var narrativesCount=0;var narratives=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(answers,function(narrative){var questionsCount=0;var questions=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(narrative.steps,function(step){if(!step.answers.length){return null;}questionsCount+=1;var answersElements=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(step.answers,function(_ref4){var id=_ref4.id,name=_ref4.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:'tag gray selected'},name);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:narrative.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step_name',dangerouslySetInnerHTML:{__html:step.title}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subsection_content'},answersElements));});if(!questionsCount){return null;}narrativesCount+=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:narrative.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'},narrative.name),questions);});if(!narrativesCount){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["l" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nocontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_assets_images_think_no_think_chats_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noContentSub)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab_content'},profilePrivacyElement&&_this.printProfileLevelSelector(),narratives);};_this.handleViewResume=function(){_this.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_7_constants_profile__["d" ]});};_this.handleViewErase=function(){_this.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_7_constants_profile__["b" ]});};_this.handleViewData=function(){_this.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_7_constants_profile__["a" ]});};_this.state={tabSelected:__WEBPACK_IMPORTED_MODULE_7_constants_profile__["d" ],answers:null,profilePrivacyField:'',profilePrivacyElement:null,profilePrivacyLevel:0,eraseForm:{errors:[],password:'',isSubmit:false},erasePop:false,collapsed:false,data:null};return _this;}_createClass(Profile,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var resetAll=this.props.resetAll;resetAll();this.setBreadcrumbProfile();__WEBPACK_IMPORTED_MODULE_3_redux_react_session__["sessionService"].loadUser().then(function(_ref5){var id=_ref5.id;Object(__WEBPACK_IMPORTED_MODULE_10_modules_users_actions__["c" ])(id).then(function(userData){_this2.setState({data:userData});});Object(__WEBPACK_IMPORTED_MODULE_15__modules_actions__["d" ])(id).then(function(response){_this2.setState({answers:response});});});}},{key:'componentDidUpdate',value:function componentDidUpdate(_ref6){var prevEraseAccountStatus=_ref6.eraseAccountStatus;var eraseAccountStatus=this.props.eraseAccountStatus;if(eraseAccountStatus!==prevEraseAccountStatus&&eraseAccountStatus===__WEBPACK_IMPORTED_MODULE_2_constants_status__["g" ]){__WEBPACK_IMPORTED_MODULE_5_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_8_constants_urls__["k" ]);}}},{key:'render',value:function render(){var literals=this.props.literals;var _state=this.state,tabSelected=_state.tabSelected,data=_state.data,answers=_state.answers;if(!data||!answers){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["n" ],{className:'Profile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.loading)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["n" ],{className:'Profile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'titles_profile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["k" ],{onClick:this.handleLogout},literals.logout)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["p" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.printHeader(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(tabSelected===__WEBPACK_IMPORTED_MODULE_7_constants_profile__["d" ]?'selected':''),onClick:this.handleViewResume},literals.resume),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(tabSelected===__WEBPACK_IMPORTED_MODULE_7_constants_profile__["a" ]?'selected':''),onClick:this.handleViewData},literals.data),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(tabSelected===__WEBPACK_IMPORTED_MODULE_7_constants_profile__["b" ]||tabSelected===__WEBPACK_IMPORTED_MODULE_7_constants_profile__["c" ]?'selected':''),onClick:this.handleViewErase},literals.erase)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["o" ],null,this.printTabContent()))));}}]);return Profile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Profile.propTypes={resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,deleteAccount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,eraseAccountError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,eraseAccountStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Profile.defaultProps={eraseAccountError:null,eraseAccountStatus:null}; __webpack_exports__["a"] = (Profile);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/impact_event.93c020ba.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/table_gray.a43fc123.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/erase.149854cf.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1073);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3__components_SocialOauth__ = __webpack_require__(1074);
 var __WEBPACK_IMPORTED_MODULE_4__Login_modules_actions__ = __webpack_require__(443);
function mapStateToProps(state){return{isAuthenticated:state.session.authenticated};}function mapDispatchToProps(dispatch){return{doLoginSocial:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4__Login_modules_actions__["b" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_SocialOauth__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_4__utils_apiFetch__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SocialOauth=function(_Component){_inherits(SocialOauth,_Component);function SocialOauth(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SocialOauth);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SocialOauth.__proto__||Object.getPrototypeOf(SocialOauth)).call.apply(_ref,[this].concat(args))),_this),_this.responseSocial=function(id){var doLoginSocial=_this.props.doLoginSocial;doLoginSocial(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SocialOauth,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,type=_props.match.params.type,history=_props.history;var origin=window.location.origin;var token='';switch(type){case'linkedin':token='oauth_3c90c80eb1c2b395af81dd463425731545396064';break;default:break;}var params={t:token};Object(__WEBPACK_IMPORTED_MODULE_4__utils_apiFetch__["a" ])('GET',origin+'/system/security/external/get_login_response.php',params).then(function(response){if(response.success){var id=response.data.user_id;_this2.responseSocial(id);}else{history.push(__WEBPACK_IMPORTED_MODULE_3_constants_urls__["w" ]);}});}},{key:'render',value:function render(){var _props2=this.props,isAuthenticated=_props2.isAuthenticated,location=_props2.location;if(isAuthenticated){var flagRedirect=location.state&&location.state.from!==__WEBPACK_IMPORTED_MODULE_3_constants_urls__["a" ]&&location.state.from!==__WEBPACK_IMPORTED_MODULE_3_constants_urls__["x" ];var redirectTo=flagRedirect?location.state.from:__WEBPACK_IMPORTED_MODULE_3_constants_urls__["y" ];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" ],{to:{pathname:redirectTo,state:location.state}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return SocialOauth;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SocialOauth.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isAuthenticated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,doLoginSocial:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (SocialOauth);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1076);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1077);
function mapStateToProps(){return{};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_ChatRoom__ = __webpack_require__(111);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1078);
function Chat(props){var id=props.match.params.id;var chatId=parseInt(id,10);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ChatRoom__["a" ],{chatId:chatId}));}Chat.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (Chat);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ChatWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  .chat_container {\n    height: calc(100vh - 15.4rem);\n\n    .list_messages {\n      height: calc(100vh - 15.4rem);\n    }\n  }\n'],['\n  .chat_container {\n    height: calc(100vh - 15.4rem);\n\n    .list_messages {\n      height: calc(100vh - 15.4rem);\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ChatWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1080);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_6__components_UsersProfiles__ = __webpack_require__(1081);
function mapStateToProps(state){return{literals:state.i18n.literals.usersProfiles,app:state.app};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),goHome:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["e" ],dispatch),resetContext:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_store_globalState_global__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components_UsersProfiles__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_components_Steps_SwipeableCards__ = __webpack_require__(65);
 var __WEBPACK_IMPORTED_MODULE_5_components_Navbar__ = __webpack_require__(116);
 var __WEBPACK_IMPORTED_MODULE_6_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersProfiles=function(_Component){_inherits(UsersProfiles,_Component);function UsersProfiles(props){_classCallCheck(this,UsersProfiles);var _this=_possibleConstructorReturn(this,(UsersProfiles.__proto__||Object.getPrototypeOf(UsersProfiles)).call(this,props));_this.handleEnd=function(){var _this$props=_this.props,goHome=_this$props.goHome,history=_this$props.history,resetContext=_this$props.resetContext;resetContext();goHome();history.push(__WEBPACK_IMPORTED_MODULE_6_constants_urls__["y" ]);};_this.state={users:null};return _this;}_createClass(UsersProfiles,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,id=_props.match.params.id,setBreadcrumb=_props.setBreadcrumb,literals=_props.literals;Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('GET',{endPoint:'recommendations/users/'+id}).then(function(_ref){var users=_ref.users;_this2.setState({users:users});});var breadcrumb=[{color:'#ffffff',text:literals.recommendations}];setBreadcrumb(breadcrumb.slice());}},{key:'render',value:function render(){var _props2=this.props,literals=_props2.literals,color=_props2.app.color1;var users=this.state.users;if(!users){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["b" ],{color:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Navbar__["a" ],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Steps_SwipeableCards__["a" ],{title:literals.weFoundTheseUsers,users:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(users,function(_ref2){var id=_ref2.id;return id;}),onEnd:this.handleEnd})));}}]);return UsersProfiles;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UsersProfiles.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,goHome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,resetContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (UsersProfiles);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(1083);
function mapStateToProps(state){return{literals:state.i18n.literals.navbar||{},navbarData:state.navbar,user:state.session.user,app:state.app,actualContext:state.steps.context};}var mapDispatchToProps={viewUserProfile:__WEBPACK_IMPORTED_MODULE_2_modules_app__["e" ]}; __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Toolbar__ = __webpack_require__(1084);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_AddCircle__ = __webpack_require__(1086);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_AddCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_AddCircle__);
 var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
 var __WEBPACK_IMPORTED_MODULE_6_components_Searcher__ = __webpack_require__(1091);
 var __WEBPACK_IMPORTED_MODULE_7__styles_css__ = __webpack_require__(1096);
 var __WEBPACK_IMPORTED_MODULE_7__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_css__);
 var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1097);
 var __WEBPACK_IMPORTED_MODULE_9__constants_urls__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Navbar=function(_React$Component){_inherits(Navbar,_React$Component);function Navbar(props){_classCallCheck(this,Navbar);var _this=_possibleConstructorReturn(this,(Navbar.__proto__||Object.getPrototypeOf(Navbar)).call(this,props));_this.handleClick=function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_9__constants_urls__["F" ]);};_this.printBreadCrumb=function(){var _this$props=_this.props,breadcrumb=_this$props.navbarData.breadcrumb,actualContext=_this$props.actualContext,app=_this$props.app;var i=0;return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(breadcrumb,function(element){if(!element){return null;}var text=element.text,color=element.color,onClick=element.onClick;var finalColor=color;if(actualContext&&typeof actualContext.color!=='undefined'&&typeof app.advanced_configuration!=='undefined'&&typeof app.advanced_configuration.no_background_color!=='undefined'&&app.advanced_configuration.no_background_color){finalColor=typeof actualContext.color==='string'?actualContext.color:actualContext.color.color;}var textElement=i?'/ '+text:text;i+=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["c" ],{key:i,color:finalColor,onClick:onClick,dangerouslySetInnerHTML:{__html:textElement}});});};_this.getColor=function(){var _this$props2=_this.props,app=_this$props2.app,actualContext=_this$props2.actualContext;if(!actualContext){return app.color1;}switch(actualContext.elementType){case'narrative':case'objective':return actualContext.color;default:return app.color1;}};_this.goToMessages=function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_9__constants_urls__["P" ]);};_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_9__constants_urls__["x" ]);};_this.goToCreationThinkSeed=function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_9__constants_urls__["Q" ]);};_this.handleCloseSelectedUser=function(){var viewUserProfile=_this.props.viewUserProfile;viewUserProfile(0);};_this.handleToggleSearcher=function(){var showSearcher=_this.state.showSearcher;_this.setState({showSearcher:!showSearcher});};_this.printCreationThinkSeed=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_AddCircle___default.a,{fontSize:'large',onClick:_this.goToCreationThinkSeed});};_this.state={showSearcher:false};return _this;}_createClass(Navbar,[{key:'render',value:function render(){var _props=this.props,searcher=_props.searcher,logoutVisible=_props.logoutVisible,literals=_props.literals,creationThinkSeed=_props.creationThinkSeed;var showSearcher=this.state.showSearcher;var color=this.getColor();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,showSearcher&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Searcher__["a" ],{onClose:this.handleToggleSearcher}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],{position:'static',className:'Navbar',color:'default'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Toolbar__["a" ],{className:'Navbar--top'},searcher&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["e" ],{color:color||color.color,onClick:this.handleToggleSearcher},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["b" ],{className:'grow text-align-left Navbar--top--title'},this.printBreadCrumb(),logoutVisible?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["d" ],{onClick:this.handleLogout},literals.logout):null),creationThinkSeed&&this.printCreationThinkSeed())));}}]);return Navbar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Navbar.propTypes={navbarData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,actualContext:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,viewUserProfile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,literals:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,searcher:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,logoutVisible:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,creationThinkSeed:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};Navbar.defaultProps={searcher:false,logoutVisible:false,creationThinkSeed:false,actualContext:null}; __webpack_exports__["a"] = (Navbar);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__Toolbar__ = __webpack_require__(1085);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Toolbar__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(63);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);







var styles = function styles(theme) {
  return {
    
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    
    gutters: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" ])({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    
    regular: theme.mixins.toolbar,

    
    dense: {
      minHeight: 48
    }
  };
};
var Toolbar = __WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Toolbar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "className", "component", "disableGutters", "variant"]);

  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.root, classes[variant], className, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? Toolbar.propTypes = {
  
  children: PropTypes.node,

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string,

  
  component: PropTypes
  
  .elementType,

  
  disableGutters: PropTypes.bool,

  
  variant: PropTypes.oneOf(['regular', 'dense'])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'MuiToolbar'
})(Toolbar));

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

var _interopRequireWildcard = __webpack_require__(452);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(454));

var _default = (0, _createSvgIcon.default)( React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
}), 'AddCircle');

exports.default = _default;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
 var __WEBPACK_IMPORTED_MODULE_0__capitalize__ = __webpack_require__(38);
 __webpack_require__.d(__webpack_exports__, "capitalize", function() { return __WEBPACK_IMPORTED_MODULE_0__capitalize__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(227);
 __webpack_require__.d(__webpack_exports__, "createChainedFunction", function() { return __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__createSvgIcon__ = __webpack_require__(236);
 __webpack_require__.d(__webpack_exports__, "createSvgIcon", function() { return __WEBPACK_IMPORTED_MODULE_2__createSvgIcon__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__debounce__ = __webpack_require__(164);
 __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_3__debounce__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__deprecatedPropType__ = __webpack_require__(1088);
 __webpack_require__.d(__webpack_exports__, "deprecatedPropType", function() { return __WEBPACK_IMPORTED_MODULE_4__deprecatedPropType__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__isMuiElement__ = __webpack_require__(233);
 __webpack_require__.d(__webpack_exports__, "isMuiElement", function() { return __WEBPACK_IMPORTED_MODULE_5__isMuiElement__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__ownerDocument__ = __webpack_require__(77);
 __webpack_require__.d(__webpack_exports__, "ownerDocument", function() { return __WEBPACK_IMPORTED_MODULE_6__ownerDocument__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__ownerWindow__ = __webpack_require__(226);
 __webpack_require__.d(__webpack_exports__, "ownerWindow", function() { return __WEBPACK_IMPORTED_MODULE_7__ownerWindow__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_8__requirePropFactory__ = __webpack_require__(439);
 __webpack_require__.d(__webpack_exports__, "requirePropFactory", function() { return __WEBPACK_IMPORTED_MODULE_8__requirePropFactory__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_9__setRef__ = __webpack_require__(165);
 __webpack_require__.d(__webpack_exports__, "setRef", function() { return __WEBPACK_IMPORTED_MODULE_9__setRef__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_10__unsupportedProp__ = __webpack_require__(1089);
 __webpack_require__.d(__webpack_exports__, "unsupportedProp", function() { return __WEBPACK_IMPORTED_MODULE_10__unsupportedProp__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_11__useControlled__ = __webpack_require__(251);
 __webpack_require__.d(__webpack_exports__, "useControlled", function() { return __WEBPACK_IMPORTED_MODULE_11__useControlled__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_12__useEventCallback__ = __webpack_require__(166);
 __webpack_require__.d(__webpack_exports__, "useEventCallback", function() { return __WEBPACK_IMPORTED_MODULE_12__useEventCallback__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_13__useForkRef__ = __webpack_require__(46);
 __webpack_require__.d(__webpack_exports__, "useForkRef", function() { return __WEBPACK_IMPORTED_MODULE_13__useForkRef__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_14__unstable_useId__ = __webpack_require__(1090);
 __webpack_require__.d(__webpack_exports__, "unstable_useId", function() { return __WEBPACK_IMPORTED_MODULE_14__unstable_useId__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_15__useIsFocusVisible__ = __webpack_require__(410);
 __webpack_require__.d(__webpack_exports__, "useIsFocusVisible", function() { return __WEBPACK_IMPORTED_MODULE_15__useIsFocusVisible__["a"]; });













 // eslint-disable-next-line camelcase




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = deprecatedPropType;
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = unsupportedProp;
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = useId;
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);



function useId(idOverride) {
  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1092);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_4__components_Searcher__ = __webpack_require__(1093);
 var __WEBPACK_IMPORTED_MODULE_5__modules_searcher__ = __webpack_require__(354);
function mapStateToProps(state){return{literals:state.i18n.literals.searcher||{},q:state.searcher.q,results:state.searcher.results,isLoading:state.searcher.isLoading,app:state.app,canLoadMore:state.searcher.canLoadMore};}function mapDispatchToProps(dispatch){return{setQueryString:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5__modules_searcher__["c" ],dispatch),search:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5__modules_searcher__["b" ],dispatch),viewUserProfile:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_app__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components_Searcher__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3__Result__ = __webpack_require__(1094);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(455);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Searcher=function(_Component){_inherits(Searcher,_Component);function Searcher(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Searcher);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Searcher.__proto__||Object.getPrototypeOf(Searcher)).call.apply(_ref,[this].concat(args))),_this),_this.printResults=function(){var _this$props=_this.props,results=_this$props.results,isLoading=_this$props.isLoading;var bubbles=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(results,function(result){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Result__["a" ],{result:result,onClick:_this.handleClick,key:result.id});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,bubbles,isLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" ],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:_this.assignRefResultsEnd}));},_this.slideToBottom=function(){if(_this.endResults){_this.endResults.scrollIntoView({behavior:'smooth'});}},_this.handleClick=function(id){var viewUserProfile=_this.props.viewUserProfile;viewUserProfile(id);},_this.handleClose=function(){var onClose=_this.props.onClose;onClose();},_this.handleChangeInput=function(event){var value=event.target.value;var _this$props2=_this.props,setQueryString=_this$props2.setQueryString,search=_this$props2.search;setQueryString(value);if(_this.intSearch){clearTimeout(_this.intSearch);}_this.intSearch=setTimeout(function(){search();},1000);},_this.assignRefResultsEnd=function(ref){_this.endResults=ref;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Searcher,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.slideToBottom();}},{key:'render',value:function render(){var _props=this.props,literals=_props.literals,q=_props.q,color=_props.app.color1,isLoading=_props.isLoading,search=_props.search,canLoadMore=_props.canLoadMore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" ],{color:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],{onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" ],{autoFocus:true,value:q,placeholder:literals.search,onChange:this.handleChangeInput}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" ],null,this.printResults()),!isLoading&&canLoadMore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],{onClick:search},literals.viewMore));}}]);return Searcher;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Searcher.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,q:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,results:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,setQueryString:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,search:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,canLoadMore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,viewUserProfile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (Searcher);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(455);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Result=function(_Component){_inherits(Result,_Component);function Result(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Result);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Result.__proto__||Object.getPrototypeOf(Result)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(){var _this$props=_this.props,id=_this$props.result.id,onClick=_this$props.onClick;onClick(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Result,[{key:'render',value:function render(){var result=this.props.result;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["d" ],{onClick:this.handleClick},result.avatar!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["h" ],{alt:result.firstname,src:result.avatar}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["h" ],{className:'text-avatar'},result.firstname.slice(0,1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["i" ],null,result.firstname+' '+result.lastname));}}]);return Result;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Result.propTypes={result:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (Result);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loader.a0ccfef4.svg";

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return AppHeader; });

 __webpack_require__.d(__webpack_exports__, "b", function() { return Breadcrumb; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return BreadcrumbElement; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return SearcherIcon; });


 __webpack_require__.d(__webpack_exports__, "d", function() { return LogoutButton; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_AppBar__ = __webpack_require__(1098);
 var __WEBPACK_IMPORTED_MODULE_2_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_3_styles_utils__ = __webpack_require__(1100);
var _templateObject=_taggedTemplateLiteral(['\n  && {\n    background-color: transparent;\n    box-shadow: none;\n    height: 45px;\n    margin: 0em 22px 0;\n    width: calc(100% - 44px);\n    transition: background-color 0.4s linear;\n    .Navbar--top{\n      padding: 3px;\n    }\n\n    ','\n  }  \n'],['\n  && {\n    background-color: transparent;\n    box-shadow: none;\n    height: 45px;\n    margin: 0em 22px 0;\n    width: calc(100% - 44px);\n    transition: background-color 0.4s linear;\n    .Navbar--top{\n      padding: 3px;\n    }\n\n    ','\n  }  \n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #fff;\n  color: #000;\n  text-align: center;\n  line-height: 50px;\n  font-size: 16px; \n'],['\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #fff;\n  color: #000;\n  text-align: center;\n  line-height: 50px;\n  font-size: 16px; \n']),_templateObject3=_taggedTemplateLiteral(['\n'],['\n']),_templateObject4=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  color: ',';\n  font-size: 14px;\n  font-family: ',';\n  opacity: 0.5;\n  \n'],['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  color: ',';\n  font-size: 14px;\n  font-family: ',';\n  opacity: 0.5;\n  \n']),_templateObject5=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  background-color: #fff;\n  margin-right: 10px;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  text-align: center;\n  padding-top: 11px;\n  cursor: pointer;\n\n  i {\n    color: ',';\n    font-size: 14px;\n  }\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  background-color: #fff;\n  margin-right: 10px;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  text-align: center;\n  padding-top: 11px;\n  cursor: pointer;\n\n  i {\n    color: ',';\n    font-size: 14px;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  position: absolute;\n  width: 98vw;\n  height: 98vh;\n  top: 1vh;\n  z-index: 1500;\n  left: 1vw;\n  box-shadow: 0px 3px 8px 4px rgba(40, 40, 40, 0.2);\n  border-radius: 4px;\n  background-color: ',';\n'],['\n  position: absolute;\n  width: 98vw;\n  height: 98vh;\n  top: 1vh;\n  z-index: 1500;\n  left: 1vw;\n  box-shadow: 0px 3px 8px 4px rgba(40, 40, 40, 0.2);\n  border-radius: 4px;\n  background-color: ',';\n']),_templateObject7=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 20px;\n  position: absolute;\n  right: 70px;\n  top: 19px;\n'],['\n  color: #fff;\n  font-size: 20px;\n  position: absolute;\n  right: 70px;\n  top: 19px;\n']),_templateObject8=_taggedTemplateLiteral(['\n  border: 1px solid #F44336;\n  color: #fff;\n  background-color: #F44336;\n  position: absolute;\n  right: 0px;\n  top: 19px;\n  font-size: 14px;\n  border-radius: 20px;\n  padding: 5px 20px;\n'],['\n  border: 1px solid #F44336;\n  color: #fff;\n  background-color: #F44336;\n  position: absolute;\n  right: 0px;\n  top: 19px;\n  font-size: 14px;\n  border-radius: 20px;\n  padding: 5px 20px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var appHeaderPhone='\n  height: 50px;\n  margin-top: 0px;\n';var AppHeader=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_AppBar__["a" ])(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_3_styles_utils__["a" ])(appHeaderPhone));var AvatarInitial=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var Breadcrumb=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var BreadcrumbElement=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily);var SearcherIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,function(props){return props.color;});var UserCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,function(props){return props.color;});var EnvelopeIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject7);var LogoutButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject8);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__AppBar__ = __webpack_require__(1099);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AppBar__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(38);
 var __WEBPACK_IMPORTED_MODULE_7__Paper__ = __webpack_require__(231);








var styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },

    
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0,
      '@media print': {
        // Prevent the app bar to be visible on each printed page.
        position: 'absolute'
      }
    },

    
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },

    
    positionSticky: {
      // ⚠️ sticky is not supported by IE 11.
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },

    
    positionStatic: {
      position: 'static'
    },

    
    positionRelative: {
      position: 'relative'
    },

    
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },

    
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    
    colorInherit: {
      color: 'inherit'
    },

    
    colorTransparent: {
      backgroundColor: 'transparent',
      color: 'inherit'
    }
  };
};
var AppBar = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function AppBar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$position = props.position,
      position = _props$position === void 0 ? 'fixed' : _props$position,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "className", "color", "position"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Paper__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    square: true,
    component: "header",
    elevation: 4,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, classes["position".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" ])(position))], classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" ])(color))], className, position === 'fixed' && 'mui-fixed'),
    ref: ref
  }, other));
});
 false ? AppBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']),

  
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiAppBar'
})(AppBar));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return mediaPhone; });
var mediaPhone=function mediaPhone(css){return"\n    @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3),\n    only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2),\n    only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {\n      "+css+"\n    }\n  ";}; var _unused_webpack_default_export = (mediaPhone);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return CardWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return UserProfilesWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  margin-top: 30px;\n'],['\n  width: 100%;\n  margin-top: 30px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n'],['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var UserProfilesWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.color;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1103);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5__components_UserProfile__ = __webpack_require__(1104);
function mapStateToProps(state){return{literals:state.i18n.literals.userProfile,color:state.app.color1};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),goHome:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components_UserProfile__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_Navbar__ = __webpack_require__(116);
 var __WEBPACK_IMPORTED_MODULE_3_components_Steps_UserCard__ = __webpack_require__(1105);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1130);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserProfile=function(_Component){_inherits(UserProfile,_Component);function UserProfile(){_classCallCheck(this,UserProfile);return _possibleConstructorReturn(this,(UserProfile.__proto__||Object.getPrototypeOf(UserProfile)).apply(this,arguments));}_createClass(UserProfile,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,literals=_props.literals,setBreadcrumb=_props.setBreadcrumb;var breadcrumb=[{color:'#ffffff',text:literals.userProfile}];setBreadcrumb(breadcrumb.slice());}},{key:'render',value:function render(){var _props2=this.props,color=_props2.color,id=_props2.match.params.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],{color:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Navbar__["a" ],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Steps_UserCard__["a" ],{color:color,user:{id:id}}));}}]);return UserProfile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserProfile.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (UserProfile);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1106);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_4_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_5_routes_Profile_modules_actions__ = __webpack_require__(92);
 var __WEBPACK_IMPORTED_MODULE_6__components_UserCard__ = __webpack_require__(1107);
function mapStateToProps(state){return{literals:state.i18n.literals.userCard||{},app:state.app};}function mapDispatchToProps(dispatch){return{addNewChat:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_chats__["b" ],dispatch),viewUserProfile:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_app__["e" ],dispatch),updateProfile:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_routes_Profile_modules_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components_UserCard__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_routes_Profile_modules_actions__ = __webpack_require__(92);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(115);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(68);
 var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
 var __WEBPACK_IMPORTED_MODULE_7_react_ga__ = __webpack_require__(106);
 var __WEBPACK_IMPORTED_MODULE_8_constants_profile__ = __webpack_require__(450);
 var __WEBPACK_IMPORTED_MODULE_9_react_slick__ = __webpack_require__(1108);
 var __WEBPACK_IMPORTED_MODULE_9_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_slick__);
 var __WEBPACK_IMPORTED_MODULE_10_utils_data__ = __webpack_require__(1123);
 var __WEBPACK_IMPORTED_MODULE_11_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_12_slick_carousel_slick_slick_css__ = __webpack_require__(1124);
 var __WEBPACK_IMPORTED_MODULE_12_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_slick_carousel_slick_slick_css__);
 var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_theme_css__ = __webpack_require__(1125);
 var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_theme_css__);
 var __WEBPACK_IMPORTED_MODULE_14_routes_Connections_components_ConnectionUser__ = __webpack_require__(1126);
 var __WEBPACK_IMPORTED_MODULE_15_routes_Profile_components_PrivacyElement__ = __webpack_require__(1127);
 var __WEBPACK_IMPORTED_MODULE_16__styles__ = __webpack_require__(1128);
 var __WEBPACK_IMPORTED_MODULE_17__styles_css__ = __webpack_require__(1129);
 var __WEBPACK_IMPORTED_MODULE_17__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserCard=function(_Component){_inherits(UserCard,_Component);function UserCard(props){_classCallCheck(this,UserCard);var _this=_possibleConstructorReturn(this,(UserCard.__proto__||Object.getPrototypeOf(UserCard)).call(this,props));_this.componentDidUpdate=function(_ref){var prevUser=_ref.userData,prevAnswers=_ref.answers;var _this$props=_this.props,userData=_this$props.userData,answers=_this$props.answers;if(JSON.stringify(prevUser)!==JSON.stringify(userData)){_this.setState({user:userData});}if(JSON.stringify(prevAnswers)!==JSON.stringify(answers)){_this.setState({answers:answers});}};_this.filterActions=function(array){var actions={};array.map(function(action){if(typeof actions[action.aType]==='undefined')actions[action.aType]=[];actions[action.aType].push(action);return action;});return actions;};_this.filterConnections=function(array){var newArray=[];array.map(function(connection){if(typeof newArray.find(function(c){return c.id===connection.id;})==='undefined'){newArray.push(connection);}return connection;});return newArray;};_this.handleClose=function(){var onClose=_this.props.onClose;onClose();};_this.handleViewResume=function(){_this.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_8_constants_profile__["d" ],editMode:false});};_this.handleViewData=function(){_this.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_8_constants_profile__["a" ],editMode:false});};_this.printTabContent=function(){var tabSelected=_this.state.tabSelected;switch(tabSelected){case __WEBPACK_IMPORTED_MODULE_8_constants_profile__["a" ]:return _this.printData();default:return _this.printResume();}};_this.handleEnableEdition=function(){_this.setState({editMode:true});};_this.handleDisableEdition=function(){_this.setState({editMode:false});};_this.handleChangeResumeField=function(name){return function(event){var value=event.target.value;var user=_this.state.user;user.profile[name]=value;_this.setState({user:user});};};_this.saveResumeEdition=function(){var user=_this.state.user;var updateProfile=_this.props.updateProfile;var params={name:user.firstname,surname:user.lastname,avatar:user.avatar};__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.forEach(user.profile,function(value,key){params[key]=value;});updateProfile(params);_this.handleDisableEdition();};_this.printResumeEdition=function(){var user=_this.state.user;var _this$props2=_this.props,literals=_this$props2.literals,color=_this$props2.color;var darkerColor=typeof color==='string'?color:color.color;var summaryFields=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(user.profile,function(value,field){switch(field){case'gender':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:'adornment-'+field},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["u" ],{className:'form__field',htmlFor:'gender-simple'},literals[field]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["g" ],{native:true,value:value,onChange:_this.handleChangeResumeField(field),inputProps:{name:'gender',id:'gender-simple',className:'form__field__input'},className:'form__field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'female'},literals.female),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'male'},literals.male)));default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__["default"],{id:'adornment-'+field,key:'adornment-'+field,label:literals[field],multiline:true,rowsMax:4,value:Object(__WEBPACK_IMPORTED_MODULE_10_utils_data__["a" ])(value),onChange:_this.handleChangeResumeField(field),className:'form__field',inputProps:{className:'form__field__input'}});}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["n" ],{color:darkerColor},summaryFields,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["c" ],{onClick:_this.saveResumeEdition},literals.save));};_this.printResume=function(){var _this$props3=_this.props,literals=_this$props3.literals,color=_this$props3.color,edit=_this$props3.edit;var darkerColor=typeof color==='string'?color:color.color;var state=_this.state;var user=state.user,editMode=state.editMode;if(editMode){return _this.printResumeEdition();}var isEmptyResume=true;var fields=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(user.profile,function(value,field){if(Object(__WEBPACK_IMPORTED_MODULE_10_utils_data__["a" ])(value)){isEmptyResume=false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:field},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["o" ],null,literals[field]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["m" ],null,(field==='gender'?literals[value]:Object(__WEBPACK_IMPORTED_MODULE_10_utils_data__["a" ])(value))||''));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);});if(isEmptyResume){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["l" ],null,literals.noInfo);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["n" ],{color:darkerColor},fields,edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["c" ],{onClick:_this.handleEnableEdition},literals.edit):null);};_this.handleClickUser=function(id){var viewUserProfile=_this.props.viewUserProfile;viewUserProfile(id);};_this.printData=function(){var app=_this.props.app;var answers=_this.state.answers;var darkerColor=app.color1;var narratives=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(answers,function(narrative){var questionsCount=0;var questions=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(narrative.questions,function(question){if(!question.answers.length){return null;}questionsCount+=1;var answersElements=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(question.answers,function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_routes_Profile_components_PrivacyElement__["a" ],{level:0,color:darkerColor,element:element,key:element.id});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:question.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["o" ],{color:darkerColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["p" ],{dangerouslySetInnerHTML:{__html:question.title}})),answersElements);});if(!questionsCount){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:narrative.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["k" ],{color:darkerColor},narrative.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["j" ],null,questions));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["s" ],null,narratives);};_this.handleConnect=function(){var user=_this.state.user;var id=user.id;var params={userId:id,action:'connect'};Object(__WEBPACK_IMPORTED_MODULE_11_utils_apiFetch__["b" ])('POST',{endPoint:'users/connection'},params);user.match_actual_user=1;_this.setState({user:user});__WEBPACK_IMPORTED_MODULE_7_react_ga__["a" ].event({category:'Add Connection User',action:'user_'+id,label:'User Card'});};_this.handleDeleteConnection=function(){var user=_this.state.user;var id=user.id;var params={userId:id,action:'connect'};Object(__WEBPACK_IMPORTED_MODULE_11_utils_apiFetch__["b" ])('DELETE',{endPoint:'users/connection'},params);user.match_actual_user=0;_this.setState({user:user});__WEBPACK_IMPORTED_MODULE_7_react_ga__["a" ].event({category:'Remove Connection User',action:'user_'+id,label:'User Card'});};_this.handleSendMessage=function(){var user=_this.state.user;var _this$props4=_this.props,addNewChat=_this$props4.addNewChat,history=_this$props4.history,viewUserProfile=_this$props4.viewUserProfile;var params={user:user.id};Object(__WEBPACK_IMPORTED_MODULE_11_utils_apiFetch__["b" ])('POST',{endPoint:'chat'},params).then(function(chat){addNewChat(chat);viewUserProfile(0);history.push('/chat/'+chat.id);});};_this.printUsersConnections=function(){var connections=_this.state.connections;var mySettings={arrows:false,slidesToShow:8,cssEase:'linear',swipe:true,dots:true,infinite:false,responsive:[{breakpoint:1400,settings:{slidesToShow:7}},{breakpoint:1200,settings:{slidesToShow:6}},{breakpoint:1000,settings:{slidesToShow:5}},{breakpoint:800,settings:{slidesToShow:4}},{breakpoint:601,settings:{slidesToShow:3}}]};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["h" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_slick___default.a,Object.assign({},mySettings,{ref:function ref(carousel){_this.carousel=carousel;}}),connections.map(function(connection,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_routes_Connections_components_ConnectionUser__["a" ],{key:index,onClick:_this.handleClickUser,connection:connection});})));};_this.state={user:props.userData,tabSelected:__WEBPACK_IMPORTED_MODULE_8_constants_profile__["d" ],answers:props.answers,editMode:false};return _this;}_createClass(UserCard,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var id=this.props.user.id;var _state=this.state,user=_state.user,answers=_state.answers;if(!user||!answers){if(!user){Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(true);Object(__WEBPACK_IMPORTED_MODULE_2_routes_Profile_modules_actions__["e" ])(id).then(function(userData){_this2.setState({user:userData.info});Object(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ])(false);});}if(!answers){Object(__WEBPACK_IMPORTED_MODULE_2_routes_Profile_modules_actions__["d" ])(id).then(function(response){_this2.setState({answers:response});});}}window.scrollTo(0,0);}},{key:'render',value:function render(){var _props=this.props,literals=_props.literals,color=_props.color,onClose=_props.onClose,showButtons=_props.showButtons;var _state2=this.state,user=_state2.user,tabSelected=_state2.tabSelected;if(!user){return null;}var avatar=user.avatar,firstname=user.firstname,lastname=user.lastname;var backColor=typeof color==='string'?color:color.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["w" ],{className:'UserCard',color:backColor},onClose&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__["a" ],{container:true,spacing:0,className:'Profile__panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__["a" ],{item:true,xs:12,sm:12,md:12,className:'Profile__panel--right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UserCard__panel--right__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UserCard__panel--right__content__form'},avatar&&avatar!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["v" ],{alt:firstname,src:avatar})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["v" ],{className:'text-avatar'},firstname&&firstname!==''&&firstname.slice(0,1))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["x" ],null,firstname+' '+lastname),showButtons?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["i" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,user.match_user&&user.match_actual_user?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["d" ],{onClick:this.handleSendMessage},literals.sendMessage):null,!user.match_actual_user?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["e" ],{onClick:this.handleConnect},literals.connect):null,user.match_actual_user?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["b" ],{onClick:this.handleDeleteConnection},literals.deleteConnection):null)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["r" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["q" ],{active:tabSelected===__WEBPACK_IMPORTED_MODULE_8_constants_profile__["d" ],onClick:this.handleViewResume},literals.resume),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["q" ],{active:tabSelected===__WEBPACK_IMPORTED_MODULE_8_constants_profile__["a" ],onClick:this.handleViewData},literals.data)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["t" ],null,this.printTabContent()))))));}}]);return UserCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserCard.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,addNewChat:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,viewUserProfile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,answers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,showButtons:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,updateProfile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,edit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};UserCard.defaultProps={color:'#fff',onClose:null,userData:null,answers:null,showButtons:true,edit:false}; __webpack_exports__["a"] = (UserCard);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(1109);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(1110);

var _json2mq = __webpack_require__(1116);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(1118);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(178);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(1119);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(1111);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(456);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(178);

var _track = __webpack_require__(1112);

var _dots = __webpack_require__(1113);

var _arrows = __webpack_require__(1114);

var _resizeObserverPolyfill = __webpack_require__(1115);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(178);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(178);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
(function(global) {

var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return  (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();


var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();


var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';

var ResizeObserverController =  (function () {
    
    function ResizeObserverController() {
        
        this.connected_ = false;
        
        this.mutationEventsAdded_ = false;
        
        this.mutationsObserver_ = null;
        
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());


var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});


var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

function toFloat(value) {
    return parseFloat(value) || 0;
}

function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}

function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}

function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}

function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}

var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();

function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}

function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}

function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}

function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}


var ResizeObservation =  (function () {
    
    function ResizeObservation(target) {
        
        this.broadcastWidth = 0;
        
        this.broadcastHeight = 0;
        
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry =  (function () {
    
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI =  (function () {
    
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        
        this.activeObservations_ = [];
        
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();

var ResizeObserver =  (function () {
    
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

 __webpack_exports__["default"] = (index);

}.call(__webpack_exports__, __webpack_require__(51)))

 }),

 (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(1117);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

 }),

 (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

 }),

 (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(1120);
module.exports = new MediaQueryDispatch();


 }),

 (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(1121);
var Util = __webpack_require__(457);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;


function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


 }),

 (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(1122);
var each = __webpack_require__(457).each;


function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


 }),

 (function(module, exports) {


function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = decodeHTML;


 var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function decodeHTML(html){var txt=document.createElement('textarea');txt.innerHTML=html;return txt.value;}function validURL(str){var pattern=new RegExp('^(https?:\\/\\/)?'// protocol
+'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'// domain name
+'((\\d{1,3}\\.){3}\\d{1,3}))'// OR ip (v4) address
+'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'// port and path
+'(\\?[;&a-z\\d%_.~+=-]*)?'// query string
+'(\\#[-a-z\\d_]*)?$','i');// fragment locator
return!!pattern.test(str);}function prepareDataForElements(actualStep){var data=Object.assign({},actualStep);switch(actualStep.type){case'custom':data.narrativeType=data.narrative_type;break;case'creation_form':data.type='form_element';data.text=data.title;data.narrativeType=data.narrative_type;data.elementType=data.element_type;break;case'faces':data={type:'users_match_element',text:actualStep.title,narrativeType:actualStep.narrative_type,elements:actualStep.users,select:actualStep.more_info.select,sort:actualStep.more_info.sort,actionSelect:actualStep.more_info.action,sortField:actualStep.more_info.action,answers:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(actualStep.answers,function(answer){return parseInt(answer,10);}),more_info:actualStep.more_info};break;case'select':data={type:'list',text:actualStep.title,narrativeType:actualStep.narrative_type,elementType:actualStep.element_type,context:actualStep.context,elements:actualStep.elements,maxOptions:actualStep.more_info.max_answers,canCreate:actualStep.more_info.can_create,answers:actualStep.answers,more_info:actualStep.more_info};break;case'top_elements':data.text=data.title;data.elementId=data.narrative_type+'-'+data.element_type;break;case'input':data={type:'input',text:actualStep.title,narrativeType:actualStep.narrative_type,elementType:actualStep.element_type,context:actualStep.context,answers:actualStep.answers,more_info:actualStep.more_info};break;default:break;}return data;}

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(458);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConnectionUser=function(_Component){_inherits(ConnectionUser,_Component);function ConnectionUser(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConnectionUser);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConnectionUser.__proto__||Object.getPrototypeOf(ConnectionUser)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(){var _this$props=_this.props,onClick=_this$props.onClick,id=_this$props.connection.id;onClick(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConnectionUser,[{key:'render',value:function render(){var connection=this.props.connection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" ],{onClick:this.handleClick},connection.avatar!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" ],{alt:connection.firstname,src:connection.avatar}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" ],{className:'text-avatar'},connection.firstname.slice(0,1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["c" ],null,connection.firstname+' '+connection.lastname));}}]);return ConnectionUser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConnectionUser.propTypes={connection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (ConnectionUser);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(451);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivacyElement=function(_Component){_inherits(PrivacyElement,_Component);function PrivacyElement(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrivacyElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrivacyElement.__proto__||Object.getPrototypeOf(PrivacyElement)).call.apply(_ref,[this].concat(args))),_this),_this.changeLevel=function(level){var _this$props=_this.props,element=_this$props.element,onChange=_this$props.onChange;if(onChange){onChange(element.id,level);}},_this.selectLevel0=function(event){_this.changeLevel(0);event.stopPropagation();},_this.selectLevel1=function(event){_this.changeLevel(1);event.stopPropagation();},_this.selectLevel2=function(event){_this.changeLevel(2);event.stopPropagation();},_this.selectLevel3=function(event){_this.changeLevel(3);event.stopPropagation();},_this.handleClick=function(event){var _this$props2=_this.props,onClick=_this$props2.onClick,element=_this$props2.element;if(onClick){onClick(element.id);event.stopPropagation();}},_this.printLevelSelector=function(){var _this$props3=_this.props,color=_this$props3.color,level=_this$props3.level;if(!_this.tag){return null;}var clientRect=_this.tag.getBoundingClientRect();var top=clientRect.top-50+window.scrollY;var left=clientRect.left+clientRect.width/2-15;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["j" ],{top:top,left:left},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["i" ],{color:color,selected:level===0,onClick:_this.selectLevel0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-wifi'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["i" ],{color:color,selected:level===1,onClick:_this.selectLevel1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-user-shield'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["i" ],{color:color,selected:level===2,onClick:_this.selectLevel2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-comments'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["i" ],{color:color,selected:level===3,onClick:_this.selectLevel3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lock'})));},_this.assignRef=function(ref){_this.tag=ref;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrivacyElement,[{key:'render',value:function render(){var _props=this.props,element=_props.element,selected=_props.selected,color=_props.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,selected&&this.printLevelSelector(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag gray',color:color,selected:selected,ref:this.assignRef,onClick:this.handleClick},element.name||element.element.name));}}]);return PrivacyElement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PrivacyElement.propTypes={element:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,level:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};PrivacyElement.defaultProps={selected:false,onClick:null,onChange:null}; __webpack_exports__["a"] = (PrivacyElement);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "w", function() { return UserCardWrapper; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return NoData; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return Close; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonEditResume; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarWrapper; });
 __webpack_require__.d(__webpack_exports__, "v", function() { return UserAvatar; });
 __webpack_require__.d(__webpack_exports__, "x", function() { return UserName; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return MainButtons; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ButtonNormal; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return ButtonSuccess; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonDanger; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return ProfileTabs; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return ProfileTab; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return TabContent; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return ProfileSection; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return ProfileContent; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return ProfileAnswer; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return RelationsList; });



 __webpack_require__.d(__webpack_exports__, "h", function() { return ConnectionsWrapper; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return ProfileSectionTitle; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return NarrativeTitle; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return NarrativeQuestions; });
 __webpack_require__.d(__webpack_exports__, "u", function() { return TextLabel; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return Combobox; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_InputLabel__ = __webpack_require__(177);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Select__ = __webpack_require__(250);
 var __WEBPACK_IMPORTED_MODULE_4_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  max-height: 100%;\n  max-width: 100%;\n  overflow-y: scroll;\n  background-color: ',';\n  font-size: 0;\n  padding: 10px;\n'],['\n  max-height: 100%;\n  max-width: 100%;\n  overflow-y: scroll;\n  background-color: ',';\n  font-size: 0;\n  padding: 10px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 80%;\n  background-color: white;\n  color: ',';\n  font-size: 1.8rem;\n  text-align: center;\n  border-radius: 2rem;\n  padding: 2rem;\n  margin: 2rem auto;\n\n  @media (max-width: ','px) {\n    font-size: 1.4rem;\n    padding: 1rem;\n  }\n'],['\n  width: 80%;\n  background-color: white;\n  color: ',';\n  font-size: 1.8rem;\n  text-align: center;\n  border-radius: 2rem;\n  padding: 2rem;\n  margin: 2rem auto;\n\n  @media (max-width: ','px) {\n    font-size: 1.4rem;\n    padding: 1rem;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  text-align: center;\n  line-height: 20px;\n  background-color: #fff;\n  border-radius: 50%;\n  padding-top: 4px;\n  z-index: 10;\n\n  i {\n    font-size: 12px;\n    color: #4d4d4d;\n  }\n'],['\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  text-align: center;\n  line-height: 20px;\n  background-color: #fff;\n  border-radius: 50%;\n  padding-top: 4px;\n  z-index: 10;\n\n  i {\n    font-size: 12px;\n    color: #4d4d4d;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  margin: 0 10px;\n  border-radius: 20px;\n  text-align: center;\n  padding: 7px;\n  font-size: 14px;\n  width: 140px;\n  border: 1px solid #64DD17;\n  color: #fff;\n  background-color: #64DD17;\n  margin: 10px auto;\n'],['\n  margin: 0 10px;\n  border-radius: 20px;\n  text-align: center;\n  padding: 7px;\n  font-size: 14px;\n  width: 140px;\n  border: 1px solid #64DD17;\n  color: #fff;\n  background-color: #64DD17;\n  margin: 10px auto;\n']),_templateObject5=_taggedTemplateLiteral(['\n  position: relative;\n'],['\n  position: relative;\n']),_templateObject6=_taggedTemplateLiteral(['\n   && {\n    width: 120px;\n    height: 120px;\n    display: inline-block;\n\n    &.text-avatar {\n      font-size: 72px;\n      padding-top: 20px;\n    }\n   }\n'],['\n   && {\n    width: 120px;\n    height: 120px;\n    display: inline-block;\n\n    &.text-avatar {\n      font-size: 72px;\n      padding-top: 20px;\n    }\n   }\n']),_templateObject7=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 20px;\n  line-height: 30px;\n  font-weight: bold;\n  margin-top: 10px;\n'],['\n  color: ',';\n  font-size: 20px;\n  line-height: 30px;\n  font-weight: bold;\n  margin-top: 10px;\n']),_templateObject8=_taggedTemplateLiteral(['\n  text-align: center;\n  margin: 20px 0;\n\n  button {\n    margin: 0 10px;\n    border-radius: 20px;\n    text-align: center;\n    width: 39%;\n    padding: 7px;\n    font-size: 14px;\n    max-width: 140px;\n  }\n'],['\n  text-align: center;\n  margin: 20px 0;\n\n  button {\n    margin: 0 10px;\n    border-radius: 20px;\n    text-align: center;\n    width: 39%;\n    padding: 7px;\n    font-size: 14px;\n    max-width: 140px;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  border: 1px solid #aaa;\n  color: #666;\n  background-color: #fff;\n'],['\n  border: 1px solid #aaa;\n  color: #666;\n  background-color: #fff;\n']),_templateObject10=_taggedTemplateLiteral(['\n  border: 1px solid #558B2F;\n  color: #fff;\n  background-color: #558B2F;\n'],['\n  border: 1px solid #558B2F;\n  color: #fff;\n  background-color: #558B2F;\n']),_templateObject11=_taggedTemplateLiteral(['\n  border: 1px solid #F44336;\n  color: #fff;\n  background-color: #F44336;\n'],['\n  border: 1px solid #F44336;\n  color: #fff;\n  background-color: #F44336;\n']),_templateObject12=_taggedTemplateLiteral(['\n  background-color: rgba(0, 0, 0, 0.05);\n'],['\n  background-color: rgba(0, 0, 0, 0.05);\n']),_templateObject13=_taggedTemplateLiteral(['\n  width: calc(100% / 3);\n  display: inline-block;\n  text-align: center;\n  padding: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n\n  ',';\n\n'],['\n  width: calc(100% / 3);\n  display: inline-block;\n  text-align: center;\n  padding: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n\n  ',';\n\n']),_templateObject14=_taggedTemplateLiteral(['\n  width: 90%;\n  margin: 0 auto;\n'],['\n  width: 90%;\n  margin: 0 auto;\n']),_templateObject15=_taggedTemplateLiteral(['\n  text-transform: uppercase;\n  color: #fff;\n  font-family: \'helvetica neue\';\n  font-size: 11px;\n  margin-bottom: 20px;\n  text-align: left;\n  margin-top: 30px;\n  border-bottom: 1px solid #fff;\n  padding-bottom: 3px;\n'],['\n  text-transform: uppercase;\n  color: #fff;\n  font-family: \'helvetica neue\';\n  font-size: 11px;\n  margin-bottom: 20px;\n  text-align: left;\n  margin-top: 30px;\n  border-bottom: 1px solid #fff;\n  padding-bottom: 3px;\n']),_templateObject16=_taggedTemplateLiteral(['\n  background-color: ',';\n  > div {\n    color: #fff;\n  }\n'],['\n  background-color: ',';\n  > div {\n    color: #fff;\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  font-size: 12px;\n  margin: 10px 0 20px;\n  text-align: left;\n'],['\n  font-size: 12px;\n  margin: 10px 0 20px;\n  text-align: left;\n']),_templateObject18=_taggedTemplateLiteral(['\n\n'],['\n\n']),_templateObject19=_taggedTemplateLiteral(['\n  &.hidden {\n    display: none;\n  }\n'],['\n  &.hidden {\n    display: none;\n  }\n']),_templateObject20=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 16px;\n  margin-top: 25px;\n'],['\n  color: ',';\n  font-size: 16px;\n  margin-top: 25px;\n']),_templateObject21=_taggedTemplateLiteral(['\n  padding: 12px 0;\n  border-radius: 5px;\n  margin-bottom: 10px;\n\n  && {\n    position: relative;\n    max-width: 100%;\n    width: 100%;\n\n    .slide {\n      background: none !important;\n\n      iframe {\n        display: block;\n        width: 100%;\n        margin: 0 0px 20px;\n        border: 0;\n      }\n    }\n  }\n'],['\n  padding: 12px 0;\n  border-radius: 5px;\n  margin-bottom: 10px;\n\n  && {\n    position: relative;\n    max-width: 100%;\n    width: 100%;\n\n    .slide {\n      background: none !important;\n\n      iframe {\n        display: block;\n        width: 100%;\n        margin: 0 0px 20px;\n        border: 0;\n      }\n    }\n  }\n']),_templateObject22=_taggedTemplateLiteral(['\n  margin-top: 20px;\n\n  .slide {\n    background: none !important;\n  }\n\n  .slick-dots {\n    margin: -15px 0 15px;\n  }\n'],['\n  margin-top: 20px;\n\n  .slide {\n    background: none !important;\n  }\n\n  .slick-dots {\n    margin: -15px 0 15px;\n  }\n']),_templateObject23=_taggedTemplateLiteral(['\n  color: #fff;\n  font-family: \'helvetica neue\';\n  font-size: 11px;\n  text-transform: uppercase;\n  display: inline-block;\n  max-width: 90%;\n  vertical-align: middle;\n'],['\n  color: #fff;\n  font-family: \'helvetica neue\';\n  font-size: 11px;\n  text-transform: uppercase;\n  display: inline-block;\n  max-width: 90%;\n  vertical-align: middle;\n']),_templateObject24=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 14px;\n  background-color: #fff;\n  text-align: left;\n  padding: 3px;\n  margin: 20px auto -15px 0;\n  display: block;\n  font-weight: 600;\n  min-width: 50px;\n  width: auto;\n  font-family: \'helvetica neue\';\n'],['\n  color: ',';\n  font-size: 14px;\n  background-color: #fff;\n  text-align: left;\n  padding: 3px;\n  margin: 20px auto -15px 0;\n  display: block;\n  font-weight: 600;\n  min-width: 50px;\n  width: auto;\n  font-family: \'helvetica neue\';\n']),_templateObject25=_taggedTemplateLiteral(['\n  padding: 10px;\n  background-color: rgba(255,255,255,0.2);\n'],['\n  padding: 10px;\n  background-color: rgba(255,255,255,0.2);\n']),_templateObject26=_taggedTemplateLiteral(['\n  && {\n    text-align: left;\n    font-size: 1.6rem;\n    color: #ecf0f1;\n    transform: scale(0.75);\n    display: block;\n    margin-bottom: 0px !important;\n  }\n'],['\n  && {\n    text-align: left;\n    font-size: 1.6rem;\n    color: #ecf0f1;\n    transform: scale(0.75);\n    display: block;\n    margin-bottom: 0px !important;\n  }\n']),_templateObject27=_taggedTemplateLiteral(['\n  && {\n\n    ::before {\n      border-bottom: 0px;\n    }\n\n    .form__field__input {\n      text-align: left;\n      border-bottom: solid 1px #ecf0f1;\n    }\n\n    svg {\n      color: #ecf0f1;\n    }\n\n    option {\n      color: #444;\n    }\n  }\n'],['\n  && {\n\n    ::before {\n      border-bottom: 0px;\n    }\n\n    .form__field__input {\n      text-align: left;\n      border-bottom: solid 1px #ecf0f1;\n    }\n\n    svg {\n      color: #ecf0f1;\n    }\n\n    option {\n      color: #444;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UserCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;});var NoData=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__["b" ]);var Close=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var ButtonEditResume=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject4);var AvatarWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var UserAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject6);var UserName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_4_constants_colors__["k" ]);var MainButtons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);var ButtonNormal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject9);var ButtonSuccess=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject10);var ButtonDanger=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject11);var ProfileTabs=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12);var ProfileTab=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13,function(props){return props.active?'border-bottom: 2px solid #fff':'';});var TabContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject14);var ProfileSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject15);var ProfileContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16,function(props){return props.color;});var ProfileAnswer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17);var RelationsList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18);var RelationWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject19);var NoRelations=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject20,__WEBPACK_IMPORTED_MODULE_4_constants_colors__["k" ]);var ActionWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject21);var ConnectionsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject22);var ProfileSectionTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject23);var NarrativeTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject24,function(props){return props.color;});var NarrativeQuestions=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject25);var TextLabel=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_InputLabel__["a" ])(_templateObject26);var Combobox=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Select__["a" ])(_templateObject27);

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return UserProfileWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 60px);\n'],['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 60px);\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UserProfileWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1132);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5__components_CancelDeletionAccount__ = __webpack_require__(1133);
function mapStateToProps(state){return{literals:state.i18n.literals.cancelDeletionAccount,color:state.app.color1};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),goHome:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components_CancelDeletionAccount__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Dialog__ = __webpack_require__(256);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__ = __webpack_require__(1134);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContentText__ = __webpack_require__(257);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle__ = __webpack_require__(259);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent__ = __webpack_require__(172);
 var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(93);
 var __WEBPACK_IMPORTED_MODULE_8_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_9_components_Navbar__ = __webpack_require__(116);
 var __WEBPACK_IMPORTED_MODULE_10_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(1136);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CancelDeletionAccount=function(_Component){_inherits(CancelDeletionAccount,_Component);function CancelDeletionAccount(props){_classCallCheck(this,CancelDeletionAccount);var _this=_possibleConstructorReturn(this,(CancelDeletionAccount.__proto__||Object.getPrototypeOf(CancelDeletionAccount)).call(this,props));_this.goHome=function(){var _this$props=_this.props,history=_this$props.history,goHome=_this$props.goHome;goHome();history.push(__WEBPACK_IMPORTED_MODULE_10_constants_urls__["y" ]);};_this.handleCancelDeletion=function(){var literals=_this.props.literals;Object(__WEBPACK_IMPORTED_MODULE_8_utils_apiFetch__["b" ])('POST',{endPoint:'users/cancel-deletion'}).then(function(response){if(response.success){_this.setState({dialogOpen:true,dialogTitle:literals.cancelled,dialogText:literals.deletionAccountHasBeenCancelled});}else{_this.setState({dialogOpen:true,dialogTitle:literals.error,dialogText:literals.errorDeletion});}});};_this.handleCloseDialog=function(){_this.setState({dialogOpen:false});_this.goHome();};_this.state={dialogOpen:false,dialogTitle:'',dialogText:''};return _this;}_createClass(CancelDeletionAccount,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,setBreadcrumb=_props.setBreadcrumb,literals=_props.literals;var breadcrumb=[{color:'#ffffff',text:literals.title}];setBreadcrumb(breadcrumb.slice());}},{key:'render',value:function render(){var _props2=this.props,color=_props2.color,literals=_props2.literals;var _state=this.state,dialogOpen=_state.dialogOpen,dialogTitle=_state.dialogTitle,dialogText=_state.dialogText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["c" ],{color:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Navbar__["a" ],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["b" ],null,literals.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["a" ],{onClick:this.handleCancelDeletion},literals.cancel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Dialog__["a" ],{open:dialogOpen,onClose:this.handleCloseDialog,'aria-labelledby':'alert-dialog-title','aria-describedby':'alert-dialog-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle__["a" ],{id:'alert-dialog-title'},dialogTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContentText__["a" ],{id:'alert-dialog-description'},dialogText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__["a" ],{onClick:this.handleCloseDialog,color:'primary'},literals.close))));}}]);return CancelDeletionAccount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CancelDeletionAccount.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,goHome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (CancelDeletionAccount);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__DialogActions__ = __webpack_require__(1135);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogActions__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);






var styles = {
  
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto'
  },

  
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var DialogActions = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function DialogActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["disableSpacing", "classes", "className"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? DialogActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  disableSpacing: PropTypes.bool
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiDialogActions'
})(DialogActions));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return UserProfilesWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return Text; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonMain; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n'],['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin: 20px;\n  color: #fff;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 20px;\n'],['\n  margin: 20px;\n  color: #fff;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 20px;\n']),_templateObject3=_taggedTemplateLiteral(['\n  &:hover{\n    box-shadow: 0 0 0 62.5px rgba(255,255,255,.1) inset;\n  }\n  &:focus{\n    outline: none !important;\n  }\n  box-shadow: none;\n  background-color: transparent !important;\n  border-radius: 100%;\n  width: 125px;\n  pointer-events: all !important;\n  cursor: pointer !important;\n  height: 125px;\n  border: #fff;\n  color: #fff !important;\n  font-size: 19px;\n  align-items: center;\n  display: flex;\n  border: solid 3px white;\n  justify-content: center;\n  margin: 20px auto;\n  & > span {\n    text-transform: uppercase;\n    word-break: break-all !important;\n  }\n'],['\n  &:hover{\n    box-shadow: 0 0 0 62.5px rgba(255,255,255,.1) inset;\n  }\n  &:focus{\n    outline: none !important;\n  }\n  box-shadow: none;\n  background-color: transparent !important;\n  border-radius: 100%;\n  width: 125px;\n  pointer-events: all !important;\n  cursor: pointer !important;\n  height: 125px;\n  border: #fff;\n  color: #fff !important;\n  font-size: 19px;\n  align-items: center;\n  display: flex;\n  border: solid 3px white;\n  justify-content: center;\n  margin: 20px auto;\n  & > span {\n    text-transform: uppercase;\n    word-break: break-all !important;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UserProfilesWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;});var Text=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var ButtonMain=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1138);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1139);
function mapStateToProps(state){return{app:state.app,literals:state.i18n.literals.connections||{}};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_People__ = __webpack_require__(459);
 var __WEBPACK_IMPORTED_MODULE_3_components_Topics__ = __webpack_require__(461);
 var __WEBPACK_IMPORTED_MODULE_4_components_ElementsHall__ = __webpack_require__(474);
 var __WEBPACK_IMPORTED_MODULE_5_components_Chats__ = __webpack_require__(1213);
 var __WEBPACK_IMPORTED_MODULE_6_components_Content__ = __webpack_require__(267);
 var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(458);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function Connections(props){var literals=props.literals,app=props.app,setBreadcrumb=props.setBreadcrumb,resetAll=props.resetAll,defaultSection=props.match.params.section,history=props.history;// Breadcrumb
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var breadcrumb=[{color:'#ffffff',text:literals.connections}];setBreadcrumb(breadcrumb.slice());resetAll();},[]);// Handle tabs
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultSection||'people'),_useState2=_slicedToArray(_useState,2),selectedTab=_useState2[0],setSelectedTab=_useState2[1];var selectTab=function selectTab(event){var currentTarget=event.currentTarget;var section=currentTarget.getAttribute('data-section');history.push('/connections/'+section);setSelectedTab(section);};var printCurrentTab=function printCurrentTab(){switch(selectedTab){case'people':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_People__["a" ],null);case'topics':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Topics__["a" ],null);case'chats':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Chats__["a" ],null);case'content':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Content__["a" ],null);case app.main_element:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ElementsHall__["a" ],{type:app.main_element});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,selectedTab);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab==='topics'?'selected':''),'data-section':'topics',onClick:selectTab},literals.topics.toUpperCase()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab==='people'?'selected':''),'data-section':'people',onClick:selectTab},literals.people.toUpperCase()),app.main_element?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab===app.main_element?'selected':''),'data-section':app.main_element,onClick:selectTab},literals.elements[app.main_element].toUpperCase()||app.main_element.toUpperCase()):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab_content'},printCurrentTab())));}Connections.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (Connections);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1141);
function mapStateToProps(state){return{literals:state.i18n.literals.people||{},myConnections:state.userConnections.connections,myConnectionsRequested:state.userConnections.requested,app:state.app};}function mapDispatchToProps(dispatch){return{showLoading:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_4_components_AvatarsCollision__ = __webpack_require__(1142);
 var __WEBPACK_IMPORTED_MODULE_5_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_6_components_Cards_UserSmallCard_components__ = __webpack_require__(134);
 var __WEBPACK_IMPORTED_MODULE_7_components_FeedbackModal__ = __webpack_require__(78);
 var __WEBPACK_IMPORTED_MODULE_8_components_AvatarNew__ = __webpack_require__(262);
 var __WEBPACK_IMPORTED_MODULE_9_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_10_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_no_results_svg__ = __webpack_require__(179);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_no_results_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_images_no_results_svg__);
 var __WEBPACK_IMPORTED_MODULE_12_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_13__styles__ = __webpack_require__(263);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var GRAVITY_VIEW='gravity_view';var RECOMMENDED_VIEW='recommended_view';var IN_MY_NETWORK_VIEW='in_my_network_view';var EVERYONE_IN_HALLS='everyone_in_halls';function People(props){var elementType=props.elementType,elementId=props.elementId,literals=props.literals,app=props.app,myConnections=props.myConnections,myConnectionsRequested=props.myConnectionsRequested;var color1=app.color1;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_9_constants_status__["b" ]),_useState2=_slicedToArray(_useState,2),statusRequest=_useState2[0],setStatusRequest=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isLoading=_useState4[0],setIsLoading=_useState4[1];// Errors
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),errors=_useState6[0],setErrors=_useState6[1];var removeErrors=function removeErrors(){setErrors([]);};var printErrors=function printErrors(){if(!errors.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_FeedbackModal__["a" ],{onClose:removeErrors,open:true,success:false,text:errors.join('<br />')});};// Searcher
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState8=_slicedToArray(_useState7,2),search=_useState8[0],setSearch=_useState8[1];var handleSearcher=function handleSearcher(event){var value=event.target.value;setSearch(value);};// Tags
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState10=_slicedToArray(_useState9,2),tags=_useState10[0],setTags=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState12=_slicedToArray(_useState11,2),selectedTags=_useState12[0],setSelectedTags=_useState12[1];var loadTags=function loadTags(){var params={};if(elementType){params.element_type=elementType;}if(elementId){params.element_id=elementId;}setIsLoading(true);Object(__WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__["b" ])('GET',{endPoint:'networking-hall/people/tags'},params).then(function(response){setIsLoading(false);setTags(response.data);}).catch(function(error){setIsLoading(false);errors.push(error.response.data.error);setErrors([].concat(_toConsumableArray(errors)));});};var selectTag=function selectTag(event){var id=parseInt(event.currentTarget.getAttribute('data-id'),10);var newSelectedTags=[].concat(_toConsumableArray(selectedTags));if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(newSelectedTags,function(tagId){return tagId===id;})){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(newSelectedTags,function(tagId){return tagId===id;});}else{newSelectedTags.push(id);}setSelectedTags(newSelectedTags);};var printTags=function printTags(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tags,function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag_filter '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(selectedTags,function(tagId){return tagId===tag.id;})?'selected':''),key:tag.id,'data-id':tag.id,onClick:selectTag},tag.name);});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){loadTags();},[elementType,elementId]);// Users
var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState14=_slicedToArray(_useState13,2),users=_useState14[0],setUsers=_useState14[1];var toSearchUsers=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var searchPeople=function searchPeople(){var params={search:search,tags:selectedTags.join(',')};if(elementType){params.element_type=elementType;}if(elementId){params.element_id=elementId;}setStatusRequest(__WEBPACK_IMPORTED_MODULE_9_constants_status__["b" ]);setUsers([]);Object(__WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__["b" ])('GET',{endPoint:'networking-hall/people'},params).then(function(response){setUsers(response.data);setStatusRequest(__WEBPACK_IMPORTED_MODULE_9_constants_status__["g" ]);}).catch(function(error){errors.push(error.response.data.error);setErrors([].concat(_toConsumableArray(errors)));setStatusRequest(__WEBPACK_IMPORTED_MODULE_9_constants_status__["a" ]);});};// Select user
var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState16=_slicedToArray(_useState15,2),selectedUser=_useState16[0],setSelectedUser=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState18=_slicedToArray(_useState17,2),selectedUserFromView=_useState18[0],setSelectedUserFromView=_useState18[1];var handleClickUserBubble=function handleClickUserBubble(userId){var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,{id:userId});setSelectedUser(user);setSelectedUserFromView('');};var handleClickUserBubbleFromRecommended=function handleClickUserBubbleFromRecommended(userId){var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,{id:userId});setSelectedUser(user);setSelectedUserFromView(RECOMMENDED_VIEW);};var handleClickUserBubbleFromInMyNetwork=function handleClickUserBubbleFromInMyNetwork(userId){var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,{id:userId});setSelectedUser(user);setSelectedUserFromView(IN_MY_NETWORK_VIEW);};var handleClickUserBubbleFromGravity=function handleClickUserBubbleFromGravity(userId){var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,{id:userId});setSelectedUser(user);setSelectedUserFromView(GRAVITY_VIEW);};var handleClickUserBubbleFromEveryoneInHalls=function handleClickUserBubbleFromEveryoneInHalls(userId){var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,{id:userId});setSelectedUser(user);setSelectedUserFromView(EVERYONE_IN_HALLS);};var getRecommendedUsers=function getRecommendedUsers(){var usersFiltered=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(users,function(user){if(typeof user.negative_feedback!=='undefined'&&user.negative_feedback){return false;}return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(myConnectionsRequested,{id:user.id});});return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy([].concat(_toConsumableArray(usersFiltered)),['points_recommendations'],['desc']).slice(0,50);};var getUsersInMyNetwork=function getUsersInMyNetwork(){// return elementType ? _.intersectionBy(myConnections, users, 'id') : myConnections;
return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.intersectionBy(myConnections,users,'id');};var removeSelectedUser=function removeSelectedUser(){setSelectedUser(null);};var swipeableCards=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!selectedUser){return null;}var usersList=null;switch(selectedUserFromView){case GRAVITY_VIEW:usersList=getRecommendedUsers();break;case RECOMMENDED_VIEW:usersList=getRecommendedUsers();break;case IN_MY_NETWORK_VIEW:usersList=getUsersInMyNetwork();break;case EVERYONE_IN_HALLS:usersList=users;break;default:usersList=users;break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_UsersModal__["a" ],{usersIds:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(usersList,function(user){return user.id;}),userSelected:selectedUser.id,onEnd:removeSelectedUser});},[selectedUser]);var printSelectedUser=function printSelectedUser(){return swipeableCards;};// Users list
var gravityBubbles=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var gravityUsers=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy([].concat(_toConsumableArray(getRecommendedUsers())),['points_recommendations'],['desc']).slice(0,100);if(!gravityUsers.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gravity_bubbles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_AvatarsCollision__["a" ],{data:gravityUsers,onClick:handleClickUserBubbleFromGravity}));},[users,myConnectionsRequested]);var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState20=_slicedToArray(_useState19,2),openLists=_useState20[0],setOpenLists=_useState20[1];var expandUserList=function expandUserList(event){var title=event.currentTarget.getAttribute('data-title');var lists=[].concat(_toConsumableArray(openLists));if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(lists,function(t){return t===title;})){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(lists,function(t){return t===title;});}else{lists.push(title);}setOpenLists(lists);};var printUsersLayer=function printUsersLayer(usersToPrint,title){var onClick=arguments.length>2&&arguments[2]!==undefined?arguments[2]:handleClickUserBubble;var type=arguments[3];var className=arguments[4];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},title)),!type&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_SimpleCarousel__["a" ],{classesList:className},usersToPrint.map(function(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_AvatarNew__["a" ],{avatar:user.avatar,firstname:user.firstname,onClick:onClick,id:user.id,classList:[className],key:user.id});})),type&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_SimpleCarousel__["a" ],{classesList:'user_wrapper'},usersToPrint.map(function(elem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Cards_UserSmallCard_components__["a" ],{key:elem.id,user:elem,onClick:onClick});})));};var printRecommendedUsers=function printRecommendedUsers(){var recommendedUsers=getRecommendedUsers();if(recommendedUsers.length){return printUsersLayer(recommendedUsers,literals.recommended,handleClickUserBubbleFromRecommended,true,'recommended_users');}return null;};var printUsersInMyNetwork=function printUsersInMyNetwork(){var usersInMyNetwork=getUsersInMyNetwork();if(usersInMyNetwork.length){return printUsersLayer(usersInMyNetwork,literals.inMyNetwork,handleClickUserBubbleFromInMyNetwork,false,'my_network');}return null;};var printEveryoneInHalls=function printEveryoneInHalls(){if(users.length){return printUsersLayer(users,literals.everyoneInHalls,handleClickUserBubbleFromEveryoneInHalls,false,'everyone_in_halls');}return null;};var printNoGravityBubbles=function printNoGravityBubbles(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_11_assets_images_no_results_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noRecommendedUsers));};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){clearTimeout(toSearchUsers.current);toSearchUsers.current=setTimeout(searchPeople,1000);return function(){clearInterval(toSearchUsers.current);};},[elementType,elementId,selectedTags,search]);var printContent=function printContent(){if(statusRequest!==__WEBPACK_IMPORTED_MODULE_9_constants_status__["g" ]){return null;}if(!users.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_11_assets_images_no_results_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noUsers));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gravity_bubbles_wrapper'},gravityBubbles||printNoGravityBubbles()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lists'},printRecommendedUsers(),printUsersInMyNetwork(),printEveryoneInHalls()));};if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_LoadingComponent__["a" ],null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles__["b" ],{color:color1},printSelectedUser(),printErrors(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search_bar form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form_input_stl',type:'text',value:search,onChange:handleSearcher,placeholder:literals.searchPeople}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters_tags'},printTags()))),printContent());}People.propTypes={app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,elementType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,elementId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,myConnections:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,myConnectionsRequested:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};People.defaultProps={elementType:null,elementId:null,myConnections:[],myConnectionsRequested:[]}; __webpack_exports__["a"] = (People);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(1143);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_4__AvatarCollisionBubble__ = __webpack_require__(1144);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(460);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function AvatarsCollision(props){var data=props.data,onClick=props.onClick;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),height=_useState2[0],setHeight=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),width=_useState4[0],setWidth=_useState4[1];var div=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(node){if(node!==null){setHeight(node.getBoundingClientRect().height);setWidth(node.getBoundingClientRect().width);}},[]);var handleClick=function handleClick(user){if(onClick){onClick(user);}};var printUsers=function printUsers(){var positions=[];var isEmptySpace=function isEmptySpace(position){var isEmpty=true;var MARGIN_BUBBLE=window.innerWidth>__WEBPACK_IMPORTED_MODULE_3_constants_breakPoints__["b" ]?20:10;var positionLeft=position.left-MARGIN_BUBBLE;var positionRight=position.right+MARGIN_BUBBLE;var positionTop=position.top-MARGIN_BUBBLE;var positionBottom=position.bottom+MARGIN_BUBBLE;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(positions,function(tmp){if((tmp.left>=positionLeft&&tmp.left<=positionRight||tmp.right>=positionLeft&&tmp.right<=positionRight)&&(tmp.top>=positionTop&&tmp.top<=positionBottom||tmp.bottom>=positionTop&&tmp.bottom<=positionBottom)||(positionLeft>=tmp.left&&positionLeft<=tmp.right||positionRight>=tmp.left&&positionRight<=tmp.right)&&(positionTop>=tmp.top&&positionTop<=tmp.bottom||positionBottom>=tmp.top&&positionBottom<=tmp.bottom)){isEmpty=false;}});return isEmpty;};var findBubblePosition=function findBubblePosition(size){var maxDistanceX=width/2-size;var maxDistanceY=height/2-size;var distanceX=0;var distanceY=0;var startTop=Math.random()*40-20;var startLeft=Math.random()*40-20;var position={top:startTop,left:startLeft,right:startTop+size,bottom:startLeft+size};var tries=0;var directionY=1;var directionX=1;do{distanceX=Math.min(distanceX+10,maxDistanceX);distanceY=Math.min(distanceY+10,maxDistanceY);directionX=Math.random()>0.5?1:-1;directionY=Math.random()>0.5?1:-1;position.top=Math.random()*(distanceY*directionY);position.bottom=position.top+size;position.left=Math.random()*(distanceX*directionX);position.right=position.left+size;tries+=1;}while(!isEmptySpace(position)&&tries<1500);if(tries>=1500){var startPositionX=maxDistanceX*-1;var endPositionX=maxDistanceX;var startPositionY=maxDistanceY*-1;var endPositionY=maxDistanceY;var oldPosition=Object.assign({},position);var found=false;if(endPositionX-startPositionX>0&&endPositionY-startPositionY>0){for(var x=startPositionX;x<=endPositionX&&!found;x+=10){for(var y=startPositionY;y<=endPositionY&&!found;y+=10){position.left=x;position.top=y;position.right=x+size;position.bottom=y+size;if(isEmptySpace(position)){found=true;}}}}if(!found){position.left=oldPosition.left;position.top=oldPosition.top;position.right=oldPosition.right;position.bottom=oldPosition.bottom;}}positions.push(position);return position;};var numCells=Math.ceil(Math.sqrt(data.length));var maxWidth=Math.min(Math.floor(Math.min(width,height)/numCells),120);var minWidth=Math.ceil(maxWidth/2);var diffWidths=maxWidth-minWidth;var maxWeight=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.maxBy(data,function(user){return user.points_recommendations;}).points_recommendations;var minWeight=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.minBy(data,function(user){return user.points_recommendations;}).points_recommendations;var diffWeights=Math.max(maxWeight-minWeight,1);return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data,function(user){var points=(user.points_recommendations-minWeight)*100/diffWeights;var userWidth=points/100*diffWidths+minWidth;var position=Object.assign({},findBubblePosition(userWidth));position.top+=Math.round(height/2-userWidth/2);position.bottom+=Math.round(height/2-userWidth/2);position.left+=Math.round(width/2-userWidth/2);position.right+=Math.round(width/2-userWidth/2);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AvatarCollisionBubble__["a" ],{key:user.id,user:user,width:userWidth,position:position,onClick:handleClick});});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["b" ],{id:'avatars_collision',ref:div},printUsers());}AvatarsCollision.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (AvatarsCollision);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
 var __WEBPACK_IMPORTED_MODULE_3_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_4_react_draggable__ = __webpack_require__(169);
 var __WEBPACK_IMPORTED_MODULE_4_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_draggable__);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(460);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function AvatarCollisionBubbleComponent(props){var position=props.position,user=props.user,width=props.width,onClick=props.onClick;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),_useState2=_slicedToArray(_useState,2),zIndex=_useState2[0],setZIndex=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState4=_slicedToArray(_useState3,2),timeStartDrag=_useState4[0],setTimeStartDrag=_useState4[1];var getMaxZIndex=function getMaxZIndex(){var maxZIndex=1;// eslint-disable-next-line
window.$('.avatar_collision_bubble').each(function(){var myZIndex=parseInt(window.$(this).css('z-index'),10);maxZIndex=Math.max(maxZIndex,myZIndex);});return maxZIndex+1;};var handleStartDrag=function handleStartDrag(){setTimeStartDrag(__WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf());setZIndex(getMaxZIndex());};var handleStopDrag=function handleStopDrag(){var actualTime=__WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf();if(onClick&&(!timeStartDrag||actualTime-timeStartDrag<200)){onClick(user.id);setTimeStartDrag(0);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_draggable___default.a,{defaultPosition:{x:position.left,y:position.top},onStart:handleStartDrag,onStop:handleStopDrag,bounds:'parent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" ],{className:'avatar_collision_bubble clickable',top:position.top,left:position.left,zIndex:zIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Avatar__["a" ],{id:user.id,firstname:user.firstname,avatar:user.avatar,size:width})));}AvatarCollisionBubbleComponent.defaultProps={position:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};AvatarCollisionBubbleComponent.defaultProps={onClick:null}; __webpack_exports__["a"] = (AvatarCollisionBubbleComponent);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return UserWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_2_constants_fonts__ = __webpack_require__(17);
var _templateObject=_taggedTemplateLiteral(['\n  margin-right: 1rem;\n  max-width: 45rem;\n  min-width: 30rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  display: inline-block;\n  vertical-align: top;\n  border-radius: 1.5rem;\n  padding: 1rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border: 0.1rem solid #e9e9e9;\n  width: 30rem;\n  white-space: normal;\n  min-height: 10rem;\n  position: relative;\n  cursor: pointer;\n\n  > div {\n    display: grid;\n    grid-template-columns: 7rem calc(100% - 7rem);\n  }\n\n  .userContent {\n    margin-left: 1rem;\n  }\n\n  .name{\n    font-size: 1.4rem;\n    font-family: ',';\n    width: 85%;\n  }\n  .contributions{\n    > div:first-child {\n      font-size: 1.2rem;\n      margin-top: 1rem;\n      font-family: ',';\n      white-space: normal;\n      margin-bottom: 0.5rem;\n    }\n\n    .contribution {\n      display: inline-block;\n      margin: 0.5rem 0.5rem 0 0;\n      max-width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n  }\n\n  button {\n    margin: 1rem 0;\n  }\n\n  .voted {\n    border: none;\n    background-color: #AED7F3;\n    color: white;\n    font-family: ',';\n    border-radius: 2rem;\n    font-size: 1.2rem;\n    padding: 1rem 1rem;\n    font-weight: 600;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n  }\n\n  .delete {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    display: flex;\n    cursor: pointer;\n  }\n\n  .paperbin {\n    background: white;\n    padding: 0.5rem;\n    border-radius: 1rem;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  }\n'],['\n  margin-right: 1rem;\n  max-width: 45rem;\n  min-width: 30rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  display: inline-block;\n  vertical-align: top;\n  border-radius: 1.5rem;\n  padding: 1rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border: 0.1rem solid #e9e9e9;\n  width: 30rem;\n  white-space: normal;\n  min-height: 10rem;\n  position: relative;\n  cursor: pointer;\n\n  > div {\n    display: grid;\n    grid-template-columns: 7rem calc(100% - 7rem);\n  }\n\n  .userContent {\n    margin-left: 1rem;\n  }\n\n  .name{\n    font-size: 1.4rem;\n    font-family: ',';\n    width: 85%;\n  }\n  .contributions{\n    > div:first-child {\n      font-size: 1.2rem;\n      margin-top: 1rem;\n      font-family: ',';\n      white-space: normal;\n      margin-bottom: 0.5rem;\n    }\n\n    .contribution {\n      display: inline-block;\n      margin: 0.5rem 0.5rem 0 0;\n      max-width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n  }\n\n  button {\n    margin: 1rem 0;\n  }\n\n  .voted {\n    border: none;\n    background-color: #AED7F3;\n    color: white;\n    font-family: ',';\n    border-radius: 2rem;\n    font-size: 1.2rem;\n    padding: 1rem 1rem;\n    font-weight: 600;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n  }\n\n  .delete {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    display: flex;\n    cursor: pointer;\n  }\n\n  .paperbin {\n    background: white;\n    padding: 0.5rem;\n    border-radius: 1rem;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UserWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1147);
// import { bindActionCreators } from 'redux';
// import { fetchUserChats } from 'modules/chats';
function mapStateToProps(state){return{userChats:state.chats,user:state.session.user};}function mapDispatchToProps(){return{// fetchChats: bindActionCreators(fetchUserChats, dispatch),
};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_ChampionUser_svg__ = __webpack_require__(413);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_ChampionUser_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_ChampionUser_svg__);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_ChatBubble_svg__ = __webpack_require__(1148);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_ChatBubble_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_ChatBubble_svg__);
 var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1149);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AvatarNew=function(_Component){_inherits(AvatarNew,_Component);function AvatarNew(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AvatarNew);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AvatarNew.__proto__||Object.getPrototypeOf(AvatarNew)).call.apply(_ref,[this].concat(args))),_this),_this.state={isChatting:false},_this.checkActiveChat=function(){var _this$props=_this.props,userChats=_this$props.userChats,id=_this$props.id;var isActive=false;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(userChats.chats,function(chat){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(chat.element_related,'type')&&chat.users.length===2&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chat.users,{id:id})){isActive=true;}});return isActive;},_this.handleClick=function(){var _this$props2=_this.props,id=_this$props2.id,onClick=_this$props2.onClick,isDragging=_this$props2.isDragging;if(onClick&&!isDragging){onClick(id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AvatarNew,[{key:'componentDidMount',value:function componentDidMount(){var chatting=this.checkActiveChat();this.setState({isChatting:chatting});}},{key:'render',value:function render(){var _props=this.props,firstname=_props.firstname,avatar=_props.avatar,isChampion=_props.isChampion,invite=_props.invite,isSelected=_props.isSelected,classList=_props.classList,onClick=_props.onClick;var isChatting=this.state.isChatting;if(isChatting&&!invite){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);}var classes=[].concat(_toConsumableArray(classList));if(onClick){classes.push('clickable');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["b" ],{className:classes.join(' '),onClick:this.handleClick},isChatting&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'bubble',src:__WEBPACK_IMPORTED_MODULE_5_assets_images_ChatBubble_svg___default.a,alt:''}),isChampion&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'champion',src:__WEBPACK_IMPORTED_MODULE_4_assets_images_ChampionUser_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new_avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Avatar__["a" ],{avatar:avatar,isSelected:isSelected,firstname:firstname})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],{className:'avatar_name'},firstname));}}]);return AvatarNew;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AvatarNew.propTypes={avatar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,firstname:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isChampion:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,userChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,invite:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isDragging:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,classList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};AvatarNew.defaultProps={avatar:'',firstname:'',isChampion:false,invite:false,isSelected:false,classList:['avatar_new'],onClick:null,isDragging:false}; __webpack_exports__["a"] = (AvatarNew);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ChatBubble.5596ec05.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return AvatarNewWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarName; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100px;\n  height: 120px;\n  position: relative;\n  margin: 10px;\n  display: inline-block;\n\n  .bubble {\n    margin: 5px;\n    position: absolute;\n    width: 18px;\n    height: 15px;\n    right: 0px;\n  }\n\n  .champion {\n    position: absolute;\n    top: 10px;\n    left: 5px;\n    z-index: 1;\n  }\n\n  .new_avatar {\n    z-index: 2;\n    text-align: center;\n    margin-bottom: 1rem;\n  }\n\n'],['\n  width: 100px;\n  height: 120px;\n  position: relative;\n  margin: 10px;\n  display: inline-block;\n\n  .bubble {\n    margin: 5px;\n    position: absolute;\n    width: 18px;\n    height: 15px;\n    right: 0px;\n  }\n\n  .champion {\n    position: absolute;\n    top: 10px;\n    left: 5px;\n    z-index: 1;\n  }\n\n  .new_avatar {\n    z-index: 2;\n    text-align: center;\n    margin-bottom: 1rem;\n  }\n\n']),_templateObject2=_taggedTemplateLiteral(['\n  font-family: ','\n  font-size: 1.2rem;\n  text-align: center;\n  color: ',';\n'],['\n  font-family: ','\n  font-size: 1.2rem;\n  text-align: center;\n  color: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AvatarNewWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var AvatarName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_draggable__ = __webpack_require__(169);
 var __WEBPACK_IMPORTED_MODULE_2_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_draggable__);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_arrowRight_svg__ = __webpack_require__(1151);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_arrowRight_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_arrowRight_svg__);
 var __WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1152);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DIRECTION_RIGHT='right';var DIRECTION_LEFT='left';function SimpleCarousel(props){var children=props.children,classesList=props.classesList,defaultPosition=props.defaultPosition,onChangeSlide=props.onChangeSlide,showButtons=props.showButtons;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),classIdName=_useState2[0],setClassIdName=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState4=_slicedToArray(_useState3,2),tries=_useState4[0],setTries=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState6=_slicedToArray(_useState5,2),fitAllElements=_useState6[0],setFitAllElements=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),isDragging=_useState8[0],setIsDragging=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState10=_slicedToArray(_useState9,2),numChildren=_useState10[0],setNumChildren=_useState10[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setClassIdName('simple_carousel_'+Math.round(Math.random()*999999));},[]);var toTry=null;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!window.$('.'+classesList).length){toTry=setTimeout(function(){setTries(tries+1);},300);}return function(){if(toTry){clearTimeout(toTry);}};},[tries]);var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState12=_slicedToArray(_useState11,2),actualSlide=_useState12[0],setActualSlide=_useState12[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setActualSlide(Math.max(0,defaultPosition));},[defaultPosition]);// events
var handleDrag=function handleDrag(){setIsDragging(true);if(onChangeSlide){var scroll=0;if(window.$('.'+classIdName+':first').hasClass('is_draggable')){scroll=Math.abs(parseInt(window.$('.'+classIdName+':first > div:first').css('transform').split(',')[4].trim(),10));}else{scroll=window.$('.'+classIdName).scrollLeft();}var widthCard=window.$('.'+classesList+':first').outerWidth()+10;var actualCard=Math.floor(scroll/widthCard);if(actualCard!==actualSlide){setActualSlide(actualCard);onChangeSlide(actualCard);}}};var handleStop=function handleStop(){setTimeout(function(){setIsDragging(false);},0);};var getCarouselBounds=function getCarouselBounds(){var widthCard=window.$('.'+classesList+':first').outerWidth();var widthParent=window.$('.'+classesList+':first').parent().outerWidth();var elementsVisibles=widthParent/widthCard;var totalElements=window.$('.'+classesList+':first').parent().children().length;var offsetElements=Math.max(0,defaultPosition-Math.max(0,totalElements-elementsVisibles));var left=totalElements<=elementsVisibles?0:(totalElements-elementsVisibles)*widthCard*-1-40-offsetElements*widthCard;if(totalElements<=elementsVisibles){if(!fitAllElements){setFitAllElements(true);}}else if(fitAllElements){setFitAllElements(false);}return{right:0,left:left};};var getDefaultPosition=function getDefaultPosition(){var position=Math.max(0,defaultPosition);var bounds=getCarouselBounds();var x=0;var width=window.$('.'+classesList+':first').outerWidth();if(position>0&&!Number.isNaN(bounds.left)&&!Number.isNaN(bounds.right)){x=position*(width+10)*-1;x=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clamp(x,bounds.left,bounds.right);}return{x:x,y:0};};var setDefaultScrollPosition=function setDefaultScrollPosition(position){if(!window.$('.'+classIdName+':first').hasClass('has_scrolled')){window.$('.'+classIdName+':first').addClass('has_scrolled');setTimeout(function(){window.$('.'+classIdName+':first').scrollLeft(Math.abs(position));},100);}};// Arrows handler
var toScroll=null;var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState14=_slicedToArray(_useState13,2),scrollDirection=_useState14[0],setScrollDirection=_useState14[1];var startScrollRight=function startScrollRight(){setScrollDirection(DIRECTION_RIGHT);};var stopScrollRight=function stopScrollRight(){setScrollDirection(null);};var startScrollLeft=function startScrollLeft(){setScrollDirection(DIRECTION_LEFT);};var stopScrollLeft=function stopScrollLeft(){setScrollDirection(null);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var bounds=getCarouselBounds();if(!scrollDirection){if(toScroll){clearInterval(toScroll);}}else{toScroll=setInterval(function(){var transformArray=window.$('.'+classIdName+':first > div:first').css('transform').split(',');var scroll=parseInt(transformArray[4].trim(),10);var movement=scrollDirection===DIRECTION_LEFT?10:-10;scroll+=movement;scroll=Math.max(Math.min(0,scroll),bounds.left);transformArray[4]=scroll;window.$('.'+classIdName+':first > div:first').css('transform',transformArray.join(','));},10);}return function(){if(toScroll){clearInterval(toScroll);}};},[scrollDirection]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(children.length!==numChildren){if(children.length<numChildren){var transformArray=window.$('.'+classIdName+':first > div:first').css('transform').split(',');transformArray[4]=0;window.$('.'+classIdName+':first > div:first').css('transform',transformArray.join(','));}setNumChildren(children.length);}},[children]);var content=void 0;var positionCoords=getDefaultPosition();var bounds=getCarouselBounds();if(window.innerWidth>__WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__["b" ]&&window.$('.'+classesList).length&&!Number.isNaN(bounds.left)){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative'}},showButtons&&!fitAllElements?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],{direction:'left',onMouseDown:startScrollLeft,onMouseUp:stopScrollLeft},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'left',src:__WEBPACK_IMPORTED_MODULE_4_assets_images_arrowRight_svg___default.a,alt:''})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["b" ],{className:'nowrap simple_carousel '+classIdName+' is_draggable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_draggable___default.a,{axis:'x',bounds:bounds,defaultPosition:positionCoords,onDrag:handleDrag,onStop:handleStop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children,function(child){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child,{isDragging:isDragging});})))),showButtons&&!fitAllElements?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],{direction:'right',onMouseDown:startScrollRight,onMouseUp:stopScrollRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_assets_images_arrowRight_svg___default.a,alt:''})):null);}else{content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["b" ],{className:'nowrap simple_carousel '+classIdName,onScroll:handleDrag},children);if(positionCoords.x!==0){setDefaultScrollPosition(positionCoords.x);}}return content;}SimpleCarousel.propTypes={defaultPosition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,classesList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onChangeSlide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,showButtons:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};SimpleCarousel.defaultProps={defaultPosition:0,onChangeSlide:null,showButtons:false}; __webpack_exports__["a"] = (SimpleCarousel);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowRight.521e18c8.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return Content; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonScroll; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 0 0rem 1rem;\n\n  &.nowrap {\n    white-space: nowrap;\n    overflow: hidden;\n\n    @media (max-width: ','px) {\n      overflow: auto;\n    }\n  }\n'],['\n  padding: 0 0rem 1rem;\n\n  &.nowrap {\n    white-space: nowrap;\n    overflow: hidden;\n\n    @media (max-width: ','px) {\n      overflow: auto;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  color: red;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  background: white;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 4rem;\n  width: 4rem;\n  cursor: pointer;\n  left: ',';\n  right: ',';\n  top: calc(50% - 2rem);\n  position: absolute;\n\n  @media (max-width: ','px) {\n    display: none;\n  }\n\n  img {\n    padding: 4rem;\n    &.left{\n      transform: rotate(180deg);\n    }\n  }\n'],['\n  color: red;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  background: white;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 4rem;\n  width: 4rem;\n  cursor: pointer;\n  left: ',';\n  right: ',';\n  top: calc(50% - 2rem);\n  position: absolute;\n\n  @media (max-width: ','px) {\n    display: none;\n  }\n\n  img {\n    padding: 4rem;\n    &.left{\n      transform: rotate(180deg);\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var ButtonScroll=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.direction==='left'?'-6rem':'auto';},function(props){return props.direction==='left'?'auto':'-6rem';},__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1154);
function mapStateToProps(state){return{literals:state.i18n.literals.topics,app:state.app,actualUser:state.session.user};}function mapDispatchToProps(dispatch){return{showLoading:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_6_components_FeedbackModal__ = __webpack_require__(78);
 var __WEBPACK_IMPORTED_MODULE_7_components_ThemeTablesBubbles__ = __webpack_require__(462);
 var __WEBPACK_IMPORTED_MODULE_8_components_Steps_Faces__ = __webpack_require__(95);
 var __WEBPACK_IMPORTED_MODULE_9_components_AutocompleteInput__ = __webpack_require__(96);
 var __WEBPACK_IMPORTED_MODULE_10_components_Cards_ElementSimpleCard__ = __webpack_require__(265);
 var __WEBPACK_IMPORTED_MODULE_11_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_12_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_13_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_14_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_15_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_16_assets_images_no_results_svg__ = __webpack_require__(179);
 var __WEBPACK_IMPORTED_MODULE_16_assets_images_no_results_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_assets_images_no_results_svg__);
 var __WEBPACK_IMPORTED_MODULE_17_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_18_assets_images_addLogo_svg__ = __webpack_require__(473);
 var __WEBPACK_IMPORTED_MODULE_18_assets_images_addLogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_assets_images_addLogo_svg__);
 var __WEBPACK_IMPORTED_MODULE_19_components_People_components_styles__ = __webpack_require__(263);
 var __WEBPACK_IMPORTED_MODULE_20__styles__ = __webpack_require__(1208);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function Topics(props){var elementType=props.elementType,elementId=props.elementId,literals=props.literals,app=props.app,history=props.history,actualUser=props.actualUser;var color1=app.color1;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),topics=_useState2[0],setTopics=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_13_constants_status__["b" ]),_useState4=_slicedToArray(_useState3,2),statusRequest=_useState4[0],setStatusRequest=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState6=_slicedToArray(_useState5,2),selectedTopic=_useState6[0],setSelectedTopic=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),isLoading=_useState8[0],setIsLoading=_useState8[1];// Errors
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState10=_slicedToArray(_useState9,2),errors=_useState10[0],setErrors=_useState10[1];var removeErrors=function removeErrors(){setErrors([]);};var printErrors=function printErrors(){if(!errors.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_FeedbackModal__["a" ],{onClose:removeErrors,open:true,success:false,text:errors.join('<br />')});};// Tags
var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState12=_slicedToArray(_useState11,2),tags=_useState12[0],setTags=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState14=_slicedToArray(_useState13,2),selectedTags=_useState14[0],setSelectedTags=_useState14[1];// Searcher
var handleSearcher=function handleSearcher(value){var valueId=parseInt(value,10);var newSelectedTags=[].concat(_toConsumableArray(selectedTags));if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(newSelectedTags,function(tagValue){return tagValue===valueId;})){newSelectedTags.push(valueId);}var newTags=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(tags,{id:valueId}).concat(tags);setSelectedTags(newSelectedTags);setTags(newTags);};var handleSelectOptionSearcher=function handleSelectOptionSearcher(option){handleSearcher(option.id);};var printSearcher=function printSearcher(){var options=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tags,function(tag){return{value:tag.id,label:tag.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_AutocompleteInput__["a" ],{type:'tag',placeholder:literals.searchTopics,onSelectOption:handleSelectOptionSearcher,options:options,async:false});};// Load data
var searchTopics=function searchTopics(){var params={};if(elementType){params.element_type=elementType;}if(elementId){params.element_id=elementId;}setSelectedTopic(0);setTopics([]);setTags([]);setStatusRequest(__WEBPACK_IMPORTED_MODULE_13_constants_status__["b" ]);setIsLoading(true);Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('GET',{endPoint:'networking-hall/topics'},params).then(function(response){setIsLoading(false);var finalTags=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(response.data,function(topic){if(typeof topic.related_elements!=='undefined'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topic.related_elements,function(element){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(finalTags,{id:element.id})){finalTags.push(element);}});}});setTags(finalTags);setTopics(response.data);setStatusRequest(__WEBPACK_IMPORTED_MODULE_13_constants_status__["g" ]);}).catch(function(error){setIsLoading(false);errors.push(error.response.data.error);setErrors([].concat(_toConsumableArray(errors)));setStatusRequest(__WEBPACK_IMPORTED_MODULE_13_constants_status__["a" ]);});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){searchTopics();},[elementType,elementId]);// Filter by tags
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!selectedTags.length){window.$('.theme_bubble').removeClass('not_pass_filter');}else{__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topics,function(topic){var hasTag=false;if(typeof topic.related_elements!=='undefined'){hasTag=true;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(selectedTags,function(selectedTag){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(topic.related_elements,{id:selectedTag})){hasTag=false;}});}if(hasTag){window.$('.theme_bubble[data-id='+topic.id+']').removeClass('not_pass_filter');}else{window.$('.theme_bubble[data-id='+topic.id+']').addClass('not_pass_filter');}});}},[selectedTags]);var selectTag=function selectTag(event){var id=parseInt(event.currentTarget.getAttribute('data-id'),10);var newSelectedTags=[].concat(_toConsumableArray(selectedTags));if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(newSelectedTags,function(tagId){return tagId===id;})){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(newSelectedTags,function(tagId){return tagId===id;});}else{newSelectedTags.push(id);}setSelectedTags(newSelectedTags);};var printTags=function printTags(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tags,function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag_filter '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(selectedTags,function(selectedTag){return selectedTag===tag.id;})?'selected':''),key:tag.id,'data-id':tag.id,onClick:selectTag},tag.name);});};// Select user
var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState16=_slicedToArray(_useState15,2),selectedUser=_useState16[0],setSelectedUser=_useState16[1];var handleClickUserBubble=function handleClickUserBubble(userId){var users=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topics,function(topic){if(!selectedTopic||selectedTopic===topic.id){users=users.concat(topic.users);}});var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,{id:userId});setSelectedUser(user);};var removeSelectedUser=function removeSelectedUser(){setSelectedUser(null);};var printSelectedUser=function printSelectedUser(){if(!selectedUser){return null;}var users=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topics,function(topic){if(!selectedTopic||selectedTopic===topic.id){users=users.concat(topic.users);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_UsersModal__["a" ],{usersIds:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(users,function(user){return user.id;}),userSelected:selectedUser.id,onEnd:removeSelectedUser});};// Selected topic
var goToTable=function goToTable(id){if(id){setSelectedTopic(id);history.push('/theme-table/'+id);}};var printUsers=function printUsers(){var users=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topics,function(topic){if(!selectedTopic||selectedTopic===topic.id){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topic.users,function(user){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,{id:user.id})){users.push(user);}});}});if(!users.length){return null;}var title=literals.peopleInAllTables;if(selectedTopic){var topic=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(topics,{id:selectedTopic});title=literals.peopleIn+' '+topic.name;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_SimpleCarousel__["a" ],{classesList:'face_bubble'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Steps_Faces__["a" ],{options:users,onClick:handleClickUserBubble,onLongPress:handleClickUserBubble})));};var printMainElements=function printMainElements(){if(!app.main_element){return null;}var mainElements=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topics,function(_ref){var users=_ref.users;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(users,function(_ref2){var elements=_ref2.elements;if(typeof elements[app.main_element]!=='undefined'&&elements[app.main_element].length){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(elements[app.main_element],function(element){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(mainElements,{id:element.id})){mainElements.push(element);}});}});});if(!mainElements.length){return null;}var title=(literals.elements[app.main_element]||app.main_element)+' ';if(selectedTopic){var topic=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(topics,{id:selectedTopic});title+=literals.in+' '+topic.name;}else{title+=literals.inAllTables;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_SimpleCarousel__["a" ],{classesList:'simple_card_element'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(mainElements,function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Cards_ElementSimpleCard__["a" ],{data:element,key:element.id,classesList:['simple_card_element']});})));};var showTopicDetailView=function showTopicDetailView(){switch(elementType){case __WEBPACK_IMPORTED_MODULE_15_constants_types__["a" ]:history.push('/calls/'+elementId+'/theme-table/'+selectedTopic);break;default:history.push('/theme-table/'+selectedTopic);break;}};var printSelectedTopic=function printSelectedTopic(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,printUsers(),printMainElements(),selectedTopic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:showTopicDetailView},literals.viewDetails))):null);};var handleCreateThinkChat=function handleCreateThinkChat(){var url=__WEBPACK_IMPORTED_MODULE_14_constants_urls__["Q" ];if(elementType===__WEBPACK_IMPORTED_MODULE_15_constants_types__["a" ]){url=url+'/call/'+elementId;}history.push(url);};var printCreateTableButton=function printCreateTableButton(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:handleCreateThinkChat},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_18_assets_images_addLogo_svg___default.a,alt:''})));};var printGravityBubbles=function printGravityBubbles(){if(!topics.length){return null;}var maxPoints=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.maxBy(topics,'points').points;var minPoints=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.minBy(topics,'points').points;var difference=Math.max(maxPoints-minPoints,1);var interval=difference/3;var limitBig=maxPoints-interval;var limitMedium=limitBig-interval;var finalTopics=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(topics,function(topic){var color='#BBE8F8';switch(topic.type){case'think_seed':color=topic.status.id===21227337?'#ddd':app.color1;break;case'think_tank':color='#3BBCEB';break;default:color='#F4F4F4';break;}var size='xs';if(topic.points>=limitBig){size='lg';}else if(topic.points>=limitMedium){size='md';}var satellites=[];var mainElements=[];var isInTable=false;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topic.users,function(user){if(actualUser&&actualUser.id===user.id){isInTable=true;}var userSize='xs';var satellite={id:user.id,name:user.firstname+' '+user.lastname,image:user.avatar,size:userSize};satellites.push(satellite);if(app.main_element&&user.elements[app.main_element]){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(user.elements[app.main_element],function(element){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(mainElements,{id:element.id})){var finalElement={id:element.id,name:element.name,image:element.image};mainElements.push(finalElement);}});}});var isNew=Math.floor((__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix()-topic.timestamp)/86400)<=2;var finalTopic={id:topic.id,name:topic.name,image:topic.image,tags:typeof topic.related_elements!=='undefined'?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(topic.related_elements,function(tag){return tag.name;}):[],color:color,size:size,satellites:satellites,isNew:isNew,inline_elements:mainElements,highlighted:isInTable};return finalTopic;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'theme_tables_wrapper '+(elementType?'with_header':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ThemeTablesBubbles__["a" ],{data:finalTopics,onClick:goToTable// onFullscreen={changeFullscreen}
}));};var gravityBubbles=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gravity_bubbles_wrapper'},printGravityBubbles());},[topics]);var printContent=function printContent(){if(statusRequest!==__WEBPACK_IMPORTED_MODULE_13_constants_status__["g" ]){return null;}if(!topics.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_16_assets_images_no_results_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noTopics));}var lists=selectedTopic||window.outerWidth<=__WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__["b" ]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lists'},printSelectedTopic()):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content gravity_bubbles fullscreen'},gravityBubbles,lists);};if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_People_components_styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_LoadingComponent__["a" ],null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_People_components_styles__["b" ],{color:color1},printErrors(),printSelectedUser(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search_bar form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_input'},printSearcher(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters_tags'},printTags()))),printContent()),printCreateTableButton());}Topics.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,actualUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,elementType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,elementId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};Topics.defaultProps={elementType:null,elementId:null,actualUser:null}; __webpack_exports__["a"] = (Topics);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1156);
function mapStateToProps(state){return{literals:state.i18n.literals.themeTablesBubbles};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_4_react_draggable__ = __webpack_require__(169);
 var __WEBPACK_IMPORTED_MODULE_4_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_draggable__);
 var __WEBPACK_IMPORTED_MODULE_5_material_ui_slider__ = __webpack_require__(1157);
 var __WEBPACK_IMPORTED_MODULE_5_material_ui_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_slider__);
 var __WEBPACK_IMPORTED_MODULE_6_components_AffiliationCard__ = __webpack_require__(470);
 var __WEBPACK_IMPORTED_MODULE_7_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(472);
 var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(1200);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function ThemeTablesBubbles(props){var data=props.data,literals=props.literals,onClick=props.onClick,onFullscreen=props.onFullscreen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState2=_slicedToArray(_useState,2),heightComponent=_useState2[0],setHeightComponent=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({width:0,height:0}),_useState4=_slicedToArray(_useState3,2),containerSize=_useState4[0],setContainerSize=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),bubbles=_useState6[0],setBubbles=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({left:0,right:0,top:0,bottom:0}),_useState8=_slicedToArray(_useState7,2),bounds=_useState8[0],setBounds=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(50),_useState10=_slicedToArray(_useState9,2),zoom=_useState10[0],setZoom=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1.3),_useState12=_slicedToArray(_useState11,2),scale=_useState12[0],setScale=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({x:0,y:0}),_useState14=_slicedToArray(_useState13,2),positionDraggable=_useState14[0],setPositionDraggable=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState16=_slicedToArray(_useState15,2),renderNumber=_useState16[0],setRenderNumber=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({width:0,height:0}),_useState18=_slicedToArray(_useState17,2),lastSizeParent=_useState18[0],setLastSizeParent=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),hasDrag=_useState20[0],setHasDrag=_useState20[1];// Rerender
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setRenderNumber(renderNumber+1);},[bubbles,zoom,containerSize,positionDraggable]);// Zoom
var changeZoom=function changeZoom(value){var newScale=value*0.02+0.3;setZoom(value);setScale(newScale);};// Set sizes and positions
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){changeZoom(75);var positions=[];var isEmptySpace=function isEmptySpace(position){var isEmpty=true;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(positions,function(tmp){var positionLeft=position.left-__WEBPACK_IMPORTED_MODULE_8__constants__["e" ];var positionRight=position.right+__WEBPACK_IMPORTED_MODULE_8__constants__["e" ];var positionTop=position.top-__WEBPACK_IMPORTED_MODULE_8__constants__["e" ];var positionBottom=position.bottom+__WEBPACK_IMPORTED_MODULE_8__constants__["e" ];if((tmp.left>=positionLeft&&tmp.left<=positionRight||tmp.right>=positionLeft&&tmp.right<=positionRight)&&(tmp.top>=positionTop&&tmp.top<=positionBottom||tmp.bottom>=positionTop&&tmp.bottom<=positionBottom)||(positionLeft>=tmp.left&&positionLeft<=tmp.right||positionRight>=tmp.left&&positionRight<=tmp.right)&&(positionTop>=tmp.top&&positionTop<=tmp.bottom||positionBottom>=tmp.top&&positionBottom<=tmp.bottom)){isEmpty=false;}});return isEmpty;};var findBubblePosition=function findBubblePosition(bubble){var numPositions=positions.length;var size=__WEBPACK_IMPORTED_MODULE_8__constants__["a" ][bubble.size];var mod=numPositions%8;var dirX=0;var dirY=0;var desv=__WEBPACK_IMPORTED_MODULE_8__constants__["b" ];var desvHalf=__WEBPACK_IMPORTED_MODULE_8__constants__["b" ]/2;switch(mod){case 1:// To the right
dirX=10+Math.random()*desv-desvHalf;dirY=Math.random()*desv-desvHalf;break;case 2:// To the left
dirX=-10+Math.random()*desv-desvHalf;dirY=Math.random()*desv-desvHalf;break;case 3:// To the bottom
dirY=10+Math.random()*desv-desvHalf;dirX=Math.random()*desv-desvHalf;break;case 4:// To the top
dirY=-10+Math.random()*desv-desvHalf;dirX=Math.random()*desv-desvHalf;break;case 5:// To the Noreast
dirY=-10+Math.random()*desv-desvHalf;dirX=10+Math.random()*desv-desvHalf;break;case 6:// To the Southeast
dirY=10+Math.random()*desv-desvHalf;dirX=10+Math.random()*desv-desvHalf;break;case 7:// To the Northwest
dirY=-10+Math.random()*desv-desvHalf;dirX=-10+Math.random()*desv-desvHalf;break;default:// To the southwest
dirY=10+Math.random()*desv-desvHalf;dirX=-10+Math.random()*desv-desvHalf;break;}var position={top:0,left:0,right:size,bottom:size};var tries=0;while(!isEmptySpace(position)&&tries<1500){position.top+=dirY;position.bottom+=dirY;position.left+=dirX;position.right+=dirX;tries+=1;}positions.push(position);return position;};if(data.length){setBubbles([].concat(_toConsumableArray(data)));var newBubbles=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data,function(bubble){var extendBubble=Object.assign({},bubble);if(typeof extendBubble.size==='undefined'){extendBubble.size='xs';}extendBubble.position=findBubblePosition(extendBubble);return extendBubble;});// Normalize positions
var minLeft=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.minBy(newBubbles,'position.left').position.left;var maxRight=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.maxBy(newBubbles,'position.right').position.right;var minTop=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.minBy(newBubbles,'position.top').position.top;var maxBottom=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.maxBy(newBubbles,'position.bottom').position.bottom;var increaseLeft=Math.abs(minLeft);var increaseTop=Math.abs(minTop);var normalizeBubbles=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(newBubbles,function(bubble){return Object.assign({},bubble,{position:{left:bubble.position.left+increaseLeft+__WEBPACK_IMPORTED_MODULE_8__constants__["f" ],right:bubble.position.right+increaseLeft+__WEBPACK_IMPORTED_MODULE_8__constants__["f" ],top:bubble.position.top+increaseTop+__WEBPACK_IMPORTED_MODULE_8__constants__["f" ],bottom:bubble.position.bottom+increaseTop+__WEBPACK_IMPORTED_MODULE_8__constants__["f" ]}});});setBubbles(normalizeBubbles);var newContainerSize={width:maxRight+increaseLeft+__WEBPACK_IMPORTED_MODULE_8__constants__["f" ]*2,height:maxBottom+increaseTop+__WEBPACK_IMPORTED_MODULE_8__constants__["f" ]*2};setContainerSize(newContainerSize);var newHeightComponent=window.$('#themeTablesGrid').parent().outerHeight();setHeightComponent(newHeightComponent);}},[data]);// Calculate bounds
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var newHeightComponent=window.$('.theme_tables_overflow:first').outerHeight();var newWidthComponent=window.$('.theme_tables_overflow:first').outerWidth();var diffX=containerSize.width-newWidthComponent;var diffY=containerSize.height-newHeightComponent;var scaleX=(containerSize.width*scale-containerSize.width)/2;var scaleY=(containerSize.height*scale-containerSize.height)/2;var left=Math.min(diffX*-1-scaleX,scaleX);var right=Math.max(diffX*-1-scaleX,scaleX);var top=Math.min(diffY*-1-scaleY,scaleY);var bottom=Math.max(diffY*-1-scaleY,scaleY);var newBounds={left:left,right:right,top:top,bottom:bottom};setBounds(newBounds);},[containerSize,zoom,lastSizeParent]);var printSatellitesInOrbit=function printSatellitesInOrbit(satellites){var satellitesBubbles=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(satellites.slice(0,__WEBPACK_IMPORTED_MODULE_8__constants__["g" ]),function(satellite,key){var size='xs';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["b" ],{className:'sat_'+key,key:satellite.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Avatar__["a" ],{firstname:satellite.firstname||satellite.name,avatar:satellite.avatar||satellite.image||satellite.logo,id:satellite.id,size:__WEBPACK_IMPORTED_MODULE_8__constants__["h" ][size]}));});if(satellitesBubbles.length<satellites.length){var numSatellite=satellitesBubbles.length;var difference=satellites.length-satellitesBubbles.length;satellitesBubbles.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["b" ],{key:0,className:'sat_'+numSatellite+' more_indicator'},'+'+difference));}return satellitesBubbles;};var handleClickBubble=function handleClickBubble(event){var target=event.currentTarget;var id=parseInt(target.getAttribute('data-id'),10);// history.push(`/theme-table/${id}`);
onClick(id);};var handleClickDraggable=function handleClickDraggable(event){var target=event.target;if(typeof onClick==='function'&&!window.$(target).hasClass('theme_bubble')&&!window.$(target).parents('.theme_bubble').length){onClick(0);}};var printBubbles=function printBubbles(){if(!bubbles.length){return null;}return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(bubbles,function(bubble){var color=bubble.color,size=bubble.size,position=bubble.position;var showSatellitesInOrbit=scale>=__WEBPACK_IMPORTED_MODULE_8__constants__["i" ][size]&&bubble.satellites&&bubble.satellites.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["a" ],{'data-id':bubble.id,key:bubble.id,className:size+' theme_bubble',color:color,style:{top:position.top,left:position.left},onTouchStart:handleClickBubble,onClick:handleClickBubble,image:bubble.image,highlighted:bubble.highlighted},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity'}),showSatellitesInOrbit?printSatellitesInOrbit(bubble.satellites):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bubble_content'},scale>=__WEBPACK_IMPORTED_MODULE_8__constants__["c" ][size]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name',title:bubble.name},bubble.name,typeof bubble.isNew!=='undefined'&&bubble.isNew?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'is_new'},literals.isNew):null):null));});};// Draggabble
var checkParentSize=function checkParentSize(){var newHeightParent=window.$('#themeTablesGrid').parent().outerHeight();var newWidthParent=window.$('#themeTablesGrid').parent().outerWidth();if(lastSizeParent.width!==newWidthParent||lastSizeParent.height!==newHeightParent){setLastSizeParent({width:newWidthParent,height:newHeightParent});}};var handleDragStart=function handleDragStart(){checkParentSize();};var handleDragStop=function handleDragStop(event,eventData){var x=positionDraggable.x,y=positionDraggable.y;var diff=Math.abs(eventData.x-x)+Math.abs(eventData.y-y);setPositionDraggable({x:eventData.x,y:eventData.y});if(diff>5){setHasDrag(true);setTimeout(function(){setHasDrag(false);},200);}};// Check position is out of bounds
var checkBounds=function checkBounds(){if(bounds&&positionDraggable.x&&positionDraggable.y&&bounds.top!==bounds.bottom&&bounds.left!==bounds.right){var newPositionDraggable={y:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clamp(positionDraggable.y,bounds.top,bounds.bottom),x:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clamp(positionDraggable.x,bounds.left,bounds.right)};setPositionDraggable(newPositionDraggable);}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){checkBounds();},[bounds]);// Set initialposition
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var newHeightComponent=window.$('#themeTablesGrid').parent().outerHeight();var newWidthComponent=window.$('#themeTablesGrid').parent().outerWidth();var newX=(containerSize.width*scale-newWidthComponent)/2;var newY=(containerSize.height*scale-newHeightComponent)/2;setPositionDraggable({x:newX*-1,y:newY*-1});checkParentSize();},[containerSize]);// Handle wheel
var handleWheel=function handleWheel(event){var newZoom=event.deltaY<0?zoom+__WEBPACK_IMPORTED_MODULE_8__constants__["j" ]:zoom-__WEBPACK_IMPORTED_MODULE_8__constants__["j" ];changeZoom(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clamp(newZoom,0,100));};var template=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["c" ],{id:'themeTablesGrid',height:heightComponent,scale:scale,size:containerSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'theme_tables_overflow',onWheel:handleWheel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_draggable___default.a,{bounds:bounds,onStart:handleDragStart,onStop:handleDragStop,defaultPosition:{x:positionDraggable.x,y:positionDraggable.y},position:{x:positionDraggable.x,y:positionDraggable.y},scale:scale,onMouseDown:handleClickDraggable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["d" ],{scale:scale,size:containerSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,printBubbles())))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'options_wrapper'},onFullscreen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-fullscreen',onClick:onFullscreen},literals.fullscreen,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-expand'})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_slider__["Slider"],{value:zoom,'aria-labelledby':'discrete-slider-small-steps',step:5,marks:true,onChange:changeZoom,min:0,max:100,valueLabelDisplay:'auto'}))));},[renderNumber]);return template;}ThemeTablesBubbles.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onFullscreen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};ThemeTablesBubbles.defaultProps={onClick:null,onFullscreen:null}; __webpack_exports__["a"] = (ThemeTablesBubbles);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _src = __webpack_require__(1158);

Object.keys(_src).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _src[key];
    }
  });
});


 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _slider.default;
  }
});

var _slider = _interopRequireDefault(__webpack_require__(1159));

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Slider = _interopRequireDefault(__webpack_require__(1160));

var _default = _Slider.default;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(463));

var _createClass2 = _interopRequireDefault(__webpack_require__(464));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(465));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(467));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(466));

var _inherits2 = _interopRequireDefault(__webpack_require__(468));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1162));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _lodash = _interopRequireDefault(__webpack_require__(1163));

var _lodash2 = _interopRequireDefault(__webpack_require__(1164));

var _lodash3 = _interopRequireDefault(__webpack_require__(1165));

var _lodash4 = _interopRequireDefault(__webpack_require__(456));

var _styles = __webpack_require__(469);

var _libs = __webpack_require__(1173);

var _slider = __webpack_require__(1175);

var styles = function styles(theme) {
  return {
    warp: {
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    trackContainer: {
      width: "100%",
      height: "100%"
    },
    track: {
      position: "absolute",
      transition: "margin 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, height 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, left 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, right 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, top 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, bottom 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms"
    },
    pointer: {
      marginTop: 1,
      width: 12,
      height: 12,
      backgroundClip: "padding-box",
      border: "0px solid transparent",
      borderRadius: "50%",
      boxSizing: "border-box",
      position: "absolute",
      cursor: "pointer",
      pointerEvents: "inherit",
      transform: "translate(-50%, -50%)",
      transition: "background 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, border-color 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, height 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, left 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, right 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, top 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, bottom 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
      overflow: "visible",
      outline: "none",
      zIndex: 1
    },
    pointerRight: {
      transform: "translate(50%, -50%)"
    },
    pointerVertical: {
      marginLeft: 1,
      transform: "translate(-50%, 50%)"
    },
    pointerVerticalTop: {
      transform: "translate(-50%, -50%)"
    },
    pointerOver: {
      "&:before": {
        content: '""',
        display: "block",
        border: "0 solid ".concat(theme.palette.action.hover),
        position: "absolute",
        overflow: "hidden",
        borderRadius: "inherit",
        boxSizing: "border-box",
        pointerEvents: "none",
        transition: "border 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, width 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, height 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, top 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, top 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, bottom 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        zIndex: -1
      }
    },
    pointerHover: {
      "&:before": {
        width: 36,
        height: 36,
        borderWidth: 12,
        left: -12,
        top: -12
      }
    },
    pointerPressed: {
      "&:before": {
        width: 48,
        height: 48,
        borderWidth: 18,
        borderColor: theme.palette.action.selected,
        left: -18,
        top: -18
      }
    },
    pointerDisabled: {
      width: 8,
      height: 8
    },
    scale: {
      position: "absolute"
    }
  };
};

var Slider =

function (_Component) {
  (0, _inherits2.default)(Slider, _Component);

  function Slider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Slider);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Slider).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "min", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "max", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "activePointer", "left");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "calcDefaultValue", function (defaultValue) {
      var range = _this.props.range;

      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
          min = _assertThisInitialize.min,
          max = _assertThisInitialize.max;

      if (range) {
        var value = _this.state ? _this.state.value : [min, max];

        if (Array.isArray(defaultValue)) {
          var value1 = (0, _lodash3.default)(defaultValue[0]) ? defaultValue[0] : min;
          var value2 = (0, _lodash3.default)(defaultValue[1]) ? defaultValue[1] : max;
          var valueMin = Math.min(value1, value2);
          var valueMax = Math.max(value1, value2);
          value[0] = _this.calcScaleValue(valueMin >= min && valueMin <= max ? valueMin : min);
          value[1] = _this.calcScaleValue(valueMax >= min && valueMax <= max ? valueMax : max);
        } else if ((0, _lodash3.default)(defaultValue)) {
          var _valueMin = _this.calcScaleValue(defaultValue);

          if (_valueMin <= value[1]) value[0] = _valueMin;else value[1] = _valueMin;
        }

        return value;
      } else {
        return _this.calcScaleValue((0, _lodash3.default)(defaultValue) && defaultValue >= min && defaultValue <= max ? defaultValue : min);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "calcScaleValue", function (value) {
      var scaleLength = _this.props.scaleLength;

      var _assertThisInitialize2 = (0, _assertThisInitialized2.default)(_this),
          min = _assertThisInitialize2.min,
          max = _assertThisInitialize2.max;

      if (scaleLength > 0) {
        value -= min;
        var halfScaleLength = scaleLength / 2;

        if ((max - min) % scaleLength > 0 && value / scaleLength > Math.floor((max - min) / scaleLength)) {
          halfScaleLength = (max - min) % scaleLength / 2;
        }

        if (value % scaleLength > halfScaleLength) {
          var upValue = min + Math.ceil(value / scaleLength) * scaleLength;
          return upValue > max ? max : upValue;
        } else {
          return min + Math.floor(value / scaleLength) * scaleLength;
        }
      } else return value;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "triggerChange", function (event) {
      _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, _this.state.value, event);
      _this.props.onChange && _this.props.onChange(_this.state.value, event);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (e, skip) {
      var _this$props = _this.props,
          decimals = _this$props.decimals,
          scaleLength = _this$props.scaleLength,
          range = _this$props.range,
          disabled = _this$props.disabled;

      var _assertThisInitialize3 = (0, _assertThisInitialized2.default)(_this),
          min = _assertThisInitialize3.min,
          max = _assertThisInitialize3.max;

      if (disabled) return;
      var offset = (0, _slider.calculateChange)(e, skip, _this.props, _this.container); //保留小数位数

      var decimal = Math.abs(decimals); //如果scaleLength 为小数，保留相同小数位

      decimal = decimal === 0 && scaleLength > 0 && String(scaleLength).indexOf('.') > 0 ? String(scaleLength).split('.')[1].length : decimal;
      var value = offset / 100 * (max - min) + min;

      if (decimal > 0) {
        var pow = Math.pow(10, decimal);
        value = Math.round(value * pow) / pow;
      } else {
        value = Math.round(value);
      }

      var oldValue = _this.state.value;

      var newValue = _this.calcScaleValue(value);

      if (range) {
        if (_this.activePointer === "left" && oldValue[0] !== newValue && newValue < oldValue[1] || newValue <= oldValue[0]) {
          _this.activePointer === "right" && (_this.activePointer = "left");

          _this.setState({
            value: [newValue, oldValue[1]]
          }, function () {
            _this.triggerChange(e);
          });
        } else if (_this.activePointer === "right" && oldValue[1] !== newValue && newValue > oldValue[0] || newValue >= oldValue[1]) {
          _this.activePointer === "left" && (_this.activePointer = "right");

          _this.setState({
            value: [oldValue[0], newValue]
          }, function () {
            _this.triggerChange(e);
          });
        }
      } else {
        if (oldValue !== newValue) {
          _this.setState({
            value: newValue
          }, function () {
            _this.triggerChange(e);
          });
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseOver", function () {
      _this.setState({
        hover: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseOut", function () {
      _this.setState({
        hover: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTouchStart", function (e, skip) {
      _this.setState({
        pressed: true
      });

      _this.handleChange(e, skip);

      window.addEventListener("touchend", _this.handleMouseUp);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseDown", function (e) {
      _this.setState({
        pressed: true
      });

      _this.handleChange(e, true);

      window.addEventListener("mousemove", _this.handleChange);
      window.addEventListener("mouseup", _this.handleMouseUp);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseUp", function () {
      _this.setState({
        pressed: false
      });

      _this.unbindEventListeners();
    });
    var _min = props.min,
        _max = props.max,
        _defaultValue = props.defaultValue,
        _value = props.value;
    _this.min = Math.min(_min, _max);
    _this.max = Math.max(_min, _max);
    _this.state = {
      value: _this.calcDefaultValue(_value || _defaultValue),
      hover: false,
      pressed: false
    };
    _this.debounce = (0, _lodash4.default)(function (fn, data, event) {
      fn(data, event);
    }, 100);
    return _this;
  }

  (0, _createClass2.default)(Slider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var min = nextProps.min,
          max = nextProps.max;
      this.min = Math.min(min, max);
      this.max = Math.max(min, max);

      if (!(0, _lodash.default)(nextProps.value) && !(0, _lodash2.default)(nextProps.value, this.props.value)) {
        this.setState({
          value: this.calcDefaultValue(nextProps.value)
        });
      }
    }
  }, {
    key: "unbindEventListeners",
    value: function unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange);
      window.removeEventListener("mouseup", this.handleMouseUp);
      window.removeEventListener("touchend", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          theme = _this$props2.theme,
          range = _this$props2.range,
          scaleLength = _this$props2.scaleLength,
          direction = _this$props2.direction,
          color = _this$props2.color,
          disabled = _this$props2.disabled;
      var _this$state = this.state,
          value = _this$state.value,
          hover = _this$state.hover,
          pressed = _this$state.pressed;
      var min = this.min,
          max = this.max;
      var trackColor = disabled ? theme.palette.grey[700] : color || theme.palette.primary[theme.palette.type];
      var vertical = direction === "vertical";
      var rootStyle = Object.assign({
        position: "relative",
        width: "100%",
        height: 48,
        display: "inline-block"
      }, vertical && {
        width: 48,
        height: "100%"
      });
      var containerStyle = Object.assign({
        position: "absolute",
        top: 23,
        left: 0,
        width: "100%",
        height: 2
      }, vertical && {
        top: 0,
        left: 23,
        height: "100%",
        width: 2
      });
      var trackEl;
      var thumbEl;

      if (range) {
        var offsetLeft = Math.round((value[0] - min) / (max - min) * 100);
        var offsetRight = 100 - Math.round((value[1] - min) / (max - min) * 100);
        var trackActiveStyle = Object.assign({
          backgroundColor: trackColor
        }, vertical ? {
          width: "100%",
          bottom: "".concat(offsetLeft, "%"),
          top: "".concat(offsetRight, "%"),
          marginTop: disabled ? 6 : 0,
          marginBottom: disabled ? 6 : 0
        } : {
          height: "100%",
          left: "".concat(offsetLeft, "%"),
          right: "".concat(offsetRight, "%"),
          marginRight: disabled ? 6 : 0,
          marginLeft: disabled ? 6 : 0
        });
        var trackLeftStyle = Object.assign({
          backgroundColor: trackColor,
          opacity: ".38"
        }, vertical ? {
          width: "100%",
          height: disabled ? "calc(".concat(offsetLeft, "% - 6px)") : "calc(".concat(offsetLeft, "%)"),
          marginTop: disabled ? 6 : 0,
          bottom: 0
        } : {
          height: "100%",
          width: disabled ? "calc(".concat(offsetLeft, "% - 6px)") : "calc(".concat(offsetLeft, "%)"),
          marginRight: disabled ? 6 : 0,
          left: 0
        });
        var trackRightStyle = Object.assign({
          backgroundColor: trackColor,
          opacity: ".38"
        }, vertical ? {
          width: "100%",
          height: disabled ? "calc(".concat(offsetRight, "% - 6px)") : "calc(".concat(offsetRight, "%)"),
          marginBottom: disabled ? 6 : 0,
          top: 0
        } : {
          height: "100%",
          width: disabled ? "calc(".concat(offsetRight, "% - 6px)") : "calc(".concat(offsetRight, "%)"),
          marginLeft: disabled ? 6 : 0,
          right: 0
        });
        var thumbLeftStyle = Object.assign({
          backgroundColor: trackColor
        }, vertical ? {
          left: 0,
          bottom: "".concat(offsetLeft, "%")
        } : {
          top: 0,
          left: "".concat(offsetLeft, "%")
        });
        var thumbLeftClass = this.classNames(classes.pointer, disabled && classes.pointerDisabled, vertical && classes.pointerVertical, this.activePointer === "left" && !disabled && (hover || pressed) && classes.pointerOver, this.activePointer === "left" && !disabled && hover && classes.pointerHover, this.activePointer === "left" && !disabled && pressed && classes.pointerPressed);
        var thumbRightStyle = Object.assign({
          backgroundColor: trackColor
        }, vertical ? {
          left: 0,
          top: "".concat(offsetRight, "%")
        } : {
          top: 0,
          right: "".concat(offsetRight, "%")
        });
        var thumbRightClass = this.classNames(classes.pointer, classes.pointerRight, disabled && classes.pointerDisabled, vertical && classes.pointerVertical, vertical && classes.pointerVerticalTop, this.activePointer === "right" && !disabled && (hover || pressed) && classes.pointerOver, this.activePointer === "right" && !disabled && hover && classes.pointerHover, this.activePointer === "right" && !disabled && pressed && classes.pointerPressed);
        trackEl = _react.default.createElement("div", null, _react.default.createElement("div", {
          className: classes.track,
          style: trackLeftStyle
        }), _react.default.createElement("div", {
          className: classes.track,
          style: trackActiveStyle
        }), _react.default.createElement("div", {
          className: classes.track,
          style: trackRightStyle
        }));
        thumbEl = _react.default.createElement("div", null, _react.default.createElement("div", {
          className: thumbLeftClass,
          style: thumbLeftStyle,
          onMouseOver: function onMouseOver() {
            _this2.activePointer = "left";
          },
          onTouchStart: function onTouchStart() {
            _this2.activePointer = "left";
          }
        }), _react.default.createElement("div", {
          className: thumbRightClass,
          style: thumbRightStyle,
          onMouseOver: function onMouseOver() {
            _this2.activePointer = "right";
          },
          onTouchStart: function onTouchStart() {
            _this2.activePointer = "right";
          }
        }));
      } else {
        var offset = Math.round((value - min) / (max - min) * 100);

        var _trackActiveStyle = Object.assign({
          backgroundColor: trackColor
        }, vertical ? {
          width: "100%",
          height: disabled ? "calc(".concat(offset, "% - 6px)") : "calc(".concat(offset, "%)"),
          marginTop: disabled ? 6 : 0,
          bottom: 0
        } : {
          height: "100%",
          width: disabled ? "calc(".concat(offset, "% - 6px)") : "calc(".concat(offset, "%)"),
          marginRight: disabled ? 6 : 0,
          left: 0
        });

        var trackStyle = Object.assign({
          backgroundColor: trackColor,
          opacity: ".38"
        }, vertical ? {
          width: "100%",
          height: disabled ? "calc(".concat(100 - offset, "% - 6px)") : "calc(".concat(100 - offset, "%)"),
          marginBottom: disabled ? 6 : 0,
          top: 0
        } : {
          height: "100%",
          width: disabled ? "calc(".concat(100 - offset, "% - 6px)") : "calc(".concat(100 - offset, "%)"),
          marginLeft: disabled ? 6 : 0,
          right: 0
        });
        var thumbStyle = Object.assign({
          backgroundColor: trackColor
        }, vertical ? {
          left: 0,
          bottom: "".concat(offset, "%")
        } : {
          top: 0,
          left: "".concat(offset, "%")
        });
        var thumbClass = this.classNames(classes.pointer, disabled && classes.pointerDisabled, vertical && classes.pointerVertical, !disabled && (hover || pressed) && classes.pointerOver, !disabled && hover && classes.pointerHover, pressed && classes.pointerPressed);
        trackEl = _react.default.createElement("div", null, _react.default.createElement("div", {
          className: classes.track,
          style: _trackActiveStyle
        }), _react.default.createElement("div", {
          className: classes.track,
          style: trackStyle
        }));
        thumbEl = _react.default.createElement("div", {
          className: thumbClass,
          style: thumbStyle
        });
      }

      var scaleEl;

      if (scaleLength > 0 && scaleLength < max - min) {
        var scaleCount = Math.floor((max - min) / scaleLength);
        var scaleArray = Array.from(new Array(scaleCount + ((max - min) % scaleLength === 0 ? 1 : 2)), function (val, index) {
          return index;
        });
        scaleEl = _react.default.createElement("div", null, scaleArray.map(function (i) {
          var scaleValue = scaleLength * i + min;
          var scaleOffset = 0;

          if (i === scaleArray.length - 1) {
            scaleOffset = 100;
          } else if (i > 0) {
            scaleOffset = (1 - (max - min) % scaleLength / (max - min)) * 100 / scaleCount * i;
          }

          var scaleStyle = Object.assign({
            backgroundColor: trackColor
          }, vertical ? {
            width: "100%",
            height: 2,
            left: 0,
            bottom: "".concat(scaleOffset, "%")
          } : {
            height: "100%",
            width: 2,
            top: 0,
            left: "".concat(scaleOffset, "%")
          });

          if (range && scaleValue > value[0] && scaleValue < value[1] || !range && scaleValue < value) {
            Object.assign(scaleStyle, {
              backgroundColor: "rgba(255,255,255,.38)"
            });
          }

          return _react.default.createElement("span", {
            key: i,
            className: classes.scale,
            style: scaleStyle
          });
        }));
      }

      return _react.default.createElement("div", {
        className: this.className("slider"),
        style: this.style(rootStyle)
      }, _react.default.createElement("div", {
        className: classes.warp,
        ref: function ref(container) {
          return _this2.container = container;
        },
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleTouchStart
      }, _react.default.createElement("div", {
        style: containerStyle
      }, trackEl, scaleEl, thumbEl)));
    }
  }]);
  return Slider;
}(_libs.Component);

(0, _defineProperty2.default)(Slider, "defaultProps", {
  min: 0,
  max: 100,
  defaultValue: 0,
  decimals: 0,
  range: false,
  scale: 0,
  direction: "horizontal",
  onChange: function onChange() {},
  onChangeComplete: function onChangeComplete() {}
});

var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})(Slider);

exports.default = _default;

 }),

 (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

 }),

 (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

 }),

 (function(module, exports) {




function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


 }),

 (function(module, exports, __webpack_require__) {

(function(global, module) {


var LARGE_ARRAY_SIZE = 200;


var HASH_UNDEFINED = '__lodash_hash_undefined__';


var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;


var MAX_SAFE_INTEGER = 9007199254740991;


var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';


var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;


var reIsHostCtor = /^\[object .+?Constructor\]$/;


var reIsUint = /^(?:0|[1-9]\d*)$/;


var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;


var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;


var freeSelf = typeof self == 'object' && self && self.Object === Object && self;


var root = freeGlobal || freeSelf || Function('return this')();


var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;


var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;


var moduleExports = freeModule && freeModule.exports === freeExports;


var freeProcess = moduleExports && freeGlobal.process;


var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());


var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;


function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}


function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}


function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}


function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}


function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}


function cacheHas(cache, key) {
  return cache.has(key);
}


function getValue(object, key) {
  return object == null ? undefined : object[key];
}


function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}


function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}


function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}


var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;


var coreJsData = root['__core-js_shared__'];


var funcToString = funcProto.toString;


var hasOwnProperty = objectProto.hasOwnProperty;


var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());


var nativeObjectToString = objectProto.toString;


var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);


var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;


var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);


var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');


var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);


var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;


function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}


function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}


function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}


function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}


function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;


function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}


function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}


function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;


function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}


function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}


function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}


function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;


function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}


function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}


function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;


function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}


function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}


function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}


function stackGet(key) {
  return this.__data__.get(key);
}


function stackHas(key) {
  return this.__data__.has(key);
}


function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;


function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}


function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}


function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}


function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}


function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}


function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}


function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}


function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}


function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}


function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}


function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}


function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}


function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}


function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}


function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}


var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};


var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}


function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}


function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}


function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}


function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}


function objectToString(value) {
  return nativeObjectToString.call(value);
}


function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}


function eq(value, other) {
  return value === other || (value !== value && other !== other);
}


var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};


var isArray = Array.isArray;


function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}


var isBuffer = nativeIsBuffer || stubFalse;


function isEqual(value, other) {
  return baseIsEqual(value, other);
}


function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}


function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}


function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}


function isObjectLike(value) {
  return value != null && typeof value == 'object';
}


var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;


function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}


function stubArray() {
  return [];
}


function stubFalse() {
  return false;
}

module.exports = isEqual;

}.call(exports, __webpack_require__(51), __webpack_require__(123)(module)))

 }),

 (function(module, exports) {




var numberTag = '[object Number]';


var objectProto = Object.prototype;


var objectToString = objectProto.toString;


function isObjectLike(value) {
  return !!value && typeof value == 'object';
}


function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && objectToString.call(value) == numberTag);
}

module.exports = isNumber;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createMuiStrictModeTheme;
 var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_1__createMuiTheme__ = __webpack_require__(223);


function createMuiStrictModeTheme(options) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_1__createMuiTheme__["a" ].apply(void 0, [Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["a" ])({
    unstable_strictMode: true
  }, options)].concat(args));
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = createStyles;
 var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(53);
 // let warnOnce = false;
// To remove in v5

function createStyles(styles) {
  // warning(
  //   warnOnce,
  //   [
  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
  //     'Please use @material-ui/styles/createStyles',
  //   ].join('\n'),
  // );
  // warnOnce = true;
  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["e" ])(styles);
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(53);
 var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(128);




function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["h" ])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" ]
  }, options));
}

 __webpack_exports__["a"] = (makeStyles);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = responsiveFontSizes;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_2__cssUtils__ = __webpack_require__(1170);



function responsiveFontSizes(themeInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$breakpoints = options.breakpoints,
      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
      _options$disableAlign = options.disableAlign,
      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
      _options$factor = options.factor,
      factor = _options$factor === void 0 ? 2 : _options$factor,
      _options$variants = options.variants,
      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;

  var theme = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, themeInput);

  theme.typography = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, theme.typography);
  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).

  var convert = Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["b" ])(typography.htmlFontSize);
  var breakpointValues = breakpoints.map(function (x) {
    return theme.breakpoints.values[x];
  });
  variants.forEach(function (variant) {
    var style = typography[variant];
    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));

    if (remFontSize <= 1) {
      return;
    }

    var maxFontSize = remFontSize;
    var minFontSize = 1 + (maxFontSize - 1) / factor;
    var lineHeight = style.lineHeight;

    if (!Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["d" ])(lineHeight) && !disableAlign) {
      throw new Error( false ? "Material-UI: Unsupported non-unitless line height with grid alignment.\nUse unitless line heights instead." : Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_utils__["b" ])(6));
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["d" ])(lineHeight)) {
      // make it unitless
      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
    }

    var transform = null;

    if (!disableAlign) {
      transform = function transform(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["a" ])({
          size: value,
          grid: Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["c" ])({
            pixels: 4,
            lineHeight: lineHeight,
            htmlFontSize: typography.htmlFontSize
          })
        });
      };
    }

    typography[variant] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({}, style, Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["e" ])({
      cssProperty: 'fontSize',
      min: minFontSize,
      max: maxFontSize,
      unit: 'rem',
      breakpoints: breakpointValues,
      transform: transform
    }));
  });
  return theme;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["d"] = isUnitless;


 __webpack_exports__["b"] = convertLength;
 __webpack_exports__["a"] = alignProperty;
 __webpack_exports__["c"] = fontGrid;
 __webpack_exports__["e"] = responsiveProperty;
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(63);

function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
} // Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"

function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
} // Emulate the sass function "unitless"

function toUnitless(length) {
  return parseFloat(length);
} // Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length

function convertLength(baseFontSize) {
  return function (length, toUnit) {
    var fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.

    if (fromUnit === toUnit) {
      return length;
    } // Convert input length to pixels.


    var pxLength = toUnitless(length);

    if (fromUnit !== 'px') {
      if (fromUnit === 'em') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === 'rem') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
        return length;
      }
    } // Convert length in pixels to the output unit


    var outputLength = pxLength;

    if (toUnit !== 'px') {
      if (toUnit === 'em') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === 'rem') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }

    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty(_ref) {
  var size = _ref.size,
      grid = _ref.grid;
  var sizeBelow = size - size % grid;
  var sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height

function fontGrid(_ref2) {
  var lineHeight = _ref2.lineHeight,
      pixels = _ref2.pixels,
      htmlFontSize = _ref2.htmlFontSize;
  return pixels / (lineHeight * htmlFontSize);
}


function responsiveProperty(_ref3) {
  var cssProperty = _ref3.cssProperty,
      min = _ref3.min,
      max = _ref3.max,
      _ref3$unit = _ref3.unit,
      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
      _ref3$breakpoints = _ref3.breakpoints,
      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
      _ref3$transform = _ref3.transform,
      transform = _ref3$transform === void 0 ? null : _ref3$transform;

  var output = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" ])({}, cssProperty, "".concat(min).concat(unit));

  var factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(function (breakpoint) {
    var value = min + factor * breakpoint;

    if (transform !== null) {
      value = transform(value);
    }

    output["@media (min-width:".concat(breakpoint, "px)")] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" ])({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
  });
  return output;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(53);
 var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(128);




var styled = function styled(Component) {
  var componentCreator = Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["j" ])(Component);
  return function (style, options) {
    return componentCreator(style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" ]
    }, options));
  };
};

 __webpack_exports__["a"] = (styled);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(53);
 var __WEBPACK_IMPORTED_MODULE_1__defaultTheme__ = __webpack_require__(128);


var withTheme = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["m" ])({
  defaultTheme: __WEBPACK_IMPORTED_MODULE_1__defaultTheme__["a" ]
});
 __webpack_exports__["a"] = (withTheme);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Component", {
  enumerable: true,
  get: function get() {
    return _component.default;
  }
});

var _component = _interopRequireDefault(__webpack_require__(1174));

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(463));

var _createClass2 = _interopRequireDefault(__webpack_require__(464));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(465));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(467));

var _inherits2 = _interopRequireDefault(__webpack_require__(468));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(11));

var Component =

function (_React$Component) {
  (0, _inherits2.default)(Component, _React$Component);

  function Component() {
    (0, _classCallCheck2.default)(this, Component);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Component).apply(this, arguments));
  }

  (0, _createClass2.default)(Component, [{
    key: "classNames",
    value: function classNames() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (0, _classnames.default)(args);
    }
  }, {
    key: "className",
    value: function className() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.classNames.apply(this, args.concat([this.props.className]));
    }
  }, {
    key: "style",
    value: function style(args) {
      return Object.assign({}, args, this.props.style);
    }
  }]);
  return Component;
}(_react.default.Component);

var _default = Component;
exports.default = _default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateChange = void 0;

var calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (props.direction === 'vertical') {
    var offset;

    if (top < 0) {
      offset = 100;
    } else if (top > containerHeight) {
      offset = 0;
    } else {
      offset = 100 - top * 100 / containerHeight;
    }

    return offset;
  } else {
    var _offset;

    if (left < 0) {
      _offset = 0;
    } else if (left > containerWidth) {
      _offset = 100;
    } else {
      _offset = left * 100 / containerWidth;
    }

    return _offset;
  }
};

exports.calculateChange = calculateChange;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_elements_actions__ = __webpack_require__(132);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1177);
function mapStateToProps(state){return{literals:state.i18n.literals.affiliation,app:state.app,user:state.session.user,userElements:state.elements.selectedElements};}function mapDispatchToProps(dispatch){return{connectWithElement:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_elements_actions__["a" ],dispatch),removeConnectionWithElement:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_elements_actions__["h" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_CloseIconBlue_svg__ = __webpack_require__(1178);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_CloseIconBlue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_CloseIconBlue_svg__);
 var __WEBPACK_IMPORTED_MODULE_5_components_Steps_Faces__ = __webpack_require__(95);
 var __WEBPACK_IMPORTED_MODULE_6_components_Cards_ThemeTableCard__ = __webpack_require__(117);
 var __WEBPACK_IMPORTED_MODULE_7_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_8_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_9_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(1199);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AffiliationCard=function(_Component){_inherits(AffiliationCard,_Component);function AffiliationCard(props){_classCallCheck(this,AffiliationCard);var _this=_possibleConstructorReturn(this,(AffiliationCard.__proto__||Object.getPrototypeOf(AffiliationCard)).call(this,props));_this.loadAffiliationInfo=function(){var elementId=_this.props.elementId;var endPoint='element/'+elementId;Object(__WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__["b" ])('GET',{endPoint:endPoint}).then(function(response){_this.setState({data:response.data});});};_this.handleClose=function(){var onClose=_this.props.onClose;onClose();};_this.goToTable=function(tableId){var history=_this.props.history;_this.handleClose();history.push('/theme-table/'+tableId);};_this.doNothing=function(){};_this.selectUser=function(userId){_this.setState({selectedUser:userId});};_this.removeSelectedUser=function(){_this.setState({selectedUser:0});};_this.handleConnectWithElement=function(){var connectWithElement=_this.props.connectWithElement;var data=_this.state.data;_this.setState({isLoadingConnection:true});connectWithElement('affiliation_card',data.element_info).then(function(){_this.setState({isLoadingConnection:false});}).catch(function(){_this.setState({isLoadingConnection:false});});};_this.handleRemoveConnectionWithElement=function(){var removeConnectionWithElement=_this.props.removeConnectionWithElement;var data=_this.state.data;_this.setState({isLoadingConnection:true});removeConnectionWithElement('affiliation_card',data.element_info).then(function(){_this.setState({isLoadingConnection:false});}).catch(function(){_this.setState({isLoadingConnection:false});});};_this.printPeople=function(){var data=_this.state.data;var literals=_this.props.literals;var title=data.users.length+' '+literals.people;var people=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SimpleCarousel__["a" ],{classesList:'face_bubble'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Steps_Faces__["a" ],{options:data.users,onClick:_this.selectUser,onLongPress:_this.selectUser})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},title),people);};_this.printTables=function(){var data=_this.state.data;var _this$props=_this.props,literals=_this$props.literals,app=_this$props.app,user=_this$props.user;var tables=data.tables.map(function(table){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Cards_ThemeTableCard__["a" ],{onClick:_this.goToTable,data:table,key:table.id,app:app,user:user});});var title=data.tables.length+' '+literals.tables;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SimpleCarousel__["a" ],{classesList:'theme_table_card'},tables));};_this.printSelectedUser=function(){var _this$state=_this.state,selectedUser=_this$state.selectedUser,data=_this$state.data;if(!selectedUser){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_UsersModal__["a" ],{usersIds:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.users,function(user){return user.id;}),userSelected:selectedUser,onEnd:_this.removeSelectedUser});};_this.state={data:null,selectedUser:0,isLoadingConnection:false};return _this;}_createClass(AffiliationCard,[{key:'componentDidMount',value:function componentDidMount(){var elementId=this.props.elementId;if(elementId){this.loadAffiliationInfo();}}},{key:'render',value:function render(){var _props=this.props,literals=_props.literals,open=_props.open,userElements=_props.userElements;var _state=this.state,data=_state.data,selectedUser=_state.selectedUser,isLoadingConnection=_state.isLoadingConnection;if(selectedUser){return this.printSelectedUser();}if(data){var hasThisElement=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(userElements,{id:data.element_info.id});var buttonBelong=null;if(!isLoadingConnection){if(hasThisElement){buttonBelong=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn_dont_belong',onClick:this.handleRemoveConnectionWithElement},literals.alreadyBelong);}else{buttonBelong=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn_belong',onClick:this.handleConnectWithElement},literals.belong);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["a" ],{open:open,onClose:this.handleClose,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal affiliation_card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_assets_images_CloseIconBlue_svg___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'affiliation_info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon',style:{backgroundImage:'url('+data.element_info.image+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.element_info.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:data.element_info.description,target:'_blank',rel:'noopener noreferrer'},data.element_info.description),buttonBelong)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sponsor'},literals.peopleAndTables),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'people'},this.printPeople()),data.tables.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tables'},this.printTables()):null)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["a" ],{open:open,onClose:this.handleClose,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal affiliation_card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_assets_images_CloseIconBlue_svg___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_LoadingComponent__["a" ],null)));}}]);return AffiliationCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AffiliationCard.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,elementId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,connectWithElement:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,removeConnectionWithElement:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,userElements:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};AffiliationCard.defaultProps={userElements:[]}; __webpack_exports__["a"] = (AffiliationCard);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/CloseIconBlue.5296e831.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components_Faces__ = __webpack_require__(1180);
function mapStateToProps(){return{};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_Faces__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_utils_string__ = __webpack_require__(67);
 var __WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_5_react_sortable_hoc__ = __webpack_require__(1181);
 var __WEBPACK_IMPORTED_MODULE_5_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_sortable_hoc__);
 var __WEBPACK_IMPORTED_MODULE_6_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(471);
 var __WEBPACK_IMPORTED_MODULE_8__Bubble__ = __webpack_require__(1186);
 var __WEBPACK_IMPORTED_MODULE_9__CustomCard_components_styles__ = __webpack_require__(264);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faces=function(_Component){_inherits(Faces,_Component);function Faces(props){_classCallCheck(this,Faces);var _this=_possibleConstructorReturn(this,(Faces.__proto__||Object.getPrototypeOf(Faces)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,options=_this$props.options,values=_this$props.values;_this.state={items:options,values:[].concat(_toConsumableArray(values)),user:null};_this.canViewDetail=true;return _this;}_createClass(Faces,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var options=this.props.options;if(prevProps.options.length!==options.length||prevProps.options!==options){this.setState({items:options});}}},{key:'render',value:function render(){var _props=this.props,sort=_props.sort,title=_props.title,backgroundColorText=_props.backgroundColorText;var fontSize=title?Object(__WEBPACK_IMPORTED_MODULE_3_utils_string__["b" ])(title):16;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.printSelectedUser(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CustomCard_components_styles__["q" ],{maxFontSize:fontSize,dangerouslySetInnerHTML:{__html:title},colorText:'#ffffff',backgroundColorText:backgroundColorText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["c" ],null,sort?this.getSortedList():this.printBubbles()));}}]);return Faces;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.getBubble=function(element){var _props2=_this2.props,select=_props2.select,color=_props2.color,noResize=_props2.noResize,onClick=_props2.onClick,icon=_props2.icon,colorText=_props2.colorText;var values=_this2.state.values;var id=element.id,firstname=element.firstname,lastname=element.lastname,avatar=element.avatar;var data={id:id,firstname:firstname,title:firstname+' '+lastname,image:avatar};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Bubble__["a" ],{data:data,key:element.id,color:color||color.color,canSelect:select,onClick:onClick,onSelect:_this2.onSelect,onUnselect:_this2.onUnselect,onLongPress:_this2.handleLongPress,selected:select&&!!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(values,function(value){return value===element.id;}),noResize:noResize,icon:icon,colorText:colorText});};this.handleLongPress=function(data){var onLongPress=_this2.props.onLongPress;if(onLongPress){onLongPress(data.id);}else{_this2.onViewDetail(data);}};this.getSortedList=function(){var itemsList=_this2.state.items;var SortableItem=Object(__WEBPACK_IMPORTED_MODULE_5_react_sortable_hoc__["SortableElement"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'hola');});var SortableList=Object(__WEBPACK_IMPORTED_MODULE_5_react_sortable_hoc__["SortableContainer"])(function(_ref){var items=_ref.items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,items.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SortableItem,{key:'item-'+index,index:index,sortIndex:index,value:value});}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SortableList,{items:itemsList,onSortStart:_this2.onSortStart,onSortEnd:_this2.onSortEnd,onSortMove:_this2.onSortMove,axis:'xy',distance:10});};this.handleSelectFace=function(userId){var actionSelect=_this2.props.actionSelect;var params={userId:userId,action:actionSelect};Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('POST',{endPoint:'users/connection'},params);};this.handleUnselectFace=function(userId){var actionSelect=_this2.props.actionSelect;var params={userId:userId,action:actionSelect};Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('DELETE',{endPoint:'users/connection'},params);};this.handleChangeAnswers=function(){var onChangeAnswers=_this2.props.onChangeAnswers;var values=_this2.state.values;if(onChangeAnswers){onChangeAnswers(values);}};this.onSelect=function(id){var _state=_this2.state,values=_state.values,items=_state.items;var _props3=_this2.props,onSelect=_props3.onSelect,maxItemsSelected=_props3.maxItemsSelected;if(!maxItemsSelected||values.length<maxItemsSelected-1){values.push(id);}_this2.setState({values:values},_this2.handleChangeAnswers);var item=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(items,{id:id});if(item){var userId=item.id;if(onSelect){onSelect(userId);}else{_this2.handleSelectFace(userId);}}};this.onUnselect=function(id){var onUnselect=_this2.props.onUnselect;var _state2=_this2.state,values=_state2.values,items=_state2.items;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(values,function(element){return element===id;});_this2.setState({values:values},_this2.handleChangeAnswers);var item=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(items,{id:id});if(item){var userId=item.id;if(onUnselect){onUnselect(userId);}else{_this2.handleUnselectFace(userId);}}};this.onSortStart=function(){};this.onSortMove=function(){_this2.isSorting=true;};this.onSortEnd=function(_ref2){var oldIndex=_ref2.oldIndex,newIndex=_ref2.newIndex;var items=_this2.state.items;if(oldIndex!==newIndex){_this2.canViewDetail=false;}var newItems=Object(__WEBPACK_IMPORTED_MODULE_5_react_sortable_hoc__["arrayMove"])(items,oldIndex,newIndex);_this2.setState({items:newItems});_this2.isSorting=false;var values=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(newItems,function(element){return element.id;});};this.onViewDetail=function(data){if(!_this2.isSorting&&_this2.canViewDetail){var items=_this2.state.items;var user=items.find(function(item){return item.id===data.id;});_this2.setState({user:user});}_this2.canViewDetail=true;};this.printBubbles=function(){var maxRows=4;var items=_this2.state.items;var bubbles=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(items,function(element){return _this2.getBubble(element);});var columnsNumber=Math.max(3,Math.ceil(bubbles.length/maxRows));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["b" ],{columns:columnsNumber,className:'faces_wrapper'},bubbles);};this.closeUsersModal=function(){_this2.setState({user:null});};this.printSelectedUser=function(){var _state3=_this2.state,user=_state3.user,items=_state3.items;if(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_UsersModal__["a" ],{usersIds:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(items,function(_ref3){var id=_ref3.id;return id;}),userSelected:user.id,onEnd:_this2.closeUsersModal});}return null;};};Faces.propTypes={options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string||__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,sort:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,select:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onLongPress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnselect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,values:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,maxItemsSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,noResize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,actionSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onChangeAnswers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element};Faces.defaultProps={sort:false,select:false,onSelect:null,onUnselect:null,onClick:null,onLongPress:null,values:[],maxItemsSelected:null,color:'',noResize:false,actionSelect:'',icon:null,onChangeAnswers:null}; __webpack_exports__["a"] = (Faces);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;

var _utils = __webpack_require__(180);

Object.defineProperty(exports, 'arrayMove', {
  enumerable: true,
  get: function get() {
    return _utils.arrayMove;
  }
});

var _SortableContainer2 = __webpack_require__(1182);

var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

var _SortableElement2 = __webpack_require__(1184);

var _SortableElement3 = _interopRequireDefault(_SortableElement2);

var _SortableHandle2 = __webpack_require__(1185);

var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SortableContainer = _SortableContainer3.default;
exports.SortableElement = _SortableElement3.default;
exports.SortableHandle = _SortableHandle3.default;
exports.sortableContainer = _SortableContainer3.default;
exports.sortableElement = _SortableElement3.default;
exports.sortableHandle = _SortableHandle3.default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableContainer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(25);

var _invariant = __webpack_require__(47);

var _invariant2 = _interopRequireDefault(_invariant);

var _Manager = __webpack_require__(1183);

var _Manager2 = _interopRequireDefault(_Manager);

var _utils = __webpack_require__(180);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.handleStart = function (event) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;


        if (event.button === 2 || shouldCancelStart(event)) {
          return false;
        }

        _this._touched = true;
        _this._pos = (0, _utils.getPosition)(event);

        var node = (0, _utils.closest)(event.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection;


          if (useDragHandle && !(0, _utils.closest)(event.target, function (el) {
            return el.sortableHandle != null;
          })) return;

          _this.manager.active = { index: index, collection: collection };

          
          if (!(0, _utils.isTouchEvent)(event) && event.target.tagName.toLowerCase() === 'a') {
            event.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(event);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(event);
              }, _this.props.pressDelay);
            }
          }
        }
      };

      _this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === _this.manager;
      };

      _this.handleMove = function (event) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;


        if (!_this.state.sorting && _this._touched) {
          var position = (0, _utils.getPosition)(event);
          var delta = _this._delta = {
            x: _this._pos.x - position.x,
            y: _this._pos.y - position.y
          };
          var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);

          if (!distance && (!pressThreshold || pressThreshold && combinedDelta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && combinedDelta >= distance && _this.manager.isActive()) {
            _this.handlePress(event);
          }
        }
      };

      _this.handleEnd = function () {
        _this._touched = false;
        _this.cancel();
      };

      _this.cancel = function () {
        var distance = _this.props.distance;
        var sorting = _this.state.sorting;


        if (!sorting) {
          if (!distance) {
            clearTimeout(_this.pressTimer);
          }
          _this.manager.active = null;
        }
      };

      _this.handlePress = function (event) {
        var active = _this.manager.getActive();

        if (active) {
          var _this$props3 = _this.props,
              axis = _this$props3.axis,
              getHelperDimensions = _this$props3.getHelperDimensions,
              helperClass = _this$props3.helperClass,
              hideSortableGhost = _this$props3.hideSortableGhost,
              onSortStart = _this$props3.onSortStart,
              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
          var node = active.node,
              collection = active.collection;
          var index = node.sortableInfo.index;

          var margin = (0, _utils.getElementMargin)(node);

          var containerBoundingRect = _this.container.getBoundingClientRect();
          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

          _this.node = node;
          _this.margin = margin;
          _this.width = dimensions.width;
          _this.height = dimensions.height;
          _this.marginOffset = {
            x: _this.margin.left + _this.margin.right,
            y: Math.max(_this.margin.top, _this.margin.bottom)
          };
          _this.boundingClientRect = node.getBoundingClientRect();
          _this.containerBoundingRect = containerBoundingRect;
          _this.index = index;
          _this.newIndex = index;

          _this.axis = {
            x: axis.indexOf('x') >= 0,
            y: axis.indexOf('y') >= 0
          };
          _this.offsetEdge = (0, _utils.getEdgeOffset)(node, _this.container);
          _this.initialOffset = (0, _utils.getPosition)(event);
          _this.initialScroll = {
            top: _this.container.scrollTop,
            left: _this.container.scrollLeft
          };

          _this.initialWindowScroll = {
            top: window.pageYOffset,
            left: window.pageXOffset
          };

          var fields = node.querySelectorAll('input, textarea, select');
          var clonedNode = node.cloneNode(true);
          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

          clonedFields.forEach(function (field, index) {
            if (field.type !== 'file' && fields[index]) {
              field.value = fields[index].value;
            }
          });

          _this.helper = _this.document.body.appendChild(clonedNode);

          _this.helper.style.position = 'fixed';
          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
          _this.helper.style.width = _this.width + 'px';
          _this.helper.style.height = _this.height + 'px';
          _this.helper.style.boxSizing = 'border-box';
          _this.helper.style.pointerEvents = 'none';

          if (hideSortableGhost) {
            _this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          _this.minTranslate = {};
          _this.maxTranslate = {};
          if (_this.axis.x) {
            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
          }
          if (_this.axis.y) {
            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
          }

          if (helperClass) {
            var _this$helper$classLis;

            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
          }

          _this.listenerNode = event.touches ? node : _this.contentWindow;
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
          });

          _this.setState({
            sorting: true,
            sortingIndex: index
          });

          if (onSortStart) {
            onSortStart({ node: node, index: index, collection: collection }, event);
          }
        }
      };

      _this.handleSortMove = function (event) {
        var onSortMove = _this.props.onSortMove;

        event.preventDefault(); // Prevent scrolling on mobile

        _this.updatePosition(event);
        _this.animateNodes();
        _this.autoscroll();

        if (onSortMove) {
          onSortMove(event);
        }
      };

      _this.handleSortEnd = function (event) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var collection = _this.manager.active.collection;

        // Remove the event listeners if the node is still in the DOM

        if (_this.listenerNode) {
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
          });
        }

        // Remove the helper from the DOM
        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          _this.sortableGhost.style.visibility = '';
          _this.sortableGhost.style.opacity = '';
        }

        var nodes = _this.manager.refs[collection];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[_utils.vendorPrefix + 'Transform'] = '';
          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this.autoscrollInterval);
        _this.autoscrollInterval = null;

        // Update state
        _this.manager.active = null;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: _this.index,
            newIndex: _this.newIndex,
            collection: collection
          }, event);
        }

        _this._touched = false;
      };

      _this.autoscroll = function () {
        var translate = _this.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
          direction.y = 1; // Scroll Down
          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
          direction.x = 1; // Scroll Right
          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
          direction.y = -1; // Scroll Up
          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
          direction.x = -1; // Scroll Left
          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
        }

        if (_this.autoscrollInterval) {
          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null;
          _this.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          _this.autoscrollInterval = setInterval(function () {
            _this.isAutoScrolling = true;
            var offset = {
              left: 1 * speed.x * direction.x,
              top: 1 * speed.y * direction.y
            };
            _this.scrollContainer.scrollTop += offset.top;
            _this.scrollContainer.scrollLeft += offset.left;
            _this.translate.x += offset.left;
            _this.translate.y += offset.top;
            _this.animateNodes();
          }, 5);
        }
      };

      _this.manager = new _Manager2.default();
      _this.events = {
        start: _this.handleStart,
        move: _this.handleMove,
        end: _this.handleEnd
      };

      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');

      _this.state = {};
      return _this;
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;

        

        var container = this.getContainer();

        Promise.resolve(container).then(function (containerNode) {
          _this2.container = containerNode;
          _this2.document = _this2.container.ownerDocument || document;

          var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;

          _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
          _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : _this2.container;

          var _loop = function _loop(key) {
            if (_this2.events.hasOwnProperty(key)) {
              _utils.events[key].forEach(function (eventName) {
                return _this2.container.addEventListener(eventName, _this2.events[key], false);
              });
            }
          };

          for (var key in _this2.events) {
            _loop(key);
          }
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        if (this.container) {
          var _loop2 = function _loop2(key) {
            if (_this3.events.hasOwnProperty(key)) {
              _utils.events[key].forEach(function (eventName) {
                return _this3.container.removeEventListener(eventName, _this3.events[key]);
              });
            }
          };

          for (var key in this.events) {
            _loop2(key);
          }
        }
      }
    }, {
      key: 'getLockPixelOffsets',
      value: function getLockPixelOffsets() {
        var width = this.width,
            height = this.height;
        var lockOffset = this.props.lockOffset;

        var offsets = Array.isArray(lockOffset) ? lockOffset : [lockOffset, lockOffset];

        (0, _invariant2.default)(offsets.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

        var _offsets = _slicedToArray(offsets, 2),
            minLockOffset = _offsets[0],
            maxLockOffset = _offsets[1];

        return [(0, _utils.getLockPixelOffset)({ lockOffset: minLockOffset, width: width, height: height }), (0, _utils.getLockPixelOffset)({ lockOffset: maxLockOffset, width: width, height: height })];
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition(event) {
        var _props = this.props,
            lockAxis = _props.lockAxis,
            lockToContainerEdges = _props.lockToContainerEdges;


        var offset = (0, _utils.getPosition)(event);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };

        // Adjust for window scroll
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;

        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = this.getLockPixelOffsets(),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };

          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
      }
    }, {
      key: 'animateNodes',
      value: function animateNodes() {
        var _props2 = this.props,
            transitionDuration = _props2.transitionDuration,
            hideSortableGhost = _props2.hideSortableGhost,
            onSortOver = _props2.onSortOver;

        var nodes = this.manager.getOrderedRefs();
        var containerScrollDelta = {
          left: this.container.scrollLeft - this.initialScroll.left,
          top: this.container.scrollTop - this.initialScroll.top
        };
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
          top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
        };
        var windowScrollDelta = {
          top: window.pageYOffset - this.initialWindowScroll.top,
          left: window.pageXOffset - this.initialWindowScroll.left
        };
        var prevIndex = this.newIndex;
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i].node;

          var index = node.sortableInfo.index;
          var width = node.offsetWidth;
          var height = node.offsetHeight;
          var offset = {
            width: this.width > width ? width / 2 : this.width / 2,
            height: this.height > height ? height / 2 : this.height / 2
          };

          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          // If we haven't cached the node's offsetTop / offsetLeft value

          if (!edgeOffset) {
            nodes[i].edgeOffset = edgeOffset = (0, _utils.getEdgeOffset)(node, this.container);
          }

          // Get a reference to the next and previous node
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          // Also cache the next node's edge offset if needed.
          // We need this for calculating the animation in a grid setup
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = (0, _utils.getEdgeOffset)(nextNode.node, this.container);
          }

          // If the node is the one we're currently animating, skip it
          if (index === this.index) {
            if (hideSortableGhost) {
              
              this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }
            continue;
          }

          if (transitionDuration) {
            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
          }

          if (this.axis.x) {
            if (this.axis.y) {
              // Calculations for a grid setup
              if (index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                // If the current node is to the left on the same row, or above the node that's being dragged
                // then move it to the right
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  // If it moves passed the right bounds, then animate it to the first position of the next row.
                  // We just use the offset of the next node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                }
                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                // If the current node is to the right on the same row, or below the node that's being dragged
                // then move it to the left
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
                  // We just use the offset of the previous node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                }
                this.newIndex = index;
              }
            } else {
              if (index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }

        if (onSortOver && this.newIndex !== prevIndex) {
          onSortOver({
            newIndex: this.newIndex,
            oldIndex: prevIndex,
            index: this.index,
            collection: this.manager.active.collection
          });
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'getContainer',
      value: function getContainer() {
        var getContainer = this.props.getContainer;


        if (typeof getContainer !== 'function') {
          return (0, _reactDom.findDOMNode)(this);
        }

        return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,
    shouldCancelStart: function shouldCancelStart(e) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
        return true; // Return true to cancel sorting
      }
    },
    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function getHelperDimensions(_ref) {
      var node = _ref.node;
      return {
        width: node.offsetWidth,
        height: node.offsetHeight
      };
    }
  }, _class.propTypes = {
    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
    distance: _propTypes2.default.number,
    lockAxis: _propTypes2.default.string,
    helperClass: _propTypes2.default.string,
    transitionDuration: _propTypes2.default.number,
    contentWindow: _propTypes2.default.any,
    onSortStart: _propTypes2.default.func,
    onSortMove: _propTypes2.default.func,
    onSortOver: _propTypes2.default.func,
    onSortEnd: _propTypes2.default.func,
    shouldCancelStart: _propTypes2.default.func,
    pressDelay: _propTypes2.default.number,
    useDragHandle: _propTypes2.default.bool,
    useWindowAsScrollContainer: _propTypes2.default.bool,
    hideSortableGhost: _propTypes2.default.bool,
    lockToContainerEdges: _propTypes2.default.bool,
    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
    getContainer: _propTypes2.default.func,
    getHelperDimensions: _propTypes2.default.func
  }, _class.childContextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _temp;
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.refs = {};
  }

  _createClass(Manager, [{
    key: "add",
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: "remove",
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var _this = this;

      return this.refs[this.active.collection].find(
      // eslint-disable-next-line eqeqeq
      function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: "getOrderedRefs",
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return this.refs[collection].sort(sortByIndex);
    }
  }]);

  return Manager;
}();

exports.default = Manager;


function sortByIndex(_ref2, _ref3) {
  var index1 = _ref2.node.sortableInfo.index;
  var index2 = _ref3.node.sortableInfo.index;

  return index1 - index2;
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(25);

var _invariant = __webpack_require__(47);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(180);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            collection = _props.collection,
            disabled = _props.disabled,
            index = _props.index;


        if (!disabled) {
          this.setDraggable(collection, index);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index && this.node) {
          this.node.sortableInfo.index = nextProps.index;
        }
        if (this.props.disabled !== nextProps.disabled) {
          var collection = nextProps.collection,
              disabled = nextProps.disabled,
              index = nextProps.index;

          if (disabled) {
            this.removeDraggable(collection);
          } else {
            this.setDraggable(collection, index);
          }
        } else if (this.props.collection !== nextProps.collection) {
          this.removeDraggable(this.props.collection);
          this.setDraggable(nextProps.collection, nextProps.index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props2 = this.props,
            collection = _props2.collection,
            disabled = _props2.disabled;


        if (!disabled) this.removeDraggable(collection);
      }
    }, {
      key: 'setDraggable',
      value: function setDraggable(collection, index) {
        var node = this.node = (0, _reactDom.findDOMNode)(this);

        node.sortableInfo = {
          index: index,
          collection: collection,
          manager: this.context.manager
        };

        this.ref = { node: node };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: 'removeDraggable',
      value: function removeDraggable(collection) {
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableHandle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(25);

var _invariant = __webpack_require__(47);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(180);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var node = (0, _reactDom.findDOMNode)(this);
        node.sortableHandle = true;
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(471);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BubbleComponent=function(_Component){_inherits(BubbleComponent,_Component);function BubbleComponent(props){_classCallCheck(this,BubbleComponent);var _this=_possibleConstructorReturn(this,(BubbleComponent.__proto__||Object.getPrototypeOf(BubbleComponent)).call(this,props));_initialiseProps.call(_this);var selected=_this.props.selected;_this.state={selected:selected,isPressing:false};return _this;}_createClass(BubbleComponent,[{key:'render',value:function render(){var _props=this.props,_props$data=_props.data,id=_props$data.id,title=_props$data.title,image=_props$data.image,firstname=_props$data.firstname,noResize=_props.noResize,icon=_props.icon,onClick=_props.onClick,onSelect=_props.onSelect,colorText=_props.colorText;var selected=this.state.selected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{className:'face_bubble '+(selected?'selected':'')+' '+(onClick||onSelect?'clickable':''),onClick:this.handleOnClick,selected:selected&&!noResize,onTouchStart:this.handleMouseDown,onTouchEnd:this.handleMouseUp,onMouseDown:this.handleMouseDown,onMouseUp:this.handleMouseUp},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Avatar__["a" ],{avatar:image,firstname:firstname,id:id}),icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bubble_icon'},icon):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["d" ],{className:'face_bubble_text',colorText:colorText?'black':'#fff'},title));}}]);return BubbleComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleOnClick=function(){var _props2=_this2.props,id=_props2.data.id,onSelect=_props2.onSelect,onUnselect=_props2.onUnselect,canSelect=_props2.canSelect,onClick=_props2.onClick;var selected=_this2.state.selected;if(onClick){onClick(id);}if(!canSelect){return true;}if(selected){if(onUnselect){onUnselect(id);}}else if(onSelect){onSelect(id);}_this2.setState({selected:!selected});return true;};this.checkViewDetail=function(){var isPressing=_this2.state.isPressing;var _props3=_this2.props,onLongPress=_props3.onLongPress,data=_props3.data;if(isPressing){onLongPress(data);}};this.handleMouseUp=function(){_this2.setState({isPressing:false});};this.handleMouseDown=function(){_this2.setState({isPressing:true});setTimeout(function(){_this2.checkViewDetail();},1000);};};BubbleComponent.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnselect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,canSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onLongPress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noResize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element};BubbleComponent.defaultProps={onSelect:null,onClick:null,onUnselect:null,canSelect:false,selected:false,noResize:false,icon:null}; __webpack_exports__["a"] = (BubbleComponent);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1188);
function mapStateToProps(state){return{literals:state.i18n.literals.think||{},app:state.app,user:state.session.user,narratives:state.narratives.list};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_constants_tables__ = __webpack_require__(110);
 var __WEBPACK_IMPORTED_MODULE_5_components_Countdown__ = __webpack_require__(69);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_think_table_jpg__ = __webpack_require__(171);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_think_table_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_images_think_table_jpg__);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_themeTable_perso1_svg__ = __webpack_require__(1191);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_themeTable_perso1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_images_themeTable_perso1_svg__);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_themeTable_perso2_svg__ = __webpack_require__(1192);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_themeTable_perso2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_images_themeTable_perso2_svg__);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_themeTable_perso3_svg__ = __webpack_require__(1193);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_themeTable_perso3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_images_themeTable_perso3_svg__);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_themeTable_perso4_svg__ = __webpack_require__(1194);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_themeTable_perso4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_assets_images_themeTable_perso4_svg__);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_themeTable_perso5_svg__ = __webpack_require__(1195);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_themeTable_perso5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_images_themeTable_perso5_svg__);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_themeTable_perso6_svg__ = __webpack_require__(1196);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_themeTable_perso6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_images_themeTable_perso6_svg__);
 var __WEBPACK_IMPORTED_MODULE_13_assets_images_themeTable_perso7_svg__ = __webpack_require__(1197);
 var __WEBPACK_IMPORTED_MODULE_13_assets_images_themeTable_perso7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_assets_images_themeTable_perso7_svg__);
 var __WEBPACK_IMPORTED_MODULE_14_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_15_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_16__styles__ = __webpack_require__(1198);
function ThemeTableCard(props){var data=props.data,user=props.user,literals=props.literals,hideInfo=props.hideInfo,onClick=props.onClick,isDragging=props.isDragging;var name=data.name,image=data.image,limitDate=data.limit_date;var isIn=false;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(data.users,function(u){if(u.id===user.id){isIn=true;}});var imageBackground=data.type===__WEBPACK_IMPORTED_MODULE_4_constants_tables__["c" ]?'':image||__WEBPACK_IMPORTED_MODULE_6_assets_images_think_table_jpg___default.a;var printUsers=function printUsers(){var size=data.users.length;var users=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.users,function(us,key){switch(key){case 0:if(us.avatar){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'6rem',top:'-2rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Avatar__["a" ],{size:40,avatar:us.avatar,firstname:user.firstname}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'6rem',top:'-3rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7_assets_images_themeTable_perso1_svg___default.a,alt:''}));case 1:if(us.avatar){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'0rem',top:'0rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Avatar__["a" ],{size:40,avatar:us.avatar,firstname:user.firstname}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'0.5rem',top:'0.5rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8_assets_images_themeTable_perso2_svg___default.a,alt:''}));case 2:if(us.avatar){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'-1.5rem',top:'6rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Avatar__["a" ],{size:40,avatar:us.avatar,firstname:user.firstname}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'-2.5rem',top:'6rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_assets_images_themeTable_perso3_svg___default.a,alt:''}));case 3:if(us.avatar){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'0.5rem',top:'11.5rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Avatar__["a" ],{size:40,avatar:us.avatar,firstname:user.firstname}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'-1.5rem',top:'11rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10_assets_images_themeTable_perso4_svg___default.a,alt:''}));case 4:if(us.avatar){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'6rem',top:'14rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Avatar__["a" ],{size:40,avatar:us.avatar,firstname:user.firstname}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'5rem',top:'12.5rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_assets_images_themeTable_perso5_svg___default.a,alt:''}));case 5:if(us.avatar){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'11.5rem',top:'11.5rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Avatar__["a" ],{size:40,avatar:us.avatar,firstname:user.firstname}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'11.5rem',top:'11.5rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12_assets_images_themeTable_perso6_svg___default.a,alt:''}));case 6:if(us.avatar){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'13.5rem',top:'6rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Avatar__["a" ],{size:40,avatar:us.avatar,firstname:user.firstname}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'12.5rem',top:'6rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13_assets_images_themeTable_perso7_svg___default.a,alt:''}));case 7:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'11.5rem',top:'0.5rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'more'},size-7,'+'));default:break;}return null;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,users);};var printLessTwoUsers=function printLessTwoUsers(){var users=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.users,function(us,key){if(key===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{left:'-2.5rem',top:'2rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Avatar__["a" ],{size:55,avatar:us.avatar,firstname:user.firstname}));}if(key===1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["f" ],{right:'-2.5rem',top:'2rem',key:us.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Avatar__["a" ],{size:55,avatar:us.avatar,firstname:user.firstname}));}return null;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,users);};var now=__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix();var click=function click(){if(!isDragging){if(onClick){onClick(data.id);}else{__WEBPACK_IMPORTED_MODULE_15_store_history__["a" ].push('/theme-table/'+data.id);}}};if(data.users.length<=2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["a" ],{className:'theme_table_card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["b" ],{onClick:click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["d" ],{img:imageBackground}),printLessTwoUsers()),!hideInfo&&data.phase.id===__WEBPACK_IMPORTED_MODULE_4_constants_tables__["a" ]&&limitDate>now?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ending'},literals.endsIn,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Countdown__["a" ],{time:limitDate})):null,!hideInfo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table_name'},name):null);}if(data.users.length>=3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["a" ],{className:'theme_table_card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["e" ],{onClick:click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["c" ],{img:imageBackground,'in':isIn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity'})),printUsers()),!hideInfo&&data.phase.id===__WEBPACK_IMPORTED_MODULE_4_constants_tables__["a" ]&&limitDate>now?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ending'},literals.endsIn,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Countdown__["a" ],{time:limitDate})):null,!hideInfo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table_name'},name):null);}}ThemeTableCard.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,hideInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isDragging:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ThemeTableCard.defaultProps={onClick:null,hideInfo:false,isDragging:false}; __webpack_exports__["a"] = (ThemeTableCard);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1190);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function Countdown(props){var time=props.time,onFinish=props.onFinish;var enabled=props.enabled;if(enabled===undefined){enabled=true;}// Count down
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),remainingTime=_useState2[0],setRemainingTime=_useState2[1];var toCountDown=null;var calculateCountdown=function calculateCountdown(){if(__WEBPACK_IMPORTED_MODULE_1_moment___default()().unix()<=time){var seconds=time-__WEBPACK_IMPORTED_MODULE_1_moment___default()().unix();// calculate days
var days=Math.floor(seconds/86400);seconds-=days*86400;// calculate hours
var hours=Math.floor(seconds/3600)%24;seconds-=hours*3600;// calculate minutes
var minutes=Math.floor(seconds/60)%60;seconds-=minutes*60;setRemainingTime({days:days.toString(),hours:hours.toString(),minutes:minutes.toString(),seconds:seconds.toString()});toCountDown=setTimeout(calculateCountdown,1000);}else{setRemainingTime(null);if(onFinish){onFinish();}}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){calculateCountdown();return function(){if(toCountDown){clearTimeout(toCountDown);}};},[time]);if(!remainingTime){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{className:'countdown',enabled:enabled},remainingTime.days>0&&remainingTime.days+' days ',remainingTime.hours>0&&remainingTime.hours+' hours ',remainingTime.minutes>0&&(remainingTime.days==='0'||remainingTime.days>0&&remainingTime.hours==='0')&&remainingTime.minutes+' minutes ',remainingTime.days==='0'&&remainingTime.hours==='0'?remainingTime.seconds+' seconds':null);}Countdown.propTypes={time:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,onFinish:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};Countdown.defaultProps={onFinish:null}; __webpack_exports__["a"] = (Countdown);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return CountdownStyled; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_2_constants_fonts__ = __webpack_require__(17);
var _templateObject=_taggedTemplateLiteral(['\n    font-family: ',';\n    color: ',';\n'],['\n    font-family: ',';\n    color: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CountdownStyled=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily,function(props){return props.enabled?''+__WEBPACK_IMPORTED_MODULE_1_constants_colors__["f" ]:'gray';});

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/perso1.40128349.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/perso2.ef40ebe9.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/perso3.b536b970.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/perso4.9d8c7bc3.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/perso5.bb86dfad.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/perso6.5be62e6e.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/perso7.876ed741.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return ThemeTableWrapper; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return User; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return TTCircle; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return SmallThemeTableWrapper; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return TTSmallCircle; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  width: 23rem;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n\n  .table_name {\n    font-family: ',';\n    color: ',';\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n    white-space: initial;\n    width: 90%;\n    margin: 0 auto;\n  }\n\n  .countdown {\n    display: inline-block;\n    margin-left: 0.5rem;\n  }\n'],['\n  width: 23rem;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n\n  .table_name {\n    font-family: ',';\n    color: ',';\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n    white-space: initial;\n    width: 90%;\n    margin: 0 auto;\n  }\n\n  .countdown {\n    display: inline-block;\n    margin-left: 0.5rem;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin: 2rem;\n  width: 16rem;\n  cursor: pointer;\n  position: relative;\n  height: 20rem;\n'],['\n  margin: 2rem;\n  width: 16rem;\n  cursor: pointer;\n  position: relative;\n  height: 20rem;\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: absolute;\n  right: ',';\n  left: ',';\n  top: ',';\n  z-index: 2;\n  .more {\n    height: 3.5rem;\n    width: 3.5rem;\n    border-radius: 100%;\n    background: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.4rem;\n  }\n'],['\n  position: absolute;\n  right: ',';\n  left: ',';\n  top: ',';\n  z-index: 2;\n  .more {\n    height: 3.5rem;\n    width: 3.5rem;\n    border-radius: 100%;\n    background: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.4rem;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 16rem;\n  height: 16rem;\n  border-radius: 100%;\n  background: ',';\n  background-color: #e8e8e8;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: ',';\n\n  .opacity {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 100%;\n    z-index: 2;\n    background-color: rgba(0, 0, 0, 0.3);\n  }\n\n  img {\n    height: 15%;\n    position: absolute;\n    top: 2rem;\n    z-index: 2;\n  }\n'],['\n  width: 16rem;\n  height: 16rem;\n  border-radius: 100%;\n  background: ',';\n  background-color: #e8e8e8;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: ',';\n\n  .opacity {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 100%;\n    z-index: 2;\n    background-color: rgba(0, 0, 0, 0.3);\n  }\n\n  img {\n    height: 15%;\n    position: absolute;\n    top: 2rem;\n    z-index: 2;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  margin: 6rem 4rem;\n  width: 10rem;\n  cursor: pointer;\n  position: relative;\n  height: 12rem;\n'],['\n  margin: 6rem 4rem;\n  width: 10rem;\n  cursor: pointer;\n  position: relative;\n  height: 12rem;\n']),_templateObject6=_taggedTemplateLiteral(['\n  width: 10rem;\n  height: 10rem;\n  border-radius: 100%;\n  background-color: #E8E8E8;\n  background-image: ',';\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50%;\n'],['\n  width: 10rem;\n  height: 10rem;\n  border-radius: 100%;\n  background-color: #E8E8E8;\n  background-image: ',';\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ]);var ThemeTableWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var User=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,function(props){return props.right;},function(props){return props.left;},function(props){return props.top;});var TTCircle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return'url('+props.img+')';},function(props){return props.in?'0.5rem solid #2680EB':'';});var SmallThemeTableWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var TTSmallCircle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,function(props){return'url('+props.img+')';});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return AffiliationModalWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_2_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_3_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  .loading_wrapper {\n    height: 90%;\n  }\n\n  .modal {\n    padding: 2rem 0\n  }\n\n  .affiliation_card {\n    border-radius: 1.5rem;\n    width: 80rem;\n    ma-width: 80vw;\n    height: calc(94vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n    font-family: ','\n\n    .affiliation_info {\n      padding: 2rem;\n\n      .icon {\n        width: 5rem;\n        height: 5rem;\n        border-radius: 2.5rem;\n        margin: 0;\n        display: inline-block;\n        background-size: contain;\n        background-position: 50%;\n        background-repeat: no-repeat;\n        border: 2px solid black;\n        vertical-align: middle;\n      }\n\n      .info {\n        display: inline-block;\n        margin: 1rem;\n        vertical-align: middle;\n        width: calc(100% - 10rem);\n        word-break: break-all;\n\n        p {\n          margin-bottom: 1rem;\n          font-size: 1.3rem;\n          font-family: ','\n        }\n\n        a {\n          color: #2680EB;\n          font-size: 1.3rem;\n          display: block;\n          font-family: ','\n        }\n      }\n\n      .btn_belong {\n        border-radius: 20px;\n        font-size: 1.2rem;\n        border: 0px;\n        color: #fff;\n        background-color: #1976d2;\n        padding: 0.8rem;\n        float: none;\n        word-break: break-word;\n        margin: 1rem 0;\n      }\n      .btn_dont_belong {\n        border-radius: 20px;\n        font-size: 1.2rem;\n        border: 0px;\n        color: #fff;\n        background-color: ',';\n        padding: 0.8rem;\n        float: none;\n        margin: 1rem 0;\n        word-break: break-word;\n      }\n    }\n\n    .sponsor {\n      background-color: #f2f2f2;\n      font-size: 1.4rem;\n      font-family: ',';\n      padding: 1rem;\n    }\n\n    .people {\n      margin: 2rem 2rem 0rem;\n\n      .face_bubble_text {\n        color: ',';\n        white-space: normal;\n      }\n\n      .users_wrapper {\n        display: inline-block;\n        white-space: nowrap;\n        overflow-y: hidden;\n        overflow-x: scroll;\n\n        .users {\n          padding: 1rem;\n          font-family: ','\n          font-size: 1rem;\n          display: inline-block;\n          margin: 1.5rem;\n          width: 8rem;\n          height: 10rem;\n\n          .user_content {\n            margin-top: 1.5rem;\n\n            .name {\n              width: 8rem;\n\n            }\n          }\n        }\n      }\n    }\n\n    .tables {\n      margin: 0rem 2rem 2rem;\n\n      .tables_wrapper {\n        display: inline-block;\n        width: auto;\n        padding: 1rem;\n        white-space: nowrap;\n        overflow-y: hidden;\n        overflow-x: scroll;\n\n        .tables {\n          padding: 1rem;\n          display: inline-block;\n          margin: 1.5rem;\n\n          .name {\n            text-align: center;\n            font-family: ','\n            font-size: 1.3rem;\n          }\n        }\n      }\n    }\n  }\n\n\n\n  button {\n    float: right;\n\n  }\n'],['\n  .loading_wrapper {\n    height: 90%;\n  }\n\n  .modal {\n    padding: 2rem 0\n  }\n\n  .affiliation_card {\n    border-radius: 1.5rem;\n    width: 80rem;\n    ma-width: 80vw;\n    height: calc(94vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n    font-family: ','\n\n    .affiliation_info {\n      padding: 2rem;\n\n      .icon {\n        width: 5rem;\n        height: 5rem;\n        border-radius: 2.5rem;\n        margin: 0;\n        display: inline-block;\n        background-size: contain;\n        background-position: 50%;\n        background-repeat: no-repeat;\n        border: 2px solid black;\n        vertical-align: middle;\n      }\n\n      .info {\n        display: inline-block;\n        margin: 1rem;\n        vertical-align: middle;\n        width: calc(100% - 10rem);\n        word-break: break-all;\n\n        p {\n          margin-bottom: 1rem;\n          font-size: 1.3rem;\n          font-family: ','\n        }\n\n        a {\n          color: #2680EB;\n          font-size: 1.3rem;\n          display: block;\n          font-family: ','\n        }\n      }\n\n      .btn_belong {\n        border-radius: 20px;\n        font-size: 1.2rem;\n        border: 0px;\n        color: #fff;\n        background-color: #1976d2;\n        padding: 0.8rem;\n        float: none;\n        word-break: break-word;\n        margin: 1rem 0;\n      }\n      .btn_dont_belong {\n        border-radius: 20px;\n        font-size: 1.2rem;\n        border: 0px;\n        color: #fff;\n        background-color: ',';\n        padding: 0.8rem;\n        float: none;\n        margin: 1rem 0;\n        word-break: break-word;\n      }\n    }\n\n    .sponsor {\n      background-color: #f2f2f2;\n      font-size: 1.4rem;\n      font-family: ',';\n      padding: 1rem;\n    }\n\n    .people {\n      margin: 2rem 2rem 0rem;\n\n      .face_bubble_text {\n        color: ',';\n        white-space: normal;\n      }\n\n      .users_wrapper {\n        display: inline-block;\n        white-space: nowrap;\n        overflow-y: hidden;\n        overflow-x: scroll;\n\n        .users {\n          padding: 1rem;\n          font-family: ','\n          font-size: 1rem;\n          display: inline-block;\n          margin: 1.5rem;\n          width: 8rem;\n          height: 10rem;\n\n          .user_content {\n            margin-top: 1.5rem;\n\n            .name {\n              width: 8rem;\n\n            }\n          }\n        }\n      }\n    }\n\n    .tables {\n      margin: 0rem 2rem 2rem;\n\n      .tables_wrapper {\n        display: inline-block;\n        width: auto;\n        padding: 1rem;\n        white-space: nowrap;\n        overflow-y: hidden;\n        overflow-x: scroll;\n\n        .tables {\n          padding: 1rem;\n          display: inline-block;\n          margin: 1.5rem;\n\n          .name {\n            text-align: center;\n            font-family: ','\n            font-size: 1.3rem;\n          }\n        }\n      }\n    }\n  }\n\n\n\n  button {\n    float: right;\n\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AffiliationModalWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Modal__["a" ])(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["h" ],__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return ThemeTablesGrid; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ThemeTablesWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return Bubble; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return Satellite; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(472);
var _templateObject=_taggedTemplateLiteral(['\n  display: grid;\n  grid-template-rows: calc(100% - 6rem) 6rem;\n  height: ','px;\n\n  .theme_tables_overflow {\n    overflow: hidden;\n    position: relative;\n    cursor: pointer;\n    * {\n      cursor: pointer;\n    }\n  }\n\n  .options_wrapper {\n    text-align: center;\n    > div {\n      display: inline-block;\n      vertical-align: middle;\n    }\n    .slider_wrapper {\n      padding: 0 2rem;\n      width: calc(100% - 12rem);\n      max-width: 50rem;\n    }\n\n    .btn-fullscreen {\n      width: 10rem;\n      background-color: rgba(255, 255, 255, 0.5);\n      border-radius: 2rem;\n      color: #fff;\n      padding: 0.5rem;\n      font-size: 1.2rem;\n      i {\n        margin-left: 0.5rem;\n      }\n    }\n  }\n\n'],['\n  display: grid;\n  grid-template-rows: calc(100% - 6rem) 6rem;\n  height: ','px;\n\n  .theme_tables_overflow {\n    overflow: hidden;\n    position: relative;\n    cursor: pointer;\n    * {\n      cursor: pointer;\n    }\n  }\n\n  .options_wrapper {\n    text-align: center;\n    > div {\n      display: inline-block;\n      vertical-align: middle;\n    }\n    .slider_wrapper {\n      padding: 0 2rem;\n      width: calc(100% - 12rem);\n      max-width: 50rem;\n    }\n\n    .btn-fullscreen {\n      width: 10rem;\n      background-color: rgba(255, 255, 255, 0.5);\n      border-radius: 2rem;\n      color: #fff;\n      padding: 0.5rem;\n      font-size: 1.2rem;\n      i {\n        margin-left: 0.5rem;\n      }\n    }\n  }\n\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: relative;\n  width: ','px;\n  height: ','px;\n  cursor: move;\n'],['\n  position: relative;\n  width: ','px;\n  height: ','px;\n  cursor: move;\n']),_templateObject3=_taggedTemplateLiteral(['\n  border-radius: 50%;\n  background-color: #ccc;\n  position: absolute;\n  cursor: pointer;\n  background-image: ',';\n  background-size: cover;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  transition: opacity ease 0.3s;\n\n  .opacity {\n    display: ',';\n    background: rgba(0, 0, 0, 0.5);\n    position: absolute;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    pointer-events: none;\n    border-radius: 50%;\n  }\n\n  &.not_pass_filter {\n    opacity: 0.4;\n  }\n\n  &.selected {\n    &.lg {\n      box-shadow: 0 0 0 1.7rem rgb(255 255 255 / 40%)\n    }\n    &.md {\n      box-shadow: 0 0 0 1.3rem rgb(255 255 255 / 40%)\n    }\n    &.xs {\n      box-shadow: 0 0 0 1rem rgb(255 255 255 / 40%)\n    }\n\n  }\n\n  img {\n    pointer-events: none;\n  }\n\n  .bubble_content {\n    position: relative;\n    width: 100%;\n    text-align: center;\n    z-index: 2;\n    overflow: hidden;\n    border-radius: 50%;\n    overflow: hidden;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n\n    > div {\n      width: 85%;\n      margin: 0 auto;\n    }\n  }\n\n  .name {\n    padding: 0.1rem 0.6rem;\n    font-weight: 600;\n    overflow: hidden;\n    color: #fff;\n    text-align: center;\n    width: 100% !important;\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n\n    .is_new {\n      color: ',';\n      display: inline-block;\n      margin: 0 0.5rem;\n      font-style: italic;\n    }\n  }\n\n  .tag {\n    background-color: #fff;\n    border-radius: 10px;\n    color: #444;\n    padding: 0.3rem;\n    font-size: 0.9rem;\n    border: 0.1rem solid #ddd;\n    display: inline-block;\n    margin: 0.2rem 0.2rem 0 0;\n  }\n\n  .inline_elements {\n    white-space: nowrap;\n    margin-bottom: 0.5rem;\n\n    .avatar_bubble {\n      margin-right: -1rem;\n      position: relative;\n    }\n\n    .more_indicator {\n      border-radius: 50%;\n      background-color: #fff;\n      text-align: center;\n      font-weight: 600;\n      letter-spacing: 0.1rem;\n      display: inline-block;\n      position: relative;\n      z-index: 20;\n      vertical-align: middle;\n    }\n  }\n\n  &.xs {\n    width: ','px;\n    height: ','px;\n    border: ',';\n\n    .inline_elements {\n      .more_indicator {\n        width: ','rem;\n        height: ','rem;\n        line-height: ','rem;\n        font-size: 0.5rem;\n      }\n    }\n\n    .name {\n      font-size: 0.6rem;\n      line-height: 0.8rem;\n      max-height: 2.4rem;\n    }\n\n    .tag {\n      font-size: 0.5rem;\n    }\n  }\n\n  &.md {\n    width: ','px;\n    height: ','px;\n    border: ',';\n\n    .inline_elements {\n      .more_indicator {\n        width: ','rem;\n        height: ','rem;\n        line-height: ','rem;\n        font-size: 0.7rem;\n      }\n    }\n\n    .name {\n      font-size: 0.7rem;\n      line-height: 0.9rem;\n      max-height: 2.9rem;\n    }\n\n    .tag {\n      font-size: 0.7rem;\n    }\n  }\n\n  &.lg {\n    width: ','px;\n    height: ','px;\n    border: ',';\n\n    .inline_elements {\n      .more_indicator {\n        width: ','rem;\n        height: ','rem;\n        line-height: ','rem;\n        font-size: 0.8rem;\n      }\n    }\n\n    .name {\n      font-size: 0.9rem;\n      line-height: 1.2rem;\n      max-height: 3.6rem;\n    }\n\n    .tag {\n      font-size: 0.8rem;\n    }\n  }\n'],['\n  border-radius: 50%;\n  background-color: #ccc;\n  position: absolute;\n  cursor: pointer;\n  background-image: ',';\n  background-size: cover;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  transition: opacity ease 0.3s;\n\n  .opacity {\n    display: ',';\n    background: rgba(0, 0, 0, 0.5);\n    position: absolute;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    pointer-events: none;\n    border-radius: 50%;\n  }\n\n  &.not_pass_filter {\n    opacity: 0.4;\n  }\n\n  &.selected {\n    &.lg {\n      box-shadow: 0 0 0 1.7rem rgb(255 255 255 / 40%)\n    }\n    &.md {\n      box-shadow: 0 0 0 1.3rem rgb(255 255 255 / 40%)\n    }\n    &.xs {\n      box-shadow: 0 0 0 1rem rgb(255 255 255 / 40%)\n    }\n\n  }\n\n  img {\n    pointer-events: none;\n  }\n\n  .bubble_content {\n    position: relative;\n    width: 100%;\n    text-align: center;\n    z-index: 2;\n    overflow: hidden;\n    border-radius: 50%;\n    overflow: hidden;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n\n    > div {\n      width: 85%;\n      margin: 0 auto;\n    }\n  }\n\n  .name {\n    padding: 0.1rem 0.6rem;\n    font-weight: 600;\n    overflow: hidden;\n    color: #fff;\n    text-align: center;\n    width: 100% !important;\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n\n    .is_new {\n      color: ',';\n      display: inline-block;\n      margin: 0 0.5rem;\n      font-style: italic;\n    }\n  }\n\n  .tag {\n    background-color: #fff;\n    border-radius: 10px;\n    color: #444;\n    padding: 0.3rem;\n    font-size: 0.9rem;\n    border: 0.1rem solid #ddd;\n    display: inline-block;\n    margin: 0.2rem 0.2rem 0 0;\n  }\n\n  .inline_elements {\n    white-space: nowrap;\n    margin-bottom: 0.5rem;\n\n    .avatar_bubble {\n      margin-right: -1rem;\n      position: relative;\n    }\n\n    .more_indicator {\n      border-radius: 50%;\n      background-color: #fff;\n      text-align: center;\n      font-weight: 600;\n      letter-spacing: 0.1rem;\n      display: inline-block;\n      position: relative;\n      z-index: 20;\n      vertical-align: middle;\n    }\n  }\n\n  &.xs {\n    width: ','px;\n    height: ','px;\n    border: ',';\n\n    .inline_elements {\n      .more_indicator {\n        width: ','rem;\n        height: ','rem;\n        line-height: ','rem;\n        font-size: 0.5rem;\n      }\n    }\n\n    .name {\n      font-size: 0.6rem;\n      line-height: 0.8rem;\n      max-height: 2.4rem;\n    }\n\n    .tag {\n      font-size: 0.5rem;\n    }\n  }\n\n  &.md {\n    width: ','px;\n    height: ','px;\n    border: ',';\n\n    .inline_elements {\n      .more_indicator {\n        width: ','rem;\n        height: ','rem;\n        line-height: ','rem;\n        font-size: 0.7rem;\n      }\n    }\n\n    .name {\n      font-size: 0.7rem;\n      line-height: 0.9rem;\n      max-height: 2.9rem;\n    }\n\n    .tag {\n      font-size: 0.7rem;\n    }\n  }\n\n  &.lg {\n    width: ','px;\n    height: ','px;\n    border: ',';\n\n    .inline_elements {\n      .more_indicator {\n        width: ','rem;\n        height: ','rem;\n        line-height: ','rem;\n        font-size: 0.8rem;\n      }\n    }\n\n    .name {\n      font-size: 0.9rem;\n      line-height: 1.2rem;\n      max-height: 3.6rem;\n    }\n\n    .tag {\n      font-size: 0.8rem;\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  z-index:100;\n\n  &.sat_0 {\n    left: 0;\n    top: 50%;\n    transform: translate(-80%, -50%);\n  }\n\n  &.sat_1 {\n    left: 15%;\n    top: 10%;\n    transform: translate(-50%, -50%);\n  }\n\n  &.sat_2 {\n    left: 15%;\n    top: 85%;\n    transform: translate(-50%, -50%);\n  }\n\n  &.sat_3 {\n    left: 50%;\n    top: -1%;\n    transform: translate(-50%, -50%);\n  }\n\n  &.sat_4 {\n    left: 50%;\n    top: 100%;\n    transform: translate(-50%, -50%);\n  }\n\n  &.sat_5 {\n    left: 65%;\n    top: 10%;\n    transform: translate(50%, -50%);\n  }\n\n  &.more_indicator {\n    background-color: #000;\n    color: #fff;\n    width: ','rem;\n    height: ','rem;\n    line-height: ','rem;\n    border-radius: 50%;\n    text-align: center;\n    font-weight: 600;\n    letter-spacing: 0.1rem;\n  }\n'],['\n  position: absolute;\n  z-index:100;\n\n  &.sat_0 {\n    left: 0;\n    top: 50%;\n    transform: translate(-80%, -50%);\n  }\n\n  &.sat_1 {\n    left: 15%;\n    top: 10%;\n    transform: translate(-50%, -50%);\n  }\n\n  &.sat_2 {\n    left: 15%;\n    top: 85%;\n    transform: translate(-50%, -50%);\n  }\n\n  &.sat_3 {\n    left: 50%;\n    top: -1%;\n    transform: translate(-50%, -50%);\n  }\n\n  &.sat_4 {\n    left: 50%;\n    top: 100%;\n    transform: translate(-50%, -50%);\n  }\n\n  &.sat_5 {\n    left: 65%;\n    top: 10%;\n    transform: translate(50%, -50%);\n  }\n\n  &.more_indicator {\n    background-color: #000;\n    color: #fff;\n    width: ','rem;\n    height: ','rem;\n    line-height: ','rem;\n    border-radius: 50%;\n    text-align: center;\n    font-weight: 600;\n    letter-spacing: 0.1rem;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ThemeTablesGrid=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.height;});var ThemeTablesWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.size.width;},function(props){return props.size.height;});var Bubble=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,function(props){return props.image?'url('+props.image+')':'none';},function(props){return props.image?'block':'none';},__WEBPACK_IMPORTED_MODULE_1_constants_colors__["h" ],__WEBPACK_IMPORTED_MODULE_2__constants__["a" ].xs,__WEBPACK_IMPORTED_MODULE_2__constants__["a" ].xs,function(props){return props.highlighted?'0.4rem solid '+props.color:'0rem';},__WEBPACK_IMPORTED_MODULE_2__constants__["d" ].xs/10,__WEBPACK_IMPORTED_MODULE_2__constants__["d" ].xs/10,__WEBPACK_IMPORTED_MODULE_2__constants__["d" ].xs/10,__WEBPACK_IMPORTED_MODULE_2__constants__["a" ].md,__WEBPACK_IMPORTED_MODULE_2__constants__["a" ].md,function(props){return props.highlighted?'0.6rem solid '+props.color:'0rem';},__WEBPACK_IMPORTED_MODULE_2__constants__["d" ].md/10,__WEBPACK_IMPORTED_MODULE_2__constants__["d" ].md/10,__WEBPACK_IMPORTED_MODULE_2__constants__["d" ].md/10,__WEBPACK_IMPORTED_MODULE_2__constants__["a" ].lg,__WEBPACK_IMPORTED_MODULE_2__constants__["a" ].lg,function(props){return props.highlighted?'0.8rem solid '+props.color:'0rem';},__WEBPACK_IMPORTED_MODULE_2__constants__["d" ].lg/10,__WEBPACK_IMPORTED_MODULE_2__constants__["d" ].lg/10,__WEBPACK_IMPORTED_MODULE_2__constants__["d" ].lg/10);var Satellite=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_2__constants__["h" ].xs/10,__WEBPACK_IMPORTED_MODULE_2__constants__["h" ].xs/10,__WEBPACK_IMPORTED_MODULE_2__constants__["h" ].xs/10);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1202);
function mapStateToProps(state){return{literals:state.i18n.literals.autocompleteInput};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(25);
 var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
 var __WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_5_utils_string__ = __webpack_require__(67);
 var __WEBPACK_IMPORTED_MODULE_6__modules_actions__ = __webpack_require__(1203);
 var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1204);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function AutocompleteInput(props){var placeholder=props.placeholder,options=props.options,async=props.async,type=props.type,literals=props.literals,onSelectOption=props.onSelectOption,canCreateNew=props.canCreateNew,onCreateOption=props.onCreateOption;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState2=_slicedToArray(_useState,2),search=_useState2[0],setSearch=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isFocus=_useState4[0],setIsFocus=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(options),_useState6=_slicedToArray(_useState5,2),results=_useState6[0],setResults=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),myResultsModal=_useState8[0],setMyResultsModal=_useState8[1];var toSearch=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var inputEl=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var searchId=0;var doSearch=function doSearch(){var newSearchId=Math.round(Math.random()*99999);searchId=newSearchId;if(search){Object(__WEBPACK_IMPORTED_MODULE_6__modules_actions__["a" ])(type,search).then(function(response){if(newSearchId===searchId){setResults(response);}});}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(async){doSearch();}var resultsModal=document.createElement('div');resultsModal.setAttribute('id','results-modal');document.body.appendChild(resultsModal);return function(){document.body.removeChild(resultsModal);};},[]);var filterOptions=function filterOptions(){var strToSearch=Object(__WEBPACK_IMPORTED_MODULE_5_utils_string__["d" ])(search.toLowerCase());setResults(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(options,function(option){if(!search){return true;}var label=Object(__WEBPACK_IMPORTED_MODULE_5_utils_string__["d" ])(option.label.toLowerCase());return label.indexOf(strToSearch)>=0;}));};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){filterOptions();return function(){if(toSearch){clearTimeout(toSearch);}};},[options,search]);var removeResultsModal=function removeResultsModal(){if(myResultsModal){__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unmountComponentAtNode(myResultsModal);setMyResultsModal(null);}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!isFocus){removeResultsModal();}},[isFocus]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(async){clearTimeout(toSearch.current);toSearch.current=setTimeout(doSearch,1000);}},[search]);var handleSearcher=function handleSearcher(event){setSearch(event.currentTarget.value);};var handleCreate=function handleCreate(){var tagCreated={name:search};onCreateOption(tagCreated);};var handleFocus=function handleFocus(){setIsFocus(true);if(async){clearTimeout(toSearch.current);toSearch.current=setTimeout(doSearch,1000);}else{filterOptions();}};var handleBlur=function handleBlur(){setTimeout(function(){setIsFocus(false);},250);};var handleSelect=function handleSelect(event){var onSelect=props.onSelect;var add={id:parseInt(event.currentTarget.getAttribute('data-id'),10),name:event.currentTarget.getAttribute('name')};onSelectOption(add);if(onSelect){onSelect(add);}};var printResults=function printResults(){var content=[];if(!search){return removeResultsModal();}var bounds=inputEl.current.getBoundingClientRect();var left=bounds.left,top=bounds.top,width=bounds.width,height=bounds.height;var hasOptions=props.hasOptions;var newLeft=left;var newTop=top+height;var styles={left:newLeft+'px',top:newTop+'px',width:width+'px'};var filteredResults=results;if(!results.length){content.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_results',key:'no_results'},literals.noResults));}else if(hasOptions!==null){filteredResults=results.filter(function(result,index){return index>hasOptions+1;});}content=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(filteredResults,function(result){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result','data-id':result.value,key:result.value,onClick:handleSelect,name:result.label},result.label);});if(canCreateNew&&search){content.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result create',key:'create',onClick:handleCreate},literals.create+' '+search));}var resultsLayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" ],{style:styles},content);var resultsModal=document.getElementById('results-modal');if(resultsModal){__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(resultsLayer,resultsModal);}setMyResultsModal(resultsModal);return null;};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isFocus){printResults();}else{removeResultsModal();}},[isFocus,search,results]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form_input_stl',type:'text',value:search,onFocus:handleFocus,onBlur:handleBlur,onChange:handleSearcher,placeholder:placeholder,ref:inputEl}));}AutocompleteInput.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,// tag || challenge || action || collective
placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,selectedOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,// ['red','yellow']
canCreateNew:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onSelectOption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onCreateOption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,async:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hasOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};AutocompleteInput.defaultProps={type:'tag',placeholder:'Search...',selectedOptions:[],canCreateNew:false,onCreateOption:null,options:null,async:true,hasOptions:null,onSelect:null}; __webpack_exports__["a"] = (AutocompleteInput);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = getOptions;
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
function getOptions(type,search){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'searchElements'},{type:type,search:search});}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ResultsModal; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 30rem;\n  max-width: 90vw;\n  background-color: #fff;\n  background: #ffffff;\n  border: 1px solid #cccccc;\n  padding: 1rem;\n  z-index: 1000;\n  max-height: 30rem;\n  overflow: auto;\n\n  &:after, &:before {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: "";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  &:after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #ffffff;\n    border-width: 5px;\n    margin-left: -5px;\n  }\n\n  &:before {\n    border-color: rgba(204, 204, 204, 0);\n    border-bottom-color: #cccccc;\n    border-width: 6px;\n    margin-left: -6px;\n  }\n\n  .result {\n    font-size: 1.4rem;\n    cursor: pointer;\n    padding: 0.5rem;\n\n    &.create {\n      border-top: 0.1rem solid #ddd;\n    }\n\n    @media (min-width: ','px) {\n      &:hover {\n        background-color: #eee;\n      }\n    }\n  }\n\n  .no_results {\n    font-size: 1.4rem;\n    padding: 0.5rem;\n  }\n'],['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 30rem;\n  max-width: 90vw;\n  background-color: #fff;\n  background: #ffffff;\n  border: 1px solid #cccccc;\n  padding: 1rem;\n  z-index: 1000;\n  max-height: 30rem;\n  overflow: auto;\n\n  &:after, &:before {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: "";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  &:after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #ffffff;\n    border-width: 5px;\n    margin-left: -5px;\n  }\n\n  &:before {\n    border-color: rgba(204, 204, 204, 0);\n    border-bottom-color: #cccccc;\n    border-width: 6px;\n    margin-left: -6px;\n  }\n\n  .result {\n    font-size: 1.4rem;\n    cursor: pointer;\n    padding: 0.5rem;\n\n    &.create {\n      border-top: 0.1rem solid #ddd;\n    }\n\n    @media (min-width: ','px) {\n      &:hover {\n        background-color: #eee;\n      }\n    }\n  }\n\n  .no_results {\n    font-size: 1.4rem;\n    padding: 0.5rem;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ResultsModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1206);
function mapStateToProps(){return{};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1207);
function ElementSimpleCard(props){var data=props.data,classesList=props.classesList;var style={};if(data.image){style.backgroundImage='url('+data.image+')';}var classesStr=classesList.join(' ');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" ],{className:classesStr},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header',style:style}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,data.name)));}ElementSimpleCard.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,classesList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};ElementSimpleCard.defaultProps={classesList:[]}; __webpack_exports__["a"] = (ElementSimpleCard);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ElementSimpleCardWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  width: 14rem;\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  overflow: hidden;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n\n  > .header {\n    height: 12rem;\n    background-size: cover;\n    background-color: #eee;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    position: relative;\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n  }\n\n  .body {\n    background-color: #fff;\n    padding: 1rem;\n\n    > div {\n      color: ',';\n      font-family: ',';\n      font-size: 1.2rem;\n      line-height: 1.6rem;\n      white-space: normal;\n      height: 4.95rem;\n      overflow: hidden;\n    }\n  }\n\n  > .footer {\n    background-color: #fff;\n  }\n'],['\n  width: 14rem;\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  overflow: hidden;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n\n  > .header {\n    height: 12rem;\n    background-size: cover;\n    background-color: #eee;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    position: relative;\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n  }\n\n  .body {\n    background-color: #fff;\n    padding: 1rem;\n\n    > div {\n      color: ',';\n      font-family: ',';\n      font-size: 1.2rem;\n      line-height: 1.6rem;\n      white-space: normal;\n      height: 4.95rem;\n      overflow: hidden;\n    }\n  }\n\n  > .footer {\n    background-color: #fff;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ElementSimpleCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return CreateTable; });



 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_3_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\nposition: absolute;\nright: 2%;\nbottom: 10%;\nwidth: 63px;\nheight: 63px;\nmargin: 2%;\nalign-items: center;\nz-index: 10000;\n\nbutton {\n  border-style: none;\n  background-color: ',';\n  width: 58px;\n  height: 58px;\n  padding: 5px;\n  border-radius: 50px;\n\n}\n'],['\nposition: absolute;\nright: 2%;\nbottom: 10%;\nwidth: 63px;\nheight: 63px;\nmargin: 2%;\nalign-items: center;\nz-index: 10000;\n\nbutton {\n  border-style: none;\n  background-color: ',';\n  width: 58px;\n  height: 58px;\n  padding: 5px;\n  border-radius: 50px;\n\n}\n']),_templateObject2=_taggedTemplateLiteral(['\n   width: 100%;\n   height: 100%;\n   font-family: ',';\n   background-color: white;\n   justify-content: center;\n\n   .new_chat_title {\n    font-family: ',';\n    font-size: 16px;\n    font-weight: 300;\n    width: 100%;\n    height: 38px;\n    text-align: center;\n    color: grey;\n    margin: 5% auto;\n    float: left;\n\n    @media (max-width: ','px){\n      font-family: ',';\n      font-size: 16px;\n      font-weight: 300;\n      width: 100%;\n      height: 38px;\n      text-align: center;\n      color: grey;\n      float: left;\n\n    }\n\n  }\n\n  .filter_chat {\n    height: 56px;\n    box-shadow: 0px 5px 10px 1px #ccc;\n\n    @media (max-width: ','px){\n      box-shadow: 0px 5px 10px 1px #ccc;\n    }\n  }\n'],['\n   width: 100%;\n   height: 100%;\n   font-family: ',';\n   background-color: white;\n   justify-content: center;\n\n   .new_chat_title {\n    font-family: ',';\n    font-size: 16px;\n    font-weight: 300;\n    width: 100%;\n    height: 38px;\n    text-align: center;\n    color: grey;\n    margin: 5% auto;\n    float: left;\n\n    @media (max-width: ','px){\n      font-family: ',';\n      font-size: 16px;\n      font-weight: 300;\n      width: 100%;\n      height: 38px;\n      text-align: center;\n      color: grey;\n      float: left;\n\n    }\n\n  }\n\n  .filter_chat {\n    height: 56px;\n    box-shadow: 0px 5px 10px 1px #ccc;\n\n    @media (max-width: ','px){\n      box-shadow: 0px 5px 10px 1px #ccc;\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n   height: 45px;\n   color: black;\n   font-size: 16px;\n   font-weight: bold;\n   display: flex;\n   margin-top: env(safe-area-inset-top);\n   align-items: center;\n\n   .arrowback {\n     float: left;\n     height: 45px;\n     margin-left: 2rem;\n   }\n\n  div {\n    float: left;\n    width: 85%;\n    height: 45px;\n    padding: 15px 0px;\n\n    @media (max-width: ','px){\n      width: 47vw;\n    }\n  }\n\n  .search_lens {\n    height: 45px;\n    padding: 10px;\n    @media (max-width: ','px){\n      margin-left: 11%;\n    }\n   }\n\n   .infocircle {\n     float: right;\n     height: 45px;\n     padding: 10px;\n   }\n'],['\n   height: 45px;\n   color: black;\n   font-size: 16px;\n   font-weight: bold;\n   display: flex;\n   margin-top: env(safe-area-inset-top);\n   align-items: center;\n\n   .arrowback {\n     float: left;\n     height: 45px;\n     margin-left: 2rem;\n   }\n\n  div {\n    float: left;\n    width: 85%;\n    height: 45px;\n    padding: 15px 0px;\n\n    @media (max-width: ','px){\n      width: 47vw;\n    }\n  }\n\n  .search_lens {\n    height: 45px;\n    padding: 10px;\n    @media (max-width: ','px){\n      margin-left: 11%;\n    }\n   }\n\n   .infocircle {\n     float: right;\n     height: 45px;\n     padding: 10px;\n   }\n']),_templateObject4=_taggedTemplateLiteral(['\n\n'],['\n\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CreateTable=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["j" ]);var NewTableContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var NewTableHeader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var NewTableContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1210);
function mapStateToProps(state){return{literals:state.i18n.literals.elementsHall,app:state.app};}function mapDispatchToProps(dispatch){return{showLoading:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_4_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_6_components_FeedbackModal__ = __webpack_require__(78);
 var __WEBPACK_IMPORTED_MODULE_7_components_ThemeTablesBubbles__ = __webpack_require__(462);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_icons_grid_png__ = __webpack_require__(1211);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_icons_grid_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_images_icons_grid_png__);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_icons_grid_off_png__ = __webpack_require__(1212);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_icons_grid_off_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_images_icons_grid_off_png__);
 var __WEBPACK_IMPORTED_MODULE_10_components_Steps_Faces__ = __webpack_require__(95);
 var __WEBPACK_IMPORTED_MODULE_11_components_AutocompleteInput__ = __webpack_require__(96);
 var __WEBPACK_IMPORTED_MODULE_12_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_13_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_14_assets_images_no_results_svg__ = __webpack_require__(179);
 var __WEBPACK_IMPORTED_MODULE_14_assets_images_no_results_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_assets_images_no_results_svg__);
 var __WEBPACK_IMPORTED_MODULE_15_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_16_components_AffiliationCard__ = __webpack_require__(470);
 var __WEBPACK_IMPORTED_MODULE_17_components_People_components_styles__ = __webpack_require__(263);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function ElementsHall(props){var elementType=props.elementType,elementId=props.elementId,literals=props.literals,app=props.app,type=props.type;var color1=app.color1;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),elements=_useState2[0],setElements=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_13_constants_status__["b" ]),_useState4=_slicedToArray(_useState3,2),statusRequest=_useState4[0],setStatusRequest=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState6=_slicedToArray(_useState5,2),selectedTopic=_useState6[0],setSelectedTopic=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),isLoading=_useState8[0],setIsLoading=_useState8[1];// Errors
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState10=_slicedToArray(_useState9,2),errors=_useState10[0],setErrors=_useState10[1];var removeErrors=function removeErrors(){setErrors([]);};var printErrors=function printErrors(){if(!errors.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_FeedbackModal__["a" ],{onClose:removeErrors,open:true,success:false,text:errors.join('<br />')});};// Tags
var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState12=_slicedToArray(_useState11,2),tags=_useState12[0],setTags=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState14=_slicedToArray(_useState13,2),selectedTags=_useState14[0],setSelectedTags=_useState14[1];// Searcher
var handleSearcher=function handleSearcher(value){var valueId=parseInt(value,10);var newSelectedTags=[].concat(_toConsumableArray(selectedTags));if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(newSelectedTags,function(tagValue){return tagValue===valueId;})){newSelectedTags.push(valueId);}var newTags=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(tags,{id:valueId}).concat(tags);setSelectedTags(newSelectedTags);setTags(newTags);};var handleSelectOptionSearcher=function handleSelectOptionSearcher(option){handleSearcher(option.id);};var printSearcher=function printSearcher(){var options=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tags,function(tag){return{value:tag.id,label:tag.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_AutocompleteInput__["a" ],{type:'tag',placeholder:literals.searchElements,onSelectOption:handleSelectOptionSearcher,options:options,async:false});};// Load data
var searchElements=function searchElements(){var params={type:type};if(elementType){params.element_type=elementType;}if(elementId){params.element_id=elementId;}setSelectedTopic(0);setElements([]);setTags([]);setStatusRequest(__WEBPACK_IMPORTED_MODULE_13_constants_status__["b" ]);setIsLoading(true);Object(__WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__["b" ])('GET',{endPoint:'networking-hall/elements'},params).then(function(response){setIsLoading(false);var finalTags=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(response.data,function(topic){if(typeof topic.related_elements!=='undefined'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topic.related_elements,function(element){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(finalTags,{id:element.id})){finalTags.push(element);}});}});setTags(finalTags);setElements(response.data);setStatusRequest(__WEBPACK_IMPORTED_MODULE_13_constants_status__["g" ]);}).catch(function(error){setIsLoading(false);errors.push(error.response.data.error);setErrors([].concat(_toConsumableArray(errors)));setStatusRequest(__WEBPACK_IMPORTED_MODULE_13_constants_status__["a" ]);});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){searchElements();},[elementType,elementId]);// Filter by tags
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!selectedTags.length){window.$('.theme_bubble').removeClass('not_pass_filter');}else{__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(elements,function(topic){var hasTag=false;if(typeof topic.related_elements!=='undefined'){hasTag=true;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(selectedTags,function(selectedTag){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(topic.related_elements,{id:selectedTag})){hasTag=false;}});}if(hasTag){window.$('.theme_bubble[data-id='+topic.id+']').removeClass('not_pass_filter');}else{window.$('.theme_bubble[data-id='+topic.id+']').addClass('not_pass_filter');}});}},[selectedTags]);var selectTag=function selectTag(event){var id=parseInt(event.currentTarget.getAttribute('data-id'),10);var newSelectedTags=[].concat(_toConsumableArray(selectedTags));if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(newSelectedTags,function(tagId){return tagId===id;})){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(newSelectedTags,function(tagId){return tagId===id;});}else{newSelectedTags.push(id);}setSelectedTags(newSelectedTags);};var printTags=function printTags(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tags,function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag_filter '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(selectedTags,function(selectedTag){return selectedTag===tag.id;})?'selected':''),key:tag.id,'data-id':tag.id,onClick:selectTag},tag.name);});};// Open Lists
var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState16=_slicedToArray(_useState15,2),openLists=_useState16[0],setOpenLists=_useState16[1];var expandUserList=function expandUserList(event){var title=event.currentTarget.getAttribute('data-title');var lists=[].concat(_toConsumableArray(openLists));if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(lists,function(t){return t===title;})){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(lists,function(t){return t===title;});}else{lists.push(title);}setOpenLists(lists);};// Select user
var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState18=_slicedToArray(_useState17,2),selectedUser=_useState18[0],setSelectedUser=_useState18[1];var handleClickUserBubble=function handleClickUserBubble(userId){var users=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(elements,function(topic){if(!selectedTopic||selectedTopic===topic.id){users=users.concat(topic.users);}});var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,{id:userId});setSelectedUser(user);};var removeSelectedUser=function removeSelectedUser(){setSelectedUser(null);};var printSelectedUser=function printSelectedUser(){if(!selectedUser){return null;}var users=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(elements,function(topic){if(!selectedTopic||selectedTopic===topic.id){users=users.concat(topic.users);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_UsersModal__["a" ],{usersIds:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(users,function(user){return user.id;}),userSelected:selectedUser.id,onEnd:removeSelectedUser});};// Selected topic
var changeElement=function changeElement(id){window.$('.theme_bubble').removeClass('selected');window.$('.theme_bubble[data-id='+id+']').addClass('selected');setSelectedTopic(id);};var printUsers=function printUsers(){var users=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(elements,function(topic){if(!selectedTopic||selectedTopic===topic.id){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topic.users,function(user){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users,{id:user.id})){users.push(user);}});}});if(!users.length){return null;}var title=literals.people;if(selectedTopic){var topic=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(elements,{id:selectedTopic});title=literals.peopleIn+' '+topic.name;}var titleSection='users';var maxHiddenUsers=window.outerWidth<=__WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__["b" ]?3:6;var classGrid=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(openLists,function(t){return t===titleSection;})?'in_table':'in_line';var iconExpand=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(openLists,function(t){return t===titleSection;})?__WEBPACK_IMPORTED_MODULE_9_assets_images_icons_grid_off_png___default.a:__WEBPACK_IMPORTED_MODULE_8_assets_images_icons_grid_png___default.a;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},title),maxHiddenUsers<users.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_expand','data-title':titleSection,onClick:expandUserList},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:iconExpand,alt:''})):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bubbles '+classGrid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Steps_Faces__["a" ],{options:users,onClick:handleClickUserBubble,onLongPress:handleClickUserBubble})));};var printGravityBubbles=function printGravityBubbles(){if(!elements.length){return null;}var maxPoints=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.maxBy(elements,'points').points;var minPoints=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.minBy(elements,'points').points;var difference=Math.max(maxPoints-minPoints,1);var interval=difference/3;var limitBig=maxPoints-interval;var limitMedium=limitBig-interval;var finalElements=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(elements,function(element){var color=Object(__WEBPACK_IMPORTED_MODULE_4_utils_colors__["i" ])().color;var size='xs';if(element.points>=limitBig){size='lg';}else if(element.points>=limitMedium){size='md';}var finalTopic={id:element.id,name:element.name,tags:typeof element.related_elements!=='undefined'?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(element.related_elements,function(tag){return tag.name;}):[],color:color,size:size,image:element.image};return finalTopic;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'theme_tables_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ThemeTablesBubbles__["a" ],{data:finalElements,onClick:changeElement}));};var gravityBubbles=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gravity_bubbles_wrapper'},printGravityBubbles());},[elements]);var handleCloseLists=function handleCloseLists(){setSelectedTopic(0);};var printSelectedTopic=function printSelectedTopic(){if(!selectedTopic){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_AffiliationCard__["a" ],{open:true,onClose:handleCloseLists,elementId:selectedTopic});};var printContent=function printContent(){if(statusRequest!==__WEBPACK_IMPORTED_MODULE_13_constants_status__["g" ]){return null;}if(!elements.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_14_assets_images_no_results_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noElements));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content gravity_bubbles fullscreen'},gravityBubbles);};if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_People_components_styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_LoadingComponent__["a" ],null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_People_components_styles__["b" ],{className:'elements_hall',color:color1},printErrors(),printSelectedUser(),printSelectedTopic(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search_bar form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_input'},printSearcher(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters_tags'},printTags()))),printContent());}ElementsHall.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,elementType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,elementId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};ElementsHall.defaultProps={elementType:null,elementId:null}; __webpack_exports__["a"] = (ElementsHall);

 }),

 (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABHNCSVQICAgIfAhkiAAAAMRJREFUOE/tVcENwjAQsyeCDaCTwAbAJMAGZQM2gG7QjYxcFSTSJilI6auW+urFse58DiU9AWyQxpXk0SWSLgAOmfo7JSlT5N8NyW1PPEUIPsQkGV4gyWSPCHFF0pd84S10IfZwu5mVbwWAbuoB1gBsrzFX2H7tyJluoEXtZkVWlkJNsu59vAfgL4V24N0JyzKppBxxv/urjIxb0IpdthXFswJAFbHbOWK3U8RuzpYZFmRJt1lCKGXNv54mJ1RuQX59TJsXbysWaIWaL28AAAAASUVORK5CYII="

 }),

 (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAbtJREFUSEu1VoFRwzAQkyZomYBuABtQJiDdoCOwAWUCYAO6ARtAN4ANygTQCZ5T7506TpyQuvUdR+rEL79eL5tmdg3gCcCC5C8A+NxEzwVjR/IzrKeZfQC4AaDJW4E5kOZLwbYecyugKQAFvToT2Jrkkk6VwJTRZQwW0jYz82dlrE3th5nNAbzrmeQ+VvRuBeABwIbkvH4ZUahvaxo9oGonGk8O1ACLaladMqMXAKKkq2aiqFZSKXWqgYLdO98pjZoPapwBWPp3qkk8tFn99dYobZ8S6WeBvgFI/2Fo1w01es2eAUitolhjk+wurMsCPZKsafA++8nQWCTvBpDLO/RRqkbtWrROjumjPqCdC6FVM5KicVTD9gEtAIjWlvRj2TsLg84gIcRi0DrVItCm/3L8lEZl9JpIX9SOkncq9/j3kPSzQJJpbZweUeaosU6yrTIOonmxoOPnf/JOVJc11Q4jHqxRnxj6gNKaqY57O8sdE8cCfWVoXJGsus6jY4EuMif1VNeDGOgNwF2fvEa+a7h+DBQ4Lb2QdEo/PefVdKEZRybQ+lzufnCQ0mi59dHtSu5wuJycA9DBZvLBP3Kmf2QuijJ5AAAAAElFTkSuQmCC"

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1214);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_reducers_userConnections__ = __webpack_require__(125);
 var __WEBPACK_IMPORTED_MODULE_4_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1215);
function mapStateToProps(state){return{userChats:state.chats.chats,literals:state.i18n.literals.chat||{},app:state.app,userConnections:state.userConnections.connections,user:state.session.user};}function mapDispatchToProps(dispatch){return{getInvitations:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_chats__["f" ],dispatch),fetchChats:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_chats__["e" ],dispatch),fetchUserConnections:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_reducers_userConnections__["e" ],dispatch),addNewChat:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_chats__["b" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_no_chats_svg__ = __webpack_require__(1216);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_no_chats_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_no_chats_svg__);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_addLogo_svg__ = __webpack_require__(473);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_addLogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_addLogo_svg__);
 var __WEBPACK_IMPORTED_MODULE_6_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_7_components_ChatRoom__ = __webpack_require__(111);
 var __WEBPACK_IMPORTED_MODULE_8__ChatElement__ = __webpack_require__(421);
 var __WEBPACK_IMPORTED_MODULE_9__FilterChat__ = __webpack_require__(266);
 var __WEBPACK_IMPORTED_MODULE_10__NewChat__ = __webpack_require__(1217);
 var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(176);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chats=function(_Component){_inherits(Chats,_Component);function Chats(props){_classCallCheck(this,Chats);var _this=_possibleConstructorReturn(this,(Chats.__proto__||Object.getPrototypeOf(Chats)).call(this,props));_this.setChats=function(setActiveChat){var userChats=_this.props.userChats;var chatsUser=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(userChats,function(chat){return _typeof(chat.element_related)==='object'&&typeof chat.element_related.type==='undefined';});chatsUser.sort(function(a,b){var aDate=a.last_message?a.last_message.timestamp:a.timestamp;var bDate=b.last_message?b.last_message.timestamp:b.timestamp;return aDate>bDate?-1:1;});_this.setState({chats:chatsUser,numChats:userChats.length});if(chatsUser.length&&setActiveChat){_this.setState({selectedChat:chatsUser[0].id});}};_this.handleClickChat=function(chatId){if(window.outerWidth>__WEBPACK_IMPORTED_MODULE_6_constants_breakPoints__["b" ]){_this.setState({selectedChat:chatId});}else{var history=_this.props.history;history.push('/chat/'+chatId);}};_this.handleClickMatch=function(userId){var _this$props=_this.props,addNewChat=_this$props.addNewChat,history=_this$props.history;var params={user:userId};Object(__WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__["b" ])('POST',{endPoint:'chat'},params).then(function(chat){addNewChat(chat);history.push('/chat/'+chat.id);});};_this.handleCreateChat=function(){_this.setState({createChat:true});};_this.handleCloseCreateChat=function(){_this.setState({createChat:false});};_this.filterChat=function(value){_this.setState({filter:value});};_this.printChats=function(){var _this$state=_this.state,chats=_this$state.chats,filter=_this$state.filter;var _this$props2=_this.props,app=_this$props2.app,user=_this$props2.user,literals=_this$props2.literals;var filteredChats=chats.filter(function(chat){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(chat.element_related);});if(!filteredChats.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_assets_images_no_chats_svg___default.a,alt:literals.noChatsAlt}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noChats)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["f" ],{color:app.color1,onClick:_this.handleCreateChat,style:{margin:'0 auto',maxWidth:'40rem'}},'+',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,literals.newChat)));}var chatRows=[];if(filter!==''){var lowerFilter=filter.toLowerCase();chatRows=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(filteredChats,function(chat){var completeName=(chat.users[1].firstname+' '+chat.users[1].lastname).toLowerCase();if(completeName.includes(lowerFilter)){return true;}return false;});}else{chatRows=filteredChats;}var rows=chatRows.map(function(chat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ChatElement__["a" ],{chat:chat,key:chat.id,onClick:_this.handleClickChat,app:app,user:user,thinkChat:false});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_chats'},literals.openChats),rows,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["f" ],{color:app.color1,onClick:_this.handleCreateChat},'+',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,literals.newChat)));};_this.printCreateChatButton=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["e" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:_this.handleCreateChat},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_assets_images_addLogo_svg___default.a,alt:''})));};_this.printFilterChat=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FilterChat__["a" ],{doFilter:_this.filterChat});};_this.printSelectedChat=function(){var selectedChat=_this.state.selectedChat;if(!selectedChat||window.outerWidth<=__WEBPACK_IMPORTED_MODULE_6_constants_breakPoints__["b" ]){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected_chat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ChatRoom__["a" ],{chatId:selectedChat}));};_this.onCreateChat=function(chat){var addNewChat=_this.props.addNewChat;addNewChat(chat);_this.setState({createChat:false},function(){_this.handleClickChat(chat.id);});};_this.state={chats:[],update:false,createChat:false,filter:'',selectedChat:0,numChats:0};return _this;}_createClass(Chats,[{key:'componentDidMount',value:function componentDidMount(){var chats=this.state.chats;var fetchChats=this.props.fetchChats;if(!chats||chats.length===0){fetchChats();}this.setChats(true);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var userChats=this.props.userChats;var _state=this.state,chats=_state.chats,update=_state.update,numChats=_state.numChats;var found=void 0;var newMessages=[];if(prevProps.userChats&&prevProps.userChats.length){prevProps.userChats.forEach(function(chat){if(chat.last_message){found=userChats.find(function(chat2){return chat2.id===chat.id;});if(found.last_message.read){newMessages.push(found);}}});}if(!update&&newMessages.length>0){this.setState({chats:chats,update:true});}if(chats.length===0&&userChats.length>0){this.setState({chats:chats,numChats:chats.length});}if(userChats.length!==numChats){this.setChats();}}},{key:'render',value:function render(){var _props=this.props,app=_props.app,literals=_props.literals,history=_props.history,userConnections=_props.userConnections,userChats=_props.userChats;var _state2=this.state,createChat=_state2.createChat,selectedChat=_state2.selectedChat;if(!createChat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["c" ],{color:app.color1,selectedChat:selectedChat},this.printFilterChat(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat_grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chats_list'},this.printChats()),this.printSelectedChat())),this.printCreateChatButton());}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NewChat__["a" ],{chats:userChats,closeNewChat:this.handleCloseCreateChat,literals:literals,addNewChat:this.onCreateChat,history:history,userConnections:userConnections});}}]);return Chats;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Chats.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,fetchChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,userChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,userConnections:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,addNewChat:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};Chats.defaultProps={userChats:[]}; __webpack_exports__["a"] = (Chats);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no_chats.5ed83213.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_ArrowBack_svg__ = __webpack_require__(135);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_ArrowBack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_ArrowBack_svg__);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_InfoCircle_svg__ = __webpack_require__(1218);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_InfoCircle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_InfoCircle_svg__);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_lens_svg__ = __webpack_require__(1219);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_lens_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_lens_svg__);
 var __WEBPACK_IMPORTED_MODULE_6_components_AvatarNew__ = __webpack_require__(262);
 var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
 var __WEBPACK_IMPORTED_MODULE_8__FilterChat__ = __webpack_require__(266);
 var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(176);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewChat=function(_Component){_inherits(NewChat,_Component);function NewChat(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewChat);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewChat.__proto__||Object.getPrototypeOf(NewChat)).call.apply(_ref,[this].concat(args))),_this),_this.state={filter:''},_this.handleCreateChat=function(event){var addNewChat=_this.props.addNewChat;var userId=parseInt(event.currentTarget.getAttribute('data-user_id'),10);var params={user:userId};Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'chat'},params).then(function(chat){addNewChat(chat);});},_this.filterChat=function(value){if(value===''){_this.setState({filter:''});}else{_this.setState({filter:value});}},_this.printGridUsers=function(){var filter=_this.state.filter;var _this$props=_this.props,userConnections=_this$props.userConnections,chats=_this$props.chats;var usersFiltered=[];var users=[];if(userConnections){var lowerFilter=filter.toLowerCase();usersFiltered=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(userConnections,function(user){// If already exists a chat with this user
if(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(chats,function(chat){return!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.has(chat.element_related,'type')&&chat.users.length===2&&__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(chat.users,{id:user.id});})){return false;}var completeName=(user.firstname+' '+user.lastname).toLowerCase();if(!lowerFilter||completeName.includes(lowerFilter)){return true;}return false;});users=usersFiltered.map(function(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{cursor:'pointer'},onClick:_this.handleCreateChat,key:user.id,'data-user_id':user.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_AvatarNew__["a" ],{avatar:user.avatar,firstname:user.firstname+' '+user.lastname,id:user.id}));});}return users;},_this.printChatGrid=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["o" ],null,_this.printGridUsers());},_this.printFilterChat=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter_chat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FilterChat__["a" ],{doFilter:_this.filterChat}));},_this.handleBackArrow=function(){var closeNewChat=_this.props.closeNewChat;closeNewChat();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewChat,[{key:'render',value:function render(){var literals=this.props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["n" ],{className:'all_screen_mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["p" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrowback',onClick:this.handleBackArrow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_assets_images_ArrowBack_svg___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.newChat)),this.printFilterChat(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new_chat_title'},literals.newChatTitle),this.printChatGrid());}}]);return NewChat;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NewChat.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,closeNewChat:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,// app: PropTypes.object.isRequired,
// user: PropTypes.object.isRequired,
// fetchChats: PropTypes.func.isRequired,
chats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,userConnections:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,addNewChat:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (NewChat);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/InfoCircle.0f3145a0.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lens.b3c681a5.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_ThinkTanks_modules_actions__ = __webpack_require__(76);
 var __WEBPACK_IMPORTED_MODULE_4__components_Content__ = __webpack_require__(1221);
function mapStateToProps(state){return{literals:state.i18n.literals.themeTableDetail,allProposedContent:state.thinkTanks.allProposedContent,calls:state.narratives.list};}function mapDispatchToProps(dispatch){return{getAllProposedContent:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_ThinkTanks_modules_actions__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components_Content__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_4_components_Cards_ContentSimpleCard__ = __webpack_require__(475);
 var __WEBPACK_IMPORTED_MODULE_5_components_Cards_NarrativeSmallCard__ = __webpack_require__(182);
 var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1238);
function Content(props){var literals=props.literals,content=props.content,narratives=props.narratives;if(!content.length&&!narratives.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},content.length+narratives.length),literals.proposedContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_SimpleCarousel__["a" ],{classesList:'element_main_card',showButtons:true},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(narratives,function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Cards_NarrativeSmallCard__["a" ],{key:element.id,data:element,color:element.color,classesList:'element_main_card'});}),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(content,function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Cards_ContentSimpleCard__["a" ],{key:element.id,data:element,recognized:true,classesList:['element_main_card']});})));}Content.propTypes={content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,narratives:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};Content.defaultProps={content:[],narratives:[]}; __webpack_exports__["a"] = (Content);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1223);
function mapStateToProps(state){return{actualUser:state.session.user,literals:state.i18n.literals.themeTableDetail,app:state.app};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_assets_images_think_paperbin_svg__ = __webpack_require__(261);
 var __WEBPACK_IMPORTED_MODULE_2_assets_images_think_paperbin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_images_think_paperbin_svg__);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_think_link_svg__ = __webpack_require__(1224);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_think_link_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_think_link_svg__);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_think_pdf_svg__ = __webpack_require__(1225);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_think_pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_think_pdf_svg__);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_photo_svg__ = __webpack_require__(1226);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_photo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_think_photo_svg__);
 var __WEBPACK_IMPORTED_MODULE_6_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_7_components_ConfirmModal__ = __webpack_require__(181);
 var __WEBPACK_IMPORTED_MODULE_8_routes_Profile_modules_actions__ = __webpack_require__(92);
 var __WEBPACK_IMPORTED_MODULE_9_components_ThinkTanks_modules_actions__ = __webpack_require__(76);
 var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(1230);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function ContentSimpleCard(props){var data=props.data,classesList=props.classesList,actualUser=props.actualUser,literals=props.literals,app=props.app,recognized=props.recognized,isDragging=props.isDragging;var style={};if(data.image){style.backgroundImage='url('+data.image+')';}var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),user=_useState2[0],setUser=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),killModal=_useState4[0],setKillModal=_useState4[1];var deleteC=function deleteC(){var onDelete=props.onDelete;Object(__WEBPACK_IMPORTED_MODULE_9_components_ThinkTanks_modules_actions__["c" ])(data.id,actualUser.id).then(function(){onDelete();});};var openModal=function openModal(){setKillModal(!killModal);};var printKillModal=function printKillModal(){if(!killModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ConfirmModal__["a" ],{onAccept:deleteC,onClose:openModal,open:true,confirmText:literals.confirmDelete}));};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(data.user_id){Object(__WEBPACK_IMPORTED_MODULE_8_routes_Profile_modules_actions__["e" ])(data.user_id).then(function(userData){setUser(userData.info);});}},[]);var classesStr=classesList.join(' ');var content='';var getTypeName=function getTypeName(){var typeName=literals.file;if(data.type[0]==='referral'){typeName=literals.link;}else{switch(data.info_type){case'application/pdf':typeName=literals.pdf;break;case'image/jpeg'||'image/png'||'image/jpg':typeName=literals.image;break;default:break;}}return typeName;};var download=function download(){if(!isDragging){if(data.info.includes('http')){window.open(data.info);}else{window.open('https://'+data.info);}}};if(data.type[0]==='referral'){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" ],{onClick:download},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_assets_images_think_link_svg___default.a,alt:''}));}else{switch(data.info_type){case'application/pdf':content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" ],{onClick:download},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_assets_images_think_pdf_svg___default.a,alt:''}));break;case'image/jpeg'||'image/png'||'image/jpg':content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" ],{onClick:download},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_assets_images_think_photo_svg___default.a,alt:''}));break;default:break;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["a" ],{className:classesStr},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bodyTop',onClick:download},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'type',style:{color:app.color1}},getTypeName()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},data.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},(parseInt(actualUser.id,10)===parseInt(data.user_id,10)||recognized)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2_assets_images_think_paperbin_svg___default.a,alt:'',className:'paperbin',onClick:openModal}),content),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body',onClick:download},user?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Avatar__["a" ],{size:25,firstname:user.firstname,id:user.id,avatar:user.avatar}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text_name'},user.firstname+' '+user.lastname)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'}),printKillModal());}ContentSimpleCard.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,classesList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,isDragging:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ContentSimpleCard.defaultProps={classesList:[],isDragging:false}; __webpack_exports__["a"] = (ContentSimpleCard);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/link.5da459e4.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pdf.9fd4010a.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/photo.5fe5e041.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1228);
function mapStateToProps(state){return{literals:state.i18n.literals.confirmModal};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1229);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmModal=function(_Component){_inherits(ConfirmModal,_Component);function ConfirmModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConfirmModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConfirmModal.__proto__||Object.getPrototypeOf(ConfirmModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleCancel=function(){var onClose=_this.props.onClose;onClose();},_this.handleAccept=function(){var onAccept=_this.props.onAccept;onAccept();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConfirmModal,[{key:'render',value:function render(){var _props=this.props,open=_props.open,confirmText=_props.confirmText,literals=_props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" ],{open:open,onClose:this.handleCancel,style:{zIndex:1110000}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal confirm_modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal_text'},confirmText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:this.handleAccept},literals.accept),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'danger',onClick:this.handleCancel},literals.cancel))));}}]);return ConfirmModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConfirmModal.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onAccept:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,confirmText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (ConfirmModal);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmModalWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n.confirm_modal {\n  align-items: center;\n  margin-top: 30vh;\n  width: 40vw;\n  overflow: hidden;\n  border-radius: 12px;\n\n  @media (max-width: ','px) {\n    width: 96vw;\n  }\n  \n  .modal_text {\n    width: 80%;\n    margin: 0% 10%;\n    margin-bottom: 5%;\n    text-align: center;\n    font-size: 20px;\n  }\n\n  .buttons {\n    width: 80%;\n    margin: 0% 10%;\n    margin-bottom: 5%;\n\n    \n  }\n}\n'],['\n.confirm_modal {\n  align-items: center;\n  margin-top: 30vh;\n  width: 40vw;\n  overflow: hidden;\n  border-radius: 12px;\n\n  @media (max-width: ','px) {\n    width: 96vw;\n  }\n  \n  .modal_text {\n    width: 80%;\n    margin: 0% 10%;\n    margin-bottom: 5%;\n    text-align: center;\n    font-size: 20px;\n  }\n\n  .buttons {\n    width: 80%;\n    margin: 0% 10%;\n    margin-bottom: 5%;\n\n    \n  }\n}\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ConfirmModalWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Modal__["a" ])(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ContentSimpleCardWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return TypePhoto; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  width: 15rem;\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  overflow: hidden;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n  cursor: pointer;\n\n  > .header {\n    height: 9.4rem;\n    background-size: cover;\n    background-color: #eee;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    position: relative;\n    .paperbin {\n      position: absolute;\n      top: 0.5rem;\n      left: 0.5rem;\n      background: white;\n      padding: 0.5rem;\n      border-radius: 1rem;\n    }\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n  }\n\n  .text_name {\n    margin-left: 0.5rem;\n  }\n\n  .bodyTop {\n    background-color: #fff;\n    padding: 1rem;\n\n    > .type {\n      font-size: 1.1rem;\n      margin-bottom: 0.5rem;\n    }\n\n    > .title {\n      color: ',';\n      font-family: ',';\n      font-size: 1.6rem;\n      overflow: hidden;\n      height: 1.7rem;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .body {\n    background-color: #fff;\n    padding: 1rem;\n    height: 7rem;\n\n    > div {\n      color: ',';\n      font-family: ',';\n      font-size: 1.1rem;\n      line-height: 1.6rem;\n      white-space: normal;\n      height: 5.5rem;\n      display: flex;\n      overflow: hidden;\n    }\n    img {\n      height: 2rem;\n      margin-right: 0.5rem;\n    }\n  }\n\n  > .footer {\n    background-color: #fff;\n    height: 2.4rem;\n  }\n'],['\n  width: 15rem;\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  overflow: hidden;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n  cursor: pointer;\n\n  > .header {\n    height: 9.4rem;\n    background-size: cover;\n    background-color: #eee;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    position: relative;\n    .paperbin {\n      position: absolute;\n      top: 0.5rem;\n      left: 0.5rem;\n      background: white;\n      padding: 0.5rem;\n      border-radius: 1rem;\n    }\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n  }\n\n  .text_name {\n    margin-left: 0.5rem;\n  }\n\n  .bodyTop {\n    background-color: #fff;\n    padding: 1rem;\n\n    > .type {\n      font-size: 1.1rem;\n      margin-bottom: 0.5rem;\n    }\n\n    > .title {\n      color: ',';\n      font-family: ',';\n      font-size: 1.6rem;\n      overflow: hidden;\n      height: 1.7rem;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .body {\n    background-color: #fff;\n    padding: 1rem;\n    height: 7rem;\n\n    > div {\n      color: ',';\n      font-family: ',';\n      font-size: 1.1rem;\n      line-height: 1.6rem;\n      white-space: normal;\n      height: 5.5rem;\n      display: flex;\n      overflow: hidden;\n    }\n    img {\n      height: 2rem;\n      margin-right: 0.5rem;\n    }\n  }\n\n  > .footer {\n    background-color: #fff;\n    height: 2.4rem;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  background: #2680EB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n'],['\n  background: #2680EB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ContentSimpleCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily);var TypePhoto=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1232);
function mapStateToProps(state){return{literals:state.i18n.literals.narrativeSeedSmallCard,itemsPreferencesFromSerendipity:state.serendipity.preferences};}function mapDispatchToProps(dispatch){return{enableItemFromSerendipity:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__["b" ],dispatch),disableItemFromSerendipity:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Switch__ = __webpack_require__(97);
 var __WEBPACK_IMPORTED_MODULE_5_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1237);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NarrativeSmallCard=function(_Component){_inherits(NarrativeSmallCard,_Component);function NarrativeSmallCard(props){_classCallCheck(this,NarrativeSmallCard);var _this=_possibleConstructorReturn(this,(NarrativeSmallCard.__proto__||Object.getPrototypeOf(NarrativeSmallCard)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,itemsPreferencesFromSerendipity=_this$props.itemsPreferencesFromSerendipity,id=_this$props.data.id;var enabled=!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(itemsPreferencesFromSerendipity,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["h" ]&&item.element_id===id&&!item.enabled;});_this.state={enabled:enabled,timeClick:null};return _this;}_createClass(NarrativeSmallCard,[{key:'componentDidUpdate',value:function componentDidUpdate(){var enabled=this.state.enabled;var _props=this.props,itemsPreferencesFromSerendipity=_props.itemsPreferencesFromSerendipity,id=_props.data.id;var enabledNow=!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(itemsPreferencesFromSerendipity,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["h" ]&&item.element_id===id&&!item.enabled;});if(enabledNow!==enabled){this.changeEnabledStatus(enabledNow);}}},{key:'render',value:function render(){var _props2=this.props,data=_props2.data,classesList=_props2.classesList,color=_props2.color,showFooter=_props2.showFooter;var enabled=this.state.enabled;var banner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'banner_narrative',style:{backgroundColor:color}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:data.image,alt:''}));if(data.type===21227760){banner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'banner_narrative',style:{backgroundColor:color,backgroundImage:'url('+data.image+')'}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],{className:classesList+' c2icard '+(enabled&&data.progress<100?'enabled':'disabled'),onClick:this.handleClick,onMouseDown:this.handleMouseDown,image:data.background_image},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section_name',style:{color:data.section.color}},data.section.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},data.name)),banner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},data.description),showFooter?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Switch__["a" ],{checked:enabled,size:'small',onChange:this.handleChangeEnabled,name:'check_enabled',color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.printProgress())):null);}}]);return NarrativeSmallCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.changeEnabledStatus=function(enabled){_this2.setState({enabled:enabled});};this.handleClick=function(event){var _props3=_this2.props,history=_props3.history,id=_props3.data.id;var timeClick=_this2.state.timeClick;var diff=__WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf()-timeClick;if(diff<200&&!window.$(event.target).hasClass('MuiSwitch-input')){history.push('/narratives/'+id);}};this.handleMouseDown=function(){_this2.setState({timeClick:__WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf()});};this.handleChangeEnabled=function(event){var _props4=_this2.props,enableItemFromSerendipity=_props4.enableItemFromSerendipity,disableItemFromSerendipity=_props4.disableItemFromSerendipity,id=_props4.data.id;_this2.setState({enabled:event.target.checked});if(event.target.checked){enableItemFromSerendipity(__WEBPACK_IMPORTED_MODULE_5_constants_types__["h" ],id);}else{disableItemFromSerendipity(__WEBPACK_IMPORTED_MODULE_5_constants_types__["h" ],id);}};this.printProgress=function(){var _props5=_this2.props,data=_props5.data,literals=_props5.literals;if(data.progress===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new'},literals.new);}if(data.progress===100){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completed'},literals.completed);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,data.progress+'%');};};NarrativeSmallCard.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,classesList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,enableItemFromSerendipity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,disableItemFromSerendipity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,itemsPreferencesFromSerendipity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,showFooter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};NarrativeSmallCard.defaultProps={classesList:'',color:'#FF8000',itemsPreferencesFromSerendipity:[],showFooter:true}; __webpack_exports__["a"] = (NarrativeSmallCard);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(129);
 var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(38);
 var __WEBPACK_IMPORTED_MODULE_9__internal_SwitchBase__ = __webpack_require__(1234);


// @inheritedComponent IconButton








var styles = function styles(theme) {
  return {
    
    root: {
      display: 'inline-flex',
      width: 34 + 12 * 2,
      height: 14 + 12 * 2,
      overflow: 'hidden',
      padding: 12,
      boxSizing: 'border-box',
      position: 'relative',
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      verticalAlign: 'middle',
      // For correct alignment with the text.
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    
    edgeStart: {
      marginLeft: -8
    },

    
    edgeEnd: {
      marginRight: -8
    },

    
    switchBase: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      // Render above the focus ripple.
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create(['left', 'transform'], {
        duration: theme.transitions.duration.shortest
      }),
      '&$checked': {
        transform: 'translateX(20px)'
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        opacity: 0.5
      },
      '&$disabled + $track': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      }
    },

    
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["d" ])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.primary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["d" ])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.secondary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    
    sizeSmall: {
      width: 40,
      height: 24,
      padding: 7,
      '& $thumb': {
        width: 16,
        height: 16
      },
      '& $switchBase': {
        padding: 4,
        '&$checked': {
          transform: 'translateX(16px)'
        }
      }
    },

    
    checked: {},

    
    disabled: {},

    
    input: {
      left: '-100%',
      width: '300%'
    },

    
    thumb: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },

    
    track: {
      height: '100%',
      width: '100%',
      borderRadius: 14 / 2,
      zIndex: -1,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};
var Switch = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Switch(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "className", "color", "edge", "size"]);

  var icon = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.thumb
  });
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge], size === "small" && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" ])(size))])
  }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__internal_SwitchBase__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    type: "checkbox",
    icon: icon,
    checkedIcon: icon,
    classes: {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.switchBase, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" ])(color))]),
      input: classes.input,
      checked: classes.checked,
      disabled: classes.disabled
    },
    ref: ref
  }, other)), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.track
  }));
});
 false ? Switch.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  checked: PropTypes.bool,

  
  checkedIcon: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  
  defaultChecked: PropTypes.bool,

  
  disabled: PropTypes.bool,

  
  disableRipple: PropTypes.bool,

  
  edge: PropTypes.oneOf(['end', 'start', false]),

  
  icon: PropTypes.node,

  
  id: PropTypes.string,

  
  inputProps: PropTypes.object,

  
  inputRef: refType,

  
  onChange: PropTypes.func,

  
  required: PropTypes.bool,

  
  size: PropTypes.oneOf(['medium', 'small']),

  
  value: PropTypes.any
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'MuiSwitch'
})(Switch));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(130);
 var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_7__utils_useControlled__ = __webpack_require__(251);
 var __WEBPACK_IMPORTED_MODULE_8__FormControl_useFormControl__ = __webpack_require__(90);
 var __WEBPACK_IMPORTED_MODULE_9__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_10__IconButton__ = __webpack_require__(1235);











var styles = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};


var SwitchBase = __WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useControlled__["a" ])({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" ])(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_8__FormControl_useFormControl__["a" ])();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v5: remove the second argument.
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__IconButton__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    component: "span",
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" ])(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

 false ? SwitchBase.propTypes = {
  
  autoFocus: PropTypes.bool,

  
  checked: PropTypes.bool,

  
  checkedIcon: PropTypes.node.isRequired,

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string,

  
  defaultChecked: PropTypes.bool,

  
  disabled: PropTypes.bool,

  
  icon: PropTypes.node.isRequired,

  
  id: PropTypes.string,

  
  inputProps: PropTypes.object,

  
  inputRef: refType,

  
  name: PropTypes.string,

  
  onBlur: PropTypes.func,

  
  onChange: PropTypes.func,

  
  onFocus: PropTypes.func,

  
  readOnly: PropTypes.bool,

  
  required: PropTypes.bool,

  
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  type: PropTypes.string.isRequired,

  
  value: PropTypes.any
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__styles_withStyles__["a" ])(styles, {
  name: 'PrivateSwitchBase'
})(SwitchBase));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__IconButton__ = __webpack_require__(1236);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IconButton__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(13);
 var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(129);
 var __WEBPACK_IMPORTED_MODULE_8__ButtonBase__ = __webpack_require__(232);
 var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(38);










var styles = function styles(theme) {
  return {
    
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["d" ])(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    
    colorInherit: {
      color: 'inherit'
    },

    
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["d" ])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["d" ])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    
    disabled: {},

    
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};


var IconButton = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ButtonBase__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" ])(color))], disabled && classes.disabled, size === "small" && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" ])(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.label
  }, children));
});
 false ? IconButton.propTypes = {
  
  children: chainPropTypes(PropTypes.node, function (props) {
    var found = React.Children.toArray(props.children).some(function (child) {
      return React.isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
    }

    return null;
  }),

  
  classes: PropTypes.object.isRequired,

  
  className: PropTypes.string,

  
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  
  disabled: PropTypes.bool,

  
  disableFocusRipple: PropTypes.bool,

  
  disableRipple: PropTypes.bool,

  
  edge: PropTypes.oneOf(['start', 'end', false]),

  
  size: PropTypes.oneOf(['small', 'medium'])
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" ])(styles, {
  name: 'MuiIconButton'
})(IconButton));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return NarrativeWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: top;\n  background-color: #fff;\n  width: 15rem;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  cursor: pointer;\n  white-space: normal;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n\n  .header {\n    padding: 1rem;\n    .section_name {\n      font-size: 1.1rem;\n      margin-bottom: 0.5rem;\n    }\n    .title {\n      font-family: ',';\n      font-size: 1.6rem;\n      color: ',';\n      overflow: hidden;\n      height: 1.7rem;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .banner_narrative {\n    height: 9.4rem;\n    text-align: center;\n    display: grid;\n    grid-template-rows: 1fr;\n    align-items: center;\n    justify-items: center;\n    background-size: cover;\n    background-position: 50% 50%;\n    img {\n      max-width: 10rem;\n      max-height: 5.5rem;\n      pointer-events: none;\n    }\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n\n    .banner_narrative {\n      filter: grayscale(100%);\n    }\n  }\n\n  .description {\n    padding: 1rem;\n    font-family: ',';\n    font-size: 1.3rem;\n    color: ',';\n    overflow: hidden;\n    height: 6rem;\n    line-height: 1.7rem;\n    margin-bottom: 1rem;\n  }\n\n  .footer {\n    white-space: nowrap;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n\n    > div:last-child {\n      justify-self: end;\n      padding-right: 1rem;\n\n      div {\n        font-family: ',';\n        font-size: 1.3rem;\n        color: ',';\n      }\n\n      .new, .completed, .updated {\n        color: ',';\n      }\n    }\n\n  }\n'],['\n  display: inline-block;\n  vertical-align: top;\n  background-color: #fff;\n  width: 15rem;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  cursor: pointer;\n  white-space: normal;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n\n  .header {\n    padding: 1rem;\n    .section_name {\n      font-size: 1.1rem;\n      margin-bottom: 0.5rem;\n    }\n    .title {\n      font-family: ',';\n      font-size: 1.6rem;\n      color: ',';\n      overflow: hidden;\n      height: 1.7rem;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .banner_narrative {\n    height: 9.4rem;\n    text-align: center;\n    display: grid;\n    grid-template-rows: 1fr;\n    align-items: center;\n    justify-items: center;\n    background-size: cover;\n    background-position: 50% 50%;\n    img {\n      max-width: 10rem;\n      max-height: 5.5rem;\n      pointer-events: none;\n    }\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n\n    .banner_narrative {\n      filter: grayscale(100%);\n    }\n  }\n\n  .description {\n    padding: 1rem;\n    font-family: ',';\n    font-size: 1.3rem;\n    color: ',';\n    overflow: hidden;\n    height: 6rem;\n    line-height: 1.7rem;\n    margin-bottom: 1rem;\n  }\n\n  .footer {\n    white-space: nowrap;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n\n    > div:last-child {\n      justify-self: end;\n      padding-right: 1rem;\n\n      div {\n        font-family: ',';\n        font-size: 1.3rem;\n        color: ',';\n      }\n\n      .new, .completed, .updated {\n        color: ',';\n      }\n    }\n\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var NarrativeWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["f" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ContentWrapper; });

 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n'],['\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .text {\n    font-size: 1.4rem;\n    color: gray;\n    margin: 1rem;\n  }\n  input {\n    width: 30rem;\n    height: 5rem;\n    border: none;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    border-radius: 1rem;\n    margin: 1rem;\n    padding: 2rem;\n    font-size: 1.3rem;\n  }\n  .input {\n    width: 30rem;\n    height: 5rem;\n    border: none;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    border-radius: 1rem;\n    margin: 1rem;\n    padding: 2rem;\n    font-size: 1.3rem;\n    position: relative;\n    display: flex;\n    align-items: center;\n    i {\n      font-size: 1.8rem;\n      position: absolute;\n      right: 2rem;\n    }\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .text {\n    font-size: 1.4rem;\n    color: gray;\n    margin: 1rem;\n  }\n  input {\n    width: 30rem;\n    height: 5rem;\n    border: none;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    border-radius: 1rem;\n    margin: 1rem;\n    padding: 2rem;\n    font-size: 1.3rem;\n  }\n  .input {\n    width: 30rem;\n    height: 5rem;\n    border: none;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    border-radius: 1rem;\n    margin: 1rem;\n    padding: 2rem;\n    font-size: 1.3rem;\n    position: relative;\n    display: flex;\n    align-items: center;\n    i {\n      font-size: 1.8rem;\n      position: absolute;\n      right: 2rem;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ContentWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var ContentTypes=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1240);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_routes_MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_6_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_7_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_8_components_Dashboard_modules_dashboard__ = __webpack_require__(343);
 var __WEBPACK_IMPORTED_MODULE_9__modules__ = __webpack_require__(82);
 var __WEBPACK_IMPORTED_MODULE_10__components__ = __webpack_require__(1241);
function mapStateToProps(state){return{app:state.app,literals:state.i18n.literals.initiatives||{},narratives:state.narratives.list,objectives:state.narratives.objectives,tools:state.narratives.tools,elements:state.narratives.elements,itemsPreferencesFromSerendipity:state.serendipity.preferences,themeTables:state.thinkChats.myThinkChatsList,scheduleSpeedDatings:state.speedDating.meetings};}function mapDispatchToProps(dispatch){return{getNarrative:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["a" ],dispatch),getObjective:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["c" ],dispatch),setAutoNavigation:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_routes_MainPage_modules_mainPage__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch),setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7_components_Navbar_modules__["b" ],dispatch),resetContext:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_store_globalState_global__["e" ],dispatch),selectDashboardElement:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_8_components_Dashboard_modules_dashboard__["b" ],dispatch),setGoDown:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_routes_MainPage_modules_mainPage__["d" ],dispatch),fetchElements:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_9__modules__["d" ],dispatch),getOnGoingActivity:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_serendipity_actions__["c" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_10__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_google_play_svg__ = __webpack_require__(1242);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_google_play_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_google_play_svg__);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_app_store_svg__ = __webpack_require__(1243);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_app_store_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_app_store_svg__);
 var __WEBPACK_IMPORTED_MODULE_6_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_7_components_Cards_Call4ImpactCard__ = __webpack_require__(268);
 var __WEBPACK_IMPORTED_MODULE_8_components_Agenda__ = __webpack_require__(136);
 var __WEBPACK_IMPORTED_MODULE_9_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_10_components_Cards_UserSmallCard_components__ = __webpack_require__(134);
 var __WEBPACK_IMPORTED_MODULE_11_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_12_modules_users_actions__ = __webpack_require__(85);
 var __WEBPACK_IMPORTED_MODULE_13_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_14_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_15_assets_images_think_no_think_chats_svg__ = __webpack_require__(91);
 var __WEBPACK_IMPORTED_MODULE_15_assets_images_think_no_think_chats_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_assets_images_think_no_think_chats_svg__);
 var __WEBPACK_IMPORTED_MODULE_16_components_Cards_ThemeTableCard__ = __webpack_require__(117);
 var __WEBPACK_IMPORTED_MODULE_17_react_materialize__ = __webpack_require__(173);
 var __WEBPACK_IMPORTED_MODULE_17_react_materialize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_materialize__);
 var __WEBPACK_IMPORTED_MODULE_18__styles__ = __webpack_require__(1258);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function Narratives(props){var resetAll=props.resetAll,scheduleSpeedDatings=props.scheduleSpeedDatings,literals=props.literals,setBreadcrumb=props.setBreadcrumb,resetContext=props.resetContext,narratives=props.narratives,itemsPreferencesFromSerendipity=props.itemsPreferencesFromSerendipity,themeTables=props.themeTables,app=props.app,history=props.history;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),isLoading=_useState2[0],setIsLoading=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState4=_slicedToArray(_useState3,2),isLoadingUsers=_useState4[0],setIsLoadingUsers=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState6=_slicedToArray(_useState5,2),isLoadingTables=_useState6[0],setIsLoadingTables=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),recommendedUsers=_useState8[0],setRecommendedUsers=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState10=_slicedToArray(_useState9,2),recommendedTables=_useState10[0],setRecommendedTables=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState12=_slicedToArray(_useState11,2),selectedUser=_useState12[0],setSelectedUser=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState14=_slicedToArray(_useState13,2),searchUsers=_useState14[0],setSearchUsers=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState16=_slicedToArray(_useState15,2),searchTables=_useState16[0],setSearchTables=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),thereAreUsers=_useState18[0],setThereAreUsers=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),thereAreTables=_useState20[0],setThereAreTables=_useState20[1];var loadRecommendedUsers=function loadRecommendedUsers(){Object(__WEBPACK_IMPORTED_MODULE_12_modules_users_actions__["b" ])(1,searchUsers).then(function(response){setRecommendedUsers(response);if(response.length){setThereAreUsers(true);}}).catch(function(error){console.error(error);setRecommendedUsers([]);});};var loadRecommendedTables=function loadRecommendedTables(){Object(__WEBPACK_IMPORTED_MODULE_13_modules_think_seeds_actions__["d" ])(1,searchTables).then(function(response){setRecommendedTables(response);if(response.length){setThereAreTables(true);}}).catch(function(error){console.error(error);setRecommendedTables([]);});};var init=function init(){var breadcrumb=[{color:'#ffffff',text:literals.title}];resetAll();setBreadcrumb(breadcrumb.slice());resetContext();};var getTimelineCards=function getTimelineCards(){var meetings=[];var speedDatings=[];narratives.forEach(function(narrative){narrative.speed_datings.forEach(function(speedDating){if(!speedDatings.find(function(_ref){var id=_ref.id;return id===speedDating.id;})&&!__WEBPACK_IMPORTED_MODULE_3_moment___default()().isAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()(speedDating.start_date,'X').format('YYYY-MM-DD'),'day')){speedDatings.push(speedDating);}});narrative.meetings.forEach(function(meeting){if(!meetings.find(function(_ref2){var id=_ref2.id;return id===meeting.id;})&&!__WEBPACK_IMPORTED_MODULE_3_moment___default()().isAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()(meeting.start_date,'X').format('YYYY-MM-DD'),'day')){meetings.push(meeting);}});});themeTables.forEach(function(themeTable){themeTable.speed_datings.forEach(function(speedDating){if(!speedDatings.find(function(_ref3){var id=_ref3.id;return id===speedDating.id;})&&!__WEBPACK_IMPORTED_MODULE_3_moment___default()().isAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()(speedDating.start_date,'X').format('YYYY-MM-DD'),'day')){speedDatings.push(speedDating);}});themeTable.meetings.forEach(function(meeting){if(!meetings.find(function(_ref4){var id=_ref4.id;return id===meeting.id;})&&!__WEBPACK_IMPORTED_MODULE_3_moment___default()().isAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()(meeting.start_date,'X').format('YYYY-MM-DD'),'day')){meetings.push(meeting);}});});return{meetings:meetings,speedDatings:speedDatings};};// Effects
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){init();},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(recommendedUsers!==null&&recommendedTables!==null){setIsLoading(false);}},[recommendedUsers,recommendedTables]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(recommendedUsers!==null){setIsLoadingUsers(false);}},[recommendedUsers]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(recommendedTables!==null){setIsLoadingTables(false);}},[recommendedTables]);// Handler events
var handleClickUser=function handleClickUser(userId){setSelectedUser(userId);};var removeSelectedUser=function removeSelectedUser(){setSelectedUser(null);loadRecommendedUsers();};var handleSearchUsers=function handleSearchUsers(event){var value=event.target.value;setSearchUsers(value);};var handleSearchTables=function handleSearchTables(event){var value=event.target.value;setSearchTables(value);};var handleClickTable=function handleClickTable(tableId){history.push('/theme-table/'+tableId);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var toSearchUsers=setTimeout(function(){loadRecommendedUsers();setIsLoadingUsers(true);},1000);return function(){clearTimeout(toSearchUsers);};},[searchUsers]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var toSearchTables=setTimeout(function(){loadRecommendedTables();setIsLoadingTables(true);},1000);return function(){clearTimeout(toSearchTables);};},[searchTables]);var openApple=function openApple(){window.open('https://apps.apple.com/us/app/ci-call-for-impact/id1377297200');};var openGoogle=function openGoogle(){window.open('https://play.google.com/store/apps/details?id=com.grupogo.c2i&hl=es_419&gl=US');};// Render functions
var printCall4Impact=function printCall4Impact(){var _getTimelineCards=getTimelineCards(),speedDatings=_getTimelineCards.speedDatings,meetings=_getTimelineCards.meetings;var time=__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix();var finalNarratives=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(narratives,function(narrative){if(narrative.type.id!==21227760||narrative.time_limit!==0&&narrative.time_limit<time){return false;}return true;});if(!finalNarratives.length){return null;}finalNarratives.sort(function(a,b){var apos=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(itemsPreferencesFromSerendipity,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_14_constants_types__["h" ]&&item.element_id===a.id&&!item.enabled;});var bpos=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(itemsPreferencesFromSerendipity,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_14_constants_types__["h" ]&&item.element_id===b.id&&!item.enabled;});if(apos&&!bpos){return-1;}return 1;});var meetingsElements=meetings.map(function(meeting){return{type:__WEBPACK_IMPORTED_MODULE_14_constants_types__["g" ],data:meeting};});var speedDatingsElements=speedDatings.map(function(speedDating){return{type:__WEBPACK_IMPORTED_MODULE_14_constants_types__["i" ],data:speedDating};});// Exclude events concluded
var now=__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix();var allElements=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(meetingsElements.concat(speedDatingsElements,meetingsElements),function(meeting){var endDate=typeof meeting.data.end_date!=='undefined'?meeting.data.end_date:meeting.data.start_date+3600*6;return endDate>now;});allElements.sort(function(a,b){return a.data.start_date-b.data.start_date;});var narrativesElements=null;narrativesElements=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(finalNarratives,function(narrative){var planId=0;var type='';// buscamos si hay algun speed dating o meeting asociado a esta narrativa
if(allElements){var plan=allElements.find(function(element){return element.data.element_id===narrative.id;});if(plan){if(plan.type===__WEBPACK_IMPORTED_MODULE_14_constants_types__["i" ]){planId=plan.data.id;type=plan.type;}if(plan.type===__WEBPACK_IMPORTED_MODULE_14_constants_types__["g" ]){planId=plan.data.zoom_data.id;type=plan.type;}}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:narrative.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Cards_Call4ImpactCard__["a" ],{data:narrative,planId:planId,type:type}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section',dangerouslySetInnerHTML:{__html:literals.call4ImpactTitle}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_materialize__["Carousel"],{carouselId:'Carousel-2',options:{dist:-20,duration:200,fullWidth:false,indicators:false,noWrap:false,numVisible:6,onCycleTo:null,padding:-170,shift:0}},narrativesElements));};var printTimeline=function printTimeline(){var _getTimelineCards2=getTimelineCards(),meetings=_getTimelineCards2.meetings,speedDatings=_getTimelineCards2.speedDatings;if(!meetings.length&&!speedDatings.length&&!scheduleSpeedDatings){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Agenda__["a" ],{meetings:meetings,speedDatings:speedDatings});};var usersCarousel=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!thereAreUsers){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_with_searcher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section',dangerouslySetInnerHTML:{__html:literals.recommendedUsers}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form_input_stl',value:searchUsers,onChange:handleSearchUsers,placeholder:literals.search})),recommendedUsers.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{opacity:isLoadingUsers?0.5:1,pointerEvents:isLoadingUsers?'none':'all'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_SimpleCarousel__["a" ],{classesList:'user_wrapper',showButtons:true},recommendedUsers.map(function(elem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Cards_UserSmallCard_components__["a" ],{key:elem.id,user:elem,onClick:handleClickUser});}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styles__["c" ],{style:{opacity:isLoadingUsers?0.5:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nocontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15_assets_images_think_no_think_chats_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noUsers))));},[recommendedUsers,searchUsers,isLoadingUsers]);var tablesCarousel=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!thereAreTables){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_with_searcher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section',dangerouslySetInnerHTML:{__html:literals.recommendedTables}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form_input_stl',value:searchTables,onChange:handleSearchTables,placeholder:literals.search})),recommendedTables.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{opacity:isLoadingTables?0.5:1,pointerEvents:isLoadingUsers?'none':'all'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_SimpleCarousel__["a" ],{classesList:'theme_table_card',showButtons:true},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(recommendedTables,function(think){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Cards_ThemeTableCard__["a" ],{key:think.id,data:think,row:true,onClick:handleClickTable});}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styles__["c" ],{style:{opacity:isLoadingTables?0.5:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nocontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15_assets_images_think_no_think_chats_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noTables))));},[recommendedTables,searchTables,isLoadingTables]);var printMobileStoreLinks=function printMobileStoreLinks(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text',dangerouslySetInnerHTML:{__html:literals.enjoy}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'photos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_assets_images_app_store_svg___default.a,alt:'',onClick:openApple}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_assets_images_google_play_svg___default.a,alt:'',onClick:openGoogle}))));};var usersSwipeableCards=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!selectedUser){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_UsersModal__["a" ],{usersIds:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(recommendedUsers,function(user){return user.id;}),userSelected:selectedUser,onEnd:removeSelectedUser});},[selectedUser]);if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_LoadingComponent__["a" ],{colorAnimation:app.color1}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styles__["b" ],{className:'main_padding_desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,printCall4Impact(),printTimeline(),usersCarousel,tablesCarousel,printMobileStoreLinks(),usersSwipeableCards));}Narratives.propTypes={narratives:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,themeTables:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,itemsPreferencesFromSerendipity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,scheduleSpeedDatings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};Narratives.defaultProps={narratives:null,themeTables:[],scheduleSpeedDatings:[],itemsPreferencesFromSerendipity:[]}; __webpack_exports__["a"] = (Narratives);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google_play.10778222.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/app_store.b046dd41.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_4_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_5_routes_Narratives_modules___ = __webpack_require__(82);
 var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(1245);
function mapStateToProps(state){return{literals:state.i18n.literals.call4Impact||{},thinkChats:state.thinkChats,speedDatingCalls:state.narratives.speedDatingCalls,itemsPreferencesFromSerendipity:state.serendipity.preferences};}function mapDispatchToProps(dispatch){return{getUserNarrativeThinkChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_think_seeds_actions__["f" ],dispatch),getUserNarrativeSpeedDatingActualCalls:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_routes_Narratives_modules___["k" ],dispatch),enableItemFromSerendipity:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_serendipity_actions__["b" ],dispatch),disableItemFromSerendipity:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_serendipity_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Switch__ = __webpack_require__(97);
 var __WEBPACK_IMPORTED_MODULE_5_components_Countdown__ = __webpack_require__(69);
 var __WEBPACK_IMPORTED_MODULE_6_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIcon_svg__ = __webpack_require__(1246);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIcon_svg__);
 var __WEBPACK_IMPORTED_MODULE_8_utils_calls__ = __webpack_require__(183);
 var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(1247);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Call4ImpactCard=function(_Component){_inherits(Call4ImpactCard,_Component);function Call4ImpactCard(props){_classCallCheck(this,Call4ImpactCard);var _this=_possibleConstructorReturn(this,(Call4ImpactCard.__proto__||Object.getPrototypeOf(Call4ImpactCard)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,itemsPreferencesFromSerendipity=_this$props.itemsPreferencesFromSerendipity,id=_this$props.data.id,data=_this$props.data;var status=!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(itemsPreferencesFromSerendipity,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_6_constants_types__["h" ]&&item.element_id===id&&!item.enabled;});_this.state={enabled:status,start:data.progress===0,reStart:data.progress>0,hall:true,newCall:data.progress===0};return _this;}_createClass(Call4ImpactCard,[{key:'render',value:function render(){var _props=this.props,data=_props.data,literals=_props.literals,planId=_props.planId,type=_props.type;var _state=this.state,start=_state.start,newCall=_state.newCall,hall=_state.hall,enabled=_state.enabled,reStart=_state.reStart;var image=data.background_image,name=data.name,description=data.description;var minDateEvent=null;var today=__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');data.meetings.forEach(function(meeting){var meetingDay=__WEBPACK_IMPORTED_MODULE_2_moment___default()(meeting.start_date,'X').format('YYYY-MM-DD');if(meetingDay>=today&&(!minDateEvent||meeting.start_date<minDateEvent)){minDateEvent=meeting.start_date;}});data.speed_datings.forEach(function(meeting){var meetingDay=__WEBPACK_IMPORTED_MODULE_2_moment___default()(meeting.start_date,'X').format('YYYY-MM-DD');if(meetingDay>=today&&(!minDateEvent||meeting.start_date<minDateEvent)){minDateEvent=meeting.start_date;}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["a" ],{className:'c4impact_card',onClick:this.handleClickCall},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["b" ],{img:'url('+image+')'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIcon_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},name)),reStart&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Switch__["a" ],{className:'switch',checked:enabled,onChange:this.handleChangeEnabled,size:'small',name:'check_enabled',color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_detail'},minDateEvent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date'},literals.liveEvent+': '+__WEBPACK_IMPORTED_MODULE_2_moment___default()(minDateEvent,'X').format('DD/MM/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Countdown__["a" ],{time:minDateEvent,enabled:enabled})):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc_call'},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer_bottom'},type===__WEBPACK_IMPORTED_MODULE_6_constants_types__["i" ]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plan_speed_dating'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.handleClickPlan},literals.planSpeedDating)),type===__WEBPACK_IMPORTED_MODULE_6_constants_types__["g" ]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plan_meeting'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.handleClickPlan},literals.planMeeting)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_buttons',style:{marginTop:planId!==0?'':'4.5rem'}},start&&enabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn-sm claim',onClick:this.handleClick},literals.start),reStart&&enabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn-sm claim white',onClick:this.handleClick},literals.reStart),hall&&type!==__WEBPACK_IMPORTED_MODULE_6_constants_types__["c" ]&&start&&!reStart&&enabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn-sm claim white',onClick:this.handleHallClick},literals.hall),hall&&type!==__WEBPACK_IMPORTED_MODULE_6_constants_types__["c" ]&&!start&&reStart&&enabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn-sm claim',onClick:this.handleHallClick},literals.hall),!enabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn-sm claim black'},literals.start))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'options'},newCall&&enabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status'},'New'),newCall&&!enabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status disabled'},'New'))));}}]);return Call4ImpactCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleClick=function(event){var _props2=_this2.props,data=_props2.data,history=_props2.history,onClickStart=_props2.onClickStart;if(onClickStart){onClickStart(data);}else{history.push(Object(__WEBPACK_IMPORTED_MODULE_8_utils_calls__["a" ])(data));}event.stopPropagation();};this.handleHallClick=function(event){var _props3=_this2.props,id=_props3.data.id,history=_props3.history;history.push('/calls/'+id+'/hall');event.stopPropagation();};this.handleClickCall=function(){var _props4=_this2.props,id=_props4.data.id,history=_props4.history;history.push('/calls/'+id);};this.handleClickPlan=function(event){var _props5=_this2.props,planId=_props5.planId,history=_props5.history,type=_props5.type;if(type===__WEBPACK_IMPORTED_MODULE_6_constants_types__["g" ]){history.push('/zoom-meeting/'+planId);}if(type===__WEBPACK_IMPORTED_MODULE_6_constants_types__["i" ]){history.push('/speed-dating/'+planId);}event.stopPropagation();};this.handleChangeEnabled=function(event){var _props6=_this2.props,enableItemFromSerendipity=_props6.enableItemFromSerendipity,disableItemFromSerendipity=_props6.disableItemFromSerendipity,id=_props6.data.id;_this2.setState({enabled:event.target.checked});if(event.target.checked){enableItemFromSerendipity(__WEBPACK_IMPORTED_MODULE_6_constants_types__["h" ],id);}else{disableItemFromSerendipity(__WEBPACK_IMPORTED_MODULE_6_constants_types__["h" ],id);}};};Call4ImpactCard.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onClickStart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Call4ImpactCard.defaultProps={type:'',onClickStart:null}; __webpack_exports__["a"] = (Call4ImpactCard);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/callIcon.0e63536f.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return CallForImpactWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return HeaderCard; });





 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_narratives_speed_dating_jpg__ = __webpack_require__(1248);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_narratives_speed_dating_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_narratives_speed_dating_jpg__);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  vertical-align: top;\n  margin: 0 1rem 1rem 0;\n  background-color: #fff;\n  box-shadow: 0px 3px 6px #00000029;\n  border-radius: 2rem;\n  width: 30rem;\n  background-size: cover;\n  background-position: 50%;\n  height: 37rem;\n  font-size: 1.2rem;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n\n  .opacity {\n    position: absolute;\n    z-index: 5;\n    background: linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.5) 100%);\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  .header {\n    z-index: 10;\n    height: 20%;\n    display: flex;\n\n    .content {\n      width: 100%;\n      height: 70%;\n      margin: 1.5rem 1rem;\n      display: flex;\n    }\n\n    .name {\n      overflow: hidden;\n      font-family: ',';\n      color: ',';\n      font-size: 1.4rem;\n      font-weight: 400;\n      line-height: 2rem;\n      margin-left: 0.5rem;\n      height: 80%;\n    }\n\n    .date {\n      font-family: ',';\n      color: ',';\n      margin: 0.5rem 0;\n      font-size: 1.3rem;\n    }\n\n    .countdown {\n      font-size: 1.8rem;\n    }\n  }\n\n  .photo {\n    height: 50%;\n    width: 100%,\n  }\n\n  .desc_call {\n    line-height: 1.8rem;\n    margin-top: 2rem;\n    height: 11rem;\n    overflow: auto;\n  }\n\n  .details {\n    color: #2680EB;\n    margin-bottom: 1rem;\n    white-space: normal;\n    font-family: ',';\n    font-size: 1.3rem;\n    line-height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    &.disabled {\n      color: ',';\n    }\n  }\n\n  .banner {\n    background-position: 50% 50%;\n    height: 13rem;\n    background-size: cover;\n  }\n\n  .banner_speed_dating {\n    height: 13rem;\n    background-color: #eee;\n    text-align: center;\n    padding-top: 1.5rem;\n  }\n\n  .footer {\n    padding: 1.5rem 1rem 1rem;\n    width: 100%;\n    z-index: 10;\n    height: 40%;\n\n    .form_buttons {\n      text-align: center;\n      .claim {\n        width: 45%;\n      }\n    }\n\n    .name {\n      margin-bottom: 1rem;\n      white-space: normal;\n      font-family: ',';\n      color: ',';\n      font-size: 1.6rem;\n      line-height: 2rem;\n    }\n\n    .content_detail {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .options {\n      margin-top: 2rem;\n      font-size: 1.2rem;\n      display: none;\n      .status {\n        color: #FFA200;\n        &.disabled {\n          color: ',';\n        }\n      }\n    }\n  }\n  .footer_bottom {\n\n    .plan_speed_dating {\n      justify-content: center;\n      display: flex;\n      margin: 1rem 0;\n\n      button {\n        border: none;\n        border-radius: 2rem;\n        padding: 1rem 1.5rem;\n        background-color: #8AD923;\n        font-family: ',';\n        font-size: 1.3rem;\n        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n      }\n    }\n\n    .plan_meeting {\n      justify-content: center;\n      display: flex;\n      margin: 1rem 0;\n\n      button {\n        border: none;\n        border-radius: 2rem;\n        padding: 1rem 1.5rem;\n        background-color: #FFA304;\n        font-family: ',';\n        font-size: 1.3rem;\n        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n      }\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  vertical-align: top;\n  margin: 0 1rem 1rem 0;\n  background-color: #fff;\n  box-shadow: 0px 3px 6px #00000029;\n  border-radius: 2rem;\n  width: 30rem;\n  background-size: cover;\n  background-position: 50%;\n  height: 37rem;\n  font-size: 1.2rem;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n\n  .opacity {\n    position: absolute;\n    z-index: 5;\n    background: linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.5) 100%);\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  .header {\n    z-index: 10;\n    height: 20%;\n    display: flex;\n\n    .content {\n      width: 100%;\n      height: 70%;\n      margin: 1.5rem 1rem;\n      display: flex;\n    }\n\n    .name {\n      overflow: hidden;\n      font-family: ',';\n      color: ',';\n      font-size: 1.4rem;\n      font-weight: 400;\n      line-height: 2rem;\n      margin-left: 0.5rem;\n      height: 80%;\n    }\n\n    .date {\n      font-family: ',';\n      color: ',';\n      margin: 0.5rem 0;\n      font-size: 1.3rem;\n    }\n\n    .countdown {\n      font-size: 1.8rem;\n    }\n  }\n\n  .photo {\n    height: 50%;\n    width: 100%,\n  }\n\n  .desc_call {\n    line-height: 1.8rem;\n    margin-top: 2rem;\n    height: 11rem;\n    overflow: auto;\n  }\n\n  .details {\n    color: #2680EB;\n    margin-bottom: 1rem;\n    white-space: normal;\n    font-family: ',';\n    font-size: 1.3rem;\n    line-height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    &.disabled {\n      color: ',';\n    }\n  }\n\n  .banner {\n    background-position: 50% 50%;\n    height: 13rem;\n    background-size: cover;\n  }\n\n  .banner_speed_dating {\n    height: 13rem;\n    background-color: #eee;\n    text-align: center;\n    padding-top: 1.5rem;\n  }\n\n  .footer {\n    padding: 1.5rem 1rem 1rem;\n    width: 100%;\n    z-index: 10;\n    height: 40%;\n\n    .form_buttons {\n      text-align: center;\n      .claim {\n        width: 45%;\n      }\n    }\n\n    .name {\n      margin-bottom: 1rem;\n      white-space: normal;\n      font-family: ',';\n      color: ',';\n      font-size: 1.6rem;\n      line-height: 2rem;\n    }\n\n    .content_detail {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .options {\n      margin-top: 2rem;\n      font-size: 1.2rem;\n      display: none;\n      .status {\n        color: #FFA200;\n        &.disabled {\n          color: ',';\n        }\n      }\n    }\n  }\n  .footer_bottom {\n\n    .plan_speed_dating {\n      justify-content: center;\n      display: flex;\n      margin: 1rem 0;\n\n      button {\n        border: none;\n        border-radius: 2rem;\n        padding: 1rem 1.5rem;\n        background-color: #8AD923;\n        font-family: ',';\n        font-size: 1.3rem;\n        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n      }\n    }\n\n    .plan_meeting {\n      justify-content: center;\n      display: flex;\n      margin: 1rem 0;\n\n      button {\n        border: none;\n        border-radius: 2rem;\n        padding: 1rem 1.5rem;\n        background-color: #FFA304;\n        font-family: ',';\n        font-size: 1.3rem;\n        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  z-index: 10;\n  height: 30%;\n  background: ',';\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  color: white;\n\n  .opacity {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 30%;\n    z-index: -1;\n    background-color: rgba(0,0,0,0.2);\n    border: ',';\n    border-radius: ',';\n  }\n\n  .content {\n    width: 88%;\n    height: 70%;\n    margin-left: 2rem;\n    margin-top: 1rem;\n    color: white;\n    display: flex;\n  }\n\n  .switch {\n    margin-left: 2rem;\n    margin-bottom: 1rem;\n  }\n\n  .name {\n    overflow: hidden;\n    font-family: ',';\n    color: ',';\n    font-size: 1.4rem;\n    line-height: 2rem;\n    margin-left: 0.5rem;\n  }\n\n  .date {\n    font-family: ',';\n    color: ',';\n    margin: 0.5rem 0;\n    font-size: 1.3rem;\n  }\n\n  .countdown {\n    font-size: 1.8rem;\n  }\n  }\n'],['\n  z-index: 10;\n  height: 30%;\n  background: ',';\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  color: white;\n\n  .opacity {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 30%;\n    z-index: -1;\n    background-color: rgba(0,0,0,0.2);\n    border: ',';\n    border-radius: ',';\n  }\n\n  .content {\n    width: 88%;\n    height: 70%;\n    margin-left: 2rem;\n    margin-top: 1rem;\n    color: white;\n    display: flex;\n  }\n\n  .switch {\n    margin-left: 2rem;\n    margin-bottom: 1rem;\n  }\n\n  .name {\n    overflow: hidden;\n    font-family: ',';\n    color: ',';\n    font-size: 1.4rem;\n    line-height: 2rem;\n    margin-left: 0.5rem;\n  }\n\n  .date {\n    font-family: ',';\n    color: ',';\n    margin: 0.5rem 0;\n    font-size: 1.3rem;\n  }\n\n  .countdown {\n    font-size: 1.8rem;\n  }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n'],['\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n']),_templateObject4=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 13px;\n  margin-top: 2px;\n  line-height: 18px;\n'],['\n  color: #fff;\n  font-size: 13px;\n  margin-top: 2px;\n  line-height: 18px;\n']),_templateObject5=_taggedTemplateLiteral(['\n  color: #000;\n  background-color: #fff;\n  margin-left: 5px;\n  display: inline-block;\n'],['\n  color: #000;\n  background-color: #fff;\n  margin-left: 5px;\n  display: inline-block;\n']),_templateObject6=_taggedTemplateLiteral(['\n  cursor: pointer;\n  margin: 0 22px 20px;\n  padding: 20px;\n  width: calc(100% - 44px);\n  border-radius: 3px;\n  box-shadow: 0px 3px 5px 0px rgba(0,0,0, 0.3);\n  background-image: url(',');\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50%;\n  position: relative;\n\n  .opacity_layer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8);\n    z-index: 1;\n    display: block;\n  }\n\n  .speed_user_content {\n    display: inline-block;\n    vertical-align: middle;\n    width: calc(100% - 100px);\n    margin-left: 10px;\n    position: relative;\n    z-index: 2;\n  }\n\n  .avatar_bubble {\n    position: relative;\n    z-index: 2;\n  }\n\n  .position {\n    font-weight: 600 !important;\n  }\n\n  button {\n    margin: 10px auto 0;\n    transform: translateX(-40px);\n    width: 200px;\n  }\n'],['\n  cursor: pointer;\n  margin: 0 22px 20px;\n  padding: 20px;\n  width: calc(100% - 44px);\n  border-radius: 3px;\n  box-shadow: 0px 3px 5px 0px rgba(0,0,0, 0.3);\n  background-image: url(',');\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50%;\n  position: relative;\n\n  .opacity_layer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8);\n    z-index: 1;\n    display: block;\n  }\n\n  .speed_user_content {\n    display: inline-block;\n    vertical-align: middle;\n    width: calc(100% - 100px);\n    margin-left: 10px;\n    position: relative;\n    z-index: 2;\n  }\n\n  .avatar_bubble {\n    position: relative;\n    z-index: 2;\n  }\n\n  .position {\n    font-weight: 600 !important;\n  }\n\n  button {\n    margin: 10px auto 0;\n    transform: translateX(-40px);\n    width: 200px;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  padding: 1rem;\n  .description {\n    font-size: 1.2rem;\n    color: #30423E;\n    line-height: 1.6rem;\n  }\n\n  .tags {\n    white-space: nowrap;\n    overflow: auto;\n    margin: 1rem 0;\n  }\n\n  .title_section {\n    font-size: 1.4rem;\n    color: ',';\n  }\n'],['\n  padding: 1rem;\n  .description {\n    font-size: 1.2rem;\n    color: #30423E;\n    line-height: 1.6rem;\n  }\n\n  .tags {\n    white-space: nowrap;\n    overflow: auto;\n    margin: 1rem 0;\n  }\n\n  .title_section {\n    font-size: 1.4rem;\n    color: ',';\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CallForImpactWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].semiBoldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["k" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].semiBoldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].semiBoldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["k" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily);var HeaderCard=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.img;},function(props){return props.reStart?' 0.5rem solid #2680EB':'';},function(props){return props.reStart?'2rem 2rem 0rem 0rem':'';},__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["k" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["k" ]);var Name=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var Description=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var Seconds=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var SpeedDatingBubble=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_3_assets_images_narratives_speed_dating_jpg___default.a);var Details=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ]);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/speed_dating.5647acd8.jpg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1250);
function mapStateToProps(state){return{literals:state.i18n.literals.agenda,speedDatingMeetings:state.speedDating.meetings};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_5_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_6_constants_speed_dating__ = __webpack_require__(269);
 var __WEBPACK_IMPORTED_MODULE_7_components_Cards_AgendaCard__ = __webpack_require__(1251);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function Agenda(props){var meetings=props.meetings,speedDatings=props.speedDatings,speedDatingMeetings=props.speedDatingMeetings,scheduleSpeedDatings=props.scheduleSpeedDatings,literals=props.literals,title=props.title,showRandomSpeedDating=props.showRandomSpeedDating,showPlanSpeedDating=props.showPlanSpeedDating;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),elements=_useState2[0],setElements=_useState2[1];// Devuelve si el usuario esta libre a esa hora
var isAvailable=function isAvailable(startTime,speedDatingEndTime){var MARGIN=60;// Damos 60 segundos de margen
var endTime=startTime+__WEBPACK_IMPORTED_MODULE_6_constants_speed_dating__["b" ]+__WEBPACK_IMPORTED_MODULE_6_constants_speed_dating__["c" ]+MARGIN;if(endTime>speedDatingEndTime){return false;}var isBusy=false;var finalScheduleSpeedDatings=scheduleSpeedDatings.length?scheduleSpeedDatings:speedDatingMeetings.filter(function(meeting){return speedDatings.find(function(speedDating){return speedDating.id===meeting.element_id;});});__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(finalScheduleSpeedDatings,function(meeting){if(meeting.start_date>=startTime&&meeting.start_date<endTime||meeting.end_date>=startTime&&meeting.end_date<endTime){isBusy=true;}});if(isBusy){return false;}// Devuelvo hasta que hora esta libre
var availableUntil=null;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(finalScheduleSpeedDatings,function(meeting){if(meeting.start_date>startTime&&(!availableUntil||availableUntil>meeting.start_date)){availableUntil=meeting.start_date;}});if(!availableUntil){availableUntil=speedDatingEndTime;}return availableUntil;};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var meetingsElements=meetings.map(function(meeting){return{type:__WEBPACK_IMPORTED_MODULE_5_constants_types__["g" ],data:meeting};});var speedDatingsElements=speedDatings.map(function(speedDating){return{type:__WEBPACK_IMPORTED_MODULE_5_constants_types__["i" ],data:speedDating};});var finalScheduleSpeedDatings=scheduleSpeedDatings.length?scheduleSpeedDatings:speedDatingMeetings.filter(function(meeting){return speedDatings.find(function(speedDating){return speedDating.id===meeting.element_id;});});var scheduleSpeedDatingsElements=finalScheduleSpeedDatings.map(function(speedDating){return{type:__WEBPACK_IMPORTED_MODULE_5_constants_types__["j" ],data:speedDating};});// Exclude events concluded
var now=__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix();var allElementsToFilter=meetingsElements.concat(scheduleSpeedDatingsElements);if(showPlanSpeedDating){allElementsToFilter=allElementsToFilter.concat(speedDatingsElements);}var allElements=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(allElementsToFilter,function(meeting){if(typeof meeting.data.status!=='undefined'&&meeting.data.status===21275693){return false;}var endDate=typeof meeting.data.end_date!=='undefined'?meeting.data.end_date:meeting.data.start_date+3600*6;return endDate>now;});if(showRandomSpeedDating){var actualTime=__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix();__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(speedDatings,function(speedDating){var randomMeetingsInserted=0;if(speedDating.end_date>actualTime&&randomMeetingsInserted<2){var startDate=Math.max(__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix(),speedDating.start_date);var endDate=speedDating.end_date;var iteratorDate=startDate;var availableUntil=false;var iteratorBreak=0;while(iteratorDate<endDate&&iteratorBreak<1000){// Compruebo si hay tiempo para un speed dating aleatorio
availableUntil=isAvailable(iteratorDate,endDate);if(availableUntil){var randomMeeting=Object.assign({},speedDating);randomMeeting.start_date=iteratorDate;randomMeeting.end_date=availableUntil;allElements.push({type:__WEBPACK_IMPORTED_MODULE_5_constants_types__["k" ],data:randomMeeting});iteratorDate=availableUntil;randomMeetingsInserted+=1;}else{iteratorDate+=60;}iteratorBreak+=1;}}});}allElements.sort(function(a,b){if(a.data.start_date===b.data.start_date){if(a.type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["i" ]){return-1;}if(b.type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["i" ]){return 1;}}return a.data.start_date-b.data.start_date;});setElements(allElements);},[meetings,speedDatings,speedDatingMeetings]);var printCards=function printCards(){return elements.map(function(element,i){var newElement=Object.assign({},element);if(!newElement.data.element){var aux=elements.find(function(e){return e.id===element.id;});if(aux){newElement.data.element=aux.data.element;newElement.data.element_type=aux.data.element_type;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Cards_AgendaCard__["a" ],{key:i,type:newElement.type,data:newElement.data});});};if(!elements.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section',dangerouslySetInnerHTML:{__html:title||literals.scheduled}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_SimpleCarousel__["a" ],{classesList:'agenda_card',showButtons:true},printCards()));}Agenda.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,meetings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,speedDatings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,speedDatingMeetings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,scheduleSpeedDatings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,showRandomSpeedDating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showPlanSpeedDating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Agenda.defaultProps={title:null,meetings:[],speedDatings:[],speedDatingMeetings:[],scheduleSpeedDatings:[],showRandomSpeedDating:true,showPlanSpeedDating:true}; __webpack_exports__["a"] = (Agenda);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1252);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1253);
function mapStateToProps(state){return{literals:state.i18n.literals.themeTableDetail,narratives:state.narratives.list,speedDatingMeetings:state.speedDating.meetings};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_4_constants_meetings__ = __webpack_require__(476);
 var __WEBPACK_IMPORTED_MODULE_5_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_6_constants_speed_dating__ = __webpack_require__(269);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIconBlack_svg__ = __webpack_require__(477);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIconBlack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIconBlack_svg__);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_hall_speedDatingLogoGreen_svg__ = __webpack_require__(237);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_hall_speedDatingLogoGreen_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_images_hall_speedDatingLogoGreen_svg__);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_hall_liveEventLogo_svg__ = __webpack_require__(1254);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_hall_liveEventLogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_images_hall_liveEventLogo_svg__);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_hall_insightsLogo_svg__ = __webpack_require__(1255);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_hall_insightsLogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_assets_images_hall_insightsLogo_svg__);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_calls_tableBlack_svg__ = __webpack_require__(478);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_calls_tableBlack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_images_calls_tableBlack_svg__);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_calls_micro_svg__ = __webpack_require__(1256);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_calls_micro_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_images_calls_micro_svg__);
 var __WEBPACK_IMPORTED_MODULE_13_assets_images_calls_clock_svg__ = __webpack_require__(479);
 var __WEBPACK_IMPORTED_MODULE_13_assets_images_calls_clock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_assets_images_calls_clock_svg__);
 var __WEBPACK_IMPORTED_MODULE_14_assets_images_speed_dating_mistery_svg__ = __webpack_require__(480);
 var __WEBPACK_IMPORTED_MODULE_14_assets_images_speed_dating_mistery_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_assets_images_speed_dating_mistery_svg__);
 var __WEBPACK_IMPORTED_MODULE_15_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_16__styles__ = __webpack_require__(1257);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function AgendaCard(props){var literals=props.literals,data=props.data,type=props.type,narratives=props.narratives,history=props.history,speedDatingMeetings=props.speedDatingMeetings,isDragging=props.isDragging;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),deployMenu=_useState2[0],setDeployMenu=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('#FFA304'),_useState4=_slicedToArray(_useState3,2),color=_useState4[0],setColor=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){switch(type){case __WEBPACK_IMPORTED_MODULE_3_constants_types__["g" ]:setColor('#FFA304');break;case __WEBPACK_IMPORTED_MODULE_3_constants_types__["i" ]:setColor('#2680EB');break;case __WEBPACK_IMPORTED_MODULE_3_constants_types__["j" ]:setColor('#2680EB');break;case __WEBPACK_IMPORTED_MODULE_3_constants_types__["k" ]:setColor('#2680EB');break;default:setColor('#FFA304');break;}},[type]);var months=['January','February','March','April','May','June','July','August','September','October','November','December'];var startDatetime=new Date(data.start_date*1000);var endDatetime=new Date(data.end_date*1000);var month=months[startDatetime.getMonth()];var day=startDatetime.getDate();var dayOfMonth='';if(day===1||day===21||day===31){dayOfMonth=day+'st';}else if(day===2||day===22){dayOfMonth=day+'nd';}else if(day===3||day===23){dayOfMonth=day+'rd';}else{dayOfMonth=day+'th';}var startMinutes=startDatetime.getMinutes();if(startMinutes<10){startMinutes='0'+startMinutes;}var endMinutes=endDatetime.getMinutes();if(endMinutes<10){endMinutes='0'+endMinutes;}var startHour=startDatetime.getHours()+':'+startMinutes;var endHour=endDatetime.getHours()+':'+endMinutes;var hour=startHour+' to '+endHour;if(!data.end_date){hour=startHour;}var printContent=function printContent(){switch(type){case __WEBPACK_IMPORTED_MODULE_3_constants_types__["i" ]:{var numSpeedDatings=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(speedDatingMeetings,{element_id:data.id}).length;var callInfo=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(narratives,function(narrative){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(narrative.theme_tables,function(themeTable){return themeTable===data.element.id;});});var callForImpact=null;if(callInfo){callForImpact=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIconBlack_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},callInfo.name));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,data.element.type===__WEBPACK_IMPORTED_MODULE_3_constants_types__["a" ]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIconBlack_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},data.element.name)):null,data.element.type===__WEBPACK_IMPORTED_MODULE_3_constants_types__["l" ]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_assets_images_calls_tableBlack_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},data.element.name)):null,data.element_type.id===__WEBPACK_IMPORTED_MODULE_6_constants_speed_dating__["d" ]&&callForImpact,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13_assets_images_calls_clock_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'Starting at ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,hour))));}case __WEBPACK_IMPORTED_MODULE_3_constants_types__["k" ]:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mystery_title'},literals.mysteryDate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14_assets_images_speed_dating_mistery_svg___default.a,className:'mistery_icon',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content',style:{marginTop:'2.5rem'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13_assets_images_calls_clock_svg___default.a,alt:'',style:{height:'1.5rem',backgroundColor:'#fff',borderRadius:'50%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'Starting at ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{style:{color:'#fff'}},hour))));case __WEBPACK_IMPORTED_MODULE_3_constants_types__["j" ]:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,data.element?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIconBlack_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},data.element.name)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Avatar__["a" ],{size:32,avatar:data.user.avatar,firstname:data.user.firstname}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},data.user.firstname+' '+data.user.lastname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13_assets_images_calls_clock_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,hour))));case __WEBPACK_IMPORTED_MODULE_3_constants_types__["g" ]:{var speakers=data.speakers.map(function(speaker){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content',key:speaker.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12_assets_images_calls_micro_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.speaker),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Avatar__["a" ],{size:16,avatar:speaker.avatar,firstname:speaker.firstname}),speaker.firstname+' '+speaker.lastname)));});var _callForImpact=null;var table=null;if(data.element.type===__WEBPACK_IMPORTED_MODULE_4_constants_meetings__["c" ]){table=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_assets_images_calls_tableBlack_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},data.element.name));var _callInfo=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(narratives,function(narrative){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(narrative.theme_tables,function(themeTable){return themeTable===data.element.id;});});if(_callInfo){_callForImpact=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIconBlack_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},_callInfo.name));}}if(data.element.type===__WEBPACK_IMPORTED_MODULE_4_constants_meetings__["a" ]){_callForImpact=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7_assets_images_calls_callIconBlack_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},data.element.name));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_callForImpact,table,speakers,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13_assets_images_calls_clock_svg___default.a,alt:'',style:{height:'1.5rem'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,hour))));}default:return null;}};var handleClick=function handleClick(){if(!isDragging){switch(type){case __WEBPACK_IMPORTED_MODULE_3_constants_types__["g" ]:history.push('/zoom-meeting/'+data.zoom_data.id);break;case __WEBPACK_IMPORTED_MODULE_3_constants_types__["k" ]:history.push('/speed-dating/'+data.id+'/random');break;case __WEBPACK_IMPORTED_MODULE_3_constants_types__["j" ]:history.push('/zoom-meeting/'+data.zoom_data.id);break;case __WEBPACK_IMPORTED_MODULE_3_constants_types__["i" ]:history.push('/speed-dating/'+data.id);break;default:break;}}};var image=__WEBPACK_IMPORTED_MODULE_9_assets_images_hall_liveEventLogo_svg___default.a;var typeName=literals.liveEvent;switch(type){case __WEBPACK_IMPORTED_MODULE_3_constants_types__["i" ]:image=__WEBPACK_IMPORTED_MODULE_8_assets_images_hall_speedDatingLogoGreen_svg___default.a;typeName=literals.speedDating;break;case __WEBPACK_IMPORTED_MODULE_3_constants_types__["g" ]:image=__WEBPACK_IMPORTED_MODULE_9_assets_images_hall_liveEventLogo_svg___default.a;typeName=literals.liveEvent;break;case __WEBPACK_IMPORTED_MODULE_3_constants_types__["k" ]:image=__WEBPACK_IMPORTED_MODULE_8_assets_images_hall_speedDatingLogoGreen_svg___default.a;typeName='';break;case __WEBPACK_IMPORTED_MODULE_3_constants_types__["j" ]:image=__WEBPACK_IMPORTED_MODULE_8_assets_images_hall_speedDatingLogoGreen_svg___default.a;typeName=literals.speedDating;break;default:image=__WEBPACK_IMPORTED_MODULE_10_assets_images_hall_insightsLogo_svg___default.a;typeName=literals.conclusions;break;}var backColor=color;if(type===__WEBPACK_IMPORTED_MODULE_3_constants_types__["i" ]||type===__WEBPACK_IMPORTED_MODULE_3_constants_types__["k" ]){backColor='#8AD923';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["a" ],{className:'agenda_card',onClick:type===__WEBPACK_IMPORTED_MODULE_3_constants_types__["i" ]?null:handleClick,color:backColor!==color?backColor:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["d" ],{color:backColor,type:type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data'},month+' '+dayOfMonth),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'type_card'},typeName&&data.element_type&&data.element_type.id===__WEBPACK_IMPORTED_MODULE_6_constants_speed_dating__["a" ]?literals.event:null,typeName&&data.element_type&&data.element_type.id===__WEBPACK_IMPORTED_MODULE_6_constants_speed_dating__["d" ]?literals.table:null,' ',typeName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["b" ],{type:type,color:type===__WEBPACK_IMPORTED_MODULE_3_constants_types__["i" ]?'white':__WEBPACK_IMPORTED_MODULE_5_constants_colors__["f" ]},printContent()),type===__WEBPACK_IMPORTED_MODULE_3_constants_types__["i" ]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:handleClick},literals.plan)):null);}AgendaCard.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,narratives:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,speedDatingMeetings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,isDragging:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};AgendaCard.defaultProps={isDragging:false}; __webpack_exports__["a"] = (AgendaCard);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/liveEventLogo.c38b91e7.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/insightsLogo.f420cd82.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/micro.8675a625.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return AgendaCardWrapper; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return Footer; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return Top; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return Data; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_types__ = __webpack_require__(32);
var _templateObject=_taggedTemplateLiteral(['\n    display: inline-block;\n    vertical-align: top;\n    background-color: ',';\n    width: 18rem;\n    height: 25rem;\n    margin-right: 1rem;\n    border-radius: 1.5rem;\n    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n    border: 0.1rem solid #e9e9e9;\n    cursor: pointer;\n    white-space: normal;\n    position: relative;\n'],['\n    display: inline-block;\n    vertical-align: top;\n    background-color: ',';\n    width: 18rem;\n    height: 25rem;\n    margin-right: 1rem;\n    border-radius: 1.5rem;\n    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n    border: 0.1rem solid #e9e9e9;\n    cursor: pointer;\n    white-space: normal;\n    position: relative;\n']),_templateObject2=_taggedTemplateLiteral(['\n    button {\n        border: none;\n        border-radius: 2rem;\n        padding: 1rem 1.5rem;\n        font-family: ',';\n        font-size: 1.5rem;\n        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n        background-color: white;\n        margin-left: 1rem;\n    }\n'],['\n    button {\n        border: none;\n        border-radius: 2rem;\n        padding: 1rem 1.5rem;\n        font-family: ',';\n        font-size: 1.5rem;\n        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n        background-color: white;\n        margin-left: 1rem;\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    height: ',';\n    background: ',';\n    border-radius: 1.5rem 1.5rem 0 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    .icon {\n        background: white;\n        border-radius: 100%;\n        border-radius: 100%;\n        width: ',';\n        height: ',';;\n        padding: ',';;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-left: 1rem;\n        top: 1rem;\n        position: absolute;\n        img {\n            height: ',';\n            width: ',';\n        }\n    }\n    .data {\n        font-size: 1.5rem;\n        width: 70%;\n        font-family: ',';\n        color: white;\n        text-align: right;\n        transform: translateY(',';);\n        margin-right: 5%;\n        right: 0;\n        position: absolute;\n\n    }\n    .type_card {\n        position: absolute;\n        font-family: ',';\n        font-weight: ',';\n        color: white;\n        top: 6.5rem;\n        left:50%;\n        text-align: right;\n        margin-right: 10%;\n        width: -webkit-fill-available;\n        font-size: 1.2rem;\n\n        transform: translate(-50%,-50%);\n    }\n\n    .menu {\n        padding: 1rem;\n\n        .deploy_menu {\n            font-family: ',';\n            font-weight: ',';\n            font-size: 1.4rem;\n            position: absolute;\n            z-index: 1000;\n            background-color: white;\n            border-radius: 10px;\n            top: 2rem;\n            left: 0.5rem;\n\n            button {\n                border: none;\n                padding: 0.5rem;\n\n\n                img {\n                    float: left;\n                    margin: 0.5rem;\n                }\n\n                p {\n                    float: right;\n                    margin: 0.5rem 0 0.5rem 0;\n                }\n\n            }\n\n            .calendar {\n                color: #2680EB;\n            }\n\n            .delete {\n                color: #F63256;\n            }\n        }\n    }\n\n\n'],['\n    height: ',';\n    background: ',';\n    border-radius: 1.5rem 1.5rem 0 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    .icon {\n        background: white;\n        border-radius: 100%;\n        border-radius: 100%;\n        width: ',';\n        height: ',';;\n        padding: ',';;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-left: 1rem;\n        top: 1rem;\n        position: absolute;\n        img {\n            height: ',';\n            width: ',';\n        }\n    }\n    .data {\n        font-size: 1.5rem;\n        width: 70%;\n        font-family: ',';\n        color: white;\n        text-align: right;\n        transform: translateY(',';);\n        margin-right: 5%;\n        right: 0;\n        position: absolute;\n\n    }\n    .type_card {\n        position: absolute;\n        font-family: ',';\n        font-weight: ',';\n        color: white;\n        top: 6.5rem;\n        left:50%;\n        text-align: right;\n        margin-right: 10%;\n        width: -webkit-fill-available;\n        font-size: 1.2rem;\n\n        transform: translate(-50%,-50%);\n    }\n\n    .menu {\n        padding: 1rem;\n\n        .deploy_menu {\n            font-family: ',';\n            font-weight: ',';\n            font-size: 1.4rem;\n            position: absolute;\n            z-index: 1000;\n            background-color: white;\n            border-radius: 10px;\n            top: 2rem;\n            left: 0.5rem;\n\n            button {\n                border: none;\n                padding: 0.5rem;\n\n\n                img {\n                    float: left;\n                    margin: 0.5rem;\n                }\n\n                p {\n                    float: right;\n                    margin: 0.5rem 0 0.5rem 0;\n                }\n\n            }\n\n            .calendar {\n                color: #2680EB;\n            }\n\n            .delete {\n                color: #F63256;\n            }\n        }\n    }\n\n\n']),_templateObject4=_taggedTemplateLiteral(['\n    height: calc(100% - 8rem);\n    ','\n    ','\n    background-color: #fff;\n    ','\n    ','\n    width: 100%;\n    padding: 0 1rem;\n    overflow-y: auto;\n\n    .mystery_title {\n        color: #ffffff;\n        font-size: 1.4rem;\n        text-transform: uppercase;\n        font-family: ',';\n        text-align: center;\n    }\n\n    .line_content {\n        margin: 1.5rem 0;\n        display: flex;\n        align-items: center;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        .mistery_icon {\n            width: 9rem;\n            margin: 0 auto;\n        }\n\n        .text {\n            margin-left: 0.5rem;\n            font-size: 1.2rem;\n        }\n\n        &.green {\n            color: white;\n        }\n\n        .user {\n            margin-top: 0.5rem;\n            margin-left: 0.5rem;\n            font-size: 1.2rem;\n\n            .avatar_bubble {\n                margin-right: 0.5rem;\n            }\n        }\n\n        strong {\n            color: ',';\n        }\n    }\n    .type {\n        color: ',';\n        font-size: 1.1rem;\n        font-family: ',';\n    }\n    .paperbin {\n      position: absolute;\n      right: 0.8rem;\n      background: white;\n      padding: 0.5rem;\n      bottom: 0.8rem;\n      border-radius: 1rem;\n      box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    }\n'],['\n    height: calc(100% - 8rem);\n    ','\n    ','\n    background-color: #fff;\n    ','\n    ','\n    width: 100%;\n    padding: 0 1rem;\n    overflow-y: auto;\n\n    .mystery_title {\n        color: #ffffff;\n        font-size: 1.4rem;\n        text-transform: uppercase;\n        font-family: ',';\n        text-align: center;\n    }\n\n    .line_content {\n        margin: 1.5rem 0;\n        display: flex;\n        align-items: center;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        .mistery_icon {\n            width: 9rem;\n            margin: 0 auto;\n        }\n\n        .text {\n            margin-left: 0.5rem;\n            font-size: 1.2rem;\n        }\n\n        &.green {\n            color: white;\n        }\n\n        .user {\n            margin-top: 0.5rem;\n            margin-left: 0.5rem;\n            font-size: 1.2rem;\n\n            .avatar_bubble {\n                margin-right: 0.5rem;\n            }\n        }\n\n        strong {\n            color: ',';\n        }\n    }\n    .type {\n        color: ',';\n        font-size: 1.1rem;\n        font-family: ',';\n    }\n    .paperbin {\n      position: absolute;\n      right: 0.8rem;\n      background: white;\n      padding: 0.5rem;\n      bottom: 0.8rem;\n      border-radius: 1rem;\n      box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AgendaCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;});var Footer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily);var Top=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["k" ]?'26%':'32%';},function(props){return props.color;},function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["k" ]?'2.5rem':'3rem';},function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["k" ]?'2.5rem':'3rem';},function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["k" ]?'0rem':'1rem';},function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["k" ]?'2.5rem':'2rem';},function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["k" ]?'2.5rem':'2rem';},__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].semiBoldFamily,function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["k" ]?'-1rem':'-2rem';},__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldWeight,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldWeight);var Data=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["i" ]?'height: 45%;':null;},function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["k" ]?'height: 65%;':null;},function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["i" ]?'background-color: #8AD923;':null;},function(props){return props.type===__WEBPACK_IMPORTED_MODULE_2_constants_types__["k" ]?'background-color: #8AD923;':null;},__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,function(props){return props.color;},function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return NarrativesWrapper; });






 __webpack_require__.d(__webpack_exports__, "d", function() { return PhoneUrl; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingWrapper; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return NoElements; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_InputBase__ = __webpack_require__(113);
 var __WEBPACK_IMPORTED_MODULE_2_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_3_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: #f9f9f9;\n  max-width: 120rem;\n  margin: 0 auto;\n  width: calc(100% - 18rem);\n\n  @media (max-width: ','px) {\n    width: 100%;\n    padding: 1rem 0rem 5rem;\n\n    .title_section {\n      margin-left: 1rem;\n    }\n\n    .simple_carousel {\n      margin-left: 1rem;\n    }\n  }\n\n  .section_wrapper {\n    padding-top: 10px;\n\n    @media (max-width: ','px) {\n      padding-top: 1rem;\n    }\n  }\n\n  .carousel {\n    height: 45rem;\n    .carousel-item {\n      width: 27.3rem;\n      height: 42rem;\n      opacity: 1 !important;\n    }\n  }\n\n  .carousel_calls_desktop {\n    .nowrap {\n      padding: 5rem 2.2rem;\n      margin: -5rem 0;\n    }\n\n    .c4impact_card {\n      transition: all linear 0.2s;\n      &:hover {\n        z-index: 100;\n        transform: scale(1.2);\n        box-shadow: 0px 3px 10px #00000050;\n      }\n    }\n  }\n  .description {\n    padding: 1rem;\n    font-family: ',';\n    font-size: 1.3rem;\n    color: ',';\n    overflow: hidden;\n    height: 6rem;\n    line-height: 1.7rem;\n    margin-bottom: 1rem;\n  }\n  .phone_content {\n    margin-top: 4rem;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n'],['\n  background-color: #f9f9f9;\n  max-width: 120rem;\n  margin: 0 auto;\n  width: calc(100% - 18rem);\n\n  @media (max-width: ','px) {\n    width: 100%;\n    padding: 1rem 0rem 5rem;\n\n    .title_section {\n      margin-left: 1rem;\n    }\n\n    .simple_carousel {\n      margin-left: 1rem;\n    }\n  }\n\n  .section_wrapper {\n    padding-top: 10px;\n\n    @media (max-width: ','px) {\n      padding-top: 1rem;\n    }\n  }\n\n  .carousel {\n    height: 45rem;\n    .carousel-item {\n      width: 27.3rem;\n      height: 42rem;\n      opacity: 1 !important;\n    }\n  }\n\n  .carousel_calls_desktop {\n    .nowrap {\n      padding: 5rem 2.2rem;\n      margin: -5rem 0;\n    }\n\n    .c4impact_card {\n      transition: all linear 0.2s;\n      &:hover {\n        z-index: 100;\n        transform: scale(1.2);\n        box-shadow: 0px 3px 10px #00000050;\n      }\n    }\n  }\n  .description {\n    padding: 1rem;\n    font-family: ',';\n    font-size: 1.3rem;\n    color: ',';\n    overflow: hidden;\n    height: 6rem;\n    line-height: 1.7rem;\n    margin-bottom: 1rem;\n  }\n  .phone_content {\n    margin-top: 4rem;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 89%;\n  margin: 0 auto;\n  display: flex;\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 0px 10px;\n  margin-bottom: 20px;\n  height: 30px;\n  border: 1px solid #ccc;\n  img {\n    width: 16px;\n  }\n'],['\n  width: 89%;\n  margin: 0 auto;\n  display: flex;\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 0px 10px;\n  margin-bottom: 20px;\n  height: 30px;\n  border: 1px solid #ccc;\n  img {\n    width: 16px;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  && {\n    flex: 1;\n    height: 30px;\n    input {\n      color: #4d4d4d;\n      font-family: \'helvetica neue light\';\n      font-size: 14px;\n      margin-top: 0px;\n    }\n  }\n'],['\n  && {\n    flex: 1;\n    height: 30px;\n    input {\n      color: #4d4d4d;\n      font-family: \'helvetica neue light\';\n      font-size: 14px;\n      margin-top: 0px;\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  font-size: 1.6rem;\n  text-align: left;\n  color: black;\n  font-family: ',';\n  line-height: 2.1rem;\n  padding-bottom: 0.2rem;\n  margin: 2rem 0rem 1rem;\n  margin-left: 2.5rem;\n\n  b {\n    font-family: ',';\n  }\n\n  @media (max-width: ','px) {\n    font-size: 1.4rem;\n  }\n'],['\n  font-size: 1.6rem;\n  text-align: left;\n  color: black;\n  font-family: ',';\n  line-height: 2.1rem;\n  padding-bottom: 0.2rem;\n  margin: 2rem 0rem 1rem;\n  margin-left: 2.5rem;\n\n  b {\n    font-family: ',';\n  }\n\n  @media (max-width: ','px) {\n    font-size: 1.4rem;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  padding: 0 2.2rem 1rem;\n\n  &.nowrap {\n    white-space: nowrap;\n    overflow: hidden;\n\n    @media (max-width: ','px) {\n      overflow: auto;\n    }\n  }\n'],['\n  padding: 0 2.2rem 1rem;\n\n  &.nowrap {\n    white-space: nowrap;\n    overflow: hidden;\n\n    @media (max-width: ','px) {\n      overflow: auto;\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  color: red;\n  margin: 4rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  background: white;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 4rem;\n  width: 4rem;\n  cursor: pointer;\n\n  @media (max-width: ','px) {\n    display: none;\n  }\n\n  img {\n    padding: 4rem;\n    &.left{\n      transform: rotate(180deg);\n    }\n  }\n'],['\n  color: red;\n  margin: 4rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  background: white;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 4rem;\n  width: 4rem;\n  cursor: pointer;\n\n  @media (max-width: ','px) {\n    display: none;\n  }\n\n  img {\n    padding: 4rem;\n    &.left{\n      transform: rotate(180deg);\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  .content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n'],['\n  width: 100%;\n  position: relative;\n  .content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  background: #2680EB;\n  display: flex;\n  flex-direction: colrowumn;\n  align-items: center;\n  width: 100%;\n  border-radius: 1.5rem;\n  position: relative;\n  @media (max-width: ','px) {\n    display: none;\n  }\n  .text {\n    font-size: 1.8rem;\n    color: white;\n    margin-left: 4rem;\n  }\n  .photos {\n    text-align: right;\n    padding-right: 1rem;\n    margin-left: auto;\n    img {\n      margin: 1rem;\n      cursor: pointer;\n    }\n  }\n'],['\n  background: #2680EB;\n  display: flex;\n  flex-direction: colrowumn;\n  align-items: center;\n  width: 100%;\n  border-radius: 1.5rem;\n  position: relative;\n  @media (max-width: ','px) {\n    display: none;\n  }\n  .text {\n    font-size: 1.8rem;\n    color: white;\n    margin-left: 4rem;\n  }\n  .photos {\n    text-align: right;\n    padding-right: 1rem;\n    margin-left: auto;\n    img {\n      margin: 1rem;\n      cursor: pointer;\n    }\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  width: 60rem;\n  height: 60rem;\n  max-width: 100vw;\n  max-height: 100vh;\n  margin: 0 auto;\n'],['\n  width: 60rem;\n  height: 60rem;\n  max-width: 100vw;\n  max-height: 100vh;\n  margin: 0 auto;\n']),_templateObject10=_taggedTemplateLiteral(['\n  height: 15rem;\n  padding: 2rem;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n\n  .nocontent {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    img {\n      width: 14rem;\n    }\n\n    .text {\n      margin-top: 1rem;\n      font-size: 1.3rem;\n      text-align: center;\n      color: black;\n    }\n  }\n'],['\n  height: 15rem;\n  padding: 2rem;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n\n  .nocontent {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    img {\n      width: 14rem;\n    }\n\n    .text {\n      margin-top: 1rem;\n      font-size: 1.3rem;\n      text-align: center;\n      color: black;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var NarrativesWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ]);var Searcher=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var SearcherInput=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_InputBase__["a" ])(_templateObject3);var TitleNarrativeSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var Content=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var ButtonScroll=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var ContentScroll=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7);var PhoneUrl=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_4_constants_breakPoints__["b" ]);var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);var NoElements=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1260);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_5_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_6__components_Gpdr__ = __webpack_require__(1261);
function mapStateToProps(state){return{literals:state.i18n.literals.gpdr,color:state.app.color1,user:state.session.user};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__["b" ],dispatch),goHome:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_steps_actions__["e" ],dispatch),resetContext:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components_Gpdr__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar__ = __webpack_require__(116);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1262);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gpdr=function(_Component){_inherits(Gpdr,_Component);function Gpdr(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Gpdr);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Gpdr.__proto__||Object.getPrototypeOf(Gpdr)).call.apply(_ref,[this].concat(args))),_this),_this.setBreadcrumb=function(){var _this$props=_this.props,history=_this$props.history,literals=_this$props.literals,setBreadcrumb=_this$props.setBreadcrumb,resetContext=_this$props.resetContext;var breadcrumb=[{color:'#ffffff',text:literals.profile,onClick:function onClick(){history.push(__WEBPACK_IMPORTED_MODULE_2_constants_urls__["F" ]);}},{color:'#ffffff',text:literals.title}];setBreadcrumb(breadcrumb.slice());resetContext();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Gpdr,[{key:'componentDidMount',value:function componentDidMount(){this.setBreadcrumb();}},{key:'render',value:function render(){var _props=this.props,_props$user=_props.user,id=_props$user.id,userCode=_props$user.user_code,color=_props.color,literals=_props.literals;var url='https://calltoinnovation.org/configuration_gdpr.php?h=true&clean=true&session_user='+id+'&session_code='+userCode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],{color:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Navbar__["a" ],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:url,title:literals.title}));}}]);return Gpdr;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Gpdr.propTypes={user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (Gpdr);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return GpdrWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 80px;\n  min-height: 100%;\n\n  iframe {\n    height: calc(100vh - 150px);\n    background-color: #fff;\n    border: 0px;\n  }\n'],['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 80px;\n  min-height: 100%;\n\n  iframe {\n    height: calc(100vh - 150px);\n    background-color: #fff;\n    border: 0px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GpdrWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1264);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_6__components_ThinkSeedCreation__ = __webpack_require__(1265);
function mapStateToProps(state){return{app:state.app,literals:state.i18n.literals.creationThinkSeed};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_components_Navbar_modules__["b" ],dispatch),resetContext:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["e" ],dispatch),goHome:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components_ThinkSeedCreation__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_CreationThinkSeed__ = __webpack_require__(481);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1271);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThinkSeedCreation=function(_Component){_inherits(ThinkSeedCreation,_Component);function ThinkSeedCreation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ThinkSeedCreation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ThinkSeedCreation.__proto__||Object.getPrototypeOf(ThinkSeedCreation)).call.apply(_ref,[this].concat(args))),_this),_this.setBreadcrumb=function(){var _this$props=_this.props,literals=_this$props.literals,setBreadcrumb=_this$props.setBreadcrumb,resetContext=_this$props.resetContext;var breadcrumb=[{type:'back',onClick:_this.handleBackArrow},{color:'#ffffff',text:literals.newTable}];setBreadcrumb(breadcrumb.slice());resetContext();},_this.handleBackArrow=function(){var history=_this.props.history;history.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ThinkSeedCreation,[{key:'componentDidMount',value:function componentDidMount(){this.setBreadcrumb();}},{key:'render',value:function render(){var _props=this.props,color1=_props.app.color1,literals=_props.literals,callId=_props.match.params.callId;var data={title:literals.defaultTitleForm};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{color:color1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CreationThinkSeed__["a" ],{callId:callId?parseInt(callId,10):null,data:data,color:color1,fromChats:true}));}}]);return ThinkSeedCreation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ThinkSeedCreation.propTypes={app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (ThinkSeedCreation);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_4_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_5_routes_MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_6__components_CreationThinkSeed__ = __webpack_require__(1267);
function mapStateToProps(state){return{literals:state.i18n.literals.creationThinkSeed,actualContext:state.steps.context,app:state.app,narratives:state.narratives.list,userConnections:state.userConnections.connections};}function mapDispatchToProps(dispatch){return{joinThemeTable:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_think_seeds_actions__["g" ],dispatch),setCanDrag:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_routes_MainPage_modules_mainPage__["c" ],dispatch),setGoDown:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_routes_MainPage_modules_mainPage__["d" ],dispatch),getChats:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_chats__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components_CreationThinkSeed__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
 var __WEBPACK_IMPORTED_MODULE_5_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_7_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_8_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_9_components_AutocompleteInput__ = __webpack_require__(96);
 var __WEBPACK_IMPORTED_MODULE_10_components_Chats_components_FilterChat__ = __webpack_require__(266);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_icons_unloadedImage_svg__ = __webpack_require__(1268);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_icons_unloadedImage_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_images_icons_unloadedImage_svg__);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_think_deleteIcon_svg__ = __webpack_require__(1269);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_think_deleteIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_images_think_deleteIcon_svg__);
 var __WEBPACK_IMPORTED_MODULE_13_assets_images_unlock_svg__ = __webpack_require__(482);
 var __WEBPACK_IMPORTED_MODULE_13_assets_images_unlock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_assets_images_unlock_svg__);
 var __WEBPACK_IMPORTED_MODULE_14_assets_images_icons_call_black_svg__ = __webpack_require__(1270);
 var __WEBPACK_IMPORTED_MODULE_14_assets_images_icons_call_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_assets_images_icons_call_black_svg__);
 var __WEBPACK_IMPORTED_MODULE_15_assets_images_ArrowBack_svg__ = __webpack_require__(135);
 var __WEBPACK_IMPORTED_MODULE_15_assets_images_ArrowBack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_assets_images_ArrowBack_svg__);
 var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Switch__ = __webpack_require__(97);
 var __WEBPACK_IMPORTED_MODULE_17_components_AvatarNew__ = __webpack_require__(262);
 var __WEBPACK_IMPORTED_MODULE_18_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_19__styles__ = __webpack_require__(270);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreationThinkSeed=function(_Component){_inherits(CreationThinkSeed,_Component);function CreationThinkSeed(props){_classCallCheck(this,CreationThinkSeed);var _this=_possibleConstructorReturn(this,(CreationThinkSeed.__proto__||Object.getPrototypeOf(CreationThinkSeed)).call(this,props));_this.getColor=function(){var _this$props=_this.props,context=_this$props.actualContext,app=_this$props.app;var color=app.color1;if(context&&context.color){color=typeof context.color==='string'?context.color:context.color.color;}return color;};_this.setTimeLife=function(event){var value=event.currentTarget.value?parseInt(event.currentTarget.value,10):0;if(Number.isNaN(value)||value<0){value=0;}var attrTime=event.currentTarget.getAttribute('attr-time');_this.setState(_defineProperty({},attrTime,value));};_this.handleFileUpload=function(event){if(event.target.files[0]!==undefined){var file=event.target.files[0];var name=file.name;var reader=new FileReader();reader.onloadend=function(){_this.uploadImage(reader.result,name);};reader.readAsDataURL(file);}};_this.handleUnselectPeople=function(event){var peopleSelected=_this.state.peopleSelected;var id=parseInt(event.currentTarget.getAttribute('user-data_id'),10);var index=peopleSelected.findIndex(function(user){return user.id===id;});if(index>=0){peopleSelected.splice(index,1);_this.setState({peopleSelected:peopleSelected});}};_this.handleGoBack=function(){var isNext=_this.state.isNext;var history=_this.props.history;if(!isNext){history.goBack();}else{_this.setState({isNext:false});}};_this.uploadImage=function(data,name){var literals=_this.props.literals;var params={data:data,name:name};_this.setState({uploadingImage:true});Object(__WEBPACK_IMPORTED_MODULE_5_utils_apiFetch__["b" ])('POST',{endPoint:'upload-file'},params).then(function(response){var error=_this.state.error;var newError=error;if(error===literals.errorUploadingImage){newError=null;}_this.setState({image:response.url,uploadingImage:false,error:newError});}).catch(function(){var error=_this.state.error;var newError=error;if(error===literals.errorUploadingImage){newError=null;}_this.setState({image:'',uploadingImage:false,error:newError});});};_this.handleChangeName=function(event){var value=event.target.value;_this.setState({name:value});};_this.handleSelectUser=function(event){var peopleSelected=_this.state.peopleSelected;var user={id:parseInt(event.currentTarget.getAttribute('data-user_id'),10),name:event.currentTarget.getAttribute('name'),avatar:event.currentTarget.getAttribute('avatar')};var index=peopleSelected.findIndex(function(elem){return elem.id===user.id;});if(index>=0){peopleSelected.splice(index,1);}else{peopleSelected.push(user);}_this.setState({peopleSelected:peopleSelected});};_this.handleChangeDescription=function(event){var value=event.target.value;_this.setState({description:value});};_this.continue=function(){var _this$state=_this.state,status=_this$state.status,name=_this$state.name,uploadingImage=_this$state.uploadingImage;var literals=_this.props.literals;if(status===__WEBPACK_IMPORTED_MODULE_7_constants_status__["b" ]){if(!name){_this.setState({error:literals.errorName});return false;}if(uploadingImage){_this.setState({error:literals.errorUploadingImage});return false;}_this.setState({isNext:true});}return true;};_this.submit=function(){var _this$props2=_this.props,joinThemeTable=_this$props2.joinThemeTable,getChats=_this$props2.getChats;var _this$state2=_this.state,name=_this$state2.name,description=_this$state2.description,image=_this$state2.image,uploadingImage=_this$state2.uploadingImage,status=_this$state2.status,tags=_this$state2.tags,peopleSelected=_this$state2.peopleSelected,call=_this$state2.call,enableSwitch=_this$state2.enableSwitch,day=_this$state2.day,hour=_this$state2.hour,minute=_this$state2.minute,seconds=_this$state2.seconds;if(status===__WEBPACK_IMPORTED_MODULE_7_constants_status__["b" ]){var _this$props3=_this.props,literals=_this$props3.literals,actualContext=_this$props3.actualContext;if(!name){_this.setState({error:literals.errorName});return false;}if(uploadingImage){_this.setState({error:literals.errorUploadingImage});return false;}var elementType='';var elementId=0;if(actualContext){elementType=actualContext.elementType?actualContext.elementType:'narrative';if(actualContext.id){elementId=actualContext.id;}if(actualContext.elementId){elementId=actualContext.elementId;}}var params={id:null,name:name,description:description,image:image,tags:tags.join('%_%'),element_type:elementType,element_id:elementId,private:+enableSwitch,call:call,timelimit:__WEBPACK_IMPORTED_MODULE_4_moment___default()().unix()+day*86400+hour*1440+minute*60+seconds,type:21283817};_this.setState({status:__WEBPACK_IMPORTED_MODULE_7_constants_status__["c" ]});_this.setState({error:false,status:__WEBPACK_IMPORTED_MODULE_7_constants_status__["f" ]});_this.setState({isLoading:true});Object(__WEBPACK_IMPORTED_MODULE_5_utils_apiFetch__["b" ])('POST',{endPoint:'think-seed'},params).then(function(table){params={id:table.id,users:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(peopleSelected,function(user){return user.id;}).join(',')};joinThemeTable(table);getChats();Object(__WEBPACK_IMPORTED_MODULE_5_utils_apiFetch__["b" ])('POST',{endPoint:'/think-seed/'+table.id+'/invitations'},params).then(function(){_this.setState({status:__WEBPACK_IMPORTED_MODULE_7_constants_status__["c" ],table:table});_this.setState({isLoading:false});});}).catch(function(){_this.setState({error:literals.errorSaving,status:__WEBPACK_IMPORTED_MODULE_7_constants_status__["b" ]});});return true;}return true;};_this.printGridUsers=function(){var _this$state3=_this.state,filter=_this$state3.filter,peopleSelected=_this$state3.peopleSelected;var _this$props4=_this.props,userConnections=_this$props4.userConnections,literals=_this$props4.literals;var usersFiltered=[];var users=[];if(!userConnections||!userConnections.length){return null;}if(userConnections){if(filter!==''){var lowerFilter=filter.toLowerCase();usersFiltered=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(userConnections,function(user){var completeName=(user.firstname+' '+user.lastname).toLowerCase();if(completeName.includes(lowerFilter)){return true;}return false;});}else{usersFiltered=userConnections;}users=usersFiltered.map(function(user){var isSelected=false;var completeName=user.firstname+' '+user.lastname;if(peopleSelected.findIndex(function(elem){return elem.id===user.id;})>=0){isSelected=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:user.id,'data-user_id':user.id,avatar:user.avatar,name:completeName,onClick:_this.handleSelectUser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_AvatarNew__["a" ],{avatar:user.avatar,firstname:completeName,id:user.id,invite:true,isSelected:isSelected}));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["s" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_network'},literals.myNetwork),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["r" ],null,users));};_this.printImage=function(){var _this$state4=_this.state,image=_this$state4.image,uploadingImage=_this$state4.uploadingImage;var literals=_this.props.literals;var button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'upload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_assets_images_icons_unloadedImage_svg___default.a,alt:'upload',style:{minHeight:'5rem'}}),literals.pressToUploadImage);var color=_this.getColor();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["k" ],{image:image,htmlFor:'document_file',color:color},!image&&!uploadingImage&&button,!image&&uploadingImage&&literals.uploading,image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'uploaded',src:image,alt:''}));};_this.printRelated=function(){var tags=_this.state.tags;if(tags.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);};_this.handleChangeEnabled=function(){var enableSwitch=_this.state.enableSwitch;_this.setState({enableSwitch:!enableSwitch});};_this.cancelInvitations=function(){_this.setState({error:'',status:__WEBPACK_IMPORTED_MODULE_7_constants_status__["d" ]});};_this.printTable=function(noTitle){var _this$state5=_this.state,image=_this$state5.image,name=_this$state5.name,peopleSelected=_this$state5.peopleSelected;var literals=_this.props.literals;var usersAround=[];if(peopleSelected.length){var left='';var top='';usersAround=peopleSelected.map(function(user,index){if(index===0){left='-1rem';top='2rem';}if(index===1){left='16rem';top='2rem';}if(index===2){top='13rem';left='-1rem';}if(index===3){left='16rem';top='13rem';}if(index===4){left='7rem';top='-2rem';}if(index===5){left='7rem';top='17rem';}if(index>5){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["A" ],{style:{left:left,top:top},key:user.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Avatar__["a" ],{avatar:user.avatar,size:40,firstname:user.name}));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["o" ],null,!noTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_invite'},literals.invitePeopleFromMyNetwork):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'circle_view'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["b" ],{img:image},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,name)),usersAround)));};_this.printSelectedOnCircle=function(){var peopleSelected=_this.state.peopleSelected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);};_this.printSelected=function(){var peopleSelected=_this.state.peopleSelected;var literals=_this.props.literals;var count=peopleSelected.length;if(count>0){var print=peopleSelected.map(function(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["B" ],{key:user.id,className:'user_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Avatar__["a" ],{key:user.id,id:user.id,avatar:user.avatar,firstname:user.name,size:52}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},''+user.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'user-data_id':user.id,onClick:_this.handleUnselectPeople},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12_assets_images_think_deleteIcon_svg___default.a,alt:''})));});var title=count+' '+literals.peopleSelected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["t" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},title),print);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);};_this.printInvitationsSent=function(){var _this$props5=_this.props,literals=_this$props5.literals,setCanDrag=_this$props5.setCanDrag,fromChats=_this$props5.fromChats;var msg='';if(fromChats){msg=literals.invitationsHasBeenSent2;}else{setCanDrag(true);msg=literals.invitationsHasBeenSent;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["i" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["q" ],null,msg));};_this.printSearcher=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Chats_components_FilterChat__["a" ],{doFilter:_this.filterUsers});};_this.handleCallChange=function(event){var call=parseInt(event.currentTarget.value,10);_this.setState({call:call});};_this.printCreatedIn=function(){var _this$props6=_this.props,literals=_this$props6.literals,narratives=_this$props6.narratives;var call=_this.state.call;var content=[];if(narratives.length>0){narratives.forEach(function(narrative){if(narrative.section.name==='Call for impact'){content.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:narrative.id,key:narrative.id},narrative.name));}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["g" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14_assets_images_icons_call_black_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:_this.handleCallChange,value:call},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0},literals.createdIn),content));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);};_this.printNoInvitationsSent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" ],{to:__WEBPACK_IMPORTED_MODULE_8_constants_urls__["P" ]});};_this.handleTag=function(tag){var tags=_this.state.tags;var newTags=[].concat(_toConsumableArray(tags));newTags.push(tag);_this.setState({tags:newTags});};_this.removeTag=function(event){var tags=_this.state.tags;var tagId=parseInt(event.currentTarget.getAttribute('data-id'),10);var index=tags.findIndex(function(tag){return tag.id===tagId;});if(index<0){return 0;}var newTags=[].concat(_toConsumableArray(tags));newTags.splice(index,1);_this.setState({tags:newTags});return 0;};_this.filterUsers=function(value){_this.setState({filter:value});};_this.printForm=function(){var _this$props7=_this.props,literals=_this$props7.literals,data=_this$props7.data;var _this$state6=_this.state,name=_this$state6.name,description=_this$state6.description,error=_this$state6.error,isNext=_this$state6.isNext,enableSwitch=_this$state6.enableSwitch,peopleSelected=_this$state6.peopleSelected,isLoading=_this$state6.isLoading;var color=_this.getColor();var darkerColor=color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!isNext&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["i" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_card_wrapper'},data.more_info&&data.more_info.icon_title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["j" ],{className:'title_card_icon',icon:data.more_info.icon_title})),_this.printImage(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'document_file',name:'document_file',style:{display:'none'},onChange:_this.handleFileUpload,accept:'image/png, image/jpeg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["m" ],{value:name,placeholder:literals.titleName,onChange:_this.handleChangeName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["l" ],{value:description,placeholder:literals.description,onChange:_this.handleChangeDescription}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["x" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_AutocompleteInput__["a" ],{canCreateNew:true,type:'tag',placeholder:literals.tags,selectedOptions:[],onSelectOption:_this.handleTag,onCreateOption:_this.handleTag})),_this.printTags(),_this.printCreatedIn(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["y" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.timeLife),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time_life'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'2','attr-time':'day',value:_this.state.day,onChange:_this.setTimeLife,placeholder:'00'}),' days : ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'2','attr-time':'hour',value:_this.state.hour,onChange:_this.setTimeLife,placeholder:'00'}),' hours : ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'2','attr-time':'minute',value:_this.state.minute,onChange:_this.setTimeLife,placeholder:'00'}),' min : ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'2','attr-time':'seconds',value:_this.state.seconds,onChange:_this.setTimeLife,placeholder:'00'}),' sec')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["u" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.privateTable),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13_assets_images_unlock_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Switch__["a" ],{checked:enableSwitch,size:'small',onChange:_this.handleChangeEnabled,name:'check_enabled',color:'primary'}),literals.onlyInvited)),_this.printRelated()),isNext&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["p" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table_view'},_this.printTable()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'people_selected'},_this.printSelected())),_this.printGridUsers()),peopleSelected.length===0&&!isLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["a" ],{type:'button',onClick:isNext?_this.submit:_this.continue,status:name,color:color||color.color,darkerColor:darkerColor},literals.next),peopleSelected.length===0&&isLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["a" ],{type:'button',status:name,color:color||color.color,darkerColor:darkerColor},literals.loading),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["h" ],null,error));};_this.printTags=function(){var tags=_this.state.tags;var tagList=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(tags,function(tag,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["w" ],{key:index,'data-id':tag.id,onClick:_this.removeTag},tag.name);});if(tags.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["v" ],null,tagList);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);};_this.printGoBack=function(){var literals=_this.props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["z" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_create'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15_assets_images_ArrowBack_svg___default.a,alt:'',onClick:_this.handleGoBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.createNewTable)));};_this.printInviteButton=function(){var literals=_this.props.literals;var _this$state7=_this.state,peopleSelected=_this$state7.peopleSelected,isLoading=_this$state7.isLoading;if(peopleSelected.length===0){return null;}if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["n" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary'},literals.loading));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["n" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:_this.submit},literals.invite));};_this.goToThink=function(){var history=_this.props.history;history.push(__WEBPACK_IMPORTED_MODULE_8_constants_urls__["P" ]);};_this.goToTable=function(){var table=_this.state.table;var history=_this.props.history;history.push('/theme-table/'+table.id);};_this.goToTableChat=function(){var table=_this.state.table;var history=_this.props.history;history.push('/theme-table/'+table.id+'/chat');};_this.printCongratulations=function(){var literals=_this.props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Modal__["a" ],{open:true,onClose:_this.goToThink,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',style:{zIndex:400}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["c" ],null,_this.printTable(true),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message_success'},literals.youHaveCreateTheTable),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn-sm',onClick:_this.goToTable},literals.addContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'welcome',onClick:_this.goToTableChat},literals.welcome))));};_this.state={name:'',description:'',image:'',uploadingImage:false,error:'',status:__WEBPACK_IMPORTED_MODULE_7_constants_status__["b" ],table:null,tags:[],isNext:false,isLoading:false,day:7,hour:0,minute:0,seconds:0,enableSwitch:false,filter:'',call:props.callId,// filter: '',
peopleSelected:[]// speedDate: new Date(),
// speedHour: 0,
// timeLife: 0,
};return _this;}// setSpeedDate = (event) => {
//   this.setState({ speedDate: event.currentTarget.value });
// }
// setSpeedHour = (event) => {
//   this.setState({ speedHour: parseInt(event.currentTarget.value, 10) });
// }
_createClass(CreationThinkSeed,[{key:'render',value:function render(){var _state=this.state,status=_state.status,isNext=_state.isNext;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,status===__WEBPACK_IMPORTED_MODULE_7_constants_status__["c" ]||status===__WEBPACK_IMPORTED_MODULE_7_constants_status__["e" ]||status===__WEBPACK_IMPORTED_MODULE_7_constants_status__["d" ]?this.printCongratulations():null,this.printGoBack(),this.printForm(),isNext&&this.printInviteButton());}}]);return CreationThinkSeed;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CreationThinkSeed.propTypes={literals:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,actualContext:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,setCanDrag:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fromChats:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,app:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,narratives:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,userConnections:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,getChats:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,joinThemeTable:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,callId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};CreationThinkSeed.defaultProps={fromChats:false,actualContext:null,callId:null}; __webpack_exports__["a"] = (CreationThinkSeed);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/unloadedImage.2faedefc.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/deleteIcon.e37568d4.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_black.a53ba61d.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ThinkSeedWrapper; });

 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 20px 0;\n'],['\n  padding: 20px 0;\n']),_templateObject2=_taggedTemplateLiteral(['\nheight: 45px;\ncolor: black;\nfont-size: 16px;\nfont-weight: bold;\ndisplay: flex;\nmargin-top: env(safe-area-inset-top);\nalign-items: center;\n\n.arrowback {\n  float: left;\n  height: 45px;\n  margin-left: 2rem;\n}\n\ndiv {\n float: left;\n width: 85%;\n height: 45px;\n padding: 15px 0px;\n\n @media (max-width: ','px){\n   width: 47vw;\n }\n}\n\n.search_lens {\n height: 45px;\n padding: 10px;\n @media (max-width: ','px){\n   margin-left: 11%;\n }\n}\n\n.infocircle {\n  float: right;\n  height: 45px;\n  padding: 10px;\n}\n'],['\nheight: 45px;\ncolor: black;\nfont-size: 16px;\nfont-weight: bold;\ndisplay: flex;\nmargin-top: env(safe-area-inset-top);\nalign-items: center;\n\n.arrowback {\n  float: left;\n  height: 45px;\n  margin-left: 2rem;\n}\n\ndiv {\n float: left;\n width: 85%;\n height: 45px;\n padding: 15px 0px;\n\n @media (max-width: ','px){\n   width: 47vw;\n }\n}\n\n.search_lens {\n height: 45px;\n padding: 10px;\n @media (max-width: ','px){\n   margin-left: 11%;\n }\n}\n\n.infocircle {\n  float: right;\n  height: 45px;\n  padding: 10px;\n}\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ThinkSeedWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var ThinkSeedHeader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1273);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_4_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_5__components_Invitations__ = __webpack_require__(1274);
function mapStateToProps(state){return{invitations:state.chats.invitations,literals:state.i18n.literals.invitations||{},app:state.app,user:state.session.user};}function mapDispatchToProps(dispatch){return{rejectInvitation:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_chats__["k" ],dispatch),acceptInvitation:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_chats__["a" ],dispatch),joinThemeTable:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_think_seeds_actions__["g" ],dispatch),getChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_chats__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components_Invitations__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_3_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_4_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_invitations_svg__ = __webpack_require__(1275);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_invitations_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_invitations_svg__);
 var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(483);
 var __WEBPACK_IMPORTED_MODULE_7__InvitationElement__ = __webpack_require__(1276);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Invitations=function(_Component){_inherits(Invitations,_Component);function Invitations(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Invitations);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Invitations.__proto__||Object.getPrototypeOf(Invitations)).call.apply(_ref,[this].concat(args))),_this),_this.backToMessages=function(){__WEBPACK_IMPORTED_MODULE_4_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_2_constants_urls__["P" ]);},_this.handleOnConfirm=function(invitation,thinkSeedId,callback){var _this$props=_this.props,acceptInvitation=_this$props.acceptInvitation,getChats=_this$props.getChats;Object(__WEBPACK_IMPORTED_MODULE_3_modules_think_seeds_actions__["h" ])(thinkSeedId).then(function(){acceptInvitation(invitation,thinkSeedId,callback);getChats();});},_this.handleOnReject=function(id,type,callback){var rejectInvitation=_this.props.rejectInvitation;if(type==='think_seed'){rejectInvitation(id,callback);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Invitations,[{key:'printInvitations',value:function printInvitations(){var _this2=this;var _props=this.props,invitations=_props.invitations,user=_props.user,literals=_props.literals,app=_props.app;if(!invitations||!invitations.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_invitations_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noInvitations));}return invitations.map(function(invitation){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InvitationElement__["a" ],{invitation:invitation,key:invitation.id,onConfirm:_this2.handleOnConfirm,onReject:_this2.handleOnReject,user:user,literals:literals,color:app.color1});});}},{key:'render',value:function render(){var _props2=this.props,app=_props2.app,literals=_props2.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["h" ],{color:app.color1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["g" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],{onClick:this.backToMessages},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-arrow-left'})),literals.invitations),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["f" ],null,this.printInvitations()));}}]);return Invitations;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Invitations.propTypes={app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,invitations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,rejectInvitation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,acceptInvitation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (Invitations);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no_invitations.c0606a88.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(93);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(252);
 var __WEBPACK_IMPORTED_MODULE_4_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(483);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import _ from 'lodash';
var InvitationElement=function(_Component){_inherits(InvitationElement,_Component);function InvitationElement(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InvitationElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InvitationElement.__proto__||Object.getPrototypeOf(InvitationElement)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false},_this.setIsLoading=function(){_this.setState({loading:true});},_this.setIsNoLoading=function(){_this.setState({loading:false});},_this.onAccept=function(){var _this$props=_this.props,invitation=_this$props.invitation,onConfirm=_this$props.onConfirm;_this.setIsLoading();onConfirm(invitation,invitation.think_seed.id,_this.setIsNoLoading);},_this.onReject=function(){var _this$props2=_this.props,invitation=_this$props2.invitation,onReject=_this$props2.onReject;_this.setIsLoading();onReject(invitation.id,invitation.think_seed?'think_seed':'chat',_this.setIsNoLoading);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InvitationElement,[{key:'render',value:function render(){var _props=this.props,invitation=_props.invitation,literals=_props.literals,color=_props.color;var loading=this.state.loading;var invitationName='';var invitationImage='';if(invitation.think_seed){invitationName=invitation.think_seed.name;invitationImage=invitation.think_seed.image;}else{invitationName=invitation.invited_by.firstname+' '+invitation.invited_by.lastname;invitationImage=invitation.invited_by.avatar;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["d" ],{'data-invitation':invitation.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Avatar__["a" ],{avatar:invitationImage,firstname:invitationName,size:60}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["e" ],null,invitationName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["c" ],null,!loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["b" ],{color:'#F63256',onClick:this.onReject},literals.reject),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["b" ],{color:'#2680EB',onClick:this.onAccept},literals.accept)),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__["a" ],{size:50,style:{color:color},className:'buttonProgress'})));}}]);return InvitationElement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InvitationElement.propTypes={invitation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,// user: PropTypes.object.isRequired,
onReject:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onConfirm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}; __webpack_exports__["a"] = (InvitationElement);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1278);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_5_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_6__modules_actions__ = __webpack_require__(484);
 var __WEBPACK_IMPORTED_MODULE_7__components_Upgrade__ = __webpack_require__(1279);
function mapStateToProps(state){return{literals:state.i18n.literals.upgrade,color:state.app.color1,thinkChats:state.thinkChats.myThinkChatsList,user:state.session.user};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__["b" ],dispatch),goHome:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_steps_actions__["e" ],dispatch),killThinkSeed:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6__modules_actions__["a" ],dispatch),launchThinkTank:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6__modules_actions__["b" ],dispatch),killSeed:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_chats__["h" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_7__components_Upgrade__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_4_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_5_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_thinkTankLogo_svg__ = __webpack_require__(1280);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_thinkTankLogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_images_thinkTankLogo_svg__);
 var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CircularProgress__ = __webpack_require__(252);
 var __WEBPACK_IMPORTED_MODULE_8_components_AddUsers__ = __webpack_require__(271);
 var __WEBPACK_IMPORTED_MODULE_9_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(1287);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Upgrade=function(_Component){_inherits(Upgrade,_Component);function Upgrade(props){_classCallCheck(this,Upgrade);var _this=_possibleConstructorReturn(this,(Upgrade.__proto__||Object.getPrototypeOf(Upgrade)).call(this,props));_this.handleBackToThink=function(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_5_constants_urls__["P" ]);};_this.handleSubmitForm=function(){var literals=_this.props.literals;var _this$state=_this.state,text=_this$state.text,description=_this$state.description,chatMembers=_this$state.chatMembers;if(text!==''&&description!==''&&chatMembers.length>0){_this.setState({section:'OPTIONS'});_this.setBreadcrumb3();}else{_this.setState({error:literals.errorFillAll});}};_this.goToForm=function(){_this.setState({section:'FORM'});_this.setBreadcrumb2();};_this.selectSection=function(){var section=_this.state.section;switch(section){case'INTRODUCTION':return _this.renderIntroduction();case'FORM':return _this.renderForm();case'CALENDLY':return _this.renderCalendly();case'OPTIONS':return _this.renderOptions();default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);}};_this.handleShowInviteForm=function(){_this.setState({showInviteUsers:true});};_this.handleChangeName=function(event){var value=event.target.value;_this.setState({text:value});};_this.handleChangeDescription=function(event){var value=event.target.value;_this.setState({description:value});};_this.clickUser=function(id){var chatMembers=_this.state.chatMembers;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chatMembers,function(member){return member===id;})){chatMembers.push(id);}else{__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(chatMembers,function(member){return member===id;});}_this.setState({chatMembers:chatMembers});};_this.inviteUsers=function(users){var _this$state2=_this.state,chat=_this$state2.chat,chatMembers=_this$state2.chatMembers;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(users,function(user){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chat.users,{id:user.id})){chat.users.push(user);}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chatMembers,function(member){return member===user.id;})){chatMembers.push(user.id);}});_this.setState({chatMembers:chatMembers,chat:chat,showInviteUsers:false});};_this.killSeed=function(){var _this$props=_this.props,killThinkSeed=_this$props.killThinkSeed,user=_this$props.user;var chat=_this.state.chat;if(chat.element_related&&chat.element_related.creator&&chat.element_related.creator.id===user.id){_this.setState({loading:true},function(){return killThinkSeed(chat.element_related.id).then(function(){return _this.afterKillSeed();});});}};_this.afterKillSeed=function(){_this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push('/think');};_this.launchSeed=function(){var launchThinkTank=_this.props.launchThinkTank;var _this$state3=_this.state,chat=_this$state3.chat,text=_this$state3.text,description=_this$state3.description,socialNetworkMovement=_this$state3.socialNetworkMovement,blog=_this$state3.blog,project=_this$state3.project,openInnovation=_this$state3.openInnovation,chatMembers=_this$state3.chatMembers;var members='';chatMembers.forEach(function(user,index){if(index<chat.users.length-1){members+=user+',';}else{members+=user;}});var params={id:chat.element_related.id,name:text,description:description,members:members,socialNetworkMovement:socialNetworkMovement?1:0,blog:blog?1:0,project:project?1:0,openInnovation:openInnovation?1:0};_this.setState({loading:true},function(){return launchThinkTank(params).then(function(){return _this.setState({loading:false,section:'CALENDLY'});}).catch(function(){return _this.setState({loading:false,section:'OPTIONS',error:'Error'});});});};_this.state={backgroundColor:Object(__WEBPACK_IMPORTED_MODULE_4_utils_colors__["i" ])(),section:'INTRODUCTION',text:'',description:'',chat:{},socialNetworkMovement:false,blog:false,project:false,openInnovation:false,loading:false,chatMembers:[props.user.id],error:'',hideSocialNetworkMovement:true,hideBlog:true,hideProject:true,hideOpenInnovation:true,showInviteUsers:false};return _this;}_createClass(Upgrade,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,thinkChats=_props.thinkChats,match=_props.match;if(thinkChats){var chatFound=thinkChats.find(function(chat){return chat.id===parseInt(match.params.id,10);});if(chatFound){this.setState({chat:chatFound});}}this.setBreadcrumb1();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _props2=this.props,thinkChats=_props2.thinkChats,match=_props2.match;if(thinkChats&&prevProps.thinkChats!==thinkChats){var chatFound=thinkChats.find(function(chat){return chat.id===parseInt(match.params.id,10);});if(chatFound){var aux=[];chatFound.users.forEach(function(user){aux.push(user.id);});this.setState({chat:chatFound,chatMembers:aux});}}}},{key:'setBreadcrumb1',value:function setBreadcrumb1(){var _props3=this.props,literals=_props3.literals,setBreadcrumb=_props3.setBreadcrumb;var breadcrumb=[{color:'#ffffff',text:literals.think,onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_5_constants_urls__["P" ]);}},{color:'#ffffff',text:literals.launchThinkTank}];setBreadcrumb(breadcrumb.slice());}},{key:'setBreadcrumb2',value:function setBreadcrumb2(){var _this2=this;var _props4=this.props,literals=_props4.literals,setBreadcrumb=_props4.setBreadcrumb;var breadcrumb=[{color:'#ffffff',text:literals.think,onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_5_constants_urls__["P" ]);}},{color:'#ffffff',text:literals.launch,onClick:function onClick(){_this2.setState({section:'INTRODUCTION'});_this2.setBreadcrumb1();}},{color:'#ffffff',text:literals.info}];setBreadcrumb(breadcrumb.slice());}},{key:'setBreadcrumb3',value:function setBreadcrumb3(){var _this3=this;var _props5=this.props,literals=_props5.literals,setBreadcrumb=_props5.setBreadcrumb;var breadcrumb=[{text:literals.think,onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_3_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_5_constants_urls__["P" ]);}},{text:literals.launch,onClick:function onClick(){_this3.setState({section:'INTRODUCTION'});_this3.setBreadcrumb1();}},{text:literals.info,onClick:function onClick(){_this3.goToForm();}},{text:literals.options}];setBreadcrumb(breadcrumb.slice());}},{key:'renderMembers',value:function renderMembers(){var _this4=this;var _state=this.state,chat=_state.chat,chatMembers=_state.chatMembers;var actualUser=this.props.user;if(chat){var chatFound=chat;if(chatFound&&chatFound.users){var users=chatFound.users.filter(function(user){return user.id!==actualUser.id;});return users.map(function(_ref){var id=_ref.id,firstname=_ref.firstname,avatar=_ref.avatar;var selected=!!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chatMembers,function(member){return member===id;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Avatar__["a" ],{size:72,firstname:firstname,id:id,avatar:avatar,onClick:_this4.clickUser,selected:selected});});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);}},{key:'renderIntroduction',value:function renderIntroduction(){var _props6=this.props,literals=_props6.literals,user=_props6.user;var _state2=this.state,loading=_state2.loading,chat=_state2.chat;var creator=chat&&chat.element_related&&chat.element_related.creator.id===user.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["u" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["o" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["i" ],null,literals.titleThinkTank),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["i" ],null,literals.descriptionThinkTank),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["k" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_assets_images_thinkTankLogo_svg___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" ],{type:'reject',disabled:!creator,onClick:this.killSeed},loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CircularProgress__["a" ],{size:40,style:{color:'black'},className:'buttonProgress'}),!loading&&literals.killThinkSeed),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" ],{backgroundColor:'green',type:'accept',onClick:this.goToForm},literals.launchThinkTank))));}},{key:'renderForm',value:function renderForm(){var _this5=this;var literals=this.props.literals;var _state3=this.state,backgroundColor=_state3.backgroundColor,text=_state3.text,description=_state3.description,error=_state3.error,showInviteUsers=_state3.showInviteUsers,chatMembers=_state3.chatMembers;if(showInviteUsers){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_AddUsers__["a" ],{onInvite:this.inviteUsers,quitView:function quitView(){return _this5.setState({showInviteUsers:false});}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["u" ],{backgroundColor:backgroundColor.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["o" ],{backgroundColor:backgroundColor.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["t" ],null,literals.titleForm1,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),literals.titleForm2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["n" ],{error:error!==''&&text===''},literals.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["m" ],{error:error!==''&&text===''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:text,onChange:this.handleChangeName}),error!==''&&text===''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{color:backgroundColor.contrastColor},className:'fas fa-exclamation-triangle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["n" ],null,literals.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["l" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'Text1',cols:'40',rows:'5',value:description,onChange:this.handleChangeDescription}),error!==''&&description===''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{color:backgroundColor.contrastColor},className:'fas fa-exclamation-triangle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["p" ],null,literals.members),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["q" ],null,this.renderMembers(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["a" ],{onClick:this.handleShowInviteForm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-plus fa-3x'})),error!==''&&chatMembers.length<1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{color:backgroundColor.contrastColor},className:'fas fa-exclamation-triangle'})),error!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["j" ],null,error!==''&&error),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" ],{type:'next',onClick:this.handleSubmitForm,color:backgroundColor.color},literals.next))));}},{key:'renderCalendly',value:function renderCalendly(){var literals=this.props.literals;var backgroundColor=this.state.backgroundColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["u" ],{backgroundColor:backgroundColor.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["o" ],{type:'calendly',backgroundColor:backgroundColor.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["e" ],null,literals.calendlyTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-align-center mt20 mb20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:this.handleBackToThink},literals.backToThink)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'hello',src:'https://calendly.com/crowdcentaurs_medioslocales/think-tanks-for-impact?text_color=173630&primary_color=48b19c'})));}},{key:'renderOptions',value:function renderOptions(){var _this6=this;var literals=this.props.literals;var _state4=this.state,backgroundColor=_state4.backgroundColor,socialNetworkMovement=_state4.socialNetworkMovement,blog=_state4.blog,project=_state4.project,openInnovation=_state4.openInnovation,loading=_state4.loading,error=_state4.error,hideBlog=_state4.hideBlog,hideOpenInnovation=_state4.hideOpenInnovation,hideProject=_state4.hideProject,hideSocialNetworkMovement=_state4.hideSocialNetworkMovement;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["u" ],{backgroundColor:backgroundColor.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["o" ],{backgroundColor:backgroundColor.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["r" ],null,literals.optionsTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["g" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',value:socialNetworkMovement,checked:socialNetworkMovement,onChange:function onChange(){return _this6.setState({socialNetworkMovement:!socialNetworkMovement});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["h" ],{type:'title'},literals.socialNetworkMovement,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["s" ],{onClick:function onClick(){return _this6.setState({hideSocialNetworkMovement:!hideSocialNetworkMovement});}},hideSocialNetworkMovement?literals.seeMore:literals.seeLess),!hideSocialNetworkMovement&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["h" ],{hide:hideSocialNetworkMovement},literals.socialNetworkMovement2,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),literals.socialNetworkMovement3,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.playgroundmag.net/movements/drought-proof-society',target:'_blank',rel:'noopener noreferrer'},'See example here'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["g" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',value:blog,checked:blog,onChange:function onChange(){return _this6.setState({blog:!blog});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["h" ],{type:'title'},literals.blog,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["s" ],{onClick:function onClick(){return _this6.setState({hideBlog:!hideBlog});}},hideBlog?literals.seeMore:literals.seeLess),!hideBlog&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["h" ],null,literals.blog2,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),literals.blog3,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.capitalradio.es/',target:'_blank',rel:'noopener noreferrer'},'See example here'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["g" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',value:project,checked:project,onChange:function onChange(){return _this6.setState({project:!project});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["h" ],{type:'title'},literals.project,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["s" ],{onClick:function onClick(){return _this6.setState({hideProject:!hideProject});}},hideProject?literals.seeMore:literals.seeLess),!hideProject&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["h" ],null,literals.project2,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://myopia.app/',target:'_blank',rel:'noopener noreferrer'},'https://myopia.app/'),literals.project3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["g" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',value:openInnovation,checked:openInnovation,onChange:function onChange(){return _this6.setState({openInnovation:!openInnovation});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["h" ],{type:'title'},literals.openInnovation,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["s" ],{onClick:function onClick(){return _this6.setState({hideOpenInnovation:!hideOpenInnovation});}},hideOpenInnovation?literals.seeMore:literals.seeLess),!hideOpenInnovation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["h" ],null,literals.openInnovation2,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://socialab.com/',target:'_blank',rel:'noopener noreferrer'},'See example here')))),!loading&&error!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["j" ],null,error),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" ],{type:'next',color:backgroundColor.color,onClick:this.launchSeed},loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CircularProgress__["a" ],{size:40,style:{color:'black'},className:'buttonProgress'}),!loading&&literals.next))));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.selectSection());}}]);return Upgrade;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Upgrade.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,thinkChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,launchThinkTank:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};Upgrade.defaultProps={thinkChats:[]}; __webpack_exports__["a"] = (Upgrade);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/thinkTankLogo.4b769da4.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1282);
function mapStateToProps(state){return{literals:state.i18n.literals.addUsersChat,connections:state.userConnections.connections};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_utils_string__ = __webpack_require__(67);
 var __WEBPACK_IMPORTED_MODULE_4_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_icons_search_solid_svg__ = __webpack_require__(1283);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_icons_search_solid_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_icons_search_solid_svg__);
 var __WEBPACK_IMPORTED_MODULE_6_components_Steps_Faces__ = __webpack_require__(95);
 var __WEBPACK_IMPORTED_MODULE_7_components_FeedbackModal__ = __webpack_require__(78);
 var __WEBPACK_IMPORTED_MODULE_8_components_Cards_UserSmallCard__ = __webpack_require__(1284);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_speed_dating_no_results_svg__ = __webpack_require__(485);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_speed_dating_no_results_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_images_speed_dating_no_results_svg__);
 var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(1286);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddUsers=function(_Component){_inherits(AddUsers,_Component);function AddUsers(props){_classCallCheck(this,AddUsers);var _this=_possibleConstructorReturn(this,(AddUsers.__proto__||Object.getPrototypeOf(AddUsers)).call(this,props));_this.handleInvite=function(){var _this$props=_this.props,isLoading=_this$props.isLoading,popUp=_this$props.popUp,onInvite=_this$props.onInvite,onCancel=_this$props.onCancel;var selectedUsers=_this.state.selectedUsers;if(!isLoading&&popUp){_this.setState({showPopupInvited:true},_this.handleModalInvite);}if(!popUp){onInvite(selectedUsers);onCancel();}};_this.handleModalInvite=function(){var onInvite=_this.props.onInvite;var selectedUsers=_this.state.selectedUsers;onInvite(selectedUsers);};_this.handleCloseModalInviteFeedback=function(){var onCancel=_this.props.onCancel;_this.setState({showPopupInvited:false});onCancel();};_this.handleSearchChange=function(event){var value=event.target.value;_this.setState({search:value});};_this.handleSelectFace=function(userId){var selectedUsers=_this.state.selectedUsers;var connections=_this.props.connections;var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(connections,{id:userId});if(user){selectedUsers.push(user);_this.setState({selectedUsers:selectedUsers});}};_this.handleUnselectFace=function(event){var userId=parseInt(event.currentTarget.getAttribute('data-user'),10);var selectedUsers=_this.state.selectedUsers;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(selectedUsers,{id:userId});_this.setState({selectedUsers:selectedUsers});};_this.doNothing=function(){};_this.printSearchResults=function(){var _this$props2=_this.props,connections=_this$props2.connections,excludedUsers=_this$props2.excludedUsers,literals=_this$props2.literals;var search=_this.state.search;var searchValue=Object(__WEBPACK_IMPORTED_MODULE_3_utils_string__["d" ])(search.toLowerCase());var searchResults=connections.filter(function(user){if(excludedUsers.includes(user.id)){return false;}if(!searchValue){return true;}var userName=Object(__WEBPACK_IMPORTED_MODULE_3_utils_string__["d" ])((user.firstname+' '+user.lastname).toLowerCase());if(userName.indexOf(searchValue)!==-1){return true;}return false;});if(!searchResults.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_9_assets_images_speed_dating_no_results_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noUsers));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Steps_Faces__["a" ],{onSelect:_this.handleSelectFace,onUnselect:_this.doNothing,options:searchResults,onLongPress:_this.doNothing,select:true});};_this.printSelectedUsers=function(){var selectedUsers=_this.state.selectedUsers;var literals=_this.props.literals;if(!selectedUsers.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected_users_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},selectedUsers.length),literals.selected),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_SimpleCarousel__["a" ],{classesList:'user_wrapper',showButtons:true},selectedUsers.map(function(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Cards_UserSmallCard__["a" ],{key:user.id,user:user,showDeleteButton:true,onDelete:_this.handleUnselectFace});})));};_this.state={search:'',selectedUsers:[],showPopupInvited:false};return _this;}_createClass(AddUsers,[{key:'render',value:function render(){var _props=this.props,literals=_props.literals,onCancel=_props.onCancel,isLoading=_props.isLoading;var _state=this.state,search=_state.search,showPopupInvited=_state.showPopupInvited;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_FeedbackModal__["a" ],{open:showPopupInvited,success:true,onClose:this.handleCloseModalInviteFeedback,text:'Invitation send'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["c" ],{value:search,placeholder:literals.searchUsers,inputProps:{'aria-label':literals.searchUsers},onChange:this.handleSearchChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_assets_images_icons_search_solid_svg___default.a,onClick:this.searchUsers,alt:'search'})),this.printSearchResults(),this.printSelectedUsers(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:this.handleInvite},isLoading?literals.sending:literals.invite),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'cancel',onClick:onCancel},literals.cancel)));}}]);return AddUsers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddUsers.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onInvite:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,excludedUsers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,connections:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};AddUsers.defaultProps={connections:[],excludedUsers:[]}; __webpack_exports__["a"] = (AddUsers);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/search-solid.c6a0effb.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1285);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(134);
function mapStateToProps(state){return{actualUser:state.session.user};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return AddUsersWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return Searcher; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return SearcherInput; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_InputBase__ = __webpack_require__(113);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 20px 0;\n  margin: 0 auto;\n  text-align: center;\n\n  .face_bubble_text {\n    color: ',';\n  }\n\n  .faces_wrapper {\n    text-align: center;\n    display: block;\n  }\n\n  .selected_users_wrapper {\n    width: calc(100% - 18rem);\n    margin: 0 auto;\n    text-align: left;\n\n    @media (max-width: ','px) {\n      width: 100%;\n    }\n  }\n'],['\n  padding: 20px 0;\n  margin: 0 auto;\n  text-align: center;\n\n  .face_bubble_text {\n    color: ',';\n  }\n\n  .faces_wrapper {\n    text-align: center;\n    display: block;\n  }\n\n  .selected_users_wrapper {\n    width: calc(100% - 18rem);\n    margin: 0 auto;\n    text-align: left;\n\n    @media (max-width: ','px) {\n      width: 100%;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 0px 10px;\n  margin-bottom: 20px;\n  height: 40px;\n  border: 0.1rem solid #e9e9e9;\n\n  img {\n    width: 16px;\n  }\n'],['\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 0px 10px;\n  margin-bottom: 20px;\n  height: 40px;\n  border: 0.1rem solid #e9e9e9;\n\n  img {\n    width: 16px;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  && {\n    flex: 1;\n\n    input {\n      color: #4d4d4d;\n      font-family: \'helvetica neue light\';\n      font-size: 14px;\n      height: 30px;\n    }\n  }\n'],['\n  && {\n    flex: 1;\n\n    input {\n      color: #4d4d4d;\n      font-family: \'helvetica neue light\';\n      font-size: 14px;\n      height: 30px;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AddUsersWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var Searcher=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var SearcherInput=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_InputBase__["a" ])(_templateObject3);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "u", function() { return UpgradeWrapper; });

 __webpack_require__.d(__webpack_exports__, "o", function() { return MainWrapper; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return Description; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ButtonsWrapper; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonNextWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return Button; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return Image; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return Title2; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return InputTitle; });

 __webpack_require__.d(__webpack_exports__, "p", function() { return MembersTitle; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return InputText; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return InputDescription; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return MembersWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AddUsers; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return CalendTitle; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return OptionsTitle; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return CheckWrapper; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return Checkbox; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return CheckboxText; });




 __webpack_require__.d(__webpack_exports__, "j", function() { return ErrorMessage; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return SeeMore; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
var _templateObject=_taggedTemplateLiteral(['\n  padding-top: 20px;\n'],['\n  padding-top: 20px;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 5%;\n    left: 5%;\n    font-family: \'helvetica\';\n    font-size: 20px;\n    color: ',';\n'],['\n    position: absolute;\n    top: 5%;\n    left: 5%;\n    font-family: \'helvetica\';\n    font-size: 20px;\n    color: ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n    background-color: ',';\n    height:',';\n    border-radius: 10px;\n    width: 90%\n    max-width: ',';\n    margin: 0 auto;\n    padding: 20px 0px 10px;\n    \n    iframe {\n      position: relative;\n      height: 650px;\n      width: 100%;\n    }\n    \n'],['\n    background-color: ',';\n    height:',';\n    border-radius: 10px;\n    width: 90%\n    max-width: ',';\n    margin: 0 auto;\n    padding: 20px 0px 10px;\n    \n    iframe {\n      position: relative;\n      height: 650px;\n      width: 100%;\n    }\n    \n']),_templateObject4=_taggedTemplateLiteral(['\n    width: 90%;\n    margin: 30px 5%;    \n    font-family: \'helvetica\';\n    font-size: 16px;\n'],['\n    width: 90%;\n    margin: 30px 5%;    \n    font-family: \'helvetica\';\n    font-size: 16px;\n']),_templateObject5=_taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    height: 60px;\n    margin: 20px auto;\n'],['\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    height: 60px;\n    margin: 20px auto;\n']),_templateObject6=_taggedTemplateLiteral(['    \n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    height: 60px;\n    margin: 20px auto;\n'],['    \n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    height: 60px;\n    margin: 20px auto;\n']),_templateObject7=_taggedTemplateLiteral(['\n    display: flex;\n    cursor: pointer;\n    justify-content: center;\n    align-items: center;\n    width: 40%;\n    border-radius: 5px;\n    background-color: ',';\n    height: 100%;\n    color: ',';\n    text-align: center;\n    padding: 5%;\n    font-size: 13px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    overflow-wrap: break-word; \n    vertical-align: center;\n    opacity: ',';\n'],['\n    display: flex;\n    cursor: pointer;\n    justify-content: center;\n    align-items: center;\n    width: 40%;\n    border-radius: 5px;\n    background-color: ',';\n    height: 100%;\n    color: ',';\n    text-align: center;\n    padding: 5%;\n    font-size: 13px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    overflow-wrap: break-word; \n    vertical-align: center;\n    opacity: ',';\n']),_templateObject8=_taggedTemplateLiteral(['\n    width: 90%;\n    left: 5%;\n    top: 10%;\n    right: 5%;\n    height: 30%;\n    margin-bottom: 10px;\n    position: relative;\n\n    img {\n        height: 100%;\n        width: 100%;\n    }\n'],['\n    width: 90%;\n    left: 5%;\n    top: 10%;\n    right: 5%;\n    height: 30%;\n    margin-bottom: 10px;\n    position: relative;\n\n    img {\n        height: 100%;\n        width: 100%;\n    }\n']),_templateObject9=_taggedTemplateLiteral(['\n    position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 10%;\n    font-size: 16px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    color: #fff;\n    margin-top: 10px;\n'],['\n    position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 10%;\n    font-size: 16px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    color: #fff;\n    margin-top: 10px;\n']),_templateObject10=_taggedTemplateLiteral(['\n    position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 20px;\n    font-size: 16px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    color: #fff;\n    margin-top: 3%;\n'],['\n    position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 20px;\n    font-size: 16px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    color: #fff;\n    margin-top: 3%;\n']),_templateObject11=_taggedTemplateLiteral(['\n    position: relative;\n    left: 5%;\n    font-size: 10px;\n    color: #d32f2f;\n'],['\n    position: relative;\n    left: 5%;\n    font-size: 10px;\n    color: #d32f2f;\n']),_templateObject12=_taggedTemplateLiteral(['\n    position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 20px;\n    font-size: 16px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    color: #fff;\n    margin-top: 15px;\n'],['\n    position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 20px;\n    font-size: 16px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    color: #fff;\n    margin-top: 15px;\n']),_templateObject13=_taggedTemplateLiteral(['\n    display: flex;\n    position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    margin-bottom: 10px;\n    input {\n      border: 0;\n      outline: 0;\n      background: transparent;\n      border-bottom: 3px solid #fff;\n      color: white;\n      width: 100%;\n      height: 50%;\n      font-size: 18px;\n    }\n    i {\n      margin-left: 5px;\n      font-size: 18px;\n    }\n'],['\n    display: flex;\n    position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    margin-bottom: 10px;\n    input {\n      border: 0;\n      outline: 0;\n      background: transparent;\n      border-bottom: 3px solid #fff;\n      color: white;\n      width: 100%;\n      height: 50%;\n      font-size: 18px;\n    }\n    i {\n      margin-left: 5px;\n      font-size: 18px;\n    }\n']),_templateObject14=_taggedTemplateLiteral(['\n    display: flex;\n    position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 15%;\n    textarea {\n      margin-top: 5px;\n      width: 100%;\n      font-size: 15px;\n    }\n    i {\n      margin-left: 5px;\n      font-size: 18px;\n    }\n'],['\n    display: flex;\n    position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 15%;\n    textarea {\n      margin-top: 5px;\n      width: 100%;\n      font-size: 15px;\n    }\n    i {\n      margin-left: 5px;\n      font-size: 18px;\n    }\n']),_templateObject15=_taggedTemplateLiteral(['\n  padding: 20px 5%;\n\n  .avatar_bubble {\n    margin: 10px 15px 0 0;\n    opacity: 0.5;\n\n    &.selected {\n      opacity: 1;\n    }\n  }\n'],['\n  padding: 20px 5%;\n\n  .avatar_bubble {\n    margin: 10px 15px 0 0;\n    opacity: 0.5;\n\n    &.selected {\n      opacity: 1;\n    }\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  border: 2px dashed #fff;\n  border-radius: 50%;\n  width: 72px;\n  height: 72px;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  padding-top: 9px;\n  margin: 10px 0px 0 0;\n\n  i {\n    color: white;\n   }\n'],['\n  border: 2px dashed #fff;\n  border-radius: 50%;\n  width: 72px;\n  height: 72px;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  padding-top: 9px;\n  margin: 10px 0px 0 0;\n\n  i {\n    color: white;\n   }\n']),_templateObject17=_taggedTemplateLiteral(['\n   position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 10%;\n    font-size: 16px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    color: #fff;\n    margin-top: 10px;\n    margin-bottom: 20px;\n'],['\n   position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 10%;\n    font-size: 16px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    color: #fff;\n    margin-top: 10px;\n    margin-bottom: 20px;\n']),_templateObject18=_taggedTemplateLiteral(['\n   position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 10%;\n    font-size: 16px;\n    font-family: \'helvetica\';\n    color: #fff;\n    margin-top: 10px;\n    margin-bottom: 30px;\n'],['\n   position: relative;\n    left: 5%;\n    right: 5%;\n    width: 90%;\n    height: 10%;\n    font-size: 16px;\n    font-family: \'helvetica\';\n    color: #fff;\n    margin-top: 10px;\n    margin-bottom: 30px;\n']),_templateObject19=_taggedTemplateLiteral(['\n  padding: 0 20px;\n'],['\n  padding: 0 20px;\n']),_templateObject20=_taggedTemplateLiteral(['\n  width: 100%;\n  input {\n    position: relative;\n    top: 17px;\n  }\n  margin-bottom: 20px;\n'],['\n  width: 100%;\n  input {\n    position: relative;\n    top: 17px;\n  }\n  margin-bottom: 20px;\n']),_templateObject21=_taggedTemplateLiteral(['\n  position: relative;\n  width: 90%;\n  left: 5%;\n  right: 5%;\n  font-size: 16px;\n  font-family: \'helvetica\';\n  font-weight: ',';\n  color: #fff;\n  a {\n    text-decoration: underline;\n    color: #fff;\n    cursor: pointer;\n  }\n'],['\n  position: relative;\n  width: 90%;\n  left: 5%;\n  right: 5%;\n  font-size: 16px;\n  font-family: \'helvetica\';\n  font-weight: ',';\n  color: #fff;\n  a {\n    text-decoration: underline;\n    color: #fff;\n    cursor: pointer;\n  }\n']),_templateObject22=_taggedTemplateLiteral(['\n    display:flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 5px;\n    position: relative;\n    bottom: 3%;\n    width: 35%;\n    left: 33%;\n    right: 25%;\n    background-color: #fff;\n    height: 7%;\n    color: ',';\n    text-align: center;\n    font-size: 16px;\n    line-height: 37px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    overflow-wrap: break-word; \n    vertical-align: center;\n'],['\n    display:flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 5px;\n    position: relative;\n    bottom: 3%;\n    width: 35%;\n    left: 33%;\n    right: 25%;\n    background-color: #fff;\n    height: 7%;\n    color: ',';\n    text-align: center;\n    font-size: 16px;\n    line-height: 37px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    overflow-wrap: break-word; \n    vertical-align: center;\n']),_templateObject23=_taggedTemplateLiteral(['\n  position: relative;\n  top: 2%;\n  left: 5%;\n  vertical-align: middle;\n\n  i {\n    color: #fff;\n    cursor: pointer;\n    font-size: 16px;\n  }\n'],['\n  position: relative;\n  top: 2%;\n  left: 5%;\n  vertical-align: middle;\n\n  i {\n    color: #fff;\n    cursor: pointer;\n    font-size: 16px;\n  }\n']),_templateObject24=_taggedTemplateLiteral(['\n  width: 20%;\n  height: 100%;\n  background-image: url(',');\n  background-size: contain;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  border-radius: 50%;\n  display: inline-block;\n  margin: 5px;\n  background-color: #f0f0f0;\n  cursor: pointer;\n  opacity: ',';\n'],['\n  width: 20%;\n  height: 100%;\n  background-image: url(',');\n  background-size: contain;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  border-radius: 50%;\n  display: inline-block;\n  margin: 5px;\n  background-color: #f0f0f0;\n  cursor: pointer;\n  opacity: ',';\n']),_templateObject25=_taggedTemplateLiteral(['\n  && {\n    width: 20%;\n    height: 100%;\n    background-color: #999;\n    font-size: 30px;\n    margin: 20px auto;\n    text-transform: uppercase;\n    display: inline-block;\n    margin: 5px;\n    cursor: pointer;\n    padding: 8px;\n    text-align: center;\n    opacity: ',';\n  }\n'],['\n  && {\n    width: 20%;\n    height: 100%;\n    background-color: #999;\n    font-size: 30px;\n    margin: 20px auto;\n    text-transform: uppercase;\n    display: inline-block;\n    margin: 5px;\n    cursor: pointer;\n    padding: 8px;\n    text-align: center;\n    opacity: ',';\n  }\n']),_templateObject26=_taggedTemplateLiteral(['\n    border: 2px solid #fff;\n    padding: 5px;\n    color: white;\n    font-size: 15px;\n    width: 35%;\n    left: 33%;\n    right: 25%;\n    text-align: center;\n    position: relative;\n    font-weight: 600;\n    top: -16px;\n    background-color: red;\n'],['\n    border: 2px solid #fff;\n    padding: 5px;\n    color: white;\n    font-size: 15px;\n    width: 35%;\n    left: 33%;\n    right: 25%;\n    text-align: center;\n    position: relative;\n    font-weight: 600;\n    top: -16px;\n    background-color: red;\n']),_templateObject27=_taggedTemplateLiteral(['\n  position: relative;\n  width: 90%;\n  left: 5%;\n  right: 5%;\n  font-size: 16px;\n  font-family: \'helvetica\';\n  font-weight: 600;\n  text-decoration: underline;\n  color: #fff;\n'],['\n  position: relative;\n  width: 90%;\n  left: 5%;\n  right: 5%;\n  font-size: 16px;\n  font-family: \'helvetica\';\n  font-weight: 600;\n  text-decoration: underline;\n  color: #fff;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UpgradeWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var MainTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.color;});var MainWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,function(props){return props.backgroundColor||'#fff';},function(props){return props.type==='calendly'?'91%':'80%';},function(props){return props.type==='calendly'?'90%':'600px';});var Description=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var ButtonsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var ButtonNextWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var Button=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7,function(props){return props.type==='reject'?'red':props.backgroundColor||'#fff';},function(props){return props.type==='reject'?'#fff':props.backgroundColor?'#fff':props.color;},function(props){return props.disabled?'0.6':'none';});var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);var Title2=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);var InputTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10);var ErrorText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11);var MembersTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12);var InputText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13);var InputDescription=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject14);var MembersWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject15);var AddUsers=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16);var CalendTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17);var OptionsTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18);var CheckWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject19);var Checkbox=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject20);var CheckboxText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject21,function(props){return props.type==='title'?'600':'100';});var ButtonNext=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject22,function(props){return props.color;});var BackArrow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject23);var AvatarUser=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject24,function(props){return props.src;},function(props){return props.selected<0&&'0.3';});var AvatarUserText=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject25,function(props){return props.selected<0&&'0.3';});var ErrorMessage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject26);var SeeMore=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject27);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1289);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_5_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_6_components_ThinkTanks_modules_actions__ = __webpack_require__(76);
 var __WEBPACK_IMPORTED_MODULE_7_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_8_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_9__components__ = __webpack_require__(1290);
function mapStateToProps(state){return{app:state.app,chats:state.chats,user:state.session.user,literals:state.i18n.literals.think||{},myThinkChatsList:state.thinkChats.myThinkChatsList,myThinkChatsStatus:state.thinkChats.myThinkChatsStatus,requestsJoinThinkTank:state.thinkTanks.requestsJoinThinkTank,myThinkTanksList:state.thinkTanks.myThinkTanksList,myThinkTanksStatus:state.thinkTanks.myThinkTanksStatus,myAdditionalThinks:state.thinkTanks.myAdditionalThinks,myAdditionalThinksStatus:state.thinkTanks.myAdditionalThinksStatus,invitationsList:state.chats.invitations};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__["b" ],dispatch),resetContext:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["e" ],dispatch),getMyThinkChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_think_seeds_actions__["b" ],dispatch),getMyThinkTanks:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_components_ThinkTanks_modules_actions__["g" ],dispatch),getInvitations:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7_modules_chats__["f" ],dispatch),setSectionSelected:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["g" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_8_modules_steps_actions__["f" ],dispatch),fetchUserChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7_modules_chats__["e" ],dispatch),getAdditionalThinks:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_components_ThinkTanks_modules_actions__["d" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_9__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_4_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg__ = __webpack_require__(91);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg__);
 var __WEBPACK_IMPORTED_MODULE_6_components_Cards_ThemeTableCard__ = __webpack_require__(117);
 var __WEBPACK_IMPORTED_MODULE_7_components_Cards_InvitationCard__ = __webpack_require__(1291);
 var __WEBPACK_IMPORTED_MODULE_8_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_9_components_Countdown__ = __webpack_require__(69);
 var __WEBPACK_IMPORTED_MODULE_10_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_11_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_12_constants_layout__ = __webpack_require__(437);
 var __WEBPACK_IMPORTED_MODULE_13_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_14_constants_tables__ = __webpack_require__(110);
 var __WEBPACK_IMPORTED_MODULE_15__styles__ = __webpack_require__(1296);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function Think(props){var setBreadcrumbF=function setBreadcrumbF(){var literals=props.literals,setBreadcrumb=props.setBreadcrumb,resetContext=props.resetContext;var breadcrumb=[{color:'#ffffff',text:literals.title}];setBreadcrumb(breadcrumb.slice());resetContext();};var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),invitations=_useState2[0],setInvitations=_useState2[1];var invitationsList=props.invitationsList;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setInvitations(invitationsList);},[invitationsList]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var getInvitations=props.getInvitations,setSectionSelected=props.setSectionSelected,resetAll=props.resetAll,getAdditionalThinks=props.getAdditionalThinks;getAdditionalThinks();getInvitations();resetAll();setBreadcrumbF();setSectionSelected(__WEBPACK_IMPORTED_MODULE_12_constants_layout__["i" ]);},[]);var handleClickTable=function handleClickTable(event){var history=props.history;var id=parseInt(event.currentTarget.getAttribute('data-id'),10);history.push('theme-table/'+id);};var handleGoToInvitations=function handleGoToInvitations(){var history=props.history;history.push(__WEBPACK_IMPORTED_MODULE_3_constants_urls__["v" ]);};var joinToTable=function joinToTable(id){var history=props.history;Object(__WEBPACK_IMPORTED_MODULE_11_modules_think_seeds_actions__["e" ])(id).then(function(response){Object(__WEBPACK_IMPORTED_MODULE_11_modules_think_seeds_actions__["g" ])(response).then(function(){history.push('theme-table/'+id);});});};var doNothing=function doNothing(){};var createTable=function createTable(){var history=props.history;history.push(__WEBPACK_IMPORTED_MODULE_3_constants_urls__["Q" ]);};var printMyTables=function printMyTables(){var literals=props.literals,myThinkChatsStatus=props.myThinkChatsStatus,myThinkChatsList=props.myThinkChatsList,app=props.app,user=props.user;var today=Math.floor(Date.now()/1000);var content=null;switch(myThinkChatsStatus){case __WEBPACK_IMPORTED_MODULE_4_constants_status__["g" ]:{var tablesList=[].concat(_toConsumableArray(myThinkChatsList));tablesList.sort(function(a,b){if(a.status.id===__WEBPACK_IMPORTED_MODULE_14_constants_tables__["b" ]&&b.status.id!==__WEBPACK_IMPORTED_MODULE_14_constants_tables__["b" ]){return 1;}if(a.status.id!==__WEBPACK_IMPORTED_MODULE_14_constants_tables__["b" ]&&b.status.id===__WEBPACK_IMPORTED_MODULE_14_constants_tables__["b" ]){return-1;}if(a.last_message&&!b.last_message){return-1;}if(!a.last_message&&b.last_message){return 1;}if(a.last_message&&b.last_message){return a.last_message.timestamp>b.last_message.timestamp?-1:1;}if(a.limit_date&&b.limit_date){if(a.limit_date>today&&b.limit_date>today){return a.limit_date<b.limit_date?-1:1;}if(a.limit_date<=today){return 1;}if(b.limit_date<=today){return-1;}}return a.timestamp>b.timestamp?-1:1;});var tables=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tablesList,function(item){var hasMessage=item.last_message&&item.last_message.type&&item.last_message.type.value==='Message';var lastMessage=item.last_message;var avatar=hasMessage?lastMessage.user.avatar:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["h" ],{key:item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["i" ],{onClick:handleClickTable,'data-id':item.id,dead:item.status.id===__WEBPACK_IMPORTED_MODULE_14_constants_tables__["b" ]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Cards_ThemeTableCard__["a" ],{onClick:doNothing,data:item,key:item.id,app:app,user:user,hideInfo:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["g" ],null,item.status.id===__WEBPACK_IMPORTED_MODULE_14_constants_tables__["b" ]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time'},literals.killed):null,item.status.id!==__WEBPACK_IMPORTED_MODULE_14_constants_tables__["b" ]&&item.limit_date>today?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time'},literals.ending,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Countdown__["a" ],{time:item.limit_date})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},item.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons_right'},!hasMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["b" ],null,literals.viewTableDetail),hasMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Avatar__["a" ],{size:40,avatar:avatar,position:'relative'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},lastMessage.text)))));});content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,tables);break;}case __WEBPACK_IMPORTED_MODULE_4_constants_status__["a" ]:{content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'errorMsg'},literals.errorLoadingThinkChats);break;}default:{break;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,content);};var printInvitations=function printInvitations(){var a=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(invitations,function(invitation){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Cards_InvitationCard__["a" ],{name:invitation.invited_by.firstname+' '+invitation.invited_by.lastname,avatar:invitation.invited_by.avatar,table:invitation.think_seed.name,id:invitation.id,type:__WEBPACK_IMPORTED_MODULE_13_constants_types__["m" ],thinkSeedId:invitation.think_seed.id,invitation:invitation,joinToTable:joinToTable,key:invitation.id});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_SimpleCarousel__["a" ],{classesList:'invitation_card',showAllAnswers:true},a);};var printContent=function printContent(){var color1=props.app.color1,literals=props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["k" ],{color:color1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["a" ],{onClick:createTable},'+')),invitations.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["j" ],{className:'section_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section',dangerouslySetInnerHTML:{__html:literals.yourInvitations}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["f" ],null,printInvitations())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["j" ],{className:'section_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section',dangerouslySetInnerHTML:{__html:literals.ongoingChats}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["f" ],{flex:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tables'},printMyTables()))));};var printNoTables=function printNoTables(){var literals=props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["e" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nocontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noContentSub)));};var printNoContent=function printNoContent(){var literals=props.literals,app=props.app;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["k" ],{color:app.color1},invitations.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["j" ],{className:'section_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section',dangerouslySetInnerHTML:{__html:literals.yourInvitations}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["f" ],null,printInvitations())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["j" ],{className:'section_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section',dangerouslySetInnerHTML:{__html:literals.ongoingChats}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles__["f" ],{flex:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tables'},printNoTables()))));};var myThinkChatsList=props.myThinkChatsList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,myThinkChatsList.length>0?printContent():printNoContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'7vh'}}));}Think.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,myThinkChatsList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,myThinkChatsStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,myThinkTanksList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,myThinkTanksStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,getInvitations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setSectionSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,invitations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,requestsJoinThinkTank:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};Think.defaultProps={myThinkChatsList:null,myThinkChatsStatus:null,myThinkTanksList:null,myThinkTanksStatus:null,invitations:null,requestsJoinThinkTank:[]}; __webpack_exports__["a"] = (Think);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1292);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1293);
function mapStateToProps(state){return{literals:state.i18n.literals.think||{}};}function mapDispatchToProps(dispatch){return{rejectInvitation:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_chats__["k" ],dispatch),acceptInvitation:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_chats__["a" ],dispatch),getChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_chats__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_2_assets_images_think_tableImageColors_svg__ = __webpack_require__(1294);
 var __WEBPACK_IMPORTED_MODULE_2_assets_images_think_tableImageColors_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_images_think_tableImageColors_svg__);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1295);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ACTION_ACCEPT_INVITATION='accept_invitation';var ACTION_REJECT_INVITATION='reject_invitation';function InvitationCard(props){var invitation=props.invitation,id=props.id,thinkSeedId=props.thinkSeedId,literals=props.literals,rejectInvitation=props.rejectInvitation,acceptInvitation=props.acceptInvitation,getChats=props.getChats,joinToTable=props.joinToTable;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),action=_useState2[0],setAction=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),loading=_useState4[0],setLoading=_useState4[1];var setIsNoLoading=function setIsNoLoading(){setLoading(false);};var handleOnConfirm=function handleOnConfirm(){if(!loading){setAction(ACTION_ACCEPT_INVITATION);setLoading(true);Object(__WEBPACK_IMPORTED_MODULE_1_modules_think_seeds_actions__["h" ])(thinkSeedId).then(function(){getChats();acceptInvitation(invitation,thinkSeedId,setIsNoLoading);joinToTable(id);});}};var handleOnReject=function handleOnReject(){if(!loading){setAction(ACTION_REJECT_INVITATION);setLoading(true);rejectInvitation(id,setIsNoLoading);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["c" ],{className:'invitation_card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["e" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:props.avatar,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.invitedYou))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2_assets_images_think_tableImageColors_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},props.table)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{onClick:handleOnReject},loading&&action===ACTION_REJECT_INVITATION?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-spinner fa-spin'}):null,literals.ignore),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" ],{onClick:handleOnConfirm},loading&&action===ACTION_ACCEPT_INVITATION?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-spinner fa-spin'}):null,literals.join))));} __webpack_exports__["a"] = (InvitationCard);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tableImageColors.1b091086.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return InvitationWrapper; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return UserInfo; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return LowerInfo; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonIgnore; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonJoin; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  height: 15rem;\n  width: 28rem;\n  border-radius: 2rem;\n  margin: 1rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  display: inline-block;\n'],['\n  height: 15rem;\n  width: 28rem;\n  border-radius: 2rem;\n  margin: 1rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  display: inline-block;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 40%;\n  padding: 1rem;\n  border-radius: 2rem 2rem 0 0;\n  display: flex;\n  .image {\n    width: 20%;\n    display: flex;\n    margin-left: 0.5rem;\n    img {\n      height: 4.5rem;\n      width: 4.5rem;\n      border-radius: 100%;\n      background: gray;\n    }\n  }\n  .info {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 80%;\n    margin-left: 0.5rem;\n    .name {\n      font-size: 1.2rem;\n      font-weight: bold;\n      margin: 0.3rem;\n    }\n    .text {\n      font-size: 1.2rem;\n      margin: 0.3rem;\n    }\n  }\n'],['\n  width: 100%;\n  height: 40%;\n  padding: 1rem;\n  border-radius: 2rem 2rem 0 0;\n  display: flex;\n  .image {\n    width: 20%;\n    display: flex;\n    margin-left: 0.5rem;\n    img {\n      height: 4.5rem;\n      width: 4.5rem;\n      border-radius: 100%;\n      background: gray;\n    }\n  }\n  .info {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 80%;\n    margin-left: 0.5rem;\n    .name {\n      font-size: 1.2rem;\n      font-weight: bold;\n      margin: 0.3rem;\n    }\n    .text {\n      font-size: 1.2rem;\n      margin: 0.3rem;\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 60%;\n  position: relative;\n  img {\n    height: 5rem;\n    margin-left: 0.4rem;\n  }\n  .cont {\n    height: 50%;\n    width: 94%;\n    display: flex;\n    align-items: center;\n    margin: 1rem;\n  }\n  .text {\n    margin-left: 1rem;\n    font-size: 1.2rem;\n    font-weight: bold;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n  .buttons {\n    position: absolute;\n    right: 0.5rem;\n    bottom: 2rem;\n  }\n'],['\n  width: 100%;\n  height: 60%;\n  position: relative;\n  img {\n    height: 5rem;\n    margin-left: 0.4rem;\n  }\n  .cont {\n    height: 50%;\n    width: 94%;\n    display: flex;\n    align-items: center;\n    margin: 1rem;\n  }\n  .text {\n    margin-left: 1rem;\n    font-size: 1.2rem;\n    font-weight: bold;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n  .buttons {\n    position: absolute;\n    right: 0.5rem;\n    bottom: 2rem;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 8rem;\n  height: 2rem;\n  border-radius: 2rem;\n  border: 0.1rem solid;\n\n  i {\n    margin-right: 0.5rem;\n    font-size: 1.2rem;\n  }\n'],['\n  width: 8rem;\n  height: 2rem;\n  border-radius: 2rem;\n  border: 0.1rem solid;\n\n  i {\n    margin-right: 0.5rem;\n    font-size: 1.2rem;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  width: 8rem;\n  height: 2rem;\n  border-radius: 2rem;\n  color: white;\n  background: #2680EB;\n\n  i {\n    margin-right: 0.5rem;\n    font-size: 1.2rem;\n  }\n'],['\n  width: 8rem;\n  height: 2rem;\n  border-radius: 2rem;\n  color: white;\n  background: #2680EB;\n\n  i {\n    margin-right: 0.5rem;\n    font-size: 1.2rem;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InvitationWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var UserInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var LowerInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var ButtonIgnore=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject4);var ButtonJoin=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject5);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "k", function() { return ThinkSection; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return ThinkContent; });


 __webpack_require__.d(__webpack_exports__, "f", function() { return TabContent; });





 __webpack_require__.d(__webpack_exports__, "e", function() { return NoContentWrapper; });

 __webpack_require__.d(__webpack_exports__, "i", function() { return ThemeTableWrapper; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return ThemeTableDetails; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AddButton; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonViewDetail; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return ThemeTableOverflow; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return LastMessageWrapper; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return CreateTable; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 2rem 0;\n\n  .title_section {\n    margin-left: 1rem;\n  }\n'],['\n  padding: 2rem 0;\n\n  .title_section {\n    margin-left: 1rem;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  .text {\n    color: black;\n    font-size: 1.5rem;\n    margin-left: 1rem;\n  }\n  .title {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    margin-left: 3rem;\n    height: 5rem;\n  }\n'],['\n  .text {\n    color: black;\n    font-size: 1.5rem;\n    margin-left: 1rem;\n  }\n  .title {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    margin-left: 3rem;\n    height: 5rem;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  background-color: rgba(0, 0, 0, 0.05);\n  white-space: nowrap;\n'],['\n  background-color: rgba(0, 0, 0, 0.05);\n  white-space: nowrap;\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 50%;\n  display: inline-block;\n  text-align: center;\n  padding: 10px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n\n  ',';\n\n  @media (max-width: ','px) {\n    font-size: 14px;\n  }\n\n  .tab_indicator {\n    font-size: 14px;\n    color: #ff0000;\n  }\n\n  .alert_in_tab {\n    background-color: #ff0000;\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    top: calc(50% - 5px);\n    right: 10px\n  }\n'],['\n  width: 50%;\n  display: inline-block;\n  text-align: center;\n  padding: 10px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n\n  ',';\n\n  @media (max-width: ','px) {\n    font-size: 14px;\n  }\n\n  .tab_indicator {\n    font-size: 14px;\n    color: #ff0000;\n  }\n\n  .alert_in_tab {\n    background-color: #ff0000;\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    top: calc(50% - 5px);\n    right: 10px\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: ',';\n  width: 100%;\n  margin: 0 auto;\n  .tables {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n\n    @media (max-width: ','px) {\n      display: block;\n    }\n  }\n  .buttonAdd {\n    position: fixed;\n    bottom: 2rem;\n    right: 2rem;\n    @media (max-width: ','px) {\n      bottom: calc(8rem + env(safe-area-inset-bottom));\n      right: 1rem;\n      z-index: 10;\n      height: 6rem;\n    }\n  }\n'],['\n  display: ',';\n  width: 100%;\n  margin: 0 auto;\n  .tables {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n\n    @media (max-width: ','px) {\n      display: block;\n    }\n  }\n  .buttonAdd {\n    position: fixed;\n    bottom: 2rem;\n    right: 2rem;\n    @media (max-width: ','px) {\n      bottom: calc(8rem + env(safe-area-inset-bottom));\n      right: 1rem;\n      z-index: 10;\n      height: 6rem;\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  color: #fff;\n  font-size: 14px;\n  margin: 20px auto;\n\n  @media (max-width: ','px) {\n    font-size: 12px;\n    margin: 10px auto;\n  }\n'],['\n  color: #fff;\n  font-size: 14px;\n  margin: 20px auto;\n\n  @media (max-width: ','px) {\n    font-size: 12px;\n    margin: 10px auto;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  text-align: right;\n'],['\n  text-align: right;\n']),_templateObject8=_taggedTemplateLiteral(['\n  margin-top: 10px;\n  padding-bottom: 20px;\n\n  .chat_element {\n    width: 100%;\n  }\n'],['\n  margin-top: 10px;\n  padding-bottom: 20px;\n\n  .chat_element {\n    width: 100%;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  background: #2680EB;\n  height: 5.5rem;\n  width: 5.5rem;\n  color: white;\n  font-size: 3rem;\n  position: fixed;\n  right: min(5vw, 2rem);\n  z-index: 100;\n  cursor: pointer;\n  bottom: 2rem;\n  @media (max-width: ','px) {\n    bottom: 10rem;\n  }\n  border-radius: 3rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  background: #2680EB;\n  height: 5.5rem;\n  width: 5.5rem;\n  color: white;\n  font-size: 3rem;\n  position: fixed;\n  right: min(5vw, 2rem);\n  z-index: 100;\n  cursor: pointer;\n  bottom: 2rem;\n  @media (max-width: ','px) {\n    bottom: 10rem;\n  }\n  border-radius: 3rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),_templateObject10=_taggedTemplateLiteral(['\n  .text {\n    color: black;\n    font-size: 1.5rem;\n  }\n  .no_content{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    margin-top: 4rem;\n\n    img {\n      width: 20rem;\n      margin-top: 3rem;\n    }\n  }\n\n  .other_chats{\n    margin-top: 4rem;\n    .other_ongoing {\n      height: 3rem;\n      .title {\n        display: flex;\n        align-items: center;\n        flex-direction: row;\n        margin-left: 3rem;\n        height: 3rem;\n      }\n      img {\n        color: #99C9BF;\n        margin-right: 2rem;\n      }\n    }\n  }\n'],['\n  .text {\n    color: black;\n    font-size: 1.5rem;\n  }\n  .no_content{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    margin-top: 4rem;\n\n    img {\n      width: 20rem;\n      margin-top: 3rem;\n    }\n  }\n\n  .other_chats{\n    margin-top: 4rem;\n    .other_ongoing {\n      height: 3rem;\n      .title {\n        display: flex;\n        align-items: center;\n        flex-direction: row;\n        margin-left: 3rem;\n        height: 3rem;\n      }\n      img {\n        color: #99C9BF;\n        margin-right: 2rem;\n      }\n    }\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 30rem;\n  padding: 2rem;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n  .nocontent{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    img {\n      width: 20rem;\n    }\n    .text {\n      margin-top: 1rem;\n      font-size: 1.6rem;\n      text-align: center;\n    }\n  }\n'],['\n  width: 100%;\n  height: 30rem;\n  padding: 2rem;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n  .nocontent{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    img {\n      width: 20rem;\n    }\n    .text {\n      margin-top: 1rem;\n      font-size: 1.6rem;\n      text-align: center;\n    }\n  }\n']),_templateObject12=_taggedTemplateLiteral(['\n  min-height: 20rem;\n  min-width: 20rem;\n  max-height: 20rem;\n  max-width: 20rem;\n  border-radius: 100%;\n  margin: 2rem;\n  background: #2680EB;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  cursor: pointer;\n  .plus{\n    font-size: 5rem;\n  }\n  .text {\n    font-size: 2rem;\n    margin: 1rem;\n    color: white;\n  }\n'],['\n  min-height: 20rem;\n  min-width: 20rem;\n  max-height: 20rem;\n  max-width: 20rem;\n  border-radius: 100%;\n  margin: 2rem;\n  background: #2680EB;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  cursor: pointer;\n  .plus{\n    font-size: 5rem;\n  }\n  .text {\n    font-size: 2rem;\n    margin: 1rem;\n    color: white;\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  width: 90%;\n  padding: 2rem;\n  margin: 1rem;\n  box-shadow: 0px 0px 6px 1px rgb(0 0 0 / 20%);\n  border-radius: 4rem;\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  background-color: ',';\n  .separator {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border-left: 0.1rem solid gray;\n    height: 60%;\n  }\n  .buttons_right {\n    position: absolute;\n    left: 50%;\n    width: 50%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 2rem;\n    justify-content: center;\n  }\n\n  @media (max-width: ','px) {\n    width: 200%;\n    padding: 0;\n    position: relative;\n    overflow-x: auto;\n    overflow-y: hidden;\n    height: 15rem;\n\n    .theme_table_card {\n      transform: scale(0.5);\n      margin-top: 1rem;\n      width :13rem;\n    }\n  }\n'],['\n  width: 90%;\n  padding: 2rem;\n  margin: 1rem;\n  box-shadow: 0px 0px 6px 1px rgb(0 0 0 / 20%);\n  border-radius: 4rem;\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  background-color: ',';\n  .separator {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border-left: 0.1rem solid gray;\n    height: 60%;\n  }\n  .buttons_right {\n    position: absolute;\n    left: 50%;\n    width: 50%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 2rem;\n    justify-content: center;\n  }\n\n  @media (max-width: ','px) {\n    width: 200%;\n    padding: 0;\n    position: relative;\n    overflow-x: auto;\n    overflow-y: hidden;\n    height: 15rem;\n\n    .theme_table_card {\n      transform: scale(0.5);\n      margin-top: 1rem;\n      width :13rem;\n    }\n  }\n']),_templateObject14=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  left: 25%;\n  width: 20%;\n  height: 100%;\n  justify-content: center;\n\n  @media (max-width: ','px) {\n    left: 18%;\n    width: 29%;\n  }\n  .name {\n    font-size: 1.4rem;\n    font-weight: bold;\n    margin-left: 3rem;\n    margin: 1rem;\n    text-align: center;\n  }\n  .time {\n    font-size: 1.2rem;\n    text-align: center;\n\n    .countdown {\n      margin-left: 0.5rem;\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  left: 25%;\n  width: 20%;\n  height: 100%;\n  justify-content: center;\n\n  @media (max-width: ','px) {\n    left: 18%;\n    width: 29%;\n  }\n  .name {\n    font-size: 1.4rem;\n    font-weight: bold;\n    margin-left: 3rem;\n    margin: 1rem;\n    text-align: center;\n  }\n  .time {\n    font-size: 1.2rem;\n    text-align: center;\n\n    .countdown {\n      margin-left: 0.5rem;\n    }\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  background: #2680EB;\n  border-radius: 100%;\n  font-size: 4rem;\n  color: white;\n  cursor: pointer;\n  width: 2rem;\n  height: 2rem;\n  padding: 3.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  background: #2680EB;\n  border-radius: 100%;\n  font-size: 4rem;\n  color: white;\n  cursor: pointer;\n  width: 2rem;\n  height: 2rem;\n  padding: 3.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),_templateObject16=_taggedTemplateLiteral(['\n    background: #2680EB;\n    color: white;\n    font-size: 1.3rem;\n    padding: 2rem;\n    border-radius: 3rem;\n'],['\n    background: #2680EB;\n    color: white;\n    font-size: 1.3rem;\n    padding: 2rem;\n    border-radius: 3rem;\n']),_templateObject17=_taggedTemplateLiteral(['\n  width: 100%;\n  @media (max-width: ','px) {\n    overflow: auto;\n    margin-right: 2rem;\n  }\n'],['\n  width: 100%;\n  @media (max-width: ','px) {\n    overflow: auto;\n    margin-right: 2rem;\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  width: 80%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  .avatar{\n    position: absolute;\n    left: 9%;\n  }\n  .text {\n    background: #2680EB;\n    color: white;\n    width: 70%;\n    padding: 2rem;\n    border-radius: 1rem;\n  }\n'],['\n  width: 80%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  .avatar{\n    position: absolute;\n    left: 9%;\n  }\n  .text {\n    background: #2680EB;\n    color: white;\n    width: 70%;\n    padding: 2rem;\n    border-radius: 1rem;\n  }\n']),_templateObject19=_taggedTemplateLiteral(['\n  position: fixed;\n  bottom: 4rem;\n  right: 4rem;\n\n  @media (max-width: ','px) {\n    bottom: 8rem;\n    right: 2rem;\n  }\n'],['\n  position: fixed;\n  bottom: 4rem;\n  right: 4rem;\n\n  @media (max-width: ','px) {\n    bottom: 8rem;\n    right: 2rem;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ThinkSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var ThinkContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var ThinkTabs=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var ThinkTab=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return props.active?'border-bottom: 2px solid #fff':'';},__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var TabContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,function(props){return props.flex?'flex':'';},__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var Subtitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var Buttons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7);var ElementsList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);var CreateButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var NoContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10);var NoContentWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11);var NewTable=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12);var ThemeTableWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13,function(props){return props.dead?'#bfbfbf':'#ffffff';},__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var ThemeTableDetails=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject14,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var AddButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject15);var ButtonViewDetail=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16);var ThemeTableOverflow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var LastMessageWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18);var CreateTable=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject19,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1298);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__ = __webpack_require__(76);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1299);
function mapStateToProps(state){return{app:state.app,user:state.session.user,literals:state.i18n.literals.thinkTank||{},actualThinkTank:state.thinkTanks.actualThinkTank,actualThinkTankStatus:state.thinkTanks.actualThinkTankStatus,actualThinkTankTools:state.thinkTanks.actualThinkTankTools,actualThinkTankToolsStatus:state.thinkTanks.actualThinkTankToolsStatus,requestThinkTankError:state.thinkTanks.requestThinkTankError,requestThinkTankStatus:state.thinkTanks.requestThinkTankStatus,requestsJoinThinkTank:state.thinkTanks.requestsJoinThinkTank,requestAcceptThinkTankStatus:state.thinkTanks.requestAcceptThinkTankStatus,requestRejectThinkTankStatus:state.thinkTanks.requestRejectThinkTankStatus,requestsLeaveThinkTankError:state.thinkTanks.requestsLeaveThinkTankError,requestLeaveThinkTankStatus:state.thinkTanks.requestLeaveThinkTankStatus};}function mapDispatchToProps(dispatch){return{getThinkTank:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__["i" ],dispatch),getThinkTankTools:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__["j" ],dispatch),changeThinkTankImage:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__["b" ],dispatch),requestJoin:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__["p" ],dispatch),acceptJoin:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__["a" ],dispatch),rejectJoin:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__["o" ],dispatch),resetSelectedChat:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_chats__["l" ],dispatch),leaveThinkTank:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__["m" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem__ = __webpack_require__(409);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText__ = __webpack_require__(1300);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItemAvatar__ = __webpack_require__(1302);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(93);
 var __WEBPACK_IMPORTED_MODULE_7_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_8_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_9_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_10_constants_others__ = __webpack_require__(1304);
 var __WEBPACK_IMPORTED_MODULE_11_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_12_components_ChatRoom__ = __webpack_require__(111);
 var __WEBPACK_IMPORTED_MODULE_13_components_AddUsers__ = __webpack_require__(271);
 var __WEBPACK_IMPORTED_MODULE_14_components_FeedbackModal__ = __webpack_require__(78);
 var __WEBPACK_IMPORTED_MODULE_15_components_GeneralModal__ = __webpack_require__(1305);
 var __WEBPACK_IMPORTED_MODULE_16_components_ShareModal__ = __webpack_require__(486);
 var __WEBPACK_IMPORTED_MODULE_17_assets_images_think_no_tools_svg__ = __webpack_require__(1366);
 var __WEBPACK_IMPORTED_MODULE_17_assets_images_think_no_tools_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_assets_images_think_no_tools_svg__);
 var __WEBPACK_IMPORTED_MODULE_18_components_Tools__ = __webpack_require__(1367);
 var __WEBPACK_IMPORTED_MODULE_19_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_20__styles__ = __webpack_require__(1374);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThinkTank=function(_Component){_inherits(ThinkTank,_Component);function ThinkTank(props){_classCallCheck(this,ThinkTank);var _this=_possibleConstructorReturn(this,(ThinkTank.__proto__||Object.getPrototypeOf(ThinkTank)).call(this,props));_initialiseProps.call(_this);var id=props.match.params.id;_this.state={id:id,tabSelected:__WEBPACK_IMPORTED_MODULE_10_constants_others__["b" ],toolsView:'list',toolEdit:0,recommendedUsers:[],inviteLoading:false,showModalInviteFeedback:false,windowWidth:window.innerWidth,showInfoThinkTank:false,showModalShare:false,thinkTankUrl:window.location.href,showGetOutThinkTank:false};return _this;}_createClass(ThinkTank,[{key:'componentDidMount',value:function componentDidMount(){var getThinkTank=this.props.getThinkTank;var id=this.state.id;getThinkTank(id);window.addEventListener('resize',this.updateDimensions);}},{key:'componentDidUpdate',value:function componentDidUpdate(_ref){var prevThinkTankStatus=_ref.actualThinkTankStatus,prevMatch=_ref.match;var _props=this.props,actualThinkTankStatus=_props.actualThinkTankStatus,actualThinkTank=_props.actualThinkTank,getThinkTankTools=_props.getThinkTankTools,match=_props.match,getThinkTank=_props.getThinkTank;var id=this.state.id;if(prevThinkTankStatus!==actualThinkTankStatus&&actualThinkTankStatus===__WEBPACK_IMPORTED_MODULE_9_constants_status__["g" ]&&actualThinkTank.permissions){getThinkTankTools(id);this.getUserRecommendations();}if(prevMatch.params.id!==match.params.id){this.setState({id:match.params.id});getThinkTank(match.params.id);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.updateDimensions);}},{key:'render',value:function render(){var showInfoThinkTank=this.state.showInfoThinkTank;var actualThinkTank=this.props.actualThinkTank;if(!actualThinkTank){return null;}if(!actualThinkTank.permissions){return this.printNoPermissionsView();}if(showInfoThinkTank){return this.printInfoView();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["x" ],null,this.printHeader(),this.printContent(),this.printShareModal());}}]);return ThinkTank;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.updateDimensions=function(){var tabSelected=_this2.state.tabSelected;_this2.setState({windowWidth:window.innerWidth});if(window.innerWidth>__WEBPACK_IMPORTED_MODULE_19_constants_breakPoints__["b" ]&&tabSelected===__WEBPACK_IMPORTED_MODULE_10_constants_others__["a" ]){_this2.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_10_constants_others__["b" ]});}};this.getUserRecommendations=function(){Object(__WEBPACK_IMPORTED_MODULE_8_utils_apiFetch__["b" ])('GET',{endPoint:'think-seed/users/recommendations'},{}).then(function(recommendedUsers){_this2.setState({recommendedUsers:recommendedUsers});}).catch(function(){_this2.setState({recommendedUsers:[]});});};this.backToThink=function(){var _props2=_this2.props,history=_props2.history,resetSelectedChat=_props2.resetSelectedChat;resetSelectedChat();history.push(__WEBPACK_IMPORTED_MODULE_11_constants_urls__["P" ]);};this.handleClickTabChat=function(){_this2.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_10_constants_others__["a" ]});};this.handleClickTabCollaborate=function(){_this2.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_10_constants_others__["b" ]});};this.handleClickTabTools=function(){_this2.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_10_constants_others__["c" ]});};this.handleShowAddUsers=function(){_this2.setState({tabSelected:__WEBPACK_IMPORTED_MODULE_10_constants_others__["d" ]});};this.handleModalShare=function(){_this2.setState({showModalShare:true});};this.handleCloseModalShare=function(){_this2.setState({showModalShare:false});};this.handleClickCreateTool=function(){_this2.setState({toolsView:'creation',toolEdit:0});};this.handleCancelCreationTool=function(){_this2.setState({toolsView:'list'});};this.handleShowInfoThinkTank=function(){_this2.setState({showInfoThinkTank:true});};this.handleCloseInfoThinkTank=function(){_this2.setState({showInfoThinkTank:false});};this.handleGetOutThinkTank=function(){_this2.setState({showGetOutThinkTank:true});};this.handleCloseGetOutThinkTank=function(){_this2.setState({showGetOutThinkTank:false});};this.handleRefreshTools=function(){var getThinkTankTools=_this2.props.getThinkTankTools;var id=_this2.state.id;getThinkTankTools(id);_this2.setState({toolsView:'list'});};this.handleEditTool=function(toolId){_this2.setState({toolsView:'creation',toolEdit:toolId});};this.handleInvite=function(selectedUsers){var actualThinkTank=_this2.props.actualThinkTank;_this2.setState({inviteLoading:true});var usersIds=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(selectedUsers,function(user){return user.id;});Object(__WEBPACK_IMPORTED_MODULE_8_utils_apiFetch__["b" ])('POST',{endPoint:'think-tank/'+actualThinkTank.id+'/invite'},{users_ids:usersIds.join(',')}).then(function(){_this2.setState({inviteLoading:false,showModalInviteFeedback:true});}).catch(function(){_this2.setState({inviteLoading:false});});};this.handleCloseModalInviteFeedback=function(){_this2.setState({showModalInviteFeedback:false});_this2.handleClickTabCollaborate();};this.handleFileUpload=function(event){var file=event.target.files[0];var name=file.name;var reader=new FileReader();reader.onloadend=function(){_this2.uploadImage(reader.result,name);};reader.readAsDataURL(file);};this.handleRequestJoin=function(){var _props3=_this2.props,requestJoin=_props3.requestJoin,requestThinkTankStatus=_props3.requestThinkTankStatus;var id=_this2.state.id;if(requestThinkTankStatus===__WEBPACK_IMPORTED_MODULE_9_constants_status__["g" ]||requestThinkTankStatus===__WEBPACK_IMPORTED_MODULE_9_constants_status__["a" ]){return false;}requestJoin(id);return true;};this.uploadImage=function(data,name){var _props4=_this2.props,changeThinkTankImage=_props4.changeThinkTankImage,actualThinkTank=_props4.actualThinkTank;var params={data:data,name:name};Object(__WEBPACK_IMPORTED_MODULE_8_utils_apiFetch__["b" ])('POST',{endPoint:'upload-file'},params).then(function(response){changeThinkTankImage(actualThinkTank.id,response.url);}).catch(function(){});};this.getOutThinkTank=function(){var _props5=_this2.props,actualThinkTank=_props5.actualThinkTank,leaveThinkTank=_props5.leaveThinkTank,history=_props5.history;leaveThinkTank(actualThinkTank.id);_this2.handleCloseGetOutThinkTank();history.push(__WEBPACK_IMPORTED_MODULE_11_constants_urls__["P" ]);};this.printTabContent=function(){var windowWidth=_this2.state.windowWidth;if(windowWidth>__WEBPACK_IMPORTED_MODULE_19_constants_breakPoints__["b" ]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this2.printCollaborate(),_this2.printTools(),_this2.printUsersInvitation());}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this2.printChat(),_this2.printCollaborate(),_this2.printTools(),_this2.printUsersInvitation());};this.printChat=function(){var _state=_this2.state,tabSelected=_state.tabSelected,windowWidth=_state.windowWidth;var actualThinkTank=_this2.props.actualThinkTank;var visible=tabSelected===__WEBPACK_IMPORTED_MODULE_10_constants_others__["a" ]||windowWidth>__WEBPACK_IMPORTED_MODULE_19_constants_breakPoints__["b" ];if(!actualThinkTank.chat_id){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:!visible?'hidden':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_ChatRoom__["a" ],{key:actualThinkTank.chat_id,chatId:actualThinkTank.chat_id}));};this.printCollaborate=function(){var actualThinkTank=_this2.props.actualThinkTank;var tabSelected=_this2.state.tabSelected;if(!actualThinkTank.doc_url){return null;}var url=actualThinkTank.doc_url+'&overridemobile=true&fd=true&rm=minimal&headers=false';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["j" ],{width:'100%',className:tabSelected!==__WEBPACK_IMPORTED_MODULE_10_constants_others__["b" ]?'hidden':'',scrolling:'yes',src:url});};this.printTools=function(){var _props6=_this2.props,actualThinkTankTools=_props6.actualThinkTankTools,actualThinkTankToolsStatus=_props6.actualThinkTankToolsStatus,literals=_props6.literals,actualThinkTank=_props6.actualThinkTank;var _state2=_this2.state,toolsView=_state2.toolsView,toolEdit=_state2.toolEdit,tabSelected=_state2.tabSelected;if(toolsView==='creation'){var tool=toolEdit?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(actualThinkTankTools,{id:toolEdit}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["u" ],{className:tabSelected!==__WEBPACK_IMPORTED_MODULE_10_constants_others__["c" ]?'hidden':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Tools__["a" ],{elementType:'think_tank',elementId:actualThinkTank.id,onSave:_this2.handleRefreshTools,tool:tool,onCancel:_this2.handleCancelCreationTool}));}if(actualThinkTankToolsStatus!==__WEBPACK_IMPORTED_MODULE_9_constants_status__["g" ]){return null;}var content=null;if(!actualThinkTankTools.length){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_17_assets_images_think_no_tools_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noToolsMsg));}else{var rows=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(actualThinkTankTools,function(tool){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Tools__["b" ],{tool:tool,key:tool.id,onDelete:_this2.handleRefreshTools,onEdit:_this2.handleEditTool});});content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["u" ],null,rows);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tabSelected!==__WEBPACK_IMPORTED_MODULE_10_constants_others__["c" ]?'hidden':''},content,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:_this2.handleClickCreateTool},literals.createTool)));};this.printUsersInvitation=function(){var _state3=_this2.state,tabSelected=_state3.tabSelected,recommendedUsers=_state3.recommendedUsers,inviteLoading=_state3.inviteLoading,showModalInviteFeedback=_state3.showModalInviteFeedback;var literals=_this2.props.literals;if(tabSelected!==__WEBPACK_IMPORTED_MODULE_10_constants_others__["d" ]){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invite_users_tab_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_AddUsers__["a" ],{recommendedUsers:recommendedUsers,onInvite:_this2.handleInvite,onCancel:_this2.handleClickTabCollaborate,isLoading:inviteLoading}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_FeedbackModal__["a" ],{open:showModalInviteFeedback,success:true,onClose:_this2.handleCloseModalInviteFeedback,text:literals.invitationsSent}));};this.printContent=function(){var _props7=_this2.props,actualThinkTank=_props7.actualThinkTank,actualThinkTankStatus=_props7.actualThinkTankStatus,literals=_props7.literals,color1=_props7.app.color1;var _state4=_this2.state,tabSelected=_state4.tabSelected,windowWidth=_state4.windowWidth;if(actualThinkTankStatus!==__WEBPACK_IMPORTED_MODULE_9_constants_status__["g" ]){return null;}if(!actualThinkTank.id){return null;}if(windowWidth>__WEBPACK_IMPORTED_MODULE_19_constants_breakPoints__["b" ]){return _this2.printDesktopVersion();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["v" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["z" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["y" ],{color:color1,active:tabSelected===__WEBPACK_IMPORTED_MODULE_10_constants_others__["b" ],onClick:_this2.handleClickTabCollaborate},literals.collaborate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["y" ],{color:color1,active:tabSelected===__WEBPACK_IMPORTED_MODULE_10_constants_others__["a" ],onClick:_this2.handleClickTabChat},literals.chat),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["y" ],{color:color1,active:tabSelected===__WEBPACK_IMPORTED_MODULE_10_constants_others__["c" ],onClick:_this2.handleClickTabTools},literals.tools)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["t" ],{color:color1},_this2.printTabContent()));};this.printGetOutThinkTank=function(){var showGetOutThinkTank=_this2.state.showGetOutThinkTank;var literals=_this2.props.literals;var type='select';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_GeneralModal__["a" ],{open:showGetOutThinkTank,onClose:_this2.handleCloseGetOutThinkTank,onAccept:_this2.getOutThinkTank,type:type,text:literals.getOut});};this.printShareModal=function(){var _state5=_this2.state,showModalShare=_state5.showModalShare,thinkTankUrl=_state5.thinkTankUrl;if(thinkTankUrl){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_ShareModal__["a" ],{open:showModalShare,docUrl:thinkTankUrl,onClose:_this2.handleCloseModalShare});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);};this.printDesktopVersion=function(){var originalTabSelected=_this2.state.tabSelected;var _props8=_this2.props,literals=_props8.literals,color1=_props8.app.color1;var tabSelected=originalTabSelected===__WEBPACK_IMPORTED_MODULE_10_constants_others__["a" ]?__WEBPACK_IMPORTED_MODULE_10_constants_others__["b" ]:originalTabSelected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["i" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["h" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["v" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["z" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["y" ],{color:color1,active:tabSelected===__WEBPACK_IMPORTED_MODULE_10_constants_others__["b" ],onClick:_this2.handleClickTabCollaborate},literals.collaborate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["y" ],{color:color1,active:tabSelected===__WEBPACK_IMPORTED_MODULE_10_constants_others__["c" ],onClick:_this2.handleClickTabTools},literals.tools)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["t" ],{className:'tab_content',color:color1},_this2.printTabContent()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["g" ],null,_this2.printChat()));};this.printUsersInHeader=function(){var _props9=_this2.props,actualThinkTank=_props9.actualThinkTank,user=_props9.user,literals=_props9.literals;if(!actualThinkTank){return null;}var members=[].concat(_toConsumableArray(actualThinkTank.members));members.sort(function(a,b){if(a.id===user.id){return 1;}if(b.id===user.id){return-1;}var aName=a.firstname+' '+a.lastname;aName=aName.toLowerCase();var bName=b.firstname+' '+b.lastname;bName=bName.toLowerCase();return aName<bName?-1:1;});var text='';__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(members,function(member,i){if(i>0){if(i===members.length-1){text+=' '+literals.and+' ';}else{text+=', ';}}if(member.id===user.id){text+=literals.you;}else{text+=member.firstname+' '+member.lastname;}});return text;};this.printHeader=function(){var _props10=_this2.props,actualThinkTank=_props10.actualThinkTank,actualThinkTankStatus=_props10.actualThinkTankStatus;if(actualThinkTankStatus!==__WEBPACK_IMPORTED_MODULE_9_constants_status__["g" ]){return null;}if(!actualThinkTank.id){return null;}var image=actualThinkTank.image;var name=actualThinkTank.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["w" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["a" ],{onClick:_this2.backToThink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-arrow-left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["A" ],{onClick:_this2.handleShowInfoThinkTank},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'avatar_image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Avatar__["a" ],{size:32,avatar:image,firstname:name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name_think_tank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,decodeURIComponent(actualThinkTank.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users_list'},_this2.printUsersInHeader()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["b" ],{onClick:_this2.handleShowAddUsers},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-user-plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["c" ],{onClick:_this2.handleModalShare},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-share-alt-square'})));};this.printInfoView=function(){var _props11=_this2.props,actualThinkTank=_props11.actualThinkTank,literals=_props11.literals;var usersRows=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(actualThinkTank.members,function(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem__["a" ],{alignItems:'flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItemAvatar__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Avatar__["a" ],{firstname:user.firstname,size:42,avatar:user.avatar})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText__["a" ],{className:'user-list__item--text',primary:user.firstname+' '+user.lastname}));});var image=actualThinkTank.image;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["k" ],{image:image},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity-frame'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow_layer',onClick:_this2.handleCloseInfoThinkTank},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-arrow-left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'document_file',name:'document_file',style:{display:'none'},onChange:_this2.handleFileUpload,accept:'image/png, image/jpeg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'edit_image_layer',htmlFor:'document_file'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_layer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_content'},decodeURIComponent(actualThinkTank.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_header'},literals.info),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description_layer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description_title'},literals.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description_content'},decodeURIComponent(actualThinkTank.description))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'members'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'members_title'},literals.members),usersRows),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this2.printRequestsJoin(),_this2.printGetOutThinkTank()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deleteButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__["a" ],{className:'danger',onClick:_this2.handleGetOutThinkTank},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-trash-alt',style:{marginRight:'10px'}}),literals.delete)));};this.printNoPermissionsView=function(){var _props12=_this2.props,literals=_props12.literals,actualThinkTank=_props12.actualThinkTank,requestThinkTankStatus=_props12.requestThinkTankStatus,requestThinkTankError=_props12.requestThinkTankError;var name=actualThinkTank.name,image=actualThinkTank.image,description=actualThinkTank.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["l" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["p" ],null,decodeURIComponent(name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["o" ],null,decodeURIComponent(description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["n" ],{src:image,size:120}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["m" ],null,literals.noPermissions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["e" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["d" ],{onClick:_this2.handleRequestJoin},requestThinkTankStatus===__WEBPACK_IMPORTED_MODULE_9_constants_status__["g" ]?literals.sentRequest:literals.requestPermission)),requestThinkTankStatus===__WEBPACK_IMPORTED_MODULE_9_constants_status__["a" ]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error_msg'},requestThinkTankError.error):null);};this.handleResponseRequest=function(event){var requestId=parseInt(event.currentTarget.getAttribute('data-id'),10);var type=parseInt(event.currentTarget.getAttribute('data-type'),10);var id=_this2.state.id;var _props13=_this2.props,acceptJoin=_props13.acceptJoin,rejectJoin=_props13.rejectJoin;if(type===0){acceptJoin(id,requestId);}else{rejectJoin(id,requestId);}};this.printRequestsJoin=function(){var _props14=_this2.props,requestsJoinThinkTank=_props14.requestsJoinThinkTank,literals=_props14.literals;var usersRows=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(requestsJoinThinkTank,function(request){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem__["a" ],{alignItems:'flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItemAvatar__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Avatar__["a" ],{firstname:request.user.firstname,size:42,avatar:request.user.avatar})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText__["a" ],{className:'user-list__item--text',primary:request.user.firstname+' '+request.user.lastname}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["s" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-id':request.id,'data-type':'0',onClick:_this2.handleResponseRequest},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["q" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-check'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-id':request.id,'data-type':'1',onClick:_this2.handleResponseRequest},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles__["r" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-times'})))));});if(requestsJoinThinkTank.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'req_members'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'members_title'},literals.reqMembers),usersRows);}return null;};};ThinkTank.propTypes={app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,getThinkTank:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,actualThinkTank:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,actualThinkTankStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,getThinkTankTools:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,requestJoin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,acceptJoin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,rejectJoin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,requestsJoinThinkTank:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,actualThinkTankTools:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,actualThinkTankToolsStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,changeThinkTankImage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,leaveThinkTank:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};ThinkTank.defaultProps={actualThinkTank:null,actualThinkTankStatus:null,actualThinkTankTools:null,actualThinkTankToolsStatus:null,requestsJoinThinkTank:null}; __webpack_exports__["a"] = (ThinkTank);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ListItemText__ = __webpack_require__(1301);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItemText__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(258);
 var __WEBPACK_IMPORTED_MODULE_7__List_ListContext__ = __webpack_require__(168);








var styles = {
  
  root: {
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  },

  
  multiline: {
    marginTop: 6,
    marginBottom: 6
  },

  
  dense: {},

  
  inset: {
    paddingLeft: 56
  },

  
  primary: {},

  
  secondary: {}
};
var ListItemText = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItemText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_7__List_ListContext__["a" ]),
      dense = _React$useContext.dense;

  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" ] && !disableTypography) {
    primary = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: "span",
      display: "block"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" ] && !disableTypography) {
    secondary = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" ], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
      variant: "body2",
      className: classes.secondary,
      color: "textSecondary",
      display: "block"
    }, secondaryTypographyProps), secondary);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
    ref: ref
  }, other), primary, secondary);
});
 false ? ListItemText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.node,

  
  classes: PropTypes.object,

  
  className: PropTypes.string,

  
  disableTypography: PropTypes.bool,

  
  inset: PropTypes.bool,

  
  primary: PropTypes.node,

  
  primaryTypographyProps: PropTypes.object,

  
  secondary: PropTypes.node,

  
  secondaryTypographyProps: PropTypes.object
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiListItemText'
})(ListItemText));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ListItemAvatar__ = __webpack_require__(1303);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItemAvatar__["a"]; });


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(6);
 var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(9);
 var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(14);
 var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(15);
 var __WEBPACK_IMPORTED_MODULE_6__List_ListContext__ = __webpack_require__(168);







var styles = {
  
  root: {
    minWidth: 56,
    flexShrink: 0
  },

  
  alignItemsFlexStart: {
    marginTop: 8
  }
};


var ListItemAvatar = __WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItemAvatar(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" ])(props, ["classes", "className"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__List_ListContext__["a" ]);
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" ])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" ])(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? ListItemAvatar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  children: PropTypes.element.isRequired,

  
  classes: PropTypes.object,

  
  className: PropTypes.string
} : void 0;
 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" ])(styles, {
  name: 'MuiListItemAvatar'
})(ListItemAvatar));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";





 __webpack_require__.d(__webpack_exports__, "a", function() { return TAB_CHAT; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return TAB_COLLABORATE; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return TAB_TOOLS; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return TAB_USERS; });
var TAB_SUGGESTIONS='suggestions';var TAB_NETWORK='network';var TAB_CHATS='chats';var TAB_THINK_CHATS='think-chats';var TAB_THINK_TANKS='think-tanks';var TAB_CHAT='chat';var TAB_COLLABORATE='collaborate';var TAB_TOOLS='tools';var TAB_USERS='users';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1306);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1307);
function mapStateToProps(state){return{literals:state.i18n.literals.generalModal};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1308);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeneralModal=function(_Component){_inherits(GeneralModal,_Component);function GeneralModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GeneralModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GeneralModal.__proto__||Object.getPrototypeOf(GeneralModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){var onClose=_this.props.onClose;onClose();},_this.handleAccept=function(){var _this$props=_this.props,onAccept=_this$props.onAccept,onClose=_this$props.onClose;onAccept();onClose();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GeneralModal,[{key:'render',value:function render(){var _props=this.props,open=_props.open,type=_props.type,text=_props.text,literals=_props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" ],{open:open,onClose:this.handleClose,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal general_modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'general_message'},text),type==='select'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',type:'button',onClick:this.handleAccept},literals.yes),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'cancel',type:'button',onClick:this.handleClose},literals.no))));}}]);return GeneralModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GeneralModal.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onAccept:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (GeneralModal);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return GeneralModalWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Modal__ = __webpack_require__(37);
var _templateObject=_taggedTemplateLiteral(['\n  .general_modal {\n    text-align: center;\n    padding: 20px;\n    overflow: hidden;\n    \n\n    .general_message {\n      color: #666;\n      font-size: 18px;\n      line-height: 30px;\n      font-weight: 600;\n    }\n\n  }\n'],['\n  .general_modal {\n    text-align: center;\n    padding: 20px;\n    overflow: hidden;\n    \n\n    .general_message {\n      color: #666;\n      font-size: 18px;\n      line-height: 30px;\n      font-weight: 600;\n    }\n\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GeneralModalWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Modal__["a" ])(_templateObject);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1310);
function mapStateToProps(state){return{literals:state.i18n.literals.shareModal};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_share__ = __webpack_require__(1311);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1365);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShareModal=function(_Component){_inherits(ShareModal,_Component);function ShareModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ShareModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ShareModal.__proto__||Object.getPrototypeOf(ShareModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){var onClose=_this.props.onClose;onClose();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ShareModal,[{key:'render',value:function render(){var _props=this.props,open=_props.open,docUrl=_props.docUrl,literals=_props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{open:open,onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal share_modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,literals.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sm_icons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_fb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_share__["d" ],{url:docUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_share__["c" ],{size:40,borderRadius:50}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_tw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_share__["f" ],{url:docUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_share__["e" ],{size:40,borderRadius:50}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_whatsapp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_share__["h" ],{url:docUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_share__["g" ],{size:40,borderRadius:50}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_mail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_share__["b" ],{url:docUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_share__["a" ],{size:40,borderRadius:50}))))));}}]);return ShareModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ShareModal.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,docUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (ShareModal);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__EmailIcon__ = __webpack_require__(1312);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EmailIcon__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__EmailShareButton__ = __webpack_require__(1313);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__EmailShareButton__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__FacebookIcon__ = __webpack_require__(1315);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__FacebookIcon__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__FacebookMessengerIcon__ = __webpack_require__(1316);

 var __WEBPACK_IMPORTED_MODULE_4__FacebookMessengerShareButton__ = __webpack_require__(1317);

 var __WEBPACK_IMPORTED_MODULE_5__FacebookShareButton__ = __webpack_require__(1318);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__FacebookShareButton__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__FacebookShareCount__ = __webpack_require__(1319);

 var __WEBPACK_IMPORTED_MODULE_7__HatenaIcon__ = __webpack_require__(1323);

 var __WEBPACK_IMPORTED_MODULE_8__HatenaShareButton__ = __webpack_require__(1324);

 var __WEBPACK_IMPORTED_MODULE_9__HatenaShareCount__ = __webpack_require__(1325);

 var __WEBPACK_IMPORTED_MODULE_10__InstapaperIcon__ = __webpack_require__(1326);

 var __WEBPACK_IMPORTED_MODULE_11__InstapaperShareButton__ = __webpack_require__(1327);

 var __WEBPACK_IMPORTED_MODULE_12__LineIcon__ = __webpack_require__(1328);

 var __WEBPACK_IMPORTED_MODULE_13__LineShareButton__ = __webpack_require__(1329);

 var __WEBPACK_IMPORTED_MODULE_14__LinkedinIcon__ = __webpack_require__(1330);

 var __WEBPACK_IMPORTED_MODULE_15__LinkedinShareButton__ = __webpack_require__(1331);

 var __WEBPACK_IMPORTED_MODULE_16__LivejournalIcon__ = __webpack_require__(1332);

 var __WEBPACK_IMPORTED_MODULE_17__LivejournalShareButton__ = __webpack_require__(1333);

 var __WEBPACK_IMPORTED_MODULE_18__MailruIcon__ = __webpack_require__(1334);

 var __WEBPACK_IMPORTED_MODULE_19__MailruShareButton__ = __webpack_require__(1335);

 var __WEBPACK_IMPORTED_MODULE_20__OKIcon__ = __webpack_require__(1336);

 var __WEBPACK_IMPORTED_MODULE_21__OKShareButton__ = __webpack_require__(1337);

 var __WEBPACK_IMPORTED_MODULE_22__OKShareCount__ = __webpack_require__(1338);

 var __WEBPACK_IMPORTED_MODULE_23__PinterestIcon__ = __webpack_require__(1339);

 var __WEBPACK_IMPORTED_MODULE_24__PinterestShareButton__ = __webpack_require__(1340);

 var __WEBPACK_IMPORTED_MODULE_25__PinterestShareCount__ = __webpack_require__(1341);

 var __WEBPACK_IMPORTED_MODULE_26__PocketIcon__ = __webpack_require__(1342);

 var __WEBPACK_IMPORTED_MODULE_27__PocketShareButton__ = __webpack_require__(1343);

 var __WEBPACK_IMPORTED_MODULE_28__RedditIcon__ = __webpack_require__(1344);

 var __WEBPACK_IMPORTED_MODULE_29__RedditShareButton__ = __webpack_require__(1345);

 var __WEBPACK_IMPORTED_MODULE_30__RedditShareCount__ = __webpack_require__(1346);

 var __WEBPACK_IMPORTED_MODULE_31__TelegramIcon__ = __webpack_require__(1347);

 var __WEBPACK_IMPORTED_MODULE_32__TelegramShareButton__ = __webpack_require__(1348);

 var __WEBPACK_IMPORTED_MODULE_33__TumblrIcon__ = __webpack_require__(1349);

 var __WEBPACK_IMPORTED_MODULE_34__TumblrShareButton__ = __webpack_require__(1350);

 var __WEBPACK_IMPORTED_MODULE_35__TumblrShareCount__ = __webpack_require__(1351);

 var __WEBPACK_IMPORTED_MODULE_36__TwitterIcon__ = __webpack_require__(1352);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_36__TwitterIcon__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_37__TwitterShareButton__ = __webpack_require__(1353);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_37__TwitterShareButton__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_38__ViberIcon__ = __webpack_require__(1354);

 var __WEBPACK_IMPORTED_MODULE_39__ViberShareButton__ = __webpack_require__(1355);

 var __WEBPACK_IMPORTED_MODULE_40__VKIcon__ = __webpack_require__(1356);

 var __WEBPACK_IMPORTED_MODULE_41__VKShareButton__ = __webpack_require__(1357);

 var __WEBPACK_IMPORTED_MODULE_42__VKShareCount__ = __webpack_require__(1358);

 var __WEBPACK_IMPORTED_MODULE_43__WeiboIcon__ = __webpack_require__(1359);

 var __WEBPACK_IMPORTED_MODULE_44__WeiboShareButton__ = __webpack_require__(1360);

 var __WEBPACK_IMPORTED_MODULE_45__WhatsappIcon__ = __webpack_require__(1361);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_45__WhatsappIcon__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_46__WhatsappShareButton__ = __webpack_require__(1362);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_46__WhatsappShareButton__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_47__WorkplaceIcon__ = __webpack_require__(1363);

 var __WEBPACK_IMPORTED_MODULE_48__WorkplaceShareButton__ = __webpack_require__(1364);




















































 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var EmailIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#7f7f7f',
    networkName: 'email',
    path: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
});
 __webpack_exports__["a"] = (EmailIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__ = __webpack_require__(28);


function emailLink(url, _a) {
    var subject = _a.subject, body = _a.body, separator = _a.separator;
    return 'mailto:' + Object(__WEBPACK_IMPORTED_MODULE_0__utils_objectToGetParams__["a" ])({ subject: subject, body: body ? body + separator + url : url });
}
var EmailShareButton = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__["a" ])('email', emailLink, function (props) { return ({
    subject: props.subject,
    body: props.body,
    separator: props.separator || ' ',
}); }, {
    openShareDialogOnClick: false,
    onClick: function (_, link) {
        window.location.href = link;
    },
});
 __webpack_exports__["a"] = (EmailShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
 var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var isPromise = function (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
var getBoxPositionOnWindowCenter = function (width, height) { return ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
}); };
var getBoxPositionOnScreenCenter = function (width, height) { return ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
}); };
function windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
    var config = __assign({ height: height,
        width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
    var shareDialog = window.open(url, '', Object.keys(config)
        .map(function (key) { return key + "=" + config[key]; })
        .join(', '));
    if (onClose) {
        var interval_1 = window.setInterval(function () {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval_1);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                
                console.error(e);
                
            }
        }, 1000);
    }
    return shareDialog;
}
var ShareButton =  (function (_super) {
    __extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function (link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
            windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                        link = networkLink(url, opts);
                        if (disabled) {
                            return [2 ];
                        }
                        event.preventDefault();
                        if (!beforeOnClick) return [3 , 2];
                        returnVal = beforeOnClick();
                        if (!isPromise(returnVal)) return [3 , 2];
                        return [4 , returnVal];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (openShareDialogOnClick) {
                            this.openShareDialog(link);
                        }
                        if (onClick) {
                            onClick(event, link);
                        }
                        return [2 ];
                }
            });
        }); };
        return _this;
    }
    ShareButton.prototype.render = function () {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
        var newClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('react-share__ShareButton', {
            'react-share__ShareButton--disabled': !!disabled,
            disabled: !!disabled,
        }, className);
        var newStyle = resetButtonStyle
            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
    };
    ShareButton.defaultProps = {
        disabledStyle: { opacity: 0.6 },
        openShareDialogOnClick: true,
        resetButtonStyle: true,
    };
    return ShareButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
 __webpack_exports__["a"] = (ShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var FacebookIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#3b5998',
    networkName: 'facebook',
    path: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
});
 __webpack_exports__["a"] = (FacebookIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var FacebookMessengerIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#2196F3',
    networkName: 'facebookmessenger',
    path: 'M 53.066406 21.871094 C 52.667969 21.339844 51.941406 21.179688 51.359375 21.496094 L 37.492188 29.058594 L 28.867188 21.660156 C 28.339844 21.207031 27.550781 21.238281 27.054688 21.730469 L 11.058594 37.726562 C 10.539062 38.25 10.542969 39.09375 11.0625 39.613281 C 11.480469 40.027344 12.121094 40.121094 12.640625 39.839844 L 26.503906 32.28125 L 35.136719 39.679688 C 35.667969 40.132812 36.457031 40.101562 36.949219 39.609375 L 52.949219 23.613281 C 53.414062 23.140625 53.464844 22.398438 53.066406 21.871094 Z M 53.066406 21.871094',
});
 var _unused_webpack_default_export = (FacebookMessengerIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__ = __webpack_require__(28);


function facebookMessengerLink(url, _a) {
    var appId = _a.appId, redirectUri = _a.redirectUri, to = _a.to;
    return ('https://www.facebook.com/dialog/send' +
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_objectToGetParams__["a" ])({
            link: url,
            redirect_uri: redirectUri || url,
            app_id: appId,
            to: to,
        }));
}
var FacebookMessengerShareButton = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__["a" ])('facebookmessenger', facebookMessengerLink, function (props) { return ({
    appId: props.appId,
    redirectUri: props.redirectUri,
    to: props.to,
}); }, {
    windowWidth: 1000,
    windowHeight: 820,
});
 var _unused_webpack_default_export = (FacebookMessengerShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'facebook.url');
    return ('https://www.facebook.com/sharer/sharer.php' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var FacebookShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('facebook', facebookLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
 __webpack_exports__["a"] = (FacebookShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(98);
 var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
 var __WEBPACK_IMPORTED_MODULE_1__hocs_createShareCount__ = __webpack_require__(99);


function getFacebookShareCount(shareUrl, callback) {
    var endpoint = "https://graph.facebook.com/?id=" + shareUrl + "&fields=og_object{engagement}";
    __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, function (err, data) {
        callback(!err && data && data.og_object && data.og_object.engagement
            ? data.og_object.engagement.count
            : undefined);
    });
}
 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__hocs_createShareCount__["a" ])(getFacebookShareCount));


 }),

 (function(module, exports, __webpack_require__) {

(function(process) {

exports = module.exports = __webpack_require__(1321);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();



exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];



function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}



exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};




function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}



function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}



function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}



function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://app.callforimpact.com/api/Rise","REACT_APP_NODE_URL":"https://node2.globalincubator.net"}).DEBUG;
  }

  return r;
}



exports.enable(load());



function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

}.call(exports, __webpack_require__(124)))

 }),

 (function(module, exports, __webpack_require__) {




exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1322);



exports.names = [];
exports.skips = [];



exports.formatters = {};



var prevTime;



function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}



function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}



function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}



function disable() {
  exports.enable('');
}



function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}



function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


 }),

 (function(module, exports) {



var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;



module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};



function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}



function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}



function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}



function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var HatenaIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#009ad9',
    networkName: 'hatena',
    path: 'M 36.164062 33.554688 C 34.988281 32.234375 33.347656 31.5 31.253906 31.34375 C 33.125 30.835938 34.476562 30.09375 35.335938 29.09375 C 36.191406 28.09375 36.609375 26.78125 36.609375 25.101562 C 36.628906 23.875 36.332031 22.660156 35.75 21.578125 C 35.160156 20.558594 34.292969 19.71875 33.253906 19.160156 C 32.304688 18.640625 31.175781 18.265625 29.847656 18.042969 C 28.523438 17.824219 26.195312 17.730469 22.867188 17.730469 L 14.769531 17.730469 L 14.769531 47.269531 L 23.113281 47.269531 C 26.46875 47.269531 28.886719 47.15625 30.367188 46.929688 C 31.851562 46.695312 33.085938 46.304688 34.085938 45.773438 C 35.289062 45.148438 36.28125 44.179688 36.933594 42.992188 C 37.597656 41.796875 37.933594 40.402344 37.933594 38.816406 C 37.933594 36.621094 37.347656 34.867188 36.164062 33.554688 Z M 22.257812 24.269531 L 23.984375 24.269531 C 25.988281 24.269531 27.332031 24.496094 28.015625 24.945312 C 28.703125 25.402344 29.042969 26.183594 29.042969 27.285156 C 29.042969 28.390625 28.664062 29.105469 27.9375 29.550781 C 27.210938 29.992188 25.84375 30.199219 23.855469 30.199219 L 22.257812 30.199219 Z M 29.121094 41.210938 C 28.328125 41.691406 26.976562 41.925781 25.078125 41.925781 L 22.257812 41.925781 L 22.257812 35.488281 L 25.195312 35.488281 C 27.144531 35.488281 28.496094 35.738281 29.210938 36.230469 C 29.925781 36.726562 30.304688 37.582031 30.304688 38.832031 C 30.304688 40.078125 29.914062 40.742188 29.105469 41.222656 Z M 29.121094 41.210938 M 46.488281 39.792969 C 44.421875 39.792969 42.742188 41.46875 42.742188 43.535156 C 42.742188 45.605469 44.421875 47.28125 46.488281 47.28125 C 48.554688 47.28125 50.230469 45.605469 50.230469 43.535156 C 50.230469 41.46875 48.554688 39.792969 46.488281 39.792969 Z M 46.488281 39.792969 M 43.238281 17.730469 L 49.738281 17.730469 L 49.738281 37.429688 L 43.238281 37.429688 Z M 43.238281 17.730469 ',
});
 var _unused_webpack_default_export = (HatenaIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__ = __webpack_require__(28);


function hatenaLink(url, _a) {
    var title = _a.title;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'hatena.url');
    return "http://b.hatena.ne.jp/add?mode=confirm&url=" + url + "&title=" + title;
}
var HatenaShareButton = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__["a" ])('hatena', hatenaLink, function (props) { return ({
    title: props.title,
}); }, {
    windowWidth: 660,
    windowHeight: 460,
    windowPosition: 'windowCenter',
});
 var _unused_webpack_default_export = (HatenaShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(98);
 var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareCount__ = __webpack_require__(99);



function getHatenaShareCount(shareUrl, callback) {
    var url = 'https://bookmark.hatenaapis.com/count/entry';
    __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: shareUrl,
        }), function (err, data) {
        callback(data ? data : undefined);
    });
}
 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareCount__["a" ])(getHatenaShareCount));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var InstapaperIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#1F1F1F',
    networkName: 'instapaper',
    path: 'M35.688 43.012c0 2.425.361 2.785 3.912 3.056V48H24.401v-1.932c3.555-.27 3.912-.63 3.912-3.056V20.944c0-2.379-.36-2.785-3.912-3.056V16H39.6v1.888c-3.55.27-3.912.675-3.912 3.056v22.068h.001z',
});
 var _unused_webpack_default_export = (InstapaperIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__ = __webpack_require__(28);
 var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);



function instapaperLink(url, _a) {
    var title = _a.title, description = _a.description;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'instapaper.url');
    return ('http://www.instapaper.com/hello2' +
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" ])({
            url: url,
            title: title,
            description: description,
        }));
}
var InstapaperShareButton = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__["a" ])('instapaper', instapaperLink, function (props) { return ({
    title: props.title,
    description: props.description,
}); }, {
    windowWidth: 500,
    windowHeight: 500,
    windowPosition: 'windowCenter',
});
 var _unused_webpack_default_export = (InstapaperShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var LineIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#00b800',
    networkName: 'line',
    path: 'M52.62 30.138c0 3.693-1.432 7.019-4.42 10.296h.001c-4.326 4.979-14 11.044-16.201 11.972-2.2.927-1.876-.591-1.786-1.112l.294-1.765c.069-.527.142-1.343-.066-1.865-.232-.574-1.146-.872-1.817-1.016-9.909-1.31-17.245-8.238-17.245-16.51 0-9.226 9.251-16.733 20.62-16.733 11.37 0 20.62 7.507 20.62 16.733zM27.81 25.68h-1.446a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-8.985a.402.402 0 0 0-.402-.401zm9.956 0H36.32a.402.402 0 0 0-.402.401v5.338L31.8 25.858a.39.39 0 0 0-.031-.04l-.002-.003-.024-.025-.008-.007a.313.313 0 0 0-.032-.026.255.255 0 0 1-.021-.014l-.012-.007-.021-.012-.013-.006-.023-.01-.013-.005-.024-.008-.014-.003-.023-.005-.017-.002-.021-.003-.021-.002h-1.46a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-5.337l4.123 5.568c.028.04.063.072.101.099l.004.003a.236.236 0 0 0 .025.015l.012.006.019.01a.154.154 0 0 1 .019.008l.012.004.028.01.005.001a.442.442 0 0 0 .104.013h1.446a.4.4 0 0 0 .401-.4v-8.985a.402.402 0 0 0-.401-.401zm-13.442 7.537h-3.93v-7.136a.401.401 0 0 0-.401-.401h-1.447a.4.4 0 0 0-.401.401v8.984a.392.392 0 0 0 .123.29c.072.068.17.111.278.111h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401zm21.429-5.287c.222 0 .401-.18.401-.402v-1.446a.401.401 0 0 0-.401-.402h-5.778a.398.398 0 0 0-.279.113l-.005.004-.006.008a.397.397 0 0 0-.111.276v8.984c0 .108.043.206.112.278l.005.006a.401.401 0 0 0 .284.117h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401h-3.93v-1.519h3.93c.222 0 .401-.18.401-.402V29.85a.401.401 0 0 0-.401-.402h-3.93V27.93h3.93z',
});
 var _unused_webpack_default_export = (LineIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__ = __webpack_require__(28);
 var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);



function lineLink(url, _a) {
    var title = _a.title;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'line.url');
    return ('https://social-plugins.line.me/lineit/share' +
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" ])({
            url: url,
            text: title,
        }));
}
var LineShareButton = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__["a" ])('line', lineLink, function (props) { return ({
    title: props.title,
}); }, {
    windowWidth: 500,
    windowHeight: 500,
});
 var _unused_webpack_default_export = (LineShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var LinkedinIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#007fb1',
    networkName: 'linkedin',
    path: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
});
 var _unused_webpack_default_export = (LinkedinIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function linkedinLink(url, _a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'linkedin.url');
    return ('https://linkedin.com/shareArticle' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({ url: url, mini: 'true', title: title, summary: summary, source: source }));
}
var LinkedinShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('linkedin', linkedinLink, function (_a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    return ({ title: title, summary: summary, source: source });
}, {
    windowWidth: 750,
    windowHeight: 600,
});
 var _unused_webpack_default_export = (LinkedinShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var LivejournalIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#21A5D8',
    networkName: 'livejournal',
    path: 'M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z',
});
 var _unused_webpack_default_export = (LivejournalIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function livejournalLink(url, _a) {
    var title = _a.title, description = _a.description;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'livejournal.url');
    return ('https://www.livejournal.com/update.bml' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            subject: title,
            event: description,
        }));
}
var LivejournalShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('livejournal', livejournalLink, function (props) { return ({
    title: props.title,
    description: props.description,
}); }, {
    windowWidth: 660,
    windowHeight: 460,
});
 var _unused_webpack_default_export = (LivejournalShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var MailruIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#168DE2',
    networkName: 'mailru',
    path: 'M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z',
});
 var _unused_webpack_default_export = (MailruIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function mailruLink(url, _a) {
    var title = _a.title, description = _a.description, imageUrl = _a.imageUrl;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'mailru.url');
    return ('https://connect.mail.ru/share' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: url,
            title: title,
            description: description,
            image_url: imageUrl,
        }));
}
var MailruShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('mailru', mailruLink, function (props) { return ({
    title: props.title,
    description: props.description,
    imageUrl: props.imageUrl,
}); }, {
    windowWidth: 660,
    windowHeight: 460,
});
 var _unused_webpack_default_export = (MailruShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var OKIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#f2720c',
    networkName: 'ok',
    path: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
});
 var _unused_webpack_default_export = (OKIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function okLink(url, _a) {
    var title = _a.title, description = _a.description, image = _a.image;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'ok.url');
    return ('https://connect.ok.ru/offer' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: url,
            title: title,
            description: description,
            imageUrl: image,
        }));
}
var OKShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('ok', okLink, function (props) { return ({
    title: props.title,
    description: props.description,
    image: props.image,
}); }, {
    windowWidth: 588,
    windowHeight: 480,
    windowPosition: 'screenCenter',
});
 var _unused_webpack_default_export = (OKShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(98);
 var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareCount__ = __webpack_require__(99);



function getOKShareCount(shareUrl, callback) {
    if (!window.OK) {
        window.OK = {
            Share: {
                count: function count(index, _count) {
                    window.OK.callbacks[index](_count);
                },
            },
            callbacks: [],
        };
    }
    var url = 'https://connect.ok.ru/dk';
    var index = window.OK.callbacks.length;
    window.ODKL = {
        updateCount: function (index, count) {
            var callbackIndex = index === '' ? 0 : parseInt(index.replace('react-share-', ''), 10);
            window.OK.callbacks[callbackIndex](count === '' ? undefined : parseInt(count, 10));
        },
    };
    window.OK.callbacks.push(callback);
    return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            'st.cmd': 'extLike',
            uid: "react-share-" + index,
            ref: shareUrl,
        }));
}
 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareCount__["a" ])(getOKShareCount));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var PinterestIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#cb2128',
    networkName: 'pinterest',
    path: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
});
 var _unused_webpack_default_export = (PinterestIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function pinterestLink(url, _a) {
    var media = _a.media, description = _a.description;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'pinterest.url');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(media, 'pinterest.media');
    return ('https://pinterest.com/pin/create/button/' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: url,
            media: media,
            description: description,
        }));
}
var PinterestShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('pinterest', pinterestLink, function (props) { return ({
    media: props.media,
    description: props.description,
}); }, {
    windowWidth: 1000,
    windowHeight: 730,
});
 var _unused_webpack_default_export = (PinterestShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(98);
 var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareCount__ = __webpack_require__(99);



function getPinterestShareCount(shareUrl, callback) {
    var url = 'https://api.pinterest.com/v1/urls/count.json';
    __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: shareUrl,
        }), function (err, data) {
        callback(data ? data.count : undefined);
    });
}
 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareCount__["a" ])(getPinterestShareCount));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var PocketIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#EF3F56',
    networkName: 'pocket',
    path: 'M41.084 29.065l-7.528 7.882a2.104 2.104 0 0 1-1.521.666 2.106 2.106 0 0 1-1.522-.666l-7.528-7.882c-.876-.914-.902-2.43-.065-3.384.84-.955 2.228-.987 3.1-.072l6.015 6.286 6.022-6.286c.88-.918 2.263-.883 3.102.071.841.938.82 2.465-.06 3.383l-.015.002zm6.777-10.976C47.463 16.84 46.361 16 45.14 16H18.905c-1.2 0-2.289.82-2.716 2.044-.125.363-.189.743-.189 1.125v10.539l.112 2.096c.464 4.766 2.73 8.933 6.243 11.838.06.053.125.102.19.153l.04.033c1.882 1.499 3.986 2.514 6.259 3.014a14.662 14.662 0 0 0 6.13.052c.118-.042.235-.065.353-.087.03 0 .065-.022.098-.042a15.395 15.395 0 0 0 6.011-2.945l.039-.045.18-.153c3.502-2.902 5.765-7.072 6.248-11.852L48 29.674v-10.52c0-.366-.041-.728-.161-1.08l.022.015z',
});
 var _unused_webpack_default_export = (PocketIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__ = __webpack_require__(28);
 var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);



function pocketLink(url, _a) {
    var title = _a.title;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'pocket.url');
    return ('https://getpocket.com/save' +
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" ])({
            url: url,
            title: title,
        }));
}
var PocketShareButton = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_createShareButton__["a" ])('pocket', pocketLink, function (props) { return ({
    title: props.title,
}); }, {
    windowWidth: 500,
    windowHeight: 500,
});
 var _unused_webpack_default_export = (PocketShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var RedditIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#5f99cf',
    networkName: 'reddit',
    path: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
});
 var _unused_webpack_default_export = (RedditIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function redditLink(url, _a) {
    var title = _a.title;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'reddit.url');
    return ('https://www.reddit.com/submit' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: url,
            title: title,
        }));
}
var RedditShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('reddit', redditLink, function (props) { return ({
    title: props.title,
}); }, {
    windowWidth: 660,
    windowHeight: 460,
    windowPosition: 'windowCenter',
});
 var _unused_webpack_default_export = (RedditShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(98);
 var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
 var __WEBPACK_IMPORTED_MODULE_1__hocs_createShareCount__ = __webpack_require__(99);


function getRedditShareCount(shareUrl, callback) {
    var endpoint = "https://www.reddit.com/api/info.json?limit=1&url=" + shareUrl;
    __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, { param: 'jsonp' }, function (err, response) {
        callback(!err &&
            response &&
            response.data &&
            response.data.children.length > 0 &&
            response.data.children[0].data.score
            ? response.data.children[0].data.score
            : undefined);
    });
}
 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__hocs_createShareCount__["a" ])(getRedditShareCount));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var TelegramIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#37aee2',
    networkName: 'telegram',
    path: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
});
 var _unused_webpack_default_export = (TelegramIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function telegramLink(url, _a) {
    var title = _a.title;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'telegram.url');
    return ('https://telegram.me/share/' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: url,
            text: title,
        }));
}
var TelegramShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('telegram', telegramLink, function (props) { return ({
    title: props.title,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
 var _unused_webpack_default_export = (TelegramShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var TumblrIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#2c4762',
    networkName: 'tumblr',
    path: 'M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z',
});
 var _unused_webpack_default_export = (TumblrIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function tumblrLink(url, _a) {
    var title = _a.title, caption = _a.caption, tags = _a.tags, posttype = _a.posttype;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'tumblr.url');
    return ('https://www.tumblr.com/widgets/share/tool' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            canonicalUrl: url,
            title: title,
            caption: caption,
            tags: tags,
            posttype: posttype,
        }));
}
var TumblrShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('tumblr', tumblrLink, function (props) { return ({
    title: props.title,
    tags: (props.tags || []).join(','),
    caption: props.caption,
    posttype: props.posttype || 'link',
}); }, {
    windowWidth: 660,
    windowHeight: 460,
});
 var _unused_webpack_default_export = (TumblrShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(98);
 var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareCount__ = __webpack_require__(99);



function getTumblrShareCount(shareUrl, callback) {
    var endpoint = 'https://api.tumblr.com/v2/share/stats';
    return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: shareUrl,
        }), function (err, data) {
        callback(!err && data && data.response ? data.response.note_count : undefined);
    });
}
 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareCount__["a" ])(getTumblrShareCount));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var TwitterIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#00aced',
    networkName: 'twitter',
    path: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
});
 __webpack_exports__["a"] = (TwitterIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'twitter.url');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(Array.isArray(hashtags), 'twitter.hashtags is not an array');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(Array.isArray(related), 'twitter.related is not an array');
    return ('https://twitter.com/share' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: url,
            text: title,
            via: via,
            hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
            related: related.length > 0 ? related.join(',') : undefined,
        }));
}
var TwitterShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('twitter', twitterLink, function (props) { return ({
    hashtags: props.hashtags,
    title: props.title,
    via: props.via,
    related: props.related,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
 __webpack_exports__["a"] = (TwitterShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var ViberIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#7C529E',
    networkName: 'viber',
    path: 'm31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z',
});
 var _unused_webpack_default_export = (ViberIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function viberLink(url, _a) {
    var title = _a.title, separator = _a.separator;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'viber.url');
    return ('viber://forward' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            text: title ? title + separator + url : url,
        }));
}
var ViberShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('viber', viberLink, function (props) { return ({
    title: props.title,
    separator: props.separator || ' ',
}); }, {
    windowWidth: 660,
    windowHeight: 460,
});
 var _unused_webpack_default_export = (ViberShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var VKIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#45668e',
    networkName: 'vk',
    path: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
});
 var _unused_webpack_default_export = (VKIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function vkLink(url, _a) {
    var title = _a.title, image = _a.image, noParse = _a.noParse, noVkLinks = _a.noVkLinks;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'vk.url');
    return ('https://vk.com/share.php' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: url,
            title: title,
            image: image,
            noparse: noParse ? 1 : 0,
            no_vk_links: noVkLinks ? 1 : 0,
        }));
}
var VKShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('vk', vkLink, function (props) { return ({
    title: props.title,
    image: props.image,
    noParse: props.noParse,
    noVkLinks: props.noVkLinks,
}); }, {
    windowWidth: 660,
    windowHeight: 460,
});
 var _unused_webpack_default_export = (VKShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(98);
 var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareCount__ = __webpack_require__(99);



function getVKShareCount(shareUrl, callback) {
    if (!window.VK)
        window.VK = {};
    window.VK.Share = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        count: function (index, count) { return window.VK.callbacks[index](count); },
    };
    window.VK.callbacks = [];
    var url = 'https://vk.com/share.php';
    var index = window.VK.callbacks.length;
    window.VK.callbacks.push(callback);
    return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            act: 'count',
            index: index,
            url: shareUrl,
        }));
}
 var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareCount__["a" ])(getVKShareCount));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var WeiboIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#CD201F',
    networkName: 'weibo',
    path: 'M40.9756152,15.0217119 C40.5000732,15.0546301 39.9999314,15.1204666 39.5325878,15.2192213 C38.6634928,15.4085016 38.0977589,16.2643757 38.2863368,17.1284787 C38.4667163,18.0008129 39.3194143,18.5686519 40.1885094,18.3793715 C42.8613908,17.8115326 45.7720411,18.6427174 47.7316073,20.8153207 C49.6911735,22.996153 50.2077122,25.975254 49.3714112,28.5840234 C49.1008441,29.4316684 49.5763861,30.3533789 50.4208857,30.6249537 C51.2653852,30.8965286 52.1754769,30.4192153 52.4542425,29.5715703 C53.6349013,25.9011885 52.9133876,21.7699494 50.1585171,18.7085538 C48.0923641,16.4042776 45.2063093,15.1533848 42.3530505,15.0217119 C41.8775084,14.9970227 41.4511594,14.9887937 40.9756152,15.0217119 Z M27.9227762,19.8277737 C24.9957268,20.140498 20.863421,22.4365431 17.2312548,26.0822378 C13.2711279,30.0571148 11,34.2871065 11,37.9328012 C11,44.9032373 19.8713401,49.125 28.5786978,49.125 C39.9917329,49.125 47.600423,42.4261409 47.600423,37.1427636 C47.600423,33.9496952 44.9603397,32.1638816 42.549827,31.4149913 C41.9594976,31.2339421 41.5167516,31.1434164 41.8283133,30.3616079 C42.5006339,28.66632 42.6236176,27.1932286 41.8939054,26.1480742 C40.5328692,24.1894405 36.7203236,24.2881952 32.448635,26.0822378 C32.448635,26.0822378 31.1203949,26.6912261 31.4647526,25.6213825 C32.1206742,23.4981576 32.0304845,21.712342 31.0056075,20.6836478 C30.2840938,19.9512176 29.2510184,19.6878718 27.9227762,19.8277737 Z M42.0906819,20.6836478 C41.6233383,20.6589586 41.1723917,20.716566 40.7132466,20.8153207 C39.9671353,20.9716828 39.4997917,21.7781784 39.6637721,22.5270687 C39.8277525,23.275959 40.5574647,23.7450433 41.303576,23.5804521 C42.1972686,23.3911718 43.2057485,23.6380596 43.8616701,24.3704897 C44.5175916,25.1029198 44.6733735,26.0657797 44.3864073,26.9381118 C44.1486363,27.6705419 44.5093932,28.4770397 45.2391054,28.7156963 C45.9688176,28.9461239 46.780521,28.5922524 47.0100936,27.8598223 C47.584026,26.0740087 47.2396661,24.0248493 45.8950269,22.5270687 C44.886547,21.4078489 43.4845162,20.7494842 42.0906819,20.6836478 Z M29.496988,29.9665891 C35.3100922,30.1723275 39.9917329,33.0691319 40.3852858,37.0769272 C40.8362324,41.6607904 35.5970585,45.9319315 28.6442899,46.6232144 C21.6915214,47.3144973 15.6488446,44.154347 15.197898,39.5787128 C14.7469514,34.9948495 20.059916,30.7237084 27.004486,30.0324256 C27.8735831,29.950131 28.6688875,29.9336709 29.496988,29.9665891 Z M25.5614586,34.3776322 C23.183744,34.5916017 20.9372116,35.9577073 19.9205332,37.9328012 C18.5348994,40.6238672 19.9041362,43.6029661 23.0689567,44.582284 C26.340366,45.5945202 30.1857056,44.0638213 31.5303448,41.1587879 C32.8503864,38.3195909 31.1613894,35.3734082 27.9227762,34.5751416 C27.1438688,34.3776322 26.356763,34.3035667 25.5614586,34.3776322 Z M24.052839,38.7228388 C24.3316067,38.7310678 24.5857748,38.8215935 24.8399449,38.9203482 C25.8648218,39.3400561 26.1845841,40.4428158 25.5614586,41.4221338 C24.9219361,42.3932227 23.5690963,42.8623069 22.5442194,42.4096807 C21.5357395,41.9652856 21.2487754,40.8542948 21.8882979,39.9078951 C22.3638421,39.2001542 23.2247386,38.7146097 24.052839,38.7228388 Z',
});
 var _unused_webpack_default_export = (WeiboIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function weiboLink(url, _a) {
    var title = _a.title, image = _a.image;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'weibo.url');
    return ('http://service.weibo.com/share/share.php' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            url: url,
            title: title,
            pic: image,
        }));
}
var WeiboShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('weibo', weiboLink, function (props) { return ({
    title: props.title,
    image: props.image,
}); }, {
    windowWidth: 660,
    windowHeight: 550,
    windowPosition: 'screenCenter',
});
 var _unused_webpack_default_export = (WeiboShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var WhatsappIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#25D366',
    networkName: 'whatsapp',
    path: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
});
 __webpack_exports__["a"] = (WhatsappIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function isMobileOrTablet() {
    return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}
function whatsappLink(url, _a) {
    var title = _a.title, separator = _a.separator;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'whatsapp.url');
    return ('https://' +
        (isMobileOrTablet() ? 'api' : 'web') +
        '.whatsapp.com/send' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            text: title ? title + separator + url : url,
        }));
}
var WhatsappShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('whatsapp', whatsappLink, function (props) { return ({
    title: props.title,
    separator: props.separator || ' ',
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
 __webpack_exports__["a"] = (WhatsappShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__ = __webpack_require__(27);

var WorkplaceIcon = Object(__WEBPACK_IMPORTED_MODULE_0__hocs_createIcon__["a" ])({
    color: '#3b3d4a',
    networkName: 'workplace',
    path: 'M34.019,10.292c0.21,0.017,0.423,0.034,0.636,0.049 c3.657,0.262,6.976,1.464,9.929,3.635c3.331,2.448,5.635,5.65,6.914,9.584c0.699,2.152,0.983,4.365,0.885,6.623 c-0.136,3.171-1.008,6.13-2.619,8.867c-0.442,0.75-0.908,1.492-1.495,2.141c-0.588,0.651-1.29,1.141-2.146,1.383 c-1.496,0.426-3.247-0.283-3.961-1.642c-0.26-0.494-0.442-1.028-0.654-1.548c-1.156-2.838-2.311-5.679-3.465-8.519 c-0.017-0.042-0.037-0.082-0.065-0.145c-0.101,0.245-0.192,0.472-0.284,0.698c-1.237,3.051-2.475,6.103-3.711,9.155 c-0.466,1.153-1.351,1.815-2.538,2.045c-1.391,0.267-2.577-0.154-3.496-1.247c-0.174-0.209-0.31-0.464-0.415-0.717 c-2.128-5.22-4.248-10.442-6.37-15.665c-0.012-0.029-0.021-0.059-0.036-0.104c0.054-0.003,0.103-0.006,0.15-0.006 c1.498-0.001,2.997,0,4.495-0.004c0.12-0.001,0.176,0.03,0.222,0.146c1.557,3.846,3.117,7.691,4.679,11.536 c0.018,0.046,0.039,0.091,0.067,0.159c0.273-0.673,0.536-1.32,0.797-1.968c1.064-2.627,2.137-5.25,3.19-7.883 c0.482-1.208,1.376-1.917,2.621-2.135c1.454-0.255,2.644,0.257,3.522,1.449c0.133,0.18,0.229,0.393,0.313,0.603 c1.425,3.495,2.848,6.991,4.269,10.488c0.02,0.047,0.04,0.093,0.073,0.172c0.196-0.327,0.385-0.625,0.559-0.935 c0.783-1.397,1.323-2.886,1.614-4.461c0.242-1.312,0.304-2.634,0.187-3.962c-0.242-2.721-1.16-5.192-2.792-7.38 c-2.193-2.939-5.086-4.824-8.673-5.625c-1.553-0.346-3.124-0.405-4.705-0.257c-3.162,0.298-6.036,1.366-8.585,3.258 c-3.414,2.534-5.638,5.871-6.623,10.016c-0.417,1.76-0.546,3.547-0.384,5.348c0.417,4.601,2.359,8.444,5.804,11.517 c2.325,2.073,5.037,3.393,8.094,3.989c1.617,0.317,3.247,0.395,4.889,0.242c1-0.094,1.982-0.268,2.952-0.529 c0.04-0.01,0.081-0.018,0.128-0.028c0,1.526,0,3.047,0,4.586c-0.402,0.074-0.805,0.154-1.21,0.221 c-0.861,0.14-1.728,0.231-2.601,0.258c-0.035,0.002-0.071,0.013-0.108,0.021c-0.493,0-0.983,0-1.476,0 c-0.049-0.007-0.1-0.018-0.149-0.022c-0.315-0.019-0.629-0.033-0.945-0.058c-1.362-0.105-2.702-0.346-4.017-0.716 c-3.254-0.914-6.145-2.495-8.66-4.752c-2.195-1.971-3.926-4.29-5.176-6.963c-1.152-2.466-1.822-5.057-1.993-7.774 c-0.014-0.226-0.033-0.451-0.05-0.676c0-0.502,0-1.003,0-1.504c0.008-0.049,0.02-0.099,0.022-0.148 c0.036-1.025,0.152-2.043,0.338-3.052c0.481-2.616,1.409-5.066,2.8-7.331c2.226-3.625,5.25-6.386,9.074-8.254 c2.536-1.24,5.217-1.947,8.037-2.126c0.23-0.015,0.461-0.034,0.691-0.051C33.052,10.292,33.535,10.292,34.019,10.292z',
});
 var _unused_webpack_default_export = (WorkplaceIcon);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(30);
 var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
 var __WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__ = __webpack_require__(28);



function workplaceLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" ])(url, 'workplace.url');
    return ('https://work.facebook.com/sharer.php' +
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" ])({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var WorkplaceShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__hocs_createShareButton__["a" ])('workplace', workplaceLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
 var _unused_webpack_default_export = (WorkplaceShareButton);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ShareModalWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n.share_modal {\n  align-items: center;\n  margin-top: 30vh;\n  width: 40vw;\n  overflow: hidden;\n  border-radius: 1.2rem;\n\n  @media (max-width: ','px) {\n    width: 96vw;\n  }\n  \n  .title {\n    width: 80%;\n    margin: 0% 10%;\n    margin-bottom: 5%;\n    text-align: center;\n\n    h2 {\n      font-size: 24px;\n      font-weight: 600;\n\n      @media (max-width: ','px) {\n        font-size: 16px;\n      }\n    }\n  }\n\n  .sm_icons {\n    width: 80%;\n    margin: 0% 10%;\n    margin-bottom: 10%;\n\n    .icon_mail {\n      width: 25%;\n      float: right;\n      text-align: center;\n    }\n\n    .icon_whatsapp {\n      width: 25%;\n      float: right;\n      text-align: center;\n    }\n\n    .icon_fb {\n      width: 25%;\n      float: right;\n      text-align: center;\n    }\n\n    .icon_tw {\n      width: 25%;\n      float: right;\n      text-align: center;\n    }\n  }\n}\n'],['\n.share_modal {\n  align-items: center;\n  margin-top: 30vh;\n  width: 40vw;\n  overflow: hidden;\n  border-radius: 1.2rem;\n\n  @media (max-width: ','px) {\n    width: 96vw;\n  }\n  \n  .title {\n    width: 80%;\n    margin: 0% 10%;\n    margin-bottom: 5%;\n    text-align: center;\n\n    h2 {\n      font-size: 24px;\n      font-weight: 600;\n\n      @media (max-width: ','px) {\n        font-size: 16px;\n      }\n    }\n  }\n\n  .sm_icons {\n    width: 80%;\n    margin: 0% 10%;\n    margin-bottom: 10%;\n\n    .icon_mail {\n      width: 25%;\n      float: right;\n      text-align: center;\n    }\n\n    .icon_whatsapp {\n      width: 25%;\n      float: right;\n      text-align: center;\n    }\n\n    .icon_fb {\n      width: 25%;\n      float: right;\n      text-align: center;\n    }\n\n    .icon_tw {\n      width: 25%;\n      float: right;\n      text-align: center;\n    }\n  }\n}\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ShareModalWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Modal__["a" ])(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no_tools.eda93c98.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return CreationForm; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ToolRow; });
 var __WEBPACK_IMPORTED_MODULE_0__container_CreationForm__ = __webpack_require__(1368);
 var __WEBPACK_IMPORTED_MODULE_1__container_ToolRow__ = __webpack_require__(1370);
var CreationForm=__WEBPACK_IMPORTED_MODULE_0__container_CreationForm__["a" ];var ToolRow=__WEBPACK_IMPORTED_MODULE_1__container_ToolRow__["a" ];

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3__modules_actions__ = __webpack_require__(487);
 var __WEBPACK_IMPORTED_MODULE_4__components_CreationForm__ = __webpack_require__(1369);
function mapStateToProps(state){return{literals:state.i18n.literals.tools||{},app:state.app,user:state.session.user,saveToolStatus:state.tools.saveToolStatus,savedTool:state.tools.savedTool};}function mapDispatchToProps(dispatch){return{saveTool:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3__modules_actions__["b" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components_CreationForm__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_constants_status__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreationForm=function(_Component){_inherits(CreationForm,_Component);function CreationForm(props){_classCallCheck(this,CreationForm);var _this=_possibleConstructorReturn(this,(CreationForm.__proto__||Object.getPrototypeOf(CreationForm)).call(this,props));_initialiseProps.call(_this);var tool=props.tool;var id=tool?tool.id:0;var name=tool?tool.name:'';var description=tool?tool.description:'';var url=tool?tool.url:'';_this.state={id:id,name:name,description:description,url:url,errors:[]};return _this;}_createClass(CreationForm,[{key:'componentDidUpdate',value:function componentDidUpdate(_ref){var prevSaveStatus=_ref.saveToolStatus;var _props=this.props,saveToolStatus=_props.saveToolStatus,onSave=_props.onSave,savedTool=_props.savedTool;if(saveToolStatus!==prevSaveStatus&&saveToolStatus===__WEBPACK_IMPORTED_MODULE_3_constants_status__["g" ]&&onSave){onSave(savedTool);}}},{key:'render',value:function render(){var literals=this.props.literals;var _state=this.state,name=_state.name,description=_state.description,url=_state.url,errors=_state.errors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_title'},literals.createNewTool),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_title'},literals.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form_icon_required'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form_input_stl '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(errors,function(error){return error==='name';})?'error':''),value:name,onChange:this.handleChangeName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_title'},literals.description,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form_icon_required'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form_input_stl '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(errors,function(error){return error==='description';})?'error':''),onChange:this.handleChangeDescription},description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_title'},literals.url,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form_icon_required'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_question_input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form_input_stl '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(errors,function(error){return error==='url';})?'error':''),value:url,onChange:this.handleChangeUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_buttons'},errors.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error_msg'},literals.errorRequiredFields):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:this.handleSubmit},literals.save),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'cancel',onClick:this.handleCancel},literals.cancel)));}}]);return CreationForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleChangeName=function(event){var value=event.target.value;_this2.setState({name:value});};this.handleChangeDescription=function(event){var value=event.target.value;_this2.setState({description:value});};this.handleChangeUrl=function(event){var value=event.target.value;_this2.setState({url:value});};this.handleCancel=function(){var onCancel=_this2.props.onCancel;onCancel();};this.handleSubmit=function(){var _props2=_this2.props,saveTool=_props2.saveTool,elementType=_props2.elementType,elementId=_props2.elementId;var _state2=_this2.state,id=_state2.id,name=_state2.name,description=_state2.description,url=_state2.url;var checked=_this2.checkForm();if(!checked){return false;}var tool={id:id,name:name,description:description,url:url,element_type:elementType,element_id:elementId};saveTool(tool);return true;};this.checkForm=function(){var _state3=_this2.state,name=_state3.name,description=_state3.description,url=_state3.url;var errors=[];if(!name){errors.push('name');}if(!description){errors.push('description');}if(!url){errors.push('url');}_this2.setState({errors:errors});return errors.length===0;};};CreationForm.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,saveTool:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,elementType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,elementId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,savedTool:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,saveToolStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onSave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,tool:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};CreationForm.defaultProps={savedTool:null,saveToolStatus:null,onSave:null,tool:null}; __webpack_exports__["a"] = (CreationForm);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3__modules_actions__ = __webpack_require__(487);
 var __WEBPACK_IMPORTED_MODULE_4__components_ToolRow__ = __webpack_require__(1371);
function mapStateToProps(state){return{literals:state.i18n.literals.tools||{},app:state.app,deleteToolStatus:state.tools.deleteToolStatus};}function mapDispatchToProps(dispatch){return{deleteTool:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3__modules_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components_ToolRow__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Popover__ = __webpack_require__(402);
 var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_4_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1372);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ToolRow=function(_Component){_inherits(ToolRow,_Component);function ToolRow(props){_classCallCheck(this,ToolRow);var _this=_possibleConstructorReturn(this,(ToolRow.__proto__||Object.getPrototypeOf(ToolRow)).call(this,props));_this.handleClickDialog=function(event){_this.setState({openDialog:true,anchorEl:event.currentTarget});};_this.handleCloseDialog=function(){_this.setState({openDialog:false,anchorEl:null});};_this.handleClickEdit=function(){var _this$props=_this.props,onEdit=_this$props.onEdit,id=_this$props.tool.id;_this.handleCloseDialog();onEdit(id);};_this.handleClickRemove=function(){_this.setState({showConfirmRemove:true});_this.handleCloseDialog();};_this.handleCloseConfirm=function(){_this.setState({showConfirmRemove:false});};_this.handleSubmitRemove=function(){var _this$props2=_this.props,deleteTool=_this$props2.deleteTool,id=_this$props2.tool.id;_this.handleCloseConfirm();deleteTool(id);};_this.state={openDialog:false,anchorEl:null,showConfirmRemove:false};return _this;}_createClass(ToolRow,[{key:'componentDidUpdate',value:function componentDidUpdate(_ref){var prevDeleteStatus=_ref.deleteToolStatus;var _props=this.props,deleteToolStatus=_props.deleteToolStatus,onDelete=_props.onDelete,id=_props.tool.id;if(prevDeleteStatus!==deleteToolStatus&&deleteToolStatus===__WEBPACK_IMPORTED_MODULE_4_constants_status__["g" ]&&onDelete){onDelete(id);}}},{key:'render',value:function render(){var _props2=this.props,tool=_props2.tool,color=_props2.app.color1,literals=_props2.literals;var _state=this.state,openDialog=_state.openDialog,anchorEl=_state.anchorEl,showConfirmRemove=_state.showConfirmRemove;var hasImage=!!tool.image;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["b" ],{color:color,hasImage:hasImage},hasImage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:tool.image})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},tool.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},tool.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:tool.url,className:'url',target:'_blank',rel:'noopener noreferrer'},tool.url)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" ],{onClick:this.handleClickDialog}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Popover__["a" ],{open:openDialog,anchorEl:anchorEl,onClose:this.handleCloseDialog,anchorOrigin:{vertical:'top',horizontal:'left'},transformOrigin:{vertical:'top',horizontal:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal_dialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.handleClickEdit},literals.edit),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'danger',onClick:this.handleClickRemove},literals.remove))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal__["a" ],{open:showConfirmRemove,onClose:this.handleCloseConfirm,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.confirmRemoveToolTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle'},literals.confirmRemoveToolSubtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'danger',onClick:this.handleSubmitRemove},literals.remove),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'cancel',onClick:this.handleCloseConfirm},literals.cancel)))));}}]);return ToolRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ToolRow.propTypes={tool:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,deleteTool:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,deleteToolStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};ToolRow.defaultProps={deleteToolStatus:null,onDelete:null}; __webpack_exports__["a"] = (ToolRow);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return ToolRowWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return IconOptions; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_MoreVert__ = __webpack_require__(1373);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_MoreVert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_MoreVert__);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 15px;\n  background-color: #fafafa;\n  border: 1px solid #eee;\n  position: relative;\n  margin-bottom: 10px;\n\n  .image {\n    display: inline-block;\n    vertical-align: top;\n    width: 65px;\n\n    img {\n      width: 60px;\n      height: 60px;\n    }\n  }\n\n  .content {\n    display: inline-block;\n    vertical-align: top;\n    width: ',';\n\n    .name {\n      font-weight: 600;\n      font-size: 14px;\n      color: #444;\n      height: 20px;\n      text-overflow: ellipsis;\n      font-family: \'helvetica neue\';\n    }\n\n    .description {\n      font-size: 12px;\n      color: #666;\n      line-height: 14px;\n      margin: 10px 0;\n    }\n\n    .url {\n      font-size: 12px;\n      text-decoration: underline;\n      color: ',';\n    }\n  }\n'],['\n  padding: 15px;\n  background-color: #fafafa;\n  border: 1px solid #eee;\n  position: relative;\n  margin-bottom: 10px;\n\n  .image {\n    display: inline-block;\n    vertical-align: top;\n    width: 65px;\n\n    img {\n      width: 60px;\n      height: 60px;\n    }\n  }\n\n  .content {\n    display: inline-block;\n    vertical-align: top;\n    width: ',';\n\n    .name {\n      font-weight: 600;\n      font-size: 14px;\n      color: #444;\n      height: 20px;\n      text-overflow: ellipsis;\n      font-family: \'helvetica neue\';\n    }\n\n    .description {\n      font-size: 12px;\n      color: #666;\n      line-height: 14px;\n      margin: 10px 0;\n    }\n\n    .url {\n      font-size: 12px;\n      text-decoration: underline;\n      color: ',';\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: absolute;\n  right: -10px;\n  top: 0px;\n  cursor: pointer;\n'],['\n  position: absolute;\n  right: -10px;\n  top: 0px;\n  cursor: pointer;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ToolRowWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.hasImage?'calc(100% - 70px)':'100%';},function(props){return props.color;});var IconOptions=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_MoreVert___default.a)(_templateObject2);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

var _interopRequireWildcard = __webpack_require__(452);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(454));

var _default = (0, _createSvgIcon.default)( React.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');

exports.default = _default;

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "x", function() { return ThinkTankSection; });
 __webpack_require__.d(__webpack_exports__, "v", function() { return ThinkTankContent; });
 __webpack_require__.d(__webpack_exports__, "z", function() { return ThinkTankTabs; });
 __webpack_require__.d(__webpack_exports__, "y", function() { return ThinkTankTab; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return TabContent; });
 __webpack_require__.d(__webpack_exports__, "w", function() { return ThinkTankHeader; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return BackArrow; });
 __webpack_require__.d(__webpack_exports__, "A", function() { return Title; });

 __webpack_require__.d(__webpack_exports__, "f", function() { return Buttons; });
 __webpack_require__.d(__webpack_exports__, "u", function() { return TabContentMargin; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return DocIframe; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return BtnAddUsers; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return BtnShare; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return DesktopVersion; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return DesktopChat; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return DesktopTabs; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return InfoSection; });

 __webpack_require__.d(__webpack_exports__, "l", function() { return NoPermission; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return NoPermissionTitle; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return NoPermissionSubtitle; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return NoPermissionDesc; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return NoPermissionImg; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return ButtonNextWrapper; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return Button; });
 __webpack_require__.d(__webpack_exports__, "s", function() { return RequestButtons; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return RequestButtonAccept; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return RequestButtonReject; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
 var __WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  // background-color: #f5f5f5;\n\n  @media (max-width: ','px) {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    z-index: 300;\n    height: 100%;\n    width: 100%;\n  }\n'],['\n  // background-color: #f5f5f5;\n\n  @media (max-width: ','px) {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    z-index: 300;\n    height: 100%;\n    width: 100%;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  .invite_users_tab_content {\n    margin-top: 15px;\n    .face_bubble {\n      &.selected {\n        .face_bubble_image {\n          box-shadow: 0px 0px 0px 6px rgba(100, 221, 23,0.8);\n        }\n      }\n      .face_bubble_text {\n        color: #444;\n      }\n    }\n  }\n'],['\n  .invite_users_tab_content {\n    margin-top: 15px;\n    .face_bubble {\n      &.selected {\n        .face_bubble_image {\n          box-shadow: 0px 0px 0px 6px rgba(100, 221, 23,0.8);\n        }\n      }\n      .face_bubble_text {\n        color: #444;\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  background-color: #e9e9e9;\n  white-space: nowrap;\n  left: 0px;\n  position: relative;\n  z-index: 400;\n  width: 100%;\n  z-index: 2;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: stretch;\n  align-content: stretch;\n  height: 40px;\n'],['\n  background-color: #e9e9e9;\n  white-space: nowrap;\n  left: 0px;\n  position: relative;\n  z-index: 400;\n  width: 100%;\n  z-index: 2;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: stretch;\n  align-content: stretch;\n  height: 40px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  text-align: center;\n  padding: 10px;\n  flex-shrink: 0;\n  flex-grow: 1;\n  color: ',';\n  font-size: 14px;\n  font-weight: 600;\n\n  ',';\n'],['\n  text-align: center;\n  padding: 10px;\n  flex-shrink: 0;\n  flex-grow: 1;\n  color: ',';\n  font-size: 14px;\n  font-weight: 600;\n\n  ',';\n']),_templateObject5=_taggedTemplateLiteral(['  \n  margin: 0 auto;\n  overflow: auto;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n  top: calc(100px + env(safe-area-inset-top));\n  height: calc(100vh - 149px - env(safe-area-inset-top));\n  background-color: #f5f5f5;\n\n  .no_elements {\n    > div {\n      color: ',';\n    }\n  }\n\n  @media (max-width: ','px) {\n    height: calc(100vh - 100px - env(safe-area-inset-top));\n\n    .chat_messages {\n      margin-top: 100px;\n    }\n  \n  }\n'],['  \n  margin: 0 auto;\n  overflow: auto;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n  top: calc(100px + env(safe-area-inset-top));\n  height: calc(100vh - 149px - env(safe-area-inset-top));\n  background-color: #f5f5f5;\n\n  .no_elements {\n    > div {\n      color: ',';\n    }\n  }\n\n  @media (max-width: ','px) {\n    height: calc(100vh - 100px - env(safe-area-inset-top));\n\n    .chat_messages {\n      margin-top: 100px;\n    }\n  \n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  background-color: #fff;\n  padding: 5px 10px;\n  padding-top: calc(5px + env(safe-area-inset-top));\n  margin: 0 auto;\n  height: calc(60px + env(safe-area-inset-top));;\n  line-height: 50px;\n  border-bottom: 1px solid #eee;\n  position: relative;\n  z-index: 300;\n'],['\n  background-color: #fff;\n  padding: 5px 10px;\n  padding-top: calc(5px + env(safe-area-inset-top));\n  margin: 0 auto;\n  height: calc(60px + env(safe-area-inset-top));;\n  line-height: 50px;\n  border-bottom: 1px solid #eee;\n  position: relative;\n  z-index: 300;\n']),_templateObject7=_taggedTemplateLiteral(['\n  width: 30px;\n  vertical-align: middle;\n  text-align: center;\n  display: inline-block;\n\n  i {\n    color: #666;\n    cursor: pointer;\n    font-size: 16px;\n  }\n'],['\n  width: 30px;\n  vertical-align: middle;\n  text-align: center;\n  display: inline-block;\n\n  i {\n    color: #666;\n    cursor: pointer;\n    font-size: 16px;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: top;\n  width: calc(100% - 30%);\n  text-align: center;\n  margin-left: 10px;  \n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media (max-width: ','px) {\n      width: calc(100% - 40%);\n      margin-left: 5px;\n  }\n  \n\n  .avatar_image {\n    float:left;\n    text-align: center;\n    align-items: middle;\n    vertical-align: middle;\n    cursor: pointer;\n  }\n\n  .header_text {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 17px;\n    text-align: left;\n    width: calc(100% - 50px);\n    margin-left: 5px;\n\n    @media (max-width: ','px) {\n        width: calc(100% - 30%);\n        margin-left: 0px;\n    }\n\n    .name_think_tank {\n      color: #444;\n      font-size: 14px;\n      font-weight: 600;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      \n      p {\n        cursor: pointer;\n        margin: 0;\n      }\n    }\n\n    .users_list {\n      color: #666;\n      font-size: 12px;\n      font-weight: 300;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      width: 95%;\n      overflow: hidden;\n    }\n  }\n'],['\n  display: inline-block;\n  vertical-align: top;\n  width: calc(100% - 30%);\n  text-align: center;\n  margin-left: 10px;  \n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media (max-width: ','px) {\n      width: calc(100% - 40%);\n      margin-left: 5px;\n  }\n  \n\n  .avatar_image {\n    float:left;\n    text-align: center;\n    align-items: middle;\n    vertical-align: middle;\n    cursor: pointer;\n  }\n\n  .header_text {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 17px;\n    text-align: left;\n    width: calc(100% - 50px);\n    margin-left: 5px;\n\n    @media (max-width: ','px) {\n        width: calc(100% - 30%);\n        margin-left: 0px;\n    }\n\n    .name_think_tank {\n      color: #444;\n      font-size: 14px;\n      font-weight: 600;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      \n      p {\n        cursor: pointer;\n        margin: 0;\n      }\n    }\n\n    .users_list {\n      color: #666;\n      font-size: 12px;\n      font-weight: 300;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      width: 95%;\n      overflow: hidden;\n    }\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  overflow: auto;\n  left: 0px;\n  width: 100%;\n  z-index: 1;\n  height: calc(100vh - 150px);\n'],['\n  overflow: auto;\n  left: 0px;\n  width: 100%;\n  z-index: 1;\n  height: calc(100vh - 150px);\n']),_templateObject10=_taggedTemplateLiteral(['\n  text-align: center;\n'],['\n  text-align: center;\n']),_templateObject11=_taggedTemplateLiteral(['\n  width: 90%;\n  margin: 10px 5%;\n'],['\n  width: 90%;\n  margin: 10px 5%;\n']),_templateObject12=_taggedTemplateLiteral(['\n  width: 100%;\n  height: calc(100vh - 155px);\n  border: 0px;\n  background-color: #fff;\n\n  @media (max-width: ','px) {\n    height: calc(100vh - 100px);\n  }\n'],['\n  width: 100%;\n  height: calc(100vh - 155px);\n  border: 0px;\n  background-color: #fff;\n\n  @media (max-width: ','px) {\n    height: calc(100vh - 100px);\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  width: 40px;\n  height: 40px;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  line-height: 46px;\n  float: right;\n  margin: 5px;\n\n  i {\n    font-size: 14px;\n    color: #888;\n  }\n'],['\n  width: 40px;\n  height: 40px;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  line-height: 46px;\n  float: right;\n  margin: 5px;\n\n  i {\n    font-size: 14px;\n    color: #888;\n  }\n']),_templateObject14=_taggedTemplateLiteral(['\n  width: 40px;\n  height: 40px;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  vertical-align: middle;\n  text-align: center;\n  float: right;\n  margin: 5px;\n\n  i {\n    font-size: 18px;\n    color: #888;\n  }\n'],['\n  width: 40px;\n  height: 40px;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  vertical-align: middle;\n  text-align: center;\n  float: right;\n  margin: 5px;\n\n  i {\n    font-size: 18px;\n    color: #888;\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  flex-flow: center;\n  align-items: flex-start;\n'],['\n  display: flex;\n  flex-direction: row;\n  flex-flow: center;\n  align-items: flex-start;\n']),_templateObject16=_taggedTemplateLiteral(['\n  flex-grow: 1;\n\n  .chat_wrapper {\n    position: relative;\n  }\n\n  .chat_form_wrapper {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n  }\n'],['\n  flex-grow: 1;\n\n  .chat_wrapper {\n    position: relative;\n  }\n\n  .chat_form_wrapper {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  flex-grow: 3;\n\n  .tabs {\n    position: relative;\n    top: 0px;\n  }\n\n  .tab_content {\n    position: relative;\n    top: 0px;\n    background-color: #f5f5f5;\n  }\n'],['\n  flex-grow: 3;\n\n  .tabs {\n    position: relative;\n    top: 0px;\n  }\n\n  .tab_content {\n    position: relative;\n    top: 0px;\n    background-color: #f5f5f5;\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  background-color: #f5f5f5;\n  height: 94.8vh;\n\n  @media (max-width: ','px) {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    z-index: 300;\n    height: 100%;\n    width: 100%;\n  }\n\n  .header {\n    display: block;\n    position: relative;\n    width: 100%;\n    margin: 0 auto;\n    height: 100px;\n    line-height: 50px;\n    border-bottom: 1px solid #eee;\n    background-image: url(',');\n    background-repeat: no-repeat,repeat;\n    background-position: center;\n    background-size: cover;\n    padding-top: env(safe-area-inset-top);\n    white-space: nowrap;\n\n    .edit_image_layer {\n      position: absolute;\n      right: 10px;\n      top: calc(0px + env(safe-area-inset-top));\n      z-index: 2;\n\n      i {\n        color: #fff;\n        cursor: pointer;\n        font-size: 16px;\n        margin-left: 10px;\n      }\n    }\n\n    .arrow_layer {\n      display: inline-block;\n      width: 50px;\n      vertical-align: middle;\n      position: relative;\n      z-index: 2;\n      float: left;\n\n      i {\n        color: #fff;\n        cursor: pointer;\n        font-size: 16px;\n        margin-left: 10px;\n      }\n    }\n\n    .title_layer {\n      display: flex;\n      flex-direction: column;\n      margin: 0% 2%;\n      margin-top: env(safe-area-inset-top); \n      color: #fff;\n      font-size: 14px;\n      font-weight: 600;\n      position: relative;\n      z-index: 2;\n      height: 50%;\n      overflow: hidden;\n      width: calc(100% - 100px);\n\n      .title_content {\n        height: 100%;\n        display: inline-block;\n        vertical-align: middle;\n        color: #fff;\n        font-size: 25px;\n        font-weight: 600;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        width: 100%;\n      }\n    }\n  }\n\n  .title_header {\n    margin: 2% 5%;\n    font-size: 22px;\n    font-weight: 800;\n    text-align: center;\n  }\n\n  .description_layer {\n    margin-left: 5%;\n    margin-right: 25%;\n    \n\n    .description_title {\n      font-weight: 400;\n      font-size: 16px;\n      color: rgb(68, 68, 68);\n      font-family: \'helvetica neue\';\n      line-height: 3.2rem;\n      margin-top: 2rem;\n      margin-bottom: 1rem;\n    }\n\n    .description_content {\n      color: #444;\n      font-size: 14px;\n    }\n  }\n\n  .members {\n    margin-left: 5%;\n    margin-right: 25%;\n\n    .members_title {\n      font-weight: 400;\n      font-size: 16px;\n      color: rgb(68, 68, 68);\n      font-family: \'helvetica neue\';\n      line-height: 3.2rem;\n      margin-top: 2rem;\n      margin-bottom: 2rem;\n    }\n  }\n\n  .req_members {\n    margin-left: 5%;\n    margin-right: 25%;\n\n    .req_members_title {\n      font-size: 17px;\n      color: rgb(68, 68, 68);\n      font-family: \'helvetica neue\';\n      line-height: 3.2rem;\n      margin-top: 2rem;\n      margin-bottom: 1rem;\n    }\n  }\n\n  .deleteButton {\n    position: absolute;\n    width: 50%\n    text-align: center;\n    left: 25%;\n    bottom: 2%;\n  }\n'],['\n  background-color: #f5f5f5;\n  height: 94.8vh;\n\n  @media (max-width: ','px) {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    z-index: 300;\n    height: 100%;\n    width: 100%;\n  }\n\n  .header {\n    display: block;\n    position: relative;\n    width: 100%;\n    margin: 0 auto;\n    height: 100px;\n    line-height: 50px;\n    border-bottom: 1px solid #eee;\n    background-image: url(',');\n    background-repeat: no-repeat,repeat;\n    background-position: center;\n    background-size: cover;\n    padding-top: env(safe-area-inset-top);\n    white-space: nowrap;\n\n    .edit_image_layer {\n      position: absolute;\n      right: 10px;\n      top: calc(0px + env(safe-area-inset-top));\n      z-index: 2;\n\n      i {\n        color: #fff;\n        cursor: pointer;\n        font-size: 16px;\n        margin-left: 10px;\n      }\n    }\n\n    .arrow_layer {\n      display: inline-block;\n      width: 50px;\n      vertical-align: middle;\n      position: relative;\n      z-index: 2;\n      float: left;\n\n      i {\n        color: #fff;\n        cursor: pointer;\n        font-size: 16px;\n        margin-left: 10px;\n      }\n    }\n\n    .title_layer {\n      display: flex;\n      flex-direction: column;\n      margin: 0% 2%;\n      margin-top: env(safe-area-inset-top); \n      color: #fff;\n      font-size: 14px;\n      font-weight: 600;\n      position: relative;\n      z-index: 2;\n      height: 50%;\n      overflow: hidden;\n      width: calc(100% - 100px);\n\n      .title_content {\n        height: 100%;\n        display: inline-block;\n        vertical-align: middle;\n        color: #fff;\n        font-size: 25px;\n        font-weight: 600;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        width: 100%;\n      }\n    }\n  }\n\n  .title_header {\n    margin: 2% 5%;\n    font-size: 22px;\n    font-weight: 800;\n    text-align: center;\n  }\n\n  .description_layer {\n    margin-left: 5%;\n    margin-right: 25%;\n    \n\n    .description_title {\n      font-weight: 400;\n      font-size: 16px;\n      color: rgb(68, 68, 68);\n      font-family: \'helvetica neue\';\n      line-height: 3.2rem;\n      margin-top: 2rem;\n      margin-bottom: 1rem;\n    }\n\n    .description_content {\n      color: #444;\n      font-size: 14px;\n    }\n  }\n\n  .members {\n    margin-left: 5%;\n    margin-right: 25%;\n\n    .members_title {\n      font-weight: 400;\n      font-size: 16px;\n      color: rgb(68, 68, 68);\n      font-family: \'helvetica neue\';\n      line-height: 3.2rem;\n      margin-top: 2rem;\n      margin-bottom: 2rem;\n    }\n  }\n\n  .req_members {\n    margin-left: 5%;\n    margin-right: 25%;\n\n    .req_members_title {\n      font-size: 17px;\n      color: rgb(68, 68, 68);\n      font-family: \'helvetica neue\';\n      line-height: 3.2rem;\n      margin-top: 2rem;\n      margin-bottom: 1rem;\n    }\n  }\n\n  .deleteButton {\n    position: absolute;\n    width: 50%\n    text-align: center;\n    left: 25%;\n    bottom: 2%;\n  }\n']),_templateObject19=_taggedTemplateLiteral(['\n   && {\n    width: 32px;\n    height: 32px;\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 10px;\n    text-align: center;\n\n    &.text-avatar {\n      font-size: 21px;\n      padding-top: 0px;\n      line-height: 32px;\n    }\n   }\n'],['\n   && {\n    width: 32px;\n    height: 32px;\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 10px;\n    text-align: center;\n\n    &.text-avatar {\n      font-size: 21px;\n      padding-top: 0px;\n      line-height: 32px;\n    }\n   }\n']),_templateObject20=_taggedTemplateLiteral(['\n   display: flex; \n   flex-direction: column;\n   justify-content: center;\n   align-items: center;\n   height: 90vh;\n   color: white;\n   with: 90vw;\n   max-width: 600px;\n   text-align: center;\n   margin: 0 auto;\n'],['\n   display: flex; \n   flex-direction: column;\n   justify-content: center;\n   align-items: center;\n   height: 90vh;\n   color: white;\n   with: 90vw;\n   max-width: 600px;\n   text-align: center;\n   margin: 0 auto;\n']),_templateObject21=_taggedTemplateLiteral(['\n   font-size: 24px;\n   font-family: \'helvetica neue strong\';\n   @media (max-width: ','px) {\n      font-size: 18px;\n   }\n'],['\n   font-size: 24px;\n   font-family: \'helvetica neue strong\';\n   @media (max-width: ','px) {\n      font-size: 18px;\n   }\n']),_templateObject22=_taggedTemplateLiteral(['\n   font-size: 18px;\n   margin-top: 10px;\n   font-weight: 600;\n   @media (max-width: ','px) {\n      font-size: 16px;\n   }\n'],['\n   font-size: 18px;\n   margin-top: 10px;\n   font-weight: 600;\n   @media (max-width: ','px) {\n      font-size: 16px;\n   }\n']),_templateObject23=_taggedTemplateLiteral(['\n  font-size: 16px;\n   @media (max-width: ','px) {\n      font-size: 14px;\n   }\n'],['\n  font-size: 16px;\n   @media (max-width: ','px) {\n      font-size: 14px;\n   }\n']),_templateObject24=_taggedTemplateLiteral(['\n  width: ','px;\n  height: ','px;\n  margin: 30px;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n\n  &.selected {\n    box-shadow: 0px 0px 0px 6px rgba(255,255,255,0.6);\n  }\n'],['\n  width: ','px;\n  height: ','px;\n  margin: 30px;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n\n  &.selected {\n    box-shadow: 0px 0px 0px 6px rgba(255,255,255,0.6);\n  }\n']),_templateObject25=_taggedTemplateLiteral(['\n    margin: 20px auto;\n    width: 200px;\n'],['\n    margin: 20px auto;\n    width: 200px;\n']),_templateObject26=_taggedTemplateLiteral(['\n    display: flex;\n    cursor: pointer;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    border-radius: 20px;\n    background-color: green;\n    height: 100%;\n    color: white;\n    text-align: center;\n    padding: 5%;\n    font-size: 13px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    overflow-wrap: break-word; \n    vertical-align: center;\n'],['\n    display: flex;\n    cursor: pointer;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    border-radius: 20px;\n    background-color: green;\n    height: 100%;\n    color: white;\n    text-align: center;\n    padding: 5%;\n    font-size: 13px;\n    font-family: \'helvetica\';\n    font-weight: 600;\n    overflow-wrap: break-word; \n    vertical-align: center;\n']),_templateObject27=_taggedTemplateLiteral(['\n  display: flex;\n'],['\n  display: flex;\n']),_templateObject28=_taggedTemplateLiteral(['\n  color: green;\n  padding: 5px;\n'],['\n  color: green;\n  padding: 5px;\n']),_templateObject29=_taggedTemplateLiteral(['\n  color: red;\n  padding: 5px;\n'],['\n  color: red;\n  padding: 5px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ThinkTankSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var ThinkTankContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var ThinkTankTabs=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var ThinkTankTab=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return props.color;},function(props){return props.active?'border-bottom: 2px solid '+props.color:'';});var TabContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var ThinkTankHeader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var BackArrow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7);var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var ChatWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);var Buttons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10);var TabContentMargin=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11);var DocIframe=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].iframe(_templateObject12,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var BtnAddUsers=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13);var BtnShare=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject14);var DesktopVersion=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject15);var DesktopChat=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16);var DesktopTabs=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject17);var InfoSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],function(props){return props.image;});var UserAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject19);var NoPermission=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject20);var NoPermissionTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject21,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var NoPermissionSubtitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject22,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var NoPermissionDesc=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject23,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var NoPermissionImg=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].img(_templateObject24,function(props){return props.size;},function(props){return props.size;});var ButtonNextWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject25);var Button=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject26);var RequestButtons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject27);var RequestButtonAccept=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject28);var RequestButtonReject=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].i(_templateObject29);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1376);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_4_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1377);
function mapStateToProps(state){return{literals:state.i18n.literals.deleteAccountSuccess,color:state.app.color1};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_components_Navbar_modules__["b" ],dispatch),logOut:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_store_globalState_global__["d" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar__ = __webpack_require__(116);
 var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1378);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteAccountSuccess=function(_Component){_inherits(DeleteAccountSuccess,_Component);function DeleteAccountSuccess(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeleteAccountSuccess);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeleteAccountSuccess.__proto__||Object.getPrototypeOf(DeleteAccountSuccess)).call.apply(_ref,[this].concat(args))),_this),_this.handleGoToLogin=function(){var history=_this.props.history;history.push(__WEBPACK_IMPORTED_MODULE_2_constants_urls__["x" ]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeleteAccountSuccess,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,setBreadcrumb=_props.setBreadcrumb,literals=_props.literals,logOut=_props.logOut;var breadcrumb=[{color:'#ffffff',text:literals.title}];setBreadcrumb(breadcrumb.slice());__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].deleteSession();__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].deleteUser();logOut();window.logout();}},{key:'render',value:function render(){var _props2=this.props,color=_props2.color,literals=_props2.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" ],{color:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Navbar__["a" ],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text_description'},literals.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'round',onClick:this.handleGoToLogin},literals.goToLogin));}}]);return DeleteAccountSuccess;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DeleteAccountSuccess.propTypes={setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,logOut:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (DeleteAccountSuccess);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteAccountSuccessWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .text_description {\n    padding: 20px;\n  }\n'],['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .text_description {\n    padding: 20px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DeleteAccountSuccessWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1380);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_5_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(1381);
function mapStateToProps(state){return{literals:state.i18n.literals.narrativeThinkChats||{},thinkChats:state.thinkChats,app:state.app};}function mapDispatchToProps(dispatch){return{getNarrativeThinkChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_think_seeds_actions__["c" ],dispatch),setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__["b" ],dispatch),resetContext:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_store_globalState_global__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_Navbar__ = __webpack_require__(116);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_5_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_6_components_Steps_SwipeableCards__ = __webpack_require__(65);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_narratives_no_groups2_svg__ = __webpack_require__(1382);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_narratives_no_groups2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_images_narratives_no_groups2_svg__);
 var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1383);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NarrativeThinkChats=function(_Component){_inherits(NarrativeThinkChats,_Component);function NarrativeThinkChats(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NarrativeThinkChats);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NarrativeThinkChats.__proto__||Object.getPrototypeOf(NarrativeThinkChats)).call.apply(_ref,[this].concat(args))),_this),_this.handleEnd=function(){var history=_this.props.history;history.push(__WEBPACK_IMPORTED_MODULE_4_constants_urls__["u" ]);},_this.printNoThinkChatsView=function(){var _this$props=_this.props,color1=_this$props.app.color1,literals=_this$props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["b" ],{color:color1,className:'no_results'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_7_assets_images_narratives_no_groups2_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noGroups),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:_this.handleEnd},literals.backToMainPage)))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NarrativeThinkChats,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,id=_props.match.params.id,getNarrativeThinkChats=_props.getNarrativeThinkChats;getNarrativeThinkChats(id);this.setBreadcrumb();}},{key:'setBreadcrumb',value:function setBreadcrumb(){var _props2=this.props,setBreadcrumb=_props2.setBreadcrumb,resetContext=_props2.resetContext;var breadcrumb=[{color:'#ffffff'}];setBreadcrumb(breadcrumb.slice());resetContext();}},{key:'render',value:function render(){var _props3=this.props,id=_props3.match.params.id,thinkChats=_props3.thinkChats,app=_props3.app,literals=_props3.literals;if(thinkChats.narrativesThinkChatsStatus[id]!==__WEBPACK_IMPORTED_MODULE_5_constants_status__["g" ]){return null;}if(!thinkChats.narrativesThinkChats[id]||!thinkChats.narrativesThinkChats[id].length){return this.printNoThinkChatsView();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["b" ],{color:app.color1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.chooseGroups),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Steps_SwipeableCards__["a" ],{thinkSeeds:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(thinkChats.narrativesThinkChats[id],function(_ref2){var thinkChatId=_ref2.id;return thinkChatId;}),onEnd:this.handleEnd}));}}]);return NarrativeThinkChats;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NarrativeThinkChats.propTypes={getNarrativeThinkChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,thinkChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (NarrativeThinkChats);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no_groups2.a4f02857.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return MainWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return MainContent; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  overflow: auto;\n  width: 70vw;\n  @media (max-width: 768px) {\n    width: 80vw;\n  }\n\n  .title {\n    margin: 1rem auto 2rem;\n    text-align: center;\n    font-size: 1.6rem;\n    width: 90%;\n    max-width: 80rem;\n    line-height: 2rem;\n  }\n'],['\n  overflow: auto;\n  width: 70vw;\n  @media (max-width: 768px) {\n    width: 80vw;\n  }\n\n  .title {\n    margin: 1rem auto 2rem;\n    text-align: center;\n    font-size: 1.6rem;\n    width: 90%;\n    max-width: 80rem;\n    line-height: 2rem;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  height: 80vh;\n  display: flex;\n  align-items: center !important;\n  justify-content: center;\n'],['\n  height: 80vh;\n  display: flex;\n  align-items: center !important;\n  justify-content: center;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MainWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var MainContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1385);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_routes_Narratives_modules__ = __webpack_require__(82);
 var __WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_5_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(1386);
function mapStateToProps(state){return{literals:state.i18n.literals.speedDating||{},speedDating:state.narratives.speedDating,speedDatingStatus:state.narratives.speedDatingStatus,speedDatingMatches:state.narratives.speedDatingMatches,narratives:state.narratives.list,app:state.app,connectInNarrativeSpeedDating:__WEBPACK_IMPORTED_MODULE_3_routes_Narratives_modules__["b" ]};}function mapDispatchToProps(dispatch){return{getNarrativeSpeedDating:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_routes_Narratives_modules__["i" ],dispatch),setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__["b" ],dispatch),resetContext:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_store_globalState_global__["e" ],dispatch),getNarrativeSpeedDatingMatches:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_routes_Narratives_modules__["j" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_speed_dating_no_results_svg__ = __webpack_require__(485);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_speed_dating_no_results_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_speed_dating_no_results_svg__);
 var __WEBPACK_IMPORTED_MODULE_6_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_7_components_Steps_SwipeableCards__ = __webpack_require__(65);
 var __WEBPACK_IMPORTED_MODULE_8_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(1387);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NarrativeSpeedDating=function(_Component){_inherits(NarrativeSpeedDating,_Component);function NarrativeSpeedDating(props){_classCallCheck(this,NarrativeSpeedDating);var _this=_possibleConstructorReturn(this,(NarrativeSpeedDating.__proto__||Object.getPrototypeOf(NarrativeSpeedDating)).call(this,props));_this.handleSelectUser=function(card){var _this$props=_this.props,connectInNarrativeSpeedDating=_this$props.connectInNarrativeSpeedDating,id=_this$props.match.params.id;connectInNarrativeSpeedDating(id,card);};_this.handleEnd=function(){_this.setState({forceCountdown:true});_this.startCountDown();};_this.updateCountdown=function(){var countdown=_this.state.countdown;if(countdown>0){countdown-=1;}_this.setState({countdown:countdown});};_this.backToMainPage=function(){var history=_this.props.history;history.push(__WEBPACK_IMPORTED_MODULE_6_constants_urls__["u" ]);};_this.state={countdown:null,forceCountdown:false};return _this;}_createClass(NarrativeSpeedDating,[{key:'componentDidMount',value:function componentDidMount(){this.setBreadcrumb();this.fetchSpeedDatingData();}},{key:'componentDidUpdate',value:function componentDidUpdate(_ref,_ref2){var prevStatus=_ref.speedDatingStatus;var prevCountdown=_ref2.countdown;var _props=this.props,speedDatingStatus=_props.speedDatingStatus,speedDating=_props.speedDating;var countdown=this.state.countdown;// Call to api has finished
if(speedDatingStatus!==prevStatus&&(speedDatingStatus===__WEBPACK_IMPORTED_MODULE_4_constants_status__["g" ]||speedDatingStatus===__WEBPACK_IMPORTED_MODULE_4_constants_status__["a" ])){if(speedDatingStatus===__WEBPACK_IMPORTED_MODULE_4_constants_status__["a" ]||!speedDating.users.length){this.startCountDown();}}// Countdown has finished
if(countdown!==prevCountdown&&countdown<=0){clearInterval(this.intSpeedDating);this.fetchSpeedDatingData();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.intSpeedDating);}},{key:'setBreadcrumb',value:function setBreadcrumb(){var _props2=this.props,literals=_props2.literals,setBreadcrumb=_props2.setBreadcrumb,resetContext=_props2.resetContext;var breadcrumb=[{color:'#ffffff',text:literals.title}];setBreadcrumb(breadcrumb.slice());resetContext();}},{key:'fetchSpeedDatingData',value:function fetchSpeedDatingData(){var _props3=this.props,getNarrativeSpeedDating=_props3.getNarrativeSpeedDating,getNarrativeSpeedDatingMatches=_props3.getNarrativeSpeedDatingMatches,id=_props3.match.params.id;getNarrativeSpeedDating(id);getNarrativeSpeedDatingMatches(id);this.setState({forceCountdown:false});}},{key:'startCountDown',value:function startCountDown(){clearInterval(this.intSpeedDating);this.setState({countdown:15});this.intSpeedDating=setInterval(this.updateCountdown,1000);}},{key:'printContent',value:function printContent(){var _props4=this.props,speedDating=_props4.speedDating,speedDatingStatus=_props4.speedDatingStatus;var forceCountdown=this.state.forceCountdown;if(forceCountdown){return this.printCountDown();}var showUsers=false;switch(speedDatingStatus){case __WEBPACK_IMPORTED_MODULE_4_constants_status__["g" ]:if(speedDating.users.length){showUsers=true;}break;default:break;}if(showUsers){return this.printUsers();}return this.printCountDown();}},{key:'printCountDown',value:function printCountDown(){var countdown=this.state.countdown;var literals=this.props.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["a" ],null,this.printMatches(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_5_assets_images_speed_dating_no_results_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.description+' '+literals.itWillBeTried+' '+countdown+' '+literals.seconds)));}},{key:'printMatches',value:function printMatches(){var _props5=this.props,speedDatingMatches=_props5.speedDatingMatches,literals=_props5.literals;if(!speedDatingMatches||!speedDatingMatches.length){return null;}var matches=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(speedDatingMatches,function(_ref3){var id=_ref3.id,firstname=_ref3.firstname,avatar=_ref3.avatar;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Avatar__["a" ],{size:60,firstname:firstname,avatar:avatar,key:id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'match_name'},firstname));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'matches_subtitle'},literals.selectedUsers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'matches_bubble'},matches));}},{key:'printUsers',value:function printUsers(){var _props6=this.props,users=_props6.speedDating.users,literals=_props6.literals,id=_props6.match.params.id,narratives=_props6.narratives;var data=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(narratives,{id:parseInt(id,10)});if(!data){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'titleDesc'},literals.titleDesc),literals.description+' '+literals.meetingsWillBeginAt+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'countdown'},__WEBPACK_IMPORTED_MODULE_3_moment___default()(data.speed_dating_date,'X').format('Y-MM-DD HH:mm:ss'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Steps_SwipeableCards__["a" ],{users:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(users,function(_ref4){var userId=_ref4.id;return userId;}),onEnd:this.handleEnd,onYup:this.handleSelectUser})),this.printMatches(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'10vh'}}));}},{key:'render',value:function render(){var app=this.props.app;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["b" ],{color:app.color1},this.printContent());}}]);return NarrativeSpeedDating;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NarrativeSpeedDating.propTypes={getNarrativeSpeedDating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getNarrativeSpeedDatingMatches:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,speedDatingMatches:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,connectInNarrativeSpeedDating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,speedDating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,speedDatingStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,narratives:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};NarrativeSpeedDating.defaultProps={speedDating:null,speedDatingStatus:null,speedDatingMatches:null,narratives:[]}; __webpack_exports__["a"] = (NarrativeSpeedDating);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return MainWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return MainContent; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return Matches; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return UsersCards; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  display: block !important;\n  flex-direction: unset !important;\n  height: calc(100vh - 50px);\n  position: relative;\n  width: 100%;\n  overflow: auto;\n  padding-top: 20px;\n'],['\n  display: block !important;\n  flex-direction: unset !important;\n  height: calc(100vh - 50px);\n  position: relative;\n  width: 100%;\n  overflow: auto;\n  padding-top: 20px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 90%;\n  margin: 0 auto;\n\n  .no_elements {\n    width: 90%;\n    max-width: 80rem;\n    margin: 2rem auto;\n\n    > div{\n      color: ',';\n      line-height: 2rem;\n    }\n  }\n'],['\n  width: 90%;\n  margin: 0 auto;\n\n  .no_elements {\n    width: 90%;\n    max-width: 80rem;\n    margin: 2rem auto;\n\n    > div{\n      color: ',';\n      line-height: 2rem;\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 90%;\n  max-width: 80rem;\n  margin: 0 auto;\n\n  .matches_title {\n    margin: 20px 0px 10px;\n    color: ',';\n    font-weight: 600;\n    font-size: 24px;\n  }\n\n  .matches_subtitle {\n    margin: 20px 0px 10px;\n    color: ',';\n    font-weight: 600;\n    font-size: 18px;\n  }\n\n  .matches_description {\n    color: ',';\n    font-weight: 600;\n    font-size: 14px;\n  }\n\n  .matches_bubble {\n    margin-top: 10px;\n    white-space: nowrap;\n    overflow: auto;\n\n    .match {\n      display: inline-block;\n      vertical-align: middle;\n      margin: 5px 10px;\n      text-align: center;\n\n      > div:first-child {\n        margin: 0 auto;\n      }\n\n      .match_name {\n        font-size: 12px;\n        color: ',';\n        margin: 5px;\n      }\n    }\n  }\n'],['\n  width: 90%;\n  max-width: 80rem;\n  margin: 0 auto;\n\n  .matches_title {\n    margin: 20px 0px 10px;\n    color: ',';\n    font-weight: 600;\n    font-size: 24px;\n  }\n\n  .matches_subtitle {\n    margin: 20px 0px 10px;\n    color: ',';\n    font-weight: 600;\n    font-size: 18px;\n  }\n\n  .matches_description {\n    color: ',';\n    font-weight: 600;\n    font-size: 14px;\n  }\n\n  .matches_bubble {\n    margin-top: 10px;\n    white-space: nowrap;\n    overflow: auto;\n\n    .match {\n      display: inline-block;\n      vertical-align: middle;\n      margin: 5px 10px;\n      text-align: center;\n\n      > div:first-child {\n        margin: 0 auto;\n      }\n\n      .match_name {\n        font-size: 12px;\n        color: ',';\n        margin: 5px;\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  height: calc(90vh - env(safe-area-inset-top));\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  .title {\n    margin-top: 1rem;\n    text-align: center;\n    font-size: 1.6rem;\n    width: 90%;\n    max-width: 80rem;\n    line-height: 2rem;\n    .titleDesc {\n      font-size: 1.8rem;\n      font-weight: bold;\n      margin-bottom: 1rem;\n    }\n\n    span {\n      font-size: 1.6rem;\n      color: ',';\n      font-family: ',';\n    }\n  }\n'],['\n  height: calc(90vh - env(safe-area-inset-top));\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  .title {\n    margin-top: 1rem;\n    text-align: center;\n    font-size: 1.6rem;\n    width: 90%;\n    max-width: 80rem;\n    line-height: 2rem;\n    .titleDesc {\n      font-size: 1.8rem;\n      font-weight: bold;\n      margin-bottom: 1rem;\n    }\n\n    span {\n      font-size: 1.6rem;\n      color: ',';\n      font-family: ',';\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MainWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var MainContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ]);var Matches=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ]);var UsersCards=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["f" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1389);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_zoom_actions__ = __webpack_require__(488);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1390);
function mapStateToProps(state){return{meeting:state.zoom.meeting,meetingStatus:state.zoom.meetingStatus,color:state.app.color1,literals:state.i18n.literals.zoomMeeting,app:state.app};}function mapDispatchToProps(dispatch){return{getMeeting:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_zoom_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
 var __WEBPACK_IMPORTED_MODULE_3_components_Countdown__ = __webpack_require__(69);
 var __WEBPACK_IMPORTED_MODULE_4_components_ZoomMeeting__ = __webpack_require__(1391);
 var __WEBPACK_IMPORTED_MODULE_5_constants_status__ = __webpack_require__(26);
 var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1398);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ZoomMeeting=function(_Component){_inherits(ZoomMeeting,_Component);function ZoomMeeting(props){_classCallCheck(this,ZoomMeeting);var _this=_possibleConstructorReturn(this,(ZoomMeeting.__proto__||Object.getPrototypeOf(ZoomMeeting)).call(this,props));_this.finishCountdown=function(){_this.setState({hasFinishCountdown:true});};_this.handleNewMeeting=function(){var _this$props=_this.props,id=_this$props.match.params.id,getMeeting=_this$props.getMeeting;getMeeting(id);};_this.printZoomMeeting=function(){var _this$props2=_this.props,id=_this$props2.match.params.id,url=_this$props2.meeting.zoom_data.join_url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ZoomMeeting__["a" ],{meetingId:id,meetingURL:url});};_this.printCountDown=function(){var _this$props3=_this.props,color=_this$props3.color,_this$props3$meeting=_this$props3.meeting,image=_this$props3$meeting.image,name=_this$props3$meeting.name,startTime=_this$props3$meeting.start_date,literals=_this$props3.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["b" ],{color:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.startingMeetingIn),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Countdown__["a" ],{time:startTime,onFinish:_this.finishCountdown,enabled:true}),image&&image!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["c" ],{alt:name,src:image})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["c" ],{className:'text-avatar'},name&&name!==''&&name.slice(0,1))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},name)));};_this.state={hasFinishCountdown:false};return _this;}_createClass(ZoomMeeting,[{key:'componentDidMount',value:function componentDidMount(){this.handleNewMeeting();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var prevId=prevProps.match.params.id;var id=this.props.match.params.id;if(prevId!==id){this.handleNewMeeting();}}},{key:'render',value:function render(){var _props=this.props,meetingStatus=_props.meetingStatus,meeting=_props.meeting;var hasFinishCountdown=this.state.hasFinishCountdown;if(meetingStatus!==__WEBPACK_IMPORTED_MODULE_5_constants_status__["g" ]||!meeting){return null;}if(meeting.start_date>__WEBPACK_IMPORTED_MODULE_2_moment___default()().unix()&&!hasFinishCountdown){return this.printCountDown();}return this.printZoomMeeting();}}]);return ZoomMeeting;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ZoomMeeting.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,meeting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,meetingStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};ZoomMeeting.defaultProps={meeting:null,meetingStatus:null}; __webpack_exports__["a"] = (ZoomMeeting);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1392);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_zoom_actions__ = __webpack_require__(488);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1393);
function mapStateToProps(state){return{app:state.app,zoomData:state.zoom,user:state.session.user,literals:state.i18n.literals.zoomMeeting};}function mapDispatchToProps(dispatch){return{getSignature:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_zoom_actions__["b" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_device_detect__ = __webpack_require__(1394);
 var __WEBPACK_IMPORTED_MODULE_2_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_device_detect__);
 var __WEBPACK_IMPORTED_MODULE_3_constants_zoom__ = __webpack_require__(1396);
 var __WEBPACK_IMPORTED_MODULE_4_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_5_constants_meetings__ = __webpack_require__(476);
 var __WEBPACK_IMPORTED_MODULE_6_components_ConfirmModal__ = __webpack_require__(181);
 var __WEBPACK_IMPORTED_MODULE_7__SpeedDatingBar__ = __webpack_require__(1397);
 var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(489);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ZoomMeeting=function(_Component){_inherits(ZoomMeeting,_Component);function ZoomMeeting(props){_classCallCheck(this,ZoomMeeting);var _this=_possibleConstructorReturn(this,(ZoomMeeting.__proto__||Object.getPrototypeOf(ZoomMeeting)).call(this,props));_this.showModalFinish=function(){_this.setState({showModalFinish:true});};_this.closeModalFinish=function(){_this.setState({showModalFinish:false});};_this.acceptModalFinish=function(){_this.setState({doFinishMeeting:true,showModalFinish:false});};_this.openInZoomApp=function(){var _this$props=_this.props,meetingNumber=_this$props.meetingId,history=_this$props.history;history.push('/main');window.openMeetingZoom(meetingNumber,__WEBPACK_IMPORTED_MODULE_3_constants_zoom__["a" ]);};_this.closeModalWindow=function(){_this.setState({showModal:false,barHeight:0});};_this.openMeeting=function(){var history=_this.props.history;history.push(__WEBPACK_IMPORTED_MODULE_4_constants_urls__["u" ]);};_this.backToHome=function(){var history=_this.props.history;history.push(__WEBPACK_IMPORTED_MODULE_4_constants_urls__["u" ]);};_this.printOpenInZoomAppBar=function(){var _this$props2=_this.props,meetingURL=_this$props2.meetingURL,literals=_this$props2.literals;var showModal=_this.state.showModal;if(!showModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'headerBar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_bar modal_new_window'},literals.problemOpenNewWindow,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:meetingURL,onClick:_this.openMeeting,target:'_blank',rel:'noopener noreferrer'},literals.openANewWindow),literals.or,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:_this.backToHome,rel:'noopener noreferrer'},literals.backToHome),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'close_button',style:{display:'none'},type:'button',onClick:_this.closeModalWindow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle'}))));};_this.printSpeedDatingHeader=function(){var _this$props3=_this.props,_this$props3$zoomData=_this$props3.zoomData.meeting,name=_this$props3$zoomData.name,image=_this$props3$zoomData.image,endDate=_this$props3$zoomData.end_date,id=_this$props3$zoomData.user.id,meetingId=_this$props3$zoomData.id,elementId=_this$props3$zoomData.element_id,literals=_this$props3.literals,app=_this$props3.app;var doFinishMeeting=_this.state.doFinishMeeting;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SpeedDatingBar__["a" ],{app:app,userId:id,avatar:image,name:name,meetingId:meetingId,elementId:elementId,literals:literals,endDate:endDate,showModalFinish:_this.showModalFinish,closeModalFinish:_this.closeModalFinish,doFinishMeeting:doFinishMeeting}));};_this.printExtraInfo=function(){var zoomData=_this.props.zoomData;if(!zoomData||!zoomData.meeting||!zoomData.meeting.type){return null;}var type=zoomData.meeting.type;switch(type){case 21275704:return _this.printSpeedDatingHeader();default:return null;}};_this.state={showModal:true,showModalFinish:false,doFinishMeeting:false,barHeight:0};return _this;}_createClass(ZoomMeeting,[{key:'componentDidMount',value:function componentDidMount(){var zoomData=this.props.zoomData;if(__WEBPACK_IMPORTED_MODULE_2_react_device_detect__["isMobile"]){this.openInZoomApp();}var barHeight=50;if(zoomData&&zoomData.meeting&&zoomData.meeting.type&&zoomData.meeting.type===__WEBPACK_IMPORTED_MODULE_5_constants_meetings__["b" ]){barHeight=128;}this.setState({barHeight:barHeight});}},{key:'render',value:function render(){var _props=this.props,literals=_props.literals,user=_props.user,meetingId=_props.meetingId;var _state=this.state,showModalFinish=_state.showModalFinish,barHeight=_state.barHeight;var urlMeeting='https://meetings.webintra.net/zoom/'+meetingId+'?username='+encodeURIComponent(user.name+' '+user.surname);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,showModalFinish&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_ConfirmModal__["a" ],{open:showModalFinish,confirmText:literals.confirmText,onClose:this.closeModalFinish,onAccept:this.acceptModalFinish}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["b" ],null,this.printOpenInZoomAppBar(),this.printExtraInfo()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["d" ],{src:urlMeeting,allow:'camera;microphone',height:barHeight}));}}]);return ZoomMeeting;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ZoomMeeting.propTypes={app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,meetingId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,meetingURL:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,zoomData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (ZoomMeeting);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(1395);

var UA = new UAParser();
var browser = UA.getBrowser();
var cpu = UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  SMART_TV: 'smarttv',
  CONSOLE: 'console',
  WEARABLE: 'wearable',
  BROWSER: undefined
};
var BROWSER_TYPES = {
  CHROME: 'Chrome',
  FIREFOX: "Firefox",
  OPERA: "Opera",
  YANDEX: "Yandex",
  SAFARI: "Safari",
  INTERNET_EXPLORER: "Internet Explorer",
  EDGE: "Edge",
  CHROMIUM: "Chromium",
  IE: 'IE',
  MOBILE_SAFARI: "Mobile Safari",
  EDGE_CHROMIUM: "Edge Chromium",
  MIUI: "MIUI Browser"
};
var OS_TYPES = {
  IOS: 'iOS',
  ANDROID: "Android",
  WINDOWS_PHONE: "Windows Phone",
  WINDOWS: 'Windows',
  MAC_OS: 'Mac OS'
};
var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkType = function checkType(type) {
  switch (type) {
    case DEVICE_TYPES.MOBILE:
      return {
        isMobile: true
      };

    case DEVICE_TYPES.TABLET:
      return {
        isTablet: true
      };

    case DEVICE_TYPES.SMART_TV:
      return {
        isSmartTV: true
      };

    case DEVICE_TYPES.CONSOLE:
      return {
        isConsole: true
      };

    case DEVICE_TYPES.WEARABLE:
      return {
        isWearable: true
      };

    case DEVICE_TYPES.BROWSER:
      return {
        isBrowser: true
      };

    default:
      return initialData;
  }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

var type = checkType(device.type);

function deviceDetect() {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
}

var isMobileType = function isMobileType() {
  return device.type === DEVICE_TYPES.MOBILE;
};

var isTabletType = function isTabletType() {
  return device.type === DEVICE_TYPES.TABLET;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case DEVICE_TYPES.MOBILE:
    case DEVICE_TYPES.TABLET:
      return true;

    default:
      return false;
  }
};

var isEdgeChromiumType = function isEdgeChromiumType() {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};

var isSmartTVType = function isSmartTVType() {
  return device.type === DEVICE_TYPES.SMART_TV;
};

var isBrowserType = function isBrowserType() {
  return device.type === DEVICE_TYPES.BROWSER;
};

var isWearableType = function isWearableType() {
  return device.type === DEVICE_TYPES.WEARABLE;
};

var isConsoleType = function isConsoleType() {
  return device.type === DEVICE_TYPES.CONSOLE;
};

var isAndroidType = function isAndroidType() {
  return os.name === OS_TYPES.ANDROID;
};

var isWindowsType = function isWindowsType() {
  return os.name === OS_TYPES.WINDOWS;
};

var isMacOsType = function isMacOsType() {
  return os.name === OS_TYPES.MAC_OS;
};

var isWinPhoneType = function isWinPhoneType() {
  return os.name === OS_TYPES.WINDOWS_PHONE;
};

var isIOSType = function isIOSType() {
  return os.name === OS_TYPES.IOS;
};

var isChromeType = function isChromeType() {
  return browser.name === BROWSER_TYPES.CHROME;
};

var isFirefoxType = function isFirefoxType() {
  return browser.name === BROWSER_TYPES.FIREFOX;
};

var isChromiumType = function isChromiumType() {
  return browser.name === BROWSER_TYPES.CHROMIUM;
};

var isEdgeType = function isEdgeType() {
  return browser.name === BROWSER_TYPES.EDGE;
};

var isYandexType = function isYandexType() {
  return browser.name === BROWSER_TYPES.YANDEX;
};

var isSafariType = function isSafariType() {
  return browser.name === BROWSER_TYPES.SAFARI || browser.name === BROWSER_TYPES.MOBILE_SAFARI;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === BROWSER_TYPES.MOBILE_SAFARI;
};

var isOperaType = function isOperaType() {
  return browser.name === BROWSER_TYPES.OPERA;
};

var isIEType = function isIEType() {
  return browser.name === BROWSER_TYPES.INTERNET_EXPLORER || browser.name === BROWSER_TYPES.IE;
};

var isMIUIType = function isMIUIType() {
  return browser.name === BROWSER_TYPES.MIUI;
};

var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};

var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};

var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};

var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return setDefaults(browser.version);
};

var getBrowserVersion = function getBrowserVersion() {
  return setDefaults(browser.major);
};

var getOsVersion = function getOsVersion() {
  return setDefaults(os.version);
};

var getOsName = function getOsName() {
  return setDefaults(os.name);
};

var getBrowserName = function getBrowserName() {
  return setDefaults(browser.name);
};

var getMobileVendor = function getMobileVendor() {
  return setDefaults(device.vendor);
};

var getMobileModel = function getMobileModel() {
  return setDefaults(device.model);
};

var getEngineName = function getEngineName() {
  return setDefaults(engine.name);
};

var getEngineVersion = function getEngineVersion() {
  return setDefaults(engine.version);
};

var getUseragent = function getUseragent() {
  return setDefaults(ua);
};

var getDeviceType = function getDeviceType() {
  return setDefaults(device.type, 'browser');
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType() || getIPad13();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType() || getIPad13();
var isMobileOnly = isMobileType();
var isTablet = isTabletType() || getIPad13();
var isBrowser = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType() || getIPad13();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType() || isEdgeChromiumType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType();
var isLegacyEdge = isEdgeType() && !isEdgeChromiumType();
var isWindows = isWindowsType();
var isMacOs = isMacOsType();
var isMIUI = isMIUIType();

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style;
  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style;
  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style;
  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style;
  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style;
  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style;
  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style;
  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style;
  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style;
  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style;
  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style;
  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition;
  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return (
    
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default.Component)
  );
}

exports.AndroidView = AndroidView;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.withOrientationChange = withOrientationChange;


 }),

 (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;
(function(window,undefined){"use strict";var LIBVERSION="0.7.23",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]{3,6}).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,/(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i],[NAME,VERSION],[/(konqueror)\/([\w\.]+)/i],[[NAME,"Konqueror"],VERSION],[/(trident).+rv[:\s]([\w\.]{1,9}).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(Avast)\/([\w\.]+)/i],[[NAME,"Avast Secure Browser"],VERSION],[/(AVG)\/([\w\.]+)/i],[[NAME,"AVG Secure Browser"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/(focus)\/([\w\.]+)/i],[[NAME,"Firefox Focus"],VERSION],[/(opt)\/([\w\.]+)/i],[[NAME,"Opera Touch"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(windowswechat qbcore)\/([\w\.]+)/i],[[NAME,"WeChat(Win) Desktop"],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(brave)\/([\w\.]+)/i],[[NAME,"Brave"],VERSION],[/(whale)\/([\w\.]+)/i],[[NAME,"Whale"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(baiduboxapp)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/FBAN\/FBIOS|FB_IAB\/FB4A/i],[[NAME,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/android.+(line)\/([\w\.]+)\/iab/i],[NAME,VERSION],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(sailfishbrowser)\/([\w\.]+)/i],[[NAME,"Sailfish Browser"],VERSION],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/(qihu|qhbrowser|qihoobrowser|360browser)/i],[[NAME,"360 Browser"]],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+)\s.*(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i,/(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"],[TYPE,SMARTTV]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)(\sbuild\/|\)).+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/android.+aft([bms])\sbuild/i],[MODEL,[VENDOR,"Amazon"],[TYPE,SMARTTV]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/android.+\s(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/android.+(bah2?-a?[lw]\d{2})/i],[MODEL,[VENDOR,"Huawei"],[TYPE,TABLET]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|SM-P605|SM-P610|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/linux;\snetcast.+smarttv/i,/lg\snetcast\.tv-201\d/i],[[VENDOR,"LG"],MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(lenovo)[_\s-]?([\w-]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"],[TYPE,SMARTTV]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel( [2-9]a?)?( xl)?)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i,/android.+(redmi[\s\-_]?(?:note|k)?(?:[\s_]?[\w\s]+))(?:\sbuild|\))/i,/android.+(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]?(?:pad)(?:[\s_]?[\w\s]+))(?:\sbuild|\))/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(mz)-([\w-]{2,})/i],[[VENDOR,"Meizu"],MODEL,[TYPE,MOBILE]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})[\s)]/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s](Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+;\s(PH-1)\s/i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\w\-\.]+)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/android .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/[\s\/\(](smart-?tv)[;\)]/i],[[TYPE,SMARTTV]],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen|kaios)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,"Chromecast"]],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "a", function() { return password; });
var apiKey='RhDz0mjbScuEruwYkELvVQ';var password='impact';

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_4_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
 var __WEBPACK_IMPORTED_MODULE_6_components_UserCard__ = __webpack_require__(235);
 var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(489);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SpeedDatingBar=function(_Component){_inherits(SpeedDatingBar,_Component);function SpeedDatingBar(props){_classCallCheck(this,SpeedDatingBar);var _this=_possibleConstructorReturn(this,(SpeedDatingBar.__proto__||Object.getPrototypeOf(SpeedDatingBar)).call(this,props));_this.handleShowModalFinish=function(){var showModalFinish=_this.props.showModalFinish;showModalFinish();};_this.updateActualTime=function(){var diffServer=_this.state.diffServer;var actualTime=__WEBPACK_IMPORTED_MODULE_5_moment___default()().unix()-diffServer;_this.setState({actualTime:actualTime});};_this.finishMeeting=function(){var _this$props=_this.props,elementId=_this$props.elementId,meetingId=_this$props.meetingId;var hasFinishedMeeting=_this.state.hasFinishedMeeting;if(hasFinishedMeeting){return false;}Object(__WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__["b" ])('POST',{endPoint:'speed-dating/'+elementId+'/finish/'+meetingId});_this.setState({hasFinishedMeeting:true});return true;};_this.handleOpenProfileModal=function(){_this.setState({showProfileModal:true});};_this.handleCloseProfileModal=function(){_this.setState({showProfileModal:false});};_this.printProfileModal=function(){var showProfileModal=_this.state.showProfileModal;var userId=_this.props.userId;if(!showProfileModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Modal__["a" ],{open:showProfileModal,onClose:_this.handleCloseProfileModal,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',style:{zIndex:1110000}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" ],{className:'fa fa-times',onClick:_this.handleCloseProfileModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_UserCard__["a" ],{userId:userId})));};_this.addMinute=function(){var canAddMinute=_this.state.canAddMinute;var _this$props2=_this.props,elementId=_this$props2.elementId,meetingId=_this$props2.meetingId;Object(__WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__["b" ])('PUT',{endPoint:'narratives/'+elementId+'/speed-dating/calls/'+meetingId+'/add-minute'});if(canAddMinute){_this.setState({canAddMinute:false});}_this.toAddMinute=setTimeout(_this.resetAddMinuteFlag,15000);};_this.resetAddMinuteFlag=function(){_this.setState({canAddMinute:true});};_this.printUserData=function(){var _this$props3=_this.props,avatar=_this$props3.avatar,name=_this$props3.name,userId=_this$props3.userId,literals=_this$props3.literals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user_layer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Avatar__["a" ],{size:42,avatar:avatar,firstname:name,id:userId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'username'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn-sm',onClick:_this.handleOpenProfileModal},literals.viewProfile));};_this.printCountDown=function(){var _this$props4=_this.props,endDate=_this$props4.endDate,literals=_this$props4.literals;var _this$state=_this.state,actualTime=_this$state.actualTime,canAddMinute=_this$state.canAddMinute;var diff=Math.max(endDate-actualTime,0);var minutes=Math.floor(diff/60);var seconds=diff%60;if(minutes<10){minutes='0'+minutes;}if(seconds<10){seconds='0'+seconds;}if(!endDate){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'countdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.timeLeft+':',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,minutes+':'+seconds)),diff>5&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'danger btn-sm',onClick:_this.handleShowModalFinish},literals.finish)));};_this.state={showProfileModal:false,actualTime:null,hasFinishedMeeting:false,canAddMinute:true,diffServer:0};return _this;}_createClass(SpeedDatingBar,[{key:'componentDidMount',value:function componentDidMount(){this.getServerTime();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _state=this.state,hasFinishedMeeting=_state.hasFinishedMeeting,actualTime=_state.actualTime;var _props=this.props,endDate=_props.endDate,doFinishMeeting=_props.doFinishMeeting;if(!hasFinishedMeeting&&actualTime&&endDate&&endDate<actualTime&&actualTime-endDate<5){this.finishMeeting();}if(!prevProps.doFinishMeeting&&doFinishMeeting){this.finishMeeting();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.intActualTime){clearInterval(this.intActualTime);}if(this.toAddMinute){clearTimeout(this.toAddMinute);}}},{key:'getServerTime',value:function getServerTime(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__["b" ])('GET',{endPoint:'instance/actual_time'}).then(function(response){var diffServer=__WEBPACK_IMPORTED_MODULE_5_moment___default()().unix()-response.actual_time;_this2.setState({actualTime:response.actual_time,diffServer:diffServer});_this2.intActualTime=setInterval(_this2.updateActualTime,1000);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["c" ],null,this.printCountDown(),this.printUserData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),this.printProfileModal()));}}]);return SpeedDatingBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SpeedDatingBar.propTypes={userId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,avatar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,endDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,meetingId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,elementId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,showModalFinish:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,doFinishMeeting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired}; __webpack_exports__["a"] = (SpeedDatingBar);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return MeetingIntro; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarWrapper; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return UserAvatar; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__ = __webpack_require__(42);
var _templateObject=_taggedTemplateLiteral(['\n  height: 100%;\n  height: calc(100vh - 5rem);\n  background-color: ',';\n  padding: 0px 20px;\n  text-align: center;\n\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .content {\n    margin-top: -50px;\n    color: #fff;\n\n    .title {\n      font-size: 18px;\n      margin-bottom: 10px;\n      font-weight: 600;\n      display: inline-block;\n    }\n\n    .name {\n      color: #fff;\n      font-size: 16px;\n      font-weight: 600;\n      margin: 5px 0px 10px;\n    }\n\n    .countdown {\n      display: inline-block;\n      font-size: 2rem;\n      margin-left: 0.5rem;\n    }\n\n    .position {\n      font-size: 12px;\n      font-weight: 600;\n    }\n\n    .overview {\n      font-size: 12px;\n    }\n  }\n'],['\n  height: 100%;\n  height: calc(100vh - 5rem);\n  background-color: ',';\n  padding: 0px 20px;\n  text-align: center;\n\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .content {\n    margin-top: -50px;\n    color: #fff;\n\n    .title {\n      font-size: 18px;\n      margin-bottom: 10px;\n      font-weight: 600;\n      display: inline-block;\n    }\n\n    .name {\n      color: #fff;\n      font-size: 16px;\n      font-weight: 600;\n      margin: 5px 0px 10px;\n    }\n\n    .countdown {\n      display: inline-block;\n      font-size: 2rem;\n      margin-left: 0.5rem;\n    }\n\n    .position {\n      font-size: 12px;\n      font-weight: 600;\n    }\n\n    .overview {\n      font-size: 12px;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: relative;\n'],['\n  position: relative;\n']),_templateObject3=_taggedTemplateLiteral(['\n   && {\n    width: 120px;\n    height: 120px;\n    display: inline-block;\n\n    &.text-avatar {\n      font-size: 72px;\n      padding-top: 10px;\n    }\n   }\n'],['\n   && {\n    width: 120px;\n    height: 120px;\n    display: inline-block;\n\n    &.text-avatar {\n      font-size: 72px;\n      padding-top: 10px;\n    }\n   }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MeetingIntro=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;});var AvatarWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var UserAvatar=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Avatar__["a" ])(_templateObject3);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1400);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_callForImpact_actions__ = __webpack_require__(272);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1401);
function mapStateToProps(state){return{callForImpact:state.callForImpact.callForImpact,callForImpactStatus:state.callForImpact.callForImpactStatus};}function mapDispatchToProps(dispatch){return{getCallForImpact:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_callForImpact_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_constants_status__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CallForImpact=function(_Component){_inherits(CallForImpact,_Component);function CallForImpact(props){_classCallCheck(this,CallForImpact);var _this=_possibleConstructorReturn(this,(CallForImpact.__proto__||Object.getPrototypeOf(CallForImpact)).call(this,props));_this.state={id:0};return _this;}_createClass(CallForImpact,[{key:'componentDidMount',value:function componentDidMount(){this.changeCallForImpact();}},{key:'componentDidUpdate',value:function componentDidUpdate(_ref){var prevStatus=_ref.callForImpactStatus;var _props=this.props,newId=_props.match.params.id,callForImpactStatus=_props.callForImpactStatus;var id=this.state.id;if(parseInt(newId,10)!==id){this.changeCallForImpact();}if(prevStatus===__WEBPACK_IMPORTED_MODULE_2_constants_status__["b" ]&&callForImpactStatus===__WEBPACK_IMPORTED_MODULE_2_constants_status__["g" ]){this.handleCallForImpactLoaded();}}},{key:'loadCallForImpact',value:function loadCallForImpact(){var getCallForImpact=this.props.getCallForImpact;var id=this.state.id;getCallForImpact(id);}},{key:'changeCallForImpact',value:function changeCallForImpact(){var id=this.props.match.params.id;this.setState({id:parseInt(id,10)},this.loadCallForImpact);}},{key:'handleCallForImpactLoaded',value:function handleCallForImpactLoaded(){var _props2=this.props,callForImpact=_props2.callForImpact,history=_props2.history;var id=callForImpact.id,phase=callForImpact.phase,introMeeting=callForImpact.zoom_meeting,conclusionsMeeting=callForImpact.zoom_meeting_conclusions,narrativePostEvent=callForImpact.narrative_post_event;switch(phase){case 21275548:// Date Event - Main meeting -> Intro | Info
history.push('/zoom-meeting/'+introMeeting);break;case 21275549:// Date Event - Think chat meeting
history.push('/narratives/'+id+'/think-chats/');break;case 21275550:// Date Event - Main meeting ->  Conclusions
history.push('/zoom-meeting/'+conclusionsMeeting);break;case 21275551:// Date Event - Speed Dating
history.push('/narratives/'+id+'/speed-dating/');break;case 21275552:// POST Event
history.push('/narratives/'+narrativePostEvent);break;default:// PRE event
history.push('/narratives/'+id);break;}}},{key:'render',value:function render(){var callForImpactStatus=this.props.callForImpactStatus;if(callForImpactStatus===__WEBPACK_IMPORTED_MODULE_2_constants_status__["a" ]){throw new Error('error loading call for impact');}return null;}}]);return CallForImpact;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CallForImpact.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,getCallForImpact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,callForImpactStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,callForImpact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};CallForImpact.defaultProps={callForImpactStatus:null,callForImpact:null}; __webpack_exports__["a"] = (CallForImpact);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1403);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_4_routes_MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1404);
function mapStateToProps(state){return{actualContext:state.steps.context};}function mapDispatchToProps(dispatch){return{getNarrative:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__["a" ],dispatch),setAutoNavigation:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_routes_MainPage_modules_mainPage__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_Narrative__ = __webpack_require__(1405);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Narrative=function(_Component){_inherits(Narrative,_Component);function Narrative(){_classCallCheck(this,Narrative);return _possibleConstructorReturn(this,(Narrative.__proto__||Object.getPrototypeOf(Narrative)).apply(this,arguments));}_createClass(Narrative,[{key:'componentDidMount',value:function componentDidMount(){this.loadNarrative();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var id=this.props.match.params.id;var prevId=prevProps.match.params.id;if(prevId!==id){this.loadNarrative();}}},{key:'loadNarrative',value:function loadNarrative(){var _props=this.props,id=_props.match.params.id,getNarrative=_props.getNarrative,resetAll=_props.resetAll,setAutoNavigation=_props.setAutoNavigation;resetAll();setAutoNavigation(false);getNarrative(id);}},{key:'render',value:function render(){var _props2=this.props,id=_props2.match.params.id,actualContext=_props2.actualContext;if(!actualContext||actualContext.id!==parseInt(id,10)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Narrative__["a" ],{id:parseInt(id,10)});}}]);return Narrative;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Narrative.propTypes={getNarrative:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setAutoNavigation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,actualContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};Narrative.defaultProps={actualContext:null}; __webpack_exports__["a"] = (Narrative);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1406);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_4_routes_Narratives_modules__ = __webpack_require__(82);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1407);
function mapStateToProps(state){return{literals:state.i18n.literals.narrative,actualContext:state.steps.context};}function mapDispatchToProps(dispatch){return{setSerendipityActionInContext:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_serendipity_actions__["f" ],dispatch),getSerendipityAction:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_serendipity_actions__["d" ],dispatch),setNarrativeAsCompleted:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_routes_Narratives_modules__["l" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_swipeable__ = __webpack_require__(1408);
 var __WEBPACK_IMPORTED_MODULE_2_react_swipeable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_swipeable__);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_components_NarrativeStep__ = __webpack_require__(490);
 var __WEBPACK_IMPORTED_MODULE_5_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_6_components_Steps_FinalStep__ = __webpack_require__(1847);
 var __WEBPACK_IMPORTED_MODULE_7_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_8_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(1867);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var deltaToScroll=100;function Narrative(props){var id=props.id,literals=props.literals,actualContext=props.actualContext,history=props.history,setSerendipityActionInContext=props.setSerendipityActionInContext,getSerendipityAction=props.getSerendipityAction,setNarrativeAsCompleted=props.setNarrativeAsCompleted;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState2=_slicedToArray(_useState,2),positionY=_useState2[0],setPositionY=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isSwiping=_useState4[0],setIsSwiping=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),isChangingStep=_useState6[0],setIsChangingStep=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),isScrolling=_useState8[0],setIsScrolling=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState10=_slicedToArray(_useState9,2),deltaToStart=_useState10[0],setDeltaToStart=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),isTheEnd=_useState12[0],setIsTheEnd=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState14=_slicedToArray(_useState13,2),stepsViewed=_useState14[0],setStepsViewed=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState16=_slicedToArray(_useState15,2),steps=_useState16[0],setSteps=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState18=_slicedToArray(_useState17,2),actualStep=_useState18[0],setActualStep=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),isLoading=_useState20[0],setIsLoading=_useState20[1];var loadNextStep=function loadNextStep(callback){var currentStep=steps.length?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.last(steps).id:0;if(!isLoading){setIsLoading(true);Object(__WEBPACK_IMPORTED_MODULE_8_modules_steps_actions__["b" ])(id,currentStep).then(function(response){steps.push(response);setSteps([].concat(_toConsumableArray(steps)));setIsLoading(false);if(actualStep>=steps.length-1){// Preload next step
if(typeof response.more_info.wait_to_answer==='undefined'||!response.more_info.wait_to_answer){loadNextStep();}}if(callback){callback();}}).catch(function(){setIsTheEnd(true);setIsLoading(false);setNarrativeAsCompleted(id);if(callback){callback();}});}};// Load First step
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setSteps([]);setActualStep(0);},[id]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){return function(){setSerendipityActionInContext(null);};},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){window.$('.narrative_step:first').removeClass('no_transition').css('opacity',1);setIsChangingStep(false);if(actualStep>=steps.length-1){var lastStep=steps.length?steps[steps.length-1]:false;if(!lastStep||typeof lastStep.more_info.wait_to_answer==='undefined'||!lastStep.more_info.wait_to_answer){loadNextStep();}}},[actualStep]);var pushStepAsViewed=function pushStepAsViewed(stepId){if(!stepsViewed.includes(stepId)){stepsViewed.push(stepId);setStepsViewed([].concat(_toConsumableArray(stepsViewed)));Object(__WEBPACK_IMPORTED_MODULE_8_modules_steps_actions__["g" ])(stepId,id);}};var setAnswers=function setAnswers(answers){steps[actualStep].answers=answers;setSteps([].concat(_toConsumableArray(steps)));};// Events
var handleSwiping=function handleSwiping(event){if(deltaToStart===null){setDeltaToStart(event.deltaY);}else if(!isScrolling){if(!isSwiping){setIsSwiping(true);}var diff=event.deltaY-deltaToStart;setPositionY(diff);}};var changeStep=function changeStep(newPosition){setTimeout(function(){window.$('.narrative_step:first').addClass('no_transition').css('opacity',0);if(newPosition>actualStep){setPositionY(window.$('.narrative_step:first').outerHeight());}else{setPositionY(window.$('.narrative_step:first').outerHeight()*-1);}window.$('.narrative_step:first').addClass('no_transition').css('opacity',1);setTimeout(function(){setActualStep(newPosition);setPositionY(0);},50);},600);};// useEffect(() => {
//   if (steps.length >= 2 && typeof steps[steps.length - 2].more_info.wait_to_answer !== 'undefined' && steps[steps.length - 2].more_info.wait_to_answer) {
//     changeStep(actualStep + 1);
//   }
// }, [steps]);
var goUp=function goUp(){if(isTheEnd||actualStep<steps.length){if(actualStep===steps.length&&isTheEnd){setSerendipityActionInContext(null);var action=getSerendipityAction();if(action){action();}else{history.push(__WEBPACK_IMPORTED_MODULE_7_constants_urls__["y" ]);}}else if(actualStep===steps.length-1&&!isLoading){loadNextStep(function(){changeStep(actualStep+1);});setIsChangingStep(true);setIsSwiping(false);setPositionY(window.$('.narrative_step:first').outerHeight()*-1);}else{setIsChangingStep(true);setIsSwiping(false);setPositionY(window.$('.narrative_step:first').outerHeight()*-1);changeStep(actualStep+1);}}};var goDown=function goDown(){if(!isChangingStep){if(actualStep>0){setIsChangingStep(true);setIsSwiping(false);setPositionY(window.$('.narrative_step:first').outerHeight());changeStep(actualStep-1);}else{setIsSwiping(false);}}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setSerendipityActionInContext(goUp);},[id,goUp]);var handleSwiped=function handleSwiped(){setDeltaToStart(null);if(Math.abs(positionY)>deltaToScroll){if(positionY>0){goDown();}else{goUp();}}else{setIsSwiping(false);}};var toScroll=null;var handleScrollStop=function handleScrollStop(){setDeltaToStart(null);setIsScrolling(false);};var handleScroll=function handleScroll(){setIsScrolling(true);if(toScroll){clearTimeout(toScroll);}toScroll=setTimeout(handleScrollStop,150);};var handlers=Object(__WEBPACK_IMPORTED_MODULE_2_react_swipeable__["useSwipeable"])({onSwiping:handleSwiping,onSwiped:handleSwiped,onTap:handleSwiped,delta:30,// preventDefaultTouchmoveEvent: true,
trackMouse:true});// Handle keyboard navigation
var checkKeyboardHandler=function checkKeyboardHandler(event){switch(event.keyCode){case 39:// Arrow right
if(document.activeElement!=='text'){goUp();}break;case 37:// Arrow left
if(document.activeElement!=='text'){goDown();}break;default:break;}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){document.addEventListener('keydown',checkKeyboardHandler,false);return function(){document.removeEventListener('keydown',checkKeyboardHandler,false);};});// Print
var ActualStepPrint=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(steps.length<actualStep+1){if(isTheEnd){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Steps_FinalStep__["a" ],{id:id});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_LoadingComponent__["a" ],{colorAnimation:'#ffffff'}));}var step=steps[actualStep];pushStepAsViewed(step.id);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_NarrativeStep__["a" ],{onChangeAnswers:setAnswers,onFinish:goUp,data:step});},[steps,actualStep,isTheEnd,id]);var colorButtons=actualContext?actualContext.color:'#444';if(typeof colorButtons!=='string'){colorButtons=colorButtons.color;}var offsetY=isSwiping||isChangingStep?positionY:0;var classes=['step_content'];if(isSwiping){classes.push('is_swiping');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["c" ],{className:'narrative_step'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overflow_step'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["d" ],Object.assign({className:classes.join(' ')},handlers,{style:{marginTop:offsetY+'px'},onScroll:handleScroll}),ActualStepPrint)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["a" ],{color:colorButtons},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prev_button',onClick:goDown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-chevron-left'}),literals.previous),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'next_button',onClick:goUp},literals.next,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-chevron-right'}))));}Narrative.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setSerendipityActionInContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getSerendipityAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,actualContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};Narrative.defaultProps={actualContext:null}; __webpack_exports__["a"] = (Narrative);

 }),

 (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(0)) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = global || self, factory(global.swipeable = {}, global.react));
}(this, (function (exports, React) {
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var LEFT = "Left";
  var RIGHT = "Right";
  var UP = "Up";
  var DOWN = "Down";

  var defaultProps = {
    delta: 10,
    preventDefaultTouchmoveEvent: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true
  };
  var initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0]
  };
  var mouseMove = "mousemove";
  var mouseUp = "mouseup";
  var touchEnd = "touchend";
  var touchMove = "touchmove";
  var touchStart = "touchstart";

  function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
      if (deltaX > 0) {
        return RIGHT;
      }

      return LEFT;
    } else if (deltaY > 0) {
      return DOWN;
    }

    return UP;
  }

  function rotateXYByAngle(pos, angle) {
    if (angle === 0) return pos;
    var angleInRadians = Math.PI / 180 * angle;
    var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
  }

  function getHandlers(set, handlerProps) {
    var onStart = function onStart(event) {
      // if more than a single touch don't track, for now...
      if (event && "touches" in event && event.touches.length > 1) return;
      set(function (state, props) {
        // setup mouse listeners on document to track swipe since swipe can leave container
        if (props.trackMouse) {
          document.addEventListener(mouseMove, onMove);
          document.addEventListener(mouseUp, onUp);
        }

        var _ref = "touches" in event ? event.touches[0] : event,
            clientX = _ref.clientX,
            clientY = _ref.clientY;

        var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
        return _extends({}, state, initialState, {
          initial: [].concat(xy),
          xy: xy,
          start: event.timeStamp || 0
        });
      });
    };

    var onMove = function onMove(event) {
      set(function (state, props) {
        // Discount a swipe if additional touches are present after
        // a swipe has started.
        if ("touches" in event && event.touches.length > 1) {
          return state;
        }

        var _ref2 = "touches" in event ? event.touches[0] : event,
            clientX = _ref2.clientX,
            clientY = _ref2.clientY;

        var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
            x = _rotateXYByAngle[0],
            y = _rotateXYByAngle[1];

        var deltaX = x - state.xy[0];
        var deltaY = y - state.xy[1];
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        var time = (event.timeStamp || 0) - state.start;
        var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
        var vxvy = [deltaX / (time || 1), deltaY / (time || 1)]; // if swipe is under delta and we have not started to track a swipe: skip update

        if (absX < props.delta && absY < props.delta && !state.swiping) return state;
        var dir = getDirection(absX, absY, deltaX, deltaY);
        var eventData = {
          absX: absX,
          absY: absY,
          deltaX: deltaX,
          deltaY: deltaY,
          dir: dir,
          event: event,
          first: state.first,
          initial: state.initial,
          velocity: velocity,
          vxvy: vxvy
        }; // call onSwipeStart if present and is first swipe event

        eventData.first && props.onSwipeStart && props.onSwipeStart(eventData); // Call onSwiping if present

        props.onSwiping && props.onSwiping(eventData); // track if a swipe is cancelable(handler for swiping or swiped(dir) exists)
        // so we can call preventDefault if needed

        var cancelablePageSwipe = false;

        if (props.onSwiping || props.onSwiped || "onSwiped" + dir in props) {
          cancelablePageSwipe = true;
        }

        if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault();
        return _extends({}, state, {
          // first is now always false
          first: false,
          eventData: eventData,
          swiping: true
        });
      });
    };

    var onEnd = function onEnd(event) {
      set(function (state, props) {
        var eventData;

        if (state.swiping && state.eventData) {
          eventData = _extends({}, state.eventData, {
            event: event
          });
          props.onSwiped && props.onSwiped(eventData);
          var onSwipedDir = "onSwiped" + eventData.dir;

          if (onSwipedDir in props) {
            props[onSwipedDir](eventData);
          }
        } else {
          props.onTap && props.onTap({
            event: event
          });
        }

        return _extends({}, state, initialState, {
          eventData: eventData
        });
      });
    };

    var cleanUpMouse = function cleanUpMouse() {
      // safe to just call removeEventListener
      document.removeEventListener(mouseMove, onMove);
      document.removeEventListener(mouseUp, onUp);
    };

    var onUp = function onUp(e) {
      cleanUpMouse();
      onEnd(e);
    };
    


    var attachTouch = function attachTouch(el, passive) {
      var cleanup = function cleanup() {};

      if (el && el.addEventListener) {
        // attach touch event listeners and handlers
        var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
        tls.forEach(function (_ref3) {
          var e = _ref3[0],
              h = _ref3[1];
          return el.addEventListener(e, h, {
            passive: passive
          });
        }); // return properly scoped cleanup method for removing listeners, options not required

        cleanup = function cleanup() {
          return tls.forEach(function (_ref4) {
            var e = _ref4[0],
                h = _ref4[1];
            return el.removeEventListener(e, h);
          });
        };
      }

      return cleanup;
    };

    var onRef = function onRef(el) {
      // "inline" ref functions are called twice on render, once with null then again with DOM element
      // ignore null here
      if (el === null) return;
      set(function (state, props) {
        // if the same DOM el as previous just return state
        if (state.el === el) return state;
        var addState = {}; // if new DOM el clean up old DOM and reset cleanUpTouch

        if (state.el && state.el !== el && state.cleanUpTouch) {
          state.cleanUpTouch();
          addState.cleanUpTouch = undefined;
        } // only attach if we want to track touch


        if (props.trackTouch && el) {
          addState.cleanUpTouch = attachTouch(el, !props.preventDefaultTouchmoveEvent);
        } // store event attached DOM el for comparison, clean up, and re-attachment


        return _extends({}, state, {
          el: el
        }, addState);
      });
    }; // set ref callback to attach touch event listeners


    var output = {
      ref: onRef
    }; // if track mouse attach mouse down listener

    if (handlerProps.trackMouse) {
      output.onMouseDown = onStart;
    }

    return [output, attachTouch];
  }

  function updateTransientState(state, props, attachTouch) {
    var addState = {}; // clean up touch handlers if no longer tracking touches

    if (!props.trackTouch && state.cleanUpTouch) {
      state.cleanUpTouch();
      addState.cleanUpTouch = undefined;
    } else if (props.trackTouch && !state.cleanUpTouch) {
      // attach/re-attach touch handlers
      if (state.el) {
        addState.cleanUpTouch = attachTouch(state.el, !props.preventDefaultTouchmoveEvent);
      }
    }

    return _extends({}, state, addState);
  }

  function useSwipeable(options) {
    var trackMouse = options.trackMouse;
    var transientState = React.useRef(_extends({}, initialState));
    var transientProps = React.useRef(_extends({}, defaultProps));
    transientProps.current = _extends({}, defaultProps, options);

    var _React$useMemo = React.useMemo(function () {
      return getHandlers(function (stateSetter) {
        return transientState.current = stateSetter(transientState.current, transientProps.current);
      }, {
        trackMouse: trackMouse
      });
    }, [trackMouse]),
        handlers = _React$useMemo[0],
        attachTouch = _React$useMemo[1];

    transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
    return handlers;
  }

  exports.DOWN = DOWN;
  exports.LEFT = LEFT;
  exports.RIGHT = RIGHT;
  exports.UP = UP;
  exports.useSwipeable = useSwipeable;

})));
//# sourceMappingURL=react-swipeable.umd.js.map


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1410);
function mapStateToProps(state){return{literals:state.i18n.literals.narrative,actualContext:state.steps.context,app:state.app};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_components_Steps_List__ = __webpack_require__(1411);
 var __WEBPACK_IMPORTED_MODULE_4_components_Steps_Bubbles__ = __webpack_require__(1419);
 var __WEBPACK_IMPORTED_MODULE_5_components_Steps_BubbleChart__ = __webpack_require__(1426);
 var __WEBPACK_IMPORTED_MODULE_6_components_Steps_Tagcloud__ = __webpack_require__(1723);
 var __WEBPACK_IMPORTED_MODULE_7_components_Steps_BarChart__ = __webpack_require__(1726);
 var __WEBPACK_IMPORTED_MODULE_8_components_Steps_PieChart__ = __webpack_require__(1823);
 var __WEBPACK_IMPORTED_MODULE_9_components_Steps_CustomCard__ = __webpack_require__(1829);
 var __WEBPACK_IMPORTED_MODULE_10_components_Steps_Faces__ = __webpack_require__(95);
 var __WEBPACK_IMPORTED_MODULE_11_components_Steps_Deliverables__ = __webpack_require__(274);
 var __WEBPACK_IMPORTED_MODULE_12_components_Steps_FormElement__ = __webpack_require__(590);
 var __WEBPACK_IMPORTED_MODULE_13_components_Steps_FreeHtml__ = __webpack_require__(1836);
 var __WEBPACK_IMPORTED_MODULE_14_components_Steps_Inputs__ = __webpack_require__(1841);
 var __WEBPACK_IMPORTED_MODULE_15_components_Steps_SwipeableCards__ = __webpack_require__(65);
 var __WEBPACK_IMPORTED_MODULE_16_components_CreationThinkSeed__ = __webpack_require__(481);
 var __WEBPACK_IMPORTED_MODULE_17__styles__ = __webpack_require__(1846);
function NarrativeStep(props){var data=props.data,actualContext=props.actualContext,onFinish=props.onFinish,onChangeAnswers=props.onChangeAnswers,app=props.app;var color=app.color1;if(actualContext){color=typeof actualContext.color==='string'?actualContext.color:actualContext.color.color;}var finishStep=function finishStep(){if(onFinish){onFinish();}};var getSelectStep=function getSelectStep(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Steps_List__["a" ],{key:'step',type:data.element_type,narrativeType:data.narrative_type,values:data.answers,options:data.elements,onChangeAnswers:onChangeAnswers,maxAnswers:typeof data.more_info.max_answers!=='undefined'?parseInt(data.more_info.max_answers,10):null,maxOptions:typeof data.more_info.max_options!=='undefined'?parseInt(data.more_info.max_options,10):null,canCreate:typeof data.more_info.can_create!=='undefined'?!!data.more_info.can_create:false,showSearcher:typeof data.more_info.show_searcher!=='undefined'?!!data.more_info.show_searcher:false,stepId:data.id});};var getFacesStep=function getFacesStep(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Steps_Faces__["a" ],{backgroundColorText:color,values:data.answers||[],color:color,options:data.users,select:data.more_info.select,sort:data.more_info.sort,actionSelect:data.more_info.action,sortField:data.more_info.action,onChangeAnswers:onChangeAnswers});};var getTopElementsStep=function getTopElementsStep(){var options=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.elements,function(_ref){var name=_ref.name,amount=_ref.amount,image=_ref.image,description=_ref.description,userLikes=_ref.users_likes,users=_ref.users;return{id:name,label:name,value:amount,color:color,image:image,description:description,users:users,users_likes:userLikes};});switch(data.visualization){case'bubbles':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Steps_Bubbles__["a" ],{elements:data.elements});case'pie_chart':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Steps_PieChart__["a" ],{backgroundColor:color,color:color.color||'#fff',options:options});case'bar_chart':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Steps_BarChart__["a" ],{options:options,color:color,backgroundColor:color});case'bubble_chart':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Steps_BubbleChart__["a" ],{options:options,color:color});case'tagcloud':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Steps_Tagcloud__["a" ],{options:options,color:color});case'faces':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Steps_Faces__["a" ],{options:options,color:color});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Steps_Tagcloud__["a" ],{options:options,color:color});}};var getCustomStep=function getCustomStep(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Steps_CustomCard__["a" ],{data:data,color:color,type:data.element_type});};var getDeliverablesStep=function getDeliverablesStep(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Steps_Deliverables__["a" ],{elements:data.elements});};var getCreationFormStep=function getCreationFormStep(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Steps_FormElement__["a" ],{color:color,narrativeType:data.narrative_type,elementType:data.element_type,onFinish:finishStep});};var getInputsStep=function getInputsStep(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Steps_Inputs__["a" ],{narrativeType:data.narrative_type,elementType:data.element_type,onChangeAnswers:onChangeAnswers,values:data.answers||[],stepId:data.id});};var getFeedbackStep=function getFeedbackStep(){var usersIds=data.users?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.users,function(user){return user.id;}):[];var thinkSeedsIds=data.think_seeds?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.think_seeds,function(thinkSeed){return thinkSeed.id;}):[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Steps_SwipeableCards__["a" ],{users:usersIds,thinkSeeds:thinkSeedsIds,onEnd:finishStep});};var getThinkSeedCreationStep=function getThinkSeedCreationStep(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CreationThinkSeed__["a" ],{color:color,data:data});};var getFreeStep=function getFreeStep(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Steps_FreeHtml__["a" ],{html:data.content});};var printStep=function printStep(){var title=null;if(data.title){title=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styles__["c" ],{key:'title',color:color,dangerouslySetInnerHTML:{__html:data.title}});}var stepContent=null;switch(data.type){case'select':stepContent=getSelectStep();break;case'top_elements':stepContent=getTopElementsStep();break;case'custom':stepContent=getCustomStep();break;case'faces':stepContent=getFacesStep();break;case'deliverables':stepContent=getDeliverablesStep();break;case'creation_form':stepContent=getCreationFormStep();break;case'input':stepContent=getInputsStep();break;case'feedback_users':stepContent=getFeedbackStep();break;case'creation_think_seed':stepContent=getThinkSeedCreationStep();break;case'free':stepContent=getFreeStep();break;default:stepContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Not controlled');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styles__["b" ],{type:data.type},title,stepContent));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styles__["a" ],null,printStep());}NarrativeStep.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,actualContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onFinish:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onChangeAnswers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};NarrativeStep.defaultProps={onFinish:null,onChangeAnswers:null}; __webpack_exports__["a"] = (NarrativeStep);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1412);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1413);
function mapStateToProps(state){return{literals:state.i18n.literals.listComponent||{},actualContext:state.steps.context};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_components_AutocompleteInput__ = __webpack_require__(96);
 var __WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_5_components_Steps_Likes__ = __webpack_require__(184);
 var __WEBPACK_IMPORTED_MODULE_6_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_7__Bubble__ = __webpack_require__(1417);
 var __WEBPACK_IMPORTED_MODULE_8__ListOption__ = __webpack_require__(1418);
 var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(273);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var List=function(_Component){_inherits(List,_Component);function List(props){_classCallCheck(this,List);var _this=_possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).call(this,props));_initialiseProps.call(_this);var values=props.values,options=props.options;var answers=[];var answersTags=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(values,function(name){var item=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(options,function(option){return option.name.trim()===name.trim();});if(item){answers.push(item.id);}else{answersTags.push(name);}});_this.state={values:answers,viewUser:'',userClicked:null,createTags:answersTags.length>0,tags:answersTags,addedOptions:[]};return _this;}_createClass(List,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var values=this.props.values;var prevValues=prevProps.values;if(JSON.stringify(values)!==JSON.stringify(prevValues)){this.setNewAnswers();}}},{key:'printSearcher',value:function printSearcher(){var _props=this.props,literals=_props.literals,type=_props.type;var tags=this.state.tags;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["h" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AutocompleteInput__["a" ],{canCreateNew:true,type:type,placeholder:literals.searchElementOrCreate,selectedOptions:tags,onSelectOption:this.handleTag,onCreateOption:this.handleTagCreation,onSelect:this.onSelect}));}},{key:'printUsers',value:function printUsers(){var _props2=this.props,options=_props2.options,literals=_props2.literals;var values=this.state.values;var name='';var users=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(values,function(opt,index){var option=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(options,{id:opt});if(option){name=name?name+' + '+option.name:option.name;users=index?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.intersectionBy(users,option.users,'id'):option.users;}});if(users.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Steps_Likes__["a" ],{userList:users,id:values[0],label:literals.usersIn+' '+name,onSelectUser:this.onSelectUser});}return null;}},{key:'printSelectedUser',value:function printSelectedUser(){var _state=this.state,viewUser=_state.viewUser,userClicked=_state.userClicked,values=_state.values;var options=this.props.options;var users=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(values,function(opt,index){var option=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(options,{id:opt});if(option){users=index?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.intersectionBy(users,option.users,'id'):option.users;}});if(viewUser!=='profile'){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_UsersModal__["a" ],{usersIds:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(users,function(user){return user.id;}),userSelected:userClicked,onEnd:this.handleCloseFeedbackUsers});}},{key:'printOptions',value:function printOptions(){var _this2=this;var _props3=this.props,options=_props3.options,maxAnswers=_props3.maxAnswers,type=_props3.type,actualContext=_props3.actualContext;var _state2=this.state,values=_state2.values,addedOptions=_state2.addedOptions;var view=this.getView();var isSdg=type==='sdg'||type==='sdg_project'||type==='investor_sdg_project'||type==='user_sdg_project';var color=actualContext.color.color;if(isSdg){var sdgOptions=options;return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(sdgOptions,function(option){var selected=values.includes(option.id);switch(view){case'bubbles':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Bubble__["a" ],{key:option.id,color:color,data:option,selected:selected,onSelect:_this2.onSelect,onUnselect:_this2.onUnselect});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ListOption__["a" ],{key:option.id,color:color,data:option,selected:selected,onSelect:_this2.onSelect,onUnselect:_this2.onUnselect,maxAnswers:maxAnswers||options.length});}});}var optionsToRender=[].concat(_toConsumableArray(options));addedOptions.forEach(function(add){optionsToRender.push(add);});var currentOptions=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(optionsToRender,function(option){var selected=values.includes(option.id);switch(view){case'bubbles':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Bubble__["a" ],{key:option.id,color:color,data:option,selected:selected,onSelect:_this2.onSelect,onUnselect:_this2.onUnselect});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ListOption__["a" ],{key:option.id,color:color,data:option,selected:selected,onSelect:_this2.onSelect,onUnselect:_this2.onUnselect});}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,currentOptions);}},{key:'printCreationOption',value:function printCreationOption(){var view=this.getView();var literals=this.props.literals;var createTags=this.state.createTags;var data={id:0,name:literals.other};switch(view){case'bubbles':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Bubble__["a" ],{key:'0',data:data,selected:createTags,onSelect:this.showCreateOthers,onUnselect:this.hideCreateOthers});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ListOption__["a" ],{key:'0',data:data,selected:createTags,onSelect:this.showCreateOthers,onUnselect:this.hideCreateOthers});}}},{key:'printTagsCreation',value:function printTagsCreation(){var _props4=this.props,type=_props4.type,literals=_props4.literals;var tags=this.state.tags;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["j" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AutocompleteInput__["a" ],{canCreateNew:true,type:type,placeholder:literals.searchOrCreate,selectedOptions:tags,onSelectOption:this.handleTag,onCreateOption:this.handleTagCreation}),this.printTags(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["b" ],null));}},{key:'render',value:function render(){var view=this.getView();var showSearcher=this.props.showSearcher;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,showSearcher&&this.printSearcher(),this.printSelectedUser(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["e" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["f" ],{view:view},this.printOptions()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["g" ],null,this.printUsers())));}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.setNewAnswers=function(){var _props5=_this3.props,values=_props5.values,options=_props5.options;var addedOptions=_this3.state.addedOptions;var answers=[];var answersTags=[];var finalOptions=options.concat(addedOptions);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(values,function(name){var item=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(finalOptions,{name:name});if(item){answers.push(item.id);}else{answersTags.push(name);}});_this3.setState({values:answers,tags:answersTags});};this.handleCloseFeedbackUsers=function(){_this3.setState({viewUser:''});};this.connectWithElement=function(id){var _props6=_this3.props,narrativeType=_props6.narrativeType,options=_props6.options,stepId=_props6.stepId;var option=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(options,{id:id});if(option){var params={narrativeType:narrativeType,type:option.type,name:option.name,stepId:stepId};Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('POST',{endPoint:'elements/connection'},params);}};this.disconnectFromElement=function(id){var _props7=_this3.props,narrativeType=_props7.narrativeType,options=_props7.options,stepId=_props7.stepId;var addedOptions=_this3.state.addedOptions;var finalOptions=options.concat(addedOptions);var option=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(finalOptions,{id:id});if(option){var params={narrativeType:narrativeType,type:option.type,name:option.name,stepId:stepId};Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('DELETE',{endPoint:'elements/connection'},params);}};this.handleChangeAnswers=function(){var _props8=_this3.props,onChangeAnswers=_props8.onChangeAnswers,options=_props8.options;var _state3=_this3.state,values=_state3.values,addedOptions=_state3.addedOptions;var finalOptions=options.concat(addedOptions);if(onChangeAnswers){var answers=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(finalOptions,function(option){return values.includes(option.id);});onChangeAnswers(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(answers,function(answer){return answer.name;}));}};this.checkMaximumOptions=function(){var maxAnswers=_this3.props.maxAnswers;var values=_this3.state.values;if(maxAnswers&&values.length>maxAnswers){do{if(values.length){_this3.disconnectFromElement(values.shift());}}while(values.length>maxAnswers);}_this3.setState({values:values});_this3.handleChangeAnswers();};this.onSelect=function(id){var values=_this3.state.values;if(!values.includes(id)){values.push(id);}_this3.connectWithElement(id);_this3.setState({values:values},_this3.checkMaximumOptions);};this.onUnselect=function(id){var values=_this3.state.values;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(values,function(element){return element===id;});_this3.setState({values:values},_this3.checkMaximumOptions);_this3.disconnectFromElement(id);_this3.handleChangeAnswers();};this.getView=function(){var options=_this3.props.options;var maxLength=8;var view='bubbles';__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(options,function(option){var length=option.name.length;if(length>maxLength){view='list';}});return view;};this.showCreateOthers=function(){_this3.setState({createTags:true});};this.hideCreateOthers=function(){_this3.setState({createTags:false});};this.printTags=function(){var tags=_this3.state.tags;return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tags,function(tag,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["i" ],{key:index,onClick:_this3.removeTag},tag);});};this.removeTag=function(event){var tag=event.currentTarget.textContent;var tags=_this3.state.tags;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(tags,function(element){return element===tag;});_this3.setState({tags:tags});_this3.disconnectTag(tag);};this.disconnectTag=function(tag){var _props9=_this3.props,narrativeType=_props9.narrativeType,type=_props9.type,stepId=_props9.stepId;var params={narrativeType:narrativeType,type:type,name:tag,stepId:stepId};Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('DELETE',{endPoint:'elements/connection'},params);};this.handleTag=function(tag){var _props10=_this3.props,type=_props10.type,narrativeType=_props10.narrativeType,options=_props10.options,stepId=_props10.stepId;var _state4=_this3.state,tags=_state4.tags,addedOptions=_state4.addedOptions,values=_state4.values;if(!tags.includes(tag.name)){var params={narrativeType:narrativeType,type:type,name:tag.name,stepId:stepId};Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('POST',{endPoint:'elements/connection'},params);if(!values.includes(tag.id)){values.push(tag.id);}if(!tags.includes(tag.name)){tags.push(tag.name);}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(addedOptions,{name:tag.name})&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(options,{name:tag.name})){addedOptions.push(tag);}_this3.setState({tags:tags,addedOptions:addedOptions,values:values},_this3.checkMaximumOptions);}};this.handleTagCreation=function(tag){var type=_this3.props.type;_this3.handleTag(Object.assign({},tag,{id:Math.round(Math.random()*99999),type:type}));};this.onSelectUser=function(like){_this3.setState({viewUser:'profile',userClicked:like});};};List.propTypes={options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,maxAnswers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,canCreate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showSearcher:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,values:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,actualContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,narrativeType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onChangeAnswers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,stepId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};List.defaultProps={maxAnswers:null,canCreate:false,showSearcher:false,values:[],type:'',narrativeType:'',onChangeAnswers:null,stepId:0}; __webpack_exports__["a"] = (List);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components_Likes__ = __webpack_require__(1415);
function mapStateToProps(state){return{app:state.app};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_Likes__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_Steps_Faces__ = __webpack_require__(95);
 var __WEBPACK_IMPORTED_MODULE_3_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1416);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Likes=function(_Component){_inherits(Likes,_Component);function Likes(){_classCallCheck(this,Likes);return _possibleConstructorReturn(this,(Likes.__proto__||Object.getPrototypeOf(Likes)).apply(this,arguments));}_createClass(Likes,[{key:'render',value:function render(){var _props=this.props,userList=_props.userList,label=_props.label,onSelectUser=_props.onSelectUser;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],null,label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_SimpleCarousel__["a" ],{classesList:'face_bubble'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Steps_Faces__["a" ],{options:userList,onClick:onSelectUser,onLongPress:onSelectUser})));}}]);return Likes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Likes.propTypes={userList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onSelectUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Likes.defaultProps={label:null,onSelectUser:null}; __webpack_exports__["a"] = (Likes);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return Title; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return MainWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  // font-size: calc(14px + (16.8 - 16) * ((100vw - 320px) / (412 - 320)));\n  font-size: 2rem;\n  color: #fff;\n  text-align: left;\n'],['\n  // font-size: calc(14px + (16.8 - 16) * ((100vw - 320px) / (412 - 320)));\n  font-size: 2rem;\n  color: #fff;\n  text-align: left;\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin-top: 10px;\n\n  .face_bubble_text {\n    color: #fff;\n  }\n'],['\n  margin-top: 10px;\n\n  .face_bubble_text {\n    color: #fff;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var MainWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(273);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Bubble=function(_Component){_inherits(Bubble,_Component);function Bubble(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Bubble);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Bubble.__proto__||Object.getPrototypeOf(Bubble)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(){var _this$props=_this.props,id=_this$props.data.id,onSelect=_this$props.onSelect,onUnselect=_this$props.onUnselect,selected=_this$props.selected;if(selected){onUnselect(id);}else{onSelect(id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Bubble,[{key:'render',value:function render(){var _props=this.props,name=_props.data.name,selected=_props.selected,color=_props.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" ],{selected:selected,onClick:this.handleClick,color:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,name));}}]);return Bubble;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Bubble.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUnselect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};Bubble.defaultProps={selected:false}; __webpack_exports__["a"] = (Bubble);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(273);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ListOption=function(_Component){_inherits(ListOption,_Component);function ListOption(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ListOption);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ListOption.__proto__||Object.getPrototypeOf(ListOption)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(){var _this$props=_this.props,id=_this$props.data.id,onSelect=_this$props.onSelect,onUnselect=_this$props.onUnselect,selected=_this$props.selected;if(selected){onUnselect(id);}else{onSelect(id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ListOption,[{key:'render',value:function render(){var _props=this.props,data=_props.data,color=_props.color,selected=_props.selected;var darkerColor=void 0;if(color){darkerColor=color||color.color;}var isSdg=data.type==='sdg'||data.type==='sdg_project'||data.type==='investor_sdg_project'||data.type==='user_sdg_project';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["d" ],{selected:selected,onClick:this.handleClick,color:darkerColor||'#fff',isSdg:isSdg},isSdg?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["c" ],{selected:selected},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:data.icon||data.image,alt:''})):data.name);}}]);return ListOption;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ListOption.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUnselect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};ListOption.defaultProps={color:'#888888'}; __webpack_exports__["a"] = (ListOption);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components_Bubbles__ = __webpack_require__(1420);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_Bubbles__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_components_Steps_Deliverables__ = __webpack_require__(274);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1425);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Bubbles=function(_React$Component){_inherits(Bubbles,_React$Component);function Bubbles(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Bubbles);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Bubbles.__proto__||Object.getPrototypeOf(Bubbles)).call.apply(_ref,[this].concat(args))),_this),_this.state={showElems:false,elementsOrdered:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Bubbles,[{key:'handleClick',value:function handleClick(element){var elements=this.props.elements;var elementsFiltered=elements.filter(function(elem){return elem.id!==element.id;});elementsFiltered.unshift(element);this.setState({showElems:true,elementsOrdered:elementsFiltered});}},{key:'render',value:function render(){var _this2=this;var elements=this.props.elements;var _state=this.state,showElems=_state.showElems,elementsOrdered=_state.elementsOrdered;var bubbles=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(elements,function(element,i){var name=element.name,icon=element.icon,image=element.image;var background=icon||image||'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],{key:i,onClick:function onClick(){return _this2.handleClick(element);}},background&&background!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],{alt:name,src:background}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],{className:'with-initial'},name.slice(0,1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" ],null,name));});if(!showElems){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" ],null,bubbles);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Steps_Deliverables__["a" ],{elements:elementsOrdered,onClose:function onClose(){return _this2.setState({showElems:false});},showClose:true});}}]);return Bubbles;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Bubbles.propTypes={elements:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired}; __webpack_exports__["a"] = (Bubbles);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components_Deliverables__ = __webpack_require__(1422);
function mapStateToProps(state){return{actualContext:state.steps.context,app:state.app};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_Deliverables__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_react_materialize__ = __webpack_require__(173);
 var __WEBPACK_IMPORTED_MODULE_2_react_materialize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_materialize__);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_components_Steps_CustomCard_modules_actions__ = __webpack_require__(1423);
 var __WEBPACK_IMPORTED_MODULE_5_components_Steps_Likes__ = __webpack_require__(184);
 var __WEBPACK_IMPORTED_MODULE_6_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
 var __WEBPACK_IMPORTED_MODULE_8__Deliverable__ = __webpack_require__(1424);
 var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(491);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function printSlider(props){var children=props.children,onChange=props.onChange;var handleClick=function handleClick(event){event.stopPropagation();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["j" ],{onMouseDown:handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_materialize__["Carousel"],{carouselId:'Carousel-'+__WEBPACK_IMPORTED_MODULE_7_moment___default()().unix(),options:{dist:-20,duration:200,fullWidth:false,indicators:false,noWrap:false,numVisible:5,onCycleTo:onChange,padding:-170,shift:0}},children));}var MySlider=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(printSlider);function Deliverables(props){var context=props.actualContext,app=props.app,startElements=props.elements,onClose=props.onClose,showClose=props.showClose,showLike=props.showLike,title=props.title;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState2=_slicedToArray(_useState,2),actualSlide=_useState2[0],setActualSlide=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),userSelected=_useState4[0],setUserSelected=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(startElements),_useState6=_slicedToArray(_useState5,2),elements=_useState6[0],setElements=_useState6[1];var getColor=function getColor(){var color=app.color1;if(context&&context.color){color=typeof context.color==='string'?context.color:context.color.color;}return color;};var handleSwipe=function handleSwipe(newSlide){setActualSlide(newSlide);};var handleLike=function handleLike(id){var element=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(elements,{id:id});element.like=+!element.like;setElements([].concat(_toConsumableArray(elements)));Object(__WEBPACK_IMPORTED_MODULE_4_components_Steps_CustomCard_modules_actions__["a" ])('like','element*___*'+id,id);};var handleCloseFeedbackUsers=function handleCloseFeedbackUsers(){setUserSelected(null);};var handleClickLike=function handleClickLike(like){setUserSelected(like);};var changeSlide=function changeSlide(slide){var position=parseInt(window.$(slide).attr('data-position'),10);handleSwipe(position);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){return function(){window.M.Carousel.getInstance(window.$('.carousel:first')).destroy();};},[]);var printCards=function printCards(){var color=getColor();return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(elements,function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,'data-position':index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Deliverable__["a" ],{element:element,color:color,onLike:handleLike,onClose:onClose,showClose:showClose,showLike:showLike,total:elements.length,position:index}));});};var printSelectedUser=function printSelectedUser(){if(userSelected){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_UsersModal__["a" ],{usersIds:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(elements[actualSlide].users,function(user){return user.id;}),userSelected:userSelected,onEnd:handleCloseFeedbackUsers});}return null;};var color=getColor();var SliderCards=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MySlider,{onChange:changeSlide},printCards());},[startElements]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,printSelectedUser(),title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_card_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["k" ],{dangerouslySetInnerHTML:{__html:title},backgroundColorText:color})),SliderCards,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Steps_Likes__["a" ],{label:elements[actualSlide].name,userList:elements[actualSlide].users,onSelectUser:handleClickLike}));}Deliverables.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,elements:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,actualContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,showClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Deliverables.defaultProps={title:null,showClose:false,onClose:null,actualContext:null}; __webpack_exports__["a"] = (Deliverables);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = saveCardAction;


 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
function saveCardAction(actionType,cardType){var contentId=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'saveCardAction'},{actionType:actionType,cardType:cardType,contentId:contentId});}function getComments(cardType){var cardId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'getComments'},{cardType:cardType,cardId:cardId});}function sendComment(newComment,cardType){var cardId=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'sendComment'},{newComment:newComment,cardType:cardType,cardId:cardId});}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_3_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(491);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Deliverable=function(_Component){_inherits(Deliverable,_Component);function Deliverable(props){_classCallCheck(this,Deliverable);var _this=_possibleConstructorReturn(this,(Deliverable.__proto__||Object.getPrototypeOf(Deliverable)).call(this,props));_this.handleLike=function(){var _this$props=_this.props,onLike=_this$props.onLike,id=_this$props.element.id;var selected=_this.state.selected;onLike(id);if(selected){_this.setState({selected:false});}else{_this.setState({selected:true});}};_this.state={selected:props.element.like};return _this;}_createClass(Deliverable,[{key:'render',value:function render(){var _props=this.props,element=_props.element,color=_props.color,onClose=_props.onClose,showClose=_props.showClose,total=_props.total,position=_props.position,showLike=_props.showLike;var selected=this.state.selected;var name=element.name,image=element.image,description=element.description,like=element.like,label=element.label;var darkerColor=Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["c" ])(color));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],{id:'deliverable-card-body'},showClose&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],{className:'fa fa-times',onClick:onClose}),element.user&&element.user.id&&element.user.firstname?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Avatar__["a" ],{id:element.user.id,firstname:element.user.firstname,avatar:element.user.avatar,size:48})):null,name&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" ],null,name),label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" ],null,label),image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" ],{image:image}),description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" ],null,description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["h" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" ],{backgroundColor:color.color||color},position+1+'/'+total))),showLike&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" ],{className:selected?'like':'',color:color,onClick:this.handleLike},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'})));}}]);return Deliverable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Deliverable.propTypes={element:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onLike:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,showClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,position:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,showLike:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Deliverable.defaultProps={onClose:null,showClose:false,showLike:true}; __webpack_exports__["a"] = (Deliverable);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return BubblesWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return BubbleElement; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return BubbleImage; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return BubbleName; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Avatar__ = __webpack_require__(42);
var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n'],['\n  display: inline-block;\n  vertical-align: middle;\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: 95px;\n  height: 110px;\n  vertical-align: top;\n  margin: 0 5px 5px 0;\n'],['\n  display: inline-block;\n  width: 95px;\n  height: 110px;\n  vertical-align: top;\n  margin: 0 5px 5px 0;\n']),_templateObject3=_taggedTemplateLiteral(['\n  && {\n    width: 60px;\n    height: 60px;\n    display: inline-block;\n    border: 1px solid white;\n    &.with-initial {\n      font-size: 30px;\n      padding-top: 13px;\n    }\n   }\n'],['\n  && {\n    width: 60px;\n    height: 60px;\n    display: inline-block;\n    border: 1px solid white;\n    &.with-initial {\n      font-size: 30px;\n      padding-top: 13px;\n    }\n   }\n']),_templateObject4=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 14px;\n  line-height: 14px;\n  margin-top: 5px;\n'],['\n  color: ',';\n  font-size: 14px;\n  line-height: 14px;\n  margin-top: 5px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BubblesWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var BubbleElement=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var BubbleImage=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Avatar__["a" ])(_templateObject3);var BubbleName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_1_constants_colors__["k" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components_BubbleChart__ = __webpack_require__(1427);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_BubbleChart__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__weknow_react_bubble_chart_d3__ = __webpack_require__(1428);
 var __WEBPACK_IMPORTED_MODULE_2__weknow_react_bubble_chart_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__weknow_react_bubble_chart_d3__);
 var __WEBPACK_IMPORTED_MODULE_3_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_4_components_Steps_Deliverables__ = __webpack_require__(274);
 var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(1722);
 var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BubbleChartComponent=function(_Component){_inherits(BubbleChartComponent,_Component);function BubbleChartComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BubbleChartComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BubbleChartComponent.__proto__||Object.getPrototypeOf(BubbleChartComponent)).call.apply(_ref,[this].concat(args))),_this),_this.state={hide:false,filteredOptions:[]},_this.handleClick=function(label){var options=_this.props.options;var first=options.find(function(elem){return elem.label===label;});var filteredOptions=options.filter(function(elem){return elem.label!==label;});filteredOptions.unshift(first);_this.setState({hide:true,filteredOptions:filteredOptions});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BubbleChartComponent,[{key:'render',value:function render(){var _this2=this;var _props=this.props,options=_props.options,color=_props.color;var _state=this.state,hide=_state.hide,filteredOptions=_state.filteredOptions;var width=Math.min(window.innerWidth,window.innerHeight/1.5,700);var fontSize=width>500?14:9;var bubbleColor=color.contrastColor||Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["c" ])(color));// const fontSize = window.innerWidth > 768 ? 16 : 12;
var data=options.filter(function(elem){return elem.value!==0;}).map(function(elem2){return Object.assign({},elem2,{color:bubbleColor});});if(!hide){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__weknow_react_bubble_chart_d3___default.a,{graph:{zoom:0.9,// 1.1 means 110% of zoom.
offsetX:0,// -0.05 means that the offset is -5% of the graph width.
offsetY:0},width:width,height:width,padding:0,overflow:true,showLegend:false// optional value, pass false to disable the legend.
,legendPercentage:0// number that represent the % of with that legend going to use.
,valueFont:{family:'Raleway',size:0,color:bubbleColor},labelFont:{family:'Raleway',size:fontSize,color:color.color||'#fff',wordWrap:'break-word'},bubbleClickFun:this.handleClick,legendClickFun:this.legendClick,data:data});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Steps_Deliverables__["a" ],{elements:filteredOptions,showClose:true,showLike:false,onClose:function onClose(){return _this2.setState({hide:false});}});}}]);return BubbleChartComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BubbleChartComponent.propTypes={options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}; __webpack_exports__["a"] = (BubbleChartComponent);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1429).default;

 }),

 (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _d = __webpack_require__(1430);

var d3 = _interopRequireWildcard(_d);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BubbleChart = function (_Component) {
  _inherits(BubbleChart, _Component);

  function BubbleChart(props) {
    _classCallCheck(this, BubbleChart);

    var _this = _possibleConstructorReturn(this, (BubbleChart.__proto__ || Object.getPrototypeOf(BubbleChart)).call(this, props));

    _this.renderChart = _this.renderChart.bind(_this);
    _this.renderBubbles = _this.renderBubbles.bind(_this);
    _this.renderLegend = _this.renderLegend.bind(_this);
    return _this;
  }

  _createClass(BubbleChart, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.svg = _reactDom2.default.findDOMNode(this);
      this.renderChart();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          width = _props.width,
          height = _props.height;

      if (width !== 0 && height !== 0) {
        this.renderChart();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          width = _props2.width,
          height = _props2.height;

      return _react2.default.createElement('svg', { width: width, height: height });
    }
  }, {
    key: 'renderChart',
    value: function renderChart() {
      var _props3 = this.props,
          graph = _props3.graph,
          data = _props3.data,
          height = _props3.height,
          width = _props3.width,
          padding = _props3.padding,
          showLegend = _props3.showLegend,
          legendPercentage = _props3.legendPercentage;
      // Reset the svg element to a empty state.

      this.svg.innerHTML = '';

      var bubblesWidth = showLegend ? width * (1 - legendPercentage / 100) : width;
      var legendWidth = width - bubblesWidth;
      var color = d3.scaleOrdinal(d3.schemeCategory20c);

      var pack = d3.pack().size([bubblesWidth * graph.zoom, bubblesWidth * graph.zoom]).padding(padding);

      // Process the data to have a hierarchy structure;
      var root = d3.hierarchy({ children: data }).sum(function (d) {
        return d.value;
      }).sort(function (a, b) {
        return b.value - a.value;
      }).each(function (d) {
        if (d.data.label) {
          d.label = d.data.label;
          d.id = d.data.label.toLowerCase().replace(/ |\//g, "-");
        }
      });

      // Pass the data to the pack layout to calculate the distribution.
      var nodes = pack(root).leaves();

      // Call to the function that draw the bubbles.
      this.renderBubbles(bubblesWidth, nodes, color);
      // Call to the function that draw the legend.
      if (showLegend) {
        this.renderLegend(legendWidth, height, bubblesWidth, nodes, color);
      }
    }
  }, {
    key: 'renderBubbles',
    value: function renderBubbles(width, nodes, color) {
      var _props4 = this.props,
          graph = _props4.graph,
          data = _props4.data,
          bubbleClickFun = _props4.bubbleClickFun,
          valueFont = _props4.valueFont,
          labelFont = _props4.labelFont;


      var bubbleChart = d3.select(this.svg).append("g").attr("class", "bubble-chart").attr("transform", function (d) {
        return "translate(" + width * graph.offsetX + "," + width * graph.offsetY + ")";
      });;

      var node = bubbleChart.selectAll(".node").data(nodes).enter().append("g").attr("class", "node").attr("transform", function (d) {
        return "translate(" + d.x + "," + d.y + ")";
      }).on("click", function (d) {
        bubbleClickFun(d.label);
      });

      node.append("circle").attr("id", function (d) {
        return d.id;
      }).attr("r", function (d) {
        return d.r - d.r * .04;
      }).style("fill", function (d) {
        return d.data.color ? d.data.color : color(nodes.indexOf(d));
      }).style("z-index", 1).on('mouseover', function (d) {
        d3.select(this).attr("r", d.r * 1.04);
      }).on('mouseout', function (d) {
        var r = d.r - d.r * 0.04;
        d3.select(this).attr("r", r);
      });

      node.append("clipPath").attr("id", function (d) {
        return "clip-" + d.id;
      }).append("use").attr("xlink:href", function (d) {
        return "#" + d.id;
      });

      node.append("text").attr("class", "value-text").style("font-size", valueFont.size + 'px').attr("clip-path", function (d) {
        return "url(#clip-" + d.id + ")";
      }).style("font-weight", function (d) {
        return valueFont.weight ? valueFont.weight : 600;
      }).style("font-family", valueFont.family).style("fill", function () {
        return valueFont.color ? valueFont.color : '#000';
      }).style("stroke", function () {
        return valueFont.lineColor ? valueFont.lineColor : '#000';
      }).style("stroke-width", function () {
        return valueFont.lineWeight ? valueFont.lineWeight : 0;
      }).text(function (d) {
        return d.value;
      });

      node.append("text").attr("class", "label-text").style("font-size", labelFont.size + 'px').attr("clip-path", function (d) {
        return "url(#clip-" + d.id + ")";
      }).style("font-weight", function (d) {
        return labelFont.weight ? labelFont.weight : 600;
      }).style("font-family", labelFont.family).style("fill", function () {
        return labelFont.color ? labelFont.color : '#000';
      }).style("stroke", function () {
        return labelFont.lineColor ? labelFont.lineColor : '#000';
      }).style("stroke-width", function () {
        return labelFont.lineWeight ? labelFont.lineWeight : 0;
      }).text(function (d) {
        return d.label;
      });

      // Center the texts inside the circles.
      d3.selectAll(".label-text").attr("x", function (d) {
        var self = d3.select(this);
        var width = self.node().getBBox().width;
        return -(width / 2);
      }).style("opacity", function (d) {
        var self = d3.select(this);
        var width = self.node().getBBox().width;
        d.hideLabel = width * 1.05 > d.r * 2;
        return d.hideLabel ? 0 : 1;
      }).attr("y", function (d) {
        return labelFont.size / 2;
      });

      // Center the texts inside the circles.
      d3.selectAll(".value-text").attr("x", function (d) {
        var self = d3.select(this);
        var width = self.node().getBBox().width;
        return -(width / 2);
      }).attr("y", function (d) {
        if (d.hideLabel) {
          return valueFont.size / 3;
        } else {
          return -valueFont.size * 0.5;
        }
      });

      node.append("title").text(function (d) {
        return d.label;
      });
    }
  }, {
    key: 'renderLegend',
    value: function renderLegend(width, height, offset, nodes, color) {
      var _props5 = this.props,
          data = _props5.data,
          legendClickFun = _props5.legendClickFun,
          legendFont = _props5.legendFont;

      var bubble = d3.select('.bubble-chart');
      var bubbleHeight = bubble.node().getBBox().height;

      var legend = d3.select(this.svg).append("g").attr("transform", function () {
        return 'translate(' + offset + ',' + bubbleHeight * 0.05 + ')';
      }).attr("class", "legend");

      var textOffset = 0;
      var texts = legend.selectAll(".legend-text").data(nodes).enter().append("g").attr("transform", function (d, i) {
        var offset = textOffset;
        textOffset += legendFont.size + 10;
        return 'translate(0,' + offset + ')';
      }).on('mouseover', function (d) {
        d3.select('#' + d.id).attr("r", d.r * 1.04);
      }).on('mouseout', function (d) {
        var r = d.r - d.r * 0.04;
        d3.select('#' + d.id).attr("r", r);
      }).on("click", function (d) {
        legendClickFun(d.label);
      });;

      texts.append("rect").attr("width", 30).attr("height", legendFont.size).attr("x", 0).attr("y", -legendFont.size).style("fill", "transparent");

      texts.append("rect").attr("width", legendFont.size).attr("height", legendFont.size).attr("x", 0).attr("y", -legendFont.size).style("fill", function (d) {
        return d.data.color ? d.data.color : color(nodes.indexOf(d));
      });

      texts.append("text").style("font-size", legendFont.size + 'px').style("font-weight", function (d) {
        return legendFont.weight ? legendFont.weight : 600;
      }).style("font-family", legendFont.family).style("fill", function () {
        return legendFont.color ? legendFont.color : '#000';
      }).style("stroke", function () {
        return legendFont.lineColor ? legendFont.lineColor : '#000';
      }).style("stroke-width", function () {
        return legendFont.lineWeight ? legendFont.lineWeight : 0;
      }).attr("x", function (d) {
        return legendFont.size + 10;
      }).attr("y", 0).text(function (d) {
        return d.label;
      });
    }
  }]);

  return BubbleChart;
}(_react.Component);

exports.default = BubbleChart;


BubbleChart.propTypes = {
  graph: _propTypes2.default.shape({
    zoom: _propTypes2.default.number,
    offsetX: _propTypes2.default.number,
    offsetY: _propTypes2.default.number
  }),
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  padding: _propTypes2.default.number,
  showLegend: _propTypes2.default.bool,
  legendPercentage: _propTypes2.default.number,
  legendFont: _propTypes2.default.shape({
    family: _propTypes2.default.string,
    size: _propTypes2.default.number,
    color: _propTypes2.default.string,
    weight: _propTypes2.default.string
  }),
  valueFont: _propTypes2.default.shape({
    family: _propTypes2.default.string,
    size: _propTypes2.default.number,
    color: _propTypes2.default.string,
    weight: _propTypes2.default.string
  }),
  labelFont: _propTypes2.default.shape({
    family: _propTypes2.default.string,
    size: _propTypes2.default.number,
    color: _propTypes2.default.string,
    weight: _propTypes2.default.string
  })
};
BubbleChart.defaultProps = {
  graph: {
    zoom: 1.1,
    offsetX: -0.05,
    offsetY: -0.01
  },
  width: 1000,
  height: 800,
  padding: 0,
  showLegend: true,
  legendPercentage: 20,
  legendFont: {
    family: 'Arial',
    size: 12,
    color: '#000',
    weight: 'bold'
  },
  valueFont: {
    family: 'Arial',
    size: 16,
    color: '#fff',
    weight: 'bold'
  },
  labelFont: {
    family: 'Arial',
    size: 11,
    color: '#fff',
    weight: 'normal'
  },
  bubbleClickFun: function bubbleClickFun(label) {
    console.log('Bubble ' + label + ' is clicked ...');
  },
  legendClickFun: function legendClickFun(label) {
    console.log('Legend ' + label + ' is clicked ...');
  }
};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
 var __WEBPACK_IMPORTED_MODULE_0__build_package__ = __webpack_require__(1431);
 __webpack_require__.d(__webpack_exports__, "version", function() { return __WEBPACK_IMPORTED_MODULE_0__build_package__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(43);
 __webpack_require__.d(__webpack_exports__, "bisect", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["b"]; });
 __webpack_require__.d(__webpack_exports__, "bisectRight", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["d"]; });
 __webpack_require__.d(__webpack_exports__, "bisectLeft", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["c"]; });
 __webpack_require__.d(__webpack_exports__, "ascending", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["a"]; });
 __webpack_require__.d(__webpack_exports__, "bisector", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["e"]; });
 __webpack_require__.d(__webpack_exports__, "cross", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["f"]; });
 __webpack_require__.d(__webpack_exports__, "descending", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["g"]; });
 __webpack_require__.d(__webpack_exports__, "deviation", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["h"]; });
 __webpack_require__.d(__webpack_exports__, "extent", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["i"]; });
 __webpack_require__.d(__webpack_exports__, "histogram", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["j"]; });
 __webpack_require__.d(__webpack_exports__, "thresholdFreedmanDiaconis", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["w"]; });
 __webpack_require__.d(__webpack_exports__, "thresholdScott", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["x"]; });
 __webpack_require__.d(__webpack_exports__, "thresholdSturges", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["y"]; });
 __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["k"]; });
 __webpack_require__.d(__webpack_exports__, "mean", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["l"]; });
 __webpack_require__.d(__webpack_exports__, "median", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["m"]; });
 __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["n"]; });
 __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["o"]; });
 __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["p"]; });
 __webpack_require__.d(__webpack_exports__, "permute", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["q"]; });
 __webpack_require__.d(__webpack_exports__, "quantile", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["r"]; });
 __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["s"]; });
 __webpack_require__.d(__webpack_exports__, "scan", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["t"]; });
 __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["u"]; });
 __webpack_require__.d(__webpack_exports__, "sum", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["v"]; });
 __webpack_require__.d(__webpack_exports__, "ticks", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["B"]; });
 __webpack_require__.d(__webpack_exports__, "tickIncrement", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["z"]; });
 __webpack_require__.d(__webpack_exports__, "tickStep", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["A"]; });
 __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["C"]; });
 __webpack_require__.d(__webpack_exports__, "variance", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["D"]; });
 __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_1_d3_array__["E"]; });
 var __WEBPACK_IMPORTED_MODULE_2_d3_axis__ = __webpack_require__(1448);
 __webpack_require__.d(__webpack_exports__, "axisTop", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["d"]; });
 __webpack_require__.d(__webpack_exports__, "axisRight", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["c"]; });
 __webpack_require__.d(__webpack_exports__, "axisBottom", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["a"]; });
 __webpack_require__.d(__webpack_exports__, "axisLeft", function() { return __WEBPACK_IMPORTED_MODULE_2_d3_axis__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_3_d3_brush__ = __webpack_require__(1452);
 __webpack_require__.d(__webpack_exports__, "brush", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["a"]; });
 __webpack_require__.d(__webpack_exports__, "brushX", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["c"]; });
 __webpack_require__.d(__webpack_exports__, "brushY", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["d"]; });
 __webpack_require__.d(__webpack_exports__, "brushSelection", function() { return __WEBPACK_IMPORTED_MODULE_3_d3_brush__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_4_d3_chord__ = __webpack_require__(1539);
 __webpack_require__.d(__webpack_exports__, "chord", function() { return __WEBPACK_IMPORTED_MODULE_4_d3_chord__["a"]; });
 __webpack_require__.d(__webpack_exports__, "ribbon", function() { return __WEBPACK_IMPORTED_MODULE_4_d3_chord__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_5_d3_collection__ = __webpack_require__(139);
 __webpack_require__.d(__webpack_exports__, "nest", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["d"]; });
 __webpack_require__.d(__webpack_exports__, "set", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["e"]; });
 __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["c"]; });
 __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["b"]; });
 __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["f"]; });
 __webpack_require__.d(__webpack_exports__, "entries", function() { return __WEBPACK_IMPORTED_MODULE_5_d3_collection__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6_d3_color__ = __webpack_require__(60);
 __webpack_require__.d(__webpack_exports__, "color", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["a"]; });
 __webpack_require__.d(__webpack_exports__, "rgb", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["f"]; });
 __webpack_require__.d(__webpack_exports__, "hsl", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["d"]; });
 __webpack_require__.d(__webpack_exports__, "lab", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["e"]; });
 __webpack_require__.d(__webpack_exports__, "hcl", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["c"]; });
 __webpack_require__.d(__webpack_exports__, "cubehelix", function() { return __WEBPACK_IMPORTED_MODULE_6_d3_color__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_7_d3_dispatch__ = __webpack_require__(100);
 __webpack_require__.d(__webpack_exports__, "dispatch", function() { return __WEBPACK_IMPORTED_MODULE_7_d3_dispatch__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_8_d3_drag__ = __webpack_require__(276);
 __webpack_require__.d(__webpack_exports__, "drag", function() { return __WEBPACK_IMPORTED_MODULE_8_d3_drag__["a"]; });
 __webpack_require__.d(__webpack_exports__, "dragDisable", function() { return __WEBPACK_IMPORTED_MODULE_8_d3_drag__["b"]; });
 __webpack_require__.d(__webpack_exports__, "dragEnable", function() { return __WEBPACK_IMPORTED_MODULE_8_d3_drag__["c"]; });
 var __WEBPACK_IMPORTED_MODULE_9_d3_dsv__ = __webpack_require__(290);
 __webpack_require__.d(__webpack_exports__, "dsvFormat", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["e"]; });
 __webpack_require__.d(__webpack_exports__, "csvParse", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["c"]; });
 __webpack_require__.d(__webpack_exports__, "csvParseRows", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["d"]; });
 __webpack_require__.d(__webpack_exports__, "csvFormat", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["a"]; });
 __webpack_require__.d(__webpack_exports__, "csvFormatRows", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["b"]; });
 __webpack_require__.d(__webpack_exports__, "tsvParse", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["h"]; });
 __webpack_require__.d(__webpack_exports__, "tsvParseRows", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["i"]; });
 __webpack_require__.d(__webpack_exports__, "tsvFormat", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["f"]; });
 __webpack_require__.d(__webpack_exports__, "tsvFormatRows", function() { return __WEBPACK_IMPORTED_MODULE_9_d3_dsv__["g"]; });
 var __WEBPACK_IMPORTED_MODULE_10_d3_ease__ = __webpack_require__(522);
 __webpack_require__.d(__webpack_exports__, "easeLinear", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["y"]; });
 __webpack_require__.d(__webpack_exports__, "easeQuad", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["D"]; });
 __webpack_require__.d(__webpack_exports__, "easeQuadIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["E"]; });
 __webpack_require__.d(__webpack_exports__, "easeQuadOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["G"]; });
 __webpack_require__.d(__webpack_exports__, "easeQuadInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["F"]; });
 __webpack_require__.d(__webpack_exports__, "easeCubic", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["m"]; });
 __webpack_require__.d(__webpack_exports__, "easeCubicIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["n"]; });
 __webpack_require__.d(__webpack_exports__, "easeCubicOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["p"]; });
 __webpack_require__.d(__webpack_exports__, "easeCubicInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["o"]; });
 __webpack_require__.d(__webpack_exports__, "easePoly", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["z"]; });
 __webpack_require__.d(__webpack_exports__, "easePolyIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["A"]; });
 __webpack_require__.d(__webpack_exports__, "easePolyOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["C"]; });
 __webpack_require__.d(__webpack_exports__, "easePolyInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["B"]; });
 __webpack_require__.d(__webpack_exports__, "easeSin", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["H"]; });
 __webpack_require__.d(__webpack_exports__, "easeSinIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["I"]; });
 __webpack_require__.d(__webpack_exports__, "easeSinOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["K"]; });
 __webpack_require__.d(__webpack_exports__, "easeSinInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["J"]; });
 __webpack_require__.d(__webpack_exports__, "easeExp", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["u"]; });
 __webpack_require__.d(__webpack_exports__, "easeExpIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["v"]; });
 __webpack_require__.d(__webpack_exports__, "easeExpOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["x"]; });
 __webpack_require__.d(__webpack_exports__, "easeExpInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["w"]; });
 __webpack_require__.d(__webpack_exports__, "easeCircle", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["i"]; });
 __webpack_require__.d(__webpack_exports__, "easeCircleIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["j"]; });
 __webpack_require__.d(__webpack_exports__, "easeCircleOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["l"]; });
 __webpack_require__.d(__webpack_exports__, "easeCircleInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["k"]; });
 __webpack_require__.d(__webpack_exports__, "easeBounce", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["e"]; });
 __webpack_require__.d(__webpack_exports__, "easeBounceIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["f"]; });
 __webpack_require__.d(__webpack_exports__, "easeBounceOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["h"]; });
 __webpack_require__.d(__webpack_exports__, "easeBounceInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["g"]; });
 __webpack_require__.d(__webpack_exports__, "easeBack", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["a"]; });
 __webpack_require__.d(__webpack_exports__, "easeBackIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["b"]; });
 __webpack_require__.d(__webpack_exports__, "easeBackOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["d"]; });
 __webpack_require__.d(__webpack_exports__, "easeBackInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["c"]; });
 __webpack_require__.d(__webpack_exports__, "easeElastic", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["q"]; });
 __webpack_require__.d(__webpack_exports__, "easeElasticIn", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["r"]; });
 __webpack_require__.d(__webpack_exports__, "easeElasticOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["t"]; });
 __webpack_require__.d(__webpack_exports__, "easeElasticInOut", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["s"]; });
 var __WEBPACK_IMPORTED_MODULE_11_d3_force__ = __webpack_require__(1552);
 __webpack_require__.d(__webpack_exports__, "forceCenter", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["a"]; });
 __webpack_require__.d(__webpack_exports__, "forceCollide", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["b"]; });
 __webpack_require__.d(__webpack_exports__, "forceLink", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["c"]; });
 __webpack_require__.d(__webpack_exports__, "forceManyBody", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["d"]; });
 __webpack_require__.d(__webpack_exports__, "forceRadial", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["e"]; });
 __webpack_require__.d(__webpack_exports__, "forceSimulation", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["f"]; });
 __webpack_require__.d(__webpack_exports__, "forceX", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["g"]; });
 __webpack_require__.d(__webpack_exports__, "forceY", function() { return __WEBPACK_IMPORTED_MODULE_11_d3_force__["h"]; });
 var __WEBPACK_IMPORTED_MODULE_12_d3_format__ = __webpack_require__(295);
 __webpack_require__.d(__webpack_exports__, "formatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["b"]; });
 __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["a"]; });
 __webpack_require__.d(__webpack_exports__, "formatPrefix", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["d"]; });
 __webpack_require__.d(__webpack_exports__, "formatLocale", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["c"]; });
 __webpack_require__.d(__webpack_exports__, "formatSpecifier", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["e"]; });
 __webpack_require__.d(__webpack_exports__, "precisionFixed", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["f"]; });
 __webpack_require__.d(__webpack_exports__, "precisionPrefix", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["g"]; });
 __webpack_require__.d(__webpack_exports__, "precisionRound", function() { return __WEBPACK_IMPORTED_MODULE_12_d3_format__["h"]; });
 var __WEBPACK_IMPORTED_MODULE_13_d3_geo__ = __webpack_require__(1582);
 __webpack_require__.d(__webpack_exports__, "geoArea", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["c"]; });
 __webpack_require__.d(__webpack_exports__, "geoBounds", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["h"]; });
 __webpack_require__.d(__webpack_exports__, "geoCentroid", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["i"]; });
 __webpack_require__.d(__webpack_exports__, "geoCircle", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["j"]; });
 __webpack_require__.d(__webpack_exports__, "geoClipAntimeridian", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["k"]; });
 __webpack_require__.d(__webpack_exports__, "geoClipCircle", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["l"]; });
 __webpack_require__.d(__webpack_exports__, "geoClipExtent", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["m"]; });
 __webpack_require__.d(__webpack_exports__, "geoClipRectangle", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["n"]; });
 __webpack_require__.d(__webpack_exports__, "geoContains", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["u"]; });
 __webpack_require__.d(__webpack_exports__, "geoDistance", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["v"]; });
 __webpack_require__.d(__webpack_exports__, "geoGraticule", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["A"]; });
 __webpack_require__.d(__webpack_exports__, "geoGraticule10", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["B"]; });
 __webpack_require__.d(__webpack_exports__, "geoInterpolate", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["D"]; });
 __webpack_require__.d(__webpack_exports__, "geoLength", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["E"]; });
 __webpack_require__.d(__webpack_exports__, "geoPath", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["L"]; });
 __webpack_require__.d(__webpack_exports__, "geoAlbers", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["a"]; });
 __webpack_require__.d(__webpack_exports__, "geoAlbersUsa", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["b"]; });
 __webpack_require__.d(__webpack_exports__, "geoAzimuthalEqualArea", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["d"]; });
 __webpack_require__.d(__webpack_exports__, "geoAzimuthalEqualAreaRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["e"]; });
 __webpack_require__.d(__webpack_exports__, "geoAzimuthalEquidistant", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["f"]; });
 __webpack_require__.d(__webpack_exports__, "geoAzimuthalEquidistantRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["g"]; });
 __webpack_require__.d(__webpack_exports__, "geoConicConformal", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["o"]; });
 __webpack_require__.d(__webpack_exports__, "geoConicConformalRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["p"]; });
 __webpack_require__.d(__webpack_exports__, "geoConicEqualArea", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["q"]; });
 __webpack_require__.d(__webpack_exports__, "geoConicEqualAreaRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["r"]; });
 __webpack_require__.d(__webpack_exports__, "geoConicEquidistant", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["s"]; });
 __webpack_require__.d(__webpack_exports__, "geoConicEquidistantRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["t"]; });
 __webpack_require__.d(__webpack_exports__, "geoEquirectangular", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["w"]; });
 __webpack_require__.d(__webpack_exports__, "geoEquirectangularRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["x"]; });
 __webpack_require__.d(__webpack_exports__, "geoGnomonic", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["y"]; });
 __webpack_require__.d(__webpack_exports__, "geoGnomonicRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["z"]; });
 __webpack_require__.d(__webpack_exports__, "geoIdentity", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["C"]; });
 __webpack_require__.d(__webpack_exports__, "geoProjection", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["M"]; });
 __webpack_require__.d(__webpack_exports__, "geoProjectionMutator", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["N"]; });
 __webpack_require__.d(__webpack_exports__, "geoMercator", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["F"]; });
 __webpack_require__.d(__webpack_exports__, "geoMercatorRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["G"]; });
 __webpack_require__.d(__webpack_exports__, "geoNaturalEarth1", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["H"]; });
 __webpack_require__.d(__webpack_exports__, "geoNaturalEarth1Raw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["I"]; });
 __webpack_require__.d(__webpack_exports__, "geoOrthographic", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["J"]; });
 __webpack_require__.d(__webpack_exports__, "geoOrthographicRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["K"]; });
 __webpack_require__.d(__webpack_exports__, "geoStereographic", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["P"]; });
 __webpack_require__.d(__webpack_exports__, "geoStereographicRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["Q"]; });
 __webpack_require__.d(__webpack_exports__, "geoTransverseMercator", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["T"]; });
 __webpack_require__.d(__webpack_exports__, "geoTransverseMercatorRaw", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["U"]; });
 __webpack_require__.d(__webpack_exports__, "geoRotation", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["O"]; });
 __webpack_require__.d(__webpack_exports__, "geoStream", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["R"]; });
 __webpack_require__.d(__webpack_exports__, "geoTransform", function() { return __WEBPACK_IMPORTED_MODULE_13_d3_geo__["S"]; });
 var __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__ = __webpack_require__(1610);
 __webpack_require__.d(__webpack_exports__, "cluster", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["a"]; });
 __webpack_require__.d(__webpack_exports__, "hierarchy", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["b"]; });
 __webpack_require__.d(__webpack_exports__, "pack", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["c"]; });
 __webpack_require__.d(__webpack_exports__, "packSiblings", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["e"]; });
 __webpack_require__.d(__webpack_exports__, "packEnclose", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["d"]; });
 __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["f"]; });
 __webpack_require__.d(__webpack_exports__, "stratify", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["g"]; });
 __webpack_require__.d(__webpack_exports__, "tree", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["h"]; });
 __webpack_require__.d(__webpack_exports__, "treemap", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["i"]; });
 __webpack_require__.d(__webpack_exports__, "treemapBinary", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["j"]; });
 __webpack_require__.d(__webpack_exports__, "treemapDice", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["k"]; });
 __webpack_require__.d(__webpack_exports__, "treemapSlice", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["m"]; });
 __webpack_require__.d(__webpack_exports__, "treemapSliceDice", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["n"]; });
 __webpack_require__.d(__webpack_exports__, "treemapSquarify", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["o"]; });
 __webpack_require__.d(__webpack_exports__, "treemapResquarify", function() { return __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__["l"]; });
 var __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__ = __webpack_require__(57);
 __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["a"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["b"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["c"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["d"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["g"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["m"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["n"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["r"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["s"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["t"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["u"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["v"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["o"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["p"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["q"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["j"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["k"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["l"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["h"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["i"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["e"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["f"]; });
 __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__["w"]; });
 var __WEBPACK_IMPORTED_MODULE_16_d3_path__ = __webpack_require__(101);
 __webpack_require__.d(__webpack_exports__, "path", function() { return __WEBPACK_IMPORTED_MODULE_16_d3_path__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_17_d3_polygon__ = __webpack_require__(1632);
 __webpack_require__.d(__webpack_exports__, "polygonArea", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_polygon__["a"]; });
 __webpack_require__.d(__webpack_exports__, "polygonCentroid", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_polygon__["b"]; });
 __webpack_require__.d(__webpack_exports__, "polygonHull", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_polygon__["d"]; });
 __webpack_require__.d(__webpack_exports__, "polygonContains", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_polygon__["c"]; });
 __webpack_require__.d(__webpack_exports__, "polygonLength", function() { return __WEBPACK_IMPORTED_MODULE_17_d3_polygon__["e"]; });
 var __WEBPACK_IMPORTED_MODULE_18_d3_quadtree__ = __webpack_require__(293);
 __webpack_require__.d(__webpack_exports__, "quadtree", function() { return __WEBPACK_IMPORTED_MODULE_18_d3_quadtree__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_19_d3_queue__ = __webpack_require__(1639);
 __webpack_require__.d(__webpack_exports__, "queue", function() { return __WEBPACK_IMPORTED_MODULE_19_d3_queue__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_20_d3_random__ = __webpack_require__(1642);
 __webpack_require__.d(__webpack_exports__, "randomUniform", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["f"]; });
 __webpack_require__.d(__webpack_exports__, "randomNormal", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["e"]; });
 __webpack_require__.d(__webpack_exports__, "randomLogNormal", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["d"]; });
 __webpack_require__.d(__webpack_exports__, "randomBates", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["a"]; });
 __webpack_require__.d(__webpack_exports__, "randomIrwinHall", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["c"]; });
 __webpack_require__.d(__webpack_exports__, "randomExponential", function() { return __WEBPACK_IMPORTED_MODULE_20_d3_random__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_21_d3_request__ = __webpack_require__(1647);
 __webpack_require__.d(__webpack_exports__, "request", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["d"]; });
 __webpack_require__.d(__webpack_exports__, "html", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["b"]; });
 __webpack_require__.d(__webpack_exports__, "json", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["c"]; });
 __webpack_require__.d(__webpack_exports__, "text", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["e"]; });
 __webpack_require__.d(__webpack_exports__, "xml", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["g"]; });
 __webpack_require__.d(__webpack_exports__, "csv", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["a"]; });
 __webpack_require__.d(__webpack_exports__, "tsv", function() { return __WEBPACK_IMPORTED_MODULE_21_d3_request__["f"]; });
 var __WEBPACK_IMPORTED_MODULE_22_d3_scale__ = __webpack_require__(1654);
 __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["i"]; });
 __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["o"]; });
 __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["j"]; });
 __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["l"]; });
 __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["m"]; });
 __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["n"]; });
 __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["k"]; });
 __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["p"]; });
 __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["t"]; });
 __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["q"]; });
 __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["r"]; });
 __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["u"]; });
 __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["v"]; });
 __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["w"]; });
 __webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["x"]; });
 __webpack_require__.d(__webpack_exports__, "schemeCategory20b", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["z"]; });
 __webpack_require__.d(__webpack_exports__, "schemeCategory20c", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["A"]; });
 __webpack_require__.d(__webpack_exports__, "schemeCategory20", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["y"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["b"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["f"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["h"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["a"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["g"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["d"]; });
 __webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["c"]; });
 __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["e"]; });
 __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["s"]; });
 var __WEBPACK_IMPORTED_MODULE_23_d3_selection__ = __webpack_require__(35);
 __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["b"]; });
 __webpack_require__.d(__webpack_exports__, "creator", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["c"]; });
 __webpack_require__.d(__webpack_exports__, "local", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["f"]; });
 __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["g"]; });
 __webpack_require__.d(__webpack_exports__, "mouse", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["h"]; });
 __webpack_require__.d(__webpack_exports__, "namespace", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["i"]; });
 __webpack_require__.d(__webpack_exports__, "namespaces", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["j"]; });
 __webpack_require__.d(__webpack_exports__, "clientPoint", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["a"]; });
 __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["k"]; });
 __webpack_require__.d(__webpack_exports__, "selectAll", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["l"]; });
 __webpack_require__.d(__webpack_exports__, "selection", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["m"]; });
 __webpack_require__.d(__webpack_exports__, "selector", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["n"]; });
 __webpack_require__.d(__webpack_exports__, "selectorAll", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["o"]; });
 __webpack_require__.d(__webpack_exports__, "style", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["p"]; });
 __webpack_require__.d(__webpack_exports__, "touch", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["q"]; });
 __webpack_require__.d(__webpack_exports__, "touches", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["r"]; });
 __webpack_require__.d(__webpack_exports__, "window", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["s"]; });
 __webpack_require__.d(__webpack_exports__, "event", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["e"]; });
 __webpack_require__.d(__webpack_exports__, "customEvent", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["d"]; });
 var __WEBPACK_IMPORTED_MODULE_24_d3_shape__ = __webpack_require__(1687);
 __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["a"]; });
 __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["b"]; });
 __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["v"]; });
 __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["A"]; });
 __webpack_require__.d(__webpack_exports__, "areaRadial", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["c"]; });
 __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["C"]; });
 __webpack_require__.d(__webpack_exports__, "lineRadial", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["w"]; });
 __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["D"]; });
 __webpack_require__.d(__webpack_exports__, "pointRadial", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["B"]; });
 __webpack_require__.d(__webpack_exports__, "linkHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["x"]; });
 __webpack_require__.d(__webpack_exports__, "linkVertical", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["z"]; });
 __webpack_require__.d(__webpack_exports__, "linkRadial", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["y"]; });
 __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["P"]; });
 __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["X"]; });
 __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["Q"]; });
 __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["R"]; });
 __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["S"]; });
 __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["T"]; });
 __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["U"]; });
 __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["V"]; });
 __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["W"]; });
 __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["e"]; });
 __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["f"]; });
 __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["d"]; });
 __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["g"]; });
 __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["i"]; });
 __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["j"]; });
 __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["h"]; });
 __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["l"]; });
 __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["m"]; });
 __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["k"]; });
 __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["o"]; });
 __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["n"]; });
 __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["p"]; });
 __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["q"]; });
 __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["r"]; });
 __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["s"]; });
 __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["t"]; });
 __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["u"]; });
 __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["E"]; });
 __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["G"]; });
 __webpack_require__.d(__webpack_exports__, "stackOffsetDiverging", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["F"]; });
 __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["H"]; });
 __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["I"]; });
 __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["J"]; });
 __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["K"]; });
 __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["L"]; });
 __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["M"]; });
 __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["N"]; });
 __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["O"]; });
 var __WEBPACK_IMPORTED_MODULE_25_d3_time__ = __webpack_require__(197);
 __webpack_require__.d(__webpack_exports__, "timeInterval", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["g"]; });
 __webpack_require__.d(__webpack_exports__, "timeMillisecond", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["h"]; });
 __webpack_require__.d(__webpack_exports__, "timeMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["i"]; });
 __webpack_require__.d(__webpack_exports__, "utcMillisecond", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["L"]; });
 __webpack_require__.d(__webpack_exports__, "utcMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["M"]; });
 __webpack_require__.d(__webpack_exports__, "timeSecond", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["r"]; });
 __webpack_require__.d(__webpack_exports__, "timeSeconds", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["s"]; });
 __webpack_require__.d(__webpack_exports__, "utcSecond", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["V"]; });
 __webpack_require__.d(__webpack_exports__, "utcSeconds", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["W"]; });
 __webpack_require__.d(__webpack_exports__, "timeMinute", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["j"]; });
 __webpack_require__.d(__webpack_exports__, "timeMinutes", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["k"]; });
 __webpack_require__.d(__webpack_exports__, "timeHour", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["e"]; });
 __webpack_require__.d(__webpack_exports__, "timeHours", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["f"]; });
 __webpack_require__.d(__webpack_exports__, "timeDay", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["a"]; });
 __webpack_require__.d(__webpack_exports__, "timeDays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["b"]; });
 __webpack_require__.d(__webpack_exports__, "timeWeek", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["B"]; });
 __webpack_require__.d(__webpack_exports__, "timeWeeks", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["C"]; });
 __webpack_require__.d(__webpack_exports__, "timeSunday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["t"]; });
 __webpack_require__.d(__webpack_exports__, "timeSundays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["u"]; });
 __webpack_require__.d(__webpack_exports__, "timeMonday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["l"]; });
 __webpack_require__.d(__webpack_exports__, "timeMondays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["m"]; });
 __webpack_require__.d(__webpack_exports__, "timeTuesday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["x"]; });
 __webpack_require__.d(__webpack_exports__, "timeTuesdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["y"]; });
 __webpack_require__.d(__webpack_exports__, "timeWednesday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["z"]; });
 __webpack_require__.d(__webpack_exports__, "timeWednesdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["A"]; });
 __webpack_require__.d(__webpack_exports__, "timeThursday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["v"]; });
 __webpack_require__.d(__webpack_exports__, "timeThursdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["w"]; });
 __webpack_require__.d(__webpack_exports__, "timeFriday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["c"]; });
 __webpack_require__.d(__webpack_exports__, "timeFridays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["d"]; });
 __webpack_require__.d(__webpack_exports__, "timeSaturday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["p"]; });
 __webpack_require__.d(__webpack_exports__, "timeSaturdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["q"]; });
 __webpack_require__.d(__webpack_exports__, "timeMonth", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["n"]; });
 __webpack_require__.d(__webpack_exports__, "timeMonths", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["o"]; });
 __webpack_require__.d(__webpack_exports__, "timeYear", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["D"]; });
 __webpack_require__.d(__webpack_exports__, "timeYears", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["E"]; });
 __webpack_require__.d(__webpack_exports__, "utcMinute", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["N"]; });
 __webpack_require__.d(__webpack_exports__, "utcMinutes", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["O"]; });
 __webpack_require__.d(__webpack_exports__, "utcHour", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["J"]; });
 __webpack_require__.d(__webpack_exports__, "utcHours", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["K"]; });
 __webpack_require__.d(__webpack_exports__, "utcDay", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["F"]; });
 __webpack_require__.d(__webpack_exports__, "utcDays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["G"]; });
 __webpack_require__.d(__webpack_exports__, "utcWeek", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_5"]; });
 __webpack_require__.d(__webpack_exports__, "utcWeeks", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_6"]; });
 __webpack_require__.d(__webpack_exports__, "utcSunday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["X"]; });
 __webpack_require__.d(__webpack_exports__, "utcSundays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["Y"]; });
 __webpack_require__.d(__webpack_exports__, "utcMonday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["P"]; });
 __webpack_require__.d(__webpack_exports__, "utcMondays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["Q"]; });
 __webpack_require__.d(__webpack_exports__, "utcTuesday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_1"]; });
 __webpack_require__.d(__webpack_exports__, "utcTuesdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_2"]; });
 __webpack_require__.d(__webpack_exports__, "utcWednesday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_3"]; });
 __webpack_require__.d(__webpack_exports__, "utcWednesdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_4"]; });
 __webpack_require__.d(__webpack_exports__, "utcThursday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["Z"]; });
 __webpack_require__.d(__webpack_exports__, "utcThursdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_0"]; });
 __webpack_require__.d(__webpack_exports__, "utcFriday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["H"]; });
 __webpack_require__.d(__webpack_exports__, "utcFridays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["I"]; });
 __webpack_require__.d(__webpack_exports__, "utcSaturday", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["T"]; });
 __webpack_require__.d(__webpack_exports__, "utcSaturdays", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["U"]; });
 __webpack_require__.d(__webpack_exports__, "utcMonth", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["R"]; });
 __webpack_require__.d(__webpack_exports__, "utcMonths", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["S"]; });
 __webpack_require__.d(__webpack_exports__, "utcYear", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_7"]; });
 __webpack_require__.d(__webpack_exports__, "utcYears", function() { return __WEBPACK_IMPORTED_MODULE_25_d3_time__["_8"]; });
 var __WEBPACK_IMPORTED_MODULE_26_d3_time_format__ = __webpack_require__(307);
 __webpack_require__.d(__webpack_exports__, "timeFormatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["d"]; });
 __webpack_require__.d(__webpack_exports__, "timeFormat", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["c"]; });
 __webpack_require__.d(__webpack_exports__, "timeParse", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["f"]; });
 __webpack_require__.d(__webpack_exports__, "utcFormat", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["g"]; });
 __webpack_require__.d(__webpack_exports__, "utcParse", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["h"]; });
 __webpack_require__.d(__webpack_exports__, "timeFormatLocale", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["e"]; });
 __webpack_require__.d(__webpack_exports__, "isoFormat", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["a"]; });
 __webpack_require__.d(__webpack_exports__, "isoParse", function() { return __WEBPACK_IMPORTED_MODULE_26_d3_time_format__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_27_d3_timer__ = __webpack_require__(188);
 __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_timer__["b"]; });
 __webpack_require__.d(__webpack_exports__, "timer", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_timer__["d"]; });
 __webpack_require__.d(__webpack_exports__, "timerFlush", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_timer__["e"]; });
 __webpack_require__.d(__webpack_exports__, "timeout", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_timer__["c"]; });
 __webpack_require__.d(__webpack_exports__, "interval", function() { return __WEBPACK_IMPORTED_MODULE_27_d3_timer__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_28_d3_transition__ = __webpack_require__(287);
 __webpack_require__.d(__webpack_exports__, "transition", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_transition__["c"]; });
 __webpack_require__.d(__webpack_exports__, "active", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_transition__["a"]; });
 __webpack_require__.d(__webpack_exports__, "interrupt", function() { return __WEBPACK_IMPORTED_MODULE_28_d3_transition__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_29_d3_voronoi__ = __webpack_require__(1712);
 __webpack_require__.d(__webpack_exports__, "voronoi", function() { return __WEBPACK_IMPORTED_MODULE_29_d3_voronoi__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_30_d3_zoom__ = __webpack_require__(1717);
 __webpack_require__.d(__webpack_exports__, "zoom", function() { return __WEBPACK_IMPORTED_MODULE_30_d3_zoom__["a"]; });
 __webpack_require__.d(__webpack_exports__, "zoomTransform", function() { return __WEBPACK_IMPORTED_MODULE_30_d3_zoom__["c"]; });
 __webpack_require__.d(__webpack_exports__, "zoomIdentity", function() { return __WEBPACK_IMPORTED_MODULE_30_d3_zoom__["b"]; });

































 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

 __webpack_require__.d(__webpack_exports__, "a", function() { return version; });













var name = "d3";
var version = "4.13.0";
var description = "Data-Driven Documents";
var keywords = ["dom","visualization","svg","animation","canvas"];
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {"name":"Mike Bostock","url":"https://bost.ocks.org/mike"};
var main = "build/d3.node.js";
var unpkg = "build/d3.min.js";
var jsdelivr = "build/d3.min.js";
var module = "index";
var repository = {"type":"git","url":"https://github.com/d3/d3.git"};
var scripts = {"pretest":"rimraf build && mkdir build && json2module package.json > build/package.js && node rollup.node","test":"tape 'test*-test.js'","prepublishOnly":"npm run test && rollup -c --banner \"$(preamble)\" && uglifyjs -b beautify=false,preamble=\"'$(preamble)'\" build/d3.js -c negate_iife=false -m -o build/d3.min.js","postpublish":"git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/build/d3.js d3.v4.js && cp ../d3/build/d3.min.js d3.v4.min.js && git add d3.v4.js d3.v4.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/build/d3.js ../d3/build/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j build/d3.zip -- LICENSE README.md API.md CHANGES.md build/d3.js build/d3.min.js"};
var devDependencies = {"json2module":"0.0","package-preamble":"0.1","rimraf":"2","rollup":"0.53","rollup-plugin-ascii":"0.0","rollup-plugin-node-resolve":"3","tape":"4","uglify-js":"3.2"};
var dependencies = {"d3-array":"1.2.1","d3-axis":"1.0.8","d3-brush":"1.0.4","d3-chord":"1.0.4","d3-collection":"1.0.4","d3-color":"1.0.3","d3-dispatch":"1.0.3","d3-drag":"1.2.1","d3-dsv":"1.0.8","d3-ease":"1.0.3","d3-force":"1.1.0","d3-format":"1.2.2","d3-geo":"1.9.1","d3-hierarchy":"1.1.5","d3-interpolate":"1.1.6","d3-path":"1.0.5","d3-polygon":"1.0.3","d3-quadtree":"1.0.3","d3-queue":"3.0.7","d3-random":"1.1.0","d3-request":"1.0.6","d3-scale":"1.0.7","d3-selection":"1.3.0","d3-shape":"1.2.0","d3-time":"1.0.8","d3-time-format":"2.1.1","d3-timer":"1.0.7","d3-transition":"1.1.1","d3-voronoi":"1.1.2","d3-zoom":"1.7.1"};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(494);


 __webpack_exports__["a"] = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["b" ];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(498);
 var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(492);
 var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1435);
 var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(497);
 var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(1436);
 var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(499);
 var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(500);
 var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(501);









 __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" ],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" ],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" ];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" ])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" ])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["c" ])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" ])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" ])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" ])(__WEBPACK_IMPORTED_MODULE_0__array__["b" ].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" ])(_), histogram) : threshold;
  };

  return histogram;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return x;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(498);
 var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(118);
 var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(137);
 var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(275);





 __webpack_exports__["a"] = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" ].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" ]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" ]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" ])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" ])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(495);


 __webpack_exports__["a"] = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" ])(values) * Math.pow(values.length, -1 / 3)));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(137);


 __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(118);
 var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(137);
 var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(275);




 __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" ])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" ])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" ])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" ]), 0.5);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(118);


 __webpack_exports__["a"] = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" ];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(503);


 __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" ])(arguments);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_axis__ = __webpack_require__(1449);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["d"]; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["c"]; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["a"]; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["b"]; });



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["d"] = axisTop;
 __webpack_exports__["c"] = axisRight;
 __webpack_exports__["a"] = axisBottom;
 __webpack_exports__["b"] = axisLeft;
 var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(1450);
 var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(1451);



var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : __WEBPACK_IMPORTED_MODULE_1__identity__["a" ]) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = __WEBPACK_IMPORTED_MODULE_0__array__["a" ].call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : __WEBPACK_IMPORTED_MODULE_0__array__["a" ].call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : __WEBPACK_IMPORTED_MODULE_0__array__["a" ].call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return x;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_brush__ = __webpack_require__(1453);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["d"]; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["b"]; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["c"]; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["a"]; });



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = brushSelection;
 __webpack_exports__["b"] = brushX;
 __webpack_exports__["c"] = brushY;
 var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(100);
 var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(276);
 var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(57);
 var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(287);
 var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(1536);
 var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(1537);
 var __WEBPACK_IMPORTED_MODULE_7__noevent__ = __webpack_require__(1538);









var MODE_DRAG = {name: "drag"},
    MODE_SPACE = {name: "space"},
    MODE_HANDLE = {name: "handle"},
    MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush(X);
}

function brushY() {
  return brush(Y);
}

 __webpack_exports__["d"] = (function() {
  return brush(XY);
});

function brush(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" ])(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local(this).extent;
          Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" ])(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = Object(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["a" ])(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" ])(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" ])(this),
        selection = local(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" ])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" ](brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].touches) { if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].changedTouches.length < __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].touches.length) return Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" ])(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].target.__data__.type,
        mode = (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].shiftKey,
        lockX,
        lockY,
        point0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" ])(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" ])(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" ])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" ])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].view);
    }

    Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" ])();
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" ])(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" ])(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" ])();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" ])();
      if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].touches) {
        if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["c" ])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty(selection)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" ])();
    }

    function keyupped() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" ])();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" ])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" ])(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

 __webpack_exports__["a"] = (dispatch);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(100);
 var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_2__nodrag__ = __webpack_require__(510);
 var __WEBPACK_IMPORTED_MODULE_3__noevent__ = __webpack_require__(511);
 var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(1490);
 var __WEBPACK_IMPORTED_MODULE_5__event__ = __webpack_require__(1491);







// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].x, y: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].y} : d;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

 __webpack_exports__["a"] = (function() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" ])("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), __WEBPACK_IMPORTED_MODULE_1_d3_selection__["h" ], this, arguments);
    if (!gesture) return;
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["k" ])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["a" ])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].view);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" ])();
    mousemoving = false;
    mousedownx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].clientX;
    mousedowny = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].clientY;
    gesture("start");
  }

  function mousemoved() {
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" ])();
    if (!mousemoving) {
      var dx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].clientX - mousedownx, dy = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["k" ])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].view).on("mousemove.drag mouseup.drag", null);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["b" ])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].view, mousemoving);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" ])();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].changedTouches,
        c = container.apply(this, arguments),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches[i].identifier, c, __WEBPACK_IMPORTED_MODULE_1_d3_selection__["q" ], this, arguments)) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" ])();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" ])();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" ])();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["d" ])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" ](drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" ].subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["d" ])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" ](drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" ])(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" ])(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" ])(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" ])(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(185);
 var __WEBPACK_IMPORTED_MODULE_1__select__ = __webpack_require__(504);



 __webpack_exports__["a"] = (function(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__select__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" ])(name).call(document.documentElement));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(56);
 var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(279);



 __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" ])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" ](subgroups, this._parents);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(56);
 var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(505);



 __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" ])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" ](subgroups, parents);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(56);
 var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(506);



 __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" ])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" ](subgroups, this._parents);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(56);
 var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(507);
 var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1461);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" ](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" ](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

 __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" ])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" ](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(508);
 var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(56);



 __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" ](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" ]), this._parents);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(56);


 __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" ](merges, this._parents);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(56);


 __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" ](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  return !this.node();
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(277);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

 __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" ])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

 __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

 __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

 __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

 __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

 __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

 __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(185);


 __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" ])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(185);
 var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(279);



function constantNull() {
  return null;
}

 __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" ])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" ])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

 __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function selection_cloneShallow() {
  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
}

function selection_cloneDeep() {
  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
}

 __webpack_exports__["a"] = (function(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(280);


function dispatchEvent(node, type, params) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" ])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

 __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = local;
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(282);
 var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(186);



 __webpack_exports__["a"] = (function(node) {
  var event = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" ])();
  if (event.changedTouches) event = event.changedTouches[0];
  return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" ])(node, event);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(56);


 __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" ]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" ]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" ]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(282);
 var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(186);



 __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" ])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" ])(node, touch);
    }
  }

  return null;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(282);
 var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(186);



 __webpack_exports__["a"] = (function(node, touches) {
  if (touches == null) touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" ])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" ])(node, touches[i]);
  }

  return points;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = DragEvent;
function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = lab;

 __webpack_exports__["b"] = hcl;

 var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(285);
 var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(284);
 var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(512);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" ];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" ])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" ])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" ])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" ])(__WEBPACK_IMPORTED_MODULE_1__color__["a" ], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" ](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" ];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" ])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" ])(__WEBPACK_IMPORTED_MODULE_1__color__["a" ], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = cubehelix;

 var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(285);
 var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(284);
 var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(512);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" ])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" ])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" ] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" ])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" ])(__WEBPACK_IMPORTED_MODULE_1__color__["a" ], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" ] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" ], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" ] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" ], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" ],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" ](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
 var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(187);
 var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(1496);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" ])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" ], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" ], ", ", ")", ")");


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = parseCss;
 __webpack_exports__["b"] = parseSvg;
 var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(1497);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" ];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" ])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" ];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" ];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" ])(value.a, value.b, value.c, value.d, value.e, value.f);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

 __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
 __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
 var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(60);
 var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(138);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" ])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" ])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

 __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" ]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" ]);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = lab;
 var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(60);
 var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(138);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" ])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" ])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
 var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(60);
 var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(138);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" ])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" ])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

 __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" ]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" ]);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
 var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(60);
 var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(138);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" ])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" ])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" ])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

 __webpack_exports__["b"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" ]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" ]);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_1__interrupt__ = __webpack_require__(1505);
 var __WEBPACK_IMPORTED_MODULE_2__transition__ = __webpack_require__(1508);




__WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" ].prototype.interrupt = __WEBPACK_IMPORTED_MODULE_1__interrupt__["a" ];
__WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" ].prototype.transition = __WEBPACK_IMPORTED_MODULE_2__transition__["a" ];


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__interrupt__ = __webpack_require__(520);


 __webpack_exports__["a"] = (function(name) {
  return this.each(function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__interrupt__["a" ])(this, name);
  });
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(288);


 __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" ];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(288);


 __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" ], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" ])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(79);
 var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(58);
 var __WEBPACK_IMPORTED_MODULE_2_d3_ease__ = __webpack_require__(522);
 var __WEBPACK_IMPORTED_MODULE_3_d3_timer__ = __webpack_require__(188);





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: __WEBPACK_IMPORTED_MODULE_2_d3_ease__["o" ]
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["b" ])(), defaultTiming;
    }
  }
  return timing;
}

 __webpack_exports__["a"] = (function(name) {
  var id,
      timing;

  if (name instanceof __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" ]) {
    id = name._id, name = name._name;
  } else {
    id = Object(__WEBPACK_IMPORTED_MODULE_0__transition_index__["c" ])(), (timing = defaultTiming).time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["b" ])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        Object(__WEBPACK_IMPORTED_MODULE_1__transition_schedule__["e" ])(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" ](groups, this._parents, name, id);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(57);
 var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(189);
 var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(521);





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

 __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["i" ])(name), i = fullname === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["u" ] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" ];
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" ])(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

 __webpack_exports__["a"] = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["i" ])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(58);


function delayFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" ])(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" ])(this, id).delay = value;
  };
}

 __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" ])(this.node(), id).delay;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(58);


function durationFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" ])(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" ])(this, id).duration = value;
  };
}

 __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" ])(this.node(), id).duration;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(58);


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" ])(this, id).ease = value;
  };
}

 __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" ])(this.node(), id).ease;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(79);



 __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" ])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" ](subgroups, this._parents, this._name, this._id);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(79);


 __webpack_exports__["a"] = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" ](merges, this._parents, this._name, this._id);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(58);


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? __WEBPACK_IMPORTED_MODULE_0__schedule__["g" ] : __WEBPACK_IMPORTED_MODULE_0__schedule__["h" ];
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

 __webpack_exports__["a"] = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" ])(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

 __webpack_exports__["a"] = (function() {
  return this.on("end.remove", removeFunction(this._id));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(79);
 var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(58);




 __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["n" ])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" ])(subgroup[i], name, id, i, subgroup, Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" ])(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" ](subgroups, this._parents, name, id);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(79);
 var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(58);




 __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["o" ])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" ])(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" ])(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" ](subgroups, parents, name, id);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);


var Selection = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["m" ].prototype.constructor;

 __webpack_exports__["a"] = (function() {
  return new Selection(this._groups, this._parents);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(57);
 var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(189);
 var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(521);





function styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" ])(this, name),
        value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" ])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" ])(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" ])(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["p" ])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

 __webpack_exports__["a"] = (function(name, value, priority) {
  var i = (name += "") === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["t" ] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" ];
  return value == null ? this
          .styleTween(name, styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction(name, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" ])(this, "style." + name, value))
          : styleConstant(name, i, value + ""), priority);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

 __webpack_exports__["a"] = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__tween__ = __webpack_require__(189);


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

 __webpack_exports__["a"] = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(Object(__WEBPACK_IMPORTED_MODULE_0__tween__["b" ])(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(79);
 var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__(58);



 __webpack_exports__["a"] = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = Object(__WEBPACK_IMPORTED_MODULE_0__index__["c" ])();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["f" ])(node, id0);
        Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["e" ])(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" ](groups, this._parents, name, id1);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = linear;
function linear(t) {
  return +t;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = quadIn;
 __webpack_exports__["c"] = quadOut;
 __webpack_exports__["b"] = quadInOut;
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = cubicIn;
 __webpack_exports__["c"] = cubicOut;
 __webpack_exports__["b"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return polyIn; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return polyOut; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return polyInOut; });
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = sinIn;
 __webpack_exports__["c"] = sinOut;
 __webpack_exports__["b"] = sinInOut;
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = expIn;
 __webpack_exports__["c"] = expOut;
 __webpack_exports__["b"] = expInOut;
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = circleIn;
 __webpack_exports__["c"] = circleOut;
 __webpack_exports__["b"] = circleInOut;
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = bounceIn;
 __webpack_exports__["c"] = bounceOut;
 __webpack_exports__["b"] = bounceInOut;
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return backIn; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return backOut; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return backInOut; });
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return elasticIn; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return elasticOut; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return elasticInOut; });
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(79);
 var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(58);



var root = [null];

 __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > __WEBPACK_IMPORTED_MODULE_1__transition_schedule__["c" ] && schedule.name === name) {
        return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" ]([[node]], root, name, +i);
      }
    }
  }

  return null;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = nopropagation;
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" ].stopImmediatePropagation();
}

 __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" ].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" ].stopImmediatePropagation();
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_chord__ = __webpack_require__(1540);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_chord__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_ribbon__ = __webpack_require__(1541);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ribbon__["a"]; });




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(523);



function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

 __webpack_exports__["a"] = (function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" ])(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" ])(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" ])(0, __WEBPACK_IMPORTED_MODULE_1__math__["e" ] - padAngle * n) / k;
    dx = k ? padAngle : __WEBPACK_IMPORTED_MODULE_1__math__["e" ] / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" ])(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(1542);
 var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(1543);
 var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(523);
 var __WEBPACK_IMPORTED_MODULE_3_d3_path__ = __webpack_require__(101);





function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

 __webpack_exports__["a"] = (function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = __WEBPACK_IMPORTED_MODULE_0__array__["a" ].call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" ],
        sa1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" ],
        sx0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" ])(sa0),
        sy0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" ],
        ta1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" ];

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_3_d3_path__["a" ])();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" ])(ta0), tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

 __webpack_exports__["a"] = (path);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(289);


 __webpack_exports__["a"] = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" ])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" ])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(289);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" ].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" ] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

 __webpack_exports__["a"] = (set);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return csvParse; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return csvParseRows; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return csvFormat; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return csvFormatRows; });
 var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__(291);


var csv = Object(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" ])(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatRows = csv.formatRows;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return tsvParse; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return tsvParseRows; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return tsvFormat; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return tsvFormatRows; });
 var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__(291);


var tsv = Object(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" ])("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatRows = tsv.formatRows;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_center__ = __webpack_require__(1553);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_center__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_collide__ = __webpack_require__(1554);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_collide__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_link__ = __webpack_require__(1568);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_link__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_manyBody__ = __webpack_require__(1569);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_manyBody__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_radial__ = __webpack_require__(1570);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_radial__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_simulation__ = __webpack_require__(524);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_simulation__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_x__ = __webpack_require__(1571);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__src_x__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__src_y__ = __webpack_require__(1572);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__src_y__["a"]; });










 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(119);
 var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(292);
 var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(293);




function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

 __webpack_exports__["a"] = (function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" ])(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" ])(), l += x * x;
            if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" ])(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), initialize(), force) : radius;
  };

  return force;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = quadtree;
 var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(1556);
 var __WEBPACK_IMPORTED_MODULE_1__cover__ = __webpack_require__(1557);
 var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(1558);
 var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(1559);
 var __WEBPACK_IMPORTED_MODULE_4__find__ = __webpack_require__(1560);
 var __WEBPACK_IMPORTED_MODULE_5__remove__ = __webpack_require__(1561);
 var __WEBPACK_IMPORTED_MODULE_6__root__ = __webpack_require__(1562);
 var __WEBPACK_IMPORTED_MODULE_7__size__ = __webpack_require__(1563);
 var __WEBPACK_IMPORTED_MODULE_8__visit__ = __webpack_require__(1564);
 var __WEBPACK_IMPORTED_MODULE_9__visitAfter__ = __webpack_require__(1565);
 var __WEBPACK_IMPORTED_MODULE_10__x__ = __webpack_require__(1566);
 var __WEBPACK_IMPORTED_MODULE_11__y__ = __webpack_require__(1567);













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? __WEBPACK_IMPORTED_MODULE_10__x__["b" ] : x, y == null ? __WEBPACK_IMPORTED_MODULE_11__y__["b" ] : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = __WEBPACK_IMPORTED_MODULE_0__add__["b" ];
treeProto.addAll = __WEBPACK_IMPORTED_MODULE_0__add__["a" ];
treeProto.cover = __WEBPACK_IMPORTED_MODULE_1__cover__["a" ];
treeProto.data = __WEBPACK_IMPORTED_MODULE_2__data__["a" ];
treeProto.extent = __WEBPACK_IMPORTED_MODULE_3__extent__["a" ];
treeProto.find = __WEBPACK_IMPORTED_MODULE_4__find__["a" ];
treeProto.remove = __WEBPACK_IMPORTED_MODULE_5__remove__["a" ];
treeProto.removeAll = __WEBPACK_IMPORTED_MODULE_5__remove__["b" ];
treeProto.root = __WEBPACK_IMPORTED_MODULE_6__root__["a" ];
treeProto.size = __WEBPACK_IMPORTED_MODULE_7__size__["a" ];
treeProto.visit = __WEBPACK_IMPORTED_MODULE_8__visit__["a" ];
treeProto.visitAfter = __WEBPACK_IMPORTED_MODULE_9__visitAfter__["a" ];
treeProto.x = __WEBPACK_IMPORTED_MODULE_10__x__["a" ];
treeProto.y = __WEBPACK_IMPORTED_MODULE_11__y__["a" ];


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = addAll;
 __webpack_exports__["b"] = (function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
});

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(294);


 __webpack_exports__["a"] = (function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](node[3], xm, ym, x2, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](node[2], x1, ym, xm, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](node[1], xm, y1, x2, ym),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = removeAll;
 __webpack_exports__["a"] = (function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
});

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  return this._root;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(294);


 __webpack_exports__["a"] = (function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](child, x0, y0, xm, ym));
    }
  }
  return this;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(294);


 __webpack_exports__["a"] = (function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" ](child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = defaultX;
function defaultX(d) {
  return d[0];
}

 __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = defaultY;
function defaultY(d) {
  return d[1];
}

 __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(119);
 var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(292);
 var __WEBPACK_IMPORTED_MODULE_2_d3_collection__ = __webpack_require__(139);




function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

 __webpack_exports__["a"] = (function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" ])();
        y = target.y + target.vy - source.y - source.vy || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" ])();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = Object(__WEBPACK_IMPORTED_MODULE_2_d3_collection__["c" ])(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), initializeDistance(), force) : distance;
  };

  return force;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(119);
 var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(292);
 var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(293);
 var __WEBPACK_IMPORTED_MODULE_3__simulation__ = __webpack_require__(524);





 __webpack_exports__["a"] = (function() {
  var nodes,
      node,
      alpha,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" ])(nodes, __WEBPACK_IMPORTED_MODULE_3__simulation__["b" ], __WEBPACK_IMPORTED_MODULE_3__simulation__["c" ]).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" ])(), l += x * x;
        if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" ])(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" ])(), l += x * x;
      if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" ])(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(119);


 __webpack_exports__["a"] = (function(radius, x, y) {
  var nodes,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(0.1),
      strengths,
      radiuses;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+radius);
  if (x == null) x = 0;
  if (y == null) y = 0;

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i],
          dx = node.x - x || 1e-6,
          dy = node.y - y || 1e-6,
          r = Math.sqrt(dx * dx + dy * dy),
          k = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k;
      node.vy += dy * k;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _, initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), initialize(), force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), initialize(), force) : radius;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(119);


 __webpack_exports__["a"] = (function(x) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), initialize(), force) : x;
  };

  return force;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(119);


 __webpack_exports__["a"] = (function(y) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), initialize(), force) : y;
  };

  return force;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return format; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return formatPrefix; });
 __webpack_exports__["a"] = defaultLocale;
 var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(525);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" ])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(296);


 __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" ])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return x;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(190);


 __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" ])(Math.abs(step)));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(190);


 __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" ])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" ])(Math.abs(step)));
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(190);


 __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" ])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" ])(step)) + 1;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(529);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_area__["c"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_bounds__ = __webpack_require__(1583);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_bounds__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_centroid__ = __webpack_require__(1584);
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__src_centroid__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_circle__ = __webpack_require__(530);
 __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__src_circle__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_clip_antimeridian__ = __webpack_require__(532);
 __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__src_clip_antimeridian__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_clip_circle__ = __webpack_require__(538);
 __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__src_clip_circle__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_clip_extent__ = __webpack_require__(1586);
 __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__src_clip_extent__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__src_clip_rectangle__ = __webpack_require__(192);
 __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__src_clip_rectangle__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_8__src_contains__ = __webpack_require__(1588);
 __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__src_contains__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_9__src_distance__ = __webpack_require__(539);
 __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_9__src_distance__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_10__src_graticule__ = __webpack_require__(1589);
 __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_10__src_graticule__["a"]; });
 __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_10__src_graticule__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_11__src_interpolate__ = __webpack_require__(1590);
 __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_11__src_interpolate__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_12__src_length__ = __webpack_require__(540);
 __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_12__src_length__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_13__src_path_index__ = __webpack_require__(1591);
 __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_13__src_path_index__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_14__src_projection_albers__ = __webpack_require__(542);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__src_projection_albers__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_15__src_projection_albersUsa__ = __webpack_require__(1599);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__src_projection_albersUsa__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__ = __webpack_require__(1600);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__["b"]; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__ = __webpack_require__(1601);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__["b"]; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_18__src_projection_conicConformal__ = __webpack_require__(1602);
 __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_18__src_projection_conicConformal__["b"]; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_18__src_projection_conicConformal__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_19__src_projection_conicEqualArea__ = __webpack_require__(298);
 __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_19__src_projection_conicEqualArea__["b"]; });
 __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_19__src_projection_conicEqualArea__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_20__src_projection_conicEquidistant__ = __webpack_require__(1603);
 __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_20__src_projection_conicEquidistant__["b"]; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_20__src_projection_conicEquidistant__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__ = __webpack_require__(543);
 __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__["a"]; });
 __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__ = __webpack_require__(1604);
 __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__["a"]; });
 __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_23__src_projection_identity__ = __webpack_require__(1605);
 __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_23__src_projection_identity__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_24__src_projection_index__ = __webpack_require__(61);
 __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_24__src_projection_index__["a"]; });
 __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_24__src_projection_index__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__ = __webpack_require__(301);
 __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__["a"]; });
 __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__["c"]; });
 var __WEBPACK_IMPORTED_MODULE_26__src_projection_naturalEarth1__ = __webpack_require__(1606);
 __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_26__src_projection_naturalEarth1__["a"]; });
 __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_26__src_projection_naturalEarth1__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__ = __webpack_require__(1607);
 __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__["a"]; });
 __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_28__src_projection_stereographic__ = __webpack_require__(1608);
 __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_28__src_projection_stereographic__["a"]; });
 __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_28__src_projection_stereographic__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_29__src_projection_transverseMercator__ = __webpack_require__(1609);
 __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_29__src_projection_transverseMercator__["a"]; });
 __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_29__src_projection_transverseMercator__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_30__src_rotation__ = __webpack_require__(191);
 __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_30__src_rotation__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_31__src_stream__ = __webpack_require__(102);
 __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_31__src_stream__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_32__src_transform__ = __webpack_require__(193);
 __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_32__src_transform__["a"]; });






 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).




























 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(120);
 var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(529);
 var __WEBPACK_IMPORTED_MODULE_2__cartesian__ = __webpack_require__(140);
 var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_4__stream__ = __webpack_require__(102);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" ])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area__["b" ].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area__["b" ].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area__["a" ] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math__["i" ]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math__["i" ]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["a" ])([lambda * __WEBPACK_IMPORTED_MODULE_3__math__["r" ], phi * __WEBPACK_IMPORTED_MODULE_3__math__["r" ]]);
  if (p0) {
    var normal = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" ])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" ])(equatorial, normal);
    Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["e" ])(inflection);
    inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["g" ])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math__["h" ] * sign,
        phii,
        antimeridian = Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" ])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" ];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" ];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" ])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area__["b" ].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area__["b" ].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area__["b" ].lineEnd();
  if (Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" ])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math__["i" ]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

 __webpack_exports__["a"] = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  Object(__WEBPACK_IMPORTED_MODULE_4__stream__["a" ])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(80);
 var __WEBPACK_IMPORTED_MODULE_2__stream__ = __webpack_require__(102);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop__["a" ],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" ], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" ];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(phi);
  centroidPointCartesian(cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" ], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" ];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" ], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" ];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(phi),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" ], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" ];
  centroidStream.point = centroidRingPoint;
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" ], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" ];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(cx * cx + cy * cy + cz * cz),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" ])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

 __webpack_exports__["a"] = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  Object(__WEBPACK_IMPORTED_MODULE_2__stream__["a" ])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" ]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math__["i" ]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" ]) return [NaN, NaN];
  }

  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" ])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" ], Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" ])(z / Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(m)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" ]];
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__rectangle__ = __webpack_require__(192);


 __webpack_exports__["a"] = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = Object(__WEBPACK_IMPORTED_MODULE_0__rectangle__["a" ])(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__polygonContains__ = __webpack_require__(537);
 var __WEBPACK_IMPORTED_MODULE_1__distance__ = __webpack_require__(539);
 var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(18);




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" ])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" ])(coordinates[0], coordinates[1]),
      ao = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" ])(coordinates[0], point),
      ob = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" ])(point, coordinates[1]);
  return ao + ob <= ab + __WEBPACK_IMPORTED_MODULE_2__math__["i" ];
}

function containsPolygon(coordinates, point) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_0__polygonContains__["a" ])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" ], point[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" ]];
}

 __webpack_exports__["a"] = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = graticule;
 __webpack_exports__["b"] = graticule10;
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(18);



function graticuleX(y0, y1, dy) {
  var y = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" ])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" ], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" ])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" ], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" ])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" ])(X0 / DX) * DX, X1, DX).map(X)
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" ])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" ])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" ])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" ])(x0 / dx) * dx, x1, dx).filter(function(x) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math__["i" ]; }).map(x))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" ])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" ])(y0 / dy) * dy, y1, dy).filter(function(y) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math__["i" ]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math__["i" ]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math__["i" ]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math__["i" ]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math__["i" ]]]);
}

function graticule10() {
  return graticule()();
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);


 __webpack_exports__["a"] = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" ],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" ],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" ],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" ],
      cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(y0),
      sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y0),
      cy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(y1),
      sy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y1),
      kx0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(x0),
      ky0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(x0),
      kx1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(x1),
      ky1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(x1),
      d = 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" ])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" ])(y1 - y0) + cy0 * cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" ])(x1 - x0))),
      k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(d);

  var interpolate = d ? function(t) {
    var B = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(t *= d) / k,
        A = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" ])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" ],
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" ])(z, Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" ]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" ], y0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" ]];
  };

  interpolate.distance = d;

  return interpolate;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(297);
 var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__(102);
 var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__(1592);
 var __WEBPACK_IMPORTED_MODULE_3__bounds__ = __webpack_require__(541);
 var __WEBPACK_IMPORTED_MODULE_4__centroid__ = __webpack_require__(1593);
 var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(1594);
 var __WEBPACK_IMPORTED_MODULE_6__measure__ = __webpack_require__(1595);
 var __WEBPACK_IMPORTED_MODULE_7__string__ = __webpack_require__(1596);









 __webpack_exports__["a"] = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" ])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" ])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area__["a" ]));
    return __WEBPACK_IMPORTED_MODULE_2__area__["a" ].result();
  };

  path.measure = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" ])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure__["a" ]));
    return __WEBPACK_IMPORTED_MODULE_6__measure__["a" ].result();
  };

  path.bounds = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" ])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds__["a" ]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds__["a" ].result();
  };

  path.centroid = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" ])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid__["a" ]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid__["a" ].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity__["a" ]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string__["a" ]) : new __WEBPACK_IMPORTED_MODULE_5__context__["a" ](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(120);
 var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(80);




var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" ])(),
    areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" ])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" ];
    areaSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

 __webpack_exports__["a"] = (areaStream);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

 __webpack_exports__["a"] = (centroidStream);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = PathContext;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(80);



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math__["w" ]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop__["a" ]
};


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(120);
 var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(80);




var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" ])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" ],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" ];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" ])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

 __webpack_exports__["a"] = (lengthStream);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(140);
 var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(193);




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" ])(30 * __WEBPACK_IMPORTED_MODULE_1__math__["r" ]); // cos(minimum angular distance)

 __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__transform__["b" ])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" ])(a * a + b * b + c * c),
          phi2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" ])(c /= m),
          lambda2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" ] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" ] ? (lambda0 + lambda1) / 2 : Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" ])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" ])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = cylindricalEqualAreaRaw;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" ])(y * cosPhi0)];
  };

  return forward;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__albers__ = __webpack_require__(542);
 var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea__ = __webpack_require__(298);
 var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(300);





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
 __webpack_exports__["a"] = (function() {
  var cache,
      cacheStream,
      lower48 = Object(__WEBPACK_IMPORTED_MODULE_1__albers__["a" ])(), lower48Point,
      alaska = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["b" ])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["b" ])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" ], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" ]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" ], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" ]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" ], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" ]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" ], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" ]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" ])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["c" ])(albersUsa, size, object);
  };

  albersUsa.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["d" ])(albersUsa, width, object);
  };

  albersUsa.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" ])(albersUsa, height, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return azimuthalEqualAreaRaw; });
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(141);
 var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(61);




var azimuthalEqualAreaRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" ])(function(cxcy) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" ])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" ])(z / 2);
});

 __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" ])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return azimuthalEquidistantRaw; });
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(141);
 var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(61);




var azimuthalEquidistantRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" ])(function(c) {
  return (c = Object(__WEBPACK_IMPORTED_MODULE_0__math__["b" ])(c)) && c / Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(c);
});

azimuthalEquidistantRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" ])(function(z) {
  return z;
});

 __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" ])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = conicConformalRaw;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(299);
 var __WEBPACK_IMPORTED_MODULE_2__mercator__ = __webpack_require__(301);




function tany(y) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" ])((__WEBPACK_IMPORTED_MODULE_0__math__["l" ] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y0) : Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" ])(cy0 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(y1)) / Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" ])(tany(y1) / tany(y0)),
      f = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" ])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator__["c" ];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math__["l" ] + __WEBPACK_IMPORTED_MODULE_0__math__["i" ]) y = -__WEBPACK_IMPORTED_MODULE_0__math__["l" ] + __WEBPACK_IMPORTED_MODULE_0__math__["i" ]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math__["l" ] - __WEBPACK_IMPORTED_MODULE_0__math__["i" ]) y = __WEBPACK_IMPORTED_MODULE_0__math__["l" ] - __WEBPACK_IMPORTED_MODULE_0__math__["i" ]; }
    var r = f / Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" ])(tany(y), n);
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(n * x), f - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" ])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(x * x + fy * fy);
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" ])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" ])(fy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" ])(fy), 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" ])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" ])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" ]];
  };

  return project;
}

 __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" ])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = conicEquidistantRaw;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(299);
 var __WEBPACK_IMPORTED_MODULE_2__equirectangular__ = __webpack_require__(543);




function conicEquidistantRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y0) : (cy0 - Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" ])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" ]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular__["b" ];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(nx), g - gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" ])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" ])(gy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" ])(gy), g - Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" ])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" ])(x * x + gy * gy)];
  };

  return project;
}

 __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" ])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = gnomonicRaw;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(141);
 var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(61);




function gnomonicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(y), k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y) / k];
}

gnomonicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" ])(__WEBPACK_IMPORTED_MODULE_0__math__["d" ]);

 __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" ])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__clip_rectangle__ = __webpack_require__(192);
 var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(297);
 var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(193);
 var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(300);





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? __WEBPACK_IMPORTED_MODULE_1__identity__["a" ] : Object(__WEBPACK_IMPORTED_MODULE_2__transform__["b" ])({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

 __webpack_exports__["a"] = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = __WEBPACK_IMPORTED_MODULE_1__identity__["a" ], // scale, translate and reflect
      x0 = null, y0, x1, y1, // clip extent
      postclip = __WEBPACK_IMPORTED_MODULE_1__identity__["a" ],
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    },
    postclip: function(_) {
      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    },
    clipExtent: function(_) {
      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity__["a" ]) : Object(__WEBPACK_IMPORTED_MODULE_0__clip_rectangle__["a" ])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" ])(projection, extent, object);
    },
    fitSize: function(size, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["c" ])(projection, size, object);
    },
    fitWidth: function(width, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["d" ])(projection, width, object);
    },
    fitHeight: function(height, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" ])(projection, height, object);
    }
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = naturalEarth1Raw;
 var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(61);
 var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(18);



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" ])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["i" ] && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

 __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" ])(naturalEarth1Raw)
      .scale(175.295);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = orthographicRaw;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(141);
 var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(61);




function orthographicRaw(x, y) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(y) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(x), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y)];
}

orthographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" ])(__WEBPACK_IMPORTED_MODULE_0__math__["c" ]);

 __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" ])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math__["i" ]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = stereographicRaw;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(141);
 var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(61);




function stereographicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(y), k = 1 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" ])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" ])(y) / k];
}

stereographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" ])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" ])(z);
});

 __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" ])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = transverseMercatorRaw;
 var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
 var __WEBPACK_IMPORTED_MODULE_1__mercator__ = __webpack_require__(301);



function transverseMercatorRaw(lambda, phi) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" ])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" ])((__WEBPACK_IMPORTED_MODULE_0__math__["l" ] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" ])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" ])(x)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" ]];
};

 __webpack_exports__["a"] = (function() {
  var m = Object(__WEBPACK_IMPORTED_MODULE_1__mercator__["b" ])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_cluster__ = __webpack_require__(1611);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_cluster__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__ = __webpack_require__(302);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__["c"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_pack_index__ = __webpack_require__(1623);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_pack_index__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__ = __webpack_require__(544);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__ = __webpack_require__(545);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_partition__ = __webpack_require__(1625);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_partition__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_stratify__ = __webpack_require__(1626);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__src_stratify__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__src_tree__ = __webpack_require__(1627);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__src_tree__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__ = __webpack_require__(1628);
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__ = __webpack_require__(1629);
 __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__ = __webpack_require__(142);
 __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__ = __webpack_require__(194);
 __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__ = __webpack_require__(1630);
 __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__ = __webpack_require__(304);
 __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__ = __webpack_require__(1631);
 __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__["a"]; });

















 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

 __webpack_exports__["a"] = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

 __webpack_exports__["a"] = (function() {
  return this.eachAfter(count);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__siblings__ = __webpack_require__(544);
 var __WEBPACK_IMPORTED_MODULE_1__accessors__ = __webpack_require__(303);
 var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(546);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

 __webpack_exports__["a"] = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant__["a" ];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant__["a" ], 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = Object(__WEBPACK_IMPORTED_MODULE_1__accessors__["a" ])(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["b" ])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = Object(__WEBPACK_IMPORTED_MODULE_0__siblings__["b" ])(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
 __webpack_exports__["a"] = shuffle;
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__treemap_round__ = __webpack_require__(547);
 var __WEBPACK_IMPORTED_MODULE_1__treemap_dice__ = __webpack_require__(142);



 __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round__["a" ]);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        Object(__WEBPACK_IMPORTED_MODULE_1__treemap_dice__["a" ])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__accessors__ = __webpack_require__(303);
 var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__(302);



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

 __webpack_exports__["a"] = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["a" ](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["b" ]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" ])(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" ])(x), stratify) : parentId;
  };

  return stratify;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index__ = __webpack_require__(302);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index__["a" ].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
 __webpack_exports__["a"] = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__round__ = __webpack_require__(547);
 var __WEBPACK_IMPORTED_MODULE_1__squarify__ = __webpack_require__(304);
 var __WEBPACK_IMPORTED_MODULE_2__accessors__ = __webpack_require__(303);
 var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(546);





 __webpack_exports__["a"] = (function() {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify__["a" ],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant__["a" ],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant__["a" ],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant__["a" ],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant__["a" ],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant__["a" ];

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round__["a" ]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = Object(__WEBPACK_IMPORTED_MODULE_2__accessors__["b" ])(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" ])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" ])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" ])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" ])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" ])(+x), treemap) : paddingLeft;
  };

  return treemap;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(142);
 var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(194);



 __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice__["a" ] : __WEBPACK_IMPORTED_MODULE_0__dice__["a" ])(parent, x0, y0, x1, y1);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(142);
 var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(194);
 var __WEBPACK_IMPORTED_MODULE_2__squarify__ = __webpack_require__(304);




 __webpack_exports__["a"] = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" ])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" ])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = Object(__WEBPACK_IMPORTED_MODULE_2__squarify__["c" ])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify__["b" ]));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(1633);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_area__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_centroid__ = __webpack_require__(1634);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_centroid__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_hull__ = __webpack_require__(1635);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__src_hull__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_contains__ = __webpack_require__(1637);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__src_contains__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_length__ = __webpack_require__(1638);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_length__["a"]; });







 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__cross__ = __webpack_require__(1636);


function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && Object(__WEBPACK_IMPORTED_MODULE_0__cross__["a" ])(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

 __webpack_exports__["a"] = (function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
 __webpack_exports__["a"] = (function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_queue__ = __webpack_require__(1640);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_queue__["a"]; });



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = queue;
 var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(1641);


var noabort = {};

function Queue(size) {
  this._size = size;
  this._call =
  this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting =
  this._active =
  this._ended =
  this._start = 0; // inside a synchronous task callback?
}

Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = __WEBPACK_IMPORTED_MODULE_0__array__["a" ].call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke(this);
    return this;
  },
  abort: function() {
    if (this._error == null) abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};

function poke(q) {
  if (!q._start) {
    try { start(q); } // let the current task complete
    catch (e) {
      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
      else if (!q._data) throw e; // await callback errored synchronously
    }
  }
}

function start(q) {
  while (q._start = q._waiting && q._active < q._size) {
    var i = q._ended + q._active,
        t = q._tasks[i],
        j = t.length - 1,
        c = t[j];
    t[j] = end(q, i);
    --q._waiting, ++q._active;
    t = c.apply(null, t);
    if (!q._tasks[i]) continue; // task finished synchronously
    q._tasks[i] = t || noabort;
  }
}

function end(q, i) {
  return function(e, r) {
    if (!q._tasks[i]) return; // ignore multiple callbacks
    --q._active, ++q._ended;
    q._tasks[i] = null;
    if (q._error != null) return; // ignore secondary errors
    if (e != null) {
      abort(q, e);
    } else {
      q._data[i] = r;
      if (q._waiting) poke(q);
      else maybeNotify(q);
    }
  };
}

function abort(q, e) {
  var i = q._tasks.length, t;
  q._error = e; // ignore active callbacks
  q._data = undefined; // allow gc
  q._waiting = NaN; // prevent starting

  while (--i >= 0) {
    if (t = q._tasks[i]) {
      q._tasks[i] = null;
      if (t.abort) {
        try { t.abort(); }
        catch (e) {  }
      }
    }
  }

  q._active = NaN; // allow notification
  maybeNotify(q);
}

function maybeNotify(q) {
  if (!q._active && q._call) {
    var d = q._data;
    q._data = undefined; // allow gc
    q._call(q._error, d);
  }
}

function queue(concurrency) {
  if (concurrency == null) concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
  return new Queue(concurrency);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = [].slice;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_uniform__ = __webpack_require__(1643);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_uniform__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_normal__ = __webpack_require__(548);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_normal__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_logNormal__ = __webpack_require__(1644);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__src_logNormal__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_bates__ = __webpack_require__(1645);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__src_bates__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_irwinHall__ = __webpack_require__(549);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__src_irwinHall__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_exponential__ = __webpack_require__(1646);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__src_exponential__["a"]; });








 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(121);


 __webpack_exports__["a"] = ((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" ]));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(121);
 var __WEBPACK_IMPORTED_MODULE_1__normal__ = __webpack_require__(548);



 __webpack_exports__["a"] = ((function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = __WEBPACK_IMPORTED_MODULE_1__normal__["a" ].source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" ]));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(121);
 var __WEBPACK_IMPORTED_MODULE_1__irwinHall__ = __webpack_require__(549);



 __webpack_exports__["a"] = ((function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = __WEBPACK_IMPORTED_MODULE_1__irwinHall__["a" ].source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" ]));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(121);


 __webpack_exports__["a"] = ((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" ]));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_request__ = __webpack_require__(305);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_request__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_html__ = __webpack_require__(1648);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_html__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_json__ = __webpack_require__(1649);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_json__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_text__ = __webpack_require__(1650);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_text__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_xml__ = __webpack_require__(1651);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__src_xml__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_csv__ = __webpack_require__(1652);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_csv__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_tsv__ = __webpack_require__(1653);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__src_tsv__["a"]; });









 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(195);


 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" ])("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
}));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(195);


 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" ])("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
}));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(195);


 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" ])("text/plain", function(xhr) {
  return xhr.responseText;
}));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(195);


 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" ])("application/xml", function(xhr) {
  var xml = xhr.responseXML;
  if (!xml) throw new Error("parse error");
  return xml;
}));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(290);
 var __WEBPACK_IMPORTED_MODULE_1__dsv__ = __webpack_require__(550);



 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__dsv__["a" ])("text/csv", __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["c" ]));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(290);
 var __WEBPACK_IMPORTED_MODULE_1__dsv__ = __webpack_require__(550);



 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__dsv__["a" ])("text/tab-separated-values", __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["h" ]));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(1655);
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
 __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(1656);
 __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__src_identity__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(143);
 __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(1658);
 __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(551);
 __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(1659);
 __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(1660);
 __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__src_quantile__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(1661);
 __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__src_quantize__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(1662);
 __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(554);
 __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(1678);
 __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(1679);
 __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_11__src_category10__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(1680);
 __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_12__src_category20b__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(1681);
 __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_13__src_category20c__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(1682);
 __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_14__src_category20__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(1683);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(1684);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["b"]; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["c"]; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(1685);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["a"]; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["c"]; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["b"]; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["d"]; });
 var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(1686);
 __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__src_sequential__["a"]; });







































 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = band;
 __webpack_exports__["b"] = point;
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(551);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" ])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["s" ])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = identity;
 var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(103);
 var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(143);
 var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(552);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" ].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" ]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" ])(scale);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(295);



 __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["A" ])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" ])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["g" ])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" ])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["h" ])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" ])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" ])(specifier);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = log;
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(295);
 var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(306);
 var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(553);
 var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(196);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" ])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" ])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["B" ])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" ])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" ])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" ])(scale, log().base(base));
  };

  return scale;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = pow;
 __webpack_exports__["b"] = sqrt;
 var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(306);
 var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(143);
 var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(196);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" ])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" ])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" ])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = quantile;
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(103);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["r" ])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" ])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" ]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" ].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = quantize;
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(103);
 var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(143);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" ])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" ].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" ])(scale);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = threshold;
 var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(43);
 var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(103);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" ])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" ].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" ].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return milliseconds; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

 __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return seconds; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);
 var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(70);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" ]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" ]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" ]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" ];
}, function(date) {
  return date.getUTCSeconds();
});

 __webpack_exports__["a"] = (second);
var seconds = second.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return minutes; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);
 var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(70);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" ]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" ]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" ]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" ];
}, function(date) {
  return date.getMinutes();
});

 __webpack_exports__["a"] = (minute);
var minutes = minute.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return hours; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);
 var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(70);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" ] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" ];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" ];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" ]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" ] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" ]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" ];
}, function(date) {
  return date.getHours();
});

 __webpack_exports__["a"] = (hour);
var hours = hour.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return days; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);
 var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(70);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" ]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" ];
}, function(date) {
  return date.getDate() - 1;
});

 __webpack_exports__["b"] = (day);
var days = day.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "g", function() { return sunday; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return monday; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return tuesday; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return wednesday; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return thursday; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return friday; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return saturday; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return sundays; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return mondays; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return tuesdays; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return wednesdays; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return thursdays; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return fridays; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return saturdays; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);
 var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(70);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" ]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" ];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return months; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

 __webpack_exports__["a"] = (month);
var months = month.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return years; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

 __webpack_exports__["a"] = (year);
var years = year.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return utcMinutes; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);
 var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(70);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" ]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" ];
}, function(date) {
  return date.getUTCMinutes();
});

 __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return utcHours; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);
 var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(70);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" ]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" ];
}, function(date) {
  return date.getUTCHours();
});

 __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return utcDays; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);
 var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(70);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" ];
}, function(date) {
  return date.getUTCDate() - 1;
});

 __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "g", function() { return utcSunday; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return utcMonday; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return utcTuesday; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return utcWednesday; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return utcThursday; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return utcFriday; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return utcSaturday; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return utcSundays; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return utcMondays; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return utcTuesdays; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return utcWednesdays; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return utcThursdays; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return utcFridays; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return utcSaturdays; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);
 var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(70);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" ];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonths; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

 __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return utcYears; });
 var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(40);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" ])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

 __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(556);
 var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(308);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["e" ])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["b" ]);

 __webpack_exports__["a"] = (parseIso);


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(554);
 var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(307);
 var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(197);




 __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" ])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["_7" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["R" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["_5" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["F" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["J" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["N" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["V" ], __WEBPACK_IMPORTED_MODULE_2_d3_time__["L" ], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["g" ]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(144);


 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" ])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(144);


 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" ])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(144);


 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" ])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(144);


 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" ])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(60);
 var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);



 __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" ])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" ])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" ])(-240, 0.5, 1.0)));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return warm; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return cool; });
 var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(60);
 var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" ])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" ])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" ])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" ])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" ])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" ])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" ])();

 __webpack_exports__["b"] = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return magma; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return inferno; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return plasma; });
 var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(144);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

 __webpack_exports__["a"] = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" ])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" ])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" ])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" ])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = sequential;
 var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(143);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" ])(scale);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(1688);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_arc__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(557);
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(309);
 __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(1689);
 __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pie__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__ = __webpack_require__(1692);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
 __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__ = __webpack_require__(559);
 __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["a"]; });
 __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__ = __webpack_require__(560);
 __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_7__src_link_index__ = __webpack_require__(1693);
 __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["a"]; });
 __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["c"]; });
 __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_8__src_symbol__ = __webpack_require__(1694);
 __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["a"]; });
 __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__ = __webpack_require__(562);
 __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__ = __webpack_require__(563);
 __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__ = __webpack_require__(564);
 __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__ = __webpack_require__(566);
 __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__ = __webpack_require__(565);
 __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__ = __webpack_require__(567);
 __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__ = __webpack_require__(568);
 __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__ = __webpack_require__(1695);
 __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__ = __webpack_require__(1696);
 __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__ = __webpack_require__(200);
 __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__ = __webpack_require__(1697);
 __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__ = __webpack_require__(569);
 __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__ = __webpack_require__(570);
 __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__ = __webpack_require__(201);
 __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__ = __webpack_require__(1698);
 __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__ = __webpack_require__(1699);
 __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__ = __webpack_require__(311);
 __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__ = __webpack_require__(1700);
 __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__ = __webpack_require__(198);
 __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__ = __webpack_require__(1701);
 __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["a"]; });
 __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["b"]; });
 var __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__ = __webpack_require__(1702);
 __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_30__src_curve_step__ = __webpack_require__(1703);
 __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["a"]; });
 __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["b"]; });
 __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["c"]; });
 var __WEBPACK_IMPORTED_MODULE_31__src_stack__ = __webpack_require__(1704);
 __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_31__src_stack__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__ = __webpack_require__(1705);
 __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__ = __webpack_require__(1706);
 __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_34__src_offset_none__ = __webpack_require__(146);
 __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_34__src_offset_none__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__ = __webpack_require__(1707);
 __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__ = __webpack_require__(1708);
 __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__ = __webpack_require__(312);
 __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_38__src_order_descending__ = __webpack_require__(1709);
 __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_38__src_order_descending__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__ = __webpack_require__(1710);
 __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_40__src_order_none__ = __webpack_require__(147);
 __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_40__src_order_none__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__ = __webpack_require__(1711);
 __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__["a"]; });




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(101);
 var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(104);
 var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(145);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" ])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" ])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" ])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

 __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" ],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" ],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" ])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" ])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" ])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" ] - __WEBPACK_IMPORTED_MODULE_2__math__["f" ]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" ])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" ])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" ]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" ])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" ])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" ]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" ])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" ])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" ])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" ]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" ])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" ])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" ])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" ])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" ]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" ]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" ])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" ])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" ])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" ])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" ]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" ])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" ])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" ])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" ])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" ]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" ] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" ])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" ])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" ])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" ])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" ])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" ])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" ])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" ])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" ]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" ]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" ])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" ]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" ])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" ] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" ])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" ])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(104);
 var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(1690);
 var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(1691);
 var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(145);





 __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" ],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" ],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(__WEBPACK_IMPORTED_MODULE_3__math__["m" ]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" ], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" ], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), pie) : padAngle;
  };

  return pie;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(d) {
  return d;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(558);
 var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(557);
 var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(559);




 __webpack_exports__["a"] = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" ])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" ]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" ])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" ])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" ])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" ])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" ])(_)) : c()._curve;
  };

  return a;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = linkHorizontal;
 __webpack_exports__["c"] = linkVertical;
 __webpack_exports__["b"] = linkRadial;
 var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(101);
 var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(561);
 var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(104);
 var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(310);
 var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(560);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" ],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" ],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" ].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" ])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" ])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" ])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" ])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" ])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" ])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" ])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
 var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(101);
 var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(562);
 var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(563);
 var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(564);
 var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(565);
 var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(566);
 var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(567);
 var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(568);
 var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(104);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" ],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" ],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" ],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" ],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" ],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" ],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" ]
];

 __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" ])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" ]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" ])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" ])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" ])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" ])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(199);
 var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(200);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" ])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

 __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(200);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" ])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

 __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(200);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" ](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

 __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" ](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(569);
 var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(199);
 var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(311);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" ],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" ],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["b" ])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

 __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" ](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(570);
 var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(311);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["b" ])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

 __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" ](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(199);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" ],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

 __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = monotoneX;
 __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

 __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["c"] = stepBefore;
 __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

 __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(561);
 var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(104);
 var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(146);
 var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(147);





function stackValue(d, key) {
  return d[key];
}

 __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" ],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" ],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(__WEBPACK_IMPORTED_MODULE_0__array__["a" ].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" ] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" ])(__WEBPACK_IMPORTED_MODULE_0__array__["a" ].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" ] : _, stack) : offset;
  };

  return stack;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(146);


 __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" ])(series, order);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(146);


 __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" ])(series, order);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(146);


 __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" ])(series, order);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(312);


 __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" ])(series).reverse();
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(147);
 var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(312);



 __webpack_exports__["a"] = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" ]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" ])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(147);


 __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" ])(series).reverse();
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_voronoi__ = __webpack_require__(1713);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_voronoi__["a"]; });



 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(1714);
 var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(1715);
 var __WEBPACK_IMPORTED_MODULE_2__Diagram__ = __webpack_require__(148);




 __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_1__point__["a" ],
      y = __WEBPACK_IMPORTED_MODULE_1__point__["b" ],
      extent = null;

  function voronoi(data) {
    return new __WEBPACK_IMPORTED_MODULE_2__Diagram__["d" ](data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" ]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" ], Math.round(y(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" ]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" ]];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" ])(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = x;
 __webpack_exports__["b"] = y;
function x(d) {
  return d[0];
}

function y(d) {
  return d[1];
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = removeBeach;
 __webpack_exports__["a"] = addBeach;
 var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(313);
 var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(571);
 var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(572);
 var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(314);
 var __WEBPACK_IMPORTED_MODULE_4__Diagram__ = __webpack_require__(148);






var beachPool = [];

function Beach() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" ])(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" ])(beach);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" ].remove(beach);
  beachPool.push(beach);
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" ])(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" ]
      && Math.abs(y - lArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" ]) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" ])(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" ]
      && Math.abs(y - rArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" ]) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" ])(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" ])(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" ])(lArc.site, rArc.site, null, vertex);

  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" ])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" ])(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" ]._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" ]) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" ]) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" ]) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" ]) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["c" ])(site);
  var newArc = createBeach(site);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" ].insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" ])(lArc);
    rArc = createBeach(lArc.site);
    __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" ].insert(newArc, rArc);
    newArc.edge = rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" ])(lArc.site, newArc.site);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" ])(lArc);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" ])(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" ])(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" ])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" ])(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" ])(rArc.edge, lSite, rSite, vertex);
  newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" ])(lSite, site, null, vertex);
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" ])(site, rSite, null, vertex);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" ])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" ])(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__src_zoom__ = __webpack_require__(1718);
 __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_zoom__["a"]; });
 var __WEBPACK_IMPORTED_MODULE_1__src_transform__ = __webpack_require__(573);
 __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_transform__["b"]; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_transform__["c"]; });




 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(100);
 var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(276);
 var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(57);
 var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(35);
 var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(287);
 var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(1719);
 var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(1720);
 var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(573);
 var __WEBPACK_IMPORTED_MODULE_8__noevent__ = __webpack_require__(1721);










// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].button;
}

function defaultExtent() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || __WEBPACK_IMPORTED_MODULE_7__transform__["c" ];
}

function defaultWheelDelta() {
  return -__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].deltaY * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].deltaMode ? 120 : 1) / 500;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

function defaultConstrain(transform, extent, translateExtent) {
  var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
      dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
      dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
      dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
  return transform.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}

 __webpack_exports__["a"] = (function() {
  var filter = defaultFilter,
      extent = defaultExtent,
      constrain = defaultConstrain,
      wheelDelta = defaultWheelDelta,
      touchable = defaultTouchable,
      scaleExtent = [0, Infinity],
      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
      duration = 250,
      interpolate = __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["v" ],
      gestures = [],
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" ])("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection) {
    selection
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform) {
    var selection = collection.selection ? collection.selection() : collection;
    selection.property("__zoom", defaultTransform);
    if (collection !== selection) {
      schedule(collection, transform);
    } else {
      selection.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection, k) {
    zoom.scaleTo(selection, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection, k) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
    });
  };

  zoom.translateBy = function(selection, x, y) {
    zoom.transform(selection, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments), translateExtent);
    });
  };

  zoom.translateTo = function(selection, x, y) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p = centroid(e);
      return constrain(__WEBPACK_IMPORTED_MODULE_7__transform__["c" ].translate(p[0], p[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e, translateExtent);
    });
  };

  function scale(transform, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform.k ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" ](k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" ](transform.k, x, y);
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition, transform, center) {
    transition
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new __WEBPACK_IMPORTED_MODULE_7__transform__["a" ](k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" ])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" ](zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" ])(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" ])(this);
      g.start();
    }

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" ])();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" ])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" ])(this),
        x0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].clientX,
        y0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].clientY;

    Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" ])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].view);
    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" ])();
    g.mouse = [p, this.__zoom.invert(p)];
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" ])(this);
    g.start();

    function mousemoved() {
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" ])();
      if (!g.moved) {
        var dx = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].clientX - x0, dy = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" ])(g.that), g.mouse[1]), g.extent, translateExtent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["c" ])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].view, g.moved);
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" ])();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["h" ])(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" ])();
    if (duration > 0) Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" ])(this).transition().duration(duration).call(schedule, t1, p0);
    else Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" ])(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].changedTouches,
        started,
        n = touches.length, i, t, p;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" ])();
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["q" ])(this, touches, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" ])(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" ])(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].changedTouches,
        n = touches.length, i, t, p, l;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" ])();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["q" ])(this, touches, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["e" ].changedTouches,
        n = touches.length, i, t;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" ])();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" ])(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" ])(!!_), zoom) : filter;
  };

  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" ])(!!_), zoom) : touchable;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" ])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };

  zoom.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom) : constrain;
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  return zoom;
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ZoomEvent;
function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["b"] = nopropagation;
 var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(35);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" ].stopImmediatePropagation();
}

 __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" ].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" ].stopImmediatePropagation();
});


 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components_Tagcloud__ = __webpack_require__(1724);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_Tagcloud__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3__Tag__ = __webpack_require__(1725);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(574);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tagcloud=function(_Component){_inherits(Tagcloud,_Component);function Tagcloud(props){_classCallCheck(this,Tagcloud);var _this=_possibleConstructorReturn(this,(Tagcloud.__proto__||Object.getPrototypeOf(Tagcloud)).call(this,props));_this.printData=function(){var _this$props=_this.props,options=_this$props.options,color=_this$props.color;var minVal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.min(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(options,function(option){return option.value||1;}));var maxVal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.max(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(options,function(option){return option.value||1;}));var minSize=15;var maxSize=40;var diff=maxVal-minVal;return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(options,function(tag){var value=tag.value;if(!value){value=1;}var fontSize=diff===0?20:minSize+(value-minVal)/diff*(maxSize-minSize);var marginTop=Math.round(fontSize*0.5);var marginBottom=Math.round(fontSize*0.3);var marginRight=Math.max(10,Math.round(fontSize*0.3));var marginLeft=Math.round(fontSize*0.3);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Tag__["a" ],{fontSize:fontSize,text:tag.label,id:tag.id,onSelect:_this.onSelect,onUnselect:_this.onUnselect,colorSelected:color,key:tag.id,marginTop:marginTop,marginBottom:marginBottom,marginRight:marginRight,marginLeft:marginLeft});});};_this.onSelect=function(id){var values=_this.state.values;var onSelect=_this.props.onSelect;values.push(id);_this.setState({values:values});if(onSelect){onSelect(id);}};_this.onUnselect=function(id){var values=_this.state.values;var onUnselect=_this.props.onUnselect;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(values,function(value){return id===value;});_this.setState({values:values});if(onUnselect){onUnselect(id);}};_this.state={values:[]};return _this;}_createClass(Tagcloud,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],null,this.printData());}}]);return Tagcloud;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Tagcloud.propTypes={options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnselect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Tagcloud.defaultProps={onSelect:null,onUnselect:null}; __webpack_exports__["a"] = (Tagcloud);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(574);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tag=function(_Component){_inherits(Tag,_Component);function Tag(props){_classCallCheck(this,Tag);var _this=_possibleConstructorReturn(this,(Tag.__proto__||Object.getPrototypeOf(Tag)).call(this,props));_this.handleClick=function(){var _this$props=_this.props,id=_this$props.id,onSelect=_this$props.onSelect,onUnselect=_this$props.onUnselect;var selected=_this.state.selected;if(selected){onUnselect(id);}else{onSelect(id);}_this.setState({selected:!selected});};_this.state={selected:false};return _this;}_createClass(Tag,[{key:'render',value:function render(){var selected=this.state.selected;var _props=this.props,fontSize=_props.fontSize,text=_props.text,colorSelected=_props.colorSelected,marginTop=_props.marginTop,marginBottom=_props.marginBottom,marginLeft=_props.marginLeft,marginRight=_props.marginRight,id=_props.id;var rotate=0;if(Number.isNaN(id)){rotate=id.length%2===0?-15:15;}else{rotate=id%2===0?-15:15;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" ],{selected:selected,fontSize:fontSize,onClick:this.handleClick,colorSelected:colorSelected,marginTop:marginTop,marginLeft:marginLeft,marginRight:marginRight,marginBottom:marginBottom,rotate:rotate},text);}}]);return Tag;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Tag.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,fontSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUnselect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,colorSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,marginLeft:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,marginRight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,marginTop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,marginBottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}; __webpack_exports__["a"] = (Tag);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components_BarChart__ = __webpack_require__(1727);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_BarChart__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_components_Steps_Likes__ = __webpack_require__(184);
 var __WEBPACK_IMPORTED_MODULE_4_components_Steps_SwipeableCards__ = __webpack_require__(65);
 var __WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__ = __webpack_require__(1728);
 var __WEBPACK_IMPORTED_MODULE_5_react_chartjs_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__);
 var __WEBPACK_IMPORTED_MODULE_6_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1822);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BarChart=function(_Component){_inherits(BarChart,_Component);function BarChart(props){_classCallCheck(this,BarChart);var _this=_possibleConstructorReturn(this,(BarChart.__proto__||Object.getPrototypeOf(BarChart)).call(this,props));_this.getData=function(){var options=_this.props.options;var selected=_this.state.selected;var average=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mean(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(options,function(element){return element.value;}));var barData={labels:[],datasets:[{datalabels:{display:false},label:'',backgroundColor:[],borderColor:'white',borderWidth:1,hoverBackgroundColor:_this.hoverColor,hoverBorderColor:'white',data:[]}]};__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(options,function(item){barData.labels.push(item.label);barData.datasets[0].data.push(item.value);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(selected,function(element){return element===item.id;})){barData.datasets[0].backgroundColor.push(_this.hoverColor);}else if(item.value<average*1.25){var color=Object(__WEBPACK_IMPORTED_MODULE_6_utils_colors__["e" ])(item.color);barData.datasets[0].backgroundColor.push('rgba('+color.r+', '+color.g+', '+color.b+', 0.5)');}else{barData.datasets[0].backgroundColor.push(item.color);}return true;});return barData;};_this.handleClick=function(elements){if(elements.length){var _this$props=_this.props,options=_this$props.options,onSelect=_this$props.onSelect,onUnselect=_this$props.onUnselect;var selected=_this.state.selected;var index=elements[0]._index;var selection=options[index];if(!selected){_this.setState({selected:selection});if(onSelect){onSelect(selection.id);}}if(selected&&selected.id===selection.id){_this.setState({selected:null});if(onUnselect){onUnselect(selection.id);}}if(selected&&selected.id!==selection.id){if(onUnselect){onUnselect(selection.id);}if(onSelect){onSelect(selection.id);}_this.setState({selected:selection});}}};_this.handleCloseFeedbackUsers=function(){_this.setState({view:''});};_this.selectUser=function(like){_this.setState({view:'profile',userClicked:like});};_this.hoverColor='#fff';_this.state={selected:null,view:'',userClicked:null};return _this;}_createClass(BarChart,[{key:'render',value:function render(){var options=this.props.options;var _state=this.state,selected=_state.selected,view=_state.view,userClicked=_state.userClicked;if(view==='profile'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Steps_SwipeableCards__["a" ],{users:[userClicked],hideFirst:true,onClose:this.handleCloseFeedbackUsers,onEnd:this.handleCloseFeedbackUsers}));}var barData=this.getData();var barYMaxValue=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.max(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(options,function(element){return element.value;}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__["Bar"],{data:barData,width:100,height:50,legend:{display:false},onElementsClick:this.handleClick,options:{tooltips:{callbacks:{label:function label(){return'';},footer:function footer(tooltipItems){return tooltipItems[0].yLabel;}}},maintainAspectRatio:false,scales:{xAxes:[{gridLines:{display:false,color:'#ffffff'},ticks:{display:false,fontColor:'#fff'}}],yAxes:[{gridLines:{display:false,color:'#fff'},ticks:{beginAtZero:true,stepSize:barYMaxValue,fontColor:'#fff'}}]}}}),selected&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Steps_Likes__["a" ],{userList:selected.users,label:selected.label,onSelectUser:this.selectUser}));}}]);return BarChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BarChart.propTypes={options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnselect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};BarChart.defaultProps={onSelect:null,onUnselect:null}; __webpack_exports__["a"] = (BarChart);

 }),

 (function(module, exports, __webpack_require__) {

"use strict";
(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Chart", {
  enumerable: true,
  get: function get() {
    return _chart["default"];
  }
});
exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _chart = _interopRequireDefault(__webpack_require__(1729));

var _isEqual = _interopRequireDefault(__webpack_require__(1730));

var _keyBy = _interopRequireDefault(__webpack_require__(1792));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NODE_ENV = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://app.callforimpact.com/api/Rise","REACT_APP_NODE_URL":"https://node2.globalincubator.net"}) && "production";

var ChartComponent = function (_React$Component) {
  _inherits(ChartComponent, _React$Component);

  var _super = _createSuper(ChartComponent);

  function ChartComponent() {
    var _this;

    _classCallCheck(this, ChartComponent);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
      var instance = _this.chartInstance;
      var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;
      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
      _this.element = element;
    });

    _this.chartInstance = undefined;
    return _this;
  }

  _createClass(ChartComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderChart();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.redraw) {
        this.destroyChart();
        this.renderChart();
        return;
      }

      this.updateChart();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props2 = this.props,
          redraw = _this$props2.redraw,
          type = _this$props2.type,
          options = _this$props2.options,
          plugins = _this$props2.plugins,
          legend = _this$props2.legend,
          height = _this$props2.height,
          width = _this$props2.width;

      if (nextProps.redraw === true) {
        return true;
      }

      if (height !== nextProps.height || width !== nextProps.width) {
        return true;
      }

      if (type !== nextProps.type) {
        return true;
      }

      if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
        return true;
      }

      if (!(0, _isEqual["default"])(options, nextProps.options)) {
        return true;
      }

      var nextData = this.transformDataProp(nextProps);

      if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
        return true;
      }

      return !(0, _isEqual["default"])(plugins, nextProps.plugins);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyChart();
    }
  }, {
    key: "transformDataProp",
    value: function transformDataProp(props) {
      var data = props.data;

      if (typeof data == 'function') {
        var node = this.element;
        return data(node);
      } else {
        return data;
      }
    } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
    // this makes impossible to compare the current and next data changes
    // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
    // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617

  }, {
    key: "memoizeDataProps",
    value: function memoizeDataProps() {
      if (!this.props.data) {
        return;
      }

      var data = this.transformDataProp(this.props);
      this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
        datasets: data.datasets && data.datasets.map(function (set) {
          return _objectSpread({}, set);
        })
      });
      this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed

      return data;
    }
  }, {
    key: "checkDatasets",
    value: function checkDatasets(datasets) {
      var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
      var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
      var multipleDatasets = datasets.length > 1;

      if (isDev && multipleDatasets && !usingCustomKeyProvider) {
        var shouldWarn = false;
        datasets.forEach(function (dataset) {
          if (!dataset.label) {
            shouldWarn = true;
          }
        });

        if (shouldWarn) {
          console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
        }
      }
    }
  }, {
    key: "getCurrentDatasets",
    value: function getCurrentDatasets() {
      return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
    }
  }, {
    key: "saveCurrentDatasets",
    value: function saveCurrentDatasets() {
      var _this2 = this;

      this.datasets = this.datasets || {};
      var currentDatasets = this.getCurrentDatasets();
      currentDatasets.forEach(function (d) {
        _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
      });
    }
  }, {
    key: "updateChart",
    value: function updateChart() {
      var _this3 = this;

      var options = this.props.options;
      var data = this.memoizeDataProps(this.props);
      if (!this.chartInstance) return;

      if (options) {
        this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
      } // Pipe datasets to chart instance datasets enabling
      // seamless transitions


      var currentDatasets = this.getCurrentDatasets();
      var nextDatasets = data.datasets || [];
      this.checkDatasets(currentDatasets);
      var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
      // on each dataset.

      this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
        var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];

        if (current && current.type === next.type && next.data) {
          // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
          // The data array must be edited in place. As chart.js adds listeners to it.
          current.data.splice(next.data.length);
          next.data.forEach(function (point, pid) {
            current.data[pid] = next.data[pid];
          });

          var _data = next.data,
              otherProps = _objectWithoutProperties(next, ["data"]); // Merge properties. Notice a weakness here. If a property is removed
          // from next, it will be retained by current and never disappears.
          // Workaround is to set value to null or undefined in next.


          return _objectSpread(_objectSpread({}, current), otherProps);
        } else {
          return next;
        }
      });

      var datasets = data.datasets,
          rest = _objectWithoutProperties(data, ["datasets"]);

      this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
      this.chartInstance.update();
    }
  }, {
    key: "renderChart",
    value: function renderChart() {
      var _this$props3 = this.props,
          options = _this$props3.options,
          legend = _this$props3.legend,
          type = _this$props3.type,
          plugins = _this$props3.plugins;
      var node = this.element;
      var data = this.memoizeDataProps();

      if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
        options.legend = legend;
      }

      this.chartInstance = new _chart["default"](node, {
        type: type,
        data: data,
        options: options,
        plugins: plugins
      });
    }
  }, {
    key: "destroyChart",
    value: function destroyChart() {
      if (!this.chartInstance) {
        return;
      } // Put all of the datasets that have existed in the chart back on the chart
      // so that the metadata associated with this chart get destroyed.
      // This allows the datasets to be used in another chart. This can happen,
      // for example, in a tabbed UI where the chart gets created each time the
      // tab gets switched to the chart and uses the same data).


      this.saveCurrentDatasets();
      var datasets = Object.values(this.datasets);
      this.chartInstance.config.data.datasets = datasets;
      this.chartInstance.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          height = _this$props4.height,
          width = _this$props4.width,
          id = _this$props4.id;
      return _react["default"].createElement("canvas", {
        ref: this.ref,
        height: height,
        width: width,
        id: id,
        onClick: this.handleOnClick
      });
    }
  }]);

  return ChartComponent;
}(_react["default"].Component);

_defineProperty(ChartComponent, "getLabelAsKey", function (d) {
  return d.label;
});

_defineProperty(ChartComponent, "propTypes", {
  data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
  getDatasetAtEvent: _propTypes["default"].func,
  getElementAtEvent: _propTypes["default"].func,
  getElementsAtEvent: _propTypes["default"].func,
  height: _propTypes["default"].number,
  legend: _propTypes["default"].object,
  onElementsClick: _propTypes["default"].func,
  options: _propTypes["default"].object,
  plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
  redraw: _propTypes["default"].bool,
  type: function type(props, propName, componentName) {
    if (!_chart["default"].controllers[props[propName]]) {
      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    }
  },
  width: _propTypes["default"].number,
  datasetKeyProvider: _propTypes["default"].func
});

_defineProperty(ChartComponent, "defaultProps", {
  legend: {
    display: true,
    position: 'bottom'
  },
  type: 'doughnut',
  height: 150,
  width: 300,
  redraw: false,
  options: {},
  datasetKeyProvider: ChartComponent.getLabelAsKey
});

var _default = ChartComponent;
exports["default"] = _default;

var Doughnut = function (_React$Component2) {
  _inherits(Doughnut, _React$Component2);

  var _super2 = _createSuper(Doughnut);

  function Doughnut() {
    _classCallCheck(this, Doughnut);

    return _super2.apply(this, arguments);
  }

  _createClass(Doughnut, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      return _react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref) {
          return _this4.chartInstance = _ref && _ref.chartInstance;
        },
        type: "doughnut"
      }));
    }
  }]);

  return Doughnut;
}(_react["default"].Component);

exports.Doughnut = Doughnut;

var Pie = function (_React$Component3) {
  _inherits(Pie, _React$Component3);

  var _super3 = _createSuper(Pie);

  function Pie() {
    _classCallCheck(this, Pie);

    return _super3.apply(this, arguments);
  }

  _createClass(Pie, [{
    key: "render",
    value: function render() {
      var _this5 = this;

      return _react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref2) {
          return _this5.chartInstance = _ref2 && _ref2.chartInstance;
        },
        type: "pie"
      }));
    }
  }]);

  return Pie;
}(_react["default"].Component);

exports.Pie = Pie;

var Line = function (_React$Component4) {
  _inherits(Line, _React$Component4);

  var _super4 = _createSuper(Line);

  function Line() {
    _classCallCheck(this, Line);

    return _super4.apply(this, arguments);
  }

  _createClass(Line, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      return _react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref3) {
          return _this6.chartInstance = _ref3 && _ref3.chartInstance;
        },
        type: "line"
      }));
    }
  }]);

  return Line;
}(_react["default"].Component);

exports.Line = Line;

var Bar = function (_React$Component5) {
  _inherits(Bar, _React$Component5);

  var _super5 = _createSuper(Bar);

  function Bar() {
    _classCallCheck(this, Bar);

    return _super5.apply(this, arguments);
  }

  _createClass(Bar, [{
    key: "render",
    value: function render() {
      var _this7 = this;

      return _react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref4) {
          return _this7.chartInstance = _ref4 && _ref4.chartInstance;
        },
        type: "bar"
      }));
    }
  }]);

  return Bar;
}(_react["default"].Component);

exports.Bar = Bar;

var HorizontalBar = function (_React$Component6) {
  _inherits(HorizontalBar, _React$Component6);

  var _super6 = _createSuper(HorizontalBar);

  function HorizontalBar() {
    _classCallCheck(this, HorizontalBar);

    return _super6.apply(this, arguments);
  }

  _createClass(HorizontalBar, [{
    key: "render",
    value: function render() {
      var _this8 = this;

      return _react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref5) {
          return _this8.chartInstance = _ref5 && _ref5.chartInstance;
        },
        type: "horizontalBar"
      }));
    }
  }]);

  return HorizontalBar;
}(_react["default"].Component);

exports.HorizontalBar = HorizontalBar;

var Radar = function (_React$Component7) {
  _inherits(Radar, _React$Component7);

  var _super7 = _createSuper(Radar);

  function Radar() {
    _classCallCheck(this, Radar);

    return _super7.apply(this, arguments);
  }

  _createClass(Radar, [{
    key: "render",
    value: function render() {
      var _this9 = this;

      return _react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref6) {
          return _this9.chartInstance = _ref6 && _ref6.chartInstance;
        },
        type: "radar"
      }));
    }
  }]);

  return Radar;
}(_react["default"].Component);

exports.Radar = Radar;

var Polar = function (_React$Component8) {
  _inherits(Polar, _React$Component8);

  var _super8 = _createSuper(Polar);

  function Polar() {
    _classCallCheck(this, Polar);

    return _super8.apply(this, arguments);
  }

  _createClass(Polar, [{
    key: "render",
    value: function render() {
      var _this10 = this;

      return _react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref7) {
          return _this10.chartInstance = _ref7 && _ref7.chartInstance;
        },
        type: "polarArea"
      }));
    }
  }]);

  return Polar;
}(_react["default"].Component);

exports.Polar = Polar;

var Bubble = function (_React$Component9) {
  _inherits(Bubble, _React$Component9);

  var _super9 = _createSuper(Bubble);

  function Bubble() {
    _classCallCheck(this, Bubble);

    return _super9.apply(this, arguments);
  }

  _createClass(Bubble, [{
    key: "render",
    value: function render() {
      var _this11 = this;

      return _react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref8) {
          return _this11.chartInstance = _ref8 && _ref8.chartInstance;
        },
        type: "bubble"
      }));
    }
  }]);

  return Bubble;
}(_react["default"].Component);

exports.Bubble = Bubble;

var Scatter = function (_React$Component10) {
  _inherits(Scatter, _React$Component10);

  var _super10 = _createSuper(Scatter);

  function Scatter() {
    _classCallCheck(this, Scatter);

    return _super10.apply(this, arguments);
  }

  _createClass(Scatter, [{
    key: "render",
    value: function render() {
      var _this12 = this;

      return _react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref9) {
          return _this12.chartInstance = _ref9 && _ref9.chartInstance;
        },
        type: "scatter"
      }));
    }
  }]);

  return Scatter;
}(_react["default"].Component);

exports.Scatter = Scatter;
var defaults = _chart["default"].defaults;
exports.defaults = defaults;
}.call(exports, __webpack_require__(124)))

 }),

 (function(module, exports, __webpack_require__) {


(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(20); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {



// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};


function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;



function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};




var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}





var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

function isValidKey(key) {
	return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}


var helpers = {
	
	noop: function() {},

	
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = Object.create(source);
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	
	_merger: function(key, target, source, options) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	
	_mergerIf: function(key, target, source) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS


helpers.callCallback = helpers.callback;


helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};


helpers.getValueOrDefault = helpers.valueOrDefault;


helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS


helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;


var exports$1 = {
	
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS


helpers_core.clear = exports$1.clear;


helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;


function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}


var helpers_options = {
	
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};


var exports$2 = {
	
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS


helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS


Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});


Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];


function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}


function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	
	datasetElementType: null,

	
	dataElementType: null,

	
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge(Object.create(null), [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}


function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});


function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}


function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}


function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	
	getStackCount: function() {
		return this._getStacks().length;
	},

	
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	
	dataElementType: elements.Point,

	
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};


function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}


function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}


function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}


function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}


function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}





var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		
		label: indexMode,

		
		index: indexMode,

		
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
		return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});



// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};



var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";

var platform_dom$1 = Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];


var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};


function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}


function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}


var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}


function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	
	disableCSSInjection: false,

	
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS


helpers$1.addEvent = addListener;


helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;


var platform = helpers$1.extend({
	
	initialize: function() {},

	
	acquireContext: function() {},

	
	releaseContext: function() {},

	
	addEventListener: function() {},

	
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});


var core_plugins = {
	
	_plugins: [],

	
	_cacheId: 0,

	
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	
	count: function() {
		return this._plugins.length;
	},

	
	getAll: function() {
		return this._plugins;
	},

	
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}


function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}



function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}


function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}


function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}


function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}


function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}


function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});


var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});


function mergeScaleConfig() {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}


function mergeConfig() {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || Object.create(null);
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || Object.create(null);

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype,  {
	
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});


Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS


Chart.Controller = Chart;


Chart.types = {};


helpers$1.configMerge = mergeConfig;


helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}






function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype,  {
	
	formats: abstract,

	
	parse: abstract,

	
	format: abstract,

	
	add: abstract,

	
	diff: abstract,

	
	startOf: abstract,

	
	endOf: abstract,

	// DEPRECATIONS

	
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};


var core_ticks = {
	
	formatters: {
		
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});


function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}


function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var widestLabelSize = 0;
	var highestLabelSize = 0;
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
		widestLabelSize = Math.max(width, widestLabelSize);
		highestLabelSize = Math.max(height, highestLabelSize);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(widestLabelSize);
	highest = heights.indexOf(highestLabelSize);

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	
	getTicks: function() {
		return this._ticks;
	},

	
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	
	getLabelForIndex: helpers$1.noop,

	
	getPixelForValue: helpers$1.noop,

	
	getValueForPixel: helpers$1.noop,

	
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;


function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;


function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}


function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}


function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}


function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}


function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}


function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}


function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}


function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	
	distribution: 'linear',

	
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});


function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}


var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});


var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;




core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS


core_controller.Chart = core_controller;


core_controller.Legend = plugins.legend._element;


core_controller.Title = plugins.title._element;


core_controller.pluginService = core_controller.plugins;


core_controller.PluginBase = core_controller.Element.extend({});


core_controller.canvasHelpers = core_controller.helpers.canvas;


core_controller.layoutService = core_controller.layouts;


core_controller.LinearScaleBase = scale_linearbase;


core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


 }),

 (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(315);


function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


 }),

 (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(575),
    equalArrays = __webpack_require__(580),
    equalByTag = __webpack_require__(1765),
    equalObjects = __webpack_require__(1769),
    getTag = __webpack_require__(1787),
    isArray = __webpack_require__(72),
    isBuffer = __webpack_require__(582),
    isTypedArray = __webpack_require__(584);


var COMPARE_PARTIAL_FLAG = 1;


var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';


var objectProto = Object.prototype;


var hasOwnProperty = objectProto.hasOwnProperty;


function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


 }),

 (function(module, exports) {


function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


 }),

 (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(203);


var arrayProto = Array.prototype;


var splice = arrayProto.splice;


function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


 }),

 (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(203);


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


 }),

 (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(203);


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


 }),

 (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(203);


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


 }),

 (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(202);


function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


 }),

 (function(module, exports) {


function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


 }),

 (function(module, exports) {


function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


 }),

 (function(module, exports) {


function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


 }),

 (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(202),
    Map = __webpack_require__(316),
    MapCache = __webpack_require__(318);


var LARGE_ARRAY_SIZE = 200;


function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


 }),

 (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(577),
    isMasked = __webpack_require__(1745),
    isObject = __webpack_require__(317),
    toSource = __webpack_require__(579);


var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;


var reIsHostCtor = /^\[object .+?Constructor\]$/;


var funcProto = Function.prototype,
    objectProto = Object.prototype;


var funcToString = funcProto.toString;


var hasOwnProperty = objectProto.hasOwnProperty;


var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);


function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


 }),

 (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(204);


var objectProto = Object.prototype;


var hasOwnProperty = objectProto.hasOwnProperty;


var nativeObjectToString = objectProto.toString;


var symToStringTag = Symbol ? Symbol.toStringTag : undefined;


function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


 }),

 (function(module, exports) {


var objectProto = Object.prototype;


var nativeObjectToString = objectProto.toString;


function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


 }),

 (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1746);


var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());


function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


 }),

 (function(module, exports, __webpack_require__) {

var root = __webpack_require__(71);


var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


 }),

 (function(module, exports) {


function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


 }),

 (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1749),
    ListCache = __webpack_require__(202),
    Map = __webpack_require__(316);


function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


 }),

 (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1750),
    hashDelete = __webpack_require__(1751),
    hashGet = __webpack_require__(1752),
    hashHas = __webpack_require__(1753),
    hashSet = __webpack_require__(1754);


function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


 }),

 (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(205);


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


 }),

 (function(module, exports) {


function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


 }),

 (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(205);


var HASH_UNDEFINED = '__lodash_hash_undefined__';


var objectProto = Object.prototype;


var hasOwnProperty = objectProto.hasOwnProperty;


function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


 }),

 (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(205);


var objectProto = Object.prototype;


var hasOwnProperty = objectProto.hasOwnProperty;


function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


 }),

 (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(205);


var HASH_UNDEFINED = '__lodash_hash_undefined__';


function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


 }),

 (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(206);


function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


 }),

 (function(module, exports) {


function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


 }),

 (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(206);


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


 }),

 (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(206);


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


 }),

 (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(206);


function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


 }),

 (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(318),
    setCacheAdd = __webpack_require__(1761),
    setCacheHas = __webpack_require__(1762);


function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


 }),

 (function(module, exports) {


var HASH_UNDEFINED = '__lodash_hash_undefined__';


function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


 }),

 (function(module, exports) {


function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


 }),

 (function(module, exports) {


function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


 }),

 (function(module, exports) {


function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


 }),

 (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(204),
    Uint8Array = __webpack_require__(1766),
    eq = __webpack_require__(576),
    equalArrays = __webpack_require__(580),
    mapToArray = __webpack_require__(1767),
    setToArray = __webpack_require__(1768);


var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;


var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';


var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;


function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


 }),

 (function(module, exports, __webpack_require__) {

var root = __webpack_require__(71);


var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


 }),

 (function(module, exports) {


function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


 }),

 (function(module, exports) {


function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


 }),

 (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1770);


var COMPARE_PARTIAL_FLAG = 1;


var objectProto = Object.prototype;


var hasOwnProperty = objectProto.hasOwnProperty;


function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


 }),

 (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1771),
    getSymbols = __webpack_require__(1773),
    keys = __webpack_require__(319);


function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


 }),

 (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1772),
    isArray = __webpack_require__(72);


function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


 }),

 (function(module, exports) {


function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


 }),

 (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1774),
    stubArray = __webpack_require__(1775);


var objectProto = Object.prototype;


var propertyIsEnumerable = objectProto.propertyIsEnumerable;


var nativeGetSymbols = Object.getOwnPropertySymbols;


var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


 }),

 (function(module, exports) {


function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


 }),

 (function(module, exports) {


function stubArray() {
  return [];
}

module.exports = stubArray;


 }),

 (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1777),
    isArguments = __webpack_require__(581),
    isArray = __webpack_require__(72),
    isBuffer = __webpack_require__(582),
    isIndex = __webpack_require__(583),
    isTypedArray = __webpack_require__(584);


var objectProto = Object.prototype;


var hasOwnProperty = objectProto.hasOwnProperty;


function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


 }),

 (function(module, exports) {


function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


 }),

 (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(149),
    isObjectLike = __webpack_require__(150);


var argsTag = '[object Arguments]';


function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


 }),

 (function(module, exports) {


function stubFalse() {
  return false;
}

module.exports = stubFalse;


 }),

 (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(149),
    isLength = __webpack_require__(320),
    isObjectLike = __webpack_require__(150);


var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';


var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;


function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


 }),

 (function(module, exports) {


function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


 }),

 (function(module, exports, __webpack_require__) {

(function(module) {var freeGlobal = __webpack_require__(578);


var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;


var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;


var moduleExports = freeModule && freeModule.exports === freeExports;


var freeProcess = moduleExports && freeGlobal.process;


var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

}.call(exports, __webpack_require__(123)(module)))

 }),

 (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1784),
    nativeKeys = __webpack_require__(1785);


var objectProto = Object.prototype;


var hasOwnProperty = objectProto.hasOwnProperty;


function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


 }),

 (function(module, exports) {


var objectProto = Object.prototype;


function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


 }),

 (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1786);


var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


 }),

 (function(module, exports) {


function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


 }),

 (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1788),
    Map = __webpack_require__(316),
    Promise = __webpack_require__(1789),
    Set = __webpack_require__(1790),
    WeakMap = __webpack_require__(1791),
    baseGetTag = __webpack_require__(149),
    toSource = __webpack_require__(579);


var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';


var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);


var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


 }),

 (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105),
    root = __webpack_require__(71);


var DataView = getNative(root, 'DataView');

module.exports = DataView;


 }),

 (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105),
    root = __webpack_require__(71);


var Promise = getNative(root, 'Promise');

module.exports = Promise;


 }),

 (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105),
    root = __webpack_require__(71);


var Set = getNative(root, 'Set');

module.exports = Set;


 }),

 (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105),
    root = __webpack_require__(71);


var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


 }),

 (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(1793),
    createAggregator = __webpack_require__(1795);


var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


 }),

 (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1794);


function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


 }),

 (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


 }),

 (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(1796),
    baseAggregator = __webpack_require__(1797),
    baseIteratee = __webpack_require__(1803),
    isArray = __webpack_require__(72);


function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


 }),

 (function(module, exports) {


function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


 }),

 (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1798);


function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


 }),

 (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1799),
    createBaseEach = __webpack_require__(1802);


var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


 }),

 (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1800),
    keys = __webpack_require__(319);


function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


 }),

 (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1801);


var baseFor = createBaseFor();

module.exports = baseFor;


 }),

 (function(module, exports) {


function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


 }),

 (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(585);


function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


 }),

 (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1804),
    baseMatchesProperty = __webpack_require__(1807),
    identity = __webpack_require__(1818),
    isArray = __webpack_require__(72),
    property = __webpack_require__(1819);


function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


 }),

 (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1805),
    getMatchData = __webpack_require__(1806),
    matchesStrictComparable = __webpack_require__(587);


function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


 }),

 (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(575),
    baseIsEqual = __webpack_require__(315);


var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;


function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


 }),

 (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(586),
    keys = __webpack_require__(319);


function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


 }),

 (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(315),
    get = __webpack_require__(1808),
    hasIn = __webpack_require__(1815),
    isKey = __webpack_require__(321),
    isStrictComparable = __webpack_require__(586),
    matchesStrictComparable = __webpack_require__(587),
    toKey = __webpack_require__(207);


var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;


function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


 }),

 (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(588);


function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


 }),

 (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1810);


var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;


var reEscapeChar = /\\(\\)?/g;


var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 ) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


 }),

 (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1811);


var MAX_MEMOIZE_SIZE = 500;


function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


 }),

 (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(318);


var FUNC_ERROR_TEXT = 'Expected a function';


function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


 }),

 (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1813);


function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


 }),

 (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(204),
    arrayMap = __webpack_require__(1814),
    isArray = __webpack_require__(72),
    isSymbol = __webpack_require__(322);


var INFINITY = 1 / 0;


var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;


function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


 }),

 (function(module, exports) {


function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


 }),

 (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1816),
    hasPath = __webpack_require__(1817);


function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


 }),

 (function(module, exports) {


function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


 }),

 (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(589),
    isArguments = __webpack_require__(581),
    isArray = __webpack_require__(72),
    isIndex = __webpack_require__(583),
    isLength = __webpack_require__(320),
    toKey = __webpack_require__(207);


function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


 }),

 (function(module, exports) {


function identity(value) {
  return value;
}

module.exports = identity;


 }),

 (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1820),
    basePropertyDeep = __webpack_require__(1821),
    isKey = __webpack_require__(321),
    toKey = __webpack_require__(207);


function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


 }),

 (function(module, exports) {


function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


 }),

 (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(588);


function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return Card; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return FeedbackLayer; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  margin: 0 auto 85px;\n  height: 340px;\n  padding: 20px;\n  border-left: 0;\n  border-right: 0;\n  max-width: 80rem\n'],['\n  position: relative;\n  margin: 0 auto 85px;\n  height: 340px;\n  padding: 20px;\n  border-left: 0;\n  border-right: 0;\n  max-width: 80rem\n']),_templateObject2=_taggedTemplateLiteral(['\n  height: 80vh;\n'],['\n  height: 80vh;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Card=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var FeedbackLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__components_PieChart__ = __webpack_require__(1824);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_PieChart__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_components_Steps_Likes__ = __webpack_require__(184);
 var __WEBPACK_IMPORTED_MODULE_4_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1825);
 var __WEBPACK_IMPORTED_MODULE_7__styles_css__ = __webpack_require__(1826);
 var __WEBPACK_IMPORTED_MODULE_7__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_css__);
 var __WEBPACK_IMPORTED_MODULE_8__Pie__ = __webpack_require__(1827);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PieChart=function(_Component){_inherits(PieChart,_Component);function PieChart(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PieChart);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PieChart.__proto__||Object.getPrototypeOf(PieChart)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:null,view:'',userClicked:null},_this.handleNewOptions=function(){_this.setState({view:'none',selected:null,userClicked:null});setTimeout(function(){_this.setState({view:''});},200);},_this.getData=function(){var options=_this.props.options;var data=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(options,function(item){data.push(item);return true;});return data;},_this.onSelect=function(id){var options=_this.props.options;_this.setState({selected:options[id]});},_this.onSelectUser=function(like){_this.setState({view:'profile',userClicked:like});},_this.closeUserCards=function(){_this.setState({view:''});},_this.printSelectedUser=function(){var _this$state=_this.state,selected=_this$state.selected,view=_this$state.view,userClicked=_this$state.userClicked;if(view!=='profile'){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UsersModal__["a" ],{usersIds:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(selected.users,function(user){return user.id;}),userSelected:userClicked,onEnd:_this.closeUserCards});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PieChart,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var options=this.props.options;if(JSON.stringify(options)!==JSON.stringify(prevProps.options)){this.handleNewOptions();}}},{key:'render',value:function render(){var color=this.props.color;var _state=this.state,selected=_state.selected,view=_state.view;var data=this.getData();if(view==='none'){return null;}var pieChartData=data.filter(function(elem){return elem.value!==0;}).map(function(item){return{value:item.value,name:item.label};});var colors=[];data.forEach(function(elem){colors.push(elem.color);});var radius=150;if(window.innerWidth>__WEBPACK_IMPORTED_MODULE_5_constants_breakPoints__["b" ]){radius=200;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.printSelectedUser(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Pie__["a" ],{data:pieChartData,radius:radius,hole:50,colors:colors,labels:true,percent:true,strokeWidth:3,stroke:color||'#fff',onSelect:this.onSelect}),selected&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Steps_Likes__["a" ],{label:selected.label,userList:selected.users,onSelectUser:this.onSelectUser})));}}]);return PieChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PieChart.propTypes={options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}; __webpack_exports__["a"] = (PieChart);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return Card; });



 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  margin: 0 auto 0px;\n  border-left: 0;\n  border-right: 0;\n  max-width: 80rem;\n\n  svg {\n    background-color: transparent !important;\n  }\n'],['\n  position: relative;\n  margin: 0 auto 0px;\n  border-left: 0;\n  border-right: 0;\n  max-width: 80rem;\n\n  svg {\n    background-color: transparent !important;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  color: white;\n  font-size: 20px;\n'],['\n  width: 100%;\n  position: relative;\n  color: white;\n  font-size: 20px;\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: relative;\n  width: 90%;\n  left: 5%;\n  right: 5%;\n  font-size: 18px;\n  color: #fff;\n  font-family: \'helvetica neue light\';\n'],['\n  position: relative;\n  width: 90%;\n  left: 5%;\n  right: 5%;\n  font-size: 18px;\n  color: #fff;\n  font-family: \'helvetica neue light\';\n']),_templateObject4=_taggedTemplateLiteral(['\n  height: 80vh;\n'],['\n  height: 80vh;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Card=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var SectorInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var SelectedNumber=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var FeedbackLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1__Slice__ = __webpack_require__(1828);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Pie=function(_React$Component){_inherits(Pie,_React$Component);function Pie(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Pie);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Pie.__proto__||Object.getPrototypeOf(Pie)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:''},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Pie,[{key:'render',value:function render(){var _this2=this;var _props=this.props,colors=_props.colors,labels=_props.labels,hole=_props.hole,radius=_props.radius,data=_props.data,_onSelect=_props.onSelect;var selected=this.state.selected;var colorsLength=colors.length;var diameter=radius*2;var self=this;var startAngle=void 0;var d=null;var sum=data.reduce(function(carry,current){return carry+current.value;},0);startAngle=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:diameter,height:diameter,viewBox:'-10 -10 '+(diameter+20)+' '+(diameter+20),xmlns:'http://www.w3.org/2000/svg',version:'1.1'},data.map(function(slice,sliceIndex){var angle=void 0;var nextAngle=void 0;var percent=void 0;nextAngle=startAngle;angle=slice.value/sum*360;percent=slice.value/sum*100;startAngle+=angle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Slice__["a" ],{key:sliceIndex,value:slice.value,name:slice.name,percent:self.props.percent,percentValue:percent.toFixed(1),startAngle:nextAngle,angle:angle,radius:radius,hole:radius-hole,trueHole:hole,showLabel:labels,fill:colors[sliceIndex%colorsLength],stroke:self.props.stroke,strokeWidth:self.props.strokeWidth,onSelect:function onSelect(){_this2.setState({selected:slice.name});_onSelect(sliceIndex);},selected:selected});}));}}]);return Pie;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component); __webpack_exports__["a"] = (Pie);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getAnglePoint(startAngle,endAngle,radius,x,y){var x1=void 0;var y1=void 0;var x2=void 0;var y2=void 0;x1=x+radius*Math.cos(Math.PI*startAngle/180);y1=y+radius*Math.sin(Math.PI*startAngle/180);x2=x+radius*Math.cos(Math.PI*endAngle/180);y2=y+radius*Math.sin(Math.PI*endAngle/180);return{x1:x1,y1:y1,x2:x2,y2:y2};}var Slice=function(_React$Component){_inherits(Slice,_React$Component);function Slice(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Slice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Slice.__proto__||Object.getPrototypeOf(Slice)).call.apply(_ref,[this].concat(args))),_this),_this.state={path:'',x:0,y:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Slice,[{key:'componentDidMount',value:function componentDidMount(){this.animate();}},{key:'animate',value:function animate(){var _this2=this;setTimeout(function(){return _this2.draw(0);},1000);}},{key:'draw',value:function draw(s){var p=this.props;var path=[];var a=void 0;var b=void 0;var c=void 0;var self=this;var step=void 0;step=p.angle/(37.5/2);if(s+step>p.angle){s=p.angle;}if(s===360){s-=1;}// Get angle points
a=getAnglePoint(p.startAngle,p.startAngle+s,p.radius,p.radius,p.radius);b=getAnglePoint(p.startAngle,p.startAngle+s,p.radius-p.hole,p.radius,p.radius);if(s<360){path.push('M'+a.x1+','+a.y1);path.push('A'+p.radius+','+p.radius+' 0 '+(s>180?1:0)+',1 '+a.x2+','+a.y2);path.push('L'+b.x2+','+b.y2);path.push('A'+(p.radius-p.hole)+','+(p.radius-p.hole)+' 0 '+(s>180?1:0)+',0 '+b.x1+','+b.y1);// Close
path.push('Z');this.setState({path:path.join(' ')});}if(s<p.angle&&s!==359){setTimeout(function(){self.draw(s+step);},16);}else if(p.showLabel){c=getAnglePoint(p.startAngle,p.startAngle+p.angle/2,p.radius/2+p.trueHole/2,p.radius,p.radius);this.setState({x:c.x2,y:c.y2});}}},{key:'render',value:function render(){var textColor='';var percentageColor='';var selectedTextColor='';if(this.props.stroke==='#fff'){textColor='#fff';percentageColor='#fff';selectedTextColor=this.props.fill;}else{textColor=this.props.stroke;percentageColor=this.props.fill;selectedTextColor=this.props.stroke;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{onClick:this.props.onSelect},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:this.state.path,fill:this.props.selected===this.props.name?'#fff':this.props.fill,stroke:this.props.stroke,strokeWidth:this.props.strokeWidth?this.props.strokeWidth:3}),this.props.showLabel&&this.props.percentValue>5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.x,y:this.state.y,fill:this.props.selected!==this.props.name?textColor:selectedTextColor,textAnchor:'middle'},''+this.props.name),this.props.selected===this.props.name&&this.props.percentValue&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{className:'percentage',x:this.props.radius,y:this.props.radius+7,fill:percentageColor,textAnchor:'middle',style:{fontSize:'18px'}},this.props.percentValue+'%')):null);}}]);return Slice;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component); __webpack_exports__["a"] = (Slice);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1830);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components_CustomCard__ = __webpack_require__(1831);
function mapStateToProps(state){return{literals:state.i18n.literals.narratives,app:state.app};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_CustomCard__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_utils_string__ = __webpack_require__(67);
 var __WEBPACK_IMPORTED_MODULE_4__ElementButtons__ = __webpack_require__(1832);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(264);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomCard=function(_Component){_inherits(CustomCard,_Component);function CustomCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CustomCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CustomCard.__proto__||Object.getPrototypeOf(CustomCard)).call.apply(_ref,[this].concat(args))),_this),_this.printElements=function(){var _this$props=_this.props,data=_this$props.data,literals=_this$props.literals,color=_this$props.color,goNext=_this$props.goNext,app=_this$props.app;var elements=data.elements,narrativeType=data.narrativeType;var i=0;var j=0;var noBackgroundColor=0;var colorText='#fff';var backgroundColor=color.color||color;if(typeof app.advanced_configuration!=='undefined'&&typeof app.advanced_configuration.no_background_color!=='undefined'&&app.advanced_configuration.no_background_color){colorText=app.color2;backgroundColor=color.color||color;noBackgroundColor=1;}return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(elements,function(element,index){i+=1;switch(element.type){case'title':{var fontSize=Object(__WEBPACK_IMPORTED_MODULE_3_utils_string__["b" ])(element.text);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["q" ],{maxFontSize:fontSize,backgroundColorText:color.color||color,key:i,dangerouslySetInnerHTML:{__html:element.text}});}case'subtitle':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["n" ],{backgroundColorText:color.color||color,key:i,dangerouslySetInnerHTML:{__html:element.text}});case'text':{if(element.color){switch(element.color){case'context':if(color){colorText=color.contrastColor||colorText;}break;default:colorText=element.color;break;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["p" ],{key:i,color:colorText,backgroundColorText:backgroundColor,noBackgroundColor:noBackgroundColor,dangerouslySetInnerHTML:{__html:''+element.text}});}case'html':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:element.html}});case'list':{var listElements=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(element.elements,function(elementList){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{dangerouslySetInnerHTML:{__html:elementList}});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["e" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list_title',dangerouslySetInnerHTML:{__html:element.title}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,listElements));}case'quote':{var elementsQuote=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["l" ],{key:i,dangerouslySetInnerHTML:{__html:element.text}})];if(element.author){elementsQuote.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["m" ],null,element.author));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,elementsQuote);}case'image':if(element.rounded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["i" ],{key:i,src:element.url,width:element.width,marginBottom:element.marginBottom||20,marginTop:element.marginTop||0,rounded:element.rounded});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["h" ],{key:i,src:element.url,marginBottom:element.marginBottom||20,marginTop:element.marginTop||10});case'overlay':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["k" ],{key:i,src:element.url,height:element.height,paddingTop:element.paddingTop});case'user':if(!element.avatar&&!element.firstname&&!element.lastname){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["r" ],{key:i},element.avatar&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" ],{img:element.avatar}),!element.avatar&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["b" ],null,element.firstname.substr(0,1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["s" ],null,element.firstname+' '+element.lastname));case'tags':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["o" ],{key:i},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(element.tags,function(tag){return!!tag;}),function(tag){j+=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:j},tag);}));case'youtube':{var autoplay=1;if(typeof element.autoplay!=='undefined'){autoplay=element.autoplay;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["t" ],{key:i,src:'https://www.youtube.com/embed/'+element.youtubeId+'?autoplay='+autoplay,frameBorder:0,allow:'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',allowFullScreen:true});}case'element':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ElementButtons__["a" ],{key:element.element_name,narrativeType:narrativeType,elementType:element.element_type,elementName:element.element_name,acceptButton:element.accept_button||literals.yes,rejectButton:element.reject_button||literals.no,color:color,onSelect:goNext,index:index,answers:data.answers});case'link':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["j" ],{key:i,href:element.url,target:'_blank',color:color},element.text);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i});}});},_this.printContent=function(){return _this.printElements();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CustomCard,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["c" ],null,this.printContent()));}}]);return CustomCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CustomCard.propTypes={app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,goNext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};CustomCard.defaultProps={goNext:null}; __webpack_exports__["a"] = (CustomCard);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(264);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ElementButtonsComponent=function(_Component){_inherits(ElementButtonsComponent,_Component);function ElementButtonsComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ElementButtonsComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ElementButtonsComponent.__proto__||Object.getPrototypeOf(ElementButtonsComponent)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:''},_this.handleNo=function(){var selected=_this.state.selected;if(selected!=='no'){_this.setState({selected:'no'});var _this$props=_this.props,narrativeType=_this$props.narrativeType,elementType=_this$props.elementType,elementName=_this$props.elementName,onSelect=_this$props.onSelect;var params={narrativeType:narrativeType,type:elementType,name:elementName};Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('DELETE',{endPoint:'elements/connection'},params);if(onSelect){setTimeout(function(){onSelect();},200);}}},_this.handleYes=function(){var selected=_this.state.selected;if(selected!=='yes'){_this.setState({selected:'yes'});var _this$props2=_this.props,narrativeType=_this$props2.narrativeType,elementType=_this$props2.elementType,elementName=_this$props2.elementName,onSelect=_this$props2.onSelect;var params={narrativeType:narrativeType,type:elementType,name:elementName};Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'elements/connection'},params);if(onSelect){setTimeout(function(){onSelect();},800);}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ElementButtonsComponent,[{key:'render',value:function render(){var _props=this.props,color=_props.color,acceptButton=_props.acceptButton,rejectButton=_props.rejectButton,key=_props.key,answers=_props.answers,elementName=_props.elementName;var selected=this.state.selected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["g" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["f" ],{onClick:!this.changingStep&&this.handleNo,selected:selected==='no',color:color||color.color},rejectButton),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["f" ],{type:'yes',onClick:!this.changingStep&&this.handleYes,selected:selected==='yes'||answers.find(function(answer){return answer===elementName;}),color:color||color.color},acceptButton));}}]);return ElementButtonsComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ElementButtonsComponent.propTypes={narrativeType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,elementType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,elementName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,acceptButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,rejectButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};ElementButtonsComponent.defaultProps={onSelect:null}; __webpack_exports__["a"] = (ElementButtonsComponent);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_routes_MainPage_modules_mainPage__ = __webpack_require__(49);
 var __WEBPACK_IMPORTED_MODULE_4__modules_elements_actions__ = __webpack_require__(132);
 var __WEBPACK_IMPORTED_MODULE_5__components_FormElement__ = __webpack_require__(1834);
function mapStateToProps(state){return{literals:state.i18n.literals.formElement,element:state.elements.element,elements:state.narratives.elements};}function mapDispatchToProps(dispatch){return{setGoDown:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_routes_MainPage_modules_mainPage__["d" ],dispatch),getElementById:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4__modules_elements_actions__["b" ],dispatch),postElementByUser:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4__modules_elements_actions__["g" ],dispatch),getElementsCreatedByUser:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4__modules_elements_actions__["d" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components_FormElement__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_5_components_AutocompleteInput__ = __webpack_require__(96);
 var __WEBPACK_IMPORTED_MODULE_6_constants_apiConf__ = __webpack_require__(156);
 var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1835);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormElement=function(_Component){_inherits(FormElement,_Component);function FormElement(props){_classCallCheck(this,FormElement);var _this=_possibleConstructorReturn(this,(FormElement.__proto__||Object.getPrototypeOf(FormElement)).call(this,props));_this.printImage=function(){var _this$state=_this.state,image=_this$state.image,uploadingImage=_this$state.uploadingImage;var _this$props=_this.props,literals=_this$props.literals,color=_this$props.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["d" ],{image:image,htmlFor:'document_file',color:color||color.color},!image&&!uploadingImage&&literals.pressToUploadImage,!image&&uploadingImage&&literals.uploading,image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image,alt:literals.pressToUploadImage}));};_this.printTags=function(){var tags=_this.state.tags;return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(tags,function(tag,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["g" ],{key:index,'data-id':tag.id,onClick:_this.removeTag},tag.name);});};_this.handleFileUpload=function(event){var file=event.target.files[0];var name=file.name;var reader=new FileReader();reader.onloadend=function(){_this.uploadImage(reader.result,name);};reader.readAsDataURL(file);};_this.uploadImage=function(data,name){var params={data:data,name:name};_this.setState({uploadingImage:true});Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('POST',{endPoint:'upload-file'},params).then(function(response){_this.setState({image:response.url,uploadingImage:false});}).catch(function(){_this.setState({image:'',uploadingImage:false});});};_this.handleChangeName=function(event){var value=event.target.value;_this.setState({name:value});};_this.handleChangeDescription=function(event){var value=event.target.value;_this.setState({description:value});};_this.removeTag=function(event){var tags=_this.state.tags;var tagId=parseInt(event.currentTarget.getAttribute('data-id'),10);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(tags,function(element){return element.id===tagId;});_this.setState({tags:tags});};_this.handleTag=function(tag){var tags=_this.state.tags;tags.push(tag);_this.setState({tags:tags});};_this.submit=function(){var _this$state2=_this.state,id=_this$state2.id,name=_this$state2.name,description=_this$state2.description,image=_this$state2.image,uploadingImage=_this$state2.uploadingImage,tags=_this$state2.tags,success=_this$state2.success;var onFinish=_this.props.onFinish;if(!success){var _this$props2=_this.props,literals=_this$props2.literals,elementType=_this$props2.elementType,narrativeType=_this$props2.narrativeType;if(!name){_this.setState({error:literals.errorName});return false;}if(uploadingImage){_this.setState({error:literals.errorUploadingImage});return false;}if(id===0){var params={name:name,description:description,image:image,type:elementType,elements:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(tags,function(tag){return'tag-'+tag.id;}).join(__WEBPACK_IMPORTED_MODULE_6_constants_apiConf__["b" ]),narrative_type:narrativeType};_this.setState({error:false,success:true});Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('POST',{endPoint:'element'},params);}else{var _this$props3=_this.props,postElementByUser=_this$props3.postElementByUser,getElementsCreatedByUser=_this$props3.getElementsCreatedByUser;var _params={id:id,name:name,description:description,image:image,tags:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(tags,function(tag){return''+tag.id;}).join(',')};postElementByUser(_params);var elements=['challenge'];getElementsCreatedByUser(elements);var history=_this.props.history;history.push('/initiatives');}if(onFinish){setTimeout(function(){onFinish();},2000);}return true;}return true;};_this.state={id:0,name:'',description:'',image:'',uploadingImage:false,tags:[],error:'',success:false};return _this;}_createClass(FormElement,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var element=this.props.element;var id=this.state.id;if(prevProps.element!==null&&prevProps.element.id!==id&&element!==null){this.setState({id:element.id,name:element.name,description:element.description,image:element.image,uploadingImage:element.image!=='',tags:[element.type],error:'',success:false});}}},{key:'render',value:function render(){var _state=this.state,name=_state.name,description=_state.description,tags=_state.tags,success=_state.success,error=_state.error;var _props=this.props,literals=_props.literals,color=_props.color;var darkerColor=color||color.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["f" ],{value:decodeURIComponent(name),placeholder:literals.name,onChange:this.handleChangeName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'document_file',name:'document_file',style:{display:'none'},onChange:this.handleFileUpload,accept:'image/png, image/jpeg'}),this.printImage(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["e" ],{value:decodeURIComponent(description),placeholder:literals.description,onChange:this.handleChangeDescription}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["h" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_AutocompleteInput__["a" ],{canCreateNew:true,type:'tag',placeholder:literals.tags,selectedOptions:tags,onSelectOption:this.handleTag,onCreateOption:this.handleTag}),this.printTags()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" ],{type:'button',onClick:this.submit,color:color||color.color,darkerColor:darkerColor,success:success},success?literals.sent:literals.send)),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["b" ],null,error));}}]);return FormElement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FormElement.propTypes={literals:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,elementType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,narrativeType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,onFinish:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};FormElement.defaultProps={onFinish:null}; __webpack_exports__["a"] = (FormElement);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return FormWrapper; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return InputName; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return Image; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return InputDescription; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return TagsWrapper; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return TagLabel; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return BtnSubmit; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ErrorLayer; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__ = __webpack_require__(68);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 0px 20px 20px;\n'],['\n  padding: 0px 20px 20px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  && {\n    width: 100%;\n    margin: 0px 0 10px;\n    border: 0px;\n\n    input {\n      background-color: #fff;\n      color: #4d4d4d;\n      padding: 10px;\n      border-radius: 3px;\n      font-family: \'helvetica neue light\';\n      font-size: 14px;\n    }    \n  }\n'],['\n  && {\n    width: 100%;\n    margin: 0px 0 10px;\n    border: 0px;\n\n    input {\n      background-color: #fff;\n      color: #4d4d4d;\n      padding: 10px;\n      border-radius: 3px;\n      font-family: \'helvetica neue light\';\n      font-size: 14px;\n    }    \n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 100%;\n  padding: ',';\n  background-color: #eee;\n  color: ',';\n  font-size: 16px;\n  line-height: 20px;  \n  display: block;\n  img {\n    width: 100%;\n  }\n'],['\n  width: 100%;\n  padding: ',';\n  background-color: #eee;\n  color: ',';\n  font-size: 16px;\n  line-height: 20px;  \n  display: block;\n  img {\n    width: 100%;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  && {\n    width: 100%;\n    margin: 10px 0 10px;\n    border: 0px;\n\n    > div::before {\n      border-bottom: 0px !important;\n    }\n\n    textarea {\n      background-color: #fff;\n      color: #4d4d4d;\n      padding: 10px;\n      border-radius: 3px;\n      font-family: \'helvetica neue light\';\n      font-size: 14px;\n      box-sizing: border-box;\n    }    \n  }\n'],['\n  && {\n    width: 100%;\n    margin: 10px 0 10px;\n    border: 0px;\n\n    > div::before {\n      border-bottom: 0px !important;\n    }\n\n    textarea {\n      background-color: #fff;\n      color: #4d4d4d;\n      padding: 10px;\n      border-radius: 3px;\n      font-family: \'helvetica neue light\';\n      font-size: 14px;\n      box-sizing: border-box;\n    }    \n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  text-align: left;\n'],['\n  text-align: left;\n']),_templateObject6=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  background-color: #fff;\n  font-size: 12px;\n  padding: 5px;\n  color: #4d4d4d;\n  border-radius: 5px;\n  cursor: pointer;\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  background-color: #fff;\n  font-size: 12px;\n  padding: 5px;\n  color: #4d4d4d;\n  border-radius: 5px;\n  cursor: pointer;\n']),_templateObject7=_taggedTemplateLiteral(['\n  color: #fff;\n  background-color: ',';\n  margin: 20px 0 0 auto;\n  font-size: 16px;\n  padding: 10px 20px;\n  border-radius: 20px;\n  font-family: \'helvetica neue strong\';\n  border: 1px solid #fff;\n  box-shadow: 0px 1px 5px 2px ',';\n'],['\n  color: #fff;\n  background-color: ',';\n  margin: 20px 0 0 auto;\n  font-size: 16px;\n  padding: 10px 20px;\n  border-radius: 20px;\n  font-family: \'helvetica neue strong\';\n  border: 1px solid #fff;\n  box-shadow: 0px 1px 5px 2px ',';\n']),_templateObject8=_taggedTemplateLiteral(['\n  background-color: #F44336;\n  margin-top: 20px;\n  font-size: 16px;\n  text-align: center;\n  font-family: \'helvetica neue strong\';\n  color: #fff;\n  padding: 10px;\n'],['\n  background-color: #F44336;\n  margin-top: 20px;\n  font-size: 16px;\n  text-align: center;\n  font-family: \'helvetica neue strong\';\n  color: #fff;\n  padding: 10px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FormWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var InputName=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__["default"])(_templateObject2);var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].label(_templateObject3,function(props){return props.image?'0px':'30px 20px';},function(props){return props.color;});var InputDescription=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__["default"]).attrs({multiline:true,rows:4})(_templateObject4);var TagsWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var TagLabel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var BtnSubmit=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject7,function(props){return props.success?'#64DD17':props.color;},function(props){return props.color;});var ErrorLayer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1837);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components_FreeHtml__ = __webpack_require__(1838);
function mapStateToProps(state){return{actualStep:state.steps.step};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_FreeHtml__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_php__ = __webpack_require__(1839);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1840);
var FreeHtml=function FreeHtml(_ref){var html=_ref.html;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_2_utils_php__["a" ])(html)}});};FreeHtml.propTypes={html:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}; __webpack_exports__["a"] = (FreeHtml);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = rawurldecode;
function rawurldecode(str){//       discuss at: http://locutus.io/php/rawurldecode/
//      original by: Brett Zamir (http://brett-zamir.me)
//         input by: travc
//         input by: Brett Zamir (http://brett-zamir.me)
//         input by: Ratheous
//         input by: lovio
//      bugfixed by: Kevin van Zonneveld (http://kvz.io)
// reimplemented by: Brett Zamir (http://brett-zamir.me)
//      improved by: Brett Zamir (http://brett-zamir.me)
//           note 1: Please be aware that this function expects to decode
//           note 1: from UTF-8 encoded strings, as found on
//           note 1: pages served as UTF-8
//        example 1: rawurldecode('Kevin+van+Zonneveld%21')
//        returns 1: 'Kevin+van+Zonneveld!'
//        example 2: rawurldecode('http%3A%2F%2Fkvz.io%2F')
//        returns 2: 'http://kvz.io/'
//        example 3: rawurldecode('http%3A%2F%2Fwww.google.nl%2Fsearch%3Fq%3DLocutus%26ie%3D')
//        returns 3: 'http://www.google.nl/search?q=Locutus&ie='
return decodeURIComponent(str.replace(/%(?![\da-f]{2})/gi,function(){// PHP tolerates poorly formed escape sequences
return'%25';}));}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n'],['\n  width: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container_inputs__ = __webpack_require__(1842);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container_inputs__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components_Inputs__ = __webpack_require__(1843);
function mapStateToProps(){return{};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_Inputs__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_4_constants_apiConf__ = __webpack_require__(156);
 var __WEBPACK_IMPORTED_MODULE_5__Input__ = __webpack_require__(1844);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Inputs=function(_Component){_inherits(Inputs,_Component);function Inputs(props){_classCallCheck(this,Inputs);var _this=_possibleConstructorReturn(this,(Inputs.__proto__||Object.getPrototypeOf(Inputs)).call(this,props));_initialiseProps.call(_this);var values=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(props.values,function(value){return decodeURIComponent(value);});if(values.length>props.amount){values.splice(props.amount);}_this.state={values:values};return _this;}_createClass(Inputs,[{key:'componentDidUpdate',value:function componentDidUpdate(_ref){var prevValues=_ref.values;var values=this.props.values;if(JSON.stringify(values)!==JSON.stringify(prevValues)){var newValues=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(values,function(value){return decodeURIComponent(value);});this.setState({values:newValues});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.printInputs());}}]);return Inputs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleOnChange=function(index,value){var values=_this2.state.values;var _props=_this2.props,onChange=_props.onChange,onChangeAnswers=_props.onChangeAnswers;values[index]=value;_this2.setState({values:values});if(onChange){onChange(values);}if(onChangeAnswers){onChangeAnswers(values);}};this.handleBlur=function(){var values=_this2.state.values;var _props2=_this2.props,narrativeType=_props2.narrativeType,elementType=_props2.elementType;var params={narrativeType:narrativeType,type:elementType,name:values.join(__WEBPACK_IMPORTED_MODULE_4_constants_apiConf__["b" ]),delete_previous_answers:1};Object(__WEBPACK_IMPORTED_MODULE_3_utils_apiFetch__["b" ])('POST',{endPoint:'elements/connection'},params);};this.printInputs=function(){var _props3=_this2.props,amount=_props3.amount,placeholders=_props3.placeholders;var values=_this2.state.values;var inputs=[];var placeholder='';for(var i=0;i<amount;i+=1){placeholder=placeholders.length>i?placeholders[i]:'';var value=values.length>=i+1?values[i]:'';inputs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Input__["a" ],{key:i,id:i,onChange:_this2.handleOnChange,onBlur:_this2.handleBlur,placeholder:placeholder,value:value}));}return inputs;};};Inputs.propTypes={amount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,placeholders:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,values:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,narrativeType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,elementType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onChangeAnswers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,stepId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};Inputs.defaultProps={amount:1,placeholders:[],values:[],onChange:null,narrativeType:'',onChangeAnswers:null,stepId:0}; __webpack_exports__["a"] = (Inputs);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1845);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Inputs=function(_Component){_inherits(Inputs,_Component);function Inputs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Inputs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Inputs.__proto__||Object.getPrototypeOf(Inputs)).call.apply(_ref,[this].concat(args))),_this),_this.handleMouseDown=function(event){event.stopPropagation();},_this.onHandleChange=function(event){var _this$props=_this.props,id=_this$props.id,onChange=_this$props.onChange;var value=event.target.value;onChange(id,value);},_this.onHandleBlur=function(event){var _this$props2=_this.props,id=_this$props2.id,onBlur=_this$props2.onBlur;var value=event.target.value;if(onBlur){onBlur(id,value);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Inputs,[{key:'render',value:function render(){var _props=this.props,placeholder=_props.placeholder,value=_props.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" ],{type:'text',onChange:this.onHandleChange,onBlur:this.onHandleBlur,value:value,placeholder:placeholder,onMouseDown:this.handleMouseDown});}}]);return Inputs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Inputs.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Inputs.defaultProps={value:'',placeholder:'',onBlur:null}; __webpack_exports__["a"] = (Inputs);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return FormInput; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__ = __webpack_require__(68);
var _templateObject=_taggedTemplateLiteral(['\n  && {\n    width: calc(100% - 4em);\n    margin: 0 2em 20px;\n    border: 0px;\n\n    input {\n      background-color: #fff;\n      font-family: \'helvetica neue light\';\n      color: #4d4d4d;\n      font-size: 18px;\n      padding: 10px;\n      border-radius: 3px;\n    }    \n  }\n'],['\n  && {\n    width: calc(100% - 4em);\n    margin: 0 2em 20px;\n    border: 0px;\n\n    input {\n      background-color: #fff;\n      font-family: \'helvetica neue light\';\n      color: #4d4d4d;\n      font-size: 18px;\n      padding: 10px;\n      border-radius: 3px;\n    }    \n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FormInput=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ])(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__["default"])(_templateObject);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return NarrativeStepStyled; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return StepWidth; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return Title; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 2rem;\n  text-align: center;\n'],['\n  padding: 2rem;\n  text-align: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 80rem;\n  max-width: 100%;\n  margin: 0 auto;\n\n  ','\n\n  .carousel {\n    height: auto;\n  }\n'],['\n  width: 80rem;\n  max-width: 100%;\n  margin: 0 auto;\n\n  ','\n\n  .carousel {\n    height: auto;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n  }\n'],['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  font-size: 2rem;\n  color: #fff;\n  text-align: center;\n  margin-bottom: 2rem;\n  line-height: 2.8rem;\n\n  font-family: ',';\n  strong {\n    ','\n    color: rgb(255, 255, 255);\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n'],['\n  font-size: 2rem;\n  color: #fff;\n  text-align: center;\n  margin-bottom: 2rem;\n  line-height: 2.8rem;\n\n  font-family: ',';\n  strong {\n    ','\n    color: rgb(255, 255, 255);\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var NarrativeStepStyled=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var StepWidth=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.type==='faces'?'\n    .face_bubble {\n      opacity: 0.7;\n      transition: all 0.3s ease;\n      cursor: pointer;\n      width: clamp(10rem, calc(25% - 2rem), 30rem);\n      margin: 1rem;\n\n      &.selected {\n        opacity: 1;\n        transform: scale(1.1);\n      }\n    }\n  ':'';});var highlight=function highlight(backgroundColorText){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject3,backgroundColorText);};var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].semiBoldFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,function(props){return highlight(props.color);});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1848);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components_FinalStep__ = __webpack_require__(1849);
function mapStateToProps(state){return{literals:state.i18n.literals.finalStep||{},narrativesList:state.narratives.list};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_FinalStep__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_narratives_narrative_completed_svg__ = __webpack_require__(1850);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_narratives_narrative_completed_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_narratives_narrative_completed_svg__);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_narratives_bg_narrative_completed_svg__ = __webpack_require__(1851);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_narratives_bg_narrative_completed_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_narratives_bg_narrative_completed_svg__);
 var __WEBPACK_IMPORTED_MODULE_5_components_OngoingActivity__ = __webpack_require__(591);
 var __WEBPACK_IMPORTED_MODULE_6_components_ConfirmModal__ = __webpack_require__(181);
 var __WEBPACK_IMPORTED_MODULE_7_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_8_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(1866);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function FinalStep(props){var literals=props.literals,id=props.id,history=props.history,narrativesList=props.narrativesList;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showConfirmReset=_useState2[0],setShowConfirmReset=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isLoading=_useState4[0],setIsLoading=_useState4[1];var showResetModal=function showResetModal(){setShowConfirmReset(true);};var hideResetModal=function hideResetModal(){setShowConfirmReset(false);};var avoidDragMovement=function avoidDragMovement(event){event.stopPropagation();};var resetNarrative=function resetNarrative(){var endPoint='narrative/'+id+'/reset';setIsLoading(true);hideResetModal();Object(__WEBPACK_IMPORTED_MODULE_8_utils_apiFetch__["b" ])('POST',{endPoint:endPoint}).then(function(){history.push('/');history.push('/narratives/'+id);});};var goToHall=function goToHall(){history.push('/calls/'+id+'/hall');};var printResetConfirm=function printResetConfirm(){if(!showConfirmReset){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_ConfirmModal__["a" ],{onClose:hideResetModal,onAccept:resetNarrative,open:true,confirmText:literals.resetNarrative});};if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_LoadingComponent__["a" ],{colorAnimation:'#ffffff'});}var isPreEvent=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(narrativesList,{id:id,type:{id:21227760}})>=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,printResetConfirm(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'images'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_assets_images_narratives_bg_narrative_completed_svg___default.a,alt:'',className:'bg_completed_narrative'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_assets_images_narratives_narrative_completed_svg___default.a,alt:'',className:'img_completed_narrative'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title',dangerouslySetInnerHTML:{__html:literals.completedNarrative}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:showResetModal},literals.reset),isPreEvent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'secondary',onClick:goToHall},literals.goToHall):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ongoing_title',dangerouslySetInnerHTML:{__html:literals.joinOtherImpactObjectives}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onMouseDown:avoidDragMovement},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_OngoingActivity__["a" ],null))));}FinalStep.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,narrativesList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired}; __webpack_exports__["a"] = (FinalStep);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/narrative_completed.72da4aac.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg_narrative_completed.7927d307.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1853);
function mapStateToProps(state){return{app:state.app};}function mapDispatchToProps(dispatch){return{getOnGoingActivity:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_serendipity_actions__["c" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_4_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_5_components_Cards_NarrativeSmallCard__ = __webpack_require__(182);
 var __WEBPACK_IMPORTED_MODULE_6_components_Cards_ThinkSeedSmallCard__ = __webpack_require__(1854);
 var __WEBPACK_IMPORTED_MODULE_7_components_Cards_ElementSmallCard__ = __webpack_require__(1858);
 var __WEBPACK_IMPORTED_MODULE_8_components_Cards_SpeedDatingSmallCard__ = __webpack_require__(1862);
 var __WEBPACK_IMPORTED_MODULE_9_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_10_utils_string__ = __webpack_require__(67);
function OngoingActivity(props){var getOnGoingActivity=props.getOnGoingActivity,onChangeSlide=props.onChangeSlide,search=props.search,app=props.app;var serendipityItems=getOnGoingActivity();var defaultPosition=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(serendipityItems,function(item){return item.serendipityInfo.enabled;});var handleChangeSlide=function handleChangeSlide(slide){if(onChangeSlide){onChangeSlide(slide<defaultPosition?'past':'ongoing');}};var printCards=function printCards(){var validTypes=[__WEBPACK_IMPORTED_MODULE_9_constants_types__["h" ],__WEBPACK_IMPORTED_MODULE_9_constants_types__["b" ],__WEBPACK_IMPORTED_MODULE_9_constants_types__["j" ],__WEBPACK_IMPORTED_MODULE_9_constants_types__["l" ]];var filteredItems=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(serendipityItems,function(item){var name='';var description='';switch(item.serendipityInfo.type){case __WEBPACK_IMPORTED_MODULE_9_constants_types__["h" ]:name=item.name;description=item.description;break;case __WEBPACK_IMPORTED_MODULE_9_constants_types__["l" ]:name=item.name;description=item.description;break;case __WEBPACK_IMPORTED_MODULE_9_constants_types__["b" ]:name=item.name;description=item.description;break;case __WEBPACK_IMPORTED_MODULE_9_constants_types__["j" ]:name='Speed Dating';description=item.firstname+' '+item.lastname;break;default:break;}name=Object(__WEBPACK_IMPORTED_MODULE_10_utils_string__["d" ])(name.toLowerCase());description=Object(__WEBPACK_IMPORTED_MODULE_10_utils_string__["d" ])(description.toLowerCase());var s=Object(__WEBPACK_IMPORTED_MODULE_10_utils_string__["d" ])(search.toLowerCase());if(s!==''&&name.indexOf(s)===-1&&description.indexOf(s)===-1){return false;}return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(validTypes,function(type){return type===item.serendipityInfo.type;})>=0;});var className='ongoing_card';return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(filteredItems,function(item){switch(item.serendipityInfo.type){case __WEBPACK_IMPORTED_MODULE_9_constants_types__["h" ]:{var color=Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_3_utils_colors__["d" ])(item.section.color,15*item.section.position));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Cards_NarrativeSmallCard__["a" ],{key:item.id,data:item,color:color,classesList:className});}case __WEBPACK_IMPORTED_MODULE_9_constants_types__["l" ]:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Cards_ThinkSeedSmallCard__["a" ],{data:Object.assign({},item,{chatId:item.chat_id}),key:item.id,classesList:[className]});case __WEBPACK_IMPORTED_MODULE_9_constants_types__["b" ]:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Cards_ElementSmallCard__["a" ],{data:item,key:item.id,classesList:[className]});case __WEBPACK_IMPORTED_MODULE_9_constants_types__["j" ]:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Cards_SpeedDatingSmallCard__["a" ],{data:item,key:item.id,color:app.color1,classesList:[className],footer:true});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}});};if(!serendipityItems.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_SimpleCarousel__["a" ],{classesList:'ongoing_card',defaultPosition:defaultPosition,onChangeSlide:handleChangeSlide},printCards());}OngoingActivity.propTypes={getOnGoingActivity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onChangeSlide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,search:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};OngoingActivity.defaultProps={onChangeSlide:null,search:''}; __webpack_exports__["a"] = (OngoingActivity);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1855);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1856);
function mapStateToProps(state){return{literals:state.i18n.literals.thinkSeedSmallCard,itemsPreferencesFromSerendipity:state.serendipity.preferences};}function mapDispatchToProps(dispatch){return{enableItemFromSerendipity:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__["b" ],dispatch),disableItemFromSerendipity:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_components_Countdown__ = __webpack_require__(69);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Switch__ = __webpack_require__(97);
 var __WEBPACK_IMPORTED_MODULE_6_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_think_table_jpg__ = __webpack_require__(171);
 var __WEBPACK_IMPORTED_MODULE_7_assets_images_think_table_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_images_think_table_jpg__);
 var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1857);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function ThinkSeedSmallCard(props){var literals=props.literals,data=props.data,classesList=props.classesList,history=props.history,enableItemFromSerendipity=props.enableItemFromSerendipity,disableItemFromSerendipity=props.disableItemFromSerendipity,itemsPreferencesFromSerendipity=props.itemsPreferencesFromSerendipity;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(itemsPreferencesFromSerendipity,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_6_constants_types__["l" ]&&item.element_id===data.id&&!item.enabled;})),_useState2=_slicedToArray(_useState,2),enabled=_useState2[0],setEnabled=_useState2[1];var handleChangeEnabled=function handleChangeEnabled(){if(!enabled){enableItemFromSerendipity(__WEBPACK_IMPORTED_MODULE_6_constants_types__["l" ],data.id);}else{disableItemFromSerendipity(__WEBPACK_IMPORTED_MODULE_6_constants_types__["l" ],data.id);}setEnabled(!enabled);};var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),timeClick=_useState4[0],setTimeClick=_useState4[1];var handleClick=function handleClick(event){var diff=__WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf()-timeClick;if(diff<200&&!window.$(event.target).hasClass('MuiSwitch-input')){history.push('/theme-table/'+data.id);}};var handleMouseDown=function handleMouseDown(){setTimeClick(__WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf());};var style={backgroundImage:'url('+(data.image||__WEBPACK_IMPORTED_MODULE_7_assets_images_think_table_jpg___default.a)+')'};var classesStr=classesList.join(' ');if(!enabled){classesStr+=' disabled';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],{enabled:enabled,className:classesStr,onClick:handleClick,onMouseDown:handleMouseDown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header',style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.title),data&&typeof data.limit_date!=='undefined'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Countdown__["a" ],{time:data.limit_date}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,data.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Switch__["a" ],{checked:enabled,size:'small',onChange:handleChangeEnabled,name:'check_enabled',color:'primary'}))));}ThinkSeedSmallCard.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,enableItemFromSerendipity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,disableItemFromSerendipity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,itemsPreferencesFromSerendipity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,classesList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};ThinkSeedSmallCard.defaultProps={classesList:[],itemsPreferencesFromSerendipity:[]}; __webpack_exports__["a"] = (ThinkSeedSmallCard);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ThinkSeedSmallCardWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  width: 15rem;\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  overflow: hidden;\n  cursor: pointer;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n\n  .header {\n    height: 14.7rem;\n    background-size: cover;\n    background-color: #eee;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    position: relative;\n\n    .opacity {\n      position: absolute;\n      background-color: rgba(0, 0, 0, 0.47);\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 1;\n      border-radius: 1.5rem 1.5rem 0 0;\n    }\n\n    .title {\n      position: relative;\n      z-index: 2;\n      padding: 1rem;\n      font-family: ',';\n      font-size: 1.3rem;\n      color: #fff;\n    }\n\n    .countdown {\n<<<<<<< HEAD:src/components/Cards/ThinkSeedSmallCard/components/styles.js\n=======\n      font-family: ',';\n>>>>>>> searchStep:src/components/ThinkSeedSmallCard/components/styles.js\n      font-size: 1.5rem;\n      padding: 0 1rem;\n      position: relative;\n      z-index: 3;\n    }\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n  }\n\n  .body {\n    background-color: #fff;\n    padding: 1rem;\n\n    > div {\n      color: ',';\n      font-family: ',';\n      font-size: 1.6rem;\n      line-height: 1.9rem;\n      white-space: normal;\n      height: 4.95rem;\n      overflow: hidden;\n    }\n  }\n\n  .footer {\n    background-color: #fff;\n  }\n'],['\n  width: 15rem;\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  overflow: hidden;\n  cursor: pointer;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n\n  .header {\n    height: 14.7rem;\n    background-size: cover;\n    background-color: #eee;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    position: relative;\n\n    .opacity {\n      position: absolute;\n      background-color: rgba(0, 0, 0, 0.47);\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 1;\n      border-radius: 1.5rem 1.5rem 0 0;\n    }\n\n    .title {\n      position: relative;\n      z-index: 2;\n      padding: 1rem;\n      font-family: ',';\n      font-size: 1.3rem;\n      color: #fff;\n    }\n\n    .countdown {\n<<<<<<< HEAD:src/components/Cards/ThinkSeedSmallCard/components/styles.js\n=======\n      font-family: ',';\n>>>>>>> searchStep:src/components/ThinkSeedSmallCard/components/styles.js\n      font-size: 1.5rem;\n      padding: 0 1rem;\n      position: relative;\n      z-index: 3;\n    }\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n  }\n\n  .body {\n    background-color: #fff;\n    padding: 1rem;\n\n    > div {\n      color: ',';\n      font-family: ',';\n      font-size: 1.6rem;\n      line-height: 1.9rem;\n      white-space: normal;\n      height: 4.95rem;\n      overflow: hidden;\n    }\n  }\n\n  .footer {\n    background-color: #fff;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ThinkSeedSmallCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1859);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1860);
function mapStateToProps(state){return{literals:state.i18n.literals.elementSmallCard,itemsPreferencesFromSerendipity:state.serendipity.preferences};}function mapDispatchToProps(dispatch){return{enableItemFromSerendipity:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__["b" ],dispatch),disableItemFromSerendipity:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Switch__ = __webpack_require__(97);
 var __WEBPACK_IMPORTED_MODULE_5_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1861);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function ElementSmallCard(props){var literals=props.literals,data=props.data,classesList=props.classesList,history=props.history,enableItemFromSerendipity=props.enableItemFromSerendipity,disableItemFromSerendipity=props.disableItemFromSerendipity,itemsPreferencesFromSerendipity=props.itemsPreferencesFromSerendipity;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(itemsPreferencesFromSerendipity,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_5_constants_types__["b" ]&&item.element_id===data.id&&!item.enabled;})),_useState2=_slicedToArray(_useState,2),enabled=_useState2[0],setEnabled=_useState2[1];var handleChangeEnabled=function handleChangeEnabled(){if(!enabled){enableItemFromSerendipity(__WEBPACK_IMPORTED_MODULE_5_constants_types__["b" ],data.id);}else{disableItemFromSerendipity(__WEBPACK_IMPORTED_MODULE_5_constants_types__["b" ],data.id);}setEnabled(!enabled);};var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),timeClick=_useState4[0],setTimeClick=_useState4[1];var handleClick=function handleClick(event){var diff=__WEBPACK_IMPORTED_MODULE_3_moment___default()().valueOf()-timeClick;if(diff<200&&!window.$(event.target).hasClass('MuiSwitch-input')){history.push('/elements/'+data.id);}};var handleMouseDown=function handleMouseDown(){setTimeClick(__WEBPACK_IMPORTED_MODULE_3_moment___default()().valueOf());};var style={};if(data.image){style.backgroundImage='url('+data.image+')';}var classesStr=classesList.join(' ');if(!enabled){classesStr+=' disabled';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],{className:classesStr,onClick:handleClick,onMouseDown:handleMouseDown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header',style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals[data.type]||data.type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,data.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Switch__["a" ],{checked:enabled,size:'small',onChange:handleChangeEnabled,name:'check_enabled',color:'primary'}))));}ElementSmallCard.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,enableItemFromSerendipity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,disableItemFromSerendipity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,itemsPreferencesFromSerendipity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,classesList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};ElementSmallCard.defaultProps={classesList:[],itemsPreferencesFromSerendipity:[]}; __webpack_exports__["a"] = (ElementSmallCard);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ElementSmallCardWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  width: 15rem;\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  overflow: hidden;\n  cursor: pointer;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n\n  .header {\n    height: 14.7rem;\n    background-size: cover;\n    background-color: #eee;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    position: relative;\n\n    .opacity {\n      position: absolute;\n      background-color: rgba(0, 0, 0, 0.47);\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 1;\n      border-radius: 1.5rem 1.5rem 0 0;\n    }\n\n    .title {\n      position: relative;\n      z-index: 2;\n      padding: 1rem;\n      font-family: ',';\n      font-size: 1.3rem;\n      color: #fff;\n    }\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n  }\n\n  .body {\n    background-color: #fff;\n    padding: 1rem;\n\n    > div {\n      color: ',';\n      font-family: ',';\n      font-size: 1.6rem;\n      line-height: 1.9rem;\n      white-space: normal;\n      height: 4.95rem;\n      overflow: hidden;\n    }\n  }\n\n  .footer {\n    background-color: #fff;\n  }\n'],['\n  width: 15rem;\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  overflow: hidden;\n  cursor: pointer;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n\n  .header {\n    height: 14.7rem;\n    background-size: cover;\n    background-color: #eee;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    position: relative;\n\n    .opacity {\n      position: absolute;\n      background-color: rgba(0, 0, 0, 0.47);\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 1;\n      border-radius: 1.5rem 1.5rem 0 0;\n    }\n\n    .title {\n      position: relative;\n      z-index: 2;\n      padding: 1rem;\n      font-family: ',';\n      font-size: 1.3rem;\n      color: #fff;\n    }\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n  }\n\n  .body {\n    background-color: #fff;\n    padding: 1rem;\n\n    > div {\n      color: ',';\n      font-family: ',';\n      font-size: 1.6rem;\n      line-height: 1.9rem;\n      white-space: normal;\n      height: 4.95rem;\n      overflow: hidden;\n    }\n  }\n\n  .footer {\n    background-color: #fff;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ElementSmallCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1863);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1864);
function mapStateToProps(state){return{literals:state.i18n.literals.speedDatingCard,itemsPreferencesFromSerendipity:state.serendipity.preferences};}function mapDispatchToProps(dispatch){return{enableItemFromSerendipity:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__["b" ],dispatch),disableItemFromSerendipity:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_serendipity_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Switch__ = __webpack_require__(97);
 var __WEBPACK_IMPORTED_MODULE_6_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1865);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function SpeedDatingSmallCard(props){var literals=props.literals,onMouseDown=props.onMouseDown,classesStr=props.classesStr,data=props.data,color=props.color,history=props.history,footer=props.footer,enableItemFromSerendipity=props.enableItemFromSerendipity,disableItemFromSerendipity=props.disableItemFromSerendipity,itemsPreferencesFromSerendipity=props.itemsPreferencesFromSerendipity;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(itemsPreferencesFromSerendipity,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_6_constants_types__["j" ]&&item.element_id===data.id&&!item.enabled;})),_useState2=_slicedToArray(_useState,2),enabled=_useState2[0],setEnabled=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),timeClick=_useState4[0],setTimeClick=_useState4[1];var handleClick=function handleClick(event){var diff=__WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf()-timeClick;if(diff<200&&!window.$(event.target).hasClass('MuiSwitch-input')){history.push('/zoom-meeting/'+data.zoom_id);}};var handleMouseDown=function handleMouseDown(){setTimeClick(__WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf());if(onMouseDown){onMouseDown();}};var handleChangeEnabled=function handleChangeEnabled(){if(!enabled){enableItemFromSerendipity(__WEBPACK_IMPORTED_MODULE_6_constants_types__["j" ],data.id);}else{disableItemFromSerendipity(__WEBPACK_IMPORTED_MODULE_6_constants_types__["j" ],data.id);}setEnabled(!enabled);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" ],{className:classesStr,onClick:handleClick,onMouseDown:handleMouseDown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section_name',style:{color:color}},literals.meeting),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.speedDating)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'banner_speed_dating',style:{backgroundColor:color}},__WEBPACK_IMPORTED_MODULE_2_moment___default()(data.start_date,'X').format('MMMM DD,YYYY HH:mm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Avatar__["a" ],{size:18,avatar:data.avatar,firstname:data.firstname,id:data.id})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user_data'},data.firstname+' '+data.lastname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},footer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Switch__["a" ],{checked:enabled,size:'small',onChange:handleChangeEnabled,name:'check_enabled',color:'primary'})):null));}SpeedDatingSmallCard.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,classesStr:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onMouseDown:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,footer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};SpeedDatingSmallCard.defaultProps={classesStr:'',onMouseDown:null,footer:false}; __webpack_exports__["a"] = (SpeedDatingSmallCard);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return SpeedDatingCardWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: top;\n  background-color: #fff;\n  width: 15rem;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  cursor: pointer;\n  white-space: normal;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n\n  .header {\n    padding: 1rem;\n    .section_name {\n      font-size: 1.1rem;\n      margin-bottom: 0.5rem;\n    }\n    .title {\n      font-family: ',';\n      font-size: 1.6rem;\n      color: ',';\n      overflow: hidden;\n      height: 1.7rem;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .banner_speed_dating {\n    height: 9.4rem;\n    text-align: center;\n    display: grid;\n    grid-template-rows: 1fr;\n    align-items: start;\n    justify-items: center;\n    background-size: cover;\n    background-position: 50% 50%;\n    font-size: 1.7rem;\n    text-align: left;\n    padding: 1rem;\n    line-height: 2rem;\n    color: #fff;\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n\n    .banner_narrative {\n      filter: grayscale(100%);\n    }\n  }\n\n  .description {\n    padding: 1rem;\n    font-family: ',';\n    font-size: 1.3rem;\n    color: ',';\n    overflow: hidden;\n    height: 6rem;\n    line-height: 1.7rem;\n    margin-bottom: 1rem;\n\n    .user_img {\n      font-size: 1.1rem;\n      width: 2.2rem;\n      display: inline-block;\n      vertical-align: top;\n    }\n\n    .user_data {\n      font-size: 1.1rem;\n      line-height: 1.2rem;\n      width: calc(100% - 2.2rem);\n      display: inline-block;\n      vertical-align: top;\n      color: ',';\n    }\n  }\n\n  .footer {\n    white-space: nowrap;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n  }\n'],['\n  display: inline-block;\n  vertical-align: top;\n  background-color: #fff;\n  width: 15rem;\n  margin-right: 1rem;\n  border-radius: 1.5rem;\n  cursor: pointer;\n  white-space: normal;\n  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n  border: 0.1rem solid #e9e9e9;\n\n  .header {\n    padding: 1rem;\n    .section_name {\n      font-size: 1.1rem;\n      margin-bottom: 0.5rem;\n    }\n    .title {\n      font-family: ',';\n      font-size: 1.6rem;\n      color: ',';\n      overflow: hidden;\n      height: 1.7rem;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .banner_speed_dating {\n    height: 9.4rem;\n    text-align: center;\n    display: grid;\n    grid-template-rows: 1fr;\n    align-items: start;\n    justify-items: center;\n    background-size: cover;\n    background-position: 50% 50%;\n    font-size: 1.7rem;\n    text-align: left;\n    padding: 1rem;\n    line-height: 2rem;\n    color: #fff;\n  }\n\n  &.disabled {\n    .header {\n      filter: grayscale(100%);\n    }\n\n    .banner_narrative {\n      filter: grayscale(100%);\n    }\n  }\n\n  .description {\n    padding: 1rem;\n    font-family: ',';\n    font-size: 1.3rem;\n    color: ',';\n    overflow: hidden;\n    height: 6rem;\n    line-height: 1.7rem;\n    margin-bottom: 1rem;\n\n    .user_img {\n      font-size: 1.1rem;\n      width: 2.2rem;\n      display: inline-block;\n      vertical-align: top;\n    }\n\n    .user_data {\n      font-size: 1.1rem;\n      line-height: 1.2rem;\n      width: calc(100% - 2.2rem);\n      display: inline-block;\n      vertical-align: top;\n      color: ',';\n    }\n  }\n\n  .footer {\n    white-space: nowrap;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SpeedDatingCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return FinalStepWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
var _templateObject=_taggedTemplateLiteral(['\n  text-align: left;\n  position: relative;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n  width: 80rem;\n  max-width: 90%;\n  margin: 0 auto;\n\n  > .images {\n    text-align: center;\n    .bg_completed_narrative {\n      width: 31rem;\n    }\n\n    .img_completed_narrative {\n      width: 22rem;\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      top: 8rem;\n    }\n  }\n\n  > .title {\n    color: #fff;\n    font-size: 1.9rem;\n    line-height: 2rem;\n    font-family: ',';\n    margin-top: -6rem;\n\n    > b {\n      color: #fff;\n    }\n  }\n\n  > .ongoing_title {\n    color: #fff;\n    font-size: 1.9rem;\n    line-height: 2rem;\n    font-family: ',';\n    margin-top: 10rem;\n    margin-bottom: 2rem;\n\n    > b {\n      color: #fff;\n    }\n  }\n\n  .buttons {\n    margin-top: 2rem;\n    text-align: center;\n  }\n'],['\n  text-align: left;\n  position: relative;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n  width: 80rem;\n  max-width: 90%;\n  margin: 0 auto;\n\n  > .images {\n    text-align: center;\n    .bg_completed_narrative {\n      width: 31rem;\n    }\n\n    .img_completed_narrative {\n      width: 22rem;\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      top: 8rem;\n    }\n  }\n\n  > .title {\n    color: #fff;\n    font-size: 1.9rem;\n    line-height: 2rem;\n    font-family: ',';\n    margin-top: -6rem;\n\n    > b {\n      color: #fff;\n    }\n  }\n\n  > .ongoing_title {\n    color: #fff;\n    font-size: 1.9rem;\n    line-height: 2rem;\n    font-family: ',';\n    margin-top: 10rem;\n    margin-bottom: 2rem;\n\n    > b {\n      color: #fff;\n    }\n  }\n\n  .buttons {\n    margin-top: 2rem;\n    text-align: center;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FinalStepWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "c", function() { return NarrativeStyled; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return StepContent; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return Buttons; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  &.no_transition {\n    .step_content {\n      transition: none !important;\n    }\n  }\n\n  .overflow_step {\n    height: calc(100vh - 12rem);\n    overflow: hidden;\n  }\n'],['\n  &.no_transition {\n    .step_content {\n      transition: none !important;\n    }\n  }\n\n  .overflow_step {\n    height: calc(100vh - 12rem);\n    overflow: hidden;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  height: 100%;\n  transition: all 0.6s ease;\n  overflow: auto;\n  &.is_swiping {\n    transition: none;\n  }\n'],['\n  height: 100%;\n  transition: all 0.6s ease;\n  overflow: auto;\n  &.is_swiping {\n    transition: none;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  display: none;\n  position: relative;\n  @media (min-width: ','px) {\n    display: block;\n  }\n\n  > div {\n    padding: 10px 20px;\n    position: absolute;\n    font-size: 14px;\n    color: #fff;\n    border: 1px solid #fff;\n    border-radius: 40px;\n    cursor: pointer;\n    min-width: 120px;\n    text-align: center;\n\n    &:hover {\n      background-color: #fff;\n      color: ',';\n      transition: background-color 0.2s linear;\n    }\n  }\n\n  .prev_button {\n    left: 20px;\n\n    i {\n      margin-right: 5px;\n    }\n  }\n\n  .next_button {\n    right: 20px;\n\n    i {\n      margin-left: 5px;\n    }\n  }\n'],['\n  display: none;\n  position: relative;\n  @media (min-width: ','px) {\n    display: block;\n  }\n\n  > div {\n    padding: 10px 20px;\n    position: absolute;\n    font-size: 14px;\n    color: #fff;\n    border: 1px solid #fff;\n    border-radius: 40px;\n    cursor: pointer;\n    min-width: 120px;\n    text-align: center;\n\n    &:hover {\n      background-color: #fff;\n      color: ',';\n      transition: background-color 0.2s linear;\n    }\n  }\n\n  .prev_button {\n    left: 20px;\n\n    i {\n      margin-right: 5px;\n    }\n  }\n\n  .next_button {\n    right: 20px;\n\n    i {\n      margin-left: 5px;\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  height: 100%;\n'],['\n  height: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var NarrativeStyled=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var StepContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var Buttons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.color;});var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1869);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(1870);
 var __WEBPACK_IMPORTED_MODULE_4__modules_elements_actions__ = __webpack_require__(132);
function mapStateToProps(state){return{literals:state.i18n.literals.initiatives||{},element:state.elements.element};}function mapDispatchToProps(dispatch){return{getElementById:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4__modules_elements_actions__["b" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__components_Steps_FormElement__ = __webpack_require__(590);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1871);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ElementForm=function(_Component){_inherits(ElementForm,_Component);function ElementForm(){_classCallCheck(this,ElementForm);return _possibleConstructorReturn(this,(ElementForm.__proto__||Object.getPrototypeOf(ElementForm)).apply(this,arguments));}_createClass(ElementForm,[{key:'componentDidMount',value:function componentDidMount(){var id=this.props.match.params.id;var getElementById=this.props.getElementById;getElementById(parseInt(id,10));}},{key:'render',value:function render(){var _props=this.props,element=_props.element,literals=_props.literals;var data=literals.modifyChallenge;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" ],{color:'#173630',id:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["c" ],{maxFontSize:'28',dangerouslySetInnerHTML:{__html:data}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Steps_FormElement__["a" ],{color:'#173630',data:element,elementType:'challenge',narrativeType:'editElement'})));}}]);return ElementForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ElementForm.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,getElementById:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (ElementForm);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return CustomCardWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return CardBody; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return Title; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  border-radius: 4px;\n  width: 100%;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: stretch;  \n  height: 100%;\n  padding-left: 90px;\n  padding-right: 90px;\n\n  @media (max-width: ','px) {\n    max-height: 78vh;\n    overflow-y: none;\n    height: auto;\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n'],['\n  border-radius: 4px;\n  width: 100%;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: stretch;  \n  height: 100%;\n  padding-left: 90px;\n  padding-right: 90px;\n\n  @media (max-width: ','px) {\n    max-height: 78vh;\n    overflow-y: none;\n    height: auto;\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  order: 1;\n  flex-grow: 2;\n'],['\n  order: 1;\n  flex-grow: 2;\n']),_templateObject3=_taggedTemplateLiteral(['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n  }  \n'],['\n  from {\n    background-image: none;\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 0% 100%;\n  }\n  to {\n    color: ',';\n    background-image: linear-gradient(#fff, #fff);\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: 100% 100%;\n  }  \n']),_templateObject4=_taggedTemplateLiteral(['\n  color: ',';\n  line-height: ',';\n  font-size: ',';\n  font-family: \'helvetica neue light\';\n  padding-bottom: 5px;\n  text-align: center;\n  max-width: ',';\n  display: inline-block;\n  vertical-align: middle;\n  margin: 15px;\n\n  left: 0px;\n  right: 10px;\n  position: relative;\n  font-family: \'helvetica neue\';\n\n  strong {\n    font-family: \'helvetica neue\';\n    color: #173630;\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n'],['\n  color: ',';\n  line-height: ',';\n  font-size: ',';\n  font-family: \'helvetica neue light\';\n  padding-bottom: 5px;\n  text-align: center;\n  max-width: ',';\n  display: inline-block;\n  vertical-align: middle;\n  margin: 15px;\n\n  left: 0px;\n  right: 10px;\n  position: relative;\n  font-family: \'helvetica neue\';\n\n  strong {\n    font-family: \'helvetica neue\';\n    color: #173630;\n    font-weight: 600;\n    border-radius: 7px;\n    padding-left: 8px;\n    padding-right: 8px;\n    white-space: nowrap;\n    animation: 1s ease-out 0.5s 1 forwards ',';\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CustomCardWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var CardBody=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var highlight=function highlight(backgroundColorText){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" ])(_templateObject3,backgroundColorText);};var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,function(props){return props.color||'#fff';},function(props){return'min('+(props.maxFontSize+6)+'px, 22px + (24 - 22) * ((100vw - 320px) / (412 - 320)))';},function(props){return'min('+props.maxFontSize+'px, 16px + (18 - 16) * ((100vw - 320px) / (412 - 320)))';},function(props){return props.maxWidth;},function(props){return highlight(props.backgroundColorText);});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1873);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1874);
function mapStateToProps(state){return{actualContext:state.steps.context,specificStep:state.steps.specificStep};}function mapDispatchToProps(dispatch){return{getSpecificStep:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_steps_actions__["d" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_NarrativeStep__ = __webpack_require__(490);
 var __WEBPACK_IMPORTED_MODULE_3_components_LoadingComponent__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Step=function(_Component){_inherits(Step,_Component);function Step(){_classCallCheck(this,Step);return _possibleConstructorReturn(this,(Step.__proto__||Object.getPrototypeOf(Step)).apply(this,arguments));}_createClass(Step,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,_props$match$params=_props.match.params,idn=_props$match$params.idn,ids=_props$match$params.ids,getSpecificStep=_props.getSpecificStep;getSpecificStep(idn,ids);}},{key:'render',value:function render(){var _props2=this.props,specificStep=_props2.specificStep,actualContext=_props2.actualContext;if(!specificStep||!actualContext){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LoadingComponent__["a" ],{colorAnimation:'#ffffff'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_NarrativeStep__["a" ],{data:specificStep});}}]);return Step;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Step.propTypes={specificStep:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,actualContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,getSpecificStep:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};Step.defaultProps={specificStep:null,actualContext:null}; __webpack_exports__["a"] = (Step);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1876);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1877);
function mapStateToProps(state){return{literals:state.i18n.literals.themeTable||{},narratives:state.narratives.list};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_3_components_ThemeTableDetail__ = __webpack_require__(1878);
function ThemeTable(props){var literals=props.literals,setBreadcrumb=props.setBreadcrumb,_props$match$params=props.match.params,id=_props$match$params.id,section=_props$match$params.section,resetAll=props.resetAll,narratives=props.narratives;var paramId=parseInt(id,10);var callId=0;if(narratives){narratives.forEach(function(elem){if(elem.theme_tables.includes(paramId)){callId=elem.id;}});}// Breadcrumb
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var breadcrumb=[{type:'back'},{color:'#ffffff',text:literals.themeTable}];setBreadcrumb(breadcrumb.slice());resetAll();},[paramId]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_ThemeTableDetail__["a" ],{id:paramId,callId:callId,initSection:section,showBackButton:true});}ThemeTable.propTypes={literals:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (ThemeTable);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1879);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_store_globalState_global__ = __webpack_require__(12);
 var __WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__ = __webpack_require__(76);
 var __WEBPACK_IMPORTED_MODULE_5_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_6_modules_chats__ = __webpack_require__(41);
 var __WEBPACK_IMPORTED_MODULE_7_routes_Upgrade_modules_actions__ = __webpack_require__(484);
 var __WEBPACK_IMPORTED_MODULE_8__components__ = __webpack_require__(1880);
function mapStateToProps(state){return{literals:state.i18n.literals.themeTableDetail,actualUser:state.session.user,app:state.app,userElements:state.elements.selectedElements,narratives:state.narratives.list,myThinkChatsList:state.thinkChats.myThinkChatsList,proposedContent:state.thinkTanks.proposedContent};}function mapDispatchToProps(dispatch){return{showLoading:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_store_globalState_global__["c" ],dispatch),leaveThinkTank:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__["m" ],dispatch),proposeContent:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__["n" ],dispatch),getProposedContent:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_ThinkTanks_modules_actions__["h" ],dispatch),leaveThinkChat:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_think_seeds_actions__["i" ],dispatch),getMyThinkChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_think_seeds_actions__["b" ],dispatch),killThinkSeed:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7_routes_Upgrade_modules_actions__["a" ],dispatch),launchThinkTank:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_7_routes_Upgrade_modules_actions__["b" ],dispatch),killSeed:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_modules_chats__["h" ],dispatch),getChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_modules_chats__["e" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_8__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_components_FeedbackModal__ = __webpack_require__(78);
 var __WEBPACK_IMPORTED_MODULE_5_components_ConfirmModal__ = __webpack_require__(181);
 var __WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_7_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_think_default_jpg__ = __webpack_require__(1881);
 var __WEBPACK_IMPORTED_MODULE_8_assets_images_think_default_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_images_think_default_jpg__);
 var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Modal__ = __webpack_require__(37);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_no_results_svg__ = __webpack_require__(179);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_no_results_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_assets_images_no_results_svg__);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_ArrowBack_svg__ = __webpack_require__(135);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_ArrowBack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_images_ArrowBack_svg__);
 var __WEBPACK_IMPORTED_MODULE_12_utils_string__ = __webpack_require__(67);
 var __WEBPACK_IMPORTED_MODULE_13_components_ChatRoom__ = __webpack_require__(111);
 var __WEBPACK_IMPORTED_MODULE_14_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_15_components_Cards_ElementSimpleCard__ = __webpack_require__(265);
 var __WEBPACK_IMPORTED_MODULE_16_components_Cards_ContentSimpleCard__ = __webpack_require__(475);
 var __WEBPACK_IMPORTED_MODULE_17_components_Cards_NarrativeSmallCard__ = __webpack_require__(182);
 var __WEBPACK_IMPORTED_MODULE_18_assets_images_callIcon_svg__ = __webpack_require__(592);
 var __WEBPACK_IMPORTED_MODULE_18_assets_images_callIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_assets_images_callIcon_svg__);
 var __WEBPACK_IMPORTED_MODULE_19_components_ThinkSeedContributionForm__ = __webpack_require__(420);
 var __WEBPACK_IMPORTED_MODULE_20_components_ShareModal__ = __webpack_require__(486);
 var __WEBPACK_IMPORTED_MODULE_21_components_AddUsers__ = __webpack_require__(271);
 var __WEBPACK_IMPORTED_MODULE_22_components_Boost__ = __webpack_require__(1882);
 var __WEBPACK_IMPORTED_MODULE_23_components_Launch__ = __webpack_require__(1887);
 var __WEBPACK_IMPORTED_MODULE_24_components_Cards_ThemeTableCard__ = __webpack_require__(117);
 var __WEBPACK_IMPORTED_MODULE_25_components_Agenda__ = __webpack_require__(136);
 var __WEBPACK_IMPORTED_MODULE_26_components_Countdown__ = __webpack_require__(69);
 var __WEBPACK_IMPORTED_MODULE_27_components_Cards_UserSmallCard_components__ = __webpack_require__(134);
 var __WEBPACK_IMPORTED_MODULE_28_assets_images_think_paperbin_svg__ = __webpack_require__(261);
 var __WEBPACK_IMPORTED_MODULE_28_assets_images_think_paperbin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_assets_images_think_paperbin_svg__);
 var __WEBPACK_IMPORTED_MODULE_29_assets_images_think_editButton_svg__ = __webpack_require__(1894);
 var __WEBPACK_IMPORTED_MODULE_29_assets_images_think_editButton_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_assets_images_think_editButton_svg__);
 var __WEBPACK_IMPORTED_MODULE_30_assets_images_think_shareButton_svg__ = __webpack_require__(1895);
 var __WEBPACK_IMPORTED_MODULE_30_assets_images_think_shareButton_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_assets_images_think_shareButton_svg__);
 var __WEBPACK_IMPORTED_MODULE_31_assets_images_think_verticalDots_svg__ = __webpack_require__(1896);
 var __WEBPACK_IMPORTED_MODULE_31_assets_images_think_verticalDots_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_assets_images_think_verticalDots_svg__);
 var __WEBPACK_IMPORTED_MODULE_32_assets_images_think_horizontalDots_svg__ = __webpack_require__(1897);
 var __WEBPACK_IMPORTED_MODULE_32_assets_images_think_horizontalDots_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_assets_images_think_horizontalDots_svg__);
 var __WEBPACK_IMPORTED_MODULE_33_assets_images_grey_arrow_right_svg__ = __webpack_require__(240);
 var __WEBPACK_IMPORTED_MODULE_33_assets_images_grey_arrow_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_assets_images_grey_arrow_right_svg__);
 var __WEBPACK_IMPORTED_MODULE_34_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_35_constants_tables__ = __webpack_require__(110);
 var __WEBPACK_IMPORTED_MODULE_36_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_37_constants_roles__ = __webpack_require__(436);
 var __WEBPACK_IMPORTED_MODULE_38_utils_calls__ = __webpack_require__(183);
 var __WEBPACK_IMPORTED_MODULE_39__styles__ = __webpack_require__(1898);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function ThemeTableDetail(props){var id=props.id,actualUser=props.actualUser,userElements=props.userElements,literals=props.literals,showLoading=props.showLoading,app=props.app,leaveThinkChat=props.leaveThinkChat,initSection=props.initSection,history=props.history,callId=props.callId,narratives=props.narratives,myThinkChatsList=props.myThinkChatsList,leaveThinkTank=props.leaveThinkTank,getProposedContent=props.getProposedContent,proposedContent=props.proposedContent,getChats=props.getChats;var call=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(narratives,{id:callId});// Theme Table data
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),data=_useState2[0],setData=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('description'),_useState4=_slicedToArray(_useState3,2),selectedTab=_useState4[0],setSelectedTab=_useState4[1];var isInTable=function isInTable(){return actualUser&&data&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(data.users,{id:actualUser.id});};var showChatInLateral=function showChatInLateral(){if(!isInTable()){return false;}if(window.outerWidth<__WEBPACK_IMPORTED_MODULE_36_constants_breakPoints__["a" ]){return false;}return true;};// Errors
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),errors=_useState6[0],setErrors=_useState6[1];// Chat tab
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),isCollapsed=_useState8[0],setIsCollapsed=_useState8[1];var handleCollapseChat=function handleCollapseChat(){setIsCollapsed(!isCollapsed);};var removeErrors=function removeErrors(){setErrors([]);};var createTable=function createTable(){history.push(__WEBPACK_IMPORTED_MODULE_7_constants_urls__["Q" ]);};var printErrors=function printErrors(){if(!errors.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_FeedbackModal__["a" ],{onClose:removeErrors,open:true,success:false,text:errors.join('<br />')});};var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState10=_slicedToArray(_useState9,2),actualUserRecognizedTo=_useState10[0],setActualUserRecognizedTo=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState12=_slicedToArray(_useState11,2),proposedContentList=_useState12[0],setProposedContent=_useState12[1];// Load info
var loadInfo=function loadInfo(){var endPoint='theme-table/'+id;showLoading(true);Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["b" ])('GET',{endPoint:endPoint}).then(function(response){showLoading(false);setData(response);var actualUserData=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(response.users,{id:actualUser.id});var recognizedTo=actualUserData&&actualUserData.recognize_to?actualUserData.recognize_to:0;setActualUserRecognizedTo(recognizedTo);if(selectedTab==='description'&&response.type===__WEBPACK_IMPORTED_MODULE_35_constants_tables__["c" ]){setSelectedTab('insight');}}).catch(function(error){showLoading(false);errors.push(error.response.data.error);setErrors([].concat(_toConsumableArray(errors)));});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){loadInfo();getProposedContent(id);setProposedContent(proposedContent);},[id]);// Join table
var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState14=_slicedToArray(_useState13,2),showJoinButton=_useState14[0],setShowJoinButton=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),showJoinModal=_useState16[0],setShowJoinModal=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),showJoinRequestModal=_useState18[0],setShowJoinRequestModal=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),showLeaveModal=_useState20[0],setShowLeaveModal=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),inviteUsers=_useState22[0],setInviteUsers=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),showModalInviteFeedback=_useState24[0],setShowModalInviteFeedback=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),recognized=_useState26[0],setRecognized=_useState26[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(data){data.users.forEach(function(user){if((user.is_recognized||Object(__WEBPACK_IMPORTED_MODULE_37_constants_roles__["a" ])(actualUser.role)||data.creator_id===actualUser.id.toString()||data.creator_id===actualUser.id)&&actualUser.id===user.id){setRecognized(true);}});}},[data]);var joinTable=function joinTable(){setShowJoinModal(true);};var hideLeaveModal=function hideLeaveModal(){setShowLeaveModal(false);};var leaveTable=function leaveTable(){hideLeaveModal();leaveThinkChat(actualUser.id,data.chat_id);};var leaveModal=function leaveModal(){setShowLeaveModal(true);};var hideJoinModal=function hideJoinModal(){setShowJoinModal(false);};var hideJoinRequestModal=function hideJoinRequestModal(){setShowJoinRequestModal(false);};var stopPropagation=function stopPropagation(event){event.stopPropagation();};var confirmJoinTable=function confirmJoinTable(){setShowJoinModal(false);var endPoint='theme-table/'+id+'/join';showLoading(true);Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["b" ])('POST',{endPoint:endPoint}).then(function(){showLoading(false);setShowJoinButton(false);loadInfo();getChats();}).catch(function(error){showLoading(false);errors.push(error.response.data.error);setErrors([].concat(_toConsumableArray(errors)));});};var sendContributionsInThinkSeed=function sendContributionsInThinkSeed(contributions){var params={contributions:contributions.contributions.join(','),other:contributions.others};Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["b" ])('POST',{endPoint:'think-seed/'+id+'/contributions'},params);confirmJoinTable();};var printJoinModal=function printJoinModal(){if(!showJoinModal){return null;}var activeChats=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(myThinkChatsList,function(table){return table.status.id!==__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]&&table.type!==__WEBPACK_IMPORTED_MODULE_35_constants_tables__["c" ];}).length;if(activeChats>=10){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_FeedbackModal__["a" ],{open:true,success:false,onClose:hideJoinModal,text:literals.joinThinkSeedMore10});}var title=activeChats>=3?literals.joinThinkSeedMore3:literals.youAreAboutToJoinThinkSeed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Modal__["a" ],{open:true,onClose:hideJoinModal,'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',style:{zIndex:1110000}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["j" ],{style:{backgroundColor:'#f1f1f1'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_ThinkSeedContributionForm__["a" ],{title:title,onCancel:hideJoinModal,onClick:sendContributionsInThinkSeed})));};var printJoinRequestModal=function printJoinRequestModal(){if(!showJoinRequestModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_FeedbackModal__["a" ],{onClose:hideJoinRequestModal,open:true,success:true,text:literals.joinRequestSuccessfull});};var printLeaveModal=function printLeaveModal(){if(!showLeaveModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ConfirmModal__["a" ],{onAccept:leaveTable,onClose:hideLeaveModal,open:true,confirmText:literals.confirmLeaveTable}));};var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),showModalShare=_useState28[0],setShowModalShare=_useState28[1];var handleCloseModalShare=function handleCloseModalShare(){setShowModalShare(false);};var handleOpenModalShare=function handleOpenModalShare(){setShowModalShare(true);};var printShareModal=function printShareModal(){if(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_ShareModal__["a" ],{open:showModalShare,docUrl:window.location.href,onClose:handleCloseModalShare});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);};// Select users
var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState30=_slicedToArray(_useState29,2),selectedUser=_useState30[0],setSelectedUser=_useState30[1];var removeSelectedUser=function removeSelectedUser(){setSelectedUser(null);};var handleClickUserBubble=function handleClickUserBubble(userId){var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(data.users,{id:userId});setSelectedUser(user);};var usersModalMemo=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!selectedUser){return null;}var usersIds=[];data.users.forEach(function(tmpUser){if(tmpUser.id!==actualUser.id){usersIds.push(tmpUser.id);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_components_UsersModal__["a" ],{usersIds:usersIds,userSelected:selectedUser.id,onEnd:removeSelectedUser});},[selectedUser]);var printSelectedUser=function printSelectedUser(){if(!selectedUser){return null;}return usersModalMemo;};var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),killModal=_useState32[0],setKillModal=_useState32[1];var showKillModal=function showKillModal(){setKillModal(true);};var hideKillModal=function hideKillModal(){setKillModal(false);};var killSeed=function killSeed(){var killThinkSeed=props.killThinkSeed,getMyThinkChats=props.getMyThinkChats;hideKillModal();if(data.creator_id===actualUser.id.toString()||recognized){killThinkSeed(data.id).then(function(){getMyThinkChats();history.push('/think');});}};var printKillModal=function printKillModal(){if(!killModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ConfirmModal__["a" ],{onAccept:killSeed,onClose:hideKillModal,open:true,confirmText:literals.confirmKillTable}));};var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),launchModal=_useState34[0],setLaunchModal=_useState34[1];var handleClickLaunch=function handleClickLaunch(){setLaunchModal(true);};var handleCloseLaunch=function handleCloseLaunch(){setLaunchModal(false);};var launchSeed=function launchSeed(){if(launchModal){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_Launch__["a" ],{data:data,history:history,user:actualUser,close:handleCloseLaunch});}return null;};// Boost
var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),boostModal=_useState36[0],setBoostModal=_useState36[1];var handleOpenBoostModal=function handleOpenBoostModal(){setBoostModal(true);};var handleCloseBoostModal=function handleCloseBoostModal(){setBoostModal(false);};var boostSeed=function boostSeed(){if(boostModal){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_Boost__["a" ],{close:handleCloseBoostModal,elementType:'think_chat',elementId:data.chat_id});}return null;};var handleInvite=function handleInvite(selectedUsers){var usersIds=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(selectedUsers,function(user){return user.id;});Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["b" ])('POST',{endPoint:'/think-seed/'+data.id+'/invitations'},{users:usersIds.join(',')}).then(function(){setShowModalInviteFeedback(true);});};var closeInvitationsFeedbackModal=function closeInvitationsFeedbackModal(){setShowModalInviteFeedback(false);};var handleClickCloseInvite=function handleClickCloseInvite(){setInviteUsers(false);};var handleClickOpenInvite=function handleClickOpenInvite(){setInviteUsers(true);};var printUsersInvitation=function printUsersInvitation(){if(!inviteUsers){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'invite_users_tab_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_AddUsers__["a" ],{onCancel:handleClickCloseInvite,onInvite:handleInvite,excludedUsers:data.users.map(function(user){return user.id;})}));};// Tabs
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(initSection){var tab=initSection==='chat'&&(showChatInLateral()||!isInTable())?'description':initSection;setSelectedTab(tab);}},[initSection]);var selectTab=function selectTab(event){var currentTarget=event.currentTarget;var section=currentTarget.getAttribute('data-section');if(section==='chat'){setTimeout(function(){var listMessages=document.getElementById('list_messages');if(listMessages){var scroll=listMessages.clientHeight;if(scroll>0){document.getElementById('chat_messages').scroll(0,scroll);}}});}setSelectedTab(section);};var printTabs=function printTabs(){if(!isInTable()){return null;}var tabsName=[];if(data.type!==__WEBPACK_IMPORTED_MODULE_35_constants_tables__["c" ]){tabsName.push('description');}tabsName.push('insight');if(!showChatInLateral()){tabsName.push('chat');}var tabs=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tabsName,function(tab,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'tab '+(selectedTab===tab?'selected':''),'data-section':tab,onClick:selectTab},literals[tab]);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs inline'},tabs,isCollapsed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'expand',onClick:handleCollapseChat},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_33_assets_images_grey_arrow_right_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.chat))));};// Count down
var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState38=_slicedToArray(_useState37,2),remainingTime=_useState38[0],setRemainingTime=_useState38[1];var toCountDown=null;var calculateCountdown=function calculateCountdown(){if(data&&typeof data.limit_date!=='undefined'&&__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix()<=data.limit_date){var limitDate=__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(data.limit_date);var difference=__WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(limitDate.diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()()));setRemainingTime({days:difference.get('days'),hours:difference.get('hours'),minutes:difference.get('minutes'),seconds:difference.get('seconds')});toCountDown=setTimeout(calculateCountdown,1000);}else{setRemainingTime(null);}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){calculateCountdown();return function(){if(toCountDown){clearTimeout(toCountDown);}};},[data]);var printCountdown=function printCountdown(){if(!remainingTime){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'countdown',style:{color:'#FFA200',zIndex:'2'}},remainingTime.days>0&&remainingTime.days+' days ',remainingTime.hours>0&&remainingTime.hours+' hours ',remainingTime.minutes>0&&(remainingTime.days==='0'||remainingTime.days>0&&remainingTime.hours==='0')&&remainingTime.minutes+' minutes ',(remainingTime.hours==='0'||remainingTime.days>0&&remainingTime.hours==='0'&&remainingTime.minutes==='0')&&remainingTime.seconds+' seconds');};var _useState39=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState40=_slicedToArray(_useState39,2),usersIn=_useState40[0],setUsersIn=_useState40[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(data){setUsersIn(data.users);}},[data]);var handleVoteUp=function handleVoteUp(event){var voteTo=parseInt(event.currentTarget.getAttribute('data-user'),10);setActualUserRecognizedTo(voteTo);var endPoint='think-seed/'+id+'/leader/'+voteTo;Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["b" ])('POST',{endPoint:endPoint}).then(function(res){var usersAux=usersIn;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(res.data,function(user){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(usersAux,function(aUsers,key){if(user.id===aUsers.id){usersAux[key].is_recognized=user.recognized;}});});setUsersIn(usersAux);});event.stopPropagation();};var _useState41=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState42=_slicedToArray(_useState41,2),userToDelete=_useState42[0],setUserToDelete=_useState42[1];var _useState43=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState44=_slicedToArray(_useState43,2),deleteUserModal=_useState44[0],setDeleteUserModal=_useState44[1];var deleteC=function deleteC(){if(userToDelete&&recognized){var params={id:data.id,user_id:userToDelete};Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["b" ])('POST',{endPoint:'theme-table/'+id+'/user/'+userToDelete},params).then(function(){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(data.users,{id:userToDelete});setData(Object.assign({},data));});setDeleteUserModal(false);}};var openDeleteUserModal=function openDeleteUserModal(userId){if(!deleteUserModal){setUserToDelete(userId);}setDeleteUserModal(!deleteUserModal);};var printDeleteUserModal=function printDeleteUserModal(){if(!deleteUserModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ConfirmModal__["a" ],{onAccept:deleteC,onClose:openDeleteUserModal,open:true,confirmText:literals.deleteUser}));};var goBack=function goBack(){history.goBack();};var handleClickReStart=function handleClickReStart(){history.push(Object(__WEBPACK_IMPORTED_MODULE_38_utils_calls__["a" ])(call));};var handleHallClick=function handleHallClick(){history.push('/calls/'+call.id+'/hall');};var openEditButton=function openEditButton(){history.push('/think-seed/'+id+'/edit');};var _useState45=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState46=_slicedToArray(_useState45,2),options=_useState46[0],setOptions=_useState46[1];var handleClickOptions=function handleClickOptions(){setOptions(!options);};var deleteTable=function deleteTable(){var getMyThinkChats=props.getMyThinkChats;var endPoint='theme-table/'+data.id;showLoading(true);Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["b" ])('DELETE',{endPoint:endPoint}).then(function(){getMyThinkChats();history.push('/think');});showLoading(false);};var _useState47=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState48=_slicedToArray(_useState47,2),deleteTableModal=_useState48[0],setDeleteTableModal=_useState48[1];var handleTableModal=function handleTableModal(){setDeleteTableModal(!deleteTableModal);};var printDeleteTableModal=function printDeleteTableModal(){if(!deleteTableModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ConfirmModal__["a" ],{onAccept:deleteTable,onClose:handleTableModal,open:true,confirmText:literals.deleteTable}));};var printOptionsModal=function printOptionsModal(){if(!options){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["n" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'edit',onClick:openEditButton},'Edit'),data.status.id!==__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'boost',onClick:handleOpenBoostModal},'Boost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'launch',onClick:handleClickLaunch},'Launch'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'killButton',onClick:showKillModal},'Kill'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'delete',onClick:handleTableModal},'Delete')):null);};var printDescriptionTab=function printDescriptionTab(){var topics=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.related_elements,function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:element.id,className:'tag gray '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(userElements,{id:element.id})?'selected':'')},element.name);});var mainElement=app.main_element||'relation_co';var mainElementsInfo=[];var canManageTable=false;var dateEvent=null;if(call){var now=Math.floor(new Date().getTime()/1000);dateEvent=call.time_limit;var changed=false;if(dateEvent<now&&data){if(data.enable_thinkchats_meeting&&data.think_chats_meeting_date>now&&!changed){changed=true;dateEvent=data.think_chats_meeting_date;}if(data.enable_speed_dating&&data.speed_dating_date>now&&!changed){changed=true;dateEvent=data.speed_dating_date;}if(data.enable_conclusion_meeting&&data.conclusiones_meeting_date>now&&!changed){changed=true;dateEvent=data.conclusiones_meeting_date;}}}__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(usersIn,function(user){if(typeof user.elements!=='undefined'&&typeof user.elements[mainElement]!=='undefined'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(user.elements[mainElement],function(element){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(mainElementsInfo,{id:element.id})){mainElementsInfo.push(element);}});}if(user.id===actualUser.id&&(user.is_recognized||Object(__WEBPACK_IMPORTED_MODULE_37_constants_roles__["a" ])(actualUser.role))){canManageTable=true;}});var content=inviteUsers?printUsersInvitation():__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["g" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["a" ],{onClick:createTable},'+')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grid_info'},data.description?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},data.description):null,topics&&topics.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,topics):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lists'},data&&(data.meetings.length||data.speed_datings.length)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_Agenda__["a" ],{meetings:data.meetings,speedDatings:data.speed_datings})):null,mainElementsInfo&&mainElementsInfo.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},mainElementsInfo.length),literals.elements[mainElement]||Object(__WEBPACK_IMPORTED_MODULE_12_utils_string__["a" ])(app.main_element))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SimpleCarousel__["a" ],{classesList:'element_main_card'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(mainElementsInfo,function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Cards_ElementSimpleCard__["a" ],{key:element.id,data:element,classesList:['element_main_card']});}))):null,data&&data.users&&data.users.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},data.users.length),literals.people,isInTable()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button_header',onClick:handleClickOpenInvite},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_button_header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'placeholder_button_header'},literals.invite)):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SimpleCarousel__["a" ],{classesList:'user_wrapper'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.users,function(user){var buttonVoteUp=null;if(isInTable()&&user.id!==actualUser.id){if(actualUserRecognizedTo===user.id){buttonVoteUp=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'voted',onClick:stopPropagation},literals.voted);}else{buttonVoteUp=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn-sm',onClick:handleVoteUp,'data-user':user.id},literals.voteup);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_Cards_UserSmallCard_components__["a" ],{key:user.id,onClick:function onClick(){return handleClickUserBubble(user.id);},user:user,tags:user.contributions,literals:literals,buttonVoteUp:buttonVoteUp,recognized:recognized||data.creator_id===actualUser.id.toString(),actualUser:actualUser,'data-user':user.id,onDelete:openDeleteUserModal});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaveTable'},isInTable()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["l" ],{onClick:leaveModal},literals.leaveTable)))):null),!isInTable()&&showJoinButton?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["k" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary btn_join_sm',style:{display:'flex',marginTop:'2rem'},onClick:joinTable},literals.joinThisTable)):null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["h" ],{image:data.image_big||__WEBPACK_IMPORTED_MODULE_8_assets_images_think_default_jpg___default.a},call&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'callInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-arrow-left',onClick:goBack})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_18_assets_images_callIcon_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},call.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live_event'},dateEvent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date'},literals.liveEvent+': '+__WEBPACK_IMPORTED_MODULE_3_moment___default()(dateEvent,'X').format('DD/MM/YYYY')):null),dateEvent&&dateEvent>__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'starting'},literals.startingAt,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_Countdown__["a" ],{time:dateEvent,enabled:true})):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'sec_button',onClick:handleClickReStart},literals.reView),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'main_button',onClick:handleHallClick},literals.eventHall))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'curtain'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table_card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_Cards_ThemeTableCard__["a" ],{data:data,key:data.id,app:app,user:actualUser,hideInfo:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},data.name),data.status.id!==__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]&&remainingTime?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'countdown'},literals.ending,printCountdown()):null,recognized&&data.status.id!==__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data_buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'boost',onClick:handleOpenBoostModal},literals.boost),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'launch',onClick:handleClickLaunch},literals.launch)):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top_buttons'},recognized&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'rounded',onClick:handleTableModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_28_assets_images_think_paperbin_svg___default.a,alt:'',className:'paperbin'})),data.status.id!==__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'rounded',onClick:handleOpenModalShare},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_30_assets_images_think_shareButton_svg___default.a,alt:'',className:'share'})):null,recognized&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'rounded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_29_assets_images_think_editButton_svg___default.a,alt:'',className:'edit',onClick:openEditButton})),recognized&&!options&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'phone_rounded',onClick:handleClickOptions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_31_assets_images_think_verticalDots_svg___default.a,alt:'',className:'dots'})),recognized&&options&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'phone_rounded',onClick:handleClickOptions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_32_assets_images_think_horizontalDots_svg___default.a,alt:'',className:'dots'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'phone_rounded',onClick:handleOpenModalShare},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_30_assets_images_think_shareButton_svg___default.a,alt:'',className:'share'}))),printOptionsModal(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom_buttons'},recognized&&data.status.id!==__WEBPACK_IMPORTED_MODULE_35_constants_tables__["b" ]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'kill',onClick:showKillModal},literals.kill):null))),content);};var _useState49=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState50=_slicedToArray(_useState49,2),addContent=_useState50[0],setAddContent=_useState50[1];var _useState51=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState52=_slicedToArray(_useState51,2),contentType=_useState52[0],setContentType=_useState52[1];var _useState53=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState54=_slicedToArray(_useState53,2),form=_useState54[0],setForm=_useState54[1];var setSelectedType=function setSelectedType(event){var currentTarget=event.currentTarget;var section=currentTarget.getAttribute('data-stage');setContentType(section);};var _useState55=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState56=_slicedToArray(_useState55,2),name=_useState56[0],setName=_useState56[1];var _useState57=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState58=_slicedToArray(_useState57,2),desc=_useState58[0],setDesc=_useState58[1];var _useState59=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState60=_slicedToArray(_useState59,2),url=_useState60[0],setUrl=_useState60[1];var _useState61=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState62=_slicedToArray(_useState61,2),file=_useState62[0],setFile=_useState62[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(proposedContent!==[]){setProposedContent(proposedContent);}},[proposedContent]);var submitForm=function submitForm(){if(file!==null&&isInTable()){var proposeContent=props.proposeContent;showLoading(true);Object(__WEBPACK_IMPORTED_MODULE_6_utils_apiFetch__["c" ])(file,'file').then(function(response){var params={name:name,description:desc,type:contentType,related_type:data.type,related_id:id,info:response.info.url,info_name:file.name,info_type:file.type,user_id:actualUser.id};proposeContent(params).then(function(){getProposedContent(id);});setAddContent(false);setContentType(null);setForm(false);showLoading(false);setName(null);setFile(null);setDesc(null);});}if(url!==null&&isInTable()){var _proposeContent=props.proposeContent;showLoading(true);var params={name:name,description:desc,type:contentType,related_type:data.type,related_id:id,info:url,user_id:actualUser.id};_proposeContent(params).then(function(){getProposedContent(id);});setAddContent(false);setContentType(null);setForm(false);getProposedContent();showLoading(false);setName(null);setFile(null);setDesc(null);setUrl(null);}};var handleChangeName=function handleChangeName(event){setName(event.target.value);};var handleChangeDesc=function handleChangeDesc(event){setDesc(event.target.value);};var handleChangeFile=function handleChangeFile(event){setFile(event.target.files[0]);};var handleChangeUrl=function handleChangeUrl(event){setUrl(event.target.value);};var printForm=function printForm(){if(form){if(contentType==='referral'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Name',value:name,onChange:handleChangeName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Description',value:desc,onChange:handleChangeDesc}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Link',value:url,onChange:handleChangeUrl}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{onClick:submitForm,cont:url!=null},literals.prop));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Name',value:name,onChange:handleChangeName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Description',value:desc,onChange:handleChangeDesc}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'upload-content',className:'input'},file?file.name:literals.attach,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-paperclip'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',placeholder:'Content',id:'upload-content',style:{opacity:0},onChange:handleChangeFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{onClick:submitForm,cont:file!=null},literals.prop));}return null;};var setFormShow=function setFormShow(){if(contentType!==null){setForm(true);}};var printSelectProposeContent=function printSelectProposeContent(){if(!addContent||form){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.whatType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["c" ],{selected:contentType==='referral',margin:'1rem',onClick:setSelectedType,'data-stage':'referral'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-link'}),literals.referral),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["c" ],{selected:contentType==='attach',margin:'1rem',onClick:setSelectedType,'data-stage':'attach'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-paperclip'}),literals.attach),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["b" ],{cont:contentType!==null,onClick:setFormShow},literals.next));};var setAddContentShow=function setAddContentShow(){setAddContent(true);setForm(false);};var handleGoBack=function handleGoBack(){setAddContent(false);setForm(false);};var openDoc=function openDoc(){var urlDoc='https://docs.google.com/document/d/'+data.conclusions_document_id+'/edit?usp=sharing';window.open(urlDoc);};var reloadContent=function reloadContent(){getProposedContent(id);};var _useState63=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState64=_slicedToArray(_useState63,2),showEntireContent=_useState64[0],setShowEntireContent=_useState64[1];var handleShowEntireContent=function handleShowEntireContent(){setShowEntireContent(true);};var printGoBack=function printGoBack(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["p" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_create'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_assets_images_ArrowBack_svg___default.a,alt:'',onClick:handleGoBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.addContent)));};var printContentTab=function printContentTab(){if(!isInTable()||selectedTab!=='insight'||!data.conclusions_document_id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_elements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_10_assets_images_no_results_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.noContent));}var urlDoc='https://docs.google.com/document/d/'+data.conclusions_document_id+'/edit?usp=sharing&overridemobile=true&fd=true&rm=minimal&headers=false';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,addContent&&printGoBack(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["e" ],null,proposedContent&&!addContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},proposedContent.length),literals.proposedContent,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button_header',onClick:setAddContentShow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_button_header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'placeholder_button_header'},literals.attachContentToTable)))),proposedContent.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["m" ],{className:showEntireContent?'show_all':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SimpleCarousel__["a" ],{classesList:'element_main_card'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(proposedContentList,function(element){if(typeof element.progress!=='undefined'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Cards_NarrativeSmallCard__["a" ],{key:element.id,data:element,color:element.color,classesList:'element_main_card'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Cards_ContentSimpleCard__["a" ],{key:element.id,data:element,recognized:recognized,classesList:['element_main_card'],onDelete:reloadContent});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity_gradient',onClick:handleShowEntireContent},literals.viewContent)):null):null,!addContent&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["c" ],{margin:'2rem',onClick:setAddContentShow,color:'white',back:'#2680EB'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),literals.propose),printSelectProposeContent(),printForm(),!addContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section'},literals.conclusionsAndInsights,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button_header',onClick:openDoc},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_button_header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-external-link-alt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'placeholder_button_header'},literals.fullEdit))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["i" ],{width:'90%',height:'119rem',scrolling:'yes',src:urlDoc})):null));};var printChatTab=function printChatTab(){if(!isInTable()||isCollapsed){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_ChatRoom__["a" ],{key:data.chat_id,chatId:data.chat_id,tableId:id,theme:true,onCollapse:handleCollapseChat});};var printTabContent=function printTabContent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectedTab!=='description'?'hidden':'tab_content'},printDescriptionTab()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectedTab!=='insight'?'hidden':'tab_content'},printContentTab()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectedTab!=='chat'?'hidden':'tab_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["d" ],null,printChatTab())));};var printContent=function printContent(){if(!data){return null;}var showChat=showChatInLateral();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table_content '+(showChat?'with_chat':''),style:{gridTemplateColumns:isCollapsed?'100% 0%':'59% 39%',gap:isCollapsed?'0':'2rem'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs_wrapper'},printTabs(),printTabContent()),showChat?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat_lateral'},printChatTab()):null));};var printInvitationsFeedbackModal=function printInvitationsFeedbackModal(){if(!showModalInviteFeedback){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_FeedbackModal__["a" ],{onClose:closeInvitationsFeedbackModal,open:true,success:true,text:literals.invitationsHasBeenSent});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,printErrors(),printSelectedUser(),printJoinModal(),printJoinRequestModal(),printLeaveModal(),printShareModal(),printKillModal(),printDeleteUserModal(),printDeleteTableModal(),printInvitationsFeedbackModal(),boostSeed(),launchSeed(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no_horizontal_padding',style:{paddingBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__styles__["o" ],{color:app.color1},printContent())));}ThemeTableDetail.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,getChats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,showBackButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,userElements:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,callId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,narratives:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,myThinkChatsList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,actualUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};ThemeTableDetail.defaultProps={userElements:[],showBackButton:false,callId:0,narratives:[],myThinkChatsList:[]}; __webpack_exports__["a"] = (ThemeTableDetail);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/default.38851b82.jpg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1883);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3__modules_actions__ = __webpack_require__(1884);
 var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(1885);
function mapStateToProps(state){return{literals:state.i18n.literals.boost||{},app:state.app,saveBoostStatus:state.boost.saveBoostStatus};}function mapDispatchToProps(dispatch){return{saveBoost:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3__modules_actions__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = saveBoost;
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(357);
function saveBoost(boost){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["b" ]});Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('POST',{endPoint:'boost'},boost).then(function(data){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["c" ],payload:{data:data}});}).catch(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["a" ]});});};}

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_components_AutocompleteInput__ = __webpack_require__(96);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1886);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function Boost(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('init'),_useState2=_slicedToArray(_useState,2),boostModalStage=_useState2[0],setBoostModalStage=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState4=_slicedToArray(_useState3,2),boostNumUser=_useState4[0],setBoostNumUser=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState6=_slicedToArray(_useState5,2),boostNeeds=_useState6[0],setBoostNeeds=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),_useState8=_slicedToArray(_useState7,2),urgencySel=_useState8[0],setUrgencySel=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState10=_slicedToArray(_useState9,2),labels=_useState10[0],setLabels=_useState10[1];var handleLabel=function handleLabel(label){setLabels([].concat(_toConsumableArray(labels),[label]));};var printTags=function printTags(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(labels,function(label,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" ],{key:index},label.name);});};var submitBoost=function submitBoost(){var saveBoost=props.saveBoost,elementType=props.elementType,elementId=props.elementId,close=props.close;var boost={element_type:elementType,element_id:elementId,num_people:boostNumUser,boostNeeds:boostNeeds,urgencySel:urgencySel,labels:labels.map(function(label){return label.id;})};boost.labels=boost.labels.join(',');saveBoost(boost);close();};var changeModalStage=function changeModalStage(event){var currentTarget=event.currentTarget;var section=currentTarget.getAttribute('data-stage');setBoostModalStage(section);};var handleChangeNumUser=function handleChangeNumUser(event){setBoostNumUser(event.target.value);};var handleChangeNeeds=function handleChangeNeeds(event){setBoostNeeds(event.target.value);};var handleUrgency=function handleUrgency(event){var currentTarget=event.currentTarget;var urg=parseInt(currentTarget.getAttribute('data-urgency'),10);setUrgencySel(urg);};var boostSeed=function boostSeed(){var literals=props.literals;switch(boostModalStage){case'init':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle close_icon',onClick:props.close})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" ],null,literals.boostYourThinkChatSubtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" ],{cont:true,'data-stage':'users',onClick:changeModalStage},literals.next));case'users':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle close_icon',onClick:props.close})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" ],null,literals.minimumUsersTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],{type:'number',value:boostNumUser,onChange:handleChangeNumUser}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" ],null,literals.minimumUsersSubtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" ],{cont:boostNumUser!=='','data-stage':'needs',onClick:changeModalStage},literals.next));case'needs':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle close_icon',onClick:props.close})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" ],null,literals.needsTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],{type:'text',value:boostNeeds,onChange:handleChangeNeeds}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" ],null,literals.needsSubtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" ],{cont:boostNeeds!=='','data-stage':'urgency',onClick:changeModalStage},literals.next));case'urgency':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle close_icon',onClick:props.close})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" ],null,literals.urgencyTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" ],{sel:urgencySel===1,'data-urgency':'1',onClick:handleUrgency},literals.urgencyLow),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" ],{sel:urgencySel===2,'data-urgency':'2',onClick:handleUrgency},literals.urgencyMedium),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" ],{sel:urgencySel===3,'data-urgency':'3',onClick:handleUrgency},literals.urgencyHigh)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" ],null,literals.urgencySubtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" ],{cont:urgencySel,'data-stage':'label',onClick:changeModalStage},literals.next));case'label':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle close_icon',onClick:props.close})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" ],null,literals.labelsTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AutocompleteInput__["a" ],{canCreateNew:true,type:'tag',selectedOptions:labels,onSelectOption:handleLabel,onCreateOption:handleLabel}),printTags()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" ],null,literals.labelsSubtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" ],{cont:labels.length>0,onClick:submitBoost},literals.finish));default:return null;}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["h" ],null),boostSeed());}Boost.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,elementType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,elementId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,close:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveBoost:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (Boost);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "i", function() { return TagLabel; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return Overlay; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return BoostModal; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return BoostTitle; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return BoostSubtitle; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return BoostNextButton; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return BoostInputText; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return BoostUrgency; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return BoostUrgencyTime; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  background-color: #f0f0f0;\n  font-size: 12px;\n  padding: 5px;\n  color: #4d4d4d;\n  border-radius: 5px;\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  background-color: #f0f0f0;\n  font-size: 12px;\n  padding: 5px;\n  color: #4d4d4d;\n  border-radius: 5px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  height: 100000rem;\n  width: 100vw;\n  position: absolute;\n  background: gray;\n  z-index: 10;\n  opacity: 70%;\n'],['\n  height: 100000rem;\n  width: 100vw;\n  position: absolute;\n  background: gray;\n  z-index: 10;\n  opacity: 70%;\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 33rem;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  border-radius: 1.5rem;\n  z-index: 101;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  flex-direction: column;\n  display: flex;\n  align-items: center; \n  .close_button {\n    width: 90%;\n    height: 5%;\n    font-size: 2rem;\n    margin-top: 2rem;\n    i {\n      float: right;\n      cursor: pointer;\n    }\n  }\n'],['\n  width: 33rem;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  border-radius: 1.5rem;\n  z-index: 101;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  flex-direction: column;\n  display: flex;\n  align-items: center; \n  .close_button {\n    width: 90%;\n    height: 5%;\n    font-size: 2rem;\n    margin-top: 2rem;\n    i {\n      float: right;\n      cursor: pointer;\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  margin-top: 2rem;\n  font-size: 1.8rem;\n  width: 80%;\n'],['\n  margin-top: 2rem;\n  font-size: 1.8rem;\n  width: 80%;\n']),_templateObject5=_taggedTemplateLiteral(['\n  margin-top: 1rem;\n  font-size: 1.2rem;\n  width: 80%;\n'],['\n  margin-top: 1rem;\n  font-size: 1.2rem;\n  width: 80%;\n']),_templateObject6=_taggedTemplateLiteral(['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.2rem;\n  width: 7rem;\n  padding: 0.8rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: ',';\n  margin-bottom: 2rem;\n'],['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.2rem;\n  width: 7rem;\n  padding: 0.8rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: ',';\n  margin-bottom: 2rem;\n']),_templateObject7=_taggedTemplateLiteral(['\n  margin: 2rem;\n  height: 6rem;\n  width: 85%;\n  border: none;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border-radius: 1rem;\n  outline: none;\n  padding: 1rem;\n  font-size: 1.4rem;\n  color: #2680EB;\n'],['\n  margin: 2rem;\n  height: 6rem;\n  width: 85%;\n  border: none;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border-radius: 1rem;\n  outline: none;\n  padding: 1rem;\n  font-size: 1.4rem;\n  color: #2680EB;\n']),_templateObject8=_taggedTemplateLiteral(['\n  margin: 1rem;\n  display: flex;\n  width: 85%;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap;\n'],['\n  margin: 1rem;\n  display: flex;\n  width: 85%;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap;\n']),_templateObject9=_taggedTemplateLiteral(['\n  border: 0.1rem solid black;\n  border-radius: 1rem;\n  padding: 1rem;\n  font-size: 1.1rem;\n  margin: 0.4rem;\n  color: ',';\n  background: ',';\n'],['\n  border: 0.1rem solid black;\n  border-radius: 1rem;\n  padding: 1rem;\n  font-size: 1.1rem;\n  margin: 0.4rem;\n  color: ',';\n  background: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TagLabel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var Overlay=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var BoostModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var BoostTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var BoostSubtitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var BoostNextButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,function(props){return props.cont?'#2680EB':'gray';});var BoostInputText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].input(_templateObject7);var BoostUrgency=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);var BoostUrgencyTime=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9,function(props){return props.sel?'white':'black';},function(props){return props.sel?'#2680EB':'';});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1888);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_ThinkTanks_modules_actions__ = __webpack_require__(76);
 var __WEBPACK_IMPORTED_MODULE_4_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1889);
function mapStateToProps(state){return{literals:state.i18n.literals.launch||{},app:state.app};}function mapDispatchToProps(dispatch){return{launchThinkTank:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_ThinkTanks_modules_actions__["l" ],dispatch),getMyThinkChats:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_think_seeds_actions__["b" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_assets_images_think_timer_svg__ = __webpack_require__(1890);
 var __WEBPACK_IMPORTED_MODULE_1_assets_images_think_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_images_think_timer_svg__);
 var __WEBPACK_IMPORTED_MODULE_2_components_ThinkTanks_modules_actions__ = __webpack_require__(76);
 var __WEBPACK_IMPORTED_MODULE_3_components_CreationThinkSeed_components_Congratulations__ = __webpack_require__(1891);
 var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1893);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function Launch(props){var literals=props.literals,history=props.history,data=props.data,user=props.user;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('init'),_useState2=_slicedToArray(_useState,2),launchModalStage=_useState2[0],setLaunchModalStage=_useState2[1];var handleSubmit=function handleSubmit(){Object(__WEBPACK_IMPORTED_MODULE_2_components_ThinkTanks_modules_actions__["k" ])(data.id,user.id).then(function(){history.push('/think');});};var congratulations=function congratulations(){setLaunchModalStage('congrats');};var launchSeed=function launchSeed(){if(launchModalStage==='congrats'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'center_items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CreationThinkSeed_components_Congratulations__["a" ],{literals:literals}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" ],null,literals.congratsTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" ],null,literals.congratsText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" ],{onClick:handleSubmit,cont:true},literals.accept))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle close_icon',onClick:props.close})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'center_items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1_assets_images_think_timer_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" ],null,literals.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],{color:'#F63256',onClick:props.close},literals.no),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" ],{color:'#2680EB',onClick:congratulations},literals.yes))));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" ],null),launchSeed());} __webpack_exports__["a"] = (Launch);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/timer.a1dc0a2a.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_2_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(270);
 var __WEBPACK_IMPORTED_MODULE_4__animation__ = __webpack_require__(1892);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Congratulations=function(_React$Component){_inherits(Congratulations,_React$Component);function Congratulations(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Congratulations);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Congratulations.__proto__||Object.getPrototypeOf(Congratulations)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(){var setGoDown=_this.props.setGoDown;if(window.location.pathname===__WEBPACK_IMPORTED_MODULE_1_constants_urls__["y" ]){setGoDown(true);}else{__WEBPACK_IMPORTED_MODULE_2_store_history__["a" ].push(__WEBPACK_IMPORTED_MODULE_1_constants_urls__["P" ]);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Congratulations,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_4__animation__["a" ])();}},{key:'render',value:function render(){var _props=this.props,literals=_props.literals,darkerColor=_props.darkerColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{className:'confetti'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["e" ],null,literals.congratulations),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["d" ],null,literals.thinkChatCreated),darkerColor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" ],{type:'button',color:darkerColor,darkerColor:darkerColor,onClick:this.handleClick,style:{zIndex:'50'}},literals.continue):null);}}]);return Congratulations;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component); __webpack_exports__["a"] = (Congratulations);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_utils_colors__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var PI=Math.PI;var TAU=PI*2;var HALF_PI=PI*0.5;var RAND=Math.random;var ROUND=Math.round;var SIN=Math.sin;var COS=Math.cos;var ABS=Math.abs;var POW=Math.pow;var lib={v2:Vector2,noise:noise,stats:Stats};var Config=function(){function Config(opts){_classCallCheck(this,Config);this.merge(opts);}_createClass(Config,[{key:'merge',value:function merge(opts){for(var opt in opts){this.set(opt,opts[opt]);}}},{key:'set',value:function set(key,value){if(!key||!value)return;this[key]=value;}}]);return Config;}();var Canvas=function(){function Canvas(selector,context,dimensions,center){_classCallCheck(this,Canvas);var self=this;if(selector){this.el=document.querySelector(selector);}else{this.el=document.createElement('canvas');document.body.appendChild(this.el);}if(this.el){this.ctx=this.el.getContext(context)||this.el.getContext('2d');this.dimensions=dimensions||{x:0,y:0};this.center=new lib.v2();window.addEventListener('resize',self.resize.bind(self));}}_createClass(Canvas,[{key:'rgba',value:function rgba(r,g,b,a){return'rgba('+r+','+g+','+b+','+a+')';}},{key:'hsla',value:function hsla(h,s,l,a){return'hsla('+h+', '+s+', '+l+', '+a+')';}},{key:'fill',value:function fill(x,y,width,height,_fill){this.ctx.fillStyle=_fill||'rgba(255,255,255,1)';this.ctx.fillRect(x,y,width,height);}},{key:'clear',value:function clear(){this.ctx.clearRect(0,0,this.dimensions.x,this.dimensions.y);}},{key:'drawLine',value:function drawLine(x1,y1,x2,y2,stroke,strokeWidth){this.ctx.beginPath();this.ctx.moveTo(x1,y1);this.ctx.lineTo(x2,y2);this.ctx.strokeStyle=stroke||'rgba(255,255,255,1)';this.ctx.lineWidth=strokeWidth||2;this.ctx.stroke();this.ctx.closePath();}},{key:'resize',value:function resize(){this.el.width=this.dimensions.x=window.innerWidth;this.el.height=this.dimensions.y=window.innerHeight;this.center.x=this.dimensions.x*0.5;this.center.y=this.dimensions.y*0.5;this.ctx.globalCompositeOperation='lighter';}}]);return Canvas;}();var Particle=function(){function Particle(x,y,bounds,center){_classCallCheck(this,Particle);this.lastPosition=new lib.v2();this.position=new lib.v2(x,y);this.velocity=new lib.v2();this.life=0;this.ttl=1000;this.bounds=bounds;this.center=center;this.reset=false;}_createClass(Particle,[{key:'update',value:function update(){if(this.life>this.ttl||this.checkBounds()){this.reset=true;}else{this.position.add(this.velocity);this.life++;}}},{key:'checkBounds',value:function checkBounds(){return this.lastPosition.x-this.size*3>this.bounds.x||this.lastPosition.x<-this.size||this.lastPosition.y-this.size*3>this.bounds.y||this.lastPosition.y<-this.size||this.position.distanceTo(this.center)<3;}}]);return Particle;}();var ParticleSystem=function(){function ParticleSystem(){_classCallCheck(this,ParticleSystem);lib.noise.seed(RAND*2000);var defaults={max:400,size:5};this.canvas=new Canvas('.confetti','2d');if(this.canvas.el){this.canvas.resize();this.bounds=this.canvas.dimensions;this.config=new Config(defaults);this.tick=0;this.points=[];this.render();}}_createClass(ParticleSystem,[{key:'update',value:function update(){var pRef=void 0;var p=void 0;var noiseVal=void 0;var noiseNorm=void 0;var theta=void 0;var theta2=void 0;var dTheta=void 0;var vel=void 0;var vel2=void 0;var size=void 0;var hue=void 0;var colorString=void 0;this.canvas.clear();this.canvas.ctx.lineCap='round';if(this.points.length<this.config.max&&this.tick%2===0){var rand=ROUND(RAND());var x=rand?ROUND(RAND())*this.canvas.dimensions.x:RAND()*this.canvas.dimensions.x;var y=rand?RAND()*this.canvas.dimensions.y:ROUND(RAND())*this.canvas.dimensions.y;p=new Particle(x,y,this.canvas.dimensions,this.canvas.center);this.points.push(p);}for(var i=this.points.length-1;i>=0;i--){p=this.points[i];if(p.reset){this.points.splice(i,1);continue;}else{p.lastPosition.x=p.position.x;p.lastPosition.y=p.position.y;noiseVal=lib.noise.simplex3(p.position.x*0.0015,p.position.y*0.0015,this.tick*0.005);noiseNorm=ABS(noiseVal);theta=noiseVal*TAU*(1000/(p.position.distanceTo(this.canvas.center)+1000));theta2=p.position.angleTo(this.canvas.center)+HALF_PI*0.25;dTheta=(theta+theta2)/2;hue=theta*10-30;var randomColor=Object(__WEBPACK_IMPORTED_MODULE_0_utils_colors__["g" ])(Object(__WEBPACK_IMPORTED_MODULE_0_utils_colors__["i" ])().color);colorString=this.canvas.hsla(randomColor[0],'100%','50%',noiseNorm+0.2);vel=new lib.v2((COS(theta)*0.5+COS(theta2))*6,(SIN(theta)*0.5+SIN(theta2))*3).multiplyScalar(POW(2*(p.position.y/this.canvas.dimensions.y)+1,2));size=POW(p.position.y/this.canvas.dimensions.y*this.config.size,2)+2;p.velocity.lerp(vel,0.035);p.update();this.canvas.drawLine(p.lastPosition.x,p.lastPosition.y,p.position.x,p.position.y,colorString,size);}}this.tick++;}},{key:'render',value:function render(){var self=this;self.update();window.requestAnimationFrame(self.render.bind(self));}}]);return ParticleSystem;}();window.requestAnimationFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(callback){window.setTimeout(callback,1000/60);};}();var initialize=function initialize(){var p=new ParticleSystem();}; __webpack_exports__["a"] = (initialize);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "f", function() { return Overlay; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return LaunchModal; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return LaunchTitle; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return LaunchSubtitle; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return LaunchNextButton; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return LaunchActionButton; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  height: 100vh;\n  width: 100vw;\n  position: absolute;\n  background: gray;\n  z-index: 10;\n  opacity: 70%;\n'],['\n  height: 100vh;\n  width: 100vw;\n  position: absolute;\n  background: gray;\n  z-index: 10;\n  opacity: 70%;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 33rem;\n  position: fixed;\n  overflow: scroll;\n  max-height: 75vh;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  border-radius: 1.5rem;\n  z-index: 101;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  flex-direction: column;\n  display: flex;\n  align-items: center; \n  .buttons {\n    display: flex;\n    align-items: center;\n    width: 70%;\n    flex-direction: row;\n    justify-content: space-evenly;\n    z-index: 999999999999999;\n    order: 9999999999;\n  }\n  .close_button {\n    width: 90%;\n    height: 5%;\n    font-size: 2rem;\n    margin-top: 2rem;\n    i {\n      float: right;\n      cursor: pointer;\n    }\n  }\n  @media(min-width: ','px) {\n    left: 50%;\n    bottom: 50%;\n    height: 40vh;\n    width: 50rem;\n  }\n  iframe {\n    height: 75vh;\n    width: 100%;\n  }\n  .center_items {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    height: 90%;\n  }\n'],['\n  width: 33rem;\n  position: fixed;\n  overflow: scroll;\n  max-height: 75vh;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  border-radius: 1.5rem;\n  z-index: 101;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  flex-direction: column;\n  display: flex;\n  align-items: center; \n  .buttons {\n    display: flex;\n    align-items: center;\n    width: 70%;\n    flex-direction: row;\n    justify-content: space-evenly;\n    z-index: 999999999999999;\n    order: 9999999999;\n  }\n  .close_button {\n    width: 90%;\n    height: 5%;\n    font-size: 2rem;\n    margin-top: 2rem;\n    i {\n      float: right;\n      cursor: pointer;\n    }\n  }\n  @media(min-width: ','px) {\n    left: 50%;\n    bottom: 50%;\n    height: 40vh;\n    width: 50rem;\n  }\n  iframe {\n    height: 75vh;\n    width: 100%;\n  }\n  .center_items {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    height: 90%;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  margin-top: -2rem;\n  font-size: 2.1rem;\n  width: 80%;\n  text-align: center;\n'],['\n  margin-top: -2rem;\n  font-size: 2.1rem;\n  width: 80%;\n  text-align: center;\n']),_templateObject4=_taggedTemplateLiteral(['\n  margin-top: 1rem;\n  font-size: 1.7rem;\n  margin-bottom: 2rem;\n  width: 80%;\n  text-align: center;\n'],['\n  margin-top: 1rem;\n  font-size: 1.7rem;\n  margin-bottom: 2rem;\n  width: 80%;\n  text-align: center;\n']),_templateObject5=_taggedTemplateLiteral(['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.2rem;\n  width: 7rem;\n  padding: 0.8rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: ',';\n  margin-bottom: 2rem;\n'],['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.2rem;\n  width: 7rem;\n  padding: 0.8rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: ',';\n  margin-bottom: 2rem;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var LaunchModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var LaunchTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var LaunchSubtitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var LaunchNextButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,function(props){return props.cont?'#2680EB':'gray';});var LaunchActionButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5,function(props){return props.color;});

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/editButton.43f3440e.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shareButton.57b14b6b.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/verticalDots.b1b6adb8.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/horizontalDots.4a259508.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "o", function() { return ThemeTableDetailWrapper; });
 __webpack_require__.d(__webpack_exports__, "p", function() { return TitleBack; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return DescriptionTab; });

 __webpack_require__.d(__webpack_exports__, "i", function() { return DocIframe; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return JoinModal; });
 __webpack_require__.d(__webpack_exports__, "l", function() { return LeaveTable; });




 __webpack_require__.d(__webpack_exports__, "b", function() { return BoostNextButton; });



 __webpack_require__.d(__webpack_exports__, "e", function() { return Content; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonAttach; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return ContentTypes; });
 __webpack_require__.d(__webpack_exports__, "n", function() { return OptionsModal; });
 __webpack_require__.d(__webpack_exports__, "m", function() { return MinimizeCarousel; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ChatTab; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return JoinTable; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return AddButton; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return CreateTable; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
 var __WEBPACK_IMPORTED_MODULE_3_constants_fonts__ = __webpack_require__(17);
var _templateObject=_taggedTemplateLiteral(['\n  @media (max-width: ','px) {\n    padding-bottom: 8rem;\n  }\n  > .header {\n    padding: 2rem 2rem;\n    height: 7rem;\n    box-shadow: inset 0px -2px 4px -2px rgba(0, 0, 0, 0.16);\n    display: flex;\n    .back_button {\n      cursor: pointer;\n      margin-right: 1.5rem;\n      flex: 1;\n      i {\n        color: ',';\n        font-size: 1.8rem;\n      }\n    }\n\n    > div {\n      display: inline-block;\n      vertical-align: middle;\n    }\n\n    > .title {\n      color: ',';\n      font-size: 1.8rem;\n      margin-right: 2rem;\n      flex: 100;\n      font-family: ',';\n      img {\n        margin-right: 0.5rem;\n      }\n    }\n\n\n    @media (max-width: ','px) {\n      .btn_join_lg {\n        display: none;\n      }\n\n      .title {\n        width: calc(100% - 5rem);\n      }\n\n\n    }\n  }\n\n  .expand {\n    display: inline-block;\n    background-color: #2680EB;\n    height: 6rem;\n    float: right;\n    padding: 1rem;\n    text-align: center;\n    font-size: 1.5rem;\n    cursor: pointer;\n\n    img {\n      transform: rotateY(180deg);\n    }\n\n    p {\n      color: white;\n      font-weight: 600;\n    }\n  }\n\n  .no_elements {\n    > div {\n      color: ',';\n    }\n  }\n\n  .tabs {\n    background-color: #fff;\n\n    @media (max-width: ','px) {\n      position: sticky;\n      top: 0rem;\n      border-bottom: 1px solid #eee;\n      z-index: 10;\n    }\n  }\n\n  .tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .table_content {\n    &.with_chat {\n      display: grid;\n\n      .tab_content {\n        height: calc(100vh - 10rem);\n        overflow: auto;\n      }\n    }\n    @media (min-width: ','px) {\n      .chat_container {\n        height: calc(100vh - 14.3rem);\n\n        .list_messages {\n          height: calc(100vh - 14.3rem);\n        }\n      }\n    }\n\n    .chat_lateral {\n      box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px;\n      height: calc(100vh - 5rem);\n\n      .chat_title {\n        background-color: ',';\n        color: #fff;\n        height: 6.4rem;\n        font-size: 1.6rem;\n        padding: 2.5rem 1rem 0;\n      }\n\n      .chat_container {\n        height: calc(100vh - 15.4rem);\n\n        .list_messages {\n          height: calc(100vh - 15.4rem);\n        }\n      }\n    }\n  }\n'],['\n  @media (max-width: ','px) {\n    padding-bottom: 8rem;\n  }\n  > .header {\n    padding: 2rem 2rem;\n    height: 7rem;\n    box-shadow: inset 0px -2px 4px -2px rgba(0, 0, 0, 0.16);\n    display: flex;\n    .back_button {\n      cursor: pointer;\n      margin-right: 1.5rem;\n      flex: 1;\n      i {\n        color: ',';\n        font-size: 1.8rem;\n      }\n    }\n\n    > div {\n      display: inline-block;\n      vertical-align: middle;\n    }\n\n    > .title {\n      color: ',';\n      font-size: 1.8rem;\n      margin-right: 2rem;\n      flex: 100;\n      font-family: ',';\n      img {\n        margin-right: 0.5rem;\n      }\n    }\n\n\n    @media (max-width: ','px) {\n      .btn_join_lg {\n        display: none;\n      }\n\n      .title {\n        width: calc(100% - 5rem);\n      }\n\n\n    }\n  }\n\n  .expand {\n    display: inline-block;\n    background-color: #2680EB;\n    height: 6rem;\n    float: right;\n    padding: 1rem;\n    text-align: center;\n    font-size: 1.5rem;\n    cursor: pointer;\n\n    img {\n      transform: rotateY(180deg);\n    }\n\n    p {\n      color: white;\n      font-weight: 600;\n    }\n  }\n\n  .no_elements {\n    > div {\n      color: ',';\n    }\n  }\n\n  .tabs {\n    background-color: #fff;\n\n    @media (max-width: ','px) {\n      position: sticky;\n      top: 0rem;\n      border-bottom: 1px solid #eee;\n      z-index: 10;\n    }\n  }\n\n  .tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .table_content {\n    &.with_chat {\n      display: grid;\n\n      .tab_content {\n        height: calc(100vh - 10rem);\n        overflow: auto;\n      }\n    }\n    @media (min-width: ','px) {\n      .chat_container {\n        height: calc(100vh - 14.3rem);\n\n        .list_messages {\n          height: calc(100vh - 14.3rem);\n        }\n      }\n    }\n\n    .chat_lateral {\n      box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px;\n      height: calc(100vh - 5rem);\n\n      .chat_title {\n        background-color: ',';\n        color: #fff;\n        height: 6.4rem;\n        font-size: 1.6rem;\n        padding: 2.5rem 1rem 0;\n      }\n\n      .chat_container {\n        height: calc(100vh - 15.4rem);\n\n        .list_messages {\n          height: calc(100vh - 15.4rem);\n        }\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  .title_create {\n    margin: 1% 0;\n    text-align: left;\n\n    div {\n      display: inline-block;\n      font-family: ',';\n      font-size: 22px;\n      margin: 1%;\n    }\n\n    img {\n      display: inline-block;\n      margin-left: 1%;\n      cursor: pointer;\n    }\n'],['\n  .title_create {\n    margin: 1% 0;\n    text-align: left;\n\n    div {\n      display: inline-block;\n      font-family: ',';\n      font-size: 22px;\n      margin: 1%;\n    }\n\n    img {\n      display: inline-block;\n      margin-left: 1%;\n      cursor: pointer;\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n  .callInfo {\n    height: 15rem;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    \n\n    .back {\n      height: 70%;\n      width: 4%;\n      display: flex;\n      justify-content: flex-end;\n      i {\n        font-size: 2rem;\n        cursor: pointer;\n      }\n    }\n    img {\n      height: 80%;\n      width: 20%;\n    }\n    .data {\n      height: 70%;\n      width: 40%;\n      .name {\n        font-size: 1.8rem;\n        font-weight: 800;\n        margin: 1rem;\n      }\n      .live_event {\n        font-size: 1.4rem;\n        margin: 1rem;\n      }\n      .starting {\n        font-size: 1.4rem;\n        margin: 1rem;\n        display: flex;\n        align-items: center;\n      }\n    }\n    .buttons {\n      height: 80%;\n      width: 31%;\n      display: flex;\n      align-items: flex-end;\n      flex-direction: column;\n      .main_button {\n        width: 10rem;\n        font-size: 1.2rem;\n        background: #2680EB;\n        color: white;\n        padding: 1rem;\n        margin: 1rem;\n        border-radius: 2rem;\n        text-transform: uppercase;\n      }\n      .sec_button {\n        width: 10rem;\n        font-size: 1.2rem;\n        border: 0.1rem solid #2680EB;\n        color: #2680EB;\n        padding: 1rem;\n        margin: 1rem;\n        border-radius: 2rem;\n        text-transform: uppercase;\n      }\n    }\n    @media (max-width: ','px) {\n      height: 12rem;\n      position: relative;\n      .back {\n        display: none;\n      }\n      img {\n        height: 80%;\n        width: 30%;\n      }\n      .data {\n        height: 70%;\n        width: 70%;\n        .name {\n          font-size: 1.2rem;\n        }\n        .live_event {\n          font-size: 1rem;\n        }\n        .starting {\n          font-size: 1rem;\n        }\n      }\n      .buttons {\n        height: 80%;\n        width: 50%;\n        display: flex;\n        flex-direction: row;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        .main_button {\n          width: 7rem;\n          font-size: 0.9rem;\n          font-weight: bold;\n          background: #2680EB;\n          color: white;\n          padding: 0.5rem;\n          margin: 1rem;\n          border-radius: 2rem;\n          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n          text-transform: none;\n        }\n        .sec_button {\n          width: 7rem;\n          font-size: 0.9rem;\n          font-weight: bold;\n          border: none;\n          background: white;\n          color: #2680EB;\n          padding: 0.5rem;\n          margin: 1rem;\n          border-radius: 2rem;\n          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n          text-transform: none;\n        }\n      }\n    }\n  }\n  > .header {\n    height: 15rem;\n    background-color: #fff;\n    background-image: url(',');\n    background-size: cover;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    position: relative;\n    color: ',';\n    display: flex;\n\n    @media (max-width: ','px) {\n      height: 12rem;\n    }\n\n    .curtain {\n      position: absolute;\n      top: 0;\n      left: 0;\n      background-color: rgba(0, 0, 0, 0.5);\n      width: 100%;\n      height: 100%;\n      color: #fff;\n    }\n\n    .icon {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      width: 26%;\n      @media (max-width: ','px) {\n          width: 45%;\n        }\n      .table_card {\n        padding-top: 6rem;\n        transform: scale(0.7);\n        @media (max-width: ','px) {\n          transform: scale(0.5);\n        }\n      }\n    }\n\n    .data {\n      width: 50%;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      margin-left: -1rem;\n      @media (max-width: ','px) {\n        margin-left: -5rem;\n      }\n      .name {\n        margin: 0.5rem;\n        color: white;\n        z-index: 2;\n        font-size: 1.8rem;\n        font-weight: 800;\n        @media (max-width: ','px) {\n          font-size: 1.2rem;\n        }\n      }\n      .countdown {\n        margin: 0.5rem;\n        color: white;\n        z-index: 2;\n        font-size: 1.4rem;\n        font-weight: 800;\n        display: flex;\n        align-items: center;\n        @media (max-width: ','px) {\n          font-size: 1rem;\n        }\n      }\n      .data_buttons {\n        width: 90%;\n        z-index: 4;\n        margin: 0.5rem;\n        display: flex;\n        justify-content: flex-end;\n        @media (max-width: ','px) {\n          display: none;\n        }\n        .boost {\n          background: #2680EB;\n          color: white;\n          font-size: 1.4rem;\n          padding: 1rem 4rem;\n          border-radius: 2rem;\n        }\n        .launch{\n          border: 0.1rem #2680EB solid;\n          color: #2680EB;\n          background: white;\n          font-size: 1.4rem;\n          padding: 1rem 3rem;\n          border-radius: 2rem;\n        }\n      }\n    }\n\n    .buttons {\n      width: 33%;\n      z-index: 2;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      padding: 2rem;\n      justify-content: center;\n      .top_buttons {\n        margin: 0.5rem;\n      }\n      .rounded {\n        background: white;\n        padding: 0.6rem 0.8rem;\n        border-radius: 100%;\n        img {\n          width: 2rem;\n          height: 2rem;\n        }\n      }\n      .bottom_buttons {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        @media (max-width: ','px) {\n          display: none;\n        }\n      }\n      .kill {\n        font-size: 1.4rem;\n        color: black;\n        padding: 1rem 2rem;\n        background: #D0D0D4;\n        border-radius: 2rem;\n        margin: 0.5rem;\n      }\n      .guided {\n        font-size: 1.4rem;\n        color: #2680EB;\n        padding: 1rem 2rem;\n        background: white;\n        border-radius: 2rem;\n        margin: 0.5rem;\n      }\n    }\n    @media (max-width: ','px) {\n      .buttons {\n        .top_buttons {\n          display: flex;\n        }\n        .rounded {\n          display: none;\n        }\n        .phone_rounded {\n          background: white;\n          padding: 0.6rem 0.8rem;\n          border-radius: 100%;\n          margin: 0.5rem;\n          .share {\n            height: 2rem;\n          }\n          .dots {\n            height: 2rem;\n            width: 2rem;\n          }\n        }\n      }\n    }\n    @media (min-width: ','px) {\n      .buttons {\n        .phone_rounded {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .grid_info {\n    margin: 2rem 2rem 4rem;\n    color: #707070;\n\n    .description {\n      font-size: 1.4rem;\n      line-height: 1.8rem;\n      margin-bottom: 2rem;\n    }\n\n    @media (max-width: ','px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    font-family: ',';\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.2rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n\n  .lists {\n    margin: 0 2rem 2rem;\n\n    @media (max-width: ','px) {\n      margin: 0 0rem 2rem;\n\n      .title_section {\n        margin-left: 2rem;\n      }\n\n      .simple_carousel  {\n        > div:first-child {\n          margin-left: 2rem;\n        }\n      }\n    }\n\n    .list {\n      margin-bottom: 2rem;\n\n      .header_list {\n        display: grid;\n        grid-template-columns: auto 50px;\n        grid-gap: 2rem;\n\n        .icon_expand {\n          justify-self: end;\n          img {\n            cursor: pointer;\n            height: 20px;\n          }\n        }\n      }\n\n      .face_bubble {\n        cursor: pointer;\n        margin: 0 1rem;\n      }\n\n      .face_bubble_text {\n        color: ',';\n      }\n\n      .bubbles {\n        &.in_line {\n          .faces_wrapper {\n            white-space: nowrap;\n            overflow: auto;\n            text-align: left;\n          }\n        }\n\n        &.in_table {\n          .face_bubble {\n            width: calc(100% / 4);\n          }\n        }\n      }\n    }\n\n    @media (max-width: ','px) {\n      grid-template-columns: 100%;\n      width: 100%;\n    }\n  }\n\n  .btn_join_sm {\n    margin-bottom: 4rem !important;\n    @media (min-width: ','px) {\n      display: none;\n    }\n  }\n  .users {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .leaveTable{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 2rem;\n  }\n'],['\n  .callInfo {\n    height: 15rem;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    \n\n    .back {\n      height: 70%;\n      width: 4%;\n      display: flex;\n      justify-content: flex-end;\n      i {\n        font-size: 2rem;\n        cursor: pointer;\n      }\n    }\n    img {\n      height: 80%;\n      width: 20%;\n    }\n    .data {\n      height: 70%;\n      width: 40%;\n      .name {\n        font-size: 1.8rem;\n        font-weight: 800;\n        margin: 1rem;\n      }\n      .live_event {\n        font-size: 1.4rem;\n        margin: 1rem;\n      }\n      .starting {\n        font-size: 1.4rem;\n        margin: 1rem;\n        display: flex;\n        align-items: center;\n      }\n    }\n    .buttons {\n      height: 80%;\n      width: 31%;\n      display: flex;\n      align-items: flex-end;\n      flex-direction: column;\n      .main_button {\n        width: 10rem;\n        font-size: 1.2rem;\n        background: #2680EB;\n        color: white;\n        padding: 1rem;\n        margin: 1rem;\n        border-radius: 2rem;\n        text-transform: uppercase;\n      }\n      .sec_button {\n        width: 10rem;\n        font-size: 1.2rem;\n        border: 0.1rem solid #2680EB;\n        color: #2680EB;\n        padding: 1rem;\n        margin: 1rem;\n        border-radius: 2rem;\n        text-transform: uppercase;\n      }\n    }\n    @media (max-width: ','px) {\n      height: 12rem;\n      position: relative;\n      .back {\n        display: none;\n      }\n      img {\n        height: 80%;\n        width: 30%;\n      }\n      .data {\n        height: 70%;\n        width: 70%;\n        .name {\n          font-size: 1.2rem;\n        }\n        .live_event {\n          font-size: 1rem;\n        }\n        .starting {\n          font-size: 1rem;\n        }\n      }\n      .buttons {\n        height: 80%;\n        width: 50%;\n        display: flex;\n        flex-direction: row;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        .main_button {\n          width: 7rem;\n          font-size: 0.9rem;\n          font-weight: bold;\n          background: #2680EB;\n          color: white;\n          padding: 0.5rem;\n          margin: 1rem;\n          border-radius: 2rem;\n          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n          text-transform: none;\n        }\n        .sec_button {\n          width: 7rem;\n          font-size: 0.9rem;\n          font-weight: bold;\n          border: none;\n          background: white;\n          color: #2680EB;\n          padding: 0.5rem;\n          margin: 1rem;\n          border-radius: 2rem;\n          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n          text-transform: none;\n        }\n      }\n    }\n  }\n  > .header {\n    height: 15rem;\n    background-color: #fff;\n    background-image: url(',');\n    background-size: cover;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    position: relative;\n    color: ',';\n    display: flex;\n\n    @media (max-width: ','px) {\n      height: 12rem;\n    }\n\n    .curtain {\n      position: absolute;\n      top: 0;\n      left: 0;\n      background-color: rgba(0, 0, 0, 0.5);\n      width: 100%;\n      height: 100%;\n      color: #fff;\n    }\n\n    .icon {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      width: 26%;\n      @media (max-width: ','px) {\n          width: 45%;\n        }\n      .table_card {\n        padding-top: 6rem;\n        transform: scale(0.7);\n        @media (max-width: ','px) {\n          transform: scale(0.5);\n        }\n      }\n    }\n\n    .data {\n      width: 50%;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      margin-left: -1rem;\n      @media (max-width: ','px) {\n        margin-left: -5rem;\n      }\n      .name {\n        margin: 0.5rem;\n        color: white;\n        z-index: 2;\n        font-size: 1.8rem;\n        font-weight: 800;\n        @media (max-width: ','px) {\n          font-size: 1.2rem;\n        }\n      }\n      .countdown {\n        margin: 0.5rem;\n        color: white;\n        z-index: 2;\n        font-size: 1.4rem;\n        font-weight: 800;\n        display: flex;\n        align-items: center;\n        @media (max-width: ','px) {\n          font-size: 1rem;\n        }\n      }\n      .data_buttons {\n        width: 90%;\n        z-index: 4;\n        margin: 0.5rem;\n        display: flex;\n        justify-content: flex-end;\n        @media (max-width: ','px) {\n          display: none;\n        }\n        .boost {\n          background: #2680EB;\n          color: white;\n          font-size: 1.4rem;\n          padding: 1rem 4rem;\n          border-radius: 2rem;\n        }\n        .launch{\n          border: 0.1rem #2680EB solid;\n          color: #2680EB;\n          background: white;\n          font-size: 1.4rem;\n          padding: 1rem 3rem;\n          border-radius: 2rem;\n        }\n      }\n    }\n\n    .buttons {\n      width: 33%;\n      z-index: 2;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      padding: 2rem;\n      justify-content: center;\n      .top_buttons {\n        margin: 0.5rem;\n      }\n      .rounded {\n        background: white;\n        padding: 0.6rem 0.8rem;\n        border-radius: 100%;\n        img {\n          width: 2rem;\n          height: 2rem;\n        }\n      }\n      .bottom_buttons {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        @media (max-width: ','px) {\n          display: none;\n        }\n      }\n      .kill {\n        font-size: 1.4rem;\n        color: black;\n        padding: 1rem 2rem;\n        background: #D0D0D4;\n        border-radius: 2rem;\n        margin: 0.5rem;\n      }\n      .guided {\n        font-size: 1.4rem;\n        color: #2680EB;\n        padding: 1rem 2rem;\n        background: white;\n        border-radius: 2rem;\n        margin: 0.5rem;\n      }\n    }\n    @media (max-width: ','px) {\n      .buttons {\n        .top_buttons {\n          display: flex;\n        }\n        .rounded {\n          display: none;\n        }\n        .phone_rounded {\n          background: white;\n          padding: 0.6rem 0.8rem;\n          border-radius: 100%;\n          margin: 0.5rem;\n          .share {\n            height: 2rem;\n          }\n          .dots {\n            height: 2rem;\n            width: 2rem;\n          }\n        }\n      }\n    }\n    @media (min-width: ','px) {\n      .buttons {\n        .phone_rounded {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .grid_info {\n    margin: 2rem 2rem 4rem;\n    color: #707070;\n\n    .description {\n      font-size: 1.4rem;\n      line-height: 1.8rem;\n      margin-bottom: 2rem;\n    }\n\n    @media (max-width: ','px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    font-family: ',';\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.2rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n\n  .lists {\n    margin: 0 2rem 2rem;\n\n    @media (max-width: ','px) {\n      margin: 0 0rem 2rem;\n\n      .title_section {\n        margin-left: 2rem;\n      }\n\n      .simple_carousel  {\n        > div:first-child {\n          margin-left: 2rem;\n        }\n      }\n    }\n\n    .list {\n      margin-bottom: 2rem;\n\n      .header_list {\n        display: grid;\n        grid-template-columns: auto 50px;\n        grid-gap: 2rem;\n\n        .icon_expand {\n          justify-self: end;\n          img {\n            cursor: pointer;\n            height: 20px;\n          }\n        }\n      }\n\n      .face_bubble {\n        cursor: pointer;\n        margin: 0 1rem;\n      }\n\n      .face_bubble_text {\n        color: ',';\n      }\n\n      .bubbles {\n        &.in_line {\n          .faces_wrapper {\n            white-space: nowrap;\n            overflow: auto;\n            text-align: left;\n          }\n        }\n\n        &.in_table {\n          .face_bubble {\n            width: calc(100% / 4);\n          }\n        }\n      }\n    }\n\n    @media (max-width: ','px) {\n      grid-template-columns: 100%;\n      width: 100%;\n    }\n  }\n\n  .btn_join_sm {\n    margin-bottom: 4rem !important;\n    @media (min-width: ','px) {\n      display: none;\n    }\n  }\n  .users {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .leaveTable{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 2rem;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n    width: 69rem;\n    max-width: 100%;\n    position: absolute;\n    border-radius: 2rem;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    overflow: hidden;\n    outline: none;\n    height: 95%;\n'],['\n    width: 69rem;\n    max-width: 100%;\n    position: absolute;\n    border-radius: 2rem;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    overflow: hidden;\n    outline: none;\n    height: 95%;\n']),_templateObject5=_taggedTemplateLiteral(['\n  width: ',';\n  height: ',';\n  margin-top: 1rem;\n  border-radius: 2rem;\n  border: 0px;\n  background-color: #fff;\n\n  @media (max-width: ','px) {\n    height: ',';\n  }\n'],['\n  width: ',';\n  height: ',';\n  margin-top: 1rem;\n  border-radius: 2rem;\n  border: 0px;\n  background-color: #fff;\n\n  @media (max-width: ','px) {\n    height: ',';\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n    width: 69rem;\n    max-width: 100%;\n    position: absolute;\n    border-radius: 2rem;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    overflow: hidden;\n    outline: none;\n    height: 95%;\n    background-color: #fff;\n    padding: 2rem;\n'],['\n    width: 69rem;\n    max-width: 100%;\n    position: absolute;\n    border-radius: 2rem;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    overflow: hidden;\n    outline: none;\n    height: 95%;\n    background-color: #fff;\n    padding: 2rem;\n']),_templateObject7=_taggedTemplateLiteral(['\n  background-color: #F44336;\n  font-size: 1.4rem;\n  padding: 1rem;\n  font-weight: bold;\n  padding: 1rem;\n  border-radius: 20px;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n'],['\n  background-color: #F44336;\n  font-size: 1.4rem;\n  padding: 1rem;\n  font-weight: bold;\n  padding: 1rem;\n  border-radius: 20px;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n']),_templateObject8=_taggedTemplateLiteral(['\n  flex: 1;\n  i {\n    font-size: 1.8rem;\n    color: black;\n    cursor: pointer;\n  }\n'],['\n  flex: 1;\n  i {\n    font-size: 1.8rem;\n    color: black;\n    cursor: pointer;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  width: 33rem;\n  position: fixed;\n  left: 5%;\n  background: white;\n  border-radius: 1.5rem;\n  top: 20%;\n  z-index: 10;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  .close_button {\n    width: 90%;\n    height: 5%;\n    font-size: 2rem;\n    margin-top: 2rem;\n    i {\n      float: right;\n    }\n  }\n'],['\n  width: 33rem;\n  position: fixed;\n  left: 5%;\n  background: white;\n  border-radius: 1.5rem;\n  top: 20%;\n  z-index: 10;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  .close_button {\n    width: 90%;\n    height: 5%;\n    font-size: 2rem;\n    margin-top: 2rem;\n    i {\n      float: right;\n    }\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  margin-top: 2rem;\n  font-size: 1.8rem;\n  width: 80%;\n'],['\n  margin-top: 2rem;\n  font-size: 1.8rem;\n  width: 80%;\n']),_templateObject11=_taggedTemplateLiteral(['\n  margin-top: 1rem;\n  font-size: 1.2rem;\n  width: 80%;\n'],['\n  margin-top: 1rem;\n  font-size: 1.2rem;\n  width: 80%;\n']),_templateObject12=_taggedTemplateLiteral(['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.2rem;\n  width: 7rem;\n  padding: 0.8rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: ',';\n  margin-bottom: 2rem;\n'],['\n  color: white;\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 1.2rem;\n  width: 7rem;\n  padding: 0.8rem;\n  cursor: pointer;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-weight: bold;\n  background: ',';\n  margin-bottom: 2rem;\n']),_templateObject13=_taggedTemplateLiteral(['\n  margin: 2rem;\n  height: 6rem;\n  width: 85%;\n  border: none;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border-radius: 1rem;\n  outline: none;\n  padding: 1rem;\n  font-size: 1.4rem;\n  color: #2680EB;\n'],['\n  margin: 2rem;\n  height: 6rem;\n  width: 85%;\n  border: none;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border-radius: 1rem;\n  outline: none;\n  padding: 1rem;\n  font-size: 1.4rem;\n  color: #2680EB;\n']),_templateObject14=_taggedTemplateLiteral(['\n  margin: 1rem;\n  display: flex;\n  width: 85%;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap;\n'],['\n  margin: 1rem;\n  display: flex;\n  width: 85%;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap;\n']),_templateObject15=_taggedTemplateLiteral(['\n  border: 0.1rem solid black;\n  border-radius: 1rem;\n  padding: 1rem;\n  font-size: 1.1rem;\n  margin: 0.4rem;\n  color: ',';\n  background: ',';\n'],['\n  border: 0.1rem solid black;\n  border-radius: 1rem;\n  padding: 1rem;\n  font-size: 1.1rem;\n  margin: 0.4rem;\n  color: ',';\n  background: ',';\n']),_templateObject16=_taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .list {\n    width: 90%;\n    margin-top: 1rem;\n    .header_list {\n      display: grid;\n      grid-template-columns: auto 50px;\n      grid-gap: 2rem;\n\n      .icon_expand {\n        justify-self: end;\n      img {\n        cursor: pointer;\n        height: 20px;\n      }\n    }\n  }\n  }\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    font-family: ',';\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.2rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n  .container_doc {\n    width: 100%,\n    height: 100%;\n  }\n'],['\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .list {\n    width: 90%;\n    margin-top: 1rem;\n    .header_list {\n      display: grid;\n      grid-template-columns: auto 50px;\n      grid-gap: 2rem;\n\n      .icon_expand {\n        justify-self: end;\n      img {\n        cursor: pointer;\n        height: 20px;\n      }\n    }\n  }\n  }\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    font-family: ',';\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.2rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n  .container_doc {\n    width: 100%,\n    height: 100%;\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  background: ',';\n  background: ',';\n  color: ',';\n  color: ',';\n  width: 33rem;\n  height: 4rem;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-size: 1.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin: ',';\n  i {\n    position: absolute;\n    left: 2rem;\n    font-size: 1.8rem;\n  }\n'],['\n  background: ',';\n  background: ',';\n  color: ',';\n  color: ',';\n  width: 33rem;\n  height: 4rem;\n  border-radius: 2rem;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  font-size: 1.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin: ',';\n  i {\n    position: absolute;\n    left: 2rem;\n    font-size: 1.8rem;\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .text {\n    font-size: 1.4rem;\n    color: gray;\n    margin: 1rem;\n  }\n  input {\n    width: 30rem;\n    height: 5rem;\n    border: none;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    border-radius: 1rem;\n    margin: 1rem;\n    padding: 2rem;\n    font-size: 1.3rem;\n  }\n  .input {\n    width: 30rem;\n    height: 5rem;\n    border: none;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    border-radius: 1rem;\n    margin: 1rem;\n    padding: 2rem;\n    font-size: 1.3rem;\n    position: relative;\n    display: flex;\n    align-items: center;\n    i {\n      font-size: 1.8rem;\n      position: absolute;\n      right: 2rem;\n    }\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  .text {\n    font-size: 1.4rem;\n    color: gray;\n    margin: 1rem;\n  }\n  input {\n    width: 30rem;\n    height: 5rem;\n    border: none;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    border-radius: 1rem;\n    margin: 1rem;\n    padding: 2rem;\n    font-size: 1.3rem;\n  }\n  .input {\n    width: 30rem;\n    height: 5rem;\n    border: none;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    border-radius: 1rem;\n    margin: 1rem;\n    padding: 2rem;\n    font-size: 1.3rem;\n    position: relative;\n    display: flex;\n    align-items: center;\n    i {\n      font-size: 1.8rem;\n      position: absolute;\n      right: 2rem;\n    }\n  }\n']),_templateObject19=_taggedTemplateLiteral(['\n  position: absolute;\n  right: 18%;\n  top: 70%;\n  width: 13rem;\n  background: white;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border-radius: 2rem;\n  padding: 1rem;\n  button {\n    margin: 0.5rem;\n    width: calc(100% - 1rem);\n    font-size: 1rem;\n    font-weight: bold;\n    padding: 0.6rem;\n    border-radius: 2rem;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  }\n\n  .edit {\n    background: #2680EB;\n    color: white;\n  }\n  .boost {\n    background: #2680EB;\n    color: white;\n  }\n  .launch {\n    background: white;\n    color: #2680EB;\n  }\n  .killButton {\n    background: #DBDBDB;\n  }\n  .delete {\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    color: #F63256;\n  }\n'],['\n  position: absolute;\n  right: 18%;\n  top: 70%;\n  width: 13rem;\n  background: white;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border-radius: 2rem;\n  padding: 1rem;\n  button {\n    margin: 0.5rem;\n    width: calc(100% - 1rem);\n    font-size: 1rem;\n    font-weight: bold;\n    padding: 0.6rem;\n    border-radius: 2rem;\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  }\n\n  .edit {\n    background: #2680EB;\n    color: white;\n  }\n  .boost {\n    background: #2680EB;\n    color: white;\n  }\n  .launch {\n    background: white;\n    color: #2680EB;\n  }\n  .killButton {\n    background: #DBDBDB;\n  }\n  .delete {\n    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n    color: #F63256;\n  }\n']),_templateObject20=_taggedTemplateLiteral(['\n    height: 6rem;\n    overflow: hidden;\n    position: relative;\n    transition: all 0.3s ease;\n\n    .opacity_gradient {\n      background: linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(20,20,20,0.5) 100%);\n      position: absolute;\n      z-index: 1;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      color: #fff;\n      text-align: center;\n      font-size: 1.8rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-family: ',';\n      cursor: pointer;\n  }\n\n  &.show_all {\n    height: 25rem;\n    .opacity_gradient {\n      display: none;\n    }\n  }\n'],['\n    height: 6rem;\n    overflow: hidden;\n    position: relative;\n    transition: all 0.3s ease;\n\n    .opacity_gradient {\n      background: linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(20,20,20,0.5) 100%);\n      position: absolute;\n      z-index: 1;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      color: #fff;\n      text-align: center;\n      font-size: 1.8rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-family: ',';\n      cursor: pointer;\n  }\n\n  &.show_all {\n    height: 25rem;\n    .opacity_gradient {\n      display: none;\n    }\n  }\n']),_templateObject21=_taggedTemplateLiteral(['\n  .chat_header {\n    display: none;\n  }\n\n  @media (max-width: ','px) {\n    .chat_wrapper {\n      top: calc(10rem + env(safe-area-inset-top));\n    }\n\n    .chat_container {\n      height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n\n      .list_messages {\n        height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n      }\n    }\n  }\n'],['\n  .chat_header {\n    display: none;\n  }\n\n  @media (max-width: ','px) {\n    .chat_wrapper {\n      top: calc(10rem + env(safe-area-inset-top));\n    }\n\n    .chat_container {\n      height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n\n      .list_messages {\n        height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n      }\n    }\n  }\n']),_templateObject22=_taggedTemplateLiteral(['\n  position: fixed;\n  z-index: 3;\n  background: rgb(0,0,0,0.5);\n  width: 100%;\n  height: 100%;\n  top: 20rem;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  @media (max-width: ','px) {\n    top: 17rem;\n  }\n'],['\n  position: fixed;\n  z-index: 3;\n  background: rgb(0,0,0,0.5);\n  width: 100%;\n  height: 100%;\n  top: 20rem;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  @media (max-width: ','px) {\n    top: 17rem;\n  }\n']),_templateObject23=_taggedTemplateLiteral(['\n  background: #2680EB;\n  border-radius: 100%;\n  font-size: 4rem;\n  color: white;\n  cursor: pointer;\n  width: 2rem;\n  height: 2rem;\n  padding: 3.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  background: #2680EB;\n  border-radius: 100%;\n  font-size: 4rem;\n  color: white;\n  cursor: pointer;\n  width: 2rem;\n  height: 2rem;\n  padding: 3.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),_templateObject24=_taggedTemplateLiteral(['\n  position: relative;\n  top: 44rem;\n  right: 4rem;\n  float: right;\n  z-index: 10000000000000;\n\n  @media (max-width: ','px) {\n    bottom: 8rem;\n    right: 2rem;\n    top: auto;\n    position: fixed;\n  }\n'],['\n  position: relative;\n  top: 44rem;\n  right: 4rem;\n  float: right;\n  z-index: 10000000000000;\n\n  @media (max-width: ','px) {\n    bottom: 8rem;\n    right: 2rem;\n    top: auto;\n    position: fixed;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ThemeTableDetailWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.color;});var TitleBack=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var DescriptionTab=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.image;},__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var FeedbackModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var DocIframe=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].iframe(_templateObject5,function(props){return props.width;},function(props){return props.height;},__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.height;});var JoinModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var LeaveTable=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7);var BtnShare=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);var BoostModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);var BoostTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10);var BoostSubtitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11);var BoostNextButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12,function(props){return props.cont?'#2680EB':'gray';});var BoostInputText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].input(_templateObject13);var BoostUrgency=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject14);var BoostUrgencyTime=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject15,function(props){return props.sel?'white':'black';},function(props){return props.sel?'#2680EB':'';});var Content=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject16,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].regularFamily);var ButtonAttach=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject17,function(props){return!props.selected?'white':'#2680EB';},function(props){return props.back;},function(props){return!props.selected?'gray':'white';},function(props){return props.color;},function(props){return props.margin;});var ContentTypes=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject18);var OptionsModal=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject19);var MinimizeCarousel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject20,__WEBPACK_IMPORTED_MODULE_3_constants_fonts__["a" ].boldFamily);var ChatTab=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject21,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var JoinTable=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject22,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var AddButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject23);var CreateTable=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject24,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1900);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(1901);
function mapStateToProps(state){return{literals:state.i18n.literals.creationThinkSeed||{},tables:state.thinkChats.myThinkChatsList};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch),updateThemeTable:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_think_seeds_actions__["l" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_unlock_svg__ = __webpack_require__(482);
 var __WEBPACK_IMPORTED_MODULE_4_assets_images_unlock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_unlock_svg__);
 var __WEBPACK_IMPORTED_MODULE_5_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Switch__ = __webpack_require__(97);
 var __WEBPACK_IMPORTED_MODULE_7_components_AutocompleteInput__ = __webpack_require__(96);
 var __WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__ = __webpack_require__(270);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function ThemeTableEdit(props){var tables=props.tables,id=props.match.params.id,literals=props.literals,updateThemeTable=props.updateThemeTable,setBreadcrumb=props.setBreadcrumb,resetAll=props.resetAll,history=props.history;var data=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(tables,{id:parseInt(id,10)});if(!data)return null;var timeDiff=Math.max(0,data.limit_date-__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix());var daysDiff=timeDiff>0?Math.floor(timeDiff/(24*3600)):0;timeDiff%=24*3600;var hoursDiff=timeDiff>0?Math.floor(timeDiff/3600):0;timeDiff%=3600;var minutesDiff=timeDiff>0?Math.floor(timeDiff/60):0;timeDiff%=60;var secondsDiff=timeDiff;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(data.name),_useState2=_slicedToArray(_useState,2),name=_useState2[0],setName=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(data.description),_useState4=_slicedToArray(_useState3,2),description=_useState4[0],setDescription=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(data.related_elements,{type:'tag'}),function(tag){return tag.name;})),_useState6=_slicedToArray(_useState5,2),tags=_useState6[0],setTags=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(data.image),_useState8=_slicedToArray(_useState7,2),image=_useState8[0],setImage=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),changeDay=_useState10[0],setChangeDay=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(daysDiff),_useState12=_slicedToArray(_useState11,2),day=_useState12[0],setDay=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(hoursDiff),_useState14=_slicedToArray(_useState13,2),hour=_useState14[0],setHour=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(minutesDiff),_useState16=_slicedToArray(_useState15,2),minute=_useState16[0],setMinute=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(secondsDiff),_useState18=_slicedToArray(_useState17,2),seconds=_useState18[0],setSeconds=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(data.is_private),_useState20=_slicedToArray(_useState19,2),enableSwitch=_useState20[0],setEnableSwitch=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState22=_slicedToArray(_useState21,2),error=_useState22[0],setError=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState24=_slicedToArray(_useState23,2),unloadedImage=_useState24[0],setUnloadedImage=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),uploadingImage=_useState26[0],setUploadingImage=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),isLoading=_useState28[0],setIsLoading=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),status=_useState30[0],setStatus=_useState30[1];var handleBackArrow=function handleBackArrow(){history.push('/theme-table/'+id);};var printBreadcrumb=function printBreadcrumb(){var breadcrumb=[{type:'back',onClick:handleBackArrow},{color:'#ffffff',text:literals.editTable}];setBreadcrumb(breadcrumb.slice());resetAll();};var printImage=function printImage(){var button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'upload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image,alt:'upload'}),literals.pressToUploadImage);var color='blue';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["k" ],{image:image,htmlFor:'document_file',color:color},!image&&!uploadingImage&&button,!image&&uploadingImage&&literals.uploading,image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'uploaded',src:image,alt:''}));};var uploadImage=function uploadImage(dataFile,nameFile){var params={data:dataFile,name:nameFile};setUploadingImage(true);Object(__WEBPACK_IMPORTED_MODULE_5_utils_apiFetch__["b" ])('POST',{endPoint:'upload-file'},params).then(function(response){var newError=error;if(error===literals.errorUploadingImage){newError=null;}setImage(response.url);setUploadingImage(false);setStatus(true);setError(newError);}).catch(function(){var newError=error;if(error===literals.errorUploadingImage){newError=null;}setImage('');setUploadingImage(false);setError(newError);});};var handleFileUpload=function handleFileUpload(event){if(event.target.files[0]!==undefined){var file=event.target.files[0];var reader=new FileReader();reader.onloadend=function(){uploadImage(reader.result,file.name);};reader.readAsDataURL(file);}};var handleChangeName=function handleChangeName(event){var value=event.target.value;setStatus(true);setName(value);};var handleChangeDescription=function handleChangeDescription(event){var value=event.target.value;setStatus(true);setDescription(value);};var handleTag=function handleTag(tag){if(!tags.includes(tag.name)){tags.push(tag.name);setStatus(true);setTags([].concat(_toConsumableArray(tags)));}};var handleChangeEnabled=function handleChangeEnabled(){setStatus(true);setEnableSwitch(!enableSwitch);};var handleRemoveTag=function handleRemoveTag(event){var tag=event.currentTarget.getAttribute('data-tag');__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(tags,function(t){return t===tag;});setTags([].concat(_toConsumableArray(tags)));setStatus(true);};var setTimeLife=function setTimeLife(event){var value=event.currentTarget.value?parseInt(event.currentTarget.value,10):0;if(Number.isNaN(value)||value<0){value=0;}setStatus(true);var attrTime=event.currentTarget.getAttribute('attr-time');setChangeDay(true);switch(attrTime){case'day':setDay(value);break;case'hour':setHour(value);break;case'minute':setMinute(value);break;case'seconds':setSeconds(value);break;default:break;}};var printTags=function printTags(){var tagList=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tags,function(tag,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["w" ],{key:index,'data-tag':tag,onClick:handleRemoveTag},tag);});if(tags.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["v" ],null,tagList);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);};var submit=function submit(){if(status&&!isLoading){var params={id:id,name:name,description:description,image:image,tags:tags.join('%_%'),private:+enableSwitch,timelimit:__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix()+day*86400+hour*1440+minute*60+seconds};setIsLoading(true);Object(__WEBPACK_IMPORTED_MODULE_5_utils_apiFetch__["b" ])('POST',{endPoint:'think-seed'},params).then(function(response){updateThemeTable(response);setIsLoading(true);history.push('/theme-table/'+id);}).catch(function(errorResponse){console.error(errorResponse);setIsLoading(false);});}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){printBreadcrumb();},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["C" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["i" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_card_wrapper'},data.more_info&&data.more_info.icon_title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["j" ],{className:'title_card_icon',icon:data.more_info.icon_title})),printImage(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'document_file',name:'document_file',style:{display:'none'},onChange:handleFileUpload,accept:'image/png, image/jpeg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["m" ],{value:name,placeholder:literals.titleName,onChange:handleChangeName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["l" ],{value:description,placeholder:literals.description,onChange:handleChangeDescription}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["x" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_AutocompleteInput__["a" ],{canCreateNew:true,type:'tag',placeholder:literals.tags,selectedOptions:[],onSelectOption:handleTag,onCreateOption:handleTag})),printTags(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["y" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.timeLife),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time_life'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'2','attr-time':'day',value:day,onChange:setTimeLife,placeholder:'00'}),' days : ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'2','attr-time':'hour',value:hour,onChange:setTimeLife,placeholder:'00'}),' hours : ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'2','attr-time':'minute',value:minute,onChange:setTimeLife,placeholder:'00'}),' min : ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'2','attr-time':'seconds',value:seconds,onChange:setTimeLife,placeholder:'00'}),' sec')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["u" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.privateTable),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4_assets_images_unlock_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Switch__["a" ],{checked:enableSwitch,size:'small',onChange:handleChangeEnabled,name:'check_enabled',color:'primary'}),literals.onlyInvited)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CreationThinkSeed_components_styles__["a" ],{status:status,onClick:submit},isLoading?literals.saving:literals.accept)));}ThemeTableEdit.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,tables:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,updateThemeTable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (ThemeTableEdit);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1903);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1904);
function mapStateToProps(state){return{app:state.app,literals:state.i18n.literals.callforImpactHall||{},calls:state.narratives.list,chats:state.chats.chats};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_components_ChatRoom__ = __webpack_require__(111);
 var __WEBPACK_IMPORTED_MODULE_5_components_People__ = __webpack_require__(459);
 var __WEBPACK_IMPORTED_MODULE_6_components_Topics__ = __webpack_require__(461);
 var __WEBPACK_IMPORTED_MODULE_7_components_Agenda__ = __webpack_require__(136);
 var __WEBPACK_IMPORTED_MODULE_8_components_Content__ = __webpack_require__(267);
 var __WEBPACK_IMPORTED_MODULE_9_components_ElementsHall__ = __webpack_require__(474);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_icons_arrow_back_button_svg__ = __webpack_require__(1905);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_icons_arrow_back_button_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_assets_images_icons_arrow_back_button_svg__);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_icons_call_white_svg__ = __webpack_require__(1906);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_icons_call_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_images_icons_call_white_svg__);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_grey_arrow_right_svg__ = __webpack_require__(240);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_grey_arrow_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_images_grey_arrow_right_svg__);
 var __WEBPACK_IMPORTED_MODULE_13_components_Countdown__ = __webpack_require__(69);
 var __WEBPACK_IMPORTED_MODULE_14_constants_chat__ = __webpack_require__(216);
 var __WEBPACK_IMPORTED_MODULE_15_utils_calls__ = __webpack_require__(183);
 var __WEBPACK_IMPORTED_MODULE_16_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_17__styles__ = __webpack_require__(1907);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function CallForImpactHall(props){var literals=props.literals,app=props.app,setBreadcrumb=props.setBreadcrumb,calls=props.calls,resetAll=props.resetAll,chats=props.chats,_props$match$params=props.match.params,defaultSection=_props$match$params.section,id=_props$match$params.id,history=props.history;var data=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(calls,{id:parseInt(id,10)});var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),chat=_useState2[0],setChat=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),collapseChat=_useState4[0],setCollapseChat=_useState4[1];var handleCollapseChat=function handleCollapseChat(){setCollapseChat(!collapseChat);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var callForImpactChat=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(chats,{element_related:{type_id:__WEBPACK_IMPORTED_MODULE_14_constants_chat__["a" ],id:data.id}});setChat(Object.assign({},callForImpactChat));},[]);var showChatInLateral=function showChatInLateral(){if(window.outerWidth<__WEBPACK_IMPORTED_MODULE_16_constants_breakPoints__["a" ]){return false;}return true;};// Breadcrumb
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var breadcrumb=[{type:'back'},{color:'#ffffff',text:data?data.name:literals.networkingHall}];setBreadcrumb(breadcrumb.slice());resetAll();},[calls,id]);// Events
var goToCall=function goToCall(){history.push(Object(__WEBPACK_IMPORTED_MODULE_15_utils_calls__["a" ])(data));};var goBack=function goBack(){history.push('/initiatives');};var toggleCollapse=function toggleCollapse(){setCollapseChat(!collapseChat);};// Handle tabs
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultSection||'content'),_useState6=_slicedToArray(_useState5,2),selectedTab=_useState6[0],setSelectedTab=_useState6[1];var selectTab=function selectTab(event){var currentTarget=event.currentTarget;var section=currentTarget.getAttribute('data-section');history.push('/calls/'+id+'/hall/'+section);setSelectedTab(section);};var printChatTab=function printChatTab(){if(!chat){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ChatRoom__["a" ],{key:chat.id,chatId:chat.id,isTab:true});};var openDoc=function openDoc(){var urlDoc='https://docs.google.com/document/d/'+data.conclusions_document_id+'/edit?usp=sharing';window.open(urlDoc);};var printContentTab=function printContentTab(){var agenda=null;var content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Content__["a" ],{narratives:data.narratives,content:data.content});if(data.meetings.length||data.speed_datings.length){agenda=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Agenda__["a" ],{meetings:data.meetings,speedDatings:data.speed_datings});}var showChat=showChatInLateral()&&chat;var urlDoc='https://docs.google.com/document/d/'+data.conclusions_document_id+'/edit?usp=sharing&overridemobile=true&fd=true&rm=minimal&headers=false';var conclusionsDoc=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_section'},literals.conclusionsAndInsights,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button_header',onClick:openDoc},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_button_header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-external-link-alt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'placeholder_button_header'},literals.fullEdit))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styles__["c" ],{width:'100%',height:'119rem',scrolling:'yes',src:urlDoc}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styles__["b" ],{className:showChat?'with_chat':'',style:{gridTemplateColumns:collapseChat?'100% 0%':'59% 39%',gap:collapseChat?'0':'2rem'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_layer'},agenda,content,conclusionsDoc)),showChat&&!collapseChat&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat_lateral'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ChatRoom__["a" ],{key:chat.id,chatId:chat.id,onCollapse:toggleCollapse})));};var printCurrentTab=function printCurrentTab(){switch(selectedTab){case'people':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_People__["a" ],{elementType:'call_for_impact',elementId:id});case'topics':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Topics__["a" ],{elementType:'call_for_impact',elementId:id});case'chat':return printChatTab();case'content':return printContentTab();case app.main_element:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_ElementsHall__["a" ],{type:app.main_element,elementType:'call_for_impact',elementId:id});default:return null;}};var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),dateEvent=_useState8[0],setDateEvent=_useState8[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var minDateEvent=null;var today=__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');data.meetings.forEach(function(meeting){var meetingDay=__WEBPACK_IMPORTED_MODULE_3_moment___default()(meeting.start_date,'X').format('YYYY-MM-DD');if(meetingDay>=today&&(!minDateEvent||meeting.start_date<minDateEvent)){minDateEvent=meeting.start_date;}});data.speed_datings.forEach(function(meeting){var meetingDay=__WEBPACK_IMPORTED_MODULE_3_moment___default()(meeting.start_date,'X').format('YYYY-MM-DD');if(meetingDay>=today&&(!minDateEvent||meeting.start_date<minDateEvent)){minDateEvent=meeting.start_date;}});setDateEvent(minDateEvent);},[calls,id]);var showHeader=window.outerWidth>__WEBPACK_IMPORTED_MODULE_16_constants_breakPoints__["b" ]||selectedTab!=='chat';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styles__["a" ],null,showHeader?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header',style:{backgroundImage:'url('+data.image+')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10_assets_images_icons_arrow_back_button_svg___default.a,className:'clickable',alt:'',onClick:goBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11_assets_images_icons_call_white_svg___default.a,className:'call_icon',alt:''}),data.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},data.description),dateEvent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time_limit'},literals.liveEvent+': '+__WEBPACK_IMPORTED_MODULE_3_moment___default()(dateEvent,'X').format('DD-MM-YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Countdown__["a" ],{time:dateEvent})):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:goToCall},literals.start))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab==='content'?'selected':''),'data-section':'content',onClick:selectTab},literals.contentTag),chat&&!showChatInLateral()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab==='chat'?'selected':''),'data-section':'chat',onClick:selectTab},literals.chat):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab==='topics'?'selected':''),'data-section':'topics',onClick:selectTab},literals.topics),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab==='people'?'selected':''),'data-section':'people',onClick:selectTab},literals.people),collapseChat&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'expand',onClick:handleCollapseChat},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12_assets_images_grey_arrow_right_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,literals.chat)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab_content'},printCurrentTab())));}CallForImpactHall.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,calls:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,chats:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};CallForImpactHall.defaultProps={calls:[],chats:[]}; __webpack_exports__["a"] = (CallForImpactHall);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow_back_button.76bc71e3.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_white.d249393c.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return CallHall; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ContentTab; });

 __webpack_require__.d(__webpack_exports__, "c", function() { return DocIframe; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  > .header {\n    height: 20rem;\n    position: relative;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: 50% 50%;\n\n    > .content {\n      padding: 3rem;\n      position: relative;\n      z-index: 10;\n      > .name {\n        color: #fff;\n        font-size: 2.7rem;\n\n        @media (max-width: ','px) {\n          font-size: 1.8rem;\n        }\n\n        img {\n          margin-right: 0.5rem;\n\n          &.call_icon {\n            width: 2rem;\n          }\n        }\n      }\n\n      .description {\n        color: #fff;\n        font-size: 1.4rem;\n        margin-top: 0.5rem;\n        line-height: 1.8rem;\n        height: 5rem;\n        overflow: auto;\n      }\n\n      > .time_limit {\n        color: #fff;\n        font-size: 1.3rem;\n        margin-top: 0.5rem;\n        @media (max-width: ','px) {\n          font-size: 1.1rem;\n        }\n      }\n\n      > .countdown {\n        font-size: 1.3rem;\n        margin-top: 0.5rem;\n        @media (max-width: ','px) {\n          font-size: 1.1rem;\n        }\n      }\n    }\n\n    > .opacity {\n      position: absolute;\n      z-index: 1;\n      background: rgba(0, 0, 0, 0.5);\n      width: 100%;\n      height: 100%;\n    }\n\n    > .buttons {\n      position: absolute;\n      z-index: 10;\n      width: 100%;\n      bottom: 2rem;\n      text-align: center;\n      button {\n        min-width: 10rem;\n      }\n    }\n  }\n  .tabs {\n    background-color: #fff;\n\n    @media (max-width: ','px) {\n      position: sticky;\n      top: 0rem;\n      border-bottom: 1px solid #eee;\n      z-index: 10;\n    }\n  }\n\n  .tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  &.gray {\n    background-color: #D9D9D9;\n\n    .tab {\n      color: #000;\n      &.selected {\n        border-bottom: 2px solid #000;\n      }\n    }\n  }\n\n  .chat_header {\n\n    @media (max-width: ','px) {\n      display: none;\n    }\n  }\n\n  .expand {\n    display: inline-block;\n    background-color: #2680EB;\n    height: 6rem;\n    float: right;\n    padding: 1rem;\n    text-align: center;\n    font-size: 1.5rem;\n    cursor: pointer;\n\n    img {\n      transform: rotateY(180deg);\n    }\n\n    p {\n      color: white;\n      font-weight: 600;\n    }\n  }\n\n  .chat_container {\n    height: calc(100vh - 40.5rem);\n\n    .list_messages {\n      height: calc(100vh - 40.5rem);\n    }\n  }\n\n  .chat_lateral {\n    box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px;\n  }\n'],['\n  > .header {\n    height: 20rem;\n    position: relative;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: 50% 50%;\n\n    > .content {\n      padding: 3rem;\n      position: relative;\n      z-index: 10;\n      > .name {\n        color: #fff;\n        font-size: 2.7rem;\n\n        @media (max-width: ','px) {\n          font-size: 1.8rem;\n        }\n\n        img {\n          margin-right: 0.5rem;\n\n          &.call_icon {\n            width: 2rem;\n          }\n        }\n      }\n\n      .description {\n        color: #fff;\n        font-size: 1.4rem;\n        margin-top: 0.5rem;\n        line-height: 1.8rem;\n        height: 5rem;\n        overflow: auto;\n      }\n\n      > .time_limit {\n        color: #fff;\n        font-size: 1.3rem;\n        margin-top: 0.5rem;\n        @media (max-width: ','px) {\n          font-size: 1.1rem;\n        }\n      }\n\n      > .countdown {\n        font-size: 1.3rem;\n        margin-top: 0.5rem;\n        @media (max-width: ','px) {\n          font-size: 1.1rem;\n        }\n      }\n    }\n\n    > .opacity {\n      position: absolute;\n      z-index: 1;\n      background: rgba(0, 0, 0, 0.5);\n      width: 100%;\n      height: 100%;\n    }\n\n    > .buttons {\n      position: absolute;\n      z-index: 10;\n      width: 100%;\n      bottom: 2rem;\n      text-align: center;\n      button {\n        min-width: 10rem;\n      }\n    }\n  }\n  .tabs {\n    background-color: #fff;\n\n    @media (max-width: ','px) {\n      position: sticky;\n      top: 0rem;\n      border-bottom: 1px solid #eee;\n      z-index: 10;\n    }\n  }\n\n  .tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  &.gray {\n    background-color: #D9D9D9;\n\n    .tab {\n      color: #000;\n      &.selected {\n        border-bottom: 2px solid #000;\n      }\n    }\n  }\n\n  .chat_header {\n\n    @media (max-width: ','px) {\n      display: none;\n    }\n  }\n\n  .expand {\n    display: inline-block;\n    background-color: #2680EB;\n    height: 6rem;\n    float: right;\n    padding: 1rem;\n    text-align: center;\n    font-size: 1.5rem;\n    cursor: pointer;\n\n    img {\n      transform: rotateY(180deg);\n    }\n\n    p {\n      color: white;\n      font-weight: 600;\n    }\n  }\n\n  .chat_container {\n    height: calc(100vh - 40.5rem);\n\n    .list_messages {\n      height: calc(100vh - 40.5rem);\n    }\n  }\n\n  .chat_lateral {\n    box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  @media (max-width: ','px) {\n    padding: 0 1rem;\n  }\n  .content_layer {\n    @media (min-width: ','px) {\n      width: calc(100% - 20rem);\n      margin: 0 auto;\n    }\n  }\n\n  &.with_chat {\n    display: grid;\n    grid-template-columns: 59% 39%;\n    gap: 2rem;\n\n    .content_wrapper {\n      height: calc(100vh - 30rem);\n      overflow: auto;\n      padding-bottom: 3rem;\n    }\n  }\n'],['\n  @media (max-width: ','px) {\n    padding: 0 1rem;\n  }\n  .content_layer {\n    @media (min-width: ','px) {\n      width: calc(100% - 20rem);\n      margin: 0 auto;\n    }\n  }\n\n  &.with_chat {\n    display: grid;\n    grid-template-columns: 59% 39%;\n    gap: 2rem;\n\n    .content_wrapper {\n      height: calc(100vh - 30rem);\n      overflow: auto;\n      padding-bottom: 3rem;\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  @media (max-width: ','px) {\n    .chat_wrapper {\n      top: calc(10rem + env(safe-area-inset-top));\n    }\n\n    .chat_container {\n      height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n\n      .list_messages {\n        height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n      }\n    }\n  }\n'],['\n  @media (max-width: ','px) {\n    .chat_wrapper {\n      top: calc(10rem + env(safe-area-inset-top));\n    }\n\n    .chat_container {\n      height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n\n      .list_messages {\n        height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: ',';\n  height: ',';\n  margin-top: 1rem;\n  border: 0px;\n  background-color: #fff;\n  margin-bottom: 2rem;\n\n  @media (max-width: ','px) {\n    height: ',';\n  }\n'],['\n  width: ',';\n  height: ',';\n  margin-top: 1rem;\n  border: 0px;\n  background-color: #fff;\n  margin-bottom: 2rem;\n\n  @media (max-width: ','px) {\n    height: ',';\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CallHall=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var ContentTab=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var ChatTab=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var DocIframe=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].iframe(_templateObject4,function(props){return props.width;},function(props){return props.height;},__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],function(props){return props.height;});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1909);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1910);
function mapStateToProps(state){return{literals:state.i18n.literals.noRecommendations||{}};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_assets_images_icons_bg_all_caught_svg__ = __webpack_require__(1911);
 var __WEBPACK_IMPORTED_MODULE_2_assets_images_icons_bg_all_caught_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_images_icons_bg_all_caught_svg__);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_icons_all_caught_svg__ = __webpack_require__(1912);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_icons_all_caught_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_icons_all_caught_svg__);
 var __WEBPACK_IMPORTED_MODULE_4_components_OngoingActivity__ = __webpack_require__(591);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1913);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function NoRecommendations(props){var literals=props.literals,resetAll=props.resetAll,setBreadcrumb=props.setBreadcrumb;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showOngoingActivity=_useState2[0],setOngoingActivity=_useState2[1];var handleToggleOngoingActivity=function handleToggleOngoingActivity(){setOngoingActivity(!showOngoingActivity);};// Breadcrumb
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var breadcrumb=[{color:'#ffffff',text:literals.comebackLater}];setBreadcrumb(breadcrumb.slice());resetAll();},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2_assets_images_icons_bg_all_caught_svg___default.a,alt:'',className:'bg_icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_assets_images_icons_all_caught_svg___default.a,alt:'',className:'img_icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},literals.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:handleToggleOngoingActivity},literals.jumpTo)),showOngoingActivity?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ongoing_title',dangerouslySetInnerHTML:{__html:literals.yourOngoingActivity}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_OngoingActivity__["a" ],null)):null);}NoRecommendations.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (NoRecommendations);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg_all_caught.d8a7d36c.svg";

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/all_caught.434b73bd.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return NoRecommendationsStylized; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 2rem 0;\n\n  > .content {\n    width: 80rem;\n    max-width: 90%;\n    margin: 0 auto;\n    text-align: center;\n    position: relative;\n    .bg_icon {\n\n    }\n\n    .img_icon {\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      top: 5rem;\n    }\n\n    .title {\n      margin: 2rem;\n      color: ',';\n      font-size: 3.2rem;\n    }\n\n    .description {\n      color: ',';\n      font-size: 1.7rem;\n      margin-bottom: 2rem;\n    }\n  }\n\n  .ongoing_title {\n    color: ',';\n    font-size: 1.7rem;\n    margin-top: 4rem;\n    margin: 4rem 2rem 2rem;\n  }\n\n  .simple_carousel {\n    padding-left: 2rem;\n    margin-bottom: 4rem;\n  }\n'],['\n  padding: 2rem 0;\n\n  > .content {\n    width: 80rem;\n    max-width: 90%;\n    margin: 0 auto;\n    text-align: center;\n    position: relative;\n    .bg_icon {\n\n    }\n\n    .img_icon {\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      top: 5rem;\n    }\n\n    .title {\n      margin: 2rem;\n      color: ',';\n      font-size: 3.2rem;\n    }\n\n    .description {\n      color: ',';\n      font-size: 1.7rem;\n      margin-bottom: 2rem;\n    }\n  }\n\n  .ongoing_title {\n    color: ',';\n    font-size: 1.7rem;\n    margin-top: 4rem;\n    margin: 4rem 2rem 2rem;\n  }\n\n  .simple_carousel {\n    padding-left: 2rem;\n    margin-bottom: 4rem;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var NoRecommendationsStylized=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_colors__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1915);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1916);
function mapStateToProps(state){return{literals:state.i18n.literals.callforImpactHall||{},app:state.app,calls:state.narratives.list,speedDatingMeetings:state.speedDating.meetings,actualUser:state.session.user};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_5_utils_string__ = __webpack_require__(67);
 var __WEBPACK_IMPORTED_MODULE_6_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_7_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_8_components_Agenda__ = __webpack_require__(136);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_think_googleCalendar_png__ = __webpack_require__(1917);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_think_googleCalendar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_images_think_googleCalendar_png__);
 var __WEBPACK_IMPORTED_MODULE_10_components_Countdown__ = __webpack_require__(69);
 var __WEBPACK_IMPORTED_MODULE_11_components_Steps_Faces__ = __webpack_require__(95);
 var __WEBPACK_IMPORTED_MODULE_12_components_Content__ = __webpack_require__(267);
 var __WEBPACK_IMPORTED_MODULE_13_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_14_components_Cards_ElementSimpleCard__ = __webpack_require__(265);
 var __WEBPACK_IMPORTED_MODULE_15_components_Cards_ThemeTableCard__ = __webpack_require__(117);
 var __WEBPACK_IMPORTED_MODULE_16_utils_calls__ = __webpack_require__(183);
 var __WEBPACK_IMPORTED_MODULE_17_components_UsersModal__ = __webpack_require__(50);
 var __WEBPACK_IMPORTED_MODULE_18_assets_images_callIcon_svg__ = __webpack_require__(592);
 var __WEBPACK_IMPORTED_MODULE_18_assets_images_callIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_assets_images_callIcon_svg__);
 var __WEBPACK_IMPORTED_MODULE_19__styles__ = __webpack_require__(1918);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function Call(props){var literals=props.literals,app=props.app,setBreadcrumb=props.setBreadcrumb,calls=props.calls,resetAll=props.resetAll,id=props.match.params.id,history=props.history,actualUser=props.actualUser;var data=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(calls,{id:parseInt(id,10)});// Breadcrumb
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var breadcrumb=[{color:'#ffffff',text:data?data.name:literals.networkingHall}];setBreadcrumb(breadcrumb.slice());resetAll();},[calls,id]);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),topics=_useState2[0],setTopics=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState4=_slicedToArray(_useState3,2),selectedTopic=_useState4[0],setSelectedTopic=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),tags=_useState6[0],setTags=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState8=_slicedToArray(_useState7,2),people=_useState8[0],setPeople=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState10=_slicedToArray(_useState9,2),selectedTags=_useState10[0],setSelectedTags=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState12=_slicedToArray(_useState11,2),relatedNarratives=_useState12[0],setRelatedNarratives=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState14=_slicedToArray(_useState13,2),selectedUser=_useState14[0],setSelectedUser=_useState14[1];var elementType='call_for_impact';var elementId=id;var searchPeople=function searchPeople(){var params={};if(elementType){params.element_type=elementType;}if(elementId){params.element_id=elementId;}setPeople([]);Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('GET',{endPoint:'networking-hall/people'},params).then(function(response){setPeople(response.data);});};var searchTopics=function searchTopics(){var params={};if(elementType){params.element_type=elementType;}if(elementId){params.element_id=elementId;}setSelectedTopic(0);setTopics([]);setTags([]);Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('GET',{endPoint:'networking-hall/topics'},params).then(function(response){var finalTags=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(response.data,function(topic){if(typeof topic.related_elements!=='undefined'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topic.related_elements,function(element){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(finalTags,{id:element.id})){finalTags.push(element);}});}});setTags(finalTags);setTopics(response.data);});};var getRelatedNarratives=function getRelatedNarratives(){setRelatedNarratives([]);var params={};if(elementId){params.call_for_impact=elementId;}Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('GET',{endPoint:'narratives'},params).then(function(response){setRelatedNarratives(response);});};var handleSelectUser=function handleSelectUser(userId){setSelectedUser(userId);};var removeSelectedUser=function removeSelectedUser(){setSelectedUser(null);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){searchTopics();getRelatedNarratives();searchPeople();},[elementType,elementId]);var usersModalMemo=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!selectedUser){return null;}var usersIds=[];people.forEach(function(tmpUser){if(tmpUser.id!==actualUser.id){usersIds.push(tmpUser.id);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_UsersModal__["a" ],{usersIds:usersIds,userSelected:selectedUser,onEnd:removeSelectedUser});},[selectedUser]);var createTable=function createTable(){history.push(__WEBPACK_IMPORTED_MODULE_6_constants_urls__["Q" ]);};var printTags=function printTags(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(tags,function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag gray '+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(selectedTags,function(selectedTag){return selectedTag===tag.id;})?'selected':''),key:tag.id,'data-id':tag.id},tag.name);});};var printUsers=function printUsers(){if(!people.length){return null;}var title=literals.peopleInAllTables;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},people.length),literals.people),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scroll_users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Steps_Faces__["a" ],{options:people,colorText:'black',onClick:handleSelectUser,onLongPress:handleSelectUser})));};var printMainElements=function printMainElements(){if(!app.main_element){return null;}var mainElements=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(topics,function(_ref){var users=_ref.users;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(users,function(_ref2){var elements=_ref2.elements;if(typeof elements[app.main_element]!=='undefined'&&elements[app.main_element].length){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(elements[app.main_element],function(element){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(mainElements,{id:element.id})){mainElements.push(element);}});}});});if(!mainElements.length){return null;}var title=(literals.elements[app.main_element]||Object(__WEBPACK_IMPORTED_MODULE_5_utils_string__["a" ])(app.main_element))+' ';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tables'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},mainElements.length),title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_SimpleCarousel__["a" ],{classesList:'simple_card_element',showButtons:true},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(mainElements,function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Cards_ElementSimpleCard__["a" ],{data:element,key:element.id,classesList:['simple_card_element']});})))));};var handleClickTable=function handleClickTable(tableId){history.push('/calls/'+id+'/theme-table/'+tableId);};var printTables=function printTables(){var chatNum=topics.length;if(chatNum===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tables'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},chatNum),literals.tables),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_SimpleCarousel__["a" ],{classesList:'theme_table_card',showButtons:true},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(topics,function(think){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Cards_ThemeTableCard__["a" ],{key:think.id,data:think,row:true,onClick:handleClickTable});})));};var printAgenda=function printAgenda(){if(!data.meetings.length&&!data.speed_datings.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Agenda__["a" ],{meetings:data.meetings,speedDatings:data.speed_datings}));};var printContent=function printContent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Content__["a" ],{narratives:data.narratives,content:data.content});};var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),calendar=_useState16[0],setCalendar=_useState16[1];var changeCalendar=function changeCalendar(){setCalendar(!calendar);};var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState18=_slicedToArray(_useState17,2),dateEvent=_useState18[0],setDateEvent=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),isLoadingCalendar=_useState20[0],setIsLoadingCalendar=_useState20[1];var calendarGoogle=function calendarGoogle(){var startTime=new Date(data.time_limit*1000).toISOString();var endTime=new Date(data.time_limit*1000+data.intro_meeting_duration*60000).toISOString();startTime=startTime.replace(/-/g,'');startTime=startTime.replace(/:/g,'');startTime=startTime.replace(/\./g,'');endTime=endTime.replace(/-/g,'');endTime=endTime.replace(/:/g,'');endTime=endTime.replace(/\./g,'');var url='http://www.google.com/calendar/event?action=TEMPLATE&text='+encodeURIComponent(data.name)+'&dates='+startTime+'/'+endTime+'&details=';if(data.zoom_meeting){setIsLoadingCalendar(true);Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('GET',{endPoint:'zoom/meetings/'+data.zoom_meeting}).then(function(response){setIsLoadingCalendar(false);var zoom='<a target=\'_blank\' href=\''+response.data.join_url+'\'>'+response.data.join_url+'</a>';url=''+url+encodeURIComponent(zoom);window.open(url);});}else{window.open(url);}};// Events
var goToCall=function goToCall(){history.push(Object(__WEBPACK_IMPORTED_MODULE_16_utils_calls__["a" ])(data));};var goToHall=function goToHall(){history.push('/calls/'+id+'/hall');};var goBack=function goBack(){history.push('/initiatives');};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(data){var events=[];var actualTime=__WEBPACK_IMPORTED_MODULE_3_moment___default()().unix();data.meetings.forEach(function(meeting){if(meeting.start_date>=actualTime){events.push(meeting.start_date);}});data.speed_datings.forEach(function(speedDating){if(speedDating.start_date>=actualTime){events.push(speedDating.start_date);}});if(events.length){var date=Math.min(events);setDateEvent(date);}else{setDateEvent(null);}}},[data]);if(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["e" ],null,usersModalMemo,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["g" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["a" ],{onClick:createTable},'+')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'callInfo',url:data.image,style:{backgroundImage:'url('+data.image+')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'opacity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-arrow-left',onClick:goBack})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_18_assets_images_callIcon_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},data.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live_event'},dateEvent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date'},literals.liveEvent+': '+__WEBPACK_IMPORTED_MODULE_3_moment___default()(dateEvent,'X').format('DD/MM/YYYY')):null),dateEvent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'starting'},literals.startingAt,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Countdown__["a" ],{time:dateEvent,enabled:true})):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},data.progress===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'main_button',onClick:goToCall},literals.joinEvent),data.progress>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'main_button',onClick:goToCall},literals.reView),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'sec_button',onClick:goToHall},literals.eventHall))),calendar&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'addToCalendarWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["d" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-times-circle close_icon',onClick:changeCalendar})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.addToCalendar),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icons'},isLoadingCalendar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'10rem',height:'10rem'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_LoadingComponent__["a" ],{colorAnimation:data.color})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon',onClick:calendarGoogle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_assets_images_think_googleCalendar_png___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon_name'},'Google Calendar'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_call'},tags.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["j" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters_tags'},printTags())):null,data.description?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["h" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc'},data.description)):null,printAgenda(),topics.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["i" ],null,printTables()):null,data.narratives.length&&data.content.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_list'},printContent())):null,printMainElements(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["k" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'users'},printUsers())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'10vh'}})));}return null;}Call.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,calls:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,actualUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};Call.defaultProps={calls:[]}; __webpack_exports__["a"] = (Call);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/googleCalendar.fa5a1ef6.png";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "e", function() { return CallHall; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return Description; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return AgendaWrapper; });
 __webpack_require__.d(__webpack_exports__, "j", function() { return Tags; });
 __webpack_require__.d(__webpack_exports__, "k", function() { return Users; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return Content; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return Tables; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return Affiliations; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return CalendarWrapper; });


 __webpack_require__.d(__webpack_exports__, "a", function() { return AddButton; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return CreateTable; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_3_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  .content_call {\n    width: calc(100% - 6rem);\n    margin: 0 auto;\n\n    @media (max-width: ','px) {\n      width: 100%;\n    }\n  }\n  .callInfo {\n    height: 15rem;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    position: relative;\n    .opacity {\n      position: absolute;\n      z-index: 1;\n      background: rgb(255,255,255);\n      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.5) 100%);\n      width: 100%;\n      height: 100%;\n    }\n\n    .back {\n      height: 70%;\n      width: 4%;\n      display: flex;\n      justify-content: flex-end;\n      z-index: 2;\n      i {\n        font-size: 2rem;\n        cursor: pointer;\n        color: white;\n      }\n    }\n    img {\n      height: 80%;\n      width: 20%;\n      z-index: 2;\n    }\n    .data {\n      height: 70%;\n      width: 40%;\n      color: white;\n      z-index: 2;\n      .name {\n        font-size: 1.8rem;\n        font-weight: 800;\n        margin: 1rem;\n      }\n      .live_event {\n        font-size: 1.4rem;\n        margin: 1rem;\n      }\n      .starting {\n        font-size: 1.4rem;\n        margin: 1rem;\n        display: flex;\n        align-items: center;\n      }\n    }\n    .buttons {\n      height: 80%;\n      width: 31%;\n      display: flex;\n      align-items: flex-end;\n      flex-direction: column;\n      z-index: 2;\n      .main_button {\n        width: 10rem;\n        font-size: 1.2rem;\n        background: #2680EB;\n        color: white;\n        padding: 1rem;\n        margin: 1rem;\n        border-radius: 2rem;\n        text-transform: uppercase;\n      }\n      .sec_button {\n        width: 10rem;\n        font-size: 1.2rem;\n        background: white;\n        color: #2680EB;\n        padding: 1rem;\n        margin: 1rem;\n        border-radius: 2rem;\n        text-transform: uppercase;\n      }\n    }\n    @media (max-width: ','px) {\n      height: 12rem;\n      position: relative;\n      .back {\n        display: none;\n      }\n      img {\n        height: 80%;\n        width: 30%;\n      }\n      .data {\n        height: 70%;\n        width: 70%;\n        .name {\n          font-size: 1.2rem;\n        }\n        .live_event {\n          font-size: 1rem;\n        }\n        .starting {\n          font-size: 1rem;\n        }\n      }\n      .buttons {\n        height: 80%;\n        width: 50%;\n        display: flex;\n        flex-direction: row;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        .main_button {\n          width: 7rem;\n          font-size: 0.9rem;\n          font-weight: bold;\n          background: #2680EB;\n          color: white;\n          padding: 0.5rem;\n          margin: 1rem;\n          border-radius: 2rem;\n          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n          text-transform: none;\n        }\n        .sec_button {\n          width: 7rem;\n          font-size: 0.9rem;\n          font-weight: bold;\n          border: none;\n          background: white;\n          color: #2680EB;\n          padding: 0.5rem;\n          margin: 1rem;\n          border-radius: 2rem;\n          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n          text-transform: none;\n        }\n      }\n    }\n  }\n  .secondary {\n    border-radius: 20px;\n    font-size: 15px;\n    border: 0px;\n    color: #1976d2;\n    background-color: #fff;\n    -webkit-box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n    padding: 10px 20px;\n    letter-spacing: 1px;\n  }\n\n  .add_to_calendar {\n    font-family: ','\n    font-size: 1.3rem;\n    font-weight: ','\n    color: ','\n    justify-content: center;\n    margin-bottom: 15px;\n    text-shadow: 1px 3px 3px rgb(0 0 0);\n    cursor: pointer;\n  }\n\n  .addToCalendarWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 25rem;\n  }\n\n  > .header {\n    height: 20rem;\n    position: relative;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: 50% 50%;\n\n    > .content {\n      padding: 3rem;\n      position: relative;\n      z-index: 10;\n      > .name {\n        color: #fff;\n        font-size: 2.7rem;\n\n        @media (max-width: ','px) {\n          font-size: 1.8rem;\n        }\n\n        img {\n          margin-right: 0.5rem;\n\n          &.call_icon {\n            width: 2rem;\n          }\n        }\n      }\n\n      > .time_limit {\n        color: #fff;\n        font-size: 1.3rem;\n        margin: 1rem 0 0.5rem;\n        @media (max-width: ','px) {\n          font-size: 1.1rem;\n        }\n      }\n\n      > .starting_in {\n        display: inline-block;\n        color: #fff;\n        font-size: 1.3rem;\n        margin-right: 0.5rem;\n      }\n\n      > .countdown {\n        display: inline-block;\n        font-size: 1.3rem;\n        margin-top: 0.5rem;\n        @media (max-width: ','px) {\n          font-size: 1.1rem;\n        }\n      }\n    }\n\n    > .opacity {\n      position: absolute;\n      z-index: 1;\n      background: rgb(255,255,255);\n      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.5) 100%);\n      width: 100%;\n      height: 100%;\n    }\n\n    > .buttons {\n      position: absolute;\n      z-index: 10;\n      width: 100%;\n      bottom: 2rem;\n      text-align: center;\n      button {\n        min-width: 10rem;\n      }\n    }\n  }\n\n  .tabs {\n    background-color: #fff;\n  }\n\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.1rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n'],['\n  .content_call {\n    width: calc(100% - 6rem);\n    margin: 0 auto;\n\n    @media (max-width: ','px) {\n      width: 100%;\n    }\n  }\n  .callInfo {\n    height: 15rem;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    position: relative;\n    .opacity {\n      position: absolute;\n      z-index: 1;\n      background: rgb(255,255,255);\n      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.5) 100%);\n      width: 100%;\n      height: 100%;\n    }\n\n    .back {\n      height: 70%;\n      width: 4%;\n      display: flex;\n      justify-content: flex-end;\n      z-index: 2;\n      i {\n        font-size: 2rem;\n        cursor: pointer;\n        color: white;\n      }\n    }\n    img {\n      height: 80%;\n      width: 20%;\n      z-index: 2;\n    }\n    .data {\n      height: 70%;\n      width: 40%;\n      color: white;\n      z-index: 2;\n      .name {\n        font-size: 1.8rem;\n        font-weight: 800;\n        margin: 1rem;\n      }\n      .live_event {\n        font-size: 1.4rem;\n        margin: 1rem;\n      }\n      .starting {\n        font-size: 1.4rem;\n        margin: 1rem;\n        display: flex;\n        align-items: center;\n      }\n    }\n    .buttons {\n      height: 80%;\n      width: 31%;\n      display: flex;\n      align-items: flex-end;\n      flex-direction: column;\n      z-index: 2;\n      .main_button {\n        width: 10rem;\n        font-size: 1.2rem;\n        background: #2680EB;\n        color: white;\n        padding: 1rem;\n        margin: 1rem;\n        border-radius: 2rem;\n        text-transform: uppercase;\n      }\n      .sec_button {\n        width: 10rem;\n        font-size: 1.2rem;\n        background: white;\n        color: #2680EB;\n        padding: 1rem;\n        margin: 1rem;\n        border-radius: 2rem;\n        text-transform: uppercase;\n      }\n    }\n    @media (max-width: ','px) {\n      height: 12rem;\n      position: relative;\n      .back {\n        display: none;\n      }\n      img {\n        height: 80%;\n        width: 30%;\n      }\n      .data {\n        height: 70%;\n        width: 70%;\n        .name {\n          font-size: 1.2rem;\n        }\n        .live_event {\n          font-size: 1rem;\n        }\n        .starting {\n          font-size: 1rem;\n        }\n      }\n      .buttons {\n        height: 80%;\n        width: 50%;\n        display: flex;\n        flex-direction: row;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        .main_button {\n          width: 7rem;\n          font-size: 0.9rem;\n          font-weight: bold;\n          background: #2680EB;\n          color: white;\n          padding: 0.5rem;\n          margin: 1rem;\n          border-radius: 2rem;\n          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n          text-transform: none;\n        }\n        .sec_button {\n          width: 7rem;\n          font-size: 0.9rem;\n          font-weight: bold;\n          border: none;\n          background: white;\n          color: #2680EB;\n          padding: 0.5rem;\n          margin: 1rem;\n          border-radius: 2rem;\n          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n          text-transform: none;\n        }\n      }\n    }\n  }\n  .secondary {\n    border-radius: 20px;\n    font-size: 15px;\n    border: 0px;\n    color: #1976d2;\n    background-color: #fff;\n    -webkit-box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n    padding: 10px 20px;\n    letter-spacing: 1px;\n  }\n\n  .add_to_calendar {\n    font-family: ','\n    font-size: 1.3rem;\n    font-weight: ','\n    color: ','\n    justify-content: center;\n    margin-bottom: 15px;\n    text-shadow: 1px 3px 3px rgb(0 0 0);\n    cursor: pointer;\n  }\n\n  .addToCalendarWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 25rem;\n  }\n\n  > .header {\n    height: 20rem;\n    position: relative;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: 50% 50%;\n\n    > .content {\n      padding: 3rem;\n      position: relative;\n      z-index: 10;\n      > .name {\n        color: #fff;\n        font-size: 2.7rem;\n\n        @media (max-width: ','px) {\n          font-size: 1.8rem;\n        }\n\n        img {\n          margin-right: 0.5rem;\n\n          &.call_icon {\n            width: 2rem;\n          }\n        }\n      }\n\n      > .time_limit {\n        color: #fff;\n        font-size: 1.3rem;\n        margin: 1rem 0 0.5rem;\n        @media (max-width: ','px) {\n          font-size: 1.1rem;\n        }\n      }\n\n      > .starting_in {\n        display: inline-block;\n        color: #fff;\n        font-size: 1.3rem;\n        margin-right: 0.5rem;\n      }\n\n      > .countdown {\n        display: inline-block;\n        font-size: 1.3rem;\n        margin-top: 0.5rem;\n        @media (max-width: ','px) {\n          font-size: 1.1rem;\n        }\n      }\n    }\n\n    > .opacity {\n      position: absolute;\n      z-index: 1;\n      background: rgb(255,255,255);\n      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.5) 100%);\n      width: 100%;\n      height: 100%;\n    }\n\n    > .buttons {\n      position: absolute;\n      z-index: 10;\n      width: 100%;\n      bottom: 2rem;\n      text-align: center;\n      button {\n        min-width: 10rem;\n      }\n    }\n  }\n\n  .tabs {\n    background-color: #fff;\n  }\n\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.1rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  min-height: 5rem;\n  margin-top: 1rem;\n  color: #707070;\n  .desc {\n    width: 90%;\n    line-break: anywhere;\n    line-height: 1.8rem;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  min-height: 5rem;\n  margin-top: 1rem;\n  color: #707070;\n  .desc {\n    width: 90%;\n    line-break: anywhere;\n    line-height: 1.8rem;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 90%;\n  margin: 0 auto 4rem;\n'],['\n  width: 90%;\n  margin: 0 auto 4rem;\n']),_templateObject4=_taggedTemplateLiteral(['\n  min-height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2rem;\n  .filters_tags {\n    width: 90%;\n    display: flex;\n    overflow: scroll;\n  }\n'],['\n  min-height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2rem;\n  .filters_tags {\n    width: 90%;\n    display: flex;\n    overflow: scroll;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  min-height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2rem;\n  .users {\n    width: 90%;\n  }\n  .scroll_users {\n    height: 15rem;\n    display: flex;\n  }\n'],['\n  min-height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2rem;\n  .users {\n    width: 90%;\n  }\n  .scroll_users {\n    height: 15rem;\n    display: flex;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  min-height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1rem;\n  .content_list {\n    width: 90%;\n  }\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.1rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n'],['\n  min-height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1rem;\n  .content_list {\n    width: 90%;\n  }\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.1rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  min-height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1rem;\n  margin-bottom: 3rem;\n  .tables {\n    width: 90%;\n  }\n  .tables_in {\n    overflow-x: scroll;\n    cursor: pointer;\n  }\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.1rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n'],['\n  min-height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1rem;\n  margin-bottom: 3rem;\n  .tables {\n    width: 90%;\n  }\n  .tables_in {\n    overflow-x: scroll;\n    cursor: pointer;\n  }\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.1rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  min-height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1rem;\n  .tables {\n    width: 90%;\n  }\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.1rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n'],['\n  min-height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1rem;\n  .tables {\n    width: 90%;\n  }\n  .name_section {\n    color: #333;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    .number {\n      font-weight: bold;\n      color: black;\n      margin-right: 0.5rem;\n    }\n    .invite_placeholder{\n      font-size: 1.1rem;\n      margin-left: 0.8rem;\n      color: #2680EB;\n    }\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  height: 20rem;\n  width: 90%;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border-radius: 3rem;\n  .close_button {\n    width: 95%;\n    height: 15%;\n    font-size: 2rem;\n    margin-top: 2rem;\n    i {\n      float: right;\n      cursor: pointer;\n      color: #707070;\n    }\n  }\n  .title {\n    text-align: center;\n    height: 10%;\n    font-size: 1.3rem;\n    color: #2680EB;\n  }\n\n  .icons {\n    height: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n    .icon {\n      height: 50%;\n      width: 40%;\n      text-align: center;\n      font-size: 1.3rem;\n      cursor: pointer;\n    }\n    .icon_name {\n      margin-top: 1rem;\n      cursor: pointer;\n    }\n    img {\n      height: 100%;\n      cursor: pointer;\n    }\n  }\n'],['\n  height: 20rem;\n  width: 90%;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  border-radius: 3rem;\n  .close_button {\n    width: 95%;\n    height: 15%;\n    font-size: 2rem;\n    margin-top: 2rem;\n    i {\n      float: right;\n      cursor: pointer;\n      color: #707070;\n    }\n  }\n  .title {\n    text-align: center;\n    height: 10%;\n    font-size: 1.3rem;\n    color: #2680EB;\n  }\n\n  .icons {\n    height: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n    .icon {\n      height: 50%;\n      width: 40%;\n      text-align: center;\n      font-size: 1.3rem;\n      cursor: pointer;\n    }\n    .icon_name {\n      margin-top: 1rem;\n      cursor: pointer;\n    }\n    img {\n      height: 100%;\n      cursor: pointer;\n    }\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  .tabs {\n    padding-top: 1rem;\n    background-color: #fff;\n  }\n\n  .tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .tabs {\n  white-space: nowrap;\n  display: grid;\n  border-bottom: 1px solid #e9e9e9;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  overflow: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &.flex {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    height: 7vh;\n  }\n\n  .tab {\n    text-align: center;\n    padding: 1.5rem 1rem;\n    color: #767676;\n    font-size: 1.4rem;\n    cursor: pointer;\n    min-width: 11rem;\n\n    &.selected {\n      border-bottom: 2px solid #000;\n      color: #000;\n    }\n  }\n\n  &.gray {\n    background-color: #D9D9D9;\n\n    .tab {\n      color: #000;\n      &.selected {\n        border-bottom: 2px solid #000;\n      }\n    }\n  }\n}\n'],['\n  .tabs {\n    padding-top: 1rem;\n    background-color: #fff;\n  }\n\n  .tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .tabs {\n  white-space: nowrap;\n  display: grid;\n  border-bottom: 1px solid #e9e9e9;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  overflow: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &.flex {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    height: 7vh;\n  }\n\n  .tab {\n    text-align: center;\n    padding: 1.5rem 1rem;\n    color: #767676;\n    font-size: 1.4rem;\n    cursor: pointer;\n    min-width: 11rem;\n\n    &.selected {\n      border-bottom: 2px solid #000;\n      color: #000;\n    }\n  }\n\n  &.gray {\n    background-color: #D9D9D9;\n\n    .tab {\n      color: #000;\n      &.selected {\n        border-bottom: 2px solid #000;\n      }\n    }\n  }\n}\n']),_templateObject11=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  overflow: auto;\n'],['\n  display: flex;\n  align-items: center;\n  overflow: auto;\n']),_templateObject12=_taggedTemplateLiteral(['\n  background: #2680EB;\n  border-radius: 100%;\n  font-size: 4rem;\n  color: white;\n  cursor: pointer;\n  width: 2rem;\n  height: 2rem;\n  padding: 3.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  background: #2680EB;\n  border-radius: 100%;\n  font-size: 4rem;\n  color: white;\n  cursor: pointer;\n  width: 2rem;\n  height: 2rem;\n  padding: 3.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),_templateObject13=_taggedTemplateLiteral(['\n  position: fixed;\n  bottom: 4rem;\n  right: 4rem;\n  z-index: 10000000000000;\n\n  @media (max-width: ','px) {\n    bottom: 8rem;\n    right: 2rem;\n  }\n'],['\n  position: fixed;\n  bottom: 4rem;\n  right: 4rem;\n  z-index: 10000000000000;\n\n  @media (max-width: ','px) {\n    bottom: 8rem;\n    right: 2rem;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CallHall=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].boldWeight,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["k" ],__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var Description=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var AgendaWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);var Tags=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);var Users=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject5);var Content=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6);var Tables=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7);var Affiliations=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8);var CalendarWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);var TabsSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject10);var SliderTables=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject11);var AddButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject12);var CreateTable=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject13,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1920);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1921);
function mapStateToProps(){return{};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_3_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_3_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_4_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1922);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function Impersonate(props){var hash=props.match.params.hash;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),error=_useState2[0],setError=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_2_utils_apiFetch__["b" ])('POST',{endPoint:'/impersonate/'+hash}).then(function(response){__WEBPACK_IMPORTED_MODULE_3_redux_react_session__["sessionService"].saveSession({token:response.user_code}).then(function(){var user=Object.assign({},response);user.instance=response.instance_id;__WEBPACK_IMPORTED_MODULE_3_redux_react_session__["sessionService"].saveUser(user).then(function(){window.sendUserIdentifier(user.id);window.location.href=window.location.origin;});});}).catch(function(responseError){setError(responseError.response.data.error);});},[]);if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error_msg'},error));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_LoadingComponent__["a" ],{colorAnimation:'#888888'}));}Impersonate.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (Impersonate);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return ImpersonateWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  > div {\n    height: calc(100vh - 5rem);\n  }\n\n  > .error_msg {\n    height: auto;\n    text-align: center;\n    font-size: 1.4rem;\n  }\n'],['\n  > div {\n    height: calc(100vh - 5rem);\n  }\n\n  > .error_msg {\n    height: auto;\n    text-align: center;\n    font-size: 1.4rem;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ImpersonateWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1924);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_routes_Profile_modules_actions__ = __webpack_require__(92);
 var __WEBPACK_IMPORTED_MODULE_5_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_6_routes_Signup_modules_signup__ = __webpack_require__(157);
 var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(1925);
function mapStateToProps(state){return{literals:state.i18n.literals.profileEdit,actualUser:state.session.user,app:state.app};}function mapDispatchToProps(dispatch){return{uploadImage:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_6_routes_Signup_modules_signup__["d" ],dispatch),updateProfile:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_routes_Profile_modules_actions__["f" ],dispatch),setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_7__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_modules_users_actions__ = __webpack_require__(85);
 var __WEBPACK_IMPORTED_MODULE_3_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__ = __webpack_require__(8);
 var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(31);
 var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
 var __WEBPACK_IMPORTED_MODULE_6_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(68);
 var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(250);
 var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(408);
 var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel__ = __webpack_require__(177);
 var __WEBPACK_IMPORTED_MODULE_11_components_FeedbackModal__ = __webpack_require__(78);
 var __WEBPACK_IMPORTED_MODULE_12_constants_urls__ = __webpack_require__(19);
 var __WEBPACK_IMPORTED_MODULE_13__styles__ = __webpack_require__(1926);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var TAB_PROFILE='tab_profile';var TAB_PASSWORD='tab_password';function ProfileEdit(props){var literals=props.literals,setBreadcrumb=props.setBreadcrumb,resetAll=props.resetAll,actualUser=props.actualUser,app=props.app,history=props.history;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isLoading=_useState2[0],setIsLoading=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(TAB_PROFILE),_useState4=_slicedToArray(_useState3,2),selectedTab=_useState4[0],setSelectedTab=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(actualUser.avatar),_useState6=_slicedToArray(_useState5,2),avatar=_useState6[0],setAvatar=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(actualUser.name),_useState8=_slicedToArray(_useState7,2),name=_useState8[0],setName=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(actualUser.surname),_useState10=_slicedToArray(_useState9,2),surname=_useState10[0],setSurname=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(actualUser.gender),_useState12=_slicedToArray(_useState11,2),gender=_useState12[0],setGender=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState14=_slicedToArray(_useState13,2),overview=_useState14[0],setOverview=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState16=_slicedToArray(_useState15,2),oldPassword=_useState16[0],setOldPassword=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState18=_slicedToArray(_useState17,2),newPassword=_useState18[0],setNewPassword=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState20=_slicedToArray(_useState19,2),repeatPassword=_useState20[0],setRepeatPassword=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState22=_slicedToArray(_useState21,2),errors=_useState22[0],setErrors=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),showPasswordChangedModal=_useState24[0],setShowPasswordChangedModal=_useState24[1];// Breadcrumb
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var breadcrumb=[{color:'#ffffff',text:literals.editProfile}];setBreadcrumb(breadcrumb.slice());resetAll();},[]);// User data
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(actualUser&&actualUser.id){setIsLoading(true);Object(__WEBPACK_IMPORTED_MODULE_2_modules_users_actions__["c" ])(actualUser.id).then(function(userData){setIsLoading(false);setOverview(userData.overview);}).catch(function(){setIsLoading(false);});}},[actualUser]);// Change avatar
var uploadImage=function uploadImage(data,nameFile){var params={data:data,name:nameFile};Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('POST',{endPoint:'upload-file'},params).then(function(response){setErrors([]);setAvatar(response.url);}).catch(function(){errors.push(literals.errorUploadingImage);});};var handleFileUpload=function handleFileUpload(event){if(event.target.files[0]!==undefined){var file=event.target.files[0];var nameFile=file.name;var reader=new FileReader();reader.onloadend=function(){uploadImage(reader.result,nameFile);};reader.readAsDataURL(file);}};// Errors
var removeErrors=function removeErrors(){setErrors([]);};// Change name
var handleChangeName=function handleChangeName(event){setName(event.currentTarget.value);};// Change surname
var handleChangeSurname=function handleChangeSurname(event){setSurname(event.currentTarget.value);};// Change gender
var handleChangeGender=function handleChangeGender(event){setGender(event.target.value);};// Change overview
var handleChangeOverview=function handleChangeOverview(event){setOverview(event.target.value);};// Change old password
var handleChangeOldPassword=function handleChangeOldPassword(event){setOldPassword(event.target.value);};// Change new password
var handleChangeNewPassword=function handleChangeNewPassword(event){setNewPassword(event.target.value);};// Change repeat password
var handleChangeRepeatPassword=function handleChangeRepeatPassword(event){setRepeatPassword(event.target.value);};// Tabs
var handleViewProfile=function handleViewProfile(){setSelectedTab(TAB_PROFILE);};var handleViewPassword=function handleViewPassword(){setSelectedTab(TAB_PASSWORD);};// Main buttons
var checkForm=function checkForm(){return name.trim()&&surname.trim();};var checkFormPassword=function checkFormPassword(){return newPassword&&oldPassword&&repeatPassword;};var handleCancel=function handleCancel(){history.push(__WEBPACK_IMPORTED_MODULE_12_constants_urls__["F" ]);};var handleSubmit=function handleSubmit(){if(!checkForm()){return false;}var params={name:name,surname:surname,avatar:avatar,gender:gender,overview:overview};if(gender!=='male'&&gender!=='female'){params.gender='';}setIsLoading(true);Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('PUT',{endPoint:'users'},params).then(function(response){var userData=Object.assign({},actualUser,response);__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].saveUser(userData);handleCancel();}).catch(function(error){setIsLoading(false);errors.push(error.response.data.error);setErrors([].concat(_toConsumableArray(errors)));});return true;};var handleSubmitPassword=function handleSubmitPassword(){if(!checkFormPassword()){return false;}if(newPassword!==repeatPassword){errors.push(literals.passwordsDontMatch);}if(newPassword.length<8){errors.push(literals.passwordLengthError);}setErrors([].concat(_toConsumableArray(errors)));if(!errors.length){var params={old_password:oldPassword,new_password:newPassword};setIsLoading(true);Object(__WEBPACK_IMPORTED_MODULE_4_utils_apiFetch__["b" ])('POST',{endPoint:'users/password'},params).then(function(response){if(!response.success){errors.push(response.info.message);setErrors([].concat(_toConsumableArray(errors)));}else{setShowPasswordChangedModal(true);}setIsLoading(false);}).catch(function(error){setIsLoading(false);errors.push(error.response.data.error);setErrors([].concat(_toConsumableArray(errors)));});}return true;};var hidePasswordModal=function hidePasswordModal(){setShowPasswordChangedModal(false);};// Print functions
var printProfileForm=function printProfileForm(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles__["a" ],{className:'form',color:app.color1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'avatar_layer',htmlFor:'document_file'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Avatar__["a" ],{size:150,avatar:avatar,firstname:name,id:actualUser.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn_edit_profile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-pen'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'document_file',name:'document_file',style:{display:'none'},onChange:handleFileUpload,accept:'image/png, image/jpeg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__["default"],{value:name,label:literals.firstname,required:true,onChange:handleChangeName,className:'textfield_material_ui'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__["default"],{value:surname,label:literals.lastname,required:true,onChange:handleChangeSurname,className:'textfield_material_ui'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel__["a" ],{className:'label_material_ui',id:'label_gender'},literals.selectYourGender),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__["a" ],{value:gender,onChange:handleChangeGender,className:'select_material_ui',labelId:'label_gender'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__["a" ],{value:''},literals.selectYourGender),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__["a" ],{value:'male'},literals.male),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__["a" ],{value:'female'},literals.female)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__["default"],{value:actualUser.emailList[0],label:literals.email,disabled:true,className:'textfield_material_ui disabled'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__["default"],{value:overview,label:literals.overview,onChange:handleChangeOverview,multiline:true,rows:4,className:'textfield_material_ui'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary '+(checkForm()?'':'disabled'),onClick:handleSubmit},literals.save),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'cancel',onClick:handleCancel},literals.cancel)));};var printPasswordForm=function printPasswordForm(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles__["a" ],{className:'form',color:app.color1},showPasswordChangedModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_FeedbackModal__["a" ],{onClose:hidePasswordModal,open:true,success:true,text:literals.passwordHasBeenChanged}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__["default"],{value:oldPassword,onChange:handleChangeOldPassword,className:'textfield_material_ui',label:literals.oldPassword,type:'password'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__["default"],{value:newPassword,onChange:handleChangeNewPassword,className:'textfield_material_ui',label:literals.newPassword,type:'password'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__["default"],{value:repeatPassword,onChange:handleChangeRepeatPassword,className:'textfield_material_ui',label:literals.repeatPassword,type:'password'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary '+(checkFormPassword()?'':'disabled'),onClick:handleSubmitPassword},literals.save),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'cancel',onClick:handleCancel},literals.cancel)));};var printContentTab=function printContentTab(){switch(selectedTab){case TAB_PASSWORD:return printPasswordForm();default:return printProfileForm();}};var printErrors=function printErrors(){if(!errors.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_FeedbackModal__["a" ],{onClose:removeErrors,open:true,success:false,text:errors.join('<br />')});};if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_LoadingComponent__["a" ],{colorAnimation:app.color1}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,printErrors(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs x2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab===TAB_PROFILE?'selected':''),onClick:handleViewProfile},literals.profileTab),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab '+(selectedTab===TAB_PASSWORD?'selected':''),onClick:handleViewPassword},literals.passwordTab)),printContentTab());}ProfileEdit.propTypes={literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,actualUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (ProfileEdit);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return EditionForm; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 2rem;\n  max-width: 60rem;\n  margin: 0 auto;\n  padding-bottom: 12rem;\n\n  .avatar_layer {\n    position: relative;\n    width: 15rem;\n    margin: 0 auto;\n    display: block;\n\n    .btn_edit_profile {\n      width: 5rem;\n      height: 5rem;\n      background-color: ',';\n      border-radius: 50%;\n      cursor: pointer;\n      text-align: center;\n      line-height: 5.5rem;\n      position: absolute;\n      bottom: 0rem;\n      right: 0rem;\n      z-index: 5;\n\n      i {\n        font-size: 2rem;\n        color: #fff;\n      }\n    }\n  }\n\n  .buttons {\n    text-align: center;\n    margin-top: 2rem;\n\n    button {\n      min-width: 12rem;\n    }\n  }\n'],['\n  padding: 2rem;\n  max-width: 60rem;\n  margin: 0 auto;\n  padding-bottom: 12rem;\n\n  .avatar_layer {\n    position: relative;\n    width: 15rem;\n    margin: 0 auto;\n    display: block;\n\n    .btn_edit_profile {\n      width: 5rem;\n      height: 5rem;\n      background-color: ',';\n      border-radius: 50%;\n      cursor: pointer;\n      text-align: center;\n      line-height: 5.5rem;\n      position: absolute;\n      bottom: 0rem;\n      right: 0rem;\n      z-index: 5;\n\n      i {\n        font-size: 2rem;\n        color: #fff;\n      }\n    }\n  }\n\n  .buttons {\n    text-align: center;\n    margin-top: 2rem;\n\n    button {\n      min-width: 12rem;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 60rem;\n  height: 60rem;\n  max-width: 100vw;\n  max-height: 100vh;\n  margin: 0 auto;\n'],['\n  width: 60rem;\n  height: 60rem;\n  max-width: 100vw;\n  max-height: 100vh;\n  margin: 0 auto;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var EditionForm=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,function(props){return props.color;});var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1928);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_5_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(1929);
function mapStateToProps(state){return{literals:state.i18n.literals.initiatives||{},element:state.elements.element,narratives:state.narratives.list,itemsPreferencesFromSerendipity:state.serendipity.preferences,user:state.session.user};}function mapDispatchToProps(dispatch){return{getSerendipityAction:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_modules_serendipity_actions__["d" ],dispatch),setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_ArrowBack_svg__ = __webpack_require__(135);
 var __WEBPACK_IMPORTED_MODULE_3_assets_images_ArrowBack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_ArrowBack_svg__);
 var __WEBPACK_IMPORTED_MODULE_4_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_5_components_Cards_NarrativeSmallCard__ = __webpack_require__(182);
 var __WEBPACK_IMPORTED_MODULE_6_utils_serendipity__ = __webpack_require__(1930);
 var __WEBPACK_IMPORTED_MODULE_7_utils_colors__ = __webpack_require__(44);
 var __WEBPACK_IMPORTED_MODULE_8_store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_9_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(1931);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function FineTune(props){var narratives=props.narratives,user=props.user,literals=props.literals,resetAll=props.resetAll,setBreadcrumb=props.setBreadcrumb;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),orderNarratives=_useState2[0],setOrderNarratives=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState4=_slicedToArray(_useState3,2),totalProgress=_useState4[0],setTotalProgress=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var breadcrumb=[{color:'#ffffff',text:literals.fineTune}];setBreadcrumb(breadcrumb.slice());resetAll();},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var total=0;if(narratives){narratives.forEach(function(na){total+=na.progress;});total/=narratives.length;setTotalProgress(total);}},[narratives]);var printOtherNarratives=function printOtherNarratives(){var itemsPreferencesFromSerendipity=props.itemsPreferencesFromSerendipity;var filterNarratives=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(narratives,function(narrative){if(narrative.type.id===21227760){return false;}return true;});if(!filterNarratives.length){return null;}var finalNarratives=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(filterNarratives,function(narrative){var enabled=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(itemsPreferencesFromSerendipity,function(item){return item.element_type===__WEBPACK_IMPORTED_MODULE_9_constants_types__["h" ]&&item.element_id===narrative.id&&!item.enabled;});return Object.assign({},narrative,{enabled:enabled});});if(orderNarratives){finalNarratives.sort(function(a,b){var positionA=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(orderNarratives,function(item){return item===a;});var positionB=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(orderNarratives,function(item){return item===b;});return positionA<positionB?-1:1;});}else{finalNarratives.sort(__WEBPACK_IMPORTED_MODULE_6_utils_serendipity__["a" ]);var newOrderNarratives=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(finalNarratives,function(narrative){return narrative.id;});setOrderNarratives(newOrderNarratives);}var classCard='narratives_card';var narrativesElements=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(finalNarratives,function(narrative){var color=Object(__WEBPACK_IMPORTED_MODULE_7_utils_colors__["j" ])(Object(__WEBPACK_IMPORTED_MODULE_7_utils_colors__["d" ])(narrative.section.color,15*narrative.section.position));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Cards_NarrativeSmallCard__["a" ],{key:narrative.id,data:narrative,color:color,literals:literals,classesList:classCard});});var defaultPosition=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(finalNarratives,function(narrative){return narrative.progress<100&&narrative.enabled;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_SimpleCarousel__["a" ],{classesList:classCard,defaultPosition:defaultPosition},narrativesElements));};var clickNarrative=function clickNarrative(event){if(event){var id=event.currentTarget.getAttribute('data-id');__WEBPACK_IMPORTED_MODULE_8_store_history__["a" ].push('/narratives/'+id);}};var goToProfile=function goToProfile(){__WEBPACK_IMPORTED_MODULE_8_store_history__["a" ].push('/userprofile');};var handleGoBack=function handleGoBack(){__WEBPACK_IMPORTED_MODULE_8_store_history__["a" ].goBack();};var serendipity=function serendipity(){var getSerendipityAction=props.getSerendipityAction;var action=getSerendipityAction();if(action){action();}};var printGoBack=function printGoBack(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["f" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_create'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3_assets_images_ArrowBack_svg___default.a,alt:'',onClick:handleGoBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,literals.fineTune,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,literals.serendipity))));};var printProgress=function printProgress(only){var progress=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(narratives,function(narr,key){if(only&&key>2){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["c" ],{progress:30*(narr.progress/100),finish:narr.progress===100,'data-id':narr.id,key:narr.id,onClick:clickNarrative},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:narr.image,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},narr.name),narr.progress>0&&narr.progress<100?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'percentage'},narr.progress+'%'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new'},'New'),narr.progress===100&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'percentage'},literals.completed));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress'},progress);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["a" ],null,printGoBack(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top_button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["e" ],{onClick:serendipity},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),literals.start)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top'},printOtherNarratives()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["i" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.progress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle'},literals.complete),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["d" ],{progress:40*(totalProgress/100)}),printProgress(false)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["h" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" ],{img:user.avatar}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},user.name+' '+user.surname),printProgress(true),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["g" ],{onClick:goToProfile},literals.viewProfile)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'10vh',width:'100%'}})));}FineTune.propTypes={setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,narratives:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};FineTune.defaultProps={narratives:[]}; __webpack_exports__["a"] = (FineTune);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return sortNarratives; });
var sortNarratives=function sortNarratives(a,b){var aEnabled=typeof a.enabled==='undefined'||a.enabled;var bEnabled=typeof b.enabled==='undefined'||b.enabled;if(!aEnabled&&bEnabled){return-1;}if(!bEnabled&&aEnabled){return 1;}if(a.progress===100&&b.progress<100){return-1;}if(b.progress===100&&a.progress<100){return 1;}if(a.section.section_position<b.section.section_position){return-1;}if(b.section.section_position<a.section.section_position){return 1;}if(a.position<b.position){return-1;}if(b.position<a.position){return 1;}if(a.progress>0&&b.progress===0){return-1;}if(b.progress>0&&a.progress===0){return 1;}return a.progress>b.progress;};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return FineTuneWrapper; });
 __webpack_require__.d(__webpack_exports__, "i", function() { return YourProgress; });
 __webpack_require__.d(__webpack_exports__, "d", function() { return ProgressSerendipity; });
 __webpack_require__.d(__webpack_exports__, "h", function() { return YourProfile; });
 __webpack_require__.d(__webpack_exports__, "e", function() { return StartButton; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return ProfilePic; });
 __webpack_require__.d(__webpack_exports__, "f", function() { return TitleBack; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return Progress; });
 __webpack_require__.d(__webpack_exports__, "g", function() { return ViewProfile; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  padding: 3rem;\n  display: flex;\n  flex-direction: column;\n  @media (max-width: ','px) {\n    padding: 0;\n  }\n  .back {\n    width: 100%;\n    margin: 2rem 1rem;\n    font-size: 1.6rem;\n    i {\n      padding: 0rem 1rem;\n      font-size: 1.6rem;\n      cursor: pointer;\n    }\n  }\n  .top_button {\n    width: 100%;\n    margin: 2rem 1rem;\n  }\n  .top {\n    width: 100%;\n    margin: 2rem;\n  }\n  .bottom {\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    margin-top: 2rem;\n    flex-wrap: wrap;\n  }\n  .progress {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    flex-wrap: wrap;\n    width: 100%;\n  }\n'],['\n  padding: 3rem;\n  display: flex;\n  flex-direction: column;\n  @media (max-width: ','px) {\n    padding: 0;\n  }\n  .back {\n    width: 100%;\n    margin: 2rem 1rem;\n    font-size: 1.6rem;\n    i {\n      padding: 0rem 1rem;\n      font-size: 1.6rem;\n      cursor: pointer;\n    }\n  }\n  .top_button {\n    width: 100%;\n    margin: 2rem 1rem;\n  }\n  .top {\n    width: 100%;\n    margin: 2rem;\n  }\n  .bottom {\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    margin-top: 2rem;\n    flex-wrap: wrap;\n  }\n  .progress {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    flex-wrap: wrap;\n    width: 100%;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 65%;\n  min-width: 50rem;\n  padding: 3rem;\n  margin: 1rem;\n  border-radius: 2.2rem;\n  background: white;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  @media (max-width: ','px) {\n    padding: 1rem;\n    min-width: 90%;\n  }\n  .title {\n    font-size: 1.8rem;\n    font-weight: bold;\n    margin: 1rem;\n  }\n  .subtitle {\n    font-size: 1.6rem;\n    margin: 1rem;\n  }\n'],['\n  width: 65%;\n  min-width: 50rem;\n  padding: 3rem;\n  margin: 1rem;\n  border-radius: 2.2rem;\n  background: white;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  @media (max-width: ','px) {\n    padding: 1rem;\n    min-width: 90%;\n  }\n  .title {\n    font-size: 1.8rem;\n    font-weight: bold;\n    margin: 1rem;\n  }\n  .subtitle {\n    font-size: 1.6rem;\n    margin: 1rem;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 40rem;\n  max-width: 80%;\n  height: 1rem;\n  z-index: 4;\n  border-radius: 2rem;\n  background: #DBDBDB;\n  position: relative;\n  margin: 2rem 1rem;\n\n  &:before {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: ',';\n    height: 1rem;\n    z-index: 4;\n    border-radius: 2rem;\n    background: #2680EB;\n  }\n'],['\n  width: 40rem;\n  max-width: 80%;\n  height: 1rem;\n  z-index: 4;\n  border-radius: 2rem;\n  background: #DBDBDB;\n  position: relative;\n  margin: 2rem 1rem;\n\n  &:before {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: ',';\n    height: 1rem;\n    z-index: 4;\n    border-radius: 2rem;\n    background: #2680EB;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 30%;\n  min-width: 35rem;\n  margin: 1rem;\n  border-radius: 2.2rem;\n  background: white;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  @media (max-width: ','px) {\n    padding: 1rem;\n    min-width: 90%;\n  }\n  .name {\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin: 2rem 0.5rem;\n  }\n'],['\n  width: 30%;\n  min-width: 35rem;\n  margin: 1rem;\n  border-radius: 2.2rem;\n  background: white;\n  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  @media (max-width: ','px) {\n    padding: 1rem;\n    min-width: 90%;\n  }\n  .name {\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin: 2rem 0.5rem;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  width: 21rem;\n  height: 5rem;\n  padding: 2rem;\n  border-radius: 4rem;\n  background: #2680EB;\n  color: white;\n  font-size: 1.5rem;\n  display: flex;\n  align-items: center;\n  i {\n    font-size: 2rem;\n    margin-right: 2rem;\n  }\n'],['\n  width: 21rem;\n  height: 5rem;\n  padding: 2rem;\n  border-radius: 4rem;\n  background: #2680EB;\n  color: white;\n  font-size: 1.5rem;\n  display: flex;\n  align-items: center;\n  i {\n    font-size: 2rem;\n    margin-right: 2rem;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  background: ',';\n  height: 10rem;\n  width: 10rem;\n  background-size: cover;\n  border-radius: 100%;\n  margin-top: 2rem;\n'],['\n  background: ',';\n  height: 10rem;\n  width: 10rem;\n  background-size: cover;\n  border-radius: 100%;\n  margin-top: 2rem;\n']),_templateObject7=_taggedTemplateLiteral(['\n  .title_create {\n    margin: 1% 0;\n    text-align: left;\n\n    div {\n      display: inline-block;\n      font-family: ',';\n      font-size: 2.2rem;\n      margin: 1%;\n    }\n\n    img {\n      display: inline-block;\n      margin-left: 1%;\n      cursor: pointer;\n    }\n'],['\n  .title_create {\n    margin: 1% 0;\n    text-align: left;\n\n    div {\n      display: inline-block;\n      font-family: ',';\n      font-size: 2.2rem;\n      margin: 1%;\n    }\n\n    img {\n      display: inline-block;\n      margin-left: 1%;\n      cursor: pointer;\n    }\n']),_templateObject8=_taggedTemplateLiteral(['\n  width: 30rem;\n  max-width: 80%;\n  height: 6rem;\n  margin: 0.5rem 2rem;\n  z-index: 4;\n  border-radius: 1rem;\n  background: #F6F7F9;\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  @media (max-width: ','px) {\n    max-width: 90%;\n    width: 90%;\n  }\n\n  &:after {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: ',';\n    height: 6rem;\n    z-index: 4;\n    border-radius: 1rem;\n    background: ',';\n    @media (max-width: ','px) {\n      width: ',';\n      width: ',';\n    }\n  }\n\n  .title {\n    z-index: 10;\n    padding: 1rem;\n    width: 50%;\n    font-size: 1.3rem;\n    left: 4rem;\n    overflow: hidden;\n    position: absolute;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  img {\n    width: 3rem;\n    height: 3rem;\n    margin: 1rem;\n    z-index: 10;\n  }\n  .percentage {\n    position: absolute;\n    right: 0;\n    padding: 1rem;\n    font-size: 1.2rem;\n    font-weight: 600;\n    z-index: 100;\n  }\n  .new {\n    position: absolute;\n    right: 0;\n    padding: 1rem;\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #FFA200;\n  }\n'],['\n  width: 30rem;\n  max-width: 80%;\n  height: 6rem;\n  margin: 0.5rem 2rem;\n  z-index: 4;\n  border-radius: 1rem;\n  background: #F6F7F9;\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  @media (max-width: ','px) {\n    max-width: 90%;\n    width: 90%;\n  }\n\n  &:after {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: ',';\n    height: 6rem;\n    z-index: 4;\n    border-radius: 1rem;\n    background: ',';\n    @media (max-width: ','px) {\n      width: ',';\n      width: ',';\n    }\n  }\n\n  .title {\n    z-index: 10;\n    padding: 1rem;\n    width: 50%;\n    font-size: 1.3rem;\n    left: 4rem;\n    overflow: hidden;\n    position: absolute;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  img {\n    width: 3rem;\n    height: 3rem;\n    margin: 1rem;\n    z-index: 10;\n  }\n  .percentage {\n    position: absolute;\n    right: 0;\n    padding: 1rem;\n    font-size: 1.2rem;\n    font-weight: 600;\n    z-index: 100;\n  }\n  .new {\n    position: absolute;\n    right: 0;\n    padding: 1rem;\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #FFA200;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n    margin: 2rem;\n    border-radius: 2rem;\n    font-size: 1.5rem;\n    cursor: pointer;\n    border: 0px;\n    color: #fff;\n    background-color: #1976d2;\n    font-weight: 600;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n    padding: 1rem 2rem;\n    letter-spacing: 1px;\n'],['\n    margin: 2rem;\n    border-radius: 2rem;\n    font-size: 1.5rem;\n    cursor: pointer;\n    border: 0px;\n    color: #fff;\n    background-color: #1976d2;\n    font-weight: 600;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n    padding: 1rem 2rem;\n    letter-spacing: 1px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FineTuneWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var YourProgress=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var ProgressSerendipity=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,function(props){return props.progress+'rem';});var YourProfile=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ]);var StartButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].button(_templateObject5);var ProfilePic=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject6,function(props){return'url('+props.img+')';});var TitleBack=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].regularFamily);var Progress=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],function(props){return props.progress+'rem';},function(props){return props.finish?'#E5E5E5':'#C2DEFF';},__WEBPACK_IMPORTED_MODULE_2_constants_breakPoints__["b" ],function(props){return 90*(props.progress/30)+'%';},function(props){return props.finish?'100%':'';});var ViewProfile=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject9);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1933);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5_routes_Narratives_modules__ = __webpack_require__(82);
 var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(1934);
function mapStateToProps(state){return{literals:state.i18n.literals.speedDating||{},app:state.app,meetings:state.speedDating.meetings,newUsersInNarratives:state.narratives.newUsersInNarratives,actualUser:state.session.user};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch),cleanUsersFromNarrative:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_routes_Narratives_modules__["a" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
 var __WEBPACK_IMPORTED_MODULE_4_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_5_components_Steps_SwipeableCards__ = __webpack_require__(65);
 var __WEBPACK_IMPORTED_MODULE_6_components_Cards_UserSmallCard_components__ = __webpack_require__(134);
 var __WEBPACK_IMPORTED_MODULE_7_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_8_components_Agenda__ = __webpack_require__(136);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_think_no_think_chats_svg__ = __webpack_require__(91);
 var __WEBPACK_IMPORTED_MODULE_9_assets_images_think_no_think_chats_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_images_think_no_think_chats_svg__);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_user_connectedWithUserBlack_svg__ = __webpack_require__(1935);
 var __WEBPACK_IMPORTED_MODULE_10_assets_images_user_connectedWithUserBlack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_assets_images_user_connectedWithUserBlack_svg__);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_calls_callIconBlack_svg__ = __webpack_require__(477);
 var __WEBPACK_IMPORTED_MODULE_11_assets_images_calls_callIconBlack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_images_calls_callIconBlack_svg__);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_ArrowBack_svg__ = __webpack_require__(135);
 var __WEBPACK_IMPORTED_MODULE_12_assets_images_ArrowBack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_images_ArrowBack_svg__);
 var __WEBPACK_IMPORTED_MODULE_13_assets_images_calls_tableBlack_svg__ = __webpack_require__(478);
 var __WEBPACK_IMPORTED_MODULE_13_assets_images_calls_tableBlack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_assets_images_calls_tableBlack_svg__);
 var __WEBPACK_IMPORTED_MODULE_14_constants_speed_dating__ = __webpack_require__(269);
 var __WEBPACK_IMPORTED_MODULE_15_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_16_assets_images_hall_speedDatingLogoGreen_svg__ = __webpack_require__(237);
 var __WEBPACK_IMPORTED_MODULE_16_assets_images_hall_speedDatingLogoGreen_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_assets_images_hall_speedDatingLogoGreen_svg__);
 var __WEBPACK_IMPORTED_MODULE_17_assets_images_calls_clock_svg__ = __webpack_require__(479);
 var __WEBPACK_IMPORTED_MODULE_17_assets_images_calls_clock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_assets_images_calls_clock_svg__);
 var __WEBPACK_IMPORTED_MODULE_18_modules_speedDating_actions__ = __webpack_require__(225);
 var __WEBPACK_IMPORTED_MODULE_19__styles__ = __webpack_require__(1936);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var MAX_CARDS=10;function SpeedDating(props){var literals=props.literals,setBreadcrumb=props.setBreadcrumb,resetAll=props.resetAll,app=props.app,meetings=props.meetings,newUsersInNarratives=props.newUsersInNarratives,actualUser=props.actualUser,cleanUsersFromNarrative=props.cleanUsersFromNarrative,id=props.match.params.id;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),isLoading=_useState2[0],setIsLoading=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState4=_slicedToArray(_useState3,2),usersViewed=_useState4[0],setUsersViewed=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),recommendations=_useState6[0],setRecommendations=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState8=_slicedToArray(_useState7,2),nextRecommendations=_useState8[0],setNextRecommendations=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState10=_slicedToArray(_useState9,2),selectedUsers=_useState10[0],setSelectedUsers=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState12=_slicedToArray(_useState11,2),data=_useState12[0],setData=_useState12[1];var loadUsersToChoose=function loadUsersToChoose(){Object(__WEBPACK_IMPORTED_MODULE_18_modules_speedDating_actions__["d" ])(id).then(function(response){if(response.data.length||recommendations===null){var next=[].concat(_toConsumableArray(response.data));var actual=next.splice(0,MAX_CARDS);setRecommendations([].concat(_toConsumableArray(actual)));setNextRecommendations(next);}cleanUsersFromNarrative(id);}).catch(function(error){console.error(error);setIsLoading(false);});};var loadSelectedUsers=function loadSelectedUsers(){Object(__WEBPACK_IMPORTED_MODULE_18_modules_speedDating_actions__["e" ])(id).then(function(response){setSelectedUsers(response.data);});};var loadSpeedDatingData=function loadSpeedDatingData(){Object(__WEBPACK_IMPORTED_MODULE_18_modules_speedDating_actions__["b" ])(id).then(function(response){setData(response);}).catch(function(){setIsLoading(false);});};var loadInitialData=function loadInitialData(){loadUsersToChoose();loadSelectedUsers();loadSpeedDatingData();};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(data!==null&&recommendations!==null){setIsLoading(false);}},[data,recommendations]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(data&&data.element&&newUsersInNarratives[data.element.id]&&newUsersInNarratives[data.element.id].length){var scheduleMeetings=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(meetings,{element_id:parseInt(id,10)});newUsersInNarratives[data.element.id].forEach(function(user){var userId=user.id;if(userId!==actualUser.id&&recommendations!==null&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(recommendations,{id:userId})&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(nextRecommendations,{id:userId})&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(usersViewed,{id:userId})&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(selectedUsers,{id:userId})&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(scheduleMeetings,{user:{id:userId}})){if(!recommendations.length){recommendations.push(Object.assign({},user));setRecommendations([].concat(_toConsumableArray(recommendations)));}else{nextRecommendations.push(Object.assign({},user));setNextRecommendations([].concat(_toConsumableArray(nextRecommendations)));}}});// cleanUsersFromNarrative(data.element.id);
}},[newUsersInNarratives]);// Breadcrumb
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var breadcrumb=[{color:'#ffffff',text:literals.title}];setBreadcrumb(breadcrumb.slice());resetAll();loadInitialData();},[]);// Event Handlers
var sendUserFeedback=function sendUserFeedback(userId,feedback){Object(__WEBPACK_IMPORTED_MODULE_18_modules_speedDating_actions__["g" ])(id,userId,feedback);};var handleSelectUser=function handleSelectUser(userId){sendUserFeedback(userId,1);var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(recommendations,{id:userId});if(user){selectedUsers.push(user);setSelectedUsers([].concat(_toConsumableArray(selectedUsers)));}};var handleRejectUser=function handleRejectUser(userId){sendUserFeedback(userId,0);};var handleFinishCarousel=function handleFinishCarousel(){setUsersViewed(usersViewed.concat([].concat(_toConsumableArray(recommendations))));setRecommendations([]);};// Cuando nos quedamos sin recomendaciones miramos si tenemos mas
// en la variable nextRecommendations
// Si no tenemos llamamos al servidor
// Pero esperamos unos segundos para asegurarnos de que el feedback de la última card se ha guardado
var toSearchRecommendations=null;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(nextRecommendations.length&&!recommendations.length){var pendingRecommendations=[].concat(_toConsumableArray(nextRecommendations));var next=pendingRecommendations.splice(0,MAX_CARDS);setRecommendations([].concat(_toConsumableArray(next)));setNextRecommendations([].concat(_toConsumableArray(pendingRecommendations)));}else if(recommendations!==null&&!nextRecommendations.length&&!recommendations.length){if(toSearchRecommendations){clearTimeout(toSearchRecommendations);}toSearchRecommendations=setTimeout(function(){if(!recommendations.length){loadUsersToChoose();}toSearchRecommendations=null;},5000);}return function(){if(toSearchRecommendations){clearTimeout(toSearchRecommendations);}};},[recommendations]);var handleGoBack=function handleGoBack(){var history=props.history;history.goBack();};// Print Functions
var userCarousel=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!recommendations||!recommendations.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nocontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_assets_images_think_no_think_chats_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noUsers)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Steps_SwipeableCards__["a" ],{users:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(recommendations,function(_ref){var userId=_ref.id;return userId;}),onEnd:handleFinishCarousel,onYup:handleSelectUser,onNope:handleRejectUser,alwaysShowOptions:true,type:__WEBPACK_IMPORTED_MODULE_15_constants_types__["i" ]});},[recommendations]);var printRecommendations=function printRecommendations(){return userCarousel;};var printScheduleMeetings=function printScheduleMeetings(){var scheduleMeetings=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(meetings,{element_id:parseInt(id,10)}),['start_date']);if(!scheduleMeetings.length&&!data){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Agenda__["a" ],{speedDatings:[data],showPlanSpeedDating:false,showRandomSpeedDating:true,scheduleSpeedDatings:scheduleMeetings,title:literals.scheduledSpeedDatings});};var carouselSelectedUsers=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var interestUsers=[];var scheduleMeetings=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(meetings,{element_id:parseInt(id,10)});selectedUsers.forEach(function(user){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(scheduleMeetings,{user:{id:user.id}})){interestUsers.push(user);}});if(!interestUsers.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'matches'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10_assets_images_user_connectedWithUserBlack_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title',dangerouslySetInnerHTML:{__html:literals.youHaveShownInterest}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SimpleCarousel__["a" ],{classesList:'user_wrapper'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(interestUsers,function(selectedUser){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Cards_UserSmallCard_components__["a" ],{key:selectedUser.id,user:selectedUser});})));},[selectedUsers,meetings]);var printSelectedUsers=function printSelectedUsers(){return carouselSelectedUsers;};var printHeader=function printHeader(){var icon=null;if(!data){return null;}switch(data.element_type.id){case __WEBPACK_IMPORTED_MODULE_14_constants_speed_dating__["a" ]:icon=__WEBPACK_IMPORTED_MODULE_11_assets_images_calls_callIconBlack_svg___default.a;break;case __WEBPACK_IMPORTED_MODULE_14_constants_speed_dating__["d" ]:icon=__WEBPACK_IMPORTED_MODULE_13_assets_images_calls_tableBlack_svg___default.a;break;default:break;}var months=['January','February','March','April','May','June','July','August','September','October','November','December'];var datetime=new Date(data.start_date*1000);var month=months[datetime.getMonth()];var day=datetime.getDate();var dayOfMonth='';if(day===1||day===21||day===31){dayOfMonth=day+'st';}else if(day===2||day===22){dayOfMonth=day+'nd';}else if(day===3||day===23){dayOfMonth=day+'rd';}else{dayOfMonth=day+'th';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["a" ],null,icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'back',src:__WEBPACK_IMPORTED_MODULE_12_assets_images_ArrowBack_svg___default.a,alt:'',onClick:handleGoBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:icon,alt:''})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},literals.titleDesc+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.element.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card_info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16_assets_images_hall_speedDatingLogoGreen_svg___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data'},month+' '+dayOfMonth),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'type'},data.element_type.id===__WEBPACK_IMPORTED_MODULE_14_constants_speed_dating__["a" ]&&literals.event,data.element_type.id===__WEBPACK_IMPORTED_MODULE_14_constants_speed_dating__["d" ]&&literals.table)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_17_assets_images_calls_clock_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data'},literals.startingAt+' '+__WEBPACK_IMPORTED_MODULE_3_moment___default()(data.start_date,'X').format('hh:mm A'))))));};if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_LoadingComponent__["a" ],{colorAnimation:app.color1}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles__["d" ],null,printHeader(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},printRecommendations(),printScheduleMeetings(),printSelectedUsers()));}SpeedDating.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,newUsersInNarratives:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,actualUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,cleanUsersFromNarrative:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,meetings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};SpeedDating.defaultProps={meetings:[]}; __webpack_exports__["a"] = (SpeedDating);

 }),

 (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/connectedWithUserBlack.9164cf15.svg";

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "d", function() { return SpeedDatingWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return NoElements; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__ = __webpack_require__(10);
 var __WEBPACK_IMPORTED_MODULE_2_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_3_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\n  .content {\n    margin: 0 auto;\n    width: 90%;\n    max-width: 100rem;\n\n    @media (max-width: ','px) {\n      .carousel {\n        height: calc(100vh - 43vh) !important;\n      }\n      .carousel .carousel-item {\n        height: calc(100vh - 50vh) !important;\n      }\n    }\n  }\n\n  .title {\n    font-size: 1.6rem;\n    text-align: left;\n    color: ',';\n    font-family: ',';\n    line-height: 2.1rem;\n    padding-bottom: 0.2rem;\n    margin: 2rem 0rem 1rem;\n    display: inline-block;\n  }\n\n  .no_elements {\n    div {\n      color: ',';\n    }\n  }\n\n  .matches {\n    margin-top: 2rem;\n    > div {\n      margin-bottom: 1rem;\n    }\n\n    @media (max-width: ','px) {\n      margin-top: 7rem;\n      margin-bottom: 10rem;\n    }\n  }\n'],['\n  .content {\n    margin: 0 auto;\n    width: 90%;\n    max-width: 100rem;\n\n    @media (max-width: ','px) {\n      .carousel {\n        height: calc(100vh - 43vh) !important;\n      }\n      .carousel .carousel-item {\n        height: calc(100vh - 50vh) !important;\n      }\n    }\n  }\n\n  .title {\n    font-size: 1.6rem;\n    text-align: left;\n    color: ',';\n    font-family: ',';\n    line-height: 2.1rem;\n    padding-bottom: 0.2rem;\n    margin: 2rem 0rem 1rem;\n    display: inline-block;\n  }\n\n  .no_elements {\n    div {\n      color: ',';\n    }\n  }\n\n  .matches {\n    margin-top: 2rem;\n    > div {\n      margin-bottom: 1rem;\n    }\n\n    @media (max-width: ','px) {\n      margin-top: 7rem;\n      margin-bottom: 10rem;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: clamp(20vw, 40rem, 100vw);\n  height: clamp(20vw, 40rem, 100vw);\n  margin: 0 auto;\n  border-radius: 50%;\n  overflow: hidden;\n'],['\n  width: clamp(20vw, 40rem, 100vw);\n  height: clamp(20vw, 40rem, 100vw);\n  margin: 0 auto;\n  border-radius: 50%;\n  overflow: hidden;\n']),_templateObject3=_taggedTemplateLiteral(['\n  @media (min-width: 1710px) {\n    margin-bottom: -14rem;\n  }\n\n\n  text-align: left;\n  padding: 2rem 2rem 0;\n  .icon {\n\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 1rem;\n\n    .back {\n      cursor: pointer;\n    }\n\n    img {\n      padding: 0 1rem;\n      height: 2.4rem;\n      display: inline-block;\n      width: 5rem;\n    }\n  }\n\n  .description {\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 1.4rem;\n    color: ',';\n    width: calc(100% - 15rem);\n    font-family: ',';\n\n    strong {\n      font-family: ',';\n    }\n  }\n\n  .card_info {\n    width: 18rem;\n    margin-right: 1rem;\n    border-radius: 1.5rem;\n    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n    border: 0.1rem solid #e9e9e9;\n    margin-top: 2rem;\n    .header {\n      border-radius: 1.5rem 1.5rem 0 0;\n      background-color: #8AD923;\n      padding: 1rem;\n      color: #fff;\n\n      .icon {\n\n        background: white;\n        border-radius: 100%;\n        border-radius: 100%;\n        width: 3rem;\n        height: 3rem;\n        margin-right: 1rem;\n        display: inline-block;\n        vertical-align: middle;\n        img {\n            height: 3rem;\n            width: 3rem;\n        }\n      }\n\n      .data {\n        margin-right: 1rem;\n        font-size: 1.8rem;\n        width: calc(100% - 5rem);\n        font-family: ',';\n        color: white;\n        display: inline-block;\n        vertical-align: middle;\n        text-align: left;\n      }\n\n      .type {\n        text-align: center;\n        color: white;\n        font-size: 15px;\n        font-weight: 600;\n      }\n    }\n\n    .body {\n      color: ',';\n      padding: 1rem;\n\n      img {\n        display: inline-block;\n        max-width: 1.4rem;\n        vertical-align: middle;\n        margin-right: 1rem;\n      }\n\n      .data {\n        display: inline-block;\n        width: calc(100% - 2.5rem);\n        vertical-align: middle;\n        font-size: 1.3rem;\n      }\n    }\n  }\n'],['\n  @media (min-width: 1710px) {\n    margin-bottom: -14rem;\n  }\n\n\n  text-align: left;\n  padding: 2rem 2rem 0;\n  .icon {\n\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 1rem;\n\n    .back {\n      cursor: pointer;\n    }\n\n    img {\n      padding: 0 1rem;\n      height: 2.4rem;\n      display: inline-block;\n      width: 5rem;\n    }\n  }\n\n  .description {\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 1.4rem;\n    color: ',';\n    width: calc(100% - 15rem);\n    font-family: ',';\n\n    strong {\n      font-family: ',';\n    }\n  }\n\n  .card_info {\n    width: 18rem;\n    margin-right: 1rem;\n    border-radius: 1.5rem;\n    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);\n    border: 0.1rem solid #e9e9e9;\n    margin-top: 2rem;\n    .header {\n      border-radius: 1.5rem 1.5rem 0 0;\n      background-color: #8AD923;\n      padding: 1rem;\n      color: #fff;\n\n      .icon {\n\n        background: white;\n        border-radius: 100%;\n        border-radius: 100%;\n        width: 3rem;\n        height: 3rem;\n        margin-right: 1rem;\n        display: inline-block;\n        vertical-align: middle;\n        img {\n            height: 3rem;\n            width: 3rem;\n        }\n      }\n\n      .data {\n        margin-right: 1rem;\n        font-size: 1.8rem;\n        width: calc(100% - 5rem);\n        font-family: ',';\n        color: white;\n        display: inline-block;\n        vertical-align: middle;\n        text-align: left;\n      }\n\n      .type {\n        text-align: center;\n        color: white;\n        font-size: 15px;\n        font-weight: 600;\n      }\n    }\n\n    .body {\n      color: ',';\n      padding: 1rem;\n\n      img {\n        display: inline-block;\n        max-width: 1.4rem;\n        vertical-align: middle;\n        margin-right: 1rem;\n      }\n\n      .data {\n        display: inline-block;\n        width: calc(100% - 2.5rem);\n        vertical-align: middle;\n        font-size: 1.3rem;\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: calc(100% - 4rem);\n  height: 30rem;\n  padding: 2rem;\n  margin: 2rem auto;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n\n  @media (min-width: 1710px) {\n    margin-top: 5rem;\n  }\n\n  .nocontent {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    img {\n      width: 20rem;\n    }\n\n    .text {\n      margin-top: 1rem;\n      font-size: 1.6rem;\n      text-align: center;\n      color: black;\n    }\n  }\n'],['\n  width: calc(100% - 4rem);\n  height: 30rem;\n  padding: 2rem;\n  margin: 2rem auto;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n\n  @media (min-width: 1710px) {\n    margin-top: 5rem;\n  }\n\n  .nocontent {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    img {\n      width: 20rem;\n    }\n\n    .text {\n      margin-top: 1rem;\n      font-size: 1.6rem;\n      text-align: center;\n      color: black;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SpeedDatingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ],__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].regularFamily,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_breakPoints__["b" ]);var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2);var Header=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].semiBoldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].boldFamily,__WEBPACK_IMPORTED_MODULE_2_constants_fonts__["a" ].semiBoldFamily,__WEBPACK_IMPORTED_MODULE_3_constants_colors__["a" ]);var NoElements=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject4);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1938);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5_modules_serendipity_actions__ = __webpack_require__(54);
 var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(1939);
function mapStateToProps(state){return{literals:state.i18n.literals.recommendations||{},app:state.app};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch),getSerendipityAction:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_5_modules_serendipity_actions__["d" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_3_components_Steps_SwipeableCards__ = __webpack_require__(65);
 var __WEBPACK_IMPORTED_MODULE_4_modules_users_actions__ = __webpack_require__(85);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg__ = __webpack_require__(91);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg__);
 var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1940);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var MAX_USERS=10;function RecommendationUsers(props){var app=props.app,resetAll=props.resetAll,setBreadcrumb=props.setBreadcrumb,literals=props.literals,getSerendipityAction=props.getSerendipityAction,history=props.history;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),isLoading=_useState2[0],setIsLoading=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState4=_slicedToArray(_useState3,2),recommendedUsersIds=_useState4[0],setRecommendedUsersIds=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),isTheEnd=_useState6[0],setIsTheEnd=_useState6[1];var initBreadcrumb=function initBreadcrumb(){var breadcrumb=[{type:'back'},{color:'#ffffff',text:literals.serendipity}];setBreadcrumb(breadcrumb.slice());};var loadRecommendations=function loadRecommendations(){Object(__WEBPACK_IMPORTED_MODULE_4_modules_users_actions__["b" ])().then(function(response){setIsLoading(false);setRecommendedUsersIds(response.ids);if(!response.ids.length){var action=getSerendipityAction();if(action){action();}else{history.push('/no-recommendations');}}}).catch(function(){setIsLoading(false);});};var handleEnd=function handleEnd(){setIsTheEnd(true);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){initBreadcrumb();resetAll();loadRecommendations();},[]);if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LoadingComponent__["a" ],{colorAnimation:app.color1}));}if(isTheEnd||!recommendedUsersIds.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title',dangerouslySetInnerHTML:{__html:literals.descriptionUsers}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nocontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noUsers))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title',dangerouslySetInnerHTML:{__html:literals.descriptionUsers}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Steps_SwipeableCards__["a" ],{users:recommendedUsersIds.slice(0,MAX_USERS),hideFirst:true,onEnd:handleEnd})));}RecommendationUsers.propTypes={app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getSerendipityAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (RecommendationUsers);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackWrapper; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return NoElements; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\nwidth: clamp(20vw, 40rem, 100vw);\nheight: clamp(20vw, 40rem, 100vw);\nmargin: 0 auto;\nborder-radius: 50%;\noverflow: hidden;\n'],['\nwidth: clamp(20vw, 40rem, 100vw);\nheight: clamp(20vw, 40rem, 100vw);\nmargin: 0 auto;\nborder-radius: 50%;\noverflow: hidden;\n']),_templateObject2=_taggedTemplateLiteral(['\n  max-width: 80rem;\n  margin: 0 auto;\n  padding: 2rem;\n\n  .title {\n    font-size: 1.6rem;\n    color: ',';\n    line-height: 2.3rem;\n    font-family: ',';\n    margin-bottom: 1rem;\n  }\n\n  .carousel {\n    height: auto;\n  }\n'],['\n  max-width: 80rem;\n  margin: 0 auto;\n  padding: 2rem;\n\n  .title {\n    font-size: 1.6rem;\n    color: ',';\n    line-height: 2.3rem;\n    font-family: ',';\n    margin-bottom: 1rem;\n  }\n\n  .carousel {\n    height: auto;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: calc(100% - 4rem);\n  height: 30rem;\n  padding: 2rem;\n  margin: 2rem auto;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n\n  .nocontent {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    img {\n      width: 20rem;\n    }\n\n    .text {\n      margin-top: 1rem;\n      font-size: 1.6rem;\n      text-align: center;\n      color: black;\n    }\n  }\n'],['\n  width: calc(100% - 4rem);\n  height: 30rem;\n  padding: 2rem;\n  margin: 2rem auto;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n\n  .nocontent {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    img {\n      width: 20rem;\n    }\n\n    .text {\n      margin-top: 1rem;\n      font-size: 1.6rem;\n      text-align: center;\n      color: black;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var FeedbackWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].semiboldFamily);var NoElements=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1942);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1943);
function mapStateToProps(state){return{literals:state.i18n.literals.recommendations||{},app:state.app};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_3_components_Steps_SwipeableCards__ = __webpack_require__(65);
 var __WEBPACK_IMPORTED_MODULE_4_modules_think_seeds_actions__ = __webpack_require__(33);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg__ = __webpack_require__(91);
 var __WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg__);
 var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1944);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function RecommendationsTables(props){var app=props.app,resetAll=props.resetAll,setBreadcrumb=props.setBreadcrumb,literals=props.literals;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),isLoading=_useState2[0],setIsLoading=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState4=_slicedToArray(_useState3,2),recommendedTablesIds=_useState4[0],setRecommendedTablesIds=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),isTheEnd=_useState6[0],setIsTheEnd=_useState6[1];var initBreadcrumb=function initBreadcrumb(){var breadcrumb=[{type:'back'},{color:'#ffffff',text:literals.serendipity}];setBreadcrumb(breadcrumb.slice());};var loadRecommendations=function loadRecommendations(){Object(__WEBPACK_IMPORTED_MODULE_4_modules_think_seeds_actions__["d" ])().then(function(response){setIsLoading(false);setRecommendedTablesIds(response);}).catch(function(){setIsLoading(false);});};var handleEnd=function handleEnd(){setIsTheEnd(true);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){initBreadcrumb();resetAll();loadRecommendations();},[]);if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["b" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LoadingComponent__["a" ],{colorAnimation:app.color1}));}if(isTheEnd||!recommendedTablesIds.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title',dangerouslySetInnerHTML:{__html:literals.descriptionUsers}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["c" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nocontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5_assets_images_think_no_think_chats_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},literals.noTables))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title',dangerouslySetInnerHTML:{__html:literals.descriptionTables}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Steps_SwipeableCards__["a" ],{thinkSeeds:recommendedTablesIds,hideFirst:true,onEnd:handleEnd})));}RecommendationsTables.propTypes={app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}; __webpack_exports__["a"] = (RecommendationsTables);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingWrapper; });
 __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackWrapper; });
 __webpack_require__.d(__webpack_exports__, "c", function() { return NoElements; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
 var __WEBPACK_IMPORTED_MODULE_1_constants_fonts__ = __webpack_require__(17);
 var __WEBPACK_IMPORTED_MODULE_2_constants_colors__ = __webpack_require__(16);
var _templateObject=_taggedTemplateLiteral(['\nwidth: clamp(20vw, 40rem, 100vw);\nheight: clamp(20vw, 40rem, 100vw);\nmargin: 0 auto;\nborder-radius: 50%;\noverflow: hidden;\n'],['\nwidth: clamp(20vw, 40rem, 100vw);\nheight: clamp(20vw, 40rem, 100vw);\nmargin: 0 auto;\nborder-radius: 50%;\noverflow: hidden;\n']),_templateObject2=_taggedTemplateLiteral(['\n  max-width: 80rem;\n  margin: 0 auto;\n  padding: 2rem;\n\n  .title {\n    font-size: 1.6rem;\n    color: ',';\n    line-height: 2.3rem;\n    font-family: ',';\n    margin-bottom: 1rem;\n  }\n\n  .carousel {\n    height: auto;\n  }\n'],['\n  max-width: 80rem;\n  margin: 0 auto;\n  padding: 2rem;\n\n  .title {\n    font-size: 1.6rem;\n    color: ',';\n    line-height: 2.3rem;\n    font-family: ',';\n    margin-bottom: 1rem;\n  }\n\n  .carousel {\n    height: auto;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: calc(100% - 4rem);\n  height: 30rem;\n  padding: 2rem;\n  margin: 2rem auto;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n\n  .nocontent {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    img {\n      width: 20rem;\n    }\n\n    .text {\n      margin-top: 1rem;\n      font-size: 1.6rem;\n      text-align: center;\n      color: black;\n    }\n  }\n'],['\n  width: calc(100% - 4rem);\n  height: 30rem;\n  padding: 2rem;\n  margin: 2rem auto;\n  background: #F3F3F3;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n\n  .nocontent {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    img {\n      width: 20rem;\n    }\n\n    .text {\n      margin-top: 1rem;\n      font-size: 1.6rem;\n      text-align: center;\n      color: black;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var FeedbackWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_2_constants_colors__["a" ],__WEBPACK_IMPORTED_MODULE_1_constants_fonts__["a" ].semiboldFamily);var NoElements=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1946);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__ = __webpack_require__(22);
 var __WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__ = __webpack_require__(21);
 var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(1947);
function mapStateToProps(state){return{literals:state.i18n.literals.speedDating||{},app:state.app,meetings:state.speedDating.meetings,actualUser:state.session.user};}function mapDispatchToProps(dispatch){return{setBreadcrumb:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_3_components_Navbar_modules__["b" ],dispatch),resetAll:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_4_modules_steps_actions__["f" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(20);
 var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
 var __WEBPACK_IMPORTED_MODULE_3_components_LoadingComponent__ = __webpack_require__(34);
 var __WEBPACK_IMPORTED_MODULE_4_components_Countdown__ = __webpack_require__(69);
 var __WEBPACK_IMPORTED_MODULE_5_components_Avatar__ = __webpack_require__(23);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_speed_dating_mistery_svg__ = __webpack_require__(480);
 var __WEBPACK_IMPORTED_MODULE_6_assets_images_speed_dating_mistery_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_images_speed_dating_mistery_svg__);
 var __WEBPACK_IMPORTED_MODULE_7_modules_speedDating_actions__ = __webpack_require__(225);
 var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1948);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function SpeedDatingRandomMeeting(props){var app=props.app,literals=props.literals,setBreadcrumb=props.setBreadcrumb,resetAll=props.resetAll,history=props.history,paramId=props.match.params.id;var id=parseInt(paramId,10);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),data=_useState2[0],setData=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState4=_slicedToArray(_useState3,2),isLoading=_useState4[0],setIsLoading=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),hasFinishCountdown=_useState6[0],setHasFinishCountdown=_useState6[1];var loadSpeedDatingData=function loadSpeedDatingData(){Object(__WEBPACK_IMPORTED_MODULE_7_modules_speedDating_actions__["b" ])(id).then(function(response){setData(response);setIsLoading(false);}).catch(function(){setIsLoading(false);});};var createBreadcrumb=function createBreadcrumb(){var breadcrumb=[{color:'#ffffff',text:literals.title}];setBreadcrumb(breadcrumb.slice());resetAll();};var finishCountdown=function finishCountdown(){setHasFinishCountdown(true);};var backToSpeedDating=function backToSpeedDating(){history.push('/speed-dating/'+id);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){createBreadcrumb();loadSpeedDatingData();},[id]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(data&&data.start_date<=__WEBPACK_IMPORTED_MODULE_2_moment___default()().unix()){Object(__WEBPACK_IMPORTED_MODULE_7_modules_speedDating_actions__["f" ])(id);}return function(){if(data&&data.start_date<=__WEBPACK_IMPORTED_MODULE_2_moment___default()().unix()){Object(__WEBPACK_IMPORTED_MODULE_7_modules_speedDating_actions__["a" ])(id);}};},[data,hasFinishCountdown]);if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LoadingComponent__["a" ],{colorAnimation:app.color1}));}var printMainScreen=function printMainScreen(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["b" ],{color:app.color1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.randomMeetingInProcess),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_assets_images_speed_dating_mistery_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:backToSpeedDating},literals.backToSpeedDating))));};var printCountDown=function printCountDown(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["b" ],{color:app.color1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},literals.randomMeetingNotStarted),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Countdown__["a" ],{time:data.start_date,onFinish:finishCountdown,enabled:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6_assets_images_speed_dating_mistery_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'primary',onClick:backToSpeedDating},literals.backToSpeedDating))));};if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LoadingComponent__["a" ],{colorAnimation:app.color1}));}if(data.start_date>__WEBPACK_IMPORTED_MODULE_2_moment___default()().unix()){return printCountDown();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,printMainScreen());}SpeedDatingRandomMeeting.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,literals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,setBreadcrumb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetAll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (SpeedDatingRandomMeeting);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingWrapper; });
 __webpack_require__.d(__webpack_exports__, "b", function() { return MainScreen; });

 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  width: clamp(20vw, 40rem, 100vw);\n  height: clamp(20vw, 40rem, 100vw);\n  margin: 0 auto;\n  border-radius: 50%;\n  overflow: hidden;\n'],['\n  width: clamp(20vw, 40rem, 100vw);\n  height: clamp(20vw, 40rem, 100vw);\n  margin: 0 auto;\n  border-radius: 50%;\n  overflow: hidden;\n']),_templateObject2=_taggedTemplateLiteral(['\n  height: 100%;\n  height: calc(100vh - 5rem);\n  background-color: ',';\n  padding: 0px 20px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .content {\n    margin-top: -5rem;\n    color: #fff;\n    width: 60rem;\n    line-height: 3rem;\n    max-width: 90%;\n\n    .title {\n      font-size: 18px;\n      margin-bottom: 10px;\n      font-weight: 600;\n      display: inline-block;\n    }\n  }\n\n  .countdown {\n    font-size: 2rem;\n    margin-bottom: 2rem;\n  }\n\n  button {\n    margin-top: 2rem;\n  }\n'],['\n  height: 100%;\n  height: calc(100vh - 5rem);\n  background-color: ',';\n  padding: 0px 20px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .content {\n    margin-top: -5rem;\n    color: #fff;\n    width: 60rem;\n    line-height: 3rem;\n    max-width: 90%;\n\n    .title {\n      font-size: 18px;\n      margin-bottom: 10px;\n      font-weight: 600;\n      display: inline-block;\n    }\n  }\n\n  .countdown {\n    font-size: 2rem;\n    margin-bottom: 2rem;\n  }\n\n  button {\n    margin-top: 2rem;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: relative;\n'],['\n  position: relative;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);var MainScreen=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject2,function(props){return props.color;});var AvatarWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject3);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1950);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1951);
var mapStateToProps=function mapStateToProps(){return{};};function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_modules_embeddables_actions__ = __webpack_require__(1952);
 var __WEBPACK_IMPORTED_MODULE_3_routes_Embed_CallForImpact_CardWithTables__ = __webpack_require__(1953);
 var __WEBPACK_IMPORTED_MODULE_4_routes_Embed_CallForImpact_Carousel__ = __webpack_require__(1957);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function EmbedMain(props){var id=props.match.params.id;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),embed=_useState2[0],setEmbed=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_2_modules_embeddables_actions__["a" ])(id).then(function(response){setEmbed(response);});},[]);if(!embed){return null;}var printCallForImpactCarousel=function printCallForImpactCarousel(){var ids=[];var impactNetworks=[];if(embed.extra_info.selection_type==='ids'){embed.extra_info.ids.forEach(function(call){ids.push(call.id);});}else{embed.extra_info.impact_networks.forEach(function(impactNetwork){impactNetworks.push(impactNetwork.id);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_routes_Embed_CallForImpact_Carousel__["a" ],{ids:ids,impactNetworks:impactNetworks,callUrl:embed.extra_info.call_url,embedId:embed.id});};var printCallForImpactTableWithCards=function printCallForImpactTableWithCards(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_routes_Embed_CallForImpact_CardWithTables__["a" ],{id:embed.extra_info.call_for_impact.id,tableUrl:embed.extra_info.table_url,callUrl:embed.extra_info.call_url,embedId:embed.id});};switch(embed.mode.id){case 21284853:return printCallForImpactCarousel();case 21284854:return printCallForImpactTableWithCards();default:return null;}}EmbedMain.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (EmbedMain);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return getEmbeddable; });
 var __WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__ = __webpack_require__(8);
var getEmbeddable=function getEmbeddable(id){return Object(__WEBPACK_IMPORTED_MODULE_0_utils_apiFetch__["b" ])('GET',{endPoint:'embeddables/'+id});};

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1954);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1955);
function mapStateToProps(){return{};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_4_components_SimpleCarousel__ = __webpack_require__(39);
 var __WEBPACK_IMPORTED_MODULE_5_components_Cards_Call4ImpactCard__ = __webpack_require__(268);
 var __WEBPACK_IMPORTED_MODULE_6_components_Cards_ThemeTableCard__ = __webpack_require__(117);
 var __WEBPACK_IMPORTED_MODULE_7_modules_callForImpact_actions__ = __webpack_require__(272);
 var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1956);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function CardWithTables(props){var id=props.id,tableUrl=props.tableUrl,callUrl=props.callUrl,embedId=props.embedId;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),call=_useState2[0],setCall=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_7_modules_callForImpact_actions__["b" ])({ids:id,embed_id:embedId}).then(function(response){if(response.length){setCall(response[0]);}});},[]);var handleClickTable=function handleClickTable(table){window.top.location.href=tableUrl.replace('*|tableId|*',table);// window.open(tableUrl.replace('*|tableId|*', table));
};var handleClickCall=function handleClickCall(){window.top.location.href=callUrl.replace('*|callId|*',id);};var printTables=function printTables(){if(!call.theme_tables.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_SimpleCarousel__["a" ],{classesList:'theme_table_card',showButtons:true},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(call.theme_tables,function(think){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Cards_ThemeTableCard__["a" ],{key:think.id,data:think,row:true,onClick:handleClickTable});}));};if(!call){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Cards_Call4ImpactCard__["a" ],{data:call,type:__WEBPACK_IMPORTED_MODULE_3_constants_types__["c" ],planId:0,onClickStart:handleClickCall})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tables_carousel'},printTables()));}CardWithTables.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,tableUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,callUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,embedId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}; __webpack_exports__["a"] = (CardWithTables);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return CardWithTablesGrid; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n\n  .tables_carousel {\n    padding: 0 50px 0 100px;\n    max-width: calc(100% - 39rem);\n  }\n'],['\n  display: flex;\n  justify-content: center;\n\n  .tables_carousel {\n    padding: 0 50px 0 100px;\n    max-width: calc(100% - 39rem);\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CardWithTablesGrid=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1958);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(1959);
function mapStateToProps(){return{};}function mapDispatchToProps(){return{};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" ])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components__["a" ])));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_components_Cards_Call4ImpactCard__ = __webpack_require__(268);
 var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
 var __WEBPACK_IMPORTED_MODULE_4_react_materialize__ = __webpack_require__(173);
 var __WEBPACK_IMPORTED_MODULE_4_react_materialize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_materialize__);
 var __WEBPACK_IMPORTED_MODULE_5_modules_callForImpact_actions__ = __webpack_require__(272);
 var __WEBPACK_IMPORTED_MODULE_6_constants_types__ = __webpack_require__(32);
 var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1960);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function EmbedCallForImpactCarousel(props){var ids=props.ids,impactNetworks=props.impactNetworks,callUrl=props.callUrl,embedId=props.embedId;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),calls=_useState2[0],setCalls=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var paramsRequest={embed_id:embedId};if(ids.length){paramsRequest.ids=ids.join(',');}else if(impactNetworks.length){paramsRequest.impact_networks=impactNetworks.join(',');}Object(__WEBPACK_IMPORTED_MODULE_5_modules_callForImpact_actions__["b" ])(paramsRequest).then(function(response){setCalls(response);});},[]);var handleClickCall=function handleClickCall(call){window.top.location.href=callUrl.replace('*|callId|*',call.id);};if(!calls.length){return calls;}var narrativesElements=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(calls,function(call){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:call.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Cards_Call4ImpactCard__["a" ],{data:call,type:__WEBPACK_IMPORTED_MODULE_6_constants_types__["c" ],planId:0,onClickStart:handleClickCall}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_materialize__["Carousel"],{carouselId:'Carousel-2',options:{dist:-20,duration:200,fullWidth:false,indicators:false,noWrap:false,numVisible:6,onCycleTo:null,padding:-170,shift:0}},narrativesElements));}EmbedCallForImpactCarousel.propTypes={callUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,ids:__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array,impactNetworks:__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array,embedId:__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number.isRequired};EmbedCallForImpactCarousel.defaultProps={ids:[],impactNetworks:[]}; __webpack_exports__["a"] = (EmbedCallForImpactCarousel);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_require__.d(__webpack_exports__, "a", function() { return EmbedCallCarouselWrapper; });
 var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  .carousel {\n    height: 45rem;\n    .carousel-item {\n      width: 27.3rem;\n      height: 42rem;\n      opacity: 1 !important;\n    }\n  }\n\n  .carousel_calls_desktop {\n    .nowrap {\n      padding: 5rem 2.2rem;\n      margin: -5rem 0;\n    }\n\n    .c4impact_card {\n      transition: all linear 0.2s;\n      &:hover {\n        z-index: 100;\n        transform: scale(1.2);\n        box-shadow: 0px 3px 10px #00000050;\n      }\n    }\n  }\n'],['\n  .carousel {\n    height: 45rem;\n    .carousel-item {\n      width: 27.3rem;\n      height: 42rem;\n      opacity: 1 !important;\n    }\n  }\n\n  .carousel_calls_desktop {\n    .nowrap {\n      padding: 5rem 2.2rem;\n      margin: -5rem 0;\n    }\n\n    .c4impact_card {\n      transition: all linear 0.2s;\n      &:hover {\n        z-index: 100;\n        transform: scale(1.2);\n        box-shadow: 0px 3px 10px #00000050;\n      }\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var EmbedCallCarouselWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" ].div(_templateObject);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(1962);
 __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__container__["a" ]);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
 var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
 var __WEBPACK_IMPORTED_MODULE_2_modules_app__ = __webpack_require__(45);
 var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(1963);
var mapStateToProps=function mapStateToProps(state){return{router:state.router,app:state.app};};function mapDispatchToProps(dispatch){return{fetchInstance:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" ])(__WEBPACK_IMPORTED_MODULE_2_modules_app__["b" ],dispatch)};} __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" ])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components__["a" ]));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
 var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
 var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(3);
 var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(151);
 var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_withWidth__ = __webpack_require__(372);
 var __WEBPACK_IMPORTED_MODULE_6_components_ErrorBoundary__ = __webpack_require__(400);
 var __WEBPACK_IMPORTED_MODULE_7__store_history__ = __webpack_require__(29);
 var __WEBPACK_IMPORTED_MODULE_8__index__ = __webpack_require__(438);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.loadPhysicsLibraries=function(){var libraries=['/js/createjs_1.1_min.js','/js/zim10.js','/js/Box2dWeb-2.1.a.3.min.js','/js/physics.js'];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(libraries,function(library){var src=''+window.location.origin+library;var scriptPhysic=document.createElement('script');scriptPhysic.src=src;document.head.appendChild(scriptPhysic);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){var fetchInstance=this.props.fetchInstance;var domain= false?'rise-develop.webintra.net':window.location.host;fetchInstance(domain);document.body.classList.add('embed');}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.checkLoading);}},{key:'render',value:function render(){var app=this.props.app;if(!app.code){return false;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_ErrorBoundary__["a" ],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["a" ],{history:__WEBPACK_IMPORTED_MODULE_7__store_history__["a" ]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" ],null,__WEBPACK_IMPORTED_MODULE_8__index__["a" ].map(function(route,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" ],{key:index,path:route.path,exact:route.exact,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(route.component,{route:__WEBPACK_IMPORTED_MODULE_7__store_history__["a" ]}));}});}))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);App.propTypes={fetchInstance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,app:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired}; __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_withWidth__["a" ])()(App));

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
 var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
 var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(469);
 var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1965);
function OverrideTheme(props){var children=props.children;var propsTheme=Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["createMuiTheme"])(Object.assign({},__WEBPACK_IMPORTED_MODULE_3__config__["a" ]));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["MuiThemeProvider"],{theme:propsTheme},children);}OverrideTheme.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired}; __webpack_exports__["a"] = (OverrideTheme);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__palette__ = __webpack_require__(1966);
 var __WEBPACK_IMPORTED_MODULE_1__typography__ = __webpack_require__(1967);
 var __WEBPACK_IMPORTED_MODULE_2__overrides__ = __webpack_require__(1968);
var OverrideThemeProps={palette:__WEBPACK_IMPORTED_MODULE_0__palette__["a" ],typography:__WEBPACK_IMPORTED_MODULE_1__typography__["a" ],overrides:__WEBPACK_IMPORTED_MODULE_2__overrides__["a" ]}; __webpack_exports__["a"] = (OverrideThemeProps);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_constants_colors__ = __webpack_require__(16);
var palette={primary:{main:__WEBPACK_IMPORTED_MODULE_0_constants_colors__["g" ]},secondary:{main:__WEBPACK_IMPORTED_MODULE_0_constants_colors__["i" ]}}; __webpack_exports__["a"] = (palette);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0_constants_colors__ = __webpack_require__(16);
var typography={fontFamily:'Helvetica Neue,'+'RalewayRegular,'+'-apple-system,system-ui,BlinkMacSystemFont,'+'"Segoe UI",Raleway,"Helvetica Neue",Arial,sans-serif',color:__WEBPACK_IMPORTED_MODULE_0_constants_colors__["a" ],htmlFontSize:10,useNextVariants:true}; __webpack_exports__["a"] = (typography);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 var __WEBPACK_IMPORTED_MODULE_0__MuiButton__ = __webpack_require__(1969);
 var __WEBPACK_IMPORTED_MODULE_1__MuiInput__ = __webpack_require__(1970);
 var __WEBPACK_IMPORTED_MODULE_2__MuiInputLabel__ = __webpack_require__(1971);
 var __WEBPACK_IMPORTED_MODULE_3__MuiFormLabel__ = __webpack_require__(1972);
 __webpack_exports__["a"] = ({MuiButton:__WEBPACK_IMPORTED_MODULE_0__MuiButton__["a" ],MuiInput:__WEBPACK_IMPORTED_MODULE_1__MuiInput__["a" ],MuiInputLabel:__WEBPACK_IMPORTED_MODULE_2__MuiInputLabel__["a" ],MuiFormLabel:__WEBPACK_IMPORTED_MODULE_3__MuiFormLabel__["a" ]});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = ({});

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MuiInput={}; __webpack_exports__["a"] = (MuiInput);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MuiInputLabel={}; __webpack_exports__["a"] = (MuiInputLabel);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MuiFormLabel={}; __webpack_exports__["a"] = (MuiFormLabel);

 }),

 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
 __webpack_exports__["a"] = register;

// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'// [::1] is the IPv6 localhost address.
||window.location.hostname==='[::1]'// 127.0.0.1/8 is considered localhost for IPv4.
||window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

 }),

 (function(module, exports) {

// removed by extract-text-webpack-plugin

 })
 ]);


// WEBPACK FOOTER //
// static/js/main.fb5c70f7.js